import * as Y from "react";
import x, { useRef as J, useCallback as y1, useEffect as h1, useState as e1, useMemo as Q, useLayoutEffect as a8, createContext as V1, useContext as M1, forwardRef as n9, Fragment as q1, isValidElement as gs, cloneElement as vs, createElement as va, useId as O1, useReducer as j5, useSyncExternalStore as bs, createRef as u6, Component as ys } from "react";
import * as O9 from "react-dom";
import xs, { createPortal as ba, flushSync as C2, findDOMNode as ws } from "react-dom";
var G6 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function M7(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function gS(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var e4 = { exports: {} }, b9 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m0;
function _s() {
  if (m0)
    return b9;
  m0 = 1;
  var e = x, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, c, u) {
    var d, C = {}, p = null, h = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (d in c)
      n.call(c, d) && !i.hasOwnProperty(d) && (C[d] = c[d]);
    if (l && l.defaultProps)
      for (d in c = l.defaultProps, c)
        C[d] === void 0 && (C[d] = c[d]);
    return { $$typeof: t, type: l, key: p, ref: h, props: C, _owner: a.current };
  }
  return b9.Fragment = r, b9.jsx = o, b9.jsxs = o, b9;
}
var y9 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g0;
function Ms() {
  return g0 || (g0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = x, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), f = Symbol.iterator, g = "@@iterator";
    function m(H) {
      if (H === null || typeof H != "object")
        return null;
      var q = f && H[f] || H[g];
      return typeof q == "function" ? q : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(H) {
      {
        for (var q = arguments.length, n1 = new Array(q > 1 ? q - 1 : 0), v1 = 1; v1 < q; v1++)
          n1[v1 - 1] = arguments[v1];
        w("error", H, n1);
      }
    }
    function w(H, q, n1) {
      {
        var v1 = v.ReactDebugCurrentFrame, z1 = v1.getStackAddendum();
        z1 !== "" && (q += "%s", n1 = n1.concat([z1]));
        var Y1 = n1.map(function(F1) {
          return String(F1);
        });
        Y1.unshift("Warning: " + q), Function.prototype.apply.call(console[H], console, Y1);
      }
    }
    var M = !1, y = !1, _ = !1, S = !1, j = !1, V;
    V = Symbol.for("react.module.reference");
    function P(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === n || H === i || j || H === a || H === u || H === d || S || H === h || M || y || _ || typeof H == "object" && H !== null && (H.$$typeof === p || H.$$typeof === C || H.$$typeof === o || H.$$typeof === l || H.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === V || H.getModuleId !== void 0));
    }
    function A(H, q, n1) {
      var v1 = H.displayName;
      if (v1)
        return v1;
      var z1 = q.displayName || q.name || "";
      return z1 !== "" ? n1 + "(" + z1 + ")" : n1;
    }
    function R(H) {
      return H.displayName || "Context";
    }
    function z(H) {
      if (H == null)
        return null;
      if (typeof H.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof H == "function")
        return H.displayName || H.name || null;
      if (typeof H == "string")
        return H;
      switch (H) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case l:
            var q = H;
            return R(q) + ".Consumer";
          case o:
            var n1 = H;
            return R(n1._context) + ".Provider";
          case c:
            return A(H, H.render, "ForwardRef");
          case C:
            var v1 = H.displayName || null;
            return v1 !== null ? v1 : z(H.type) || "Memo";
          case p: {
            var z1 = H, Y1 = z1._payload, F1 = z1._init;
            try {
              return z(F1(Y1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, G = 0, U, Z, E, F, I, T, B;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function $() {
      {
        if (G === 0) {
          U = console.log, Z = console.info, E = console.warn, F = console.error, I = console.group, T = console.groupCollapsed, B = console.groupEnd;
          var H = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: H,
            log: H,
            warn: H,
            error: H,
            group: H,
            groupCollapsed: H,
            groupEnd: H
          });
        }
        G++;
      }
    }
    function W() {
      {
        if (G--, G === 0) {
          var H = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, H, {
              value: U
            }),
            info: N({}, H, {
              value: Z
            }),
            warn: N({}, H, {
              value: E
            }),
            error: N({}, H, {
              value: F
            }),
            group: N({}, H, {
              value: I
            }),
            groupCollapsed: N({}, H, {
              value: T
            }),
            groupEnd: N({}, H, {
              value: B
            })
          });
        }
        G < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var i1 = v.ReactCurrentDispatcher, r1;
    function d1(H, q, n1) {
      {
        if (r1 === void 0)
          try {
            throw Error();
          } catch (z1) {
            var v1 = z1.stack.trim().match(/\n( *(at )?)/);
            r1 = v1 && v1[1] || "";
          }
        return `
` + r1 + H;
      }
    }
    var m1 = !1, Q1;
    {
      var _1 = typeof WeakMap == "function" ? WeakMap : Map;
      Q1 = new _1();
    }
    function p1(H, q) {
      if (!H || m1)
        return "";
      {
        var n1 = Q1.get(H);
        if (n1 !== void 0)
          return n1;
      }
      var v1;
      m1 = !0;
      var z1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y1;
      Y1 = i1.current, i1.current = null, $();
      try {
        if (q) {
          var F1 = function() {
            throw Error();
          };
          if (Object.defineProperty(F1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F1, []);
            } catch (P2) {
              v1 = P2;
            }
            Reflect.construct(H, [], F1);
          } else {
            try {
              F1.call();
            } catch (P2) {
              v1 = P2;
            }
            H.call(F1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (P2) {
            v1 = P2;
          }
          H();
        }
      } catch (P2) {
        if (P2 && v1 && typeof P2.stack == "string") {
          for (var I1 = P2.stack.split(`
`), k2 = v1.stack.split(`
`), s2 = I1.length - 1, d2 = k2.length - 1; s2 >= 1 && d2 >= 0 && I1[s2] !== k2[d2]; )
            d2--;
          for (; s2 >= 1 && d2 >= 0; s2--, d2--)
            if (I1[s2] !== k2[d2]) {
              if (s2 !== 1 || d2 !== 1)
                do
                  if (s2--, d2--, d2 < 0 || I1[s2] !== k2[d2]) {
                    var O2 = `
` + I1[s2].replace(" at new ", " at ");
                    return H.displayName && O2.includes("<anonymous>") && (O2 = O2.replace("<anonymous>", H.displayName)), typeof H == "function" && Q1.set(H, O2), O2;
                  }
                while (s2 >= 1 && d2 >= 0);
              break;
            }
        }
      } finally {
        m1 = !1, i1.current = Y1, W(), Error.prepareStackTrace = z1;
      }
      var V6 = H ? H.displayName || H.name : "", r6 = V6 ? d1(V6) : "";
      return typeof H == "function" && Q1.set(H, r6), r6;
    }
    function T1(H, q, n1) {
      return p1(H, !1);
    }
    function l1(H) {
      var q = H.prototype;
      return !!(q && q.isReactComponent);
    }
    function k1(H, q, n1) {
      if (H == null)
        return "";
      if (typeof H == "function")
        return p1(H, l1(H));
      if (typeof H == "string")
        return d1(H);
      switch (H) {
        case u:
          return d1("Suspense");
        case d:
          return d1("SuspenseList");
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case c:
            return T1(H.render);
          case C:
            return k1(H.type, q, n1);
          case p: {
            var v1 = H, z1 = v1._payload, Y1 = v1._init;
            try {
              return k1(Y1(z1), q, n1);
            } catch {
            }
          }
        }
      return "";
    }
    var r2 = Object.prototype.hasOwnProperty, n5 = {}, n6 = v.ReactDebugCurrentFrame;
    function H6(H) {
      if (H) {
        var q = H._owner, n1 = k1(H.type, H._source, q ? q.type : null);
        n6.setExtraStackFrame(n1);
      } else
        n6.setExtraStackFrame(null);
    }
    function _5(H, q, n1, v1, z1) {
      {
        var Y1 = Function.call.bind(r2);
        for (var F1 in H)
          if (Y1(H, F1)) {
            var I1 = void 0;
            try {
              if (typeof H[F1] != "function") {
                var k2 = Error((v1 || "React class") + ": " + n1 + " type `" + F1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[F1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k2.name = "Invariant Violation", k2;
              }
              I1 = H[F1](q, F1, v1, n1, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (s2) {
              I1 = s2;
            }
            I1 && !(I1 instanceof Error) && (H6(z1), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v1 || "React class", n1, F1, typeof I1), H6(null)), I1 instanceof Error && !(I1.message in n5) && (n5[I1.message] = !0, H6(z1), b("Failed %s type: %s", n1, I1.message), H6(null));
          }
      }
    }
    var P6 = Array.isArray;
    function T6(H) {
      return P6(H);
    }
    function H8(H) {
      {
        var q = typeof Symbol == "function" && Symbol.toStringTag, n1 = q && H[Symbol.toStringTag] || H.constructor.name || "Object";
        return n1;
      }
    }
    function m9(H) {
      try {
        return g9(H), !1;
      } catch {
        return !0;
      }
    }
    function g9(H) {
      return "" + H;
    }
    function v9(H) {
      if (m9(H))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", H8(H)), g9(H);
    }
    var I5 = v.ReactCurrentOwner, P8 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, s0, l0, y3;
    y3 = {};
    function es(H) {
      if (r2.call(H, "ref")) {
        var q = Object.getOwnPropertyDescriptor(H, "ref").get;
        if (q && q.isReactWarning)
          return !1;
      }
      return H.ref !== void 0;
    }
    function ts(H) {
      if (r2.call(H, "key")) {
        var q = Object.getOwnPropertyDescriptor(H, "key").get;
        if (q && q.isReactWarning)
          return !1;
      }
      return H.key !== void 0;
    }
    function as(H, q) {
      if (typeof H.ref == "string" && I5.current && q && I5.current.stateNode !== q) {
        var n1 = z(I5.current.type);
        y3[n1] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(I5.current.type), H.ref), y3[n1] = !0);
      }
    }
    function ns(H, q) {
      {
        var n1 = function() {
          s0 || (s0 = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
        };
        n1.isReactWarning = !0, Object.defineProperty(H, "key", {
          get: n1,
          configurable: !0
        });
      }
    }
    function rs(H, q) {
      {
        var n1 = function() {
          l0 || (l0 = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", q));
        };
        n1.isReactWarning = !0, Object.defineProperty(H, "ref", {
          get: n1,
          configurable: !0
        });
      }
    }
    var is = function(H, q, n1, v1, z1, Y1, F1) {
      var I1 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: H,
        key: q,
        ref: n1,
        props: F1,
        // Record the component responsible for creating this element.
        _owner: Y1
      };
      return I1._store = {}, Object.defineProperty(I1._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(I1, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v1
      }), Object.defineProperty(I1, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z1
      }), Object.freeze && (Object.freeze(I1.props), Object.freeze(I1)), I1;
    };
    function os(H, q, n1, v1, z1) {
      {
        var Y1, F1 = {}, I1 = null, k2 = null;
        n1 !== void 0 && (v9(n1), I1 = "" + n1), ts(q) && (v9(q.key), I1 = "" + q.key), es(q) && (k2 = q.ref, as(q, z1));
        for (Y1 in q)
          r2.call(q, Y1) && !P8.hasOwnProperty(Y1) && (F1[Y1] = q[Y1]);
        if (H && H.defaultProps) {
          var s2 = H.defaultProps;
          for (Y1 in s2)
            F1[Y1] === void 0 && (F1[Y1] = s2[Y1]);
        }
        if (I1 || k2) {
          var d2 = typeof H == "function" ? H.displayName || H.name || "Unknown" : H;
          I1 && ns(F1, d2), k2 && rs(F1, d2);
        }
        return is(H, I1, k2, z1, v1, I5.current, F1);
      }
    }
    var x3 = v.ReactCurrentOwner, c0 = v.ReactDebugCurrentFrame;
    function j6(H) {
      if (H) {
        var q = H._owner, n1 = k1(H.type, H._source, q ? q.type : null);
        c0.setExtraStackFrame(n1);
      } else
        c0.setExtraStackFrame(null);
    }
    var w3;
    w3 = !1;
    function _3(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function u0() {
      {
        if (x3.current) {
          var H = z(x3.current.type);
          if (H)
            return `

Check the render method of \`` + H + "`.";
        }
        return "";
      }
    }
    function ss(H) {
      return "";
    }
    var d0 = {};
    function ls(H) {
      {
        var q = u0();
        if (!q) {
          var n1 = typeof H == "string" ? H : H.displayName || H.name;
          n1 && (q = `

Check the top-level render call using <` + n1 + ">.");
        }
        return q;
      }
    }
    function C0(H, q) {
      {
        if (!H._store || H._store.validated || H.key != null)
          return;
        H._store.validated = !0;
        var n1 = ls(q);
        if (d0[n1])
          return;
        d0[n1] = !0;
        var v1 = "";
        H && H._owner && H._owner !== x3.current && (v1 = " It was passed a child from " + z(H._owner.type) + "."), j6(H), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n1, v1), j6(null);
      }
    }
    function p0(H, q) {
      {
        if (typeof H != "object")
          return;
        if (T6(H))
          for (var n1 = 0; n1 < H.length; n1++) {
            var v1 = H[n1];
            _3(v1) && C0(v1, q);
          }
        else if (_3(H))
          H._store && (H._store.validated = !0);
        else if (H) {
          var z1 = m(H);
          if (typeof z1 == "function" && z1 !== H.entries)
            for (var Y1 = z1.call(H), F1; !(F1 = Y1.next()).done; )
              _3(F1.value) && C0(F1.value, q);
        }
      }
    }
    function cs(H) {
      {
        var q = H.type;
        if (q == null || typeof q == "string")
          return;
        var n1;
        if (typeof q == "function")
          n1 = q.propTypes;
        else if (typeof q == "object" && (q.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        q.$$typeof === C))
          n1 = q.propTypes;
        else
          return;
        if (n1) {
          var v1 = z(q);
          _5(n1, H.props, "prop", v1, H);
        } else if (q.PropTypes !== void 0 && !w3) {
          w3 = !0;
          var z1 = z(q);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z1 || "Unknown");
        }
        typeof q.getDefaultProps == "function" && !q.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function us(H) {
      {
        for (var q = Object.keys(H.props), n1 = 0; n1 < q.length; n1++) {
          var v1 = q[n1];
          if (v1 !== "children" && v1 !== "key") {
            j6(H), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v1), j6(null);
            break;
          }
        }
        H.ref !== null && (j6(H), b("Invalid attribute `ref` supplied to `React.Fragment`."), j6(null));
      }
    }
    var h0 = {};
    function f0(H, q, n1, v1, z1, Y1) {
      {
        var F1 = P(H);
        if (!F1) {
          var I1 = "";
          (H === void 0 || typeof H == "object" && H !== null && Object.keys(H).length === 0) && (I1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var k2 = ss();
          k2 ? I1 += k2 : I1 += u0();
          var s2;
          H === null ? s2 = "null" : T6(H) ? s2 = "array" : H !== void 0 && H.$$typeof === t ? (s2 = "<" + (z(H.type) || "Unknown") + " />", I1 = " Did you accidentally export a JSX literal instead of a component?") : s2 = typeof H, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", s2, I1);
        }
        var d2 = os(H, q, n1, z1, Y1);
        if (d2 == null)
          return d2;
        if (F1) {
          var O2 = q.children;
          if (O2 !== void 0)
            if (v1)
              if (T6(O2)) {
                for (var V6 = 0; V6 < O2.length; V6++)
                  p0(O2[V6], H);
                Object.freeze && Object.freeze(O2);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              p0(O2, H);
        }
        if (r2.call(q, "key")) {
          var r6 = z(H), P2 = Object.keys(q).filter(function(ms) {
            return ms !== "key";
          }), M3 = P2.length > 0 ? "{key: someKey, " + P2.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!h0[r6 + M3]) {
            var fs = P2.length > 0 ? "{" + P2.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, M3, r6, fs, r6), h0[r6 + M3] = !0;
          }
        }
        return H === n ? us(d2) : cs(d2), d2;
      }
    }
    function ds(H, q, n1) {
      return f0(H, q, n1, !0);
    }
    function Cs(H, q, n1) {
      return f0(H, q, n1, !1);
    }
    var ps = Cs, hs = ds;
    y9.Fragment = n, y9.jsx = ps, y9.jsxs = hs;
  }()), y9;
}
process.env.NODE_ENV === "production" ? e4.exports = _s() : e4.exports = Ms();
var s = e4.exports;
const ya = typeof document < "u" ? x.useLayoutEffect : () => {
};
var S3;
const Ss = (S3 = x.useInsertionEffect) !== null && S3 !== void 0 ? S3 : ya;
function ks(e) {
  const t = J(null);
  return Ss(() => {
    t.current = e;
  }, [
    e
  ]), y1((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
const q5 = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, s6 = (e) => e && "window" in e && e.window === e ? e : q5(e).defaultView || window;
function Ls(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function Hs(e) {
  return Ls(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Ps = !1;
function O4() {
  return Ps;
}
function xa(e, t) {
  if (!O4())
    return t && e ? e.contains(t) : !1;
  if (!e || !t)
    return !1;
  let r = t;
  for (; r !== null; ) {
    if (r === e)
      return !0;
    r.tagName === "SLOT" && r.assignedSlot ? r = r.assignedSlot.parentNode : Hs(r) ? r = r.host : r = r.parentNode;
  }
  return !1;
}
const t4 = (e = document) => {
  var t;
  if (!O4())
    return e.activeElement;
  let r = e.activeElement;
  for (; r && "shadowRoot" in r && (!((t = r.shadowRoot) === null || t === void 0) && t.activeElement); )
    r = r.shadowRoot.activeElement;
  return r;
};
function wa(e) {
  return O4() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function S7(e) {
  var t;
  if (typeof window > "u" || window.navigator == null)
    return !1;
  let r = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(r) && r.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function B4(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function V5(e) {
  if (process.env.NODE_ENV === "test")
    return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Z4 = V5(function() {
  return B4(/^Mac/i);
}), Ts = V5(function() {
  return B4(/^iPhone/i);
}), js = V5(function() {
  return B4(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Z4() && navigator.maxTouchPoints > 1;
}), Vs = V5(function() {
  return Ts() || js();
});
V5(function() {
  return Z4() || Vs();
});
V5(function() {
  return S7(/AppleWebKit/i) && !As();
});
const As = V5(function() {
  return S7(/Chrome/i);
}), Es = V5(function() {
  return S7(/Android/i);
});
V5(function() {
  return S7(/Firefox/i);
});
function _a() {
  let e = J(/* @__PURE__ */ new Map()), t = y1((a, i, o, l) => {
    let c = l != null && l.once ? (...u) => {
      e.current.delete(o), o(...u);
    } : o;
    e.current.set(o, {
      type: i,
      eventTarget: a,
      fn: c,
      options: l
    }), a.addEventListener(i, c, l);
  }, []), r = y1((a, i, o, l) => {
    var c;
    let u = ((c = e.current.get(o)) === null || c === void 0 ? void 0 : c.fn) || o;
    a.removeEventListener(i, u, l), e.current.delete(o);
  }, []), n = y1(() => {
    e.current.forEach((a, i) => {
      r(a.eventTarget, a.type, i, a.options);
    });
  }, [
    r
  ]);
  return h1(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function Is(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : Es() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Ma(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function Ds(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function Sa(e) {
  let t = J({
    isFocused: !1,
    observer: null
  });
  ya(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = ks((n) => {
    e == null || e(n);
  });
  return y1((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = n.target, i = (o) => {
        if (t.current.isFocused = !1, a.disabled) {
          let l = Ma(o);
          r(l);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let l = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
let Ns = !1, n8 = null, a4 = /* @__PURE__ */ new Set(), j9 = /* @__PURE__ */ new Map(), m6 = !1, n4 = !1;
const Rs = {
  Tab: !0,
  Escape: !0
};
function G4(e, t) {
  for (let r of a4)
    r(e, t);
}
function Fs(e) {
  return !(e.metaKey || !Z4() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function J8(e) {
  m6 = !0, Fs(e) && (n8 = "keyboard", G4("keyboard", e));
}
function B2(e) {
  n8 = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (m6 = !0, G4("pointer", e));
}
function ka(e) {
  Is(e) && (m6 = !0, n8 = "virtual");
}
function La(e) {
  e.target === window || e.target === document || Ns || !e.isTrusted || (!m6 && !n4 && (n8 = "virtual", G4("virtual", e)), m6 = !1, n4 = !1);
}
function Ha() {
  m6 = !1, n4 = !0;
}
function r4(e) {
  if (typeof window > "u" || typeof document > "u" || j9.get(s6(e)))
    return;
  const t = s6(e), r = q5(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    m6 = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", J8, !0), r.addEventListener("keyup", J8, !0), r.addEventListener("click", ka, !0), t.addEventListener("focus", La, !0), t.addEventListener("blur", Ha, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", B2, !0), r.addEventListener("pointermove", B2, !0), r.addEventListener("pointerup", B2, !0)) : process.env.NODE_ENV === "test" && (r.addEventListener("mousedown", B2, !0), r.addEventListener("mousemove", B2, !0), r.addEventListener("mouseup", B2, !0)), t.addEventListener("beforeunload", () => {
    Pa(e);
  }, {
    once: !0
  }), j9.set(t, {
    focus: n
  });
}
const Pa = (e, t) => {
  const r = s6(e), n = q5(e);
  t && n.removeEventListener("DOMContentLoaded", t), j9.has(r) && (r.HTMLElement.prototype.focus = j9.get(r).focus, n.removeEventListener("keydown", J8, !0), n.removeEventListener("keyup", J8, !0), n.removeEventListener("click", ka, !0), r.removeEventListener("focus", La, !0), r.removeEventListener("blur", Ha, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", B2, !0), n.removeEventListener("pointermove", B2, !0), n.removeEventListener("pointerup", B2, !0)) : process.env.NODE_ENV === "test" && (n.removeEventListener("mousedown", B2, !0), n.removeEventListener("mousemove", B2, !0), n.removeEventListener("mouseup", B2, !0)), j9.delete(r));
};
function Os(e) {
  const t = q5(e);
  let r;
  return t.readyState !== "loading" ? r4(e) : (r = () => {
    r4(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => Pa(e, r);
}
typeof document < "u" && Os();
function Ta() {
  return n8 !== "pointer";
}
const Bs = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Zs(e, t, r) {
  let n = q5(r == null ? void 0 : r.target);
  const a = typeof window < "u" ? s6(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? s6(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? s6(r == null ? void 0 : r.target).HTMLElement : HTMLElement, l = typeof window < "u" ? s6(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || n.activeElement instanceof a && !Bs.has(n.activeElement.type) || n.activeElement instanceof i || n.activeElement instanceof o && n.activeElement.isContentEditable, !(e && t === "keyboard" && r instanceof l && !Rs[r.key]);
}
function Gs(e, t, r) {
  r4(), h1(() => {
    let n = (a, i) => {
      Zs(!!(r != null && r.isTextInput), a, i) && e(Ta());
    };
    return a4.add(n), () => {
      a4.delete(n);
    };
  }, t);
}
function Ks(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: a } = e;
  const i = y1((c) => {
    if (c.target === c.currentTarget)
      return n && n(c), a && a(!1), !0;
  }, [
    n,
    a
  ]), o = Sa(i), l = y1((c) => {
    const u = q5(c.target), d = u ? t4(u) : t4();
    c.target === c.currentTarget && d === wa(c.nativeEvent) && (r && r(c), a && a(!0), o(c));
  }, [
    a,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || a || n) ? l : void 0,
      onBlur: !t && (n || a) ? i : void 0
    }
  };
}
function zs(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: a } = e, i = J({
    isFocusWithin: !1
  }), { addGlobalListener: o, removeAllGlobalListeners: l } = _a(), c = y1((C) => {
    C.currentTarget.contains(C.target) && i.current.isFocusWithin && !C.currentTarget.contains(C.relatedTarget) && (i.current.isFocusWithin = !1, l(), r && r(C), a && a(!1));
  }, [
    r,
    a,
    i,
    l
  ]), u = Sa(c), d = y1((C) => {
    if (!C.currentTarget.contains(C.target))
      return;
    const p = q5(C.target), h = t4(p);
    if (!i.current.isFocusWithin && h === wa(C.nativeEvent)) {
      n && n(C), a && a(!0), i.current.isFocusWithin = !0, u(C);
      let f = C.currentTarget;
      o(p, "focus", (g) => {
        if (i.current.isFocusWithin && !xa(f, g.target)) {
          let m = new p.defaultView.FocusEvent("blur", {
            relatedTarget: g.target
          });
          Ds(m, f);
          let v = Ma(m);
          c(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    n,
    a,
    u,
    o,
    c
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: d,
      onBlur: c
    }
  };
}
let q8 = !1, T8 = 0;
function i4() {
  q8 = !0, setTimeout(() => {
    q8 = !1;
  }, 50);
}
function v0(e) {
  e.pointerType === "touch" && i4();
}
function Us() {
  if (!(typeof document > "u"))
    return T8 === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", v0) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", i4)), T8++, () => {
      T8--, !(T8 > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", v0) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", i4));
    };
}
function S2(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: a } = e, [i, o] = e1(!1), l = J({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  h1(Us, []);
  let { addGlobalListener: c, removeAllGlobalListeners: u } = _a(), { hoverProps: d, triggerHoverEnd: C } = Q(() => {
    let p = (g, m) => {
      if (l.pointerType = m, a || m === "touch" || l.isHovered || !g.currentTarget.contains(g.target))
        return;
      l.isHovered = !0;
      let v = g.currentTarget;
      l.target = v, c(q5(g.target), "pointerover", (b) => {
        l.isHovered && l.target && !xa(l.target, b.target) && h(b, b.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: v,
        pointerType: m
      }), r && r(!0), o(!0);
    }, h = (g, m) => {
      let v = l.target;
      l.pointerType = "", l.target = null, !(m === "touch" || !l.isHovered || !v) && (l.isHovered = !1, u(), n && n({
        type: "hoverend",
        target: v,
        pointerType: m
      }), r && r(!1), o(!1));
    }, f = {};
    return typeof PointerEvent < "u" ? (f.onPointerEnter = (g) => {
      q8 && g.pointerType === "mouse" || p(g, g.pointerType);
    }, f.onPointerLeave = (g) => {
      !a && g.currentTarget.contains(g.target) && h(g, g.pointerType);
    }) : process.env.NODE_ENV === "test" && (f.onTouchStart = () => {
      l.ignoreEmulatedMouseEvents = !0;
    }, f.onMouseEnter = (g) => {
      !l.ignoreEmulatedMouseEvents && !q8 && p(g, "mouse"), l.ignoreEmulatedMouseEvents = !1;
    }, f.onMouseLeave = (g) => {
      !a && g.currentTarget.contains(g.target) && h(g, "mouse");
    }), {
      hoverProps: f,
      triggerHoverEnd: h
    };
  }, [
    t,
    r,
    n,
    a,
    l,
    c,
    u
  ]);
  return h1(() => {
    a && C({
      currentTarget: l.target
    }, l.pointerType);
  }, [
    a
  ]), {
    hoverProps: d,
    isHovered: i
  };
}
function x2(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, a = J({
    isFocused: !1,
    isFocusVisible: t || Ta()
  }), [i, o] = e1(!1), [l, c] = e1(() => a.current.isFocused && a.current.isFocusVisible), u = y1(() => c(a.current.isFocused && a.current.isFocusVisible), []), d = y1((h) => {
    a.current.isFocused = h, o(h), u();
  }, [
    u
  ]);
  Gs((h) => {
    a.current.isFocusVisible = h, u();
  }, [], {
    isTextInput: r
  });
  let { focusProps: C } = Ks({
    isDisabled: n,
    onFocusChange: d
  }), { focusWithinProps: p } = zs({
    isDisabled: !n,
    onFocusWithinChange: d
  });
  return {
    isFocused: i,
    isFocusVisible: l,
    focusProps: n ? p : C
  };
}
var Ys = Object.defineProperty, Ws = (e, t, r) => t in e ? Ys(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, k3 = (e, t, r) => (Ws(e, typeof t != "symbol" ? t + "" : t, r), r);
let $s = class {
  constructor() {
    k3(this, "current", this.detect()), k3(this, "handoffState", "pending"), k3(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, d6 = new $s();
function U2(e) {
  return d6.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function r8(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function N2() {
  let e = [], t = { addEventListener(r, n, a, i) {
    return r.addEventListener(n, a, i), t.add(() => r.removeEventListener(n, a, i));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return r8(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, a) {
    let i = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: a }), this.add(() => {
      Object.assign(r.style, { [n]: i });
    });
  }, group(r) {
    let n = N2();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0)
        for (let a of e.splice(n, 1))
          a();
    };
  }, dispose() {
    for (let r of e.splice(0))
      r();
  } };
  return t;
}
function Y2() {
  let [e] = e1(N2);
  return h1(() => () => e.dispose(), [e]), e;
}
let x1 = (e, t) => {
  d6.isServer ? h1(e, t) : a8(e, t);
};
function b2(e) {
  let t = J(e);
  return x1(() => {
    t.current = e;
  }, [e]), t;
}
let O = function(e) {
  let t = b2(e);
  return x.useCallback((...r) => t.current(...r), [t]);
};
function Js(e) {
  let t = e.width / 2, r = e.height / 2;
  return { top: e.clientY - r, right: e.clientX + t, bottom: e.clientY + r, left: e.clientX - t };
}
function qs(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function t5({ disabled: e = !1 } = {}) {
  let t = J(null), [r, n] = e1(!1), a = Y2(), i = O(() => {
    t.current = null, n(!1), a.dispose();
  }), o = O((l) => {
    if (a.dispose(), t.current === null) {
      t.current = l.currentTarget, n(!0);
      {
        let c = U2(l.currentTarget);
        a.addEventListener(c, "pointerup", i, !1), a.addEventListener(c, "pointermove", (u) => {
          if (t.current) {
            let d = Js(u);
            n(qs(d, t.current.getBoundingClientRect()));
          }
        }, !1), a.addEventListener(c, "pointercancel", i, !1);
      }
    }
  });
  return { pressed: r, pressProps: e ? {} : { onPointerDown: o, onPointerUp: i, onClick: i } };
}
let ja = V1(void 0);
function E2() {
  return M1(ja);
}
function Va({ value: e, children: t }) {
  return x.createElement(ja.Provider, { value: e }, t);
}
function o4(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function P1(e, t, ...r) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...r) : a;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, P1), n;
}
var h2 = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(h2 || {}), Z5 = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Z5 || {});
function f1() {
  let e = Xs();
  return y1((t) => Qs({ mergeRefs: e, ...t }), [e]);
}
function Qs({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: a, visible: i = !0, name: o, mergeRefs: l }) {
  l = l ?? el;
  let c = Aa(t, e);
  if (i)
    return j8(c, r, n, o, l);
  let u = a ?? 0;
  if (u & 2) {
    let { static: d = !1, ...C } = c;
    if (d)
      return j8(C, r, n, o, l);
  }
  if (u & 1) {
    let { unmount: d = !0, ...C } = c;
    return P1(d ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return j8({ ...C, hidden: !0, style: { display: "none" } }, r, n, o, l);
    } });
  }
  return j8(c, r, n, o, l);
}
function j8(e, t = {}, r, n, a) {
  let { as: i = r, children: o, refName: l = "ref", ...c } = L3(e, ["unmount", "static"]), u = e.ref !== void 0 ? { [l]: e.ref } : {}, d = typeof o == "function" ? o(t) : o;
  "className" in c && c.className && typeof c.className == "function" && (c.className = c.className(t)), c["aria-labelledby"] && c["aria-labelledby"] === c.id && (c["aria-labelledby"] = void 0);
  let C = {};
  if (t) {
    let p = !1, h = [];
    for (let [f, g] of Object.entries(t))
      typeof g == "boolean" && (p = !0), g === !0 && h.push(f.replace(/([A-Z])/g, (m) => `-${m.toLowerCase()}`));
    if (p) {
      C["data-headlessui-state"] = h.join(" ");
      for (let f of h)
        C[`data-${f}`] = "";
    }
  }
  if (i === q1 && (Object.keys(F5(c)).length > 0 || Object.keys(F5(C)).length > 0))
    if (!gs(d) || Array.isArray(d) && d.length > 1) {
      if (Object.keys(F5(c)).length > 0)
        throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(F5(c)).concat(Object.keys(F5(C))).map((p) => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)].join(`
`));
    } else {
      let p = d.props, h = p == null ? void 0 : p.className, f = typeof h == "function" ? (...v) => o4(h(...v), c.className) : o4(h, c.className), g = f ? { className: f } : {}, m = Aa(d.props, F5(L3(c, ["ref"])));
      for (let v in C)
        v in m && delete C[v];
      return vs(d, Object.assign({}, m, C, u, { ref: a(tl(d), u.ref) }, g));
    }
  return va(i, Object.assign({}, L3(c, ["ref"]), i !== q1 && u, i !== q1 && C), d);
}
function Xs() {
  let e = J([]), t = y1((r) => {
    for (let n of e.current)
      n != null && (typeof n == "function" ? n(r) : n.current = r);
  }, []);
  return (...r) => {
    if (!r.every((n) => n == null))
      return e.current = r, t;
  };
}
function el(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e)
      r != null && (typeof r == "function" ? r(t) : r.current = t);
  };
}
function Aa(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let n of e)
    for (let a in n)
      a.startsWith("on") && typeof n[a] == "function" ? (r[a] != null || (r[a] = []), r[a].push(n[a])) : t[a] = n[a];
  if (t.disabled || t["aria-disabled"])
    for (let n in r)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(n) && (r[n] = [(a) => {
        var i;
        return (i = a == null ? void 0 : a.preventDefault) == null ? void 0 : i.call(a);
      }]);
  for (let n in r)
    Object.assign(t, { [n](a, ...i) {
      let o = r[n];
      for (let l of o) {
        if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented)
          return;
        l(a, ...i);
      }
    } });
  return t;
}
function a2(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let n of e)
    for (let a in n)
      a.startsWith("on") && typeof n[a] == "function" ? (r[a] != null || (r[a] = []), r[a].push(n[a])) : t[a] = n[a];
  for (let n in r)
    Object.assign(t, { [n](...a) {
      let i = r[n];
      for (let o of i)
        o == null || o(...a);
    } });
  return t;
}
function C1(e) {
  var t;
  return Object.assign(n9(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function F5(e) {
  let t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function L3(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t)
    n in r && delete r[n];
  return r;
}
function tl(e) {
  return x.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
let al = "button";
function nl(e, t) {
  var r;
  let n = E2(), { disabled: a = n || !1, autoFocus: i = !1, ...o } = e, { isFocusVisible: l, focusProps: c } = x2({ autoFocus: i }), { isHovered: u, hoverProps: d } = S2({ isDisabled: a }), { pressed: C, pressProps: p } = t5({ disabled: a }), h = a2({ ref: t, type: (r = o.type) != null ? r : "button", disabled: a || void 0, autoFocus: i }, c, d, p), f = Q(() => ({ disabled: a, hover: u, focus: l, active: C, autofocus: i }), [a, u, l, C, i]);
  return f1()({ ourProps: h, theirProps: o, slot: f, defaultTag: al, name: "Button" });
}
let Ea = C1(nl);
function i8(e, t, r) {
  let [n, a] = e1(r), i = e !== void 0, o = J(i), l = J(!1), c = J(!1);
  return i && !o.current && !l.current ? (l.current = !0, o.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && o.current && !c.current && (c.current = !0, o.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : n, O((u) => (i || a(u), t == null ? void 0 : t(u)))];
}
function o8(e) {
  let [t] = e1(e);
  return t;
}
function Ia(e = {}, t = null, r = []) {
  for (let [n, a] of Object.entries(e))
    Na(r, Da(t, n), a);
  return r;
}
function Da(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Na(e, t, r) {
  if (Array.isArray(r))
    for (let [n, a] of r.entries())
      Na(e, Da(t, n.toString()), a);
  else
    r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : Ia(r, t, e);
}
function k7(e) {
  var t, r;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let a of n.elements)
      if (a !== e && (a.tagName === "INPUT" && a.type === "submit" || a.tagName === "BUTTON" && a.type === "submit" || a.nodeName === "INPUT" && a.type === "image")) {
        a.click();
        return;
      }
    (r = n.requestSubmit) == null || r.call(n);
  }
}
let rl = "span";
var q2 = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(q2 || {});
function il(e, t) {
  var r;
  let { features: n = 1, ...a } = e, i = { ref: t, "aria-hidden": (n & 2) === 2 ? !0 : (r = a["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return f1()({ ourProps: i, theirProps: a, slot: {}, defaultTag: rl, name: "Hidden" });
}
let Q2 = C1(il), Ra = V1(null);
function ol(e) {
  let [t, r] = e1(null);
  return x.createElement(Ra.Provider, { value: { target: t } }, e.children, x.createElement(Q2, { features: q2.Hidden, ref: r }));
}
function sl({ children: e }) {
  let t = M1(Ra);
  if (!t)
    return x.createElement(x.Fragment, null, e);
  let { target: r } = t;
  return r ? ba(x.createElement(x.Fragment, null, e), r) : null;
}
function s8({ data: e, form: t, disabled: r, onReset: n, overrides: a }) {
  let [i, o] = e1(null), l = Y2();
  return h1(() => {
    if (n && i)
      return l.addEventListener(i, "reset", n);
  }, [i, t, n]), x.createElement(sl, null, x.createElement(ll, { setForm: o, formId: t }), Ia(e).map(([c, u]) => x.createElement(Q2, { features: q2.Hidden, ...F5({ key: c, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: r, name: c, value: u, ...a }) })));
}
function ll({ setForm: e, formId: t }) {
  return h1(() => {
    if (t) {
      let r = document.getElementById(t);
      r && e(r);
    }
  }, [e, t]), t ? null : x.createElement(Q2, { features: q2.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (r) => {
    if (!r)
      return;
    let n = r.closest("form");
    n && e(n);
  } });
}
let Fa = V1(void 0);
function A5() {
  return M1(Fa);
}
function cl({ id: e, children: t }) {
  return x.createElement(Fa.Provider, { value: e }, t);
}
function y5(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && ul(r) ? !1 : n;
}
function ul(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let Oa = Symbol();
function K4(e, t = !0) {
  return Object.assign(e, { [Oa]: t });
}
function w1(...e) {
  let t = J(e);
  h1(() => {
    t.current = e;
  }, [e]);
  let r = O((n) => {
    for (let a of t.current)
      a != null && (typeof a == "function" ? a(n) : a.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[Oa])) ? void 0 : r;
}
let L7 = V1(null);
L7.displayName = "DescriptionContext";
function Ba() {
  let e = M1(L7);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ba), t;
  }
  return e;
}
function Q5() {
  var e, t;
  return (t = (e = M1(L7)) == null ? void 0 : e.value) != null ? t : void 0;
}
function r9() {
  let [e, t] = e1([]);
  return [e.length > 0 ? e.join(" ") : void 0, Q(() => function(r) {
    let n = O((i) => (t((o) => [...o, i]), () => t((o) => {
      let l = o.slice(), c = l.indexOf(i);
      return c !== -1 && l.splice(c, 1), l;
    }))), a = Q(() => ({ register: n, slot: r.slot, name: r.name, props: r.props, value: r.value }), [n, r.slot, r.name, r.props, r.value]);
    return x.createElement(L7.Provider, { value: a }, r.children);
  }, [t])];
}
let dl = "p";
function Cl(e, t) {
  let r = O1(), n = E2(), { id: a = `headlessui-description-${r}`, ...i } = e, o = Ba(), l = w1(t);
  x1(() => o.register(a), [a, o.register]);
  let c = n || !1, u = Q(() => ({ ...o.slot, disabled: c }), [o.slot, c]), d = { ref: l, ...o.props, id: a };
  return f1()({ ourProps: d, theirProps: i, slot: u, defaultTag: dl, name: o.name || "Description" });
}
let pl = C1(Cl), l8 = Object.assign(pl, {});
var X = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(X || {});
let H7 = V1(null);
H7.displayName = "LabelContext";
function z4() {
  let e = M1(H7);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, z4), t;
  }
  return e;
}
function a5(e) {
  var t, r, n;
  let a = (r = (t = M1(H7)) == null ? void 0 : t.value) != null ? r : void 0;
  return ((n = e == null ? void 0 : e.length) != null ? n : 0) > 0 ? [a, ...e].filter(Boolean).join(" ") : a;
}
function E5({ inherit: e = !1 } = {}) {
  let t = a5(), [r, n] = e1([]), a = e ? [t, ...r].filter(Boolean) : r;
  return [a.length > 0 ? a.join(" ") : void 0, Q(() => function(i) {
    let o = O((c) => (n((u) => [...u, c]), () => n((u) => {
      let d = u.slice(), C = d.indexOf(c);
      return C !== -1 && d.splice(C, 1), d;
    }))), l = Q(() => ({ register: o, slot: i.slot, name: i.name, props: i.props, value: i.value }), [o, i.slot, i.name, i.props, i.value]);
    return x.createElement(H7.Provider, { value: l }, i.children);
  }, [n])];
}
let hl = "label";
function fl(e, t) {
  var r;
  let n = O1(), a = z4(), i = A5(), o = E2(), { id: l = `headlessui-label-${n}`, htmlFor: c = i ?? ((r = a.props) == null ? void 0 : r.htmlFor), passive: u = !1, ...d } = e, C = w1(t);
  x1(() => a.register(l), [l, a.register]);
  let p = O((m) => {
    let v = m.currentTarget;
    if (v instanceof HTMLLabelElement && m.preventDefault(), a.props && "onClick" in a.props && typeof a.props.onClick == "function" && a.props.onClick(m), v instanceof HTMLLabelElement) {
      let b = document.getElementById(v.htmlFor);
      if (b) {
        let w = b.getAttribute("disabled");
        if (w === "true" || w === "")
          return;
        let M = b.getAttribute("aria-disabled");
        if (M === "true" || M === "")
          return;
        (b instanceof HTMLInputElement && (b.type === "radio" || b.type === "checkbox") || b.role === "radio" || b.role === "checkbox" || b.role === "switch") && b.click(), b.focus({ preventScroll: !0 });
      }
    }
  }), h = o || !1, f = Q(() => ({ ...a.slot, disabled: h }), [a.slot, h]), g = { ref: C, ...a.props, id: l, htmlFor: c, onClick: p };
  return u && ("onClick" in g && (delete g.htmlFor, delete g.onClick), "onClick" in d && delete d.onClick), f1()({ ourProps: g, theirProps: d, slot: f, defaultTag: c ? hl : "div", name: a.name || "Label" });
}
let ml = C1(fl), i9 = Object.assign(ml, {}), gl = "span";
function vl(e, t) {
  let r = O1(), n = A5(), a = E2(), { id: i = n || `headlessui-checkbox-${r}`, disabled: o = a || !1, autoFocus: l = !1, checked: c, defaultChecked: u, onChange: d, name: C, value: p, form: h, indeterminate: f = !1, ...g } = e, m = o8(u), [v, b] = i8(c, d, m ?? !1), w = a5(), M = Q5(), y = Y2(), [_, S] = e1(!1), j = O(() => {
    S(!0), b == null || b(!v), y.nextFrame(() => {
      S(!1);
    });
  }), V = O((B) => {
    if (y5(B.currentTarget))
      return B.preventDefault();
    B.preventDefault(), j();
  }), P = O((B) => {
    B.key === X.Space ? (B.preventDefault(), j()) : B.key === X.Enter && k7(B.currentTarget);
  }), A = O((B) => B.preventDefault()), { isFocusVisible: R, focusProps: z } = x2({ autoFocus: l }), { isHovered: N, hoverProps: G } = S2({ isDisabled: o }), { pressed: U, pressProps: Z } = t5({ disabled: o }), E = a2({ ref: t, id: i, role: "checkbox", "aria-checked": f ? "mixed" : v ? "true" : "false", "aria-labelledby": w, "aria-describedby": M, "aria-disabled": o ? !0 : void 0, indeterminate: f ? "true" : void 0, tabIndex: o ? void 0 : 0, onKeyUp: o ? void 0 : P, onKeyPress: o ? void 0 : A, onClick: o ? void 0 : V }, z, G, Z), F = Q(() => ({ checked: v, disabled: o, hover: N, focus: R, active: U, indeterminate: f, changing: _, autofocus: l }), [v, f, o, N, R, U, _, l]), I = y1(() => {
    if (m !== void 0)
      return b == null ? void 0 : b(m);
  }, [b, m]), T = f1();
  return x.createElement(x.Fragment, null, C != null && x.createElement(s8, { disabled: o, data: { [C]: p || "on" }, overrides: { type: "checkbox", checked: v }, form: h, onReset: I }), T({ ourProps: E, theirProps: g, slot: F, defaultTag: gl, name: "Checkbox" }));
}
let bl = C1(vl), Za = V1(() => {
});
function Ga() {
  return M1(Za);
}
function U4({ value: e, children: t }) {
  return x.createElement(Za.Provider, { value: e }, t);
}
function yl(e, t) {
  let r = Ga();
  return x.createElement(Ea, { ref: t, ...a2({ onClick: r }, e) });
}
let xl = C1(yl);
function A6(e, t, r) {
  let n = r.initialDeps ?? [], a;
  return () => {
    var i, o, l, c;
    let u;
    r.key && ((i = r.debug) != null && i.call(r)) && (u = Date.now());
    const d = e();
    if (!(d.length !== n.length || d.some((h, f) => n[f] !== h)))
      return a;
    n = d;
    let p;
    if (r.key && ((o = r.debug) != null && o.call(r)) && (p = Date.now()), a = t(...d), r.key && ((l = r.debug) != null && l.call(r))) {
      const h = Math.round((Date.now() - u) * 100) / 100, f = Math.round((Date.now() - p) * 100) / 100, g = f / 16, m = (v, b) => {
        for (v = String(v); v.length < b; )
          v = " " + v;
        return v;
      };
      console.info(
        `%c⏱ ${m(f, 5)} /${m(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (c = r == null ? void 0 : r.onChange) == null || c.call(r, a), a;
  };
}
function H3(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const wl = (e, t) => Math.abs(e - t) < 1, _l = (e, t, r) => {
  let n;
  return function(...a) {
    e.clearTimeout(n), n = e.setTimeout(() => t.apply(this, a), r);
  };
}, Ml = (e) => e, Sl = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), n = [];
  for (let a = t; a <= r; a++)
    n.push(a);
  return n;
}, kl = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  const a = (o) => {
    const { width: l, height: c } = o;
    t({ width: Math.round(l), height: Math.round(c) });
  };
  if (a(r.getBoundingClientRect()), !n.ResizeObserver)
    return () => {
    };
  const i = new n.ResizeObserver((o) => {
    const l = o[0];
    if (l != null && l.borderBoxSize) {
      const c = l.borderBoxSize[0];
      if (c) {
        a({ width: c.inlineSize, height: c.blockSize });
        return;
      }
    }
    a(r.getBoundingClientRect());
  });
  return i.observe(r, { box: "border-box" }), () => {
    i.unobserve(r);
  };
}, b0 = {
  passive: !0
}, Ll = typeof window > "u" ? !0 : "onscrollend" in window, Hl = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const n = e.targetWindow;
  if (!n)
    return;
  let a = 0;
  const i = Ll ? () => {
  } : _l(
    n,
    () => {
      t(a, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (u) => () => {
    const { horizontal: d, isRtl: C } = e.options;
    a = d ? r.scrollLeft * (C && -1 || 1) : r.scrollTop, i(), t(a, u);
  }, l = o(!0), c = o(!1);
  return c(), r.addEventListener("scroll", l, b0), r.addEventListener("scrollend", c, b0), () => {
    r.removeEventListener("scroll", l), r.removeEventListener("scrollend", c);
  };
}, Pl = (e, t, r) => {
  if (t != null && t.borderBoxSize) {
    const n = t.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, Tl = (e, {
  adjustments: t = 0,
  behavior: r
}, n) => {
  var a, i;
  const o = e + t;
  (i = (a = n.scrollElement) == null ? void 0 : a.scrollTo) == null || i.call(a, {
    [n.options.horizontal ? "left" : "top"]: o,
    behavior: r
  });
};
class jl {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((a) => {
        a.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var a;
          (a = n()) == null || a.disconnect(), r = null;
        },
        observe: (a) => {
          var i;
          return (i = n()) == null ? void 0 : i.observe(a, { box: "border-box" });
        },
        unobserve: (a) => {
          var i;
          return (i = n()) == null ? void 0 : i.unobserve(a);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, a]) => {
        typeof a > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Ml,
        rangeExtractor: Sl,
        onChange: () => {
        },
        measureElement: Pl,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, a;
      (a = (n = this.options).onChange) == null || a.call(n, this, r);
    }, this.maybeNotify = A6(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((a) => {
          this.observer.observe(a);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (a) => {
            this.scrollRect = a, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (a, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < a ? "forward" : "backward" : null, this.scrollOffset = a, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let o = n - 1; o >= 0; o--) {
        const l = r[o];
        if (a.has(l.lane))
          continue;
        const c = i.get(
          l.lane
        );
        if (c == null || l.end > c.end ? i.set(l.lane, l) : l.end < c.end && a.set(l.lane, !0), a.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((o, l) => o.end === l.end ? o.index - l.index : o.end - l.end)[0] : void 0;
    }, this.getMeasurementOptions = A6(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, n, a, i, o) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: a,
        getItemKey: i,
        enabled: o
      }),
      {
        key: !1
      }
    ), this.getMeasurements = A6(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: a, getItemKey: i, enabled: o }, l) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let d = c; d < r; d++) {
          const C = i(d), p = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), h = p ? p.end + this.options.gap : n + a, f = l.get(C), g = typeof f == "number" ? f : this.options.estimateSize(d), m = h + g, v = p ? p.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: h,
            size: g,
            end: m,
            key: C,
            lane: v
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = A6(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (r, n, a) => this.range = r.length > 0 && n > 0 ? Vl({
        measurements: r,
        outerSize: n,
        scrollOffset: a
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = A6(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, n, a, i) => n === null ? [] : r({
        startIndex: n.startIndex,
        endIndex: n.endIndex,
        overscan: a,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, a = r.getAttribute(n);
      return a ? parseInt(a, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, n) => {
      const a = this.indexFromElement(r), i = this.measurementsCache[a];
      if (!i)
        return;
      const o = i.key, l = this.elementsCache.get(o);
      l !== r && (l && this.observer.unobserve(l), this.observer.observe(r), this.elementsCache.set(o, r)), r.isConnected && this.resizeItem(a, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      const a = this.measurementsCache[r];
      if (!a)
        return;
      const i = this.itemSizeCache.get(a.key) ?? a.size, o = n - i;
      o !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(a, o, this) : a.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", o), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(a.index), this.itemSizeCache = new Map(this.itemSizeCache.set(a.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, a) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(a));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = A6(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, n) => {
        const a = [];
        for (let i = 0, o = r.length; i < o; i++) {
          const l = r[i], c = n[l];
          a.push(c);
        }
        return a;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return H3(
          n[Ka(
            0,
            n.length - 1,
            (a) => H3(n[a]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, n) => {
      const a = this.getSize(), i = this.getScrollOffset();
      n === "auto" && (r <= i ? n = "start" : r >= i + a ? n = "end" : n = "start"), n === "start" ? r = r : n === "end" ? r = r - a : n === "center" && (r = r - a / 2);
      const o = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[o] : this.scrollElement[o] : 0) - a;
      return Math.max(Math.min(c, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const a = this.measurementsCache[r];
      if (!a)
        return;
      const i = this.getSize(), o = this.getScrollOffset();
      if (n === "auto")
        if (a.end >= o + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (a.start <= o + this.options.scrollPaddingStart)
          n = "start";
        else
          return [o, n];
      const l = n === "end" ? a.end + this.options.scrollPaddingEnd : a.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(l, n), n];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: n = "start", behavior: a } = {}) => {
      this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, n), {
        adjustments: void 0,
        behavior: a
      });
    }, this.scrollToIndex = (r, { align: n = "auto", behavior: a } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(r, n);
      if (!i)
        return;
      const [o, l] = i;
      this._scrollToOffset(o, { adjustments: void 0, behavior: a }), a !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [u] = H3(
            this.getOffsetForIndex(r, l)
          );
          wl(u, this.getScrollOffset()) || this.scrollToIndex(r, { align: l, behavior: a });
        } else
          this.scrollToIndex(r, { align: l, behavior: a });
      }));
    }, this.scrollBy = (r, { behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let a;
      return n.length === 0 ? a = this.options.paddingStart : a = this.options.lanes === 1 ? ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...n.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        a - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: a
    }) => {
      this.options.scrollToFn(r, { behavior: a, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const Ka = (e, t, r, n) => {
  for (; e <= t; ) {
    const a = (e + t) / 2 | 0, i = r(a);
    if (i < n)
      e = a + 1;
    else if (i > n)
      t = a - 1;
    else
      return a;
  }
  return e > 0 ? e - 1 : 0;
};
function Vl({
  measurements: e,
  outerSize: t,
  scrollOffset: r
}) {
  const n = e.length - 1, i = Ka(0, n, (l) => e[l].start, r);
  let o = i;
  for (; o < n && e[o].end < r + t; )
    o++;
  return { startIndex: i, endIndex: o };
}
const Al = typeof document < "u" ? Y.useLayoutEffect : Y.useEffect;
function El(e) {
  const t = Y.useReducer(() => ({}), {})[1], r = {
    ...e,
    onChange: (a, i) => {
      var o;
      i ? C2(t) : t(), (o = e.onChange) == null || o.call(e, a, i);
    }
  }, [n] = Y.useState(
    () => new jl(r)
  );
  return n.setOptions(r), Y.useEffect(() => n._didMount(), []), Al(() => n._willUpdate()), n;
}
function Il(e) {
  return El({
    observeElementRect: kl,
    observeElementOffset: Hl,
    scrollToFn: Tl,
    ...e
  });
}
function Dl(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function Y4(e = Dl) {
  return y1((t, r) => {
    if (typeof e == "string") {
      let n = e;
      return (t == null ? void 0 : t[n]) === (r == null ? void 0 : r[n]);
    }
    return e(t, r);
  }, [e]);
}
function Nl(e) {
  if (e === null)
    return { width: 0, height: 0 };
  let { width: t, height: r } = e.getBoundingClientRect();
  return { width: t, height: r };
}
function B9(e, t = !1) {
  let [r, n] = j5(() => ({}), {}), a = Q(() => Nl(e), [e, r]);
  return x1(() => {
    if (!e)
      return;
    let i = new ResizeObserver(n);
    return i.observe(e), () => {
      i.disconnect();
    };
  }, [e]), t ? { width: `${a.width}px`, height: `${a.height}px` } : a;
}
let Rl = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let r = super.get(t);
    return r === void 0 && (r = this.factory(t), this.set(t, r)), r;
  }
};
function za(e, t) {
  let r = e(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(a) {
    return n.add(a), () => n.delete(a);
  }, dispatch(a, ...i) {
    let o = t[a].call(r, ...i);
    o && (r = o, n.forEach((l) => l()));
  } };
}
function Ua(e) {
  return bs(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let Fl = new Rl(() => za(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1)
    return this;
  let r = this.slice();
  return r.splice(t, 1), r;
} }));
function o9(e, t) {
  let r = Fl.get(t), n = O1(), a = Ua(r);
  if (x1(() => {
    if (e)
      return r.dispatch("ADD", n), () => r.dispatch("REMOVE", n);
  }, [r, e]), !e)
    return !1;
  let i = a.indexOf(n), o = a.length;
  return i === -1 && (i = o, o += 1), i === o - 1;
}
let s4 = /* @__PURE__ */ new Map(), V9 = /* @__PURE__ */ new Map();
function y0(e) {
  var t;
  let r = (t = V9.get(e)) != null ? t : 0;
  return V9.set(e, r + 1), r !== 0 ? () => x0(e) : (s4.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => x0(e));
}
function x0(e) {
  var t;
  let r = (t = V9.get(e)) != null ? t : 1;
  if (r === 1 ? V9.delete(e) : V9.set(e, r - 1), r !== 1)
    return;
  let n = s4.get(e);
  n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, s4.delete(e));
}
function P7(e, { allowed: t, disallowed: r } = {}) {
  let n = o9(e, "inert-others");
  x1(() => {
    var a, i;
    if (!n)
      return;
    let o = N2();
    for (let c of (a = r == null ? void 0 : r()) != null ? a : [])
      c && o.add(y0(c));
    let l = (i = t == null ? void 0 : t()) != null ? i : [];
    for (let c of l) {
      if (!c)
        continue;
      let u = U2(c);
      if (!u)
        continue;
      let d = c.parentElement;
      for (; d && d !== u.body; ) {
        for (let C of d.children)
          l.some((p) => C.contains(p)) || o.add(y0(C));
        d = d.parentElement;
      }
    }
    return o.dispose;
  }, [n, t, r]);
}
function c8(e, t, r) {
  let n = b2((a) => {
    let i = a.getBoundingClientRect();
    i.x === 0 && i.y === 0 && i.width === 0 && i.height === 0 && r();
  });
  h1(() => {
    if (!e)
      return;
    let a = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!a)
      return;
    let i = N2();
    if (typeof ResizeObserver < "u") {
      let o = new ResizeObserver(() => n.current(a));
      o.observe(a), i.add(() => o.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let o = new IntersectionObserver(() => n.current(a));
      o.observe(a), i.add(() => o.disconnect());
    }
    return () => i.dispose();
  }, [t, n, e]);
}
let Q8 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), Ol = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var R1 = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(R1 || {}), Z2 = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Z2 || {}), Bl = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Bl || {});
function u8(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Q8)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function Zl(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ol)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var d8 = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(d8 || {});
function C8(e, t = 0) {
  var r;
  return e === ((r = U2(e)) == null ? void 0 : r.body) ? !1 : P1(t, { 0() {
    return e.matches(Q8);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(Q8))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
function Ya(e) {
  let t = U2(e);
  N2().nextFrame(() => {
    t && !C8(t.activeElement, 0) && d5(e);
  });
}
var Gl = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Gl || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function d5(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let Kl = ["textarea", "input"].join(",");
function zl(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Kl)) != null ? r : !1;
}
function c5(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let a = t(r), i = t(n);
    if (a === null || i === null)
      return 0;
    let o = a.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Wa(e, t) {
  return l2(u8(), t, { relativeTo: e });
}
function l2(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: a = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, o = Array.isArray(e) ? r ? c5(e) : e : t & 64 ? Zl(e) : u8(e);
  a.length > 0 && o.length > 1 && (o = o.filter((h) => !a.some((f) => f != null && "current" in f ? (f == null ? void 0 : f.current) === h : f === h))), n = n ?? i.activeElement;
  let l = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, o.indexOf(n)) - 1;
    if (t & 4)
      return Math.max(0, o.indexOf(n)) + 1;
    if (t & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, d = 0, C = o.length, p;
  do {
    if (d >= C || d + C <= 0)
      return 0;
    let h = c + d;
    if (t & 16)
      h = (h + C) % C;
    else {
      if (h < 0)
        return 3;
      if (h >= C)
        return 1;
    }
    p = o[h], p == null || p.focus(u), d += l;
  } while (p !== i.activeElement);
  return t & 6 && zl(p) && p.select(), 2;
}
function $a() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Ul() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Ja() {
  return $a() || Ul();
}
function x9(e, t, r, n) {
  let a = b2(r);
  h1(() => {
    if (!e)
      return;
    function i(o) {
      a.current(o);
    }
    return document.addEventListener(t, i, n), () => document.removeEventListener(t, i, n);
  }, [e, t, n]);
}
function qa(e, t, r, n) {
  let a = b2(r);
  h1(() => {
    if (!e)
      return;
    function i(o) {
      a.current(o);
    }
    return window.addEventListener(t, i, n), () => window.removeEventListener(t, i, n);
  }, [e, t, n]);
}
const w0 = 30;
function p8(e, t, r) {
  let n = o9(e, "outside-click"), a = b2(r), i = y1(function(c, u) {
    if (c.defaultPrevented)
      return;
    let d = u(c);
    if (d === null || !d.getRootNode().contains(d) || !d.isConnected)
      return;
    let C = function p(h) {
      return typeof h == "function" ? p(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(t);
    for (let p of C)
      if (p !== null && (p.contains(d) || c.composed && c.composedPath().includes(p)))
        return;
    return !C8(d, d8.Loose) && d.tabIndex !== -1 && c.preventDefault(), a.current(c, d);
  }, [a, t]), o = J(null);
  x9(n, "pointerdown", (c) => {
    var u, d;
    o.current = ((d = (u = c.composedPath) == null ? void 0 : u.call(c)) == null ? void 0 : d[0]) || c.target;
  }, !0), x9(n, "mousedown", (c) => {
    var u, d;
    o.current = ((d = (u = c.composedPath) == null ? void 0 : u.call(c)) == null ? void 0 : d[0]) || c.target;
  }, !0), x9(n, "click", (c) => {
    Ja() || o.current && (i(c, () => o.current), o.current = null);
  }, !0);
  let l = J({ x: 0, y: 0 });
  x9(n, "touchstart", (c) => {
    l.current.x = c.touches[0].clientX, l.current.y = c.touches[0].clientY;
  }, !0), x9(n, "touchend", (c) => {
    let u = { x: c.changedTouches[0].clientX, y: c.changedTouches[0].clientY };
    if (!(Math.abs(u.x - l.current.x) >= w0 || Math.abs(u.y - l.current.y) >= w0))
      return i(c, () => c.target instanceof HTMLElement ? c.target : null);
  }, !0), qa(n, "blur", (c) => i(c, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function W2(...e) {
  return Q(() => U2(...e), [...e]);
}
function T7(e, t, r, n) {
  let a = b2(r);
  h1(() => {
    e = e ?? window;
    function i(o) {
      a.current(o);
    }
    return e.addEventListener(t, i, n), () => e.removeEventListener(t, i, n);
  }, [e, t, n]);
}
function Qa(e) {
  let t = J({ value: "", selectionStart: null, selectionEnd: null });
  return T7(e, "blur", (r) => {
    let n = r.target;
    n instanceof HTMLInputElement && (t.current = { value: n.value, selectionStart: n.selectionStart, selectionEnd: n.selectionEnd });
  }), O(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== t.current.value)
        e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: r, selectionEnd: n } = t.current;
        r !== null && n !== null && e.setSelectionRange(r, n);
      }
      t.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function x6(e, t) {
  return Q(() => {
    var r;
    if (e.type)
      return e.type;
    let n = (r = e.as) != null ? r : "button";
    if (typeof n == "string" && n.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type"))
      return "button";
  }, [e.type, e.as, t]);
}
function Yl() {
  let e;
  return { before({ doc: t }) {
    var r;
    let n = t.documentElement, a = (r = t.defaultView) != null ? r : window;
    e = Math.max(0, a.innerWidth - n.clientWidth);
  }, after({ doc: t, d: r }) {
    let n = t.documentElement, a = Math.max(0, n.clientWidth - n.offsetWidth), i = Math.max(0, e - a);
    r.style(n, "paddingRight", `${i}px`);
  } };
}
function Wl() {
  return $a() ? { before({ doc: e, d: t, meta: r }) {
    function n(a) {
      return r.containers.flatMap((i) => i()).some((i) => i.contains(a));
    }
    t.microTask(() => {
      var a;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let l = N2();
        l.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => l.dispose()));
      }
      let i = (a = window.scrollY) != null ? a : window.pageYOffset, o = null;
      t.addEventListener(e, "click", (l) => {
        if (l.target instanceof HTMLElement)
          try {
            let c = l.target.closest("a");
            if (!c)
              return;
            let { hash: u } = new URL(c.href), d = e.querySelector(u);
            d && !n(d) && (o = d);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (l) => {
        if (l.target instanceof HTMLElement)
          if (n(l.target)) {
            let c = l.target;
            for (; c.parentElement && n(c.parentElement); )
              c = c.parentElement;
            t.style(c, "overscrollBehavior", "contain");
          } else
            t.style(l.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (l) => {
        if (l.target instanceof HTMLElement) {
          if (l.target.tagName === "INPUT")
            return;
          if (n(l.target)) {
            let c = l.target;
            for (; c.parentElement && c.dataset.headlessuiPortal !== "" && !(c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth); )
              c = c.parentElement;
            c.dataset.headlessuiPortal === "" && l.preventDefault();
          } else
            l.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var l;
        let c = (l = window.scrollY) != null ? l : window.pageYOffset;
        i !== c && window.scrollTo(0, i), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
      });
    });
  } } : {};
}
function $l() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function Jl(e) {
  let t = {};
  for (let r of e)
    Object.assign(t, r(t));
  return t;
}
let l6 = za(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let n = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: N2(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(t), this.set(e, n), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let n = { doc: e, d: t, meta: Jl(r) }, a = [Wl(), Yl(), $l()];
  a.forEach(({ before: i }) => i == null ? void 0 : i(n)), a.forEach(({ after: i }) => i == null ? void 0 : i(n));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
l6.subscribe(() => {
  let e = l6.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e)
    t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let n = t.get(r.doc) === "hidden", a = r.count !== 0;
    (a && !n || !a && n) && l6.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && l6.dispatch("TEARDOWN", r);
  }
});
function ql(e, t, r = () => ({ containers: [] })) {
  let n = Ua(l6), a = t ? n.get(t) : void 0, i = a ? a.count > 0 : !1;
  return x1(() => {
    if (!(!t || !e))
      return l6.dispatch("PUSH", t, r), () => l6.dispatch("POP", t, r);
  }, [e, t]), i;
}
function h8(e, t, r = () => [document.body]) {
  let n = o9(e, "scroll-lock");
  ql(n, t, (a) => {
    var i;
    return { containers: [...(i = a.containers) != null ? i : [], r] };
  });
}
function _0(e) {
  return [e.screenX, e.screenY];
}
function W4() {
  let e = J([-1, -1]);
  return { wasMoved(t) {
    let r = _0(t);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(t) {
    e.current = _0(t);
  } };
}
function Ql(e = 0) {
  let [t, r] = e1(e), n = y1((c) => r(c), [t]), a = y1((c) => r((u) => u | c), [t]), i = y1((c) => (t & c) === c, [t]), o = y1((c) => r((u) => u & ~c), [r]), l = y1((c) => r((u) => u ^ c), [r]);
  return { flags: t, setFlag: n, addFlag: a, hasFlag: i, removeFlag: o, toggleFlag: l };
}
var M0, S0;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((M0 = process == null ? void 0 : process.env) == null ? void 0 : M0.NODE_ENV) === "test" && typeof ((S0 = Element == null ? void 0 : Element.prototype) == null ? void 0 : S0.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var Xl = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(Xl || {});
function w6(e) {
  let t = {};
  for (let r in e)
    e[r] === !0 && (t[`data-${r}`] = "");
  return t;
}
function _6(e, t, r, n) {
  let [a, i] = e1(r), { hasFlag: o, addFlag: l, removeFlag: c } = Ql(e && a ? 3 : 0), u = J(!1), d = J(!1), C = Y2();
  return x1(() => {
    var p;
    if (e) {
      if (r && i(!0), !t) {
        r && l(3);
        return;
      }
      return (p = n == null ? void 0 : n.start) == null || p.call(n, r), ec(t, { inFlight: u, prepare() {
        d.current ? d.current = !1 : d.current = u.current, u.current = !0, !d.current && (r ? (l(3), c(4)) : (l(4), c(2)));
      }, run() {
        d.current ? r ? (c(3), l(4)) : (c(4), l(3)) : r ? c(1) : l(1);
      }, done() {
        var h;
        d.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (u.current = !1, c(7), r || i(!1), (h = n == null ? void 0 : n.end) == null || h.call(n, r));
      } });
    }
  }, [e, r, t, C]), e ? [a, { closed: o(1), enter: o(2), leave: o(4), transition: o(2) || o(4) }] : [r, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function ec(e, { prepare: t, run: r, done: n, inFlight: a }) {
  let i = N2();
  return ac(e, { prepare: t, inFlight: a }), i.nextFrame(() => {
    r(), i.requestAnimationFrame(() => {
      i.add(tc(e, n));
    });
  }), i.dispose;
}
function tc(e, t) {
  var r, n;
  let a = N2();
  if (!e)
    return a.dispose;
  let i = !1;
  a.add(() => {
    i = !0;
  });
  let o = (n = (r = e.getAnimations) == null ? void 0 : r.call(e).filter((l) => l instanceof CSSTransition)) != null ? n : [];
  return o.length === 0 ? (t(), a.dispose) : (Promise.allSettled(o.map((l) => l.finished)).then(() => {
    i || t();
  }), a.dispose);
}
function ac(e, { inFlight: t, prepare: r }) {
  if (t != null && t.current) {
    r();
    return;
  }
  let n = e.style.transition;
  e.style.transition = "none", r(), e.offsetHeight, e.style.transition = n;
}
function Xa(e, { container: t, accept: r, walk: n }) {
  let a = J(r), i = J(n);
  h1(() => {
    a.current = r, i.current = n;
  }, [r, n]), x1(() => {
    if (!t || !e)
      return;
    let o = U2(t);
    if (!o)
      return;
    let l = a.current, c = i.current, u = Object.assign((C) => l(C), { acceptNode: l }), d = o.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; d.nextNode(); )
      c(d.currentNode);
  }, [t, e, a, i]);
}
function Z9(e, t) {
  let r = J([]), n = O(e);
  h1(() => {
    let a = [...r.current];
    for (let [i, o] of t.entries())
      if (r.current[i] !== o) {
        let l = n(t, a);
        return r.current = t, l;
      }
  }, [n, ...t]);
}
function j7() {
  return typeof window < "u";
}
function s9(e) {
  return en(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function D2(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function x5(e) {
  var t;
  return (t = (en(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function en(e) {
  return j7() ? e instanceof Node || e instanceof D2(e).Node : !1;
}
function M2(e) {
  return j7() ? e instanceof Element || e instanceof D2(e).Element : !1;
}
function v5(e) {
  return j7() ? e instanceof HTMLElement || e instanceof D2(e).HTMLElement : !1;
}
function k0(e) {
  return !j7() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof D2(e).ShadowRoot;
}
const nc = /* @__PURE__ */ new Set(["inline", "contents"]);
function f8(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = X2(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !nc.has(a);
}
const rc = /* @__PURE__ */ new Set(["table", "td", "th"]);
function ic(e) {
  return rc.has(s9(e));
}
const oc = [":popover-open", ":modal"];
function V7(e) {
  return oc.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const sc = ["transform", "translate", "scale", "rotate", "perspective"], lc = ["transform", "translate", "scale", "rotate", "perspective", "filter"], cc = ["paint", "layout", "strict", "content"];
function $4(e) {
  const t = J4(), r = M2(e) ? X2(e) : e;
  return sc.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || lc.some((n) => (r.willChange || "").includes(n)) || cc.some((n) => (r.contain || "").includes(n));
}
function uc(e) {
  let t = W5(e);
  for (; v5(t) && !K6(t); ) {
    if ($4(t))
      return t;
    if (V7(t))
      return null;
    t = W5(t);
  }
  return null;
}
function J4() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const dc = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function K6(e) {
  return dc.has(s9(e));
}
function X2(e) {
  return D2(e).getComputedStyle(e);
}
function A7(e) {
  return M2(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function W5(e) {
  if (s9(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    k0(e) && e.host || // Fallback.
    x5(e)
  );
  return k0(t) ? t.host : t;
}
function tn(e) {
  const t = W5(e);
  return K6(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : v5(t) && f8(t) ? t : tn(t);
}
function G9(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const a = tn(e), i = a === ((n = e.ownerDocument) == null ? void 0 : n.body), o = D2(a);
  if (i) {
    const l = l4(o);
    return t.concat(o, o.visualViewport || [], f8(a) ? a : [], l && r ? G9(l) : []);
  }
  return t.concat(a, G9(a, [], r));
}
function l4(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Cc() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: r,
      version: n
    } = t;
    return r + "/" + n;
  }).join(" ") : navigator.userAgent;
}
const g6 = Math.min, w2 = Math.max, K9 = Math.round, V8 = Math.floor, C5 = (e) => ({
  x: e,
  y: e
}), pc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, hc = {
  start: "end",
  end: "start"
};
function L0(e, t, r) {
  return w2(e, g6(t, r));
}
function l9(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function $5(e) {
  return e.split("-")[0];
}
function m8(e) {
  return e.split("-")[1];
}
function an(e) {
  return e === "x" ? "y" : "x";
}
function nn(e) {
  return e === "y" ? "height" : "width";
}
const fc = /* @__PURE__ */ new Set(["top", "bottom"]);
function H5(e) {
  return fc.has($5(e)) ? "y" : "x";
}
function rn(e) {
  return an(H5(e));
}
function mc(e, t, r) {
  r === void 0 && (r = !1);
  const n = m8(e), a = rn(e), i = nn(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = X8(o)), [o, X8(o)];
}
function gc(e) {
  const t = X8(e);
  return [c4(e), t, c4(t)];
}
function c4(e) {
  return e.replace(/start|end/g, (t) => hc[t]);
}
const H0 = ["left", "right"], P0 = ["right", "left"], vc = ["top", "bottom"], bc = ["bottom", "top"];
function yc(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? P0 : H0 : t ? H0 : P0;
    case "left":
    case "right":
      return t ? vc : bc;
    default:
      return [];
  }
}
function xc(e, t, r, n) {
  const a = m8(e);
  let i = yc($5(e), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(c4)))), i;
}
function X8(e) {
  return e.replace(/left|right|bottom|top/g, (t) => pc[t]);
}
function wc(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function _c(e) {
  return typeof e != "number" ? wc(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function e7(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: a
  } = e;
  return {
    width: n,
    height: a,
    top: r,
    left: t,
    right: t + n,
    bottom: r + a,
    x: t,
    y: r
  };
}
function T0(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const i = H5(t), o = rn(t), l = nn(o), c = $5(t), u = i === "y", d = n.x + n.width / 2 - a.width / 2, C = n.y + n.height / 2 - a.height / 2, p = n[l] / 2 - a[l] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: d,
        y: n.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: C
      };
      break;
    case "left":
      h = {
        x: n.x - a.width,
        y: C
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (m8(t)) {
    case "start":
      h[o] -= p * (r && u ? -1 : 1);
      break;
    case "end":
      h[o] += p * (r && u ? -1 : 1);
      break;
  }
  return h;
}
const Mc = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, l = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: d,
    y: C
  } = T0(u, n, c), p = n, h = {}, f = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: m,
      fn: v
    } = l[g], {
      x: b,
      y: w,
      data: M,
      reset: y
    } = await v({
      x: d,
      y: C,
      initialPlacement: n,
      placement: p,
      strategy: a,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = b ?? d, C = w ?? C, h = {
      ...h,
      [m]: {
        ...h[m],
        ...M
      }
    }, y && f <= 50 && (f++, typeof y == "object" && (y.placement && (p = y.placement), y.rects && (u = y.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : y.rects), {
      x: d,
      y: C
    } = T0(u, p, c)), g = -1);
  }
  return {
    x: d,
    y: C,
    placement: p,
    strategy: a,
    middlewareData: h
  };
};
async function E7(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: l,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: C = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = l9(t, e), f = _c(h), m = l[p ? C === "floating" ? "reference" : "floating" : C], v = e7(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(m))) == null || r ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), b = C === "floating" ? {
    x: n,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), M = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = e7(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: w,
    strategy: c
  }) : b);
  return {
    top: (v.top - y.top + f.top) / M.y,
    bottom: (y.bottom - v.bottom + f.bottom) / M.y,
    left: (v.left - y.left + f.left) / M.x,
    right: (y.right - v.right + f.right) / M.x
  };
}
const Sc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: l,
        platform: c,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: C = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: g = !0,
        ...m
      } = l9(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const v = $5(a), b = H5(l), w = $5(l) === l, M = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), y = p || (w || !g ? [X8(l)] : gc(l)), _ = f !== "none";
      !p && _ && y.push(...xc(l, g, f, M));
      const S = [l, ...y], j = await E7(t, m), V = [];
      let P = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (d && V.push(j[v]), C) {
        const N = mc(a, o, M);
        V.push(j[N[0]], j[N[1]]);
      }
      if (P = [...P, {
        placement: a,
        overflows: V
      }], !V.every((N) => N <= 0)) {
        var A, R;
        const N = (((A = i.flip) == null ? void 0 : A.index) || 0) + 1, G = S[N];
        if (G && (!(C === "alignment" ? b !== H5(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((E) => H5(E.placement) === b ? E.overflows[0] > 0 : !0)))
          return {
            data: {
              index: N,
              overflows: P
            },
            reset: {
              placement: G
            }
          };
        let U = (R = P.filter((Z) => Z.overflows[0] <= 0).sort((Z, E) => Z.overflows[1] - E.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!U)
          switch (h) {
            case "bestFit": {
              var z;
              const Z = (z = P.filter((E) => {
                if (_) {
                  const F = H5(E.placement);
                  return F === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((E) => [E.placement, E.overflows.filter((F) => F > 0).reduce((F, I) => F + I, 0)]).sort((E, F) => E[1] - F[1])[0]) == null ? void 0 : z[0];
              Z && (U = Z);
              break;
            }
            case "initialPlacement":
              U = l;
              break;
          }
        if (a !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
}, kc = /* @__PURE__ */ new Set(["left", "top"]);
async function Lc(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = $5(r), l = m8(r), c = H5(r) === "y", u = kc.has(o) ? -1 : 1, d = i && c ? -1 : 1, C = l9(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: f
  } = typeof C == "number" ? {
    mainAxis: C,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: C.mainAxis || 0,
    crossAxis: C.crossAxis || 0,
    alignmentAxis: C.alignmentAxis
  };
  return l && typeof f == "number" && (h = l === "end" ? f * -1 : f), c ? {
    x: h * d,
    y: p * u
  } : {
    x: p * u,
    y: h * d
  };
}
const Hc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: l
      } = t, c = await Lc(t, e);
      return o === ((r = l.offset) == null ? void 0 : r.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: a + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, Pc = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (m) => {
            let {
              x: v,
              y: b
            } = m;
            return {
              x: v,
              y: b
            };
          }
        },
        ...c
      } = l9(e, t), u = {
        x: r,
        y: n
      }, d = await E7(t, c), C = H5($5(a)), p = an(C);
      let h = u[p], f = u[C];
      if (i) {
        const m = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", b = h + d[m], w = h - d[v];
        h = L0(b, h, w);
      }
      if (o) {
        const m = C === "y" ? "top" : "left", v = C === "y" ? "bottom" : "right", b = f + d[m], w = f - d[v];
        f = L0(b, f, w);
      }
      const g = l.fn({
        ...t,
        [p]: h,
        [C]: f
      });
      return {
        ...g,
        data: {
          x: g.x - r,
          y: g.y - n,
          enabled: {
            [p]: i,
            [C]: o
          }
        }
      };
    }
  };
}, Tc = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        rects: i,
        platform: o,
        elements: l
      } = t, {
        apply: c = () => {
        },
        ...u
      } = l9(e, t), d = await E7(t, u), C = $5(a), p = m8(a), h = H5(a) === "y", {
        width: f,
        height: g
      } = i.floating;
      let m, v;
      C === "top" || C === "bottom" ? (m = C, v = p === (await (o.isRTL == null ? void 0 : o.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (v = C, m = p === "end" ? "top" : "bottom");
      const b = g - d.top - d.bottom, w = f - d.left - d.right, M = g6(g - d[m], b), y = g6(f - d[v], w), _ = !t.middlewareData.shift;
      let S = M, j = y;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (j = w), (n = t.middlewareData.shift) != null && n.enabled.y && (S = b), _ && !p) {
        const P = w2(d.left, 0), A = w2(d.right, 0), R = w2(d.top, 0), z = w2(d.bottom, 0);
        h ? j = f - 2 * (P !== 0 || A !== 0 ? P + A : w2(d.left, d.right)) : S = g - 2 * (R !== 0 || z !== 0 ? R + z : w2(d.top, d.bottom));
      }
      await c({
        ...t,
        availableWidth: j,
        availableHeight: S
      });
      const V = await o.getDimensions(l.floating);
      return f !== V.width || g !== V.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function on(e) {
  const t = X2(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = v5(e), i = a ? e.offsetWidth : r, o = a ? e.offsetHeight : n, l = K9(r) !== i || K9(n) !== o;
  return l && (r = i, n = o), {
    width: r,
    height: n,
    $: l
  };
}
function q4(e) {
  return M2(e) ? e : e.contextElement;
}
function B6(e) {
  const t = q4(e);
  if (!v5(t))
    return C5(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = on(t);
  let o = (i ? K9(r.width) : r.width) / n, l = (i ? K9(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}
const jc = /* @__PURE__ */ C5(0);
function sn(e) {
  const t = D2(e);
  return !J4() || !t.visualViewport ? jc : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Vc(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== D2(e) ? !1 : t;
}
function v6(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), i = q4(e);
  let o = C5(1);
  t && (n ? M2(n) && (o = B6(n)) : o = B6(e));
  const l = Vc(i, r, n) ? sn(i) : C5(0);
  let c = (a.left + l.x) / o.x, u = (a.top + l.y) / o.y, d = a.width / o.x, C = a.height / o.y;
  if (i) {
    const p = D2(i), h = n && M2(n) ? D2(n) : n;
    let f = p, g = l4(f);
    for (; g && n && h !== f; ) {
      const m = B6(g), v = g.getBoundingClientRect(), b = X2(g), w = v.left + (g.clientLeft + parseFloat(b.paddingLeft)) * m.x, M = v.top + (g.clientTop + parseFloat(b.paddingTop)) * m.y;
      c *= m.x, u *= m.y, d *= m.x, C *= m.y, c += w, u += M, f = D2(g), g = l4(f);
    }
  }
  return e7({
    width: d,
    height: C,
    x: c,
    y: u
  });
}
function I7(e, t) {
  const r = A7(e).scrollLeft;
  return t ? t.left + r : v6(x5(e)).left + r;
}
function ln(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - I7(e, r), a = r.top + t.scrollTop;
  return {
    x: n,
    y: a
  };
}
function Ac(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: a
  } = e;
  const i = a === "fixed", o = x5(n), l = t ? V7(t.floating) : !1;
  if (n === o || l && i)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = C5(1);
  const d = C5(0), C = v5(n);
  if ((C || !C && !i) && ((s9(n) !== "body" || f8(o)) && (c = A7(n)), v5(n))) {
    const h = v6(n);
    u = B6(n), d.x = h.x + n.clientLeft, d.y = h.y + n.clientTop;
  }
  const p = o && !C && !i ? ln(o, c) : C5(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - c.scrollLeft * u.x + d.x + p.x,
    y: r.y * u.y - c.scrollTop * u.y + d.y + p.y
  };
}
function Ec(e) {
  return Array.from(e.getClientRects());
}
function Ic(e) {
  const t = x5(e), r = A7(e), n = e.ownerDocument.body, a = w2(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = w2(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + I7(e);
  const l = -r.scrollTop;
  return X2(n).direction === "rtl" && (o += w2(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: l
  };
}
const j0 = 25;
function Dc(e, t) {
  const r = D2(e), n = x5(e), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, l = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    const d = J4();
    (!d || d && t === "fixed") && (l = a.offsetLeft, c = a.offsetTop);
  }
  const u = I7(n);
  if (u <= 0) {
    const d = n.ownerDocument, C = d.body, p = getComputedStyle(C), h = d.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, f = Math.abs(n.clientWidth - C.clientWidth - h);
    f <= j0 && (i -= f);
  } else
    u <= j0 && (i += u);
  return {
    width: i,
    height: o,
    x: l,
    y: c
  };
}
const Nc = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Rc(e, t) {
  const r = v6(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, i = v5(e) ? B6(e) : C5(1), o = e.clientWidth * i.x, l = e.clientHeight * i.y, c = a * i.x, u = n * i.y;
  return {
    width: o,
    height: l,
    x: c,
    y: u
  };
}
function V0(e, t, r) {
  let n;
  if (t === "viewport")
    n = Dc(e, r);
  else if (t === "document")
    n = Ic(x5(e));
  else if (M2(t))
    n = Rc(t, r);
  else {
    const a = sn(e);
    n = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return e7(n);
}
function cn(e, t) {
  const r = W5(e);
  return r === t || !M2(r) || K6(r) ? !1 : X2(r).position === "fixed" || cn(r, t);
}
function Fc(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = G9(e, [], !1).filter((l) => M2(l) && s9(l) !== "body"), a = null;
  const i = X2(e).position === "fixed";
  let o = i ? W5(e) : e;
  for (; M2(o) && !K6(o); ) {
    const l = X2(o), c = $4(o);
    !c && l.position === "fixed" && (a = null), (i ? !c && !a : !c && l.position === "static" && !!a && Nc.has(a.position) || f8(o) && !c && cn(e, o)) ? n = n.filter((d) => d !== o) : a = l, o = W5(o);
  }
  return t.set(e, n), n;
}
function Oc(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const o = [...r === "clippingAncestors" ? V7(t) ? [] : Fc(t, this._c) : [].concat(r), n], l = o[0], c = o.reduce((u, d) => {
    const C = V0(t, d, a);
    return u.top = w2(C.top, u.top), u.right = g6(C.right, u.right), u.bottom = g6(C.bottom, u.bottom), u.left = w2(C.left, u.left), u;
  }, V0(t, l, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Bc(e) {
  const {
    width: t,
    height: r
  } = on(e);
  return {
    width: t,
    height: r
  };
}
function Zc(e, t, r) {
  const n = v5(t), a = x5(t), i = r === "fixed", o = v6(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = C5(0);
  function u() {
    c.x = I7(a);
  }
  if (n || !n && !i)
    if ((s9(t) !== "body" || f8(a)) && (l = A7(t)), n) {
      const h = v6(t, !0, i, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else
      a && u();
  i && !n && a && u();
  const d = a && !n && !i ? ln(a, l) : C5(0), C = o.left + l.scrollLeft - c.x - d.x, p = o.top + l.scrollTop - c.y - d.y;
  return {
    x: C,
    y: p,
    width: o.width,
    height: o.height
  };
}
function P3(e) {
  return X2(e).position === "static";
}
function A0(e, t) {
  if (!v5(e) || X2(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return x5(e) === r && (r = r.ownerDocument.body), r;
}
function un(e, t) {
  const r = D2(e);
  if (V7(e))
    return r;
  if (!v5(e)) {
    let a = W5(e);
    for (; a && !K6(a); ) {
      if (M2(a) && !P3(a))
        return a;
      a = W5(a);
    }
    return r;
  }
  let n = A0(e, t);
  for (; n && ic(n) && P3(n); )
    n = A0(n, t);
  return n && K6(n) && P3(n) && !$4(n) ? r : n || uc(e) || r;
}
const Gc = async function(e) {
  const t = this.getOffsetParent || un, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: Zc(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Kc(e) {
  return X2(e).direction === "rtl";
}
const zc = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ac,
  getDocumentElement: x5,
  getClippingRect: Oc,
  getOffsetParent: un,
  getElementRects: Gc,
  getClientRects: Ec,
  getDimensions: Bc,
  getScale: B6,
  isElement: M2,
  isRTL: Kc
};
function dn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Uc(e, t) {
  let r = null, n;
  const a = x5(e);
  function i() {
    var l;
    clearTimeout(n), (l = r) == null || l.disconnect(), r = null;
  }
  function o(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), i();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: C,
      width: p,
      height: h
    } = u;
    if (l || t(), !p || !h)
      return;
    const f = V8(C), g = V8(a.clientWidth - (d + p)), m = V8(a.clientHeight - (C + h)), v = V8(d), w = {
      rootMargin: -f + "px " + -g + "px " + -m + "px " + -v + "px",
      threshold: w2(0, g6(1, c)) || 1
    };
    let M = !0;
    function y(_) {
      const S = _[0].intersectionRatio;
      if (S !== c) {
        if (!M)
          return o();
        S ? o(!1, S) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !dn(u, e.getBoundingClientRect()) && o(), M = !1;
    }
    try {
      r = new IntersectionObserver(y, {
        ...w,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(y, w);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function Yc(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, u = q4(e), d = a || i ? [...u ? G9(u) : [], ...G9(t)] : [];
  d.forEach((v) => {
    a && v.addEventListener("scroll", r, {
      passive: !0
    }), i && v.addEventListener("resize", r);
  });
  const C = u && l ? Uc(u, r) : null;
  let p = -1, h = null;
  o && (h = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === u && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), r();
  }), u && !c && h.observe(u), h.observe(t));
  let f, g = c ? v6(e) : null;
  c && m();
  function m() {
    const v = v6(e);
    g && !dn(g, v) && r(), g = v, f = requestAnimationFrame(m);
  }
  return r(), () => {
    var v;
    d.forEach((b) => {
      a && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), C == null || C(), (v = h) == null || v.disconnect(), h = null, c && cancelAnimationFrame(f);
  };
}
const T3 = E7, Wc = Hc, $c = Pc, Jc = Sc, qc = Tc, Qc = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: zc,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return Mc(e, t, {
    ...a,
    platform: i
  });
};
var Xc = typeof document < "u", eu = function() {
}, O8 = Xc ? a8 : eu;
function t7(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!t7(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && e.$$typeof) && !t7(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Cn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function E0(e, t) {
  const r = Cn(e);
  return Math.round(t * r) / r;
}
function j3(e) {
  const t = Y.useRef(e);
  return O8(() => {
    t.current = e;
  }), t;
}
function tu(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, C] = Y.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = Y.useState(n);
  t7(p, n) || h(n);
  const [f, g] = Y.useState(null), [m, v] = Y.useState(null), b = Y.useCallback((E) => {
    E !== _.current && (_.current = E, g(E));
  }, []), w = Y.useCallback((E) => {
    E !== S.current && (S.current = E, v(E));
  }, []), M = i || f, y = o || m, _ = Y.useRef(null), S = Y.useRef(null), j = Y.useRef(d), V = c != null, P = j3(c), A = j3(a), R = j3(u), z = Y.useCallback(() => {
    if (!_.current || !S.current)
      return;
    const E = {
      placement: t,
      strategy: r,
      middleware: p
    };
    A.current && (E.platform = A.current), Qc(_.current, S.current, E).then((F) => {
      const I = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: R.current !== !1
      };
      N.current && !t7(j.current, I) && (j.current = I, O9.flushSync(() => {
        C(I);
      }));
    });
  }, [p, t, r, A, R]);
  O8(() => {
    u === !1 && j.current.isPositioned && (j.current.isPositioned = !1, C((E) => ({
      ...E,
      isPositioned: !1
    })));
  }, [u]);
  const N = Y.useRef(!1);
  O8(() => (N.current = !0, () => {
    N.current = !1;
  }), []), O8(() => {
    if (M && (_.current = M), y && (S.current = y), M && y) {
      if (P.current)
        return P.current(M, y, z);
      z();
    }
  }, [M, y, z, P, V]);
  const G = Y.useMemo(() => ({
    reference: _,
    floating: S,
    setReference: b,
    setFloating: w
  }), [b, w]), U = Y.useMemo(() => ({
    reference: M,
    floating: y
  }), [M, y]), Z = Y.useMemo(() => {
    const E = {
      position: r,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return E;
    const F = E0(U.floating, d.x), I = E0(U.floating, d.y);
    return l ? {
      ...E,
      transform: "translate(" + F + "px, " + I + "px)",
      ...Cn(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: F,
      top: I
    };
  }, [r, l, U.floating, d.x, d.y]);
  return Y.useMemo(() => ({
    ...d,
    update: z,
    refs: G,
    elements: U,
    floatingStyles: Z
  }), [d, z, G, U, Z]);
}
const pn = (e, t) => ({
  ...Wc(e),
  options: [e, t]
}), au = (e, t) => ({
  ...$c(e),
  options: [e, t]
}), nu = (e, t) => ({
  ...Jc(e),
  options: [e, t]
}), ru = (e, t) => ({
  ...qc(e),
  options: [e, t]
}), hn = {
  ...Y
}, iu = hn.useInsertionEffect, ou = iu || ((e) => e());
function fn(e) {
  const t = Y.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return ou(() => {
    t.current = e;
  }), Y.useCallback(function() {
    for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++)
      n[a] = arguments[a];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
var u4 = typeof document < "u" ? a8 : h1;
let I0 = !1, su = 0;
const D0 = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + su++
);
function lu() {
  const [e, t] = Y.useState(() => I0 ? D0() : void 0);
  return u4(() => {
    e == null && t(D0());
  }, []), Y.useEffect(() => {
    I0 = !0;
  }, []), e;
}
const cu = hn.useId, uu = cu || lu;
let z9;
process.env.NODE_ENV !== "production" && (z9 = /* @__PURE__ */ new Set());
function du() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const a = "Floating UI: " + r.join(" ");
  if (!((e = z9) != null && e.has(a))) {
    var i;
    (i = z9) == null || i.add(a), console.warn(a);
  }
}
function Cu() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const a = "Floating UI: " + r.join(" ");
  if (!((e = z9) != null && e.has(a))) {
    var i;
    (i = z9) == null || i.add(a), console.error(a);
  }
}
function pu() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      var n;
      (n = e.get(t)) == null || n.forEach((a) => a(r));
    },
    on(t, r) {
      e.set(t, [...e.get(t) || [], r]);
    },
    off(t, r) {
      var n;
      e.set(t, ((n = e.get(t)) == null ? void 0 : n.filter((a) => a !== r)) || []);
    }
  };
}
const hu = /* @__PURE__ */ Y.createContext(null), fu = /* @__PURE__ */ Y.createContext(null), mu = () => {
  var e;
  return ((e = Y.useContext(hu)) == null ? void 0 : e.id) || null;
}, gu = () => Y.useContext(fu), vu = "data-floating-ui-focusable";
function bu(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: n
  } = e, a = uu(), i = Y.useRef({}), [o] = Y.useState(() => pu()), l = mu() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = n.reference;
    h && !M2(h) && Cu("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, u] = Y.useState(n.reference), d = fn((h, f, g) => {
    i.current.openEvent = h ? f : void 0, o.emit("openchange", {
      open: h,
      event: f,
      reason: g,
      nested: l
    }), r == null || r(h, f, g);
  }), C = Y.useMemo(() => ({
    setPositionReference: u
  }), []), p = Y.useMemo(() => ({
    reference: c || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [c, n.reference, n.floating]);
  return Y.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: d,
    elements: p,
    events: o,
    floatingId: a,
    refs: C
  }), [t, d, p, o, a, C]);
}
function yu(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, r = bu({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || r, a = n.elements, [i, o] = Y.useState(null), [l, c] = Y.useState(null), d = (a == null ? void 0 : a.domReference) || i, C = Y.useRef(null), p = gu();
  u4(() => {
    d && (C.current = d);
  }, [d]);
  const h = tu({
    ...e,
    elements: {
      ...a,
      ...l && {
        reference: l
      }
    }
  }), f = Y.useCallback((w) => {
    const M = M2(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      contextElement: w
    } : w;
    c(M), h.refs.setReference(M);
  }, [h.refs]), g = Y.useCallback((w) => {
    (M2(w) || w === null) && (C.current = w, o(w)), (M2(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !M2(w)) && h.refs.setReference(w);
  }, [h.refs]), m = Y.useMemo(() => ({
    ...h.refs,
    setReference: g,
    setPositionReference: f,
    domReference: C
  }), [h.refs, g, f]), v = Y.useMemo(() => ({
    ...h.elements,
    domReference: d
  }), [h.elements, d]), b = Y.useMemo(() => ({
    ...h,
    ...n,
    refs: m,
    elements: v,
    nodeId: t
  }), [h, m, v, t, n]);
  return u4(() => {
    n.dataRef.current.floatingContext = b;
    const w = p == null ? void 0 : p.nodesRef.current.find((M) => M.id === t);
    w && (w.context = b);
  }), Y.useMemo(() => ({
    ...h,
    context: b,
    refs: m,
    elements: v
  }), [h, m, v, b]);
}
const N0 = "active", R0 = "selected";
function V3(e, t, r) {
  const n = /* @__PURE__ */ new Map(), a = r === "item";
  let i = e;
  if (a && e) {
    const {
      [N0]: o,
      [R0]: l,
      ...c
    } = e;
    i = c;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1,
      [vu]: ""
    },
    ...i,
    ...t.map((o) => {
      const l = o ? o[r] : null;
      return typeof l == "function" ? e ? l(e) : null : l;
    }).concat(e).reduce((o, l) => (l && Object.entries(l).forEach((c) => {
      let [u, d] = c;
      if (!(a && [N0, R0].includes(u)))
        if (u.indexOf("on") === 0) {
          if (n.has(u) || n.set(u, []), typeof d == "function") {
            var C;
            (C = n.get(u)) == null || C.push(d), o[u] = function() {
              for (var p, h = arguments.length, f = new Array(h), g = 0; g < h; g++)
                f[g] = arguments[g];
              return (p = n.get(u)) == null ? void 0 : p.map((m) => m(...f)).find((m) => m !== void 0);
            };
          }
        } else
          o[u] = d;
    }), o), {})
  };
}
function xu(e) {
  e === void 0 && (e = []);
  const t = e.map((l) => l == null ? void 0 : l.reference), r = e.map((l) => l == null ? void 0 : l.floating), n = e.map((l) => l == null ? void 0 : l.item), a = Y.useCallback(
    (l) => V3(l, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = Y.useCallback(
    (l) => V3(l, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = Y.useCallback(
    (l) => V3(l, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  );
  return Y.useMemo(() => ({
    getReferenceProps: a,
    getFloatingProps: i,
    getItemProps: o
  }), [a, i, o]);
}
function F0(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const wu = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: r,
      overflowRef: n,
      onFallbackChange: a,
      offset: i = 0,
      index: o = 0,
      minItemsVisible: l = 4,
      referenceOverflowThreshold: c = 0,
      scrollRef: u,
      ...d
    } = l9(e, t), {
      rects: C,
      elements: {
        floating: p
      }
    } = t, h = r.current[o], f = (u == null ? void 0 : u.current) || p, g = p.clientTop || f.clientTop, m = p.clientTop !== 0, v = f.clientTop !== 0, b = p === f;
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || du('`placement` side must be "bottom" when using the `inner`', "middleware.")), !h)
      return {};
    const w = {
      ...t,
      ...await pn(-h.offsetTop - p.clientTop - C.reference.height / 2 - h.offsetHeight / 2 - i).fn(t)
    }, M = await T3(F0(w, f.scrollHeight + g + p.clientTop), d), y = await T3(w, {
      ...d,
      elementContext: "reference"
    }), _ = w2(0, M.top), S = w.y + _, P = (f.scrollHeight > f.clientHeight ? (A) => A : K9)(w2(0, f.scrollHeight + (m && b || v ? g * 2 : 0) - _ - w2(0, M.bottom)));
    if (f.style.maxHeight = P + "px", f.scrollTop = _, a) {
      const A = f.offsetHeight < h.offsetHeight * g6(l, r.current.length) - 1 || y.top >= -c || y.bottom >= -c;
      O9.flushSync(() => a(A));
    }
    return n && (n.current = await T3(F0({
      ...w,
      y: S
    }, f.offsetHeight + g + p.clientTop), d)), {
      y: S
    };
  }
});
function _u(e, t) {
  const {
    open: r,
    elements: n
  } = e, {
    enabled: a = !0,
    overflowRef: i,
    scrollRef: o,
    onChange: l
  } = t, c = fn(l), u = Y.useRef(!1), d = Y.useRef(null), C = Y.useRef(null);
  Y.useEffect(() => {
    if (!a)
      return;
    function h(g) {
      if (g.ctrlKey || !f || i.current == null)
        return;
      const m = g.deltaY, v = i.current.top >= -0.5, b = i.current.bottom >= -0.5, w = f.scrollHeight - f.clientHeight, M = m < 0 ? -1 : 1, y = m < 0 ? "max" : "min";
      f.scrollHeight <= f.clientHeight || (!v && m > 0 || !b && m < 0 ? (g.preventDefault(), O9.flushSync(() => {
        c((_) => _ + Math[y](m, w * M));
      })) : /firefox/i.test(Cc()) && (f.scrollTop += m));
    }
    const f = (o == null ? void 0 : o.current) || n.floating;
    if (r && f)
      return f.addEventListener("wheel", h), requestAnimationFrame(() => {
        d.current = f.scrollTop, i.current != null && (C.current = {
          ...i.current
        });
      }), () => {
        d.current = null, C.current = null, f.removeEventListener("wheel", h);
      };
  }, [a, r, n.floating, i, o, c]);
  const p = Y.useMemo(() => ({
    onKeyDown() {
      u.current = !0;
    },
    onWheel() {
      u.current = !1;
    },
    onPointerMove() {
      u.current = !1;
    },
    onScroll() {
      const h = (o == null ? void 0 : o.current) || n.floating;
      if (!(!i.current || !h || !u.current)) {
        if (d.current !== null) {
          const f = h.scrollTop - d.current;
          (i.current.bottom < -0.5 && f < -1 || i.current.top < -0.5 && f > 1) && O9.flushSync(() => c((g) => g + f));
        }
        requestAnimationFrame(() => {
          d.current = h.scrollTop;
        });
      }
    }
  }), [n.floating, c, i, o]);
  return Y.useMemo(() => a ? {
    floating: p
  } : {}, [a, p]);
}
let c9 = V1({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
c9.displayName = "FloatingContext";
let Q4 = V1(null);
Q4.displayName = "PlacementContext";
function D7(e) {
  return Q(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function N7() {
  return M1(c9).setReference;
}
function mn() {
  return M1(c9).getReferenceProps;
}
function R7() {
  let { getFloatingProps: e, slot: t } = M1(c9);
  return y1((...r) => Object.assign({}, e(...r), { "data-anchor": t.anchor }), [e, t]);
}
function F7(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = M1(Q4), r = Q(() => e, [JSON.stringify(e, (a, i) => {
    var o;
    return (o = i == null ? void 0 : i.outerHTML) != null ? o : i;
  })]);
  x1(() => {
    t == null || t(r ?? null);
  }, [t, r]);
  let n = M1(c9);
  return Q(() => [n.setFloating, e ? n.styles : {}], [n.setFloating, e, n.styles]);
}
let O0 = 4;
function O7({ children: e, enabled: t = !0 }) {
  let [r, n] = e1(null), [a, i] = e1(0), o = J(null), [l, c] = e1(null);
  Mu(l);
  let u = t && r !== null && l !== null, { to: d = "bottom", gap: C = 0, offset: p = 0, padding: h = 0, inner: f } = Su(r, l), [g, m = "center"] = d.split(" ");
  x1(() => {
    u && i(0);
  }, [u]);
  let { refs: v, floatingStyles: b, context: w } = yu({ open: u, placement: g === "selection" ? m === "center" ? "bottom" : `bottom-${m}` : m === "center" ? `${g}` : `${g}-${m}`, strategy: "absolute", transform: !1, middleware: [pn({ mainAxis: g === "selection" ? 0 : C, crossAxis: p }), au({ padding: h }), g !== "selection" && nu({ padding: h }), g === "selection" && f ? wu({ ...f, padding: h, overflowRef: o, offset: a, minItemsVisible: O0, referenceOverflowThreshold: h, onFallbackChange(A) {
    var R, z;
    if (!A)
      return;
    let N = w.elements.floating;
    if (!N)
      return;
    let G = parseFloat(getComputedStyle(N).scrollPaddingBottom) || 0, U = Math.min(O0, N.childElementCount), Z = 0, E = 0;
    for (let F of (z = (R = w.elements.floating) == null ? void 0 : R.childNodes) != null ? z : [])
      if (F instanceof HTMLElement) {
        let I = F.offsetTop, T = I + F.clientHeight + G, B = N.scrollTop, D = B + N.clientHeight;
        if (I >= B && T <= D)
          U--;
        else {
          E = Math.max(0, Math.min(T, D) - Math.max(I, B)), Z = F.clientHeight;
          break;
        }
      }
    U >= 1 && i((F) => {
      let I = Z * U - E + G;
      return F >= I ? F : I;
    });
  } }) : null, ru({ padding: h, apply({ availableWidth: A, availableHeight: R, elements: z }) {
    Object.assign(z.floating.style, { overflow: "auto", maxWidth: `${A}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${R}px)` });
  } })].filter(Boolean), whileElementsMounted: Yc }), [M = g, y = m] = w.placement.split("-");
  g === "selection" && (M = "selection");
  let _ = Q(() => ({ anchor: [M, y].filter(Boolean).join(" ") }), [M, y]), S = _u(w, { overflowRef: o, onChange: i }), { getReferenceProps: j, getFloatingProps: V } = xu([S]), P = O((A) => {
    c(A), v.setFloating(A);
  });
  return Y.createElement(Q4.Provider, { value: n }, Y.createElement(c9.Provider, { value: { setFloating: P, setReference: v.setReference, styles: b, getReferenceProps: j, getFloatingProps: V, slot: _ } }, e));
}
function Mu(e) {
  x1(() => {
    if (!e)
      return;
    let t = new MutationObserver(() => {
      let r = window.getComputedStyle(e).maxHeight, n = parseFloat(r);
      if (isNaN(n))
        return;
      let a = parseInt(r);
      isNaN(a) || n !== a && (e.style.maxHeight = `${Math.ceil(n)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function Su(e, t) {
  var r, n, a;
  let i = A3((r = e == null ? void 0 : e.gap) != null ? r : "var(--anchor-gap, 0)", t), o = A3((n = e == null ? void 0 : e.offset) != null ? n : "var(--anchor-offset, 0)", t), l = A3((a = e == null ? void 0 : e.padding) != null ? a : "var(--anchor-padding, 0)", t);
  return { ...e, gap: i, offset: o, padding: l };
}
function A3(e, t, r = void 0) {
  let n = Y2(), a = O((c, u) => {
    if (c == null)
      return [r, null];
    if (typeof c == "number")
      return [c, null];
    if (typeof c == "string") {
      if (!u)
        return [r, null];
      let d = B0(c, u);
      return [d, (C) => {
        let p = gn(c);
        {
          let h = p.map((f) => window.getComputedStyle(u).getPropertyValue(f));
          n.requestAnimationFrame(function f() {
            n.nextFrame(f);
            let g = !1;
            for (let [v, b] of p.entries()) {
              let w = window.getComputedStyle(u).getPropertyValue(b);
              if (h[v] !== w) {
                h[v] = w, g = !0;
                break;
              }
            }
            if (!g)
              return;
            let m = B0(c, u);
            d !== m && (C(m), d = m);
          });
        }
        return n.dispose;
      }];
    }
    return [r, null];
  }), i = Q(() => a(e, t)[0], [e, t]), [o = i, l] = e1();
  return x1(() => {
    let [c, u] = a(e, t);
    if (l(c), !!u)
      return u(l);
  }, [e, t]), o;
}
function gn(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let r = t[1].indexOf(",");
    if (r === -1)
      return [t[1]];
    let n = t[1].slice(0, r).trim(), a = t[1].slice(r + 1).trim();
    return a ? [n, ...gn(a)] : [n];
  }
  return [];
}
function B0(e, t) {
  let r = document.createElement("div");
  t.appendChild(r), r.style.setProperty("margin-top", "0px", "important"), r.style.setProperty("margin-top", e, "important");
  let n = parseFloat(window.getComputedStyle(r).marginTop) || 0;
  return t.removeChild(r), n;
}
function ku({ children: e, freeze: t }) {
  let r = a7(t, e);
  return x.createElement(x.Fragment, null, r);
}
function a7(e, t) {
  let [r, n] = e1(t);
  return !e && r !== t && n(t), e ? r : t;
}
let B7 = V1(null);
B7.displayName = "OpenClosedContext";
var B1 = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(B1 || {});
function w5() {
  return M1(B7);
}
function u9({ value: e, children: t }) {
  return x.createElement(B7.Provider, { value: e }, t);
}
function X4({ children: e }) {
  return x.createElement(B7.Provider, { value: null }, e);
}
function Lu(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let o5 = [];
Lu(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || o5[0] === t.target)
      return;
    let r = t.target;
    r = r.closest(Q8), o5.unshift(r ?? t.target), o5 = o5.filter((n) => n != null && n.isConnected), o5.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Hu(e) {
  throw new Error("Unexpected object: " + e);
}
var g1 = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(g1 || {});
function z5(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0)
    return null;
  let n = t.resolveActiveIndex(), a = n ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return n;
    }
    case 1: {
      a === -1 && (a = r.length);
      for (let i = a - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return n;
    }
    case 2: {
      for (let i = a + 1; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return n;
    }
    case 3: {
      for (let i = r.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return n;
    }
    case 4: {
      for (let i = 0; i < r.length; ++i)
        if (t.resolveId(r[i], i, r) === e.id)
          return i;
      return n;
    }
    case 5:
      return null;
    default:
      Hu(e);
  }
}
var ee = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(ee || {});
function vn(e) {
  let t = O(e), r = J(!1);
  h1(() => (r.current = !1, () => {
    r.current = !0, r8(() => {
      r.current && t();
    });
  }), [t]);
}
function Pu() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in Y ? ((t) => t.useSyncExternalStore)(Y)(() => () => {
  }, () => !1, () => !e) : !1;
}
function g8() {
  let e = Pu(), [t, r] = Y.useState(d6.isHandoffComplete);
  return t && d6.isHandoffComplete === !1 && r(!1), Y.useEffect(() => {
    t !== !0 && r(!0);
  }, [t]), Y.useEffect(() => d6.handoff(), []), e ? !1 : t;
}
let bn = V1(!1);
function Tu() {
  return M1(bn);
}
function Z0(e) {
  return x.createElement(bn.Provider, { value: e.force }, e.children);
}
function ju(e) {
  let t = Tu(), r = M1(xn), n = W2(e), [a, i] = e1(() => {
    var o;
    if (!t && r !== null)
      return (o = r.current) != null ? o : null;
    if (d6.isServer)
      return null;
    let l = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (l)
      return l;
    if (n === null)
      return null;
    let c = n.createElement("div");
    return c.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(c);
  });
  return h1(() => {
    a !== null && (n != null && n.body.contains(a) || n == null || n.body.appendChild(a));
  }, [a, n]), h1(() => {
    t || r !== null && i(r.current);
  }, [r, i, t]), a;
}
let yn = q1, Vu = C1(function(e, t) {
  let r = e, n = J(null), a = w1(K4((C) => {
    n.current = C;
  }), t), i = W2(n), o = ju(n), [l] = e1(() => {
    var C;
    return d6.isServer ? null : (C = i == null ? void 0 : i.createElement("div")) != null ? C : null;
  }), c = M1(d4), u = g8();
  x1(() => {
    !o || !l || o.contains(l) || (l.setAttribute("data-headlessui-portal", ""), o.appendChild(l));
  }, [o, l]), x1(() => {
    if (l && c)
      return c.register(l);
  }, [c, l]), vn(() => {
    var C;
    !o || !l || (l instanceof Node && o.contains(l) && o.removeChild(l), o.childNodes.length <= 0 && ((C = o.parentElement) == null || C.removeChild(o)));
  });
  let d = f1();
  return u ? !o || !l ? null : ba(d({ ourProps: { ref: a }, theirProps: r, slot: {}, defaultTag: yn, name: "Portal" }), l) : null;
});
function Au(e, t) {
  let r = w1(t), { enabled: n = !0, ...a } = e, i = f1();
  return n ? x.createElement(Vu, { ...a, ref: r }) : i({ ourProps: { ref: r }, theirProps: a, slot: {}, defaultTag: yn, name: "Portal" });
}
let Eu = q1, xn = V1(null);
function Iu(e, t) {
  let { target: r, ...n } = e, a = { ref: w1(t) }, i = f1();
  return x.createElement(xn.Provider, { value: r }, i({ ourProps: a, theirProps: n, defaultTag: Eu, name: "Popover.Group" }));
}
let d4 = V1(null);
function wn() {
  let e = M1(d4), t = J([]), r = O((i) => (t.current.push(i), e && e.register(i), () => n(i))), n = O((i) => {
    let o = t.current.indexOf(i);
    o !== -1 && t.current.splice(o, 1), e && e.unregister(i);
  }), a = Q(() => ({ register: r, unregister: n, portals: t }), [r, n, t]);
  return [t, Q(() => function({ children: i }) {
    return x.createElement(d4.Provider, { value: a }, i);
  }, [a])];
}
let Du = C1(Au), _n = C1(Iu), d9 = Object.assign(Du, { Group: _n });
var Nu = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Nu || {}), Ru = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Ru || {}), Fu = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(Fu || {}), Ou = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(Ou || {});
function E3(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = t(e.options.slice()), a = n.length > 0 && n[0].dataRef.current.order !== null ? n.sort((o, l) => o.dataRef.current.order - l.dataRef.current.order) : c5(n, (o) => o.dataRef.current.domRef.current), i = r ? a.indexOf(r) : null;
  return i === -1 && (i = null), { options: a, activeOptionIndex: i };
}
let Bu = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, 0(e) {
  var t, r;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((r = e.dataRef.current) != null && r.value) {
    let n = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (n !== -1)
      return { ...e, activeOptionIndex: n, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, 3(e, t) {
  return e.isTyping === t.isTyping ? e : { ...e, isTyping: t.isTyping };
}, 2(e, t) {
  var r, n, a, i;
  if ((r = e.dataRef.current) != null && r.disabled || e.optionsElement && !((n = e.dataRef.current) != null && n.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let { options: u, disabled: d } = e.virtual, C = t.focus === g1.Specific ? t.idx : z5(t, { resolveItems: () => u, resolveActiveIndex: () => {
      var h, f;
      return (f = (h = e.activeOptionIndex) != null ? h : u.findIndex((g) => !d(g))) != null ? f : null;
    }, resolveDisabled: d, resolveId() {
      throw new Error("Function not implemented.");
    } }), p = (a = t.trigger) != null ? a : 2;
    return e.activeOptionIndex === C && e.activationTrigger === p ? e : { ...e, activeOptionIndex: C, activationTrigger: p, isTyping: !1, __demoMode: !1 };
  }
  let o = E3(e);
  if (o.activeOptionIndex === null) {
    let u = o.options.findIndex((d) => !d.dataRef.current.disabled);
    u !== -1 && (o.activeOptionIndex = u);
  }
  let l = t.focus === g1.Specific ? t.idx : z5(t, { resolveItems: () => o.options, resolveActiveIndex: () => o.activeOptionIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled }), c = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === l && e.activationTrigger === c ? e : { ...e, ...o, isTyping: !1, activeOptionIndex: l, activationTrigger: c, __demoMode: !1 };
}, 4: (e, t) => {
  var r, n, a;
  if ((r = e.dataRef.current) != null && r.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, o = E3(e, (c) => (c.push(i), c));
  e.activeOptionIndex === null && (n = e.dataRef.current) != null && n.isSelected(t.payload.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(i));
  let l = { ...e, ...o, activationTrigger: 2 };
  return (a = e.dataRef.current) != null && a.__demoMode && e.dataRef.current.value === void 0 && (l.activeOptionIndex = 0), l;
}, 5: (e, t) => {
  var r;
  if ((r = e.dataRef.current) != null && r.virtual)
    return { ...e, options: e.options.filter((a) => a.id !== t.id) };
  let n = E3(e, (a) => {
    let i = a.findIndex((o) => o.id === t.id);
    return i !== -1 && a.splice(i, 1), a;
  });
  return { ...e, ...n, activationTrigger: 2 };
}, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var r, n;
  if (e.virtual === null)
    return { ...e, virtual: { options: t.options, disabled: (r = t.disabled) != null ? r : () => !1 } };
  if (e.virtual.options === t.options && e.virtual.disabled === t.disabled)
    return e;
  let a = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let i = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    i !== -1 ? a = i : a = null;
  }
  return { ...e, activeOptionIndex: a, virtual: { options: t.options, disabled: (n = t.disabled) != null ? n : () => !1 } };
}, 8: (e, t) => e.inputElement === t.element ? e : { ...e, inputElement: t.element }, 9: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 10: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, te = V1(null);
te.displayName = "ComboboxActionsContext";
function v8(e) {
  let t = M1(te);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, v8), r;
  }
  return t;
}
let Mn = V1(null);
function Zu(e) {
  let t = C9("VirtualProvider"), { options: r } = t.virtual, [n, a] = Q(() => {
    let u = t.optionsElement;
    if (!u)
      return [0, 0];
    let d = window.getComputedStyle(u);
    return [parseFloat(d.paddingBlockStart || d.paddingTop), parseFloat(d.paddingBlockEnd || d.paddingBottom)];
  }, [t.optionsElement]), i = Il({ enabled: r.length !== 0, scrollPaddingStart: n, scrollPaddingEnd: a, count: r.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return t.optionsElement;
  }, overscan: 12 }), [o, l] = e1(0);
  x1(() => {
    l((u) => u + 1);
  }, [r]);
  let c = i.getVirtualItems();
  return c.length === 0 ? null : x.createElement(Mn.Provider, { value: i }, x.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (u) => {
    u && t.activationTrigger !== 0 && t.activeOptionIndex !== null && r.length > t.activeOptionIndex && i.scrollToIndex(t.activeOptionIndex);
  } }, c.map((u) => {
    var d;
    return x.createElement(q1, { key: u.key }, x.cloneElement((d = e.children) == null ? void 0 : d.call(e, { ...e.slot, option: r[u.index] }), { key: `${o}-${u.key}`, "data-index": u.index, "aria-setsize": r.length, "aria-posinset": u.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${u.start}px)`, overflowAnchor: "none" } }));
  })));
}
let U9 = V1(null);
U9.displayName = "ComboboxDataContext";
function C9(e) {
  let t = M1(U9);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, C9), r;
  }
  return t;
}
function Gu(e, t) {
  return P1(t.type, Bu, e, t);
}
let Ku = q1;
function zu(e, t) {
  var r, n;
  let a = E2(), { value: i, defaultValue: o, onChange: l, form: c, name: u, by: d, disabled: C = a || !1, onClose: p, __demoMode: h = !1, multiple: f = !1, immediate: g = !1, virtual: m = null, nullable: v, ...b } = e, w = o8(o), [M = f ? [] : void 0, y] = i8(i, l, w), [_, S] = j5(Gu, { dataRef: u6(), comboboxState: h ? 0 : 1, isTyping: !1, options: [], virtual: m ? { options: m.options, disabled: (r = m.disabled) != null ? r : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: h }), j = J(!1), V = J({ static: !1, hold: !1 }), P = Y4(d), A = O((l1) => m ? d === null ? m.options.indexOf(l1) : m.options.findIndex((k1) => P(k1, l1)) : _.options.findIndex((k1) => P(k1.dataRef.current.value, l1))), R = y1((l1) => P1(N.mode, { 1: () => M.some((k1) => P(k1, l1)), 0: () => P(M, l1) }), [M]), z = O((l1) => _.activeOptionIndex === A(l1)), N = Q(() => ({ ..._, immediate: g, optionsPropsRef: V, value: M, defaultValue: w, disabled: C, mode: f ? 1 : 0, virtual: m ? _.virtual : null, get activeOptionIndex() {
    if (j.current && _.activeOptionIndex === null && (m ? m.options.length > 0 : _.options.length > 0)) {
      if (m) {
        let k1 = m.options.findIndex((r2) => {
          var n5, n6;
          return !((n6 = (n5 = m.disabled) == null ? void 0 : n5.call(m, r2)) != null && n6);
        });
        if (k1 !== -1)
          return k1;
      }
      let l1 = _.options.findIndex((k1) => !k1.dataRef.current.disabled);
      if (l1 !== -1)
        return l1;
    }
    return _.activeOptionIndex;
  }, calculateIndex: A, compare: P, isSelected: R, isActive: z }), [M, w, C, f, h, _, m]);
  x1(() => {
    var l1;
    m && S({ type: 7, options: m.options, disabled: (l1 = m.disabled) != null ? l1 : null });
  }, [m, m == null ? void 0 : m.options, m == null ? void 0 : m.disabled]), x1(() => {
    _.dataRef.current = N;
  }, [N]);
  let G = N.comboboxState === 0;
  p8(G, [N.buttonElement, N.inputElement, N.optionsElement], () => d1.closeCombobox());
  let U = Q(() => {
    var l1, k1, r2;
    return { open: N.comboboxState === 0, disabled: C, activeIndex: N.activeOptionIndex, activeOption: N.activeOptionIndex === null ? null : N.virtual ? N.virtual.options[(l1 = N.activeOptionIndex) != null ? l1 : 0] : (r2 = (k1 = N.options[N.activeOptionIndex]) == null ? void 0 : k1.dataRef.current.value) != null ? r2 : null, value: M };
  }, [N, C, M]), Z = O(() => {
    if (N.activeOptionIndex !== null) {
      if (d1.setIsTyping(!1), N.virtual)
        D(N.virtual.options[N.activeOptionIndex]);
      else {
        let { dataRef: l1 } = N.options[N.activeOptionIndex];
        D(l1.current.value);
      }
      d1.goToOption(g1.Specific, N.activeOptionIndex);
    }
  }), E = O(() => {
    S({ type: 0 }), j.current = !0;
  }), F = O(() => {
    S({ type: 1 }), j.current = !1, p == null || p();
  }), I = O((l1) => {
    S({ type: 3, isTyping: l1 });
  }), T = O((l1, k1, r2) => (j.current = !1, l1 === g1.Specific ? S({ type: 2, focus: g1.Specific, idx: k1, trigger: r2 }) : S({ type: 2, focus: l1, trigger: r2 }))), B = O((l1, k1) => (S({ type: 4, payload: { id: l1, dataRef: k1 } }), () => {
    N.isActive(k1.current.value) && (j.current = !0), S({ type: 5, id: l1 });
  })), D = O((l1) => P1(N.mode, { 0() {
    return y == null ? void 0 : y(l1);
  }, 1() {
    let k1 = N.value.slice(), r2 = k1.findIndex((n5) => P(n5, l1));
    return r2 === -1 ? k1.push(l1) : k1.splice(r2, 1), y == null ? void 0 : y(k1);
  } })), $ = O((l1) => {
    S({ type: 6, trigger: l1 });
  }), W = O((l1) => {
    S({ type: 8, element: l1 });
  }), i1 = O((l1) => {
    S({ type: 9, element: l1 });
  }), r1 = O((l1) => {
    S({ type: 10, element: l1 });
  }), d1 = Q(() => ({ onChange: D, registerOption: B, goToOption: T, setIsTyping: I, closeCombobox: F, openCombobox: E, setActivationTrigger: $, selectActiveOption: Z, setInputElement: W, setButtonElement: i1, setOptionsElement: r1 }), []), [m1, Q1] = E5(), _1 = t === null ? {} : { ref: t }, p1 = y1(() => {
    if (w !== void 0)
      return y == null ? void 0 : y(w);
  }, [y, w]), T1 = f1();
  return x.createElement(Q1, { value: m1, props: { htmlFor: (n = N.inputElement) == null ? void 0 : n.id }, slot: { open: N.comboboxState === 0, disabled: C } }, x.createElement(O7, null, x.createElement(te.Provider, { value: d1 }, x.createElement(U9.Provider, { value: N }, x.createElement(u9, { value: P1(N.comboboxState, { 0: B1.Open, 1: B1.Closed }) }, u != null && x.createElement(s8, { disabled: C, data: M != null ? { [u]: M } : {}, form: c, onReset: p1 }), T1({ ourProps: _1, theirProps: b, slot: U, defaultTag: Ku, name: "Combobox" }))))));
}
let Uu = "input";
function Yu(e, t) {
  var r, n, a, i, o;
  let l = C9("Combobox.Input"), c = v8("Combobox.Input"), u = O1(), d = A5(), { id: C = d || `headlessui-combobox-input-${u}`, onChange: p, displayValue: h, disabled: f = l.disabled || !1, autoFocus: g = !1, type: m = "text", ...v } = e, b = J(null), w = w1(b, t, N7(), c.setInputElement), M = W2(l.inputElement), y = Y2(), _ = O(() => {
    c.onChange(null), l.optionsElement && (l.optionsElement.scrollTop = 0), c.goToOption(g1.Nothing);
  }), S = Q(() => {
    var D;
    return typeof h == "function" && l.value !== void 0 ? (D = h(l.value)) != null ? D : "" : typeof l.value == "string" ? l.value : "";
  }, [l.value, h]);
  Z9(([D, $], [W, i1]) => {
    if (l.isTyping)
      return;
    let r1 = b.current;
    r1 && ((i1 === 0 && $ === 1 || D !== W) && (r1.value = D), requestAnimationFrame(() => {
      if (l.isTyping || !r1 || (M == null ? void 0 : M.activeElement) !== r1)
        return;
      let { selectionStart: d1, selectionEnd: m1 } = r1;
      Math.abs((m1 ?? 0) - (d1 ?? 0)) === 0 && d1 === 0 && r1.setSelectionRange(r1.value.length, r1.value.length);
    }));
  }, [S, l.comboboxState, M, l.isTyping]), Z9(([D], [$]) => {
    if (D === 0 && $ === 1) {
      if (l.isTyping)
        return;
      let W = b.current;
      if (!W)
        return;
      let i1 = W.value, { selectionStart: r1, selectionEnd: d1, selectionDirection: m1 } = W;
      W.value = "", W.value = i1, m1 !== null ? W.setSelectionRange(r1, d1, m1) : W.setSelectionRange(r1, d1);
    }
  }, [l.comboboxState]);
  let j = J(!1), V = O(() => {
    j.current = !0;
  }), P = O(() => {
    y.nextFrame(() => {
      j.current = !1;
    });
  }), A = O((D) => {
    switch (c.setIsTyping(!0), D.key) {
      case X.Enter:
        if (l.comboboxState !== 0 || j.current)
          return;
        if (D.preventDefault(), D.stopPropagation(), l.activeOptionIndex === null) {
          c.closeCombobox();
          return;
        }
        c.selectActiveOption(), l.mode === 0 && c.closeCombobox();
        break;
      case X.ArrowDown:
        return D.preventDefault(), D.stopPropagation(), P1(l.comboboxState, { 0: () => c.goToOption(g1.Next), 1: () => c.openCombobox() });
      case X.ArrowUp:
        return D.preventDefault(), D.stopPropagation(), P1(l.comboboxState, { 0: () => c.goToOption(g1.Previous), 1: () => {
          C2(() => c.openCombobox()), l.value || c.goToOption(g1.Last);
        } });
      case X.Home:
        if (D.shiftKey)
          break;
        return D.preventDefault(), D.stopPropagation(), c.goToOption(g1.First);
      case X.PageUp:
        return D.preventDefault(), D.stopPropagation(), c.goToOption(g1.First);
      case X.End:
        if (D.shiftKey)
          break;
        return D.preventDefault(), D.stopPropagation(), c.goToOption(g1.Last);
      case X.PageDown:
        return D.preventDefault(), D.stopPropagation(), c.goToOption(g1.Last);
      case X.Escape:
        return l.comboboxState !== 0 ? void 0 : (D.preventDefault(), l.optionsElement && !l.optionsPropsRef.current.static && D.stopPropagation(), l.mode === 0 && l.value === null && _(), c.closeCombobox());
      case X.Tab:
        if (l.comboboxState !== 0)
          return;
        l.mode === 0 && l.activationTrigger !== 1 && c.selectActiveOption(), c.closeCombobox();
        break;
    }
  }), R = O((D) => {
    p == null || p(D), l.mode === 0 && D.target.value === "" && _(), c.openCombobox();
  }), z = O((D) => {
    var $, W, i1;
    let r1 = ($ = D.relatedTarget) != null ? $ : o5.find((d1) => d1 !== D.currentTarget);
    if (!((W = l.optionsElement) != null && W.contains(r1)) && !((i1 = l.buttonElement) != null && i1.contains(r1)) && l.comboboxState === 0)
      return D.preventDefault(), l.mode === 0 && l.value === null && _(), c.closeCombobox();
  }), N = O((D) => {
    var $, W, i1;
    let r1 = ($ = D.relatedTarget) != null ? $ : o5.find((d1) => d1 !== D.currentTarget);
    (W = l.buttonElement) != null && W.contains(r1) || (i1 = l.optionsElement) != null && i1.contains(r1) || l.disabled || l.immediate && l.comboboxState !== 0 && y.microTask(() => {
      C2(() => c.openCombobox()), c.setActivationTrigger(1);
    });
  }), G = a5(), U = Q5(), { isFocused: Z, focusProps: E } = x2({ autoFocus: g }), { isHovered: F, hoverProps: I } = S2({ isDisabled: f }), T = Q(() => ({ open: l.comboboxState === 0, disabled: f, hover: F, focus: Z, autofocus: g }), [l, F, Z, g, f]), B = a2({ ref: w, id: C, role: "combobox", type: m, "aria-controls": (r = l.optionsElement) == null ? void 0 : r.id, "aria-expanded": l.comboboxState === 0, "aria-activedescendant": l.activeOptionIndex === null ? void 0 : l.virtual ? (n = l.options.find((D) => !D.dataRef.current.disabled && l.compare(D.dataRef.current.value, l.virtual.options[l.activeOptionIndex]))) == null ? void 0 : n.id : (a = l.options[l.activeOptionIndex]) == null ? void 0 : a.id, "aria-labelledby": G, "aria-describedby": U, "aria-autocomplete": "list", defaultValue: (o = (i = e.defaultValue) != null ? i : l.defaultValue !== void 0 ? h == null ? void 0 : h(l.defaultValue) : null) != null ? o : l.defaultValue, disabled: f || void 0, autoFocus: g, onCompositionStart: V, onCompositionEnd: P, onKeyDown: A, onChange: R, onFocus: N, onBlur: z }, E, I);
  return f1()({ ourProps: B, theirProps: v, slot: T, defaultTag: Uu, name: "Combobox.Input" });
}
let Wu = "button";
function $u(e, t) {
  var r;
  let n = C9("Combobox.Button"), a = v8("Combobox.Button"), i = w1(t, a.setButtonElement), o = O1(), { id: l = `headlessui-combobox-button-${o}`, disabled: c = n.disabled || !1, autoFocus: u = !1, ...d } = e, C = Qa(n.inputElement), p = O((S) => {
    switch (S.key) {
      case X.Space:
      case X.Enter:
        S.preventDefault(), S.stopPropagation(), n.comboboxState === 1 && C2(() => a.openCombobox()), C();
        return;
      case X.ArrowDown:
        S.preventDefault(), S.stopPropagation(), n.comboboxState === 1 && (C2(() => a.openCombobox()), n.value || a.goToOption(g1.First)), C();
        return;
      case X.ArrowUp:
        S.preventDefault(), S.stopPropagation(), n.comboboxState === 1 && (C2(() => a.openCombobox()), n.value || a.goToOption(g1.Last)), C();
        return;
      case X.Escape:
        if (n.comboboxState !== 0)
          return;
        S.preventDefault(), n.optionsElement && !n.optionsPropsRef.current.static && S.stopPropagation(), C2(() => a.closeCombobox()), C();
        return;
      default:
        return;
    }
  }), h = O((S) => {
    S.preventDefault(), !y5(S.currentTarget) && (S.button === ee.Left && (n.comboboxState === 0 ? a.closeCombobox() : a.openCombobox()), C());
  }), f = a5([l]), { isFocusVisible: g, focusProps: m } = x2({ autoFocus: u }), { isHovered: v, hoverProps: b } = S2({ isDisabled: c }), { pressed: w, pressProps: M } = t5({ disabled: c }), y = Q(() => ({ open: n.comboboxState === 0, active: w || n.comboboxState === 0, disabled: c, value: n.value, hover: v, focus: g }), [n, v, g, w, c]), _ = a2({ ref: i, id: l, type: x6(e, n.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (r = n.optionsElement) == null ? void 0 : r.id, "aria-expanded": n.comboboxState === 0, "aria-labelledby": f, disabled: c || void 0, autoFocus: u, onMouseDown: h, onKeyDown: p }, m, b, M);
  return f1()({ ourProps: _, theirProps: d, slot: y, defaultTag: Wu, name: "Combobox.Button" });
}
let Ju = "div", qu = h2.RenderStrategy | h2.Static;
function Qu(e, t) {
  var r, n, a;
  let i = O1(), { id: o = `headlessui-combobox-options-${i}`, hold: l = !1, anchor: c, portal: u = !1, modal: d = !0, transition: C = !1, ...p } = e, h = C9("Combobox.Options"), f = v8("Combobox.Options"), g = D7(c);
  g && (u = !0);
  let [m, v] = F7(g), [b, w] = e1(null), M = R7(), y = w1(t, g ? m : null, f.setOptionsElement, w), _ = W2(h.optionsElement), S = w5(), [j, V] = _6(C, b, S !== null ? (S & B1.Open) === B1.Open : h.comboboxState === 0);
  c8(j, h.inputElement, f.closeCombobox);
  let P = h.__demoMode ? !1 : d && h.comboboxState === 0;
  h8(P, _);
  let A = h.__demoMode ? !1 : d && h.comboboxState === 0;
  P7(A, { allowed: y1(() => [h.inputElement, h.buttonElement, h.optionsElement], [h.inputElement, h.buttonElement, h.optionsElement]) }), x1(() => {
    var B;
    h.optionsPropsRef.current.static = (B = e.static) != null ? B : !1;
  }, [h.optionsPropsRef, e.static]), x1(() => {
    h.optionsPropsRef.current.hold = l;
  }, [h.optionsPropsRef, l]), Xa(h.comboboxState === 0, { container: h.optionsElement, accept(B) {
    return B.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : B.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(B) {
    B.setAttribute("role", "none");
  } });
  let R = a5([(r = h.buttonElement) == null ? void 0 : r.id]), z = Q(() => ({ open: h.comboboxState === 0, option: void 0 }), [h.comboboxState]), N = O(() => {
    f.setActivationTrigger(0);
  }), G = O((B) => {
    B.preventDefault(), f.setActivationTrigger(0);
  }), U = a2(g ? M() : {}, { "aria-labelledby": R, role: "listbox", "aria-multiselectable": h.mode === 1 ? !0 : void 0, id: o, ref: y, style: { ...p.style, ...v, "--input-width": B9(h.inputElement, !0).width, "--button-width": B9(h.buttonElement, !0).width }, onWheel: h.activationTrigger === 0 ? void 0 : N, onMouseDown: G, ...w6(V) }), Z = j && h.comboboxState === 1, E = a7(Z, (n = h.virtual) == null ? void 0 : n.options), F = a7(Z, h.value), I = O((B) => h.compare(F, B));
  if (h.virtual) {
    if (E === void 0)
      throw new Error("Missing `options` in virtual mode");
    Object.assign(p, { children: x.createElement(U9.Provider, { value: E !== h.virtual.options ? { ...h, virtual: { ...h.virtual, options: E } } : h }, x.createElement(Zu, { slot: z }, p.children)) });
  }
  let T = f1();
  return x.createElement(d9, { enabled: u ? e.static || j : !1 }, x.createElement(U9.Provider, { value: h.mode === 1 ? h : { ...h, isSelected: I } }, T({ ourProps: U, theirProps: { ...p, children: x.createElement(ku, { freeze: Z }, typeof p.children == "function" ? (a = p.children) == null ? void 0 : a.call(p, z) : p.children) }, slot: z, defaultTag: Ju, features: qu, visible: j, name: "Combobox.Options" })));
}
let Xu = "div";
function ed(e, t) {
  var r, n, a, i;
  let o = C9("Combobox.Option"), l = v8("Combobox.Option"), c = O1(), { id: u = `headlessui-combobox-option-${c}`, value: d, disabled: C = (a = (n = (r = o.virtual) == null ? void 0 : r.disabled) == null ? void 0 : n.call(r, d)) != null ? a : !1, order: p = null, ...h } = e, f = Qa(o.inputElement), g = o.virtual ? o.activeOptionIndex === o.calculateIndex(d) : o.activeOptionIndex === null ? !1 : ((i = o.options[o.activeOptionIndex]) == null ? void 0 : i.id) === u, m = o.isSelected(d), v = J(null), b = b2({ disabled: C, value: d, domRef: v, order: p }), w = M1(Mn), M = w1(t, v, w ? w.measureElement : null), y = O(() => {
    l.setIsTyping(!1), l.onChange(d);
  });
  x1(() => l.registerOption(u, b), [b, u]);
  let _ = J(!(o.virtual || o.__demoMode));
  x1(() => {
    if (!o.virtual && !o.__demoMode)
      return N2().requestAnimationFrame(() => {
        _.current = !0;
      });
  }, [o.virtual, o.__demoMode]), x1(() => {
    if (_.current && o.comboboxState === 0 && g && o.activationTrigger !== 0)
      return N2().requestAnimationFrame(() => {
        var G, U;
        (U = (G = v.current) == null ? void 0 : G.scrollIntoView) == null || U.call(G, { block: "nearest" });
      });
  }, [v, g, o.comboboxState, o.activationTrigger, o.activeOptionIndex]);
  let S = O((G) => {
    G.preventDefault(), G.button === ee.Left && (C || (y(), Ja() || requestAnimationFrame(() => f()), o.mode === 0 && l.closeCombobox()));
  }), j = O(() => {
    if (C)
      return l.goToOption(g1.Nothing);
    let G = o.calculateIndex(d);
    l.goToOption(g1.Specific, G);
  }), V = W4(), P = O((G) => V.update(G)), A = O((G) => {
    if (!V.wasMoved(G) || C || g)
      return;
    let U = o.calculateIndex(d);
    l.goToOption(g1.Specific, U, 0);
  }), R = O((G) => {
    V.wasMoved(G) && (C || g && (o.optionsPropsRef.current.hold || l.goToOption(g1.Nothing)));
  }), z = Q(() => ({ active: g, focus: g, selected: m, disabled: C }), [g, m, C]), N = { id: u, ref: M, role: "option", tabIndex: C === !0 ? void 0 : -1, "aria-disabled": C === !0 ? !0 : void 0, "aria-selected": m, disabled: void 0, onMouseDown: S, onFocus: j, onPointerEnter: P, onMouseEnter: P, onPointerMove: A, onMouseMove: A, onPointerLeave: R, onMouseLeave: R };
  return f1()({ ourProps: N, theirProps: h, slot: z, defaultTag: Xu, name: "Combobox.Option" });
}
let td = C1(zu), b8 = C1($u), ae = C1(Yu), Sn = i9, Z7 = C1(Qu), G7 = C1(ed), ne = Object.assign(td, { Input: ae, Button: b8, Label: Sn, Options: Z7, Option: G7 }), ad = q1;
function nd(e, t) {
  let { ...r } = e, n = !1, { isFocusVisible: a, focusProps: i } = x2(), { isHovered: o, hoverProps: l } = S2({ isDisabled: n }), { pressed: c, pressProps: u } = t5({ disabled: n }), d = a2({ ref: t }, i, l, u), C = Q(() => ({ hover: o, focus: a, active: c }), [o, a, c]);
  return f1()({ ourProps: d, theirProps: r, slot: C, defaultTag: ad, name: "DataInteractive" });
}
let rd = C1(nd);
function id(e, t = typeof document < "u" ? document.defaultView : null, r) {
  let n = o9(e, "escape");
  T7(t, "keydown", (a) => {
    n && (a.defaultPrevented || a.key === X.Escape && r(a));
  });
}
function od() {
  var e;
  let [t] = e1(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [r, n] = e1((e = t == null ? void 0 : t.matches) != null ? e : !1);
  return x1(() => {
    if (!t)
      return;
    function a(i) {
      n(i.matches);
    }
    return t.addEventListener("change", a), () => t.removeEventListener("change", a);
  }, [t]), r;
}
function kn({ defaultContainers: e = [], portals: t, mainTreeNode: r } = {}) {
  let n = W2(r), a = O(() => {
    var i, o;
    let l = [];
    for (let c of e)
      c !== null && (c instanceof HTMLElement ? l.push(c) : "current" in c && c.current instanceof HTMLElement && l.push(c.current));
    if (t != null && t.current)
      for (let c of t.current)
        l.push(c);
    for (let c of (i = n == null ? void 0 : n.querySelectorAll("html > *, body > *")) != null ? i : [])
      c !== document.body && c !== document.head && c instanceof HTMLElement && c.id !== "headlessui-portal-root" && (r && (c.contains(r) || c.contains((o = r == null ? void 0 : r.getRootNode()) == null ? void 0 : o.host)) || l.some((u) => c.contains(u)) || l.push(c));
    return l;
  });
  return { resolveContainers: a, contains: O((i) => a().some((o) => o.contains(i))) };
}
let Ln = V1(null);
function n7({ children: e, node: t }) {
  let [r, n] = e1(null), a = re(t ?? r);
  return x.createElement(Ln.Provider, { value: a }, e, a === null && x.createElement(Q2, { features: q2.Hidden, ref: (i) => {
    var o, l;
    if (i) {
      for (let c of (l = (o = U2(i)) == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? l : [])
        if (c !== document.body && c !== document.head && c instanceof HTMLElement && c != null && c.contains(i)) {
          n(c);
          break;
        }
    }
  } }));
}
function re(e = null) {
  var t;
  return (t = M1(Ln)) != null ? t : e;
}
function K7() {
  let e = J(!1);
  return x1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var I2 = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(I2 || {});
function ie() {
  let e = J(0);
  return qa(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function Hn(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.current)
    r.current instanceof HTMLElement && t.add(r.current);
  return t;
}
let sd = "div";
var L5 = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(L5 || {});
function ld(e, t) {
  let r = J(null), n = w1(r, t), { initialFocus: a, initialFocusFallback: i, containers: o, features: l = 15, ...c } = e;
  g8() || (l = 0);
  let u = W2(r);
  dd(l, { ownerDocument: u });
  let d = Cd(l, { ownerDocument: u, container: r, initialFocus: a, initialFocusFallback: i });
  pd(l, { ownerDocument: u, container: r, containers: o, previousActiveElement: d });
  let C = ie(), p = O((b) => {
    let w = r.current;
    w && ((M) => M())(() => {
      P1(C.current, { [I2.Forwards]: () => {
        l2(w, R1.First, { skipElements: [b.relatedTarget, i] });
      }, [I2.Backwards]: () => {
        l2(w, R1.Last, { skipElements: [b.relatedTarget, i] });
      } });
    });
  }), h = o9(!!(l & 2), "focus-trap#tab-lock"), f = Y2(), g = J(!1), m = { ref: n, onKeyDown(b) {
    b.key == "Tab" && (g.current = !0, f.requestAnimationFrame(() => {
      g.current = !1;
    }));
  }, onBlur(b) {
    if (!(l & 4))
      return;
    let w = Hn(o);
    r.current instanceof HTMLElement && w.add(r.current);
    let M = b.relatedTarget;
    M instanceof HTMLElement && M.dataset.headlessuiFocusGuard !== "true" && (Pn(w, M) || (g.current ? l2(r.current, P1(C.current, { [I2.Forwards]: () => R1.Next, [I2.Backwards]: () => R1.Previous }) | R1.WrapAround, { relativeTo: b.target }) : b.target instanceof HTMLElement && d5(b.target)));
  } }, v = f1();
  return x.createElement(x.Fragment, null, h && x.createElement(Q2, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: q2.Focusable }), v({ ourProps: m, theirProps: c, defaultTag: sd, name: "FocusTrap" }), h && x.createElement(Q2, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: q2.Focusable }));
}
let cd = C1(ld), oe = Object.assign(cd, { features: L5 });
function ud(e = !0) {
  let t = J(o5.slice());
  return Z9(([r], [n]) => {
    n === !0 && r === !1 && r8(() => {
      t.current.splice(0);
    }), n === !1 && r === !0 && (t.current = o5.slice());
  }, [e, o5, t]), O(() => {
    var r;
    return (r = t.current.find((n) => n != null && n.isConnected)) != null ? r : null;
  });
}
function dd(e, { ownerDocument: t }) {
  let r = !!(e & 8), n = ud(r);
  Z9(() => {
    r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && d5(n());
  }, [r]), vn(() => {
    r && d5(n());
  });
}
function Cd(e, { ownerDocument: t, container: r, initialFocus: n, initialFocusFallback: a }) {
  let i = J(null), o = o9(!!(e & 1), "focus-trap#initial-focus"), l = K7();
  return Z9(() => {
    if (e === 0)
      return;
    if (!o) {
      a != null && a.current && d5(a.current);
      return;
    }
    let c = r.current;
    c && r8(() => {
      if (!l.current)
        return;
      let u = t == null ? void 0 : t.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === u) {
          i.current = u;
          return;
        }
      } else if (c.contains(u)) {
        i.current = u;
        return;
      }
      if (n != null && n.current)
        d5(n.current);
      else {
        if (e & 16) {
          if (l2(c, R1.First | R1.AutoFocus) !== Z2.Error)
            return;
        } else if (l2(c, R1.First) !== Z2.Error)
          return;
        if (a != null && a.current && (d5(a.current), (t == null ? void 0 : t.activeElement) === a.current))
          return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      i.current = t == null ? void 0 : t.activeElement;
    });
  }, [a, o, e]), i;
}
function pd(e, { ownerDocument: t, container: r, containers: n, previousActiveElement: a }) {
  let i = K7(), o = !!(e & 4);
  T7(t == null ? void 0 : t.defaultView, "focus", (l) => {
    if (!o || !i.current)
      return;
    let c = Hn(n);
    r.current instanceof HTMLElement && c.add(r.current);
    let u = a.current;
    if (!u)
      return;
    let d = l.target;
    d && d instanceof HTMLElement ? Pn(c, d) ? (a.current = d, d5(d)) : (l.preventDefault(), l.stopPropagation(), d5(u)) : d5(a.current);
  }, !0);
}
function Pn(e, t) {
  for (let r of e)
    if (r.contains(t))
      return !0;
  return !1;
}
function Tn(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : Vn) !== q1 || x.Children.count(e.children) === 1;
}
let z7 = V1(null);
z7.displayName = "TransitionContext";
var hd = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(hd || {});
function fd() {
  let e = M1(z7);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function md() {
  let e = M1(U7);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let U7 = V1(null);
U7.displayName = "NestingContext";
function Y7(e) {
  return "children" in e ? Y7(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function jn(e, t) {
  let r = b2(e), n = J([]), a = K7(), i = Y2(), o = O((h, f = Z5.Hidden) => {
    let g = n.current.findIndex(({ el: m }) => m === h);
    g !== -1 && (P1(f, { [Z5.Unmount]() {
      n.current.splice(g, 1);
    }, [Z5.Hidden]() {
      n.current[g].state = "hidden";
    } }), i.microTask(() => {
      var m;
      !Y7(n) && a.current && ((m = r.current) == null || m.call(r));
    }));
  }), l = O((h) => {
    let f = n.current.find(({ el: g }) => g === h);
    return f ? f.state !== "visible" && (f.state = "visible") : n.current.push({ el: h, state: "visible" }), () => o(h, Z5.Unmount);
  }), c = J([]), u = J(Promise.resolve()), d = J({ enter: [], leave: [] }), C = O((h, f, g) => {
    c.current.splice(0), t && (t.chains.current[f] = t.chains.current[f].filter(([m]) => m !== h)), t == null || t.chains.current[f].push([h, new Promise((m) => {
      c.current.push(m);
    })]), t == null || t.chains.current[f].push([h, new Promise((m) => {
      Promise.all(d.current[f].map(([v, b]) => b)).then(() => m());
    })]), f === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => g(f)) : g(f);
  }), p = O((h, f, g) => {
    Promise.all(d.current[f].splice(0).map(([m, v]) => v)).then(() => {
      var m;
      (m = c.current.shift()) == null || m();
    }).then(() => g(f));
  });
  return Q(() => ({ children: n, register: l, unregister: o, onStart: C, onStop: p, wait: u, chains: d }), [l, o, n, C, p, d, u]);
}
let Vn = q1, An = h2.RenderStrategy;
function gd(e, t) {
  var r, n;
  let { transition: a = !0, beforeEnter: i, afterEnter: o, beforeLeave: l, afterLeave: c, enter: u, enterFrom: d, enterTo: C, entered: p, leave: h, leaveFrom: f, leaveTo: g, ...m } = e, [v, b] = e1(null), w = J(null), M = Tn(e), y = w1(...M ? [w, t, b] : t === null ? [] : [t]), _ = (r = m.unmount) == null || r ? Z5.Unmount : Z5.Hidden, { show: S, appear: j, initial: V } = fd(), [P, A] = e1(S ? "visible" : "hidden"), R = md(), { register: z, unregister: N } = R;
  x1(() => z(w), [z, w]), x1(() => {
    if (_ === Z5.Hidden && w.current) {
      if (S && P !== "visible") {
        A("visible");
        return;
      }
      return P1(P, { hidden: () => N(w), visible: () => z(w) });
    }
  }, [P, w, z, N, S, _]);
  let G = g8();
  x1(() => {
    if (M && G && P === "visible" && w.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [w, P, G, M]);
  let U = V && !j, Z = j && S && V, E = J(!1), F = jn(() => {
    E.current || (A("hidden"), N(w));
  }, R), I = O((r1) => {
    E.current = !0;
    let d1 = r1 ? "enter" : "leave";
    F.onStart(w, d1, (m1) => {
      m1 === "enter" ? i == null || i() : m1 === "leave" && (l == null || l());
    });
  }), T = O((r1) => {
    let d1 = r1 ? "enter" : "leave";
    E.current = !1, F.onStop(w, d1, (m1) => {
      m1 === "enter" ? o == null || o() : m1 === "leave" && (c == null || c());
    }), d1 === "leave" && !Y7(F) && (A("hidden"), N(w));
  });
  h1(() => {
    M && a || (I(S), T(S));
  }, [S, M, a]);
  let B = !(!a || !M || !G || U), [, D] = _6(B, v, S, { start: I, end: T }), $ = F5({ ref: y, className: ((n = o4(m.className, Z && u, Z && d, D.enter && u, D.enter && D.closed && d, D.enter && !D.closed && C, D.leave && h, D.leave && !D.closed && f, D.leave && D.closed && g, !D.transition && S && p)) == null ? void 0 : n.trim()) || void 0, ...w6(D) }), W = 0;
  P === "visible" && (W |= B1.Open), P === "hidden" && (W |= B1.Closed), D.enter && (W |= B1.Opening), D.leave && (W |= B1.Closing);
  let i1 = f1();
  return x.createElement(U7.Provider, { value: F }, x.createElement(u9, { value: W }, i1({ ourProps: $, theirProps: m, defaultTag: Vn, features: An, visible: P === "visible", name: "Transition.Child" })));
}
function vd(e, t) {
  let { show: r, appear: n = !1, unmount: a = !0, ...i } = e, o = J(null), l = Tn(e), c = w1(...l ? [o, t] : t === null ? [] : [t]);
  g8();
  let u = w5();
  if (r === void 0 && u !== null && (r = (u & B1.Open) === B1.Open), r === void 0)
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [d, C] = e1(r ? "visible" : "hidden"), p = jn(() => {
    r || C("hidden");
  }), [h, f] = e1(!0), g = J([r]);
  x1(() => {
    h !== !1 && g.current[g.current.length - 1] !== r && (g.current.push(r), f(!1));
  }, [g, r]);
  let m = Q(() => ({ show: r, appear: n, initial: h }), [r, n, h]);
  x1(() => {
    r ? C("visible") : !Y7(p) && o.current !== null && C("hidden");
  }, [r, p]);
  let v = { unmount: a }, b = O(() => {
    var y;
    h && f(!1), (y = e.beforeEnter) == null || y.call(e);
  }), w = O(() => {
    var y;
    h && f(!1), (y = e.beforeLeave) == null || y.call(e);
  }), M = f1();
  return x.createElement(U7.Provider, { value: p }, x.createElement(z7.Provider, { value: m }, M({ ourProps: { ...v, as: q1, children: x.createElement(En, { ref: c, ...v, ...i, beforeEnter: b, beforeLeave: w }) }, theirProps: {}, defaultTag: q1, features: An, visible: d === "visible", name: "Transition" })));
}
function bd(e, t) {
  let r = M1(z7) !== null, n = w5() !== null;
  return x.createElement(x.Fragment, null, !r && n ? x.createElement(C4, { ref: t, ...e }) : x.createElement(En, { ref: t, ...e }));
}
let C4 = C1(vd), En = C1(gd), W7 = C1(bd), U5 = Object.assign(C4, { Child: W7, Root: C4 });
var yd = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(yd || {}), xd = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(xd || {});
let wd = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, se = V1(null);
se.displayName = "DialogContext";
function $7(e) {
  let t = M1(se);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, $7), r;
  }
  return t;
}
function _d(e, t) {
  return P1(t.type, wd, e, t);
}
let G0 = C1(function(e, t) {
  let r = O1(), { id: n = `headlessui-dialog-${r}`, open: a, onClose: i, initialFocus: o, role: l = "dialog", autoFocus: c = !0, __demoMode: u = !1, unmount: d = !1, ...C } = e, p = J(!1);
  l = function() {
    return l === "dialog" || l === "alertdialog" ? l : (p.current || (p.current = !0, console.warn(`Invalid role [${l}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = w5();
  a === void 0 && h !== null && (a = (h & B1.Open) === B1.Open);
  let f = J(null), g = w1(f, t), m = W2(f), v = a ? 0 : 1, [b, w] = j5(_d, { titleId: null, descriptionId: null, panelRef: u6() }), M = O(() => i(!1)), y = O((T) => w({ type: 0, id: T })), _ = g8() ? v === 0 : !1, [S, j] = wn(), V = { get current() {
    var T;
    return (T = b.panelRef.current) != null ? T : f.current;
  } }, P = re(), { resolveContainers: A } = kn({ mainTreeNode: P, portals: S, defaultContainers: [V] }), R = h !== null ? (h & B1.Closing) === B1.Closing : !1;
  P7(u || R ? !1 : _, { allowed: O(() => {
    var T, B;
    return [(B = (T = f.current) == null ? void 0 : T.closest("[data-headlessui-portal]")) != null ? B : null];
  }), disallowed: O(() => {
    var T;
    return [(T = P == null ? void 0 : P.closest("body > *:not(#headlessui-portal-root)")) != null ? T : null];
  }) }), p8(_, A, (T) => {
    T.preventDefault(), M();
  }), id(_, m == null ? void 0 : m.defaultView, (T) => {
    T.preventDefault(), T.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), M();
  }), h8(u || R ? !1 : _, m, A), c8(_, f, M);
  let [z, N] = r9(), G = Q(() => [{ dialogState: v, close: M, setTitleId: y, unmount: d }, b], [v, b, M, y, d]), U = Q(() => ({ open: v === 0 }), [v]), Z = { ref: g, id: n, role: l, tabIndex: -1, "aria-modal": u ? void 0 : v === 0 ? !0 : void 0, "aria-labelledby": b.titleId, "aria-describedby": z, unmount: d }, E = !od(), F = L5.None;
  _ && !u && (F |= L5.RestoreFocus, F |= L5.TabLock, c && (F |= L5.AutoFocus), E && (F |= L5.InitialFocus));
  let I = f1();
  return x.createElement(X4, null, x.createElement(Z0, { force: !0 }, x.createElement(d9, null, x.createElement(se.Provider, { value: G }, x.createElement(_n, { target: f }, x.createElement(Z0, { force: !1 }, x.createElement(N, { slot: U }, x.createElement(j, null, x.createElement(oe, { initialFocus: o, initialFocusFallback: f, containers: A, features: F }, x.createElement(U4, { value: M }, I({ ourProps: Z, theirProps: C, slot: U, defaultTag: Md, features: Sd, visible: v === 0, name: "Dialog" })))))))))));
}), Md = "div", Sd = h2.RenderStrategy | h2.Static;
function kd(e, t) {
  let { transition: r = !1, open: n, ...a } = e, i = w5(), o = e.hasOwnProperty("open") || i !== null, l = e.hasOwnProperty("onClose");
  if (!o && !l)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!o)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!l)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!i && typeof e.open != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (n !== void 0 || r) && !a.static ? x.createElement(n7, null, x.createElement(U5, { show: n, transition: r, unmount: a.unmount }, x.createElement(G0, { ref: t, ...a }))) : x.createElement(n7, null, x.createElement(G0, { ref: t, open: n, ...a }));
}
let Ld = "div";
function Hd(e, t) {
  let r = O1(), { id: n = `headlessui-dialog-panel-${r}`, transition: a = !1, ...i } = e, [{ dialogState: o, unmount: l }, c] = $7("Dialog.Panel"), u = w1(t, c.panelRef), d = Q(() => ({ open: o === 0 }), [o]), C = O((m) => {
    m.stopPropagation();
  }), p = { ref: u, id: n, onClick: C }, h = a ? W7 : q1, f = a ? { unmount: l } : {}, g = f1();
  return x.createElement(h, { ...f }, g({ ourProps: p, theirProps: i, slot: d, defaultTag: Ld, name: "Dialog.Panel" }));
}
let Pd = "div";
function Td(e, t) {
  let { transition: r = !1, ...n } = e, [{ dialogState: a, unmount: i }] = $7("Dialog.Backdrop"), o = Q(() => ({ open: a === 0 }), [a]), l = { ref: t, "aria-hidden": !0 }, c = r ? W7 : q1, u = r ? { unmount: i } : {}, d = f1();
  return x.createElement(c, { ...u }, d({ ourProps: l, theirProps: n, slot: o, defaultTag: Pd, name: "Dialog.Backdrop" }));
}
let jd = "h2";
function Vd(e, t) {
  let r = O1(), { id: n = `headlessui-dialog-title-${r}`, ...a } = e, [{ dialogState: i, setTitleId: o }] = $7("Dialog.Title"), l = w1(t);
  h1(() => (o(n), () => o(null)), [n, o]);
  let c = Q(() => ({ open: i === 0 }), [i]), u = { ref: l, id: n };
  return f1()({ ourProps: u, theirProps: a, slot: c, defaultTag: jd, name: "Dialog.Title" });
}
let Ad = C1(kd), In = C1(Hd), Ed = C1(Td), Dn = C1(Vd), Id = l8, p4 = Object.assign(Ad, { Panel: In, Title: Dn, Description: l8 });
var K0;
let Dd = (K0 = x.startTransition) != null ? K0 : function(e) {
  e();
};
var Nd = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Nd || {}), Rd = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(Rd || {});
let Fd = { 0: (e) => ({ ...e, disclosureState: P1(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
}, 4(e, t) {
  return e.buttonElement === t.element ? e : { ...e, buttonElement: t.element };
}, 5(e, t) {
  return e.panelElement === t.element ? e : { ...e, panelElement: t.element };
} }, le = V1(null);
le.displayName = "DisclosureContext";
function ce(e) {
  let t = M1(le);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ce), r;
  }
  return t;
}
let ue = V1(null);
ue.displayName = "DisclosureAPIContext";
function Nn(e) {
  let t = M1(ue);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Nn), r;
  }
  return t;
}
let de = V1(null);
de.displayName = "DisclosurePanelContext";
function Od() {
  return M1(de);
}
function Bd(e, t) {
  return P1(t.type, Fd, e, t);
}
let Zd = q1;
function Gd(e, t) {
  let { defaultOpen: r = !1, ...n } = e, a = J(null), i = w1(t, K4((g) => {
    a.current = g;
  }, e.as === void 0 || e.as === q1)), o = j5(Bd, { disclosureState: r ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: l, buttonId: c }, u] = o, d = O((g) => {
    u({ type: 1 });
    let m = U2(a);
    if (!m || !c)
      return;
    let v = g ? g instanceof HTMLElement ? g : g.current instanceof HTMLElement ? g.current : m.getElementById(c) : m.getElementById(c);
    v == null || v.focus();
  }), C = Q(() => ({ close: d }), [d]), p = Q(() => ({ open: l === 0, close: d }), [l, d]), h = { ref: i }, f = f1();
  return x.createElement(le.Provider, { value: o }, x.createElement(ue.Provider, { value: C }, x.createElement(U4, { value: d }, x.createElement(u9, { value: P1(l, { 0: B1.Open, 1: B1.Closed }) }, f({ ourProps: h, theirProps: n, slot: p, defaultTag: Zd, name: "Disclosure" })))));
}
let Kd = "button";
function zd(e, t) {
  let r = O1(), { id: n = `headlessui-disclosure-button-${r}`, disabled: a = !1, autoFocus: i = !1, ...o } = e, [l, c] = ce("Disclosure.Button"), u = Od(), d = u === null ? !1 : u === l.panelId, C = J(null), p = w1(C, t, O((V) => {
    if (!d)
      return c({ type: 4, element: V });
  }));
  h1(() => {
    if (!d)
      return c({ type: 2, buttonId: n }), () => {
        c({ type: 2, buttonId: null });
      };
  }, [n, c, d]);
  let h = O((V) => {
    var P;
    if (d) {
      if (l.disclosureState === 1)
        return;
      switch (V.key) {
        case X.Space:
        case X.Enter:
          V.preventDefault(), V.stopPropagation(), c({ type: 0 }), (P = l.buttonElement) == null || P.focus();
          break;
      }
    } else
      switch (V.key) {
        case X.Space:
        case X.Enter:
          V.preventDefault(), V.stopPropagation(), c({ type: 0 });
          break;
      }
  }), f = O((V) => {
    switch (V.key) {
      case X.Space:
        V.preventDefault();
        break;
    }
  }), g = O((V) => {
    var P;
    y5(V.currentTarget) || a || (d ? (c({ type: 0 }), (P = l.buttonElement) == null || P.focus()) : c({ type: 0 }));
  }), { isFocusVisible: m, focusProps: v } = x2({ autoFocus: i }), { isHovered: b, hoverProps: w } = S2({ isDisabled: a }), { pressed: M, pressProps: y } = t5({ disabled: a }), _ = Q(() => ({ open: l.disclosureState === 0, hover: b, active: M, disabled: a, focus: m, autofocus: i }), [l, b, M, m, a, i]), S = x6(e, l.buttonElement), j = a2(d ? { ref: p, type: S, disabled: a || void 0, autoFocus: i, onKeyDown: h, onClick: g } : { ref: p, id: n, type: S, "aria-expanded": l.disclosureState === 0, "aria-controls": l.panelElement ? l.panelId : void 0, disabled: a || void 0, autoFocus: i, onKeyDown: h, onKeyUp: f, onClick: g }, v, w, y);
  return f1()({ ourProps: j, theirProps: o, slot: _, defaultTag: Kd, name: "Disclosure.Button" });
}
let Ud = "div", Yd = h2.RenderStrategy | h2.Static;
function Wd(e, t) {
  let r = O1(), { id: n = `headlessui-disclosure-panel-${r}`, transition: a = !1, ...i } = e, [o, l] = ce("Disclosure.Panel"), { close: c } = Nn("Disclosure.Panel"), [u, d] = e1(null), C = w1(t, O((b) => {
    Dd(() => l({ type: 5, element: b }));
  }), d);
  h1(() => (l({ type: 3, panelId: n }), () => {
    l({ type: 3, panelId: null });
  }), [n, l]);
  let p = w5(), [h, f] = _6(a, u, p !== null ? (p & B1.Open) === B1.Open : o.disclosureState === 0), g = Q(() => ({ open: o.disclosureState === 0, close: c }), [o.disclosureState, c]), m = { ref: C, id: n, ...w6(f) }, v = f1();
  return x.createElement(X4, null, x.createElement(de.Provider, { value: o.panelId }, v({ ourProps: m, theirProps: i, slot: g, defaultTag: Ud, features: Yd, visible: h, name: "Disclosure.Panel" })));
}
let $d = C1(Gd), Rn = C1(zd), Fn = C1(Wd), Jd = Object.assign($d, { Button: Rn, Panel: Fn }), qd = "div";
function Qd(e, t) {
  let r = `headlessui-control-${O1()}`, [n, a] = E5(), [i, o] = r9(), l = E2(), { disabled: c = l || !1, ...u } = e, d = Q(() => ({ disabled: c }), [c]), C = { ref: t, disabled: c || void 0, "aria-disabled": c || void 0 }, p = f1();
  return x.createElement(Va, { value: c }, x.createElement(a, { value: n }, x.createElement(o, { value: i }, x.createElement(cl, { id: r }, p({ ourProps: C, theirProps: { ...u, children: x.createElement(ol, null, typeof u.children == "function" ? u.children(d) : u.children) }, slot: d, defaultTag: qd, name: "Field" })))));
}
let J7 = C1(Qd);
function Xd(e) {
  let t = typeof e == "string" ? e : void 0, [r, n] = e1(t);
  return [t ?? r, y1((a) => {
    t || a instanceof HTMLElement && n(a.tagName.toLowerCase());
  }, [t])];
}
let z0 = "fieldset";
function eC(e, t) {
  var r;
  let n = E2(), { disabled: a = n || !1, ...i } = e, [o, l] = Xd((r = e.as) != null ? r : z0), c = w1(t, l), [u, d] = E5(), C = Q(() => ({ disabled: a }), [a]), p = o === "fieldset" ? { ref: c, "aria-labelledby": u, disabled: a || void 0 } : { ref: c, role: "group", "aria-labelledby": u, "aria-disabled": a || void 0 }, h = f1();
  return x.createElement(Va, { value: a }, x.createElement(d, null, h({ ourProps: p, theirProps: i, slot: C, defaultTag: z0, name: "Fieldset" })));
}
let tC = C1(eC), aC = "input";
function nC(e, t) {
  let r = O1(), n = A5(), a = E2(), { id: i = n || `headlessui-input-${r}`, disabled: o = a || !1, autoFocus: l = !1, invalid: c = !1, ...u } = e, d = a5(), C = Q5(), { isFocused: p, focusProps: h } = x2({ autoFocus: l }), { isHovered: f, hoverProps: g } = S2({ isDisabled: o }), m = a2({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": C, "aria-invalid": c ? "" : void 0, disabled: o || void 0, autoFocus: l }, h, g), v = Q(() => ({ disabled: o, invalid: c, hover: f, focus: p, autofocus: l }), [o, c, f, p, l]);
  return f1()({ ourProps: m, theirProps: u, slot: v, defaultTag: aC, name: "Input" });
}
let rC = C1(nC);
function iC(e, t) {
  return x.createElement(i9, { as: "div", ref: t, ...e });
}
let oC = C1(iC);
function On(e, t) {
  let r = J({ left: 0, top: 0 });
  if (x1(() => {
    if (!t)
      return;
    let a = t.getBoundingClientRect();
    a && (r.current = a);
  }, [e, t]), t == null || !e || t === document.activeElement)
    return !1;
  let n = t.getBoundingClientRect();
  return n.top !== r.current.top || n.left !== r.current.left;
}
let U0 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Y0(e) {
  var t, r;
  let n = (t = e.innerText) != null ? t : "", a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement))
    return n;
  let i = !1;
  for (let l of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    l.remove(), i = !0;
  let o = i ? (r = a.innerText) != null ? r : "" : n;
  return U0.test(o) && (o = o.replace(U0, "")), o;
}
function sC(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let n = r.split(" ").map((a) => {
      let i = document.getElementById(a);
      if (i) {
        let o = i.getAttribute("aria-label");
        return typeof o == "string" ? o.trim() : Y0(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (n.length > 0)
      return n.join(", ");
  }
  return Y0(e).trim();
}
function Bn(e) {
  let t = J(""), r = J("");
  return O(() => {
    let n = e.current;
    if (!n)
      return "";
    let a = n.innerText;
    if (t.current === a)
      return r.current;
    let i = sC(n).trim().toLowerCase();
    return t.current = a, r.current = i, i;
  });
}
var lC = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(lC || {}), cC = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(cC || {}), uC = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(uC || {}), dC = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetOptionsElement = 8] = "SetOptionsElement", e))(dC || {});
function I3(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = c5(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), a = r ? n.indexOf(r) : null;
  return a === -1 && (a = null), { options: n, activeOptionIndex: a };
}
let CC = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: r } = e.dataRef.current, n = e.options.findIndex((a) => r(a.dataRef.current.value));
  return n !== -1 && (t = n), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var r, n, a, i, o;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let l = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === g1.Nothing)
    return { ...l, activeOptionIndex: null };
  if (t.focus === g1.Specific)
    return { ...l, activeOptionIndex: e.options.findIndex((d) => d.id === t.id) };
  if (t.focus === g1.Previous) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let C = e.options[d].dataRef.current.domRef, p = z5(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((n = C.current) == null ? void 0 : n.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...l, activeOptionIndex: p };
      }
    }
  } else if (t.focus === g1.Next) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let C = e.options[d].dataRef.current.domRef, p = z5(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((i = C.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null)
          return { ...l, activeOptionIndex: p };
      }
    }
  }
  let c = I3(e), u = z5(t, { resolveItems: () => c.options, resolveActiveIndex: () => c.activeOptionIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled });
  return { ...l, ...c, activeOptionIndex: u };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), a = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((o) => {
    var l;
    return !o.dataRef.current.disabled && ((l = o.dataRef.current.textValue) == null ? void 0 : l.startsWith(n));
  }), i = a ? e.options.indexOf(a) : -1;
  return i === -1 || i === e.activeOptionIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeOptionIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let r = { id: t.id, dataRef: t.dataRef }, n = I3(e, (a) => [...a, r]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r)), { ...e, ...n };
}, 6: (e, t) => {
  let r = I3(e, (n) => {
    let a = n.findIndex((i) => i.id === t.id);
    return a !== -1 && n.splice(a, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, Ce = V1(null);
Ce.displayName = "ListboxActionsContext";
function q7(e) {
  let t = M1(Ce);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, q7), r;
  }
  return t;
}
let Q7 = V1(null);
Q7.displayName = "ListboxDataContext";
function y8(e) {
  let t = M1(Q7);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, y8), r;
  }
  return t;
}
function pC(e, t) {
  return P1(t.type, CC, e, t);
}
let hC = q1;
function fC(e, t) {
  var r;
  let n = E2(), { value: a, defaultValue: i, form: o, name: l, onChange: c, by: u, invalid: d = !1, disabled: C = n || !1, horizontal: p = !1, multiple: h = !1, __demoMode: f = !1, ...g } = e;
  const m = p ? "horizontal" : "vertical";
  let v = w1(t), b = o8(i), [w = h ? [] : void 0, M] = i8(a, c, b), [y, _] = j5(pC, { dataRef: u6(), listboxState: f ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, buttonElement: null, optionsElement: null, __demoMode: f }), S = J({ static: !1, hold: !1 }), j = J(/* @__PURE__ */ new Map()), V = Y4(u), P = y1((p1) => P1(A.mode, { 1: () => w.some((T1) => V(T1, p1)), 0: () => V(w, p1) }), [w]), A = Q(() => ({ ...y, value: w, disabled: C, invalid: d, mode: h ? 1 : 0, orientation: m, compare: V, isSelected: P, optionsPropsRef: S, listRef: j }), [w, C, d, h, y, j]);
  x1(() => {
    y.dataRef.current = A;
  }, [A]);
  let R = A.listboxState === 0;
  p8(R, [A.buttonElement, A.optionsElement], (p1, T1) => {
    var l1;
    _({ type: 1 }), C8(T1, d8.Loose) || (p1.preventDefault(), (l1 = A.buttonElement) == null || l1.focus());
  });
  let z = Q(() => ({ open: A.listboxState === 0, disabled: C, invalid: d, value: w }), [A, C, w, d]), N = O((p1) => {
    let T1 = A.options.find((l1) => l1.id === p1);
    T1 && T(T1.dataRef.current.value);
  }), G = O(() => {
    if (A.activeOptionIndex !== null) {
      let { dataRef: p1, id: T1 } = A.options[A.activeOptionIndex];
      T(p1.current.value), _({ type: 2, focus: g1.Specific, id: T1 });
    }
  }), U = O(() => _({ type: 0 })), Z = O(() => _({ type: 1 })), E = Y2(), F = O((p1, T1, l1) => {
    E.dispose(), E.microTask(() => p1 === g1.Specific ? _({ type: 2, focus: g1.Specific, id: T1, trigger: l1 }) : _({ type: 2, focus: p1, trigger: l1 }));
  }), I = O((p1, T1) => (_({ type: 5, id: p1, dataRef: T1 }), () => _({ type: 6, id: p1 }))), T = O((p1) => P1(A.mode, { 0() {
    return M == null ? void 0 : M(p1);
  }, 1() {
    let T1 = A.value.slice(), l1 = T1.findIndex((k1) => V(k1, p1));
    return l1 === -1 ? T1.push(p1) : T1.splice(l1, 1), M == null ? void 0 : M(T1);
  } })), B = O((p1) => _({ type: 3, value: p1 })), D = O(() => _({ type: 4 })), $ = O((p1) => {
    _({ type: 7, element: p1 });
  }), W = O((p1) => {
    _({ type: 8, element: p1 });
  }), i1 = Q(() => ({ onChange: T, registerOption: I, goToOption: F, closeListbox: Z, openListbox: U, selectActiveOption: G, selectOption: N, search: B, clearSearch: D, setButtonElement: $, setOptionsElement: W }), []), [r1, d1] = E5({ inherit: !0 }), m1 = { ref: v }, Q1 = y1(() => {
    if (b !== void 0)
      return M == null ? void 0 : M(b);
  }, [M, b]), _1 = f1();
  return x.createElement(d1, { value: r1, props: { htmlFor: (r = A.buttonElement) == null ? void 0 : r.id }, slot: { open: A.listboxState === 0, disabled: C } }, x.createElement(O7, null, x.createElement(Ce.Provider, { value: i1 }, x.createElement(Q7.Provider, { value: A }, x.createElement(u9, { value: P1(A.listboxState, { 0: B1.Open, 1: B1.Closed }) }, l != null && w != null && x.createElement(s8, { disabled: C, data: { [l]: w }, form: o, onReset: Q1 }), _1({ ourProps: m1, theirProps: g, slot: z, defaultTag: hC, name: "Listbox" }))))));
}
let mC = "button";
function gC(e, t) {
  var r;
  let n = y8("Listbox.Button"), a = q7("Listbox.Button"), i = O1(), o = A5(), { id: l = o || `headlessui-listbox-button-${i}`, disabled: c = n.disabled || !1, autoFocus: u = !1, ...d } = e, C = w1(t, N7(), a.setButtonElement), p = mn(), h = O((A) => {
    switch (A.key) {
      case X.Enter:
        k7(A.currentTarget);
        break;
      case X.Space:
      case X.ArrowDown:
        A.preventDefault(), C2(() => a.openListbox()), n.value || a.goToOption(g1.First);
        break;
      case X.ArrowUp:
        A.preventDefault(), C2(() => a.openListbox()), n.value || a.goToOption(g1.Last);
        break;
    }
  }), f = O((A) => {
    switch (A.key) {
      case X.Space:
        A.preventDefault();
        break;
    }
  }), g = O((A) => {
    var R;
    if (y5(A.currentTarget))
      return A.preventDefault();
    n.listboxState === 0 ? (C2(() => a.closeListbox()), (R = n.buttonElement) == null || R.focus({ preventScroll: !0 })) : (A.preventDefault(), a.openListbox());
  }), m = O((A) => A.preventDefault()), v = a5([l]), b = Q5(), { isFocusVisible: w, focusProps: M } = x2({ autoFocus: u }), { isHovered: y, hoverProps: _ } = S2({ isDisabled: c }), { pressed: S, pressProps: j } = t5({ disabled: c }), V = Q(() => ({ open: n.listboxState === 0, active: S || n.listboxState === 0, disabled: c, invalid: n.invalid, value: n.value, hover: y, focus: w, autofocus: u }), [n.listboxState, n.value, c, y, w, S, n.invalid, u]), P = a2(p(), { ref: C, id: l, type: x6(e, n.buttonElement), "aria-haspopup": "listbox", "aria-controls": (r = n.optionsElement) == null ? void 0 : r.id, "aria-expanded": n.listboxState === 0, "aria-labelledby": v, "aria-describedby": b, disabled: c || void 0, autoFocus: u, onKeyDown: h, onKeyUp: f, onKeyPress: m, onClick: g }, M, _, j);
  return f1()({ ourProps: P, theirProps: d, slot: V, defaultTag: mC, name: "Listbox.Button" });
}
let Zn = V1(!1), vC = "div", bC = h2.RenderStrategy | h2.Static;
function yC(e, t) {
  var r, n;
  let a = O1(), { id: i = `headlessui-listbox-options-${a}`, anchor: o, portal: l = !1, modal: c = !0, transition: u = !1, ...d } = e, C = D7(o), [p, h] = e1(null);
  C && (l = !0);
  let f = y8("Listbox.Options"), g = q7("Listbox.Options"), m = W2(f.optionsElement), v = w5(), [b, w] = _6(u, p, v !== null ? (v & B1.Open) === B1.Open : f.listboxState === 0);
  c8(b, f.buttonElement, g.closeListbox);
  let M = f.__demoMode ? !1 : c && f.listboxState === 0;
  h8(M, m);
  let y = f.__demoMode ? !1 : c && f.listboxState === 0;
  P7(y, { allowed: y1(() => [f.buttonElement, f.optionsElement], [f.buttonElement, f.optionsElement]) });
  let _ = f.listboxState !== 0, S = On(_, f.buttonElement) ? !1 : b, j = b && f.listboxState === 1, V = a7(j, f.value), P = O((D) => f.compare(V, D)), A = Q(() => {
    var D;
    if (C == null || !((D = C == null ? void 0 : C.to) != null && D.includes("selection")))
      return null;
    let $ = f.options.findIndex((W) => P(W.dataRef.current.value));
    return $ === -1 && ($ = 0), $;
  }, [C, f.options]), R = (() => {
    if (C == null)
      return;
    if (A === null)
      return { ...C, inner: void 0 };
    let D = Array.from(f.listRef.current.values());
    return { ...C, inner: { listRef: { current: D }, index: A } };
  })(), [z, N] = F7(R), G = R7(), U = w1(t, C ? z : null, g.setOptionsElement, h), Z = Y2();
  h1(() => {
    var D;
    let $ = f.optionsElement;
    $ && f.listboxState === 0 && $ !== ((D = U2($)) == null ? void 0 : D.activeElement) && ($ == null || $.focus({ preventScroll: !0 }));
  }, [f.listboxState, f.optionsElement]);
  let E = O((D) => {
    var $, W;
    switch (Z.dispose(), D.key) {
      case X.Space:
        if (f.searchQuery !== "")
          return D.preventDefault(), D.stopPropagation(), g.search(D.key);
      case X.Enter:
        if (D.preventDefault(), D.stopPropagation(), f.activeOptionIndex !== null) {
          let { dataRef: i1 } = f.options[f.activeOptionIndex];
          g.onChange(i1.current.value);
        }
        f.mode === 0 && (C2(() => g.closeListbox()), ($ = f.buttonElement) == null || $.focus({ preventScroll: !0 }));
        break;
      case P1(f.orientation, { vertical: X.ArrowDown, horizontal: X.ArrowRight }):
        return D.preventDefault(), D.stopPropagation(), g.goToOption(g1.Next);
      case P1(f.orientation, { vertical: X.ArrowUp, horizontal: X.ArrowLeft }):
        return D.preventDefault(), D.stopPropagation(), g.goToOption(g1.Previous);
      case X.Home:
      case X.PageUp:
        return D.preventDefault(), D.stopPropagation(), g.goToOption(g1.First);
      case X.End:
      case X.PageDown:
        return D.preventDefault(), D.stopPropagation(), g.goToOption(g1.Last);
      case X.Escape:
        D.preventDefault(), D.stopPropagation(), C2(() => g.closeListbox()), (W = f.buttonElement) == null || W.focus({ preventScroll: !0 });
        return;
      case X.Tab:
        D.preventDefault(), D.stopPropagation(), C2(() => g.closeListbox()), Wa(f.buttonElement, D.shiftKey ? R1.Previous : R1.Next);
        break;
      default:
        D.key.length === 1 && (g.search(D.key), Z.setTimeout(() => g.clearSearch(), 350));
        break;
    }
  }), F = (r = f.buttonElement) == null ? void 0 : r.id, I = Q(() => ({ open: f.listboxState === 0 }), [f.listboxState]), T = a2(C ? G() : {}, { id: i, ref: U, "aria-activedescendant": f.activeOptionIndex === null || (n = f.options[f.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": f.mode === 1 ? !0 : void 0, "aria-labelledby": F, "aria-orientation": f.orientation, onKeyDown: E, role: "listbox", tabIndex: f.listboxState === 0 ? 0 : void 0, style: { ...d.style, ...N, "--button-width": B9(f.buttonElement, !0).width }, ...w6(w) }), B = f1();
  return x.createElement(d9, { enabled: l ? e.static || b : !1 }, x.createElement(Q7.Provider, { value: f.mode === 1 ? f : { ...f, isSelected: P } }, B({ ourProps: T, theirProps: d, slot: I, defaultTag: vC, features: bC, visible: S, name: "Listbox.Options" })));
}
let xC = "div";
function wC(e, t) {
  let r = O1(), { id: n = `headlessui-listbox-option-${r}`, disabled: a = !1, value: i, ...o } = e, l = M1(Zn) === !0, c = y8("Listbox.Option"), u = q7("Listbox.Option"), d = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === n : !1, C = c.isSelected(i), p = J(null), h = Bn(p), f = b2({ disabled: a, value: i, domRef: p, get textValue() {
    return h();
  } }), g = w1(t, p, (V) => {
    V ? c.listRef.current.set(n, V) : c.listRef.current.delete(n);
  });
  x1(() => {
    if (!c.__demoMode && c.listboxState === 0 && d && c.activationTrigger !== 0)
      return N2().requestAnimationFrame(() => {
        var V, P;
        (P = (V = p.current) == null ? void 0 : V.scrollIntoView) == null || P.call(V, { block: "nearest" });
      });
  }, [p, d, c.__demoMode, c.listboxState, c.activationTrigger, c.activeOptionIndex]), x1(() => {
    if (!l)
      return u.registerOption(n, f);
  }, [f, n, l]);
  let m = O((V) => {
    var P;
    if (a)
      return V.preventDefault();
    u.onChange(i), c.mode === 0 && (C2(() => u.closeListbox()), (P = c.buttonElement) == null || P.focus({ preventScroll: !0 }));
  }), v = O(() => {
    if (a)
      return u.goToOption(g1.Nothing);
    u.goToOption(g1.Specific, n);
  }), b = W4(), w = O((V) => {
    b.update(V), !a && (d || u.goToOption(g1.Specific, n, 0));
  }), M = O((V) => {
    b.wasMoved(V) && (a || d || u.goToOption(g1.Specific, n, 0));
  }), y = O((V) => {
    b.wasMoved(V) && (a || d && u.goToOption(g1.Nothing));
  }), _ = Q(() => ({ active: d, focus: d, selected: C, disabled: a, selectedOption: C && l }), [d, C, a, l]), S = l ? {} : { id: n, ref: g, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": C, disabled: void 0, onClick: m, onFocus: v, onPointerEnter: w, onMouseEnter: w, onPointerMove: M, onMouseMove: M, onPointerLeave: y, onMouseLeave: y }, j = f1();
  return !C && l ? null : j({ ourProps: S, theirProps: o, slot: _, defaultTag: xC, name: "Listbox.Option" });
}
let _C = q1;
function MC(e, t) {
  let { options: r, placeholder: n, ...a } = e, i = { ref: w1(t) }, o = y8("ListboxSelectedOption"), l = Q(() => ({}), []), c = o.value === void 0 || o.value === null || o.mode === 1 && Array.isArray(o.value) && o.value.length === 0, u = f1();
  return x.createElement(Zn.Provider, { value: !0 }, u({ ourProps: i, theirProps: { ...a, children: x.createElement(x.Fragment, null, n && c ? n : r) }, slot: l, defaultTag: _C, name: "ListboxSelectedOption" }));
}
let SC = C1(fC), z6 = C1(gC), Gn = i9, x8 = C1(yC), X7 = C1(wC), Kn = C1(MC), e3 = Object.assign(SC, { Button: z6, Label: Gn, Options: x8, Option: X7, SelectedOption: Kn });
var kC = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(kC || {}), LC = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(LC || {}), HC = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(HC || {});
function D3(e, t = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = c5(t(e.items.slice()), (i) => i.dataRef.current.domRef.current), a = r ? n.indexOf(r) : null;
  return a === -1 && (a = null), { items: n, activeItemIndex: a };
}
let PC = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, t) => {
  var r, n, a, i, o;
  if (e.menuState === 1)
    return e;
  let l = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === g1.Nothing)
    return { ...l, activeItemIndex: null };
  if (t.focus === g1.Specific)
    return { ...l, activeItemIndex: e.items.findIndex((d) => d.id === t.id) };
  if (t.focus === g1.Previous) {
    let d = e.activeItemIndex;
    if (d !== null) {
      let C = e.items[d].dataRef.current.domRef, p = z5(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((n = C.current) == null ? void 0 : n.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...l, activeItemIndex: p };
      }
    }
  } else if (t.focus === g1.Next) {
    let d = e.activeItemIndex;
    if (d !== null) {
      let C = e.items[d].dataRef.current.domRef, p = z5(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((i = C.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null)
          return { ...l, activeItemIndex: p };
      }
    }
  }
  let c = D3(e), u = z5(t, { resolveItems: () => c.items, resolveActiveIndex: () => c.activeItemIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled });
  return { ...l, ...c, activeItemIndex: u };
}, 3: (e, t) => {
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), a = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((o) => {
    var l;
    return ((l = o.dataRef.current.textValue) == null ? void 0 : l.startsWith(n)) && !o.dataRef.current.disabled;
  }), i = a ? e.items.indexOf(a) : -1;
  return i === -1 || i === e.activeItemIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeItemIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, t) => {
  let r = D3(e, (n) => [...n, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...r };
}, 6: (e, t) => {
  let r = D3(e, (n) => {
    let a = n.findIndex((i) => i.id === t.id);
    return a !== -1 && n.splice(a, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.itemsElement === t.element ? e : { ...e, itemsElement: t.element } }, pe = V1(null);
pe.displayName = "MenuContext";
function t3(e) {
  let t = M1(pe);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, t3), r;
  }
  return t;
}
function TC(e, t) {
  return P1(t.type, PC, e, t);
}
let jC = q1;
function VC(e, t) {
  let { __demoMode: r = !1, ...n } = e, a = j5(TC, { __demoMode: r, menuState: r ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: i, itemsElement: o, buttonElement: l }, c] = a, u = w1(t);
  p8(i === 0, [l, o], (f, g) => {
    c({ type: 1 }), C8(g, d8.Loose) || (f.preventDefault(), l == null || l.focus());
  });
  let d = O(() => {
    c({ type: 1 });
  }), C = Q(() => ({ open: i === 0, close: d }), [i, d]), p = { ref: u }, h = f1();
  return x.createElement(O7, null, x.createElement(pe.Provider, { value: a }, x.createElement(u9, { value: P1(i, { 0: B1.Open, 1: B1.Closed }) }, h({ ourProps: p, theirProps: n, slot: C, defaultTag: jC, name: "Menu" }))));
}
let AC = "button";
function EC(e, t) {
  var r;
  let n = O1(), { id: a = `headlessui-menu-button-${n}`, disabled: i = !1, autoFocus: o = !1, ...l } = e, [c, u] = t3("Menu.Button"), d = mn(), C = w1(t, N7(), O((S) => u({ type: 7, element: S }))), p = O((S) => {
    switch (S.key) {
      case X.Space:
      case X.Enter:
      case X.ArrowDown:
        S.preventDefault(), S.stopPropagation(), C2(() => u({ type: 0 })), u({ type: 2, focus: g1.First });
        break;
      case X.ArrowUp:
        S.preventDefault(), S.stopPropagation(), C2(() => u({ type: 0 })), u({ type: 2, focus: g1.Last });
        break;
    }
  }), h = O((S) => {
    switch (S.key) {
      case X.Space:
        S.preventDefault();
        break;
    }
  }), f = O((S) => {
    var j;
    if (y5(S.currentTarget))
      return S.preventDefault();
    i || (c.menuState === 0 ? (C2(() => u({ type: 1 })), (j = c.buttonElement) == null || j.focus({ preventScroll: !0 })) : (S.preventDefault(), u({ type: 0 })));
  }), { isFocusVisible: g, focusProps: m } = x2({ autoFocus: o }), { isHovered: v, hoverProps: b } = S2({ isDisabled: i }), { pressed: w, pressProps: M } = t5({ disabled: i }), y = Q(() => ({ open: c.menuState === 0, active: w || c.menuState === 0, disabled: i, hover: v, focus: g, autofocus: o }), [c, v, g, w, i, o]), _ = a2(d(), { ref: C, id: a, type: x6(e, c.buttonElement), "aria-haspopup": "menu", "aria-controls": (r = c.itemsElement) == null ? void 0 : r.id, "aria-expanded": c.menuState === 0, disabled: i || void 0, autoFocus: o, onKeyDown: p, onKeyUp: h, onClick: f }, m, b, M);
  return f1()({ ourProps: _, theirProps: l, slot: y, defaultTag: AC, name: "Menu.Button" });
}
let IC = "div", DC = h2.RenderStrategy | h2.Static;
function NC(e, t) {
  var r, n;
  let a = O1(), { id: i = `headlessui-menu-items-${a}`, anchor: o, portal: l = !1, modal: c = !0, transition: u = !1, ...d } = e, C = D7(o), [p, h] = t3("Menu.Items"), [f, g] = F7(C), m = R7(), [v, b] = e1(null), w = w1(t, C ? f : null, O((E) => h({ type: 8, element: E })), b), M = W2(p.itemsElement);
  C && (l = !0);
  let y = w5(), [_, S] = _6(u, v, y !== null ? (y & B1.Open) === B1.Open : p.menuState === 0);
  c8(_, p.buttonElement, () => {
    h({ type: 1 });
  });
  let j = p.__demoMode ? !1 : c && p.menuState === 0;
  h8(j, M);
  let V = p.__demoMode ? !1 : c && p.menuState === 0;
  P7(V, { allowed: y1(() => [p.buttonElement, p.itemsElement], [p.buttonElement, p.itemsElement]) });
  let P = p.menuState !== 0, A = On(P, p.buttonElement) ? !1 : _;
  h1(() => {
    let E = p.itemsElement;
    E && p.menuState === 0 && E !== (M == null ? void 0 : M.activeElement) && E.focus({ preventScroll: !0 });
  }, [p.menuState, p.itemsElement, M]), Xa(p.menuState === 0, { container: p.itemsElement, accept(E) {
    return E.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : E.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(E) {
    E.setAttribute("role", "none");
  } });
  let R = Y2(), z = O((E) => {
    var F, I, T;
    switch (R.dispose(), E.key) {
      case X.Space:
        if (p.searchQuery !== "")
          return E.preventDefault(), E.stopPropagation(), h({ type: 3, value: E.key });
      case X.Enter:
        if (E.preventDefault(), E.stopPropagation(), h({ type: 1 }), p.activeItemIndex !== null) {
          let { dataRef: B } = p.items[p.activeItemIndex];
          (I = (F = B.current) == null ? void 0 : F.domRef.current) == null || I.click();
        }
        Ya(p.buttonElement);
        break;
      case X.ArrowDown:
        return E.preventDefault(), E.stopPropagation(), h({ type: 2, focus: g1.Next });
      case X.ArrowUp:
        return E.preventDefault(), E.stopPropagation(), h({ type: 2, focus: g1.Previous });
      case X.Home:
      case X.PageUp:
        return E.preventDefault(), E.stopPropagation(), h({ type: 2, focus: g1.First });
      case X.End:
      case X.PageDown:
        return E.preventDefault(), E.stopPropagation(), h({ type: 2, focus: g1.Last });
      case X.Escape:
        E.preventDefault(), E.stopPropagation(), C2(() => h({ type: 1 })), (T = p.buttonElement) == null || T.focus({ preventScroll: !0 });
        break;
      case X.Tab:
        E.preventDefault(), E.stopPropagation(), C2(() => h({ type: 1 })), Wa(p.buttonElement, E.shiftKey ? R1.Previous : R1.Next);
        break;
      default:
        E.key.length === 1 && (h({ type: 3, value: E.key }), R.setTimeout(() => h({ type: 4 }), 350));
        break;
    }
  }), N = O((E) => {
    switch (E.key) {
      case X.Space:
        E.preventDefault();
        break;
    }
  }), G = Q(() => ({ open: p.menuState === 0 }), [p.menuState]), U = a2(C ? m() : {}, { "aria-activedescendant": p.activeItemIndex === null || (r = p.items[p.activeItemIndex]) == null ? void 0 : r.id, "aria-labelledby": (n = p.buttonElement) == null ? void 0 : n.id, id: i, onKeyDown: z, onKeyUp: N, role: "menu", tabIndex: p.menuState === 0 ? 0 : void 0, ref: w, style: { ...d.style, ...g, "--button-width": B9(p.buttonElement, !0).width }, ...w6(S) }), Z = f1();
  return x.createElement(d9, { enabled: l ? e.static || _ : !1 }, Z({ ourProps: U, theirProps: d, slot: G, defaultTag: IC, features: DC, visible: A, name: "Menu.Items" }));
}
let RC = q1;
function FC(e, t) {
  let r = O1(), { id: n = `headlessui-menu-item-${r}`, disabled: a = !1, ...i } = e, [o, l] = t3("Menu.Item"), c = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === n : !1, u = J(null), d = w1(t, u);
  x1(() => {
    if (!o.__demoMode && o.menuState === 0 && c && o.activationTrigger !== 0)
      return N2().requestAnimationFrame(() => {
        var A, R;
        (R = (A = u.current) == null ? void 0 : A.scrollIntoView) == null || R.call(A, { block: "nearest" });
      });
  }, [o.__demoMode, u, c, o.menuState, o.activationTrigger, o.activeItemIndex]);
  let C = Bn(u), p = J({ disabled: a, domRef: u, get textValue() {
    return C();
  } });
  x1(() => {
    p.current.disabled = a;
  }, [p, a]), x1(() => (l({ type: 5, id: n, dataRef: p }), () => l({ type: 6, id: n })), [p, n]);
  let h = O(() => {
    l({ type: 1 });
  }), f = O((A) => {
    if (a)
      return A.preventDefault();
    l({ type: 1 }), Ya(o.buttonElement);
  }), g = O(() => {
    if (a)
      return l({ type: 2, focus: g1.Nothing });
    l({ type: 2, focus: g1.Specific, id: n });
  }), m = W4(), v = O((A) => {
    m.update(A), !a && (c || l({ type: 2, focus: g1.Specific, id: n, trigger: 0 }));
  }), b = O((A) => {
    m.wasMoved(A) && (a || c || l({ type: 2, focus: g1.Specific, id: n, trigger: 0 }));
  }), w = O((A) => {
    m.wasMoved(A) && (a || c && l({ type: 2, focus: g1.Nothing }));
  }), [M, y] = E5(), [_, S] = r9(), j = Q(() => ({ active: c, focus: c, disabled: a, close: h }), [c, a, h]), V = { id: n, ref: d, role: "menuitem", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-labelledby": M, "aria-describedby": _, disabled: void 0, onClick: f, onFocus: g, onPointerEnter: v, onMouseEnter: v, onPointerMove: b, onMouseMove: b, onPointerLeave: w, onMouseLeave: w }, P = f1();
  return x.createElement(y, null, x.createElement(S, null, P({ ourProps: V, theirProps: i, slot: j, defaultTag: RC, name: "Menu.Item" })));
}
let OC = "div";
function BC(e, t) {
  let [r, n] = E5(), a = e, i = { ref: t, "aria-labelledby": r, role: "group" }, o = f1();
  return x.createElement(n, null, o({ ourProps: i, theirProps: a, slot: {}, defaultTag: OC, name: "Menu.Section" }));
}
let ZC = "header";
function GC(e, t) {
  let r = O1(), { id: n = `headlessui-menu-heading-${r}`, ...a } = e, i = z4();
  x1(() => i.register(n), [n, i.register]);
  let o = { id: n, ref: t, role: "presentation", ...i.props };
  return f1()({ ourProps: o, theirProps: a, slot: {}, defaultTag: ZC, name: "Menu.Heading" });
}
let KC = "div";
function zC(e, t) {
  let r = e, n = { ref: t, role: "separator" };
  return f1()({ ourProps: n, theirProps: r, slot: {}, defaultTag: KC, name: "Menu.Separator" });
}
let UC = C1(VC), he = C1(EC), fe = C1(NC), me = C1(FC), zn = C1(BC), Un = C1(GC), Yn = C1(zC), Wn = Object.assign(UC, { Button: he, Items: fe, Item: me, Section: zn, Heading: Un, Separator: Yn });
var YC = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(YC || {}), WC = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(WC || {});
let $C = { 0: (e) => ({ ...e, popoverState: P1(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, ge = V1(null);
ge.displayName = "PopoverContext";
function a3(e) {
  let t = M1(ge);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, a3), r;
  }
  return t;
}
let n3 = V1(null);
n3.displayName = "PopoverAPIContext";
function ve(e) {
  let t = M1(n3);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ve), r;
  }
  return t;
}
let be = V1(null);
be.displayName = "PopoverGroupContext";
function $n() {
  return M1(be);
}
let r3 = V1(null);
r3.displayName = "PopoverPanelContext";
function JC() {
  return M1(r3);
}
function qC(e, t) {
  return P1(t.type, $C, e, t);
}
let QC = "div";
function XC(e, t) {
  var r;
  let { __demoMode: n = !1, ...a } = e, i = J(null), o = w1(t, K4((F) => {
    i.current = F;
  })), l = J([]), c = j5(qC, { __demoMode: n, popoverState: n ? 0 : 1, buttons: l, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: u6(), afterPanelSentinel: u6(), afterButtonSentinel: u6() }), [{ popoverState: u, button: d, buttonId: C, panel: p, panelId: h, beforePanelSentinel: f, afterPanelSentinel: g, afterButtonSentinel: m }, v] = c, b = W2((r = i.current) != null ? r : d), w = Q(() => {
    if (!d || !p)
      return !1;
    for (let W of document.querySelectorAll("body > *"))
      if (Number(W == null ? void 0 : W.contains(d)) ^ Number(W == null ? void 0 : W.contains(p)))
        return !0;
    let F = u8(), I = F.indexOf(d), T = (I + F.length - 1) % F.length, B = (I + 1) % F.length, D = F[T], $ = F[B];
    return !p.contains(D) && !p.contains($);
  }, [d, p]), M = b2(C), y = b2(h), _ = Q(() => ({ buttonId: M, panelId: y, close: () => v({ type: 1 }) }), [M, y, v]), S = $n(), j = S == null ? void 0 : S.registerPopover, V = O(() => {
    var F;
    return (F = S == null ? void 0 : S.isFocusWithinPopoverGroup()) != null ? F : (b == null ? void 0 : b.activeElement) && ((d == null ? void 0 : d.contains(b.activeElement)) || (p == null ? void 0 : p.contains(b.activeElement)));
  });
  h1(() => j == null ? void 0 : j(_), [j, _]);
  let [P, A] = wn(), R = re(d), z = kn({ mainTreeNode: R, portals: P, defaultContainers: [d, p] });
  T7(b == null ? void 0 : b.defaultView, "focus", (F) => {
    var I, T, B, D, $, W;
    F.target !== window && F.target instanceof HTMLElement && u === 0 && (V() || d && p && (z.contains(F.target) || (T = (I = f.current) == null ? void 0 : I.contains) != null && T.call(I, F.target) || (D = (B = g.current) == null ? void 0 : B.contains) != null && D.call(B, F.target) || (W = ($ = m.current) == null ? void 0 : $.contains) != null && W.call($, F.target) || v({ type: 1 })));
  }, !0), p8(u === 0, z.resolveContainers, (F, I) => {
    v({ type: 1 }), C8(I, d8.Loose) || (F.preventDefault(), d == null || d.focus());
  });
  let N = O((F) => {
    v({ type: 1 });
    let I = F ? F instanceof HTMLElement ? F : "current" in F && F.current instanceof HTMLElement ? F.current : d : d;
    I == null || I.focus();
  }), G = Q(() => ({ close: N, isPortalled: w }), [N, w]), U = Q(() => ({ open: u === 0, close: N }), [u, N]), Z = { ref: o }, E = f1();
  return x.createElement(n7, { node: R }, x.createElement(O7, null, x.createElement(r3.Provider, { value: null }, x.createElement(ge.Provider, { value: c }, x.createElement(n3.Provider, { value: G }, x.createElement(U4, { value: N }, x.createElement(u9, { value: P1(u, { 0: B1.Open, 1: B1.Closed }) }, x.createElement(A, null, E({ ourProps: Z, theirProps: a, slot: U, defaultTag: QC, name: "Popover" })))))))));
}
let ep = "button";
function tp(e, t) {
  let r = O1(), { id: n = `headlessui-popover-button-${r}`, disabled: a = !1, autoFocus: i = !1, ...o } = e, [l, c] = a3("Popover.Button"), { isPortalled: u } = ve("Popover.Button"), d = J(null), C = `headlessui-focus-sentinel-${O1()}`, p = $n(), h = p == null ? void 0 : p.closeOthers, f = JC() !== null;
  h1(() => {
    if (!f)
      return c({ type: 3, buttonId: n }), () => {
        c({ type: 3, buttonId: null });
      };
  }, [f, n, c]);
  let [g] = e1(() => Symbol()), m = w1(d, t, N7(), O((I) => {
    if (!f) {
      if (I)
        l.buttons.current.push(g);
      else {
        let T = l.buttons.current.indexOf(g);
        T !== -1 && l.buttons.current.splice(T, 1);
      }
      l.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), I && c({ type: 2, button: I });
    }
  })), v = w1(d, t), b = W2(d), w = O((I) => {
    var T, B, D;
    if (f) {
      if (l.popoverState === 1)
        return;
      switch (I.key) {
        case X.Space:
        case X.Enter:
          I.preventDefault(), (B = (T = I.target).click) == null || B.call(T), c({ type: 1 }), (D = l.button) == null || D.focus();
          break;
      }
    } else
      switch (I.key) {
        case X.Space:
        case X.Enter:
          I.preventDefault(), I.stopPropagation(), l.popoverState === 1 && (h == null || h(l.buttonId)), c({ type: 0 });
          break;
        case X.Escape:
          if (l.popoverState !== 0)
            return h == null ? void 0 : h(l.buttonId);
          if (!d.current || b != null && b.activeElement && !d.current.contains(b.activeElement))
            return;
          I.preventDefault(), I.stopPropagation(), c({ type: 1 });
          break;
      }
  }), M = O((I) => {
    f || I.key === X.Space && I.preventDefault();
  }), y = O((I) => {
    var T, B;
    y5(I.currentTarget) || a || (f ? (c({ type: 1 }), (T = l.button) == null || T.focus()) : (I.preventDefault(), I.stopPropagation(), l.popoverState === 1 && (h == null || h(l.buttonId)), c({ type: 0 }), (B = l.button) == null || B.focus()));
  }), _ = O((I) => {
    I.preventDefault(), I.stopPropagation();
  }), { isFocusVisible: S, focusProps: j } = x2({ autoFocus: i }), { isHovered: V, hoverProps: P } = S2({ isDisabled: a }), { pressed: A, pressProps: R } = t5({ disabled: a }), z = l.popoverState === 0, N = Q(() => ({ open: z, active: A || z, disabled: a, hover: V, focus: S, autofocus: i }), [z, V, S, A, a, i]), G = x6(e, l.button), U = a2(f ? { ref: v, type: G, onKeyDown: w, onClick: y, disabled: a || void 0, autoFocus: i } : { ref: m, id: l.buttonId, type: G, "aria-expanded": l.popoverState === 0, "aria-controls": l.panel ? l.panelId : void 0, disabled: a || void 0, autoFocus: i, onKeyDown: w, onKeyUp: M, onClick: y, onMouseDown: _ }, j, P, R), Z = ie(), E = O(() => {
    let I = l.panel;
    if (!I)
      return;
    function T() {
      P1(Z.current, { [I2.Forwards]: () => l2(I, R1.First), [I2.Backwards]: () => l2(I, R1.Last) }) === Z2.Error && l2(u8().filter((B) => B.dataset.headlessuiFocusGuard !== "true"), P1(Z.current, { [I2.Forwards]: R1.Next, [I2.Backwards]: R1.Previous }), { relativeTo: l.button });
    }
    T();
  }), F = f1();
  return x.createElement(x.Fragment, null, F({ ourProps: U, theirProps: o, slot: N, defaultTag: ep, name: "Popover.Button" }), z && !f && u && x.createElement(Q2, { id: C, ref: l.afterButtonSentinel, features: q2.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: E }));
}
let ap = "div", np = h2.RenderStrategy | h2.Static;
function Jn(e, t) {
  let r = O1(), { id: n = `headlessui-popover-backdrop-${r}`, transition: a = !1, ...i } = e, [{ popoverState: o }, l] = a3("Popover.Backdrop"), [c, u] = e1(null), d = w1(t, u), C = w5(), [p, h] = _6(a, c, C !== null ? (C & B1.Open) === B1.Open : o === 0), f = O((v) => {
    if (y5(v.currentTarget))
      return v.preventDefault();
    l({ type: 1 });
  }), g = Q(() => ({ open: o === 0 }), [o]), m = { ref: d, id: n, "aria-hidden": !0, onClick: f, ...w6(h) };
  return f1()({ ourProps: m, theirProps: i, slot: g, defaultTag: ap, features: np, visible: p, name: "Popover.Backdrop" });
}
let rp = "div", ip = h2.RenderStrategy | h2.Static;
function op(e, t) {
  let r = O1(), { id: n = `headlessui-popover-panel-${r}`, focus: a = !1, anchor: i, portal: o = !1, modal: l = !1, transition: c = !1, ...u } = e, [d, C] = a3("Popover.Panel"), { close: p, isPortalled: h } = ve("Popover.Panel"), f = `headlessui-focus-sentinel-before-${r}`, g = `headlessui-focus-sentinel-after-${r}`, m = J(null), v = D7(i), [b, w] = F7(v), M = R7();
  v && (o = !0);
  let [y, _] = e1(null), S = w1(m, t, v ? b : null, O((I) => C({ type: 4, panel: I })), _), j = W2(m);
  x1(() => (C({ type: 5, panelId: n }), () => {
    C({ type: 5, panelId: null });
  }), [n, C]);
  let V = w5(), [P, A] = _6(c, y, V !== null ? (V & B1.Open) === B1.Open : d.popoverState === 0);
  c8(P, d.button, () => {
    C({ type: 1 });
  });
  let R = d.__demoMode ? !1 : l && P;
  h8(R, j);
  let z = O((I) => {
    var T;
    switch (I.key) {
      case X.Escape:
        if (d.popoverState !== 0 || !m.current || j != null && j.activeElement && !m.current.contains(j.activeElement))
          return;
        I.preventDefault(), I.stopPropagation(), C({ type: 1 }), (T = d.button) == null || T.focus();
        break;
    }
  });
  h1(() => {
    var I;
    e.static || d.popoverState === 1 && ((I = e.unmount) == null || I) && C({ type: 4, panel: null });
  }, [d.popoverState, e.unmount, e.static, C]), h1(() => {
    if (d.__demoMode || !a || d.popoverState !== 0 || !m.current)
      return;
    let I = j == null ? void 0 : j.activeElement;
    m.current.contains(I) || l2(m.current, R1.First);
  }, [d.__demoMode, a, m.current, d.popoverState]);
  let N = Q(() => ({ open: d.popoverState === 0, close: p }), [d.popoverState, p]), G = a2(v ? M() : {}, { ref: S, id: n, onKeyDown: z, onBlur: a && d.popoverState === 0 ? (I) => {
    var T, B, D, $, W;
    let i1 = I.relatedTarget;
    i1 && m.current && ((T = m.current) != null && T.contains(i1) || (C({ type: 1 }), ((D = (B = d.beforePanelSentinel.current) == null ? void 0 : B.contains) != null && D.call(B, i1) || (W = ($ = d.afterPanelSentinel.current) == null ? void 0 : $.contains) != null && W.call($, i1)) && i1.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...u.style, ...w, "--button-width": B9(d.button, !0).width }, ...w6(A) }), U = ie(), Z = O(() => {
    let I = m.current;
    if (!I)
      return;
    function T() {
      P1(U.current, { [I2.Forwards]: () => {
        var B;
        l2(I, R1.First) === Z2.Error && ((B = d.afterPanelSentinel.current) == null || B.focus());
      }, [I2.Backwards]: () => {
        var B;
        (B = d.button) == null || B.focus({ preventScroll: !0 });
      } });
    }
    T();
  }), E = O(() => {
    let I = m.current;
    if (!I)
      return;
    function T() {
      P1(U.current, { [I2.Forwards]: () => {
        if (!d.button)
          return;
        let B = u8(), D = B.indexOf(d.button), $ = B.slice(0, D + 1), W = [...B.slice(D + 1), ...$];
        for (let i1 of W.slice())
          if (i1.dataset.headlessuiFocusGuard === "true" || y != null && y.contains(i1)) {
            let r1 = W.indexOf(i1);
            r1 !== -1 && W.splice(r1, 1);
          }
        l2(W, R1.First, { sorted: !1 });
      }, [I2.Backwards]: () => {
        var B;
        l2(I, R1.Previous) === Z2.Error && ((B = d.button) == null || B.focus());
      } });
    }
    T();
  }), F = f1();
  return x.createElement(X4, null, x.createElement(r3.Provider, { value: n }, x.createElement(n3.Provider, { value: { close: p, isPortalled: h } }, x.createElement(d9, { enabled: o ? e.static || P : !1 }, P && h && x.createElement(Q2, { id: f, ref: d.beforePanelSentinel, features: q2.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: Z }), F({ ourProps: G, theirProps: u, slot: N, defaultTag: rp, features: ip, visible: P, name: "Popover.Panel" }), P && h && x.createElement(Q2, { id: g, ref: d.afterPanelSentinel, features: q2.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: E })))));
}
let sp = "div";
function lp(e, t) {
  let r = J(null), n = w1(r, t), [a, i] = e1([]), o = O((g) => {
    i((m) => {
      let v = m.indexOf(g);
      if (v !== -1) {
        let b = m.slice();
        return b.splice(v, 1), b;
      }
      return m;
    });
  }), l = O((g) => (i((m) => [...m, g]), () => o(g))), c = O(() => {
    var g;
    let m = U2(r);
    if (!m)
      return !1;
    let v = m.activeElement;
    return (g = r.current) != null && g.contains(v) ? !0 : a.some((b) => {
      var w, M;
      return ((w = m.getElementById(b.buttonId.current)) == null ? void 0 : w.contains(v)) || ((M = m.getElementById(b.panelId.current)) == null ? void 0 : M.contains(v));
    });
  }), u = O((g) => {
    for (let m of a)
      m.buttonId.current !== g && m.close();
  }), d = Q(() => ({ registerPopover: l, unregisterPopover: o, isFocusWithinPopoverGroup: c, closeOthers: u }), [l, o, c, u]), C = Q(() => ({}), []), p = e, h = { ref: n }, f = f1();
  return x.createElement(n7, null, x.createElement(be.Provider, { value: d }, f({ ourProps: h, theirProps: p, slot: C, defaultTag: sp, name: "Popover.Group" })));
}
let cp = C1(XC), i3 = C1(tp), qn = C1(Jn), Qn = C1(Jn), o3 = C1(op), Xn = C1(lp), ye = Object.assign(cp, { Button: i3, Backdrop: Qn, Overlay: qn, Panel: o3, Group: Xn });
var up = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(up || {});
let dp = { 0(e, t) {
  let r = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: c5(r, (n) => n.element.current) };
}, 1(e, t) {
  let r = e.options.slice(), n = e.options.findIndex((a) => a.id === t.id);
  return n === -1 ? e : (r.splice(n, 1), { ...e, options: r });
} }, xe = V1(null);
xe.displayName = "RadioGroupDataContext";
function we(e) {
  let t = M1(xe);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, we), r;
  }
  return t;
}
let _e = V1(null);
_e.displayName = "RadioGroupActionsContext";
function Me(e) {
  let t = M1(_e);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Me), r;
  }
  return t;
}
function Cp(e, t) {
  return P1(t.type, dp, e, t);
}
let pp = "div";
function hp(e, t) {
  let r = O1(), n = E2(), { id: a = `headlessui-radiogroup-${r}`, value: i, form: o, name: l, onChange: c, by: u, disabled: d = n || !1, defaultValue: C, ...p } = e, h = Y4(u), [f, g] = j5(Cp, { options: [] }), m = f.options, [v, b] = E5(), [w, M] = r9(), y = J(null), _ = w1(y, t), S = o8(C), [j, V] = i8(i, c, S), P = Q(() => m.find((T) => !T.propsRef.current.disabled), [m]), A = Q(() => m.some((T) => h(T.propsRef.current.value, j)), [m, j]), R = O((T) => {
    var B;
    if (d || h(T, j))
      return !1;
    let D = (B = m.find(($) => h($.propsRef.current.value, T))) == null ? void 0 : B.propsRef.current;
    return D != null && D.disabled ? !1 : (V == null || V(T), !0);
  }), z = O((T) => {
    let B = y.current;
    if (!B)
      return;
    let D = U2(B), $ = m.filter((W) => W.propsRef.current.disabled === !1).map((W) => W.element.current);
    switch (T.key) {
      case X.Enter:
        k7(T.currentTarget);
        break;
      case X.ArrowLeft:
      case X.ArrowUp:
        if (T.preventDefault(), T.stopPropagation(), l2($, R1.Previous | R1.WrapAround) === Z2.Success) {
          let W = m.find((i1) => i1.element.current === (D == null ? void 0 : D.activeElement));
          W && R(W.propsRef.current.value);
        }
        break;
      case X.ArrowRight:
      case X.ArrowDown:
        if (T.preventDefault(), T.stopPropagation(), l2($, R1.Next | R1.WrapAround) === Z2.Success) {
          let W = m.find((i1) => i1.element.current === (D == null ? void 0 : D.activeElement));
          W && R(W.propsRef.current.value);
        }
        break;
      case X.Space:
        {
          T.preventDefault(), T.stopPropagation();
          let W = m.find((i1) => i1.element.current === (D == null ? void 0 : D.activeElement));
          W && R(W.propsRef.current.value);
        }
        break;
    }
  }), N = O((T) => (g({ type: 0, ...T }), () => g({ type: 1, id: T.id }))), G = Q(() => ({ value: j, firstOption: P, containsCheckedOption: A, disabled: d, compare: h, ...f }), [j, P, A, d, h, f]), U = Q(() => ({ registerOption: N, change: R }), [N, R]), Z = { ref: _, id: a, role: "radiogroup", "aria-labelledby": v, "aria-describedby": w, onKeyDown: z }, E = Q(() => ({ value: j }), [j]), F = y1(() => {
    if (S !== void 0)
      return R(S);
  }, [R, S]), I = f1();
  return x.createElement(M, { name: "RadioGroup.Description" }, x.createElement(b, { name: "RadioGroup.Label" }, x.createElement(_e.Provider, { value: U }, x.createElement(xe.Provider, { value: G }, l != null && x.createElement(s8, { disabled: d, data: { [l]: j || "on" }, overrides: { type: "radio", checked: j != null }, form: o, onReset: F }), I({ ourProps: Z, theirProps: p, slot: E, defaultTag: pp, name: "RadioGroup" })))));
}
let fp = "div";
function mp(e, t) {
  var r;
  let n = we("RadioGroup.Option"), a = Me("RadioGroup.Option"), i = O1(), { id: o = `headlessui-radiogroup-option-${i}`, value: l, disabled: c = n.disabled || !1, autoFocus: u = !1, ...d } = e, C = J(null), p = w1(C, t), [h, f] = E5(), [g, m] = r9(), v = b2({ value: l, disabled: c });
  x1(() => a.registerOption({ id: o, element: C, propsRef: v }), [o, a, C, v]);
  let b = O((R) => {
    var z;
    if (y5(R.currentTarget))
      return R.preventDefault();
    a.change(l) && ((z = C.current) == null || z.focus());
  }), w = ((r = n.firstOption) == null ? void 0 : r.id) === o, { isFocusVisible: M, focusProps: y } = x2({ autoFocus: u }), { isHovered: _, hoverProps: S } = S2({ isDisabled: c }), j = n.compare(n.value, l), V = a2({ ref: p, id: o, role: "radio", "aria-checked": j ? "true" : "false", "aria-labelledby": h, "aria-describedby": g, "aria-disabled": c ? !0 : void 0, tabIndex: c ? -1 : j || !n.containsCheckedOption && w ? 0 : -1, onClick: c ? void 0 : b, autoFocus: u }, y, S), P = Q(() => ({ checked: j, disabled: c, active: M, hover: _, focus: M, autofocus: u }), [j, c, _, M, u]), A = f1();
  return x.createElement(m, { name: "RadioGroup.Description" }, x.createElement(f, { name: "RadioGroup.Label" }, A({ ourProps: V, theirProps: d, slot: P, defaultTag: fp, name: "RadioGroup.Option" })));
}
let gp = "span";
function vp(e, t) {
  var r;
  let n = we("Radio"), a = Me("Radio"), i = O1(), o = A5(), l = E2(), { id: c = o || `headlessui-radio-${i}`, value: u, disabled: d = n.disabled || l || !1, autoFocus: C = !1, ...p } = e, h = J(null), f = w1(h, t), g = a5(), m = Q5(), v = b2({ value: u, disabled: d });
  x1(() => a.registerOption({ id: c, element: h, propsRef: v }), [c, a, h, v]);
  let b = O((A) => {
    var R;
    if (y5(A.currentTarget))
      return A.preventDefault();
    a.change(u) && ((R = h.current) == null || R.focus());
  }), { isFocusVisible: w, focusProps: M } = x2({ autoFocus: C }), { isHovered: y, hoverProps: _ } = S2({ isDisabled: d }), S = ((r = n.firstOption) == null ? void 0 : r.id) === c, j = n.compare(n.value, u), V = a2({ ref: f, id: c, role: "radio", "aria-checked": j ? "true" : "false", "aria-labelledby": g, "aria-describedby": m, "aria-disabled": d ? !0 : void 0, tabIndex: d ? -1 : j || !n.containsCheckedOption && S ? 0 : -1, autoFocus: C, onClick: d ? void 0 : b }, M, _), P = Q(() => ({ checked: j, disabled: d, hover: y, focus: w, autofocus: C }), [j, d, y, w, C]);
  return f1()({ ourProps: V, theirProps: p, slot: P, defaultTag: gp, name: "Radio" });
}
let bp = C1(hp), er = C1(mp), tr = C1(vp), ar = i9, nr = l8, yp = Object.assign(bp, { Option: er, Radio: tr, Label: ar, Description: nr }), xp = "select";
function wp(e, t) {
  let r = O1(), n = A5(), a = E2(), { id: i = n || `headlessui-select-${r}`, disabled: o = a || !1, invalid: l = !1, autoFocus: c = !1, ...u } = e, d = a5(), C = Q5(), { isFocusVisible: p, focusProps: h } = x2({ autoFocus: c }), { isHovered: f, hoverProps: g } = S2({ isDisabled: o }), { pressed: m, pressProps: v } = t5({ disabled: o }), b = a2({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": C, "aria-invalid": l ? "" : void 0, disabled: o || void 0, autoFocus: c }, h, g, v), w = Q(() => ({ disabled: o, invalid: l, hover: f, focus: p, active: m, autofocus: c }), [o, l, f, p, m, c]);
  return f1()({ ourProps: b, theirProps: u, slot: w, defaultTag: xp, name: "Select" });
}
let _p = C1(wp), Se = V1(null);
Se.displayName = "GroupContext";
let Mp = q1;
function Sp(e) {
  var t;
  let [r, n] = e1(null), [a, i] = E5(), [o, l] = r9(), c = Q(() => ({ switch: r, setSwitch: n }), [r, n]), u = {}, d = e, C = f1();
  return x.createElement(l, { name: "Switch.Description", value: o }, x.createElement(i, { name: "Switch.Label", value: a, props: { htmlFor: (t = c.switch) == null ? void 0 : t.id, onClick(p) {
    r && (p.currentTarget instanceof HTMLLabelElement && p.preventDefault(), r.click(), r.focus({ preventScroll: !0 }));
  } } }, x.createElement(Se.Provider, { value: c }, C({ ourProps: u, theirProps: d, slot: {}, defaultTag: Mp, name: "Switch.Group" }))));
}
let kp = "button";
function Lp(e, t) {
  var r;
  let n = O1(), a = A5(), i = E2(), { id: o = a || `headlessui-switch-${n}`, disabled: l = i || !1, checked: c, defaultChecked: u, onChange: d, name: C, value: p, form: h, autoFocus: f = !1, ...g } = e, m = M1(Se), [v, b] = e1(null), w = J(null), M = w1(w, t, m === null ? null : m.setSwitch, b), y = o8(u), [_, S] = i8(c, d, y ?? !1), j = Y2(), [V, P] = e1(!1), A = O(() => {
    P(!0), S == null || S(!_), j.nextFrame(() => {
      P(!1);
    });
  }), R = O((r1) => {
    if (y5(r1.currentTarget))
      return r1.preventDefault();
    r1.preventDefault(), A();
  }), z = O((r1) => {
    r1.key === X.Space ? (r1.preventDefault(), A()) : r1.key === X.Enter && k7(r1.currentTarget);
  }), N = O((r1) => r1.preventDefault()), G = a5(), U = Q5(), { isFocusVisible: Z, focusProps: E } = x2({ autoFocus: f }), { isHovered: F, hoverProps: I } = S2({ isDisabled: l }), { pressed: T, pressProps: B } = t5({ disabled: l }), D = Q(() => ({ checked: _, disabled: l, hover: F, focus: Z, active: T, autofocus: f, changing: V }), [_, F, Z, T, l, V, f]), $ = a2({ id: o, ref: M, role: "switch", type: x6(e, v), tabIndex: e.tabIndex === -1 ? 0 : (r = e.tabIndex) != null ? r : 0, "aria-checked": _, "aria-labelledby": G, "aria-describedby": U, disabled: l || void 0, autoFocus: f, onClick: R, onKeyUp: z, onKeyPress: N }, E, I, B), W = y1(() => {
    if (y !== void 0)
      return S == null ? void 0 : S(y);
  }, [S, y]), i1 = f1();
  return x.createElement(x.Fragment, null, C != null && x.createElement(s8, { disabled: l, data: { [C]: p || "on" }, overrides: { type: "checkbox", checked: _ }, form: h, onReset: W }), i1({ ourProps: $, theirProps: g, slot: D, defaultTag: kp, name: "Switch" }));
}
let Hp = C1(Lp), rr = Sp, ir = i9, or = l8, sr = Object.assign(Hp, { Group: rr, Label: ir, Description: or });
function Pp({ onFocus: e }) {
  let [t, r] = e1(!0), n = K7();
  return t ? x.createElement(Q2, { as: "button", type: "button", features: q2.Focusable, onFocus: (a) => {
    a.preventDefault();
    let i, o = 50;
    function l() {
      if (o-- <= 0) {
        i && cancelAnimationFrame(i);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(i), !n.current)
          return;
        r(!1);
        return;
      }
      i = requestAnimationFrame(l);
    }
    i = requestAnimationFrame(l);
  } }) : null;
}
const lr = Y.createContext(null);
function Tp() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var r;
    let n = this.groups.get(e);
    n || (n = /* @__PURE__ */ new Map(), this.groups.set(e, n));
    let a = (r = n.get(t)) != null ? r : 0;
    n.set(t, a + 1);
    let i = Array.from(n.keys()).indexOf(t);
    function o() {
      let l = n.get(t);
      l > 1 ? n.set(t, l - 1) : n.delete(t);
    }
    return [i, o];
  } };
}
function jp({ children: e }) {
  let t = Y.useRef(Tp());
  return Y.createElement(lr.Provider, { value: t }, e);
}
function cr(e) {
  let t = Y.useContext(lr);
  if (!t)
    throw new Error("You must wrap your component in a <StableCollection>");
  let r = Y.useId(), [n, a] = t.current.get(e, r);
  return Y.useEffect(() => a, []), n;
}
var Vp = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Vp || {}), Ap = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(Ap || {}), Ep = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(Ep || {});
let Ip = { 0(e, t) {
  var r;
  let n = c5(e.tabs, (d) => d.current), a = c5(e.panels, (d) => d.current), i = n.filter((d) => {
    var C;
    return !((C = d.current) != null && C.hasAttribute("disabled"));
  }), o = { ...e, tabs: n, panels: a };
  if (t.index < 0 || t.index > n.length - 1) {
    let d = P1(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => P1(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (i.length === 0)
      return o;
    let C = P1(d, { 0: () => n.indexOf(i[0]), 1: () => n.indexOf(i[i.length - 1]) });
    return { ...o, selectedIndex: C === -1 ? e.selectedIndex : C };
  }
  let l = n.slice(0, t.index), c = [...n.slice(t.index), ...l].find((d) => i.includes(d));
  if (!c)
    return o;
  let u = (r = n.indexOf(c)) != null ? r : e.selectedIndex;
  return u === -1 && (u = e.selectedIndex), { ...o, selectedIndex: u };
}, 1(e, t) {
  if (e.tabs.includes(t.tab))
    return e;
  let r = e.tabs[e.selectedIndex], n = c5([...e.tabs, t.tab], (i) => i.current), a = e.selectedIndex;
  return e.info.current.isControlled || (a = n.indexOf(r), a === -1 && (a = e.selectedIndex)), { ...e, tabs: n, selectedIndex: a };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((r) => r !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: c5([...e.panels, t.panel], (r) => r.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((r) => r !== t.panel) };
} }, ke = V1(null);
ke.displayName = "TabsDataContext";
function U6(e) {
  let t = M1(ke);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, U6), r;
  }
  return t;
}
let Le = V1(null);
Le.displayName = "TabsActionsContext";
function He(e) {
  let t = M1(Le);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, He), r;
  }
  return t;
}
function Dp(e, t) {
  return P1(t.type, Ip, e, t);
}
let Np = "div";
function Rp(e, t) {
  let { defaultIndex: r = 0, vertical: n = !1, manual: a = !1, onChange: i, selectedIndex: o = null, ...l } = e;
  const c = n ? "vertical" : "horizontal", u = a ? "manual" : "auto";
  let d = o !== null, C = b2({ isControlled: d }), p = w1(t), [h, f] = j5(Dp, { info: C, selectedIndex: o ?? r, tabs: [], panels: [] }), g = Q(() => ({ selectedIndex: h.selectedIndex }), [h.selectedIndex]), m = b2(i || (() => {
  })), v = b2(h.tabs), b = Q(() => ({ orientation: c, activation: u, ...h }), [c, u, h]), w = O((P) => (f({ type: 1, tab: P }), () => f({ type: 2, tab: P }))), M = O((P) => (f({ type: 3, panel: P }), () => f({ type: 4, panel: P }))), y = O((P) => {
    _.current !== P && m.current(P), d || f({ type: 0, index: P });
  }), _ = b2(d ? e.selectedIndex : h.selectedIndex), S = Q(() => ({ registerTab: w, registerPanel: M, change: y }), []);
  x1(() => {
    f({ type: 0, index: o ?? r });
  }, [o]), x1(() => {
    if (_.current === void 0 || h.tabs.length <= 0)
      return;
    let P = c5(h.tabs, (A) => A.current);
    P.some((A, R) => h.tabs[R] !== A) && y(P.indexOf(h.tabs[_.current]));
  });
  let j = { ref: p }, V = f1();
  return x.createElement(jp, null, x.createElement(Le.Provider, { value: S }, x.createElement(ke.Provider, { value: b }, b.tabs.length <= 0 && x.createElement(Pp, { onFocus: () => {
    var P, A;
    for (let R of v.current)
      if (((P = R.current) == null ? void 0 : P.tabIndex) === 0)
        return (A = R.current) == null || A.focus(), !0;
    return !1;
  } }), V({ ourProps: j, theirProps: l, slot: g, defaultTag: Np, name: "Tabs" }))));
}
let Fp = "div";
function Op(e, t) {
  let { orientation: r, selectedIndex: n } = U6("Tab.List"), a = w1(t), i = Q(() => ({ selectedIndex: n }), [n]), o = e, l = { ref: a, role: "tablist", "aria-orientation": r };
  return f1()({ ourProps: l, theirProps: o, slot: i, defaultTag: Fp, name: "Tabs.List" });
}
let Bp = "button";
function Zp(e, t) {
  var r, n;
  let a = O1(), { id: i = `headlessui-tabs-tab-${a}`, disabled: o = !1, autoFocus: l = !1, ...c } = e, { orientation: u, activation: d, selectedIndex: C, tabs: p, panels: h } = U6("Tab"), f = He("Tab"), g = U6("Tab"), [m, v] = e1(null), b = J(null), w = w1(b, t, v);
  x1(() => f.registerTab(b), [f, b]);
  let M = cr("tabs"), y = p.indexOf(b);
  y === -1 && (y = M);
  let _ = y === C, S = O((I) => {
    var T;
    let B = I();
    if (B === Z2.Success && d === "auto") {
      let D = (T = U2(b)) == null ? void 0 : T.activeElement, $ = g.tabs.findIndex((W) => W.current === D);
      $ !== -1 && f.change($);
    }
    return B;
  }), j = O((I) => {
    let T = p.map((B) => B.current).filter(Boolean);
    if (I.key === X.Space || I.key === X.Enter) {
      I.preventDefault(), I.stopPropagation(), f.change(y);
      return;
    }
    switch (I.key) {
      case X.Home:
      case X.PageUp:
        return I.preventDefault(), I.stopPropagation(), S(() => l2(T, R1.First));
      case X.End:
      case X.PageDown:
        return I.preventDefault(), I.stopPropagation(), S(() => l2(T, R1.Last));
    }
    if (S(() => P1(u, { vertical() {
      return I.key === X.ArrowUp ? l2(T, R1.Previous | R1.WrapAround) : I.key === X.ArrowDown ? l2(T, R1.Next | R1.WrapAround) : Z2.Error;
    }, horizontal() {
      return I.key === X.ArrowLeft ? l2(T, R1.Previous | R1.WrapAround) : I.key === X.ArrowRight ? l2(T, R1.Next | R1.WrapAround) : Z2.Error;
    } })) === Z2.Success)
      return I.preventDefault();
  }), V = J(!1), P = O(() => {
    var I;
    V.current || (V.current = !0, (I = b.current) == null || I.focus({ preventScroll: !0 }), f.change(y), r8(() => {
      V.current = !1;
    }));
  }), A = O((I) => {
    I.preventDefault();
  }), { isFocusVisible: R, focusProps: z } = x2({ autoFocus: l }), { isHovered: N, hoverProps: G } = S2({ isDisabled: o }), { pressed: U, pressProps: Z } = t5({ disabled: o }), E = Q(() => ({ selected: _, hover: N, active: U, focus: R, autofocus: l, disabled: o }), [_, N, R, U, l, o]), F = a2({ ref: w, onKeyDown: j, onMouseDown: A, onClick: P, id: i, role: "tab", type: x6(e, m), "aria-controls": (n = (r = h[y]) == null ? void 0 : r.current) == null ? void 0 : n.id, "aria-selected": _, tabIndex: _ ? 0 : -1, disabled: o || void 0, autoFocus: l }, z, G, Z);
  return f1()({ ourProps: F, theirProps: c, slot: E, defaultTag: Bp, name: "Tabs.Tab" });
}
let Gp = "div";
function Kp(e, t) {
  let { selectedIndex: r } = U6("Tab.Panels"), n = w1(t), a = Q(() => ({ selectedIndex: r }), [r]), i = e, o = { ref: n };
  return f1()({ ourProps: o, theirProps: i, slot: a, defaultTag: Gp, name: "Tabs.Panels" });
}
let zp = "div", Up = h2.RenderStrategy | h2.Static;
function Yp(e, t) {
  var r, n, a, i;
  let o = O1(), { id: l = `headlessui-tabs-panel-${o}`, tabIndex: c = 0, ...u } = e, { selectedIndex: d, tabs: C, panels: p } = U6("Tab.Panel"), h = He("Tab.Panel"), f = J(null), g = w1(f, t);
  x1(() => h.registerPanel(f), [h, f]);
  let m = cr("panels"), v = p.indexOf(f);
  v === -1 && (v = m);
  let b = v === d, { isFocusVisible: w, focusProps: M } = x2(), y = Q(() => ({ selected: b, focus: w }), [b, w]), _ = a2({ ref: g, id: l, role: "tabpanel", "aria-labelledby": (n = (r = C[v]) == null ? void 0 : r.current) == null ? void 0 : n.id, tabIndex: b ? c : -1 }, M), S = f1();
  return !b && ((a = u.unmount) == null || a) && !((i = u.static) != null && i) ? x.createElement(Q2, { "aria-hidden": "true", ..._ }) : S({ ourProps: _, theirProps: u, slot: y, defaultTag: zp, features: Up, visible: b, name: "Tabs.Panel" });
}
let Wp = C1(Zp), ur = C1(Rp), dr = C1(Op), Cr = C1(Kp), pr = C1(Yp), $p = Object.assign(Wp, { Group: ur, List: dr, Panels: Cr, Panel: pr }), Jp = "textarea";
function qp(e, t) {
  let r = O1(), n = A5(), a = E2(), { id: i = n || `headlessui-textarea-${r}`, disabled: o = a || !1, autoFocus: l = !1, invalid: c = !1, ...u } = e, d = a5(), C = Q5(), { isFocused: p, focusProps: h } = x2({ autoFocus: l }), { isHovered: f, hoverProps: g } = S2({ isDisabled: o }), m = a2({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": C, "aria-invalid": c ? "" : void 0, disabled: o || void 0, autoFocus: l }, h, g), v = Q(() => ({ disabled: o, invalid: c, hover: f, focus: p, autofocus: l }), [o, c, f, p, l]);
  return f1()({ ourProps: m, theirProps: u, slot: v, defaultTag: Jp, name: "Textarea" });
}
let Qp = C1(qp);
const yS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Ea,
  Checkbox: bl,
  CloseButton: xl,
  Combobox: ne,
  ComboboxButton: b8,
  ComboboxInput: ae,
  ComboboxLabel: Sn,
  ComboboxOption: G7,
  ComboboxOptions: Z7,
  DataInteractive: rd,
  Description: l8,
  Dialog: p4,
  DialogBackdrop: Ed,
  DialogDescription: Id,
  DialogPanel: In,
  DialogTitle: Dn,
  Disclosure: Jd,
  DisclosureButton: Rn,
  DisclosurePanel: Fn,
  Field: J7,
  Fieldset: tC,
  FocusTrap: oe,
  FocusTrapFeatures: L5,
  Input: rC,
  Label: i9,
  Legend: oC,
  Listbox: e3,
  ListboxButton: z6,
  ListboxLabel: Gn,
  ListboxOption: X7,
  ListboxOptions: x8,
  ListboxSelectedOption: Kn,
  Menu: Wn,
  MenuButton: he,
  MenuHeading: Un,
  MenuItem: me,
  MenuItems: fe,
  MenuSection: zn,
  MenuSeparator: Yn,
  Popover: ye,
  PopoverBackdrop: Qn,
  PopoverButton: i3,
  PopoverGroup: Xn,
  PopoverOverlay: qn,
  PopoverPanel: o3,
  Portal: d9,
  Radio: tr,
  RadioGroup: yp,
  RadioGroupDescription: nr,
  RadioGroupLabel: ar,
  RadioGroupOption: er,
  Select: _p,
  Switch: sr,
  SwitchDescription: or,
  SwitchGroup: rr,
  SwitchLabel: ir,
  Tab: $p,
  TabGroup: ur,
  TabList: dr,
  TabPanel: pr,
  TabPanels: Cr,
  Textarea: Qp,
  Transition: U5,
  TransitionChild: W7,
  useClose: Ga
}, Symbol.toStringTag, { value: "Module" })), Pe = "-", Xp = (e) => {
  const t = th(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (o) => {
      const l = o.split(Pe);
      return l[0] === "" && l.length !== 1 && l.shift(), hr(l, t) || eh(o);
    },
    getConflictingClassGroupIds: (o, l) => {
      const c = r[o] || [];
      return l && n[o] ? [...c, ...n[o]] : c;
    }
  };
}, hr = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), a = n ? hr(e.slice(1), n) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(Pe);
  return (o = t.validators.find(({
    validator: l
  }) => l(i))) == null ? void 0 : o.classGroupId;
}, W0 = /^\[(.+)\]$/, eh = (e) => {
  if (W0.test(e)) {
    const t = W0.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, th = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return nh(Object.entries(e.classGroups), r).forEach(([i, o]) => {
    h4(o, n, i, t);
  }), n;
}, h4 = (e, t, r, n) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : $0(t, a);
      i.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (ah(a)) {
        h4(a(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      h4(o, $0(t, i), r, n);
    });
  });
}, $0 = (e, t) => {
  let r = e;
  return t.split(Pe).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, ah = (e) => e.isThemeGetter, nh = (e, t) => t ? e.map(([r, n]) => {
  const a = n.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, l]) => [t + o, l])) : i);
  return [r, a];
}) : e, rh = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    r.set(i, o), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = r.get(i);
      if (o !== void 0)
        return o;
      if ((o = n.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      r.has(i) ? r.set(i, o) : a(i, o);
    }
  };
}, fr = "!", ih = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, a = t[0], i = t.length, o = (l) => {
    const c = [];
    let u = 0, d = 0, C;
    for (let m = 0; m < l.length; m++) {
      let v = l[m];
      if (u === 0) {
        if (v === a && (n || l.slice(m, m + i) === t)) {
          c.push(l.slice(d, m)), d = m + i;
          continue;
        }
        if (v === "/") {
          C = m;
          continue;
        }
      }
      v === "[" ? u++ : v === "]" && u--;
    }
    const p = c.length === 0 ? l : l.substring(d), h = p.startsWith(fr), f = h ? p.substring(1) : p, g = C && C > d ? C - d : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: f,
      maybePostfixModifierPosition: g
    };
  };
  return r ? (l) => r({
    className: l,
    parseClassName: o
  }) : o;
}, oh = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, sh = (e) => ({
  cache: rh(e.cacheSize),
  parseClassName: ih(e),
  ...Xp(e)
}), lh = /\s+/, ch = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split(lh);
  let l = "";
  for (let c = o.length - 1; c >= 0; c -= 1) {
    const u = o[c], {
      modifiers: d,
      hasImportantModifier: C,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = r(u);
    let f = !!h, g = n(f ? p.substring(0, h) : p);
    if (!g) {
      if (!f) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (g = n(p), !g) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      f = !1;
    }
    const m = oh(d).join(":"), v = C ? m + fr : m, b = v + g;
    if (i.includes(b))
      continue;
    i.push(b);
    const w = a(g, f);
    for (let M = 0; M < w.length; ++M) {
      const y = w[M];
      i.push(v + y);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function r7() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = mr(t)) && (n && (n += " "), n += r);
  return n;
}
const mr = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = mr(e[n])) && (r && (r += " "), r += t);
  return r;
};
function uh(e, ...t) {
  let r, n, a, i = o;
  function o(c) {
    const u = t.reduce((d, C) => C(d), e());
    return r = sh(u), n = r.cache.get, a = r.cache.set, i = l, l(c);
  }
  function l(c) {
    const u = n(c);
    if (u)
      return u;
    const d = ch(c, r);
    return a(c, d), d;
  }
  return function() {
    return i(r7.apply(null, arguments));
  };
}
const X1 = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, gr = /^\[(?:([a-z-]+):)?(.+)\]$/i, dh = /^\d+\/\d+$/, Ch = /* @__PURE__ */ new Set(["px", "full", "screen"]), ph = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, hh = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, fh = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, mh = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, gh = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, M5 = (e) => Z6(e) || Ch.has(e) || dh.test(e), D5 = (e) => p9(e, "length", Sh), Z6 = (e) => !!e && !Number.isNaN(Number(e)), N3 = (e) => p9(e, "number", Z6), w9 = (e) => !!e && Number.isInteger(Number(e)), vh = (e) => e.endsWith("%") && Z6(e.slice(0, -1)), S1 = (e) => gr.test(e), N5 = (e) => ph.test(e), bh = /* @__PURE__ */ new Set(["length", "size", "percentage"]), yh = (e) => p9(e, bh, vr), xh = (e) => p9(e, "position", vr), wh = /* @__PURE__ */ new Set(["image", "url"]), _h = (e) => p9(e, wh, Lh), Mh = (e) => p9(e, "", kh), _9 = () => !0, p9 = (e, t, r) => {
  const n = gr.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, Sh = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  hh.test(e) && !fh.test(e)
), vr = () => !1, kh = (e) => mh.test(e), Lh = (e) => gh.test(e), Hh = () => {
  const e = X1("colors"), t = X1("spacing"), r = X1("blur"), n = X1("brightness"), a = X1("borderColor"), i = X1("borderRadius"), o = X1("borderSpacing"), l = X1("borderWidth"), c = X1("contrast"), u = X1("grayscale"), d = X1("hueRotate"), C = X1("invert"), p = X1("gap"), h = X1("gradientColorStops"), f = X1("gradientColorStopPositions"), g = X1("inset"), m = X1("margin"), v = X1("opacity"), b = X1("padding"), w = X1("saturate"), M = X1("scale"), y = X1("sepia"), _ = X1("skew"), S = X1("space"), j = X1("translate"), V = () => ["auto", "contain", "none"], P = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", S1, t], R = () => [S1, t], z = () => ["", M5, D5], N = () => ["auto", Z6, S1], G = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], U = () => ["solid", "dashed", "dotted", "double", "none"], Z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], E = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], F = () => ["", "0", S1], I = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Z6, S1];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [_9],
      spacing: [M5, D5],
      blur: ["none", "", N5, S1],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", N5, S1],
      borderSpacing: R(),
      borderWidth: z(),
      contrast: T(),
      grayscale: F(),
      hueRotate: T(),
      invert: F(),
      gap: R(),
      gradientColorStops: [e],
      gradientColorStopPositions: [vh, D5],
      inset: A(),
      margin: A(),
      opacity: T(),
      padding: R(),
      saturate: T(),
      scale: T(),
      sepia: F(),
      skew: T(),
      space: R(),
      translate: R()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", S1]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [N5]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": I()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": I()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...G(), S1]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: P()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": P()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": P()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: V()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": V()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": V()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", w9, S1]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", S1]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: F()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: F()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", w9, S1]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [_9]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", w9, S1]
        }, S1]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [_9]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [w9, S1]
        }, S1]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", S1]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", S1]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...E()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...E(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...E(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", S1, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [S1, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [S1, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [N5]
        }, N5]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [S1, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [S1, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [S1, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [S1, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", N5, D5]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", N3]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [_9]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", S1]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Z6, N3]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", M5, S1]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", S1]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", S1]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", M5, D5]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", M5, S1]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: R()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", S1]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", S1]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...G(), xh]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", yh]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, _h]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [f]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...U()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [M5, S1]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [M5, D5]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [M5, D5]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", N5, Mh]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [_9]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", N5, S1]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [C]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [C]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", S1]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", S1]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", S1]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [M]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [M]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [M]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [w9, S1]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [j]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [j]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [_]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [_]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", S1]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", S1]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": R()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": R()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": R()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": R()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": R()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": R()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": R()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": R()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": R()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": R()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": R()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": R()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": R()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": R()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": R()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": R()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": R()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": R()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", S1]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [M5, D5, N3]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, K = /* @__PURE__ */ uh(Hh);
function w8(e) {
  return /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "19", height: "16", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" }) });
}
var Ph = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.big = "big", e))(Ph || {});
function xS({
  opened: e,
  onClose: t,
  children: r,
  title: n,
  size: a = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: l,
  className: c,
  contentClassName: u,
  isCentered: d,
  dialogClassName: C,
  backdropClassName: p,
  dialogContentClassName: h,
  dialogContentWrapperClassName: f,
  dialogContentWrapper1ClassName: g,
  titleClassName: m,
  closeIconWrapperClassName: v,
  closeIconClassName: b,
  ...w
}) {
  return /* @__PURE__ */ s.jsx(U5.Root, { afterEnter: l, show: e, as: q1, children: /* @__PURE__ */ s.jsxs(
    p4,
    {
      className: K("relative z-10", C),
      onClose: i ? () => {
      } : t,
      children: [
        /* @__PURE__ */ s.jsx(
          U5.Child,
          {
            as: q1,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ s.jsx(
              "div",
              {
                className: K(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  p
                )
              }
            )
          }
        ),
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: K("fixed inset-0 z-10 overflow-y-auto", f),
            children: /* @__PURE__ */ s.jsx(
              "div",
              {
                id: "modal-background",
                className: K(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  g
                ),
                children: /* @__PURE__ */ s.jsx(
                  U5.Child,
                  {
                    as: q1,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ s.jsxs(
                      p4.Panel,
                      {
                        className: K(
                          "relative w-full",
                          a === "small" ? "max-w-2xl" : a === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          c
                        ),
                        ...w,
                        children: [
                          /* @__PURE__ */ s.jsxs(
                            "div",
                            {
                              className: K(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                d ? "justify-center" : "justify-between",
                                h
                              ),
                              children: [
                                /* @__PURE__ */ s.jsx("h3", { className: K(d ? "px-6 lg:px-10" : "", m), children: n }),
                                /* @__PURE__ */ s.jsx(
                                  "button",
                                  {
                                    className: K(
                                      "focus-ring rounded-full",
                                      d && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      v
                                    ),
                                    disabled: i,
                                    onClick: t,
                                    children: /* @__PURE__ */ s.jsx(
                                      w8,
                                      {
                                        className: K(
                                          "cursor-pointer",
                                          i && "fill-text-secondary pointer-events-none",
                                          b
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ s.jsx(
                            "div",
                            {
                              className: K(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                u
                              ),
                              children: r
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const i7 = ({ small: e = !1, type: t = "light", className: r, style: n }) => /* @__PURE__ */ s.jsxs("div", { role: "status", className: r, style: n, children: [
  /* @__PURE__ */ s.jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: `${e ? "h-5 w-5" : "h-8 w-8"} animate-spin ${t === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: "Loading..." })
] }), wS = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    width: "42",
    height: "42",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ s.jsx("rect", { width: "50", height: "50", rx: "6", fill: "rgb(var(--brand-primary))" }),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.8666 33.3232L23.0246 37.4275C23.3113 37.8 23.261 38.3274 22.9128 38.6432L21.8268 39.6289C21.6328 39.8048 21.3994 39.8831 21.1386 39.8595C20.8778 39.836 20.663 39.7165 20.5029 39.5093L17.0017 34.9772L19.8666 33.3232ZM37.19 22.79H40.4062C40.9207 22.79 41.337 22.3699 41.3359 21.8561C41.3348 21.3416 40.9153 20.9259 40.4016 20.9259H37.1853C36.6709 20.9259 36.2546 21.3461 36.2556 21.8598C36.2566 22.3744 36.6761 22.79 37.19 22.79ZM33.3723 14.3218L34.9805 11.5364C35.2374 11.0914 35.0872 10.5203 34.6422 10.2621C34.1978 10.0044 33.6257 10.1548 33.3685 10.6003L31.7604 13.3856C31.5035 13.8306 31.6537 14.4017 32.0987 14.6599C32.5431 14.9177 33.1151 14.7673 33.3723 14.3218ZM37.0935 17.6581L39.734 16.1337C40.1822 15.8749 40.3358 15.3019 40.077 14.8535C39.8182 14.4053 39.2452 14.2518 38.7969 14.5106L36.1564 16.0351C35.7082 16.2939 35.5546 16.8669 35.8134 17.3152C36.0722 17.7634 36.6452 17.9169 37.0935 17.6581ZM32.9406 21.8529L36.055 27.2473C36.6398 28.2601 36.2895 29.5672 35.2767 30.1519C34.3316 30.6976 33.1303 30.429 32.4988 29.5676H32.4987C29.0513 29.0432 24.5606 29.6066 20.0953 31.3473L15.8024 23.9118C19.544 20.9183 22.2856 17.33 23.5552 14.0822L23.5553 14.0821C23.1093 13.1001 23.4757 11.9114 24.4281 11.3615C25.441 10.7767 26.748 11.127 27.3327 12.1398L30.4472 17.5342C30.5359 17.4657 30.6301 17.4023 30.7298 17.3447C31.9332 16.6499 33.4721 17.0622 34.1669 18.2657C34.8618 19.4692 34.4494 21.0081 33.246 21.7029C33.1463 21.7605 33.0442 21.8104 32.9406 21.8529ZM19.0158 32.1338L14.5175 24.3427L10.9415 26.4073C8.76855 27.6618 8.01723 30.4661 9.27171 32.639L9.27178 32.6391C10.5263 34.8119 13.3305 35.5633 15.5035 34.3088L19.0795 32.2442L19.0158 32.1338Z",
          fill: "rgb(var(--background-secondary))"
        }
      )
    ]
  }
);
function _S(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      fill: "rgb(var(--background-secondary))",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 5C9 4.44772 8.55228 4 8 4C7.44771 4 7 4.44772 7 5V7H5C4.44772 7 4 7.44772 4 8C4 8.55229 4.44772 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55228 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55228 12 8C12 7.44771 11.5523 7 11 7H9V5Z"
        }
      )
    }
  );
}
function MS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "43",
      height: "36",
      viewBox: "0 0 43 36",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            stroke: "none",
            d: "M19.8215 35.0926L1.23971 16.2129C0.965302 15.8379 0.820312 15.3926 0.820312 14.9249V2.66362C0.820312 2.08549 1.04176 1.5421 1.44386 1.13356C1.84682 0.725 2.38163 0.5 2.94977 0.5H15.0176C15.6891 0.50088 16.3284 0.82857 16.7276 1.37656L27.2326 12.0505C25.0306 13.9778 23.7678 16.7746 23.7678 19.7251C23.7678 23.7767 26.1355 27.4293 29.8 29.0305C29.6392 29.2038 29.494 29.3552 29.3566 29.4948C26.7197 32.1732 23.4226 34.1089 19.822 35.0925L19.8215 35.0926ZM10.6579 6.44148C9.59225 6.44236 8.59058 6.86431 7.83736 7.6296C7.08415 8.3949 6.66886 9.41263 6.66799 10.4953C6.66799 11.5776 7.08267 12.596 7.83565 13.3628C8.57766 14.1175 9.60538 14.5509 10.6553 14.5518C11.7235 14.5518 12.7273 14.1302 13.4818 13.3645C14.2361 12.5971 14.6511 11.5773 14.6503 10.4927C14.6494 9.42597 14.2229 8.38176 13.48 7.62787C12.7262 6.86282 11.7239 6.44149 10.6578 6.44149L10.6579 6.44148Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "none",
            clipRule: "evenodd",
            d: "M34.3106 11.0938C29.5693 11.0938 25.8008 14.8622 25.8008 19.6036C25.8008 24.345 29.5693 28.1135 34.3106 28.1135C39.0521 28.1135 42.8205 24.345 42.8205 19.6036C42.8205 14.8622 39.0521 11.0938 34.3106 11.0938ZM39.1734 20.8193H35.5264V24.4664H33.0949V20.8193H29.4479V18.388H33.0949V14.7409H35.5264V18.388H39.1734V20.8193Z"
          }
        )
      ]
    }
  );
}
function SS(e) {
  return /* @__PURE__ */ s.jsx("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" }) });
}
const Th = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    version: "1.1",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 210.2",
    ...e,
    children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          id: "XMLID_34_",
          d: `M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9
	C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2
	c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7
	c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2
	C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z
	 M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2
	c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8
	c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4
	l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5
	l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z
	`
        }
      ),
      /* @__PURE__ */ s.jsx("g", {}),
      /* @__PURE__ */ s.jsx("g", {}),
      /* @__PURE__ */ s.jsx("g", {}),
      /* @__PURE__ */ s.jsx("g", {}),
      /* @__PURE__ */ s.jsx("g", {}),
      /* @__PURE__ */ s.jsx("g", {})
    ]
  }
);
function br(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15",
      height: "9",
      viewBox: "0 0 15 9",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M1.5 1.5L7.5 7.5L13.5 1.5",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function kS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "17",
      height: "10",
      viewBox: "0 0 17 10",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M7.89997 0.550032C7.99302 0.455547 8.10394 0.380513 8.22626 0.329296C8.34858 0.27808 8.47987 0.251704 8.61248 0.251704C8.74509 0.251704 8.87637 0.27808 8.99869 0.329296C9.12101 0.380513 9.23193 0.455547 9.32498 0.550032L16.456 7.79603C16.5938 7.9366 16.687 8.1147 16.724 8.30802C16.761 8.50134 16.7401 8.70129 16.664 8.8828C16.5879 9.06432 16.4599 9.21933 16.296 9.32841C16.1322 9.4375 15.9398 9.49581 15.743 9.49603H1.48098C1.28414 9.49581 1.09175 9.4375 0.927914 9.32841C0.764074 9.21933 0.636071 9.06432 0.559942 8.8828C0.483812 8.70129 0.462944 8.50134 0.49995 8.30802C0.536956 8.1147 0.630192 7.9366 0.767975 7.79603L7.89997 0.550032Z" })
    }
  );
}
function jh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "rgb(var(--text-secondary) / 0.8)",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.306 5.49756L6.27959 1.52696C6.57347 1.23307 6.57347 0.757853 6.27959 0.467093C5.98571 0.176333 5.51051 0.176333 5.21663 0.467093L0.714683 4.96606C0.430183 5.25057 0.423933 5.70703 0.692793 6.00092L5.2135 10.5312C5.36044 10.6781 5.55427 10.75 5.74498 10.75C5.93569 10.75 6.12952 10.6781 6.27646 10.5312C6.57034 10.2373 6.57034 9.76204 6.27646 9.47128L2.306 5.49756Z"
        }
      )
    }
  );
}
function yr(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "rgb(var(--text-secondary) / 0.8)",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.69414 5.49755L0.720417 1.52696C0.426528 1.23307 0.426528 0.757853 0.720417 0.467093C1.01431 0.176333 1.48953 0.176333 1.78341 0.467093L6.2855 4.96605C6.57001 5.25056 6.57626 5.70702 6.30739 6.00091L1.78654 10.5311C1.6396 10.6781 1.44576 10.75 1.25504 10.75C1.06433 10.75 0.870488 10.6781 0.723538 10.5311C0.429648 10.2373 0.429648 9.76203 0.723538 9.47127L4.69414 5.49755Z"
        }
      )
    }
  );
}
function LS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M13.5 8.5H2.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        /* @__PURE__ */ s.jsx("path", { d: "M7 4L2.5 8.5L7 13", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
      ]
    }
  );
}
function HS(e) {
  return /* @__PURE__ */ s.jsx("svg", { width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.04185 0.956942L6.67606 0.306247C6.9446 0.0307302 7.37885 0.0307302 7.64453 0.306247L13.1982 6.00133C13.4667 6.27684 13.4667 6.72238 13.1982 6.99496L7.64453 12.693C7.37599 12.9685 6.94174 12.9685 6.67606 12.693L6.04185 12.0423C5.77045 11.7638 5.77617 11.3095 6.05328 11.0369L9.49577 7.67205H1.28524C0.90529 7.67205 0.599609 7.35842 0.599609 6.96859V6.03065C0.599609 5.64082 0.90529 5.3272 1.28524 5.3272H9.49577L6.05328 1.96233C5.77331 1.68974 5.7676 1.23542 6.04185 0.956967V0.956942Z",
      fill: "rgb(var(--background-secondary))"
    }
  ) });
}
function PS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M14.0002 1.5C14.0002 0.946875 14.4471 0.5 15.0002 0.5C15.5533 0.5 16.0002 0.946875 16.0002 1.5V6.5C16.0002 8.15625 14.6564 9.5 13.0002 9.5H3.41582L5.70957 11.7937C6.1002 12.1844 6.1002 12.8188 5.70957 13.2094C5.31895 13.6 4.68457 13.6 4.29395 13.2094L0.293945 9.20938C-0.0966797 8.81875 -0.0966797 8.18437 0.293945 7.79375L4.29395 3.79375C4.68457 3.40312 5.31895 3.40312 5.70957 3.79375C6.1002 4.18437 6.1002 4.81875 5.70957 5.20937L3.41582 7.5H13.0002C13.5533 7.5 14.0002 7.05312 14.0002 6.5V1.5Z",
          fill: "rgb(var(--background-secondary))"
        }
      )
    }
  );
}
function TS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      ...e,
      width: "63",
      height: "60",
      viewBox: "0 0 63 60",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M41.7732 27.5558C42.1021 27.0626 41.6089 26.5694 41.1157 26.5694H32.4019V12.9236C32.4019 12.2661 31.4154 11.9372 31.0865 12.5947L21.5509 31.6662C21.222 31.9952 21.5509 32.6527 22.2084 32.6527H30.9222V46.134C30.9222 46.9562 31.9087 47.1205 32.2376 46.463L41.7732 27.5558Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M60.6977 24.3826H60.6974L57.3533 24.3823C54.9442 12.1595 44.0877 3.28823 31.5387 3.28823C19.0504 3.28823 8.26021 12.1596 5.88206 24.3823H2.53906C3.12658 20.9711 4.30145 17.7216 6.0308 14.7238C7.72275 11.7909 9.89129 9.18962 12.4762 6.99228C15.0791 4.77958 18.0153 3.05289 21.2029 1.86015C24.5017 0.62585 27.9792 0 31.5387 0C35.099 0 38.5835 0.62585 41.8954 1.86015C45.0974 3.0535 48.0497 4.78019 50.6704 6.99227C53.2754 9.19117 55.4619 11.7924 57.1692 14.7238C58.9165 17.724 60.1037 20.9736 60.6976 24.3823L60.6977 24.3826Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.95353 31.5234L0.00080061 26.1681H7.90625L3.95353 31.5234Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.55229 35.9572H2.55259L5.89669 35.9575C8.30578 48.1804 19.1623 57.0516 31.7112 57.0516C44.1996 57.0516 54.9898 48.1803 57.3679 35.9575H60.7109C60.1234 39.3688 58.9485 42.6182 57.2192 45.616C55.5272 48.549 53.3587 51.1502 50.7738 53.3476C48.1708 55.5603 45.2347 57.287 42.047 58.4797C38.7482 59.714 35.2708 60.3398 31.7112 60.3398C28.1509 60.3398 24.6664 59.714 21.3546 58.4797C18.1526 57.2864 15.2003 55.5597 12.5796 53.3476C9.97456 51.1487 7.78802 48.5474 6.08075 45.616C4.33342 42.6159 3.14629 39.3663 2.55235 35.9575L2.55229 35.9572Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.2965 28.8164L63.2492 34.1717H55.3438L59.2965 28.8164Z"
          }
        )
      ]
    }
  );
}
function jS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "60",
      height: "60",
      viewBox: "0 0 60 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39.6209 27.4562C39.9498 26.963 39.4566 26.4698 38.9633 26.4698H30.2495V12.824C30.2495 12.1665 29.2631 11.8375 28.9342 12.495L19.3986 31.5666C19.0696 31.8956 19.3986 32.5531 20.0561 32.5531H28.7699V46.0344C28.7699 46.8566 29.7564 47.0209 30.0853 46.3634L39.6209 27.4562Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.429 0C45.7054 0 59.0224 13.1525 59.0224 29.429C59.0224 45.7054 45.7054 59.0224 29.429 59.0224C13.1525 59.0224 0 45.7054 0 29.429C0 13.1525 13.1525 0 29.429 0ZM29.429 3.28828C14.9611 3.28828 3.28839 14.961 3.28839 29.4289C3.28839 43.8967 14.9611 55.7339 29.429 55.7339C43.8968 55.7339 55.734 43.8967 55.734 29.4289C55.734 14.961 43.8968 3.28828 29.429 3.28828Z",
            fill: "rgb(var(--fill-primary))"
          }
        )
      ]
    }
  );
}
function VS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.869867 10.956C0.869867 5.18211 5.55026 0.501719 11.3242 0.501719C17.0981 0.501719 21.7785 5.18211 21.7785 10.956C21.7785 16.7299 17.0981 21.4103 11.3242 21.4103C5.55026 21.4103 0.869867 16.7299 0.869867 10.956Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.63731 9.6693L13.0481 5.91566C13.8419 5.3615 14.3015 5.67518 14.0717 6.6162L13.0794 10.6312L14.8029 11.0599C15.5863 11.2586 15.6803 11.7918 15.0223 12.2519L9.61151 16.0055C8.81766 16.5597 8.35805 16.246 8.58785 15.305L9.58017 11.29L7.85667 10.8613C7.07325 10.6626 6.97925 10.1293 7.63731 9.6693Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function AS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M9.99995 17.0602C10.8845 17.8519 12.0527 18.3333 13.3333 18.3333C16.0947 18.3333 18.3333 16.0948 18.3333 13.3333C18.3333 11.0276 16.7725 9.08632 14.6498 8.50848M5.35011 8.50847C3.22741 9.08631 1.66663 11.0276 1.66663 13.3333C1.66663 16.0948 3.9052 18.3333 6.66663 18.3333C9.42805 18.3333 11.6666 16.0948 11.6666 13.3333C11.6666 12.6829 11.5424 12.0615 11.3165 11.4915M15 6.66666C15 9.42809 12.7614 11.6667 9.99996 11.6667C7.23854 11.6667 4.99996 9.42809 4.99996 6.66666C4.99996 3.90524 7.23854 1.66666 9.99996 1.66666C12.7614 1.66666 15 3.90524 15 6.66666Z",
          stroke: "rgb(var(--text-primary))",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
function Vh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "24",
      height: "10",
      viewBox: "0 0 24 10",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M4.75347 9.9973C8.35951 9.9973 10.1625 7.57135 11.9656 5.14539H0V9.9973H4.75347Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M19.1778 0.293716C15.5717 0.293716 13.7687 2.71967 11.9657 5.14562H23.9312V0.293716H19.1778Z" })
      ]
    }
  );
}
function ES(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      "enable-background": "new 0 0 32 32",
      viewBox: "0 0 32 32",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { id: "Grid", display: "none" }),
        /* @__PURE__ */ s.jsx("g", { id: "Chat_Bubble" }),
        /* @__PURE__ */ s.jsx("g", { id: "Destination" }),
        /* @__PURE__ */ s.jsx("g", { id: "Money" }),
        /* @__PURE__ */ s.jsx("g", { id: "Calendar" }),
        /* @__PURE__ */ s.jsx("g", { id: "Passport_1_" }),
        /* @__PURE__ */ s.jsx("g", { id: "Wallet" }),
        /* @__PURE__ */ s.jsx("g", { id: "Taxi" }),
        /* @__PURE__ */ s.jsx("g", { id: "Ticket" }),
        /* @__PURE__ */ s.jsx("g", { id: "Profile" }),
        /* @__PURE__ */ s.jsx("g", { id: "Plane" }),
        /* @__PURE__ */ s.jsx("g", { id: "Compass" }),
        /* @__PURE__ */ s.jsx("g", { id: "Hotel" }),
        /* @__PURE__ */ s.jsxs("g", { id: "Booking", children: [
          /* @__PURE__ */ s.jsx("path", { d: "m24.507 17.564c-3.034 0-5.493 2.459-5.493 5.493s2.459 5.493 5.493 5.493 5.493-2.459 5.493-5.493-2.459-5.493-5.493-5.493zm2.432 5.259-2.682 2.16c-.16.129-.36.199-.564.199-.034 0-.068-.002-.103-.006-.239-.027-.457-.149-.605-.339l-1.054-1.344c-.307-.392-.238-.957.152-1.264.393-.307.956-.238 1.264.152l.491.627 1.972-1.589c.388-.313.954-.249 1.266.137.312.388.251.955-.137 1.267z" }),
          /* @__PURE__ */ s.jsx("path", { d: "m17.514 23.058c0-3.856 3.137-6.993 6.993-6.993 1.281 0 2.479.352 3.513.956v-9.001c0-2.27-1.84-4.11-4.11-4.11h-2.16v-.46c0-.5-.41-.9-.9-.9-.5 0-.9.4-.9.9v.46h-10.77v-.46c0-.5-.4-.9-.9-.9s-.9.4-.9.9v.46h-2.17c-2.27 0-4.11 1.84-4.11 4.11v14.74c0 2.27 1.84 4.11 4.11 4.11h13.442c-.717-1.098-1.138-2.406-1.138-3.812zm3.517-10.814c.574 0 1.039.465 1.039 1.039s-.465 1.039-1.039 1.039-1.039-.465-1.039-1.039.465-1.039 1.039-1.039zm-12.937 7.739c-.574 0-1.039-.465-1.039-1.039s.465-1.039 1.039-1.039 1.039.465 1.039 1.039-.465 1.039-1.039 1.039zm0-5.661c-.574 0-1.039-.465-1.039-1.039s.465-1.039 1.039-1.039 1.039.465 1.039 1.039-.465 1.039-1.039 1.039zm6.469 5.661c-.574 0-1.039-.465-1.039-1.039s.465-1.039 1.039-1.039 1.039.465 1.039 1.039-.466 1.039-1.039 1.039zm0-5.661c-.574 0-1.039-.465-1.039-1.039s.465-1.039 1.039-1.039 1.039.465 1.039 1.039-.466 1.039-1.039 1.039z" })
        ] }),
        /* @__PURE__ */ s.jsx("g", { id: "Camera" }),
        /* @__PURE__ */ s.jsx("g", { id: "Luggage" }),
        /* @__PURE__ */ s.jsx("g", { id: "Help" }),
        /* @__PURE__ */ s.jsx("g", { id: "Notification" }),
        /* @__PURE__ */ s.jsx("g", { id: "Weather" }),
        /* @__PURE__ */ s.jsx("g", { id: "Travel_Guide" }),
        /* @__PURE__ */ s.jsx("g", { id: "Placeholder" }),
        /* @__PURE__ */ s.jsx("g", { id: "Credit_Card" }),
        /* @__PURE__ */ s.jsx("g", { id: "Review" }),
        /* @__PURE__ */ s.jsx("g", { id: "Global_Search" }),
        /* @__PURE__ */ s.jsx("g", { id: "Travel_Bag" }),
        /* @__PURE__ */ s.jsx("g", { id: "Globe" })
      ]
    }
  );
}
function IS(e) {
  return /* @__PURE__ */ s.jsx("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z" }) });
}
function DS(e) {
  return /* @__PURE__ */ s.jsxs("svg", { width: "22", height: "24", viewBox: "0 0 22 24", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsx("path", { d: "M21.1719 17.2391C20.5266 16.1234 19.75 14.0016 19.75 10.25V9.47344C19.75 4.62813 15.8563 0.657819 11.0657 0.625007H11C9.85057 0.623567 8.71211 0.84891 7.64986 1.28813C6.58761 1.72735 5.62245 2.37181 4.80965 3.18461C3.99685 3.99741 3.35238 4.96258 2.91317 6.02483C2.47395 7.08707 2.2486 8.22554 2.25004 9.37501V10.25C2.25004 14.0016 1.47348 16.1234 0.828168 17.2391C0.66867 17.5047 0.583501 17.8082 0.581576 18.118C0.579652 18.4278 0.661044 18.7325 0.817231 19C0.970367 19.2675 1.19184 19.4895 1.45898 19.6432C1.72612 19.797 2.02933 19.877 2.33754 19.875H19.6625C19.9708 19.877 20.274 19.797 20.5411 19.6432C20.8082 19.4895 21.0297 19.2675 21.1829 19C21.339 18.7325 21.4204 18.4278 21.4185 18.118C21.4166 17.8082 21.3314 17.5047 21.1719 17.2391Z" }),
    /* @__PURE__ */ s.jsx("path", { d: "M14.4893 21.625H7.48926C7.25719 21.625 7.03464 21.7172 6.87054 21.8813C6.70645 22.0454 6.61426 22.2679 6.61426 22.5C6.61426 22.7321 6.70645 22.9546 6.87054 23.1187C7.03464 23.2828 7.25719 23.375 7.48926 23.375H14.4893C14.7213 23.375 14.9439 23.2828 15.108 23.1187C15.2721 22.9546 15.3643 22.7321 15.3643 22.5C15.3643 22.2679 15.2721 22.0454 15.108 21.8813C14.9439 21.7172 14.7213 21.625 14.4893 21.625Z" })
  ] });
}
function NS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "24",
      viewBox: "0 0 20 24",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.56799 23.3918H15.222C16.1299 23.3918 16.8683 22.6533 16.8683 21.7455V8.73633H2.92188V21.7455C2.92188 22.6534 3.66036 23.3918 4.5682 23.3918H4.56799ZM12.5703 12.1425C12.5703 11.8395 12.816 11.5938 13.1191 11.5938C13.4222 11.5938 13.6679 11.8395 13.6679 12.1425V18.897C13.6679 19.2001 13.4222 19.4458 13.1191 19.4458C12.816 19.4458 12.5703 19.2001 12.5703 18.897V12.1425ZM6.42969 12.1425C6.42969 11.8395 6.67548 11.5938 6.97849 11.5938C7.2815 11.5938 7.52729 11.8395 7.52729 12.1425V18.897C7.52729 19.2001 7.28153 19.4458 6.97849 19.4458C6.67548 19.4458 6.42969 19.2001 6.42969 18.897V12.1425Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.0161 5.22538C19.0161 4.62019 18.5238 4.12782 17.9186 4.12782H13.6663V2.97832C13.6663 1.76787 12.6816 0.783203 11.4712 0.783203H8.31644C7.10598 0.783203 6.12134 1.76787 6.12134 2.97832V4.12782H1.86904C1.26385 4.12782 0.771484 4.62015 0.771484 5.22538V7.64003H19.0164L19.0161 5.22538ZM12.5683 4.12792H7.21875V2.97842C7.21875 2.37322 7.71107 1.88086 8.3163 1.88086H11.471C12.0762 1.88086 12.5686 2.3732 12.5686 2.97842L12.5683 4.12792Z"
          }
        )
      ]
    }
  );
}
function RS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.98859 0C4.04487 0 0 4.04486 0 8.98859C0 13.9323 4.04487 17.9772 8.98859 17.9772C13.9323 17.9772 17.9772 13.9323 17.9772 8.98859C17.9772 4.04487 13.9323 0 8.98859 0ZM8.98859 2.24715C10.4717 2.24715 11.82 2.71902 12.9211 3.50552L3.50555 12.9211C2.71906 11.8199 2.24718 10.4716 2.24718 8.98855C2.24718 5.25829 5.2584 2.24711 8.98862 2.24711L8.98859 2.24715ZM14.4716 5.05608C15.2581 6.15721 15.73 7.5055 15.73 8.98859C15.73 12.7188 12.7188 15.73 8.98855 15.73C7.50546 15.73 6.15718 15.2582 5.05605 14.4717L14.4716 5.05608Z"
        }
      )
    }
  );
}
function FS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.35742 15.5V4.91504H15.1816V15.5H6.35742ZM0.181641 15.5V4.91504H5.47656V15.5H0.181641ZM0.181641 4.03125V0.5H15.1816V4.03125H0.181641Z"
        }
      )
    }
  );
}
function OS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "19",
      height: "28",
      viewBox: "0 0 19 21",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.51767 13.8557C4.2928 13.8557 4.07714 13.945 3.91814 14.104C3.75913 14.2631 3.6698 14.4787 3.6698 14.7036C3.6698 14.9284 3.75913 15.1441 3.91814 15.3031C4.07715 15.4621 4.29281 15.5514 4.51767 15.5514H14.1269C14.3517 15.5514 14.5674 15.4621 14.7264 15.3031C14.8854 15.1441 14.9747 14.9284 14.9747 14.7036C14.9747 14.4787 14.8854 14.263 14.7264 14.104C14.5674 13.945 14.3517 13.8557 14.1269 13.8557H4.51767ZM3.6698 10.1816C3.6698 10.6496 4.04965 11.0295 4.51767 11.0295H14.1269C14.3517 11.0295 14.5674 10.9401 14.7264 10.7811C14.8854 10.6221 14.9747 10.4065 14.9747 10.1816C14.9747 9.95673 14.8854 9.74107 14.7264 9.58207C14.5674 9.42306 14.3517 9.33373 14.1269 9.33373H4.51767C4.2928 9.33373 4.07714 9.42306 3.91814 9.58207C3.75913 9.74108 3.6698 9.95674 3.6698 10.1816ZM4.51767 4.81176C4.2928 4.81176 4.07714 4.90109 3.91814 5.0601C3.75913 5.21911 3.6698 5.43477 3.6698 5.65963C3.6698 5.8845 3.75913 6.10016 3.91814 6.25916C4.07715 6.41817 4.29281 6.5075 4.51767 6.5075H14.1269C14.3517 6.5075 14.5674 6.41817 14.7264 6.25916C14.8854 6.10015 14.9747 5.88449 14.9747 5.65963C14.9747 5.43476 14.8854 5.2191 14.7264 5.0601C14.5674 4.90109 14.3517 4.81176 14.1269 4.81176H4.51767ZM15.8226 0.298828C16.4671 0.298748 17.0877 0.543348 17.5588 0.983198C18.0299 1.42305 18.3165 2.02534 18.3606 2.66835L18.3662 2.84245V18.1018C18.366 18.7462 18.1213 19.3664 17.6815 19.8373C17.2416 20.3082 16.6395 20.5946 15.9967 20.6387L15.8226 20.6443H2.82193C2.17741 20.6444 1.55688 20.3998 1.08577 19.96C0.61466 19.5201 0.32809 18.9178 0.28397 18.2748L0.27832 18.1018V2.84245C0.27824 2.19793 0.52284 1.5774 0.96269 1.10629C1.40254 0.635178 2.00483 0.348608 2.64784 0.304488L2.82194 0.298838L15.8226 0.298828Z"
        }
      )
    }
  );
}
function Ah(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M0.535394 0.862247C0.535394 0.75915 0.619218 0.675638 0.721353 0.675638H19.443C19.5455 0.675638 19.6292 0.759223 19.6292 0.862247V13.4278C19.6292 13.5308 19.5455 13.6144 19.443 13.6144H0.721353C0.619218 13.6144 0.535394 13.5309 0.535394 13.4278V0.862247ZM0.721353 14.2511H19.443C19.8964 14.2511 20.2646 13.8816 20.2646 13.4278V0.862247C20.2646 0.408374 19.8964 0.0389313 19.443 0.0389313H0.721353C0.26825 0.0389313 -0.1 0.408403 -0.1 0.862247V13.4278C-0.1 13.8816 0.26825 14.2511 0.721353 14.2511ZM17.3582 8.55702C17.3582 8.38228 17.2172 8.23931 17.0414 8.23931C16.866 8.23931 16.7251 8.38248 16.7251 8.55702V11.8459C16.7251 12.0206 16.8662 12.1633 17.0414 12.1633C17.217 12.1633 17.3582 12.0208 17.3582 11.8459V8.55702ZM16.1986 8.55702C16.1986 8.38218 16.0571 8.23931 15.8817 8.23931C15.7066 8.23931 15.5651 8.38228 15.5651 8.55702V11.8459C15.5651 12.0208 15.7067 12.1633 15.8817 12.1633C16.0569 12.1633 16.1986 12.0209 16.1986 11.8459V8.55702ZM15.0389 8.55702C15.0389 8.38199 14.8969 8.23931 14.7217 8.23931C14.5466 8.23931 14.4052 8.38228 14.4052 8.55702V11.8459C14.4052 12.0208 14.5468 12.1633 14.7217 12.1633C14.8967 12.1633 15.0389 12.0211 15.0389 11.8459V8.55702ZM13.879 8.55702C13.879 8.38199 13.7369 8.23931 13.5618 8.23931C13.3866 8.23931 13.2452 8.38228 13.2452 8.55702V11.8459C13.2452 12.0208 13.3868 12.1633 13.5618 12.1633C13.7367 12.1633 13.879 12.0211 13.879 11.8459V8.55702ZM12.719 8.55702C12.719 8.38209 12.5774 8.23931 12.4018 8.23931C12.2269 8.23931 12.0855 8.38238 12.0855 8.55702V11.8459C12.0855 12.0207 12.227 12.1633 12.4018 12.1633C12.5772 12.1633 12.719 12.021 12.719 11.8459V8.55702ZM11.5593 8.55702C11.5593 8.38199 11.4173 8.23931 11.2421 8.23931C11.0674 8.23931 10.9256 8.38218 10.9256 8.55702V11.8459C10.9256 12.0209 11.0676 12.1633 11.2421 12.1633C11.4171 12.1633 11.5593 12.0211 11.5593 11.8459V8.55702ZM10.3994 8.55702C10.3994 8.38209 10.2574 8.23931 10.0825 8.23931C9.90752 8.23931 9.76559 8.38209 9.76559 8.55702V11.8459C9.76559 12.021 9.90771 12.1633 10.0825 12.1633C10.2572 12.1633 10.3994 12.021 10.3994 11.8459V8.55702ZM9.2394 8.55702C9.2394 8.38209 9.09746 8.23931 8.92251 8.23931C8.74755 8.23931 8.60561 8.38209 8.60561 8.55702V11.8459C8.60561 12.021 8.74774 12.1633 8.92251 12.1633C9.09727 12.1633 9.2394 12.021 9.2394 11.8459V8.55702ZM8.07942 8.55702C8.07942 8.38218 7.93791 8.23931 7.76253 8.23931C7.58738 8.23931 7.44596 8.38228 7.44596 8.55702V11.8459C7.44596 12.0208 7.58757 12.1633 7.76253 12.1633C7.93772 12.1633 8.07942 12.0209 8.07942 11.8459V8.55702ZM6.91977 8.55702C6.91977 8.38218 6.77826 8.23931 6.60288 8.23931C6.42792 8.23931 6.28599 8.38209 6.28599 8.55702V11.8459C6.28599 12.021 6.42812 12.1633 6.60288 12.1633C6.77806 12.1633 6.91977 12.0209 6.91977 11.8459V8.55702ZM5.7598 8.55702C5.7598 8.38218 5.61828 8.23931 5.44291 8.23931C5.26795 8.23931 5.12602 8.38209 5.12602 8.55702V11.8459C5.12602 12.021 5.26814 12.1633 5.44291 12.1633C5.61809 12.1633 5.7598 12.0209 5.7598 11.8459V8.55702ZM4.59982 8.55702C4.59982 8.38218 4.45831 8.23931 4.28293 8.23931C4.10778 8.23931 3.96636 8.38228 3.96636 8.55702V11.8459C3.96636 12.0208 4.10797 12.1633 4.28293 12.1633C4.45812 12.1633 4.59982 12.0209 4.59982 11.8459V8.55702ZM3.43985 8.55702C3.43985 8.38218 3.29833 8.23931 3.12296 8.23931C2.94761 8.23931 2.80671 8.38248 2.80671 8.55702V11.8459C2.80671 12.0206 2.94781 12.1633 3.12296 12.1633C3.29814 12.1633 3.43985 12.0209 3.43985 11.8459V8.55702Z",
          strokeWidth: "0.2"
        }
      )
    }
  );
}
function BS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2505 0.456055L19.5374 3.60469L10.7068 6.77941L2.83755 3.65222L11.2505 0.456055ZM1.72305 4.28464L9.99009 7.57033L8.83806 9.69065L0.5 6.48277L1.72305 4.28464ZM2.24525 8.21085L8.90716 10.7799C8.96625 10.8025 9.01829 10.813 9.07738 10.813C9.25659 10.813 9.47687 10.7178 9.56552 10.5515L10.3072 9.2786V18.8893L2.2452 15.6045L2.24525 8.21085ZM20.1598 15.5903L11.2022 18.9163V8.906L12.5145 10.7952C12.6085 10.9314 12.7633 11.0085 12.923 11.0085C12.9821 11.0085 13.0302 10.9975 13.0886 10.9759L20.1605 8.25098L20.1598 15.5903ZM13.1075 9.90308L11.4807 7.56424L20.7486 4.2319L22 6.48301L13.1075 9.90308Z"
        }
      )
    }
  );
}
function ZS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M4 6h16M4 12h16M4 18h16" })
    }
  );
}
function GS(e) {
  return /* @__PURE__ */ s.jsxs("svg", { width: "50", height: "44", viewBox: "0 0 50 44", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsx("path", { d: "M49.1668 42.5445C48.7855 43.3785 48.1247 43.6158 47.2339 43.6143C35.0091 43.5954 22.7829 43.6012 10.5582 43.6012C9.24093 43.6012 8.7417 43.0991 8.7417 41.7731C8.7417 40.4806 8.7417 39.1867 8.7417 37.8389H9.33845C19.1311 37.8389 28.9251 37.8301 38.7178 37.8476C40.1456 37.8505 41.326 37.3862 42.3463 36.3979C45.1453 33.6849 47.1873 30.4638 48.7753 26.9313C48.8976 26.6577 49.0358 26.3913 49.1668 26.1221V42.5445Z" }),
    /* @__PURE__ */ s.jsx("path", { d: "M49.1668 9.02718H8.78095C8.7664 8.89764 8.74311 8.79283 8.74311 8.68658C8.7402 7.39118 8.73729 6.09434 8.74311 4.79894C8.74747 3.85868 9.33259 3.27066 10.2714 3.26775C12.4474 3.26193 14.6233 3.26629 16.7993 3.26629C16.9725 3.26629 17.1472 3.26629 17.3844 3.26629C17.3844 2.79616 17.3801 2.35516 17.3844 1.91268C17.3946 1.01464 17.9899 0.385863 18.8225 0.385863C19.6536 0.385863 20.2503 1.01464 20.2634 1.91268C20.2692 2.34206 20.2634 2.77288 20.2634 3.23427H27.4652C27.4652 2.78452 27.4609 2.34204 27.4652 1.89811C27.4769 1.00735 28.0838 0.378586 28.9178 0.385863C29.7329 0.393141 30.3268 1.01171 30.3428 1.87919C30.3515 2.32312 30.3442 2.76852 30.3442 3.23864H37.6421C37.6421 2.81218 37.6392 2.37117 37.6421 1.93161C37.6509 1.02628 38.2316 0.396052 39.0627 0.385863C39.9156 0.375675 40.5124 1.01027 40.5226 1.94179C40.5269 2.35806 40.5226 2.77288 40.5226 3.26629C40.7045 3.26629 40.8719 3.26629 41.0393 3.26629C43.1192 3.26629 45.1991 3.29541 47.279 3.2532C48.1625 3.23427 48.7985 3.50354 49.1653 4.32299V9.02864L49.1668 9.02718Z" }),
    /* @__PURE__ */ s.jsx("path", { d: "M49.1041 11.944C49.0109 15.2495 48.5364 18.4531 47.6165 21.5809C46.3051 26.0406 44.25 30.1029 41.093 33.5626C41.0828 33.5743 41.0697 33.5859 41.061 33.5975C40.275 34.6179 39.2954 34.9963 37.9564 34.9905C25.8772 34.9366 13.7965 34.957 1.71727 34.9643C1.07976 34.9643 0.545593 34.8129 0.205006 34.2365C-0.137037 33.6572 -0.0497101 32.9761 0.456805 32.4797C4.68795 28.3257 6.95999 23.1718 8.05599 17.4444C8.3762 15.7706 8.46644 14.0516 8.66293 12.3545C8.67748 12.2293 8.68913 12.1041 8.70514 11.9455H49.107L49.1041 11.944Z" })
  ] });
}
function Eh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.9039 2.72621H18.3769V1.35165C18.3769 0.59564 17.7813 0 17.0253 0C16.2693 0 15.6736 0.59564 15.6736 1.35165V2.72621H12.3518V1.35165C12.3518 0.59564 11.7561 0 11.0001 0C10.2441 0 9.64848 0.59564 9.64848 1.35165V2.72621H6.32663V1.35165C6.32663 0.59564 5.73099 0 4.97498 0C4.21897 0 3.62333 0.59564 3.62333 1.35165V2.72621H3.09642C1.46986 2.72621 0.141113 4.05495 0.141113 5.68151V18.8086C0.141113 20.4351 1.46985 21.7639 3.09642 21.7639H18.9039C20.5304 21.7639 21.8592 20.4351 21.8592 18.8086V5.68151C21.8592 4.05495 20.5304 2.72621 18.9039 2.72621H18.9039ZM18.9039 19.7937H3.0964C2.54658 19.7937 2.1113 19.3584 2.1113 18.8086V8.79719H19.889V18.8086C19.889 19.3584 19.4537 19.7937 18.9039 19.7937Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 10.767H4.53961C4.33343 10.767 4.15015 10.9502 4.15015 11.1564V12.8975C4.15015 13.1037 4.33343 13.287 4.53961 13.287H7.26582C7.472 13.287 7.65528 13.1037 7.65528 12.8975V11.1564C7.65528 10.9502 7.472 10.767 7.26582 10.767Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 10.767H9.62554C9.41936 10.767 9.23608 10.9502 9.23608 11.1564V12.8975C9.23608 13.1037 9.41936 13.287 9.62554 13.287H12.3747C12.5809 13.287 12.7641 13.1037 12.7641 12.8975V11.1564C12.7641 10.9502 12.5809 10.767 12.3747 10.767Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 10.767H14.7347C14.5285 10.767 14.3452 10.9502 14.3452 11.1564V12.8975C14.3452 13.1037 14.5285 13.287 14.7347 13.287H17.4609C17.6671 13.287 17.8504 13.1037 17.8504 12.8975V11.1564C17.8733 10.9502 17.69 10.767 17.4838 10.767H17.4838Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 15.281H4.53961C4.33343 15.281 4.15015 15.4643 4.15015 15.6705V17.4116C4.15015 17.6178 4.33343 17.801 4.53961 17.801H7.26582C7.472 17.801 7.65528 17.6178 7.65528 17.4116V15.6705C7.65528 15.4643 7.472 15.281 7.26582 15.281Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 15.281H9.62554C9.41936 15.281 9.23608 15.4643 9.23608 15.6705V17.4116C9.23608 17.6178 9.41936 17.801 9.62554 17.801H12.3747C12.5809 17.801 12.7641 17.6178 12.7641 17.4116V15.6705C12.7641 15.4643 12.5809 15.281 12.3747 15.281Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 15.281H14.7347C14.5285 15.281 14.3452 15.4643 14.3452 15.6705V17.4116C14.3452 17.6178 14.5285 17.801 14.7347 17.801H17.4609C17.6671 17.801 17.8504 17.6178 17.8504 17.4116V15.6705C17.8733 15.4643 17.69 15.281 17.4838 15.281H17.4838Z"
          }
        )
      ]
    }
  );
}
function KS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M16.625 4.375H15.75V2.625C15.75 2.39294 15.6578 2.17038 15.4937 2.00628C15.3296 1.84219 15.1071 1.75 14.875 1.75C14.6429 1.75 14.4204 1.84219 14.2563 2.00628C14.0922 2.17038 14 2.39294 14 2.625V4.375H7V2.625C7 2.39294 6.90781 2.17038 6.74372 2.00628C6.57962 1.84219 6.35707 1.75 6.125 1.75C5.89294 1.75 5.67038 1.84219 5.50628 2.00628C5.34219 2.17038 5.25 2.39294 5.25 2.625V4.375H4.375C3.67881 4.375 3.01113 4.65156 2.51884 5.14385C2.02656 5.63613 1.75 6.30381 1.75 7V7.875H19.25V7C19.25 6.30381 18.9734 5.63613 18.4812 5.14385C17.9889 4.65156 17.3212 4.375 16.625 4.375Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1.75 16.625C1.75 17.3212 2.02656 17.9889 2.51884 18.4812C3.01113 18.9734 3.67881 19.25 4.375 19.25H16.625C17.3212 19.25 17.9889 18.9734 18.4812 18.4812C18.9734 17.9889 19.25 17.3212 19.25 16.625V9.625H1.75V16.625Z",
            fill: "rgb(var(--text-tertiary))"
          }
        )
      ]
    }
  );
}
function zS(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { "clip-path": "url(#clip0_266003_10873)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M0 5.33333V4.66667C0 2.82867 1.49533 1.33333 3.33333 1.33333H4V0.666667C4 0.298667 4.298 0 4.66667 0C5.03533 0 5.33333 0.298667 5.33333 0.666667V1.33333H10.6667V0.666667C10.6667 0.298667 10.9647 0 11.3333 0C11.702 0 12 0.298667 12 0.666667V1.33333H12.6667C14.5047 1.33333 16 2.82867 16 4.66667V5.33333H0ZM16 6.66667V12.6667C16 14.5047 14.5047 16 12.6667 16H3.33333C1.49533 16 0 14.5047 0 12.6667V6.66667H16ZM11.888 8.768C11.632 8.50333 11.2107 8.49533 10.9453 8.75067L7.776 11.8053C7.52533 12.056 7.10467 12.0747 6.81667 11.788L5.298 10.3767C5.02933 10.1267 4.608 10.1407 4.356 10.4113C4.10533 10.6807 4.12067 11.1027 4.39067 11.3533L5.892 12.748C6.26933 13.126 6.772 13.334 7.306 13.334C7.84 13.334 8.34333 13.126 8.71133 12.7567L11.8713 9.71133C12.136 9.456 12.144 9.03267 11.888 8.768Z",
            fill: "rgb(var(--brand-primary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_266003_10873", children: /* @__PURE__ */ s.jsx("rect", { width: "16", height: "16", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function US(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "39",
      height: "41",
      viewBox: "0 0 39 41",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          stroke: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75104 30.9259C3.49183 32.3519 4.57216 33.6915 6.04127 33.7345L7.29422 33.7776C8.3314 33.8208 9.2387 34.5122 9.49796 35.506L9.84369 36.7159C10.2325 38.0988 11.7881 38.8333 13.1277 38.2715L14.2945 37.7962C15.2451 37.4073 16.3685 37.6234 17.06 38.4011L17.8811 39.3518C18.8318 40.432 20.5602 40.432 21.5108 39.3087L22.3319 38.358C23.0234 37.5804 24.1037 37.3208 25.0543 37.71L26.2211 38.1853C27.5605 38.7471 29.0731 38.0126 29.4619 36.5866L29.8077 35.3766C30.0669 34.3829 30.9745 33.6483 32.0114 33.6049L33.2644 33.5184C34.6904 33.4319 35.7706 32.0924 35.5115 30.6663L35.2954 29.4564C35.1227 28.4192 35.598 27.4255 36.5053 26.907L37.5856 26.302C38.8385 25.6106 39.2277 23.9253 38.3632 22.7585L37.6286 21.7647C37.0237 20.9437 37.0237 19.7769 37.6286 18.9561L38.3632 17.919C39.1843 16.7522 38.7954 15.0669 37.5421 14.4189L36.4618 13.814C35.5542 13.3386 35.0358 12.3014 35.2088 11.3077L35.425 10.0978C35.6842 8.67181 34.6038 7.33225 33.1348 7.28918L31.8818 7.24609C30.8446 7.20298 29.9373 6.51153 29.6781 5.51779L29.3324 4.30787C28.9435 2.92494 27.3879 2.19043 26.0483 2.75225L24.7089 3.22728C23.7582 3.61611 22.6348 3.39999 21.9433 2.62233L21.1222 1.67168C20.1716 0.634518 18.4863 0.634518 17.5357 1.75819L16.7146 2.70885C16.0231 3.4865 14.9428 3.74601 13.9922 3.3569L12.8254 2.88156C11.4859 2.31971 9.97333 3.05427 9.5845 4.48031L9.23878 5.69024C8.97954 6.68402 8.07199 7.41855 7.03505 7.46199L5.78207 7.5485C4.35608 7.635 3.27581 8.97448 3.53499 10.4005L3.75111 11.6105C3.92384 12.6476 3.44847 13.6414 2.54119 14.1599L1.46091 14.7648C0.207928 15.4563 -0.181202 17.1415 0.683258 18.3083L1.4178 19.3021C2.02277 20.1232 2.02277 21.29 1.4178 22.1107L0.683258 23.1478C-0.137842 24.3146 0.250988 25.9999 1.50435 26.6479L2.58465 27.2529C3.49224 27.7282 4.01062 28.7654 3.83761 29.7591L3.75104 30.9259ZM13.6897 17.5736L17.1033 20.9871L25.2702 12.8634L28.8138 16.4069L17.1034 28.1172L10.1464 21.1601L13.6897 17.5736Z"
        }
      )
    }
  );
}
function YS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "m220.605 223.843 17.572 42.263c1.826 4.391-.047 9.413-4.275 11.588l-13.193 6.788c-2.356 1.212-4.842 1.366-7.33.452-2.487-.913-4.273-2.643-5.295-5.088l-19.792-47.344zm110.586 127.108 153.707 133.211c.703-2.038 1.104-4.217 1.104-6.491v-252.776c0-2.264-.391-4.425-1.08-6.444zm-74.592 37.883 213.02-183.599c-1.179-.212-2.377-.344-3.618-.344h-53.133c.598 18.815-11.841 36.455-30.734 41.517-17.189 4.606-35.09-2.386-44.868-16.468-29.454-11.333-64.949-14.304-97.498-12.101l16.876 40.589c5.806 13.965-.155 30.137-13.593 37.051l-13.193 6.788c-7.32 3.766-15.646 4.279-23.373 1.442-7.712-2.832-13.686-8.571-16.853-16.148l-21.111-50.499c-26.019 2.978-51.466-10.005-64.611-32.171h-57.91c-.038 0-.071 0-.109 0zm6.491 20.821 52.789-45.501 153.683 133.178c-1.151.212-2.344.34-3.561.34h-420.002c-.019 0-.028 0-.047 0l152.037-133.461 52.001 45.393c1.882 1.651 4.222 2.467 6.571 2.467 2.331-.001 4.647-.807 6.529-2.416zm-80.299-58.704-154.632 135.72c-1.368-2.708-2.161-5.76-2.161-9v-252.776c0-3.222.783-6.25 2.142-8.953zm239.163-192.676 31.43 8.421c5.027 1.347 10.196-1.669 11.53-6.692 1.337-5.03-1.674-10.191-6.695-11.536l-31.43-8.421c-5.027-1.347-10.196 1.669-11.53 6.692-1.338 5.03 1.673 10.191 6.695 11.536zm-15.133-92.75 23.008-23.008c3.676-3.676 3.703-9.65.03-13.338-3.668-3.683-9.651-3.711-13.332-.03l-23.008 23.008c-3.676 3.676-3.703 9.65-.03 13.338 3.668 3.683 9.651 3.711 13.332.03zm27.627 42.348 29.795-7.984c5.058-1.355 8.059-6.553 6.704-11.611s-6.553-8.059-11.611-6.704l-29.796 7.984c-5.058 1.355-8.059 6.553-6.704 11.611 1.356 5.058 6.554 8.059 11.612 6.704zm-58.589 31.999c1.124-.144 2.252-.364 3.377-.666 13.58-3.639 21.639-17.597 18-31.177s-17.597-21.638-31.177-18c-1.126.302-2.213.675-3.258 1.112l-16.31-60.871c-3.062-11.428-14.918-18.273-26.346-15.211-10.645 2.852-17.458 13.431-15.653 24.3l-.001.001c-19.951 27.108-53.807 53.739-95.437 73.025l23.036 85.971c45.714-4.068 88.418 2.246 119.251 15.747h.001c3.916 10.071 14.952 15.841 25.616 12.984 11.382-3.05 18.261-14.965 15.211-26.346zm-162.663 65.251-40.352 10.812c-24.519 6.57-49.955-8.116-56.525-32.634v-.001c-6.57-24.518 8.116-49.955 32.635-56.525l40.352-10.812c7.963 29.72 15.924 59.44 23.89 89.16z",
          fillRule: "evenodd"
        }
      )
    }
  );
}
function WS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx("path", { d: "m305.617 219.523-15.899-15.631-33.724 22.375-30.764-20.132-183.555 180.456 194.225.117c-2.664-11.357-4.078-23.191-4.078-35.349.001-55.673 29.555-104.567 73.795-131.836z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m333.964 205.721c16.358-5.898 33.983-9.121 52.349-9.121 41.351 0 80.177 16.121 109.326 45.394 5.976 6.002 11.391 12.417 16.238 19.171l.123-204.927-197.083 130.757z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m.196 58.92-.196 326.637 199.549-196.18z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m489.696 35.165-471.371-.283 237.682 152.555z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m386.582 225.601c-69.344 0-125.759 56.415-125.759 125.759s56.415 125.759 125.759 125.759c33.583 0 65.11-13.089 88.777-36.856 23.628-23.73 36.641-55.303 36.641-88.904 0-33.6-13.013-65.173-36.641-88.902-23.667-23.767-55.195-36.856-88.777-36.856zm53.931 140.748h-107.864v-29.98h107.865v29.98z" })
      ] })
    }
  );
}
function Ih(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M22.3346 26.8581C22.5382 26.7636 22.7637 26.7709 22.9673 26.8727L24.4946 27.6363V24.8218H20.5601V27.68L22.3346 26.8581Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M37.2945 37.92C36.8218 37.6727 36.2909 37.6291 35.8109 37.8036L25.7164 41.4254C25.2218 41.7018 24.6473 41.8545 24.0436 41.8545H17.9564C17.5564 41.8545 17.2291 41.5273 17.2291 41.1273C17.2291 40.7273 17.5564 40.4 17.9564 40.4H24.0436C24.3855 40.4 24.72 40.3127 25.0036 40.1673C25.04 40.1454 25.0764 40.1236 25.1127 40.1018C25.5418 39.8327 25.8545 39.4109 25.9345 38.9236C26.0218 38.3854 25.8764 37.8691 25.5345 37.4691C25.1927 37.0691 24.6982 36.8436 24.1745 36.8436H19.6291C18.2982 36.8436 16.9673 36.3636 15.8836 35.4982C14.1091 34.08 10.4364 32.1891 5.58545 35.1491V43.9782C6.82909 43.9854 9.43272 44.2109 13.0545 45.6291C16.4509 46.96 20.0655 47.2654 23.5127 46.5163C27.0473 45.7454 32.3345 44.1818 37.3964 41.0763C37.7964 40.8291 38.0945 40.4145 38.2036 39.9345C38.3927 39.1345 38.0145 38.3054 37.2945 37.92Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M19.6293 35.3746H24.1748C25.1275 35.3746 26.022 35.7891 26.6402 36.5164C27.2584 37.2436 27.5202 38.2036 27.3675 39.1491C27.3602 39.2 27.3529 39.2436 27.3384 39.2946L32.3129 37.5127V26.0218C32.3129 25.36 31.7748 24.8291 31.1202 24.8291H25.942V28.8218C25.942 29.0764 25.8111 29.3091 25.6002 29.44C25.4839 29.5127 25.3529 29.5491 25.2148 29.5491C25.1057 29.5491 24.9893 29.52 24.8875 29.4691L22.6184 28.3346L20.1239 29.4836C19.8984 29.5855 19.6366 29.5709 19.4257 29.4327C19.2148 29.3018 19.0911 29.0691 19.0911 28.8218V24.8291H13.9129C13.2511 24.8291 12.7202 25.3673 12.7202 26.0218V32.3418C14.4657 32.7491 15.8548 33.6073 16.7857 34.3564C17.6293 35.0255 18.6111 35.3746 19.6293 35.3746Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M4.13102 32.7419L1.0183 32.6982L0.981934 45.8764L4.08739 45.9201L4.13102 45.8764V32.7419Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M25.782 10.9455C25.2147 10.611 24.5674 10.4219 23.8911 10.4219C21.8329 10.4219 20.1602 12.0946 20.1602 14.1528C20.1602 16.211 21.8329 17.8837 23.8911 17.8837C24.9529 17.8837 25.942 17.4255 26.6402 16.6619C26.0292 16.4873 25.4765 16.1382 25.0692 15.6437C24.0583 14.4219 24.182 12.5528 25.3456 11.3819L25.782 10.9455Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M32.3783 5.76718C32.4874 6.03627 32.4292 6.349 32.2183 6.55991L26.371 12.4072C25.731 13.0472 25.651 14.0581 26.1892 14.7126C26.4946 15.0835 26.9237 15.3017 27.3965 15.3235C27.8692 15.3526 28.3201 15.1708 28.6546 14.8363L33.5055 9.98536C33.7892 9.70173 34.2474 9.70173 34.531 9.98536C35.5201 10.9599 36.8292 11.4545 38.2183 11.469C39.5055 11.4472 40.7128 10.9526 41.6437 10.0726V1.09082H29.0401C27.8183 1.09082 26.6619 1.57082 25.7965 2.43627L22.9092 5.32355H31.7092C32.0001 5.31627 32.2692 5.49809 32.3783 5.76718Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M14.0222 15.6434C14.8456 15.6434 15.5131 14.9759 15.5131 14.1525C15.5131 13.3291 14.8456 12.6616 14.0222 12.6616C13.1988 12.6616 12.5312 13.3291 12.5312 14.1525C12.5312 14.9759 13.1988 15.6434 14.0222 15.6434Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M43.1055 1.09082H47.0255V9.64355H43.1055V1.09082Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M34.0584 11.4983L29.6875 15.8692C29.3384 16.2183 28.902 16.4655 28.4366 16.6183C27.5347 18.2765 25.7966 19.3383 23.8911 19.3383C21.0329 19.3383 18.7057 17.011 18.7057 14.1528C18.7057 11.2946 21.0329 8.96736 23.8911 8.96736C24.9457 8.96736 25.9711 9.29463 26.8293 9.891L29.9493 6.771H9.82565C9.55656 6.771 9.33838 6.98918 9.33838 7.25827V21.0328C9.33838 21.3019 9.55656 21.5201 9.82565 21.5201H37.9638C38.2329 21.5201 38.4511 21.3019 38.4511 21.0328V12.9019C38.3784 12.9019 38.3129 12.9165 38.2402 12.9165C36.7057 12.9165 35.2438 12.4437 34.0584 11.4983ZM14.022 17.0983C12.4002 17.0983 11.0766 15.7746 11.0766 14.1528C11.0766 12.531 12.4002 11.2074 14.022 11.2074C15.6438 11.2074 16.9675 12.531 16.9675 14.1528C16.9675 15.7746 15.6438 17.0983 14.022 17.0983Z" })
      ]
    }
  );
}
function $S(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "19",
      height: "18",
      viewBox: "0 0 512 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "currentColor",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M475.312 148.688L379.312 52.688C374.736 48.112 367.872 46.768 361.872 49.216C355.888 51.696 352 57.536 352 64V112H112C85.488 112 64 133.488 64 160C64 186.512 85.488 208 112 208H352V256C352 262.464 355.888 268.304 361.872 270.784C367.888 273.264 374.752 271.872 379.312 267.312L475.312 171.312C481.568 165.072 481.568 154.928 475.312 148.688Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M400 304H160V256C160 249.536 156.112 243.696 150.128 241.216C144.144 238.736 137.28 240.096 132.688 244.688L36.6881 340.688C30.4481 346.928 30.4481 357.072 36.6881 363.312L132.688 459.312C137.248 463.872 144.112 465.264 150.128 462.784C156.112 460.304 160 454.464 160 448V400H400C426.512 400 448 378.512 448 352C448 325.488 426.512 304 400 304Z" })
      ]
    }
  );
}
function Dh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "13",
      height: "10",
      viewBox: "0 0 13 10",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--background-secondary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.39016 9.4496L0.189285 5.24872C-0.063095 4.99635 -0.063095 4.58713 0.189285 4.33472L1.10326 3.42073C1.35564 3.16832 1.76487 3.16832 2.01725 3.42073L4.84717 6.25063L10.9085 0.189285C11.1609 -0.063095 11.5701 -0.063095 11.8225 0.189285L12.7365 1.10327C12.9889 1.35565 12.9889 1.76487 12.7365 2.01727L5.30415 9.44963C5.05174 9.70201 4.64254 9.70201 4.39016 9.4496Z"
        }
      )
    }
  );
}
function Nh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
        }
      )
    }
  );
}
function JS({ isSelected: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      fill: "rgb(var(--fill-primary))",
      children: e ? /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
        }
      ) : /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
          fill: "transparent",
          stroke: "rgb(var(--fill-primary))",
          strokeWidth: "2"
        }
      )
    }
  );
}
function Rh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "16",
      height: "13",
      viewBox: "0 0 16 13",
      fill: "none",
      stroke: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function qS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: "2",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { id: "Icon", children: [
        /* @__PURE__ */ s.jsx("path", { d: "m16.75 2.5v2c0 .69-.56 1.25-1.25 1.25h-7c-.332 0-.649-.132-.884-.366-.234-.235-.366-.552-.366-.884v-2c0-.69.56-1.25 1.25-1.25h7c.332 0 .649.132.884.366.234.235.366.552.366.884z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m17.75 2.759c1.678.128 3 1.53 3 3.241v13.5c0 .862-.342 1.689-.952 2.298-.609.61-1.436.952-2.298.952h-11c-.862 0-1.689-.342-2.298-.952-.61-.609-.952-1.436-.952-2.298v-13.5c0-1.711 1.322-3.113 3-3.241v1.741c0 .597.237 1.169.659 1.591s.994.659 1.591.659h7c1.243 0 2.25-1.007 2.25-2.25zm-4.75 7.991h4c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75s.336.75.75.75zm0 6h4c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75s.336.75.75.75zm0 2.5h1.571c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.571c-.414 0-.75.336-.75.75s.336.75.75.75zm0-6h1.571c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.571c-.414 0-.75.336-.75.75s.336.75.75.75zm-2.25 3.25c0-.332-.132-.649-.366-.884-.235-.234-.552-.366-.884-.366h-2c-.332 0-.649.132-.884.366-.234.235-.366.552-.366.884v2c0 .332.132.649.366.884.235.234.552.366.884.366h2c.332 0 .649-.132.884-.366.234-.235.366-.552.366-.884zm-3 .25h1.5v1.5h-1.5zm-1.28-5.22 1 1c.293.293.767.293 1.06 0l2-2c.293-.292.293-.768 0-1.06-.292-.293-.768-.293-1.06 0l-1.47 1.469-.47-.469c-.292-.293-.768-.293-1.06 0-.293.292-.293.768 0 1.06z" })
      ] })
    }
  );
}
function QS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "9",
      height: "5",
      viewBox: "0 0 9 5",
      fill: "CurrentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.54022 0.210728C8.297 -0.0324822 7.90225 -0.0324822 7.65841 0.210728L4.79847 3.07067C4.55214 3.30702 4.163 3.30702 3.91667 3.07067L1.05673 0.210728C0.809153 -0.0287422 0.414402 -0.0218822 0.174922 0.226318C-0.0583075 0.467658 -0.0583075 0.850568 0.174922 1.09253L3.03424 3.95247C3.7645 4.68336 4.94939 4.68336 5.68028 3.95247V3.95247L8.54022 1.09253C8.78343 0.848688 8.78343 0.453938 8.54022 0.210718V0.210728Z"
        }
      )
    }
  );
}
function XS(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M14.032 7.58875C14.032 11.0105 11.2581 13.7844 7.83631 13.7844C4.41453 13.7844 1.64062 11.0105 1.64062 7.58875C1.64062 4.16697 4.41453 1.39307 7.83631 1.39307C11.2581 1.39307 14.032 4.16697 14.032 7.58875Z",
          stroke: "CurrentColor",
          strokeWidth: "1.5"
        }
      )
    }
  );
}
function Fh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1719 0C4.92404 0 0.671875 4.25216 0.671875 9.5C0.671875 14.7478 4.92404 19 10.1719 19C15.4197 19 19.6719 14.7478 19.6719 9.5C19.6719 4.25216 15.4197 0 10.1719 0ZM12.5788 12.9392L10.1719 10.5322L7.7649 12.9392C7.48173 13.2224 7.01586 13.2224 6.7327 12.9392C6.5911 12.7976 6.51803 12.6103 6.51803 12.4231C6.51803 12.2358 6.59111 12.0486 6.7327 11.907L9.13966 9.5L6.7327 7.09303C6.5911 6.95144 6.51803 6.76418 6.51803 6.57692C6.51803 6.38966 6.59111 6.2024 6.7327 6.06081C7.01586 5.77764 7.48173 5.77764 7.7649 6.06081L10.1719 8.46778L12.5788 6.06081C12.862 5.77764 13.3279 5.77764 13.6111 6.06081C13.8942 6.34398 13.8942 6.80985 13.6111 7.09302L11.2041 9.49999L13.6111 11.907C13.8942 12.1901 13.8942 12.656 13.6111 12.9392C13.3279 13.2269 12.862 13.2269 12.5788 12.9392V12.9392Z"
        }
      )
    }
  );
}
function ek(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "26",
      height: "20",
      viewBox: "0 0 26 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--brand-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M23.7148 0.859375H2.28516C1.02771 0.859375 0 1.88257 0 3.14453V16.8555C0 18.1179 1.02837 19.1406 2.28516 19.1406H23.7148C24.9723 19.1406 26 18.1174 26 16.8555V3.14453C26 1.88226 24.9718 0.859375 23.7148 0.859375ZM23.3639 2.38281C22.6251 3.12407 13.9468 11.8307 13.5903 12.1884C13.2925 12.4871 12.7077 12.4873 12.4097 12.1884L2.63605 2.38281H23.3639ZM1.52344 16.5754V3.42459L8.07752 10L1.52344 16.5754ZM2.63605 17.6172L9.15302 11.079L11.3308 13.2639C12.2232 14.1592 13.7772 14.1588 14.6693 13.2639L16.847 11.0791L23.3639 17.6172H2.63605ZM24.4766 16.5754L17.9225 10L24.4766 3.42459V16.5754Z" })
    }
  );
}
function tk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "CurrentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M10 0.25C8.3067 0.249871 6.64255 0.690745 5.17141 1.52921C3.70026 2.36768 2.47285 3.57483 1.61001 5.03182C0.747172 6.4888 0.278662 8.14538 0.250606 9.83846C0.222551 11.5315 0.635918 13.2027 1.45001 14.6875L0.653133 17.5C0.578795 17.7563 0.574616 18.0278 0.641033 18.2863C0.70745 18.5447 0.842028 18.7806 1.03072 18.9693C1.21941 19.158 1.45529 19.2926 1.71374 19.359C1.97219 19.4254 2.24373 19.4212 2.50001 19.3469L5.31251 18.55C6.6159 19.2644 8.06537 19.6713 9.55012 19.7397C11.0349 19.8081 12.5156 19.5361 13.8791 18.9445C15.2427 18.353 16.4529 17.4575 17.4174 16.3266C18.3818 15.1956 19.0749 13.8592 19.4437 12.4193C19.8125 10.9795 19.8473 9.47439 19.5453 8.01906C19.2433 6.56374 18.6126 5.19672 17.7014 4.02249C16.7901 2.84826 15.6225 1.8979 14.2877 1.24406C12.9529 0.590223 11.4863 0.250206 10 0.25V0.25Z",
          fillOpacity: "0.3"
        }
      )
    }
  );
}
function ak(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Composant_127_2",
      "data-name": "Composant 127 – 2",
      xmlns: "http://www.w3.org/2000/svg",
      width: "35",
      height: "35",
      viewBox: "0 0 35 35",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { id: "Groupe_3402", "data-name": "Groupe 3402", transform: "translate(-863 -1502)", children: [
        /* @__PURE__ */ s.jsx(
          "circle",
          {
            id: "Ellipse_2975",
            "data-name": "Ellipse 2975",
            cx: "17.5",
            cy: "17.5",
            r: "17.5",
            transform: "translate(863 1502)",
            fill: "rgb(var(--background-primary))"
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { id: "Groupe_2819", "data-name": "Groupe 2819", transform: "translate(493.176 1350.037)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22384",
              "data-name": "Tracé 22384",
              d: "M383.587,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z",
              fill: "rgba(96,96,96,0.51)"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22385",
              "data-name": "Tracé 22385",
              d: "M407.84,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z",
              transform: "translate(-17.928)",
              fill: "rgba(96,96,96,0.51)"
            }
          )
        ] })
      ] })
    }
  );
}
function nk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Composant_127_3",
      "data-name": "Composant 127 – 3",
      xmlns: "http://www.w3.org/2000/svg",
      width: "35",
      height: "35",
      viewBox: "0 0 35 35",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { id: "Groupe_3402", "data-name": "Groupe 3402", transform: "translate(-863 -1502)", children: [
        /* @__PURE__ */ s.jsx(
          "circle",
          {
            id: "Ellipse_2975",
            "data-name": "Ellipse 2975",
            cx: "17.5",
            cy: "17.5",
            r: "17.5",
            transform: "translate(863 1502)",
            fill: "rgb(var(--background-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Soustraction_3",
            "data-name": "Soustraction 3",
            d: "M15,14H0L2.706,8.949h9.588L15,14ZM11.752,7.938h-8.5L7.5,0l4.252,7.937Z",
            transform: "translate(873 1511)",
            fill: "rgba(96,96,96,0.51)"
          }
        )
      ] })
    }
  );
}
function rk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx("path", { d: "m256 0c-63.411 0-115 51.589-115 115s51.589 115 115 115 115-51.589 115-115-51.589-115-115-115zm40 130h-25v25c0 8.284-6.716 15-15 15s-15-6.716-15-15v-25h-25c-8.284 0-15-6.716-15-15s6.716-15 15-15h25v-25c0-8.284 6.716-15 15-15s15 6.716 15 15v25h25c8.284 0 15 6.716 15 15s-6.716 15-15 15z" }),
        /* @__PURE__ */ s.jsxs("g", { children: [
          /* @__PURE__ */ s.jsxs("g", { children: [
            /* @__PURE__ */ s.jsx("path", { d: "m317.869 420.196c-15.513 16.482-37.502 26.804-61.869 26.804s-46.356-10.322-61.869-26.804c-25.848 15.831-43.131 44.336-43.131 76.804 0 8.284 6.716 15 15 15h180c8.284 0 15-6.716 15-15 0-32.468-17.283-60.973-43.131-76.804z" }),
            /* @__PURE__ */ s.jsx("path", { d: "m256 417c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" })
          ] }),
          /* @__PURE__ */ s.jsx("path", { d: "m407 382c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" }),
          /* @__PURE__ */ s.jsxs("g", { children: [
            /* @__PURE__ */ s.jsxs("g", { children: [
              /* @__PURE__ */ s.jsx("path", { d: "m468.869 385.196c-15.513 16.482-37.502 26.804-61.869 26.804s-46.356-10.322-61.869-26.804c-4.341 2.659-8.433 5.682-12.249 9.015l.656.402c17.194 10.532 31.583 25.338 41.611 42.818 7.033 12.26 11.81 25.682 14.161 39.569h107.69c8.284 0 15-6.716 15-15 0-32.468-17.283-60.973-43.131-76.804z" }),
              /* @__PURE__ */ s.jsx("path", { d: "m178.462 394.612.656-.402c-3.816-3.332-7.909-6.356-12.249-9.015-15.513 16.483-37.502 26.805-61.869 26.805s-46.356-10.322-61.869-26.804c-25.848 15.831-43.131 44.336-43.131 76.804 0 8.284 6.716 15 15 15h107.69c2.351-13.887 7.127-27.309 14.161-39.569 10.028-17.481 24.417-32.286 41.611-42.819z" })
            ] }),
            /* @__PURE__ */ s.jsx("path", { d: "m105 382c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" })
          ] })
        ] })
      ] })
    }
  );
}
const ik = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "rgb(var(--fill-primary))",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ s.jsx("path", { d: "M23.4823 66.0459C19.3311 66.0511 15.3515 67.7027 12.4166 70.6385C9.48175 73.5743 7.83132 77.5545 7.82745 81.7057C7.83132 85.8564 9.48191 89.836 12.4169 92.7711C15.352 95.7061 19.3316 97.3567 23.4823 97.3605C27.6331 97.3567 31.6127 95.7061 34.5478 92.7711C37.4828 89.836 39.1334 85.8564 39.1372 81.7057C39.1334 77.5545 37.4829 73.5743 34.548 70.6385C31.6132 67.7027 27.6335 66.0511 23.4823 66.0459ZM133.076 66.0459C128.924 66.0498 124.943 67.7009 122.007 70.6368C119.072 73.5727 117.42 77.5536 117.417 81.7057C117.422 85.8568 119.073 89.8365 122.009 92.7714C124.945 95.7062 128.925 97.3567 133.076 97.3605C137.231 97.3631 141.217 95.7154 144.157 92.7797C147.098 89.8439 148.752 85.8606 148.756 81.7057C148.752 77.5502 147.098 73.5664 144.158 70.6299C141.218 67.6934 137.232 66.0446 133.076 66.0459ZM140.904 105.188H125.244C123.194 105.184 121.162 105.584 119.266 106.364C117.37 107.145 115.647 108.292 114.194 109.739C119.151 112.436 123.4 116.268 126.593 120.921C129.786 125.574 131.833 130.917 132.565 136.512H148.756C150.828 136.505 152.813 135.674 154.273 134.204C155.734 132.733 156.551 130.743 156.544 128.67V120.843C156.54 116.695 154.892 112.717 151.96 109.783C149.028 106.848 145.052 105.196 140.904 105.188ZM103.349 66.7322C96.2703 72.03 87.6609 74.8816 78.8197 74.8566C69.6392 74.8806 60.7197 71.8034 53.507 66.1238C51.7824 69.7766 50.8912 73.7671 50.8979 77.8065C50.896 81.4054 51.6034 84.9694 52.9797 88.2947C54.3561 91.62 56.3743 94.6414 58.9191 97.1862C61.4639 99.731 64.4853 101.749 67.8106 103.126C71.1359 104.502 74.6999 105.209 78.2988 105.207C81.8981 105.206 85.4618 104.495 88.7862 103.116C92.1106 101.736 95.1305 99.7148 97.6731 97.1673C100.216 94.6197 102.231 91.5959 103.604 88.2688C104.977 84.9417 105.681 81.3766 105.675 77.7773C105.681 73.9687 104.888 70.2012 103.349 66.7177V66.7322ZM97.0642 113.03H95.0343C89.8146 115.575 84.0866 116.907 78.2793 116.924C72.4709 116.903 66.742 115.572 61.5194 113.03H59.4896C52.0166 113.033 44.8505 116.002 39.5663 121.287C34.2821 126.571 31.3124 133.737 31.3098 141.21V148.258C31.3111 151.372 32.5485 154.358 34.7501 156.559C36.9517 158.761 39.9374 159.998 43.051 160H113.503C116.616 159.998 119.602 158.761 121.804 156.559C124.005 154.358 125.243 151.372 125.244 148.258V141.21C125.245 133.734 122.277 126.564 116.993 121.277C111.708 115.99 104.54 113.018 97.0642 113.015V113.03ZM31.3098 105.188H15.6549C11.5041 105.192 7.52451 106.842 4.58949 109.777C1.65446 112.712 0.00387263 116.692 6.07017e-06 120.843V128.67C-0.00127527 129.699 0.200312 130.717 0.593225 131.667C0.986137 132.618 1.56265 133.481 2.28975 134.208C3.01686 134.935 3.88025 135.512 4.8305 135.905C5.78075 136.297 6.79918 136.499 7.82745 136.498H23.9448C24.688 130.902 26.7413 125.562 29.9378 120.909C33.1343 116.257 37.3836 112.425 42.3403 109.725C40.8898 108.281 39.1691 107.137 37.2764 106.359C35.3838 105.58 33.3563 105.183 31.3098 105.188Z" }),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M78.8196 0C59.621 0 44.3652 14.954 44.3652 33.7681C44.364 36.1518 44.6136 38.529 45.11 40.8604C48.3812 56.2038 62.1084 67.5555 78.8196 67.5555C95.5308 67.5555 109.209 56.2622 112.515 40.9578C113.021 38.6013 113.275 36.1977 113.274 33.7875C113.274 14.9539 98.0183 0 78.8196 0ZM98.5099 38.592H59.1293V28.944H98.5099V38.592Z"
        }
      )
    ]
  }
);
function ok(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15",
      height: "17",
      viewBox: "0 0 15 17",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3613 1.63892H12.5419V0H10.903V1.63892H4.3473V0H2.70838V1.63892H1.88892C0.97932 1.63892 0.25 2.37643 0.25 3.27784V14.7502C0.25 15.6516 0.97932 16.3892 1.88892 16.3892H13.3613C14.2627 16.3892 15.0002 15.6517 15.0002 14.7502V3.27784C15.0002 2.37644 14.2627 1.63892 13.3613 1.63892H13.3613ZM7.62513 4.09729C8.98543 4.09729 10.0835 5.19536 10.0835 6.55566C10.0835 7.91596 8.98543 9.01403 7.62513 9.01403C6.26483 9.01403 5.16676 7.91596 5.16676 6.55566C5.16676 5.19536 6.26483 4.09729 7.62513 4.09729ZM12.5419 13.9308H2.70838V13.1113C2.70838 11.4724 5.98621 10.571 7.62513 10.571C9.26405 10.571 12.5419 11.4724 12.5419 13.1113V13.9308Z"
        }
      )
    }
  );
}
function sk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "18",
      height: "28",
      viewBox: "0 0 15 16",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.8003 14.1178C14.8809 14.2272 14.9288 14.3572 14.9386 14.4927C14.9484 14.6283 14.9196 14.7638 14.8556 14.8837C14.7924 15.0028 14.6981 15.1026 14.5828 15.1724C14.4675 15.2423 14.3354 15.2796 14.2006 15.2805H0.915116C0.780298 15.2796 0.648229 15.2423 0.532917 15.1724C0.417596 15.1026 0.323321 15.0028 0.260071 14.8837C0.196071 14.7638 0.167306 14.6283 0.177094 14.4927C0.186893 14.3572 0.234845 14.2272 0.315422 14.1178C1.34697 12.6424 2.8055 11.5185 4.49481 10.8971C3.50454 10.2391 2.75237 9.27969 2.3496 8.16087C1.94683 7.04204 1.91487 5.82324 2.25844 4.68484C2.60202 3.54643 3.30287 2.54891 4.2573 1.8399C5.21172 1.13088 6.36899 0.748043 7.55785 0.748043C8.74671 0.748043 9.90397 1.13088 10.8584 1.8399C11.8128 2.54892 12.5137 3.54643 12.8573 4.68484C13.2008 5.82325 13.1689 7.04204 12.7661 8.16087C12.3633 9.27969 11.6112 10.2391 10.6209 10.8971C12.3102 11.5185 13.7687 12.6424 14.8003 14.1178Z"
        }
      )
    }
  );
}
function lk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.8579 16.6084H14.4205V7.80825L10.3589 3.80801H4.67102V1.40806C4.67102 0.967118 5.03578 0.608398 5.48413 0.608398H13.6084L17.671 4.60864V15.8078C17.671 16.2492 17.3063 16.6084 16.8579 16.6084L16.8579 16.6084Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5131 20.6088H1.46049C1.02448 20.6088 0.671021 20.2554 0.671021 19.8193V5.60881C0.671021 5.17279 1.02448 4.81934 1.46049 4.81934H9.35523L13.3026 8.7667V19.8193C13.3026 20.2554 12.9491 20.6088 12.5131 20.6088Z"
          }
        )
      ]
    }
  );
}
const ck = (e) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.974 25.974",
    fill: "rgb(var(--fill-primary))",
    ...e,
    children: /* @__PURE__ */ s.jsx("path", { d: "M8.973 11.146v9.558a.998.998 0 0 1-.668.943c-.566.199-1.249.304-1.976.304-2.091 0-4.34-.858-4.34-2.742V6.979c-.047-.84.246-2.324 1.653-3.127.653-.373 4.082-2.578 5.804-3.692a1.002 1.002 0 0 1 1.543.84v1.448a1 1 0 0 1-1.938.347c-1.556 1-3.848 2.468-4.417 2.793-.512.293-.623.831-.645 1.123 0 .328.071.586.199.727.355.387 1.538.146 2.829-.629 1.24-.744 7.356-4.816 7.417-4.857a1 1 0 0 1 1.555.833v.114c0 .334-.167.646-.444.832 0 0-4.246 2.834-4.622 3.075-1.439.926-1.95 2.062-1.95 4.34zM23.989 6.32v12.982a1 1 0 0 1-.468.846s-5.83 4.528-7.013 5.247c-.622.379-1.414.579-2.289.579-2.079 0-4.23-1.125-4.23-3.006V10.559c0-.004.003-.008.003-.013.02-.732.191-1.777 1.552-2.781.816-.602 5.676-3.916 5.882-4.056a.999.999 0 0 1 1.563.826v1.448a1 1 0 0 1-1.92.392c-1.551 1.061-3.828 2.624-4.338 2.999-.644.476-.73.79-.741 1.193.002.299.083.527.247.677.51.467 1.883.271 3.237-.541 1.002-.602 5.32-3.936 6.898-5.17.303-.234.711-.277 1.055-.11s.562.514.562.897zm-2 4.456-5 3.879v2l5-3.879v-2z" })
  }
), uk = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "rgb(var(--fill-primary))",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ s.jsx("path", { d: "M79.6239 18.5188C78.7887 17.9806 77.8162 17.6944 76.8226 17.6944C75.8291 17.6944 74.8565 17.9806 74.0213 18.5188C73.4614 19.0666 39.298 41.6462 32.0158 45.5048C24.7336 49.9032 17.9186 50.9625 16.2591 48.7633C15.7396 48.2518 15.2844 46.685 15.2119 45.1383V44.7919C15.1856 43.5414 15.4967 42.3068 16.1127 41.2181C16.7286 40.1294 17.6266 39.2268 18.7121 38.6053C21.8618 36.8854 29.6716 31.9877 37.268 27.2712C40.4902 25.2573 40.893 25.0599 43.3902 23.4851C43.7243 24.836 44.5594 26.0094 45.7263 26.7677C46.9033 27.5341 48.3216 27.8395 49.7097 27.6256C51.0923 27.4141 52.3469 26.6964 53.23 25.6117C54.1084 24.5384 54.541 23.1686 54.4383 21.7853V13.5405C54.4456 12.7557 54.2806 11.9789 53.955 11.2648C53.6313 10.5449 53.1543 9.90433 52.5574 9.3879C51.959 8.86545 51.2558 8.47683 50.4951 8.24804C49.7328 8.0152 48.93 7.94522 48.1389 8.04262C47.3273 8.16116 46.551 8.45382 45.8632 8.90054C45.8632 8.90054 38.7784 13.2787 31.1619 18.0113C23.5454 22.744 15.0509 27.9519 13.1296 29.0071C13.0128 29.0555 12.896 29.1118 12.7792 29.1723C5.7427 33.4336 4.28058 40.3936 4.03086 44.2965C4.03086 44.4778 4.03086 44.6268 4.03086 44.8161C3.98971 45.6211 3.98971 46.4277 4.03086 47.2328V119.036C4.03086 129.468 16.4243 134.486 28.1974 134.486C31.999 134.496 35.779 133.916 39.4027 132.766C41.6421 131.667 43.2492 129.468 43.2492 127.268V69.5264C43.2492 56.8833 46.0686 50.9423 54.4504 45.9962C56.6898 44.8967 80.1838 28.9789 80.1838 28.9789C81.3035 27.8794 82.4555 25.648 82.4555 24.0006V23.4971C82.4543 22.4933 82.1928 21.507 81.6965 20.6344C81.2002 19.7619 80.4861 19.0329 79.6239 18.5188ZM127.232 45.5048V43.2574C127.232 40.5104 126.145 38.859 123.905 37.7595C122.226 36.6599 119.475 37.1754 117.783 38.275C108.821 44.8725 84.6989 63.5009 79.1164 66.7996C71.2744 71.1979 63.8874 72.2975 61.0882 69.5466C59.9684 68.447 60.0409 67.4159 60.0409 65.7645C60.0473 64.9468 60.1652 64.1337 60.3914 63.3478C60.7055 62.3892 61.3459 61.2131 63.7143 59.3966C63.827 59.312 63.7706 59.316 63.8874 59.2274C67.9152 56.5731 80.3207 48.288 88.3964 42.8989C88.8601 44.1092 89.7339 45.1184 90.8654 45.7505C92.0069 46.3906 93.3343 46.6168 94.6233 46.391C95.9073 46.1716 97.075 45.5123 97.9261 44.5261C98.7692 43.5492 99.2375 42.3043 99.2472 41.0139V32.7771C99.2545 31.9923 99.0895 31.2155 98.7639 30.5014C98.4377 29.7841 97.961 29.1454 97.3662 28.6285C96.7681 28.1048 96.0649 27.7148 95.304 27.4846C94.5416 27.2517 93.7386 27.1831 92.9477 27.2832C92.0585 27.4268 91.2162 27.7803 90.4908 28.3144C90.4908 28.3144 62.2965 46.9347 57.4148 50.1287C57.3544 50.1891 57.294 50.2455 57.2376 50.3059C53.1857 53.2905 50.7932 56.843 49.7097 60.0934C49.1117 61.9235 48.8178 63.8393 48.8397 65.7645V67.4884C48.8397 67.6575 48.8397 67.8267 48.8397 67.9959V134.486C48.8397 144.934 61.0922 151 72.2934 151C77.3362 151 81.8835 149.937 85.2426 147.738C91.965 143.887 124.453 119.048 124.453 119.048C126.133 117.948 127.272 116.397 127.272 114.75V113.493C118.125 113.56 109.321 110.008 102.78 103.613C99.563 100.475 97.0104 96.722 95.2736 92.5773C93.5369 88.4326 92.6514 83.9809 92.6699 79.4871C92.6517 74.9939 93.5374 70.5429 95.2741 66.3989C97.0109 62.2549 99.5633 58.5025 102.78 55.3648C109.313 48.9856 118.101 45.4423 127.232 45.5048Z" }),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M127.232 51.5464C111.347 51.5464 98.7236 63.9197 98.7236 79.487C98.7236 95.0543 111.347 107.432 127.232 107.432C143.118 107.432 155.741 95.0583 155.741 79.487C155.741 63.9156 143.118 51.5464 127.232 51.5464ZM143.524 83.4785H110.94V75.4955H143.524V83.4785Z"
        }
      )
    ]
  }
);
function dk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M47.3023 41.7056L28.0718 34.9731C28.0718 41.1191 28.0188 41.0759 28.213 41.6566C28.4798 42.4883 29.1115 43.1808 29.957 43.5045C50.9118 51.5651 49.4385 51.0884 50.2193 51.0884C51.0001 51.0884 49.5033 51.5729 70.4797 43.5045C71.6037 43.0729 72.3668 41.994 72.3668 40.7581V35.2948L53.0108 41.7488C51.1531 42.3687 49.1443 42.353 47.3003 41.7056H47.3023Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M84.188 43.7144C84.188 46.3274 81.01 47.6397 79.166 45.7958C78.6325 45.2641 78.3029 44.5265 78.3029 43.7144V27.1145C69.385 30.0865 62.2759 32.4562 51.1491 36.1658C50.5273 36.3718 49.8603 36.3679 49.2463 36.1501C17.3099 24.9724 19.6797 25.9022 18.9715 25.4334C17.0176 24.0366 17.4629 21.0353 19.7012 20.2525C49.7073 9.75357 49.4954 9.74768 50.2193 9.74768C50.902 9.74768 50.7607 9.76534 80.1881 19.5758C79.9605 20.692 79.8409 21.8474 79.8409 23.0303C79.8409 27.4068 81.4828 31.3989 84.186 34.4258C84.188 36.925 84.188 39.9793 84.188 43.7144Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M81.9204 23.9131C81.9204 23.3265 81.9204 22.738 81.9204 22.1515C81.9381 22.0475 81.9596 21.9435 81.9753 21.8395C82.0695 21.1922 82.1225 20.535 82.2617 19.8975C83.0464 16.286 84.9022 13.3258 87.8447 11.0993C91.5053 8.32741 95.6268 7.40737 100.121 8.34506C103.719 9.09443 106.644 10.9796 108.88 13.8888C111.295 17.0275 112.301 20.6037 111.923 24.5388C111.617 27.7266 110.379 30.5416 108.254 32.9447C105.926 35.5792 103.022 37.2192 99.556 37.8372C98.9891 37.9372 98.4163 37.9941 97.8454 38.0706H96.0838C96.0073 38.0549 95.9328 38.0274 95.8563 38.0216C93.5042 37.8548 91.3032 37.1819 89.2944 35.952C85.3985 33.5646 82.9994 30.1218 82.1578 25.6197C82.0519 25.0567 82.0008 24.4819 81.9243 23.9131H81.9204ZM94.693 25.4648C94.5635 25.3431 94.4929 25.2784 94.4242 25.2097C93.4473 24.2348 92.4724 23.2579 91.4954 22.2849C91.3777 22.1671 91.2561 22.0534 91.1266 21.9494C90.2635 21.2491 88.9335 21.3825 88.2214 22.2378C87.4622 23.15 87.5387 24.3329 88.4234 25.2215C89.9437 26.7457 91.468 28.268 92.9903 29.7883C94.0241 30.8221 95.2599 30.8221 96.2957 29.7883C99.3422 26.7438 102.387 23.6992 105.429 20.6547C105.561 20.5233 105.686 20.3859 105.8 20.2388C106.657 19.1206 106.106 17.4002 104.76 16.9804C103.862 16.7019 103.113 16.9569 102.463 17.6082C99.9386 20.1368 97.4119 22.6595 94.8872 25.1882C94.8127 25.2627 94.7616 25.3647 94.693 25.4667V25.4648Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M96.9586 40.148C94.5104 40.148 92.18 39.634 90.0751 38.7062V43.7144C90.0751 48.5833 86.1144 52.5439 81.2455 52.5439C78.1127 52.5439 75.3545 50.904 73.7871 48.4362C72.9769 48.8972 74.3227 48.3361 53.3914 56.3869C51.3846 57.1598 49.1286 57.1873 47.0493 56.3869L27.8443 48.9992C24.4329 47.6868 22.1848 44.4167 22.1848 40.7581V32.9172L17.7553 31.3635C14.2184 30.1277 11.8427 26.7791 11.8427 23.0303H2.9445C1.32022 23.0303 0 24.3505 0 25.9748V89.514C0 91.1403 1.32022 92.4585 2.9445 92.4585H29.549V98.3887H20.6723C19.048 98.3887 17.7278 99.7089 17.7278 101.333C17.7278 102.957 19.048 104.276 20.6723 104.276H79.7683C81.3926 104.276 82.7109 102.959 82.7109 101.333C82.7109 99.707 81.3926 98.3887 79.7683 98.3887H70.8917V92.4585H97.4961C99.1204 92.4585 100.439 91.1403 100.439 89.514V39.7949C99.3146 40.0264 98.1514 40.148 96.9586 40.148ZM19.2109 83.5818C14.3223 83.5818 10.3577 79.6173 10.3577 74.7287C10.3577 69.8402 14.3223 65.8756 19.2109 65.8756C24.0994 65.8756 28.064 69.8402 28.064 74.7287C28.064 79.6173 24.1014 83.5818 19.2109 83.5818ZM85.6789 83.5818H38.4001C36.7759 83.5818 35.4576 82.2636 35.4576 80.6373C35.4576 79.0111 36.7759 77.6948 38.4001 77.6948H85.6789C87.3032 77.6948 88.6214 79.0131 88.6214 80.6373C88.6214 82.2616 87.3032 83.5818 85.6789 83.5818ZM85.6789 71.7627H38.4001C36.7759 71.7627 35.4576 70.4444 35.4576 68.8201C35.4576 67.1958 36.7759 65.8756 38.4001 65.8756H85.6789C87.3032 65.8756 88.6214 67.1939 88.6214 68.8201C88.6214 70.4464 87.3032 71.7627 85.6789 71.7627Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M58.0916 72.6376V76.8179C58.0916 77.4712 58.7781 77.8949 59.3608 77.6026L63.5411 75.5114C64.1885 75.1878 64.1885 74.2658 63.5411 73.9421L59.3608 71.8509C58.7781 71.5586 58.0916 71.9843 58.0916 72.6356V72.6376Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M16.5823 72.6376V76.8179C16.5823 77.4712 17.2689 77.8949 17.8515 77.6026L22.0319 75.5114C22.6792 75.1878 22.6792 74.2658 22.0319 73.9421L17.8515 71.8509C17.2689 71.5586 16.5823 71.9843 16.5823 72.6356V72.6376Z" })
      ]
    }
  );
}
function Ck(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "27",
      height: "27",
      viewBox: "0 0 22 15",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            stroke: "none",
            d: "M21.5274 3.9381L11.281 0.605099C11.2592 0.597779 11.2353 0.597779 11.2134 0.605099L0.914657 3.88727C0.869307 3.90189 0.838397 3.94375 0.837897 3.99127C0.837397 4.03894 0.867477 4.08131 0.912327 4.09676L3.42849 4.95894V7.94639C3.00603 8.1361 2.7115 8.55956 2.7115 9.05265C2.7115 9.54571 3.00637 9.96951 3.42849 10.1589L2.76696 14.419H4.97214L4.42093 10.1589C4.84339 9.96935 5.13791 9.54572 5.13791 9.05265C5.13791 8.55956 4.84337 8.13611 4.42093 7.94639V5.29882L11.1761 7.61348C11.1876 7.61747 11.1997 7.61946 11.2117 7.61946C11.2237 7.61946 11.2358 7.61763 11.2472 7.61365L21.5285 4.14757C21.5737 4.13229 21.6038 4.08992 21.6034 4.04258C21.6029 3.99473 21.5724 3.95286 21.5273 3.93808L21.5274 3.9381Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2104 8.17106C11.1375 8.17106 11.0658 8.15876 10.9968 8.13517L5.61523 6.29135V10.2296C5.61523 11.3359 8.15747 12.2326 11.2937 12.2326C14.4298 12.2326 16.972 11.3359 16.972 10.2296L16.9719 6.26562L11.4232 8.13621C11.3549 8.15962 11.283 8.1711 11.2104 8.1711L11.2104 8.17106Z"
          }
        )
      ]
    }
  );
}
const pk = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "rgb(var(--fill-primary))",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_28602_6922)", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M160.005 67.3016C160.006 67.4815 159.95 67.6571 159.847 67.8037C159.744 67.9502 159.597 68.0603 159.429 68.1184L80.2103 95.0747C80.1214 95.102 80.029 95.116 79.936 95.1163C79.8426 95.1171 79.7498 95.1014 79.6617 95.0701L27.6115 77.0746V97.6633C29.2566 98.4071 30.6537 99.6152 31.6342 101.142C32.6148 102.669 33.1372 104.449 33.1383 106.269C33.1372 108.088 32.6148 109.869 31.6342 111.396C30.6537 112.922 29.2566 114.131 27.6115 114.874L31.8583 148.005H14.8617L19.9589 114.874C18.3149 114.129 16.9192 112.921 15.9395 111.394C14.9598 109.868 14.4379 108.088 14.4366 106.269C14.4368 104.45 14.9582 102.669 15.938 101.143C16.9178 99.6156 18.3142 98.4073 19.9589 97.6633V74.426L0.571459 67.7215C0.403251 67.6619 0.257738 67.5506 0.155276 67.4034C0.0528133 67.2561 -0.0014712 67.0801 3.03298e-05 66.9002C0.00200043 66.7202 0.0600201 66.5453 0.165851 66.4004C0.271681 66.2555 0.419981 66.1479 0.589763 66.0927L41.7783 52.8452C43.4158 59.9957 47.0542 66.5207 52.2606 71.6436C59.6742 78.9495 69.6438 83.0085 80.0046 82.9393C90.3638 83.0073 100.332 78.9484 107.744 71.6436C112.925 66.5495 116.553 60.0648 118.199 52.956L159.419 66.4895C159.59 66.5451 159.738 66.6536 159.843 66.7995C159.948 66.9454 160.005 67.1212 160.005 67.3016Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M79.9223 99.4074C79.3625 99.4059 78.8067 99.3123 78.2766 99.1305L36.8092 84.7895V115.437C36.8092 124.038 56.3978 131.015 80.5623 131.015C104.727 131.015 124.315 124.038 124.315 115.437V84.5911L81.5635 99.1351C81.0352 99.3172 80.4806 99.4092 79.9223 99.4074Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80.0045 12C61.9748 12 47.648 26.1749 47.648 44.009C47.6467 46.2685 47.8812 48.5219 48.3474 50.7319C51.4194 65.276 64.3108 76.0179 80.0045 76.0179C95.6983 76.0179 108.544 65.3129 111.648 50.8057C112.123 48.572 112.362 46.2936 112.361 44.009C112.357 26.1749 98.0297 12 80.0045 12ZM98.496 48.5817H61.5131V39.4362H98.496V48.5817Z"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_28602_6922", children: /* @__PURE__ */ s.jsx(
        "rect",
        {
          width: "160",
          height: "136",
          fill: "rgb(var(--background-secondary))",
          transform: "translate(0 12)"
        }
      ) }) })
    ]
  }
);
function Oh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "19",
      height: "15",
      viewBox: "0 0 19 15",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.0035 0.218132H1.88928C0.84752 0.218132 0 1.06565 0 2.10741V12.1836C0 13.2254 0.84752 14.0729 1.88928 14.0729H17.0035C18.0453 14.0729 18.8928 13.2254 18.8928 12.1836V2.10741C18.8928 1.06565 18.0453 0.218132 17.0035 0.218132ZM15.744 4.62646H3.14879C2.80074 4.62646 2.51903 4.34476 2.51903 3.9967C2.51903 3.64865 2.80074 3.36694 3.14879 3.36694H15.744C16.0921 3.36694 16.3738 3.64865 16.3738 3.9967C16.3738 4.34476 16.0921 4.62646 15.744 4.62646ZM6.92737 10.9241H3.1488V7.14551H6.92737V10.9241Z"
        }
      )
    }
  );
}
function hk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "19",
      height: "28",
      viewBox: "0 0 19 19",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2301 7.70151V0.805664H16.1408C17.2245 0.805664 18.1111 1.69227 18.1111 2.7759V7.7015L10.2301 7.70151ZM10.2301 9.67175H18.1111V16.5676C18.1111 17.6512 17.2245 18.5378 16.1408 18.5378H10.2301V9.67175ZM8.25988 18.5378H2.34915C1.26552 18.5378 0.378906 17.6512 0.378906 16.5676V2.77591C0.378906 1.69228 1.26552 0.805674 2.34915 0.805674H8.25988V18.5378Z"
        }
      )
    }
  );
}
function fk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.606 2.90772C1.13495 4.37914 0.308594 6.37461 0.308594 8.45517C0.308774 10.5359 1.13533 12.5314 2.60673 14.0026C4.07797 15.4739 6.07344 16.3004 8.1542 16.3004C10.2349 16.3004 12.2304 15.4739 13.7016 14.0026C15.1729 12.5314 15.9996 10.5359 15.9996 8.45517C15.9998 6.37446 15.1735 4.37899 13.7022 2.90772C12.7284 1.93379 11.5154 1.2333 10.185 0.87684C8.85459 0.52022 7.4538 0.52022 6.12337 0.87684C4.79297 1.2333 3.57985 1.93379 2.60594 2.90772H2.606ZM4.08614 4.38787L4.08632 4.38804C5.03674 3.4393 6.28922 2.85316 7.62657 2.73076C8.9639 2.60854 10.302 2.95788 11.4087 3.71857L3.41696 11.7131C2.65463 10.606 2.30401 9.2672 2.42586 7.92858C2.54752 6.59018 3.13422 5.33636 4.08368 4.38525L4.08614 4.38787ZM12.2222 12.5239C11.2716 13.4725 10.0191 14.0588 8.68177 14.181C7.34441 14.3032 6.00637 13.9539 4.8996 13.1934L12.889 5.19607C13.6513 6.30316 14.002 7.64195 13.8802 8.98055C13.7585 10.319 13.1718 11.5728 12.2223 12.5239L12.2222 12.5239Z"
        }
      )
    }
  );
}
function mk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--background-secondary))",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { id: "Icon", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Vector",
            d: "M7 2.46948H16.5L21 6.96948V19.4695",
            fill: "none",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Vector_2",
            d: "M3 20.9695V6.96948C3 6.14105 3.67157 5.46948 4.5 5.46948H14.2515C14.4106 5.46948 14.5632 5.53269 14.6757 5.64522L17.8243 8.79374C17.9368 8.90627 18 9.05888 18 9.21801V20.9695C18 21.7979 17.3284 22.4695 16.5 22.4695H4.5C3.67157 22.4695 3 21.7979 3 20.9695Z",
            strokeWidth: "1.5",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Vector_3",
            d: "M14 8.86948V5.82303C14 5.62777 14.1583 5.46948 14.3536 5.46948C14.4473 5.46948 14.5372 5.50673 14.6036 5.57303L17.8964 8.86593C17.9628 8.93223 18 9.02216 18 9.11593C18 9.31119 17.8417 9.46948 17.6464 9.46948H14.6C14.2686 9.46948 14 9.20085 14 8.86948Z",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] })
    }
  );
}
function gk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.8519 10.2206V0.866211H8.9426V10.3189L5.94167 7.31566L3.88501 9.37464L10.3481 15.8378L16.8939 9.29391L14.8351 7.23741L11.8519 10.2206Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4646 15.7612V17.9567H3.29433V15.7612H0.38501V20.866H20.3742V15.7612H17.4646Z"
          }
        )
      ]
    }
  );
}
function Bh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "18",
      height: "4",
      viewBox: "0 0 18 4",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("circle", { cx: "2.50928", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "9.06396", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "15.6187", cy: "2.03174", r: "1.90771" })
      ]
    }
  );
}
function vk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "10",
      viewBox: "0 0 20 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.2254 0.899587C12.5915 1.2657 12.5915 1.8593 12.2254 2.22541L5.35041 9.10041C4.9843 9.46653 4.3907 9.46653 4.02459 9.10041L0.587087 5.66291C0.220971 5.2968 0.220971 4.7032 0.587087 4.33709C0.953204 3.97097 1.5468 3.97097 1.91291 4.33709L4.6875 7.11167L10.8996 0.899587C11.2657 0.533471 11.8593 0.533471 12.2254 0.899587Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4129 0.899587C19.779 1.2657 19.779 1.8593 19.4129 2.22541L12.5379 9.10041C12.1718 9.46653 11.5782 9.46653 11.2121 9.10041L9.38396 7.27229C9.01785 6.90617 9.01785 6.31258 9.38396 5.94646C9.75008 5.58035 10.3437 5.58035 10.7098 5.94646L11.875 7.11167L18.0871 0.899587C18.4532 0.533471 19.0468 0.533471 19.4129 0.899587Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function bk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      fill: "rgb(var(--text-secondary))",
      width: "15",
      height: "25",
      viewBox: "0 0 15 25",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("circle", { cx: "2.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "2.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "2.5", cy: "22.4942", r: "2.5" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "12.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "12.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ s.jsx("circle", { cx: "12.5", cy: "22.4942", r: "2.5" })
      ]
    }
  );
}
function yk(e) {
  return /* @__PURE__ */ s.jsx("svg", { width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6l319.2 0 42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z" }) });
}
function xk(e) {
  return /* @__PURE__ */ s.jsxs("svg", { width: "15", height: "14", viewBox: "0 0 15 14", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_268001_9652)", children: [
      /* @__PURE__ */ s.jsx("path", { d: "M14.9713 3.23242L9.71 8.14292C9.12336 8.68907 8.32859 8.99578 7.5 8.99578C6.67141 8.99578 5.87664 8.68907 5.29 8.14292L0.02875 3.23242C0.02 3.32459 0 3.40801 0 3.49959V10.4996C0.000992411 11.2729 0.330551 12.0142 0.916387 12.561C1.50222 13.1077 2.2965 13.4153 3.125 13.4163H11.875C12.7035 13.4153 13.4978 13.1077 14.0836 12.561C14.6694 12.0142 14.999 11.2729 15 10.4996V3.49959C15 3.40801 14.98 3.32459 14.9713 3.23242Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M8.82622 7.31915L14.535 1.9904C14.2584 1.56242 13.8684 1.20817 13.4025 0.961827C12.9365 0.715481 12.4105 0.58535 11.875 0.583984H3.12497C2.58948 0.58535 2.0634 0.715481 1.59748 0.961827C1.13156 1.20817 0.741515 1.56242 0.464966 1.9904L6.17372 7.31915C6.52595 7.64658 7.00283 7.83042 7.49997 7.83042C7.9971 7.83042 8.47398 7.64658 8.82622 7.31915Z" })
    ] }),
    /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_268001_9652", children: /* @__PURE__ */ s.jsx("rect", { width: "15", height: "14", fill: "rgb(var(--background-secondary))" }) }) })
  ] });
}
function wk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 512 512",
      width: "512",
      height: "512",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M488.432,0H23.568A22.916,22.916,0,0,0,.679,22.89v7.667L220.3,181.894a63.26,63.26,0,0,0,71.4,0L511.321,30.557V22.89A22.916,22.916,0,0,0,488.432,0Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M256,208.962a78.932,78.932,0,0,1-44.805-13.85L.679,50.05V321.965a22.751,22.751,0,0,0,4.046,12.973l131.5-148.376a8.026,8.026,0,0,1,12.014,10.646L18,344.165a22.863,22.863,0,0,0,5.573.689H130.947L112.7,326.6a30.705,30.705,0,1,1,43.424-43.424l59.093,59.093a30.3,30.3,0,0,1,37.96-20.159,30.3,30.3,0,0,1,43.543-22.5,24.191,24.191,0,0,1,6.519-12.805,28.045,28.045,0,0,1,39.661,0l52.675,52.675q2.614,2.614,5.084,5.372h87.778a22.863,22.863,0,0,0,5.573-.689L363.761,197.208a8.026,8.026,0,0,1,12.014-10.646l131.5,148.376a22.751,22.751,0,0,0,4.046-12.973V50.05L300.805,195.112A78.932,78.932,0,0,1,256,208.962Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M414.5,399.466a127.192,127.192,0,0,0-30.284-48.634l-52.675-52.675a11.991,11.991,0,0,0-16.96,0c-1.848,1.848-2.649,5.1-2.2,8.91a19.38,19.38,0,0,0,4.338,10.123c9.063,9.05-4.709,20.519-12.429,10.36l-11.012-10.874a14.283,14.283,0,1,0-20.245,20.154l3.377,3.377a8.026,8.026,0,0,1-11.351,11.35l-10.67-10.5a14.283,14.283,0,1,0-20.264,20.135s3.824,3.862,4.024,4.117a8.022,8.022,0,0,1-.6,10.555c-.018.018-.032.037-.05.055a8.027,8.027,0,0,1-10.741.551c-.21-.171-13.918-13.859-13.918-13.859l-68.079-68.078a14.653,14.653,0,1,0-20.722,20.724L244.209,435.415a11.156,11.156,0,0,1-11.86,18.314l-52.89-20.153A23.034,23.034,0,0,0,155,438.807a3.758,3.758,0,0,0,.831,5.942l62.9,34.943A215.75,215.75,0,0,0,294.953,505l69.936,7,68.879-68.879L414.616,399.8Z" })
      ]
    }
  );
}
function _k(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { id: "_x32__x2C__message_x2C__Email_x2C__mail_x2C__open", children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx("path", { d: "m16 219.855v269.882l178.304-145.554z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m25.032 495.273h461.937l-230.969-188.546z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m496 489.737v-269.882l-178.304 124.328z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m252.838 296.4c1.84-1.502 4.483-1.502 6.323 0l50.48 41.208 183.067-127.649-236.708-193.232-236.708 193.232 183.067 127.649z" })
      ] }) }) })
    }
  );
}
function Mk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.4753 8.47342C15.6279 8.27888 15.6086 8.00028 15.4304 7.82891C15.2521 7.65754 14.9731 7.6492 14.7849 7.80946L6.15544 15.1533L1.5985 13.3905C1.3327 13.2886 1.11625 13.0887 0.994021 12.8316C0.871542 12.5748 0.852573 12.2805 0.940996 12.01C1.02944 11.7395 1.21859 11.5135 1.46909 11.3785L20.3875 0.777433C20.5866 0.670209 20.8181 0.638952 21.0385 0.689664C21.2591 0.740155 21.4536 0.869374 21.586 1.05279C21.7185 1.23645 21.7796 1.46178 21.7583 1.6871L20.0988 18.9911C20.065 19.351 19.8635 19.6738 19.5552 19.8621C19.2466 20.0504 18.8675 20.0821 18.5321 19.9473L12.9861 17.7993L9.50435 21.0629C9.33211 21.2239 9.1036 21.3109 8.86793 21.3049C8.63202 21.2991 8.40813 21.2007 8.24424 21.0314C8.08011 20.8619 7.98935 20.6347 7.99097 20.3989V17.836L15.4753 8.47342Z"
        }
      )
    }
  );
}
function Sk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "189",
      height: "176",
      id: "Layer_1",
      viewBox: "0 0 65 65",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("circle", { cx: "32.5", cy: "32.5", fill: "rgb(var(--background-primary))", r: "32" }) }),
        /* @__PURE__ */ s.jsxs("g", { children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "m49.1 22.9v1.2h-8.1c-1.1 0-2.1.7-2.3 1.5s-1.3 1.5-2.3 1.5h-16.1c-1.5 0-3 .9-3.3 2.1l-4.5 17.3c-.1.5 0 1 .2 1.3-.5-.5-.8-1.3-.8-2.1v-26.4c0-1.7 1.4-3.1 3.1-3.1h11.3c1.1 0 1.9.9 1.9 1.9s.9 1.9 1.9 1.9h16.1c1.6.1 2.9 1.3 2.9 2.9z",
              fill: "rgb(var(--text-secondary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "m12.7 48.5c-.2 0-.4-.1-.5-.2-.7-.7-1-1.6-1-2.6v-26.4c0-2.1 1.7-3.9 3.9-3.9h11.3c1.5 0 2.7 1.2 2.7 2.7 0 .7.5 1.2 1.2 1.2h16.1c1.9 0 3.5 1.6 3.5 3.5v1.2c0 .4-.3.8-.8.8h-8.1c-.8 0-1.5.5-1.6.9-.3 1.1-1.6 2-3.1 2h-16c-1.3 0-2.4.8-2.6 1.5l-4.5 17.3c-.1.3 0 .5.1.7.2.3.1.8-.2 1-.1.3-.2.3-.4.3zm2.3-31.6c-1.3 0-2.4 1.1-2.4 2.4v23.6l3.6-13.9c.4-1.5 2.2-2.7 4-2.7h16.1c.8 0 1.5-.5 1.6-.9.3-1.1 1.6-2 3-2h7.3v-.5c0-1.1-.9-2-2-2h-16c-1.5 0-2.7-1.2-2.7-2.7 0-.7-.5-1.2-1.2-1.2h-11.3z",
              fill: "rgb(var(--text-primary))"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs("g", { children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "m54.8 26.5-5.2 20c-.3 1.3-2 2.4-3.7 2.4h-30.9c-.1 0-.2 0-.3 0-.9-.1-1.6-.4-2-1-.3-.4-.3-.8-.2-1.3l4.5-17.5c.3-1.2 1.8-2.1 3.3-2.1h16.1c1.1 0 2.1-.7 2.3-1.5s1.3-1.5 2.3-1.5h11.3c1.8.1 2.9 1.2 2.5 2.5z",
              fill: "rgb(var(--background-secondary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "m45.9 49.6h-30.9c-.1 0-.3 0-.4 0-1.1-.1-2-.6-2.5-1.4-.4-.6-.5-1.2-.3-1.9l4.4-17.3c.4-1.5 2.2-2.7 4-2.7h16.1c.8 0 1.5-.5 1.6-.9.3-1.1 1.6-2 3-2h11.3c1.2 0 2.2.4 2.8 1.2.5.6.6 1.3.4 2.1l-5.2 20c-.2 1.6-2.2 2.9-4.3 2.9zm-25.6-21.8c-1.3 0-2.4.8-2.6 1.5l-4.5 17.3c-.1.3 0 .5.1.7.2.4.8.6 1.4.7h.3 30.9c1.4 0 2.8-.8 3-1.8l5.2-20c.1-.3 0-.6-.2-.8-.3-.4-.9-.6-1.6-.6h-11.3c-.8 0-1.5.5-1.6.9-.3 1.1-1.6 2-3.1 2h-16z",
              fill: "rgb(var(--text-primary))"
            }
          )
        ] })
      ] })
    }
  );
}
function kk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "189",
      height: "176",
      viewBox: "0 0 189 176",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M99.0519 149.787C135.246 149.787 164.588 120.445 164.588 84.1219C164.588 47.799 135.116 18.4563 99.0519 18.4563C62.8583 18.4563 33.5156 47.799 33.5156 84.1219C33.5156 120.445 62.8583 149.787 99.0519 149.787Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M184.143 119.506C186.466 119.506 188.349 117.613 188.349 115.3C188.349 112.971 186.466 111.094 184.143 111.094C181.82 111.094 179.938 112.971 179.938 115.3C179.938 117.613 181.82 119.506 184.143 119.506Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.0418 22.7514C27.3641 22.7514 29.2477 20.8587 29.2477 18.5455C29.2477 16.2172 27.3641 14.3396 25.0418 14.3396C22.7181 14.3396 20.8359 16.2172 20.8359 18.5455C20.8359 20.8587 22.7181 22.7514 25.0418 22.7514Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.31291 112.939C12.627 112.939 16.1239 109.439 16.1239 105.128C16.1239 100.817 12.627 97.3169 8.31291 97.3169C3.99886 97.3169 0.501953 100.817 0.501953 105.128C0.501953 109.439 3.99886 112.939 8.31291 112.939Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M158.973 17.4765C158.251 17.4765 157.674 16.8946 157.674 16.1724V1.66641C157.674 0.944124 158.251 0.372314 158.973 0.372314C159.694 0.372314 160.271 0.944124 160.271 1.66641V16.1724C160.271 16.8946 159.694 17.4765 158.973 17.4765Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M169.508 28.5819C169.508 27.8597 170.086 27.2878 170.807 27.2878H185.311C186.032 27.2878 186.609 27.8597 186.609 28.5819C186.609 29.3042 186.032 29.8861 185.311 29.8861H170.807C170.086 29.8861 169.508 29.3042 169.508 28.5819Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M168.357 19.202C167.852 18.7005 167.852 17.8377 168.357 17.3261L178.676 7.08367C179.181 6.57205 180.047 6.57205 180.552 7.08367C181.057 7.58526 181.057 8.44799 180.552 8.95961L170.305 19.202C169.728 19.7137 168.863 19.7137 168.357 19.202Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx("g", { filter: "url(#filter0_d_10697_6855)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M155.556 31.0478V137.172C155.556 140.292 153.857 142.89 151.82 142.89H46.2848C44.2462 143.016 42.5488 140.419 42.5488 137.298V31.0478C42.5488 27.8193 44.2462 25.3484 46.2848 25.3484H151.82C153.942 25.3484 155.556 27.9456 155.556 31.0478Z",
            fill: "url(#paint0_linear_10697_6855)"
          }
        ) }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M155.556 30.095V36.9146H42.5488V30.095C42.5488 27.4063 44.2462 25.3484 46.2848 25.3484H151.82C153.942 25.3484 155.556 27.5114 155.556 30.095Z",
            fill: "url(#paint1_linear_10697_6855)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M48.9235 33.1296C49.8173 33.1296 50.5428 32.4085 50.5428 31.5073C50.5428 30.606 49.8173 29.885 48.9235 29.885C48.0283 29.885 47.3027 30.606 47.3027 31.5073C47.3027 32.4085 48.0282 33.1296 48.9235 33.1296Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M54.0016 33.1296C54.8969 33.1296 55.6224 32.4085 55.6224 31.5073C55.6224 30.606 54.8969 29.885 54.0016 29.885C53.1064 29.885 52.3809 30.606 52.3809 31.5073C52.3809 32.4085 53.1064 33.1296 54.0016 33.1296Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.1872 33.1296C60.0824 33.1296 60.808 32.4085 60.808 31.5073C60.808 30.606 60.0824 29.885 59.1872 29.885C58.2919 29.885 57.5664 30.606 57.5664 31.5073C57.5664 32.4085 58.2919 33.1296 59.1872 33.1296Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 100.231C66.5195 99.324 67.2546 98.5889 68.1615 98.5889H129.944C130.851 98.5889 131.586 99.324 131.586 100.231C131.586 101.138 130.851 101.873 129.944 101.873H68.1615C67.2546 101.873 66.5195 101.138 66.5195 100.231Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 110.514C66.5195 109.608 67.2546 108.873 68.1615 108.873H129.944C130.851 108.873 131.586 109.608 131.586 110.514C131.586 111.421 130.851 112.156 129.944 112.156H68.1615C67.2546 112.156 66.5195 111.421 66.5195 110.514Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 120.799C66.5195 119.892 67.2546 119.157 68.1615 119.157H129.944C130.851 119.157 131.586 119.892 131.586 120.799C131.586 121.705 130.851 122.441 129.944 122.441H68.1615C67.2546 122.441 66.5195 121.705 66.5195 120.799Z",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M82.7083 60.385C84.5238 60.385 85.996 58.9153 85.996 57.0998C85.996 55.2843 84.5238 53.8022 82.7083 53.8022C80.894 53.8022 79.4219 55.2843 79.4219 57.0998C79.4219 58.9153 80.894 60.385 82.7083 60.385Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.4 60.385C117.215 60.385 118.686 58.9153 118.686 57.0998C118.686 55.2843 117.215 53.8022 115.4 53.8022C113.584 53.8022 112.113 55.2843 112.113 57.0998C112.113 58.9153 113.584 60.385 115.4 60.385Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M104.384 81.9734H94.0792C92.481 81.9734 91.1484 80.6395 91.1484 79.034C91.1484 77.4408 92.481 76.1069 94.0792 76.1069H104.295C105.895 76.1069 107.227 77.4408 107.227 79.034C107.316 80.6395 105.984 81.9734 104.384 81.9734Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ s.jsxs("defs", { children: [
          /* @__PURE__ */ s.jsxs(
            "filter",
            {
              id: "filter0_d_10697_6855",
              x: "20.5488",
              y: "14.3484",
              width: "157.006",
              height: "161.546",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ s.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ s.jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ s.jsx("feOffset", { dy: "11" }),
                /* @__PURE__ */ s.jsx("feGaussianBlur", { stdDeviation: "11" }),
                /* @__PURE__ */ s.jsx(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.270588 0"
                  }
                ),
                /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_10697_6855" }),
                /* @__PURE__ */ s.jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_10697_6855",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_10697_6855",
              x1: "99.0165",
              y1: "22.6255",
              x2: "99.0165",
              y2: "144.159",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#FDFEFF" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "0.9964", stopColor: "#ECF0F5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_10697_6855",
              x1: "43.6352",
              y1: "31.0472",
              x2: "156.229",
              y2: "31.0472",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "rgb(var(--brand-primary))" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "rgb(var(--brand-primary) / 0.7)" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Lk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "428.067px",
      y: "428.067px",
      viewBox: "0 0 428.067 428.067",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M285.376,0c-0.142-0.001-0.284,0-0.426,0.003c-9.726-0.167-17.746,7.583-17.912,17.309
			c-0.003,0.183-0.003,0.366-0.001,0.549v41.142h36V17.861C303.092,8.052,295.185,0.056,285.376,0z`
          }
        ) }) }),
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M327.35,44.003h-8.313v23.222c0.084,4.211-3.261,7.694-7.473,7.778c-0.102,0.002-0.203,0.002-0.305,0h-52.622
			c-4.132,0.068-7.536-3.225-7.605-7.357c-0.002-0.14-0.001-0.281,0.005-0.421V44.003h-136v23.222
			c-0.136,4.421-3.823,7.9-8.245,7.778h-52.62c-4.379,0.113-8.02-3.344-8.134-7.723c0-0.018-0.001-0.037-0.001-0.055V44.003h-7.455
			C20.59,44.094,6.049,58.699,6.037,76.691v34.312h354V76.691C359.959,58.671,345.37,44.082,327.35,44.003z`
          }
        ) }) }),
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("path", { d: "M80.483,0.003c-10.097,0-18.446,7.763-18.446,17.858v41.142h37V17.861C99.037,7.766,90.579,0.003,80.483,0.003z" }) }) }),
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M6.037,127.003v218.913c0,17.941,14.6,33.087,32.545,33.087h148.231c-12.607-21.159-19.283-45.322-19.327-69.952
			c0-74.6,60.728-135.566,135.327-135.566c19.766,0.048,39.288,4.375,57.224,12.683v-59.165H6.037z`
          }
        ) }) }),
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M302.737,189.485c-65.883,0.001-119.29,53.41-119.289,119.293s53.41,119.29,119.293,119.289
			c65.882-0.001,119.289-53.409,119.289-119.291C421.956,242.923,368.59,189.558,302.737,189.485z M349.847,327.003h-53.622
			c-4.493-0.081-8.114-3.707-8.188-8.2v-70.16c0-4.418,3.582-8,8-8s8,3.582,8,8v62.36h45.81c4.418,0,8,3.582,8,8
			S354.265,327.003,349.847,327.003z`
          }
        ) }) })
      ]
    }
  );
}
function Hk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      fill: "rgb(var(--rgb-color-red))",
      width: "21",
      height: "21",
      viewBox: "0 0 21 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.7436 20.08C16.2886 20.08 20.7836 15.5849 20.7836 10.04C20.7836 4.49506 16.2886 0 10.7436 0C5.19867 0 0.703613 4.49506 0.703613 10.04C0.703613 15.5849 5.19867 20.08 10.7436 20.08Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.166 3.59497L11.8445 12.3002H9.02518L8.70368 3.59497H12.166ZM10.4348 16.455C9.95671 16.455 9.54762 16.287 9.20758 15.9511C8.86753 15.6151 8.69957 15.2061 8.70369 14.7238C8.69957 14.2539 8.86753 13.852 9.20758 13.5182C9.54763 13.1843 9.95672 13.0174 10.4348 13.0174C10.8882 13.0174 11.2891 13.1843 11.6374 13.5182C11.9857 13.8521 12.1619 14.2539 12.166 14.7238C12.1619 15.2061 11.9857 15.6152 11.6374 15.9511C11.2891 16.287 10.8882 16.455 10.4348 16.455Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function Pk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_301_2)", children: [
          /* @__PURE__ */ s.jsx("path", { d: "M12 8.13763C9.86904 8.13763 8.13763 9.86904 8.13763 12C8.13763 14.131 9.86904 15.8624 12 15.8624C14.131 15.8624 15.8624 14.131 15.8624 12C15.8624 9.86904 14.131 8.13763 12 8.13763ZM11.707 10.8546C11.2275 10.8546 10.828 11.2542 10.828 11.7336H9.54939C9.57603 10.535 10.535 9.57604 11.707 9.57604V10.8546Z" }),
          /* @__PURE__ */ s.jsx("path", { d: "M23.7203 11.2009C22.4151 9.57605 17.7536 4.27527 12 4.27527C6.24639 4.27527 1.58491 9.57605 0.279689 11.2009C-0.0932297 11.6537 -0.0932297 12.3197 0.279689 12.7991C1.58491 14.424 6.24639 19.7248 12 19.7248C17.7536 19.7248 22.4151 14.424 23.7203 12.7991C24.0932 12.3463 24.0932 11.6804 23.7203 11.2009ZM12 17.5938C8.9101 17.5938 6.40622 15.0899 6.40622 12C6.40622 8.91012 8.9101 6.40623 12 6.40623C15.0899 6.40623 17.5938 8.91012 17.5938 12C17.5938 15.0899 15.0899 17.5938 12 17.5938Z" })
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_301_2", children: /* @__PURE__ */ s.jsx("rect", { width: "24", height: "24", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function Tk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "12",
      height: "23",
      viewBox: "0 0 12 23",
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M11.1133 12.5947L11.7148 8.6416H7.89062V6.06348C7.89062 4.94629 8.40625 3.91504 10.125 3.91504H11.8867V0.520508C11.8867 0.520508 10.2969 0.219727 8.79297 0.219727C5.65625 0.219727 3.59375 2.15332 3.59375 5.59082V8.6416H0.0703125V12.5947H3.59375V22.2197H7.89062V12.5947H11.1133Z" })
    }
  );
}
function jk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.7608 0.608398H1.19002C0.382658 0.608398 -0.0247321 1.588 0.547328 2.16007L7.55151 9.16531V16.9692C7.55151 17.2658 7.69622 17.5438 7.93921 17.7139L10.969 19.834C11.5667 20.2524 12.3992 19.8283 12.3992 19.0893V9.16531L19.4035 2.16007C19.9744 1.58915 19.5698 0.608398 18.7608 0.608398Z"
        }
      )
    }
  );
}
function Vk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.00462 13.1546H15.6384V18.1335C15.6384 18.6023 15.2623 18.981 14.7962 18.981H7.8468C7.38068 18.981 7.00461 18.6023 7.00461 18.1335L7.00462 13.1546ZM21.0702 0.0185547C21.7191 0.0185547 22.1243 0.725675 21.8012 1.28978L19.1872 5.84501H3.45578L0.844472 1.28978C0.518722 0.725675 0.923922 0.0185547 1.57278 0.0185547H21.0702H21.0702ZM4.43038 7.53998H18.2126L15.9641 11.4596H6.67886L4.43038 7.53998Z"
        }
      )
    }
  );
}
function Zh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M-0.000106812 4.07082C-0.000106812 2.90389 0.339278 1.90757 1.05149 1.19147L2.29012 2.43686C0.911525 3.81801 2.11547 8.11214 6.04069 12.0625C9.96591 16.0129 14.2392 17.2222 15.6165 15.8386L16.8552 17.084C14.5315 19.4203 9.23883 17.7627 4.80825 13.3067C1.73521 10.2156 -0.000106812 6.70857 -0.000106812 4.07082Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M7.81099 18.1573C6.65039 18.1573 5.65949 17.8161 4.94604 17.1L6.18467 15.8546C7.56079 17.2382 11.8316 16.0277 15.7605 12.0786C19.6894 8.1294 20.8909 3.83527 19.5148 2.45163L20.7534 1.20624C23.0783 3.5426 21.4285 8.86418 16.9967 13.319C13.9224 16.4138 10.4344 18.1573 7.81099 18.1573Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M17.4053 11.5363C16.6534 9.35934 15.1175 7.03294 13.08 4.98551C8.64939 0.529482 3.35672 -1.12939 1.03305 1.20822C0.868316 1.37511 1.01076 1.78733 1.35262 2.13106C1.69448 2.47479 2.10447 2.61677 2.26921 2.45113C3.64656 1.06749 7.91736 2.27802 11.8451 6.22842C13.703 8.09651 15.0878 10.1826 15.7554 12.1129C16.34 13.8054 16.2831 15.1704 15.6018 15.8553C15.4358 16.021 15.5795 16.4344 15.9201 16.7769C16.2608 17.1194 16.672 17.2639 16.838 17.097C18.0283 15.9002 18.2302 13.9225 17.4053 11.5363Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M20.751 1.20826C19.5582 0.00894456 17.5937 -0.194055 15.218 0.636625C13.0541 1.39134 10.7391 2.93687 8.70281 4.9843C4.27223 9.43909 2.62237 14.7607 4.94604 17.0983C5.11202 17.2639 5.522 17.1207 5.86387 16.7782C6.20573 16.4357 6.34817 16.0223 6.18219 15.8554C4.80236 14.4717 6.01002 10.1776 9.93896 6.22721C11.7969 4.35912 13.8716 2.96676 15.7915 2.29549C17.4748 1.70891 18.8323 1.76495 19.5148 2.44992C19.6795 2.61556 20.0908 2.47234 20.4314 2.12861C20.772 1.78488 20.9157 1.3739 20.751 1.20826Z" })
      ]
    }
  );
}
function Ak(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      viewBox: "-135.4 209.8 604.3 125.4",
      width: "159",
      height: "42",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m67.2 244.4h.2c1.2 0 1.9.9 1.9 2.1v53.9c0 .9-.7 1.9-1.9 1.9-.9 0-1.9-.7-1.9-1.9v-54.1c0-1 .7-1.9 1.7-1.9zm-51.3 2.8h35.3c1.2 0 1.9 1.2 1.9 2.1s-.7 1.9-1.9 1.9h-33.4v22.5h30.2c.9 0 1.9.7 1.9 1.9 0 .9-.7 1.9-1.9 1.9h-29.9v23.2c-.2 1.2-1.2 2.1-2.3 2.1-1.2 0-2.1-.9-2.1-2.1v-51.3h.2a2 2 0 0 1 2-2.2zm102.5 16.7c0-1.2-.9-1.9-1.9-1.9-1.2 0-1.9.9-1.9 1.9v22.5c0 7.7-6.3 13.7-14 13.5-8.2 0-12.9-5.3-12.9-13.7v-22.3c0-1.2-.9-1.9-1.9-1.9-.9 0-1.9.9-1.9 1.9v23c0 9.5 6.1 16.5 16.1 16.5 6.1.2 11.9-3 14.7-8.4v5.8c0 1.2.9 1.9 1.9 1.9 1.2 0 1.9-.9 1.9-1.9h-.2v-36.9zm35.5.3c0 .9-.9 1.6-1.9 1.6h-12.9v25.8c0 5.8 3.3 7.9 8.2 7.9 1.6 0 3.3-.2 4.7-.7.9 0 1.6.7 1.6 1.6 0 .7-.5 1.4-1.2 1.6-1.9.7-4 .9-5.8.9-6.1 0-11.2-3.5-11.2-10.9v-26.2h-4.4c-.9 0-1.9-.9-1.9-1.9 0-.9.9-1.6 1.9-1.6h4.4v-11.1c0-.9.7-1.9 1.6-1.9h.2c.9 0 1.9.9 1.9 1.9v11.1h12.9c1 0 1.9.9 1.9 1.9zm30 1.6c.9 0 1.9-.7 1.9-1.6s-.9-1.9-1.9-1.9h-12.9v-11.1c0-.9-.9-1.9-1.9-1.9h-.2c-.9 0-1.6.9-1.6 1.9v11.1h-4.4c-.9 0-1.9.7-1.9 1.6s.9 1.9 1.9 1.9h4.4v26.2c0 7.4 5.1 10.9 11.2 10.9 1.9 0 4-.2 5.8-.9.7-.2 1.2-.9 1.2-1.6 0-.9-.7-1.6-1.6-1.6-1.4.5-3 .7-4.7.7-4.9 0-8.2-2.1-8.2-7.9v-25.8zm8.9 16.5c0-11.8 8.2-21.1 19.2-21.1 11.5 0 18.7 9.3 18.7 21.1 0 .9-.9 1.9-1.9 1.9h-31.8c.7 10 8 15.8 15.9 15.8 4.9 0 9.8-2.1 13.1-5.6.2-.2.7-.5 1.2-.5.9 0 1.9.9 1.9 1.9 0 .5-.2.9-.7 1.4-4 4.4-9.8 6.7-15.7 6.5-10.8 0-19.9-8.4-19.9-21.1zm53.1-8.4c2.6-6.7 8.9-11.6 16.1-12.1 1.2 0 2.1.9 2.1 2.3 0 .9-.7 2.1-1.9 2.1h-.2c-8.7.9-16.1 7.2-16.1 20.2v14.9c-.2 1.2-.9 1.9-2.1 1.9-.9 0-1.9-.9-1.9-1.9v-37.2c.2-1.2.9-1.9 2.1-1.9.9 0 1.9.9 1.9 1.9zm79.9-14.2c-2.8 0-5.1 1.9-5.8 4.6l-6.8 21.6-6.8-21.6c-.7-2.8-3.3-4.9-6.3-4.9h-.7c-3 0-5.6 1.9-6.3 4.9l-6.8 21.4-6.5-21.6c-.7-2.6-3-4.6-5.8-4.6h-.2c-3 0-5.4 2.6-5.4 5.6 0 .9.2 1.9.5 2.8l10.5 30c.7 3 3.3 5.1 6.5 5.3h.5c3 0 5.6-2.1 6.5-5.1l6.8-21.4 6.8 21.4c.7 3 3.5 5.1 6.5 5.1h.5c3.3 0 6.1-2.1 6.8-5.3l10.5-30.2c.2-.7.5-1.6.5-2.3v-.2c-.1-3.1-2.4-5.5-5.5-5.5zm16.4 2.1c4.4-1.4 8.9-2.3 13.6-2.1 6.5 0 11.2 1.9 14.7 4.9 3.3 3.7 4.9 8.6 4.7 13.5v19c0 3.3-2.6 5.8-5.8 5.8-3 0-5.6-2.1-5.8-5.1-3.3 3.5-8 5.6-12.9 5.3-7.7 0-14.5-4.6-14.5-13 0-9.3 7-13.7 17.1-13.7 3.5 0 7 .5 10.3 1.6v-.7c0-5.1-3-7.7-9.1-7.7-2.8 0-5.6.2-8.4 1.2-.5.2-1.2.2-1.6.2-2.8.2-5.1-1.9-5.1-4.6-.2-2 .9-3.9 2.8-4.6zm69 1.9c.7-2.6 3-4.2 5.6-4.2 3.3 0 5.8 2.6 5.8 5.6v.2c0 .9-.2 1.9-.7 2.8l-12.6 30c-1.2 3-4 4.9-7 5.1h-.7c-3.3-.2-5.8-2.3-6.8-5.3l-13.1-30c-.5-.9-.7-1.9-.7-2.8.2-3.3 2.8-5.6 5.8-5.6 2.8 0 5.1 1.9 5.8 4.4l9.1 24.4zm16.2 19.5c.5 11.6 10.5 20.7 22.2 20 5.4 0 10.5-1.6 14.7-5.1 1.2-.9 1.6-2.1 1.6-3.5v-.2c0-2.6-2.1-4.6-4.7-4.6-.9 0-2.1.2-2.8.9-2.6 1.9-5.6 3-8.7 2.8-5.1.2-9.6-3.3-10.3-8.4h24.1c3-.2 5.4-2.8 5.1-5.8v-.9c0-10.5-9.1-19.3-20.3-19-12.4 0-21.1 10-21.1 22.1v1.7z",
            fill: "#10112b"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m196.7 280.4c.7-8.8 7-15.6 15-15.6 9.1 0 14 7.4 14.5 15.6zm167 7c0 4.6-4 7.4-9.6 7.2-3.7 0-6.5-1.9-6.5-5.1v-.2c0-3.5 3.3-5.8 8.4-5.8 2.6 0 5.4.7 7.7 1.6zm84.7-18.4c-4.9 0-8.2 3.5-9.1 9.1h18c-.7-5.4-4-9.1-8.9-9.1z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m-46.7 217.7c52.6-7.9 18.9 36.9 2.6 49.5 11.2 8.6 22.7 20.7 27.6 34.4 9.1 25.1-13.3 28.8-30.2 22.5-18.5-6.5-34.8-20.4-45.6-36.7-3 0-6.3-.5-9.4-1.4 6.1 17.2 8.7 34.8 7 49.2 0-29-13.8-57.8-33.7-81.8-7-8.4.2-14.6 6.5-6.5 4.3 5.9 8.2 12 11.7 18.3 6.9-23.6 40.5-44.2 63.5-47.5zm-7.5 42.7c10.3-6.3 41.6-39.9 12.4-36.9-16.8 1.9-37.2 17.4-45.6 27.4 11.7-1.4 23.6 3.7 33.2 9.5zm-29 26.1c9.4 10.5 22.2 20.7 36 24.4 8 2.1 16.8 1.2 13.6-10.2-3.3-10.5-11.7-19.7-19.9-26.7-2.3 1.6-4.9 3.3-7.5 4.4-7 3.9-14.5 6.7-22.2 8.1z",
            fill: "#eba12a"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m-87.7 258.3c8-.7 16.6 3.5 23.2 7.7-6.3 3-13.3 4.9-20.6 5.3-10.7.1-12.9-12-2.6-13z",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
function Ek(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "39",
      height: "37",
      viewBox: "0 0 39 37",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.4811 0.50007H2.11624C0.938396 0.50007 0.00390625 1.43427 0.00390625 2.6124V10.899C0.00390625 12.0768 0.978866 13.0113 2.11624 13.0113H14.5055V11.4271C14.5055 8.90872 16.5365 6.8777 19.0549 6.8777C20.2736 6.8777 21.4109 7.36506 22.2637 8.21817C23.1169 9.07134 23.6042 10.2086 23.6042 11.427V13.0112H36.4403C37.6181 13.0112 38.5526 12.0363 38.5526 10.8989V2.61233C38.5931 1.47496 37.6589 0.5 36.4808 0.5L36.4811 0.50007Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.0351 20.078C30.2633 20.078 29.5728 20.4843 29.2073 21.0935V21.053C29.2073 19.8752 28.2323 18.9001 27.0544 18.9001C26.2826 18.9001 25.5921 19.3064 25.2266 19.9156V19.8751C25.2266 18.6972 24.2516 17.7222 23.0737 17.7222C22.3018 17.7222 21.6114 18.1286 21.2458 18.7377L21.2456 11.4261C21.2456 10.8574 21.0019 10.2887 20.5956 9.8824C20.1892 9.47609 19.6614 9.23242 19.0519 9.23242C17.8741 9.23242 16.899 10.2074 16.899 11.3853V25.5212C16.899 25.643 16.8177 25.7649 16.6959 25.8057C16.574 25.8462 16.4522 25.8462 16.3709 25.7244L14.1775 23.531C13.4465 22.8 12.2683 22.6778 11.4155 23.2873C10.8873 23.6123 10.5623 24.181 10.4813 24.7902C10.4 25.3994 10.5626 26.0089 10.9686 26.4963L16.4525 33.1175C17.9962 34.9861 20.2709 36.0421 22.7079 36.0421H26.12C28.0291 36.0421 29.8165 35.3111 31.157 33.9705C32.4974 32.6301 33.2285 30.8427 33.2285 28.9335V22.1905C33.188 21.0531 32.213 20.0784 31.0352 20.0784L31.0351 20.078Z"
          }
        )
      ]
    }
  );
}
function Ik(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "40",
      height: "31",
      viewBox: "0 0 40 31",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.5932 21.2188H16.1055V30.919L24.5932 26.6752V21.2188ZM18.5307 28.13L17.3182 28.9788L17.3179 22.4312H18.5304L18.5307 28.13Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.98047 4.84961L16.1058 20.0059H24.5935L36.7188 4.84961H3.98047ZM18.5308 17.5808H17.197L9.31589 7.27468H18.531L18.5308 17.5808Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.949219 -0.000976562H39.7495V3.63662H0.949219L0.949219 -0.000976562Z"
          }
        )
      ]
    }
  );
}
function Dk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      viewBox: "0 0 1000 148",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_1_2)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M65.2627 67.3465H111.133C112.42 74.9933 113.048 82.7363 113.01 90.4904C113.01 118.43 91.2908 146.786 59.0076 146.786C27.5236 146.786 -0.207335 119.264 0.00116826 81.1078C0.209671 41.0751 30.4079 15.2207 70.4752 15.2207C74.7969 15.2751 79.1124 15.5651 83.4025 16.0895L96.9552 59.0412L91.3256 60.9177L76.9128 47.7472C64.4287 36.4881 55.88 32.7698 47.3748 32.7698C35.6987 32.7698 26.316 41.3184 26.316 58.2072C26.316 89.8997 49.0429 122.635 74.098 122.635C85.9827 122.635 91.8208 118.291 95.9908 113.877L65.2627 73.6016V67.3465ZM232.17 92.7839C232.17 123.191 208.817 147.203 176.708 147.203C144.598 147.203 121.22 123.225 121.22 92.7839C121.22 62.3425 144.572 38.3646 176.682 38.3646C208.791 38.3646 232.17 62.3077 232.17 92.7839ZM194.813 86.9458C186.716 62.3077 176.082 47.5387 163.363 51.7088C150.645 55.8789 150.645 74.0186 158.568 98.622C166.699 123.225 177.333 138.029 190.052 133.859C202.771 129.689 202.771 111.549 194.847 86.9458H194.813ZM339.027 99.6645L341.529 108.005C338.193 126.561 324.224 146.786 296.284 146.786C264.792 146.786 240.188 120.306 240.188 82.1503C240.188 41.0752 270.43 15.2555 307.752 15.2555C312.076 15.2427 316.396 15.533 320.679 16.1242L334.232 59.0759L328.602 60.9524L314.216 47.8167C301.914 36.7661 294.408 32.596 285.859 32.596C274.183 32.596 266.468 41.3531 266.468 58.2419C266.468 89.9344 283.983 118.499 309.628 118.499C325.483 118.43 334.067 109.673 339.036 99.6645H339.027ZM460.585 128.021L462.67 134.693C460.304 138.343 457.061 141.342 453.239 143.418C449.417 145.494 445.135 146.58 440.786 146.578C423.48 146.578 416.391 136.361 411.387 122.6C406.591 135.527 395.54 146.786 375.524 146.786C357.593 146.786 347.793 134.902 347.793 121.974C347.793 104.043 362.562 91.3244 394.289 74.8527C390.328 67.3465 381.362 63.802 371.771 63.802C360.095 63.5935 347.168 68.5976 340.496 77.5632L338.202 70.4741C343.206 56.9214 359.921 38.9901 386.575 38.9901C410.553 38.9901 426.816 53.5853 434.357 76.7292L448.744 120.932C450.829 127.604 454.165 129.481 456.875 129.481C458.253 129.471 459.578 128.951 460.593 128.021H460.585ZM401.587 95.3207L397.243 82.185C385.359 91.1507 379.52 102.618 379.52 110.958C379.52 121.801 384.942 126.805 392.448 126.805C405.305 126.77 408.051 114.677 401.587 95.3207ZM547.783 71.0996L542.361 72.9762C531.068 67.7636 526.932 67.3465 517.55 67.3465C513.741 67.4754 509.991 68.3244 506.499 69.8486V126.144C506.499 131.983 509.418 136.361 517.133 138.655V144.91H464.764V138.655C471.644 136.361 472.27 131.983 472.27 126.144V66.0955C472.27 55.2533 469.142 51.5003 458.091 46.9132V40.6581H506.082L505.213 63.385H505.63L509.592 58.1724C517.515 47.7472 527.523 40.2411 537.323 40.2411H538.191L547.783 71.0996ZM653.919 138.655V144.91H610.959L611.168 131.357H610.125C607.052 135.866 602.905 139.539 598.057 142.045C593.21 144.551 587.815 145.81 582.359 145.709C558.59 145.709 543.786 125.727 543.786 99.8383C543.786 65.8523 566.722 41.2489 604.252 41.2489C607.171 41.2489 610.09 41.4574 610.09 41.4574V32.9435C610.09 23.7694 605.503 20.6418 597.997 20.0163V14.3867L642.408 0H644.285V126.144C644.285 131.983 646.995 136.361 653.885 138.655H653.919ZM610.125 110.715V56.0874C607.682 55.0722 605.055 54.5752 602.41 54.6278C590.109 54.6278 574.888 64.0105 574.888 90.2471C574.888 114.642 584.271 127.986 596.989 127.986C601.75 128.021 610.09 125.727 610.09 110.715H610.125ZM714.802 138.655V144.91H661.426V138.655C668.297 136.361 670.982 131.983 670.982 126.144V32.9435C670.982 23.7694 666.404 20.6418 658.897 20.0163V14.3867L703.291 0H705.168V126.144C705.176 131.983 707.887 136.361 714.768 138.655H714.802ZM823.641 95.4945L825.935 102.584C822.39 126.978 802.582 146.786 776.728 146.786C743.576 146.786 722.308 121.974 722.308 90.6989C722.308 62.134 742.29 39.1986 770.473 39.1986C790.906 39.1986 806.092 51.7088 812.382 68.5975L757.754 105.503C765.469 113.634 776.311 119.264 788.821 119.264C805.883 119.264 818.837 107.379 823.606 95.4945H823.641ZM743.784 71.9336C743.784 81.1078 746.912 90.6989 752.333 98.8653L761.498 90.1081C767.753 84.27 772.966 77.8065 772.966 68.8408C772.966 61.9602 768.379 53.8286 759.205 53.8286C750.63 53.7938 743.749 60.2574 743.749 71.9336H743.784ZM884.072 78.8142C904.297 89.0309 912.429 99.039 912.429 113.009C912.429 129.897 898.876 146.786 869.859 146.786C854.43 146.786 845.464 144.284 837.958 141.157L828.159 110.75L833.58 109.082L838.375 113.669C853.144 127.639 865.898 136.813 875.732 136.813C883.03 136.813 887.026 132.226 887.026 127.43C887.026 122.843 886.157 117.422 873.682 111.167L855.125 101.784C838.862 93.4442 831.147 83.2275 831.147 71.5514C831.147 51.5698 848.661 39.8589 871.18 39.8589C886.4 39.8589 894.949 41.9439 894.949 41.9439L903.498 68.4238L898.077 70.0919L894.741 67.1728C877.435 51.952 871.388 48.8245 864.091 48.8245C858.878 48.8245 854.534 52.1605 854.534 56.7476C854.534 60.0837 855.16 64.2537 865.585 69.4663L884.072 78.8142ZM971.644 79.0227C991.625 89.4479 1000 99.0043 1000 113.009C1000 129.897 986.447 146.786 957.431 146.786C942.001 146.786 933.036 144.284 925.53 141.157L915.73 110.75L921.151 109.082L925.947 113.669C940.716 127.639 953.469 136.813 963.303 136.813C970.601 136.813 974.597 132.226 974.597 127.43C974.597 122.843 973.729 117.631 961.253 111.167L942.696 101.611C926.433 93.2704 918.718 83.2623 918.718 71.5861C918.718 51.6045 936.233 39.8936 958.751 39.8936C973.972 39.8936 982.52 41.9787 982.52 41.9787L991.069 68.4586L985.648 70.1266L982.312 67.2075C965.006 51.9868 958.96 48.8592 951.662 48.8592C946.449 48.8592 942.106 52.1953 942.106 56.7824C942.106 60.1184 942.731 64.08 953.156 69.5011L971.644 79.0227Z",
            fill: "#1C1B18"
          }
        ) }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_1_2", children: /* @__PURE__ */ s.jsx("rect", { width: "1000", height: "148", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function Gh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "56",
      height: "59",
      viewBox: "0 0 56 59",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 58.165C43.464 58.165 56 45.181 56 29.165C56 27.12 55.817 25.101 55.464 23.137H27.512L47.768 45.165C26.4 63.072 0.073 17.275 13.577 8.73C15.863 7.283 19.133 7.127 23.385 8.263L24.03 8.443C24.248 8.506 24.468 8.573 24.69 8.643L25.365 8.861L25.708 8.978L26.404 9.226C26.757 9.354 27.114 9.491 27.477 9.634L28.211 9.93L28.959 10.246C29.211 10.354 29.466 10.466 29.722 10.581L30.5 10.935L31.293 11.309L32.1 11.702L32.923 12.115L33.339 12.328L34.183 12.77L35.043 13.23L35.916 13.711L36.805 14.211L37.255 14.468L38.165 14.997L39.09 15.545C39.246 15.638 39.402 15.731 39.558 15.826L40.985 16.699L41.955 17.305L42.939 17.931L43.938 18.576L44.952 19.24L45.98 19.924L47.023 20.627L48.616 21.718L49.154 22.091L38.543 1.11C36.197 0.207001 33.228 0.038 30.418 0.00699997L28.95 0H28C12.536 0 0 13.149 0 29.165C0 45.181 12.536 58.165 28 58.165Z"
        }
      )
    }
  );
}
function Nk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "50",
      height: "50",
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_244030_522)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.2401 32.2565C16.2565 31.5921 15.5756 30.6217 15.2039 29.3388L17.4868 28.3979C17.694 29.1874 18.0558 29.7992 18.5723 30.2335C19.0855 30.6677 19.7105 30.8815 20.4408 30.8815C21.1875 30.8815 21.829 30.6546 22.3651 30.2006C22.9013 29.7467 23.171 29.1677 23.171 28.467C23.171 27.7499 22.8881 27.1644 22.3223 26.7104C21.7565 26.2565 21.046 26.0295 20.1973 26.0295H18.8783V23.7696H20.0625C20.7927 23.7696 21.4079 23.5723 21.9079 23.1775C22.4079 22.7828 22.6579 22.2434 22.6579 21.5559C22.6579 20.944 22.4341 20.4571 21.9868 20.0921C21.5394 19.727 20.9736 19.5428 20.2861 19.5428C19.615 19.5428 19.0822 19.7204 18.6874 20.079C18.2926 20.4376 18.0064 20.8783 17.8255 21.398L15.5657 20.4572C15.865 19.6085 16.4144 18.8585 17.2203 18.2105C18.0262 17.5625 19.0558 17.2368 20.3058 17.2368C21.2301 17.2368 22.0624 17.4145 22.7993 17.773C23.5361 18.1316 24.1151 18.6283 24.5329 19.2599C24.9506 19.8947 25.1579 20.6053 25.1579 21.3947C25.1579 22.2007 24.9638 22.8815 24.5756 23.4408C24.1875 24 23.7105 24.4276 23.1447 24.727V24.8619C23.8914 25.1744 24.5 25.6514 24.9802 26.2929C25.4572 26.9343 25.6973 27.7008 25.6973 28.5955C25.6973 29.4902 25.4704 30.2895 25.0164 30.9902C24.5625 31.6909 23.9341 32.2436 23.138 32.6448C22.3387 33.0461 21.4407 33.2501 20.444 33.2501C19.2894 33.2533 18.2237 32.9211 17.2401 32.2565Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M31.2632 20.9277L28.7565 22.7402L27.5033 20.8388L32 17.5955H33.7237V32.8948H31.2632V20.9277Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M38.1579 38.158H11.8421L8.07507 43.7084L11.8421 50H38.1579L41.27 43.3061L38.1579 38.158Z",
              fill: "#00A94B"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M38.1579 0H3.94736C1.76641 0 0 1.76641 0 3.94736V38.1579L5.92109 42.3672L11.8422 38.1579V11.8421H38.158L42.209 5.921L38.1579 0Z",
              fill: "#0085F7"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M0 38.158V46.0527C0 48.2336 1.76641 50 3.94736 50H11.8421V38.158H0Z",
              fill: "#00802E"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M50 11.8422L44.079 8.03223L38.158 11.8422V38.158L43.4831 40.9376L50 38.158V11.8422Z",
              fill: "#FFBC00"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M50 11.8421V3.94736C50 1.76641 48.2336 0 46.0527 0H38.158V11.8421H50Z",
              fill: "#0067D5"
            }
          ),
          /* @__PURE__ */ s.jsx("path", { d: "M38.158 50L50 38.158H38.158V50Z", fill: "#FF4131" })
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_244030_522", children: /* @__PURE__ */ s.jsx("rect", { width: "50", height: "50", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function Rk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_16011_9270)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M24.2663 12.7765C24.2663 11.9608 24.2001 11.1406 24.059 10.3381H12.7402V14.9591H19.222C18.953 16.4495 18.0888 17.7679 16.8233 18.6056V21.604H20.6903C22.9611 19.514 24.2663 16.4274 24.2663 12.7765Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M12.74 24.5008C15.9764 24.5008 18.7058 23.4382 20.6944 21.6039L16.8274 18.6055C15.7516 19.3375 14.3626 19.752 12.7444 19.752C9.61376 19.752 6.95934 17.6399 6.00693 14.8003H2.01648V17.8912C4.05359 21.9434 8.20278 24.5008 12.74 24.5008Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M6.00277 14.8002C5.50011 13.3099 5.50011 11.696 6.00277 10.2057V7.11475H2.01674C0.314734 10.5055 0.314734 14.5004 2.01674 17.8912L6.00277 14.8002Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M12.74 5.24966C14.4508 5.2232 16.1043 5.86697 17.3433 7.04867L20.7694 3.62262C18.6 1.5855 15.7207 0.465534 12.74 0.500809C8.20277 0.500809 4.05359 3.05822 2.01648 7.11481L6.00252 10.2058C6.95052 7.36173 9.60935 5.24966 12.74 5.24966Z",
              fill: "#EA4335"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_16011_9270", children: /* @__PURE__ */ s.jsx(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "rgb(var(--background-secondary))",
            transform: "translate(0.5 0.5)"
          }
        ) }) })
      ]
    }
  );
}
function Fk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "51",
      height: "50",
      viewBox: "0 0 51 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_244030_448)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M28.7856 24.9651L33.6599 30.5368L40.2151 34.7253L41.3553 25.0003L40.2151 15.4946L33.5345 19.174L28.7856 24.9651Z",
              fill: "#00832D"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M0.500122 33.8203V42.1074C0.500122 43.9997 2.03592 45.5359 3.92856 45.5359H12.2157L13.9317 39.2745L12.2157 33.8203L6.53017 32.1042L0.500122 33.8203Z",
              fill: "#0066DA"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M12.2156 4.39453L0.5 16.1101L6.53041 17.8222L12.2156 16.1101L13.9004 10.7303L12.2156 4.39453Z",
              fill: "#E94235"
            }
          ),
          /* @__PURE__ */ s.jsx("path", { d: "M0.500122 33.8242H12.2157V16.1101H0.500122V33.8242Z", fill: "#2684FC" }),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M47.699 9.35504L40.2151 15.495V34.7253L47.7302 40.8891C48.8551 41.7704 50.5008 40.9671 50.5008 39.5372V10.6794C50.5008 9.23355 48.8159 8.43429 47.699 9.35504Z",
              fill: "#00AC47"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M28.7856 24.9651V33.8201H12.2157V45.5357H36.7867C38.6793 45.5357 40.2151 43.9996 40.2151 42.1073V34.7253L28.7856 24.9651Z",
              fill: "#00AC47"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M36.7867 4.39453H12.2157V16.1101H28.7856V24.9652L40.2151 15.4947V7.82297C40.2151 5.93033 38.6793 4.39453 36.7867 4.39453Z",
              fill: "#FFBA00"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_244030_448", children: /* @__PURE__ */ s.jsx(
          "rect",
          {
            width: "50",
            height: "50",
            fill: "rgb(var(--background-secondary))",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
function Ok(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "42",
      height: "42",
      viewBox: "0 0 37 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("mask", { id: "mask0_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L28.2806 8.44208L22.8469 0.715088Z",
            fill: "#0F9D58"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask1_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask1_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M9.80603 24.448V40.4539H27.1938V24.448H9.80603ZM17.4132 38.2462H11.9795V35.4866H17.4132V38.2462ZM17.4132 33.8308H11.9795V31.0711H17.4132V33.8308ZM17.4132 29.4153H11.9795V26.6557H17.4132V29.4153ZM25.0203 38.2462H19.5866V35.4866H25.0203V38.2462ZM25.0203 33.8308H19.5866V31.0711H25.0203V33.8308ZM25.0203 29.4153H19.5866V26.6557H25.0203V29.4153Z",
            fill: "#F1F1F1"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask2_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask2_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M23.8005 12.9927L35.8877 25.2676V13.9613L23.8005 12.9927Z",
            fill: "url(#paint0_linear_204047_1574)"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask3_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask3_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088V10.6498C22.8469 12.4794 24.3059 13.9614 26.1071 13.9614H35.8877L22.8469 0.715088Z",
            fill: "#87CEAC"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask4_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask4_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M4.37239 0.715088C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V4.30262C1.11218 2.48126 2.57927 0.991052 4.37239 0.991052H22.8469V0.715088H4.37239Z",
            fill: "rgb(var(--background-secondary))",
            "fill-opacity": "0.2"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask5_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask5_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M32.6275 49.0088H4.37239C2.57927 49.0088 1.11218 47.5186 1.11218 45.6973V45.9732C1.11218 47.7946 2.57927 49.2848 4.37239 49.2848H32.6275C34.4206 49.2848 35.8877 47.7946 35.8877 45.9732V45.6973C35.8877 47.5186 34.4206 49.0088 32.6275 49.0088Z",
            fill: "#263238",
            "fill-opacity": "0.2"
          }
        ) }),
        /* @__PURE__ */ s.jsx("mask", { id: "mask6_204047_1574", maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "35", height: "50", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "rgb(var(--background-secondary))"
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", { mask: "url(#mask6_204047_1574)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M26.1071 13.9615C24.3059 13.9615 22.8469 12.4795 22.8469 10.6499V10.9259C22.8469 12.7555 24.3059 14.2374 26.1071 14.2374H35.8877V13.9615H26.1071Z",
            fill: "#263238",
            "fill-opacity": "0.1"
          }
        ) }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.8469 0.715088H4.37239C2.57927 0.715088 1.11218 2.20529 1.11218 4.02665V45.9732C1.11218 47.7945 2.57927 49.2847 4.37239 49.2847H32.6275C34.4206 49.2847 35.8877 47.7945 35.8877 45.9732V13.9614L22.8469 0.715088Z",
            fill: "url(#paint1_radial_204047_1574)"
          }
        ),
        /* @__PURE__ */ s.jsxs("defs", { children: [
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_204047_1574",
              x1: "628.226",
              y1: "118.386",
              x2: "628.226",
              y2: "1240.65",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { "stop-color": "#263238", "stop-opacity": "0.2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", "stop-color": "#263238", "stop-opacity": "0.02" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "radialGradient",
            {
              id: "paint1_radial_204047_1574",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(111.283 96.7101) scale(5607.5 5695.85)",
              children: [
                /* @__PURE__ */ s.jsx("stop", { "stop-color": "rgb(var(--background-secondary))", "stop-opacity": "0.1" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", "stop-color": "rgb(var(--background-secondary))", "stop-opacity": "0" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Bk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.869867 10.9274C0.869867 5.15351 5.55026 0.473122 11.3242 0.473122C17.0981 0.473122 21.7785 5.15351 21.7785 10.9274C21.7785 16.7013 17.0981 21.3817 11.3242 21.3817C5.55026 21.3817 0.869867 16.7013 0.869867 10.9274Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1975 12.8669C10.9228 12.8669 10.6604 12.7501 10.4774 12.5465C10.2946 12.3431 10.2057 12.0701 10.2336 11.7977C10.2613 11.252 10.523 10.826 10.7376 10.5647C11.0523 10.1809 11.4523 9.92014 11.6096 9.82584C12.057 9.56003 12.2495 9.17438 12.1378 8.76777C12.0212 8.34333 11.6082 8.02326 11.1771 8.02326C10.9567 8.02326 10.6358 8.10724 10.3595 8.50733C10.1919 8.81736 9.86876 9.01224 9.51626 9.01584L9.50642 9.0159C9.15736 9.0159 8.83386 8.82687 8.66216 8.52261C8.4886 8.21505 8.49618 7.83743 8.68195 7.53708C9.19944 6.6402 10.1639 6.08301 11.199 6.08301C11.4528 6.08301 11.7063 6.11655 11.9526 6.18262C13.2208 6.52213 14.1071 7.67682 14.108 8.99063C14.108 9.95065 13.5643 10.8563 12.6537 11.4134C12.4017 11.5674 12.3087 11.8271 12.2187 12.0783C12.0798 12.4661 11.9362 12.8669 11.1975 12.8669ZM11.1975 15.7748C10.663 15.7748 10.2282 15.34 10.2282 14.8055C10.2282 14.2711 10.663 13.8362 11.1975 13.8362C11.7319 13.8362 12.1667 14.271 12.1667 14.8055C12.1667 15.34 11.7319 15.7748 11.1975 15.7748Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function Zk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      fill: "rgb(var(--text-primary))",
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24px",
      height: "24px",
      viewBox: "0 0 495.398 495.398",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
  v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
  c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
  c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z`
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
  c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
  c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z`
          }
        )
      ] }) }) })
    }
  );
}
function Kh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "26",
      height: "22",
      viewBox: "0 0 26 22",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M7.62919 4.03262V19.4089H14.3212C20.3975 19.4089 23.0326 15.9768 23.0326 11.1231C23.0326 6.47761 20.3975 2.87352 14.3212 2.87352H8.78829C8.14535 2.87352 7.62919 3.39874 7.62919 4.03262Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M2.73866 21.7997H13.5509C17.3649 21.7997 20.3397 20.8565 22.3619 19.0428C24.3859 17.2276 25.4412 14.5533 25.4412 11.1229C25.4412 9.1476 25.0571 6.48868 23.3725 4.32192C21.6842 2.15039 18.704 0.491309 13.5509 0.491309H2.73866C1.72355 0.491309 0.9 1.31485 0.9 2.32997V19.961C0.9 20.9762 1.72355 21.7997 2.73866 21.7997ZM1.67955 2.32997C1.67955 1.74225 2.15095 1.27086 2.73866 1.27086H13.5509C15.6357 1.27086 18.4163 1.59408 20.6727 2.98558C22.9212 4.37219 24.6617 6.82698 24.6617 11.1229C24.6617 14.3254 23.6728 16.7946 21.7996 18.4647C19.9246 20.1364 17.1491 21.0202 13.5509 21.0202H2.73866C2.15095 21.0202 1.67955 20.5488 1.67955 19.961V2.32997Z",
            strokeWidth: "0.2"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M9.9854 9.04946C10.2208 9.04946 10.4382 9.08568 10.6464 9.15813C10.8547 9.23057 11.0268 9.34829 11.1807 9.49318C11.3256 9.64712 11.4433 9.83729 11.5339 10.0546C11.6154 10.281 11.6607 10.5436 11.6607 10.8515C11.6607 11.1232 11.6244 11.3677 11.5611 11.5941C11.4886 11.8204 11.389 12.0197 11.2532 12.1827C11.1173 12.3457 10.9453 12.4724 10.737 12.5721C10.5287 12.6626 10.2842 12.7169 10.0035 12.7169H8.41879V9.04041H9.9854V9.04946ZM9.93106 12.0468C10.0488 12.0468 10.1575 12.0287 10.2752 11.9925C10.3838 11.9563 10.4834 11.8929 10.5649 11.8023C10.6464 11.7118 10.7189 11.6031 10.7732 11.4582C10.8276 11.3133 10.8547 11.1503 10.8547 10.9421C10.8547 10.761 10.8366 10.5889 10.8004 10.444C10.7642 10.2991 10.7008 10.1633 10.6193 10.0637C10.5378 9.96407 10.4291 9.87351 10.2933 9.81918C10.1575 9.76485 9.99445 9.73768 9.79523 9.73768H9.21568V12.0559H9.93106V12.0468Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M14.9314 9.04946V9.72862H12.9935V10.5165H14.7775V11.1413H12.9935V12.0378H14.9767V12.7169H12.1876V9.04041H14.9314V9.04946Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M17.7008 9.04926L19.0773 12.7258H18.2351L17.9544 11.9108H16.5779L16.2882 12.7258H15.4732L16.8587 9.04926H17.7008ZM17.7461 11.3041L17.2843 9.95482H17.2752L16.7953 11.3041H17.7461Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M20.3893 9.04926V12.0466H22.1823V12.7258H19.5834V9.04926H20.3893Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M4.60354 12.5799C5.53877 12.5799 6.29693 11.8217 6.29693 10.8865C6.29693 9.95125 5.53877 9.1931 4.60354 9.1931C3.66832 9.1931 2.91016 9.95125 2.91016 10.8865C2.91016 11.8217 3.66832 12.5799 4.60354 12.5799Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M5.87874 19.4088C4.45703 19.4088 3.31603 18.2588 3.31603 16.8461V14.8449C3.31603 14.1385 3.88653 13.559 4.60192 13.559C5.30825 13.559 5.8878 14.1295 5.8878 14.8449V19.4088H5.87874Z",
            stroke: "none"
          }
        )
      ]
    }
  );
}
function Gk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "rgb(var(--rgb-color-red))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 0.759766C3.13428 0.759766 0 3.89518 0 7.75977C0 11.6266 3.13428 14.7598 7 14.7598C10.8657 14.7598 14 11.6266 14 7.75977C14 3.89518 10.8657 0.759766 7 0.759766ZM7 3.86461C7.65473 3.86461 8.18548 4.39537 8.18548 5.05009C8.18548 5.70482 7.65472 6.23557 7 6.23557C6.34527 6.23557 5.81452 5.70481 5.81452 5.05009C5.81452 4.39536 6.34528 3.86461 7 3.86461ZM8.58065 11.034C8.58065 11.221 8.42899 11.3727 8.24194 11.3727H5.75807C5.57102 11.3727 5.41936 11.221 5.41936 11.034V10.3565C5.41936 10.1695 5.57102 10.0178 5.75807 10.0178H6.09678V8.21139H5.75807C5.57102 8.21139 5.41936 8.05973 5.41936 7.87268V7.19526C5.41936 7.00821 5.57102 6.85655 5.75807 6.85655H7.56452C7.75157 6.85655 7.90323 7.00821 7.90323 7.19526V10.0178H8.24194C8.42899 10.0178 8.58065 10.1695 8.58065 10.3565V11.034Z"
        }
      )
    }
  );
}
function Kk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M10 5.27832C7.25 5.27832 5.05859 7.5127 5.05859 10.2197C5.05859 12.9697 7.25 15.1611 10 15.1611C12.707 15.1611 14.9414 12.9697 14.9414 10.2197C14.9414 7.5127 12.707 5.27832 10 5.27832ZM10 13.4424C8.23828 13.4424 6.77734 12.0244 6.77734 10.2197C6.77734 8.45801 8.19531 7.04004 10 7.04004C11.7617 7.04004 13.1797 8.45801 13.1797 10.2197C13.1797 12.0244 11.7617 13.4424 10 13.4424ZM16.2734 5.10645C16.2734 4.46191 15.7578 3.94629 15.1133 3.94629C14.4688 3.94629 13.9531 4.46191 13.9531 5.10645C13.9531 5.75098 14.4688 6.2666 15.1133 6.2666C15.7578 6.2666 16.2734 5.75098 16.2734 5.10645ZM19.5391 6.2666C19.4531 4.71973 19.1094 3.34473 17.9922 2.22754C16.875 1.11035 15.5 0.766602 13.9531 0.680664C12.3633 0.594727 7.59375 0.594727 6.00391 0.680664C4.45703 0.766602 3.125 1.11035 1.96484 2.22754C0.847656 3.34473 0.503906 4.71973 0.417969 6.2666C0.332031 7.85645 0.332031 12.626 0.417969 14.2158C0.503906 15.7627 0.847656 17.0947 1.96484 18.2549C3.125 19.3721 4.45703 19.7158 6.00391 19.8018C7.59375 19.8877 12.3633 19.8877 13.9531 19.8018C15.5 19.7158 16.875 19.3721 17.9922 18.2549C19.1094 17.0947 19.4531 15.7627 19.5391 14.2158C19.625 12.626 19.625 7.85645 19.5391 6.2666ZM17.4766 15.8916C17.1758 16.751 16.4883 17.3955 15.6719 17.7393C14.3828 18.2549 11.375 18.126 10 18.126C8.58203 18.126 5.57422 18.2549 4.32812 17.7393C3.46875 17.3955 2.82422 16.751 2.48047 15.8916C1.96484 14.6455 2.09375 11.6377 2.09375 10.2197C2.09375 8.84473 1.96484 5.83691 2.48047 4.54785C2.82422 3.73145 3.46875 3.08691 4.32812 2.74316C5.57422 2.22754 8.58203 2.35645 10 2.35645C11.375 2.35645 14.3828 2.22754 15.6719 2.74316C16.4883 3.04395 17.1328 3.73145 17.4766 4.54785C17.9922 5.83691 17.8633 8.84473 17.8633 10.2197C17.8633 11.6377 17.9922 14.6455 17.4766 15.8916Z" })
    }
  );
}
function zk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "62",
      height: "61",
      viewBox: "0 0 62 61",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M61.2057 20.3732L31.177 10.6053C31.1132 10.5839 31.0431 10.5839 30.9788 10.6053L0.796722 20.2243C0.663818 20.2671 0.573254 20.3898 0.571795 20.5291C0.570325 20.6688 0.658446 20.793 0.789891 20.8382L8.16392 23.365V32.1202C6.92583 32.6762 6.06268 33.9173 6.06268 35.3623C6.06268 36.8073 6.92684 38.0493 8.16392 38.6044L6.2252 51.0892H12.6879L11.0725 38.6044C12.3106 38.0488 13.1737 36.8073 13.1737 35.3623C13.1737 33.9173 12.3105 32.6762 11.0725 32.1202V24.3611L30.8698 31.1446C30.9034 31.1563 30.9389 31.1621 30.974 31.1621C31.009 31.1621 31.0446 31.1568 31.0782 31.1451L61.2091 20.9872C61.3416 20.9424 61.4297 20.8182 61.4287 20.6795C61.4273 20.5393 61.3377 20.4166 61.2057 20.3732H61.2057Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M30.3448 32.6736C30.5468 32.7427 30.7571 32.7788 30.9709 32.7788L30.9707 32.7788C31.1835 32.7788 31.3943 32.7453 31.5944 32.6766L47.8558 27.1946L47.856 32.4866C47.2868 32.3887 46.7016 32.3377 46.1044 32.3377C40.4374 32.3377 35.8434 36.9317 35.8434 42.5987C35.8434 43.2254 35.8996 43.839 36.0072 44.4347C34.4896 44.5954 32.8808 44.6818 31.2148 44.6818C22.0236 44.6818 14.5732 42.0537 14.5732 38.8116V27.27L30.3448 32.6736Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M55.9797 43.4498C55.9797 48.4093 51.9593 52.4297 46.9999 52.4297C42.0404 52.4297 38.02 48.4093 38.02 43.4498C38.02 38.4904 42.0404 34.47 46.9999 34.47C51.9593 34.47 55.9797 38.4904 55.9797 43.4498ZM45.9615 48.2046L52.6239 41.5421C52.8502 41.3159 52.8502 40.9491 52.6239 40.7228L51.8046 39.9035C51.5784 39.6773 51.2116 39.6773 50.9853 39.9035L45.5518 45.337L43.015 42.8002C42.7888 42.574 42.422 42.574 42.1957 42.8002L41.3764 43.6195C41.1502 43.8458 41.1502 44.2126 41.3764 44.4388L45.1421 48.2046C45.3684 48.4309 45.7352 48.4309 45.9615 48.2046Z",
            fill: "rgb(var(--text-primary))"
          }
        )
      ]
    }
  );
}
function Uk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "62",
      height: "61",
      viewBox: "0 0 62 61",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M61.2057 19.8732L31.177 10.1053C31.1132 10.0839 31.0431 10.0839 30.9788 10.1053L0.796722 19.7243C0.663818 19.7671 0.573254 19.8898 0.571795 20.0291C0.570325 20.1688 0.658446 20.293 0.789891 20.3382L8.16392 22.865V31.6202C6.92583 32.1762 6.06268 33.4173 6.06268 34.8623C6.06268 36.3073 6.92684 37.5493 8.16392 38.1044L6.2252 50.5892H12.6879L11.0725 38.1044C12.3106 37.5488 13.1737 36.3073 13.1737 34.8623C13.1737 33.4173 12.3105 32.1762 11.0725 31.6202V23.8611L30.8698 30.6446C30.9034 30.6563 30.9389 30.6621 30.974 30.6621C31.009 30.6621 31.0446 30.6568 31.0782 30.6451L61.2091 20.4872C61.3416 20.4424 61.4297 20.3182 61.4287 20.1795C61.4273 20.0393 61.3377 19.9166 61.2057 19.8732H61.2057Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M30.3448 32.1736C30.5468 32.2427 30.7571 32.2788 30.9709 32.2788L30.9707 32.2788C31.1835 32.2788 31.3943 32.2453 31.5944 32.1766L47.8558 26.6946L47.8561 33.8471C48.1853 33.8106 48.5199 33.7919 48.8589 33.7919C53.8294 33.7919 57.8589 37.8213 57.8589 42.7919C57.8589 47.7624 53.8294 51.7919 48.8589 51.7919C44.0674 51.7919 40.1505 48.0476 39.8744 43.3254C37.3517 43.8687 34.3869 44.1818 31.2148 44.1818C22.0236 44.1818 14.5732 41.5537 14.5732 38.3116V26.77L30.3448 32.1736ZM48.8589 38.2919C49.4802 38.2919 49.9839 38.7956 49.9839 39.4169V41.6669H52.2339C52.8552 41.6669 53.3589 42.1706 53.3589 42.7919C53.3589 43.4132 52.8552 43.9169 52.2339 43.9169H49.9839V46.1669C49.9839 46.7882 49.4802 47.2919 48.8589 47.2919C48.2376 47.2919 47.7339 46.7882 47.7339 46.1669V43.9169H45.4839C44.8626 43.9169 44.3589 43.4132 44.3589 42.7919C44.3589 42.1706 44.8626 41.6669 45.4839 41.6669H47.7339V39.4169C47.7339 38.7956 48.2376 38.2919 48.8589 38.2919Z",
            fill: "rgb(var(--text-primary))"
          }
        )
      ]
    }
  );
}
function Yk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M108.626 9.37702C106.207 6.23306 103.044 4.19437 99.1534 3.38398C94.2932 2.36994 89.8362 3.36489 85.8797 6.36247C83.5185 8.15084 81.8066 10.3741 80.7331 12.9962C80.3577 13.9084 80.0627 14.8694 79.8421 15.8771C79.6936 16.5666 79.6342 17.2772 79.5324 17.9773C79.5175 18.0897 79.4942 18.2022 79.4751 18.3146V20.2197C79.4878 20.3088 79.4985 20.3957 79.5091 20.4848C79.5748 21.0131 79.6299 21.5413 79.7275 22.0653C79.8866 22.916 80.0967 23.7306 80.3597 24.5113C81.5923 28.1984 83.9683 31.1068 87.4453 33.2389C89.6176 34.569 91.9958 35.2967 94.5415 35.477C94.6242 35.4833 94.7048 35.5109 94.7854 35.5279H96.6927C97.3079 35.4452 97.9294 35.3836 98.5425 35.2754C99.6965 35.0697 100.791 34.7599 101.829 34.3463C104.164 33.415 106.205 31.9575 107.949 29.9846C110.246 27.3858 111.585 24.3416 111.916 20.8943C112.325 16.6387 111.239 12.7713 108.626 9.37702ZM105.299 16.2441C105.178 16.4032 105.04 16.5538 104.898 16.6938C103.473 18.1216 102.047 19.5472 100.619 20.9728C98.7546 22.8396 96.8878 24.7065 95.0209 26.5733C93.9008 27.6913 92.5665 27.6913 91.4464 26.5733C90.759 25.886 90.0695 25.1987 89.3821 24.5113C88.4232 23.5545 87.4644 22.5957 86.5076 21.6346C86.1597 21.2846 85.9264 20.8921 85.8118 20.4848C85.6124 19.7805 85.7694 19.0338 86.2892 18.408C87.0592 17.4851 88.4976 17.3409 89.431 18.0961C89.571 18.2107 89.7025 18.3337 89.8298 18.4589C90.8884 19.5132 91.9427 20.5697 92.997 21.624C93.0713 21.6962 93.1477 21.7662 93.2877 21.8977C93.3641 21.7874 93.4171 21.6792 93.4998 21.5965C94.9912 20.103 96.4847 18.6095 97.9803 17.116C99.2171 15.8771 100.454 14.6403 101.691 13.4014C102.393 12.6971 103.205 12.4192 104.177 12.7225C105.632 13.1744 106.226 15.037 105.299 16.2441Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M61.0972 101.248V94.4592H40.7315V101.248H27.1543V108.036H74.6743V101.248H61.0972Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M95.738 37.7766C87.3351 37.7766 80.2409 32.1803 77.9816 24.5113H48.6104C47.503 24.5113 46.5972 23.6055 46.5972 22.4981C46.5972 21.9444 46.8242 21.4416 47.1891 21.0767C47.554 20.7119 48.0567 20.4849 48.6104 20.4849H77.2667C77.2391 20.0818 77.2264 19.6745 77.2264 19.265C77.2264 17.0651 77.6103 14.9543 78.3147 12.9962H13.5772C6.09063 12.9962 0 19.0868 0 26.5734V74.0934C0 81.5821 6.09063 87.6706 13.5772 87.6706H88.2515C95.738 87.6706 101.829 81.5821 101.829 74.0934V36.7499C99.9215 37.416 97.8722 37.7766 95.738 37.7766ZM26.0893 20.4849C27.201 20.4849 28.1025 21.3865 28.1025 22.4981C28.1025 23.6097 27.201 24.5113 26.0893 24.5113C24.9777 24.5113 24.0761 23.6097 24.0761 22.4981C24.0761 21.3865 24.9777 20.4849 26.0893 20.4849ZM18.3291 20.4849C19.4408 20.4849 20.3423 21.3865 20.3423 22.4981C20.3423 23.6097 19.4408 24.5113 18.3291 24.5113C17.2175 24.5113 16.3159 23.6097 16.3159 22.4981C16.3159 21.3865 17.2175 20.4849 18.3291 20.4849ZM8.55564 22.4981C8.55564 21.3865 9.4573 20.4849 10.5689 20.4849C11.6806 20.4849 12.5822 21.3865 12.5822 22.4981C12.5822 23.6097 11.6806 24.5113 10.5689 24.5113C9.4573 24.5113 8.55564 23.6097 8.55564 22.4981ZM27.1543 72.5087C18.5349 72.5087 11.5469 65.5207 11.5469 56.9035C11.5469 48.2862 18.5349 41.2961 27.1543 41.2961C35.7737 41.2961 42.7596 48.2841 42.7596 56.9035C42.7596 65.5228 35.7737 72.5087 27.1543 72.5087ZM86.3443 71.745C85.8733 72.2159 85.2242 72.5087 84.5093 72.5087H55.9378C54.508 72.5087 53.3391 71.3398 53.3391 69.9121C53.3391 69.1972 53.6318 68.548 54.1028 68.0792C54.5737 67.6082 55.2229 67.3154 55.9378 67.3154H84.5093C85.9391 67.3154 87.108 68.4843 87.108 69.9121C87.108 70.627 86.8152 71.2761 86.3443 71.745ZM86.3443 58.7364C85.8733 59.2073 85.2242 59.5001 84.5093 59.5001H55.9378C54.508 59.5001 53.3391 58.3312 53.3391 56.9035C53.3391 56.1885 53.6318 55.5394 54.1028 55.0684C54.5737 54.5975 55.2229 54.3047 55.9378 54.3047H84.5093C85.9391 54.3047 87.108 55.4736 87.108 56.9035C87.108 57.6184 86.8152 58.2675 86.3443 58.7364ZM86.3443 45.7256C85.8733 46.1966 85.2242 46.4894 84.5093 46.4894H55.9378C54.508 46.4894 53.3391 45.3204 53.3391 43.8927C53.3391 43.1799 53.6318 42.5308 54.1028 42.0598C54.5737 41.5889 55.2229 41.2961 55.9378 41.2961H84.5093C85.9391 41.2961 87.108 42.465 87.108 43.8927C87.108 44.6055 86.8152 45.2547 86.3443 45.7256Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M22.6653 53.331V60.4717C22.6653 61.5854 23.8384 62.311 24.8355 61.8124L31.9763 58.2421C33.0815 57.6905 33.0815 56.1122 31.9763 55.5606L24.8355 51.9902C23.8384 51.4917 22.6653 52.2172 22.6653 53.331Z" })
      ]
    }
  );
}
function Wk(e) {
  return /* @__PURE__ */ s.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_4_30349)", children: [
      /* @__PURE__ */ s.jsx("path", { d: "M1.52401 -0.00489127C1.55494 -0.00496905 1.58587 -0.00504682 1.61773 -0.00512695C1.65147 -0.00501317 1.68522 -0.00489939 1.71998 -0.00478216C1.75601 -0.00481553 1.79203 -0.00484891 1.82915 -0.0048833C1.95012 -0.00494775 2.0711 -0.00473256 2.19207 -0.0045193C2.27869 -0.00450828 2.3653 -0.00451446 2.45191 -0.00453659C2.68732 -0.00454781 2.92273 -0.00431779 3.15813 -0.00404542C3.40405 -0.00380159 3.64996 -0.00377831 3.89588 -0.00373192C4.30872 -0.00362422 4.72156 -0.00338006 5.13441 -0.00303157C5.55963 -0.002673 5.98485 -0.0023965 6.41008 -0.00223048C6.43629 -0.00222022 6.4625 -0.00220996 6.48951 -0.00219938C6.62101 -0.0021484 6.7525 -0.00209904 6.884 -0.00205048C7.97486 -0.00164193 9.06573 -0.00095464 10.1566 -8.47145e-05C10.1568 0.0342645 10.1568 0.0342645 10.157 0.0693076C10.1602 0.627166 10.1638 1.18502 10.1678 1.74287C10.1698 2.01265 10.1716 2.28243 10.1731 2.55221C10.1745 2.81258 10.1763 3.07294 10.1784 3.33331C10.1791 3.43263 10.1797 3.53194 10.1802 3.63126C10.1808 3.77041 10.1819 3.90955 10.1832 4.04869C10.1833 4.08971 10.1834 4.13074 10.1834 4.173C10.1865 4.43659 10.1919 4.66024 10.3592 4.8754C10.6043 5.06602 10.881 5.05081 11.1788 5.05143C11.2219 5.05183 11.2649 5.05222 11.3093 5.05262C11.4512 5.05382 11.593 5.05449 11.7348 5.05515C11.8334 5.05588 11.932 5.05665 12.0305 5.05744C12.2631 5.05924 12.4956 5.0607 12.7282 5.062C12.9931 5.0635 13.2579 5.06543 13.5228 5.06739C14.0674 5.07142 14.612 5.0749 15.1566 5.07804C15.1246 5.1148 15.0927 5.15157 15.0598 5.18945C14.9608 5.30465 14.8654 5.42215 14.771 5.54107C13.478 7.15021 13.478 7.15021 12.4901 7.28516C12.023 7.32975 11.5539 7.3181 11.0859 7.29637C10.817 7.28426 10.5484 7.28279 10.2793 7.28167C9.79965 7.27941 9.32051 7.26948 8.84111 7.2543C8.37756 7.23963 7.91416 7.22858 7.45042 7.22233C7.42163 7.22194 7.39285 7.22155 7.36319 7.22115C7.19 7.21884 7.0168 7.21666 6.84361 7.21451C6.59146 7.21134 6.33931 7.2079 6.08717 7.20432C6.04649 7.20374 6.04649 7.20374 6.00499 7.20316C5.60571 7.19743 5.20656 7.18893 4.80738 7.17863C4.7577 7.17739 4.70802 7.17614 4.65684 7.17486C4.42449 7.16901 4.19216 7.16274 3.95984 7.15568C3.87836 7.15354 3.79689 7.15141 3.71541 7.1493C3.6791 7.14803 3.6428 7.14675 3.60539 7.14544C3.34645 7.13936 3.13831 7.14726 2.93491 7.32413C2.79976 7.48313 2.80181 7.5905 2.80444 7.7938C2.81545 7.92064 2.84598 7.99022 2.93002 8.08585C3.16035 8.25557 3.39744 8.24797 3.67187 8.24828C3.725 8.24857 3.725 8.24857 3.7792 8.24887C3.8979 8.24947 4.01659 8.24979 4.13529 8.25012C4.22037 8.2505 4.30545 8.25089 4.39053 8.2513C4.62157 8.25235 4.85262 8.25317 5.08367 8.25395C5.3251 8.25481 5.56653 8.25587 5.80796 8.25692C6.26518 8.25887 6.7224 8.26063 7.17962 8.26231C7.70013 8.26424 8.22065 8.26639 8.74116 8.26855C9.81193 8.273 10.8827 8.27717 11.9535 8.28117C11.9309 8.30697 11.9309 8.30696 11.908 8.33329C11.7842 8.47619 11.6667 8.62122 11.5544 8.77341C10.9266 9.6031 10.1702 10.5929 9.08683 10.7725C8.29725 10.88 7.48932 10.8349 6.69668 10.787C6.33187 10.7654 5.96701 10.7557 5.60169 10.7469C5.15538 10.7362 4.70927 10.7242 4.26335 10.7023C4.2322 10.7008 4.20106 10.6993 4.16897 10.6977C4.02369 10.6907 3.87847 10.6832 3.73326 10.6748C3.68263 10.6722 3.632 10.6697 3.57984 10.667C3.51425 10.6633 3.51425 10.6633 3.44734 10.6595C3.241 10.6668 3.09149 10.7036 2.93491 10.8398C2.79976 10.9988 2.80181 11.1061 2.80444 11.3094C2.81545 11.4363 2.84598 11.5058 2.93002 11.6015C3.12844 11.7477 3.31827 11.7624 3.55917 11.7639C3.60709 11.7643 3.65502 11.7647 3.7044 11.7651C3.75719 11.7653 3.80998 11.7655 3.86277 11.7657C3.9186 11.7661 3.97443 11.7665 4.03026 11.7669C4.18157 11.768 4.33288 11.7688 4.48419 11.7696C4.64242 11.7704 4.80064 11.7715 4.95887 11.7725C5.25838 11.7745 5.55788 11.7763 5.85739 11.7779C6.19842 11.7799 6.53945 11.782 6.88047 11.7842C7.58188 11.7886 8.2833 11.7928 8.98471 11.7968C8.65345 12.4612 8.65345 12.4612 8.49338 12.7695C8.46306 12.8282 8.43275 12.8869 8.40244 12.9455C8.35637 13.0346 8.31027 13.1237 8.26412 13.2127C8.21838 13.3009 8.17276 13.3892 8.12717 13.4775C8.11357 13.5037 8.09998 13.5298 8.08598 13.5567C8.01507 13.6943 7.94862 13.8329 7.88613 13.9745C7.87232 14.0057 7.85852 14.0369 7.8443 14.0691C7.82873 14.1045 7.82872 14.1045 7.81284 14.1405C7.78994 14.1407 7.76704 14.1408 7.74344 14.1409C7.18559 14.1441 6.62773 14.1477 6.06988 14.1518C5.8001 14.1537 5.53033 14.1555 5.26055 14.157C5.00017 14.1584 4.73981 14.1603 4.47944 14.1623C4.38013 14.1631 4.28081 14.1637 4.1815 14.1641C4.04235 14.1648 3.90321 14.1659 3.76406 14.1671C3.72304 14.1672 3.68202 14.1673 3.63975 14.1674C3.25842 14.1713 3.25842 14.1713 2.93491 14.3554C2.79976 14.5144 2.80181 14.6217 2.80444 14.8251C2.81545 14.9519 2.84598 15.0215 2.93002 15.1171C3.11451 15.253 3.29093 15.2787 3.5158 15.2766C3.5733 15.2763 3.5733 15.2763 3.63195 15.2759C3.67355 15.2755 3.71516 15.275 3.75802 15.2746C3.84954 15.2739 3.94106 15.2733 4.03258 15.2727C4.10523 15.2722 4.10523 15.2722 4.17935 15.2716C4.46268 15.2697 4.74603 15.2698 5.02937 15.2696C5.32907 15.2694 5.62873 15.2685 5.92841 15.2655C6.19232 15.2628 6.45615 15.2624 6.72007 15.2633C6.82059 15.2633 6.92111 15.2625 7.02162 15.2609C7.16232 15.2589 7.30277 15.2595 7.44348 15.2607C7.48492 15.2594 7.52637 15.2582 7.56907 15.2569C7.69039 15.2596 7.77838 15.2666 7.89096 15.3124C7.98063 15.4136 8.04193 15.5134 8.1041 15.6332C8.29896 15.9851 8.66947 16.1647 9.0401 16.2791C9.51497 16.3976 9.93317 16.2936 10.3621 16.0726C10.389 16.059 10.4159 16.0453 10.4436 16.0312C10.5303 15.9871 10.6169 15.9428 10.7035 15.8984C10.7615 15.8688 10.8195 15.8392 10.8776 15.8096C11.0582 15.7175 11.2385 15.6249 11.4188 15.5321C11.4504 15.5159 11.482 15.4996 11.5146 15.4829C12.2052 15.1288 12.2052 15.1288 12.891 14.7655C12.9353 14.7419 12.9796 14.7183 13.0252 14.694C13.4445 14.4618 13.7685 14.1285 14.1033 13.79C14.1347 13.7585 14.1661 13.7269 14.1985 13.6943C14.2974 13.595 14.3962 13.4955 14.495 13.3959C14.6263 13.2635 14.7578 13.1312 14.8894 12.999C14.9347 12.9533 14.9347 12.9533 14.9809 12.9066C15.0086 12.8788 15.0362 12.851 15.0647 12.8223C15.0891 12.7977 15.1136 12.7731 15.1387 12.7477C15.1957 12.6952 15.1957 12.6952 15.2347 12.6952C15.2393 13.4606 15.2427 14.226 15.2448 14.9914C15.2458 15.3468 15.2472 15.7022 15.2494 16.0576C15.2514 16.3676 15.2527 16.6776 15.2531 16.9876C15.2533 17.1515 15.2539 17.3155 15.2554 17.4794C15.2567 17.6341 15.2571 17.7888 15.2568 17.9435C15.2569 17.9999 15.2572 18.0564 15.258 18.1128C15.2654 18.6977 15.1053 19.1334 14.7042 19.5574C14.4215 19.8242 14.0434 20.0043 13.6545 20.0053C13.611 20.0055 13.5674 20.0057 13.5226 20.0059C13.4747 20.0059 13.4269 20.0059 13.3776 20.0059C13.3268 20.0061 13.276 20.0063 13.2236 20.0064C13.0824 20.0069 12.9412 20.0071 12.8 20.0073C12.6478 20.0075 12.4956 20.008 12.3433 20.0084C11.9756 20.0094 11.6078 20.0099 11.24 20.0105C11.1361 20.0106 11.0322 20.0108 10.9283 20.0109C10.2827 20.0119 9.63717 20.0128 8.99161 20.0132C8.84209 20.0134 8.69257 20.0135 8.54306 20.0136C8.48731 20.0136 8.48731 20.0136 8.43045 20.0137C7.82885 20.0142 7.22727 20.0155 6.62568 20.0171C6.00774 20.0188 5.3898 20.0197 4.77186 20.0199C4.42503 20.02 4.07821 20.0205 3.73139 20.0218C3.43592 20.0229 3.14046 20.0233 2.84499 20.0228C2.69437 20.0226 2.54377 20.0228 2.39315 20.0237C2.22945 20.0248 2.06579 20.0243 1.90209 20.0237C1.85504 20.0242 1.80799 20.0248 1.75951 20.0253C1.23013 20.0204 0.822852 19.829 0.442842 19.4694C0.147735 19.1568 -0.00574538 18.769 -0.00501508 18.3453C-0.00511866 18.3161 -0.00522217 18.2869 -0.00532889 18.2569C-0.00562943 18.1585 -0.00565125 18.0602 -0.0056746 17.9619C-0.00583142 17.8909 -0.00600476 17.8199 -0.00619331 17.7489C-0.00666096 17.5534 -0.00688146 17.3579 -0.00705981 17.1623C-0.00729238 16.9516 -0.00774589 16.7409 -0.00816488 16.5302C-0.00912309 16.0211 -0.00969425 15.512 -0.0101984 15.0028C-0.0103434 14.859 -0.0104987 14.7152 -0.0106575 14.5714C-0.0116434 13.6785 -0.012505 12.7856 -0.0129908 11.8927C-0.0131052 11.6859 -0.0132208 11.479 -0.0133386 11.2722C-0.0133823 11.195 -0.0133823 11.195 -0.0134269 11.1164C-0.0139211 10.2836 -0.0152187 9.45093 -0.0168464 8.61821C-0.0185038 7.76333 -0.0194241 6.90844 -0.0196282 6.05355C-0.0197615 5.57354 -0.0202203 5.09354 -0.0215072 4.61354C-0.0226015 4.20471 -0.0230305 3.79588 -0.0225934 3.38704C-0.0223909 3.17851 -0.0225027 2.97 -0.0234709 2.76147C-0.0243509 2.57035 -0.0243195 2.37926 -0.0235801 2.18814C-0.023471 2.11921 -0.0236884 2.05028 -0.024276 1.98135C-0.0292065 1.36501 0.096839 0.901116 0.530885 0.44242C0.789321 0.198447 1.16296 -0.0050923 1.52401 -0.00489127Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M15.8981 5.89844C16.0477 5.96802 16.1509 6.0626 16.2657 6.17907C16.2863 6.19965 16.3069 6.22024 16.3281 6.24145C16.396 6.30932 16.4635 6.37747 16.531 6.44562C16.5781 6.49282 16.6252 6.54 16.6723 6.58716C16.796 6.71119 16.9195 6.83544 17.0429 6.95975C17.169 7.08662 17.2953 7.21327 17.4215 7.33994C17.6692 7.58839 17.9165 7.83708 18.1637 8.08594C18.1017 8.23672 18.0055 8.33195 17.8908 8.44635C17.8708 8.46642 17.8508 8.48649 17.8302 8.50717C17.7632 8.57435 17.6958 8.64125 17.6285 8.70815C17.5804 8.75626 17.5323 8.80439 17.4842 8.85254C17.3535 8.98321 17.2226 9.11363 17.0917 9.24401C16.9549 9.38031 16.8184 9.51682 16.6818 9.65331C16.4231 9.91175 16.1642 10.17 15.9053 10.4282C15.6105 10.7221 15.3159 11.0162 15.0213 11.3104C14.4154 11.9155 13.8092 12.5203 13.2028 13.125C13.0357 12.9843 12.8741 12.8406 12.7184 12.6872C12.6993 12.6684 12.6801 12.6495 12.6604 12.6301C12.5981 12.5689 12.5361 12.5074 12.474 12.446C12.442 12.4143 12.442 12.4143 12.4094 12.3819C12.2968 12.2704 12.1844 12.1588 12.0721 12.0471C11.9793 11.9547 11.8861 11.8627 11.7927 11.7709C11.6795 11.6596 11.5668 11.5478 11.4544 11.4357C11.4116 11.3932 11.3686 11.3508 11.3255 11.3086C11.2654 11.2498 11.206 11.1904 11.1467 11.1308C11.1128 11.0972 11.0788 11.0635 11.0438 11.0289C10.9762 10.9375 10.9762 10.9375 10.9797 10.8664C11.0311 10.7435 11.1111 10.6711 11.2054 10.5771C11.2253 10.557 11.2453 10.5369 11.2659 10.5163C11.333 10.449 11.4005 10.3821 11.468 10.3153C11.5161 10.2672 11.5642 10.2191 11.6123 10.1709C11.743 10.0401 11.8741 9.90975 12.0052 9.77943C12.1422 9.6432 12.2788 9.50665 12.4155 9.37012C12.6744 9.11161 12.9335 8.85339 13.1928 8.59528C13.488 8.30143 13.7828 8.00725 14.0776 7.71305C14.6841 7.10781 15.291 6.50298 15.8981 5.89844Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M11.3281 0.3125C11.6358 0.576182 11.6358 0.576182 11.7605 0.700849C11.7888 0.729052 11.8171 0.757255 11.8463 0.786313C11.8914 0.831528 11.8914 0.831528 11.9374 0.877657C11.9698 0.910013 12.0022 0.94237 12.0357 0.975707C12.1421 1.08194 12.2483 1.18832 12.3546 1.29471C12.4286 1.36873 12.5027 1.44274 12.5767 1.51675C12.7315 1.67143 12.8862 1.82619 13.0408 1.981C13.2197 2.16014 13.3988 2.33915 13.5779 2.51807C13.7319 2.6719 13.8859 2.8258 14.0397 2.97977C14.1315 3.07166 14.2234 3.16351 14.3153 3.25531C14.4175 3.35734 14.5195 3.45949 14.6214 3.56168C14.652 3.59222 14.6827 3.62276 14.7142 3.65422C14.7417 3.68187 14.7693 3.70952 14.7977 3.73802C14.8218 3.76216 14.8459 3.7863 14.8708 3.81118C14.9219 3.86719 14.9219 3.86719 14.9219 3.90625C13.7359 3.90625 12.55 3.90625 11.3281 3.90625C11.3281 2.72031 11.3281 1.53438 11.3281 0.3125Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M19.4319 4.37476C19.7325 4.61165 19.9616 4.97238 20.0106 5.35609C20.052 5.89278 19.9554 6.30008 19.6094 6.71866C19.51 6.82618 19.4066 6.92898 19.3018 7.03116C19.2749 7.0577 19.248 7.08423 19.2203 7.11158C19.1548 7.1761 19.0892 7.24044 19.0234 7.3046C18.8713 7.24272 18.7691 7.1389 18.6558 7.02397C18.6352 7.00339 18.6146 6.9828 18.5934 6.96159C18.5256 6.89372 18.458 6.82557 18.3905 6.75742C18.3435 6.71022 18.2964 6.66304 18.2493 6.61588C18.1256 6.49185 18.0021 6.36759 17.8786 6.24328C17.7526 6.11641 17.6263 5.98977 17.5 5.8631C17.2524 5.61465 17.005 5.36595 16.7578 5.1171C16.8296 4.96206 16.9304 4.85294 17.0508 4.7338C17.0716 4.71311 17.0925 4.69241 17.114 4.67109C17.7805 4.02317 18.6272 3.83113 19.4319 4.37476Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M10.2345 11.7969C10.4761 11.9968 10.6975 12.2144 10.9192 12.4359C10.9582 12.4748 10.9972 12.5137 11.0362 12.5526C11.1174 12.6335 11.1985 12.7146 11.2796 12.7957C11.3836 12.8997 11.488 13.0035 11.5924 13.1072C11.6727 13.1872 11.753 13.2673 11.8331 13.3475C11.8715 13.3859 11.91 13.4242 11.9486 13.4624C12.0021 13.5156 12.0554 13.5691 12.1087 13.6226C12.1391 13.6529 12.1695 13.6832 12.2009 13.7145C12.2658 13.7891 12.2658 13.7891 12.2658 13.8672C12.246 13.877 12.2262 13.8868 12.2058 13.8968C11.8455 14.0754 11.486 14.2553 11.1305 14.4434C11.1012 14.4588 11.0719 14.4742 11.0418 14.4901C10.8751 14.5779 10.7089 14.6663 10.5429 14.7554C10.4483 14.806 10.3535 14.8563 10.2586 14.9064C10.1897 14.943 10.121 14.9801 10.0524 15.0173C9.54323 15.2857 9.54323 15.2857 9.23109 15.1904C9.05671 15.0917 8.93176 14.998 8.86732 14.8047C8.83576 14.5184 8.88787 14.3183 9.02448 14.0688C9.0409 14.0373 9.05731 14.0058 9.07423 13.9733C9.12659 13.8732 9.18002 13.7738 9.23353 13.6743C9.26794 13.609 9.30227 13.5437 9.33653 13.4783C9.40518 13.3476 9.4743 13.2172 9.54386 13.087C9.66523 12.8598 9.78486 12.6316 9.90424 12.4034C10.0112 12.1994 10.1219 11.9977 10.2345 11.7969Z" })
    ] }),
    /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_4_30349", children: /* @__PURE__ */ s.jsx("rect", { width: "20", height: "20", fill: "rgb(var(--background-secondary))" }) }) })
  ] });
}
function $k(e) {
  return /* @__PURE__ */ s.jsxs("svg", { height: "16", width: "16", viewBox: "0 0 74 74", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsx("path", { d: "m17.56 30.32h-10.58a3.649 3.649 0 0 0 -3.64 3.65v34.38a3.649 3.649 0 0 0 3.64 3.65h10.58a3.658 3.658 0 0 0 3.65-3.65v-34.38a3.658 3.658 0 0 0 -3.65-3.65z" }),
    /* @__PURE__ */ s.jsx("path", { d: "m69.09 42.29a6.231 6.231 0 0 0 -1.82-4.4 3 3 0 0 0 -.32-.3 6.081 6.081 0 0 0 -2.36-11.68h-21.7c.12-.21.23-.4.33-.59a14.353 14.353 0 0 0 1.48-3.22 20.85 20.85 0 0 0 .87-4.82 17.74 17.74 0 0 0 -4.6-12.99 6.772 6.772 0 0 0 -4.77-2.29 4.923 4.923 0 0 0 -5.08 4.36.66.66 0 0 0 -.01.14v8.76l-5.8 14.7a9.425 9.425 0 0 1 -2.1 3.19v33.88a33.044 33.044 0 0 0 4.36.89 12.466 12.466 0 0 0 1.65.11h29.41a5.522 5.522 0 0 0 3.88-1.6 5.464 5.464 0 0 0 1.6-3.87 5.407 5.407 0 0 0 -1.36-3.6 6.283 6.283 0 0 0 2.7-11 6.245 6.245 0 0 0 3.64-5.67z" })
  ] });
}
function zh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function Jk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M18.25 0.594727H1.70703C0.976562 0.594727 0.375 1.23926 0.375 2.0127V18.4697C0.375 19.2432 0.976562 19.8447 1.70703 19.8447H18.25C18.9805 19.8447 19.625 19.2432 19.625 18.4697V2.0127C19.625 1.23926 18.9805 0.594727 18.25 0.594727ZM6.17578 17.0947H3.33984V7.94238H6.17578V17.0947ZM4.75781 6.65332C3.8125 6.65332 3.08203 5.92285 3.08203 5.02051C3.08203 4.11816 3.8125 3.34473 4.75781 3.34473C5.66016 3.34473 6.39062 4.11816 6.39062 5.02051C6.39062 5.92285 5.66016 6.65332 4.75781 6.65332ZM16.875 17.0947H13.9961V12.626C13.9961 11.5947 13.9961 10.2197 12.5352 10.2197C11.0312 10.2197 10.8164 11.3799 10.8164 12.583V17.0947H7.98047V7.94238H10.6875V9.18848H10.7305C11.1172 8.45801 12.0625 7.68457 13.4375 7.68457C16.3164 7.68457 16.875 9.61816 16.875 12.0674V17.0947Z" })
    }
  );
}
function qk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      fill: "rgb(var(--fill-primary))",
      height: "512",
      viewBox: "0 0 24 24",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "m16.19 2h-8.38c-3.64 0-5.81 2.17-5.81 5.81v8.38c0 3.64 2.17 5.81 5.81 5.81h8.38c3.64 0 5.81-2.17 5.81-5.81v-8.38c0-3.64-2.17-5.81-5.81-5.81zm-6.22 12.9-2.25 2.25c-.15.15-.34.22-.53.22s-.39-.07-.53-.22l-.75-.75c-.3-.29-.3-.77 0-1.06.29-.29.76-.29 1.06 0l.22.22 1.72-1.72c.29-.29.76-.29 1.06 0 .29.29.29.77 0 1.06zm0-7-2.25 2.25c-.15.15-.34.22-.53.22s-.39-.07-.53-.22l-.75-.75c-.3-.29-.3-.77 0-1.06.29-.29.76-.29 1.06 0l.22.22 1.72-1.72c.29-.29.76-.29 1.06 0 .29.29.29.77 0 1.06zm7.59 8.72h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25c.42 0 .75.34.75.75s-.33.75-.75.75zm0-7h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25c.42 0 .75.34.75.75s-.33.75-.75.75z" })
    }
  );
}
function Qk(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      className: "text-text-secondary -ml-1 mr-3 h-7 w-7 animate-spin",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
}
function Xk(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M15 2.5C12.3487 2.50298 9.80694 3.5575 7.93222 5.43222C6.0575 7.30694 5.00298 9.84875 5 12.5C5 16.5688 7.95375 19.9475 11.0825 23.5238C12.0725 24.6562 13.0975 25.8275 14.01 27.0125C14.1268 27.164 14.2767 27.2866 14.4484 27.3711C14.62 27.4555 14.8087 27.4993 15 27.4993C15.1913 27.4993 15.38 27.4555 15.5516 27.3711C15.7233 27.2866 15.8732 27.164 15.99 27.0125C16.9025 25.8275 17.9275 24.6562 18.9175 23.5238C22.0462 19.9475 25 16.5688 25 12.5C24.997 9.84875 23.9425 7.30694 22.0678 5.43222C20.1931 3.5575 17.6513 2.50298 15 2.5ZM15 16.25C14.2583 16.25 13.5333 16.0301 12.9166 15.618C12.2999 15.206 11.8193 14.6203 11.5355 13.9351C11.2516 13.2498 11.1774 12.4958 11.3221 11.7684C11.4667 11.041 11.8239 10.3728 12.3483 9.84835C12.8728 9.3239 13.541 8.96675 14.2684 8.82206C14.9958 8.67736 15.7498 8.75162 16.4351 9.03545C17.1203 9.31928 17.706 9.79993 18.118 10.4166C18.5301 11.0333 18.75 11.7583 18.75 12.5C18.75 13.4946 18.3549 14.4484 17.6517 15.1517C16.9484 15.8549 15.9946 16.25 15 16.25Z" })
    }
  );
}
function eL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.75435 1.875L9 1.875C9.62132 1.875 10.125 2.37868 10.125 3C10.125 3.62132 9.62132 4.125 9 4.125H7.8C6.94136 4.125 6.36504 4.12588 5.92122 4.16214C5.49053 4.19733 5.28461 4.26015 5.14877 4.32936C4.79597 4.50913 4.50913 4.79596 4.32936 5.14877C4.26015 5.28461 4.19733 5.49053 4.16214 5.92122C4.12588 6.36504 4.125 6.94136 4.125 7.8V16.2C4.125 17.0586 4.12588 17.635 4.16214 18.0788C4.19733 18.5095 4.26015 18.7154 4.32936 18.8512C4.50913 19.204 4.79596 19.4909 5.14877 19.6706C5.28461 19.7399 5.49053 19.8027 5.92122 19.8379C6.36504 19.8741 6.94136 19.875 7.8 19.875H9C9.62132 19.875 10.125 20.3787 10.125 21C10.125 21.6213 9.62132 22.125 9 22.125H7.75432C6.9531 22.125 6.28434 22.125 5.738 22.0804C5.16817 22.0338 4.63318 21.9332 4.12729 21.6754C3.35112 21.2799 2.72008 20.6489 2.3246 19.8727C2.06683 19.3668 1.96617 18.8318 1.91961 18.262C1.87497 17.7157 1.87498 17.0469 1.875 16.2457V7.75435C1.87498 6.95312 1.87497 6.28435 1.91961 5.738C1.96617 5.16817 2.06683 4.63318 2.3246 4.12729C2.72008 3.35112 3.35112 2.72008 4.12729 2.3246C4.63318 2.06683 5.16817 1.96617 5.738 1.91961C6.28435 1.87497 6.95312 1.87498 7.75435 1.875ZM15.2045 6.20451C15.6438 5.76517 16.3562 5.76517 16.7955 6.20451L21.7955 11.2045C22.2348 11.6438 22.2348 12.3562 21.7955 12.7955L16.7955 17.7955C16.3562 18.2348 15.6438 18.2348 15.2045 17.7955C14.7652 17.3562 14.7652 16.6438 15.2045 16.2045L18.284 13.125H9C8.37868 13.125 7.875 12.6213 7.875 12C7.875 11.3787 8.37868 10.875 9 10.875H18.284L15.2045 7.7955C14.7652 7.35616 14.7652 6.64385 15.2045 6.20451Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function tL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.68787 22.6607L2.68807 22.6609L0.95896 20.9318C0.82491 20.7952 0.75 20.6117 0.75 20.4204C0.75 20.2293 0.82491 20.0457 0.95896 19.9091L10.1154 10.7286C10.252 10.5947 10.4356 10.5198 10.6268 10.5198C10.818 10.5198 11.0017 10.5948 11.1383 10.7286L12.8915 12.4818C13.0254 12.6184 13.1003 12.802 13.1003 12.9933C13.1003 13.1844 13.0254 13.368 12.8915 13.5046L3.71068 22.6607C3.57409 22.7947 3.39045 22.8696 3.19935 22.8696C3.00808 22.8696 2.82445 22.7947 2.68786 22.6607L2.68787 22.6607ZM14.8398 18.0293V13.456H16.301V18.0293H14.8398ZM13.4517 11.8975L11.7228 10.1686C11.5889 10.032 11.5139 9.84838 11.5139 9.65712C11.5139 9.46586 11.5889 9.28239 11.7228 9.14584V9.14568L13.9144 6.95413C14.051 6.82028 14.2346 6.74538 14.4259 6.74538C14.617 6.74538 14.8007 6.82029 14.9372 6.95413L16.6663 8.68317C16.8002 8.81976 16.8751 9.00334 16.8751 9.19445C16.8751 9.38575 16.8002 9.56937 16.6663 9.70592H16.6662L14.4745 11.8975C14.3379 12.0313 14.1545 12.1064 13.9632 12.1064C13.7719 12.1064 13.5883 12.0313 13.4517 11.8975ZM13.4517 11.8975L14.4517 12.8975L13.4517 11.8975ZM18.1761 11.5566V10.0954H22.7543V11.5566H18.1761ZM5.61024 8.78058V7.31939H10.1885V8.78058H5.61024ZM16.0892 6.50058L19.4298 3.16007L20.4629 4.19319L17.1223 7.5337L16.0892 6.50058ZM12.0636 5.43952V0.866211H13.5248V5.43952H12.0636Z",
          fill: "rgb(var(--brand-primary))"
        }
      )
    }
  );
}
function aL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_58020_24302)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M2.99992 9.35547C3.81898 9.95024 4.58378 10.5047 5.34792 11.0604C8.17293 13.1146 10.9979 15.1696 13.8229 17.2245C14.6102 17.7974 15.3797 17.8034 16.1637 17.2344C19.6886 14.6753 23.2123 12.1137 26.7366 9.55395C26.8081 9.50168 26.8822 9.45272 26.9834 9.38193C26.99 9.48646 26.9986 9.56387 26.9986 9.64062C26.9986 13.5215 27.0006 17.4024 26.9986 21.2834C26.9979 22.7759 25.983 23.7934 24.4905 23.7934C18.1663 23.7961 11.8428 23.7954 5.51861 23.7934C4.01084 23.7941 3.00124 22.7786 3.00058 21.2688C2.99926 17.3958 2.99992 13.5229 2.99992 9.65054C2.99992 9.57115 2.99992 9.49176 2.99992 9.35613V9.35547Z",
              fill: "rgb(var(--text-primary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M4.29004 7.23333C4.6043 7.15857 4.91789 7.07785 5.23413 7.01236C5.34462 6.98986 5.46371 7.00375 5.57882 7.00375C11.8607 7.00375 18.1418 7.00442 24.4237 7.00177C24.8736 7.00177 25.3043 7.05867 25.7264 7.29949C25.6589 7.35638 25.6086 7.40402 25.5524 7.44504C22.4422 9.70703 19.332 11.9684 16.2212 14.2304C15.3665 14.8516 14.6367 14.8509 13.7806 14.229C10.6764 11.9723 7.57221 9.71563 4.46867 7.45893C4.40979 7.41593 4.35355 7.37028 4.29599 7.32529C4.29401 7.29486 4.29202 7.26376 4.29004 7.23333Z",
              fill: "rgb(var(--text-primary))"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_58020_24302", children: /* @__PURE__ */ s.jsx(
          "rect",
          {
            width: "24",
            height: "16.7959",
            fill: "rgb(var(--background-secondary))",
            transform: "translate(3 7)"
          }
        ) }) })
      ]
    }
  );
}
function nL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 26",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M5.93798 8.12999C6.02798 8.54399 6.16598 8.81199 6.32698 8.97899C6.70998 11.645 9.10298 13.917 11.025 13.822C13.47 13.702 15.203 11.067 15.592 8.97899C15.753 8.81299 15.908 8.45799 16.001 8.04099C16.105 7.56199 16.217 6.83999 15.929 6.45799C15.912 6.43799 15.802 6.33699 15.783 6.31999C16.058 5.32799 16.662 3.55799 15.158 1.96699C14.343 1.10499 13.211 0.671994 12.188 0.329994C9.16798 -0.679006 7.03598 0.735994 6.05198 3.08899C5.98098 3.25599 5.52198 4.31299 6.07798 6.31999C6.02398 6.35599 5.97498 6.40199 5.93398 6.45799C5.64498 6.83899 5.83298 7.65099 5.93798 8.12999Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M21.557 22.792C21.473 20.957 21.369 18.049 19.766 15.67C19.766 15.67 19.309 15.047 18.225 14.633C18.225 14.633 15.871 13.916 14.787 13.141L14.292 13.48L14.347 16.698L11.375 24.632C11.31 24.806 11.144 24.921 10.959 24.921C10.774 24.921 10.608 24.806 10.543 24.632L7.57197 16.698C7.57197 16.698 7.62697 13.49 7.62597 13.48C7.63297 13.507 7.12997 13.141 7.12997 13.141C6.04797 13.916 3.69297 14.633 3.69297 14.633C2.60897 15.047 2.15197 15.67 2.15197 15.67C0.549971 18.049 0.443971 20.957 0.359971 22.792C0.301971 24.06 0.567971 24.533 0.901971 24.668C5.04797 26.332 16.867 26.332 21.014 24.668C21.35 24.534 21.614 24.06 21.557 22.792Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M11.0649 14.847L10.9309 14.85C10.4989 14.85 10.0629 14.766 9.63495 14.618L10.8129 16.421L9.75595 17.441L10.8439 24.048C10.8529 24.105 10.9019 24.146 10.9599 24.146C11.0169 24.146 11.0659 24.105 11.0759 24.048L12.1639 17.441L11.1059 16.421L12.2669 14.645C11.8879 14.756 11.4869 14.83 11.0649 14.847Z" })
      ]
    }
  );
}
function rL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M11.9998 2.25C10.6876 2.25155 9.38914 2.51772 8.18215 3.03258C6.97516 3.54744 5.88439 4.30042 4.97507 5.24649C4.06576 6.19257 3.35657 7.3123 2.88992 8.53874C2.42327 9.76518 2.20874 11.0731 2.25916 12.3844C2.45604 17.5125 6.66541 21.6469 11.8029 21.75C13.5245 21.7835 15.2243 21.3605 16.7294 20.524C18.2345 19.6875 19.4912 18.4673 20.3717 16.9875C20.4085 16.926 20.427 16.8552 20.4248 16.7836C20.4227 16.7119 20.4001 16.6423 20.3596 16.5831C20.3192 16.5239 20.2626 16.4776 20.1966 16.4496C20.1306 16.4215 20.058 16.413 19.9873 16.425C19.7025 16.4753 19.4139 16.5004 19.1248 16.5C17.4092 16.5 16.4529 15.75 15.9467 15.1219C15.8298 14.9731 15.7233 14.8165 15.6279 14.6531C15.174 15.2749 14.5683 15.7698 13.8685 16.0906C13.1687 16.4114 12.3983 16.5474 11.631 16.4854C10.8637 16.4234 10.1252 16.1657 9.48592 15.7368C8.84668 15.3078 8.32817 14.7221 7.97995 14.0356C7.63173 13.349 7.46545 12.5846 7.49701 11.8155C7.52858 11.0463 7.75693 10.2981 8.16023 9.64243C8.56353 8.98673 9.1283 8.44545 9.80053 8.07035C10.4728 7.69526 11.23 7.49888 11.9998 7.5C13.1086 7.49662 14.1787 7.90792 14.9998 8.65313V8.27813C14.9967 8.08351 15.0676 7.89496 15.1981 7.75055C15.3286 7.60613 15.509 7.51659 15.7029 7.5C15.8053 7.49359 15.9079 7.50824 16.0043 7.54305C16.1008 7.57786 16.1891 7.63209 16.2638 7.70238C16.3385 7.77268 16.398 7.85754 16.4386 7.95173C16.4791 8.04592 16.5 8.14744 16.4998 8.25V12C16.4998 13.3687 16.9592 15 19.1248 15C21.2904 15 21.7123 13.4813 21.7498 12.1406V12C21.7473 9.4149 20.7193 6.93639 18.8913 5.10845C17.0634 3.28051 14.5849 2.25248 11.9998 2.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M11.9998 15C13.6566 15 14.9998 13.6569 14.9998 12C14.9998 10.3431 13.6566 9 11.9998 9C10.3429 9 8.99979 10.3431 8.99979 12C8.99979 13.6569 10.3429 15 11.9998 15Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function iL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      viewBox: "0 0 159 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M157.185 6.45665C154.539 3.83737 150.28 3.83737 147.634 6.45665C145.544 9.20821 145.544 13.0445 147.634 15.7961C150.28 18.3889 154.539 18.3889 157.185 15.7961C159.275 13.0445 159.275 9.2082 157.185 6.45665ZM154.564 13.9965C153.532 15.2135 151.707 15.3458 150.49 14.314C150.384 14.2081 150.278 14.1023 150.172 13.9965C149.14 12.2239 149.14 10.0279 150.172 8.2288C151.204 7.01176 153.03 6.87947 154.247 7.93775C154.353 8.04358 154.458 8.12298 154.538 8.2288C155.596 10.0279 155.596 12.1974 154.564 13.9965H154.564ZM130.358 5.37147C129.22 4.81585 127.977 4.55129 126.707 4.55129C125.04 4.36609 123.399 5.00107 122.235 6.19164C121.653 6.98537 121.336 7.91138 121.309 8.86384H124.458C124.511 8.44055 124.669 8.04366 124.908 7.72618C125.357 7.30289 125.939 7.09122 126.548 7.14412C127.104 7.11768 127.633 7.2235 128.135 7.43517C128.506 7.64682 128.717 8.07012 128.664 8.49346C128.664 8.91678 128.373 9.31364 127.95 9.41945C127.553 9.5782 127.13 9.65758 126.707 9.71048L125.595 9.84279C124.59 9.92215 123.611 10.2132 122.712 10.663C121.521 11.3244 120.833 12.6208 120.912 13.9966C120.86 15.0284 121.256 16.0338 122.024 16.7482C122.817 17.3831 123.823 17.7271 124.855 17.7271C131.972 18.0446 131.892 13.9966 131.945 13.1235V8.44056C132.13 7.19706 131.495 5.95356 130.358 5.37148V5.37147ZM128.718 12.4622C128.797 13.3089 128.453 14.1555 127.792 14.7111C127.21 15.108 126.522 15.3197 125.834 15.3197C125.41 15.3197 125.014 15.1874 124.696 14.9492C124.352 14.6318 124.167 14.182 124.22 13.7057C124.193 13.1501 124.484 12.5945 124.987 12.33C125.463 12.0919 125.966 11.9596 126.495 11.8802L127.236 11.7479C127.527 11.695 127.818 11.6156 128.109 11.5363C128.321 11.4569 128.532 11.3511 128.744 11.2188L128.718 12.4622V12.4622ZM114.14 7.32901C114.828 7.27608 115.489 7.56711 115.939 8.09627C116.203 8.46666 116.362 8.88997 116.442 9.33976H119.96C119.934 7.88461 119.246 6.50882 118.108 5.60925C116.891 4.86847 115.489 4.49806 114.06 4.57742C112.367 4.47159 110.7 5.13302 109.51 6.35008C108.346 7.72586 107.737 9.4985 107.869 11.3241C107.79 12.9909 108.319 14.6312 109.351 15.9276C110.542 17.1976 112.261 17.859 114.008 17.7003C115.86 17.8325 117.632 17.0124 118.796 15.5573C119.431 14.7635 119.828 13.7846 119.934 12.7527H116.415C116.362 13.3348 116.151 13.8904 115.807 14.3667C115.357 14.8164 114.722 15.0545 114.087 14.9752C113.055 15.0281 112.103 14.3931 111.785 13.4142C111.547 12.6998 111.415 11.959 111.441 11.2182C111.415 10.451 111.521 9.65724 111.785 8.91644C112.103 7.9375 113.082 7.27607 114.14 7.32901ZM106.865 4.60459C99.6417 4.60459 100.091 10.9808 100.091 10.9808V17.4629H103.372V11.3777C103.319 10.6104 103.452 9.86959 103.743 9.15526C104.298 8.2557 105.33 7.77948 106.388 7.91176H106.785H107.341V4.57812H107.05L106.865 4.60459H106.865ZM94.878 14.0765C94.7457 14.2617 94.6134 14.4204 94.4283 14.5791C93.8991 14.9495 93.2377 15.1348 92.6027 15.0818C91.9942 15.1083 91.3857 14.976 90.8565 14.6585C89.9834 14.0765 89.4807 13.0976 89.5336 12.0657H98.582C98.6085 11.2455 98.582 10.3989 98.4762 9.57872C98.3439 8.65271 98 7.77963 97.4708 7.01236C96.9417 6.21863 96.2009 5.55721 95.3278 5.18681C94.4018 4.78993 93.4229 4.57827 92.4175 4.60475C90.7507 4.55182 89.1632 5.16034 87.9727 6.32448C86.7556 7.6738 86.1206 9.47289 86.2529 11.2984C86.0942 13.1505 86.782 15.0025 88.1578 16.2724C89.4014 17.2778 90.9359 17.8334 92.5498 17.807C94.296 17.9128 96.0157 17.2514 97.2327 15.9814C97.7619 15.4523 98.1588 14.8173 98.3704 14.1029L94.878 14.0765L94.878 14.0765ZM90.4864 7.96243C91.0155 7.45973 91.7034 7.22165 92.4178 7.24809C93.1321 7.22163 93.7935 7.45974 94.3492 7.90953C94.9048 8.41222 95.2223 9.12656 95.2223 9.86736H89.6133C89.6927 9.17949 90.0102 8.51804 90.4864 7.96243H90.4864ZM84.9558 17.4628H82.019V9.92245C82.1513 8.75831 81.3046 7.72648 80.167 7.62066C80.0612 7.62066 79.9289 7.59419 79.8231 7.62066C78.606 7.59419 77.6006 8.54665 77.5477 9.76371C77.5477 9.81661 77.5477 9.89599 77.5477 9.94891V17.4628H74.5581V9.92245C74.6903 8.78479 73.8702 7.75296 72.7325 7.62066C72.6267 7.62066 72.4944 7.59419 72.3886 7.62066C71.1715 7.56774 70.1661 8.5202 70.1132 9.71078C70.1132 9.79014 70.1132 9.86953 70.1132 9.94891V17.4628H67.0971V10.0018C66.9119 7.17088 69.0549 4.7368 71.8859 4.55158C72.0446 4.55158 72.2034 4.55158 72.3357 4.55158C73.7908 4.52512 75.1666 5.1601 76.0662 6.29777C76.9921 5.18656 78.3415 4.55158 79.7966 4.55158C83.0509 4.55158 84.9823 6.80047 84.9823 10.0018V17.4628H84.9558ZM145.066 0.713866C145.066 0.713866 141.785 0.369905 141.785 3.01564V6.50803C141.441 5.92597 140.938 5.44974 140.356 5.13224C139.748 4.78829 139.06 4.62957 138.346 4.62957C136.838 4.57664 135.382 5.26453 134.43 6.45512C133.372 7.93672 132.869 9.73582 132.975 11.5349C132.895 13.1753 133.425 14.7892 134.456 16.0591C135.726 17.2497 137.393 17.8582 139.113 17.7524C145.145 17.7524 145.066 12.5932 145.066 12.5932V0.713886V0.713866ZM141.15 14.0767C140.673 14.7646 139.88 15.1615 139.06 15.1085C138.239 15.1615 137.446 14.7646 136.996 14.0767C136.493 13.2036 136.255 12.2247 136.308 11.2458C136.282 10.3198 136.52 9.39375 136.969 8.57359C137.419 7.85923 138.213 7.43593 139.06 7.48881C139.668 7.48881 140.25 7.70048 140.7 8.09735C141.547 8.99689 141.97 10.2139 141.864 11.4574C141.891 12.3834 141.652 13.283 141.15 14.0503L141.15 14.0767ZM70.4052 38.2292C70.4052 38.6526 70.2465 39.0759 69.929 39.367C69.638 39.6844 69.2147 39.8432 68.7649 39.8432H67.1245V28.4665C66.9922 26.7203 67.733 25.0271 69.1088 23.9423C70.3523 23.0427 71.8604 22.593 73.3949 22.6988C75.0088 22.6724 76.5698 23.3073 77.681 24.4714C78.7657 25.7943 79.2949 27.4875 79.2156 29.2073C79.2949 30.927 78.7922 32.6468 77.7868 34.049C76.9137 35.2131 75.5115 35.8745 74.0564 35.8481C73.342 35.8745 72.6012 35.7158 71.9397 35.4248C71.2783 35.1073 70.7492 34.5781 70.4052 33.9431V38.2028L70.4052 38.2292ZM75.8823 29.3689C75.9352 28.3635 75.6971 27.3846 75.168 26.538C74.6917 25.8765 73.898 25.5061 73.1043 25.5326C72.3106 25.5061 71.5433 25.8765 71.0671 26.538C70.5644 27.3846 70.3262 28.39 70.4056 29.3689C70.3262 30.3214 70.5908 31.2738 71.12 32.0675C71.5962 32.729 72.3899 33.0994 73.1837 33.0729C73.9774 33.0994 74.7181 32.729 75.168 32.0675C75.6971 31.2738 75.9352 30.3214 75.8823 29.3689ZM100.882 34.815V33.9948C100.38 34.8415 99.5595 35.45 98.607 35.6617C97.6546 35.8733 96.6492 35.794 95.7496 35.4235C94.7178 35.0002 93.8447 34.2594 93.2626 33.307C92.5219 32.09 92.1779 30.6612 92.2573 29.259C92.1779 27.5657 92.6541 25.8989 93.6066 24.4967C94.6649 23.2267 96.2788 22.5653 97.9191 22.6711C99.4272 22.5389 100.935 22.9886 102.126 23.9146C103.475 25.0258 104.216 26.7191 104.057 28.4653V35.159C104.163 38.2545 101.729 40.8209 98.66 40.9267C98.4218 40.9267 98.1573 40.9267 97.9191 40.9002C95.3793 40.9796 93.1568 39.2863 92.5219 36.8258H95.9613C96.5169 37.7518 97.6017 38.2545 98.6864 38.0693C99.242 37.937 99.7447 37.5931 100.115 37.1433C100.591 36.4819 100.856 35.6881 100.856 34.8679M95.4309 29.3926C95.4309 31.5886 96.0659 32.7792 97.3094 33.0173C98.3412 33.3348 99.426 32.9908 100.087 32.1442C100.431 31.668 100.643 31.0859 100.696 30.5038C100.802 29.7631 100.802 29.0222 100.696 28.2814C100.59 27.5671 100.326 26.9056 99.9022 26.3236C99.4789 25.7415 98.8175 25.424 98.1031 25.477C97.1772 25.3976 96.3305 25.9003 95.9337 26.7205C95.5368 27.5671 95.3516 28.4931 95.3516 29.4191M89.4797 23.5707C88.342 23.0151 87.0985 22.7505 85.8286 22.7505C84.1618 22.5653 82.5214 23.2003 81.3573 24.3908C80.7752 25.1846 80.4577 26.1106 80.4313 27.0895H83.6062C83.6591 26.6662 83.8178 26.2693 84.0559 25.9518C84.5057 25.5285 85.0878 25.3169 85.6963 25.3698C86.2519 25.3433 86.781 25.4491 87.2838 25.6608C87.6541 25.8725 87.8658 26.2958 87.8129 26.7191C87.8129 27.1424 87.5218 27.5393 87.0985 27.6451C86.7017 27.8039 86.2783 27.8832 85.8551 27.9362L84.7438 28.0685C83.7385 28.1478 82.7595 28.4388 81.86 28.8886C80.6694 29.55 79.9815 30.8464 80.0609 32.2222C80.008 33.2541 80.4048 34.2595 81.1721 34.9738C81.9658 35.6088 82.9712 35.9527 84.0031 35.9527C91.1201 36.2702 91.0407 32.2222 91.0936 31.3492V26.6662C91.2259 25.4227 90.5909 24.2057 89.5062 23.5971M87.8934 30.7162C87.9728 31.5628 87.6288 32.4094 86.9674 32.965C86.3853 33.3619 85.6974 33.5735 85.0095 33.5735C84.5862 33.5735 84.1894 33.4412 83.8719 33.2032C83.528 32.8856 83.3427 32.4359 83.3957 31.9596C83.3692 31.404 83.6602 30.8484 84.1629 30.5839C84.6391 30.3458 85.1418 30.2135 85.671 30.1341L86.4118 30.0018C86.7028 29.9489 86.9939 29.8695 87.2849 29.7902C87.4965 29.7108 87.7082 29.6049 87.9199 29.4727L87.8934 30.7162L87.8934 30.7162ZM116.466 24.6325C113.821 22.0131 109.561 22.0131 106.915 24.6325C104.825 27.384 104.825 31.2203 106.915 33.9719C109.587 36.5647 113.794 36.5647 116.466 33.9719C118.556 31.1939 118.556 27.384 116.466 24.6325ZM113.873 32.1697C112.841 33.3868 111.015 33.5191 109.798 32.4872C109.693 32.3814 109.587 32.2755 109.481 32.1697C108.449 30.3971 108.449 28.2011 109.481 26.4285C110.513 25.2114 112.338 25.0791 113.555 26.111C113.661 26.2168 113.767 26.3226 113.873 26.4285C114.878 28.2011 114.878 30.3706 113.873 32.1697",
            fill: "#0A0080"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57.5967 21.0042C57.5967 31.4813 44.8178 39.9741 29.0757 39.9741C13.3336 39.9741 0.554688 31.4813 0.554688 21.0042C0.554688 10.5271 13.3336 2.00781 29.0757 2.00781C44.8178 2.03428 57.5967 10.5271 57.5967 21.0042Z",
            fill: "#00BCFF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57.0384 20.1843C49.2334 18.9144 39.4971 23.0947 38.333 23.5444L37.698 23.809L37.9626 23.174C38.4124 21.9041 38.677 18.3588 38.5182 15.7395C38.333 13.0938 39.3384 10.5539 39.7882 9.38976L39.8675 9.12519C40.2379 8.11982 40.6877 8.11982 41.2169 8.22564C41.4021 8.22564 41.5873 8.33146 41.7725 8.33146C42.5927 8.33146 43.598 7.96104 44.3124 7.59066C44.6828 7.40545 45.0267 7.22025 45.4765 7.22025C45.7411 7.14087 46.0321 7.14087 46.2173 7.03505C46.4819 6.95566 46.7729 6.84984 47.0375 6.84984C48.0429 6.77046 48.7572 6.58528 48.7572 5.84445C48.7572 5.76509 48.7572 5.57989 48.572 5.47404C48.3868 5.39469 48.1222 5.28884 47.3021 5.47404H47.2227C46.8523 5.57989 46.0321 5.73863 46.7729 5.10366C46.7729 4.99784 46.8523 4.99784 46.8523 4.99784C47.1169 4.81261 47.4079 4.36283 47.5931 4.09827C47.6725 4.01889 47.7783 3.83368 47.6725 3.64849C47.5931 3.0929 46.7729 2.56374 45.8469 2.00814C45.6617 1.92878 45.4765 1.74358 45.2913 1.63773C44.8415 1.26735 43.7568 0.447161 43.2805 0.896951C42.6456 1.45254 40.185 3.80724 38.7299 5.44759C37.407 6.95568 36.3223 8.64894 35.4492 10.4481L35.0788 11.2682C34.2586 13.0938 32.9886 15.8982 31.7187 18.8879L31.1631 20.2373C31.0837 20.4225 31.0837 20.5018 30.9779 20.687C29.8931 23.1476 28.438 26.2166 29.4434 27.857C29.8931 28.5713 30.7927 29.0476 32.1685 29.1269C40.6083 29.8413 42.6985 29.6825 47.6196 29.0211C48.5191 28.9417 49.3393 28.7565 50.2653 28.5713C50.6357 28.492 50.9796 28.3862 51.35 28.3862C51.6146 28.3862 51.7998 28.3862 52.0909 28.4655C52.5406 28.6507 52.7258 28.9153 52.911 29.2857L53.0962 29.5503L53.3608 29.2857C54.8953 27.566 55.9801 25.661 56.6415 23.6502C56.9061 22.4597 57.0119 21.2955 57.0913 20.74V20.105H57.0384L57.0384 20.1843ZM26.2433 20.1858C26.0581 19.7361 25.7935 19.2863 25.6877 18.8365C24.4178 15.741 23.1478 12.9365 22.3276 11.1109L21.9572 10.3701C20.9519 8.28 19.9729 6.63965 18.6765 5.3697C17.2214 3.83517 14.7873 1.37466 14.1259 0.819028C13.5703 0.369248 12.4855 1.26881 12.1416 1.55984C11.9564 1.63922 11.7712 1.82441 11.586 1.93026C10.6864 2.48585 9.86622 3.01501 9.76039 3.57061C9.76039 3.75579 9.76039 3.94099 9.83976 4.02038C9.91913 4.20558 10.1043 4.47013 10.2895 4.65536C10.3689 4.73471 10.4747 4.73471 10.5541 4.84056H10.6599C11.3743 5.47552 11.2949 5.66075 11.2155 5.58137C10.8451 5.39614 10.5806 5.31678 10.316 5.31678H10.2366C9.33707 5.13158 9.04604 5.2374 8.8873 5.31678C8.7021 5.39614 8.7021 5.58137 8.7021 5.68719C8.7021 6.40153 9.52228 6.58673 10.5277 6.69258C10.7922 6.69258 11.0833 6.77194 11.3478 6.87776C11.6124 6.98358 11.7976 7.06299 12.0886 7.06299C12.4591 7.14235 12.9088 7.24817 13.2528 7.43337C13.9936 7.80378 14.9725 8.25356 15.7927 8.14774C15.9779 8.14774 16.1631 8.14774 16.3483 8.06833C16.9039 7.989 17.3537 7.989 17.6976 8.9679L17.777 9.23249C18.2267 10.3966 19.2321 12.963 19.0469 15.5822C18.8617 18.2015 19.1263 21.7468 19.6025 23.0168L19.8671 23.6517L19.2321 23.3872C18.2268 22.9374 8.88731 18.8365 1.16176 20.1064H0.976562V21.4558C1.24113 23.9957 2.32589 26.5356 4.33664 28.8109L4.52184 29.0755L4.70704 28.8109C4.89224 28.5463 5.07745 28.4405 5.34202 28.2553C5.97699 28.0701 6.3474 28.1495 7.16758 28.3347C8.06713 28.5199 8.99314 28.7051 9.81331 28.7845C12.5384 29.1549 14.364 29.3401 16.7981 29.3401C18.8882 29.3401 21.4281 29.1549 25.238 28.8903C26.5873 28.8109 27.5133 28.3347 27.9631 27.6204C28.9684 25.9006 27.5927 22.9109 26.4285 20.3446C26.3492 20.4504 26.3492 20.2917 26.2433 20.1858L26.2433 20.1858Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M52.4899 30.1871C52.3047 30.2665 52.2254 30.4517 52.0402 30.5575L51.9343 30.6369C51.7491 30.7163 51.6698 30.9015 51.4846 31.0073C51.2994 31.1925 51.1142 31.2719 50.929 31.4571C50.7438 31.5365 50.5585 31.7216 50.4792 31.8274L50.3998 31.9333C50.2146 32.0127 50.0294 32.1979 49.95 32.3037C49.95 32.3037 49.8706 32.3037 49.8706 32.4096C49.6854 32.4889 49.5002 32.6741 49.315 32.7799C49.1298 32.8858 48.9446 33.0445 48.7594 33.1503L48.6801 33.2297L48.1244 33.4943C48.1244 33.4943 48.0451 33.4943 48.0451 33.5737C47.5953 33.8382 47.2249 34.0234 46.7751 34.3144C46.6958 34.3144 46.6958 34.3938 46.6958 34.3938L46.1401 34.6584C46.0343 34.6584 46.0343 34.7378 46.0343 34.7378C45.5845 34.923 45.1348 35.1875 44.685 35.3728C44.6056 35.3728 44.6056 35.4521 44.4998 35.4521C44.3146 35.558 44.1294 35.6374 43.9442 35.6374C43.8648 35.6374 43.8648 35.7167 43.759 35.7167C43.5738 35.7961 43.3092 35.9019 43.0446 35.9813C42.7801 36.0607 42.5949 36.1665 42.3038 36.2459C42.2245 36.2459 42.2245 36.2459 42.1186 36.3252C41.9334 36.431 41.7482 36.431 41.563 36.5104C41.4572 36.5104 41.4572 36.5898 41.3778 36.5898C41.1926 36.6692 40.928 36.6692 40.7428 36.775H40.6634C40.3989 36.8809 40.2137 36.9602 39.9226 36.9602C39.8433 36.9602 39.8433 36.9602 39.7374 37.0396C39.5522 37.1189 39.367 37.1189 39.1025 37.2248C39.0231 37.2248 38.9173 37.2248 38.9173 37.3306C38.7321 37.41 38.4675 37.41 38.2823 37.5158H38.0971C37.8325 37.5952 37.5415 37.5952 37.2769 37.701H37.0917C36.9065 37.8068 36.6419 37.8068 36.4567 37.8068C36.3774 37.8068 36.2715 37.8068 36.1922 37.8862C36.007 37.8862 35.7424 37.9656 35.5572 37.9656H35.372C35.1074 38.045 34.8164 38.045 34.5518 38.045H34.3666C34.1814 38.045 33.9168 38.1244 33.6258 38.1244H33.3612C33.176 38.1244 32.9114 38.2301 32.7262 38.2301H32.4617C32.1971 38.2301 31.9061 38.3095 31.6415 38.3095H26.7469C26.4823 38.3095 26.1913 38.3095 25.9267 38.2301H25.8473C25.5827 38.2301 25.2917 38.2301 25.0271 38.1244H24.7626C24.5774 38.1244 24.3128 38.1244 24.1276 38.045H23.863C23.5984 38.045 23.3074 37.9656 23.0428 37.9656H22.9634C22.6989 37.9656 22.5137 37.8862 22.2226 37.8862H21.9581C21.7729 37.8862 21.5083 37.8068 21.3231 37.8068H21.1643C20.8998 37.701 20.6087 37.701 20.3442 37.6216H20.2648C20.0796 37.5422 19.815 37.5422 19.6298 37.4364C19.5504 37.4364 19.4446 37.4364 19.3652 37.3571C19.18 37.2512 18.9948 37.2512 18.8096 37.1718C18.7303 37.1718 18.7303 37.1718 18.6244 37.0925C18.3599 37.0131 18.0688 37.0131 17.8836 36.9073H17.6984C17.5132 36.8015 17.2487 36.8015 17.0635 36.7221C16.9576 36.7221 16.8783 36.6427 16.8783 36.6427C16.6931 36.5633 16.5079 36.5633 16.3227 36.4575C16.2433 36.4575 16.2433 36.4575 16.1375 36.3517C15.8729 36.2723 15.6877 36.1665 15.3966 36.0871C15.3173 36.0871 15.3173 36.0871 15.2114 36.0077C15.0262 35.9019 14.841 35.8225 14.6558 35.8225C14.5765 35.8225 14.4706 35.7431 14.4706 35.7431C14.2854 35.6638 14.1002 35.558 13.915 35.558C13.8357 35.558 13.8357 35.558 13.7298 35.4521C13.5446 35.3728 13.2801 35.2669 13.0155 35.1875C12.9361 35.1875 12.9361 35.1082 12.8303 35.1082L12.2747 34.8436C12.1953 34.8436 12.1953 34.7642 12.0895 34.7642L11.5339 34.4996C11.5339 34.4996 11.4281 34.4996 11.4281 34.4203C11.2429 34.3409 10.9783 34.2351 10.7931 34.0499C10.7137 34.0499 10.7137 33.9705 10.6079 33.9705C10.4227 33.8911 10.2375 33.7853 10.1581 33.7059C10.0523 33.7059 10.0523 33.6266 9.97291 33.6266L9.4173 33.362C9.4173 33.362 9.33793 33.362 9.33793 33.2562C9.15273 33.1768 8.96754 32.9916 8.78234 32.8858C8.67651 32.8858 8.67651 32.7799 8.59714 32.7799C8.41193 32.7006 8.33257 32.5947 8.14737 32.5153C8.068 32.5153 8.068 32.436 7.96216 32.436C7.77697 32.3302 7.59176 32.2508 7.51239 32.0656C7.51239 32.0656 7.43302 32.0656 7.43302 31.9862C7.24782 31.8804 7.06261 31.7216 6.87743 31.6158C6.79806 31.6158 6.79805 31.5364 6.79805 31.5364C6.71869 31.4306 6.53347 31.3512 6.42764 31.1661C6.34828 31.1661 6.34828 31.0867 6.24244 31.0867C6.05723 30.9808 5.97787 30.8221 5.79267 30.7163C5.60746 30.5311 5.42227 30.4517 5.3429 30.2665C5.26353 30.2665 5.26353 30.1871 5.26353 30.1871L4.81375 29.7373L4.73438 29.6315C4.91958 29.3669 4.99895 29.2611 5.10477 29.1817C5.47518 28.9965 5.66038 29.1024 6.4541 29.2876C7.35365 29.4728 8.27966 29.658 9.17921 29.7373C14.0738 30.3723 16.2698 30.5575 24.8155 29.8167C26.4559 29.6315 27.5406 29.0759 28.0962 28.097C28.1756 28.0176 28.1756 27.9118 28.2814 27.7266C28.3872 27.8059 28.3872 27.9118 28.4666 28.097C29.0222 29.1024 30.1863 29.6315 31.7473 29.8167C40.293 30.5311 42.4626 30.3723 47.3572 29.7373C48.2567 29.6315 49.1827 29.4728 50.0823 29.2876C50.9025 29.1024 51.0877 29.1024 51.4316 29.1817C51.6168 29.2876 51.6962 29.3669 51.9872 29.9225C52.5957 30.0813 52.5957 30.0813 52.4899 30.1871C52.4899 30.0813 52.4899 30.0813 52.4899 30.1871L52.4899 30.1871ZM53.2305 11.563L53.4157 11.7482C53.6009 11.9335 53.6803 12.1187 53.8655 12.3038C53.9448 12.4097 53.9448 12.4097 53.9448 12.489C54.0242 12.5684 54.13 12.6743 54.13 12.7536C54.2094 12.8595 54.2094 12.8595 54.2094 12.9388C54.3153 13.0182 54.3946 13.1241 54.3946 13.2034C54.474 13.3092 54.474 13.3092 54.474 13.3886C54.6592 13.759 54.9238 14.0236 55.109 14.394C55.109 14.4734 55.2148 14.4734 55.2148 14.5792C55.2942 14.685 55.2942 14.7644 55.4 14.8438C55.4 14.9232 55.4794 14.9232 55.4794 15.029C55.5587 15.1348 55.5587 15.2142 55.6646 15.2936C55.6646 15.3729 55.7439 15.3729 55.7439 15.4788C55.8233 15.664 55.9291 15.9285 56.0085 16.1137C56.0085 16.1931 56.0085 16.1931 56.1143 16.1931C56.1143 16.2725 56.1937 16.3783 56.1937 16.4577C56.1937 16.537 56.2731 16.6429 56.2731 16.6429C56.2731 16.7223 56.3525 16.8281 56.3525 16.9075C56.3525 16.9868 56.4318 17.0927 56.4318 17.0927C56.4318 17.172 56.5377 17.2779 56.5377 17.3573C56.5377 17.4366 56.5377 17.5425 56.617 17.5425C56.6964 17.7276 56.6964 17.9128 56.6964 18.0981C56.6964 18.1774 56.6964 18.2833 56.7758 18.2833C56.7758 18.3626 56.7758 18.4684 56.8552 18.5478V19.1034C54.3153 18.733 50.3202 18.733 44.6054 20.294C42.6211 21.1142 40.7956 21.6433 38.8906 22.4635C39.261 20.638 39.3404 17.8335 39.1552 15.7434C38.97 13.3886 39.896 11.034 40.4252 9.73753L40.5045 9.47294C40.6104 9.28776 40.6104 9.10255 40.7691 9.02319H41.0337C41.2189 9.02319 41.4835 9.10254 41.6687 9.10254C42.8592 9.20837 44.2086 8.46759 44.579 8.28238C44.8435 8.09717 45.2139 8.01779 45.5843 7.91197C45.8489 7.83259 46.14 7.72676 46.4839 7.6474C46.6691 7.56802 46.8543 7.56802 47.1189 7.56802C47.3834 7.56802 47.7538 7.48866 48.1242 7.38281C50.135 8.65274 51.8547 10.0285 53.2305 11.5631L53.2305 11.563ZM43.6012 1.03057C43.8658 0.845356 44.5008 1.10995 45.321 1.74493C45.5062 1.93011 45.6914 2.00947 45.8766 2.11531C46.4322 2.4857 47.5169 3.1207 47.5963 3.57048C47.5963 3.64986 47.5963 3.75568 47.5169 3.83504V3.91442C47.3317 4.17901 47.0672 4.65523 46.882 4.73461L46.6968 4.91981C46.3264 5.29022 45.7972 5.66062 45.612 5.66062C45.0564 5.58124 44.7125 5.47541 44.2627 5.29021C44.5272 4.20546 44.8976 4.47003 45.612 4.84044C45.612 4.65523 45.5326 4.57585 45.5326 4.39066L46.0882 4.12609L45.4533 4.04671C45.3739 3.59694 45.3739 3.22653 45.3739 2.77677C45.1887 3.04133 45.1887 3.33237 45.1093 3.51757C45.0299 3.70277 44.8447 3.88798 44.7389 3.96734L44.3685 3.59695C44.1833 3.41174 43.9187 3.22654 43.7335 3.14717C43.7335 3.22655 43.6542 3.22655 43.6542 3.22655C44.2891 4.1261 44.2891 4.31131 43.5748 5.13147C42.9398 5.84583 42.3048 6.40141 41.6698 7.03641C42.1196 7.30098 42.6752 7.11577 43.3102 6.48081C44.1304 5.58126 44.1304 5.58126 45.2151 6.03103L45.4003 6.11042C45.8501 6.2956 46.1147 6.03103 46.5644 5.84582C46.829 5.76646 47.1994 5.58126 47.464 5.58126H47.5698C48.2048 5.47543 48.5752 5.47543 48.6546 5.58126C48.6546 5.58126 48.734 5.66062 48.734 5.76646C48.734 6.21626 48.3636 6.40142 47.1994 6.50726C46.9348 6.50726 46.6438 6.58665 46.2999 6.69247C46.0353 6.77183 45.8501 6.87768 45.5591 6.87768C45.1093 6.9835 44.7389 7.06288 44.395 7.32745C43.6541 7.69784 42.7546 8.06825 42.0402 8.06825C41.855 8.06825 41.6698 8.06825 41.5905 7.98889C40.9555 7.90951 40.4263 7.90951 39.9501 9.07364L39.8707 9.33821C39.421 10.6081 38.4156 13.1481 38.5214 15.7938C38.7066 18.4396 38.4156 21.9848 37.9658 23.1489L37.3308 24.3395L38.5214 23.7839C38.6008 23.6781 48.9721 19.1539 57.0416 20.4238V20.7942C56.9622 21.535 56.8564 22.6198 56.5918 23.7045C56.0362 25.7153 54.9514 27.6202 53.4169 29.2606C53.2317 28.8108 52.9671 28.5198 52.4115 28.361C52.1469 28.2552 51.8559 28.1758 51.5913 28.1758C51.221 28.1758 50.7712 28.2552 50.4272 28.361C49.5277 28.5462 48.7075 28.7314 47.7815 28.8108C42.9662 29.4458 40.7967 29.631 32.3304 28.8902C31.0604 28.8108 30.2402 28.3346 29.7905 27.6996C28.8909 26.1651 30.2402 23.1489 31.325 20.7149C31.5896 20.0799 31.8806 19.4449 32.1452 18.8893C33.4945 15.5292 34.8703 12.5395 35.6905 10.7934L35.8757 10.423C36.881 8.33284 37.86 6.79831 39.0505 5.42253C40.5057 3.9409 42.9662 1.55974 43.6012 1.03061L43.6012 1.03057ZM29.0778 2.67188C32.7024 2.67188 36.1683 3.12165 39.2374 3.94184C38.867 4.31224 38.6024 4.5768 38.3378 4.94723C36.9356 6.50819 35.7979 8.28084 34.9778 10.2122L34.7926 10.5826C33.9724 12.4082 32.5172 15.3979 31.2473 18.758C31.0621 19.3136 30.7975 19.8427 30.5065 20.4777C29.8715 21.827 29.2365 23.3086 28.8661 24.7373C28.4957 23.2822 27.7814 21.827 27.2258 20.4777L26.485 18.758C25.1356 15.3979 23.7598 12.4082 22.9397 10.5826L22.7545 10.2122C21.7491 8.04272 20.6643 6.40237 19.3944 4.94723C19.1298 4.68264 18.8388 4.39162 18.5742 4.04768C21.7226 3.12167 25.2415 2.67189 29.0778 2.67189L29.0778 2.67188ZM9.07532 5.66402C9.15469 5.58464 9.63091 5.58464 10.1601 5.66402H10.3453L11.1655 5.92858C11.6152 6.19317 11.8798 6.37836 12.3296 6.19317C12.4089 6.19317 12.5148 6.11381 12.5148 6.11381C13.5995 5.7434 13.5995 5.7434 14.4197 6.56358C15.0547 7.27794 15.5838 7.38376 16.0601 7.11918C15.4251 6.48422 14.7107 5.84924 14.1551 5.21426C13.4408 4.39408 13.4408 4.1295 14.0758 3.30932C14.0758 3.2035 13.9964 3.2035 13.9964 3.2035C13.8112 3.3887 13.5466 3.46806 13.3614 3.65327L12.991 4.02366C12.8058 3.83848 12.6206 3.7591 12.6206 3.57389C12.5412 3.38869 12.5412 3.12412 12.356 2.85955C12.356 3.22994 12.2767 3.67973 12.2767 4.12949L11.6417 4.3147L12.1973 4.57926L12.1179 4.94968C12.7529 4.49991 13.2027 4.23531 13.4672 5.39943C13.0175 5.58464 12.5677 5.58464 12.1179 5.76985C11.9327 5.84921 11.3771 5.39943 10.9273 5.02904C10.9273 4.94968 10.848 4.94968 10.848 4.94968L10.5834 4.68511C10.3982 4.49991 10.3188 4.23533 10.213 4.12951V4.05013C10.1336 3.97075 10.1336 3.86492 10.1336 3.78556C10.213 3.33579 11.3242 2.59498 11.8533 2.33039C12.0386 2.25101 12.2238 2.06583 12.4089 1.96C13.1498 1.32502 13.8641 0.954607 14.1287 1.2192C14.7637 1.77479 17.1184 4.12951 18.6793 5.66404C19.8699 6.93398 20.8488 8.57433 21.8542 10.6645L22.0394 11.0349C22.8596 12.8604 24.3147 15.8501 25.5847 19.1044C25.7699 19.66 26.0345 20.295 26.4049 20.9299C27.4896 23.3904 28.8654 26.3801 27.9394 27.9147C27.569 28.629 26.6695 28.9994 25.3995 29.1052C16.9596 29.846 14.8695 29.6608 9.94841 29.0258C9.04886 28.9465 8.22868 28.7613 7.30268 28.5761C6.4825 28.3909 6.03273 28.3115 5.31839 28.4967C4.94799 28.5761 4.76278 28.8671 4.57759 29.1317C2.75203 26.9622 1.5879 24.5016 1.29688 21.8559V20.6653C9.39283 19.316 19.182 23.8402 19.2879 23.946L20.4784 24.5016L20.0287 23.3111C19.5789 22.1205 19.2879 18.5752 19.4731 15.9559C19.6583 13.3366 18.6529 10.7703 18.1237 9.50033L18.0444 9.23574C17.5946 8.04516 17.039 8.04516 16.404 8.15099C16.2188 8.15099 16.0336 8.23038 15.9543 8.23038C15.2134 8.23038 14.2345 7.85996 13.5995 7.51602C13.2291 7.33081 12.7794 7.14561 12.409 7.06622C12.1444 6.98686 11.9592 6.98686 11.6946 6.88101C11.43 6.80166 11.139 6.69583 10.7951 6.69583C9.60448 6.51062 9.26053 6.32541 9.26053 5.95502C8.99597 5.74338 8.99597 5.664 9.07533 5.664L9.07532 5.66402ZM9.81435 7.46096C9.99955 7.54034 10.2641 7.54034 10.4493 7.54034C10.6345 7.54034 10.8991 7.6197 11.0843 7.6197C11.3489 7.69906 11.6399 7.8049 11.9839 7.88427C12.3543 7.96365 12.6188 8.06947 12.9892 8.25466C13.3596 8.43987 14.709 9.15423 15.8995 9.07484C16.0848 9.07484 16.3493 9.07484 16.5345 8.99548H16.7991C16.7991 8.99548 16.8785 9.07484 17.0637 9.44526L17.143 9.70983C17.5928 10.9798 18.5982 13.3345 18.413 15.7156C18.2278 17.8058 18.3072 20.6102 18.6776 22.4358C15.9525 21.2452 8.14756 18.4408 1.24219 19.5255C1.32156 18.8111 1.42739 18.1761 1.61259 17.4354V17.356C1.61259 17.2502 1.69196 17.1708 1.69196 17.0914C1.69196 17.012 1.77133 16.9062 1.77133 16.8269V16.7475C1.95653 16.1919 2.2211 15.5834 2.51213 15.0277C2.51213 15.0277 2.51213 14.9484 2.5915 14.9484C2.5915 14.9484 2.5915 14.869 2.67087 14.869C2.75024 14.7896 2.75024 14.6838 2.85607 14.6044C4.17893 11.8264 6.63947 9.4717 9.81435 7.46094V7.46096ZM49.3165 6.82611C49.5017 6.56154 49.6869 6.27049 49.6869 5.92654C49.6869 5.55616 49.5017 5.2122 49.2371 4.92117C48.9726 4.73597 48.6815 4.6566 48.3376 4.6566C48.3376 4.6566 48.3376 4.55078 48.4434 4.55078C48.6286 4.28621 48.708 3.9158 48.6286 3.54541C48.4434 2.64586 47.2793 1.90504 46.4591 1.3759C46.2739 1.29652 46.0887 1.19069 46.0093 1.11133C44.369 -0.238001 43.4694 -0.079251 43.0196 0.291149C42.5699 0.661539 41.4851 1.7463 40.2945 2.93687C36.8286 2.03733 33.0187 1.48172 29.1295 1.48172C25.0551 1.48172 21.1394 2.03734 17.5941 3.01625C16.4035 1.82568 15.2394 0.740919 14.7632 0.291149C14.3134 -0.079261 13.308 -0.343841 11.7735 1.11133C11.6941 1.19069 11.5089 1.29653 11.3237 1.3759C10.5036 1.82568 9.31298 2.56648 9.15424 3.54541C9.07487 3.9158 9.15424 4.28621 9.33944 4.55078C9.33944 4.55078 9.33944 4.6566 9.44527 4.6566C9.07487 4.6566 8.81029 4.73598 8.54572 4.92117C8.28115 5.18576 8.09595 5.47677 8.09595 5.92654C8.09595 6.48216 8.28115 6.74673 8.54572 7.0113C3.28071 10.3714 0 15.1866 0 20.3723V21.5628C0 32.6484 11.3502 41.644 29.0766 41.644C46.8824 41.644 58.1533 32.6484 58.1533 21.5628V20.4781C58.1268 15.1072 54.7667 10.292 49.3165 6.8261V6.82611Z",
            fill: "#0A0080"
          }
        )
      ]
    }
  );
}
function oL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M80.4585 20.8837C80.4585 20.2687 80.4585 19.6516 80.4585 19.0365C80.477 18.9275 80.4996 18.8185 80.5161 18.7094C80.6148 18.0306 80.6704 17.3415 80.8164 16.673C81.6392 12.886 83.5852 9.78194 86.6707 7.44722C90.5091 4.54064 94.8309 3.5759 99.5436 4.55915C103.316 5.34494 106.383 7.32174 108.728 10.3723C111.26 13.6635 112.316 17.4135 111.919 21.5399C111.598 24.8826 110.3 27.8344 108.072 30.3543C105.63 33.1168 102.586 34.8365 98.9511 35.4845C98.3567 35.5894 97.756 35.649 97.1574 35.7293H95.3102C95.23 35.7128 95.1518 35.684 95.0716 35.6778C92.6052 35.503 90.2972 34.7974 88.1908 33.5077C84.1056 31.0043 81.5899 27.3942 80.7074 22.6733C80.5963 22.083 80.5428 21.4802 80.4626 20.8837H80.4585ZM93.8518 22.5108C93.716 22.3833 93.642 22.3154 93.57 22.2434C92.5456 21.2211 91.5232 20.1967 90.4989 19.1764C90.3754 19.053 90.2479 18.9336 90.1121 18.8246C89.207 18.0903 87.8123 18.2301 87.0656 19.127C86.2696 20.0835 86.3498 21.3239 87.2775 22.2557C88.8717 23.8541 90.47 25.4503 92.0663 27.0445C93.1503 28.1286 94.4463 28.1286 95.5324 27.0445C98.7269 23.852 101.919 20.6595 105.11 17.467C105.248 17.3292 105.379 17.1852 105.499 17.0309C106.398 15.8584 105.82 14.0544 104.408 13.6142C103.466 13.3221 102.681 13.5895 102 14.2724C99.3523 16.9239 96.7028 19.5693 94.0554 22.2208C93.9772 22.2989 93.9238 22.4059 93.8518 22.5129V22.5108Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M79.463 26.0387H24.6844C23.7752 26.0387 23.0388 26.7751 23.0388 27.6843V93.5091C23.0388 94.4183 22.3023 95.1548 21.3931 95.1548H14.8107C13.9015 95.1548 13.165 94.4183 13.165 93.5091V17.8106C13.165 16.9014 13.9015 16.165 14.8107 16.165H78.6073C78.3892 17.2799 78.2761 18.4298 78.2761 19.6084C78.2761 21.8753 78.6957 24.0434 79.463 26.0387Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M11.5193 12.8737H74.0529C74.9621 12.8737 75.6985 12.1373 75.6985 11.2281V4.64562C75.6985 3.73642 74.9621 3 74.0529 3H1.64562C0.736415 3 0 3.73642 0 4.64562V80.3442C0 81.2534 0.736415 81.9898 1.64562 81.9898H8.2281C9.13731 81.9898 9.87372 81.2534 9.87372 80.3442V14.5193C9.87372 13.6101 10.6101 12.8737 11.5193 12.8737Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M96.2256 37.5581C96.0282 37.5581 95.8286 37.5539 95.6332 37.5478C95.5715 37.5539 95.5077 37.5581 95.4439 37.5581H67.4684C66.5612 37.5581 65.8228 36.8216 65.8228 35.9124C65.8228 35.4578 66.0079 35.0464 66.3062 34.7482C66.6045 34.4519 67.0158 34.2668 67.4684 34.2668H85.8644C83.9884 32.94 82.3798 31.2615 81.1333 29.33H27.9735C27.0664 29.33 26.3279 30.0664 26.3279 30.9756V40.8493C26.3279 41.7585 27.0664 42.4949 27.9735 42.4949H100.381C101.29 42.4949 102.026 41.7585 102.026 40.8493V36.6015C100.208 37.2207 98.2559 37.5581 96.2256 37.5581ZM34.0747 37.0767C33.7764 37.3729 33.365 37.5581 32.9104 37.5581C32.4558 37.5581 32.0464 37.3729 31.7482 37.0767C31.4499 36.7784 31.2647 36.367 31.2647 35.9124C31.2647 35.4578 31.4499 35.0464 31.7482 34.7482C32.0464 34.4519 32.4578 34.2668 32.9104 34.2668C33.8196 34.2668 34.556 35.0032 34.556 35.9124C34.556 36.367 34.3709 36.7784 34.0747 37.0767ZM40.6572 37.0767C40.3589 37.3729 39.9474 37.5581 39.4928 37.5581C39.0382 37.5581 38.6289 37.3729 38.3306 37.0767C38.0324 36.7784 37.8472 36.367 37.8472 35.9124C37.8472 35.4578 38.0324 35.0464 38.3306 34.7482C38.6289 34.4519 39.0403 34.2668 39.4928 34.2668C40.4021 34.2668 41.1385 35.0032 41.1385 35.9124C41.1385 36.367 40.9534 36.7784 40.6572 37.0767ZM47.2396 37.0767C46.9414 37.3729 46.5299 37.5581 46.0753 37.5581C45.6207 37.5581 45.2114 37.3729 44.9131 37.0767C44.6149 36.7784 44.4297 36.367 44.4297 35.9124C44.4297 35.4578 44.6149 35.0464 44.9131 34.7482C45.2114 34.4519 45.6228 34.2668 46.0753 34.2668C46.9845 34.2668 47.7209 35.0032 47.7209 35.9124C47.7209 36.367 47.5358 36.7784 47.2396 37.0767Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M100.381 45.7861H27.9735C27.0664 45.7861 26.3279 46.5225 26.3279 47.4318V106.674C26.3279 107.583 27.0664 108.32 27.9735 108.32H100.381C101.29 108.32 102.026 107.583 102.026 106.674V47.4318C102.026 46.5225 101.29 45.7861 100.381 45.7861ZM48.0439 92.1865C39.6862 92.1865 32.9104 85.4106 32.9104 77.0529C32.9104 68.6952 39.6862 61.9194 48.0439 61.9194C56.4016 61.9194 63.1754 68.6952 63.1754 77.0529C63.1754 85.4106 56.4016 92.1865 48.0439 92.1865ZM94.2344 91.4459C93.7778 91.9026 93.1484 92.1865 92.4572 92.1865H71.8972C70.5107 92.1865 69.3794 91.053 69.3794 89.6687C69.3794 88.9754 69.6612 88.346 70.1179 87.8914C70.5745 87.4347 71.204 87.1509 71.8972 87.1509H92.4572C93.8416 87.1509 94.975 88.2843 94.975 89.6687C94.975 90.3619 94.6911 90.9913 94.2344 91.4459ZM94.2344 79.0503C93.7778 79.507 93.1484 79.7908 92.4572 79.7908H71.8972C70.5107 79.7908 69.3794 78.6574 69.3794 77.271C69.3794 76.5798 69.6612 75.9504 70.1179 75.4937C70.5745 75.037 71.204 74.7532 71.8972 74.7532H92.4572C93.8416 74.7532 94.975 75.8866 94.975 77.271C94.975 77.9642 94.6911 78.5936 94.2344 79.0503ZM94.2344 66.6526C93.7778 67.1093 93.1484 67.3931 92.4572 67.3931H71.8972C70.5107 67.3931 69.3794 66.2597 69.3794 64.8753C69.3794 64.1842 69.6612 63.5547 70.1179 63.0981C70.5745 62.6414 71.204 62.3575 71.8972 62.3575H92.4572C93.8416 62.3575 94.975 63.491 94.975 64.8753C94.975 65.5665 94.6911 66.1959 94.2344 66.6526Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M43.7734 73.5909V80.5149C43.7734 81.5948 44.911 82.2983 45.8778 81.8149L52.8018 78.353C53.8735 77.8181 53.8735 76.2877 52.8018 75.7529L45.8778 72.2909C44.911 71.8075 43.7734 72.511 43.7734 73.5909Z" })
      ]
    }
  );
}
function Uh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "931.999",
      height: "931.999",
      viewBox: "0 0 931.999 931.999",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          id: "Exclusion_3",
          "data-name": "Exclusion 3",
          d: "M466,931.5a472.963,472.963,0,0,1-47.595-2.4,466.666,466.666,0,0,1-46.22-7.054c-15-3.069-30.006-6.928-44.611-11.471-14.441-4.492-28.83-9.758-42.768-15.653-13.808-5.84-27.5-12.435-40.691-19.6-13.1-7.115-26.011-14.96-38.38-23.317A468.069,468.069,0,0,1,80,726.266c-8.357-12.369-16.2-25.282-23.317-38.38-7.167-13.193-13.762-26.883-19.6-40.691-5.9-13.938-11.162-28.327-15.653-42.768-4.543-14.605-8.4-29.614-11.471-44.611A466.67,466.67,0,0,1,2.9,513.595a472.483,472.483,0,0,1,0-95.189,466.668,466.668,0,0,1,7.054-46.22c3.069-15,6.928-30.006,11.471-44.611,4.492-14.441,9.758-28.83,15.653-42.768,5.84-13.808,12.435-27.5,19.6-40.691C63.8,231.017,71.644,218.1,80,205.735A468.069,468.069,0,0,1,205.735,80c12.369-8.357,25.282-16.2,38.38-23.317,13.193-7.167,26.883-13.762,40.691-19.6,13.938-5.9,28.327-11.162,42.768-15.653,14.605-4.543,29.614-8.4,44.611-11.471A466.668,466.668,0,0,1,418.406,2.9a472.483,472.483,0,0,1,95.189,0,466.67,466.67,0,0,1,46.22,7.054c15,3.069,30.006,6.928,44.611,11.471,14.441,4.492,28.83,9.758,42.768,15.653,13.808,5.84,27.5,12.435,40.691,19.6C700.983,63.8,713.9,71.644,726.266,80A468.069,468.069,0,0,1,852,205.735c8.357,12.369,16.2,25.282,23.317,38.38,7.167,13.193,13.762,26.883,19.6,40.691,5.9,13.938,11.162,28.327,15.653,42.768,4.543,14.605,8.4,29.614,11.471,44.611a466.666,466.666,0,0,1,7.054,46.22,472.43,472.43,0,0,1,0,95.189,466.667,466.667,0,0,1-7.054,46.22c-3.069,15-6.928,30.006-11.471,44.611-4.492,14.441-9.758,28.83-15.653,42.768-5.84,13.808-12.435,27.5-19.6,40.691-7.115,13.1-14.96,26.011-23.317,38.38A468.07,468.07,0,0,1,726.266,852c-12.369,8.357-25.282,16.2-38.38,23.317-13.193,7.167-26.883,13.762-40.691,19.6-13.938,5.9-28.327,11.162-42.768,15.653-14.605,4.543-29.614,8.4-44.611,11.471a466.667,466.667,0,0,1-46.22,7.054A472.963,472.963,0,0,1,466,931.5ZM591.545,364.758a80.927,80.927,0,0,1,15.924,1.594,83.7,83.7,0,0,1,15.106,4.568A85.8,85.8,0,0,1,648.74,387.7,83.147,83.147,0,0,1,659,399.281a78.754,78.754,0,0,1,7.845,13.276,72.539,72.539,0,0,1,6.849,30.37v218.92H766V442.927a167.974,167.974,0,0,0-11.76-62.213,180.051,180.051,0,0,0-33.721-53.795,170.406,170.406,0,0,0-112.982-56.757c-5.238-.42-10.266-.624-15.369-.624a174.2,174.2,0,0,0-69.106,14.241,173.135,173.135,0,0,0-57.581,40.436,175.252,175.252,0,0,0-57.425-40.359,171.956,171.956,0,0,0-68.64-14.319C243.794,269.539,166,347.321,166,442.927v218.92h92.308V442.927a71.8,71.8,0,0,1,5.875-28.312,78.778,78.778,0,0,1,6.832-12.631,83.117,83.117,0,0,1,8.974-11.238A84.939,84.939,0,0,1,303,373.58a81.077,81.077,0,0,1,13.354-5.362,76.388,76.388,0,0,1,14.133-2.838c2.655-.2,5.4-.416,7.891-.416a81.331,81.331,0,0,1,15.895,1.576,83.049,83.049,0,0,1,15.03,4.524,84.18,84.18,0,0,1,25.931,16.664,81.736,81.736,0,0,1,10.135,11.526A78.109,78.109,0,0,1,413.1,412.5a73.5,73.5,0,0,1,6.742,30.425v218.92h92.777V442.927a73.82,73.82,0,0,1,5.666-28.257,79.5,79.5,0,0,1,6.623-12.661,82.439,82.439,0,0,1,8.74-11.289A83.346,83.346,0,0,1,544.2,381.1a81.81,81.81,0,0,1,12.055-7.662,76.21,76.21,0,0,1,27.4-8.261C586.31,364.969,589.052,364.758,591.545,364.758Z",
          transform: "translate(-0.001 -0.001)",
          strokeWidth: "1"
        }
      )
    }
  );
}
function sL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      enableBackground: "new 0 0 2500 738.6",
      viewBox: "0 0 2500 738.6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "m1057.4 241.2c-137.3 0-248.7 111.7-248.7 248.7s111.7 248.7 248.7 248.7 248.7-111.7 248.7-248.7-111.4-248.7-248.7-248.7zm0 379.7c-72.1 0-130.8-58.7-130.8-130.8s58.7-130.8 130.8-130.8 130.8 58.7 130.8 130.8-58.7 130.8-130.8 130.8z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m1884.7 155.1c42.8 0 77.6-34.7 77.6-77.6s-34.8-77.5-77.6-77.5-77.6 34.7-77.6 77.6 34.8 77.5 77.6 77.5z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m549.6 241.4c-6.5-.5-12.7-.8-19.1-.8-60 0-116.9 24.6-157.7 68-40.8-43.2-97.5-68-156.9-68-119 .1-215.9 96.7-215.9 215.7v272.2h116.3v-268.9c0-49.4 40.6-94.9 88.4-99.8 3.4-.3 6.7-.5 9.8-.5 53.8 0 97.7 43.9 98 97.7v271.4h118.9v-269.3c0-49.1 40.3-94.6 88.4-99.5 3.4-.3 6.7-.5 9.8-.5 53.8 0 98 43.7 98.2 97.2v272.2h118.9v-268.9c0-54.5-20.2-107.1-56.6-147.6-36.3-40.8-86.2-65.9-140.5-70.6z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m1489.1 11.6h-118.9v717.4h118.9zm227.6 0h-118.9v717.4h118.9zm227.5 241.5h-118.9v475.7h118.9z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m2500 478.8c0-63.1-24.6-122.5-69-167.8-44.7-45.2-103.7-70.3-166.5-70.3h-3.1c-65.1.8-126.7 26.6-172.7 72.9s-71.9 107.5-72.6 172.9c-.8 66.7 24.8 129.8 72.1 177.6s109.9 74.2 176.6 74.2h.3c87.4 0 169.3-46.8 214.1-122l5.7-9.6-98.2-48.3-4.9 8c-24.8 40.6-67.4 64.6-114.7 64.6-60.5 0-112.7-40.3-128.8-97.7h361.7zm-240.2-130.1c54.3 0 102.9 35.7 120 86.3h-239.7c16.8-50.6 65.4-86.3 119.7-86.3z" })
      ]
    }
  );
}
function lL(e) {
  return /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64l241.9 0c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5 608 384c0 35.3-28.7 64-64 64l-241.9 0c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5 32 128c0-35.3 28.7-64 64-64zm64 64l-64 0 0 64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64l64 0 0-64zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z" }) });
}
function cL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.5",
      height: "19.875",
      viewBox: "0 0 28.5 19.875",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { transform: "translate(-1376.759 -16.413)", children: /* @__PURE__ */ s.jsxs("g", { transform: "translate(1377.009 16.663)", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1348.956,462h-7.45a6.115,6.115,0,0,0,7.45,7.092Z",
            transform: "translate(-1321.396 -461.999)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1341.3,461.749h7.907v7.538l-.191.046a6.363,6.363,0,0,1-7.754-7.382Zm7.407.5h-6.99a5.865,5.865,0,0,0,6.99,6.642Z",
            transform: "translate(-1321.396 -461.999)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M894.4,687.154h7.45a6.115,6.115,0,0,0-7.45-7.092Z",
            transform: "translate(-894.396 -669.194)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M902.053,687.4h-7.907v-7.538l.191-.046a6.365,6.365,0,0,1,7.755,7.382Zm-7.407-.5h6.99a5.864,5.864,0,0,0-6.99-6.642Z",
            transform: "translate(-894.396 -669.194)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "circle",
          {
            cx: "3.853",
            cy: "3.853",
            r: "3.853",
            transform: "translate(9.946 5.127)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M3.853-.25a4.1,4.1,0,1,1-4.1,4.1A4.108,4.108,0,0,1,3.853-.25Zm0,7.707a3.6,3.6,0,1,0-3.6-3.6A3.607,3.607,0,0,0,3.853,7.457Z",
            transform: "translate(9.946 5.127)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M912.079,478.29H895.955V463.668H920.4v7.567a6.306,6.306,0,0,1,1.559.707V462H894.4v17.96h17.935A7.464,7.464,0,0,1,912.079,478.29Z",
            transform: "translate(-894.396 -461.999)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M912.657,480.209H894.146v-18.46h28.059v10.645l-.383-.241a6.063,6.063,0,0,0-1.5-.679l-.179-.053v-7.5H896.205V478.04H912.32l.009.241a7.229,7.229,0,0,0,.243,1.613Zm-18.011-.5h17.366a7.733,7.733,0,0,1-.169-1.169H895.705V463.418h24.941v7.633a6.538,6.538,0,0,1,1.059.456v-9.258H894.646Z",
            transform: "translate(-894.396 -461.999)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1324.349,672.157a4.53,4.53,0,1,0,4.53,4.53A4.529,4.529,0,0,0,1324.349,672.157Zm2.336,5.218h-4.671V676h4.671Z",
            transform: "translate(-1300.878 -661.841)",
            fill: "rgb(var(--text-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1324.349,671.907a4.78,4.78,0,1,1-4.779,4.78A4.785,4.785,0,0,1,1324.349,671.907Zm0,9.059a4.28,4.28,0,1,0-4.279-4.28A4.284,4.284,0,0,0,1324.349,680.966Zm-2.585-5.218h5.171v1.877h-5.171Zm4.671.5h-4.171v.877h4.171Z",
            transform: "translate(-1300.878 -661.841)",
            fill: "rgb(var(--text-secondary))"
          }
        )
      ] }) })
    }
  );
}
function uL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.501",
      height: "19.993",
      viewBox: "0 0 28.501 19.993",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { transform: "translate(-1365.793 -6.208)", children: /* @__PURE__ */ s.jsxs("g", { transform: "translate(1366.044 6.458)", children: [
        /* @__PURE__ */ s.jsx("g", { transform: "translate(18.113 10.469)", children: /* @__PURE__ */ s.jsxs("g", { transform: "translate(0)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M1294.017,246.759c-.564-3.762-5.946-4.28-8.082-1.652-.107-.224-.213-.449-.315-.675a.607.607,0,0,0-.829-.217.62.62,0,0,0-.217.829c.248.553.517,1.1.788,1.637a.535.535,0,0,0,.274.268.7.7,0,0,0,.562.132,14.655,14.655,0,0,1,1.475-.16c.777-.046.781-1.259,0-1.212-.223.013-.446.033-.669.055,1.678-1.768,5.429-1.444,5.843,1.318C1292.963,247.853,1294.131,247.524,1294.017,246.759Z",
              transform: "translate(-1284.501 -243.468)",
              fill: "rgb(var(--brand-primary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M1293.339,247.771h0a.725.725,0,0,1-.739-.653,2.694,2.694,0,0,0-2.869-2.2,3.741,3.741,0,0,0-1.955.541.772.772,0,0,1,.731.791.872.872,0,0,1-.819.921,14.307,14.307,0,0,0-1.45.157,1.1,1.1,0,0,1-.177.014.92.92,0,0,1-.556-.178.794.794,0,0,1-.367-.372c-.277-.553-.545-1.095-.792-1.646a.849.849,0,0,1,.755-1.261.793.793,0,0,1,.748.444c.047.1.1.212.152.331a5.2,5.2,0,0,1,3.695-1.443,4.326,4.326,0,0,1,4.569,3.5.879.879,0,0,1-.2.715A.966.966,0,0,1,1293.339,247.771Zm-3.608-3.354a3.764,3.764,0,0,1,2.158.64,2.893,2.893,0,0,1,1.205,1.986.229.229,0,0,0,.245.227.473.473,0,0,0,.343-.161.377.377,0,0,0,.087-.315,3.843,3.843,0,0,0-4.075-3.078,4.585,4.585,0,0,0-3.566,1.547l-.249.306-.171-.356c-.128-.266-.229-.482-.318-.681a.314.314,0,0,0-.292-.149.369.369,0,0,0-.183.045.389.389,0,0,0-.116.511c.243.542.509,1.079.784,1.627a.29.29,0,0,0,.147.149l.035.015.029.024a.456.456,0,0,0,.361.077,14.8,14.8,0,0,1,1.5-.163.37.37,0,0,0,.349-.406.287.287,0,0,0-.291-.308h-.029c-.2.012-.412.03-.658.055l-.671.068.464-.489A4.053,4.053,0,0,1,1289.731,244.418Z",
              transform: "translate(-1284.501 -243.468)",
              fill: "rgb(var(--brand-primary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M1300.009,347.246c.108.224.213.449.315.675a.608.608,0,0,0,.829.217.62.62,0,0,0,.218-.829c-.248-.553-.517-1.095-.788-1.637a.538.538,0,0,0-.275-.268.7.7,0,0,0-.562-.132,14.646,14.646,0,0,1-1.476.16c-.777.047-.781,1.259,0,1.212.224-.013.446-.033.669-.055-1.678,1.768-5.43,1.443-5.844-1.318-.116-.771-1.284-.442-1.169.322C1292.492,349.356,1297.873,349.874,1300.009,347.246Z",
              transform: "translate(-1291.556 -339.861)",
              fill: "rgb(var(--brand-primary))"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M1296.25,349.136h0a4.326,4.326,0,0,1-4.569-3.5.879.879,0,0,1,.2-.715.966.966,0,0,1,.722-.334.725.725,0,0,1,.739.653,2.694,2.694,0,0,0,2.869,2.2,3.742,3.742,0,0,0,1.955-.541.772.772,0,0,1-.731-.791.872.872,0,0,1,.819-.921,14.3,14.3,0,0,0,1.451-.157.965.965,0,0,1,.733.163.8.8,0,0,1,.367.371c.289.578.548,1.1.793,1.646a.849.849,0,0,1-.755,1.261.793.793,0,0,1-.748-.444c-.048-.106-.1-.215-.152-.331A5.2,5.2,0,0,1,1296.25,349.136Zm-3.645-4.053a.473.473,0,0,0-.343.161.376.376,0,0,0-.087.314,3.843,3.843,0,0,0,4.074,3.078h0a4.585,4.585,0,0,0,3.565-1.547l.249-.306.171.355c.124.258.225.474.318.681a.314.314,0,0,0,.292.149.369.369,0,0,0,.183-.045.39.39,0,0,0,.116-.512c-.241-.537-.5-1.055-.783-1.627a.292.292,0,0,0-.147-.149l-.035-.015-.029-.024a.457.457,0,0,0-.361-.077,14.791,14.791,0,0,1-1.5.163.371.371,0,0,0-.349.407.287.287,0,0,0,.291.308h.029c.2-.012.408-.029.659-.055l.67-.068-.464.488a4.053,4.053,0,0,1-2.908,1.173,3.764,3.764,0,0,1-2.158-.64,2.893,2.893,0,0,1-1.206-1.986A.229.229,0,0,0,1292.6,345.082Z",
              transform: "translate(-1291.556 -339.861)",
              fill: "rgb(var(--brand-primary))"
            }
          )
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1331.552,30h-7.443a6.109,6.109,0,0,0,7.443,7.085Z",
            transform: "translate(-1303.95 -30)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1323.9,29.75h7.9v7.532l-.191.046a6.359,6.359,0,0,1-7.748-7.375Zm7.4.5h-6.983a5.859,5.859,0,0,0,6.983,6.635Z",
            transform: "translate(-1303.95 -30)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M877,255.148h7.443A6.109,6.109,0,0,0,877,248.063Z",
            transform: "translate(-877 -237.205)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M884.65,255.4h-7.9v-7.532l.191-.046a6.359,6.359,0,0,1,7.748,7.375Zm-7.4-.5h6.983a5.859,5.859,0,0,0-6.983-6.635Z",
            transform: "translate(-877 -237.205)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "circle",
          {
            cx: "3.85",
            cy: "3.85",
            r: "3.85",
            transform: "translate(9.968 5.122)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M3.85-.25a4.1,4.1,0,1,1-4.1,4.1A4.1,4.1,0,0,1,3.85-.25Zm0,7.7a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,3.85,7.449Z",
            transform: "translate(9.968 5.122)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M894.711,46.276H878.562V31.667h24.479v7.56a6.318,6.318,0,0,1,1.562.707V30H877V47.943h17.963A7.44,7.44,0,0,1,894.711,46.276Z",
            transform: "translate(-877 -30)",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M895.289,48.193H876.75V29.75h28.1V40.386l-.383-.24a6.071,6.071,0,0,0-1.5-.679l-.179-.053v-7.5H878.812V46.026h16.14l.009.241a7.2,7.2,0,0,0,.244,1.611Zm-18.039-.5h17.393a7.718,7.718,0,0,1-.17-1.167H878.312V31.417h24.979v7.626a6.551,6.551,0,0,1,1.062.456V30.25h-27.1Z",
            transform: "translate(-877 -30)",
            fill: "rgb(var(--brand-primary))"
          }
        )
      ] }) })
    }
  );
}
function dL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.16",
      height: "18.511",
      viewBox: "0 0 28.16 18.511",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { transform: "translate(-1365.792 -6.141)", children: /* @__PURE__ */ s.jsxs("g", { transform: "translate(1366.044 6.458)", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1331.552,30h-7.443a6.109,6.109,0,0,0,7.443,7.085Z",
            transform: "translate(-1303.95 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1323.9,29.75h7.9v7.532l-.191.046a6.359,6.359,0,0,1-7.748-7.375Zm7.4.5h-6.983a5.859,5.859,0,0,0,6.983,6.635Z",
            transform: "translate(-1303.95 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M877,255.148h7.443A6.109,6.109,0,0,0,877,248.063Z",
            transform: "translate(-877 -237.205)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M884.65,255.4h-7.9v-7.532l.191-.046a6.359,6.359,0,0,1,7.748,7.375Zm-7.4-.5h6.983a5.859,5.859,0,0,0-6.983-6.635Z",
            transform: "translate(-877 -237.205)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx("circle", { cx: "3.85", cy: "3.85", r: "3.85", transform: "translate(9.968 5.122)", fill: "#35e190" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M3.85-.25a4.1,4.1,0,1,1-4.1,4.1A4.1,4.1,0,0,1,3.85-.25Zm0,7.7a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,3.85,7.449Z",
            transform: "translate(9.968 5.122)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M878.562,46.276V31.667h24.479c.2,2.75-.71,9.324,1.562-1.667H877l.076,17.575Z",
            transform: "translate(-877 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M876.828,48.123l-.079-18.373h28.16l-.062.3c-.467,2.258-.811,3.832-1.053,4.812-.118.477-.213.82-.29,1.047s-.163.479-.4.479a.274.274,0,0,1-.2-.084c-.149-.153-.154-.467-.113-2,.021-.794.045-1.684.012-2.386H878.812V46.389Zm.423-17.873.072,16.776.988-.864V31.417h24.962l.017.232c.054.754.027,1.77,0,2.667,0,.175-.01.361-.014.543.236-.946.575-2.486,1.016-4.609Z",
            transform: "translate(-877 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M878.5,45.981V31.637h23.492A20.627,20.627,0,0,0,903.49,30H877V47.618Z",
            transform: "translate(904.602 47.943) rotate(180)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M876.75,48.261V29.75H903.8l-.06.3c-.016.078-.045.224-1.566,1.763l-.073.074H878.749V46.078Zm.5-18.011V46.974l1-1.091v-14.5h23.638c.4-.405.814-.84,1.083-1.137Z",
            transform: "translate(904.602 47.943) rotate(180)",
            fill: "#35e190"
          }
        )
      ] }) })
    }
  );
}
function CL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "26",
      height: "18",
      viewBox: "0 0 26 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.69935 12.4767H0.977051V5.5008H5.69935L12.7833 0V17.9775L5.69935 12.4767ZM20.0553 10.3608L16.2753 14.1408L15.2142 13.0806C15.0648 12.9429 15.0648 12.7062 15.2142 12.5568L18.7206 9.0252L15.2025 5.5071C15.0522 5.3703 15.0522 5.1327 15.2025 4.9833L16.2627 3.9222L20.0553 7.7157L23.8362 3.9348L24.8964 4.9959C25.0458 5.1327 25.0458 5.3703 24.8964 5.5197L21.3783 9.0378L24.8964 12.5568C25.0458 12.7062 25.0458 12.9429 24.909 13.0932L23.8488 14.1534L20.0553 10.3608Z"
        }
      )
    }
  );
}
function pL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Layer_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 512 512",
      width: "512",
      height: "512",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx("path", { d: "M347,182c-90.981,0-165,74.019-165,165s74.019,165,165,165s165-74.019,165-165S437.981,182,347,182z M347,332   c24.814,0,45,20.186,45,45c0,19.53-12.578,36.024-30,42.237V452h-30v-32.763c-17.422-6.213-30-22.707-30-42.237h30   c0,8.276,6.724,15,15,15s15-6.724,15-15s-6.724-15-15-15c-24.814,0-45-20.186-45-45c0-19.53,12.578-36.024,30-42.237V242h30v32.763   c17.422,6.213,30,22.707,30,42.237h-30c0-8.276-6.724-15-15-15s-15,6.724-15,15S338.724,332,347,332z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M167,182c92.52,0,165-39.536,165-90S259.52,0,167,0S0,41.536,0,92S74.48,182,167,182z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M0,337.559V362c0,50.464,74.48,90,167,90c5.248,0,10.333-0.483,15.5-0.736c-11.506-18.091-20.087-38.165-25.14-59.625   C90.455,389.792,32.362,369.233,0,337.559z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M152.721,361.236C152.377,356.518,152,351.805,152,347c0-15.637,2.049-30.771,5.543-45.353   C90.555,299.832,32.391,279.262,0,247.559V272C0,319.787,67.262,357.342,152.721,361.236z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M167,272c0.016,0,0.029-0.002,0.046-0.002c9.893-23.644,24.274-44.958,42.133-62.816C195.632,210.894,181.632,212,167,212   c-71.217,0-133.074-21.237-167-54.441V182C0,232.464,74.48,272,167,272z" })
      ] })
    }
  );
}
function hL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "40",
      height: "44",
      viewBox: "0 0 40 44",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.7534 10.8353C28.7534 16.3019 24.3217 20.7339 18.8548 20.7339C13.3885 20.7339 8.95703 16.3022 8.95703 10.8353C8.95703 5.36877 13.3888 0.9375 18.8548 0.9375C24.3214 0.9375 28.7534 5.36892 28.7534 10.8353Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.0426 43.63H0.90625C0.90625 33.7153 8.94069 25.6816 18.8546 25.6816C21.994 25.6816 24.9453 26.4901 27.5123 27.9106C24.8301 29.5717 23.0448 32.5395 23.0448 35.9266C23.0448 39.1103 24.6238 41.9262 27.0422 43.6302L27.0426 43.63Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.4844 28.9473H34.4601V42.9371H30.4844V28.9473Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.4688 33.9492H39.4586V37.925H25.4688V33.9492Z"
          }
        )
      ]
    }
  );
}
function fL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M22.5747 19.6343C22.5747 19.7121 22.5747 19.7898 22.5747 19.8676C22.5747 21.1663 22.576 22.4644 22.5747 23.7631C22.5727 25.6276 21.2113 26.9962 19.3449 26.9976C14.9763 27.0008 10.6078 27.0008 6.23926 26.9976C4.62302 26.9962 3.35826 25.9758 3.05513 24.4308C3.01463 24.2243 3.00287 24.0088 3.00287 23.7977C3.00026 17.9338 2.9983 12.0699 3.00222 6.20602C3.00352 4.63748 4.00501 3.38447 5.50104 3.06828C5.72251 3.0219 5.95377 3.00295 6.18111 3.00295C10.615 2.99969 15.0488 2.99969 19.4827 3.00034C21.2864 3.00034 22.6662 4.37355 22.674 6.17271C22.6766 6.81815 22.6707 7.46295 22.6773 8.1084C22.6786 8.25539 22.6466 8.33705 22.4996 8.40434C21.9613 8.65193 21.4909 9.00079 21.0715 9.4215C19.5206 10.977 17.9795 12.5429 16.4077 14.0775C15.4558 15.0071 14.7934 16.0694 14.5589 17.3942C14.4341 18.0998 14.2165 18.7903 14.1042 19.4972C13.8697 20.9716 15.0567 22.3475 16.539 22.2174C17.7998 22.107 19.0666 21.9111 20.2399 21.3662C20.9591 21.0324 21.5961 20.5855 22.135 20.0021C22.2598 19.8669 22.3866 19.7336 22.512 19.5997C22.5329 19.6115 22.5532 19.6232 22.5741 19.635L22.5747 19.6343ZM12.7035 8.52585C14.3034 8.52585 15.9033 8.52715 17.5032 8.52519C18.0337 8.52454 18.3904 8.2776 18.5119 7.83989C18.7151 7.10821 18.2754 6.52025 17.5157 6.51895C15.2873 6.51633 13.0589 6.51829 10.8306 6.51829C9.86761 6.51829 8.90402 6.51372 7.94107 6.52025C7.31261 6.52417 6.82983 7.11475 6.93697 7.72949C7.02451 8.23187 7.3897 8.52323 7.95283 8.52454C9.5364 8.52781 11.12 8.52585 12.7035 8.52585ZM10.7469 10.6334C9.84083 10.6334 8.93472 10.6327 8.02861 10.6347C7.91494 10.6347 7.798 10.6366 7.6889 10.6628C7.19044 10.783 6.86641 11.2403 6.91867 11.7368C6.97682 12.2868 7.33025 12.6291 7.89207 12.6376C8.71652 12.6507 9.54097 12.6422 10.3654 12.6422C11.41 12.6422 12.4553 12.6448 13.4999 12.6409C14.0173 12.6389 14.3675 12.3946 14.4935 11.9674C14.7078 11.2403 14.2701 10.6392 13.5136 10.6347C12.5912 10.6288 11.6687 10.6334 10.7463 10.6327L10.7469 10.6334Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M23.9767 10.2354C24.8528 10.236 25.6008 10.7025 25.913 11.4825C26.2482 12.3207 26.1103 13.0987 25.4753 13.7416C23.8291 15.4087 22.1756 17.0701 20.5025 18.7105C20.0171 19.1867 19.4279 19.5258 18.7406 19.6695C18.0148 19.821 17.2936 19.9974 16.5697 20.1601C16.2117 20.2405 15.9739 20.0072 16.0549 19.6499C16.2385 18.8392 16.4247 18.0284 16.6194 17.2203C16.735 16.7408 16.9859 16.3292 17.3308 15.983C19.047 14.2583 20.7658 12.5356 22.4898 10.8187C22.8962 10.4144 23.4044 10.2341 23.9767 10.2354Z",
            fill: "rgb(var(--text-primary))"
          }
        )
      ]
    }
  );
}
function mL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsxs(
          "linearGradient",
          {
            id: "linear-gradient",
            x1: "0.5",
            x2: "0.5",
            y2: "1",
            gradientUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ s.jsx("stop", { offset: "0", stopColor: "#b5f292" }),
              /* @__PURE__ */ s.jsx("stop", { offset: "0.962", stopColor: "#a6de85" }),
              /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#ace68a" })
            ]
          }
        ) }),
        /* @__PURE__ */ s.jsxs("g", { id: "Groupe_3467", "data-name": "Groupe 3467", transform: "translate(-491.43 -1137.43)", children: [
          /* @__PURE__ */ s.jsx(
            "circle",
            {
              id: "Ellipse_3010",
              "data-name": "Ellipse 3010",
              cx: "9",
              cy: "9",
              r: "9",
              transform: "translate(491.43 1137.43)",
              fill: "#ace68a"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Icon_awesome-bell",
              "data-name": "Icon awesome-bell",
              d: "M3.624,8.284A1.035,1.035,0,0,0,4.659,7.248H2.589A1.035,1.035,0,0,0,3.624,8.284ZM7.109,5.862a3.01,3.01,0,0,1-.9-2.5A2.555,2.555,0,0,0,4.142.855V.518a.517.517,0,1,0-1.035,0V.855a2.555,2.555,0,0,0-2.07,2.51,3.01,3.01,0,0,1-.9,2.5A.506.506,0,0,0,0,6.213a.518.518,0,0,0,.519.518h6.21a.518.518,0,0,0,.519-.518.505.505,0,0,0-.139-.351Z",
              transform: "translate(496.879 1142.288)",
              fill: "#fff"
            }
          )
        ] })
      ]
    }
  );
}
function gL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 14 15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7517 12.6416H1.46897V2.35886H6.61035V0.889893H1.46897C0.65369 0.889893 0 1.55093 0 2.35886V12.6416C0 13.4496 0.65369 14.1106 1.46897 14.1106H11.7517C12.5597 14.1106 13.2207 13.4496 13.2207 12.6416V7.50025H11.7517V12.6416ZM8.07932 0.889893V2.35886H10.7161L3.49615 9.57883L4.53177 10.6145L11.7517 3.39448V6.03128H13.2207V0.889903L8.07932 0.889893Z"
        }
      )
    }
  );
}
function vL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "24",
      height: "23",
      viewBox: "0 0 24 23",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--brand-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M23.375 8.56255C23.375 8.4382 23.3464 8.31551 23.2914 8.20394C23.2365 8.09238 23.1567 7.99491 23.0581 7.91905L13.4861 0.556178C13.06 0.228463 12.5375 0.0507812 12 0.0507812C11.4625 0.0507812 10.94 0.228463 10.5139 0.556178L0.941875 7.91905C0.843334 7.99491 0.76352 8.09238 0.708582 8.20394C0.653645 8.31551 0.62505 8.4382 0.625 8.56255V19.9376C0.630307 20.5824 0.888819 21.1993 1.34479 21.6553C1.80077 22.1112 2.41768 22.3697 3.0625 22.3751H20.9375C21.5363 22.3798 22.1144 22.1564 22.5544 21.7502L22.5625 21.7405L22.5747 21.7316C22.5796 21.7267 22.5804 21.721 22.5853 21.7161C22.8334 21.4909 23.0318 21.2164 23.1678 20.9102C23.3038 20.6039 23.3743 20.2726 23.375 19.9376V8.56255ZM21.75 19.9091L15.4458 15.0626L21.75 10.2127V19.9091ZM12.4948 1.84318L21.23 8.56255L14.1125 14.0372L13.4861 13.5562C13.06 13.2285 12.5375 13.0508 12 13.0508C11.4625 13.0508 10.94 13.2285 10.5139 13.5562L9.8875 14.0372L2.77 8.56255L11.5044 1.84318C11.6464 1.73401 11.8205 1.67482 11.9996 1.67482C12.1787 1.67482 12.3528 1.73401 12.4948 1.84318ZM8.55419 15.0626L2.25 19.9091V10.2127L8.55419 15.0626ZM3.82219 20.7501L11.5044 14.8432C11.6464 14.734 11.8205 14.6748 11.9996 14.6748C12.1787 14.6748 12.3528 14.734 12.4948 14.8432L20.1778 20.7501H3.82219Z" })
    }
  );
}
function bL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "512",
      height: "512",
      fill: "rgb(var(--fill-primary))",
      x: "0",
      y: "0",
      viewBox: "0 0 511.626 511.626",
      ...e,
      children: /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M505.918 236.117c-26.651-43.587-62.485-78.609-107.497-105.065-45.015-26.457-92.549-39.687-142.608-39.687s-97.595 13.225-142.61 39.687C68.187 157.508 32.355 192.53 5.708 236.117 1.903 242.778 0 249.345 0 255.818c0 6.473 1.903 13.04 5.708 19.699 26.647 43.589 62.479 78.614 107.495 105.064 45.015 26.46 92.551 39.68 142.61 39.68 50.06 0 97.594-13.176 142.608-39.536 45.012-26.361 80.852-61.432 107.497-105.208 3.806-6.659 5.708-13.223 5.708-19.699 0-6.473-1.902-13.04-5.708-19.701zm-311.35-78.087c17.034-17.034 37.447-25.554 61.242-25.554 3.805 0 7.043 1.336 9.709 3.999 2.662 2.664 4 5.901 4 9.707 0 3.809-1.338 7.044-3.994 9.704-2.662 2.667-5.902 3.999-9.708 3.999-16.368 0-30.362 5.808-41.971 17.416-11.613 11.615-17.416 25.603-17.416 41.971 0 3.811-1.336 7.044-3.999 9.71-2.667 2.668-5.901 3.999-9.707 3.999-3.809 0-7.044-1.334-9.71-3.999-2.667-2.666-3.999-5.903-3.999-9.71 0-23.79 8.52-44.207 25.553-61.242zm185.299 191.01c-38.164 23.12-79.514 34.687-124.054 34.687-44.539 0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222c28.931-44.921 65.19-78.518 108.777-100.783-11.61 19.792-17.417 41.207-17.417 64.236 0 35.216 12.517 65.329 37.544 90.362s55.151 37.544 90.362 37.544c35.214 0 65.329-12.518 90.362-37.544s37.545-55.146 37.545-90.362c0-23.029-5.808-44.447-17.419-64.236 43.585 22.265 79.846 55.865 108.776 100.783-25.31 39.022-57.046 70.095-95.21 93.222z",
          "data-original": "#000000"
        }
      ) })
    }
  );
}
function yL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 500 500",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M484.058 101.194C421.738 166.233 360.94 262.231 320.78 355.43L367.1 381.51C425.899 298.631 476.537 196.873 499.657 109.995C502.137 100.794 490.697 94.3146 484.058 101.194Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M297.489 398.445C245.38 423.756 277.414 458.618 264.208 485.482C261.201 491.599 265.251 498.892 272.032 499.593C317.877 504.331 352.067 467.091 342.709 423.899L297.489 398.445Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M288.778 389.51L306.777 357.51C314.691 338.784 323.442 319.957 332.845 301.284C328.965 302.759 324.793 303.657 320.381 303.657C301.109 303.657 285.529 288.075 285.529 268.806C285.529 249.418 301.109 233.836 320.381 233.836C337.037 233.836 350.813 245.367 354.384 260.902C376.632 221.305 401.426 183.317 427.229 149.571C419.055 108.456 398.75 70.4015 363.948 42.1783C295.711 -13.1805 198.752 -8.6206 121.794 24.6586C84.8341 40.6583 4.83552 93.3776 35.876 144.337C53.235 172.816 108.834 179.776 107.953 220.095C107.314 251.614 63.8755 262.094 42.1943 275.214C20.1947 288.574 5.87662 312.414 1.39622 337.933C-5.48453 377.852 13.4761 414.252 49.2352 432.571C95.4746 456.171 157.073 454.011 207.152 444.811C223.159 441.884 239.199 437.804 254.888 432.61C256.899 417.799 264.626 402.2 288.778 389.51ZM343.408 112.077C362.795 112.077 378.378 127.659 378.378 147.047C378.378 166.316 362.795 181.898 343.408 181.898C324.138 181.898 308.557 166.316 308.557 147.047C308.557 127.659 324.138 112.077 343.408 112.077ZM244.467 42.256C263.854 42.256 279.436 57.8377 279.436 77.2261C279.436 96.4952 263.854 112.077 244.467 112.077C225.197 112.077 209.615 96.4952 209.615 77.2261C209.615 57.8378 225.197 42.256 244.467 42.256ZM115.705 376.008C89.0177 387.877 60.321 381.126 51.4325 361.143C42.4874 341.032 56.7507 315.327 83.4378 303.457C109.955 291.663 138.596 298.287 147.54 318.397C156.429 338.381 142.223 364.214 115.705 376.008ZM135.595 146.988C116.324 146.988 100.743 131.405 100.743 112.137C100.743 92.7483 116.324 77.1665 135.595 77.1665C154.981 77.1665 170.564 92.7482 170.564 112.137C170.564 131.405 154.981 146.988 135.595 146.988ZM238.681 387.358C219.41 387.358 203.83 371.776 203.83 352.507C203.83 333.119 219.41 317.537 238.681 317.537C258.067 317.537 273.65 333.119 273.65 352.507C273.65 371.776 258.067 387.358 238.681 387.358Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M303.427 387.988L348.225 413.188L360.465 391.588L315.587 366.309L303.427 387.988Z" })
      ]
    }
  );
}
function Yh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "18",
      height: "21",
      viewBox: "0 0 18 21",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.67824 19.4354L9.29538 15.5267L9.3387 15.3101C9.37119 15.1261 9.46863 14.9528 9.6094 14.8229C9.75013 14.7038 9.94504 14.628 10.1291 14.628H10.6163C11.4284 14.628 12.1863 14.5414 12.8468 14.3682C13.5506 14.1841 14.1786 13.9026 14.7199 13.5236C15.283 13.123 15.7594 12.6033 16.1275 11.9753C16.5173 11.3148 16.8096 10.5244 16.9829 9.62575C17.1345 8.82452 17.167 8.10991 17.0695 7.50357C16.9612 6.85392 16.7122 6.31255 16.3333 5.86862C16.095 5.59794 15.8027 5.37056 15.4454 5.17567H15.4346V5.16485C15.5645 4.36362 15.5537 3.70314 15.4237 3.12928C15.2938 2.55543 15.0123 2.03572 14.59 1.54847C13.7022 0.54152 12.0889 0.0218048 9.8043 0.0218048H3.51355C3.30784 0.0218048 3.10211 0.0975972 2.9397 0.23835C2.7773 0.379114 2.66902 0.563184 2.63654 0.768897L0.00546765 17.3998C-0.016197 17.5514 0.0271323 17.703 0.124567 17.8221C0.222013 17.9412 0.373609 18.0062 0.525194 18.0062H4.43389V18.0278L4.1632 19.7278C4.14154 19.8577 4.18486 19.9984 4.27149 20.0959C4.35809 20.1933 4.48802 20.2583 4.61796 20.2583H7.89866C8.08273 20.2583 8.25597 20.1933 8.39673 20.0742C8.53748 19.9551 8.62411 19.7927 8.65659 19.6087L8.67825 19.4354"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.4549 5.16492C15.4333 5.28402 15.4116 5.40313 15.3899 5.53305C14.5562 9.79905 11.7194 11.2716 8.09223 11.2716H6.24074C5.79683 11.2716 5.42869 11.5964 5.35291 12.0295L4.14023 19.7278C4.09691 20.0093 4.31346 20.2692 4.60582 20.2692H7.88651C8.27631 20.2692 8.60113 19.9877 8.66609 19.6087L8.69858 19.4463L9.31576 15.5376L9.35907 15.3211C9.42403 14.9421 9.74884 14.6606 10.1386 14.6606H10.6259C13.7983 14.6606 16.2886 13.3721 17.0141 9.64748C17.3172 8.08833 17.1656 6.78904 16.3536 5.87953C16.1046 5.57636 15.8014 5.34899 15.4549 5.16493"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5792 4.81794C14.4492 4.78546 14.3193 4.75298 14.1894 4.7205C14.0595 4.68801 13.9187 4.66636 13.7779 4.6447C13.2799 4.56891 12.7385 4.5256 12.1538 4.5256H7.21651C7.0974 4.5256 6.9783 4.55809 6.88086 4.6014C6.65348 4.70967 6.48024 4.92622 6.44776 5.18607L5.3975 11.8341L5.36501 12.029C5.42997 11.5959 5.80894 11.2711 6.25286 11.2711H8.10436C11.7316 11.2711 14.5683 9.79856 15.402 5.53255C15.4237 5.40262 15.4454 5.28352 15.467 5.16442C15.2613 5.05614 15.0339 4.95869 14.7849 4.87208C14.7091 4.85043 14.6441 4.8396 14.5792 4.81794",
            fill: "#B3BCC7",
            className: "group-aria-checked:fill-brand-primary-hover group-aria-checked:easy-out group-aria-checked:transition-colors group-aria-checked:duration-75"
          }
        )
      ]
    }
  );
}
function xL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "124",
      height: "31",
      viewBox: "0 0 124 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M46.2113 6.75H39.3723C38.9043 6.75 38.5063 7.09 38.4333 7.552L35.6673 25.089C35.6123 25.435 35.8803 25.747 36.2313 25.747H39.4963C39.9643 25.747 40.3623 25.407 40.4353 24.944L41.1813 20.214C41.2533 19.751 41.6523 19.411 42.1193 19.411H44.2843C48.7893 19.411 51.3893 17.231 52.0683 12.911C52.3743 11.021 52.0813 9.536 51.1963 8.496C50.2243 7.354 48.5003 6.75 46.2113 6.75ZM47.0002 13.1569C46.6263 15.6109 44.7513 15.6109 42.9383 15.6109H41.9062L42.6302 11.0279C42.6733 10.7509 42.9132 10.5469 43.1933 10.5469H43.6663C44.9012 10.5469 46.0662 10.5469 46.6683 11.2509C47.0273 11.6709 47.1373 12.2949 47.0002 13.1569Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.654 13.0736H63.379C63.1 13.0736 62.859 13.2776 62.816 13.5546L62.671 14.4706L62.442 14.1386C61.733 13.1096 60.152 12.7656 58.574 12.7656C54.955 12.7656 51.864 15.5066 51.262 19.3516C50.949 21.2696 51.394 23.1036 52.482 24.3826C53.48 25.5586 54.908 26.0486 56.607 26.0486C59.523 26.0486 61.14 24.1736 61.14 24.1736L60.994 25.0836C60.939 25.4316 61.207 25.7436 61.556 25.7436H64.506C64.975 25.7436 65.371 25.4036 65.445 24.9406L67.215 13.7316C67.271 13.3866 67.004 13.0736 66.654 13.0736ZM62.09 19.4473C61.774 21.3183 60.289 22.5743 58.395 22.5743C57.444 22.5743 56.684 22.2693 56.196 21.6913C55.712 21.1173 55.528 20.3003 55.682 19.3903C55.977 17.5353 57.487 16.2383 59.352 16.2383C60.282 16.2383 61.038 16.5473 61.536 17.1303C62.035 17.7193 62.233 18.5413 62.09 19.4473Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M84.0946 13.0742H80.8036C80.4896 13.0742 80.1946 13.2302 80.0166 13.4912L75.4776 20.1772L73.5536 13.7522C73.4326 13.3502 73.0616 13.0742 72.6416 13.0742H69.4076C69.0146 13.0742 68.7416 13.4582 68.8666 13.8282L72.4916 24.4662L69.0836 29.2772C68.8156 29.6562 69.0856 30.1772 69.5486 30.1772H72.8356C73.1476 30.1772 73.4396 30.0252 73.6166 29.7692L84.5626 13.9692C84.8246 13.5912 84.5556 13.0742 84.0946 13.0742L84.0946 13.0742Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.9926 6.75H88.1526C87.6856 6.75 87.2876 7.09 87.2146 7.552L84.4486 25.089C84.3936 25.435 84.6616 25.747 85.0106 25.747H88.5206C88.8466 25.747 89.1256 25.509 89.1766 25.185L89.9616 20.214C90.0336 19.751 90.4326 19.411 90.8996 19.411H93.0636C97.5696 19.411 100.169 17.231 100.849 12.911C101.156 11.021 100.861 9.536 99.9756 8.496C99.0046 7.354 97.2816 6.75 94.9926 6.75H94.9926ZM95.7805 13.1569C95.4075 15.6109 93.5325 15.6109 91.7185 15.6109H90.6875L91.4125 11.0279C91.4555 10.7509 91.6935 10.5469 91.9745 10.5469H92.4475C93.6815 10.5469 94.8475 10.5469 95.4495 11.2509C95.8085 11.6709 95.9175 12.2949 95.7805 13.1569Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.435 13.0736H112.162C111.881 13.0736 111.642 13.2776 111.6 13.5546L111.455 14.4706L111.225 14.1386C110.516 13.1096 108.936 12.7656 107.358 12.7656C103.739 12.7656 100.649 15.5066 100.047 19.3516C99.7349 21.2696 100.178 23.1036 101.266 24.3826C102.266 25.5586 103.692 26.0486 105.391 26.0486C108.307 26.0486 109.924 24.1736 109.924 24.1736L109.778 25.0836C109.723 25.4316 109.991 25.7436 110.342 25.7436H113.291C113.758 25.7436 114.156 25.4036 114.229 24.9406L116 13.7316C116.054 13.3866 115.786 13.0736 115.435 13.0736H115.435ZM110.87 19.4473C110.556 21.3183 109.069 22.5743 107.175 22.5743C106.226 22.5743 105.464 22.2693 104.976 21.6913C104.492 21.1173 104.31 20.3003 104.462 19.3903C104.759 17.5353 106.267 16.2383 108.132 16.2383C109.062 16.2383 109.818 16.5473 110.316 17.1303C110.817 17.7193 111.015 18.5413 110.87 19.4473Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M119.295 7.232L116.488 25.09C116.433 25.436 116.701 25.748 117.05 25.748H119.872C120.341 25.748 120.739 25.408 120.811 24.945L123.579 7.409C123.634 7.063 123.366 6.75 123.017 6.75H119.857C119.578 6.751 119.338 6.955 119.295 7.232Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.2675 29.1534L7.7905 25.8314L6.6255 25.8044H1.0625L4.9285 1.29144C4.9405 1.21744 4.9795 1.14844 5.0365 1.09944C5.0935 1.05044 5.1665 1.02344 5.2425 1.02344H14.6225C17.7365 1.02344 19.8855 1.67144 21.0075 2.95044C21.5335 3.55044 21.8685 4.17744 22.0305 4.86744C22.2005 5.59144 22.2035 6.45644 22.0375 7.51144L22.0255 7.58844V8.26444L22.5515 8.56244C22.9945 8.79744 23.3465 9.06644 23.6165 9.37444C24.0665 9.88744 24.3575 10.5394 24.4805 11.3124C24.6075 12.1074 24.5655 13.0534 24.3575 14.1244C24.1175 15.3564 23.7295 16.4294 23.2055 17.3074C22.7235 18.1164 22.1095 18.7874 21.3805 19.3074C20.6845 19.8014 19.8575 20.1764 18.9225 20.4164C18.0165 20.6524 16.9835 20.7714 15.8505 20.7714H15.1205C14.5985 20.7714 14.0915 20.9594 13.6935 21.2964C13.2945 21.6404 13.0305 22.1104 12.9495 22.6244L12.8945 22.9234L11.9705 28.7784L11.9285 28.9934C11.9175 29.0614 11.8985 29.0954 11.8705 29.1184C11.8455 29.1394 11.8095 29.1534 11.7745 29.1534H7.2675Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M12.0772 16.763C17.4822 16.763 21.7142 14.569 22.9512 8.21797L23.0472 7.66797C23.5722 7.94597 24.0212 8.28697 24.3832 8.69797C25.5792 10.061 25.8132 11.999 25.3612 14.32C24.2792 19.876 20.5772 21.796 15.8482 21.796H15.1182C14.5402 21.796 14.0482 22.216 13.9582 22.788L13.8992 23.108L12.9802 28.94L12.9322 29.188C12.8412 29.758 12.3502 30.178 11.7722 30.178H6.89117C6.45917 30.178 6.12917 29.792 6.19617 29.364L6.59517 26.831L8.00417 17.895C8.10717 17.243 8.66417 16.763 9.32517 16.763H12.0772Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7529 7.15103C21.5639 7.09603 21.3689 7.04603 21.1689 7.00103C20.9679 6.95703 20.7619 6.91803 20.5499 6.88403C19.8079 6.76403 18.9949 6.70703 18.1239 6.70703H10.7719C10.5909 6.70703 10.4189 6.74803 10.2649 6.82203C9.92591 6.98503 9.67391 7.30603 9.61291 7.69903L8.04891 17.605L8.00391 17.894C8.10691 17.242 8.66391 16.762 9.32491 16.762H12.0769C17.4819 16.762 21.7139 14.567 22.9509 8.21703C22.9879 8.02903 23.0189 7.84603 23.0469 7.66703C22.7339 7.50103 22.3949 7.35903 22.0299 7.23803C21.9399 7.20803 21.8469 7.17903 21.7529 7.15103Z",
            fill: "#222D65"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.61399 7.699C9.67499 7.306 9.92699 6.985 10.266 6.823C10.421 6.749 10.592 6.708 10.773 6.708H18.125C18.996 6.708 19.809 6.765 20.551 6.885C20.763 6.919 20.969 6.958 21.17 7.002C21.37 7.047 21.565 7.097 21.754 7.152C21.848 7.18 21.941 7.209 22.032 7.238C22.397 7.359 22.736 7.502 23.049 7.667C23.417 5.32 23.046 3.722 21.777 2.275C20.378 0.682 17.853 0 14.622 0H5.24199C4.58199 0 4.01899 0.48 3.91699 1.133L0.00998882 25.898C-0.0670112 26.388 0.310989 26.83 0.804989 26.83H6.59599L8.04999 17.605L9.61399 7.699Z",
            fill: "#253B80"
          }
        )
      ]
    }
  );
}
function Wh(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 50 50",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M44.5947 49.5015H3.30047C1.91372 49.5015 0.732422 48.3202 0.732422 46.8821L0.732422 42.2082C0.732422 40.7701 1.91372 39.5888 3.30047 39.5888H44.5947C46.0328 39.5888 47.1628 40.7701 47.2141 42.2082V46.8307C47.2141 48.3202 46.0328 49.5015 44.5947 49.5015ZM44.5947 23.5642L3.30047 23.5642C2.63278 23.5642 1.96509 23.3074 1.50284 22.7937C0.989227 22.2801 0.732422 21.6638 0.732422 20.9448L0.732422 16.2709C0.732422 14.8328 1.91372 13.6515 3.30047 13.6515H44.5947C46.0328 13.6515 47.1628 14.7814 47.2141 16.2709V20.9448C47.1628 22.4342 46.0328 23.5642 44.5947 23.5642ZM26.567 10.6212H3.30047C2.63278 10.6212 1.96509 10.3644 1.50284 9.85078C1.04059 9.33717 0.732422 8.72084 0.732422 8.00178L0.732422 3.32793C0.732422 1.88982 1.91372 0.708518 3.30047 0.708518H26.5156C27.9537 0.708518 29.0837 1.88982 29.0837 3.27657V7.95042C29.135 9.49125 28.0051 10.6726 26.567 10.6212ZM47.2141 36.5585H3.30047C2.63278 36.5585 1.96509 36.3017 1.50284 35.7881C1.04059 35.2745 0.732422 34.6581 0.732422 33.9391L0.732422 29.2652C0.732422 27.8271 1.91372 26.6458 3.30047 26.6458L47.1628 26.6458C48.6009 26.6458 49.7308 27.8271 49.7308 29.2652V33.9391C49.7822 35.3772 48.6009 36.5071 47.2141 36.5585Z" })
    }
  );
}
function wL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "169",
      height: "30",
      viewBox: "0 0 169 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_210_22)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M24.1964 2.85986H1.65431C0.897301 2.85986 0.252441 3.50472 0.252441 4.28976V6.84117C0.252441 7.62621 0.897301 8.27107 1.65431 8.27107H24.1964C24.9814 8.27107 25.5982 7.62621 25.6263 6.84117V4.3178C25.6263 3.50472 24.9814 2.85986 24.1964 2.85986ZM24.1964 17.0187H1.65431C1.28982 17.0187 0.925339 17.1589 0.673002 17.4393C0.392628 17.7197 0.252441 18.0561 0.252441 18.4486V21C0.252441 21.7851 0.897301 22.43 1.65431 22.43H24.1964C24.9814 22.43 25.5982 21.8131 25.6263 21V18.4486C25.5982 17.6356 24.9814 17.0187 24.1964 17.0187ZM14.3552 24.0842H1.65431C1.28982 24.0842 0.925339 24.2243 0.673002 24.5047C0.420666 24.7851 0.252441 25.1215 0.252441 25.5141V28.0655C0.252441 28.8505 0.897301 29.4954 1.65431 29.4954H14.3272C15.1123 29.4954 15.7291 28.8505 15.7291 28.0935V25.5421C15.7571 24.701 15.1403 24.0842 14.3552 24.0842ZM25.6263 9.92528H1.65431C1.28982 9.92528 0.925339 10.0655 0.673002 10.3458C0.420666 10.6262 0.252441 10.9627 0.252441 11.3552V13.9066C0.252441 14.6916 0.897301 15.3365 1.65431 15.3365H25.5982C26.3833 15.3365 27.0001 14.6916 27.0001 13.9066V11.3552C27.0281 10.5982 26.3833 9.95332 25.6263 9.92528Z",
              fill: "#2DBDEF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M51.8412 8.57948C51.1402 7.85051 50.3272 7.28976 49.4019 6.89724C48.4767 6.50471 47.4954 6.30845 46.486 6.30845C45.5047 6.28041 44.5515 6.50471 43.6543 6.92527C43.0655 7.20565 42.5328 7.59816 42.0842 8.0748V7.62621C42.0842 7.40191 42.0001 7.17761 41.8599 7.00938C41.7197 6.84116 41.4954 6.72901 41.243 6.72901H38.1309C37.9066 6.72901 37.6823 6.81312 37.5421 7.00938C37.3739 7.17761 37.2898 7.40191 37.3178 7.62621V28.5982C37.3178 28.8225 37.4019 29.0468 37.5421 29.215C37.7103 29.3832 37.9066 29.4673 38.1309 29.4673H41.3272C41.5515 29.4673 41.7477 29.3832 41.9159 29.215C42.0842 29.0748 42.1963 28.8505 42.1683 28.5982V21.4206C42.6169 21.9253 43.2057 22.2898 43.8505 22.5141C44.6916 22.8225 45.5608 22.9907 46.458 22.9907C47.4673 22.9907 48.4767 22.7944 49.4019 22.4019C50.3272 22.0094 51.1683 21.4486 51.8692 20.7197C52.5982 19.9627 53.1589 19.0655 53.5515 18.0841C54.0001 16.9907 54.1963 15.8131 54.1683 14.6356C54.1963 13.458 53.972 12.2804 53.5515 11.1589C53.1309 10.2337 52.5701 9.33649 51.8412 8.57948ZM48.9814 16.1776C48.8131 16.6262 48.5608 17.0187 48.2244 17.3832C47.5795 18.0841 46.6543 18.4767 45.701 18.4767C45.2244 18.4767 44.7477 18.3926 44.2991 18.1683C43.8786 17.972 43.486 17.7197 43.1496 17.3832C42.8131 17.0468 42.5608 16.6262 42.3926 16.1776C42.0281 15.2243 42.0281 14.187 42.3926 13.2337C42.5608 12.7851 42.8412 12.3926 43.1496 12.0561C43.486 11.7197 43.8786 11.4393 44.2991 11.243C44.7477 11.0468 45.2244 10.9346 45.701 10.9346C46.2057 10.9346 46.6543 11.0187 47.1309 11.243C47.5515 11.4393 47.944 11.6916 48.2524 12.0281C48.5888 12.3645 48.8131 12.757 49.0094 13.2056C49.3459 14.187 49.3178 15.2243 48.9814 16.1776ZM71.2991 6.75705H68.1309C67.9066 6.75705 67.6823 6.84116 67.5421 7.00938C67.3739 7.17761 67.2898 7.4019 67.2898 7.65424V8.04677C66.8973 7.57013 66.3926 7.20564 65.8599 6.9533C64.9907 6.53274 64.0374 6.33649 63.0842 6.33649C61.0374 6.33649 59.1029 7.14957 57.6449 8.57948C56.8879 9.33649 56.2991 10.2337 55.9066 11.215C55.458 12.3084 55.2337 13.486 55.2617 14.6916C55.2337 15.8692 55.458 17.0468 55.9066 18.1683C56.3272 19.1496 56.8879 20.0468 57.6449 20.8038C59.0748 22.2617 61.0374 23.0748 63.0561 23.0748C64.0094 23.1028 64.9627 22.8785 65.8318 22.458C66.3645 22.1776 66.8973 21.8131 67.2898 21.3645V21.7851C67.2898 22.0094 67.3739 22.2337 67.5421 22.4019C67.7103 22.5421 67.9066 22.6542 68.1309 22.6542H71.2991C71.5234 22.6542 71.7477 22.5701 71.8879 22.4019C72.0561 22.2337 72.1402 22.0094 72.1402 21.7851V7.68228C72.1402 7.45798 72.0561 7.23369 71.9159 7.06546C71.7477 6.8692 71.5234 6.75705 71.2991 6.75705ZM67.0094 16.1776C66.8412 16.6262 66.5888 17.0187 66.2524 17.3832C65.9159 17.7197 65.5515 18 65.1309 18.1963C64.2337 18.6169 63.1963 18.6169 62.2991 18.1963C61.8786 18 61.486 17.7197 61.1496 17.3832C60.8131 17.0468 60.5608 16.6262 60.3926 16.1776C60.0561 15.2243 60.0561 14.187 60.3926 13.2337C60.5608 12.7851 60.8131 12.4206 61.1496 12.0561C61.486 11.7197 61.8505 11.4393 62.2991 11.243C63.1963 10.8225 64.2337 10.8225 65.1029 11.243C65.5234 11.4393 65.9159 11.6916 66.2244 12.0281C66.5328 12.3645 66.7851 12.757 66.9814 13.2056C67.3739 14.187 67.3739 15.2243 67.0094 16.1776ZM102.869 14.2711C102.421 13.8785 101.888 13.5421 101.327 13.3178C100.738 13.0655 100.094 12.8972 99.4767 12.757L97.0655 12.2804C96.4487 12.1683 96.0001 12 95.7758 11.8038C95.5795 11.6636 95.4393 11.4393 95.4393 11.187C95.4393 10.9346 95.5795 10.7103 95.8879 10.5141C96.3085 10.2898 96.7571 10.1776 97.2337 10.2056C97.8505 10.2056 98.4674 10.3458 99.0281 10.5701C99.5888 10.8225 100.122 11.0748 100.626 11.4113C101.327 11.8599 101.944 11.7757 102.365 11.2711L103.514 9.95331C103.738 9.72901 103.851 9.44864 103.879 9.14023C103.851 8.80378 103.682 8.5234 103.43 8.2991C102.953 7.87854 102.168 7.42994 101.131 6.98134C100.094 6.53275 98.7758 6.30845 97.2337 6.30845C96.2804 6.28041 95.3552 6.4206 94.458 6.70097C93.701 6.95331 92.972 7.31779 92.3272 7.79443C91.7384 8.24302 91.2898 8.80377 90.9533 9.47667C90.6449 10.1215 90.4767 10.8225 90.4767 11.5234C90.4767 12.8412 90.8692 13.9066 91.6543 14.6916C92.4393 15.4767 93.4767 16.0094 94.7664 16.2617L97.2898 16.8225C97.8225 16.9066 98.3832 17.0748 98.8879 17.3271C99.1683 17.4393 99.3365 17.7197 99.3365 18.0281C99.3365 18.3084 99.1963 18.5608 98.8879 18.7851C98.5795 19.0094 98.0748 19.1496 97.4019 19.1496C96.729 19.1496 96.0281 19.0094 95.4113 18.701C94.8225 18.4206 94.2898 18.0561 93.7851 17.6355C93.5608 17.4673 93.3365 17.3271 93.0561 17.215C92.7758 17.1309 92.4113 17.215 92.0468 17.5234L90.673 18.5608C90.2804 18.8412 90.0842 19.3178 90.1963 19.7664C90.2804 20.243 90.6449 20.6916 91.3458 21.2243C93.0842 22.4019 95.1589 23.0187 97.2617 22.9627C98.243 22.9627 99.2244 22.8505 100.15 22.5701C100.963 22.3178 101.72 21.9533 102.393 21.4486C103.009 21 103.514 20.4112 103.851 19.7103C104.187 19.0374 104.355 18.3085 104.355 17.5514C104.383 16.8785 104.243 16.2056 103.963 15.5888C103.682 15.1402 103.318 14.6636 102.869 14.2711ZM116.72 18.1122C116.579 17.8599 116.327 17.6916 116.019 17.6355C115.738 17.6355 115.43 17.7197 115.206 17.8879C114.813 18.1402 114.365 18.2804 113.916 18.3084C113.776 18.3084 113.608 18.2804 113.467 18.2524C113.299 18.2243 113.159 18.1402 113.047 18.0281C112.907 17.8879 112.794 17.7197 112.71 17.5514C112.598 17.2711 112.542 16.9907 112.57 16.7103V10.9627H116.664C116.916 10.9627 117.14 10.8505 117.308 10.6823C117.477 10.5141 117.589 10.3178 117.589 10.0655V7.62621C117.589 7.37387 117.505 7.14957 117.308 7.00938C117.14 6.84116 116.916 6.75705 116.692 6.75705H112.57V2.83181C112.57 2.60752 112.486 2.35518 112.318 2.21499C112.15 2.0748 111.953 1.99069 111.729 1.96265H108.533C108.308 1.96265 108.084 2.04676 107.916 2.21499C107.748 2.38321 107.636 2.60752 107.636 2.83181V6.75705H105.813C105.589 6.75705 105.365 6.84116 105.196 7.03742C105.056 7.20565 104.972 7.42994 104.972 7.65424V10.0935C104.972 10.3178 105.056 10.5421 105.196 10.7103C105.337 10.9066 105.561 10.9907 105.813 10.9907H107.636V17.8318C107.608 18.6449 107.776 19.458 108.112 20.187C108.421 20.8038 108.813 21.3365 109.346 21.7851C109.851 22.2056 110.439 22.5141 111.084 22.6823C111.729 22.8785 112.402 22.9907 113.075 22.9907C113.944 22.9907 114.841 22.8505 115.682 22.5701C116.467 22.3178 117.168 21.8692 117.729 21.2804C118.094 20.9159 118.122 20.3271 117.841 19.9066L116.72 18.1122ZM134.047 6.75705H130.879C130.654 6.75705 130.458 6.84116 130.29 7.00938C130.122 7.17761 130.037 7.4019 130.037 7.65424V8.04677C129.645 7.57013 129.168 7.20564 128.608 6.9533C127.738 6.53274 126.785 6.33649 125.832 6.33649C123.785 6.33649 121.851 7.14957 120.393 8.57948C119.636 9.33649 119.047 10.2337 118.654 11.215C118.206 12.3084 117.981 13.486 118.009 14.6636C117.981 15.8412 118.206 17.0187 118.654 18.1402C119.047 19.1215 119.664 20.0187 120.393 20.7757C121.822 22.2337 123.757 23.0468 125.804 23.0468C126.757 23.0748 127.71 22.8505 128.579 22.458C129.14 22.1776 129.645 21.8131 130.037 21.3645V21.7851C130.037 22.0094 130.122 22.2337 130.29 22.3739C130.458 22.5421 130.654 22.6262 130.879 22.6262H134.047C134.523 22.6262 134.888 22.2617 134.888 21.7851V7.68228C134.888 7.45798 134.804 7.23369 134.664 7.06546C134.523 6.8692 134.299 6.75705 134.047 6.75705ZM129.785 16.2056C129.617 16.6542 129.365 17.0468 129.028 17.4113C128.692 17.7477 128.327 18.0281 127.907 18.2243C127.458 18.4206 126.981 18.5327 126.477 18.5327C125.972 18.5327 125.523 18.4206 125.075 18.2243C124.654 18.0281 124.262 17.7477 123.925 17.4113C123.589 17.0748 123.337 16.6542 123.196 16.2056C122.86 15.2524 122.86 14.215 123.196 13.2617C123.365 12.8131 123.617 12.4206 123.925 12.0842C124.262 11.7477 124.654 11.4673 125.075 11.2711C125.523 11.0748 126 10.9627 126.477 10.9627C126.953 10.9627 127.43 11.0468 127.907 11.2711C128.327 11.4673 128.692 11.7197 129.028 12.0561C129.365 12.3926 129.617 12.7851 129.785 13.2337C130.15 14.1589 130.15 15.2524 129.785 16.2056ZM151.43 17.9159L149.608 16.5141C149.271 16.2337 148.935 16.1496 148.654 16.2617C148.402 16.3739 148.178 16.5421 147.981 16.7384C147.589 17.215 147.112 17.6356 146.608 18C146.047 18.3085 145.458 18.4767 144.841 18.4206C144.112 18.4206 143.439 18.2243 142.851 17.8038C142.262 17.3832 141.813 16.8225 141.589 16.1215C141.421 15.6449 141.337 15.1683 141.337 14.6916C141.337 14.187 141.421 13.7103 141.589 13.2056C141.757 12.757 141.981 12.3645 142.318 12.0281C142.654 11.6916 143.019 11.4113 143.439 11.243C143.888 11.0468 144.365 10.9346 144.869 10.9346C145.486 10.9066 146.103 11.0748 146.636 11.3832C147.168 11.7197 147.617 12.1402 148.009 12.6449C148.178 12.8412 148.402 13.0094 148.654 13.1215C148.935 13.2337 149.271 13.1496 149.608 12.8692L151.43 11.4954C151.654 11.3552 151.822 11.1309 151.907 10.8785C152.019 10.5982 151.991 10.2898 151.822 10.0374C151.122 8.94396 150.168 8.04676 149.019 7.4019C147.813 6.72901 146.383 6.36453 144.785 6.36453C143.664 6.36453 142.542 6.58882 141.477 7.00938C140.467 7.42994 139.57 8.01873 138.813 8.77573C138.056 9.53274 137.439 10.4299 137.019 11.4393C136.15 13.5421 136.15 15.8972 137.019 18C137.439 18.9813 138.028 19.9066 138.813 20.6356C140.411 22.2056 142.542 23.0468 144.785 23.0468C146.383 23.0468 147.813 22.6823 149.019 22.0094C150.168 21.3645 151.15 20.4673 151.851 19.3458C151.991 19.0935 152.019 18.7851 151.935 18.5327C151.822 18.3085 151.654 18.0841 151.43 17.9159ZM168.308 21.1963L163.29 13.8505L167.58 8.18696C167.776 7.93462 167.86 7.57013 167.748 7.26172C167.664 7.03742 167.467 6.81312 166.935 6.81312H163.542C163.346 6.81312 163.15 6.86919 162.981 6.9533C162.757 7.06545 162.589 7.23368 162.477 7.42994L159.056 12.2243H158.243V0.897237C158.243 0.672938 158.159 0.448635 157.991 0.280411C157.822 0.112187 157.626 0.0280762 157.402 0.0280762H154.234C154.009 0.0280762 153.785 0.112187 153.617 0.280411C153.449 0.448635 153.365 0.6449 153.365 0.897237V21.7851C153.365 22.0374 153.449 22.2337 153.617 22.4019C153.785 22.5701 154.009 22.6542 154.234 22.6542H157.402C157.626 22.6542 157.851 22.5701 157.991 22.4019C158.159 22.2337 158.243 22.0094 158.243 21.7851V16.2617H159.14L162.869 21.9813C163.094 22.4019 163.514 22.6542 163.963 22.6542H167.523C168.056 22.6542 168.28 22.4019 168.393 22.1776C168.533 21.8131 168.505 21.4486 168.308 21.1963ZM89.2991 6.78509H85.7384C85.458 6.78509 85.2057 6.8692 85.0094 7.06546C84.8412 7.23369 84.729 7.42994 84.673 7.65424L82.0374 17.4113H81.3926L78.5888 7.65424C78.5328 7.45798 78.4487 7.26172 78.3085 7.06546C78.1402 6.8692 77.9159 6.75705 77.6636 6.75705H74.0468C73.5702 6.75705 73.2898 6.89723 73.1496 7.23368C73.0655 7.51405 73.0655 7.82247 73.1496 8.10284L77.6356 21.8412C77.7197 22.0374 77.8038 22.2617 77.972 22.4019C78.1402 22.5701 78.3926 22.6542 78.6449 22.6542H80.5515L80.3832 23.1028L79.9627 24.3645C79.8225 24.757 79.5982 25.0935 79.2617 25.3458C78.9533 25.5701 78.5888 25.7103 78.1963 25.6823C77.8599 25.6823 77.5515 25.5982 77.243 25.486C76.9346 25.3458 76.6543 25.1776 76.4019 24.9813C76.1776 24.8131 75.8973 24.729 75.5888 24.729H75.5608C75.2244 24.7571 74.9159 24.9253 74.7477 25.2337L73.6262 26.8879C73.1776 27.6169 73.43 28.0655 73.7103 28.3178C74.3272 28.8785 75.0281 29.2991 75.8131 29.5514C76.6823 29.8598 77.5795 30 78.4767 30C80.1029 30 81.4487 29.5514 82.486 28.6823C83.5515 27.729 84.3645 26.4954 84.7571 25.0935L89.972 8.10284C90.0842 7.79443 90.1122 7.48602 90.0001 7.20565C89.972 7.00939 89.7758 6.75705 89.2991 6.78509Z",
              fill: "#131E32"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_210_22", children: /* @__PURE__ */ s.jsx("rect", { width: "168.505", height: "30", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function _L(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.64524 22.7014C0.46938 22.7433 0.28417 22.6914 0.15575 22.5642C0.0270098 22.4371 -0.0268802 22.2528 0.0128098 22.0764L1.1728 16.8362L5.76534 21.452L0.64524 22.7014ZM7.00918 20.2033L2.41699 15.5866L14.0449 3.89916L18.64 8.51589L7.00918 20.2033ZM22.1262 5.01601L19.8369 7.31635L15.2418 2.69962L17.2043 0.727479C17.5844 0.345429 18.1013 0.130859 18.6402 0.130859C19.1793 0.130859 19.6959 0.345429 20.0764 0.727479L22.1262 2.78642C22.4212 3.0823 22.587 3.48338 22.587 3.90123C22.587 4.3194 22.4212 4.72014 22.1262 5.01602V5.01601Z"
        }
      )
    }
  );
}
function ML(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "13",
      height: "15",
      viewBox: "0 0 13 15",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M7.21591 11.5455V10.8551C7.21591 10.3778 7.31392 9.94105 7.50994 9.54474C7.71023 9.14418 8 8.82457 8.37926 8.58594C8.76278 8.34304 9.22727 8.22159 9.77273 8.22159C10.3267 8.22159 10.7912 8.34304 11.1662 8.58594C11.5412 8.82457 11.8246 9.14418 12.0163 9.54474C12.2081 9.94105 12.304 10.3778 12.304 10.8551V11.5455C12.304 12.0227 12.206 12.4616 12.0099 12.8622C11.8182 13.2585 11.5327 13.5781 11.1534 13.821C10.7784 14.0597 10.3182 14.179 9.77273 14.179C9.21875 14.179 8.75213 14.0597 8.37287 13.821C7.99361 13.5781 7.70597 13.2585 7.50994 12.8622C7.31392 12.4616 7.21591 12.0227 7.21591 11.5455ZM8.51989 10.8551V11.5455C8.51989 11.9418 8.61364 12.2976 8.80114 12.6129C8.98864 12.924 9.3125 13.0795 9.77273 13.0795C10.2202 13.0795 10.5355 12.924 10.7188 12.6129C10.9062 12.2976 11 11.9418 11 11.5455V10.8551C11 10.4588 10.9105 10.1051 10.7315 9.79403C10.5526 9.47869 10.233 9.32102 9.77273 9.32102C9.32528 9.32102 9.00355 9.47869 8.80753 9.79403C8.61577 10.1051 8.51989 10.4588 8.51989 10.8551ZM0.696023 4.05398V3.36364C0.696023 2.88636 0.794034 2.44957 0.990057 2.05327C1.19034 1.6527 1.48011 1.3331 1.85938 1.09446C2.2429 0.851562 2.70739 0.730113 3.25284 0.730113C3.80682 0.730113 4.27131 0.851562 4.64631 1.09446C5.02131 1.3331 5.30469 1.6527 5.49645 2.05327C5.68821 2.44957 5.78409 2.88636 5.78409 3.36364V4.05398C5.78409 4.53125 5.68608 4.97017 5.49006 5.37074C5.2983 5.76705 5.01278 6.08665 4.63352 6.32955C4.25852 6.56818 3.7983 6.6875 3.25284 6.6875C2.69886 6.6875 2.23224 6.56818 1.85298 6.32955C1.47372 6.08665 1.18608 5.76705 0.990057 5.37074C0.794034 4.97017 0.696023 4.53125 0.696023 4.05398ZM2 3.36364V4.05398C2 4.45028 2.09375 4.80611 2.28125 5.12145C2.46875 5.43253 2.79261 5.58807 3.25284 5.58807C3.70028 5.58807 4.01563 5.43253 4.19886 5.12145C4.38636 4.80611 4.48011 4.45028 4.48011 4.05398V3.36364C4.48011 2.96733 4.39062 2.61364 4.21165 2.30256C4.03267 1.98722 3.71307 1.82955 3.25284 1.82955C2.8054 1.82955 2.48366 1.98722 2.28764 2.30256C2.09588 2.61364 2 2.96733 2 3.36364ZM1.18182 14L10.1818 0.909091H11.6392L2.6392 14H1.18182Z" })
    }
  );
}
function SL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "rgb(var(--rgb-color-green))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M9.93709 10.61C10.8847 10.5968 11.8073 10.3037 12.5888 9.76761C13.3703 9.23151 13.9758 8.47632 14.3293 7.597C14.6828 6.71768 14.7684 5.75348 14.5754 4.82564C14.3823 3.8978 13.9193 3.04773 13.2445 2.38233C12.5697 1.71692 11.7132 1.26588 10.7827 1.08592C9.85225 0.90596 8.88935 1.00511 8.01508 1.3709C7.14082 1.7367 6.39421 2.35281 5.86915 3.14176C5.34408 3.93072 5.06399 4.8573 5.06409 5.80501C5.06841 6.44052 5.1979 7.06895 5.44515 7.6544C5.69241 8.23986 6.05259 8.77086 6.50512 9.21707C6.95765 9.66329 7.49366 10.016 8.08253 10.255C8.6714 10.494 9.30159 10.6146 9.93709 10.61ZM9.93709 13.01C6.68409 13.013 0.190094 14.622 0.190094 17.818V20.218H19.6831V17.818C19.6831 14.622 13.1901 13.013 9.93709 13.013V13.01Z" })
    }
  );
}
function kL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M3 6C3 4.93913 3.42143 3.92172 4.17157 3.17157C4.92172 2.42143 5.93913 2 7 2C8.06087 2 9.07828 2.42143 9.82843 3.17157C10.5786 3.92172 11 4.93913 11 6C11 7.06087 10.5786 8.07828 9.82843 8.82843C9.07828 9.57857 8.06087 10 7 10C5.93913 10 4.92172 9.57857 4.17157 8.82843C3.42143 8.07828 3 7.06087 3 6ZM0 17.0719C0 13.9937 2.49375 11.5 5.57188 11.5H8.42813C11.5063 11.5 14 13.9937 14 17.0719C14 17.5844 13.5844 18 13.0719 18H0.928125C0.415625 18 0 17.5844 0 17.0719ZM19.0406 18H14.7344C14.9031 17.7063 15.0031 17.3656 15.0031 17V16.75C15.0031 14.8531 14.1562 13.15 12.8219 12.0063C12.8969 12.0031 12.9688 12 13.0437 12H14.9625C17.7437 12 20 14.2562 20 17.0406C20 17.5719 19.5688 18 19.0406 18ZM13.5 10C12.5312 10 11.6562 9.60625 11.0219 8.97188C11.6375 8.14062 12 7.1125 12 6C12 5.1625 11.7938 4.37188 11.4281 3.67813C12.0094 3.25312 12.725 3 13.5 3C15.4344 3 17 4.56562 17 6.5C17 8.43437 15.4344 10 13.5 10Z",
          fill: "rgb(var(--brand-primary))"
        }
      )
    }
  );
}
function LL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M12.39 7.55988C12.0319 3.4405 7.73439 1.41925 7.55252 1.33675C7.38249 1.25683 7.19196 1.23129 7.00689 1.26363C2.04564 2.08675 1.29939 4.97425 1.26939 5.09425C1.22857 5.26148 1.23507 5.43676 1.28814 5.6005C7.20564 23.9605 19.5038 27.3636 23.5463 28.483C23.8575 28.5693 24.1144 28.6386 24.3094 28.7024C24.5319 28.7751 24.7737 28.761 24.9863 28.663C25.11 28.6068 28.0313 27.2305 28.7456 22.7418C28.7773 22.5458 28.7458 22.3448 28.6556 22.168C28.5919 22.0443 27.0638 19.1361 22.8263 18.1086C22.6825 18.0719 22.532 18.0706 22.3876 18.1049C22.2432 18.1392 22.1094 18.208 21.9975 18.3055C20.6606 19.4474 18.8138 20.6643 18.0169 20.7899C12.675 18.178 9.69189 13.1661 9.57939 12.2155C9.51377 11.6811 10.7381 9.80425 12.1463 8.278C12.2348 8.18195 12.3022 8.06842 12.3442 7.94474C12.3861 7.82106 12.4018 7.68996 12.39 7.55988Z" })
    }
  );
}
function HL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "17",
      height: "17",
      viewBox: "0 0 17 17",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M12.2915 1.16686C12.1045 0.97886 11.8505 0.872824 11.5853 0.872074C11.3202 0.871324 11.0656 0.975921 10.8775 1.16286C10.7783 1.264 10.7016 1.38498 10.6525 1.51786C9.8205 3.25386 8.9045 4.23286 7.7485 4.81086C6.4515 5.45086 4.9625 5.89586 2.5625 5.89586C2.36508 5.8968 2.1723 5.95579 2.00818 6.06551C1.84405 6.17522 1.71584 6.3308 1.6395 6.51286C1.56393 6.69566 1.54421 6.89675 1.58283 7.09074C1.62145 7.28474 1.71668 7.46295 1.8565 7.60286L5.0995 10.8459L0.5625 16.8959L6.6125 12.3589L9.8545 15.6009C9.94737 15.6945 10.0583 15.7683 10.1805 15.8179C10.3025 15.8689 10.4325 15.8959 10.5625 15.8959C10.6925 15.8959 10.8225 15.8689 10.9445 15.8179C11.1274 15.7428 11.2838 15.6151 11.3938 15.4509C11.5039 15.2867 11.5626 15.0935 11.5625 14.8959C11.5625 12.4959 12.0065 11.0069 12.6455 9.72986C13.2225 8.57386 14.2015 7.65786 15.9385 6.82586C16.0713 6.77721 16.1921 6.70046 16.2925 6.60086C16.4794 6.41281 16.584 6.1582 16.5833 5.89303C16.5825 5.62787 16.4765 5.37386 16.2885 5.18686L12.2915 1.16686Z" })
    }
  );
}
function PL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "19",
      height: "20",
      viewBox: "0 0 19 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.5527 17.1788V2.74891C18.5527 1.61513 17.6251 0.6875 16.4913 0.6875H2.06141C0.92763 0.6875 0 1.61514 0 2.74891V17.1788C0 18.3126 0.92764 19.2402 2.06141 19.2402H16.4913C17.6251 19.2402 18.5527 18.3126 18.5527 17.1788ZM5.66899 11.5109L8.24576 14.6133L11.8532 9.96484L16.4914 16.1491H2.06152L5.66899 11.5109Z"
        }
      )
    }
  );
}
const TL = (e) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(var(--fill-primary))",
    ...e,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        clipRule: "evenodd",
        d: "m106.7 150.46h73.72c4.57-9.77 11.27-18.17 19.44-24.49-5.53-14.45-18.52-24.25-32.8-24.25h-27.52c-19.64 0-35.62 17.77-35.62 39.62v5.49c0 1.97 1.28 3.63 2.78 3.63zm329.86 258.68c0-42.33-34.44-76.78-76.78-76.78-42.33 0-76.78 34.44-76.78 76.78s34.45 76.78 76.78 76.78c42.34 0 76.78-34.45 76.78-76.78zm-76.78-54.4c3.31 0 6 2.68 6 6v7.52c9.56 2.53 16.6 10.96 16.6 20.94 0 3.32-2.69 6-6 6s-6-2.69-6-6c0-5.37-4.76-9.73-10.6-9.73s-10.6 4.36-10.6 9.73c0 5.63 6.62 8.61 12.17 10.11 18.3 4.97 21.03 15.72 21.03 21.7 0 9.98-7.04 18.41-16.6 20.94v7.52c0 3.31-2.69 6-6 6s-6-2.69-6-6v-7.52c-9.56-2.54-16.6-10.96-16.6-20.94 0-3.32 2.69-6 6-6 3.32 0 6 2.69 6 6 0 5.37 4.76 9.73 10.6 9.73 5.85 0 10.6-4.36 10.6-9.73 0-5.63-6.62-8.61-12.17-10.11-18.3-4.97-21.03-15.72-21.03-21.7 0-9.98 7.04-18.41 16.6-20.94v-7.52c0-3.32 2.69-6 6-6zm75.05-122.39c2.38 0 4.32 1.94 4.32 4.32v38.09c0 1.51-.61 2.67-1.85 3.54l-62.22 43.38c-4.97-.87-10.08-1.32-15.3-1.32-48.95 0-88.78 39.82-88.78 88.78 0 10.78 1.94 21.12 5.48 30.69l-38.76 22.66v-72.84c0-2.09-1.07-3.92-2.69-5l-160.74-106.44c-1.31-.86-1.94-2.04-1.94-3.6v-37.93c0-2.38 1.94-4.32 4.32-4.32h358.16zm-93.14 18c0-3.32-2.69-6-6-6-3.32 0-6 2.69-6 6v36.76l-8.13-8.13c-2.35-2.34-6.14-2.34-8.49 0-2.34 2.34-2.34 6.14 0 8.48l18.37 18.37c1.13 1.13 2.66 1.76 4.25 1.76s3.11-.63 4.24-1.76l18.37-18.37c2.34-2.34 2.34-6.14 0-8.48s-6.14-2.34-8.48 0l-8.13 8.13zm-85.94-1.41c-3.31 0-6 2.69-6 6v66.49l-8.13-8.13c-2.34-2.34-6.14-2.34-8.48 0-2.35 2.34-2.35 6.14 0 8.48l18.37 18.37c1.17 1.17 2.7 1.76 4.24 1.76s3.07-.58 4.24-1.76l18.37-18.37c2.35-2.34 2.35-6.15 0-8.48-2.34-2.34-6.14-2.34-8.48 0l-8.13 8.13v-66.49c0-3.31-2.69-6-6-6zm-79.94-4.59c-3.31 0-6 2.69-6 6v36.76l-8.13-8.13c-2.34-2.34-6.14-2.34-8.48 0s-2.34 6.14 0 8.48l18.37 18.37c1.13 1.13 2.65 1.76 4.24 1.76s3.12-.63 4.25-1.76l18.37-18.37c2.34-2.34 2.34-6.14 0-8.48-2.35-2.34-6.14-2.34-8.49 0l-8.13 8.13v-36.76c0-3.31-2.68-6-6-6zm159.71-171.83c2.76 6.19 8.38 13.58 19.44 13.58 11.05 0 16.67-7.38 19.43-13.57 5.75-12.89 3.54-29.77-2.27-36.25-4.53-5.05-9.66-7.2-17.14-7.2-7.52 0-12.66 2.15-17.19 7.2-5.81 6.47-8.02 23.35-2.27 36.24zm5.67 29.21c-14.28 0-27.27 9.79-32.8 24.25 8.17 6.31 14.87 14.71 19.44 24.49h73.72c1.51 0 2.78-1.66 2.78-3.62v-5.49c0-21.84-15.98-39.62-35.61-39.62h-27.53zm-68.57 23.82c27.52 0 49.91 24.8 49.91 55.28v7.38c0 3.76-2.65 6.93-5.79 6.93h-125.22c-3.14 0-5.79-3.17-5.79-6.93v-7.38c0-30.49 22.39-55.28 49.91-55.28zm-43.09-87.28c-9.29 10.36-10.88 34.16-3.4 50.92 3.96 8.88 12.04 19.46 28 19.46s24.03-10.58 27.99-19.46c7.48-16.77 5.89-40.56-3.4-50.92-6.52-7.26-13.86-10.36-24.56-10.36-10.75 0-18.11 3.1-24.63 10.36zm-95.67 34.25c2.76 6.19 8.38 13.58 19.44 13.58 11.05 0 16.67-7.38 19.43-13.57 5.75-12.89 3.54-29.77-2.27-36.25-4.53-5.05-9.66-7.2-17.14-7.2-7.52 0-12.66 2.15-17.19 7.2-5.81 6.47-8.02 23.35-2.27 36.24z",
        fillRule: "evenodd"
      }
    )
  }
);
function $h(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      version: "1.1",
      fill: "rgb(var(--fill-primary))",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "20px",
      viewBox: "0 0 298 294",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M244.285446,208.610062
	C242.970535,209.638763 241.936996,211.008606 240.866455,211.038147
	C226.915070,211.423294 213.323441,212.234283 202.526245,199.743088
	C191.444809,186.923065 178.474030,175.756104 166.753845,163.461746
	C157.923599,154.198914 143.357864,154.168411 134.603729,163.190262
	C121.496552,176.698273 108.021919,189.849380 94.731537,203.180161
	C89.298790,208.629440 82.626717,210.348587 75.120163,211.342804
	C60.985691,213.214874 50.329533,208.886612 41.561268,197.525284
	C35.426071,189.575714 27.253853,183.221161 20.883156,175.425507
	C8.642242,160.446579 10.216591,137.694260 24.153507,123.132507
	C33.826618,113.025703 43.814171,103.215714 53.828175,93.444191
	C55.185833,92.119408 57.495472,91.183701 59.401691,91.115700
	C65.546120,90.896507 71.750221,90.741402 77.853561,91.346245
	C87.652054,92.317268 94.438049,98.733185 100.955849,105.375687
	C112.375610,117.013977 123.608986,128.844330 135.293442,140.210785
	C144.487930,149.155029 157.356705,148.646927 166.649048,139.429947
	C179.301895,126.879730 192.115875,114.471695 204.310608,101.486053
	C214.881454,90.229607 227.898621,89.801460 241.426010,92.080154
	C244.539246,92.604576 247.171005,96.638344 249.796814,99.283035
	C257.645477,107.188202 265.340271,115.245918 273.169800,123.170311
	C288.713440,138.902252 288.759369,163.937805 273.159729,179.690308
	C263.665131,189.277969 254.089081,198.784973 244.285446,208.610062
z`
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M99.133804,254.866470
	C89.211319,245.070602 79.538452,235.525192 69.900787,226.014526
	C77.181381,224.578506 84.190994,224.060730 90.499619,221.683029
	C95.720055,219.715469 100.687065,216.152695 104.766792,212.251404
	C117.882652,199.709244 130.526199,186.673599 143.371429,173.847855
	C148.933350,168.294357 151.991394,168.267914 157.623703,173.866959
	C170.023743,186.193771 182.537323,198.413330 194.675293,210.994354
	C202.944809,219.565735 212.734009,224.177948 224.546219,224.728470
	C225.302353,224.763702 226.052200,224.934326 228.588257,225.296951
	C219.519348,234.040939 211.361176,241.787537 203.339722,249.673203
	C194.672058,258.194153 186.151550,266.864594 177.532349,275.435120
	C161.107605,291.767181 136.428574,291.868164 119.855301,275.622467
	C112.958298,268.861816 106.203102,261.956482 99.133804,254.866470
z`
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M93.157654,81.812546
	C85.493309,79.981094 78.150978,78.351784 70.817352,76.724403
	C70.913933,76.604439 71.581711,75.602051 72.415405,74.764885
	C88.518112,58.595020 104.543739,42.346703 120.786789,26.318796
	C135.627319,11.674816 158.966370,10.582329 174.536713,24.857964
	C190.414688,39.415646 205.186234,55.179058 220.474991,70.381584
	C222.722427,72.616348 225.151276,74.668686 227.593521,76.894150
	C220.952347,78.432266 214.797546,79.087257 209.311203,81.357597
	C204.392059,83.393204 199.630020,86.613060 195.805130,90.342636
	C182.501434,103.314796 169.612640,116.713509 156.616074,129.998932
	C152.699371,134.002716 149.133774,134.139923 145.126892,130.125793
	C132.536896,117.513069 120.106400,104.735985 107.298668,92.348724
	C103.197273,88.381973 98.113815,85.430618 93.157654,81.812546
z`
          }
        )
      ]
    }
  );
}
function jL(e) {
  return /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...e, children: /* @__PURE__ */ s.jsx("g", { fill: "CurrentColor", children: /* @__PURE__ */ s.jsx("path", { d: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" }) }) });
}
function VL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 14 14",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 0.8125C7.14918 0.8125 7.29226 0.871763 7.39775 0.977252C7.50324 1.08274 7.5625 1.22582 7.5625 1.375V6.4375H12.625C12.7742 6.4375 12.9173 6.49676 13.0227 6.60225C13.1282 6.70774 13.1875 6.85082 13.1875 7C13.1875 7.14918 13.1282 7.29226 13.0227 7.39775C12.9173 7.50324 12.7742 7.5625 12.625 7.5625H7.5625V12.625C7.5625 12.7742 7.50324 12.9173 7.39775 13.0227C7.29226 13.1282 7.14918 13.1875 7 13.1875C6.85082 13.1875 6.70774 13.1282 6.60225 13.0227C6.49676 12.9173 6.4375 12.7742 6.4375 12.625V7.5625H1.375C1.22582 7.5625 1.08274 7.50324 0.977252 7.39775C0.871763 7.29226 0.8125 7.14918 0.8125 7C0.8125 6.85082 0.871763 6.70774 0.977252 6.60225C1.08274 6.49676 1.22582 6.4375 1.375 6.4375H6.4375V1.375C6.4375 1.22582 6.49676 1.08274 6.60225 0.977252C6.70774 0.871763 6.85082 0.8125 7 0.8125Z"
        }
      )
    }
  );
}
function AL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "23",
      height: "28",
      x: "0",
      y: "0",
      viewBox: "0 0 477.869 477.869",
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m192.951 171.027 32.913-54.878L29.598 61.195l-26.24 43.887c-6.642 11.052-3.068 25.396 7.984 32.038a23.373 23.373 0 0 0 5.729 2.471l149.581 41.907a23.339 23.339 0 0 0 26.299-10.471z",
            fill: "rgb(var(--text-tertiary))",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m40.35 312.322 70.588 19.277v-84.13c0-18.851 15.282-34.133 34.133-34.133h85.333v-71.569l-22.818 38.042c-9.378 15.59-28.009 23.003-45.534 18.116l-127.914-35.79V304.13a8.532 8.532 0 0 0 6.212 8.192zM238.938 102.086l181.931-50.935L243.511.633a16.913 16.913 0 0 0-9.173 0L57.007 51.151zM437.559 312.322a8.533 8.533 0 0 0 6.178-8.192V162.135l-127.915 35.84a39.808 39.808 0 0 1-10.846 1.493 40.48 40.48 0 0 1-34.688-19.627l-22.818-38.076v71.569h85.333c18.851 0 34.133 15.282 34.133 34.133v84.13z",
            fill: "rgb(var(--text-tertiary))",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M284.924 171.027a23.363 23.363 0 0 0 26.3 10.47l149.581-41.907c12.415-3.483 19.656-16.371 16.173-28.786a23.366 23.366 0 0 0-2.459-5.706l-26.223-43.904-196.267 54.955zM349.871 460.802V247.469c0-9.426-7.641-17.067-17.067-17.067H145.071c-9.426 0-17.067 7.641-17.067 17.067v213.333c0 9.426 7.641 17.067 17.067 17.067h187.733c9.426 0 17.067-7.641 17.067-17.067zm-147.567-36.634-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm113.434 173.167h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066z",
            fill: "rgb(var(--text-tertiary))",
            "data-original": "#000000"
          }
        )
      ] })
    }
  );
}
function xr(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8813 9.18766C10.687 9.54872 10.3116 9.77547 9.90164 9.77949C9.49164 9.7835 9.11193 9.56414 8.91059 9.20696C8.70926 8.84978 8.71819 8.41134 8.93391 8.06266C9.69772 6.73986 11.2548 6.09497 12.7302 6.49031C14.2056 6.88566 15.2316 8.22267 15.2317 9.75016C15.2317 10.9854 14.4745 11.9934 13.5442 12.5627C12.7972 13.0194 13.2629 14.2502 11.8533 14.2502C11.5347 14.25 11.2311 14.1147 11.0179 13.8779C10.8047 13.6411 10.7019 13.325 10.735 13.0082C10.7654 12.413 11.0309 11.9282 11.32 11.5772C11.6249 11.2059 12.0265 10.9022 12.3325 10.7199C14.0392 9.70516 11.9579 7.62953 10.8813 9.18878V9.18766ZM11.8533 15.3752C11.232 15.3752 10.7283 15.8788 10.7283 16.5002C10.7283 17.1215 11.232 17.6252 11.8533 17.6252C12.4746 17.6252 12.9783 17.1215 12.9783 16.5002C12.9783 15.8788 12.4746 15.3752 11.8533 15.3752Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function EL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "15",
      viewBox: "0 0 22 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { fill: "CurrentColor", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.5274 3.9381L11.281 0.605099C11.2592 0.597779 11.2353 0.597779 11.2134 0.605099L0.914657 3.88727C0.869307 3.90189 0.838397 3.94375 0.837897 3.99127C0.837397 4.03894 0.867477 4.08131 0.912327 4.09676L3.42849 4.95894V7.94639C3.00603 8.1361 2.7115 8.55956 2.7115 9.05265C2.7115 9.54571 3.00637 9.96951 3.42849 10.1589L2.76696 14.419H4.97214L4.42093 10.1589C4.84339 9.96935 5.13791 9.54572 5.13791 9.05265C5.13791 8.55956 4.84337 8.13611 4.42093 7.94639V5.29882L11.1761 7.61348C11.1876 7.61747 11.1997 7.61946 11.2117 7.61946C11.2237 7.61946 11.2358 7.61763 11.2472 7.61365L21.5285 4.14757C21.5737 4.13229 21.6038 4.08992 21.6034 4.04258C21.6029 3.99473 21.5724 3.95286 21.5273 3.93808L21.5274 3.9381Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2104 8.17106C11.1375 8.17106 11.0658 8.15876 10.9968 8.13517L5.61523 6.29135V10.2296C5.61523 11.3359 8.15747 12.2326 11.2937 12.2326C14.4298 12.2326 16.972 11.3359 16.972 10.2296L16.9719 6.26562L11.4232 8.13621C11.3549 8.15962 11.283 8.1711 11.2104 8.1711L11.2104 8.17106Z"
          }
        )
      ] })
    }
  );
}
function IL(e) {
  return /* @__PURE__ */ s.jsxs("svg", { width: "24", height: "18", viewBox: "0 0 24 18", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_4_30323)", children: [
      /* @__PURE__ */ s.jsx("path", { d: "M12.7551 0.124876C12.7833 0.135011 12.8113 0.14383 12.8401 0.151601C12.8852 0.164613 12.9282 0.181667 12.9715 0.200812C12.9836 0.206073 12.9836 0.206073 12.9959 0.211439C13.0722 0.244853 13.1481 0.27956 13.2239 0.314611C13.2691 0.335494 13.3144 0.356157 13.3597 0.376864C13.3912 0.391265 13.4226 0.405702 13.454 0.42027C13.533 0.456813 13.6128 0.490244 13.693 0.522827C13.7325 0.539198 13.7699 0.557231 13.8072 0.579419C13.8468 0.60275 13.8863 0.618867 13.9288 0.634284C14.0238 0.671177 14.1164 0.717445 14.2089 0.762022C14.2626 0.787814 14.3168 0.811223 14.3717 0.833691C14.4817 0.879191 14.5898 0.929624 14.6977 0.98148C14.7962 1.02862 14.8945 1.07525 14.9951 1.11608C15.0406 1.13526 15.085 1.1571 15.1297 1.17869C15.1669 1.19635 15.2044 1.213 15.2421 1.22942C15.2918 1.25106 15.3409 1.27359 15.3899 1.29726C15.4327 1.31791 15.4756 1.33729 15.5194 1.35506C15.6022 1.38885 15.683 1.42818 15.7642 1.46677C15.8351 1.50038 15.9065 1.53229 15.9782 1.56363C16.0278 1.58538 16.0771 1.60789 16.126 1.63148C16.1863 1.66052 16.2472 1.68761 16.3083 1.7143C16.3806 1.74613 16.4523 1.77936 16.5241 1.8124C16.5529 1.82558 16.5816 1.83875 16.6104 1.85188C16.6338 1.8626 16.6571 1.87344 16.6804 1.88434C16.768 1.92513 16.856 1.96325 16.9457 1.99762C16.9955 2.01707 17.0414 2.04069 17.0881 2.06825C17.1151 2.08363 17.1425 2.09529 17.171 2.10641C17.217 2.12499 17.2621 2.14499 17.3071 2.16672C17.3679 2.1961 17.4292 2.22347 17.4908 2.25038C17.563 2.28221 17.6348 2.31544 17.7066 2.34849C17.7353 2.36162 17.7639 2.37474 17.7926 2.38785C17.8169 2.39898 17.8411 2.41016 17.8653 2.42136C17.9318 2.45206 17.9983 2.48255 18.0659 2.51015C18.1222 2.5332 18.1772 2.55926 18.2323 2.5859C18.2695 2.60357 18.307 2.62021 18.3447 2.63663C18.3943 2.65827 18.4435 2.6808 18.4925 2.70448C18.5353 2.72512 18.5782 2.7445 18.622 2.76227C18.7048 2.79608 18.7857 2.83543 18.8668 2.87404C18.9031 2.8912 18.9395 2.90785 18.9759 2.92441C18.9999 2.93532 19.0238 2.94634 19.0477 2.95739C19.1143 2.98811 19.1808 3.01861 19.2484 3.04623C19.3047 3.06928 19.3597 3.09534 19.4147 3.12198C19.452 3.13965 19.4895 3.15629 19.5272 3.17271C19.5768 3.19435 19.626 3.21688 19.675 3.24056C19.7178 3.26121 19.7607 3.28058 19.8045 3.29835C19.8873 3.33214 19.9681 3.37147 20.0492 3.41006C20.1201 3.44368 20.1916 3.47559 20.2633 3.50692C20.3129 3.52867 20.3621 3.55118 20.4111 3.57477C20.4714 3.60382 20.5323 3.63091 20.5934 3.65759C20.6656 3.68942 20.7374 3.72265 20.8092 3.7557C20.8287 3.76464 20.8482 3.77357 20.8677 3.7825C20.9653 3.82718 21.0628 3.87185 21.1604 3.91652C21.1695 3.92067 21.1785 3.92481 21.1879 3.92909C21.2121 3.94021 21.2364 3.95139 21.2606 3.96259C21.3271 3.99329 21.3936 4.02378 21.4611 4.05138C21.5174 4.0744 21.5723 4.10044 21.6273 4.12703C21.7046 4.16372 21.783 4.19739 21.8614 4.23063C21.9136 4.2529 21.9652 4.27691 22.0169 4.3007C22.0656 4.3231 22.1145 4.34492 22.1636 4.36633C22.2232 4.39243 22.2822 4.42005 22.341 4.44836C22.4374 4.4943 22.5344 4.53817 22.6319 4.58076C22.6916 4.60689 22.7506 4.63456 22.8095 4.66285C22.9222 4.71669 23.0351 4.76768 23.1509 4.81205C23.1915 4.82794 23.2297 4.84559 23.2679 4.86817C23.3134 4.89507 23.3597 4.91361 23.4083 4.93173C23.5297 4.97875 23.6531 5.04019 23.7595 5.1227C23.7595 5.13155 23.7595 5.1404 23.7595 5.14951C23.7687 5.15255 23.7779 5.15559 23.7873 5.15872C23.8259 5.18079 23.8274 5.19834 23.8415 5.24332C23.8531 5.24775 23.8647 5.25217 23.8766 5.25672C23.9665 5.40176 23.9981 5.54501 23.9988 5.71993C23.9992 5.73601 23.9996 5.75208 24 5.76865C24.0008 5.92491 23.9641 6.06385 23.8759 6.18481C23.8703 6.19261 23.8647 6.2004 23.8589 6.20843C23.7472 6.3588 23.6182 6.42432 23.46 6.49108C23.4198 6.5082 23.38 6.52656 23.3403 6.54499C23.297 6.56482 23.2537 6.58464 23.2104 6.60447C23.199 6.60967 23.199 6.60967 23.1874 6.61499C23.1724 6.62187 23.1573 6.62874 23.1423 6.63561C23.1108 6.65001 23.0794 6.66445 23.048 6.67901C22.9991 6.70163 22.9501 6.7232 22.9005 6.74351C22.8429 6.76721 22.7867 6.79376 22.7303 6.82099C22.6812 6.84429 22.6316 6.86585 22.582 6.88753C22.4856 6.92998 22.3898 6.97412 22.2946 7.01993C22.2348 7.04864 22.1744 7.07545 22.1138 7.10191C22.0415 7.13374 21.9698 7.16697 21.898 7.20002C21.8785 7.20896 21.859 7.21789 21.8395 7.22682C21.8304 7.23097 21.8213 7.23511 21.812 7.23939C21.7876 7.25055 21.7632 7.26172 21.7388 7.27289C21.7314 7.27631 21.7239 7.27973 21.7162 7.28326C21.7008 7.2903 21.6854 7.29734 21.6701 7.30438C21.6378 7.31913 21.6056 7.33391 21.5734 7.34875C21.5235 7.37174 21.4734 7.39419 21.4231 7.41613C21.3455 7.45017 21.2683 7.48546 21.1911 7.52083C21.1783 7.52671 21.1655 7.53259 21.1522 7.53865C21.0989 7.5631 21.0456 7.58758 20.9924 7.61239C20.9086 7.6513 20.8244 7.68746 20.7387 7.7203C20.6982 7.73613 20.6602 7.7537 20.6222 7.7762C20.5669 7.80885 20.5093 7.83048 20.4504 7.85284C20.3989 7.87287 20.3513 7.89663 20.303 7.92517C20.2784 7.93939 20.2535 7.95037 20.2274 7.96058C20.1603 7.98777 20.0936 8.01629 20.0269 8.04518C20.0163 8.04975 20.0057 8.05431 19.9947 8.05902C19.9406 8.08251 19.889 8.10797 19.8374 8.13816C19.8215 8.14478 19.8054 8.15097 19.7891 8.15659C19.7342 8.17679 19.6816 8.20202 19.6285 8.22779C19.5922 8.24505 19.5558 8.26127 19.5191 8.27721C19.4328 8.31485 19.3476 8.3554 19.2623 8.39583C19.1915 8.42928 19.1202 8.4612 19.0486 8.49248C18.9985 8.51443 18.9488 8.53726 18.8993 8.56116C18.8451 8.58728 18.7904 8.61098 18.7351 8.63367C18.6371 8.67418 18.5405 8.71844 18.4445 8.7647C18.4076 8.78216 18.3703 8.79866 18.333 8.81496C18.2726 8.84132 18.2129 8.8692 18.1533 8.89789C18.0977 8.92438 18.0417 8.94984 17.9858 8.97531C17.9563 8.98874 17.9269 9.00234 17.8975 9.01604C17.8112 9.05618 17.7245 9.09364 17.6362 9.1275C17.5957 9.14334 17.5576 9.1609 17.5196 9.18341C17.4643 9.21606 17.4067 9.2377 17.3478 9.26005C17.2965 9.28003 17.249 9.30372 17.2009 9.3322C17.1742 9.3475 17.1471 9.35919 17.119 9.37031C17.0097 9.41456 16.902 9.46304 16.7951 9.51438C16.6824 9.56822 16.5695 9.61921 16.4537 9.66358C16.4132 9.67942 16.3751 9.69698 16.3371 9.71949C16.2818 9.75214 16.2242 9.77378 16.1653 9.79614C16.114 9.8161 16.0665 9.8398 16.0184 9.86828C15.9916 9.88368 15.9642 9.89529 15.9358 9.90639C15.8898 9.92497 15.8446 9.94497 15.7997 9.9667C15.7044 10.0127 15.608 10.055 15.5106 10.0949C15.4539 10.1183 15.3984 10.1446 15.3428 10.1714C15.3056 10.1891 15.2681 10.2058 15.2304 10.2222C15.1812 10.2436 15.1325 10.2658 15.084 10.2892C15.0237 10.3182 14.9628 10.3453 14.9017 10.3721C14.8053 10.4145 14.7095 10.4586 14.6143 10.5045C14.5544 10.5332 14.4941 10.56 14.4334 10.5864C14.3612 10.6183 14.2895 10.6515 14.2177 10.6845C14.189 10.6977 14.1603 10.7108 14.1316 10.7239C14.1074 10.735 14.0831 10.7462 14.0589 10.7574C13.9924 10.7881 13.9259 10.8186 13.8584 10.8462C13.8154 10.8638 13.7733 10.8828 13.7312 10.9031C13.6573 10.9385 13.583 10.9729 13.5086 11.007C13.4964 11.0127 13.4841 11.0183 13.4715 11.0241C13.4027 11.0557 13.3336 11.0856 13.2638 11.1143C13.221 11.1324 13.1789 11.1525 13.1369 11.1729C12.9059 11.2829 12.9059 11.2829 12.7924 11.3078C12.7655 11.3145 12.74 11.3234 12.7138 11.333C12.2571 11.4906 11.6964 11.4795 11.2437 11.3133C11.2135 11.3027 11.1839 11.2943 11.1529 11.2871C11.0998 11.2744 11.0511 11.2532 11.0009 11.2298C10.9824 11.2214 10.9639 11.213 10.9454 11.2046C10.9364 11.2004 10.9275 11.1963 10.9182 11.1921C10.883 11.176 10.8476 11.1606 10.8121 11.1452C10.7532 11.1194 10.695 11.0919 10.6368 11.064C10.5241 11.0101 10.4112 10.9592 10.2954 10.9148C10.2456 10.8953 10.1997 10.8717 10.153 10.8442C10.1261 10.8288 10.0986 10.8171 10.0702 10.806C10.0241 10.7874 9.97902 10.7674 9.93405 10.7457C9.87326 10.7163 9.81195 10.6889 9.75029 10.662C9.67807 10.6302 9.60633 10.597 9.53452 10.5639C9.51501 10.555 9.4955 10.546 9.47598 10.5371C9.37537 10.4911 9.37537 10.4911 9.35272 10.4807C9.33736 10.4736 9.322 10.4666 9.30664 10.4596C9.2741 10.4447 9.24157 10.4298 9.20908 10.4147C9.16102 10.3925 9.11282 10.3712 9.06401 10.3512C8.95759 10.3073 8.85291 10.2581 8.74863 10.2079C8.66071 10.1657 8.57168 10.1269 8.48228 10.089C8.43009 10.0667 8.3785 10.0427 8.32682 10.0189C8.27807 9.99653 8.22916 9.97471 8.18007 9.9533C8.12045 9.92719 8.06151 9.89957 8.00267 9.87126C7.90633 9.82532 7.80926 9.78145 7.71176 9.73886C7.65208 9.71274 7.59309 9.68506 7.53418 9.65678C7.42149 9.60293 7.30859 9.55194 7.19279 9.50758C7.15229 9.49174 7.11425 9.47417 7.0762 9.45166C7.02873 9.42363 6.98015 9.40376 6.92953 9.38455C6.86956 9.36179 6.81363 9.33609 6.75747 9.30287C6.73086 9.28758 6.70375 9.27588 6.67562 9.26477C6.56628 9.22051 6.45862 9.17203 6.35168 9.1207C6.239 9.06685 6.1261 9.01586 6.0103 8.9715C5.96979 8.95566 5.93176 8.93809 5.89371 8.91558C5.84623 8.88755 5.79766 8.86768 5.74704 8.84847C5.68708 8.82571 5.63118 8.80001 5.57503 8.76679C5.54818 8.7514 5.5208 8.73978 5.49239 8.72869C5.44584 8.70992 5.40028 8.68958 5.35483 8.66754C5.30011 8.6411 5.245 8.61709 5.18909 8.59419C5.09111 8.55368 4.99458 8.50943 4.89859 8.46316C4.8616 8.4457 4.82438 8.4292 4.787 8.4129C4.72662 8.38655 4.66696 8.35868 4.6074 8.33003C4.47969 8.26913 4.35087 8.21051 4.22101 8.15589C4.16122 8.13066 4.10279 8.10252 4.04428 8.07366C3.96228 8.03355 3.87982 7.99705 3.79515 7.96499C3.74617 7.94611 3.70111 7.92288 3.65518 7.89578C3.62846 7.88048 3.60127 7.8687 3.57304 7.85755C3.52303 7.83732 3.47331 7.81642 3.42377 7.79473C3.41134 7.78931 3.39892 7.78388 3.38613 7.77829C3.35279 7.7629 3.35279 7.7629 3.30596 7.7361C3.30596 9.1027 3.30596 10.4693 3.30596 11.8773C3.32141 11.8817 3.33686 11.8862 3.35279 11.8907C3.37902 11.9157 3.4036 11.9408 3.42816 11.9678C3.43471 11.9748 3.44127 11.9819 3.44803 11.9891C3.46715 12.0098 3.48608 12.0306 3.50499 12.0515C3.51088 12.0579 3.51676 12.0642 3.52283 12.0708C3.53685 12.0862 3.55026 12.1023 3.56353 12.1186C3.56353 12.1274 3.56353 12.1363 3.56353 12.1454C3.57512 12.1498 3.58671 12.1542 3.59865 12.1588C3.61114 12.1805 3.62262 12.2031 3.63377 12.2258C3.64472 12.2437 3.6557 12.2615 3.6667 12.2794C3.85133 12.5969 3.88765 13.0066 3.82993 13.3767C3.78964 13.5676 3.71872 13.7266 3.62207 13.8876C3.6141 13.902 3.60613 13.9164 3.59792 13.9312C3.57366 13.9706 3.54719 14.0018 3.5167 14.035C3.50655 14.0472 3.49641 14.0594 3.48596 14.0719C3.45816 14.1021 3.45816 14.1021 3.42303 14.1155C3.4104 14.1981 3.41425 14.2619 3.43035 14.3433C3.4325 14.3548 3.43464 14.3663 3.43685 14.3782C3.44146 14.4029 3.44613 14.4276 3.45086 14.4523C3.46071 14.5041 3.47007 14.5561 3.47944 14.608C3.48679 14.6487 3.49421 14.6894 3.50165 14.7301C3.51647 14.8111 3.53122 14.8921 3.54597 14.9732C3.56046 15.0528 3.57495 15.1324 3.58946 15.2121C3.59423 15.2383 3.599 15.2645 3.60377 15.2907C3.60616 15.3037 3.60854 15.3168 3.611 15.3303C3.62442 15.404 3.63776 15.4777 3.65102 15.5515C3.68056 15.7157 3.71051 15.8797 3.74195 16.0434C3.76026 16.1393 3.77736 16.2353 3.79367 16.3316C3.80198 16.3803 3.81087 16.4285 3.8216 16.4766C3.8928 16.8023 3.87678 17.1545 3.72597 17.4467C3.71485 17.4666 3.70364 17.4864 3.69231 17.5062C3.68507 17.5203 3.67783 17.5344 3.67036 17.5489C3.64208 17.5917 3.61054 17.6236 3.57478 17.658C3.53984 17.6921 3.50748 17.7289 3.47718 17.7684C3.45383 17.792 3.42825 17.8087 3.4009 17.8256C3.38364 17.8365 3.3667 17.8481 3.35004 17.8602C3.13625 18.0084 2.89699 17.9997 2.65589 17.9981C2.61755 17.9979 2.57923 17.998 2.5409 17.9984C2.06463 18.0037 2.06463 18.0037 1.8776 17.868C1.86788 17.8636 1.85816 17.8592 1.84815 17.8546C1.81696 17.8403 1.79133 17.8224 1.76345 17.801C1.74977 17.7907 1.74977 17.7907 1.73582 17.7801C1.71369 17.7608 1.71369 17.7608 1.70198 17.734C1.6948 17.73 1.68761 17.726 1.68021 17.7219C1.65207 17.7054 1.63732 17.6879 1.6171 17.6603C1.60795 17.6481 1.60795 17.6481 1.59862 17.6356C1.5849 17.6134 1.5849 17.6134 1.5849 17.5866C1.56945 17.5777 1.55399 17.5689 1.53807 17.5598C1.53807 17.5465 1.53807 17.5332 1.53807 17.5196C1.53035 17.5196 1.52262 17.5196 1.51466 17.5196C1.36845 17.2463 1.31046 16.9692 1.35441 16.651C1.35599 16.6392 1.35757 16.6274 1.35921 16.6152C1.36959 16.5405 1.3831 16.4678 1.40046 16.3947C1.41377 16.3327 1.4227 16.2699 1.43165 16.2068C1.44034 16.147 1.45306 16.0903 1.46783 16.0319C1.47354 15.9999 1.47889 15.9678 1.48392 15.9356C1.48701 15.9164 1.4901 15.8971 1.49321 15.8778C1.49562 15.8628 1.49562 15.8628 1.49807 15.8476C1.52953 15.6537 1.5663 15.4612 1.60288 15.2685C1.63339 15.1078 1.66283 14.947 1.69027 14.7856C1.69852 14.7372 1.70682 14.6889 1.71515 14.6407C1.71701 14.6297 1.71887 14.6187 1.72079 14.6074C1.72892 14.5603 1.73785 14.5146 1.74945 14.4684C1.76037 14.4243 1.76685 14.3819 1.77223 14.3366C1.78016 14.2741 1.79029 14.2157 1.80735 14.1557C1.79576 14.1512 1.78417 14.1468 1.77223 14.1423C1.75549 14.1228 1.75549 14.1228 1.73857 14.0987C1.71732 14.0692 1.69638 14.042 1.67271 14.0149C1.61342 13.9471 1.56457 13.8796 1.52636 13.7938C1.52636 13.785 1.52636 13.7761 1.52636 13.767C1.51864 13.767 1.51091 13.767 1.50295 13.767C1.4178 13.574 1.35362 13.3827 1.35075 13.1639C1.35059 13.1551 1.35043 13.1462 1.35026 13.1371C1.34929 13.079 1.34933 13.0209 1.35031 12.9628C1.3507 12.9391 1.35083 12.9155 1.35093 12.8918C1.35836 12.6529 1.45476 12.4061 1.5732 12.2124C1.58092 12.2124 1.58865 12.2124 1.59661 12.2124C1.59763 12.2016 1.59763 12.2016 1.59867 12.1905C1.61267 12.1444 1.64025 12.114 1.66905 12.0792C1.67455 12.0723 1.68006 12.0655 1.68572 12.0584C1.72369 12.0117 1.76314 11.9698 1.80735 11.9309C1.81508 11.9309 1.82281 11.9309 1.83077 11.9309C1.83463 11.9177 1.8385 11.9044 1.84248 11.8907C1.85793 11.8863 1.87338 11.8819 1.88931 11.8773C1.88931 10.294 1.88931 8.71069 1.88931 7.0794C1.85453 7.07055 1.81976 7.06171 1.78394 7.0526C1.76171 7.04338 1.7397 7.03339 1.71808 7.02244C1.66495 6.99615 1.61162 6.97068 1.55783 6.94622C1.5429 6.93941 1.52798 6.93261 1.51306 6.9258C1.50559 6.9224 1.49813 6.919 1.49045 6.9155C1.46794 6.90522 1.44545 6.89489 1.42296 6.88455C1.35347 6.85258 1.28389 6.82097 1.21391 6.79042C1.15371 6.76408 1.09427 6.73605 1.03486 6.70744C0.986072 6.68439 0.936781 6.66295 0.887464 6.64143C0.80527 6.6052 0.723652 6.56729 0.641966 6.5296C0.633182 6.52556 0.624398 6.52152 0.615349 6.51735C0.606278 6.5131 0.597208 6.50885 0.587863 6.50447C0.560827 6.49247 0.533796 6.48147 0.506365 6.47076C0.326364 6.39859 0.184662 6.2934 0.0863008 6.10105C0.079298 6.08858 0.0722953 6.07611 0.0650803 6.06325C-0.0140467 5.89594 -0.0153268 5.65103 0.0307343 5.47063C0.0515844 5.40403 0.0754592 5.34536 0.121424 5.29693C0.13519 5.26879 0.13519 5.26879 0.14484 5.24332C0.152567 5.24332 0.160294 5.24332 0.168256 5.24332C0.17224 5.22757 0.17224 5.22757 0.176305 5.21149C0.195586 5.16735 0.210914 5.16566 0.25021 5.14951C0.254074 5.13624 0.257938 5.12297 0.261918 5.1093C0.289561 5.09042 0.316395 5.07405 0.345337 5.05821C0.35374 5.05351 0.362144 5.04882 0.370802 5.04398C0.45388 4.99825 0.538722 4.95919 0.624861 4.92167C0.650961 4.91023 0.67706 4.89878 0.703157 4.88733C0.715548 4.88191 0.727939 4.87648 0.740705 4.87089C0.787722 4.84991 0.834206 4.82758 0.880741 4.80524C0.993429 4.7514 1.10632 4.70041 1.22213 4.65604C1.26263 4.6402 1.30067 4.62264 1.33872 4.60013C1.39401 4.56748 1.45158 4.54585 1.51049 4.52349C1.5618 4.50352 1.60926 4.47982 1.65739 4.45134C1.68425 4.43595 1.71162 4.42433 1.74003 4.41323C1.78606 4.39466 1.83117 4.37466 1.87614 4.35293C1.97141 4.30693 2.06782 4.26464 2.16517 4.22477C2.22195 4.20135 2.27743 4.17506 2.33302 4.14818C2.37026 4.13051 2.40775 4.11387 2.44543 4.09745C2.49458 4.07602 2.5433 4.0538 2.59178 4.03044C2.65212 4.00138 2.713 3.97428 2.77416 3.94757C2.87055 3.90512 2.96635 3.86097 3.06155 3.81517C3.12139 3.78645 3.18176 3.75965 3.24239 3.73319C3.31461 3.70136 3.38635 3.66812 3.45816 3.63508C3.48683 3.62194 3.5155 3.60882 3.54418 3.59571C3.56844 3.58459 3.59267 3.57341 3.6169 3.56221C3.68341 3.53151 3.74989 3.50102 3.81744 3.47342C3.87377 3.45037 3.92873 3.42431 3.98382 3.39767C4.03368 3.37401 4.08412 3.35222 4.13456 3.33024C4.17134 3.31388 4.2077 3.29667 4.24405 3.27909C4.28688 3.25844 4.32976 3.23906 4.37356 3.22129C4.4564 3.18749 4.53723 3.14814 4.61842 3.10953C4.66467 3.08762 4.71121 3.06655 4.75773 3.04539C4.77928 3.03553 4.80084 3.02566 4.82239 3.01579C4.84532 3.00528 4.86825 2.99479 4.89118 2.9843C4.91588 2.97298 4.94058 2.96164 4.96527 2.95027C5.01834 2.92583 5.07161 2.90205 5.12506 2.8787C5.1752 2.85674 5.22488 2.83392 5.27433 2.81002C5.32864 2.78386 5.38338 2.76014 5.43884 2.73741C5.55289 2.69028 5.66499 2.63781 5.77699 2.58475C5.85585 2.54739 5.93512 2.51149 6.01486 2.47664C6.06447 2.45489 6.1137 2.43239 6.16267 2.40879C6.22298 2.37975 6.28382 2.35266 6.34496 2.32597C6.41719 2.29415 6.48893 2.26091 6.56073 2.22787C6.58024 2.21893 6.59976 2.20999 6.61927 2.20106C6.62833 2.19692 6.63738 2.19277 6.64671 2.1885C6.6711 2.17733 6.6955 2.16616 6.71989 2.15499C6.72736 2.15157 6.73483 2.14815 6.74253 2.14463C6.75791 2.13758 6.77329 2.13055 6.78866 2.12351C6.82091 2.10875 6.85314 2.09398 6.88535 2.07914C6.97691 2.03697 7.06906 1.99658 7.16131 1.95642C7.23479 1.92433 7.30756 1.89082 7.38005 1.85591C7.42884 1.83286 7.47814 1.81142 7.52745 1.78989C7.59968 1.75807 7.67142 1.72483 7.74322 1.69179C7.77189 1.67865 7.80057 1.66553 7.82925 1.65242C7.8535 1.6413 7.87774 1.63012 7.90197 1.61891C7.96848 1.58821 8.03495 1.55773 8.10251 1.53013C8.15884 1.50708 8.21379 1.48102 8.26889 1.45437C8.31875 1.43072 8.36919 1.40892 8.41963 1.38694C8.4564 1.37058 8.49277 1.35337 8.52911 1.3358C8.57195 1.31515 8.61483 1.29577 8.65863 1.278C8.74146 1.24419 8.8223 1.20485 8.90348 1.16624C8.94974 1.14433 8.99628 1.12325 9.04279 1.1021C9.06435 1.09223 9.08591 1.08237 9.10746 1.07249C9.13039 1.06199 9.15332 1.0515 9.17624 1.041C9.20095 1.02969 9.22565 1.01835 9.25033 1.00698C9.30341 0.982533 9.35667 0.958755 9.41013 0.93541C9.45975 0.913662 9.50897 0.891154 9.55794 0.867563C9.65275 0.821948 9.74868 0.779898 9.84551 0.740243C9.90223 0.71685 9.95764 0.690587 10.0132 0.663758C10.0921 0.62629 10.172 0.591766 10.2524 0.558478C10.2838 0.544464 10.3119 0.530072 10.3416 0.512409C10.3814 0.489052 10.4209 0.47293 10.4634 0.457492C10.5256 0.433366 10.5861 0.404035 10.6468 0.375804C10.6851 0.358092 10.7234 0.340607 10.7617 0.323105C10.819 0.296884 10.819 0.296884 10.8763 0.27044C10.9051 0.257093 10.934 0.244005 10.9629 0.230967C10.9832 0.221663 10.9832 0.221663 11.0039 0.212172C11.1245 0.157751 11.246 0.11539 11.3727 0.0835443C11.3847 0.0804433 11.3968 0.0773422 11.4093 0.0741472C11.8437 -0.0327165 12.3302 -0.0309911 12.7551 0.124876Z" }),
      /* @__PURE__ */ s.jsx("path", { d: "M4.52391 9.47656C4.56881 9.48627 4.60876 9.50017 4.65135 9.51935C4.66472 9.52535 4.67809 9.53136 4.69186 9.53754C4.70605 9.544 4.72023 9.55045 4.73485 9.5571C4.74209 9.56038 4.74933 9.56366 4.75679 9.56704C4.83228 9.60126 4.90756 9.636 4.9824 9.67203C5.0423 9.70079 5.10272 9.72764 5.1634 9.75414C5.2357 9.78602 5.3075 9.81931 5.37938 9.8524C5.39891 9.86136 5.41844 9.8703 5.43797 9.87925C5.53868 9.92539 5.53868 9.92539 5.56134 9.93577C5.57674 9.94282 5.59213 9.94987 5.60752 9.95692C5.63979 9.9717 5.67206 9.9865 5.7043 10.0014C5.79594 10.0436 5.88818 10.084 5.98051 10.1243C6.05406 10.1564 6.1269 10.19 6.19946 10.2249C6.2483 10.248 6.29763 10.2695 6.347 10.2911C6.41929 10.3229 6.4911 10.3562 6.56297 10.3893C6.59167 10.4025 6.62037 10.4156 6.64908 10.4287C6.67335 10.4399 6.69761 10.4511 6.72186 10.4623C6.78843 10.493 6.85497 10.5236 6.92259 10.5512C6.97897 10.5743 7.03398 10.6004 7.08912 10.6271C7.1264 10.6448 7.16393 10.6615 7.20164 10.6779C7.25032 10.6992 7.29862 10.7211 7.34666 10.7442C7.47102 10.8039 7.59539 10.8614 7.7233 10.9104C7.76384 10.9263 7.80191 10.9438 7.83999 10.9664C7.88751 10.9945 7.93613 11.0144 7.9868 11.0336C8.04681 11.0564 8.10277 11.0821 8.15896 11.1154C8.18584 11.1308 8.21325 11.1425 8.24168 11.1536C8.28775 11.1722 8.3329 11.1922 8.37791 11.214C8.43876 11.2434 8.50013 11.2708 8.56184 11.2978C8.63414 11.3296 8.70594 11.3629 8.77781 11.396C8.8066 11.4092 8.83539 11.4224 8.86419 11.4356C8.88757 11.4463 8.91091 11.4572 8.93423 11.4681C9.02194 11.5089 9.11004 11.5471 9.19985 11.5815C9.24963 11.601 9.29563 11.6247 9.34238 11.6523C9.36933 11.6677 9.39678 11.6794 9.42528 11.6905C9.47135 11.7091 9.5165 11.7291 9.56151 11.7509C9.62235 11.7803 9.68373 11.8077 9.74544 11.8347C9.81773 11.8666 9.88953 11.8998 9.96141 11.9329C9.99011 11.9461 10.0188 11.9592 10.0475 11.9724C10.0718 11.9835 10.096 11.9947 10.1203 12.0059C10.1869 12.0367 10.2534 12.0672 10.321 12.0949C10.3653 12.113 10.4088 12.1327 10.4521 12.1536C11.3243 12.5737 12.2796 12.6302 13.1841 12.3088C13.1973 12.3041 13.2106 12.2994 13.2243 12.2946C13.3033 12.2656 13.3801 12.2305 13.4569 12.1947C13.4962 12.1764 13.5356 12.159 13.5752 12.1418C13.6526 12.1079 13.7292 12.0717 13.8058 12.0353C13.8816 11.9994 13.9578 11.9647 14.0344 11.9313C14.1503 11.8804 14.2653 11.827 14.3804 11.7741C14.4247 11.7538 14.4691 11.7334 14.5134 11.7131C14.5337 11.7038 14.5337 11.7038 14.5544 11.6944C14.6489 11.6511 14.6489 11.6511 14.6767 11.6384C14.7001 11.6276 14.7234 11.6168 14.7467 11.6059C14.8344 11.565 14.9225 11.5268 15.0124 11.4924C15.0529 11.4765 15.091 11.4589 15.1291 11.4364C15.1764 11.4085 15.2247 11.3885 15.2751 11.3692C15.3372 11.3448 15.3978 11.3193 15.4574 11.2876C15.5035 11.2634 15.551 11.2429 15.5981 11.2215C15.6274 11.2081 15.6567 11.1947 15.686 11.1813C15.7013 11.1743 15.7165 11.1673 15.7318 11.1603C15.7457 11.1539 15.7596 11.1476 15.7739 11.141C15.8325 11.1141 15.8325 11.1141 15.86 11.1016C15.8843 11.0904 15.9085 11.0792 15.9328 11.068C15.9994 11.0373 16.0659 11.0067 16.1335 10.9791C16.1894 10.9562 16.244 10.9304 16.2987 10.904C16.4117 10.8498 16.5251 10.7987 16.6413 10.7541C16.6818 10.7383 16.7199 10.7207 16.758 10.6981C16.8133 10.6654 16.8709 10.6438 16.9299 10.6214C16.9812 10.6014 17.0288 10.5776 17.0769 10.5491C17.1038 10.5337 17.1312 10.5221 17.1597 10.511C17.2057 10.4924 17.2509 10.4723 17.2959 10.4506C17.3567 10.4211 17.4181 10.3937 17.4798 10.3668C17.5234 10.3476 17.5668 10.3278 17.6101 10.3079C17.6175 10.3045 17.625 10.3011 17.6327 10.2976C17.6646 10.2829 17.6965 10.2682 17.7284 10.2534C17.7761 10.2313 17.8239 10.2102 17.8723 10.1905C17.9556 10.1562 18.037 10.1167 18.1187 10.0778C18.1897 10.0441 18.2612 10.0121 18.333 9.98076C18.3827 9.95897 18.4319 9.93643 18.4809 9.9128C18.5413 9.88371 18.6022 9.85658 18.6634 9.82986C18.7357 9.79798 18.8075 9.76469 18.8794 9.7316C18.9081 9.71844 18.9368 9.7053 18.9655 9.69217C18.9898 9.68103 19.014 9.66983 19.0383 9.65861C19.1149 9.62322 19.1917 9.58895 19.2695 9.55726C19.3178 9.53659 19.365 9.51299 19.4122 9.48936C19.4419 9.47656 19.4419 9.47656 19.477 9.47656C19.4781 10.0467 19.4789 10.6168 19.4794 11.1869C19.4795 11.2543 19.4795 11.3218 19.4796 11.3893C19.4796 11.4094 19.4796 11.4094 19.4796 11.43C19.4798 11.6468 19.4802 11.8636 19.4806 12.0804C19.4811 12.3033 19.4813 12.5261 19.4814 12.749C19.4815 12.8862 19.4817 13.0235 19.4821 13.1607C19.4823 13.2551 19.4824 13.3496 19.4824 13.444C19.4823 13.4983 19.4824 13.5526 19.4826 13.6068C19.4846 14.0402 19.4469 14.4324 19.2661 14.8188C19.2607 14.8315 19.2554 14.8442 19.2498 14.8573C19.2261 14.9103 19.1992 14.9605 19.1716 15.011C19.1664 15.0207 19.1611 15.0305 19.1558 15.0406C19.1482 15.0545 19.1482 15.0545 19.1404 15.0687C19.1359 15.0771 19.1313 15.0855 19.1266 15.0942C19.1138 15.1141 19.1138 15.1141 19.0903 15.1276C19.0855 15.137 19.0806 15.1464 19.0756 15.1561C19.0497 15.2049 19.0184 15.2458 18.9856 15.2886C18.9733 15.3049 18.9609 15.3211 18.9486 15.3373C18.9399 15.3488 18.9399 15.3488 18.9309 15.3605C18.9161 15.3805 18.9021 15.4012 18.8881 15.422C18.878 15.4357 18.878 15.4357 18.8677 15.4497C18.8599 15.4497 18.8522 15.4497 18.8442 15.4497C18.8411 15.4583 18.8379 15.4669 18.8347 15.4757C18.8208 15.5034 18.8208 15.5034 18.7856 15.5168C18.7822 15.5247 18.7787 15.5326 18.7752 15.5408C18.7581 15.5798 18.7352 15.6014 18.7065 15.6301C18.6908 15.6458 18.6908 15.6458 18.6748 15.6619C18.665 15.6716 18.6552 15.6813 18.645 15.6913C18.6376 15.6988 18.6301 15.7063 18.6225 15.7141C18.5778 15.7584 18.5778 15.7584 18.5513 15.7584C18.5513 15.7673 18.5513 15.7762 18.5513 15.7853C18.5418 15.7889 18.5324 15.7925 18.5227 15.7962C18.5128 15.8015 18.5029 15.8067 18.4927 15.8121C18.4888 15.8254 18.4849 15.8387 18.4809 15.8524C18.4618 15.8665 18.4422 15.8798 18.4223 15.8927C18.3997 15.9117 18.3773 15.931 18.355 15.9506C18.3051 15.9939 18.2545 16.0353 18.2021 16.0744C18.1739 16.0958 18.1466 16.1184 18.1191 16.141C18.0678 16.1825 18.0146 16.2169 17.9591 16.2505C17.9245 16.272 17.8925 16.297 17.8598 16.3222C17.8365 16.3359 17.8131 16.3492 17.7895 16.3625C17.7705 16.3744 17.7514 16.3865 17.7324 16.3985C17.6686 16.4387 17.6037 16.476 17.5384 16.5128C17.5051 16.5316 17.4728 16.5506 17.441 16.5725C17.4175 16.5886 17.3963 16.5998 17.3706 16.61C17.3286 16.6273 17.2881 16.6471 17.2474 16.6681C16.9762 16.8077 16.7012 16.9313 16.4187 17.038C16.3938 17.0475 16.3689 17.0571 16.344 17.0668C16.2564 17.1007 16.1687 17.1336 16.0801 17.1636C16.0726 17.1662 16.065 17.1687 16.0573 17.1714C16.011 17.1868 15.9644 17.2006 15.9176 17.2138C15.8445 17.2345 15.7723 17.2581 15.6999 17.2819C15.6043 17.3131 15.5096 17.3412 15.4116 17.3611C15.3743 17.3688 15.3743 17.3688 15.334 17.3828C15.298 17.3945 15.2637 17.4024 15.2268 17.4086C15.1791 17.4173 15.1329 17.4281 15.0862 17.4422C15.0312 17.4585 14.9761 17.4712 14.9202 17.4821C14.9025 17.4857 14.8847 17.4892 14.8669 17.4927C14.8579 17.4945 14.8489 17.4963 14.8397 17.4981C14.8144 17.5031 14.7891 17.5082 14.7638 17.5133C14.5434 17.558 14.3231 17.5985 14.1011 17.6318C14.0615 17.6379 14.0219 17.6446 13.9824 17.6513C13.8955 17.6656 13.8084 17.6754 13.7209 17.6846C13.691 17.6878 13.661 17.691 13.6311 17.6943C13.6234 17.6951 13.6157 17.6959 13.6078 17.6967C13.5672 17.7011 13.5266 17.7058 13.4861 17.7112C13.3325 17.7315 13.1788 17.7414 13.0244 17.7501C12.9809 17.7525 12.9374 17.7551 12.8939 17.7577C12.5986 17.7749 12.3035 17.7881 12.0078 17.7878C11.9952 17.7878 11.9827 17.7878 11.9697 17.7878C11.7158 17.7876 11.4627 17.777 11.2092 17.7621C11.1573 17.7591 11.1054 17.7564 11.0535 17.754C10.8124 17.7425 10.5742 17.7203 10.3347 17.6871C10.2668 17.6778 10.1988 17.6704 10.1306 17.6636C10.0457 17.655 9.96207 17.6417 9.87803 17.6256C9.81733 17.6141 9.75671 17.605 9.69554 17.5974C9.62248 17.5882 9.55084 17.5748 9.47874 17.5585C9.42835 17.5472 9.37803 17.5381 9.32713 17.5303C9.25924 17.5196 9.19302 17.5043 9.12617 17.4872C9.06871 17.4732 9.01094 17.4618 8.95299 17.4509C8.90112 17.4409 8.85174 17.4261 8.80125 17.4094C8.77886 17.4048 8.75639 17.4006 8.73387 17.3969C8.67661 17.3865 8.62195 17.3718 8.56642 17.3528C8.53702 17.3439 8.50809 17.3369 8.47825 17.3304C8.40778 17.3146 8.33878 17.2935 8.26951 17.2719C8.24958 17.2657 8.24958 17.2657 8.22924 17.2594C8.11067 17.2223 7.99293 17.1825 7.87547 17.141C7.8613 17.136 7.84713 17.1311 7.83253 17.1259C7.80776 17.1172 7.78299 17.1085 7.75824 17.0997C7.73424 17.0912 7.71022 17.0828 7.68619 17.0745C7.4775 17.0017 7.27382 16.9174 7.07164 16.8239C7.03739 16.808 7.00308 16.7924 6.96873 16.7769C6.92393 16.7564 6.87993 16.7343 6.83598 16.7115C6.80678 16.6969 6.77724 16.6836 6.74754 16.6704C6.70666 16.6519 6.67066 16.6307 6.63328 16.6041C6.61378 16.5944 6.59426 16.5848 6.57469 16.5753C6.43603 16.5071 6.30188 16.4316 6.17625 16.3356C6.16586 16.3298 6.15547 16.324 6.14476 16.318C6.09715 16.2902 6.05323 16.2573 6.00834 16.2242C5.98377 16.2063 5.95919 16.1892 5.93382 16.1729C5.90332 16.1531 5.87303 16.1332 5.843 16.1125C5.83504 16.107 5.82708 16.1016 5.81888 16.096C5.81306 16.0909 5.80724 16.0858 5.80125 16.0806C5.80125 16.0717 5.80125 16.0629 5.80125 16.0537C5.7916 16.052 5.7916 16.052 5.78175 16.0502C5.74591 16.0373 5.72148 16.0157 5.69139 15.99C5.68004 15.9803 5.6687 15.9707 5.65701 15.9607C5.63253 15.9392 5.60866 15.9173 5.58519 15.8943C5.55986 15.8703 5.53837 15.8536 5.50828 15.839C5.50828 15.8301 5.50828 15.8213 5.50828 15.8121C5.48895 15.8033 5.46961 15.7944 5.44969 15.7853C5.44969 15.7764 5.44969 15.7676 5.44969 15.7584C5.44313 15.7552 5.43658 15.752 5.42982 15.7486C5.39717 15.728 5.37302 15.7027 5.34569 15.6737C5.31219 15.6384 5.27877 15.6038 5.24315 15.5714C5.23396 15.5622 5.22478 15.5531 5.21531 15.5437C5.21531 15.5348 5.21531 15.526 5.21531 15.5168C5.20782 15.5132 5.20033 15.5096 5.19261 15.5059C5.16844 15.49 5.16844 15.49 5.15672 15.4497C5.14512 15.4453 5.13352 15.4409 5.12156 15.4363C5.10447 15.4147 5.08822 15.3921 5.07249 15.3692C5.03021 15.3083 4.98644 15.2501 4.94029 15.193C4.92235 15.1678 4.92235 15.1678 4.91063 15.1276C4.90002 15.1154 4.90002 15.1154 4.8892 15.103C4.79794 14.9985 4.7429 14.8423 4.68731 14.7105C4.67567 14.6832 4.6636 14.6563 4.65153 14.6292C4.54515 14.3854 4.52197 14.0819 4.5225 13.8138C4.52249 13.795 4.52248 13.7763 4.52247 13.7575C4.52244 13.7062 4.52249 13.6549 4.52255 13.6036C4.5226 13.5482 4.52258 13.4928 4.52257 13.4373C4.52257 13.3414 4.5226 13.2455 4.52267 13.1495C4.52276 13.0108 4.52279 12.8721 4.52281 12.7334C4.52284 12.5084 4.52291 12.2833 4.52302 12.0583C4.52313 11.8397 4.52321 11.6211 4.52326 11.4026C4.52327 11.3891 4.52327 11.3756 4.52327 11.3617C4.52329 11.2941 4.5233 11.2265 4.52332 11.1588C4.52344 10.5981 4.52365 10.0373 4.52391 9.47656Z" })
    ] }),
    /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_4_30323", children: /* @__PURE__ */ s.jsx("rect", { width: "24", height: "18", fill: "rgb(var(--background-secondary))" }) }) })
  ] });
}
function Jh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "19",
      height: "22",
      viewBox: "0 0 19 22",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M11.19 9.44064L7.94 21.8806H0L1.61 15.7606L11.19 9.44064Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M18.3994 0.41037L12.7594 21.8804H8.88938L12.6994 7.34037L6.85938 11.1904L7.89937 7.36037L18.3994 0.41037Z" })
      ]
    }
  );
}
function DL({ ...e }) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M4 11C6.38695 11 8.67613 11.9482 10.364 13.636C12.0518 15.3239 13 17.6131 13 20M4 4C8.24346 4 12.3131 5.68571 15.3137 8.68629C18.3143 11.6869 20 15.7565 20 20M6 19C6 19.5523 5.55228 20 5 20C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18C5.55228 18 6 18.4477 6 19Z",
          stroke: "rgb(var(--text-secondary))",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function NL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      viewBox: ".8 .48 1894.74 400.27",
      width: "159",
      height: "42",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "m122.63 105.7-15.75 57.97 90.15-58.3-58.96 219.98 59.88.05 87.1-324.92",
            fill: "#3395ff"
          }
        ),
        /* @__PURE__ */ s.jsx("path", { d: "m25.6 232.92-24.8 92.48h122.73l50.22-188.13zm426.32-81.42c-3 11.15-8.78 19.34-17.4 24.57-8.6 5.22-20.67 7.84-36.25 7.84h-49.5l17.38-64.8h49.5c15.56 0 26.25 2.6 32.05 7.9s7.2 13.4 4.22 24.6m51.25-1.4c6.3-23.4 3.7-41.4-7.82-54-11.5-12.5-31.68-18.8-60.48-18.8h-110.47l-66.5 248.1h53.67l26.8-100h35.2c7.9 0 14.12 1.3 18.66 3.8 4.55 2.6 7.22 7.1 8.04 13.6l9.58 82.6h57.5l-9.32-77c-1.9-17.2-9.77-27.3-23.6-30.3 17.63-5.1 32.4-13.6 44.3-25.4a92.6 92.6 0 0 0 24.44-42.5m130.46 86.4c-4.5 16.8-11.4 29.5-20.73 38.4-9.34 8.9-20.5 13.3-33.52 13.3-13.26 0-22.25-4.3-27-13-4.76-8.7-4.92-21.3-.5-37.8s11.47-29.4 21.17-38.7 21.04-13.95 34.06-13.95c13 0 21.9 4.5 26.4 13.43 4.6 8.97 4.7 21.8.2 38.5zm23.52-87.8-6.72 25.1c-2.9-9-8.53-16.2-16.85-21.6-8.34-5.3-18.66-8-30.97-8-15.1 0-29.6 3.9-43.5 11.7s-26.1 18.8-36.5 33-18 30.3-22.9 48.4c-4.8 18.2-5.8 34.1-2.9 47.9 3 13.9 9.3 24.5 19 31.9 9.8 7.5 22.3 11.2 37.6 11.2a82.4 82.4 0 0 0 35.2-7.7 82.11 82.11 0 0 0 28.4-21.2l-7 26.16h51.9l47.39-176.77h-52zm238.65 0h-150.93l-10.55 39.4h87.82l-116.1 100.3-9.92 37h155.8l10.55-39.4h-94.1l117.88-101.8m142.4 52c-4.67 17.4-11.6 30.48-20.75 39-9.15 8.6-20.23 12.9-33.24 12.9-27.2 0-36.14-17.3-26.86-51.9 4.6-17.2 11.56-30.13 20.86-38.84 9.3-8.74 20.57-13.1 33.82-13.1 13 0 21.78 4.33 26.3 13.05 4.52 8.7 4.48 21.67-.13 38.87m30.38-80.83c-11.95-7.44-27.2-11.16-45.8-11.16-18.83 0-36.26 3.7-52.3 11.1a113.09 113.09 0 0 0 -41 32.06c-11.3 13.9-19.43 30.2-24.42 48.8-4.9 18.53-5.5 34.8-1.7 48.73 3.8 13.9 11.8 24.6 23.8 32 12.1 7.46 27.5 11.17 46.4 11.17 18.6 0 35.9-3.74 51.8-11.18 15.9-7.48 29.5-18.1 40.8-32.1 11.3-13.94 19.4-30.2 24.4-48.8s5.6-34.84 1.8-48.8c-3.8-13.9-11.7-24.6-23.6-32.05m185.1 40.8 13.3-48.1c-4.5-2.3-10.4-3.5-17.8-3.5-11.9 0-23.3 2.94-34.3 8.9-9.46 5.06-17.5 12.2-24.3 21.14l6.9-25.9-15.07.06h-37l-47.7 176.7h52.63l24.75-92.37c3.6-13.43 10.08-24 19.43-31.5 9.3-7.53 20.9-11.3 34.9-11.3 8.6 0 16.6 1.97 24.2 5.9m146.5 41.1c-4.5 16.5-11.3 29.1-20.6 37.8-9.3 8.74-20.5 13.1-33.5 13.1s-21.9-4.4-26.6-13.2c-4.8-8.85-4.9-21.6-.4-38.36 4.5-16.75 11.4-29.6 20.9-38.5 9.5-8.97 20.7-13.45 33.7-13.45 12.8 0 21.4 4.6 26 13.9s4.7 22.2.28 38.7m36.8-81.4c-9.75-7.8-22.2-11.7-37.3-11.7-13.23 0-25.84 3-37.8 9.06-11.95 6.05-21.65 14.3-29.1 24.74l.18-1.2 8.83-28.1h-51.4l-13.1 48.9-.4 1.7-54 201.44h52.7l27.2-101.4c2.7 9.02 8.2 16.1 16.6 21.22 8.4 5.1 18.77 7.63 31.1 7.63 15.3 0 29.9-3.7 43.75-11.1 13.9-7.42 25.9-18.1 36.1-31.9s17.77-29.8 22.6-47.9c4.9-18.13 5.9-34.3 3.1-48.45-2.85-14.17-9.16-25.14-18.9-32.9m174.65 80.65c-4.5 16.7-11.4 29.5-20.7 38.3-9.3 8.86-20.5 13.27-33.5 13.27-13.3 0-22.3-4.3-27-13-4.8-8.7-4.9-21.3-.5-37.8s11.42-29.4 21.12-38.7 21.05-13.94 34.07-13.94c13 0 21.8 4.5 26.4 13.4 4.6 8.93 4.63 21.76.15 38.5zm23.5-87.85-6.73 25.1c-2.9-9.05-8.5-16.25-16.8-21.6-8.4-5.34-18.7-8-31-8-15.1 0-29.68 3.9-43.6 11.7-13.9 7.8-26.1 18.74-36.5 32.9s-18 30.3-22.9 48.4c-4.85 18.17-5.8 34.1-2.9 47.96 2.93 13.8 9.24 24.46 19 31.9 9.74 7.4 22.3 11.14 37.6 11.14 12.3 0 24.05-2.56 35.2-7.7a82.3 82.3 0 0 0 28.33-21.23l-7 26.18h51.9l47.38-176.7h-51.9zm269.87.06.03-.05h-31.9c-1.02 0-1.92.05-2.85.07h-16.55l-8.5 11.8-2.1 2.8-.9 1.4-67.25 93.68-13.9-109.7h-55.08l27.9 166.7-61.6 85.3h54.9l14.9-21.13c.42-.62.8-1.14 1.3-1.8l17.4-24.7.5-.7 77.93-110.5 65.7-93 .1-.06h-.03z" })
      ]
    }
  );
}
function RL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.5852 11.6602C22.5847 11.5054 22.5811 11.3515 22.5742 11.1983V2.46357L20.1594 4.87836C18.183 2.4592 15.1765 0.914062 11.8088 0.914062C8.30428 0.914062 5.1908 2.58687 3.22266 5.17747L7.18079 9.17724C7.56868 8.45985 8.11974 7.84368 8.78416 7.37831C9.47519 6.83906 10.4543 6.39814 11.8087 6.39814C11.9723 6.39814 12.0986 6.41726 12.1914 6.45329C13.8696 6.58574 15.3242 7.51186 16.1806 8.85605L13.3789 11.6578C16.9277 11.6439 20.9367 11.6357 22.5849 11.6596",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.7462 0.914062C11.5914 0.914583 11.4374 0.918152 11.2842 0.925092H2.54952L4.96431 3.33988C2.54515 5.31625 1 8.32282 1 11.6904C1 15.195 2.67284 18.3085 5.26342 20.2766L9.26318 16.3185C8.54579 15.9306 7.92962 15.3796 7.46425 14.7151C6.92502 14.0241 6.48408 13.045 6.48408 11.6906C6.48408 11.5269 6.5032 11.4006 6.53923 11.3079C6.67168 9.62972 7.5978 8.17511 8.94199 7.31862L11.7438 10.1204C11.7298 6.57161 11.7216 2.5626 11.7456 0.914382",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M11.7462 0.914062C11.5914 0.914583 11.4374 0.918152 11.2842 0.925092H2.54952L4.96431 3.33988C2.54515 5.31625 1 8.32282 1 11.6904C1 15.195 2.67284 18.3085 5.26342 20.2766L9.26318 16.3185C8.54579 15.9306 7.92962 15.3796 7.46425 14.7151C6.92502 14.0241 6.48408 13.045 6.48408 11.6906C6.48408 11.5269 6.5032 11.4006 6.53923 11.3079C6.67168 9.62972 7.5978 8.17511 8.94199 7.31862L11.7438 10.1204C11.7298 6.57161 11.7216 2.5626 11.7456 0.914382",
            fill: "none",
            strokeWidth: "0.5",
            strokeLinecap: "square"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 11.6914C1.00052 11.8462 1.00409 12.0001 1.01102 12.1533V20.8881L3.42581 18.4733C5.40217 20.8925 8.40874 22.4376 11.7764 22.4376C15.2809 22.4376 18.3944 20.7648 20.3626 18.1742L16.4044 14.1744C16.0165 14.8918 15.4655 15.508 14.8011 15.9733C14.11 16.5126 13.1309 16.9535 11.7765 16.9535C11.6129 16.9535 11.4866 16.9344 11.3938 16.8983C9.71565 16.7659 8.26103 15.8398 7.40455 14.4956L10.2063 11.6938C6.65754 11.7078 2.64851 11.7159 1.00029 11.692",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M1 11.6914C1.00052 11.8462 1.00409 12.0001 1.01102 12.1533V20.8881L3.42581 18.4733C5.40217 20.8925 8.40874 22.4376 11.7764 22.4376C15.2809 22.4376 18.3944 20.7648 20.3626 18.1742L16.4044 14.1744C16.0165 14.8918 15.4655 15.508 14.8011 15.9733C14.11 16.5126 13.1309 16.9535 11.7765 16.9535C11.6129 16.9535 11.4866 16.9344 11.3938 16.8983C9.71565 16.7659 8.26103 15.8398 7.40455 14.4956L10.2063 11.6938C6.65754 11.7078 2.64851 11.7159 1.00029 11.692",
            fill: "none",
            strokeWidth: "0.5",
            strokeLinecap: "square"
          }
        )
      ]
    }
  );
}
function FL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "21",
      height: "23",
      viewBox: "0 0 21 23",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.79268 22.0883C8.03229 22.6214 9.37152 22.8844 10.7207 22.8596C12.0699 22.835 13.3984 22.5231 14.6178 21.945C16.83 20.9346 18.5971 19.1514 19.5878 16.9303C21.4336 12.5935 19.7999 6.41694 14.4297 4.13209C12.3462 3.2583 10.024 3.13392 7.85891 3.77978L8.6235 1.716L6.38345 0.888672L4.25674 6.63495L9.78221 9.32292L10.8216 7.17245L8.56964 6.08224L8.56944 6.08245C10.1945 5.60744 11.9327 5.70014 13.4977 6.34516C16.3411 7.53976 19.2738 11.5839 17.3805 16.0073C16.6159 17.6744 15.2798 19.0126 13.6142 19.7796C11.7631 20.6697 9.61634 20.7101 7.73293 19.8901C6.48079 19.3556 5.40349 18.4806 4.62368 17.3644C3.84386 16.2483 3.39281 14.9358 3.32156 13.5762L0.932129 13.7524C1.21588 17.5454 3.40531 20.6486 6.79254 22.0881L6.79268 22.0883Z"
        }
      )
    }
  );
}
function OL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "43",
      height: "36",
      viewBox: "0 0 43 36",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.8215 35.0926L1.23971 16.2129C0.965302 15.8379 0.820312 15.3926 0.820312 14.9249V2.66362C0.820312 2.08549 1.04176 1.5421 1.44386 1.13356C1.84682 0.725 2.38163 0.5 2.94977 0.5H15.0176C15.6891 0.50088 16.3284 0.82857 16.7276 1.37656L27.2326 12.0505C25.0306 13.9778 23.7678 16.7746 23.7678 19.7251C23.7678 23.7767 26.1355 27.4293 29.8 29.0305C29.6392 29.2038 29.494 29.3552 29.3566 29.4948C26.7197 32.1732 23.4226 34.1089 19.822 35.0925L19.8215 35.0926ZM10.6579 6.44148C9.59225 6.44236 8.59058 6.86431 7.83736 7.6296C7.08415 8.3949 6.66886 9.41263 6.66799 10.4953C6.66799 11.5776 7.08267 12.596 7.83565 13.3628C8.57766 14.1175 9.60538 14.5509 10.6553 14.5518C11.7235 14.5518 12.7273 14.1302 13.4818 13.3645C14.2361 12.5971 14.6511 11.5773 14.6503 10.4927C14.6494 9.42597 14.2229 8.38176 13.48 7.62787C12.7262 6.86282 11.7239 6.44149 10.6578 6.44149L10.6579 6.44148Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M34.3106 11.0938C29.5693 11.0938 25.8008 14.8622 25.8008 19.6036C25.8008 24.345 29.5693 28.1135 34.3106 28.1135C39.0521 28.1135 42.8205 24.345 42.8205 19.6036C42.8205 14.8622 39.0521 11.0938 34.3106 11.0938ZM39.1734 20.8193H35.5264H33.0949H29.4479V18.388H33.0949H35.5264H39.1734V20.8193Z"
          }
        )
      ]
    }
  );
}
function BL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      height: "15",
      viewBox: "0 0 24 24",
      width: "15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#11AD84",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "m18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4h-12c-2.206 0-4-1.794-4-4v-12c0-2.206 1.794-4 4-4zm0-2h-12c-3.314 0-6 2.686-6 6v12c0 3.314 2.686 6 6 6h12c3.314 0 6-2.686 6-6v-12c0-3.314-2.686-6-6-6z" }),
        /* @__PURE__ */ s.jsx("path", { d: "m9.957 17c-.253 0-.505-.096-.7-.286l-2.857-2.8c-.394-.386-.4-1.019-.014-1.414.387-.395 1.021-.4 1.414-.015l2.157 2.115 6.442-6.314c.395-.386 1.028-.382 1.414.014.387.394.381 1.028-.013 1.414l-7.143 7c-.195.19-.447.286-.7.286z" })
      ]
    }
  );
}
function ZL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.94569 14.5339C10.7817 14.5339 13.8914 11.4243 13.8914 7.58826C13.8914 3.75227 10.7817 0.642578 6.94569 0.642578C3.10969 0.642578 0 3.75227 0 7.58826C0 11.4243 3.10969 14.5339 6.94569 14.5339Z",
            fill: "#11AD84"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M9.95478 5.61133L5.83468 9.73143L3.96191 7.85866",
            stroke: "rgb(var(--background-primary))",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function GL({
  checkmarkClassName: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ s.jsxs("g", { stroke: "CurrentColor", children: [
        /* @__PURE__ */ s.jsx("path", { d: "M14.032 7.58875C14.032 11.0105 11.2581 13.7844 7.83631 13.7844C4.41453 13.7844 1.64062 11.0105 1.64062 7.58875C1.64062 4.16697 4.41453 1.39307 7.83631 1.39307C11.2581 1.39307 14.032 4.16697 14.032 7.58875Z" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M10.95576 5.43359L6.83566 9.55369L4.96289 7.68092",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: e
          }
        )
      ] })
    }
  );
}
function KL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100",
      height: "98",
      viewBox: "0 0 100 98",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsxs(
          "linearGradient",
          {
            id: "linear-gradient",
            x1: "4.606",
            y1: "-1.004",
            x2: "4.606",
            y2: "8.832",
            gradientUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ s.jsx("stop", { offset: "0", stopColor: "rgb(var(--text-tertiary))" }),
              /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "rgb(var(--text-primary))" })
            ]
          }
        ) }),
        /* @__PURE__ */ s.jsxs("g", { id: "cancel", transform: "translate(-10 -12)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22885",
              "data-name": "Tracé 22885",
              d: "M101,12H19a5,5,0,0,0-5,5v1h92V17A5,5,0,0,0,101,12Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22886",
              "data-name": "Tracé 22886",
              d: "M54.122,41.294H58v6.5H54.122a2.908,2.908,0,0,1-2.33-.951,3.735,3.735,0,0,1,0-4.6A2.908,2.908,0,0,1,54.122,41.294Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22887",
              "data-name": "Tracé 22887",
              d: "M60,58a25.985,25.985,0,1,0,10.851,2.366A26.038,26.038,0,0,0,60,58ZM51.586,75.586a2,2,0,0,1,2.828,0L60,81.172l5.586-5.586a2,2,0,0,1,2.828,2.828L62.828,84l5.586,5.586a2,2,0,0,1-2.828,2.828L60,86.828l-5.586,5.586a2,2,0,0,1-2.828-2.828L57.172,84l-5.586-5.586A2,2,0,0,1,51.586,75.586Z",
              fillRule: "evenodd"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22888",
              "data-name": "Tracé 22888",
              d: "M72.792,56.856A7.987,7.987,0,0,0,73,55.044a7.517,7.517,0,0,0-1.77-4.92,6.9,6.9,0,0,0-5.353-2.33H62v-6.5h6.8a2,2,0,0,0,0-4H62v-2a2,2,0,0,0-4,0v2H54.122a6.9,6.9,0,0,0-5.352,2.33,7.724,7.724,0,0,0,0,9.839,6.9,6.9,0,0,0,5.352,2.33H58v2.272A30.02,30.02,0,0,0,31.079,76h-6.11C24.475,68.132,18.174,62.455,10,62.026V35.972A15.513,15.513,0,0,0,24.888,22H95.112A15.513,15.513,0,0,0,110,35.972V62.026c-8.174.429-14.475,6.106-14.969,13.974h-6.11A30.074,30.074,0,0,0,72.792,56.856Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22889",
              "data-name": "Tracé 22889",
              d: "M62,54.066V51.794h3.878a2.909,2.909,0,0,1,2.33.951,3.59,3.59,0,0,1,.779,2.625A29.9,29.9,0,0,0,62,54.066Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22890",
              "data-name": "Tracé 22890",
              d: "M105,76H99.043c.472-5.44,4.791-9.565,10.957-9.968V71A5,5,0,0,1,105,76Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22891",
              "data-name": "Tracé 22891",
              d: "M10,66.032c6.166.4,10.485,4.528,10.957,9.968H15a5,5,0,0,1-5-5Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22892",
              "data-name": "Tracé 22892",
              d: "M20.854,22A11.489,11.489,0,0,1,10,31.964V27a5,5,0,0,1,5-5Z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_22893",
              "data-name": "Tracé 22893",
              d: "M110,31.964A11.488,11.488,0,0,1,99.146,22H105a5,5,0,0,1,5,5Z"
            }
          )
        ] })
      ]
    }
  );
}
function zL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "23",
      height: "28",
      viewBox: "0 0 23 18",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.596903 0.917895H22.0412V17.965H0.596903V0.917895Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.4904 11.5919C14.4889 12.8741 13.51 13.7907 11.9891 14.0086V15.2422H10.4494V13.9815C9.56536 13.8131 8.7314 13.3834 8.1574 12.7757L9.27598 11.7165C9.72924 12.1961 10.5288 12.5187 11.2642 12.5187C12.0426 12.5187 12.9512 12.2747 12.9512 11.5884L12.9512 11.5824C12.9574 10.7646 12.4136 10.5177 11.0744 10.1125C10.4491 9.92271 9.80186 9.72672 9.27112 9.36168C8.57333 8.88354 8.21849 8.20563 8.21849 7.35083C8.21849 6.13028 9.08072 5.23477 10.4494 4.93337V3.64022H11.9892V4.84862C12.7328 4.92422 13.4859 5.1678 14.0361 5.52488L13.2014 6.81895C12.7804 6.54715 12.1025 6.36375 11.5132 6.36375C10.7041 6.36375 9.75897 6.62279 9.75897 7.35084C9.75897 8.00445 10.155 8.22269 11.5203 8.63705C12.1757 8.83489 12.8534 9.04079 13.4118 9.43549C14.1347 9.94814 14.4972 10.6741 14.4904 11.5919L14.4904 11.5919Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function UL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5606 3.06065L10.9393 0.43934C10.658 0.15804 10.2765 0 9.87869 0H1.5C0.67156 0 0 0.67156 0 1.5V12.5C0 13.3284 0.67156 14 1.5 14H12.5C13.3284 14 14 13.3284 14 12.5V4.12132C14 3.7235 13.842 3.34197 13.5607 3.06067L13.5606 3.06065ZM7 12C5.89544 12 5 11.1046 5 9.99999C5 8.89543 5.89544 7.99999 7 7.99999C8.10456 7.99999 9 8.89543 9 9.99999C9 11.1046 8.10456 12 7 12ZM10 2.48374V5.62499C10 5.83208 9.83209 5.99999 9.625 5.99999H2.375C2.16791 5.99999 2 5.83208 2 5.62499V2.37499C2 2.1679 2.16791 1.99999 2.375 1.99999H9.51625C9.61572 1.99999 9.71109 2.03949 9.78141 2.10983L9.89016 2.21858C9.9605 2.28889 10 2.38428 10 2.48374Z"
        }
      )
    }
  );
}
function qh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 17 16",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2107 7.17079C14.2107 10.5788 11.448 13.3416 8.03993 13.3416C4.6319 13.3416 1.86914 10.5788 1.86914 7.17079C1.86914 3.76276 4.6319 1 8.03993 1C11.448 1 14.2107 3.76276 14.2107 7.17079Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M15.7538 14.8847L12.3984 11.5293",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
const YL = (e) => /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "318", height: "114", viewBox: "0 0 318 114", ...e, children: /* @__PURE__ */ s.jsx(
  "image",
  {
    width: "318",
    height: "114",
    xlinkHref: "data:img/png;base64,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"
  }
) });
function WL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "37",
      height: "37",
      viewBox: "0 0 37 37",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.0855 14.5284C26.3503 14.1908 26.317 13.7074 26.0075 13.41C25.6981 13.1126 25.2138 13.0981 24.8871 13.3762L9.90817 26.1196L1.99827 23.0607C1.53692 22.8838 1.16117 22.537 0.949013 22.091C0.736423 21.6453 0.703483 21.1345 0.856983 20.6652C1.01048 20.1958 1.33884 19.8036 1.77364 19.5694L34.612 1.17392C34.9576 0.987858 35.3595 0.933618 35.742 1.02161C36.125 1.10921 36.4625 1.33345 36.6924 1.65173C36.9223 1.97041 37.0284 2.36142 36.9914 2.75241L34.1108 32.7791C34.0522 33.4036 33.7025 33.9639 33.1672 34.2905C32.6316 34.6172 31.9737 34.6722 31.3914 34.4384L21.7648 30.7111L15.7212 36.3742C15.4222 36.6535 15.0255 36.8046 14.6165 36.7941C14.207 36.7841 13.8184 36.6133 13.5339 36.3195C13.249 36.0254 13.0914 35.6312 13.0942 35.2221V30.7747L26.0855 14.5284Z"
        }
      )
    }
  );
}
function $L(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2081 19.565C12.6186 19.565 12.0637 19.2471 11.7598 18.7358L11.6494 18.5464C11.2143 17.7871 10.6315 17.3692 10.0083 17.3692C9.38512 17.3692 8.79943 17.7871 8.35924 18.5464L8.24999 18.7358C7.94591 19.2471 7.39074 19.565 6.80102 19.565C6.50817 19.565 6.22045 19.4858 5.96923 19.3364L4.23962 18.3467C3.33422 17.8252 3.02002 16.6631 3.5393 15.7559C3.97936 14.9971 4.05065 14.2817 3.73986 13.7427C3.42907 13.2031 2.77563 12.9062 1.90002 12.9062C0.85229 12.9062 0 12.0542 0 11.0063V9.2461C0 8.19923 0.85229 7.34717 1.90002 7.34717C2.77539 7.34717 3.42883 7.0503 3.73974 6.51074C4.05053 5.9707 3.97936 5.25537 3.5393 4.49658C3.2871 4.05957 3.22143 3.54834 3.35424 3.05615C3.48693 2.56494 3.80138 2.15625 4.23962 1.90576L5.96923 0.9165C6.22094 0.7666 6.50841 0.6875 6.80077 0.6875C7.39025 0.6875 7.94555 1.00537 8.24999 1.5166L8.35924 1.70703C8.79442 2.46631 9.37743 2.88428 10.0008 2.88428C10.6243 2.88428 11.2097 2.46631 11.6494 1.70703L11.7598 1.5166C12.0642 1.00537 12.6194 0.6875 13.2086 0.6875C13.5008 0.6875 13.7881 0.7666 14.0394 0.9165L15.7701 1.90576C16.2085 2.15625 16.5229 2.56543 16.6555 3.05664C16.7881 3.54834 16.7219 4.05957 16.4693 4.49658C16.0295 5.25586 15.9587 5.9707 16.27 6.51074C16.5809 7.05029 17.2344 7.34717 18.1097 7.34717C19.1574 7.34717 20.0097 8.19922 20.0097 9.2461V11.0063C20.0097 12.0542 19.1574 12.9062 18.1097 12.9062C17.2341 12.9062 16.5807 13.2031 16.2699 13.7427C15.9588 14.2817 16.0298 14.9971 16.4693 15.7559C16.9896 16.666 16.676 17.8281 15.7701 18.3467L14.0394 19.3364C13.7878 19.4858 13.5003 19.565 13.2081 19.565ZM9.99914 6.875C8.20703 6.875 6.74902 8.33301 6.74902 10.125C6.74902 11.9175 8.20703 13.3755 9.99914 13.3755C11.7913 13.3755 13.2493 11.9175 13.2493 10.125C13.2493 8.33301 11.7913 6.875 9.99914 6.875Z"
        }
      )
    }
  );
}
function JL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "13",
      height: "18",
      viewBox: "0 0 13 18",
      fill: "rgb(var(--text-tertiary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M10.5 14C11.6046 14 12.5 14.8954 12.5 16C12.5 17.1046 11.6046 18 10.5 18C9.3954 18 8.5 17.1046 8.5 16C8.5 14.8954 9.3954 14 10.5 14ZM2.5 14C3.60457 14 4.5 14.8954 4.5 16C4.5 17.1046 3.60457 18 2.5 18C1.39543 18 0.5 17.1046 0.5 16C0.5 14.8954 1.39543 14 2.5 14ZM10.5 7C11.6046 7 12.5 7.8954 12.5 9C12.5 10.1046 11.6046 11 10.5 11C9.3954 11 8.5 10.1046 8.5 9C8.5 7.8954 9.3954 7 10.5 7ZM2.5 7C3.60457 7 4.5 7.8954 4.5 9C4.5 10.1046 3.60457 11 2.5 11C1.39543 11 0.5 10.1046 0.5 9C0.5 7.8954 1.39543 7 2.5 7ZM10.5 0C11.6046 0 12.5 0.89543 12.5 2C12.5 3.10457 11.6046 4 10.5 4C9.3954 4 8.5 3.10457 8.5 2C8.5 0.89543 9.3954 0 10.5 0ZM2.5 0C3.60457 0 4.5 0.89543 4.5 2C4.5 3.10457 3.60457 4 2.5 4C1.39543 4 0.5 3.10457 0.5 2C0.5 0.89543 1.39543 0 2.5 0Z" })
    }
  );
}
function qL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 490 490",
      xmlSpace: "preserve",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M384.547,31.26H105.453C47.313,31.26,0,79.606,0,139.016v106.739c0,59.411,47.313,107.756,105.453,107.756h176.408
	L410.103,458.74V350.266C456.489,338.453,490,295.745,490,245.755V139.016C490,79.606,442.687,31.26,384.547,31.26z M112.84,238.413
	c-12.486,0-23.612-2.722-30.819-6.624l5.264-21.264c5.458,3.32,16.778,7.223,25.556,7.223c8.972,0,12.681-3.125,12.681-8
	c0-4.89-2.931-7.223-14.041-10.931c-19.709-6.639-27.32-17.361-27.126-28.681c0-17.75,15.223-31.208,38.82-31.208
	c11.125,0,21.085,2.527,26.931,5.458l-5.264,20.486c-4.292-2.348-12.486-5.473-20.681-5.473c-7.223,0-11.32,2.931-11.32,7.806
	c0,4.486,3.708,6.834,15.417,10.931c18.139,6.236,25.75,15.417,25.945,29.459C154.202,225.344,140.16,238.413,112.84,238.413z
	 M316.314,236.469h-28.875V184.58c0-13.862-4.501-21.862-14.056-21.862c-6.819,0-11.709,4.68-13.653,10.348
	c-0.778,2.138-1.166,5.264-1.166,7.611v55.792h-28.875V183.01c0-12.098-4.292-20.292-13.668-20.292
	c-7.596,0-12.098,5.862-13.847,10.737c-0.972,2.333-1.166,5.069-1.166,7.417v55.598h-28.875v-64.973
	c0-11.888-0.389-22.042-0.778-30.431h24.973l1.361,12.875h0.583c4.097-6.041,12.486-15.013,28.875-15.013
	c12.292,0,22.042,6.236,26.139,16.18h0.389c3.514-4.875,7.806-8.778,12.292-11.499c5.279-3.125,11.125-4.68,18.154-4.68
	c18.333,0,32.195,12.875,32.195,41.347V236.469z M365.242,238.413c-12.486,0-23.612-2.722-30.819-6.624l5.264-21.264
	c5.458,3.32,16.778,7.223,25.556,7.223c8.972,0,12.681-3.125,12.681-8c0-4.89-2.931-7.223-14.042-10.931
	c-19.709-6.639-27.32-17.361-27.126-28.681c0-17.75,15.223-31.208,38.82-31.208c11.125,0,21.07,2.527,26.931,5.458l-5.264,20.486
	c-4.292-2.348-12.486-5.473-20.681-5.473c-7.223,0-11.32,2.931-11.32,7.806c0,4.486,3.708,6.834,15.417,10.931
	c18.139,6.236,25.75,15.417,25.945,29.459C406.604,225.344,392.562,238.413,365.242,238.413z`
          }
        ),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {})
      ]
    }
  );
}
function QL(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "19",
      height: "28",
      viewBox: "0 0 15 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M10.2575 0.667196H4.39084C4.16113 0.665229 3.93153 0.677475 3.70334 0.703863C1.23756 0.914696 0 2.3722 0 5.05803V8.7247C0 12.3914 1.46676 13.1155 4.39084 13.1155H4.75746C4.86987 13.1229 4.97968 13.1526 5.08044 13.203C5.18121 13.2534 5.2709 13.3234 5.34425 13.4089L6.44443 14.8755C6.53762 15.0249 6.6673 15.1481 6.82125 15.2335C6.9752 15.3189 7.14835 15.3637 7.32439 15.3637C7.50044 15.3637 7.67359 15.3189 7.82754 15.2335C7.98149 15.1481 8.11117 15.0249 8.20436 14.8755L9.30409 13.4089C9.37267 13.318 9.46132 13.2443 9.56311 13.1934C9.6649 13.1425 9.77708 13.1159 9.89088 13.1155H10.2575C12.9435 13.1155 14.4008 11.8872 14.6116 9.4122C14.6379 9.184 14.6502 8.9544 14.6483 8.7247V5.05803C14.6483 2.13385 13.1847 0.67024 10.2575 0.667196ZM4.12143 8.00053H4.11691C3.87411 7.99994 3.64147 7.90299 3.4701 7.73099C3.29872 7.55899 3.20263 7.326 3.20293 7.0832C3.20322 6.8404 3.29988 6.60764 3.47168 6.43606C3.64347 6.26447 3.87634 6.1681 4.11914 6.1681C4.36195 6.1681 4.59482 6.26447 4.76661 6.43606C4.9384 6.60764 5.03507 6.8404 5.03536 7.0832C5.03566 7.326 4.93957 7.55899 4.76819 7.73099C4.59682 7.90299 4.36423 7.99994 4.12143 8.00053ZM7.32793 8.00053H7.32346C7.08065 7.99994 6.84802 7.90299 6.67664 7.73099C6.50527 7.55899 6.40918 7.326 6.40947 7.0832C6.40977 6.8404 6.50643 6.60764 6.67822 6.43606C6.85002 6.26447 7.08289 6.1681 7.32569 6.1681C7.56849 6.1681 7.80137 6.26447 7.97316 6.43606C8.14495 6.60764 8.24161 6.8404 8.24191 7.0832C8.24221 7.326 8.14611 7.55899 7.97474 7.73099C7.80337 7.90299 7.57073 7.99994 7.32793 8.00053ZM10.5336 8.00053H10.5291C10.2861 7.99994 10.0532 7.9029 9.88166 7.73073C9.71012 7.55856 9.61393 7.32534 9.61423 7.0823C9.61452 6.83926 9.71128 6.60627 9.88324 6.43452C10.0552 6.26277 10.2883 6.1663 10.5313 6.1663C10.7744 6.1663 11.0075 6.26277 11.1794 6.43452C11.3514 6.60627 11.4482 6.83926 11.4485 7.0823C11.4488 7.32534 11.3526 7.55856 11.181 7.73073C11.0095 7.9029 10.7766 7.99994 10.5336 8.00053Z",
          fill: "rgb(var(--text-secondary))"
        }
      )
    }
  );
}
function XL(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "45",
      height: "26",
      viewBox: "0 0 45 26",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M40.2636 10.1633C40.2636 12.6577 38.2417 14.6796 35.7472 14.6796C33.2528 14.6796 31.2305 12.6577 31.2305 10.1633C31.2305 7.66881 33.2528 5.64648 35.7472 5.64648C38.2417 5.64648 40.2636 7.66882 40.2636 10.1633Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.2136 25.4062C44.21 22.5006 42.7174 19.7998 40.2588 18.2508C37.8005 16.7019 34.7197 16.5215 32.0977 17.773C33.3721 19.7024 34.0514 21.9641 34.051 24.2771V25.4061L44.2136 25.4062Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.9863 10.1633C12.9863 12.6577 10.9639 14.6796 8.46948 14.6796C5.97503 14.6796 3.95312 12.6577 3.95312 10.1633C3.95312 7.66881 5.97503 5.64648 8.46948 5.64648C10.9639 5.64648 12.9863 7.66882 12.9863 10.1633Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.00401625 25.4062H10.1665V24.2771C10.1661 21.9642 10.8455 19.7024 12.1199 17.7731C9.49777 16.5215 6.41697 16.7019 3.95872 18.2508C1.50006 19.7996 0.00753625 22.5004 0.00390625 25.4062H0.00401625Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.3197 6.21022C28.3197 9.64037 25.5389 12.4208 22.1091 12.4208C18.6792 12.4208 15.8984 9.64046 15.8984 6.21022C15.8984 2.78036 18.6792 0 22.1091 0C25.5389 0 28.3197 2.78036 28.3197 6.21022Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.2388 14.6787H20.9806C18.435 14.6787 15.9936 15.69 14.1939 17.4902C12.3938 19.29 11.3828 21.7313 11.3828 24.2769V25.406H32.837V24.2769C32.837 21.7313 31.826 19.2899 30.0258 17.4902C28.226 15.6901 25.7848 14.6787 23.2392 14.6787H23.2388Z"
          }
        )
      ]
    }
  );
}
function eH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_134156_86)", children: /* @__PURE__ */ s.jsx("path", { d: "M12.6187 1.57503C12.9937 1.41878 13.4219 1.50628 13.7094 1.79066L15.7094 3.79066C15.8969 3.97816 16.0031 4.23128 16.0031 4.49691C16.0031 4.76253 15.8969 5.01566 15.7094 5.20316L13.7094 7.20316C13.4219 7.49066 12.9937 7.57503 12.6187 7.41878C12.2437 7.26253 12 6.90003 12 6.49378V5.50003H10.8281C10.5625 5.50003 10.3094 5.60628 10.1219 5.79378L7.41563 8.50003L10.1219 11.2063C10.3094 11.3938 10.5625 11.5 10.8281 11.5H12V10.5C12 10.0969 12.2437 9.73128 12.6187 9.57503C12.9937 9.41878 13.4219 9.50628 13.7094 9.79066L15.7094 11.7907C15.8969 11.9782 16.0031 12.2313 16.0031 12.4969C16.0031 12.7625 15.8969 13.0157 15.7094 13.2032L13.7094 15.2032C13.4219 15.4907 12.9937 15.575 12.6187 15.4188C12.2437 15.2625 12 14.9 12 14.4938V13.5H10.8281C10.0312 13.5 9.26875 13.1844 8.70625 12.6219L5.58437 9.50003H1C0.446875 9.50003 0 9.05316 0 8.50003C0 7.94691 0.446875 7.50003 1 7.50003H5.58437L8.70625 4.37816C9.26875 3.81566 10.0312 3.50003 10.8281 3.50003H12V2.50003C12 2.09691 12.2437 1.73128 12.6187 1.57503Z" }) }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_134156_86", children: /* @__PURE__ */ s.jsx("rect", { width: "16", height: "16", transform: "translate(0 0.5)" }) }) })
      ]
    }
  );
}
function tH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "683",
      height: "683",
      viewBox: "0 0 683 683",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_104086_494)", children: [
          /* @__PURE__ */ s.jsx("path", { d: "M682.667 341.333C682.667 529.849 529.849 682.667 341.333 682.667C152.818 682.667 0 529.849 0 341.333C0 152.818 152.818 0 341.333 0C529.849 0 682.667 152.818 682.667 341.333Z" }),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M551.152 215.416C527.538 193.454 475.266 145.239 454.647 129.222C443.268 120.385 425.536 130.778 434.145 147.599L455.476 195.867C452.951 195.911 450.358 195.949 448.287 196.016C404.124 197.492 365.428 221.098 340.233 255.446C315.038 221.098 276.342 197.492 232.179 196.016C230.237 195.953 227.783 195.919 225.436 195.878L246.536 148.453C255.554 130.838 236.572 122.263 226.257 130.279C205.861 146.123 154.155 193.814 130.796 215.539C129.28 216.987 128.074 218.728 127.249 220.655C126.425 222.583 126 224.657 126 226.754C126 228.85 126.425 230.925 127.249 232.853C128.074 234.78 129.28 236.521 130.796 237.969C154.155 259.686 205.861 307.385 226.257 323.222C237.366 331.854 255.129 321.84 246.536 305.055L225.436 257.671C227.784 257.735 230.237 257.724 232.179 257.814C275.448 259.836 309.311 297.863 309.311 341.98V540.167C309.311 544.237 310.927 548.139 313.805 551.016C316.682 553.894 320.584 555.51 324.654 555.51H355.812C359.882 555.51 363.784 553.894 366.661 551.016C369.539 548.139 371.155 544.237 371.155 540.167V341.98C371.155 297.863 405.018 259.836 448.287 257.814C450.358 257.716 452.949 257.652 455.476 257.585L434.145 305.909C425.371 323.053 443.544 332.906 454.647 324.278C475.266 308.269 527.538 260.05 551.152 238.092C552.684 236.628 553.904 234.868 554.737 232.92C555.57 230.971 556 228.873 556 226.754C556 224.634 555.57 222.537 554.737 220.588C553.904 218.639 552.684 216.88 551.152 215.416Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_104086_494", children: /* @__PURE__ */ s.jsx("rect", { width: "682.667", height: "682.667", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function aH(e) {
  return /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ s.jsx("path", { d: "M18,2a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2Zm0-2H6A6,6,0,0,0,0,6V18a6,6,0,0,0,6,6H18a6,6,0,0,0,6-6V6A6,6,0,0,0,18,0Z" }) });
}
function nH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0994 0H6.71524C3.07343 0 0.902344 2.17 0.902344 5.81V14.18C0.902344 17.83 3.07342 20 6.71524 20H15.0894C18.7312 20 20.9023 17.83 20.9023 14.19V5.81C20.9123 2.17 18.7412 0 15.0994 0Z",
            className: "fill-background-secondary"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3312 5.8099V14.1899C15.3312 14.8299 14.8109 15.3499 14.1706 15.3499C13.5203 15.3499 13 14.8299 13 14.1899V5.8099C13 5.1699 13.5203 4.6499 14.1706 4.6499C14.8109 4.6499 15.3312 5.1699 15.3312 5.8099Z",
            className: "fill-brand-primary"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.81554 10.93V14.19C8.81554 14.83 8.29527 15.35 7.64496 15.35C7.00464 15.35 6.48438 14.83 6.48438 14.19V10.93C6.48438 10.29 7.00464 9.77002 7.64496 9.77002C8.29528 9.77002 8.81554 10.29 8.81554 10.93Z",
            className: "fill-brand-primary"
          }
        )
      ]
    }
  );
}
function rH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21.5",
      height: "21.5",
      viewBox: "0 0 21.5 21.5",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { id: "Layer_2", "data-name": "Layer 2", transform: "translate(-1.25 -1.25)", children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Tracé_43",
            "data-name": "Tracé 43",
            d: "M12,22.75A10.762,10.762,0,0,1,1.25,12a.75.75,0,0,1,1.5,0A9.25,9.25,0,1,0,12,2.75a.75.75,0,1,1,0-1.5,10.75,10.75,0,0,1,0,21.5Z",
            fill: "#ffc107"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "Tracé_44",
            "data-name": "Tracé 44",
            d: "M12,22.75a10.744,10.744,0,0,1-3.176-.477.75.75,0,1,1,.443-1.433A9.257,9.257,0,0,0,12,21.25a.75.75,0,1,1,0,1.5ZM5.56,20.4a.742.742,0,0,1-.483-.176A10.74,10.74,0,0,1,2.42,16.882.75.75,0,0,1,3.756,16.2a9.236,9.236,0,0,0,2.287,2.877A.749.749,0,0,1,5.56,20.4ZM2.144,14.456a.751.751,0,0,1-.738-.623,10.839,10.839,0,0,1,.121-4.267A.75.75,0,0,1,2.988,9.9a9.358,9.358,0,0,0-.1,3.675.75.75,0,0,1-.612.866.8.8,0,0,1-.132.015ZM3.909,6.872A.749.749,0,0,1,3.3,5.681,10.808,10.808,0,0,1,5.557,3.4a.75.75,0,0,1,.9,1.2A9.3,9.3,0,0,0,4.516,6.563a.75.75,0,0,1-.607.309ZM9.6,3.041a.75.75,0,0,1-.18-1.478A10.758,10.758,0,0,1,12,1.25a.75.75,0,1,1,0,1.5,9.255,9.255,0,0,0-2.224.27.8.8,0,0,1-.176.021Z",
            fill: "#ffc107"
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { id: "Groupe_40", "data-name": "Groupe 40", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_45",
              "data-name": "Tracé 45",
              d: "M9.171,15.578a.75.75,0,0,1-.53-1.28L14.3,8.642A.75.75,0,0,1,15.359,9.7L9.7,15.358a.748.748,0,0,1-.529.22Z",
              fill: "#ffc107"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              id: "Tracé_46",
              "data-name": "Tracé 46",
              d: "M14.829,15.578a.748.748,0,0,1-.531-.22L8.641,9.7A.75.75,0,0,1,9.7,8.642L15.359,14.3a.75.75,0,0,1-.53,1.28Z",
              fill: "#ffc107"
            }
          )
        ] })
      ] })
    }
  );
}
function iH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.0102539 8.9901C0.0102539 4.0248 4.03505 0 9.00035 0C13.9657 0 17.9905 4.0248 17.9905 8.9901C17.9905 13.9554 13.9657 17.9802 9.00035 17.9802C4.03505 17.9802 0.0102539 13.9554 0.0102539 8.9901ZM2.31065 8.9901C2.31065 12.6792 5.31125 15.6798 9.00035 15.6798C12.6895 15.6798 15.6901 12.6792 15.6901 8.9901C15.6901 5.301 12.6895 2.3004 9.00035 2.3004C5.31125 2.3004 2.31065 5.301 2.31065 8.9901ZM6.01055 11.9997V6.0003H12.01V11.9997H6.01055Z"
        }
      )
    }
  );
}
function oH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "35",
      height: "26",
      viewBox: "0 0 35 26",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.9182 9.49287C34.9132 9.38267 34.8897 9.27367 34.8485 9.1701C34.8391 9.14645 34.8333 9.12257 34.8224 9.09987C34.8164 9.0871 34.8146 9.07315 34.8078 9.06038L30.28 0.58549H30.2798C30.1858 0.40956 30.0413 0.26153 29.8624 0.1582C29.6837 0.05463 29.4776 0 29.2673 0H6.62845C6.41824 0 6.21206 0.05462 6.03343 0.1582C5.85455 0.26153 5.71002 0.40956 5.61603 0.58549L1.08826 9.06038C1.08144 9.07315 1.07967 9.0871 1.0736 9.09987C1.06223 9.12257 1.05667 9.14646 1.04758 9.1701H1.04732C1.00613 9.27367 0.98264 9.38268 0.97758 9.49287C0.97708 9.50753 0.96875 9.51959 0.96875 9.53425V11.653C0.96975 12.4955 1.32778 13.3035 1.96453 13.8991C2.601 14.495 3.46439 14.8301 4.36457 14.8311C4.75116 14.8275 5.13398 14.7615 5.49652 14.6357V25.4249H30.3993V14.6357C30.7619 14.7613 31.1446 14.8275 31.5312 14.8311C32.4315 14.8301 33.2949 14.495 33.9313 13.8991C34.568 13.3035 34.926 12.4954 34.9271 11.653V9.53425C34.9271 9.51959 34.9187 9.50753 34.9182 9.49287ZM28.1356 21.187H7.76062V14.6353C8.33342 14.8361 8.95473 14.8831 9.55453 14.7718C10.1544 14.6601 10.7093 14.3944 11.1565 14.0039C11.7735 14.5355 12.5817 14.8306 13.4204 14.8306C14.259 14.8306 15.0672 14.5355 15.6842 14.0039C16.3013 14.5355 17.1095 14.8306 17.9481 14.8306C18.7867 14.8306 19.595 14.5355 20.212 14.0039C20.829 14.5355 21.6373 14.8306 22.4759 14.8306C23.3145 14.8306 24.1228 14.5355 24.7398 14.0039C25.187 14.3943 25.7419 14.6601 26.3417 14.7718C26.9416 14.8831 27.5629 14.8361 28.1356 14.6353L28.1356 21.187ZM23.6078 10.5934V11.6528C23.6078 12.0313 23.3921 12.381 23.0419 12.5702C22.6917 12.7594 22.2601 12.7594 21.9099 12.5702C21.5597 12.3811 21.344 12.0313 21.344 11.6528V10.5934H23.6078ZM19.0801 10.5934V11.6528C19.0801 12.0313 18.8643 12.381 18.5141 12.5702C18.1639 12.7594 17.7323 12.7594 17.3821 12.5702C17.0319 12.3811 16.8162 12.0313 16.8162 11.6528V10.5934H19.0801ZM14.5523 10.5934V11.6528C14.5523 12.0313 14.3365 12.381 13.9863 12.5702C13.6361 12.7594 13.2046 12.7594 12.8544 12.5702C12.5042 12.3811 12.2884 12.0313 12.2884 11.6528V10.5934H14.5523ZM10.0245 10.5934V11.6528C10.0245 12.0313 9.80874 12.381 9.45855 12.5702C9.10834 12.7594 8.67678 12.7594 8.3266 12.5702C7.9764 12.3811 7.76062 12.0313 7.76062 11.6528V10.5934H10.0245ZM28.1356 11.6528C28.1356 12.0313 27.9198 12.3811 27.5697 12.5702C27.2194 12.7594 26.7879 12.7594 26.4377 12.5702C26.0875 12.3811 25.8717 12.0313 25.8717 11.6528V10.5934H28.1356V11.6528ZM4.36479 12.7121C4.06463 12.7119 3.77685 12.6003 3.5646 12.4016C3.35237 12.203 3.2331 11.9337 3.23286 11.6528V10.5934H5.49675V11.6528C5.49648 11.9337 5.37723 12.203 5.16499 12.4016C4.95276 12.6003 4.66497 12.7119 4.3648 12.7121H4.36479ZM32.6634 11.6528C32.6634 12.0313 32.4476 12.3811 32.0974 12.5702C31.7472 12.7594 31.3157 12.7594 30.9655 12.5702C30.6153 12.3811 30.3995 12.0313 30.3995 11.6528V10.5934H32.6634V11.6528Z"
        }
      )
    }
  );
}
function sH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "96",
      height: "40",
      viewBox: "0 0 96 40",
      fill: "#635BFF",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M95.194 20.4663C95.194 13.6969 91.9151 8.35547 85.6481 8.35547C79.3547 8.35547 75.5469 13.6969 75.5469 20.4134C75.5469 28.3728 80.0422 32.3921 86.4943 32.3921C89.641 32.3921 92.0208 31.6781 93.819 30.6733V25.3847C92.0208 26.2838 89.9583 26.8391 87.3404 26.8391C84.7755 26.8391 82.5014 25.94 82.2105 22.8197H95.1411C95.1411 22.476 95.194 21.1009 95.194 20.4663V20.4663ZM82.1328 17.9535C82.1328 14.9655 83.9574 13.7227 85.6233 13.7227C87.2363 13.7227 88.9551 14.9655 88.9551 17.9535H82.1328Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M65.3401 8.35547C62.7487 8.35547 61.0828 9.57185 60.1573 10.418L59.8135 8.77855H53.9961V39.611L60.6068 38.2095L60.6333 30.7262C61.5852 31.4137 62.9867 32.3921 65.3137 32.3921C70.047 32.3921 74.3572 28.5843 74.3572 20.2019C74.3307 12.5334 69.9676 8.35547 65.3401 8.35547H65.3401ZM63.7522 26.5754C62.1921 26.5754 61.2665 26.0201 60.6319 25.3326L60.6055 15.5223C61.293 14.7554 62.2449 14.2266 63.7522 14.2266C66.1585 14.2266 67.8244 16.9237 67.8244 20.3878C67.8244 23.9311 66.1849 26.5754 63.7522 26.5754Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 6.79584L51.5356 5.36792V0L44.8984 1.40147V6.79584Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 8.80469H51.5356V31.9423H44.8984V8.80469Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M37.7871 10.7614L37.364 8.80458H31.6523V31.9421H38.2631V16.2615C39.8232 14.2254 42.4675 14.5956 43.2872 14.8865V8.80458C42.4411 8.48727 39.3472 7.90552 37.7871 10.7614H37.7871Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.5644 3.06641L18.1124 4.44144L18.0859 25.6222C18.0859 29.5358 21.0211 32.4181 24.9347 32.4181C27.103 32.4181 28.6896 32.0214 29.5622 31.5455V26.1775C28.716 26.5213 24.538 27.7377 24.538 23.8241V14.4369H29.5622V8.80453H24.538L24.5644 3.06641Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.69006 15.5215C6.69006 14.4902 7.53624 14.0936 8.93771 14.0936C10.9474 14.0936 13.4859 14.7018 15.4956 15.7859V9.57185C13.3008 8.69923 11.1325 8.35547 8.93771 8.35547C3.56979 8.35547 0 11.1584 0 15.8388C0 23.1371 10.0483 21.9736 10.0483 25.1203C10.0483 26.3367 8.9906 26.7333 7.5098 26.7333C5.31503 26.7333 2.51208 25.8342 0.29087 24.6179V30.9113C2.75006 31.969 5.2357 32.4185 7.5098 32.4185C13.0099 32.4185 16.7913 29.6949 16.7913 24.9616C16.7648 17.0816 6.69007 18.4831 6.69007 15.5215L6.69006 15.5215Z"
          }
        )
      ]
    }
  );
}
function lH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 19 19",
      fill: "rgb(var(--text-tertiary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3608 9.44301L13.5162 10.0029C12.3305 10.3653 11.1118 10.53 9.89287 10.53C8.67418 10.53 7.45532 10.3653 6.26946 10.0029L4.39184 9.44301C4.35899 9.44301 4.29304 9.41016 4.26019 9.41016C3.79905 10.2665 3.56836 11.2218 3.56836 12.2758C3.56836 15.7344 6.36829 18.5342 9.82674 18.5342C13.2854 18.5342 16.0851 15.7342 16.0851 12.2758C16.0856 11.2547 15.8551 10.2665 15.3609 9.44305C15.394 9.44305 15.394 9.44305 15.3609 9.44305L15.3608 9.44301Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.23129 3.89036L4.06404 4.74671V7.31594C4.06404 7.84301 4.39352 8.30416 4.92039 8.46892L6.76492 9.02885C8.80706 9.62163 10.9811 9.62163 13.0233 9.02885L14.8678 8.46892C15.3618 8.30418 15.7242 7.84302 15.7242 7.31594V4.71389L17.404 4.2199V6.82195H17.3052C17.1735 6.82195 17.0745 6.92075 17.0745 7.05263V8.27131C17.0745 8.40296 17.1733 8.50199 17.3052 8.50199H17.3381L16.9429 9.25952C16.8769 9.42426 16.9757 9.589 17.1405 9.589H18.3263C18.491 9.589 18.6226 9.3914 18.5238 9.25952L18.1287 8.50199H18.1615C18.2932 8.50199 18.3922 8.40319 18.3922 8.27131V7.05263C18.3922 6.92097 18.2934 6.82195 18.1615 6.82195H18.0627V3.98921L18.3591 3.89041C18.8862 3.72567 18.8862 3.001 18.3591 2.83625L10.9814 0.629584C10.5862 0.530784 10.2238 0.464844 9.82841 0.464844C9.43321 0.464844 9.07087 0.530784 8.67544 0.629584L1.23124 2.83649C0.70417 3.00123 0.70417 3.7259 1.23124 3.89042L1.23129 3.89036Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function cH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "160",
      height: "163",
      viewBox: "0 0 160 163",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M159.973 72.3533C159.973 71.1226 159.81 69.8439 159.459 68.665C157.996 63.7386 153.761 60.8337 148.162 60.8337C134.739 60.8337 121.32 60.83 107.897 60.8337C106.91 62.1716 105.82 63.4466 104.63 64.6477C103.31 65.9819 101.902 67.1978 100.413 68.2806C111.445 68.2769 122.48 68.2695 133.512 68.2622C135.145 68.2622 136.394 68.7426 137.507 69.9474C142.097 74.9218 146.79 79.8002 151.31 84.8375C152.127 85.7466 152.715 87.2249 152.726 88.4445C152.829 101.047 152.777 113.649 152.8 126.252C152.803 127.756 152.279 128.942 151.251 130.021C146.646 134.841 142.056 139.671 137.514 144.549C136.283 145.869 134.905 146.43 133.105 146.427C115.406 146.39 97.7038 146.405 80.0013 146.405C62.2988 146.405 44.6998 146.39 27.049 146.43C25.1346 146.434 23.6859 145.846 22.3776 144.435C17.8836 139.582 13.3231 134.796 8.74778 130.021C7.66493 128.894 7.18819 127.66 7.19189 126.1C7.22145 113.605 7.22145 101.106 7.18819 88.6071C7.18449 86.9884 7.69819 85.7171 8.8143 84.5529C13.4229 79.7411 18.0056 74.8997 22.5476 70.025C23.697 68.7906 24.9757 68.2585 26.672 68.2622C37.6557 68.2695 48.6394 68.2769 59.6231 68.2806C58.167 67.2273 56.7885 66.0521 55.4913 64.7586C54.2532 63.5242 53.1223 62.2123 52.0986 60.8301H11.7672C11.3496 60.8301 10.932 60.819 10.518 60.8559C6.10534 61.2366 2.88267 63.3801 0.975676 67.3974C0.55806 68.2806 0.321528 69.2526 0 70.1839V144.568C0.332615 145.492 0.580233 146.453 1.00894 147.325C3.32246 152.011 7.23254 153.833 12.3289 153.829C57.4278 153.796 102.53 153.811 147.629 153.807C148.202 153.807 148.775 153.796 149.344 153.755C155.719 153.293 159.988 148.755 159.992 142.358C160.006 119.023 160.003 95.6881 159.973 72.3533Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M145.379 90.5547C145.371 89.7306 144.95 88.7364 144.396 88.1155C140.944 84.2868 137.377 80.5615 133.9 76.7512C133.105 75.8827 132.3 75.5057 131.091 75.5057C114.113 75.5501 97.1347 75.5353 80.1528 75.5353V75.576C63.0712 75.576 45.9896 75.5612 28.908 75.6166C28.0986 75.6203 27.0823 76.0601 26.5131 76.6403C22.762 80.4728 19.0847 84.3829 15.4481 88.3225C14.9751 88.8325 14.6166 89.6641 14.6129 90.3515C14.5612 101.653 14.5612 112.958 14.6129 124.263C14.6129 124.951 14.9492 125.797 15.4149 126.303C19.0552 130.243 22.7398 134.146 26.4872 137.986C27.0231 138.533 27.9692 138.98 28.7268 138.98C62.8938 139.028 97.0571 139.028 131.224 138.98C131.989 138.98 132.946 138.57 133.482 138.023C137.23 134.183 140.914 130.284 144.547 126.34C145.046 125.801 145.382 124.892 145.382 124.153C145.438 112.955 145.441 101.753 145.379 90.5547ZM85.0866 129.112C83.9668 129.559 83.5086 130.062 83.6564 131.234C83.734 131.843 83.6786 132.486 83.5825 133.096C83.2683 135.044 81.8048 136.289 79.9274 136.26C78.1165 136.234 76.3056 134.97 76.4497 133.159C76.6715 130.321 75.2375 129.312 73.0164 128.096C68.8513 125.819 66.8556 121.931 66.56 117.855C66.5193 114.806 67.9348 113.128 70.0561 113.043C72.0888 112.958 73.5634 114.418 73.8295 116.776C74.2027 120.043 76.0876 122.264 78.8704 122.708C81.694 123.162 84.2773 121.858 85.4821 119.374C87.4962 115.224 84.5988 110.756 79.6983 110.563C75.7328 110.404 72.4251 108.904 69.8307 105.929C63.8473 99.0586 66.2865 88.3188 74.6943 84.8337C76.1171 84.2424 76.3352 83.4996 76.3204 82.1987C76.3019 80.2843 77.3737 78.928 79.0294 78.4512C80.4485 78.041 82.1264 78.503 82.8618 79.826C83.3607 80.7315 83.5603 81.8698 83.6305 82.9231C83.6934 83.8248 83.9373 84.2424 84.8021 84.6046C90.1054 86.8073 92.9881 90.8319 93.4057 96.5492C93.5794 98.9255 92.1011 100.64 89.9946 100.781C87.9471 100.921 86.4319 99.4984 86.1251 97.1479C85.6004 93.1787 83.2794 90.9428 79.7796 91.0389C76.6678 91.1239 74.2138 93.4411 73.8775 96.6157C73.5708 99.4984 75.5591 102.355 78.4676 103.009C79.8794 103.327 81.3687 103.294 82.7842 103.59C88.5976 104.794 92.9068 109.699 93.3946 115.575C93.8825 121.392 90.5304 126.958 85.0866 129.112Z" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80 68C98.7777 68 114 52.7777 114 34C114 15.2223 98.7777 0 80 0C61.2223 0 46 15.2223 46 34C46 52.7777 61.2223 68 80 68ZM74.9312 54.3574V47.6427C74.9312 47.1231 75.0984 46.6734 75.4328 46.2937C75.7672 45.914 76.1632 45.7242 76.6208 45.7242H83.3791C83.8367 45.7242 84.2327 45.914 84.5671 46.2937C84.9015 46.6734 85.0687 47.1231 85.0687 47.6427V54.3574C85.0687 54.877 84.9015 55.3266 84.5671 55.7063C84.2327 56.086 83.8367 56.2759 83.3791 56.2759H76.6208C76.1632 56.2759 75.7672 56.086 75.4328 55.7063C75.0984 55.3266 74.9312 54.877 74.9312 54.3574ZM74.8784 39.0094L74.1392 15.9875C74.1216 15.4679 74.2756 15.0182 74.6012 14.6385C74.9268 14.2588 75.3184 14.069 75.776 14.069H84.2239C84.6815 14.069 85.0731 14.2588 85.3987 14.6385C85.7243 15.0182 85.8783 15.4679 85.8607 15.9875L85.1215 39.0094C85.1039 39.529 84.9235 39.9787 84.5803 40.3584C84.2371 40.7381 83.8367 40.9279 83.3791 40.9279H76.6208C76.1632 40.9279 75.7628 40.7381 75.4196 40.3584C75.0764 39.9787 74.896 39.529 74.8784 39.0094Z"
          }
        )
      ]
    }
  );
}
function uH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "35",
      height: "35",
      viewBox: "0 0 50 40",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32.8398 18.3711C32.8398 25.5586 27.0133 31.3847 19.8261 31.3847C12.6386 31.3847 6.8125 25.5583 6.8125 18.3711C6.8125 11.1839 12.6389 5.35742 19.8261 5.35742C27.0133 5.35742 32.8398 11.1839 32.8398 18.3711Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.86618 16.7521C5.03597 8.64575 11.6785 2.10082 19.8261 2.10082C27.9425 2.10082 34.5652 8.5952 34.7837 16.6595C34.7506 16.8242 34.7312 24.1857 34.7312 24.1857C34.7312 24.4961 34.7871 24.7923 34.8858 25.0626C33.3255 30.5284 28.7347 34.7225 23.0533 35.7069C22.5339 35.268 21.779 34.9901 20.9365 34.9901C19.3709 34.9901 18.1013 35.946 18.1013 37.1248C18.1013 38.3052 19.371 39.2607 20.9365 39.2607C22.2228 39.2607 23.3072 38.6162 23.6547 37.7326C29.7192 36.592 34.659 32.2346 36.6325 26.5058C36.6951 26.5125 36.7561 26.5168 36.8206 26.5168C37.9748 26.5168 38.9116 25.4741 38.9116 24.1856L38.9112 17.1727C38.9112 15.8846 37.9751 14.8409 36.8203 14.8409C36.7944 14.8409 36.7698 14.8442 36.7449 14.8448C35.6512 6.48194 28.4831 0 19.8263 0C11.1686 0 4.00087 6.48155 2.90758 14.8464C2.87934 14.8452 2.85139 14.8412 2.82192 14.8412C1.67288 14.8412 0.742188 15.8849 0.742188 17.1731V24.1859C0.742188 25.4744 1.67288 26.5171 2.82192 26.5171C3.97158 26.5171 4.90289 25.4744 4.90289 24.1859"
          }
        )
      ]
    }
  );
}
function dH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "512",
      height: "512",
      x: "0",
      y: "0",
      viewBox: "0 0 64 64",
      className: "",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ s.jsxs("g", { children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M44.987 46.887a21.208 21.208 0 0 0 2.669-9.456v-9.75a3.878 3.878 0 0 0-5.908-3.305 3.979 3.979 0 0 0-6.12-2.173 3.98 3.98 0 0 0-5.652-1.914v-7.965a4.183 4.183 0 0 0-8.365 0v14.009a8.414 8.414 0 0 0-4.94 5.277c-1.354 4.67 1.737 10.36 4.57 14.312a11.57 11.57 0 0 1 2.18 6.572h-1.417a1 1 0 0 0-1 1V59a1 1 0 0 0 1 1h23.237a1 1 0 0 0 1-1v-5.506c-.056-1.353-1.645-.94-2.526-1a11.511 11.511 0 0 1 1.272-5.607zM44.241 58H23.004v-3.506h21.237zm-18.813-5.506a13.568 13.568 0 0 0-2.562-7.738c-2.107-2.94-5.464-8.485-4.274-12.588a6.032 6.032 0 0 1 3.019-3.59v6.528a1 1 0 0 0 2 0V12.324a2.182 2.182 0 0 1 4.365 0v18.439a1 1 0 0 0 2 0V23.74a1.98 1.98 0 1 1 3.96 0v7.527a1 1 0 0 0 2 0v-5.81a1.98 1.98 0 1 1 3.961 0v6.112a1 1 0 0 0 2 0v-3.89a1.88 1.88 0 0 1 3.759 0v9.75c.067 6.076-4.235 9.383-3.94 15.064z",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M19.075 13.274a1 1 0 0 0 1-1v-.606c.238-7.491 11.099-7.488 11.336 0v.41a1 1 0 0 0 2 0v-.41c-.386-10.16-14.953-10.155-15.336 0v.606a1 1 0 0 0 1 1z",
            "data-original": "#000000"
          }
        )
      ] })
    }
  );
}
function CH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "Layer",
      height: "512",
      viewBox: "0 0 24 24",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          id: "test-tube-alt",
          d: "m21.53 9.47-7-7a.75.75 0 0 0 -1.06 1.06l.47.47-10.435 10.435a4.285 4.285 0 0 0 6.06 6.06l10.435-10.434.47.47a.75.75 0 1 0 1.06-1.061zm-6.59 3.53h-7.879l7.939-7.939 3.94 3.939z"
        }
      )
    }
  );
}
function pH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_3840_14182)", children: [
          /* @__PURE__ */ s.jsx("path", { d: "M3.125 10H16.875", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M11.25 4.375L16.875 10L11.25 15.625",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_3840_14182", children: /* @__PURE__ */ s.jsx("rect", { width: "20", height: "20", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function hH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("circle", { cx: "10.1884", cy: "10.1875", r: "10.04" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M10.1895 6.79727V10.1875L12.4496 11.3176M15.8398 10.1875C15.8398 13.3081 13.3101 15.8379 10.1895 15.8379C7.06883 15.8379 4.53906 13.3081 4.53906 10.1875C4.53906 7.06688 7.06883 4.53711 10.1895 4.53711C13.3101 4.53711 15.8398 7.06688 15.8398 10.1875Z",
            stroke: "rgb(var(--background-secondary))",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function fH(e) {
  return /* @__PURE__ */ s.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 64 64", ...e, children: /* @__PURE__ */ s.jsxs("g", { transform: "matrix(.937042 0 0 .937042 0 .046624)", fill: "#e31e26", children: [
    /* @__PURE__ */ s.jsx("path", { d: "M34.1 0C15.3 0 0 15.3 0 34.1s15.3 34.1 34.1 34.1C53 68.3 68.3 53 68.3 34.1S53 0 34.1 0zm0 59.3C20.3 59.3 9 48 9 34.1 9 20.3 20.3 9 34.1 9 48 9 59.3 20.3 59.3 34.1 59.3 48 48 59.3 34.1 59.3z" }),
    /* @__PURE__ */ s.jsx("circle", { cx: "42.6", cy: "25.6", r: "7.1" }),
    /* @__PURE__ */ s.jsx("circle", { cx: "42.6", cy: "42.6", r: "7.1" }),
    /* @__PURE__ */ s.jsx("circle", { cx: "25.6", cy: "42.6", r: "7.1" }),
    /* @__PURE__ */ s.jsx("circle", { cx: "25.6", cy: "25.6", r: "7.1" })
  ] }) });
}
function mH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      fill: "rgb(var(--fill-primary))",
      viewBox: "0 0 22 22",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z" })
    }
  );
}
function gH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "18",
      height: "16",
      viewBox: "0 0 18 16",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_18606_11175)", children: /* @__PURE__ */ s.jsx("path", { d: "M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.3375C8.925 15.0031 8 13.3594 8 11.5C8 8.675 10.1313 6.34688 12.8719 6.03438L13 4ZM18 11.5C18 9.01562 15.9844 7 13.5 7C11.0156 7 9 9.01562 9 11.5C9 13.9844 11.0156 16 13.5 16C15.9844 16 18 13.9844 18 11.5ZM13.5 9C13.775 9 14 9.225 14 9.5V11H15C15.275 11 15.5 11.225 15.5 11.5C15.5 11.775 15.275 12 15 12H13.5C13.225 12 13 11.775 13 11.5V9.5C13 9.225 13.225 9 13.5 9Z" }) }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_18606_11175", children: /* @__PURE__ */ s.jsx("rect", { width: "18", height: "16" }) }) })
      ]
    }
  );
}
function vH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 14 15",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--fill-primary))",
      fill: "rgb(var(--background-secondary))",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9242 1.00738H9.4459L9.17343 0.465349C9.0557 0.228979 8.8143 0.0796491 8.55024 0.0798391H5.23717C4.9736 0.0788291 4.73266 0.228569 4.61687 0.465349L4.3444 1.00738H0.866114C0.609984 1.00738 0.402344 1.21502 0.402344 1.47115V2.39869C0.402344 2.65482 0.609984 2.86246 0.866114 2.86246H12.9242C13.1803 2.86246 13.388 2.65482 13.388 2.39869V1.47115C13.388 1.21502 13.1803 1.00738 12.9242 1.00738H12.9242ZM1.94439 13.6162C1.9903 14.3493 2.59824 14.9204 3.33281 14.9205H10.4575C11.1919 14.9205 11.7999 14.3495 11.8459 13.6163L12.4604 3.79H1.32989L1.94439 13.6162Z"
        }
      )
    }
  );
}
function bH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M19.7227 4.75098C20.582 4.10645 21.3555 3.33301 21.957 2.43066C21.1836 2.77441 20.2812 3.03223 19.3789 3.11816C20.3242 2.55957 21.0117 1.7002 21.3555 0.625977C20.4961 1.1416 19.5078 1.52832 18.5195 1.74316C17.6602 0.84082 16.5 0.325195 15.2109 0.325195C12.7188 0.325195 10.6992 2.34473 10.6992 4.83691C10.6992 5.18066 10.7422 5.52441 10.8281 5.86816C7.08984 5.65332 3.73828 3.84863 1.50391 1.1416C1.11719 1.78613 0.902344 2.55957 0.902344 3.41895C0.902344 4.96582 1.67578 6.34082 2.92188 7.15723C2.19141 7.11426 1.46094 6.94238 0.859375 6.59863V6.6416C0.859375 8.83301 2.40625 10.6377 4.46875 11.0674C4.125 11.1533 3.69531 11.2393 3.30859 11.2393C3.00781 11.2393 2.75 11.1963 2.44922 11.1533C3.00781 12.958 4.68359 14.2471 6.66016 14.29C5.11328 15.4932 3.17969 16.2236 1.07422 16.2236C0.6875 16.2236 0.34375 16.1807 0 16.1377C1.97656 17.4268 4.33984 18.1572 6.91797 18.1572C15.2109 18.1572 19.7227 11.3252 19.7227 5.35254C19.7227 5.1377 19.7227 4.96582 19.7227 4.75098Z" })
    }
  );
}
function yH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "475.078px",
      height: "475.078px",
      viewBox: "0 0 475.078 475.078",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { children: /* @__PURE__ */ s.jsx(
          "path",
          {
            d: `M437.537,74.086c-25.029-25.031-55.151-37.544-90.365-37.544c-35.207,0-65.329,12.513-90.359,37.544
		c-25.031,25.028-37.544,55.15-37.544,90.362v54.821H27.408c-7.612,0-14.083,2.663-19.414,7.993C2.664,232.589,0,239.062,0,246.677
		v164.455c0,7.611,2.664,14.089,7.994,19.417c5.33,5.325,11.801,7.987,19.414,7.987h274.084c7.618,0,14.086-2.662,19.418-7.987
		c5.325-5.331,7.994-11.806,7.994-19.417V246.677c0-7.611-2.669-14.084-7.994-19.414c-5.332-5.33-11.8-7.993-19.418-7.993h-27.404
		v-54.821c0-20.175,7.132-37.402,21.409-51.675c14.277-14.275,31.505-21.411,51.675-21.411c20.177,0,37.404,7.135,51.682,21.411
		c14.27,14.272,21.408,31.5,21.408,51.675v73.089c0,4.95,1.808,9.235,5.428,12.848c3.614,3.614,7.898,5.421,12.847,5.421h18.274
		c4.949,0,9.227-1.807,12.848-5.421c3.613-3.613,5.42-7.898,5.42-12.848v-73.089C475.078,129.236,462.563,99.118,437.537,74.086z`
          }
        ) }),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {}),
        /* @__PURE__ */ s.jsx("g", {})
      ]
    }
  );
}
function xH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      width: "17px",
      height: "15px",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M109.7 160H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32v51.2L81.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L109.7 160z" })
    }
  );
}
function wH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      id: "图层_1",
      height: "24",
      viewBox: "0 0 44 44",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--text-secondary))",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "m33.73 19.88h-6.64a1.85 1.85 0 0 0 -1.6.92 9.05 9.05 0 0 1 -1.71 2.2.73.73 0 0 0 .48 1.27h9.47a1.1 1.1 0 0 0 1.1-1.1v-2.17a1.1 1.1 0 0 0 -1.1-1.12zm3.67-8.06h-14.35a.73.73 0 0 0 -.67.45.72.72 0 0 0 .16.8l2.62 2.61a1.82 1.82 0 0 0 1.3.54h10.94a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 0 -1.1-1.1zm-7.33 16.18h-9.57a.74.74 0 0 0 -.74.73v2.94a.74.74 0 0 0 .74.73h9.57a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 0 -1.1-1.1zm-8.86-7.78h-4.89v13.51a1.1 1.1 0 0 1 -1.1 1.1h-2.94a1.1 1.1 0 0 1 -1.1-1.1v-13.56h-4.89a1.48 1.48 0 0 1 -1-2.51l7-6.95a2.17 2.17 0 0 1 1.56-.65 2.2 2.2 0 0 1 1.56.65l7 7a1.47 1.47 0 0 1 -1.06 2.51z" })
    }
  );
}
function _H(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "18",
      viewBox: "0 0 20 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M6.6665 12.3333L9.99984 9M9.99984 9L13.3332 12.3333M9.99984 9V16.5M16.6665 12.9524C17.6844 12.1117 18.3332 10.8399 18.3332 9.41667C18.3332 6.88536 16.2811 4.83333 13.7498 4.83333C13.5677 4.83333 13.3974 4.73833 13.3049 4.58145C12.2182 2.73736 10.2119 1.5 7.9165 1.5C4.46472 1.5 1.6665 4.29822 1.6665 7.75C1.6665 9.47175 2.36271 11.0309 3.48896 12.1613",
          stroke: "rgb(var(--brand-primary))",
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function MH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M19 2.5C19 2.10218 18.842 1.72064 18.5607 1.43934C18.2794 1.15804 17.8978 1 17.5 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V17.5C1 17.8978 1.15804 18.2794 1.43934 18.5607C1.72064 18.842 2.10218 19 2.5 19H10V17H3.497C3.087 17 2.857 16.54 3.097 16.21L6.65 12.159C6.84 11.949 7.17 11.949 7.37 12.149L9 14L12.06 9.219C12.107 9.14987 12.1705 9.09363 12.2449 9.0554C12.3192 9.01717 12.4019 8.99818 12.4854 9.00017C12.569 9.00216 12.6507 9.02507 12.7231 9.06679C12.7956 9.10851 12.8564 9.16772 12.9 9.239L13.62 10.49C14.3714 10.1655 15.1815 9.99873 16 10H19V2.5ZM7.5 4.5C8.6 4.5 9.5 5.4 9.5 6.5C9.5 7.6 8.6 8.5 7.5 8.5C6.4 8.5 5.5 7.6 5.5 6.5C5.5 5.4 6.4 4.5 7.5 4.5ZM19.707 15.293C19.5195 15.1055 19.2652 15.0001 19 15H17V13C17 12.7348 16.8946 12.4804 16.7071 12.2929C16.5196 12.1054 16.2652 12 16 12C15.7348 12 15.4804 12.1054 15.2929 12.2929C15.1054 12.4804 15 12.7348 15 13V15H13C12.7348 15 12.4804 15.1054 12.2929 15.2929C12.1054 15.4804 12 15.7348 12 16C12 16.2652 12.1054 16.5196 12.2929 16.7071C12.4804 16.8946 12.7348 17 13 17H15V19C15 19.2652 15.1054 19.5196 15.2929 19.7071C15.4804 19.8946 15.7348 20 16 20C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V17H19C19.1978 17 19.391 16.9413 19.5555 16.8314C19.7199 16.7215 19.848 16.5654 19.9237 16.3827C19.9993 16.2 20.0192 15.9989 19.9806 15.805C19.942 15.611 19.8468 15.4329 19.707 15.293V15.293Z" })
    }
  );
}
function SH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "260",
      height: "230",
      viewBox: "0 0 260 230",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M119.197 229.75C182.289 229.75 233.434 178.375 233.434 115C233.434 51.6253 182.289 0.25 119.197 0.25C56.1053 0.25 4.95941 51.6253 4.95941 115C4.95941 178.375 56.1053 229.75 119.197 229.75Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M9.01956 47.7823C12.0377 46.797 13.6891 43.5405 12.7081 40.5089C11.7272 37.4772 8.48528 35.8184 5.46716 36.8037C2.44905 37.7891 0.797612 41.0455 1.77858 44.0772C2.75955 47.1088 6.00144 48.7677 9.01956 47.7823Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M21.5559 28.9495C23.6083 28.2794 24.7312 26.065 24.0642 24.0035C23.3971 21.942 21.1926 20.814 19.1403 21.484C17.088 22.1541 15.965 24.3685 16.6321 26.43C17.2991 28.4915 19.5036 29.6195 21.5559 28.9495Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M247.594 78.2378C251.155 74.969 251.404 69.4194 248.15 65.8424C244.895 62.2655 239.371 62.0156 235.81 65.2844C232.249 68.5532 232 74.1028 235.254 77.6798C238.508 81.2568 244.033 81.5066 247.594 78.2378Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M256.41 55.0753C257.909 53.6989 258.014 51.3623 256.644 49.8562C255.273 48.3501 252.947 48.2449 251.448 49.6212C249.948 50.9975 249.844 53.3342 251.214 54.8403C252.584 56.3464 254.91 56.4516 256.41 55.0753Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M219.633 179.65H18.7406V51.9704C18.7406 47.8144 21.9586 44.582 26.096 44.582H212.278C216.415 44.582 219.633 47.8144 219.633 51.9704V179.65Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M169.524 186.346H24.9457V51.9707H212.507V186.346H190.441",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M231.122 179.646V185.419C231.122 190.729 226.525 192.114 221.009 192.114H17.3581C11.8416 192.114 7.24457 190.96 7.24457 185.419V179.646H99.4161C100.106 181.724 102.404 183.341 104.933 183.341H133.434C135.963 183.341 138.032 181.724 138.951 179.646H231.122Z",
            fill: "rgb(var(--text-primary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M231.122 179.646C231.122 184.957 226.525 186.111 221.009 186.111H17.3581C11.8416 186.111 7.24457 184.957 7.24457 179.646H99.4161C100.106 181.724 102.404 183.341 104.933 183.341H133.434C135.963 183.341 138.032 181.724 138.951 179.646H231.122Z",
            fill: "#1F3C7A"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M32.0784 60.9751C33.3478 60.9751 34.3769 59.9414 34.3769 58.6663C34.3769 57.3911 33.3478 56.3574 32.0784 56.3574C30.8089 56.3574 29.7798 57.3911 29.7798 58.6663C29.7798 59.9414 30.8089 60.9751 32.0784 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M38.2834 60.9751C39.5529 60.9751 40.582 59.9414 40.582 58.6663C40.582 57.3911 39.5529 56.3574 38.2834 56.3574C37.014 56.3574 35.9849 57.3911 35.9849 58.6663C35.9849 59.9414 37.014 60.9751 38.2834 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M44.26 60.9751C45.5294 60.9751 46.5585 59.9414 46.5585 58.6663C46.5585 57.3911 45.5294 56.3574 44.26 56.3574C42.9905 56.3574 41.9614 57.3911 41.9614 58.6663C41.9614 59.9414 42.9905 60.9751 44.26 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M197.803 96.5316H137.581C136.432 96.5316 135.512 95.608 135.512 94.4536V72.9813C135.512 71.8269 136.432 70.9033 137.581 70.9033H197.803C198.952 70.9033 199.871 71.8269 199.871 72.9813V94.4536C200.101 95.608 199.182 96.5316 197.803 96.5316Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M200.101 127.471C200.101 128.626 199.182 129.549 198.032 129.549H137.581C136.432 129.549 135.512 128.626 135.512 127.471V105.999C135.512 104.844 136.432 103.921 137.581 103.921H197.803C198.952 103.921 199.871 104.844 199.871 105.999V127.471H200.101Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M187.916 80.3723H147.462C146.773 80.3723 146.313 79.9106 146.313 79.2179C146.313 78.5252 146.773 78.0635 147.462 78.0635H187.916C188.606 78.0635 189.066 78.5252 189.066 79.2179C188.836 79.9106 188.376 80.3723 187.916 80.3723Z",
            fill: "url(#paint0_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M173.665 88.9153H147.462C146.773 88.9153 146.313 88.4535 146.313 87.7609C146.313 87.0682 146.773 86.6064 147.462 86.6064H173.895C174.585 86.6064 175.045 87.0682 175.045 87.7609C174.815 88.2226 174.355 88.9153 173.665 88.9153Z",
            fill: "url(#paint1_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M187.916 113.39H147.462C146.773 113.39 146.313 112.928 146.313 112.235C146.313 111.543 146.773 111.081 147.462 111.081H187.916C188.606 111.081 189.066 111.543 189.066 112.235C188.836 112.928 188.376 113.39 187.916 113.39Z",
            fill: "url(#paint2_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M173.665 121.933H147.462C146.773 121.933 146.313 121.471 146.313 120.778C146.313 120.086 146.773 119.624 147.462 119.624H173.895C174.585 119.624 175.045 120.086 175.045 120.778C174.815 121.471 174.355 121.933 173.665 121.933Z",
            fill: "url(#paint3_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M200.103 160.72C200.103 161.875 199.184 162.798 198.034 162.798H137.583C136.433 162.798 135.514 161.875 135.514 160.72V139.248C135.514 138.094 136.433 137.17 137.583 137.17H197.804C198.954 137.17 199.873 138.094 199.873 139.248V160.72H200.103Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M187.916 146.865H147.462C146.773 146.865 146.313 146.403 146.313 145.71C146.313 145.017 146.773 144.556 147.462 144.556H187.916C188.606 144.556 189.066 145.017 189.066 145.71C188.836 146.403 188.376 146.865 187.916 146.865Z",
            fill: "url(#paint4_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M173.665 155.407H147.462C146.773 155.407 146.313 154.946 146.313 154.253C146.313 153.56 146.773 153.099 147.462 153.099H173.895C174.585 153.099 175.045 153.56 175.045 154.253C174.815 154.715 174.355 155.407 173.665 155.407Z",
            fill: "url(#paint5_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M118.744 134.631H37.6059C35.5372 134.631 33.9283 133.015 33.9283 130.937V74.8319C33.9283 72.7539 35.5372 71.1377 37.6059 71.1377H118.974C121.043 71.1377 122.652 72.7539 122.652 74.8319V130.937C122.422 133.015 120.813 134.631 118.744 134.631Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx("path", { d: "M79.8964 120.779H50.4751L65.1858 104.155L79.8964 120.779Z", fill: "#CED7E2" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M104.03 120.779H61.7368L82.8834 96.7666L104.03 120.779Z",
            fill: "rgb(var(--background-secondary))"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M61.5111 98.1518C64.5578 98.1518 67.0276 95.6709 67.0276 92.6106C67.0276 89.5502 64.5578 87.0693 61.5111 87.0693C58.4645 87.0693 55.9946 89.5502 55.9946 92.6106C55.9946 95.6709 58.4645 98.1518 61.5111 98.1518Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M121.031 156.794H35.5255C34.6061 156.794 33.9165 156.101 33.9165 155.178C33.9165 154.254 34.6061 153.562 35.5255 153.562H121.031C121.951 153.562 122.64 154.254 122.64 155.178C122.41 156.101 121.721 156.794 121.031 156.794Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M121.031 147.094H35.5255C34.6061 147.094 33.9165 146.401 33.9165 145.478C33.9165 144.554 34.6061 143.861 35.5255 143.861H121.031C121.951 143.861 122.64 144.554 122.64 145.478C122.41 146.401 121.721 147.094 121.031 147.094Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M64.2573 166.257H35.5255C34.6061 166.257 33.9165 165.564 33.9165 164.641C33.9165 163.717 34.6061 163.024 35.5255 163.024H64.2573C65.1767 163.024 65.8663 163.717 65.8663 164.641C65.6364 165.564 64.9468 166.257 64.2573 166.257Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M164.251 35.5773C161.952 35.5773 156.436 33.4993 154.597 32.8066C144.943 28.4198 129.083 15.4902 120.349 15.4902C111.614 15.4902 95.7543 28.1889 86.1004 32.8066C84.4915 33.4993 78.7451 35.5773 76.4466 35.5773C72.7689 35.8081 70.0106 39.0405 70.4704 42.5038C71.3898 51.0466 73.6883 66.285 79.6645 85.9102C87.4796 110.153 109.086 124.699 117.361 129.548C119.429 130.702 121.728 130.702 123.797 129.548C132.071 124.699 153.678 110.153 161.033 85.9102C167.009 66.285 169.308 51.0466 170.227 42.5038C170.687 39.0405 167.929 35.8081 164.251 35.5773Z",
            fill: "url(#paint6_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M161.265 44.1213C160.345 51.0479 158.506 62.8231 154.369 77.5997C153.909 79.4468 153.22 81.5248 152.53 83.3718C146.324 103.459 128.855 116.158 120.351 121.237C119.431 120.775 118.512 120.083 117.592 119.39C108.628 113.387 93.9173 101.381 88.4008 83.3718C83.1141 66.0555 80.8156 51.9714 79.6663 44.1213C83.8037 43.1978 88.8605 41.3507 89.7799 40.889C93.6874 39.0419 98.0547 36.5021 102.652 33.5006C107.709 30.2682 117.133 24.4961 120.351 24.4961C123.568 24.4961 132.992 30.4991 138.049 33.5006C142.646 36.2712 147.014 39.0419 150.921 40.889C152.07 41.1198 157.127 43.1978 161.265 44.1213Z",
            fill: "url(#paint7_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.531 61.7356V53.5884C129.531 49.6919 126.333 45.7954 122.78 45.087C119.938 44.7328 117.095 45.4412 115.319 47.5666C113.898 48.9835 112.832 51.1088 112.832 53.5884V62.0899C110.7 63.5068 108.568 65.6321 107.147 67.7575C105.726 69.8829 105.015 72.3624 105.015 75.1963C104.66 84.0519 111.766 91.4907 120.648 91.8449C129.886 92.1992 137.348 84.7604 137.348 75.9047C137.348 69.8829 134.15 64.5695 129.531 61.7356ZM123.136 77.3216V81.5724C123.136 82.2808 122.78 82.635 122.07 82.635H120.293C119.583 82.635 119.227 82.2808 119.227 81.5724V78.7385V76.9674C117.451 76.6132 116.74 74.842 117.095 73.0709C117.451 71.654 118.517 70.2371 120.293 69.8829C122.78 69.1744 125.267 71.2998 125.267 73.7794C124.912 75.1963 124.201 76.6132 123.136 77.3216ZM125.978 60.3187C124.557 59.9645 122.78 59.6103 121.004 59.6103C119.583 59.6103 117.806 59.9645 116.385 60.3187V53.9427C116.385 52.5257 117.095 51.4631 117.806 50.7546C118.872 49.6919 121.004 48.9835 123.136 49.6919C124.912 50.4004 125.978 52.1715 125.978 54.2969V60.3187Z",
            fill: "url(#paint8_linear_0_9)"
          }
        ),
        /* @__PURE__ */ s.jsxs("defs", { children: [
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_0_9",
              x1: "146.265",
              y1: "79.2798",
              x2: "188.926",
              y2: "79.2798",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_0_9",
              x1: "146.265",
              y1: "87.7073",
              x2: "174.889",
              y2: "87.7073",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint2_linear_0_9",
              x1: "146.265",
              y1: "112.335",
              x2: "188.926",
              y2: "112.335",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint3_linear_0_9",
              x1: "146.265",
              y1: "120.762",
              x2: "174.889",
              y2: "120.762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint4_linear_0_9",
              x1: "146.265",
              y1: "145.736",
              x2: "188.926",
              y2: "145.736",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint5_linear_0_9",
              x1: "146.265",
              y1: "154.164",
              x2: "174.889",
              y2: "154.164",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint6_linear_0_9",
              x1: "71.3802",
              y1: "72.1147",
              x2: "170.872",
              y2: "72.1147",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "#46BAFF" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "rgb(var(--brand-primary))" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint7_linear_0_9",
              x1: "80.4508",
              y1: "72.1619",
              x2: "161.751",
              y2: "72.1619",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { stopColor: "rgb(var(--brand-primary))" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "#46BAFF" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(
            "linearGradient",
            {
              id: "paint8_linear_0_9",
              x1: "137.004",
              y1: "85.7724",
              x2: "106.945",
              y2: "55.6217",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ s.jsx("stop", { offset: "0.0113208", stopColor: "#C2EDFF" }),
                /* @__PURE__ */ s.jsx("stop", { offset: "1", stopColor: "rgb(var(--background-secondary))" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function kH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      id: "Glyph",
      height: "512",
      viewBox: "0 0 32 32",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            id: "XMLID_436_",
            d: "m30 24v2.5c0 1.379-1.122 2.5-2.5 2.5h-21.5c-2.206 0-4-1.794-4-4 0 0 0-16.985 0-17 0-2.206 1.794-4 4-4h18.5c.829 0 1.5.672 1.5 1.5s-.671 1.5-1.5 1.5h-18.5c-.551 0-1 .448-1 1s.449 1 1 1h21.5c1.378 0 2.5 1.121 2.5 2.5v2.5h-5c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
          }
        ),
        /* @__PURE__ */ s.jsx("path", { id: "XMLID_438_", d: "m30 16v6h-5c-1.657 0-3-1.343-3-3s1.343-3 3-3z" })
      ]
    }
  );
}
function LH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "23",
      height: "20",
      viewBox: "0 0 23 20",
      fill: "rgb(var(--rgb-color-red))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.76619 3.01532C10.5352 1.67791 12.4648 1.67792 13.2338 3.01533L21.2768 17.0031C22.0434 18.3364 21.081 20 19.5429 20H3.45705C1.91902 20 0.956577 18.3364 1.72324 17.0031L9.76619 3.01532Z"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.7031 8.24512L12.471 14.5307H10.4353L10.2032 8.24512H12.7031ZM11.4531 17.5306C11.1079 17.5306 10.8125 17.4093 10.567 17.1668C10.3215 16.9242 10.2002 16.6289 10.2032 16.2807C10.2002 15.9414 10.3215 15.6512 10.567 15.4101C10.8125 15.1691 11.1079 15.0485 11.4531 15.0485C11.7805 15.0485 12.0699 15.1691 12.3214 15.4101C12.5729 15.6512 12.7001 15.9414 12.7031 16.2807C12.7001 16.6289 12.5729 16.9242 12.3214 17.1668C12.0699 17.4093 11.7805 17.5306 11.4531 17.5306Z",
            fill: "rgb(var(--background-secondary))"
          }
        )
      ]
    }
  );
}
function HH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "45",
      height: "38",
      viewBox: "0 0 45 38",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          stroke: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.8475 37.4094C30.4303 37.4094 30.0551 37.1763 29.8683 36.801L28.4211 33.8877H15.7716L14.3235 36.801C14.1367 37.1763 13.7612 37.4094 13.3434 37.4094C13.1745 37.4094 13.0058 37.3693 12.8556 37.2933C12.3162 37.0223 12.0966 36.3597 12.366 35.8164L15.075 30.3669H1.0935C0.49054 30.3669 0 29.8735 0 29.2671C0 28.6602 0.49054 28.1664 1.0935 28.1664H1.7496V2.2005H1.0935C0.49054 2.2005 0 1.70673 0 1.0998C0 0.49337 0.49054 0 1.0935 0H43.0983C43.7013 0 44.1918 0.49337 44.1918 1.0998C44.1918 1.70673 43.7013 2.2005 43.0983 2.2005H42.4422V28.1664H43.0983C43.7018 28.1664 44.1927 28.6602 44.1927 29.2671C44.1927 29.8735 43.7018 30.3669 43.0983 30.3669H29.1168L31.8249 35.8164C32.0951 36.3596 31.8759 37.0221 31.3362 37.2933C31.1843 37.3693 31.0153 37.4094 30.8475 37.4094ZM17.5212 30.3678V30.3678L16.8651 31.6881H27.3267L26.6697 30.3678L17.5212 30.3678L17.5212 30.3678ZM22.5441 6.759C18.4018 6.759 15.0318 10.1484 15.0318 14.3145C15.0318 18.4811 18.4018 21.8709 22.5441 21.8709C26.6859 21.8709 30.0555 18.4811 30.0555 14.3145C30.0555 10.1484 26.6859 6.759 22.5441 6.759ZM20.3662 18.216C19.9637 18.2159 19.6362 17.8873 19.6362 17.4834V11.1465C19.6362 10.7425 19.9636 10.4139 20.3661 10.4139C20.4866 10.4139 20.6079 10.446 20.7171 10.5066L26.0487 13.7664C26.2826 13.8982 26.4219 14.1383 26.4213 14.4089C26.4207 14.6781 26.2815 14.9163 26.0487 15.0462L20.7171 18.1233C20.6075 18.1848 20.4895 18.216 20.3662 18.216Z"
        }
      )
    }
  );
}
function PH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.83563 0.644531C3.99918 0.644531 0.890625 3.75308 0.890625 7.58953C0.890625 11.426 3.99918 14.5345 7.83563 14.5345C11.6721 14.5345 14.7806 11.426 14.7806 7.58953C14.7806 3.75308 11.6721 0.644531 7.83563 0.644531ZM9.59525 10.1038L7.83562 8.34413L6.076 10.1038C5.86899 10.3108 5.52841 10.3108 5.3214 10.1038C5.2179 10.0002 5.16447 9.86335 5.16447 9.72645C5.16447 9.58955 5.2179 9.45266 5.3214 9.34915L7.08103 7.58953L5.3214 5.82991C5.2179 5.7264 5.16447 5.5895 5.16447 5.45261C5.16447 5.31571 5.2179 5.17882 5.3214 5.07531C5.52841 4.86829 5.869 4.86829 6.076 5.07531L7.83562 6.83493L9.59525 5.07531C9.80225 4.86829 10.1428 4.86829 10.3498 5.07531C10.5569 5.28233 10.5569 5.6229 10.3498 5.82991L8.59023 7.58953L10.3498 9.34915C10.5569 9.55617 10.5569 9.89674 10.3498 10.1038C10.1428 10.3141 9.80227 10.3141 9.59525 10.1038Z",
          fill: "#F04438"
        }
      )
    }
  );
}
function Qh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 49 47",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      fill: "rgb(var(--fill-primary))",
      children: [
        /* @__PURE__ */ s.jsx("path", { d: "M26.5134 0.399902H13.6093L0.300049 23.4596L13.6093 46.5193L16.2422 41.9768L5.56587 23.4596L16.2422 4.97133H23.8805L26.5134 0.399902Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M17.4285 16.0526L20.0325 11.539L16.2423 4.97119L13.6094 9.48476L17.4285 16.0526Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M32.358 4.97119L34.9909 9.51369L16.2423 41.9766L13.6094 37.4341L32.358 4.97119Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M22.1155 46.5193L24.7195 41.9768H32.3578L43.0341 23.4596L32.3578 4.97133L34.9907 0.399902L48.2999 23.4596L34.9907 46.5193H22.1155Z" }),
        /* @__PURE__ */ s.jsx("path", { d: "M31.1139 30.7798L28.481 35.3223L32.358 41.9769L34.9909 37.4633L31.1139 30.7798Z" })
      ]
    }
  );
}
function TH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "146",
      height: "43",
      viewBox: "0 0 146 43",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M64.5063 13.8643L60.0798 20.2934L55.6268 13.8643H52.0961L58.2617 22.5067L51.7799 31.5707H55.3106L60.0798 24.7463L64.7962 31.5707H68.3269L61.8451 22.5067L68.0107 13.8643H64.5063Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M77.8916 16.183C79.1826 16.183 80.1839 16.6046 80.869 17.4214C81.5277 18.2118 81.8966 19.3712 81.9229 20.8467H73.3596C73.5176 19.4239 73.9919 18.2909 74.7297 17.4741C75.5202 16.6046 76.5741 16.183 77.8916 16.183ZM77.9179 13.5481C75.5465 13.5481 73.623 14.3913 72.2266 16.0776C70.8301 17.7376 70.1187 20.0299 70.1187 22.8492C70.1187 25.6685 70.8828 27.8818 72.3847 29.4628C73.8865 31.0437 75.9944 31.8605 78.603 31.8605C79.7887 31.8605 80.7899 31.7815 81.6331 31.597C82.4762 31.4126 83.3721 31.1228 84.2943 30.7275L84.4261 30.6748V27.8555L84.1099 27.9872C82.3182 28.7514 80.5001 29.1466 78.682 29.1466C76.9957 29.1466 75.6519 28.646 74.7297 27.6447C73.8338 26.6698 73.3332 25.247 73.2542 23.4026H85.1638V21.5318C85.1638 19.1604 84.5051 17.2106 83.214 15.7614C81.9229 14.2859 80.1312 13.5481 77.9179 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M97.5741 13.5481C96.3621 13.5481 95.2291 13.7852 94.2542 14.2595C93.3847 14.6811 92.6469 15.2608 92.1199 15.9985L91.7247 13.8379H89.1952V31.5443H92.2516V22.2696C92.2516 20.0826 92.6469 18.5017 93.4637 17.5795C94.2542 16.6573 95.5453 16.183 97.2579 16.183C98.549 16.183 99.4976 16.4992 100.104 17.1579C100.71 17.8166 100.999 18.8179 100.999 20.1616V31.5443H104.056V20.0563C104.056 17.7903 103.503 16.1303 102.422 15.0763C101.342 14.0751 99.7084 13.5481 97.5741 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.755 29.2256C114.253 29.2256 113.146 28.6986 112.382 27.6446C111.618 26.5643 111.223 24.9307 111.223 22.7965C111.223 20.6886 111.618 19.0286 112.408 17.8692C113.173 16.7362 114.279 16.1829 115.755 16.1829C117.467 16.1829 118.706 16.6835 119.47 17.6584C120.26 18.6597 120.656 20.3724 120.656 22.7438V23.2971C120.656 25.405 120.26 26.9332 119.496 27.8554C118.706 28.7776 117.467 29.2256 115.755 29.2256ZM120.603 13.8642L120.656 15.0763L120.735 15.8667C119.47 14.3121 117.678 13.5217 115.412 13.5217C113.094 13.5217 111.275 14.3385 109.984 15.9721C108.693 17.5794 108.035 19.8454 108.035 22.7438C108.035 25.6158 108.693 27.8818 109.958 29.4627C111.249 31.0436 113.094 31.8604 115.412 31.8604C117.757 31.8604 119.575 31.0436 120.814 29.41L121.13 31.5443H123.686V6.61829H120.629L120.603 13.8642Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M130.326 7.43518C129.825 7.43518 129.403 7.59327 129.061 7.90946C128.718 8.22564 128.56 8.72627 128.56 9.38499C128.56 10.0437 128.718 10.518 129.061 10.8605C129.403 11.2031 129.825 11.3612 130.326 11.3612C130.8 11.3612 131.222 11.2031 131.564 10.8605C131.907 10.518 132.091 10.0437 132.091 9.38499C132.091 8.72627 131.907 8.25199 131.564 7.90946C131.222 7.59327 130.8 7.43518 130.326 7.43518Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M128.771 31.5707H131.854V13.8643H128.771V31.5707Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M145.055 28.9621C144.818 29.0412 144.475 29.0939 144.053 29.1729C143.632 29.2256 143.21 29.2783 142.736 29.2783C141.946 29.2783 141.313 29.0412 140.865 28.5142C140.417 28.0136 140.18 27.2495 140.18 26.2746V16.3411H145.186V13.8643H140.18V9.85925H138.283L137.15 13.6008L134.647 14.7074V16.3411H137.124V26.38C137.124 30.0161 138.889 31.8869 142.367 31.8869C142.815 31.8869 143.316 31.8342 143.895 31.7551C144.475 31.6497 144.897 31.5443 145.213 31.3862L145.344 31.3335V28.8831L145.055 28.9621Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M24.172 0.400024H12.4204L0.299988 21.4L12.4204 42.4L14.8182 38.2633L5.09547 21.4L14.8182 4.56313H21.7743L24.172 0.400024Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M15.8985 14.6547L18.2699 10.5443L14.8182 4.56311L12.4204 8.67353L15.8985 14.6547Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M29.4945 4.56311L31.8922 8.69987L14.8182 38.2632L12.4204 34.1265L29.4945 4.56311Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M20.167 42.4L22.5384 38.2633H29.4945L39.2172 21.4L29.4945 4.56313L31.8922 0.400024L44.0127 21.4L31.8922 42.4H20.167Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M28.3615 28.0663L25.9637 32.2031L29.4945 38.2633L31.8922 34.1529L28.3615 28.0663Z",
            fill: "#D24D57"
          }
        )
      ]
    }
  );
}
function jH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      id: "body_1",
      width: "31",
      height: "22",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "1", children: /* @__PURE__ */ s.jsx("path", { clipRule: "evenodd", d: "M0 0L122.88 0L122.88 86.43L0 86.43z" }) }) }),
        /* @__PURE__ */ s.jsx("g", { transform: "matrix(0.25227866 0 0 0.25227866 -0 0.09777742)", children: /* @__PURE__ */ s.jsx("g", { clipPath: "url(#1)", children: /* @__PURE__ */ s.jsx(
          "path",
          {
            transform: "matrix(1 0 0 1 -12198 8410)",
            d: "M12259.441 -8323.52C 12258.131 -8323.531 12227.25 -8323.825 12217.662 -8324.741C 12217.186 -8324.831 12216.62 -8324.899 12215.962 -8324.979C 12212.776 -8325.363 12207.962 -8325.944 12204.088 -8330.001C 12202.1875 -8331.949 12200.969 -8335.173 12200.276 -8337.534C 12199.823 -8339.078 12199.47 -8340.649 12199.218 -8342.239C 12198.463 -8348.847 12198.057 -8355.489 12198 -8362.14L12198 -8362.14L12198 -8371.45C 12198.053 -8378.101 12198.46 -8384.743 12199.218 -8391.351C 12199.466 -8392.939 12199.819 -8394.51 12200.273 -8396.051C 12200.967 -8398.407 12202.197 -8401.62 12204.119 -8403.542C 12205.872 -8405.405 12208.049 -8406.818 12210.465 -8407.661C 12212.138 -8408.206 12213.872 -8408.544 12215.629 -8408.668L12215.629 -8408.668L12215.684 -8408.674C 12215.951 -8408.699 12216.205 -8408.725 12216.429 -8408.752C 12233.436 -8409.987 12259.17 -8410.002 12259.429 -8410.002C 12259.6875 -8410.002 12285.429 -8409.987 12302.419 -8408.752C 12302.625 -8408.728 12302.869 -8408.702 12303.21 -8408.669C 12304.969 -8408.544 12306.705 -8408.205 12308.382 -8407.66C 12310.799 -8406.818 12312.977 -8405.406 12314.731 -8403.542C 12316.642 -8401.62 12317.872 -8398.407 12318.567 -8396.051C 12319.023 -8394.51 12319.379 -8392.939 12319.631 -8391.351L12319.631 -8391.351L12319.621 -8391.363C 12320.384 -8384.756 12320.802 -8378.114 12320.871 -8371.463L12320.871 -8371.463L12320.871 -8362.104C 12320.816 -8355.453 12320.409 -8348.811 12319.652 -8342.203C 12319.399 -8340.616 12319.045 -8339.046 12318.591 -8337.503C 12317.896 -8335.145 12316.668 -8331.93 12314.761 -8330.009C 12313.005 -8328.1455 12310.826 -8326.732 12308.408 -8325.89C 12306.732 -8325.344 12304.996 -8325.006 12303.238 -8324.882C 12302.901 -8324.85 12302.649 -8324.823 12302.438 -8324.799C 12285.466 -8323.534 12259.7 -8323.52 12259.441 -8323.52zM12246.711 -8385.369L12246.711 -8350.839L12279.899 -8368.05L12246.711 -8385.369z",
            stroke: "none",
            fillRule: "nonzero"
          }
        ) }) })
      ]
    }
  );
}
function VH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx("path", { d: "M0 7.67967V18.6666C0.00996094 21.151 2.03906 23.1502 4.51348 23.1402H20.5277C20.983 23.1402 21.3492 22.774 21.3492 22.3287V11.3424C21.3393 8.85799 19.3107 6.85818 16.8357 6.86814H0.821484C0.366211 6.86814 0 7.23435 0 7.67967ZM22.3688 11.9658L28.9805 7.13533C29.5547 6.66072 30 6.77908 30 7.64041V22.3679C30 23.3482 29.4557 23.2293 28.9805 22.873L22.3688 18.0525V11.9658Z" })
    }
  );
}
function AH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "42",
      height: "42",
      viewBox: "0 0 40 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_204047_1251)", children: /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip1_204047_1251)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M34 0.716309H6C2.68629 0.716309 0 3.4026 0 6.71631V34.7163C0 38.03 2.68629 40.7163 6 40.7163H34C37.3137 40.7163 40 38.03 40 34.7163V6.71631C40 3.4026 37.3137 0.716309 34 0.716309Z",
              fill: "#2D8CFF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M33.4375 28.6069C34.0625 28.7632 34.6094 28.4507 34.9219 27.9819C35.0781 27.7476 35.0781 27.3569 35.0781 26.4976V14.7007C35.0781 13.8413 35.0781 13.5288 34.9219 13.2163C34.6875 12.5913 34.0625 12.3569 33.4375 12.5913C31.7969 13.6851 28.2031 16.8882 28.125 18.2163C28.0625 18.4507 28.0625 18.8413 28.0625 19.3882V22.3569C28.0625 22.9819 28.0625 23.2163 28.125 23.5288C28.2031 24.1538 28.4375 24.7007 28.75 25.0132C29.6875 25.7163 32.8125 28.5288 33.5156 28.5288L33.4375 28.6069ZM5 15.3257C5 14.1538 5 13.5288 5.23438 13.2163C5.39062 12.9038 5.85938 12.5913 6.09375 12.3569C6.40625 12.1226 6.95312 12.1226 8.20312 12.1226H18.2812C21.25 12.1226 22.7344 12.1226 23.9062 12.7476C24.7656 13.3726 25.7031 13.9194 26.25 15.0913C26.875 16.2632 26.875 17.7476 26.875 20.7163V26.0288C26.875 27.2007 26.875 27.8257 26.6406 28.1382C26.4844 28.4507 26.0156 28.7632 25.7812 28.9976C25.4688 29.2319 24.9219 29.2319 23.6719 29.2319H13.5938C10.625 29.2319 9.14062 29.2319 7.96875 28.6069C7.10938 27.9819 6.17188 27.4351 5.625 26.2632C5 25.0913 5 23.6069 5 20.6382V15.3257Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }) }),
        /* @__PURE__ */ s.jsxs("defs", { children: [
          /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_204047_1251", children: /* @__PURE__ */ s.jsx(
            "rect",
            {
              y: "0.716309",
              width: "40",
              height: "40",
              rx: "6",
              fill: "rgb(var(--background-secondary))"
            }
          ) }),
          /* @__PURE__ */ s.jsx("clipPath", { id: "clip1_204047_1251", children: /* @__PURE__ */ s.jsx(
            "rect",
            {
              width: "40",
              height: "40",
              fill: "rgb(var(--background-secondary))",
              transform: "translate(0 0.716309)"
            }
          ) })
        ] })
      ]
    }
  );
}
function EH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_324073_7693)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M9.9998 20C15.5229 20 20 15.5225 20 9.9998C20 4.47708 15.5229 0 9.9998 0C4.47668 0 0 4.47708 0 9.9998C0 15.5225 4.47708 20 9.9998 20Z",
              fill: "#2196F3"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M5.86768 12.858H12.4814V8.0083C12.4814 7.27765 11.8893 6.68555 11.1587 6.68555H4.54492V11.5353C4.54492 12.2659 5.13702 12.858 5.86768 12.858ZM13.3629 11.0947L16.0084 12.858V6.68555L13.3633 8.44922L13.3629 11.0947Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_324073_7693", children: /* @__PURE__ */ s.jsx("rect", { width: "20", height: "20", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
function IH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "15.238095238095237",
      height: "16",
      viewBox: "0 0 20 21",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.571349 20.5938C0.415649 20.6309 0.251629 20.5849 0.137909 20.4724C0.0239292 20.3598 -0.0238008 20.1967 0.0113392 20.0404L1.0385 15.4004L5.10503 19.4875L0.571349 20.5938ZM6.20639 18.3818L2.14017 14.2939L12.4363 3.94508L16.5051 8.03305L6.20639 18.3818ZM19.592 4.93402L17.5649 6.97089L13.4961 2.88292L15.2338 1.13669C15.5704 0.798368 16.0281 0.608398 16.5052 0.608398C16.9826 0.608398 17.4401 0.798368 17.7769 1.13669L19.592 2.95979C19.8532 3.22178 20 3.57693 20 3.94691C20 4.3172 19.8532 4.67202 19.592 4.93403V4.93402Z"
        }
      )
    }
  );
}
function DH(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsxs("g", { "clip-path": "url(#clip0_1013_2035)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
              fill: "#F6970A"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M5 7.5L9.08246 10.3577C9.41304 10.5891 9.57834 10.7048 9.75813 10.7497C9.91695 10.7892 10.0831 10.7892 10.2419 10.7497C10.4217 10.7048 10.587 10.5891 10.9175 10.3577L15 7.5M7.4 14H12.6C13.4401 14 13.8601 14 14.181 13.8365C14.4632 13.6927 14.6927 13.4632 14.8365 13.181C15 12.8601 15 12.4401 15 11.6V8.4C15 7.55992 15 7.13988 14.8365 6.81901C14.6927 6.53677 14.4632 6.3073 14.181 6.16349C13.8601 6 13.4401 6 12.6 6H7.4C6.55992 6 6.13988 6 5.81901 6.16349C5.53677 6.3073 5.3073 6.53677 5.16349 6.81901C5 7.13988 5 7.55992 5 8.4V11.6C5 12.4401 5 12.8601 5.16349 13.181C5.3073 13.4632 5.53677 13.6927 5.81901 13.8365C6.13988 14 6.55992 14 7.4 14Z",
              stroke: "white",
              "stroke-width": "1.3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_1013_2035", children: /* @__PURE__ */ s.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
const NH = (e) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    width: "12",
    height: "16",
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M6.00008 7.99992L3.15149 5.62609C2.72826 5.2734 2.51664 5.09705 2.36451 4.88088C2.22971 4.68934 2.12961 4.47561 2.06876 4.24944C2.00008 3.99418 2.00008 3.71871 2.00008 3.16779V1.33325M6.00008 7.99992L8.84867 5.62609C9.27191 5.2734 9.48352 5.09705 9.63566 4.88088C9.77045 4.68934 9.87056 4.47561 9.93141 4.24944C10.0001 3.99418 10.0001 3.71871 10.0001 3.16779V1.33325M6.00008 7.99992L3.15149 10.3737C2.72826 10.7264 2.51664 10.9028 2.36451 11.119C2.22971 11.3105 2.12961 11.5242 2.06876 11.7504C2.00008 12.0057 2.00008 12.2811 2.00008 12.8321V14.6666M6.00008 7.99992L8.84867 10.3737C9.27191 10.7264 9.48352 10.9028 9.63566 11.119C9.77045 11.3105 9.87056 11.5242 9.93141 11.7504C10.0001 12.0057 10.0001 12.2811 10.0001 12.8321V14.6666M0.666748 1.33325H11.3334M0.666748 14.6666H11.3334",
        stroke: "#F6970A",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    )
  }
), RH = (e) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M9.99992 0.833496C15.0625 0.833497 19.1666 4.93755 19.1666 10.0002C19.1666 15.0628 15.0625 19.1668 9.99992 19.1668C4.93731 19.1668 0.833252 15.0628 0.833252 10.0002C0.833252 4.93755 4.93731 0.833496 9.99992 0.833496ZM11.9172 14.0366C11.2725 14.1122 10.6329 14.154 10.017 14.1668C10.0056 14.1671 9.99422 14.1671 9.98283 14.1668C9.3667 14.154 8.72684 14.1122 8.08179 14.0366C8.12155 14.1689 8.16345 14.2997 8.20793 14.4289C8.61051 15.5977 9.19528 16.5845 9.99992 17.2845C10.8046 16.5845 11.3893 15.5977 11.7919 14.4289C11.8364 14.2998 11.8775 14.1688 11.9172 14.0366ZM2.86694 12.3203C3.60653 14.5956 5.40376 16.3924 7.67895 17.1323C7.23618 16.4655 6.89294 15.7304 6.63159 14.9717C6.4915 14.5649 6.37352 14.1475 6.27433 13.7249C5.85211 13.6258 5.43486 13.5085 5.0284 13.3685C4.26929 13.107 3.534 12.7634 2.86694 12.3203ZM17.1321 12.3203C16.4652 12.7632 15.7303 13.1071 14.9714 13.3685C14.5647 13.5086 14.1472 13.6258 13.7247 13.7249C13.6255 14.1474 13.5083 14.565 13.3682 14.9717C13.1068 15.7306 12.763 16.4654 12.3201 17.1323C14.5955 16.3926 16.3924 14.5958 17.1321 12.3203ZM9.99992 7.50016C9.24121 7.51663 8.46112 7.57776 7.69604 7.69629C7.57752 8.46137 7.51639 9.24146 7.49992 10.0002C7.51638 10.7586 7.5776 11.5384 7.69604 12.3032C8.46116 12.4218 9.24118 12.4829 9.99992 12.4993C10.7584 12.4829 11.5381 12.4217 12.303 12.3032C12.4214 11.5384 12.4826 10.7586 12.4991 10.0002C12.4826 9.24142 12.4215 8.4614 12.303 7.69629C11.5382 7.57784 10.7584 7.51663 9.99992 7.50016ZM5.96265 8.08203C5.83063 8.12172 5.70009 8.16378 5.57121 8.20817C4.4022 8.61082 3.41475 9.19531 2.71476 10.0002C3.41475 10.805 4.4022 11.3895 5.57121 11.7922C5.70002 11.8365 5.8307 11.8778 5.96265 11.9175C5.88712 11.2727 5.84608 10.6331 5.83325 10.0173C5.83302 10.0059 5.83302 9.99446 5.83325 9.98307C5.84609 9.36697 5.88706 8.72705 5.96265 8.08203ZM14.0364 8.08203C14.112 8.72708 14.1537 9.36694 14.1666 9.98307C14.1668 9.99446 14.1668 10.0059 14.1666 10.0173C14.1538 10.6331 14.1119 11.2727 14.0364 11.9175C14.1686 11.8777 14.2996 11.8366 14.4286 11.7922C15.5974 11.3896 16.5843 10.8048 17.2843 10.0002C16.5843 9.19552 15.5974 8.61076 14.4286 8.20817C14.2995 8.1637 14.1687 8.12179 14.0364 8.08203ZM7.67895 2.86719C5.40389 3.60695 3.60671 5.40414 2.86694 7.6792C3.5339 7.23624 4.26943 6.89326 5.0284 6.63184C5.43492 6.49183 5.85205 6.37372 6.27433 6.27458C6.37348 5.8523 6.49159 5.43516 6.63159 5.02865C6.89301 4.26967 7.23599 3.53415 7.67895 2.86719ZM12.3201 2.86719C12.7631 3.53425 13.1068 4.26953 13.3682 5.02865C13.5082 5.4351 13.6255 5.85236 13.7247 6.27458C14.1472 6.37376 14.5647 6.49175 14.9714 6.63184C15.7302 6.89318 16.4653 7.23642 17.1321 7.6792C16.3922 5.404 14.5954 3.60678 12.3201 2.86719ZM9.99992 2.71501C9.19507 3.415 8.61058 4.40245 8.20793 5.57145C8.16354 5.70033 8.12148 5.83087 8.08179 5.96289C8.72681 5.8873 9.36673 5.84633 9.98283 5.8335H10.017C10.6329 5.84633 11.2725 5.88737 11.9172 5.96289C11.8776 5.83095 11.8363 5.70026 11.7919 5.57145C11.3893 4.40245 10.8048 3.415 9.99992 2.71501Z",
        fill: "rgb(var(--text-primary))",
        "fill-opacity": "0.7"
      }
    )
  }
);
function FH(e) {
  return /* @__PURE__ */ s.jsx(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M20.25 11C20.25 5.89137 16.1086 1.75 11 1.75C5.89137 1.75 1.75 5.89137 1.75 11C1.75 16.1086 5.89137 20.25 11 20.25C16.1086 20.25 20.25 16.1086 20.25 11ZM13.4697 7.46973C13.7626 7.17683 14.2374 7.17683 14.5303 7.46973C14.8232 7.76262 14.8232 8.23738 14.5303 8.53027L12.0605 11L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11 12.0605L8.53027 14.5303C8.23738 14.8232 7.76262 14.8232 7.46973 14.5303C7.17683 14.2374 7.17683 13.7626 7.46973 13.4697L9.93945 11L7.46973 8.53027C7.17683 8.23738 7.17683 7.76262 7.46973 7.46973C7.76262 7.17683 8.23738 7.17683 8.53027 7.46973L11 9.93945L13.4697 7.46973ZM21.75 11C21.75 16.9371 16.9371 21.75 11 21.75C5.06294 21.75 0.25 16.9371 0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C16.9371 0.25 21.75 5.06294 21.75 11Z",
          fill: "rgb(var(--text-primary))"
        }
      )
    }
  );
}
function Xh(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2004_5212",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2004_5212)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M50.282 12.0475C49.8323 12.0475 49.4428 11.9905 49.1135 11.8765C48.7905 11.7562 48.5403 11.5662 48.363 11.3065C48.1857 11.0405 48.0843 10.6858 48.059 10.2425L47.888 6.414H49.2275L49.389 9.777C49.4017 10.0367 49.4428 10.2362 49.5125 10.3755C49.5885 10.5085 49.6962 10.6003 49.8355 10.651C49.9748 10.6953 50.1553 10.7175 50.377 10.7175C50.6177 10.7175 50.7887 10.7808 50.89 10.9075C50.9913 11.0278 51.042 11.1798 51.042 11.3635C51.042 11.5598 50.9755 11.7245 50.8425 11.8575C50.7158 11.9842 50.529 12.0475 50.282 12.0475ZM48.5435 11.164C48.1192 11.259 47.7107 11.3033 47.318 11.297C46.9253 11.2843 46.5738 11.2147 46.2635 11.088C45.9532 10.955 45.7062 10.765 45.5225 10.518C45.3452 10.271 45.2565 9.9575 45.2565 9.5775C45.2565 9.24183 45.3293 8.93783 45.475 8.6655C45.627 8.38683 45.836 8.143 46.102 7.934C46.3743 7.725 46.691 7.54767 47.052 7.402C47.413 7.25633 47.8057 7.1455 48.23 7.0695L48.363 8.4185C48.0907 8.43117 47.8437 8.46917 47.622 8.5325C47.4067 8.5895 47.2198 8.6655 47.0615 8.7605C46.9095 8.8555 46.7923 8.96317 46.71 9.0835C46.6277 9.1975 46.5865 9.321 46.5865 9.454C46.5865 9.56167 46.6245 9.65033 46.7005 9.72C46.7765 9.78967 46.8778 9.84667 47.0045 9.891C47.1312 9.929 47.2768 9.95117 47.4415 9.9575C47.6062 9.96383 47.774 9.95433 47.945 9.929C48.1223 9.90367 48.2965 9.8625 48.4675 9.8055L48.5435 11.164ZM48.572 5.4355C48.3883 5.4355 48.23 5.37217 48.097 5.2455C47.9703 5.1125 47.907 4.95733 47.907 4.78C47.907 4.59633 47.9703 4.438 48.097 4.305C48.23 4.172 48.3883 4.1055 48.572 4.1055C48.7493 4.1055 48.9013 4.172 49.028 4.305C49.1547 4.438 49.218 4.59633 49.218 4.78C49.218 4.95733 49.1547 5.1125 49.028 5.2455C48.9013 5.37217 48.7493 5.4355 48.572 5.4355ZM46.9285 5.426C46.7448 5.426 46.5865 5.36267 46.4535 5.236C46.3268 5.103 46.2635 4.94783 46.2635 4.7705C46.2635 4.58683 46.3268 4.4285 46.4535 4.2955C46.5865 4.1625 46.7448 4.096 46.9285 4.096C47.1058 4.096 47.2578 4.1625 47.3845 4.2955C47.5112 4.4285 47.5745 4.58683 47.5745 4.7705C47.5745 4.94783 47.5112 5.103 47.3845 5.236C47.2578 5.36267 47.1058 5.426 46.9285 5.426ZM57.5083 12.0475C57.1853 12.0475 56.875 12.019 56.5773 11.962C56.2796 11.8987 56.0105 11.8163 55.7698 11.715C55.5355 11.6137 55.3423 11.4997 55.1903 11.373L56.0453 10.4515C56.2733 10.5465 56.5076 10.6162 56.7483 10.6605C56.989 10.6985 57.274 10.7175 57.6033 10.7175C57.844 10.7175 58.015 10.7808 58.1163 10.9075C58.224 11.0278 58.2778 11.1798 58.2778 11.3635C58.2778 11.5598 58.2113 11.7245 58.0783 11.8575C57.9453 11.9842 57.7553 12.0475 57.5083 12.0475ZM50.2788 12.0475L50.3738 10.7175H52.5018C53.0971 10.7175 53.5911 10.6953 53.9838 10.651C54.3828 10.6067 54.6995 10.5433 54.9338 10.461C55.1681 10.3723 55.3328 10.271 55.4278 10.157C55.5291 10.043 55.5798 9.9195 55.5798 9.7865C55.5798 9.66617 55.5513 9.55217 55.4943 9.4445C55.4373 9.3305 55.3518 9.23867 55.2378 9.169C55.1238 9.09933 54.975 9.0645 54.7913 9.0645C54.557 9.0645 54.3226 9.1215 54.0883 9.2355C53.854 9.34317 53.626 9.492 53.4043 9.682C53.1826 9.86567 52.9705 10.0715 52.7678 10.2995C52.5715 10.5275 52.391 10.7587 52.2263 10.993L50.7918 10.7935C51.0578 10.3818 51.346 9.99233 51.6563 9.625C51.973 9.25133 52.3055 8.92517 52.6538 8.6465C53.0085 8.3615 53.3726 8.13983 53.7463 7.9815C54.1263 7.81683 54.5126 7.7345 54.9053 7.7345C55.3233 7.7345 55.6811 7.82 55.9788 7.991C56.2765 8.162 56.5045 8.39633 56.6628 8.694C56.8275 8.99167 56.9098 9.33683 56.9098 9.7295C56.9098 10.1412 56.7926 10.5117 56.5583 10.841C56.3303 11.1703 55.9408 11.4427 55.3898 11.658C55.1555 11.7467 54.9021 11.8195 54.6298 11.8765C54.3575 11.9335 54.0376 11.9747 53.6703 12C53.303 12.0317 52.8628 12.0475 52.3498 12.0475H50.2788ZM51.2668 11.0785L51.0673 5.046H52.3973L52.5683 9.606L51.2668 11.0785ZM57.5151 12.0475L57.6101 10.7175C57.8191 10.7175 57.9901 10.7017 58.1231 10.67C58.2561 10.632 58.3638 10.5528 58.4461 10.4325C58.5348 10.3058 58.6108 10.119 58.6741 9.872C58.7438 9.61867 58.8198 9.27667 58.9021 8.846L60.1371 9.074C60.1181 9.169 60.096 9.27983 60.0706 9.4065C60.0453 9.53317 60.0231 9.663 60.0041 9.796C59.9851 9.92267 59.9756 10.0367 59.9756 10.138C59.9756 10.3153 60.0326 10.4578 60.1466 10.5655C60.2606 10.6668 60.476 10.7175 60.7926 10.7175C60.951 10.7175 61.0871 10.7017 61.2011 10.67C61.3215 10.632 61.4228 10.5528 61.5051 10.4325C61.5938 10.3058 61.6698 10.1127 61.7331 9.853C61.8028 9.587 61.8693 9.22917 61.9326 8.7795L63.1866 8.979C63.1613 9.12467 63.136 9.27983 63.1106 9.4445C63.0853 9.60917 63.0631 9.76117 63.0441 9.9005C63.0251 10.0398 63.0156 10.1538 63.0156 10.2425C63.0156 10.3248 63.0378 10.404 63.0821 10.48C63.1328 10.5497 63.2215 10.6067 63.3481 10.651C63.4811 10.6953 63.668 10.7175 63.9086 10.7175C64.0796 10.7175 64.2253 10.6953 64.3456 10.651C64.4723 10.6067 64.5673 10.5338 64.6306 10.4325C64.7003 10.3312 64.7351 10.1982 64.7351 10.0335C64.7351 9.79917 64.6813 9.492 64.5736 9.112C64.466 8.732 64.3393 8.333 64.1936 7.915L65.5331 7.516C65.6345 7.78833 65.7231 8.07967 65.7991 8.39C65.8815 8.694 65.9448 8.99167 65.9891 9.283C66.0398 9.568 66.0651 9.81817 66.0651 10.0335C66.0651 10.3565 66.0145 10.6447 65.9131 10.898C65.8118 11.145 65.6693 11.354 65.4856 11.525C65.302 11.696 65.0835 11.8258 64.8301 11.9145C64.5768 12.0032 64.2981 12.0475 63.9941 12.0475C63.6268 12.0475 63.326 12.0127 63.0916 11.943C62.8573 11.867 62.6768 11.7435 62.5501 11.5725C62.4298 11.3952 62.3506 11.1545 62.3126 10.8505H62.6356C62.5026 11.2242 62.3538 11.4965 62.1891 11.6675C62.0245 11.8322 61.8281 11.9367 61.6001 11.981C61.3785 12.0253 61.0998 12.0475 60.7641 12.0475C60.5551 12.0475 60.3398 12.0253 60.1181 11.981C59.9028 11.9303 59.7096 11.8163 59.5386 11.639C59.3676 11.4617 59.241 11.1862 59.1586 10.8125L59.6716 10.7935C59.5386 11.1672 59.3645 11.4427 59.1491 11.62C58.9401 11.7973 58.6995 11.9145 58.4271 11.9715C58.1548 12.0222 57.8508 12.0475 57.5151 12.0475ZM67.302 12L67.1025 5.046H68.4325L68.632 12H67.302ZM69.6811 14.185L69.4056 12.855C69.8553 12.798 70.248 12.7283 70.5836 12.646C70.9193 12.57 71.2011 12.4623 71.4291 12.323C71.6571 12.1837 71.8281 11.9937 71.9421 11.753C72.0561 11.506 72.1131 11.1893 72.1131 10.803C72.1131 10.4293 72.0561 10.1317 71.9421 9.91C71.8281 9.68833 71.6761 9.5775 71.4861 9.5775C71.3531 9.5775 71.2423 9.625 71.1536 9.72C71.065 9.80867 70.9985 9.91633 70.9541 10.043C70.9161 10.1633 70.8971 10.271 70.8971 10.366C70.8971 10.423 70.913 10.4832 70.9446 10.5465C70.9763 10.6098 71.046 10.6637 71.1536 10.708C71.2613 10.7523 71.4291 10.7777 71.6571 10.784C71.8915 10.7903 72.2081 10.7682 72.6071 10.7175H74.2031C74.4438 10.7175 74.6148 10.7808 74.7161 10.9075C74.8238 11.0278 74.8776 11.1798 74.8776 11.3635C74.8776 11.5598 74.8111 11.7245 74.6781 11.8575C74.5451 11.9842 74.3551 12.0475 74.1081 12.0475H71.4956C71.0966 12.0475 70.7546 12 70.4696 11.905C70.1846 11.81 69.9661 11.658 69.8141 11.449C69.6621 11.2337 69.5861 10.9487 69.5861 10.594C69.5861 10.309 69.6336 10.024 69.7286 9.739C69.83 9.454 69.9693 9.19433 70.1466 8.96C70.324 8.71933 70.5298 8.52933 70.7641 8.39C71.0048 8.24433 71.2645 8.1715 71.5431 8.1715C71.9231 8.1715 72.2556 8.28867 72.5406 8.523C72.8256 8.75733 73.0473 9.06767 73.2056 9.454C73.3703 9.84033 73.4526 10.2615 73.4526 10.7175C73.4526 11.4332 73.3006 12.0412 72.9966 12.5415C72.6926 13.0418 72.2588 13.4282 71.6951 13.7005C71.1315 13.9792 70.4601 14.1407 69.6811 14.185ZM74.1216 12.0475L74.2166 10.7175C74.4952 10.7175 74.7137 10.6985 74.8721 10.6605C75.0367 10.6225 75.1539 10.5528 75.2236 10.4515C75.2932 10.3438 75.3281 10.1918 75.3281 9.9955C75.3281 9.81817 75.3027 9.606 75.2521 9.359C75.2077 9.112 75.1476 8.8555 75.0716 8.5895C74.9956 8.3235 74.9196 8.07967 74.8436 7.858L76.1546 7.497C76.2306 7.71233 76.3066 7.9625 76.3826 8.2475C76.4586 8.5325 76.5219 8.827 76.5726 9.131C76.6296 9.42867 76.6581 9.71683 76.6581 9.9955C76.6581 10.3438 76.6137 10.6383 76.5251 10.879C76.4364 11.1133 76.3129 11.3097 76.1546 11.468C76.0026 11.62 75.8189 11.7403 75.6036 11.829C75.3946 11.9113 75.1634 11.9683 74.9101 12C74.6567 12.0317 74.3939 12.0475 74.1216 12.0475ZM75.2901 14.2325C75.1064 14.2325 74.9481 14.1692 74.8151 14.0425C74.6884 13.9158 74.6251 13.7607 74.6251 13.577C74.6251 13.3933 74.6884 13.2318 74.8151 13.0925C74.9481 12.9595 75.1064 12.893 75.2901 12.893C75.4737 12.893 75.6289 12.9595 75.7556 13.0925C75.8886 13.2318 75.9551 13.3933 75.9551 13.577C75.9551 13.7607 75.8886 13.9158 75.7556 14.0425C75.6289 14.1692 75.4737 14.2325 75.2901 14.2325ZM79.5824 11.734C79.5824 11.5883 79.5951 11.4173 79.6204 11.221C79.6458 11.0247 79.6933 10.803 79.7629 10.556C79.8326 10.3027 79.9371 10.0208 80.0764 9.7105L81.2449 10.119C81.1753 10.3153 81.1151 10.4958 81.0644 10.6605C81.0138 10.8188 80.9758 10.9677 80.9504 11.107C80.9251 11.24 80.9124 11.373 80.9124 11.506C80.9124 11.791 80.9821 12.038 81.1214 12.247C81.2671 12.4623 81.4634 12.627 81.7104 12.741C81.9638 12.8613 82.2551 12.9215 82.5844 12.9215C83.1228 12.9215 83.5344 12.8328 83.8194 12.6555C84.1108 12.4845 84.3071 12.2122 84.4084 11.8385C84.5161 11.4585 84.5573 10.9677 84.5319 10.366L84.3419 5.046H85.6814L85.8239 9.5395C85.8366 9.85617 85.8809 10.1 85.9569 10.271C86.0329 10.442 86.1501 10.5592 86.3084 10.6225C86.4731 10.6858 86.6853 10.7175 86.9449 10.7175C87.1856 10.7175 87.3566 10.7808 87.4579 10.9075C87.5593 11.0278 87.6099 11.1798 87.6099 11.3635C87.6099 11.5598 87.5434 11.7245 87.4104 11.8575C87.2774 11.9842 87.0906 12.0475 86.8499 12.0475C86.7106 12.0475 86.5618 12.0285 86.4034 11.9905C86.2451 11.9525 86.0931 11.8923 85.9474 11.81C85.8018 11.7277 85.6751 11.62 85.5674 11.487C85.4598 11.3477 85.3869 11.1767 85.3489 10.974L85.8619 10.7175C85.8619 11.3572 85.7859 11.8987 85.6339 12.342C85.4883 12.7853 85.2729 13.1432 84.9879 13.4155C84.7093 13.6878 84.3641 13.8842 83.9524 14.0045C83.5471 14.1312 83.0784 14.1945 82.5464 14.1945C82.1411 14.1945 81.7579 14.1438 81.3969 14.0425C81.0423 13.9412 80.7288 13.7892 80.4564 13.5865C80.1841 13.3838 79.9688 13.1273 79.8104 12.817C79.6584 12.513 79.5824 12.152 79.5824 11.734ZM86.8501 12.0475L86.9451 10.7175C87.1034 10.7175 87.2238 10.6858 87.3061 10.6225C87.3884 10.5592 87.4708 10.4483 87.5531 10.29C87.6354 10.1317 87.7494 9.91633 87.8951 9.644C88.0534 9.34 88.2181 9.08667 88.3891 8.884C88.5601 8.675 88.7311 8.51033 88.9021 8.39C89.0794 8.26333 89.2536 8.17467 89.4246 8.124C89.6019 8.067 89.7761 8.0385 89.9471 8.0385C90.1814 8.0385 90.3999 8.08917 90.6026 8.1905C90.8116 8.2855 91.0111 8.45333 91.2011 8.694C91.3911 8.92833 91.5716 9.25133 91.7426 9.663C91.8629 9.948 91.9833 10.1665 92.1036 10.3185C92.2239 10.4705 92.3474 10.575 92.4741 10.632C92.6071 10.689 92.7401 10.7175 92.8731 10.7175C93.1138 10.7175 93.2848 10.7808 93.3861 10.9075C93.4874 11.0278 93.5381 11.1798 93.5381 11.3635C93.5381 11.5598 93.4716 11.7245 93.3386 11.8575C93.2056 11.9842 93.0188 12.0475 92.7781 12.0475C92.4678 12.0475 92.1859 11.9968 91.9326 11.8955C91.6793 11.7942 91.4798 11.6422 91.3341 11.4395L91.6096 11.2305C91.5526 11.3635 91.4671 11.5028 91.3531 11.6485C91.2454 11.7942 91.1029 11.9177 90.9256 12.019C90.7546 12.1203 90.5488 12.171 90.3081 12.171C90.1498 12.171 89.9629 12.1393 89.7476 12.076C89.5386 12.019 89.3201 11.9208 89.0921 11.7815C88.8704 11.6358 88.6646 11.4395 88.4746 11.1925C88.3543 11.4142 88.2213 11.5883 88.0756 11.715C87.9299 11.8353 87.7589 11.9208 87.5626 11.9715C87.3663 12.0222 87.1288 12.0475 86.8501 12.0475ZM89.0256 10.0715C89.0889 10.1665 89.1649 10.2615 89.2536 10.3565C89.3423 10.4515 89.4404 10.537 89.5481 10.613C89.6558 10.6827 89.7698 10.7397 89.8901 10.784C90.0168 10.8283 90.1403 10.8505 90.2606 10.8505C90.3873 10.8505 90.4918 10.803 90.5741 10.708C90.6564 10.6067 90.6596 10.4578 90.5836 10.2615C90.5519 10.1792 90.5076 10.0873 90.4506 9.986C90.3999 9.87833 90.3398 9.777 90.2701 9.682C90.2068 9.587 90.1339 9.50783 90.0516 9.4445C89.9756 9.38117 89.8964 9.3495 89.8141 9.3495C89.7318 9.3495 89.6463 9.37483 89.5576 9.4255C89.4689 9.47617 89.3803 9.55533 89.2916 9.663C89.2029 9.76433 89.1143 9.9005 89.0256 10.0715ZM92.7403 12.0475L92.8353 10.7175C93.2787 10.7175 93.6777 10.689 94.0323 10.632C94.387 10.5687 94.6973 10.4863 94.9633 10.385C95.2357 10.2837 95.4605 10.1665 95.6378 10.0335C95.8215 9.9005 95.9577 9.76117 96.0463 9.6155C96.1413 9.4635 96.1888 9.31467 96.1888 9.169C96.1888 9.08667 96.1667 9.01067 96.1223 8.941C96.0843 8.865 96.0178 8.80483 95.9228 8.7605C95.8278 8.70983 95.698 8.6845 95.5333 8.6845C95.451 8.6845 95.3528 8.694 95.2388 8.713C95.1248 8.732 95.0108 8.7605 94.8968 8.7985C94.7828 8.83017 94.6752 8.8745 94.5738 8.9315C94.7068 9.03283 94.8525 9.16267 95.0108 9.321C95.1692 9.473 95.3275 9.6345 95.4858 9.8055C95.6442 9.97017 95.7803 10.1317 95.8943 10.29C96.0273 10.347 96.173 10.404 96.3313 10.461C96.496 10.5117 96.6733 10.556 96.8633 10.594C97.0533 10.632 97.2528 10.6637 97.4618 10.689C97.6708 10.708 97.8862 10.7175 98.1078 10.7175C98.3485 10.7175 98.5195 10.7808 98.6208 10.9075C98.7285 11.0278 98.7823 11.1798 98.7823 11.3635C98.7823 11.5598 98.7158 11.7245 98.5828 11.8575C98.4498 11.9842 98.2598 12.0475 98.0128 12.0475C97.5062 12.0475 97.0565 12.0095 96.6638 11.9335C96.2712 11.8512 95.9197 11.734 95.6093 11.582C95.3053 11.4237 95.0203 11.2337 94.7543 11.012C94.6783 10.879 94.5707 10.7365 94.4313 10.5845C94.2983 10.4262 94.1558 10.2742 94.0038 10.1285C93.8582 9.98283 93.7252 9.8625 93.6048 9.7675C93.5732 9.74217 93.5352 9.67567 93.4908 9.568C93.4528 9.454 93.418 9.33683 93.3863 9.2165C93.3547 9.08983 93.3388 9.00117 93.3388 8.9505C93.3388 8.80483 93.4053 8.64967 93.5383 8.485C93.6777 8.32033 93.8613 8.16833 94.0893 8.029C94.3237 7.88333 94.5802 7.76617 94.8588 7.6775C95.1438 7.5825 95.432 7.535 95.7233 7.535C96.116 7.535 96.4422 7.59517 96.7018 7.7155C96.9678 7.8295 97.1673 7.991 97.3003 8.2C97.4333 8.40267 97.4998 8.64017 97.4998 8.9125C97.4998 9.2165 97.4333 9.5205 97.3003 9.8245C97.1673 10.1222 96.971 10.404 96.7113 10.67C96.458 10.936 96.1382 11.1735 95.7518 11.3825C95.3718 11.5852 94.9285 11.7467 94.4218 11.867C93.9215 11.9873 93.361 12.0475 92.7403 12.0475ZM98.02 12.0475L98.115 10.7175C98.495 10.7175 98.7864 10.6985 98.989 10.6605C99.1917 10.6225 99.331 10.5528 99.407 10.4515C99.4894 10.3438 99.5305 10.1918 99.5305 9.9955C99.5305 9.81817 99.5052 9.606 99.4545 9.359C99.4102 9.112 99.35 8.8555 99.274 8.5895C99.2044 8.3235 99.1284 8.07967 99.046 7.858L100.357 7.497C100.439 7.71233 100.519 7.9625 100.595 8.2475C100.671 8.5325 100.734 8.827 100.785 9.131C100.835 9.42867 100.861 9.71683 100.861 9.9955C100.861 10.4262 100.791 10.7777 100.652 11.05C100.512 11.316 100.316 11.5218 100.063 11.6675C99.8155 11.8132 99.5179 11.9145 99.1695 11.9715C98.8212 12.0222 98.438 12.0475 98.02 12.0475ZM100.367 14.2515C100.183 14.2515 100.025 14.185 99.8915 14.052C99.7649 13.9253 99.7015 13.7733 99.7015 13.596C99.7015 13.4123 99.7649 13.254 99.8915 13.121C100.025 12.988 100.183 12.9215 100.367 12.9215C100.544 12.9215 100.696 12.988 100.823 13.121C100.949 13.254 101.013 13.4123 101.013 13.596C101.013 13.7733 100.949 13.9253 100.823 14.052C100.696 14.185 100.544 14.2515 100.367 14.2515ZM98.723 14.2515C98.5394 14.2515 98.381 14.185 98.248 14.052C98.1214 13.9253 98.058 13.7733 98.058 13.596C98.058 13.4123 98.1214 13.254 98.248 13.121C98.381 12.988 98.5394 12.9215 98.723 12.9215C98.9004 12.9215 99.0524 12.988 99.179 13.121C99.3057 13.254 99.369 13.4123 99.369 13.596C99.369 13.7733 99.3057 13.9253 99.179 14.052C99.0524 14.185 98.9004 14.2515 98.723 14.2515Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ef(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2003_5139",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2003_5139)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.0629 12.0978C52.7322 12.0978 52.4376 12.0405 52.179 11.9258C51.9203 11.8088 51.7157 11.6368 51.565 11.4096C51.4165 11.1802 51.3423 10.8946 51.3423 10.5527C51.3423 10.2649 51.3952 10.0231 51.5009 9.82741C51.6066 9.63175 51.7505 9.47431 51.9327 9.35511C52.1149 9.23591 52.3218 9.14595 52.5534 9.08523C52.7873 9.0245 53.0325 8.98177 53.2889 8.95703C53.5903 8.92554 53.8332 8.89631 54.0176 8.86932C54.202 8.84008 54.3358 8.79735 54.419 8.74112C54.5022 8.6849 54.5439 8.60168 54.5439 8.49148V8.47124C54.5439 8.25758 54.4764 8.09227 54.3414 7.97532C54.2087 7.85837 54.0198 7.79989 53.7747 7.79989C53.516 7.79989 53.3103 7.85724 53.1573 7.97195C53.0044 8.0844 52.9032 8.22609 52.8537 8.39702L51.5245 8.28906C51.592 7.97419 51.7247 7.70206 51.9226 7.47266C52.1205 7.241 52.3758 7.06333 52.6884 6.93963C53.0033 6.81368 53.3676 6.75071 53.7814 6.75071C54.0693 6.75071 54.3448 6.78445 54.608 6.85192C54.8733 6.91939 55.1084 7.02397 55.313 7.16566C55.5199 7.30735 55.683 7.48952 55.8022 7.71218C55.9214 7.93259 55.981 8.19685 55.981 8.50497V12H54.6181V11.2814H54.5776C54.4944 11.4434 54.383 11.5862 54.2436 11.7099C54.1042 11.8313 53.9366 11.9269 53.7409 11.9966C53.5453 12.0641 53.3192 12.0978 53.0629 12.0978ZM53.4744 11.106C53.6858 11.106 53.8725 11.0644 54.0344 10.9812C54.1964 10.8957 54.3234 10.781 54.4157 10.6371C54.5079 10.4931 54.554 10.3301 54.554 10.1479V9.59801C54.509 9.62725 54.4471 9.65424 54.3684 9.67898C54.292 9.70147 54.2054 9.72283 54.1087 9.74308C54.012 9.76107 53.9152 9.77794 53.8185 9.79368C53.7218 9.80717 53.6341 9.81954 53.5554 9.83079C53.3867 9.85553 53.2394 9.89489 53.1135 9.94886C52.9875 10.0028 52.8897 10.0759 52.82 10.1681C52.7502 10.2581 52.7154 10.3706 52.7154 10.5055C52.7154 10.7012 52.7862 10.8507 52.9279 10.9542C53.0719 11.0554 53.254 11.106 53.4744 11.106ZM61.404 4.91548L61.8426 5.85334C61.6964 5.97479 61.5345 6.06475 61.3568 6.12322C61.1791 6.17945 60.9666 6.21656 60.7192 6.23455C60.474 6.25254 60.1749 6.26491 59.8218 6.27166C59.4215 6.27616 59.0954 6.34026 58.8435 6.46396C58.5916 6.58765 58.4004 6.7822 58.27 7.04759C58.1395 7.31072 58.0541 7.65483 58.0136 8.0799H58.0642C58.2194 7.76278 58.4375 7.51764 58.7187 7.34446C59.002 7.17128 59.3518 7.08469 59.7678 7.08469C60.2087 7.08469 60.5944 7.1814 60.925 7.37482C61.2578 7.56824 61.5165 7.846 61.7009 8.2081C61.8853 8.57019 61.9775 9.00426 61.9775 9.5103C61.9775 10.0366 61.8741 10.4943 61.6672 10.8833C61.4625 11.2702 61.1713 11.5704 60.7934 11.7841C60.4156 11.9955 59.9658 12.1012 59.444 12.1012C58.92 12.1012 58.4679 11.991 58.0878 11.7706C57.71 11.5502 57.4176 11.2252 57.2107 10.7956C57.006 10.3661 56.9037 9.83754 56.9037 9.21005V8.78498C56.9037 7.53675 57.1466 6.61127 57.6324 6.00852C58.1182 5.40578 58.8322 5.0999 59.7746 5.09091C60.031 5.08641 60.2626 5.08529 60.4695 5.08754C60.6765 5.08978 60.8575 5.07966 61.0127 5.05717C61.1701 5.03468 61.3006 4.98745 61.404 4.91548ZM59.4507 10.9879C59.6711 10.9879 59.8601 10.9306 60.0175 10.8159C60.1772 10.7012 60.2997 10.537 60.3852 10.3233C60.4729 10.1097 60.5168 9.8544 60.5168 9.55753C60.5168 9.2629 60.4729 9.01326 60.3852 8.80859C60.2997 8.60168 60.1772 8.44425 60.0175 8.33629C59.8578 8.22834 59.6666 8.17436 59.444 8.17436C59.2776 8.17436 59.128 8.20472 58.9953 8.26545C58.8626 8.32617 58.749 8.41613 58.6546 8.53533C58.5624 8.65228 58.4904 8.79735 58.4387 8.97053C58.3892 9.14145 58.3644 9.33712 58.3644 9.55753C58.3644 10.0006 58.46 10.3503 58.6512 10.6067C58.8446 10.8609 59.1111 10.9879 59.4507 10.9879ZM65.2727 12.1012C64.7487 12.1012 64.2955 11.9899 63.9131 11.7672C63.533 11.5423 63.2395 11.2297 63.0326 10.8294C62.8257 10.4268 62.7223 9.96011 62.7223 9.42933C62.7223 8.89406 62.8257 8.42625 63.0326 8.02592C63.2395 7.62334 63.533 7.31072 63.9131 7.08807C64.2955 6.86316 64.7487 6.75071 65.2727 6.75071C65.7967 6.75071 66.2488 6.86316 66.6289 7.08807C67.0112 7.31072 67.3058 7.62334 67.5127 8.02592C67.7197 8.42625 67.8231 8.89406 67.8231 9.42933C67.8231 9.96011 67.7197 10.4268 67.5127 10.8294C67.3058 11.2297 67.0112 11.5423 66.6289 11.7672C66.2488 11.9899 65.7967 12.1012 65.2727 12.1012ZM65.2794 10.9879C65.5178 10.9879 65.7169 10.9205 65.8766 10.7855C66.0362 10.6483 66.1566 10.4616 66.2375 10.2255C66.3207 9.98935 66.3623 9.72058 66.3623 9.41921C66.3623 9.11784 66.3207 8.84908 66.2375 8.61293C66.1566 8.37678 66.0362 8.1901 65.8766 8.05291C65.7169 7.91572 65.5178 7.84712 65.2794 7.84712C65.0388 7.84712 64.8364 7.91572 64.6722 8.05291C64.5103 8.1901 64.3877 8.37678 64.3045 8.61293C64.2235 8.84908 64.183 9.11784 64.183 9.41921C64.183 9.72058 64.2235 9.98935 64.3045 10.2255C64.3877 10.4616 64.5103 10.6483 64.6722 10.7855C64.8364 10.9205 65.0388 10.9879 65.2794 10.9879ZM68.2558 7.94833V6.81818H72.9518V7.94833H71.2819V12H69.9122V7.94833H68.2558ZM75.1151 12.0978C74.7845 12.0978 74.4899 12.0405 74.2312 11.9258C73.9726 11.8088 73.7679 11.6368 73.6172 11.4096C73.4688 11.1802 73.3946 10.8946 73.3946 10.5527C73.3946 10.2649 73.4474 10.0231 73.5531 9.82741C73.6588 9.63175 73.8028 9.47431 73.985 9.35511C74.1671 9.23591 74.374 9.14595 74.6057 9.08523C74.8396 9.0245 75.0847 8.98177 75.3411 8.95703C75.6425 8.92554 75.8854 8.89631 76.0698 8.86932C76.2542 8.84008 76.3881 8.79735 76.4713 8.74112C76.5545 8.6849 76.5961 8.60168 76.5961 8.49148V8.47124C76.5961 8.25758 76.5286 8.09227 76.3937 7.97532C76.261 7.85837 76.0721 7.79989 75.8269 7.79989C75.5683 7.79989 75.3625 7.85724 75.2096 7.97195C75.0566 8.0844 74.9554 8.22609 74.9059 8.39702L73.5767 8.28906C73.6442 7.97419 73.7769 7.70206 73.9748 7.47266C74.1727 7.241 74.428 7.06333 74.7406 6.93963C75.0555 6.81368 75.4198 6.75071 75.8337 6.75071C76.1216 6.75071 76.3971 6.78445 76.6602 6.85192C76.9256 6.91939 77.1606 7.02397 77.3653 7.16566C77.5722 7.30735 77.7352 7.48952 77.8544 7.71218C77.9736 7.93259 78.0332 8.19685 78.0332 8.50497V12H76.6703V11.2814H76.6298C76.5466 11.4434 76.4353 11.5862 76.2959 11.7099C76.1564 11.8313 75.9889 11.9269 75.7932 11.9966C75.5975 12.0641 75.3715 12.0978 75.1151 12.0978ZM75.5267 11.106C75.7381 11.106 75.9248 11.0644 76.0867 10.9812C76.2486 10.8957 76.3757 10.781 76.4679 10.6371C76.5601 10.4931 76.6062 10.3301 76.6062 10.1479V9.59801C76.5612 9.62725 76.4994 9.65424 76.4207 9.67898C76.3442 9.70147 76.2576 9.72283 76.1609 9.74308C76.0642 9.76107 75.9675 9.77794 75.8708 9.79368C75.7741 9.80717 75.6864 9.81954 75.6076 9.83079C75.439 9.85553 75.2917 9.89489 75.1657 9.94886C75.0398 10.0028 74.9419 10.0759 74.8722 10.1681C74.8025 10.2581 74.7676 10.3706 74.7676 10.5055C74.7676 10.7012 74.8385 10.8507 74.9802 10.9542C75.1241 11.0554 75.3063 11.106 75.5267 11.106ZM81.5097 12.1012C80.9767 12.1012 80.5179 11.9933 80.1333 11.7773C79.751 11.5592 79.4563 11.2511 79.2494 10.853C79.0425 10.4527 78.9391 9.97923 78.9391 9.43271C78.9391 8.89968 79.0425 8.43188 79.2494 8.0293C79.4563 7.62672 79.7476 7.31297 80.1232 7.08807C80.501 6.86316 80.9441 6.75071 81.4524 6.75071C81.7942 6.75071 82.1125 6.80581 82.4071 6.91602C82.704 7.02397 82.9626 7.18703 83.183 7.40518C83.4057 7.62334 83.5789 7.89773 83.7025 8.22834C83.8262 8.5567 83.8881 8.94129 83.8881 9.3821V9.77681H79.5126V8.88619H82.5353C82.5353 8.67927 82.4903 8.49598 82.4003 8.33629C82.3104 8.17661 82.1856 8.05179 82.0259 7.96183C81.8684 7.86961 81.6851 7.82351 81.476 7.82351C81.2578 7.82351 81.0644 7.87411 80.8957 7.97532C80.7293 8.07428 80.5989 8.2081 80.5044 8.37678C80.4099 8.54321 80.3616 8.72875 80.3593 8.93342V9.78018C80.3593 10.0366 80.4066 10.2581 80.501 10.4448C80.5977 10.6315 80.7338 10.7754 80.9092 10.8766C81.0847 10.9778 81.2927 11.0284 81.5333 11.0284C81.693 11.0284 81.8392 11.0059 81.9719 10.9609C82.1046 10.916 82.2182 10.8485 82.3126 10.7585C82.4071 10.6686 82.4791 10.5584 82.5285 10.4279L83.8577 10.5156C83.7903 10.835 83.6519 11.1139 83.4428 11.3523C83.2359 11.5884 82.9682 11.7728 82.6399 11.9055C82.3138 12.036 81.937 12.1012 81.5097 12.1012ZM84.4262 7.94833V6.81818H89.1222V7.94833H87.4523V12H86.0826V7.94833H84.4262ZM95.7985 8.83558V9.96573H93.0929V8.83558H95.7985ZM93.5652 6.81818V12H92.1922V6.81818H93.5652ZM96.6993 6.81818V12H95.3363V6.81818H96.6993ZM99.2919 12.0978C98.9612 12.0978 98.6666 12.0405 98.408 11.9258C98.1493 11.8088 97.9447 11.6368 97.794 11.4096C97.6456 11.1802 97.5713 10.8946 97.5713 10.5527C97.5713 10.2649 97.6242 10.0231 97.7299 9.82741C97.8356 9.63175 97.9795 9.47431 98.1617 9.35511C98.3439 9.23591 98.5508 9.14595 98.7824 9.08523C99.0164 9.0245 99.2615 8.98177 99.5179 8.95703C99.8193 8.92554 100.062 8.89631 100.247 8.86932C100.431 8.84008 100.565 8.79735 100.648 8.74112C100.731 8.6849 100.773 8.60168 100.773 8.49148V8.47124C100.773 8.25758 100.705 8.09227 100.57 7.97532C100.438 7.85837 100.249 7.79989 100.004 7.79989C99.745 7.79989 99.5393 7.85724 99.3863 7.97195C99.2334 8.0844 99.1322 8.22609 99.0827 8.39702L97.7535 8.28906C97.821 7.97419 97.9537 7.70206 98.1516 7.47266C98.3495 7.241 98.6048 7.06333 98.9174 6.93963C99.2323 6.81368 99.5966 6.75071 100.01 6.75071C100.298 6.75071 100.574 6.78445 100.837 6.85192C101.102 6.91939 101.337 7.02397 101.542 7.16566C101.749 7.30735 101.912 7.48952 102.031 7.71218C102.15 7.93259 102.21 8.19685 102.21 8.50497V12H100.847V11.2814H100.807C100.723 11.4434 100.612 11.5862 100.473 11.7099C100.333 11.8313 100.166 11.9269 99.9699 11.9966C99.7743 12.0641 99.5483 12.0978 99.2919 12.0978ZM99.7034 11.106C99.9148 11.106 100.102 11.0644 100.263 10.9812C100.425 10.8957 100.552 10.781 100.645 10.6371C100.737 10.4931 100.783 10.3301 100.783 10.1479V9.59801C100.738 9.62725 100.676 9.65424 100.597 9.67898C100.521 9.70147 100.434 9.72283 100.338 9.74308C100.241 9.76107 100.144 9.77794 100.048 9.79368C99.9508 9.80717 99.8631 9.81954 99.7844 9.83079C99.6157 9.85553 99.4684 9.89489 99.3425 9.94886C99.2165 10.0028 99.1187 10.0759 99.049 10.1681C98.9792 10.2581 98.9444 10.3706 98.9444 10.5055C98.9444 10.7012 99.0152 10.8507 99.1569 10.9542C99.3009 11.0554 99.483 11.106 99.7034 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function tf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2003_5115",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2003_5115)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M51.9496 8.54545C51.9496 9.29889 51.8068 9.93987 51.5211 10.4684C51.2377 10.9969 50.8509 11.4006 50.3606 11.6795C49.8726 11.9561 49.3238 12.0945 48.7143 12.0945C48.1003 12.0945 47.5493 11.955 47.0613 11.6761C46.5732 11.3973 46.1875 10.9935 45.9041 10.465C45.6207 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5732 5.69141 47.0613 5.41477C47.5493 5.13589 48.1003 4.99645 48.7143 4.99645C49.3238 4.99645 49.8726 5.13589 50.3606 5.41477C50.8509 5.69141 51.2377 6.09399 51.5211 6.62251C51.8068 7.15104 51.9496 7.79202 51.9496 8.54545ZM50.4686 8.54545C50.4686 8.05741 50.3955 7.64583 50.2493 7.31072C50.1054 6.97562 49.9018 6.72147 49.6387 6.5483C49.3755 6.37512 49.0674 6.28853 48.7143 6.28853C48.3612 6.28853 48.0531 6.37512 47.79 6.5483C47.5268 6.72147 47.3221 6.97562 47.176 7.31072C47.032 7.64583 46.96 8.05741 46.96 8.54545C46.96 9.0335 47.032 9.44508 47.176 9.78018C47.3221 10.1153 47.5268 10.3694 47.79 10.5426C48.0531 10.7158 48.3612 10.8024 48.7143 10.8024C49.0674 10.8024 49.3755 10.7158 49.6387 10.5426C49.9018 10.3694 50.1054 10.1153 50.2493 9.78018C50.3955 9.44508 50.4686 9.0335 50.4686 8.54545ZM54.4418 9.00426V12H53.0047V6.81818H54.3743V7.73242H54.4351C54.5498 7.43105 54.7421 7.19265 55.0119 7.01722C55.2818 6.83955 55.6091 6.75071 55.9937 6.75071C56.3535 6.75071 56.6672 6.82943 56.9349 6.98686C57.2025 7.14429 57.4106 7.3692 57.559 7.66158C57.7074 7.9517 57.7816 8.29806 57.7816 8.70064V12H56.3445V8.95703C56.3468 8.63991 56.2658 8.39252 56.1016 8.21484C55.9374 8.03492 55.7114 7.94496 55.4235 7.94496C55.2301 7.94496 55.0592 7.98656 54.9107 8.06978C54.7645 8.15299 54.6498 8.27444 54.5666 8.43413C54.4857 8.59156 54.4441 8.78161 54.4418 9.00426ZM60.8238 12.0843C60.4302 12.0843 60.0737 11.9831 59.7544 11.7807C59.4372 11.5761 59.1853 11.2758 58.9987 10.88C58.8142 10.4819 58.722 9.99384 58.722 9.41584C58.722 8.82209 58.8176 8.32842 59.0088 7.93484C59.2 7.539 59.4541 7.24325 59.7712 7.04759C60.0906 6.84967 60.4403 6.75071 60.8204 6.75071C61.1105 6.75071 61.3523 6.80019 61.5457 6.89915C61.7414 6.99586 61.8988 7.11731 62.018 7.26349C62.1395 7.40743 62.2317 7.54912 62.2947 7.68857H62.3385V5.09091H63.7723V12H62.3554V11.1701H62.2947C62.2272 11.314 62.1316 11.4569 62.0079 11.5985C61.8865 11.738 61.7279 11.8538 61.5322 11.946C61.3388 12.0382 61.1027 12.0843 60.8238 12.0843ZM61.2792 10.9407C61.5109 10.9407 61.7065 10.8777 61.8662 10.7518C62.0281 10.6236 62.1518 10.4448 62.2373 10.2154C62.325 9.98597 62.3689 9.71721 62.3689 9.40909C62.3689 9.10097 62.3261 8.83333 62.2407 8.60618C62.1552 8.37902 62.0315 8.2036 61.8696 8.0799C61.7077 7.9562 61.5109 7.89435 61.2792 7.89435C61.0431 7.89435 60.844 7.95845 60.6821 8.08665C60.5202 8.21484 60.3976 8.39252 60.3144 8.61967C60.2311 8.84683 60.1895 9.10997 60.1895 9.40909C60.1895 9.71046 60.2311 9.97698 60.3144 10.2086C60.3998 10.438 60.5224 10.618 60.6821 10.7484C60.844 10.8766 61.0431 10.9407 61.2792 10.9407ZM67.3154 12.1012C66.7824 12.1012 66.3236 11.9933 65.939 11.7773C65.5566 11.5592 65.262 11.2511 65.0551 10.853C64.8482 10.4527 64.7447 9.97923 64.7447 9.43271C64.7447 8.89968 64.8482 8.43188 65.0551 8.0293C65.262 7.62672 65.5533 7.31297 65.9288 7.08807C66.3067 6.86316 66.7497 6.75071 67.258 6.75071C67.5999 6.75071 67.9181 6.80581 68.2128 6.91602C68.5096 7.02397 68.7683 7.18703 68.9887 7.40518C69.2113 7.62334 69.3845 7.89773 69.5082 8.22834C69.6319 8.5567 69.6938 8.94129 69.6938 9.3821V9.77681H65.3182V8.88619H68.341C68.341 8.67927 68.296 8.49598 68.206 8.33629C68.116 8.17661 67.9912 8.05179 67.8315 7.96183C67.6741 7.86961 67.4908 7.82351 67.2816 7.82351C67.0635 7.82351 66.8701 7.87411 66.7014 7.97532C66.535 8.07428 66.4045 8.2081 66.3101 8.37678C66.2156 8.54321 66.1672 8.72875 66.165 8.93342V9.78018C66.165 10.0366 66.2122 10.2581 66.3067 10.4448C66.4034 10.6315 66.5395 10.7754 66.7149 10.8766C66.8903 10.9778 67.0984 11.0284 67.339 11.0284C67.4987 11.0284 67.6449 11.0059 67.7776 10.9609C67.9103 10.916 68.0238 10.8485 68.1183 10.7585C68.2128 10.6686 68.2847 10.5584 68.3342 10.4279L69.6634 10.5156C69.5959 10.835 69.4576 11.1139 69.2484 11.3523C69.0415 11.5884 68.7739 11.7728 68.4455 11.9055C68.1194 12.036 67.7427 12.1012 67.3154 12.1012ZM70.6316 12V6.81818H72.0249V7.7223H72.0789C72.1733 7.40069 72.3319 7.15779 72.5546 6.99361C72.7772 6.82718 73.0336 6.74396 73.3237 6.74396C73.3957 6.74396 73.4733 6.74846 73.5565 6.75746C73.6397 6.76645 73.7128 6.77882 73.7758 6.79457V8.06978C73.7083 8.04954 73.615 8.03155 73.4958 8.0158C73.3766 8.00006 73.2675 7.99219 73.1685 7.99219C72.9571 7.99219 72.7682 8.03829 72.6018 8.1305C72.4376 8.22047 72.3072 8.34641 72.2104 8.50835C72.116 8.67028 72.0688 8.85695 72.0688 9.06836V12H70.6316ZM78.8303 8.29581L77.5146 8.37678C77.4921 8.26432 77.4437 8.16312 77.3695 8.07315C77.2953 7.98094 77.1974 7.90785 77.076 7.85387C76.9568 7.79764 76.814 7.76953 76.6475 7.76953C76.4249 7.76953 76.2371 7.81676 76.0842 7.91122C75.9312 8.00343 75.8548 8.12713 75.8548 8.28232C75.8548 8.40601 75.9042 8.51059 76.0032 8.59606C76.1022 8.68152 76.272 8.75012 76.5126 8.80185L77.4505 8.99077C77.9542 9.09422 78.3298 9.26065 78.5772 9.49006C78.8246 9.71946 78.9483 10.0208 78.9483 10.3942C78.9483 10.7338 78.8482 11.0318 78.6481 11.2882C78.4502 11.5446 78.178 11.7447 77.8317 11.8887C77.4876 12.0304 77.0906 12.1012 76.6408 12.1012C75.9548 12.1012 75.4083 11.9584 75.0012 11.6728C74.5964 11.3849 74.3591 10.9935 74.2894 10.4988L75.7029 10.4245C75.7457 10.6337 75.8491 10.7934 76.0133 10.9036C76.1775 11.0115 76.3878 11.0655 76.6442 11.0655C76.8961 11.0655 77.0985 11.0172 77.2514 10.9205C77.4066 10.8215 77.4853 10.6944 77.4876 10.5392C77.4853 10.4088 77.4302 10.302 77.3223 10.2188C77.2143 10.1333 77.0479 10.0681 76.823 10.0231L75.9256 9.84428C75.4196 9.74308 75.0429 9.56765 74.7955 9.318C74.5503 9.06836 74.4277 8.75012 74.4277 8.36328C74.4277 8.03042 74.5177 7.74367 74.6976 7.50302C74.8798 7.26237 75.1351 7.07682 75.4634 6.94638C75.794 6.81593 76.1809 6.75071 76.6239 6.75071C77.2784 6.75071 77.7934 6.88903 78.169 7.16566C78.5469 7.44229 78.7673 7.81901 78.8303 8.29581ZM82.6095 6.81818V7.89773H79.4889V6.81818H82.6095ZM80.1974 5.5767H81.6345V10.4077C81.6345 10.5404 81.6548 10.6438 81.6953 10.718C81.7358 10.79 81.792 10.8406 81.8639 10.8699C81.9382 10.8991 82.0236 10.9137 82.1203 10.9137C82.1878 10.9137 82.2553 10.9081 82.3228 10.8968C82.3902 10.8833 82.442 10.8732 82.4779 10.8665L82.704 11.9359C82.632 11.9584 82.5308 11.9843 82.4003 12.0135C82.2699 12.045 82.1113 12.0641 81.9247 12.0708C81.5783 12.0843 81.2747 12.0382 81.0138 11.9325C80.7552 11.8268 80.5539 11.6626 80.4099 11.44C80.266 11.2173 80.1951 10.9362 80.1974 10.5966V5.5767ZM85.8515 12.1012C85.3185 12.1012 84.8597 11.9933 84.4751 11.7773C84.0928 11.5592 83.7981 11.2511 83.5912 10.853C83.3843 10.4527 83.2809 9.97923 83.2809 9.43271C83.2809 8.89968 83.3843 8.43188 83.5912 8.0293C83.7981 7.62672 84.0894 7.31297 84.465 7.08807C84.8428 6.86316 85.2859 6.75071 85.7942 6.75071C86.136 6.75071 86.4543 6.80581 86.7489 6.91602C87.0458 7.02397 87.3044 7.18703 87.5248 7.40518C87.7475 7.62334 87.9206 7.89773 88.0443 8.22834C88.168 8.5567 88.2299 8.94129 88.2299 9.3821V9.77681H83.8544V8.88619H86.8771C86.8771 8.67927 86.8321 8.49598 86.7421 8.33629C86.6522 8.17661 86.5274 8.05179 86.3677 7.96183C86.2102 7.86961 86.0269 7.82351 85.8178 7.82351C85.5996 7.82351 85.4062 7.87411 85.2375 7.97532C85.0711 8.07428 84.9407 8.2081 84.8462 8.37678C84.7517 8.54321 84.7034 8.72875 84.7011 8.93342V9.78018C84.7011 10.0366 84.7484 10.2581 84.8428 10.4448C84.9395 10.6315 85.0756 10.7754 85.251 10.8766C85.4264 10.9778 85.6345 11.0284 85.8751 11.0284C86.0348 11.0284 86.181 11.0059 86.3137 10.9609C86.4464 10.916 86.56 10.8485 86.6544 10.7585C86.7489 10.6686 86.8209 10.5584 86.8703 10.4279L88.1995 10.5156C88.1321 10.835 87.9937 11.1139 87.7846 11.3523C87.5777 11.5884 87.31 11.7728 86.9817 11.9055C86.6556 12.036 86.2788 12.1012 85.8515 12.1012ZM92.4907 9.79368V6.81818H93.9279V12H92.5481V11.0588H92.4941C92.3771 11.3624 92.1826 11.6064 91.9105 11.7908C91.6406 11.9753 91.3111 12.0675 90.922 12.0675C90.5757 12.0675 90.2709 11.9888 90.0078 11.8313C89.7446 11.6739 89.5388 11.4501 89.3904 11.16C89.2442 10.8699 89.17 10.5224 89.1677 10.1175V6.81818H90.6049V9.86115C90.6071 10.167 90.6892 10.4088 90.8512 10.5865C91.0131 10.7641 91.2301 10.853 91.5023 10.853C91.6754 10.853 91.8374 10.8136 91.9881 10.7349C92.1387 10.6539 92.2602 10.5347 92.3524 10.3773C92.4469 10.2199 92.493 10.0253 92.4907 9.79368ZM96.5146 9.00426V12H95.0774V6.81818H96.4471V7.73242H96.5078C96.6225 7.43105 96.8148 7.19265 97.0847 7.01722C97.3546 6.83955 97.6818 6.75071 98.0664 6.75071C98.4263 6.75071 98.74 6.82943 99.0076 6.98686C99.2753 7.14429 99.4833 7.3692 99.6317 7.66158C99.7802 7.9517 99.8544 8.29806 99.8544 8.70064V12H98.4173V8.95703C98.4195 8.63991 98.3385 8.39252 98.1744 8.21484C98.0102 8.03492 97.7842 7.94496 97.4963 7.94496C97.3029 7.94496 97.1319 7.98656 96.9835 8.06978C96.8373 8.15299 96.7226 8.27444 96.6394 8.43413C96.5584 8.59156 96.5168 8.78161 96.5146 9.00426ZM102.897 12.0843C102.503 12.0843 102.146 11.9831 101.827 11.7807C101.51 11.5761 101.258 11.2758 101.071 10.88C100.887 10.4819 100.795 9.99384 100.795 9.41584C100.795 8.82209 100.89 8.32842 101.082 7.93484C101.273 7.539 101.527 7.24325 101.844 7.04759C102.163 6.84967 102.513 6.75071 102.893 6.75071C103.183 6.75071 103.425 6.80019 103.618 6.89915C103.814 6.99586 103.972 7.11731 104.091 7.26349C104.212 7.40743 104.304 7.54912 104.367 7.68857H104.411V5.09091H105.845V12H104.428V11.1701H104.367C104.3 11.314 104.204 11.4569 104.081 11.5985C103.959 11.738 103.801 11.8538 103.605 11.946C103.412 12.0382 103.175 12.0843 102.897 12.0843ZM103.352 10.9407C103.584 10.9407 103.779 10.8777 103.939 10.7518C104.101 10.6236 104.225 10.4448 104.31 10.2154C104.398 9.98597 104.442 9.71721 104.442 9.40909C104.442 9.10097 104.399 8.83333 104.313 8.60618C104.228 8.37902 104.104 8.2036 103.942 8.0799C103.78 7.9562 103.584 7.89435 103.352 7.89435C103.116 7.89435 102.917 7.95845 102.755 8.08665C102.593 8.21484 102.47 8.39252 102.387 8.61967C102.304 8.84683 102.262 9.10997 102.262 9.40909C102.262 9.71046 102.304 9.97698 102.387 10.2086C102.473 10.438 102.595 10.618 102.755 10.7484C102.917 10.8766 103.116 10.9407 103.352 10.9407ZM111.135 12.0843C110.741 12.0843 110.385 11.9831 110.065 11.7807C109.748 11.5761 109.496 11.2758 109.31 10.88C109.125 10.4819 109.033 9.99384 109.033 9.41584C109.033 8.82209 109.129 8.32842 109.32 7.93484C109.511 7.539 109.765 7.24325 110.082 7.04759C110.402 6.84967 110.751 6.75071 111.131 6.75071C111.422 6.75071 111.663 6.80019 111.857 6.89915C112.052 6.99586 112.21 7.11731 112.329 7.26349C112.451 7.40743 112.543 7.54912 112.606 7.68857H112.65V5.09091H114.083V12H112.666V11.1701H112.606C112.538 11.314 112.443 11.4569 112.319 11.5985C112.197 11.738 112.039 11.8538 111.843 11.946C111.65 12.0382 111.414 12.0843 111.135 12.0843ZM111.59 10.9407C111.822 10.9407 112.018 10.8777 112.177 10.7518C112.339 10.6236 112.463 10.4448 112.548 10.2154C112.636 9.98597 112.68 9.71721 112.68 9.40909C112.68 9.10097 112.637 8.83333 112.552 8.60618C112.466 8.37902 112.343 8.2036 112.181 8.0799C112.019 7.9562 111.822 7.89435 111.59 7.89435C111.354 7.89435 111.155 7.95845 110.993 8.08665C110.831 8.21484 110.709 8.39252 110.625 8.61967C110.542 8.84683 110.501 9.10997 110.501 9.40909C110.501 9.71046 110.542 9.97698 110.625 10.2086C110.711 10.438 110.833 10.618 110.993 10.7484C111.155 10.8766 111.354 10.9407 111.59 10.9407ZM117.606 12.1012C117.082 12.1012 116.629 11.9899 116.247 11.7672C115.867 11.5423 115.573 11.2297 115.366 10.8294C115.159 10.4268 115.056 9.96011 115.056 9.42933C115.056 8.89406 115.159 8.42625 115.366 8.02592C115.573 7.62334 115.867 7.31072 116.247 7.08807C116.629 6.86316 117.082 6.75071 117.606 6.75071C118.13 6.75071 118.582 6.86316 118.962 7.08807C119.345 7.31072 119.639 7.62334 119.846 8.02592C120.053 8.42625 120.157 8.89406 120.157 9.42933C120.157 9.96011 120.053 10.4268 119.846 10.8294C119.639 11.2297 119.345 11.5423 118.962 11.7672C118.582 11.9899 118.13 12.1012 117.606 12.1012ZM117.613 10.9879C117.851 10.9879 118.05 10.9205 118.21 10.7855C118.37 10.6483 118.49 10.4616 118.571 10.2255C118.654 9.98935 118.696 9.72058 118.696 9.41921C118.696 9.11784 118.654 8.84908 118.571 8.61293C118.49 8.37678 118.37 8.1901 118.21 8.05291C118.05 7.91572 117.851 7.84712 117.613 7.84712C117.372 7.84712 117.17 7.91572 117.006 8.05291C116.844 8.1901 116.721 8.37678 116.638 8.61293C116.557 8.84908 116.517 9.11784 116.517 9.41921C116.517 9.72058 116.557 9.98935 116.638 10.2255C116.721 10.4616 116.844 10.6483 117.006 10.7855C117.17 10.9205 117.372 10.9879 117.613 10.9879ZM123.432 12.1012C122.908 12.1012 122.455 11.9899 122.073 11.7672C121.693 11.5423 121.399 11.2297 121.192 10.8294C120.985 10.4268 120.882 9.96011 120.882 9.42933C120.882 8.89406 120.985 8.42625 121.192 8.02592C121.399 7.62334 121.693 7.31072 122.073 7.08807C122.455 6.86316 122.908 6.75071 123.432 6.75071C123.956 6.75071 124.408 6.86316 124.789 7.08807C125.171 7.31072 125.465 7.62334 125.672 8.02592C125.879 8.42625 125.983 8.89406 125.983 9.42933C125.983 9.96011 125.879 10.4268 125.672 10.8294C125.465 11.2297 125.171 11.5423 124.789 11.7672C124.408 11.9899 123.956 12.1012 123.432 12.1012ZM123.439 10.9879C123.677 10.9879 123.877 10.9205 124.036 10.7855C124.196 10.6483 124.316 10.4616 124.397 10.2255C124.48 9.98935 124.522 9.72058 124.522 9.41921C124.522 9.11784 124.48 8.84908 124.397 8.61293C124.316 8.37678 124.196 8.1901 124.036 8.05291C123.877 7.91572 123.677 7.84712 123.439 7.84712C123.198 7.84712 122.996 7.91572 122.832 8.05291C122.67 8.1901 122.547 8.37678 122.464 8.61293C122.383 8.84908 122.343 9.11784 122.343 9.41921C122.343 9.72058 122.383 9.98935 122.464 10.2255C122.547 10.4616 122.67 10.6483 122.832 10.7855C122.996 10.9205 123.198 10.9879 123.439 10.9879ZM126.917 12V6.81818H128.311V7.7223H128.365C128.459 7.40069 128.618 7.15779 128.84 6.99361C129.063 6.82718 129.319 6.74396 129.609 6.74396C129.681 6.74396 129.759 6.74846 129.842 6.75746C129.925 6.76645 129.998 6.77882 130.061 6.79457V8.06978C129.994 8.04954 129.901 8.03155 129.781 8.0158C129.662 8.00006 129.553 7.99219 129.454 7.99219C129.243 7.99219 129.054 8.03829 128.887 8.1305C128.723 8.22047 128.593 8.34641 128.496 8.50835C128.402 8.67028 128.354 8.85695 128.354 9.06836V12H126.917Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function af(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2003_5091",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2003_5091)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M49.8681 5.09091H51.3288V9.57777C51.3288 10.0816 51.2085 10.5224 50.9679 10.9002C50.7295 11.2781 50.3955 11.5727 49.9659 11.7841C49.5363 11.9933 49.0359 12.0978 48.4647 12.0978C47.8912 12.0978 47.3896 11.9933 46.96 11.7841C46.5305 11.5727 46.1965 11.2781 45.9581 10.9002C45.7197 10.5224 45.6005 10.0816 45.6005 9.57777V5.09091H47.0613V9.45295C47.0613 9.71609 47.1186 9.94999 47.2333 10.1547C47.3503 10.3593 47.5144 10.5201 47.7259 10.6371C47.9373 10.754 48.1835 10.8125 48.4647 10.8125C48.748 10.8125 48.9943 10.754 49.2035 10.6371C49.4149 10.5201 49.5779 10.3593 49.6926 10.1547C49.8096 9.94999 49.8681 9.71609 49.8681 9.45295V5.09091ZM53.9408 9.00426V12H52.5037V6.81818H53.8734V7.73242H53.9341C54.0488 7.43105 54.2411 7.19265 54.511 7.01722C54.7809 6.83955 55.1081 6.75071 55.4927 6.75071C55.8525 6.75071 56.1663 6.82943 56.4339 6.98686C56.7015 7.14429 56.9096 7.3692 57.058 7.66158C57.2065 7.9517 57.2807 8.29806 57.2807 8.70064V12H55.8435V8.95703C55.8458 8.63991 55.7648 8.39252 55.6006 8.21484C55.4364 8.03492 55.2104 7.94496 54.9225 7.94496C54.7291 7.94496 54.5582 7.98656 54.4098 8.06978C54.2636 8.15299 54.1489 8.27444 54.0657 8.43413C53.9847 8.59156 53.9431 8.78161 53.9408 9.00426ZM61.1696 6.81818V7.89773H58.049V6.81818H61.1696ZM58.7575 5.5767H60.1946V10.4077C60.1946 10.5404 60.2148 10.6438 60.2553 10.718C60.2958 10.79 60.352 10.8406 60.424 10.8699C60.4982 10.8991 60.5837 10.9137 60.6804 10.9137C60.7479 10.9137 60.8153 10.9081 60.8828 10.8968C60.9503 10.8833 61.002 10.8732 61.038 10.8665L61.264 11.9359C61.1921 11.9584 61.0909 11.9843 60.9604 12.0135C60.83 12.045 60.6714 12.0641 60.4847 12.0708C60.1384 12.0843 59.8348 12.0382 59.5739 11.9325C59.3152 11.8268 59.1139 11.6626 58.97 11.44C58.8261 11.2173 58.7552 10.9362 58.7575 10.5966V5.5767ZM64.4116 12.1012C63.8786 12.1012 63.4197 11.9933 63.0352 11.7773C62.6528 11.5592 62.3582 11.2511 62.1513 10.853C61.9444 10.4527 61.8409 9.97923 61.8409 9.43271C61.8409 8.89968 61.9444 8.43188 62.1513 8.0293C62.3582 7.62672 62.6494 7.31297 63.025 7.08807C63.4029 6.86316 63.8459 6.75071 64.3542 6.75071C64.6961 6.75071 65.0143 6.80581 65.3089 6.91602C65.6058 7.02397 65.8645 7.18703 66.0849 7.40518C66.3075 7.62334 66.4807 7.89773 66.6044 8.22834C66.7281 8.5567 66.79 8.94129 66.79 9.3821V9.77681H62.4144V8.88619H65.4371C65.4371 8.67927 65.3922 8.49598 65.3022 8.33629C65.2122 8.17661 65.0874 8.05179 64.9277 7.96183C64.7703 7.86961 64.587 7.82351 64.3778 7.82351C64.1597 7.82351 63.9663 7.87411 63.7976 7.97532C63.6312 8.07428 63.5007 8.2081 63.4062 8.37678C63.3118 8.54321 63.2634 8.72875 63.2612 8.93342V9.78018C63.2612 10.0366 63.3084 10.2581 63.4029 10.4448C63.4996 10.6315 63.6357 10.7754 63.8111 10.8766C63.9865 10.9778 64.1945 11.0284 64.4352 11.0284C64.5949 11.0284 64.7411 11.0059 64.8738 10.9609C65.0065 10.916 65.12 10.8485 65.2145 10.7585C65.3089 10.6686 65.3809 10.5584 65.4304 10.4279L66.7596 10.5156C66.6921 10.835 66.5538 11.1139 66.3446 11.3523C66.1377 11.5884 65.8701 11.7728 65.5417 11.9055C65.2156 12.036 64.8389 12.1012 64.4116 12.1012ZM67.7278 12V6.81818H69.1211V7.7223H69.1751C69.2695 7.40069 69.4281 7.15779 69.6507 6.99361C69.8734 6.82718 70.1298 6.74396 70.4199 6.74396C70.4919 6.74396 70.5695 6.74846 70.6527 6.75746C70.7359 6.76645 70.809 6.77882 70.872 6.79457V8.06978C70.8045 8.04954 70.7112 8.03155 70.592 8.0158C70.4728 8.00006 70.3637 7.99219 70.2647 7.99219C70.0533 7.99219 69.8644 8.03829 69.698 8.1305C69.5338 8.22047 69.4033 8.34641 69.3066 8.50835C69.2122 8.67028 69.165 8.85695 69.165 9.06836V12H67.7278ZM75.9264 8.29581L74.6108 8.37678C74.5883 8.26432 74.5399 8.16312 74.4657 8.07315C74.3915 7.98094 74.2936 7.90785 74.1722 7.85387C74.053 7.79764 73.9102 7.76953 73.7437 7.76953C73.5211 7.76953 73.3333 7.81676 73.1804 7.91122C73.0274 8.00343 72.951 8.12713 72.951 8.28232C72.951 8.40601 73.0004 8.51059 73.0994 8.59606C73.1983 8.68152 73.3681 8.75012 73.6088 8.80185L74.5467 8.99077C75.0504 9.09422 75.426 9.26065 75.6734 9.49006C75.9208 9.71946 76.0445 10.0208 76.0445 10.3942C76.0445 10.7338 75.9444 11.0318 75.7443 11.2882C75.5464 11.5446 75.2742 11.7447 74.9279 11.8887C74.5838 12.0304 74.1868 12.1012 73.737 12.1012C73.051 12.1012 72.5045 11.9584 72.0974 11.6728C71.6926 11.3849 71.4553 10.9935 71.3856 10.4988L72.7991 10.4245C72.8419 10.6337 72.9453 10.7934 73.1095 10.9036C73.2737 11.0115 73.484 11.0655 73.7404 11.0655C73.9923 11.0655 74.1947 11.0172 74.3476 10.9205C74.5028 10.8215 74.5815 10.6944 74.5838 10.5392C74.5815 10.4088 74.5264 10.302 74.4185 10.2188C74.3105 10.1333 74.1441 10.0681 73.9192 10.0231L73.0218 9.84428C72.5158 9.74308 72.139 9.56765 71.8916 9.318C71.6465 9.06836 71.5239 8.75012 71.5239 8.36328C71.5239 8.03042 71.6139 7.74367 71.7938 7.50302C71.976 7.26237 72.2313 7.07682 72.5596 6.94638C72.8902 6.81593 73.2771 6.75071 73.7201 6.75071C74.3746 6.75071 74.8896 6.88903 75.2652 7.16566C75.6431 7.44229 75.8635 7.81901 75.9264 8.29581ZM79.7057 6.81818V7.89773H76.5851V6.81818H79.7057ZM77.2936 5.5767H78.7307V10.4077C78.7307 10.5404 78.751 10.6438 78.7915 10.718C78.8319 10.79 78.8882 10.8406 78.9601 10.8699C79.0344 10.8991 79.1198 10.9137 79.2165 10.9137C79.284 10.9137 79.3515 10.9081 79.4189 10.8968C79.4864 10.8833 79.5381 10.8732 79.5741 10.8665L79.8002 11.9359C79.7282 11.9584 79.627 11.9843 79.4965 12.0135C79.3661 12.045 79.2075 12.0641 79.0209 12.0708C78.6745 12.0843 78.3709 12.0382 78.11 11.9325C77.8514 11.8268 77.6501 11.6626 77.5061 11.44C77.3622 11.2173 77.2913 10.9362 77.2936 10.5966V5.5767ZM83.9648 9.79368V6.81818H85.402V12H84.0222V11.0588H83.9682C83.8513 11.3624 83.6567 11.6064 83.3846 11.7908C83.1147 11.9753 82.7852 12.0675 82.3961 12.0675C82.0498 12.0675 81.745 11.9888 81.4819 11.8313C81.2188 11.6739 81.013 11.4501 80.8645 11.16C80.7183 10.8699 80.6441 10.5224 80.6419 10.1175V6.81818H82.079V9.86115C82.0813 10.167 82.1634 10.4088 82.3253 10.5865C82.4872 10.7641 82.7042 10.853 82.9764 10.853C83.1496 10.853 83.3115 10.8136 83.4622 10.7349C83.6129 10.6539 83.7343 10.5347 83.8265 10.3773C83.921 10.2199 83.9671 10.0253 83.9648 9.79368ZM82.0014 6.10973C81.808 6.10973 81.6416 6.04226 81.5021 5.90732C81.3627 5.77012 81.293 5.60819 81.293 5.42152C81.293 5.23035 81.3627 5.06842 81.5021 4.93572C81.6416 4.80303 81.808 4.73668 82.0014 4.73668C82.1971 4.73668 82.3624 4.80303 82.4973 4.93572C82.6345 5.06842 82.7031 5.23035 82.7031 5.42152C82.7031 5.60819 82.6345 5.77012 82.4973 5.90732C82.3624 6.04226 82.1971 6.10973 82.0014 6.10973ZM84.0661 6.10973C83.8726 6.10973 83.7062 6.04226 83.5668 5.90732C83.4273 5.77012 83.3576 5.60819 83.3576 5.42152C83.3576 5.23035 83.4273 5.06842 83.5668 4.93572C83.7062 4.80303 83.8726 4.73668 84.0661 4.73668C84.2617 4.73668 84.427 4.80303 84.562 4.93572C84.6992 5.06842 84.7678 5.23035 84.7678 5.42152C84.7678 5.60819 84.6992 5.77012 84.562 5.90732C84.427 6.04226 84.2617 6.10973 84.0661 6.10973ZM89.3078 6.81818V7.89773H86.1872V6.81818H89.3078ZM86.8956 5.5767H88.3328V10.4077C88.3328 10.5404 88.353 10.6438 88.3935 10.718C88.434 10.79 88.4902 10.8406 88.5622 10.8699C88.6364 10.8991 88.7219 10.9137 88.8186 10.9137C88.8861 10.9137 88.9535 10.9081 89.021 10.8968C89.0885 10.8833 89.1402 10.8732 89.1762 10.8665L89.4022 11.9359C89.3302 11.9584 89.229 11.9843 89.0986 12.0135C88.9681 12.045 88.8096 12.0641 88.6229 12.0708C88.2766 12.0843 87.9729 12.0382 87.712 11.9325C87.4534 11.8268 87.2521 11.6626 87.1082 11.44C86.9642 11.2173 86.8934 10.9362 86.8956 10.5966V5.5767ZM90.2169 12V11.1431L92.7539 8.00231V7.9652H90.3046V6.81818H94.4845V7.75266L92.1028 10.8159V10.853H94.5722V12H90.2169ZM98.4274 6.81818V7.89773H95.3068V6.81818H98.4274ZM96.0153 5.5767H97.4524V10.4077C97.4524 10.5404 97.4727 10.6438 97.5131 10.718C97.5536 10.79 97.6098 10.8406 97.6818 10.8699C97.756 10.8991 97.8415 10.9137 97.9382 10.9137C98.0057 10.9137 98.0732 10.9081 98.1406 10.8968C98.2081 10.8833 98.2598 10.8732 98.2958 10.8665L98.5218 11.9359C98.4499 11.9584 98.3487 11.9843 98.2182 12.0135C98.0878 12.045 97.9292 12.0641 97.7425 12.0708C97.3962 12.0843 97.0926 12.0382 96.8317 11.9325C96.573 11.8268 96.3717 11.6626 96.2278 11.44C96.0839 11.2173 96.013 10.9362 96.0153 10.5966V5.5767ZM106.393 6.81818L104.582 12H102.962L101.151 6.81818H102.669L103.745 10.5257H103.799L104.872 6.81818H106.393ZM109.303 12.1012C108.779 12.1012 108.326 11.9899 107.943 11.7672C107.563 11.5423 107.27 11.2297 107.063 10.8294C106.856 10.4268 106.753 9.96011 106.753 9.42933C106.753 8.89406 106.856 8.42625 107.063 8.02592C107.27 7.62334 107.563 7.31072 107.943 7.08807C108.326 6.86316 108.779 6.75071 109.303 6.75071C109.827 6.75071 110.279 6.86316 110.659 7.08807C111.041 7.31072 111.336 7.62334 111.543 8.02592C111.75 8.42625 111.853 8.89406 111.853 9.42933C111.853 9.96011 111.75 10.4268 111.543 10.8294C111.336 11.2297 111.041 11.5423 110.659 11.7672C110.279 11.9899 109.827 12.1012 109.303 12.1012ZM109.31 10.9879C109.548 10.9879 109.747 10.9205 109.907 10.7855C110.067 10.6483 110.187 10.4616 110.268 10.2255C110.351 9.98935 110.393 9.72058 110.393 9.41921C110.393 9.11784 110.351 8.84908 110.268 8.61293C110.187 8.37678 110.067 8.1901 109.907 8.05291C109.747 7.91572 109.548 7.84712 109.31 7.84712C109.069 7.84712 108.867 7.91572 108.702 8.05291C108.541 8.1901 108.418 8.37678 108.335 8.61293C108.254 8.84908 108.213 9.11784 108.213 9.41921C108.213 9.72058 108.254 9.98935 108.335 10.2255C108.418 10.4616 108.541 10.6483 108.702 10.7855C108.867 10.9205 109.069 10.9879 109.31 10.9879ZM114.225 9.00426V12H112.788V6.81818H114.158V7.73242H114.218C114.333 7.43105 114.525 7.19265 114.795 7.01722C115.065 6.83955 115.392 6.75071 115.777 6.75071C116.137 6.75071 116.45 6.82943 116.718 6.98686C116.986 7.14429 117.194 7.3692 117.342 7.66158C117.491 7.9517 117.565 8.29806 117.565 8.70064V12H116.128V8.95703C116.13 8.63991 116.049 8.39252 115.885 8.21484C115.721 8.03492 115.495 7.94496 115.207 7.94496C115.013 7.94496 114.842 7.98656 114.694 8.06978C114.548 8.15299 114.433 8.27444 114.35 8.43413C114.269 8.59156 114.227 8.78161 114.225 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function nf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2003_5067",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2003_5067)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM54.8466 12.1012C54.3136 12.1012 53.8548 11.9933 53.4702 11.7773C53.0879 11.5592 52.7932 11.2511 52.5863 10.853C52.3794 10.4527 52.276 9.97923 52.276 9.43271C52.276 8.89968 52.3794 8.43188 52.5863 8.0293C52.7932 7.62672 53.0845 7.31297 53.4601 7.08807C53.8379 6.86316 54.281 6.75071 54.7893 6.75071C55.1311 6.75071 55.4494 6.80581 55.744 6.91602C56.0409 7.02397 56.2995 7.18703 56.5199 7.40518C56.7426 7.62334 56.9158 7.89773 57.0395 8.22834C57.1632 8.5567 57.225 8.94129 57.225 9.3821V9.77681H52.8495V8.88619H55.8722C55.8722 8.67927 55.8272 8.49598 55.7373 8.33629C55.6473 8.17661 55.5225 8.05179 55.3628 7.96183C55.2054 7.86961 55.0221 7.82351 54.8129 7.82351C54.5947 7.82351 54.4013 7.87411 54.2326 7.97532C54.0662 8.07428 53.9358 8.2081 53.8413 8.37678C53.7468 8.54321 53.6985 8.72875 53.6962 8.93342V9.78018C53.6962 10.0366 53.7435 10.2581 53.8379 10.4448C53.9346 10.6315 54.0707 10.7754 54.2461 10.8766C54.4216 10.9778 54.6296 11.0284 54.8703 11.0284C55.0299 11.0284 55.1761 11.0059 55.3088 10.9609C55.4415 10.916 55.5551 10.8485 55.6495 10.7585C55.744 10.6686 55.816 10.5584 55.8655 10.4279L57.1946 10.5156C57.1272 10.835 56.9889 11.1139 56.7797 11.3523C56.5728 11.5884 56.3051 11.7728 55.9768 11.9055C55.6507 12.036 55.274 12.1012 54.8466 12.1012ZM62.4743 8.29581L61.1586 8.37678C61.1361 8.26432 61.0878 8.16312 61.0135 8.07315C60.9393 7.98094 60.8415 7.90785 60.72 7.85387C60.6008 7.79764 60.458 7.76953 60.2916 7.76953C60.0689 7.76953 59.8811 7.81676 59.7282 7.91122C59.5753 8.00343 59.4988 8.12713 59.4988 8.28232C59.4988 8.40601 59.5483 8.51059 59.6472 8.59606C59.7462 8.68152 59.916 8.75012 60.1566 8.80185L61.0945 8.99077C61.5983 9.09422 61.9739 9.26065 62.2213 9.49006C62.4687 9.71946 62.5924 10.0208 62.5924 10.3942C62.5924 10.7338 62.4923 11.0318 62.2921 11.2882C62.0942 11.5446 61.8221 11.7447 61.4757 11.8887C61.1316 12.0304 60.7347 12.1012 60.2848 12.1012C59.5989 12.1012 59.0524 11.9584 58.6453 11.6728C58.2405 11.3849 58.0032 10.9935 57.9335 10.4988L59.347 10.4245C59.3897 10.6337 59.4932 10.7934 59.6574 10.9036C59.8215 11.0115 60.0318 11.0655 60.2882 11.0655C60.5401 11.0655 60.7425 11.0172 60.8955 10.9205C61.0506 10.8215 61.1294 10.6944 61.1316 10.5392C61.1294 10.4088 61.0743 10.302 60.9663 10.2188C60.8584 10.1333 60.6919 10.0681 60.467 10.0231L59.5696 9.84428C59.0636 9.74308 58.6869 9.56765 58.4395 9.318C58.1944 9.06836 58.0718 8.75012 58.0718 8.36328C58.0718 8.03042 58.1617 7.74367 58.3417 7.50302C58.5238 7.26237 58.7791 7.07682 59.1075 6.94638C59.4381 6.81593 59.8249 6.75071 60.268 6.75071C60.9225 6.75071 61.4375 6.88903 61.8131 7.16566C62.1909 7.44229 62.4113 7.81901 62.4743 8.29581ZM65.8588 12.1012C65.3258 12.1012 64.867 11.9933 64.4824 11.7773C64.1001 11.5592 63.8055 11.2511 63.5985 10.853C63.3916 10.4527 63.2882 9.97923 63.2882 9.43271C63.2882 8.89968 63.3916 8.43188 63.5985 8.0293C63.8055 7.62672 64.0967 7.31297 64.4723 7.08807C64.8501 6.86316 65.2932 6.75071 65.8015 6.75071C66.1433 6.75071 66.4616 6.80581 66.7562 6.91602C67.0531 7.02397 67.3117 7.18703 67.5321 7.40518C67.7548 7.62334 67.928 7.89773 68.0517 8.22834C68.1754 8.5567 68.2372 8.94129 68.2372 9.3821V9.77681H63.8617V8.88619H66.8844C66.8844 8.67927 66.8394 8.49598 66.7495 8.33629C66.6595 8.17661 66.5347 8.05179 66.375 7.96183C66.2176 7.86961 66.0343 7.82351 65.8251 7.82351C65.6069 7.82351 65.4135 7.87411 65.2449 7.97532C65.0784 8.07428 64.948 8.2081 64.8535 8.37678C64.7591 8.54321 64.7107 8.72875 64.7085 8.93342V9.78018C64.7085 10.0366 64.7557 10.2581 64.8501 10.4448C64.9469 10.6315 65.0829 10.7754 65.2583 10.8766C65.4338 10.9778 65.6418 11.0284 65.8825 11.0284C66.0421 11.0284 66.1883 11.0059 66.321 10.9609C66.4537 10.916 66.5673 10.8485 66.6618 10.7585C66.7562 10.6686 66.8282 10.5584 66.8777 10.4279L68.2069 10.5156C68.1394 10.835 68.0011 11.1139 67.7919 11.3523C67.585 11.5884 67.3174 11.7728 66.989 11.9055C66.6629 12.036 66.2862 12.1012 65.8588 12.1012ZM70.6122 9.00426V12H69.1751V6.81818H70.5447V7.73242H70.6055C70.7202 7.43105 70.9125 7.19265 71.1824 7.01722C71.4522 6.83955 71.7795 6.75071 72.1641 6.75071C72.5239 6.75071 72.8377 6.82943 73.1053 6.98686C73.3729 7.14429 73.581 7.3692 73.7294 7.66158C73.8778 7.9517 73.9521 8.29806 73.9521 8.70064V12H72.5149V8.95703C72.5172 8.63991 72.4362 8.39252 72.272 8.21484C72.1078 8.03492 71.8818 7.94496 71.5939 7.94496C71.4005 7.94496 71.2296 7.98656 71.0811 8.06978C70.935 8.15299 70.8203 8.27444 70.737 8.43413C70.6561 8.59156 70.6145 8.78161 70.6122 9.00426ZM79.7302 6.81818L77.9185 12H76.2992L74.4876 6.81818H76.0057L77.0819 10.5257H77.1359L78.2087 6.81818H79.7302ZM82.6399 12.1012C82.1158 12.1012 81.6627 11.9899 81.2803 11.7672C80.9002 11.5423 80.6067 11.2297 80.3998 10.8294C80.1929 10.4268 80.0894 9.96011 80.0894 9.42933C80.0894 8.89406 80.1929 8.42625 80.3998 8.02592C80.6067 7.62334 80.9002 7.31072 81.2803 7.08807C81.6627 6.86316 82.1158 6.75071 82.6399 6.75071C83.1639 6.75071 83.616 6.86316 83.996 7.08807C84.3784 7.31072 84.673 7.62334 84.8799 8.02592C85.0868 8.42625 85.1903 8.89406 85.1903 9.42933C85.1903 9.96011 85.0868 10.4268 84.8799 10.8294C84.673 11.2297 84.3784 11.5423 83.996 11.7672C83.616 11.9899 83.1639 12.1012 82.6399 12.1012ZM82.6466 10.9879C82.885 10.9879 83.0841 10.9205 83.2437 10.7855C83.4034 10.6483 83.5237 10.4616 83.6047 10.2255C83.6879 9.98935 83.7295 9.72058 83.7295 9.41921C83.7295 9.11784 83.6879 8.84908 83.6047 8.61293C83.5237 8.37678 83.4034 8.1901 83.2437 8.05291C83.0841 7.91572 82.885 7.84712 82.6466 7.84712C82.406 7.84712 82.2036 7.91572 82.0394 8.05291C81.8774 8.1901 81.7549 8.37678 81.6717 8.61293C81.5907 8.84908 81.5502 9.11784 81.5502 9.41921C81.5502 9.72058 81.5907 9.98935 81.6717 10.2255C81.7549 10.4616 81.8774 10.6483 82.0394 10.7855C82.2036 10.9205 82.406 10.9879 82.6466 10.9879ZM87.5619 5.09091V12H86.1248V5.09091H87.5619ZM93.5441 6.81818L91.7325 12H90.1132L88.3016 6.81818H89.8197L90.8959 10.5257H90.9498L92.0226 6.81818H93.5441ZM94.2796 12V6.81818H95.7167V12H94.2796ZM95.0015 6.15021C94.7878 6.15021 94.6046 6.07937 94.4516 5.93768C94.3009 5.79374 94.2256 5.62169 94.2256 5.42152C94.2256 5.2236 94.3009 5.0538 94.4516 4.91211C94.6046 4.76817 94.7878 4.6962 95.0015 4.6962C95.2152 4.6962 95.3973 4.76817 95.548 4.91211C95.701 5.0538 95.7774 5.2236 95.7774 5.42152C95.7774 5.62169 95.701 5.79374 95.548 5.93768C95.3973 6.07937 95.2152 6.15021 95.0015 6.15021ZM98.7774 12.0843C98.3838 12.0843 98.0273 11.9831 97.708 11.7807C97.3908 11.5761 97.139 11.2758 96.9523 10.88C96.7679 10.4819 96.6756 9.99384 96.6756 9.41584C96.6756 8.82209 96.7712 8.32842 96.9624 7.93484C97.1536 7.539 97.4077 7.24325 97.7248 7.04759C98.0442 6.84967 98.3939 6.75071 98.774 6.75071C99.0641 6.75071 99.3059 6.80019 99.4993 6.89915C99.695 6.99586 99.8524 7.11731 99.9716 7.26349C100.093 7.40743 100.185 7.54912 100.248 7.68857H100.292V5.09091H101.726V12H100.309V11.1701H100.248C100.181 11.314 100.085 11.4569 99.9615 11.5985C99.8401 11.738 99.6815 11.8538 99.4858 11.946C99.2924 12.0382 99.0563 12.0843 98.7774 12.0843ZM99.2328 10.9407C99.4645 10.9407 99.6601 10.8777 99.8198 10.7518C99.9818 10.6236 100.105 10.4448 100.191 10.2154C100.279 9.98597 100.322 9.71721 100.322 9.40909C100.322 9.10097 100.28 8.83333 100.194 8.60618C100.109 8.37902 99.9851 8.2036 99.8232 8.0799C99.6613 7.9562 99.4645 7.89435 99.2328 7.89435C98.9967 7.89435 98.7976 7.95845 98.6357 8.08665C98.4738 8.21484 98.3512 8.39252 98.268 8.61967C98.1848 8.84683 98.1432 9.10997 98.1432 9.40909C98.1432 9.71046 98.1848 9.97698 98.268 10.2086C98.3534 10.438 98.476 10.618 98.6357 10.7484C98.7976 10.8766 98.9967 10.9407 99.2328 10.9407ZM105.249 12.1012C104.725 12.1012 104.272 11.9899 103.889 11.7672C103.509 11.5423 103.216 11.2297 103.009 10.8294C102.802 10.4268 102.698 9.96011 102.698 9.42933C102.698 8.89406 102.802 8.42625 103.009 8.02592C103.216 7.62334 103.509 7.31072 103.889 7.08807C104.272 6.86316 104.725 6.75071 105.249 6.75071C105.773 6.75071 106.225 6.86316 106.605 7.08807C106.987 7.31072 107.282 7.62334 107.489 8.02592C107.696 8.42625 107.799 8.89406 107.799 9.42933C107.799 9.96011 107.696 10.4268 107.489 10.8294C107.282 11.2297 106.987 11.5423 106.605 11.7672C106.225 11.9899 105.773 12.1012 105.249 12.1012ZM105.256 10.9879C105.494 10.9879 105.693 10.9205 105.853 10.7855C106.012 10.6483 106.133 10.4616 106.214 10.2255C106.297 9.98935 106.338 9.72058 106.338 9.41921C106.338 9.11784 106.297 8.84908 106.214 8.61293C106.133 8.37678 106.012 8.1901 105.853 8.05291C105.693 7.91572 105.494 7.84712 105.256 7.84712C105.015 7.84712 104.812 7.91572 104.648 8.05291C104.486 8.1901 104.364 8.37678 104.281 8.61293C104.2 8.84908 104.159 9.11784 104.159 9.41921C104.159 9.72058 104.2 9.98935 104.281 10.2255C104.364 10.4616 104.486 10.6483 104.648 10.7855C104.812 10.9205 105.015 10.9879 105.256 10.9879ZM110.932 13.9432V6.81818H112.349V7.68857H112.413C112.476 7.54912 112.567 7.40743 112.687 7.26349C112.808 7.11731 112.966 6.99586 113.159 6.89915C113.355 6.80019 113.598 6.75071 113.888 6.75071C114.265 6.75071 114.614 6.84967 114.933 7.04759C115.253 7.24325 115.508 7.539 115.699 7.93484C115.89 8.32842 115.986 8.82209 115.986 9.41584C115.986 9.99384 115.893 10.4819 115.706 10.88C115.522 11.2758 115.27 11.5761 114.95 11.7807C114.633 11.9831 114.278 12.0843 113.884 12.0843C113.605 12.0843 113.368 12.0382 113.172 11.946C112.979 11.8538 112.82 11.738 112.697 11.5985C112.573 11.4569 112.479 11.314 112.413 11.1701H112.37V13.9432H110.932ZM112.339 9.40909C112.339 9.71721 112.382 9.98597 112.467 10.2154C112.553 10.4448 112.677 10.6236 112.838 10.7518C113 10.8777 113.197 10.9407 113.429 10.9407C113.663 10.9407 113.861 10.8766 114.023 10.7484C114.185 10.618 114.307 10.438 114.39 10.2086C114.476 9.97698 114.519 9.71046 114.519 9.40909C114.519 9.10997 114.477 8.84683 114.394 8.61967C114.31 8.39252 114.188 8.21484 114.026 8.08665C113.864 7.95845 113.665 7.89435 113.429 7.89435C113.195 7.89435 112.997 7.9562 112.835 8.0799C112.675 8.2036 112.553 8.37902 112.467 8.60618C112.382 8.83333 112.339 9.10097 112.339 9.40909ZM119.285 12.1012C118.761 12.1012 118.308 11.9899 117.926 11.7672C117.546 11.5423 117.252 11.2297 117.045 10.8294C116.838 10.4268 116.735 9.96011 116.735 9.42933C116.735 8.89406 116.838 8.42625 117.045 8.02592C117.252 7.62334 117.546 7.31072 117.926 7.08807C118.308 6.86316 118.761 6.75071 119.285 6.75071C119.809 6.75071 120.261 6.86316 120.642 7.08807C121.024 7.31072 121.319 7.62334 121.525 8.02592C121.732 8.42625 121.836 8.89406 121.836 9.42933C121.836 9.96011 121.732 10.4268 121.525 10.8294C121.319 11.2297 121.024 11.5423 120.642 11.7672C120.261 11.9899 119.809 12.1012 119.285 12.1012ZM119.292 10.9879C119.531 10.9879 119.73 10.9205 119.889 10.7855C120.049 10.6483 120.169 10.4616 120.25 10.2255C120.333 9.98935 120.375 9.72058 120.375 9.41921C120.375 9.11784 120.333 8.84908 120.25 8.61293C120.169 8.37678 120.049 8.1901 119.889 8.05291C119.73 7.91572 119.531 7.84712 119.292 7.84712C119.051 7.84712 118.849 7.91572 118.685 8.05291C118.523 8.1901 118.4 8.37678 118.317 8.61293C118.236 8.84908 118.196 9.11784 118.196 9.41921C118.196 9.72058 118.236 9.98935 118.317 10.2255C118.4 10.4616 118.523 10.6483 118.685 10.7855C118.849 10.9205 119.051 10.9879 119.292 10.9879ZM122.77 12V6.81818H124.164V7.7223H124.218C124.312 7.40069 124.471 7.15779 124.693 6.99361C124.916 6.82718 125.172 6.74396 125.462 6.74396C125.534 6.74396 125.612 6.74846 125.695 6.75746C125.778 6.76645 125.851 6.77882 125.914 6.79457V8.06978C125.847 8.04954 125.754 8.03155 125.634 8.0158C125.515 8.00006 125.406 7.99219 125.307 7.99219C125.096 7.99219 124.907 8.03829 124.74 8.1305C124.576 8.22047 124.446 8.34641 124.349 8.50835C124.255 8.67028 124.207 8.85695 124.207 9.06836V12H122.77Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function rf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2003_5043",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2003_5043)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8481 5.09091 49.2934 5.18424 49.6623 5.37092C50.0334 5.55534 50.3156 5.81735 50.5091 6.15696C50.7047 6.49432 50.8026 6.89128 50.8026 7.34783C50.8026 7.80664 50.7036 8.20135 50.5057 8.53196C50.3078 8.86032 50.021 9.11222 49.6454 9.28764C49.2721 9.46307 48.82 9.55078 48.2892 9.55078H46.4641V8.37678H48.0531C48.332 8.37678 48.5636 8.33854 48.748 8.26207C48.9325 8.18561 49.0697 8.0709 49.1596 7.91797C49.2518 7.76503 49.2979 7.57499 49.2979 7.34783C49.2979 7.11843 49.2518 6.92501 49.1596 6.76758C49.0697 6.61014 48.9313 6.49094 48.7447 6.40998C48.5603 6.32676 48.3275 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM49.3317 8.85582L51.0488 12H49.4363L47.7562 8.85582H49.3317ZM54.0859 12.1012C53.5529 12.1012 53.0941 11.9933 52.7095 11.7773C52.3271 11.5592 52.0325 11.2511 51.8256 10.853C51.6187 10.4527 51.5152 9.97923 51.5152 9.43271C51.5152 8.89968 51.6187 8.43188 51.8256 8.0293C52.0325 7.62672 52.3238 7.31297 52.6994 7.08807C53.0772 6.86316 53.5203 6.75071 54.0285 6.75071C54.3704 6.75071 54.6886 6.80581 54.9833 6.91602C55.2801 7.02397 55.5388 7.18703 55.7592 7.40518C55.9818 7.62334 56.155 7.89773 56.2787 8.22834C56.4024 8.5567 56.4643 8.94129 56.4643 9.3821V9.77681H52.0887V8.88619H55.1115C55.1115 8.67927 55.0665 8.49598 54.9765 8.33629C54.8866 8.17661 54.7617 8.05179 54.6021 7.96183C54.4446 7.86961 54.2613 7.82351 54.0522 7.82351C53.834 7.82351 53.6406 7.87411 53.4719 7.97532C53.3055 8.07428 53.175 8.2081 53.0806 8.37678C52.9861 8.54321 52.9378 8.72875 52.9355 8.93342V9.78018C52.9355 10.0366 52.9827 10.2581 53.0772 10.4448C53.1739 10.6315 53.31 10.7754 53.4854 10.8766C53.6608 10.9778 53.8689 11.0284 54.1095 11.0284C54.2692 11.0284 54.4154 11.0059 54.5481 10.9609C54.6808 10.916 54.7943 10.8485 54.8888 10.7585C54.9833 10.6686 55.0552 10.5584 55.1047 10.4279L56.4339 10.5156C56.3664 10.835 56.2281 11.1139 56.019 11.3523C55.812 11.5884 55.5444 11.7728 55.216 11.9055C54.8899 12.036 54.5132 12.1012 54.0859 12.1012ZM58.8797 12.0978C58.5491 12.0978 58.2545 12.0405 57.9959 11.9258C57.7372 11.8088 57.5326 11.6368 57.3819 11.4096C57.2334 11.1802 57.1592 10.8946 57.1592 10.5527C57.1592 10.2649 57.2121 10.0231 57.3178 9.82741C57.4235 9.63175 57.5674 9.47431 57.7496 9.35511C57.9318 9.23591 58.1387 9.14595 58.3703 9.08523C58.6042 9.0245 58.8494 8.98177 59.1058 8.95703C59.4072 8.92554 59.6501 8.89631 59.8345 8.86932C60.0189 8.84008 60.1527 8.79735 60.2359 8.74112C60.3191 8.6849 60.3608 8.60168 60.3608 8.49148V8.47124C60.3608 8.25758 60.2933 8.09227 60.1583 7.97532C60.0256 7.85837 59.8367 7.79989 59.5916 7.79989C59.3329 7.79989 59.1271 7.85724 58.9742 7.97195C58.8213 8.0844 58.7201 8.22609 58.6706 8.39702L57.3414 8.28906C57.4089 7.97419 57.5416 7.70206 57.7395 7.47266C57.9374 7.241 58.1927 7.06333 58.5053 6.93963C58.8201 6.81368 59.1845 6.75071 59.5983 6.75071C59.8862 6.75071 60.1617 6.78445 60.4248 6.85192C60.6902 6.91939 60.9253 7.02397 61.1299 7.16566C61.3368 7.30735 61.4999 7.48952 61.6191 7.71218C61.7383 7.93259 61.7979 8.19685 61.7979 8.50497V12H60.435V11.2814H60.3945C60.3113 11.4434 60.1999 11.5862 60.0605 11.7099C59.9211 11.8313 59.7535 11.9269 59.5578 11.9966C59.3622 12.0641 59.1361 12.0978 58.8797 12.0978ZM59.2913 11.106C59.5027 11.106 59.6894 11.0644 59.8513 10.9812C60.0133 10.8957 60.1403 10.781 60.2326 10.6371C60.3248 10.4931 60.3709 10.3301 60.3709 10.1479V9.59801C60.3259 9.62725 60.264 9.65424 60.1853 9.67898C60.1089 9.70147 60.0223 9.72283 59.9256 9.74308C59.8289 9.76107 59.7321 9.77794 59.6354 9.79368C59.5387 9.80717 59.451 9.81954 59.3723 9.83079C59.2036 9.85553 59.0563 9.89489 58.9304 9.94886C58.8044 10.0028 58.7066 10.0759 58.6369 10.1681C58.5671 10.2581 58.5323 10.3706 58.5323 10.5055C58.5323 10.7012 58.6031 10.8507 58.7448 10.9542C58.8887 11.0554 59.0709 11.106 59.2913 11.106ZM64.35 5.09091V12H62.9129V5.09091H64.35ZM65.5012 12V6.81818H66.9384V12H65.5012ZM66.2232 6.15021C66.0095 6.15021 65.8262 6.07937 65.6733 5.93768C65.5226 5.79374 65.4473 5.62169 65.4473 5.42152C65.4473 5.2236 65.5226 5.0538 65.6733 4.91211C65.8262 4.76817 66.0095 4.6962 66.2232 4.6962C66.4368 4.6962 66.619 4.76817 66.7697 4.91211C66.9226 5.0538 66.9991 5.2236 66.9991 5.42152C66.9991 5.62169 66.9226 5.79374 66.7697 5.93768C66.619 6.07937 66.4368 6.15021 66.2232 6.15021ZM68.0626 12V11.1431L70.5996 8.00231V7.9652H68.1503V6.81818H72.3302V7.75266L69.9485 10.8159V10.853H72.4179V12H68.0626ZM73.4899 12V11.1431L76.0268 8.00231V7.9652H73.5776V6.81818H77.7575V7.75266L75.3757 10.8159V10.853H77.8452V12H73.4899ZM80.4217 12.0978C80.0911 12.0978 79.7965 12.0405 79.5379 11.9258C79.2792 11.8088 79.0746 11.6368 78.9239 11.4096C78.7754 11.1802 78.7012 10.8946 78.7012 10.5527C78.7012 10.2649 78.7541 10.0231 78.8598 9.82741C78.9655 9.63175 79.1094 9.47431 79.2916 9.35511C79.4738 9.23591 79.6807 9.14595 79.9123 9.08523C80.1462 9.0245 80.3914 8.98177 80.6478 8.95703C80.9491 8.92554 81.192 8.89631 81.3765 8.86932C81.5609 8.84008 81.6947 8.79735 81.7779 8.74112C81.8611 8.6849 81.9027 8.60168 81.9027 8.49148V8.47124C81.9027 8.25758 81.8353 8.09227 81.7003 7.97532C81.5676 7.85837 81.3787 7.79989 81.1336 7.79989C80.8749 7.79989 80.6691 7.85724 80.5162 7.97195C80.3633 8.0844 80.2621 8.22609 80.2126 8.39702L78.8834 8.28906C78.9509 7.97419 79.0836 7.70206 79.2815 7.47266C79.4794 7.241 79.7347 7.06333 80.0473 6.93963C80.3621 6.81368 80.7265 6.75071 81.1403 6.75071C81.4282 6.75071 81.7037 6.78445 81.9668 6.85192C82.2322 6.91939 82.4673 7.02397 82.6719 7.16566C82.8788 7.30735 83.0419 7.48952 83.1611 7.71218C83.2803 7.93259 83.3399 8.19685 83.3399 8.50497V12H81.977V11.2814H81.9365C81.8533 11.4434 81.7419 11.5862 81.6025 11.7099C81.4631 11.8313 81.2955 11.9269 81.0998 11.9966C80.9042 12.0641 80.6781 12.0978 80.4217 12.0978ZM80.8333 11.106C81.0447 11.106 81.2314 11.0644 81.3933 10.9812C81.5553 10.8957 81.6823 10.781 81.7745 10.6371C81.8668 10.4931 81.9129 10.3301 81.9129 10.1479V9.59801C81.8679 9.62725 81.806 9.65424 81.7273 9.67898C81.6508 9.70147 81.5643 9.72283 81.4676 9.74308C81.3708 9.76107 81.2741 9.77794 81.1774 9.79368C81.0807 9.80717 80.993 9.81954 80.9143 9.83079C80.7456 9.85553 80.5983 9.89489 80.4723 9.94886C80.3464 10.0028 80.2486 10.0759 80.1788 10.1681C80.1091 10.2581 80.0743 10.3706 80.0743 10.5055C80.0743 10.7012 80.1451 10.8507 80.2868 10.9542C80.4307 11.0554 80.6129 11.106 80.8333 11.106ZM87.2111 6.81818V7.89773H84.0905V6.81818H87.2111ZM84.799 5.5767H86.2361V10.4077C86.2361 10.5404 86.2563 10.6438 86.2968 10.718C86.3373 10.79 86.3935 10.8406 86.4655 10.8699C86.5397 10.8991 86.6252 10.9137 86.7219 10.9137C86.7894 10.9137 86.8568 10.9081 86.9243 10.8968C86.9918 10.8833 87.0435 10.8732 87.0795 10.8665L87.3055 11.9359C87.2336 11.9584 87.1324 11.9843 87.0019 12.0135C86.8715 12.045 86.7129 12.0641 86.5262 12.0708C86.1799 12.0843 85.8763 12.0382 85.6154 11.9325C85.3567 11.8268 85.1554 11.6626 85.0115 11.44C84.8676 11.2173 84.7967 10.9362 84.799 10.5966V5.5767ZM90.4328 12.1012C89.9088 12.1012 89.4556 11.9899 89.0733 11.7672C88.6932 11.5423 88.3997 11.2297 88.1928 10.8294C87.9859 10.4268 87.8824 9.96011 87.8824 9.42933C87.8824 8.89406 87.9859 8.42625 88.1928 8.02592C88.3997 7.62334 88.6932 7.31072 89.0733 7.08807C89.4556 6.86316 89.9088 6.75071 90.4328 6.75071C90.9569 6.75071 91.4089 6.86316 91.789 7.08807C92.1714 7.31072 92.466 7.62334 92.6729 8.02592C92.8798 8.42625 92.9833 8.89406 92.9833 9.42933C92.9833 9.96011 92.8798 10.4268 92.6729 10.8294C92.466 11.2297 92.1714 11.5423 91.789 11.7672C91.4089 11.9899 90.9569 12.1012 90.4328 12.1012ZM90.4396 10.9879C90.678 10.9879 90.877 10.9205 91.0367 10.7855C91.1964 10.6483 91.3167 10.4616 91.3977 10.2255C91.4809 9.98935 91.5225 9.72058 91.5225 9.41921C91.5225 9.11784 91.4809 8.84908 91.3977 8.61293C91.3167 8.37678 91.1964 8.1901 91.0367 8.05291C90.877 7.91572 90.678 7.84712 90.4396 7.84712C90.1989 7.84712 89.9965 7.91572 89.8323 8.05291C89.6704 8.1901 89.5478 8.37678 89.4646 8.61293C89.3837 8.84908 89.3432 9.11784 89.3432 9.41921C89.3432 9.72058 89.3837 9.98935 89.4646 10.2255C89.5478 10.4616 89.6704 10.6483 89.8323 10.7855C89.9965 10.9205 90.1989 10.9879 90.4396 10.9879ZM98.4577 12.1012C97.927 12.1012 97.4704 11.9888 97.0881 11.7638C96.708 11.5367 96.4156 11.2218 96.2109 10.8192C96.0085 10.4167 95.9073 9.95336 95.9073 9.42933C95.9073 8.89856 96.0096 8.433 96.2143 8.03267C96.4212 7.63009 96.7147 7.31635 97.0948 7.09144C97.4749 6.86429 97.927 6.75071 98.451 6.75071C98.9031 6.75071 99.2989 6.8328 99.6385 6.99698C99.9781 7.16116 100.247 7.39169 100.445 7.68857C100.643 7.98544 100.752 8.33404 100.772 8.73438H99.4158C99.3776 8.47573 99.2764 8.2677 99.1122 8.11026C98.9503 7.95058 98.7377 7.87074 98.4746 7.87074C98.252 7.87074 98.0574 7.93146 97.891 8.05291C97.7268 8.17211 97.5986 8.34641 97.5064 8.57582C97.4142 8.80522 97.3681 9.08298 97.3681 9.40909C97.3681 9.7397 97.4131 10.0208 97.503 10.2525C97.5952 10.4841 97.7246 10.6607 97.891 10.7821C98.0574 10.9036 98.252 10.9643 98.4746 10.9643C98.6388 10.9643 98.7861 10.9306 98.9165 10.8631C99.0492 10.7956 99.1583 10.6978 99.2438 10.5696C99.3315 10.4392 99.3888 10.2828 99.4158 10.1007H100.772C100.75 10.4965 100.642 10.8451 100.448 11.1465C100.257 11.4456 99.9927 11.6795 99.6554 11.8482C99.318 12.0169 98.9188 12.1012 98.4577 12.1012ZM104.033 12.1012C103.509 12.1012 103.056 11.9899 102.674 11.7672C102.294 11.5423 102 11.2297 101.793 10.8294C101.586 10.4268 101.483 9.96011 101.483 9.42933C101.483 8.89406 101.586 8.42625 101.793 8.02592C102 7.62334 102.294 7.31072 102.674 7.08807C103.056 6.86316 103.509 6.75071 104.033 6.75071C104.557 6.75071 105.01 6.86316 105.39 7.08807C105.772 7.31072 106.067 7.62334 106.273 8.02592C106.48 8.42625 106.584 8.89406 106.584 9.42933C106.584 9.96011 106.48 10.4268 106.273 10.8294C106.067 11.2297 105.772 11.5423 105.39 11.7672C105.01 11.9899 104.557 12.1012 104.033 12.1012ZM104.04 10.9879C104.279 10.9879 104.478 10.9205 104.637 10.7855C104.797 10.6483 104.917 10.4616 104.998 10.2255C105.081 9.98935 105.123 9.72058 105.123 9.41921C105.123 9.11784 105.081 8.84908 104.998 8.61293C104.917 8.37678 104.797 8.1901 104.637 8.05291C104.478 7.91572 104.279 7.84712 104.04 7.84712C103.8 7.84712 103.597 7.91572 103.433 8.05291C103.271 8.1901 103.148 8.37678 103.065 8.61293C102.984 8.84908 102.944 9.11784 102.944 9.41921C102.944 9.72058 102.984 9.98935 103.065 10.2255C103.148 10.4616 103.271 10.6483 103.433 10.7855C103.597 10.9205 103.8 10.9879 104.04 10.9879ZM108.955 9.00426V12H107.518V6.81818H108.888V7.73242H108.949C109.063 7.43105 109.256 7.19265 109.526 7.01722C109.795 6.83955 110.123 6.75071 110.507 6.75071C110.867 6.75071 111.181 6.82943 111.449 6.98686C111.716 7.14429 111.924 7.3692 112.073 7.66158C112.221 7.9517 112.295 8.29806 112.295 8.70064V12H110.858V8.95703C110.86 8.63991 110.779 8.39252 110.615 8.21484C110.451 8.03492 110.225 7.94496 109.937 7.94496C109.744 7.94496 109.573 7.98656 109.424 8.06978C109.278 8.15299 109.164 8.27444 109.08 8.43413C108.999 8.59156 108.958 8.78161 108.955 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function of(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2002_5019",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2002_5019)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H50.1751V6.29528H47.0613V7.94158H49.8714V9.14595H47.0613V12H45.6005ZM54.1289 9.79368V6.81818H55.5661V12H54.1863V11.0588H54.1323C54.0153 11.3624 53.8208 11.6064 53.5487 11.7908C53.2788 11.9753 52.9493 12.0675 52.5602 12.0675C52.2138 12.0675 51.9091 11.9888 51.646 11.8313C51.3828 11.6739 51.177 11.4501 51.0286 11.16C50.8824 10.8699 50.8082 10.5224 50.8059 10.1175V6.81818H52.2431V9.86115C52.2453 10.167 52.3274 10.4088 52.4893 10.5865C52.6513 10.7641 52.8683 10.853 53.1404 10.853C53.3136 10.853 53.4756 10.8136 53.6262 10.7349C53.7769 10.6539 53.8984 10.5347 53.9906 10.3773C54.085 10.2199 54.1312 10.0253 54.1289 9.79368ZM58.1527 9.00426V12H56.7156V6.81818H58.0853V7.73242H58.146C58.2607 7.43105 58.453 7.19265 58.7229 7.01722C58.9928 6.83955 59.32 6.75071 59.7046 6.75071C60.0644 6.75071 60.3782 6.82943 60.6458 6.98686C60.9135 7.14429 61.1215 7.3692 61.2699 7.66158C61.4184 7.9517 61.4926 8.29806 61.4926 8.70064V12H60.0554V8.95703C60.0577 8.63991 59.9767 8.39252 59.8125 8.21484C59.6484 8.03492 59.4223 7.94496 59.1345 7.94496C58.941 7.94496 58.7701 7.98656 58.6217 8.06978C58.4755 8.15299 58.3608 8.27444 58.2776 8.43413C58.1966 8.59156 58.155 8.78161 58.1527 9.00426ZM64.9665 12.1012C64.4358 12.1012 63.9792 11.9888 63.5969 11.7638C63.2168 11.5367 62.9244 11.2218 62.7197 10.8192C62.5173 10.4167 62.4161 9.95336 62.4161 9.42933C62.4161 8.89856 62.5184 8.433 62.7231 8.03267C62.93 7.63009 63.2235 7.31635 63.6036 7.09144C63.9837 6.86429 64.4358 6.75071 64.9598 6.75071C65.4118 6.75071 65.8077 6.8328 66.1473 6.99698C66.4869 7.16116 66.7557 7.39169 66.9536 7.68857C67.1515 7.98544 67.2606 8.33404 67.2808 8.73438H65.9246C65.8864 8.47573 65.7852 8.2677 65.621 8.11026C65.4591 7.95058 65.2465 7.87074 64.9834 7.87074C64.7607 7.87074 64.5662 7.93146 64.3998 8.05291C64.2356 8.17211 64.1074 8.34641 64.0152 8.57582C63.923 8.80522 63.8769 9.08298 63.8769 9.40909C63.8769 9.7397 63.9218 10.0208 64.0118 10.2525C64.104 10.4841 64.2333 10.6607 64.3998 10.7821C64.5662 10.9036 64.7607 10.9643 64.9834 10.9643C65.1476 10.9643 65.2949 10.9306 65.4253 10.8631C65.558 10.7956 65.6671 10.6978 65.7526 10.5696C65.8403 10.4392 65.8976 10.2828 65.9246 10.1007H67.2808C67.2583 10.4965 67.1504 10.8451 66.9569 11.1465C66.7658 11.4456 66.5015 11.6795 66.1642 11.8482C65.8268 12.0169 65.4276 12.1012 64.9665 12.1012ZM68.2009 12V6.81818H69.6381V12H68.2009ZM68.9229 6.15021C68.7092 6.15021 68.5259 6.07937 68.373 5.93768C68.2223 5.79374 68.147 5.62169 68.147 5.42152C68.147 5.2236 68.2223 5.0538 68.373 4.91211C68.5259 4.76817 68.7092 4.6962 68.9229 4.6962C69.1366 4.6962 69.3187 4.76817 69.4694 4.91211C69.6224 5.0538 69.6988 5.2236 69.6988 5.42152C69.6988 5.62169 69.6224 5.79374 69.4694 5.93768C69.3187 6.07937 69.1366 6.15021 68.9229 6.15021ZM73.1306 12.1012C72.6066 12.1012 72.1534 11.9899 71.771 11.7672C71.391 11.5423 71.0974 11.2297 70.8905 10.8294C70.6836 10.4268 70.5802 9.96011 70.5802 9.42933C70.5802 8.89406 70.6836 8.42625 70.8905 8.02592C71.0974 7.62334 71.391 7.31072 71.771 7.08807C72.1534 6.86316 72.6066 6.75071 73.1306 6.75071C73.6546 6.75071 74.1067 6.86316 74.4868 7.08807C74.8691 7.31072 75.1637 7.62334 75.3706 8.02592C75.5776 8.42625 75.681 8.89406 75.681 9.42933C75.681 9.96011 75.5776 10.4268 75.3706 10.8294C75.1637 11.2297 74.8691 11.5423 74.4868 11.7672C74.1067 11.9899 73.6546 12.1012 73.1306 12.1012ZM73.1373 10.9879C73.3757 10.9879 73.5748 10.9205 73.7345 10.7855C73.8941 10.6483 74.0145 10.4616 74.0954 10.2255C74.1787 9.98935 74.2203 9.72058 74.2203 9.41921C74.2203 9.11784 74.1787 8.84908 74.0954 8.61293C74.0145 8.37678 73.8941 8.1901 73.7345 8.05291C73.5748 7.91572 73.3757 7.84712 73.1373 7.84712C72.8967 7.84712 72.6943 7.91572 72.5301 8.05291C72.3682 8.1901 72.2456 8.37678 72.1624 8.61293C72.0814 8.84908 72.0409 9.11784 72.0409 9.41921C72.0409 9.72058 72.0814 9.98935 72.1624 10.2255C72.2456 10.4616 72.3682 10.6483 72.5301 10.7855C72.6943 10.9205 72.8967 10.9879 73.1373 10.9879ZM78.0526 9.00426V12H76.6155V6.81818H77.9852V7.73242H78.0459C78.1606 7.43105 78.3529 7.19265 78.6228 7.01722C78.8927 6.83955 79.2199 6.75071 79.6045 6.75071C79.9643 6.75071 80.2781 6.82943 80.5457 6.98686C80.8134 7.14429 81.0214 7.3692 81.1698 7.66158C81.3183 7.9517 81.3925 8.29806 81.3925 8.70064V12H79.9553V8.95703C79.9576 8.63991 79.8766 8.39252 79.7124 8.21484C79.5483 8.03492 79.3222 7.94496 79.0344 7.94496C78.8409 7.94496 78.67 7.98656 78.5216 8.06978C78.3754 8.15299 78.2607 8.27444 78.1775 8.43413C78.0965 8.59156 78.0549 8.78161 78.0526 9.00426ZM84.0028 12.0978C83.6722 12.0978 83.3776 12.0405 83.1189 11.9258C82.8603 11.8088 82.6556 11.6368 82.5049 11.4096C82.3565 11.1802 82.2823 10.8946 82.2823 10.5527C82.2823 10.2649 82.3351 10.0231 82.4408 9.82741C82.5465 9.63175 82.6905 9.47431 82.8726 9.35511C83.0548 9.23591 83.2617 9.14595 83.4934 9.08523C83.7273 9.0245 83.9724 8.98177 84.2288 8.95703C84.5302 8.92554 84.7731 8.89631 84.9575 8.86932C85.1419 8.84008 85.2758 8.79735 85.359 8.74112C85.4422 8.6849 85.4838 8.60168 85.4838 8.49148V8.47124C85.4838 8.25758 85.4163 8.09227 85.2814 7.97532C85.1487 7.85837 84.9598 7.79989 84.7146 7.79989C84.456 7.79989 84.2502 7.85724 84.0973 7.97195C83.9443 8.0844 83.8431 8.22609 83.7936 8.39702L82.4644 8.28906C82.5319 7.97419 82.6646 7.70206 82.8625 7.47266C83.0604 7.241 83.3157 7.06333 83.6283 6.93963C83.9432 6.81368 84.3075 6.75071 84.7214 6.75071C85.0092 6.75071 85.2848 6.78445 85.5479 6.85192C85.8133 6.91939 86.0483 7.02397 86.253 7.16566C86.4599 7.30735 86.6229 7.48952 86.7421 7.71218C86.8613 7.93259 86.9209 8.19685 86.9209 8.50497V12H85.558V11.2814H85.5175C85.4343 11.4434 85.323 11.5862 85.1835 11.7099C85.0441 11.8313 84.8766 11.9269 84.6809 11.9966C84.4852 12.0641 84.2592 12.0978 84.0028 12.0978ZM84.4144 11.106C84.6258 11.106 84.8125 11.0644 84.9744 10.9812C85.1363 10.8957 85.2634 10.781 85.3556 10.6371C85.4478 10.4931 85.4939 10.3301 85.4939 10.1479V9.59801C85.4489 9.62725 85.3871 9.65424 85.3084 9.67898C85.2319 9.70147 85.1453 9.72283 85.0486 9.74308C84.9519 9.76107 84.8552 9.77794 84.7585 9.79368C84.6618 9.80717 84.5741 9.81954 84.4953 9.83079C84.3267 9.85553 84.1793 9.89489 84.0534 9.94886C83.9275 10.0028 83.8296 10.0759 83.7599 10.1681C83.6902 10.2581 83.6553 10.3706 83.6553 10.5055C83.6553 10.7012 83.7262 10.8507 83.8679 10.9542C84.0118 11.0554 84.194 11.106 84.4144 11.106ZM92.5759 12.1012C92.0451 12.1012 91.5886 11.9888 91.2062 11.7638C90.8261 11.5367 90.5338 11.2218 90.3291 10.8192C90.1267 10.4167 90.0255 9.95336 90.0255 9.42933C90.0255 8.89856 90.1278 8.433 90.3325 8.03267C90.5394 7.63009 90.8329 7.31635 91.213 7.09144C91.5931 6.86429 92.0451 6.75071 92.5692 6.75071C93.0212 6.75071 93.4171 6.8328 93.7567 6.99698C94.0963 7.16116 94.365 7.39169 94.5629 7.68857C94.7609 7.98544 94.8699 8.33404 94.8902 8.73438H93.534C93.4958 8.47573 93.3946 8.2677 93.2304 8.11026C93.0684 7.95058 92.8559 7.87074 92.5928 7.87074C92.3701 7.87074 92.1756 7.93146 92.0091 8.05291C91.845 8.17211 91.7168 8.34641 91.6246 8.57582C91.5323 8.80522 91.4862 9.08298 91.4862 9.40909C91.4862 9.7397 91.5312 10.0208 91.6212 10.2525C91.7134 10.4841 91.8427 10.6607 92.0091 10.7821C92.1756 10.9036 92.3701 10.9643 92.5928 10.9643C92.757 10.9643 92.9043 10.9306 93.0347 10.8631C93.1674 10.7956 93.2765 10.6978 93.3619 10.5696C93.4497 10.4392 93.507 10.2828 93.534 10.1007H94.8902C94.8677 10.4965 94.7597 10.8451 94.5663 11.1465C94.3751 11.4456 94.1109 11.6795 93.7735 11.8482C93.4362 12.0169 93.037 12.1012 92.5759 12.1012ZM98.1516 12.1012C97.6276 12.1012 97.1744 11.9899 96.792 11.7672C96.4119 11.5423 96.1184 11.2297 95.9115 10.8294C95.7046 10.4268 95.6012 9.96011 95.6012 9.42933C95.6012 8.89406 95.7046 8.42625 95.9115 8.02592C96.1184 7.62334 96.4119 7.31072 96.792 7.08807C97.1744 6.86316 97.6276 6.75071 98.1516 6.75071C98.6756 6.75071 99.1277 6.86316 99.5078 7.08807C99.8901 7.31072 100.185 7.62334 100.392 8.02592C100.599 8.42625 100.702 8.89406 100.702 9.42933C100.702 9.96011 100.599 10.4268 100.392 10.8294C100.185 11.2297 99.8901 11.5423 99.5078 11.7672C99.1277 11.9899 98.6756 12.1012 98.1516 12.1012ZM98.1583 10.9879C98.3967 10.9879 98.5958 10.9205 98.7555 10.7855C98.9151 10.6483 99.0355 10.4616 99.1164 10.2255C99.1996 9.98935 99.2413 9.72058 99.2413 9.41921C99.2413 9.11784 99.1996 8.84908 99.1164 8.61293C99.0355 8.37678 98.9151 8.1901 98.7555 8.05291C98.5958 7.91572 98.3967 7.84712 98.1583 7.84712C97.9177 7.84712 97.7153 7.91572 97.5511 8.05291C97.3892 8.1901 97.2666 8.37678 97.1834 8.61293C97.1024 8.84908 97.0619 9.11784 97.0619 9.41921C97.0619 9.72058 97.1024 9.98935 97.1834 10.2255C97.2666 10.4616 97.3892 10.6483 97.5511 10.7855C97.7153 10.9205 97.9177 10.9879 98.1583 10.9879ZM103.074 9.00426V12H101.636V6.81818H103.006V7.73242H103.067C103.182 7.43105 103.374 7.19265 103.644 7.01722C103.914 6.83955 104.241 6.75071 104.625 6.75071C104.985 6.75071 105.299 6.82943 105.567 6.98686C105.834 7.14429 106.042 7.3692 106.191 7.66158C106.339 7.9517 106.413 8.29806 106.413 8.70064V12H104.976V8.95703C104.979 8.63991 104.898 8.39252 104.733 8.21484C104.569 8.03492 104.343 7.94496 104.055 7.94496C103.862 7.94496 103.691 7.98656 103.543 8.06978C103.396 8.15299 103.282 8.27444 103.198 8.43413C103.117 8.59156 103.076 8.78161 103.074 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function sf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2002_4995",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2002_4995)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8481 5.09091 49.2934 5.18424 49.6623 5.37092C50.0334 5.55534 50.3156 5.81735 50.5091 6.15696C50.7047 6.49432 50.8026 6.89128 50.8026 7.34783C50.8026 7.80664 50.7036 8.20135 50.5057 8.53196C50.3078 8.86032 50.021 9.11222 49.6454 9.28764C49.2721 9.46307 48.82 9.55078 48.2892 9.55078H46.4641V8.37678H48.0531C48.332 8.37678 48.5636 8.33854 48.748 8.26207C48.9325 8.18561 49.0697 8.0709 49.1596 7.91797C49.2518 7.76503 49.2979 7.57499 49.2979 7.34783C49.2979 7.11843 49.2518 6.92501 49.1596 6.76758C49.0697 6.61014 48.9313 6.49094 48.7447 6.40998C48.5603 6.32676 48.3275 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM49.3317 8.85582L51.0488 12H49.4363L47.7562 8.85582H49.3317ZM54.0859 12.1012C53.5529 12.1012 53.0941 11.9933 52.7095 11.7773C52.3271 11.5592 52.0325 11.2511 51.8256 10.853C51.6187 10.4527 51.5152 9.97923 51.5152 9.43271C51.5152 8.89968 51.6187 8.43188 51.8256 8.0293C52.0325 7.62672 52.3238 7.31297 52.6994 7.08807C53.0772 6.86316 53.5203 6.75071 54.0285 6.75071C54.3704 6.75071 54.6886 6.80581 54.9833 6.91602C55.2801 7.02397 55.5388 7.18703 55.7592 7.40518C55.9818 7.62334 56.155 7.89773 56.2787 8.22834C56.4024 8.5567 56.4643 8.94129 56.4643 9.3821V9.77681H52.0887V8.88619H55.1115C55.1115 8.67927 55.0665 8.49598 54.9765 8.33629C54.8866 8.17661 54.7617 8.05179 54.6021 7.96183C54.4446 7.86961 54.2613 7.82351 54.0522 7.82351C53.834 7.82351 53.6406 7.87411 53.4719 7.97532C53.3055 8.07428 53.175 8.2081 53.0806 8.37678C52.9861 8.54321 52.9378 8.72875 52.9355 8.93342V9.78018C52.9355 10.0366 52.9827 10.2581 53.0772 10.4448C53.1739 10.6315 53.31 10.7754 53.4854 10.8766C53.6608 10.9778 53.8689 11.0284 54.1095 11.0284C54.2692 11.0284 54.4154 11.0059 54.5481 10.9609C54.6808 10.916 54.7943 10.8485 54.8888 10.7585C54.9833 10.6686 55.0552 10.5584 55.1047 10.4279L56.4339 10.5156C56.3664 10.835 56.2281 11.1139 56.019 11.3523C55.812 11.5884 55.5444 11.7728 55.216 11.9055C54.8899 12.036 54.5132 12.1012 54.0859 12.1012ZM53.4786 6.15021L54.1938 4.61523H55.523L54.4941 6.15021H53.4786ZM58.8797 12.0978C58.5491 12.0978 58.2545 12.0405 57.9959 11.9258C57.7372 11.8088 57.5326 11.6368 57.3819 11.4096C57.2334 11.1802 57.1592 10.8946 57.1592 10.5527C57.1592 10.2649 57.2121 10.0231 57.3178 9.82741C57.4235 9.63175 57.5674 9.47431 57.7496 9.35511C57.9318 9.23591 58.1387 9.14595 58.3703 9.08523C58.6042 9.0245 58.8494 8.98177 59.1058 8.95703C59.4072 8.92554 59.6501 8.89631 59.8345 8.86932C60.0189 8.84008 60.1527 8.79735 60.2359 8.74112C60.3191 8.6849 60.3608 8.60168 60.3608 8.49148V8.47124C60.3608 8.25758 60.2933 8.09227 60.1583 7.97532C60.0256 7.85837 59.8367 7.79989 59.5916 7.79989C59.3329 7.79989 59.1271 7.85724 58.9742 7.97195C58.8213 8.0844 58.7201 8.22609 58.6706 8.39702L57.3414 8.28906C57.4089 7.97419 57.5416 7.70206 57.7395 7.47266C57.9374 7.241 58.1927 7.06333 58.5053 6.93963C58.8201 6.81368 59.1845 6.75071 59.5983 6.75071C59.8862 6.75071 60.1617 6.78445 60.4248 6.85192C60.6902 6.91939 60.9253 7.02397 61.1299 7.16566C61.3368 7.30735 61.4999 7.48952 61.6191 7.71218C61.7383 7.93259 61.7979 8.19685 61.7979 8.50497V12H60.435V11.2814H60.3945C60.3113 11.4434 60.1999 11.5862 60.0605 11.7099C59.9211 11.8313 59.7535 11.9269 59.5578 11.9966C59.3622 12.0641 59.1361 12.0978 58.8797 12.0978ZM59.2913 11.106C59.5027 11.106 59.6894 11.0644 59.8513 10.9812C60.0133 10.8957 60.1403 10.781 60.2326 10.6371C60.3248 10.4931 60.3709 10.3301 60.3709 10.1479V9.59801C60.3259 9.62725 60.264 9.65424 60.1853 9.67898C60.1089 9.70147 60.0223 9.72283 59.9256 9.74308C59.8289 9.76107 59.7321 9.77794 59.6354 9.79368C59.5387 9.80717 59.451 9.81954 59.3723 9.83079C59.2036 9.85553 59.0563 9.89489 58.9304 9.94886C58.8044 10.0028 58.7066 10.0759 58.6369 10.1681C58.5671 10.2581 58.5323 10.3706 58.5323 10.5055C58.5323 10.7012 58.6031 10.8507 58.7448 10.9542C58.8887 11.0554 59.0709 11.106 59.2913 11.106ZM64.35 5.09091V12H62.9129V5.09091H64.35ZM65.5012 12V6.81818H66.9384V12H65.5012ZM66.2232 6.15021C66.0095 6.15021 65.8262 6.07937 65.6733 5.93768C65.5226 5.79374 65.4473 5.62169 65.4473 5.42152C65.4473 5.2236 65.5226 5.0538 65.6733 4.91211C65.8262 4.76817 66.0095 4.6962 66.2232 4.6962C66.4368 4.6962 66.619 4.76817 66.7697 4.91211C66.9226 5.0538 66.9991 5.2236 66.9991 5.42152C66.9991 5.62169 66.9226 5.79374 66.7697 5.93768C66.619 6.07937 66.4368 6.15021 66.2232 6.15021ZM72.4011 8.29581L71.0854 8.37678C71.0629 8.26432 71.0145 8.16312 70.9403 8.07315C70.8661 7.98094 70.7682 7.90785 70.6468 7.85387C70.5276 7.79764 70.3848 7.76953 70.2184 7.76953C69.9957 7.76953 69.8079 7.81676 69.655 7.91122C69.502 8.00343 69.4256 8.12713 69.4256 8.28232C69.4256 8.40601 69.475 8.51059 69.574 8.59606C69.673 8.68152 69.8428 8.75012 70.0834 8.80185L71.0213 8.99077C71.5251 9.09422 71.9006 9.26065 72.148 9.49006C72.3954 9.71946 72.5191 10.0208 72.5191 10.3942C72.5191 10.7338 72.419 11.0318 72.2189 11.2882C72.021 11.5446 71.7488 11.7447 71.4025 11.8887C71.0584 12.0304 70.6614 12.1012 70.2116 12.1012C69.5256 12.1012 68.9791 11.9584 68.572 11.6728C68.1672 11.3849 67.9299 10.9935 67.8602 10.4988L69.2737 10.4245C69.3165 10.6337 69.4199 10.7934 69.5841 10.9036C69.7483 11.0115 69.9586 11.0655 70.215 11.0655C70.4669 11.0655 70.6693 11.0172 70.8222 10.9205C70.9774 10.8215 71.0561 10.6944 71.0584 10.5392C71.0561 10.4088 71.001 10.302 70.8931 10.2188C70.7851 10.1333 70.6187 10.0681 70.3938 10.0231L69.4964 9.84428C68.9904 9.74308 68.6137 9.56765 68.3663 9.318C68.1211 9.06836 67.9985 8.75012 67.9985 8.36328C67.9985 8.03042 68.0885 7.74367 68.2684 7.50302C68.4506 7.26237 68.7059 7.07682 69.0342 6.94638C69.3648 6.81593 69.7517 6.75071 70.1947 6.75071C70.8492 6.75071 71.3642 6.88903 71.7398 7.16566C72.1177 7.44229 72.3381 7.81901 72.4011 8.29581ZM75.7856 12.1012C75.2526 12.1012 74.7938 11.9933 74.4092 11.7773C74.0268 11.5592 73.7322 11.2511 73.5253 10.853C73.3184 10.4527 73.2149 9.97923 73.2149 9.43271C73.2149 8.89968 73.3184 8.43188 73.5253 8.0293C73.7322 7.62672 74.0235 7.31297 74.3991 7.08807C74.7769 6.86316 75.22 6.75071 75.7282 6.75071C76.0701 6.75071 76.3883 6.80581 76.683 6.91602C76.9798 7.02397 77.2385 7.18703 77.4589 7.40518C77.6816 7.62334 77.8547 7.89773 77.9784 8.22834C78.1021 8.5567 78.164 8.94129 78.164 9.3821V9.77681H73.7884V8.88619H76.8112C76.8112 8.67927 76.7662 8.49598 76.6762 8.33629C76.5863 8.17661 76.4614 8.05179 76.3018 7.96183C76.1443 7.86961 75.961 7.82351 75.7519 7.82351C75.5337 7.82351 75.3403 7.87411 75.1716 7.97532C75.0052 8.07428 74.8747 8.2081 74.7803 8.37678C74.6858 8.54321 74.6375 8.72875 74.6352 8.93342V9.78018C74.6352 10.0366 74.6824 10.2581 74.7769 10.4448C74.8736 10.6315 75.0097 10.7754 75.1851 10.8766C75.3605 10.9778 75.5686 11.0284 75.8092 11.0284C75.9689 11.0284 76.1151 11.0059 76.2478 10.9609C76.3805 10.916 76.4941 10.8485 76.5885 10.7585C76.683 10.6686 76.7549 10.5584 76.8044 10.4279L78.1336 10.5156C78.0661 10.835 77.9278 11.1139 77.7187 11.3523C77.5117 11.5884 77.2441 11.7728 76.9157 11.9055C76.5896 12.036 76.2129 12.1012 75.7856 12.1012ZM75.1784 6.15021L75.8936 4.61523H77.2227L76.1938 6.15021H75.1784ZM82.7782 12.0978C82.4476 12.0978 82.153 12.0405 81.8943 11.9258C81.6357 11.8088 81.431 11.6368 81.2803 11.4096C81.1319 11.1802 81.0577 10.8946 81.0577 10.5527C81.0577 10.2649 81.1105 10.0231 81.2162 9.82741C81.3219 9.63175 81.4659 9.47431 81.648 9.35511C81.8302 9.23591 82.0371 9.14595 82.2688 9.08523C82.5027 9.0245 82.7478 8.98177 83.0042 8.95703C83.3056 8.92554 83.5485 8.89631 83.7329 8.86932C83.9173 8.84008 84.0512 8.79735 84.1344 8.74112C84.2176 8.6849 84.2592 8.60168 84.2592 8.49148V8.47124C84.2592 8.25758 84.1917 8.09227 84.0568 7.97532C83.9241 7.85837 83.7352 7.79989 83.49 7.79989C83.2314 7.79989 83.0256 7.85724 82.8726 7.97195C82.7197 8.0844 82.6185 8.22609 82.569 8.39702L81.2398 8.28906C81.3073 7.97419 81.44 7.70206 81.6379 7.47266C81.8358 7.241 82.0911 7.06333 82.4037 6.93963C82.7186 6.81368 83.0829 6.75071 83.4968 6.75071C83.7846 6.75071 84.0601 6.78445 84.3233 6.85192C84.5887 6.91939 84.8237 7.02397 85.0284 7.16566C85.2353 7.30735 85.3983 7.48952 85.5175 7.71218C85.6367 7.93259 85.6963 8.19685 85.6963 8.50497V12H84.3334V11.2814H84.2929C84.2097 11.4434 84.0984 11.5862 83.9589 11.7099C83.8195 11.8313 83.6519 11.9269 83.4563 11.9966C83.2606 12.0641 83.0346 12.0978 82.7782 12.0978ZM83.1898 11.106C83.4012 11.106 83.5878 11.0644 83.7498 10.9812C83.9117 10.8957 84.0388 10.781 84.131 10.6371C84.2232 10.4931 84.2693 10.3301 84.2693 10.1479V9.59801C84.2243 9.62725 84.1625 9.65424 84.0838 9.67898C84.0073 9.70147 83.9207 9.72283 83.824 9.74308C83.7273 9.76107 83.6306 9.77794 83.5339 9.79368C83.4372 9.80717 83.3494 9.81954 83.2707 9.83079C83.1021 9.85553 82.9547 9.89489 82.8288 9.94886C82.7028 10.0028 82.605 10.0759 82.5353 10.1681C82.4656 10.2581 82.4307 10.3706 82.4307 10.5055C82.4307 10.7012 82.5016 10.8507 82.6432 10.9542C82.7872 11.0554 82.9694 11.106 83.1898 11.106ZM91.4567 6.81818L89.6451 12H88.0258L86.2142 6.81818H87.7323L88.8085 10.5257H88.8624L89.9352 6.81818H91.4567ZM94.3867 12.1012C93.8536 12.1012 93.3948 11.9933 93.0103 11.7773C92.6279 11.5592 92.3333 11.2511 92.1264 10.853C91.9195 10.4527 91.816 9.97923 91.816 9.43271C91.816 8.89968 91.9195 8.43188 92.1264 8.0293C92.3333 7.62672 92.6245 7.31297 93.0001 7.08807C93.378 6.86316 93.821 6.75071 94.3293 6.75071C94.6712 6.75071 94.9894 6.80581 95.284 6.91602C95.5809 7.02397 95.8396 7.18703 96.06 7.40518C96.2826 7.62334 96.4558 7.89773 96.5795 8.22834C96.7032 8.5567 96.765 8.94129 96.765 9.3821V9.77681H92.3895V8.88619H95.4122C95.4122 8.67927 95.3673 8.49598 95.2773 8.33629C95.1873 8.17661 95.0625 8.05179 94.9028 7.96183C94.7454 7.86961 94.5621 7.82351 94.3529 7.82351C94.1348 7.82351 93.9414 7.87411 93.7727 7.97532C93.6063 8.07428 93.4758 8.2081 93.3813 8.37678C93.2869 8.54321 93.2385 8.72875 93.2363 8.93342V9.78018C93.2363 10.0366 93.2835 10.2581 93.378 10.4448C93.4747 10.6315 93.6108 10.7754 93.7862 10.8766C93.9616 10.9778 94.1696 11.0284 94.4103 11.0284C94.57 11.0284 94.7162 11.0059 94.8489 10.9609C94.9815 10.916 95.0951 10.8485 95.1896 10.7585C95.284 10.6686 95.356 10.5584 95.4055 10.4279L96.7347 10.5156C96.6672 10.835 96.5289 11.1139 96.3197 11.3523C96.1128 11.5884 95.8452 11.7728 95.5168 11.9055C95.1907 12.036 94.814 12.1012 94.3867 12.1012ZM100.044 12.1012C99.5134 12.1012 99.0568 11.9888 98.6745 11.7638C98.2944 11.5367 98.002 11.2218 97.7974 10.8192C97.5949 10.4167 97.4937 9.95336 97.4937 9.42933C97.4937 8.89856 97.5961 8.433 97.8007 8.03267C98.0076 7.63009 98.3012 7.31635 98.6812 7.09144C99.0613 6.86429 99.5134 6.75071 100.037 6.75071C100.489 6.75071 100.885 6.8328 101.225 6.99698C101.565 7.16116 101.833 7.39169 102.031 7.68857C102.229 7.98544 102.338 8.33404 102.358 8.73438H101.002C100.964 8.47573 100.863 8.2677 100.699 8.11026C100.537 7.95058 100.324 7.87074 100.061 7.87074C99.8384 7.87074 99.6438 7.93146 99.4774 8.05291C99.3132 8.17211 99.185 8.34641 99.0928 8.57582C99.0006 8.80522 98.9545 9.08298 98.9545 9.40909C98.9545 9.7397 98.9995 10.0208 99.0894 10.2525C99.1817 10.4841 99.311 10.6607 99.4774 10.7821C99.6438 10.9036 99.8384 10.9643 100.061 10.9643C100.225 10.9643 100.373 10.9306 100.503 10.8631C100.636 10.7956 100.745 10.6978 100.83 10.5696C100.918 10.4392 100.975 10.2828 101.002 10.1007H102.358C102.336 10.4965 102.228 10.8451 102.035 11.1465C101.843 11.4456 101.579 11.6795 101.242 11.8482C100.904 12.0169 100.505 12.1012 100.044 12.1012Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function J0(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2001_4947",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2001_4947)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M46.1005 12V5.09091H48.8263C49.3504 5.09091 49.7968 5.19099 50.1657 5.39116C50.5345 5.58907 50.8156 5.86458 51.0091 6.21768C51.2047 6.56854 51.3026 6.97337 51.3026 7.43217C51.3026 7.89098 51.2036 8.29581 51.0057 8.64666C50.8078 8.99751 50.521 9.27077 50.1454 9.46644C49.7721 9.66211 49.32 9.75994 48.7892 9.75994H47.0518V8.58931H48.5531C48.8342 8.58931 49.0659 8.54096 49.248 8.44425C49.4325 8.34529 49.5697 8.20922 49.6596 8.03604C49.7518 7.86062 49.7979 7.65933 49.7979 7.43217C49.7979 7.20277 49.7518 7.0026 49.6596 6.83168C49.5697 6.6585 49.4325 6.52468 49.248 6.43022C49.0636 6.33351 48.8297 6.28516 48.5463 6.28516H47.5613V12H46.1005ZM54.4822 12.1012C53.9581 12.1012 53.5049 11.9899 53.1226 11.7672C52.7425 11.5423 52.449 11.2297 52.2421 10.8294C52.0352 10.4268 51.9317 9.96011 51.9317 9.42933C51.9317 8.89406 52.0352 8.42625 52.2421 8.02592C52.449 7.62334 52.7425 7.31072 53.1226 7.08807C53.5049 6.86316 53.9581 6.75071 54.4822 6.75071C55.0062 6.75071 55.4582 6.86316 55.8383 7.08807C56.2207 7.31072 56.5153 7.62334 56.7222 8.02592C56.9291 8.42625 57.0326 8.89406 57.0326 9.42933C57.0326 9.96011 56.9291 10.4268 56.7222 10.8294C56.5153 11.2297 56.2207 11.5423 55.8383 11.7672C55.4582 11.9899 55.0062 12.1012 54.4822 12.1012ZM54.4889 10.9879C54.7273 10.9879 54.9263 10.9205 55.086 10.7855C55.2457 10.6483 55.366 10.4616 55.447 10.2255C55.5302 9.98935 55.5718 9.72058 55.5718 9.41921C55.5718 9.11784 55.5302 8.84908 55.447 8.61293C55.366 8.37678 55.2457 8.1901 55.086 8.05291C54.9263 7.91572 54.7273 7.84712 54.4889 7.84712C54.2483 7.84712 54.0458 7.91572 53.8817 8.05291C53.7197 8.1901 53.5972 8.37678 53.5139 8.61293C53.433 8.84908 53.3925 9.11784 53.3925 9.41921C53.3925 9.72058 53.433 9.98935 53.5139 10.2255C53.5972 10.4616 53.7197 10.6483 53.8817 10.7855C54.0458 10.9205 54.2483 10.9879 54.4889 10.9879ZM58.8594 12L57.4492 6.81818H58.9032L59.7061 10.2997H59.7534L60.59 6.81818H62.017L62.8672 10.2795H62.911L63.7005 6.81818H65.1511L63.7443 12H62.2228L61.3322 8.74112H61.2681L60.3775 12H58.8594ZM68.1494 12.1012C67.6163 12.1012 67.1575 11.9933 66.7729 11.7773C66.3906 11.5592 66.096 11.2511 65.8891 10.853C65.6822 10.4527 65.5787 9.97923 65.5787 9.43271C65.5787 8.89968 65.6822 8.43188 65.8891 8.0293C66.096 7.62672 66.3872 7.31297 66.7628 7.08807C67.1407 6.86316 67.5837 6.75071 68.092 6.75071C68.4339 6.75071 68.7521 6.80581 69.0467 6.91602C69.3436 7.02397 69.6023 7.18703 69.8227 7.40518C70.0453 7.62334 70.2185 7.89773 70.3422 8.22834C70.4659 8.5567 70.5277 8.94129 70.5277 9.3821V9.77681H66.1522V8.88619H69.1749C69.1749 8.67927 69.13 8.49598 69.04 8.33629C68.95 8.17661 68.8252 8.05179 68.6655 7.96183C68.5081 7.86961 68.3248 7.82351 68.1156 7.82351C67.8975 7.82351 67.7041 7.87411 67.5354 7.97532C67.3689 8.07428 67.2385 8.2081 67.144 8.37678C67.0496 8.54321 67.0012 8.72875 66.999 8.93342V9.78018C66.999 10.0366 67.0462 10.2581 67.1407 10.4448C67.2374 10.6315 67.3734 10.7754 67.5489 10.8766C67.7243 10.9778 67.9323 11.0284 68.173 11.0284C68.3327 11.0284 68.4789 11.0059 68.6116 10.9609C68.7442 10.916 68.8578 10.8485 68.9523 10.7585C69.0467 10.6686 69.1187 10.5584 69.1682 10.4279L70.4974 10.5156C70.4299 10.835 70.2916 11.1139 70.0824 11.3523C69.8755 11.5884 69.6079 11.7728 69.2795 11.9055C68.9534 12.036 68.5767 12.1012 68.1494 12.1012ZM71.4656 12V6.81818H72.8589V7.7223H72.9129C73.0073 7.40069 73.1659 7.15779 73.3885 6.99361C73.6112 6.82718 73.8676 6.74396 74.1577 6.74396C74.2297 6.74396 74.3073 6.74846 74.3905 6.75746C74.4737 6.76645 74.5468 6.77882 74.6098 6.79457V8.06978C74.5423 8.04954 74.449 8.03155 74.3298 8.0158C74.2106 8.00006 74.1015 7.99219 74.0025 7.99219C73.7911 7.99219 73.6022 8.03829 73.4358 8.1305C73.2716 8.22047 73.1411 8.34641 73.0444 8.50835C72.95 8.67028 72.9027 8.85695 72.9027 9.06836V12H71.4656ZM77.4731 12.1012C76.9401 12.1012 76.4813 11.9933 76.0967 11.7773C75.7143 11.5592 75.4197 11.2511 75.2128 10.853C75.0059 10.4527 74.9024 9.97923 74.9024 9.43271C74.9024 8.89968 75.0059 8.43188 75.2128 8.0293C75.4197 7.62672 75.711 7.31297 76.0866 7.08807C76.4644 6.86316 76.9075 6.75071 77.4157 6.75071C77.7576 6.75071 78.0758 6.80581 78.3705 6.91602C78.6673 7.02397 78.926 7.18703 79.1464 7.40518C79.3691 7.62334 79.5422 7.89773 79.6659 8.22834C79.7896 8.5567 79.8515 8.94129 79.8515 9.3821V9.77681H75.4759V8.88619H78.4987C78.4987 8.67927 78.4537 8.49598 78.3637 8.33629C78.2738 8.17661 78.1489 8.05179 77.9893 7.96183C77.8318 7.86961 77.6485 7.82351 77.4394 7.82351C77.2212 7.82351 77.0278 7.87411 76.8591 7.97532C76.6927 8.07428 76.5622 8.2081 76.4678 8.37678C76.3733 8.54321 76.325 8.72875 76.3227 8.93342V9.78018C76.3227 10.0366 76.3699 10.2581 76.4644 10.4448C76.5611 10.6315 76.6972 10.7754 76.8726 10.8766C77.048 10.9778 77.2561 11.0284 77.4967 11.0284C77.6564 11.0284 77.8026 11.0059 77.9353 10.9609C78.068 10.916 78.1816 10.8485 78.276 10.7585C78.3705 10.6686 78.4424 10.5584 78.4919 10.4279L79.8211 10.5156C79.7536 10.835 79.6153 11.1139 79.4062 11.3523C79.1992 11.5884 78.9316 11.7728 78.6032 11.9055C78.2771 12.036 77.9004 12.1012 77.4731 12.1012ZM82.6988 12.0843C82.3052 12.0843 81.9487 11.9831 81.6294 11.7807C81.3122 11.5761 81.0603 11.2758 80.8737 10.88C80.6892 10.4819 80.597 9.99384 80.597 9.41584C80.597 8.82209 80.6926 8.32842 80.8838 7.93484C81.075 7.539 81.3291 7.24325 81.6462 7.04759C81.9656 6.84967 82.3153 6.75071 82.6954 6.75071C82.9855 6.75071 83.2273 6.80019 83.4207 6.89915C83.6164 6.99586 83.7738 7.11731 83.893 7.26349C84.0145 7.40743 84.1067 7.54912 84.1697 7.68857H84.2135V5.09091H85.6473V12H84.2304V11.1701H84.1697C84.1022 11.314 84.0066 11.4569 83.8829 11.5985C83.7615 11.738 83.6029 11.8538 83.4072 11.946C83.2138 12.0382 82.9777 12.0843 82.6988 12.0843ZM83.1542 10.9407C83.3859 10.9407 83.5815 10.8777 83.7412 10.7518C83.9031 10.6236 84.0268 10.4448 84.1123 10.2154C84.2 9.98597 84.2439 9.71721 84.2439 9.40909C84.2439 9.10097 84.2011 8.83333 84.1157 8.60618C84.0302 8.37902 83.9065 8.2036 83.7446 8.0799C83.5827 7.9562 83.3859 7.89435 83.1542 7.89435C82.9181 7.89435 82.719 7.95845 82.5571 8.08665C82.3952 8.21484 82.2726 8.39252 82.1894 8.61967C82.1061 8.84683 82.0645 9.10997 82.0645 9.40909C82.0645 9.71046 82.1061 9.97698 82.1894 10.2086C82.2748 10.438 82.3974 10.618 82.5571 10.7484C82.719 10.8766 82.9181 10.9407 83.1542 10.9407ZM89.0546 12V5.09091H90.4917V7.68857H90.5356C90.5986 7.54912 90.6897 7.40743 90.8089 7.26349C90.9303 7.11731 91.0877 6.99586 91.2812 6.89915C91.4768 6.80019 91.7197 6.75071 92.0099 6.75071C92.3877 6.75071 92.7363 6.84967 93.0557 7.04759C93.375 7.24325 93.6303 7.539 93.8215 7.93484C94.0126 8.32842 94.1082 8.82209 94.1082 9.41584C94.1082 9.99384 94.0149 10.4819 93.8282 10.88C93.6438 11.2758 93.3919 11.5761 93.0725 11.7807C92.7554 11.9831 92.4001 12.0843 92.0065 12.0843C91.7276 12.0843 91.4903 12.0382 91.2947 11.946C91.1012 11.8538 90.9427 11.738 90.819 11.5985C90.6953 11.4569 90.6008 11.314 90.5356 11.1701H90.4715V12H89.0546ZM90.4614 9.40909C90.4614 9.71721 90.5041 9.98597 90.5896 10.2154C90.675 10.4448 90.7987 10.6236 90.9607 10.7518C91.1226 10.8777 91.3194 10.9407 91.551 10.9407C91.7849 10.9407 91.9829 10.8766 92.1448 10.7484C92.3067 10.618 92.4293 10.438 92.5125 10.2086C92.598 9.97698 92.6407 9.71046 92.6407 9.40909C92.6407 9.10997 92.5991 8.84683 92.5159 8.61967C92.4327 8.39252 92.3101 8.21484 92.1482 8.08665C91.9862 7.95845 91.7872 7.89435 91.551 7.89435C91.3171 7.89435 91.1192 7.9562 90.9573 8.0799C90.7976 8.2036 90.675 8.37902 90.5896 8.60618C90.5041 8.83333 90.4614 9.10097 90.4614 9.40909ZM95.7874 13.9432C95.6052 13.9432 95.4343 13.9286 95.2746 13.8993C95.1172 13.8723 94.9868 13.8375 94.8833 13.7947L95.2072 12.7219C95.3758 12.7737 95.5277 12.8018 95.6626 12.8063C95.7998 12.8108 95.9179 12.7793 96.0168 12.7118C96.118 12.6444 96.2001 12.5297 96.2631 12.3677L96.3474 12.1484L94.4886 6.81818H96L97.0728 10.6236H97.1267L98.2097 6.81818H99.7311L97.7171 12.56C97.6204 12.8389 97.4888 13.0818 97.3224 13.2887C97.1582 13.4979 96.9502 13.6587 96.6983 13.7711C96.4464 13.8858 96.1428 13.9432 95.7874 13.9432Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function lf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2004_5187",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2004_5187)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M49.9115 6.2335V6.7085H52.486V6.2335H49.9115ZM49.9115 5.0365V5.502H52.486V5.0365H49.9115ZM48.876 4.2195H53.5785V7.516H48.876V4.2195ZM48.4105 7.9625H54.063V8.884H48.4105V7.9625ZM50.662 8.466H51.7355V12.3325L50.662 11.867V8.466ZM49.788 10.1475C49.9463 10.6162 50.1553 10.9645 50.415 11.1925C50.6747 11.4142 50.9723 11.563 51.308 11.639C51.6437 11.7087 52.0047 11.7435 52.391 11.7435C52.4733 11.7435 52.5968 11.7435 52.7615 11.7435C52.9325 11.7435 53.1162 11.7435 53.3125 11.7435C53.5152 11.7435 53.7083 11.7435 53.892 11.7435C54.0757 11.7372 54.2182 11.7308 54.3195 11.7245C54.2752 11.8005 54.2308 11.8987 54.1865 12.019C54.1485 12.1393 54.1137 12.2628 54.082 12.3895C54.0503 12.5162 54.025 12.627 54.006 12.722H53.626H52.353C51.9603 12.722 51.5993 12.6935 51.27 12.6365C50.9407 12.5795 50.6398 12.4687 50.3675 12.304C50.0952 12.1393 49.8513 11.9018 49.636 11.5915C49.427 11.2812 49.2497 10.8758 49.104 10.3755L49.788 10.1475ZM51.441 9.7105H53.55V10.6035H51.441V9.7105ZM48.971 9.169L50.0065 9.2925C49.9052 10.0652 49.731 10.7523 49.484 11.354C49.237 11.9493 48.9013 12.4433 48.477 12.836C48.42 12.7727 48.3408 12.6967 48.2395 12.608C48.1382 12.5193 48.0337 12.4338 47.926 12.3515C47.8183 12.2692 47.7233 12.2027 47.641 12.152C48.04 11.8417 48.344 11.4268 48.553 10.9075C48.762 10.3882 48.9013 9.80867 48.971 9.169ZM45.2185 8.751C45.6048 8.66867 46.0672 8.55783 46.6055 8.4185C47.1438 8.27283 47.6885 8.124 48.2395 7.972L48.3915 8.998C47.8912 9.14367 47.3845 9.2925 46.8715 9.4445C46.3585 9.59017 45.8898 9.72317 45.4655 9.8435L45.2185 8.751ZM45.3135 5.73H48.3345V6.775H45.3135V5.73ZM46.3395 3.9345H47.3845V11.525C47.3845 11.7847 47.356 11.9905 47.299 12.1425C47.2483 12.2945 47.1502 12.4148 47.0045 12.5035C46.8588 12.5922 46.6783 12.6492 46.463 12.6745C46.254 12.7062 45.9943 12.722 45.684 12.722C45.6713 12.5827 45.6365 12.4085 45.5795 12.1995C45.5225 11.9968 45.4592 11.8227 45.3895 11.677C45.5605 11.6833 45.722 11.6865 45.874 11.6865C46.026 11.6865 46.1305 11.6833 46.1875 11.677C46.2445 11.677 46.2825 11.6675 46.3015 11.6485C46.3268 11.6232 46.3395 11.5788 46.3395 11.5155V3.9345ZM56.8085 3.944L57.882 4.2765C57.6793 4.81483 57.4387 5.35633 57.16 5.901C56.8813 6.43933 56.5773 6.94917 56.248 7.4305C55.925 7.91183 55.5893 8.33617 55.241 8.7035C55.2093 8.6085 55.1587 8.48817 55.089 8.3425C55.0193 8.1905 54.9433 8.0385 54.861 7.8865C54.7787 7.72817 54.7058 7.60467 54.6425 7.516C54.9275 7.22467 55.203 6.889 55.469 6.509C55.7413 6.129 55.9915 5.7205 56.2195 5.2835C56.4475 4.84017 56.6438 4.39367 56.8085 3.944ZM55.849 6.5945L56.9605 5.4735L56.97 5.483V12.836H55.849V6.5945ZM57.7395 5.787H63.62V6.8795H57.7395V5.787ZM57.502 8.77H63.696V9.891H57.502V8.77ZM58.7845 4.001H59.896V9.3495H58.7845V4.001ZM61.2735 3.982H62.385V9.359H61.2735V3.982ZM59.041 10.271L60.105 10.6035C59.953 10.8822 59.7693 11.1577 59.554 11.43C59.3387 11.7023 59.1138 11.9557 58.8795 12.19C58.6515 12.4307 58.4235 12.6365 58.1955 12.8075C58.1258 12.7442 58.0372 12.665 57.9295 12.57C57.8282 12.4813 57.7205 12.3927 57.6065 12.304C57.4925 12.2153 57.3912 12.1457 57.3025 12.095C57.6445 11.8733 57.9707 11.601 58.281 11.278C58.5913 10.9487 58.8447 10.613 59.041 10.271ZM61.1215 10.765L62.0335 10.2615C62.2425 10.4642 62.4483 10.6827 62.651 10.917C62.8537 11.1513 63.0405 11.3825 63.2115 11.6105C63.3888 11.8385 63.5345 12.0443 63.6485 12.228L62.689 12.836C62.5877 12.6397 62.4515 12.4212 62.2805 12.1805C62.1095 11.9462 61.9227 11.7055 61.72 11.4585C61.5173 11.2052 61.3178 10.974 61.1215 10.765ZM69.3295 7.9055H70.5075V11.202C70.5075 11.3857 70.5265 11.5028 70.5645 11.5535C70.6088 11.5978 70.7102 11.62 70.8685 11.62C70.9002 11.62 70.954 11.62 71.03 11.62C71.106 11.62 71.1883 11.62 71.277 11.62C71.372 11.62 71.4575 11.62 71.5335 11.62C71.6158 11.62 71.6823 11.62 71.733 11.62C71.8407 11.62 71.9198 11.582 71.9705 11.506C72.0275 11.4237 72.0687 11.2685 72.094 11.0405C72.1193 10.8062 72.1383 10.461 72.151 10.005C72.2333 10.0683 72.3378 10.1317 72.4645 10.195C72.5912 10.2583 72.721 10.3153 72.854 10.366C72.987 10.4167 73.1042 10.4547 73.2055 10.48C73.1675 11.05 73.101 11.4965 73.006 11.8195C72.9173 12.1362 72.7812 12.3578 72.5975 12.4845C72.4138 12.6175 72.1605 12.684 71.8375 12.684C71.7805 12.684 71.6982 12.684 71.5905 12.684C71.4892 12.684 71.3783 12.684 71.258 12.684C71.1377 12.684 71.0237 12.684 70.916 12.684C70.8147 12.684 70.7355 12.684 70.6785 12.684C70.3238 12.684 70.0483 12.6365 69.852 12.5415C69.6557 12.4528 69.5195 12.3008 69.4435 12.0855C69.3675 11.8702 69.3295 11.5788 69.3295 11.2115V7.9055ZM64.5035 7.1835H73.025V8.2855H64.5035V7.1835ZM65.368 4.5995H72.151V5.692H65.368V4.5995ZM66.679 8.0575H67.9045C67.8665 8.57683 67.8032 9.07083 67.7145 9.5395C67.6258 10.0082 67.4833 10.4483 67.287 10.86C67.0907 11.2653 66.8088 11.6358 66.4415 11.9715C66.0742 12.3008 65.5928 12.5858 64.9975 12.8265C64.9342 12.6808 64.8328 12.5162 64.6935 12.3325C64.5542 12.1552 64.4212 12.0095 64.2945 11.8955C64.8138 11.7055 65.2255 11.4775 65.5295 11.2115C65.8335 10.9392 66.0647 10.6415 66.223 10.3185C66.3813 9.98917 66.489 9.6345 66.546 9.2545C66.603 8.86817 66.6473 8.46917 66.679 8.0575Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function cf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5620",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5620)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M51.4739 5.09091V12H50.03V6.27841H47.2367V12H45.7928V5.09091H51.4739ZM55.1789 12.1012C54.6549 12.1012 54.2017 11.9899 53.8194 11.7672C53.4393 11.5423 53.1458 11.2297 52.9389 10.8294C52.732 10.4268 52.6285 9.96011 52.6285 9.42933C52.6285 8.89406 52.732 8.42625 52.9389 8.02592C53.1458 7.62334 53.4393 7.31072 53.8194 7.08807C54.2017 6.86316 54.6549 6.75071 55.1789 6.75071C55.703 6.75071 56.155 6.86316 56.5351 7.08807C56.9175 7.31072 57.2121 7.62334 57.419 8.02592C57.6259 8.42625 57.7294 8.89406 57.7294 9.42933C57.7294 9.96011 57.6259 10.4268 57.419 10.8294C57.2121 11.2297 56.9175 11.5423 56.5351 11.7672C56.155 11.9899 55.703 12.1012 55.1789 12.1012ZM55.1857 10.9879C55.4241 10.9879 55.6231 10.9205 55.7828 10.7855C55.9425 10.6483 56.0628 10.4616 56.1438 10.2255C56.227 9.98935 56.2686 9.72058 56.2686 9.41921C56.2686 9.11784 56.227 8.84908 56.1438 8.61293C56.0628 8.37678 55.9425 8.1901 55.7828 8.05291C55.6231 7.91572 55.4241 7.84712 55.1857 7.84712C54.945 7.84712 54.7426 7.91572 54.5784 8.05291C54.4165 8.1901 54.2939 8.37678 54.2107 8.61293C54.1297 8.84908 54.0893 9.11784 54.0893 9.41921C54.0893 9.72058 54.1297 9.98935 54.2107 10.2255C54.2939 10.4616 54.4165 10.6483 54.5784 10.7855C54.7426 10.9205 54.945 10.9879 55.1857 10.9879ZM58.6638 12V6.81818H60.101V8.82883H60.5058L61.916 6.81818H63.6028L61.7709 9.38885L63.623 12H61.916L60.6374 10.1614H60.101V12H58.6638ZM64.2302 13.9432V6.81818H65.6472V7.68857H65.7112C65.7742 7.54912 65.8653 7.40743 65.9845 7.26349C66.106 7.11731 66.2634 6.99586 66.4568 6.89915C66.6525 6.80019 66.8954 6.75071 67.1855 6.75071C67.5633 6.75071 67.9119 6.84967 68.2313 7.04759C68.5507 7.24325 68.8059 7.539 68.9971 7.93484C69.1883 8.32842 69.2839 8.82209 69.2839 9.41584C69.2839 9.99384 69.1905 10.4819 69.0039 10.88C68.8194 11.2758 68.5675 11.5761 68.2482 11.7807C67.9311 11.9831 67.5757 12.0843 67.1821 12.0843C66.9032 12.0843 66.666 12.0382 66.4703 11.946C66.2769 11.8538 66.1183 11.738 65.9946 11.5985C65.8709 11.4569 65.7765 11.314 65.7112 11.1701H65.6674V13.9432H64.2302ZM65.637 9.40909C65.637 9.71721 65.6798 9.98597 65.7652 10.2154C65.8507 10.4448 65.9744 10.6236 66.1363 10.7518C66.2983 10.8777 66.495 10.9407 66.7267 10.9407C66.9606 10.9407 67.1585 10.8766 67.3204 10.7484C67.4824 10.618 67.605 10.438 67.6882 10.2086C67.7736 9.97698 67.8164 9.71046 67.8164 9.40909C67.8164 9.10997 67.7748 8.84683 67.6915 8.61967C67.6083 8.39252 67.4858 8.21484 67.3238 8.08665C67.1619 7.95845 66.9628 7.89435 66.7267 7.89435C66.4928 7.89435 66.2949 7.9562 66.1329 8.0799C65.9733 8.2036 65.8507 8.37902 65.7652 8.60618C65.6798 8.83333 65.637 9.10097 65.637 9.40909ZM72.6035 12.1012C72.0704 12.1012 71.6116 11.9933 71.2271 11.7773C70.8447 11.5592 70.5501 11.2511 70.3432 10.853C70.1363 10.4527 70.0328 9.97923 70.0328 9.43271C70.0328 8.89968 70.1363 8.43188 70.3432 8.0293C70.5501 7.62672 70.8413 7.31297 71.2169 7.08807C71.5948 6.86316 72.0378 6.75071 72.5461 6.75071C72.888 6.75071 73.2062 6.80581 73.5008 6.91602C73.7977 7.02397 74.0564 7.18703 74.2768 7.40518C74.4994 7.62334 74.6726 7.89773 74.7963 8.22834C74.92 8.5567 74.9818 8.94129 74.9818 9.3821V9.77681H70.6063V8.88619H73.629C73.629 8.67927 73.5841 8.49598 73.4941 8.33629C73.4041 8.17661 73.2793 8.05179 73.1196 7.96183C72.9622 7.86961 72.7789 7.82351 72.5697 7.82351C72.3516 7.82351 72.1582 7.87411 71.9895 7.97532C71.823 8.07428 71.6926 8.2081 71.5981 8.37678C71.5037 8.54321 71.4553 8.72875 71.4531 8.93342V9.78018C71.4531 10.0366 71.5003 10.2581 71.5948 10.4448C71.6915 10.6315 71.8275 10.7754 72.003 10.8766C72.1784 10.9778 72.3864 11.0284 72.6271 11.0284C72.7868 11.0284 72.933 11.0059 73.0657 10.9609C73.1983 10.916 73.3119 10.8485 73.4064 10.7585C73.5008 10.6686 73.5728 10.5584 73.6223 10.4279L74.9515 10.5156C74.884 10.835 74.7457 11.1139 74.5365 11.3523C74.3296 11.5884 74.062 11.7728 73.7336 11.9055C73.4075 12.036 73.0308 12.1012 72.6035 12.1012ZM77.3568 9.00426V12H75.9197V5.09091H77.3164V7.73242H77.3771C77.494 7.42655 77.683 7.18703 77.9438 7.01385C78.2047 6.83842 78.532 6.75071 78.9256 6.75071C79.2854 6.75071 79.5992 6.82943 79.8668 6.98686C80.1367 7.14205 80.3458 7.36583 80.4943 7.6582C80.645 7.94833 80.7192 8.29581 80.7169 8.70064V12H79.2798V8.95703C79.282 8.63767 79.2011 8.38915 79.0369 8.21147C78.875 8.03379 78.6478 7.94496 78.3554 7.94496C78.1598 7.94496 77.9866 7.98656 77.8359 8.06978C77.6875 8.15299 77.5705 8.27444 77.485 8.43413C77.4018 8.59156 77.3591 8.78161 77.3568 9.00426ZM74.9312 6.44371V5.59695H78.2947V6.44371H74.9312ZM84.2094 12.1012C83.6764 12.1012 83.2176 11.9933 82.833 11.7773C82.4507 11.5592 82.156 11.2511 81.9491 10.853C81.7422 10.4527 81.6388 9.97923 81.6388 9.43271C81.6388 8.89968 81.7422 8.43188 81.9491 8.0293C82.156 7.62672 82.4473 7.31297 82.8229 7.08807C83.2007 6.86316 83.6438 6.75071 84.1521 6.75071C84.4939 6.75071 84.8122 6.80581 85.1068 6.91602C85.4037 7.02397 85.6623 7.18703 85.8827 7.40518C86.1054 7.62334 86.2786 7.89773 86.4023 8.22834C86.526 8.5567 86.5878 8.94129 86.5878 9.3821V9.77681H82.2123V8.88619H85.235C85.235 8.67927 85.19 8.49598 85.1001 8.33629C85.0101 8.17661 84.8853 8.05179 84.7256 7.96183C84.5682 7.86961 84.3849 7.82351 84.1757 7.82351C83.9575 7.82351 83.7641 7.87411 83.5954 7.97532C83.429 8.07428 83.2986 8.2081 83.2041 8.37678C83.1096 8.54321 83.0613 8.72875 83.059 8.93342V9.78018C83.059 10.0366 83.1063 10.2581 83.2007 10.4448C83.2974 10.6315 83.4335 10.7754 83.6089 10.8766C83.7844 10.9778 83.9924 11.0284 84.233 11.0284C84.3927 11.0284 84.5389 11.0059 84.6716 10.9609C84.8043 10.916 84.9179 10.8485 85.0123 10.7585C85.1068 10.6686 85.1788 10.5584 85.2282 10.4279L86.5574 10.5156C86.49 10.835 86.3517 11.1139 86.1425 11.3523C85.9356 11.5884 85.6679 11.7728 85.3396 11.9055C85.0135 12.036 84.6367 12.1012 84.2094 12.1012ZM93.2734 6.81818V7.94833H91.121V12H89.7244V6.81818H93.2734ZM95.4418 12.0978C95.1112 12.0978 94.8165 12.0405 94.5579 11.9258C94.2992 11.8088 94.0946 11.6368 93.9439 11.4096C93.7955 11.1802 93.7212 10.8946 93.7212 10.5527C93.7212 10.2649 93.7741 10.0231 93.8798 9.82741C93.9855 9.63175 94.1294 9.47431 94.3116 9.35511C94.4938 9.23591 94.7007 9.14595 94.9324 9.08523C95.1663 9.0245 95.4114 8.98177 95.6678 8.95703C95.9692 8.92554 96.2121 8.89631 96.3965 8.86932C96.5809 8.84008 96.7147 8.79735 96.7979 8.74112C96.8812 8.6849 96.9228 8.60168 96.9228 8.49148V8.47124C96.9228 8.25758 96.8553 8.09227 96.7203 7.97532C96.5877 7.85837 96.3987 7.79989 96.1536 7.79989C95.8949 7.79989 95.6892 7.85724 95.5362 7.97195C95.3833 8.0844 95.2821 8.22609 95.2326 8.39702L93.9034 8.28906C93.9709 7.97419 94.1036 7.70206 94.3015 7.47266C94.4994 7.241 94.7547 7.06333 95.0673 6.93963C95.3822 6.81368 95.7465 6.75071 96.1603 6.75071C96.4482 6.75071 96.7237 6.78445 96.9869 6.85192C97.2522 6.91939 97.4873 7.02397 97.6919 7.16566C97.8989 7.30735 98.0619 7.48952 98.1811 7.71218C98.3003 7.93259 98.3599 8.19685 98.3599 8.50497V12H96.997V11.2814H96.9565C96.8733 11.4434 96.762 11.5862 96.6225 11.7099C96.4831 11.8313 96.3155 11.9269 96.1199 11.9966C95.9242 12.0641 95.6982 12.0978 95.4418 12.0978ZM95.8533 11.106C96.0647 11.106 96.2514 11.0644 96.4134 10.9812C96.5753 10.8957 96.7024 10.781 96.7946 10.6371C96.8868 10.4931 96.9329 10.3301 96.9329 10.1479V9.59801C96.8879 9.62725 96.8261 9.65424 96.7473 9.67898C96.6709 9.70147 96.5843 9.72283 96.4876 9.74308C96.3909 9.76107 96.2942 9.77794 96.1974 9.79368C96.1007 9.80717 96.013 9.81954 95.9343 9.83079C95.7656 9.85553 95.6183 9.89489 95.4924 9.94886C95.3664 10.0028 95.2686 10.0759 95.1989 10.1681C95.1291 10.2581 95.0943 10.3706 95.0943 10.5055C95.0943 10.7012 95.1651 10.8507 95.3068 10.9542C95.4508 11.0554 95.6329 11.106 95.8533 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function uf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5548",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5548)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M51.9496 8.54545C51.9496 9.29889 51.8068 9.93987 51.5211 10.4684C51.2377 10.9969 50.8509 11.4006 50.3606 11.6795C49.8726 11.9561 49.3238 12.0945 48.7143 12.0945C48.1003 12.0945 47.5493 11.955 47.0613 11.6761C46.5732 11.3973 46.1875 10.9935 45.9041 10.465C45.6207 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5732 5.69141 47.0613 5.41477C47.5493 5.13589 48.1003 4.99645 48.7143 4.99645C49.3238 4.99645 49.8726 5.13589 50.3606 5.41477C50.8509 5.69141 51.2377 6.09399 51.5211 6.62251C51.8068 7.15104 51.9496 7.79202 51.9496 8.54545ZM50.4686 8.54545C50.4686 8.05741 50.3955 7.64583 50.2493 7.31072C50.1054 6.97562 49.9018 6.72147 49.6387 6.5483C49.3755 6.37512 49.0674 6.28853 48.7143 6.28853C48.3612 6.28853 48.0531 6.37512 47.79 6.5483C47.5268 6.72147 47.3221 6.97562 47.176 7.31072C47.032 7.64583 46.96 8.05741 46.96 8.54545C46.96 9.0335 47.032 9.44508 47.176 9.78018C47.3221 10.1153 47.5268 10.3694 47.79 10.5426C48.0531 10.7158 48.3612 10.8024 48.7143 10.8024C49.0674 10.8024 49.3755 10.7158 49.6387 10.5426C49.9018 10.3694 50.1054 10.1153 50.2493 9.78018C50.3955 9.44508 50.4686 9.0335 50.4686 8.54545ZM53.0316 12V5.09091H54.4688V7.68857H54.5127C54.5756 7.54912 54.6667 7.40743 54.7859 7.26349C54.9074 7.11731 55.0648 6.99586 55.2582 6.89915C55.4539 6.80019 55.6968 6.75071 55.9869 6.75071C56.3647 6.75071 56.7133 6.84967 57.0327 7.04759C57.3521 7.24325 57.6073 7.539 57.7985 7.93484C57.9897 8.32842 58.0853 8.82209 58.0853 9.41584C58.0853 9.99384 57.9919 10.4819 57.8053 10.88C57.6208 11.2758 57.3689 11.5761 57.0496 11.7807C56.7325 11.9831 56.3771 12.0843 55.9835 12.0843C55.7046 12.0843 55.4674 12.0382 55.2717 11.946C55.0783 11.8538 54.9197 11.738 54.796 11.5985C54.6723 11.4569 54.5779 11.314 54.5127 11.1701H54.4486V12H53.0316ZM54.4384 9.40909C54.4384 9.71721 54.4812 9.98597 54.5666 10.2154C54.6521 10.4448 54.7758 10.6236 54.9377 10.7518C55.0997 10.8777 55.2964 10.9407 55.5281 10.9407C55.762 10.9407 55.9599 10.8766 56.1218 10.7484C56.2838 10.618 56.4064 10.438 56.4896 10.2086C56.575 9.97698 56.6178 9.71046 56.6178 9.40909C56.6178 9.10997 56.5762 8.84683 56.4929 8.61967C56.4097 8.39252 56.2872 8.21484 56.1252 8.08665C55.9633 7.95845 55.7642 7.89435 55.5281 7.89435C55.2942 7.89435 55.0963 7.9562 54.9343 8.0799C54.7747 8.2036 54.6521 8.37902 54.5666 8.60618C54.4812 8.83333 54.4384 9.10097 54.4384 9.40909ZM63.3556 8.29581L62.04 8.37678C62.0175 8.26432 61.9691 8.16312 61.8949 8.07315C61.8207 7.98094 61.7228 7.90785 61.6014 7.85387C61.4822 7.79764 61.3394 7.76953 61.1729 7.76953C60.9503 7.76953 60.7625 7.81676 60.6096 7.91122C60.4566 8.00343 60.3801 8.12713 60.3801 8.28232C60.3801 8.40601 60.4296 8.51059 60.5286 8.59606C60.6275 8.68152 60.7973 8.75012 61.038 8.80185L61.9759 8.99077C62.4796 9.09422 62.8552 9.26065 63.1026 9.49006C63.35 9.71946 63.4737 10.0208 63.4737 10.3942C63.4737 10.7338 63.3736 11.0318 63.1735 11.2882C62.9756 11.5446 62.7034 11.7447 62.3571 11.8887C62.013 12.0304 61.616 12.1012 61.1662 12.1012C60.4802 12.1012 59.9337 11.9584 59.5266 11.6728C59.1218 11.3849 58.8845 10.9935 58.8148 10.4988L60.2283 10.4245C60.2711 10.6337 60.3745 10.7934 60.5387 10.9036C60.7029 11.0115 60.9132 11.0655 61.1696 11.0655C61.4215 11.0655 61.6239 11.0172 61.7768 10.9205C61.932 10.8215 62.0107 10.6944 62.013 10.5392C62.0107 10.4088 61.9556 10.302 61.8477 10.2188C61.7397 10.1333 61.5733 10.0681 61.3484 10.0231L60.451 9.84428C59.945 9.74308 59.5682 9.56765 59.3208 9.318C59.0757 9.06836 58.9531 8.75012 58.9531 8.36328C58.9531 8.03042 59.0431 7.74367 59.223 7.50302C59.4052 7.26237 59.6605 7.07682 59.9888 6.94638C60.3194 6.81593 60.7063 6.75071 61.1493 6.75071C61.8038 6.75071 62.3188 6.88903 62.6944 7.16566C63.0723 7.44229 63.2927 7.81901 63.3556 8.29581ZM66.4602 7.50302V8.29918L63.7343 9.17294V8.37678L66.4602 7.50302ZM65.8158 5.09091V12H64.3787V5.09091H65.8158ZM70.29 9.79368V6.81818H71.7272V12H70.3474V11.0588H70.2934C70.1765 11.3624 69.9819 11.6064 69.7098 11.7908C69.4399 11.9753 69.1104 12.0675 68.7213 12.0675C68.375 12.0675 68.0702 11.9888 67.8071 11.8313C67.5439 11.6739 67.3382 11.4501 67.1897 11.16C67.0435 10.8699 66.9693 10.5224 66.9671 10.1175V6.81818H68.4042V9.86115C68.4065 10.167 68.4885 10.4088 68.6505 10.5865C68.8124 10.7641 69.0294 10.853 69.3016 10.853C69.4748 10.853 69.6367 10.8136 69.7874 10.7349C69.9381 10.6539 70.0595 10.5347 70.1517 10.3773C70.2462 10.2199 70.2923 10.0253 70.29 9.79368ZM75.2112 14.0511C74.7457 14.0511 74.3465 13.987 74.0136 13.8588C73.683 13.7329 73.4199 13.5608 73.2242 13.3427C73.0285 13.1245 72.9015 12.8794 72.843 12.6072L74.1722 12.4284C74.2127 12.5319 74.2768 12.6286 74.3645 12.7186C74.4522 12.8085 74.568 12.8805 74.712 12.9345C74.8581 12.9907 75.0358 13.0188 75.245 13.0188C75.5576 13.0188 75.8151 12.9424 76.0175 12.7894C76.2222 12.6387 76.3245 12.3857 76.3245 12.0304V11.0824H76.2638C76.2008 11.2263 76.1064 11.3624 75.9804 11.4906C75.8545 11.6188 75.6925 11.7234 75.4946 11.8043C75.2967 11.8853 75.0606 11.9258 74.7862 11.9258C74.3971 11.9258 74.0429 11.8358 73.7235 11.6559C73.4064 11.4737 73.1534 11.196 72.9644 10.8226C72.7778 10.447 72.6844 9.97248 72.6844 9.39897C72.6844 8.81197 72.78 8.32167 72.9712 7.92809C73.1624 7.53451 73.4165 7.23988 73.7336 7.04421C74.053 6.84854 74.4027 6.75071 74.7828 6.75071C75.0729 6.75071 75.3158 6.80019 75.5115 6.89915C75.7072 6.99586 75.8646 7.11731 75.9838 7.26349C76.1052 7.40743 76.1986 7.54912 76.2638 7.68857H76.3178V6.81818H77.7448V12.0506C77.7448 12.4914 77.6369 12.8603 77.4209 13.1571C77.205 13.454 76.9059 13.6767 76.5236 13.8251C76.1435 13.9758 75.706 14.0511 75.2112 14.0511ZM75.2416 10.8462C75.4733 10.8462 75.6689 10.7889 75.8286 10.6742C75.9905 10.5572 76.1142 10.3908 76.1997 10.1749C76.2874 9.95674 76.3313 9.69585 76.3313 9.39222C76.3313 9.0886 76.2885 8.82546 76.2031 8.60281C76.1176 8.3779 75.9939 8.2036 75.832 8.0799C75.6701 7.9562 75.4733 7.89435 75.2416 7.89435C75.0055 7.89435 74.8064 7.95845 74.6445 8.08665C74.4826 8.21259 74.36 8.38802 74.2768 8.61293C74.1936 8.83783 74.1519 9.0976 74.1519 9.39222C74.1519 9.69135 74.1936 9.94999 74.2768 10.1681C74.3622 10.3841 74.4848 10.5516 74.6445 10.6708C74.8064 10.7878 75.0055 10.8462 75.2416 10.8462ZM78.8884 12V6.81818H80.3256V12H78.8884ZM79.6104 6.15021C79.3967 6.15021 79.2134 6.07937 79.0605 5.93768C78.9098 5.79374 78.8345 5.62169 78.8345 5.42152C78.8345 5.2236 78.9098 5.0538 79.0605 4.91211C79.2134 4.76817 79.3967 4.6962 79.6104 4.6962C79.8241 4.6962 80.0062 4.76817 80.1569 4.91211C80.3099 5.0538 80.3863 5.2236 80.3863 5.42152C80.3863 5.62169 80.3099 5.79374 80.1569 5.93768C80.0062 6.07937 79.8241 6.15021 79.6104 6.15021ZM82.499 12L81.0889 6.81818H82.5429L83.3458 10.2997H83.393L84.2297 6.81818H85.6567L86.5068 10.2795H86.5507L87.3401 6.81818H88.7907L87.384 12H85.8625L84.9719 8.74112H84.9078L84.0171 12H82.499ZM91.035 12.0978C90.7044 12.0978 90.4098 12.0405 90.1511 11.9258C89.8925 11.8088 89.6878 11.6368 89.5372 11.4096C89.3887 11.1802 89.3145 10.8946 89.3145 10.5527C89.3145 10.2649 89.3674 10.0231 89.4731 9.82741C89.5788 9.63175 89.7227 9.47431 89.9049 9.35511C90.087 9.23591 90.294 9.14595 90.5256 9.08523C90.7595 9.0245 91.0047 8.98177 91.2611 8.95703C91.5624 8.92554 91.8053 8.89631 91.9897 8.86932C92.1742 8.84008 92.308 8.79735 92.3912 8.74112C92.4744 8.6849 92.516 8.60168 92.516 8.49148V8.47124C92.516 8.25758 92.4486 8.09227 92.3136 7.97532C92.1809 7.85837 91.992 7.79989 91.7468 7.79989C91.4882 7.79989 91.2824 7.85724 91.1295 7.97195C90.9765 8.0844 90.8753 8.22609 90.8259 8.39702L89.4967 8.28906C89.5641 7.97419 89.6968 7.70206 89.8948 7.47266C90.0927 7.241 90.3479 7.06333 90.6606 6.93963C90.9754 6.81368 91.3398 6.75071 91.7536 6.75071C92.0415 6.75071 92.317 6.78445 92.5801 6.85192C92.8455 6.91939 93.0805 7.02397 93.2852 7.16566C93.4921 7.30735 93.6552 7.48952 93.7744 7.71218C93.8936 7.93259 93.9532 8.19685 93.9532 8.50497V12H92.5902V11.2814H92.5498C92.4665 11.4434 92.3552 11.5862 92.2158 11.7099C92.0763 11.8313 91.9088 11.9269 91.7131 11.9966C91.5174 12.0641 91.2914 12.0978 91.035 12.0978ZM91.4466 11.106C91.658 11.106 91.8447 11.0644 92.0066 10.9812C92.1685 10.8957 92.2956 10.781 92.3878 10.6371C92.48 10.4931 92.5261 10.3301 92.5261 10.1479V9.59801C92.4812 9.62725 92.4193 9.65424 92.3406 9.67898C92.2641 9.70147 92.1775 9.72283 92.0808 9.74308C91.9841 9.76107 91.8874 9.77794 91.7907 9.79368C91.694 9.80717 91.6063 9.81954 91.5276 9.83079C91.3589 9.85553 91.2116 9.89489 91.0856 9.94886C90.9597 10.0028 90.8618 10.0759 90.7921 10.1681C90.7224 10.2581 90.6875 10.3706 90.6875 10.5055C90.6875 10.7012 90.7584 10.8507 90.9001 10.9542C91.044 11.0554 91.2262 11.106 91.4466 11.106ZM96.5053 9.00426V12H95.0681V6.81818H96.4378V7.73242H96.4985C96.6132 7.43105 96.8055 7.19265 97.0754 7.01722C97.3453 6.83955 97.6725 6.75071 98.0571 6.75071C98.417 6.75071 98.7307 6.82943 98.9984 6.98686C99.266 7.14429 99.474 7.3692 99.6225 7.66158C99.7709 7.9517 99.8451 8.29806 99.8451 8.70064V12H98.408V8.95703C98.4102 8.63991 98.3293 8.39252 98.1651 8.21484C98.0009 8.03492 97.7749 7.94496 97.487 7.94496C97.2936 7.94496 97.1226 7.98656 96.9742 8.06978C96.828 8.15299 96.7133 8.27444 96.6301 8.43413C96.5491 8.59156 96.5075 8.78161 96.5053 9.00426ZM103.339 12.1012C102.806 12.1012 102.347 11.9933 101.963 11.7773C101.581 11.5592 101.286 11.2511 101.079 10.853C100.872 10.4527 100.769 9.97923 100.769 9.43271C100.769 8.89968 100.872 8.43188 101.079 8.0293C101.286 7.62672 101.577 7.31297 101.953 7.08807C102.331 6.86316 102.774 6.75071 103.282 6.75071C103.624 6.75071 103.942 6.80581 104.237 6.91602C104.534 7.02397 104.792 7.18703 105.013 7.40518C105.235 7.62334 105.408 7.89773 105.532 8.22834C105.656 8.5567 105.718 8.94129 105.718 9.3821V9.77681H101.342V8.88619H104.365C104.365 8.67927 104.32 8.49598 104.23 8.33629C104.14 8.17661 104.015 8.05179 103.855 7.96183C103.698 7.86961 103.515 7.82351 103.306 7.82351C103.087 7.82351 102.894 7.87411 102.725 7.97532C102.559 8.07428 102.428 8.2081 102.334 8.37678C102.24 8.54321 102.191 8.72875 102.189 8.93342V9.78018C102.189 10.0366 102.236 10.2581 102.331 10.4448C102.427 10.6315 102.563 10.7754 102.739 10.8766C102.914 10.9778 103.122 11.0284 103.363 11.0284C103.523 11.0284 103.669 11.0059 103.801 10.9609C103.934 10.916 104.048 10.8485 104.142 10.7585C104.237 10.6686 104.309 10.5584 104.358 10.4279L105.687 10.5156C105.62 10.835 105.482 11.1139 105.272 11.3523C105.065 11.5884 104.798 11.7728 104.469 11.9055C104.143 12.036 103.767 12.1012 103.339 12.1012ZM108.854 13.9432V6.81818H110.271V7.68857H110.335C110.398 7.54912 110.489 7.40743 110.609 7.26349C110.73 7.11731 110.887 6.99586 111.081 6.89915C111.277 6.80019 111.519 6.75071 111.81 6.75071C112.187 6.75071 112.536 6.84967 112.855 7.04759C113.175 7.24325 113.43 7.539 113.621 7.93484C113.812 8.32842 113.908 8.82209 113.908 9.41584C113.908 9.99384 113.815 10.4819 113.628 10.88C113.443 11.2758 113.192 11.5761 112.872 11.7807C112.555 11.9831 112.2 12.0843 111.806 12.0843C111.527 12.0843 111.29 12.0382 111.094 11.946C110.901 11.8538 110.742 11.738 110.619 11.5985C110.495 11.4569 110.4 11.314 110.335 11.1701H110.291V13.9432H108.854ZM110.261 9.40909C110.261 9.71721 110.304 9.98597 110.389 10.2154C110.475 10.4448 110.598 10.6236 110.76 10.7518C110.922 10.8777 111.119 10.9407 111.351 10.9407C111.585 10.9407 111.783 10.8766 111.944 10.7484C112.106 10.618 112.229 10.438 112.312 10.2086C112.398 9.97698 112.44 9.71046 112.44 9.40909C112.44 9.10997 112.399 8.84683 112.316 8.61967C112.232 8.39252 112.11 8.21484 111.948 8.08665C111.786 7.95845 111.587 7.89435 111.351 7.89435C111.117 7.89435 110.919 7.9562 110.757 8.0799C110.597 8.2036 110.475 8.37902 110.389 8.60618C110.304 8.83333 110.261 9.10097 110.261 9.40909ZM114.866 12V6.81818H116.259V7.7223H116.313C116.408 7.40069 116.566 7.15779 116.789 6.99361C117.012 6.82718 117.268 6.74396 117.558 6.74396C117.63 6.74396 117.708 6.74846 117.791 6.75746C117.874 6.76645 117.947 6.77882 118.01 6.79457V8.06978C117.943 8.04954 117.849 8.03155 117.73 8.0158C117.611 8.00006 117.502 7.99219 117.403 7.99219C117.192 7.99219 117.003 8.03829 116.836 8.1305C116.672 8.22047 116.542 8.34641 116.445 8.50835C116.35 8.67028 116.303 8.85695 116.303 9.06836V12H114.866ZM118.726 12V11.1431L121.263 8.00231V7.9652H118.814V6.81818H122.994V7.75266L120.612 10.8159V10.853H123.081V12H118.726ZM126.394 12.1012C125.86 12.1012 125.402 11.9933 125.017 11.7773C124.635 11.5592 124.34 11.2511 124.133 10.853C123.926 10.4527 123.823 9.97923 123.823 9.43271C123.823 8.89968 123.926 8.43188 124.133 8.0293C124.34 7.62672 124.631 7.31297 125.007 7.08807C125.385 6.86316 125.828 6.75071 126.336 6.75071C126.678 6.75071 126.996 6.80581 127.291 6.91602C127.588 7.02397 127.846 7.18703 128.067 7.40518C128.289 7.62334 128.463 7.89773 128.586 8.22834C128.71 8.5567 128.772 8.94129 128.772 9.3821V9.77681H124.396V8.88619H127.419C127.419 8.67927 127.374 8.49598 127.284 8.33629C127.194 8.17661 127.069 8.05179 126.91 7.96183C126.752 7.86961 126.569 7.82351 126.36 7.82351C126.142 7.82351 125.948 7.87411 125.78 7.97532C125.613 8.07428 125.483 8.2081 125.388 8.37678C125.294 8.54321 125.245 8.72875 125.243 8.93342V9.78018C125.243 10.0366 125.29 10.2581 125.385 10.4448C125.482 10.6315 125.618 10.7754 125.793 10.8766C125.968 10.9778 126.176 11.0284 126.417 11.0284C126.577 11.0284 126.723 11.0059 126.856 10.9609C126.988 10.916 127.102 10.8485 127.196 10.7585C127.291 10.6686 127.363 10.5584 127.412 10.4279L128.742 10.5156C128.674 10.835 128.536 11.1139 128.327 11.3523C128.12 11.5884 127.852 11.7728 127.524 11.9055C127.198 12.036 126.821 12.1012 126.394 12.1012ZM129.683 12V11.1431L132.22 8.00231V7.9652H129.77V6.81818H133.95V7.75266L131.569 10.8159V10.853H134.038V12H129.683Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function df(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5524",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5524)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.9223V12H52.4851ZM53.2071 6.15021C52.9934 6.15021 52.8101 6.07937 52.6572 5.93768C52.5065 5.79374 52.4312 5.62169 52.4312 5.42152C52.4312 5.2236 52.5065 5.0538 52.6572 4.91211C52.8101 4.76817 52.9934 4.6962 53.2071 4.6962C53.4207 4.6962 53.6029 4.76817 53.7536 4.91211C53.9065 5.0538 53.983 5.2236 53.983 5.42152C53.983 5.62169 53.9065 5.79374 53.7536 5.93768C53.6029 6.07937 53.4207 6.15021 53.2071 6.15021ZM55.0735 13.9432V6.81818H56.4904V7.68857H56.5545C56.6175 7.54912 56.7086 7.40743 56.8278 7.26349C56.9492 7.11731 57.1067 6.99586 57.3001 6.89915C57.4957 6.80019 57.7386 6.75071 58.0288 6.75071C58.4066 6.75071 58.7552 6.84967 59.0746 7.04759C59.3939 7.24325 59.6492 7.539 59.8404 7.93484C60.0315 8.32842 60.1271 8.82209 60.1271 9.41584C60.1271 9.99384 60.0338 10.4819 59.8471 10.88C59.6627 11.2758 59.4108 11.5761 59.0914 11.7807C58.7743 11.9831 58.419 12.0843 58.0254 12.0843C57.7465 12.0843 57.5092 12.0382 57.3136 11.946C57.1201 11.8538 56.9616 11.738 56.8379 11.5985C56.7142 11.4569 56.6197 11.314 56.5545 11.1701H56.5107V13.9432H55.0735ZM56.4803 9.40909C56.4803 9.71721 56.523 9.98597 56.6085 10.2154C56.694 10.4448 56.8176 10.6236 56.9796 10.7518C57.1415 10.8777 57.3383 10.9407 57.57 10.9407C57.8039 10.9407 58.0018 10.8766 58.1637 10.7484C58.3256 10.618 58.4482 10.438 58.5314 10.2086C58.6169 9.97698 58.6596 9.71046 58.6596 9.40909C58.6596 9.10997 58.618 8.84683 58.5348 8.61967C58.4516 8.39252 58.329 8.21484 58.1671 8.08665C58.0051 7.95845 57.8061 7.89435 57.57 7.89435C57.3361 7.89435 57.1381 7.9562 56.9762 8.0799C56.8165 8.2036 56.694 8.37902 56.6085 8.60618C56.523 8.83333 56.4803 9.10097 56.4803 9.40909ZM63.4467 12.1012C62.9137 12.1012 62.4549 11.9933 62.0703 11.7773C61.688 11.5592 61.3933 11.2511 61.1864 10.853C60.9795 10.4527 60.8761 9.97923 60.8761 9.43271C60.8761 8.89968 60.9795 8.43188 61.1864 8.0293C61.3933 7.62672 61.6846 7.31297 62.0602 7.08807C62.438 6.86316 62.8811 6.75071 63.3894 6.75071C63.7312 6.75071 64.0495 6.80581 64.3441 6.91602C64.641 7.02397 64.8996 7.18703 65.12 7.40518C65.3427 7.62334 65.5159 7.89773 65.6396 8.22834C65.7633 8.5567 65.8251 8.94129 65.8251 9.3821V9.77681H61.4496V8.88619H64.4723C64.4723 8.67927 64.4273 8.49598 64.3374 8.33629C64.2474 8.17661 64.1226 8.05179 63.9629 7.96183C63.8055 7.86961 63.6222 7.82351 63.413 7.82351C63.1948 7.82351 63.0014 7.87411 62.8327 7.97532C62.6663 8.07428 62.5359 8.2081 62.4414 8.37678C62.3469 8.54321 62.2986 8.72875 62.2963 8.93342V9.78018C62.2963 10.0366 62.3436 10.2581 62.438 10.4448C62.5347 10.6315 62.6708 10.7754 62.8462 10.8766C63.0217 10.9778 63.2297 11.0284 63.4703 11.0284C63.63 11.0284 63.7762 11.0059 63.9089 10.9609C64.0416 10.916 64.1552 10.8485 64.2496 10.7585C64.3441 10.6686 64.4161 10.5584 64.4656 10.4279L65.7947 10.5156C65.7273 10.835 65.589 11.1139 65.3798 11.3523C65.1729 11.5884 64.9052 11.7728 64.5769 11.9055C64.2508 12.036 63.8741 12.1012 63.4467 12.1012ZM66.763 12V6.81818H68.1562V7.7223H68.2102C68.3047 7.40069 68.4632 7.15779 68.6859 6.99361C68.9086 6.82718 69.165 6.74396 69.4551 6.74396C69.527 6.74396 69.6046 6.74846 69.6879 6.75746C69.7711 6.76645 69.8442 6.77882 69.9071 6.79457V8.06978C69.8397 8.04954 69.7463 8.03155 69.6271 8.0158C69.5079 8.00006 69.3989 7.99219 69.2999 7.99219C69.0885 7.99219 68.8996 8.03829 68.7331 8.1305C68.569 8.22047 68.4385 8.34641 68.3418 8.50835C68.2473 8.67028 68.2001 8.85695 68.2001 9.06836V12H66.763ZM74.9616 8.29581L73.6459 8.37678C73.6234 8.26432 73.5751 8.16312 73.5008 8.07315C73.4266 7.98094 73.3288 7.90785 73.2073 7.85387C73.0881 7.79764 72.9453 7.76953 72.7789 7.76953C72.5562 7.76953 72.3684 7.81676 72.2155 7.91122C72.0626 8.00343 71.9861 8.12713 71.9861 8.28232C71.9861 8.40601 72.0356 8.51059 72.1345 8.59606C72.2335 8.68152 72.4033 8.75012 72.644 8.80185L73.5818 8.99077C74.0856 9.09422 74.4612 9.26065 74.7086 9.49006C74.956 9.71946 75.0797 10.0208 75.0797 10.3942C75.0797 10.7338 74.9796 11.0318 74.7794 11.2882C74.5815 11.5446 74.3094 11.7447 73.963 11.8887C73.6189 12.0304 73.222 12.1012 72.7722 12.1012C72.0862 12.1012 71.5397 11.9584 71.1326 11.6728C70.7278 11.3849 70.4905 10.9935 70.4208 10.4988L71.8343 10.4245C71.877 10.6337 71.9805 10.7934 72.1447 10.9036C72.3088 11.0115 72.5191 11.0655 72.7755 11.0655C73.0274 11.0655 73.2298 11.0172 73.3828 10.9205C73.538 10.8215 73.6167 10.6944 73.6189 10.5392C73.6167 10.4088 73.5616 10.302 73.4536 10.2188C73.3457 10.1333 73.1792 10.0681 72.9543 10.0231L72.057 9.84428C71.5509 9.74308 71.1742 9.56765 70.9268 9.318C70.6817 9.06836 70.5591 8.75012 70.5591 8.36328C70.5591 8.03042 70.649 7.74367 70.829 7.50302C71.0111 7.26237 71.2664 7.07682 71.5948 6.94638C71.9254 6.81593 72.3122 6.75071 72.7553 6.75071C73.4098 6.75071 73.9248 6.88903 74.3004 7.16566C74.6782 7.44229 74.8986 7.81901 74.9616 8.29581ZM78.3461 12.1012C77.8131 12.1012 77.3543 11.9933 76.9697 11.7773C76.5874 11.5592 76.2928 11.2511 76.0858 10.853C75.8789 10.4527 75.7755 9.97923 75.7755 9.43271C75.7755 8.89968 75.8789 8.43188 76.0858 8.0293C76.2928 7.62672 76.584 7.31297 76.9596 7.08807C77.3374 6.86316 77.7805 6.75071 78.2888 6.75071C78.6307 6.75071 78.9489 6.80581 79.2435 6.91602C79.5404 7.02397 79.799 7.18703 80.0194 7.40518C80.2421 7.62334 80.4153 7.89773 80.539 8.22834C80.6627 8.5567 80.7245 8.94129 80.7245 9.3821V9.77681H76.349V8.88619H79.3717C79.3717 8.67927 79.3267 8.49598 79.2368 8.33629C79.1468 8.17661 79.022 8.05179 78.8623 7.96183C78.7049 7.86961 78.5216 7.82351 78.3124 7.82351C78.0943 7.82351 77.9008 7.87411 77.7322 7.97532C77.5657 8.07428 77.4353 8.2081 77.3408 8.37678C77.2464 8.54321 77.198 8.72875 77.1958 8.93342V9.78018C77.1958 10.0366 77.243 10.2581 77.3374 10.4448C77.4342 10.6315 77.5702 10.7754 77.7456 10.8766C77.9211 10.9778 78.1291 11.0284 78.3698 11.0284C78.5294 11.0284 78.6756 11.0059 78.8083 10.9609C78.941 10.916 79.0546 10.8485 79.1491 10.7585C79.2435 10.6686 79.3155 10.5584 79.365 10.4279L80.6942 10.5156C80.6267 10.835 80.4884 11.1139 80.2792 11.3523C80.0723 11.5884 79.8047 11.7728 79.4763 11.9055C79.1502 12.036 78.7735 12.1012 78.3461 12.1012ZM81.6624 12V6.81818H83.032V7.73242H83.0928C83.2007 7.4288 83.3807 7.18928 83.6325 7.01385C83.8844 6.83842 84.1858 6.75071 84.5367 6.75071C84.892 6.75071 85.1945 6.83955 85.4442 7.01722C85.6938 7.19265 85.8602 7.43105 85.9434 7.73242H85.9974C86.1031 7.43555 86.2943 7.19827 86.5709 7.0206C86.8498 6.84067 87.1793 6.75071 87.5594 6.75071C88.0429 6.75071 88.4354 6.90477 88.7368 7.21289C89.0404 7.51876 89.1922 7.95283 89.1922 8.51509V12H87.7584V8.79847C87.7584 8.51059 87.682 8.29469 87.529 8.15075C87.3761 8.00681 87.1849 7.93484 86.9555 7.93484C86.6946 7.93484 86.4911 8.01805 86.3449 8.18448C86.1987 8.34866 86.1256 8.5657 86.1256 8.83558V12H84.7323V8.76811C84.7323 8.51397 84.6592 8.31155 84.5131 8.16087C84.3691 8.01018 84.1791 7.93484 83.9429 7.93484C83.7832 7.93484 83.6393 7.97532 83.5111 8.05629C83.3852 8.135 83.2851 8.24633 83.2108 8.39027C83.1366 8.53196 83.0995 8.69839 83.0995 8.88956V12H81.6624ZM90.3544 12V5.09091H91.7915V7.68857H91.8354C91.8984 7.54912 91.9895 7.40743 92.1087 7.26349C92.2301 7.11731 92.3875 6.99586 92.581 6.89915C92.7766 6.80019 93.0195 6.75071 93.3097 6.75071C93.6875 6.75071 94.0361 6.84967 94.3555 7.04759C94.6748 7.24325 94.9301 7.539 95.1213 7.93484C95.3124 8.32842 95.408 8.82209 95.408 9.41584C95.408 9.99384 95.3147 10.4819 95.128 10.88C94.9436 11.2758 94.6917 11.5761 94.3723 11.7807C94.0552 11.9831 93.6999 12.0843 93.3063 12.0843C93.0274 12.0843 92.7901 12.0382 92.5945 11.946C92.401 11.8538 92.2425 11.738 92.1188 11.5985C91.9951 11.4569 91.9006 11.314 91.8354 11.1701H91.7713V12H90.3544ZM91.7612 9.40909C91.7612 9.71721 91.8039 9.98597 91.8894 10.2154C91.9748 10.4448 92.0985 10.6236 92.2605 10.7518C92.4224 10.8777 92.6192 10.9407 92.8509 10.9407C93.0848 10.9407 93.2827 10.8766 93.4446 10.7484C93.6065 10.618 93.7291 10.438 93.8123 10.2086C93.8978 9.97698 93.9405 9.71046 93.9405 9.40909C93.9405 9.10997 93.8989 8.84683 93.8157 8.61967C93.7325 8.39252 93.6099 8.21484 93.448 8.08665C93.286 7.95845 93.087 7.89435 92.8509 7.89435C92.617 7.89435 92.419 7.9562 92.2571 8.0799C92.0974 8.2036 91.9748 8.37902 91.8894 8.60618C91.8039 8.83333 91.7612 9.10097 91.7612 9.40909ZM97.8446 12.0978C97.514 12.0978 97.2194 12.0405 96.9607 11.9258C96.7021 11.8088 96.4974 11.6368 96.3467 11.4096C96.1983 11.1802 96.1241 10.8946 96.1241 10.5527C96.1241 10.2649 96.1769 10.0231 96.2826 9.82741C96.3883 9.63175 96.5323 9.47431 96.7144 9.35511C96.8966 9.23591 97.1035 9.14595 97.3352 9.08523C97.5691 9.0245 97.8142 8.98177 98.0706 8.95703C98.372 8.92554 98.6149 8.89631 98.7993 8.86932C98.9837 8.84008 99.1176 8.79735 99.2008 8.74112C99.284 8.6849 99.3256 8.60168 99.3256 8.49148V8.47124C99.3256 8.25758 99.2581 8.09227 99.1232 7.97532C98.9905 7.85837 98.8016 7.79989 98.5564 7.79989C98.2978 7.79989 98.092 7.85724 97.9391 7.97195C97.7861 8.0844 97.6849 8.22609 97.6354 8.39702L96.3062 8.28906C96.3737 7.97419 96.5064 7.70206 96.7043 7.47266C96.9022 7.241 97.1575 7.06333 97.4701 6.93963C97.785 6.81368 98.1493 6.75071 98.5632 6.75071C98.851 6.75071 99.1266 6.78445 99.3897 6.85192C99.6551 6.91939 99.8901 7.02397 100.095 7.16566C100.302 7.30735 100.465 7.48952 100.584 7.71218C100.703 7.93259 100.763 8.19685 100.763 8.50497V12H99.3998V11.2814H99.3593C99.2761 11.4434 99.1648 11.5862 99.0253 11.7099C98.8859 11.8313 98.7184 11.9269 98.5227 11.9966C98.327 12.0641 98.101 12.0978 97.8446 12.0978ZM98.2562 11.106C98.4676 11.106 98.6543 11.0644 98.8162 10.9812C98.9781 10.8957 99.1052 10.781 99.1974 10.6371C99.2896 10.4931 99.3357 10.3301 99.3357 10.1479V9.59801C99.2907 9.62725 99.2289 9.65424 99.1502 9.67898C99.0737 9.70147 98.9871 9.72283 98.8904 9.74308C98.7937 9.76107 98.697 9.77794 98.6003 9.79368C98.5036 9.80717 98.4159 9.81954 98.3371 9.83079C98.1685 9.85553 98.0211 9.89489 97.8952 9.94886C97.7693 10.0028 97.6714 10.0759 97.6017 10.1681C97.532 10.2581 97.4971 10.3706 97.4971 10.5055C97.4971 10.7012 97.568 10.8507 97.7097 10.9542C97.8536 11.0554 98.0358 11.106 98.2562 11.106ZM103.315 9.00426V12H101.878V5.09091H103.274V7.73242H103.335C103.452 7.42655 103.641 7.18703 103.902 7.01385C104.163 6.83842 104.49 6.75071 104.884 6.75071C105.243 6.75071 105.557 6.82943 105.825 6.98686C106.095 7.14205 106.304 7.36583 106.452 7.6582C106.603 7.94833 106.677 8.29581 106.675 8.70064V12H105.238V8.95703C105.24 8.63767 105.159 8.38915 104.995 8.21147C104.833 8.03379 104.606 7.94496 104.313 7.94496C104.118 7.94496 103.945 7.98656 103.794 8.06978C103.645 8.15299 103.529 8.27444 103.443 8.43413C103.36 8.59156 103.317 8.78161 103.315 9.00426ZM109.108 10.5089L109.112 8.78498H109.321L110.98 6.81818H112.63L110.4 9.42259H110.059L109.108 10.5089ZM107.806 12V5.09091H109.243V12H107.806ZM111.045 12L109.52 9.74308L110.478 8.72763L112.728 12H111.045ZM114.813 12.0978C114.482 12.0978 114.188 12.0405 113.929 11.9258C113.67 11.8088 113.466 11.6368 113.315 11.4096C113.167 11.1802 113.092 10.8946 113.092 10.5527C113.092 10.2649 113.145 10.0231 113.251 9.82741C113.357 9.63175 113.501 9.47431 113.683 9.35511C113.865 9.23591 114.072 9.14595 114.303 9.08523C114.537 9.0245 114.782 8.98177 115.039 8.95703C115.34 8.92554 115.583 8.89631 115.768 8.86932C115.952 8.84008 116.086 8.79735 116.169 8.74112C116.252 8.6849 116.294 8.60168 116.294 8.49148V8.47124C116.294 8.25758 116.226 8.09227 116.091 7.97532C115.959 7.85837 115.77 7.79989 115.525 7.79989C115.266 7.79989 115.06 7.85724 114.907 7.97195C114.754 8.0844 114.653 8.22609 114.604 8.39702L113.275 8.28906C113.342 7.97419 113.475 7.70206 113.673 7.47266C113.871 7.241 114.126 7.06333 114.438 6.93963C114.753 6.81368 115.118 6.75071 115.531 6.75071C115.819 6.75071 116.095 6.78445 116.358 6.85192C116.623 6.91939 116.858 7.02397 117.063 7.16566C117.27 7.30735 117.433 7.48952 117.552 7.71218C117.671 7.93259 117.731 8.19685 117.731 8.50497V12H116.368V11.2814H116.328C116.244 11.4434 116.133 11.5862 115.994 11.7099C115.854 11.8313 115.687 11.9269 115.491 11.9966C115.295 12.0641 115.069 12.0978 114.813 12.0978ZM115.224 11.106C115.436 11.106 115.623 11.0644 115.784 10.9812C115.946 10.8957 116.073 10.781 116.166 10.6371C116.258 10.4931 116.304 10.3301 116.304 10.1479V9.59801C116.259 9.62725 116.197 9.65424 116.118 9.67898C116.042 9.70147 115.955 9.72283 115.859 9.74308C115.762 9.76107 115.665 9.77794 115.569 9.79368C115.472 9.80717 115.384 9.81954 115.305 9.83079C115.137 9.85553 114.989 9.89489 114.863 9.94886C114.738 10.0028 114.64 10.0759 114.57 10.1681C114.5 10.2581 114.465 10.3706 114.465 10.5055C114.465 10.7012 114.536 10.8507 114.678 10.9542C114.822 11.0554 115.004 11.106 115.224 11.106ZM120.283 9.00426V12H118.846V6.81818H120.216V7.73242H120.276C120.391 7.43105 120.583 7.19265 120.853 7.01722C121.123 6.83955 121.45 6.75071 121.835 6.75071C122.195 6.75071 122.509 6.82943 122.776 6.98686C123.044 7.14429 123.252 7.3692 123.4 7.66158C123.549 7.9517 123.623 8.29806 123.623 8.70064V12H122.186V8.95703C122.188 8.63991 122.107 8.39252 121.943 8.21484C121.779 8.03492 121.553 7.94496 121.265 7.94496C121.071 7.94496 120.9 7.98656 120.752 8.06978C120.606 8.15299 120.491 8.27444 120.408 8.43413C120.327 8.59156 120.285 8.78161 120.283 9.00426ZM129.296 12.1012C128.772 12.1012 128.318 11.9899 127.936 11.7672C127.556 11.5423 127.262 11.2297 127.056 10.8294C126.849 10.4268 126.745 9.96011 126.745 9.42933C126.745 8.89406 126.849 8.42625 127.056 8.02592C127.262 7.62334 127.556 7.31072 127.936 7.08807C128.318 6.86316 128.772 6.75071 129.296 6.75071C129.82 6.75071 130.272 6.86316 130.652 7.08807C131.034 7.31072 131.329 7.62334 131.536 8.02592C131.743 8.42625 131.846 8.89406 131.846 9.42933C131.846 9.96011 131.743 10.4268 131.536 10.8294C131.329 11.2297 131.034 11.5423 130.652 11.7672C130.272 11.9899 129.82 12.1012 129.296 12.1012ZM129.302 10.9879C129.541 10.9879 129.74 10.9205 129.9 10.7855C130.059 10.6483 130.18 10.4616 130.26 10.2255C130.344 9.98935 130.385 9.72058 130.385 9.41921C130.385 9.11784 130.344 8.84908 130.26 8.61293C130.18 8.37678 130.059 8.1901 129.9 8.05291C129.74 7.91572 129.541 7.84712 129.302 7.84712C129.062 7.84712 128.859 7.91572 128.695 8.05291C128.533 8.1901 128.411 8.37678 128.327 8.61293C128.246 8.84908 128.206 9.11784 128.206 9.41921C128.206 9.72058 128.246 9.98935 128.327 10.2255C128.411 10.4616 128.533 10.6483 128.695 10.7855C128.859 10.9205 129.062 10.9879 129.302 10.9879ZM134.218 5.09091V12H132.781V5.09091H134.218ZM137.73 12.1012C137.197 12.1012 136.739 11.9933 136.354 11.7773C135.972 11.5592 135.677 11.2511 135.47 10.853C135.263 10.4527 135.16 9.97923 135.16 9.43271C135.16 8.89968 135.263 8.43188 135.47 8.0293C135.677 7.62672 135.968 7.31297 136.344 7.08807C136.722 6.86316 137.165 6.75071 137.673 6.75071C138.015 6.75071 138.333 6.80581 138.628 6.91602C138.925 7.02397 139.183 7.18703 139.404 7.40518C139.626 7.62334 139.8 7.89773 139.923 8.22834C140.047 8.5567 140.109 8.94129 140.109 9.3821V9.77681H135.733V8.88619H138.756C138.756 8.67927 138.711 8.49598 138.621 8.33629C138.531 8.17661 138.406 8.05179 138.247 7.96183C138.089 7.86961 137.906 7.82351 137.697 7.82351C137.479 7.82351 137.285 7.87411 137.116 7.97532C136.95 8.07428 136.82 8.2081 136.725 8.37678C136.631 8.54321 136.582 8.72875 136.58 8.93342V9.78018C136.58 10.0366 136.627 10.2581 136.722 10.4448C136.818 10.6315 136.955 10.7754 137.13 10.8766C137.305 10.9778 137.513 11.0284 137.754 11.0284C137.914 11.0284 138.06 11.0059 138.193 10.9609C138.325 10.916 138.439 10.8485 138.533 10.7585C138.628 10.6686 138.7 10.5584 138.749 10.4279L140.078 10.5156C140.011 10.835 139.873 11.1139 139.663 11.3523C139.457 11.5884 139.189 11.7728 138.861 11.9055C138.534 12.036 138.158 12.1012 137.73 12.1012ZM142.484 9.00426V12H141.047V5.09091H142.443V7.73242H142.504C142.621 7.42655 142.81 7.18703 143.071 7.01385C143.332 6.83842 143.659 6.75071 144.053 6.75071C144.412 6.75071 144.726 6.82943 144.994 6.98686C145.264 7.14205 145.473 7.36583 145.621 7.6582C145.772 7.94833 145.846 8.29581 145.844 8.70064V12H144.407V8.95703C144.409 8.63767 144.328 8.38915 144.164 8.21147C144.002 8.03379 143.775 7.94496 143.482 7.94496C143.287 7.94496 143.114 7.98656 142.963 8.06978C142.814 8.15299 142.697 8.27444 142.612 8.43413C142.529 8.59156 142.486 8.78161 142.484 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Cf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5500",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5500)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM58.4926 12.1012C57.9596 12.1012 57.5008 11.9933 57.1162 11.7773C56.7339 11.5592 56.4392 11.2511 56.2323 10.853C56.0254 10.4527 55.922 9.97923 55.922 9.43271C55.922 8.89968 56.0254 8.43188 56.2323 8.0293C56.4392 7.62672 56.7305 7.31297 57.1061 7.08807C57.4839 6.86316 57.927 6.75071 58.4353 6.75071C58.7771 6.75071 59.0954 6.80581 59.39 6.91602C59.6869 7.02397 59.9455 7.18703 60.1659 7.40518C60.3886 7.62334 60.5618 7.89773 60.6855 8.22834C60.8092 8.5567 60.871 8.94129 60.871 9.3821V9.77681H56.4955V8.88619H59.5182C59.5182 8.67927 59.4732 8.49598 59.3833 8.33629C59.2933 8.17661 59.1685 8.05179 59.0088 7.96183C58.8514 7.86961 58.6681 7.82351 58.4589 7.82351C58.2407 7.82351 58.0473 7.87411 57.8786 7.97532C57.7122 8.07428 57.5818 8.2081 57.4873 8.37678C57.3928 8.54321 57.3445 8.72875 57.3422 8.93342V9.78018C57.3422 10.0366 57.3895 10.2581 57.4839 10.4448C57.5806 10.6315 57.7167 10.7754 57.8921 10.8766C58.0676 10.9778 58.2756 11.0284 58.5162 11.0284C58.6759 11.0284 58.8221 11.0059 58.9548 10.9609C59.0875 10.916 59.2011 10.8485 59.2955 10.7585C59.39 10.6686 59.462 10.5584 59.5115 10.4279L60.8406 10.5156C60.7732 10.835 60.6349 11.1139 60.4257 11.3523C60.2188 11.5884 59.9511 11.7728 59.6228 11.9055C59.2967 12.036 58.92 12.1012 58.4926 12.1012ZM66.5007 6.81818L64.6891 12H63.0697L61.2581 6.81818H62.7762L63.8524 10.5257H63.9064L64.9792 6.81818H66.5007ZM69.4306 12.1012C68.8976 12.1012 68.4388 11.9933 68.0542 11.7773C67.6719 11.5592 67.3772 11.2511 67.1703 10.853C66.9634 10.4527 66.86 9.97923 66.86 9.43271C66.86 8.89968 66.9634 8.43188 67.1703 8.0293C67.3772 7.62672 67.6685 7.31297 68.0441 7.08807C68.4219 6.86316 68.865 6.75071 69.3733 6.75071C69.7151 6.75071 70.0334 6.80581 70.328 6.91602C70.6249 7.02397 70.8835 7.18703 71.1039 7.40518C71.3266 7.62334 71.4997 7.89773 71.6234 8.22834C71.7471 8.5567 71.809 8.94129 71.809 9.3821V9.77681H67.4335V8.88619H70.4562C70.4562 8.67927 70.4112 8.49598 70.3212 8.33629C70.2313 8.17661 70.1065 8.05179 69.9468 7.96183C69.7893 7.86961 69.606 7.82351 69.3969 7.82351C69.1787 7.82351 68.9853 7.87411 68.8166 7.97532C68.6502 8.07428 68.5198 8.2081 68.4253 8.37678C68.3308 8.54321 68.2825 8.72875 68.2802 8.93342V9.78018C68.2802 10.0366 68.3275 10.2581 68.4219 10.4448C68.5186 10.6315 68.6547 10.7754 68.8301 10.8766C69.0055 10.9778 69.2136 11.0284 69.4542 11.0284C69.6139 11.0284 69.7601 11.0059 69.8928 10.9609C70.0255 10.916 70.1391 10.8485 70.2335 10.7585C70.328 10.6686 70.4 10.5584 70.4494 10.4279L71.7786 10.5156C71.7112 10.835 71.5728 11.1139 71.3637 11.3523C71.1568 11.5884 70.8891 11.7728 70.5608 11.9055C70.2347 12.036 69.8579 12.1012 69.4306 12.1012ZM75.5031 6.81818V7.89773H72.3825V6.81818H75.5031ZM73.091 5.5767H74.5281V10.4077C74.5281 10.5404 74.5483 10.6438 74.5888 10.718C74.6293 10.79 74.6855 10.8406 74.7575 10.8699C74.8317 10.8991 74.9172 10.9137 75.0139 10.9137C75.0814 10.9137 75.1488 10.9081 75.2163 10.8968C75.2838 10.8833 75.3355 10.8732 75.3715 10.8665L75.5975 11.9359C75.5256 11.9584 75.4243 11.9843 75.2939 12.0135C75.1635 12.045 75.0049 12.0641 74.8182 12.0708C74.4719 12.0843 74.1682 12.0382 73.9074 11.9325C73.6487 11.8268 73.4474 11.6626 73.3035 11.44C73.1595 11.2173 73.0887 10.9362 73.091 10.5966V5.5767ZM80.1156 12.0978C79.785 12.0978 79.4904 12.0405 79.2317 11.9258C78.9731 11.8088 78.7684 11.6368 78.6177 11.4096C78.4693 11.1802 78.3951 10.8946 78.3951 10.5527C78.3951 10.2649 78.4479 10.0231 78.5536 9.82741C78.6593 9.63175 78.8033 9.47431 78.9854 9.35511C79.1676 9.23591 79.3745 9.14595 79.6062 9.08523C79.8401 9.0245 80.0852 8.98177 80.3416 8.95703C80.643 8.92554 80.8859 8.89631 81.0703 8.86932C81.2547 8.84008 81.3886 8.79735 81.4718 8.74112C81.555 8.6849 81.5966 8.60168 81.5966 8.49148V8.47124C81.5966 8.25758 81.5291 8.09227 81.3942 7.97532C81.2615 7.85837 81.0726 7.79989 80.8274 7.79989C80.5688 7.79989 80.363 7.85724 80.21 7.97195C80.0571 8.0844 79.9559 8.22609 79.9064 8.39702L78.5772 8.28906C78.6447 7.97419 78.7774 7.70206 78.9753 7.47266C79.1732 7.241 79.4285 7.06333 79.7411 6.93963C80.056 6.81368 80.4203 6.75071 80.8342 6.75071C81.122 6.75071 81.3975 6.78445 81.6607 6.85192C81.9261 6.91939 82.1611 7.02397 82.3658 7.16566C82.5727 7.30735 82.7357 7.48952 82.8549 7.71218C82.9741 7.93259 83.0337 8.19685 83.0337 8.50497V12H81.6708V11.2814H81.6303C81.5471 11.4434 81.4358 11.5862 81.2963 11.7099C81.1569 11.8313 80.9893 11.9269 80.7937 11.9966C80.598 12.0641 80.372 12.0978 80.1156 12.0978ZM80.5272 11.106C80.7386 11.106 80.9252 11.0644 81.0872 10.9812C81.2491 10.8957 81.3762 10.781 81.4684 10.6371C81.5606 10.4931 81.6067 10.3301 81.6067 10.1479V9.59801C81.5617 9.62725 81.4999 9.65424 81.4212 9.67898C81.3447 9.70147 81.2581 9.72283 81.1614 9.74308C81.0647 9.76107 80.968 9.77794 80.8713 9.79368C80.7746 9.80717 80.6868 9.81954 80.6081 9.83079C80.4395 9.85553 80.2921 9.89489 80.1662 9.94886C80.0402 10.0028 79.9424 10.0759 79.8727 10.1681C79.803 10.2581 79.7681 10.3706 79.7681 10.5055C79.7681 10.7012 79.839 10.8507 79.9806 10.9542C80.1246 11.0554 80.3068 11.106 80.5272 11.106ZM86.9353 6.81818V7.89773H83.7371V6.81818H86.9353ZM84.4692 12V6.44371C84.4692 6.06812 84.5423 5.75663 84.6885 5.50923C84.8369 5.26184 85.0393 5.07629 85.2957 4.95259C85.5521 4.82889 85.8434 4.76704 86.1695 4.76704C86.3899 4.76704 86.5912 4.78391 86.7733 4.81765C86.9578 4.85138 87.095 4.88175 87.1849 4.90874L86.9285 5.98828C86.8723 5.97029 86.8026 5.95342 86.7194 5.93768C86.6384 5.92193 86.5552 5.91406 86.4697 5.91406C86.2583 5.91406 86.111 5.96354 86.0278 6.0625C85.9446 6.15921 85.903 6.29528 85.903 6.4707V12H84.4692Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function pf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2007_5476",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2007_5476)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.9042 9.00426V12H57.4671V5.09091H58.8637V7.73242H58.9244C59.0414 7.42655 59.2303 7.18703 59.4912 7.01385C59.7521 6.83842 60.0793 6.75071 60.4729 6.75071C60.8328 6.75071 61.1465 6.82943 61.4142 6.98686C61.684 7.14205 61.8932 7.36583 62.0416 7.6582C62.1923 7.94833 62.2665 8.29581 62.2643 8.70064V12H60.8271V8.95703C60.8294 8.63767 60.7484 8.38915 60.5843 8.21147C60.4223 8.03379 60.1952 7.94496 59.9028 7.94496C59.7071 7.94496 59.5339 7.98656 59.3833 8.06978C59.2348 8.15299 59.1179 8.27444 59.0324 8.43413C58.9492 8.59156 58.9065 8.78161 58.9042 9.00426ZM64.8729 12.0978C64.5423 12.0978 64.2477 12.0405 63.989 11.9258C63.7304 11.8088 63.5257 11.6368 63.375 11.4096C63.2266 11.1802 63.1524 10.8946 63.1524 10.5527C63.1524 10.2649 63.2052 10.0231 63.3109 9.82741C63.4167 9.63175 63.5606 9.47431 63.7428 9.35511C63.9249 9.23591 64.1319 9.14595 64.3635 9.08523C64.5974 9.0245 64.8426 8.98177 65.0989 8.95703C65.4003 8.92554 65.6432 8.89631 65.8276 8.86932C66.0121 8.84008 66.1459 8.79735 66.2291 8.74112C66.3123 8.6849 66.3539 8.60168 66.3539 8.49148V8.47124C66.3539 8.25758 66.2864 8.09227 66.1515 7.97532C66.0188 7.85837 65.8299 7.79989 65.5847 7.79989C65.3261 7.79989 65.1203 7.85724 64.9674 7.97195C64.8144 8.0844 64.7132 8.22609 64.6638 8.39702L63.3346 8.28906C63.402 7.97419 63.5347 7.70206 63.7326 7.47266C63.9306 7.241 64.1858 7.06333 64.4984 6.93963C64.8133 6.81368 65.1777 6.75071 65.5915 6.75071C65.8794 6.75071 66.1549 6.78445 66.418 6.85192C66.6834 6.91939 66.9184 7.02397 67.1231 7.16566C67.33 7.30735 67.4931 7.48952 67.6123 7.71218C67.7315 7.93259 67.7911 8.19685 67.7911 8.50497V12H66.4281V11.2814H66.3877C66.3044 11.4434 66.1931 11.5862 66.0537 11.7099C65.9142 11.8313 65.7467 11.9269 65.551 11.9966C65.3553 12.0641 65.1293 12.0978 64.8729 12.0978ZM65.2845 11.106C65.4959 11.106 65.6826 11.0644 65.8445 10.9812C66.0064 10.8957 66.1335 10.781 66.2257 10.6371C66.3179 10.4931 66.364 10.3301 66.364 10.1479V9.59801C66.3191 9.62725 66.2572 9.65424 66.1785 9.67898C66.102 9.70147 66.0154 9.72283 65.9187 9.74308C65.822 9.76107 65.7253 9.77794 65.6286 9.79368C65.5319 9.80717 65.4442 9.81954 65.3655 9.83079C65.1968 9.85553 65.0495 9.89489 64.9235 9.94886C64.7976 10.0028 64.6997 10.0759 64.63 10.1681C64.5603 10.2581 64.5254 10.3706 64.5254 10.5055C64.5254 10.7012 64.5963 10.8507 64.738 10.9542C64.8819 11.0554 65.0641 11.106 65.2845 11.106ZM65.1293 6.15021L65.8445 4.61523H67.1737L66.1448 6.15021H65.1293ZM70.3432 9.00426V12H68.906V6.81818H70.2757V7.73242H70.3364C70.4511 7.43105 70.6434 7.19265 70.9133 7.01722C71.1832 6.83955 71.5104 6.75071 71.895 6.75071C72.2549 6.75071 72.5686 6.82943 72.8362 6.98686C73.1039 7.14429 73.3119 7.3692 73.4604 7.66158C73.6088 7.9517 73.683 8.29806 73.683 8.70064V12H72.2459V8.95703C72.2481 8.63991 72.1672 8.39252 72.003 8.21484C71.8388 8.03492 71.6128 7.94496 71.3249 7.94496C71.1315 7.94496 70.9605 7.98656 70.8121 8.06978C70.6659 8.15299 70.5512 8.27444 70.468 8.43413C70.387 8.59156 70.3454 8.78161 70.3432 9.00426ZM70.6131 4.66584L71.2911 5.48899L71.9692 4.66584H73.1938V4.71307L71.8242 6.19744H70.7547L69.3884 4.71307V4.66584H70.6131ZM76.2933 12.0978C75.9627 12.0978 75.6681 12.0405 75.4094 11.9258C75.1508 11.8088 74.9461 11.6368 74.7955 11.4096C74.647 11.1802 74.5728 10.8946 74.5728 10.5527C74.5728 10.2649 74.6257 10.0231 74.7314 9.82741C74.8371 9.63175 74.981 9.47431 75.1632 9.35511C75.3453 9.23591 75.5523 9.14595 75.7839 9.08523C76.0178 9.0245 76.263 8.98177 76.5194 8.95703C76.8207 8.92554 77.0636 8.89631 77.248 8.86932C77.4325 8.84008 77.5663 8.79735 77.6495 8.74112C77.7327 8.6849 77.7743 8.60168 77.7743 8.49148V8.47124C77.7743 8.25758 77.7069 8.09227 77.5719 7.97532C77.4392 7.85837 77.2503 7.79989 77.0051 7.79989C76.7465 7.79989 76.5407 7.85724 76.3878 7.97195C76.2348 8.0844 76.1336 8.22609 76.0842 8.39702L74.755 8.28906C74.8224 7.97419 74.9551 7.70206 75.1531 7.47266C75.351 7.241 75.6062 7.06333 75.9189 6.93963C76.2337 6.81368 76.5981 6.75071 77.0119 6.75071C77.2998 6.75071 77.5753 6.78445 77.8384 6.85192C78.1038 6.91939 78.3388 7.02397 78.5435 7.16566C78.7504 7.30735 78.9135 7.48952 79.0327 7.71218C79.1519 7.93259 79.2115 8.19685 79.2115 8.50497V12H77.8485V11.2814H77.8081C77.7248 11.4434 77.6135 11.5862 77.4741 11.7099C77.3346 11.8313 77.1671 11.9269 76.9714 11.9966C76.7757 12.0641 76.5497 12.0978 76.2933 12.0978ZM76.7049 11.106C76.9163 11.106 77.103 11.0644 77.2649 10.9812C77.4268 10.8957 77.5539 10.781 77.6461 10.6371C77.7383 10.4931 77.7844 10.3301 77.7844 10.1479V9.59801C77.7395 9.62725 77.6776 9.65424 77.5989 9.67898C77.5224 9.70147 77.4358 9.72283 77.3391 9.74308C77.2424 9.76107 77.1457 9.77794 77.049 9.79368C76.9523 9.80717 76.8646 9.81954 76.7859 9.83079C76.6172 9.85553 76.4699 9.89489 76.3439 9.94886C76.218 10.0028 76.1201 10.0759 76.0504 10.1681C75.9807 10.2581 75.9458 10.3706 75.9458 10.5055C75.9458 10.7012 76.0167 10.8507 76.1584 10.9542C76.3023 11.0554 76.4845 11.106 76.7049 11.106ZM81.7636 9.00426V12H80.3264V6.81818H81.6961V7.73242H81.7568C81.8715 7.43105 82.0638 7.19265 82.3337 7.01722C82.6036 6.83955 82.9308 6.75071 83.3154 6.75071C83.6753 6.75071 83.989 6.82943 84.2567 6.98686C84.5243 7.14429 84.7323 7.3692 84.8808 7.66158C85.0292 7.9517 85.1034 8.29806 85.1034 8.70064V12H83.6663V8.95703C83.6685 8.63991 83.5876 8.39252 83.4234 8.21484C83.2592 8.03492 83.0332 7.94496 82.7453 7.94496C82.5519 7.94496 82.3809 7.98656 82.2325 8.06978C82.0863 8.15299 81.9716 8.27444 81.8884 8.43413C81.8074 8.59156 81.7658 8.78161 81.7636 9.00426ZM86.9378 13.9432C86.7556 13.9432 86.5847 13.9286 86.425 13.8993C86.2676 13.8723 86.1371 13.8375 86.0337 13.7947L86.3576 12.7219C86.5262 12.7737 86.678 12.8018 86.813 12.8063C86.9502 12.8108 87.0683 12.7793 87.1672 12.7118C87.2684 12.6444 87.3505 12.5297 87.4135 12.3677L87.4978 12.1484L85.639 6.81818H87.1503L88.2231 10.6236H88.2771L89.36 6.81818H90.8815L88.8675 12.56C88.7708 12.8389 88.6392 13.0818 88.4728 13.2887C88.3086 13.4979 88.1006 13.6587 87.8487 13.7711C87.5968 13.8858 87.2932 13.9432 86.9378 13.9432ZM87.734 6.15021L88.4492 4.61523H89.7784L88.7494 6.15021H87.734Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function hf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2007_5452",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2007_5452)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.3594 12L56.9492 6.81818H58.4032L59.2061 10.2997H59.2534L60.09 6.81818H61.517L62.3672 10.2795H62.411L63.2005 6.81818H64.6511L63.2443 12H61.7228L60.8322 8.74112H60.7681L59.8775 12H58.3594ZM67.6494 12.1012C67.1163 12.1012 66.6575 11.9933 66.2729 11.7773C65.8906 11.5592 65.596 11.2511 65.3891 10.853C65.1822 10.4527 65.0787 9.97923 65.0787 9.43271C65.0787 8.89968 65.1822 8.43188 65.3891 8.0293C65.596 7.62672 65.8872 7.31297 66.2628 7.08807C66.6407 6.86316 67.0837 6.75071 67.592 6.75071C67.9339 6.75071 68.2521 6.80581 68.5467 6.91602C68.8436 7.02397 69.1023 7.18703 69.3227 7.40518C69.5453 7.62334 69.7185 7.89773 69.8422 8.22834C69.9659 8.5567 70.0277 8.94129 70.0277 9.3821V9.77681H65.6522V8.88619H68.6749C68.6749 8.67927 68.63 8.49598 68.54 8.33629C68.45 8.17661 68.3252 8.05179 68.1655 7.96183C68.0081 7.86961 67.8248 7.82351 67.6156 7.82351C67.3975 7.82351 67.2041 7.87411 67.0354 7.97532C66.8689 8.07428 66.7385 8.2081 66.644 8.37678C66.5496 8.54321 66.5012 8.72875 66.499 8.93342V9.78018C66.499 10.0366 66.5462 10.2581 66.6407 10.4448C66.7374 10.6315 66.8734 10.7754 67.0489 10.8766C67.2243 10.9778 67.4323 11.0284 67.673 11.0284C67.8327 11.0284 67.9789 11.0059 68.1116 10.9609C68.2442 10.916 68.3578 10.8485 68.4523 10.7585C68.5467 10.6686 68.6187 10.5584 68.6682 10.4279L69.9974 10.5156C69.9299 10.835 69.7916 11.1139 69.5824 11.3523C69.3755 11.5884 69.1079 11.7728 68.7795 11.9055C68.4534 12.036 68.0767 12.1012 67.6494 12.1012ZM70.9656 12V6.81818H72.3589V7.7223H72.4129C72.5073 7.40069 72.6659 7.15779 72.8885 6.99361C73.1112 6.82718 73.3676 6.74396 73.6577 6.74396C73.7297 6.74396 73.8073 6.74846 73.8905 6.75746C73.9737 6.76645 74.0468 6.77882 74.1098 6.79457V8.06978C74.0423 8.04954 73.949 8.03155 73.8298 8.0158C73.7106 8.00006 73.6015 7.99219 73.5025 7.99219C73.2911 7.99219 73.1022 8.03829 72.9358 8.1305C72.7716 8.22047 72.6411 8.34641 72.5444 8.50835C72.45 8.67028 72.4027 8.85695 72.4027 9.06836V12H70.9656ZM76.9731 12.1012C76.4401 12.1012 75.9813 11.9933 75.5967 11.7773C75.2143 11.5592 74.9197 11.2511 74.7128 10.853C74.5059 10.4527 74.4024 9.97923 74.4024 9.43271C74.4024 8.89968 74.5059 8.43188 74.7128 8.0293C74.9197 7.62672 75.211 7.31297 75.5866 7.08807C75.9644 6.86316 76.4075 6.75071 76.9157 6.75071C77.2576 6.75071 77.5758 6.80581 77.8705 6.91602C78.1673 7.02397 78.426 7.18703 78.6464 7.40518C78.8691 7.62334 79.0422 7.89773 79.1659 8.22834C79.2896 8.5567 79.3515 8.94129 79.3515 9.3821V9.77681H74.9759V8.88619H77.9987C77.9987 8.67927 77.9537 8.49598 77.8637 8.33629C77.7738 8.17661 77.6489 8.05179 77.4893 7.96183C77.3318 7.86961 77.1485 7.82351 76.9394 7.82351C76.7212 7.82351 76.5278 7.87411 76.3591 7.97532C76.1927 8.07428 76.0622 8.2081 75.9678 8.37678C75.8733 8.54321 75.825 8.72875 75.8227 8.93342V9.78018C75.8227 10.0366 75.8699 10.2581 75.9644 10.4448C76.0611 10.6315 76.1972 10.7754 76.3726 10.8766C76.548 10.9778 76.7561 11.0284 76.9967 11.0284C77.1564 11.0284 77.3026 11.0059 77.4353 10.9609C77.568 10.916 77.6816 10.8485 77.776 10.7585C77.8705 10.6686 77.9424 10.5584 77.9919 10.4279L79.3211 10.5156C79.2536 10.835 79.1153 11.1139 78.9062 11.3523C78.6992 11.5884 78.4316 11.7728 78.1032 11.9055C77.7771 12.036 77.4004 12.1012 76.9731 12.1012ZM82.1988 12.0843C81.8052 12.0843 81.4487 11.9831 81.1294 11.7807C80.8122 11.5761 80.5603 11.2758 80.3737 10.88C80.1892 10.4819 80.097 9.99384 80.097 9.41584C80.097 8.82209 80.1926 8.32842 80.3838 7.93484C80.575 7.539 80.8291 7.24325 81.1462 7.04759C81.4656 6.84967 81.8153 6.75071 82.1954 6.75071C82.4855 6.75071 82.7273 6.80019 82.9207 6.89915C83.1164 6.99586 83.2738 7.11731 83.393 7.26349C83.5145 7.40743 83.6067 7.54912 83.6697 7.68857H83.7135V5.09091H85.1473V12H83.7304V11.1701H83.6697C83.6022 11.314 83.5066 11.4569 83.3829 11.5985C83.2615 11.738 83.1029 11.8538 82.9072 11.946C82.7138 12.0382 82.4777 12.0843 82.1988 12.0843ZM82.6542 10.9407C82.8859 10.9407 83.0815 10.8777 83.2412 10.7518C83.4031 10.6236 83.5268 10.4448 83.6123 10.2154C83.7 9.98597 83.7439 9.71721 83.7439 9.40909C83.7439 9.10097 83.7011 8.83333 83.6157 8.60618C83.5302 8.37902 83.4065 8.2036 83.2446 8.0799C83.0827 7.9562 82.8859 7.89435 82.6542 7.89435C82.4181 7.89435 82.219 7.95845 82.0571 8.08665C81.8952 8.21484 81.7726 8.39252 81.6894 8.61967C81.6061 8.84683 81.5645 9.10997 81.5645 9.40909C81.5645 9.71046 81.6061 9.97698 81.6894 10.2086C81.7748 10.438 81.8974 10.618 82.0571 10.7484C82.219 10.8766 82.4181 10.9407 82.6542 10.9407ZM88.5546 12V5.09091H89.9917V7.68857H90.0356C90.0986 7.54912 90.1897 7.40743 90.3089 7.26349C90.4303 7.11731 90.5877 6.99586 90.7812 6.89915C90.9768 6.80019 91.2197 6.75071 91.5099 6.75071C91.8877 6.75071 92.2363 6.84967 92.5557 7.04759C92.875 7.24325 93.1303 7.539 93.3215 7.93484C93.5126 8.32842 93.6082 8.82209 93.6082 9.41584C93.6082 9.99384 93.5149 10.4819 93.3282 10.88C93.1438 11.2758 92.8919 11.5761 92.5725 11.7807C92.2554 11.9831 91.9001 12.0843 91.5065 12.0843C91.2276 12.0843 90.9903 12.0382 90.7947 11.946C90.6012 11.8538 90.4427 11.738 90.319 11.5985C90.1953 11.4569 90.1008 11.314 90.0356 11.1701H89.9715V12H88.5546ZM89.9614 9.40909C89.9614 9.71721 90.0041 9.98597 90.0896 10.2154C90.175 10.4448 90.2987 10.6236 90.4607 10.7518C90.6226 10.8777 90.8194 10.9407 91.051 10.9407C91.2849 10.9407 91.4829 10.8766 91.6448 10.7484C91.8067 10.618 91.9293 10.438 92.0125 10.2086C92.098 9.97698 92.1407 9.71046 92.1407 9.40909C92.1407 9.10997 92.0991 8.84683 92.0159 8.61967C91.9327 8.39252 91.8101 8.21484 91.6482 8.08665C91.4862 7.95845 91.2872 7.89435 91.051 7.89435C90.8171 7.89435 90.6192 7.9562 90.4573 8.0799C90.2976 8.2036 90.175 8.37902 90.0896 8.60618C90.0041 8.83333 89.9614 9.10097 89.9614 9.40909ZM95.2874 13.9432C95.1052 13.9432 94.9343 13.9286 94.7746 13.8993C94.6172 13.8723 94.4868 13.8375 94.3833 13.7947L94.7072 12.7219C94.8758 12.7737 95.0277 12.8018 95.1626 12.8063C95.2998 12.8108 95.4179 12.7793 95.5168 12.7118C95.618 12.6444 95.7001 12.5297 95.7631 12.3677L95.8474 12.1484L93.9886 6.81818H95.5L96.5728 10.6236H96.6267L97.7097 6.81818H99.2311L97.2171 12.56C97.1204 12.8389 96.9888 13.0818 96.8224 13.2887C96.6582 13.4979 96.4502 13.6587 96.1983 13.7711C95.9464 13.8858 95.6428 13.9432 95.2874 13.9432Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ff(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2007_5428",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2007_5428)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.9042 9.00426V12H57.4671V5.09091H58.8637V7.73242H58.9244C59.0414 7.42655 59.2303 7.18703 59.4912 7.01385C59.7521 6.83842 60.0793 6.75071 60.4729 6.75071C60.8328 6.75071 61.1465 6.82943 61.4142 6.98686C61.684 7.14205 61.8932 7.36583 62.0416 7.6582C62.1923 7.94833 62.2665 8.29581 62.2643 8.70064V12H60.8271V8.95703C60.8294 8.63767 60.7484 8.38915 60.5843 8.21147C60.4223 8.03379 60.1952 7.94496 59.9028 7.94496C59.7071 7.94496 59.5339 7.98656 59.3833 8.06978C59.2348 8.15299 59.1179 8.27444 59.0324 8.43413C58.9492 8.59156 58.9065 8.78161 58.9042 9.00426ZM64.8729 12.0978C64.5423 12.0978 64.2477 12.0405 63.989 11.9258C63.7304 11.8088 63.5257 11.6368 63.375 11.4096C63.2266 11.1802 63.1524 10.8946 63.1524 10.5527C63.1524 10.2649 63.2052 10.0231 63.3109 9.82741C63.4167 9.63175 63.5606 9.47431 63.7428 9.35511C63.9249 9.23591 64.1319 9.14595 64.3635 9.08523C64.5974 9.0245 64.8426 8.98177 65.0989 8.95703C65.4003 8.92554 65.6432 8.89631 65.8276 8.86932C66.0121 8.84008 66.1459 8.79735 66.2291 8.74112C66.3123 8.6849 66.3539 8.60168 66.3539 8.49148V8.47124C66.3539 8.25758 66.2864 8.09227 66.1515 7.97532C66.0188 7.85837 65.8299 7.79989 65.5847 7.79989C65.3261 7.79989 65.1203 7.85724 64.9674 7.97195C64.8144 8.0844 64.7132 8.22609 64.6638 8.39702L63.3346 8.28906C63.402 7.97419 63.5347 7.70206 63.7326 7.47266C63.9306 7.241 64.1858 7.06333 64.4984 6.93963C64.8133 6.81368 65.1777 6.75071 65.5915 6.75071C65.8794 6.75071 66.1549 6.78445 66.418 6.85192C66.6834 6.91939 66.9184 7.02397 67.1231 7.16566C67.33 7.30735 67.4931 7.48952 67.6123 7.71218C67.7315 7.93259 67.7911 8.19685 67.7911 8.50497V12H66.4281V11.2814H66.3877C66.3044 11.4434 66.1931 11.5862 66.0537 11.7099C65.9142 11.8313 65.7467 11.9269 65.551 11.9966C65.3553 12.0641 65.1293 12.0978 64.8729 12.0978ZM65.2845 11.106C65.4959 11.106 65.6826 11.0644 65.8445 10.9812C66.0064 10.8957 66.1335 10.781 66.2257 10.6371C66.3179 10.4931 66.364 10.3301 66.364 10.1479V9.59801C66.3191 9.62725 66.2572 9.65424 66.1785 9.67898C66.102 9.70147 66.0154 9.72283 65.9187 9.74308C65.822 9.76107 65.7253 9.77794 65.6286 9.79368C65.5319 9.80717 65.4442 9.81954 65.3655 9.83079C65.1968 9.85553 65.0495 9.89489 64.9235 9.94886C64.7976 10.0028 64.6997 10.0759 64.63 10.1681C64.5603 10.2581 64.5254 10.3706 64.5254 10.5055C64.5254 10.7012 64.5963 10.8507 64.738 10.9542C64.8819 11.0554 65.0641 11.106 65.2845 11.106ZM65.1293 6.15021L65.8445 4.61523H67.1737L66.1448 6.15021H65.1293ZM70.3432 9.00426V12H68.906V6.81818H70.2757V7.73242H70.3364C70.4511 7.43105 70.6434 7.19265 70.9133 7.01722C71.1832 6.83955 71.5104 6.75071 71.895 6.75071C72.2549 6.75071 72.5686 6.82943 72.8362 6.98686C73.1039 7.14429 73.3119 7.3692 73.4604 7.66158C73.6088 7.9517 73.683 8.29806 73.683 8.70064V12H72.2459V8.95703C72.2481 8.63991 72.1672 8.39252 72.003 8.21484C71.8388 8.03492 71.6128 7.94496 71.3249 7.94496C71.1315 7.94496 70.9605 7.98656 70.8121 8.06978C70.6659 8.15299 70.5512 8.27444 70.468 8.43413C70.387 8.59156 70.3454 8.78161 70.3432 9.00426ZM77.1772 12.1012C76.6442 12.1012 76.1854 11.9933 75.8008 11.7773C75.4184 11.5592 75.1238 11.2511 74.9169 10.853C74.71 10.4527 74.6065 9.97923 74.6065 9.43271C74.6065 8.89968 74.71 8.43188 74.9169 8.0293C75.1238 7.62672 75.4151 7.31297 75.7907 7.08807C76.1685 6.86316 76.6116 6.75071 77.1199 6.75071C77.4617 6.75071 77.7799 6.80581 78.0746 6.91602C78.3714 7.02397 78.6301 7.18703 78.8505 7.40518C79.0732 7.62334 79.2463 7.89773 79.37 8.22834C79.4937 8.5567 79.5556 8.94129 79.5556 9.3821V9.77681H75.18V8.88619H78.2028C78.2028 8.67927 78.1578 8.49598 78.0678 8.33629C77.9779 8.17661 77.853 8.05179 77.6934 7.96183C77.5359 7.86961 77.3526 7.82351 77.1435 7.82351C76.9253 7.82351 76.7319 7.87411 76.5632 7.97532C76.3968 8.07428 76.2663 8.2081 76.1719 8.37678C76.0774 8.54321 76.0291 8.72875 76.0268 8.93342V9.78018C76.0268 10.0366 76.074 10.2581 76.1685 10.4448C76.2652 10.6315 76.4013 10.7754 76.5767 10.8766C76.7521 10.9778 76.9602 11.0284 77.2008 11.0284C77.3605 11.0284 77.5067 11.0059 77.6394 10.9609C77.7721 10.916 77.8857 10.8485 77.9801 10.7585C78.0746 10.6686 78.1465 10.5584 78.196 10.4279L79.5252 10.5156C79.4577 10.835 79.3194 11.1139 79.1103 11.3523C78.9034 11.5884 78.6357 11.7728 78.3074 11.9055C77.9812 12.036 77.6045 12.1012 77.1772 12.1012ZM76.408 4.66584L77.0861 5.48899L77.7642 4.66584H78.9888V4.71307L77.6191 6.19744H76.5497L75.1834 4.71307V4.66584H76.408ZM81.9306 9.00426V12H80.4934V6.81818H81.8631V7.73242H81.9238C82.0385 7.43105 82.2308 7.19265 82.5007 7.01722C82.7706 6.83955 83.0978 6.75071 83.4824 6.75071C83.8423 6.75071 84.156 6.82943 84.4237 6.98686C84.6913 7.14429 84.8993 7.3692 85.0478 7.66158C85.1962 7.9517 85.2704 8.29806 85.2704 8.70064V12H83.8333V8.95703C83.8355 8.63991 83.7546 8.39252 83.5904 8.21484C83.4262 8.03492 83.2002 7.94496 82.9123 7.94496C82.7189 7.94496 82.5479 7.98656 82.3995 8.06978C82.2533 8.15299 82.1386 8.27444 82.0554 8.43413C81.9744 8.59156 81.9328 8.78161 81.9306 9.00426ZM88.7444 12.1012C88.2203 12.1012 87.7671 11.9899 87.3848 11.7672C87.0047 11.5423 86.7112 11.2297 86.5043 10.8294C86.2974 10.4268 86.1939 9.96011 86.1939 9.42933C86.1939 8.89406 86.2974 8.42625 86.5043 8.02592C86.7112 7.62334 87.0047 7.31072 87.3848 7.08807C87.7671 6.86316 88.2203 6.75071 88.7444 6.75071C89.2684 6.75071 89.7205 6.86316 90.1005 7.08807C90.4829 7.31072 90.7775 7.62334 90.9844 8.02592C91.1913 8.42625 91.2948 8.89406 91.2948 9.42933C91.2948 9.96011 91.1913 10.4268 90.9844 10.8294C90.7775 11.2297 90.4829 11.5423 90.1005 11.7672C89.7205 11.9899 89.2684 12.1012 88.7444 12.1012ZM88.7511 10.9879C88.9895 10.9879 89.1886 10.9205 89.3482 10.7855C89.5079 10.6483 89.6282 10.4616 89.7092 10.2255C89.7924 9.98935 89.834 9.72058 89.834 9.41921C89.834 9.11784 89.7924 8.84908 89.7092 8.61293C89.6282 8.37678 89.5079 8.1901 89.3482 8.05291C89.1886 7.91572 88.9895 7.84712 88.7511 7.84712C88.5105 7.84712 88.308 7.91572 88.1439 8.05291C87.9819 8.1901 87.8594 8.37678 87.7761 8.61293C87.6952 8.84908 87.6547 9.11784 87.6547 9.41921C87.6547 9.72058 87.6952 9.98935 87.7761 10.2255C87.8594 10.4616 87.9819 10.6483 88.1439 10.7855C88.308 10.9205 88.5105 10.9879 88.7511 10.9879Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function mf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2005_5380",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2005_5380)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M51.6966 7.50977H50.2189C50.1919 7.3186 50.1368 7.14879 50.0536 7.00035C49.9704 6.84967 49.8636 6.72147 49.7331 6.61577C49.6027 6.51006 49.452 6.4291 49.2811 6.37287C49.1124 6.31664 48.9291 6.28853 48.7312 6.28853C48.3736 6.28853 48.0621 6.37737 47.7967 6.55504C47.5313 6.73047 47.3255 6.98686 47.1793 7.32422C47.0331 7.65933 46.96 8.06641 46.96 8.54545C46.96 9.038 47.0331 9.45182 47.1793 9.78693C47.3278 10.122 47.5347 10.3751 47.8001 10.546C48.0655 10.7169 48.3725 10.8024 48.7211 10.8024C48.9167 10.8024 49.0978 10.7765 49.2642 10.7248C49.4329 10.6731 49.5824 10.5977 49.7129 10.4988C49.8433 10.3975 49.9513 10.275 50.0368 10.131C50.1245 9.9871 50.1852 9.82292 50.2189 9.63849L51.6966 9.64524C51.6583 9.96236 51.5627 10.2682 51.4098 10.5629C51.2591 10.8552 51.0556 11.1172 50.7992 11.3489C50.545 11.5783 50.2414 11.7605 49.8883 11.8954C49.5375 12.0281 49.1405 12.0945 48.6974 12.0945C48.0812 12.0945 47.5302 11.955 47.0444 11.6761C46.5608 11.3973 46.1785 10.9935 45.8974 10.465C45.6185 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5721 5.69141 47.0579 5.41477C47.5437 5.13589 48.0902 4.99645 48.6974 4.99645C49.0978 4.99645 49.4689 5.05267 49.8107 5.16513C50.1548 5.27758 50.4596 5.44176 50.725 5.65767C50.9904 5.87133 51.2063 6.13334 51.3727 6.44371C51.5414 6.75408 51.6493 7.10943 51.6966 7.50977ZM56.04 9.79368V6.81818H57.4772V12H56.0974V11.0588H56.0434C55.9265 11.3624 55.7319 11.6064 55.4598 11.7908C55.1899 11.9753 54.8604 12.0675 54.4713 12.0675C54.125 12.0675 53.8202 11.9888 53.5571 11.8313C53.2939 11.6739 53.0882 11.4501 52.9397 11.16C52.7935 10.8699 52.7193 10.5224 52.7171 10.1175V6.81818H54.1542V9.86115C54.1565 10.167 54.2385 10.4088 54.4005 10.5865C54.5624 10.7641 54.7794 10.853 55.0516 10.853C55.2248 10.853 55.3867 10.8136 55.5374 10.7349C55.6881 10.6539 55.8095 10.5347 55.9017 10.3773C55.9962 10.2199 56.0423 10.0253 56.04 9.79368ZM65.1369 8.29581L63.8212 8.37678C63.7987 8.26432 63.7504 8.16312 63.6761 8.07315C63.6019 7.98094 63.5041 7.90785 63.3826 7.85387C63.2634 7.79764 63.1206 7.76953 62.9542 7.76953C62.7315 7.76953 62.5437 7.81676 62.3908 7.91122C62.2379 8.00343 62.1614 8.12713 62.1614 8.28232C62.1614 8.40601 62.2109 8.51059 62.3098 8.59606C62.4088 8.68152 62.5786 8.75012 62.8192 8.80185L63.7571 8.99077C64.2609 9.09422 64.6365 9.26065 64.8839 9.49006C65.1313 9.71946 65.255 10.0208 65.255 10.3942C65.255 10.7338 65.1549 11.0318 64.9547 11.2882C64.7568 11.5446 64.4847 11.7447 64.1383 11.8887C63.7942 12.0304 63.3973 12.1012 62.9474 12.1012C62.2615 12.1012 61.715 11.9584 61.3079 11.6728C60.9031 11.3849 60.6658 10.9935 60.5961 10.4988L62.0096 10.4245C62.0523 10.6337 62.1558 10.7934 62.32 10.9036C62.4841 11.0115 62.6944 11.0655 62.9508 11.0655C63.2027 11.0655 63.4051 11.0172 63.5581 10.9205C63.7132 10.8215 63.792 10.6944 63.7942 10.5392C63.792 10.4088 63.7369 10.302 63.6289 10.2188C63.521 10.1333 63.3545 10.0681 63.1296 10.0231L62.2322 9.84428C61.7262 9.74308 61.3495 9.56765 61.1021 9.318C60.8569 9.06836 60.7344 8.75012 60.7344 8.36328C60.7344 8.03042 60.8243 7.74367 61.0043 7.50302C61.1864 7.26237 61.4417 7.07682 61.7701 6.94638C62.1007 6.81593 62.4875 6.75071 62.9306 6.75071C63.585 6.75071 64.1001 6.88903 64.4757 7.16566C64.8535 7.44229 65.0739 7.81901 65.1369 8.29581ZM66.1599 13.9432V6.81818H67.5768V7.68857H67.6409C67.7039 7.54912 67.795 7.40743 67.9142 7.26349C68.0356 7.11731 68.1931 6.99586 68.3865 6.89915C68.5822 6.80019 68.8251 6.75071 69.1152 6.75071C69.493 6.75071 69.8416 6.84967 70.161 7.04759C70.4804 7.24325 70.7356 7.539 70.9268 7.93484C71.118 8.32842 71.2136 8.82209 71.2136 9.41584C71.2136 9.99384 71.1202 10.4819 70.9335 10.88C70.7491 11.2758 70.4972 11.5761 70.1779 11.7807C69.8608 11.9831 69.5054 12.0843 69.1118 12.0843C68.8329 12.0843 68.5957 12.0382 68.4 11.946C68.2066 11.8538 68.048 11.738 67.9243 11.5985C67.8006 11.4569 67.7062 11.314 67.6409 11.1701H67.5971V13.9432H66.1599ZM67.5667 9.40909C67.5667 9.71721 67.6094 9.98597 67.6949 10.2154C67.7804 10.4448 67.9041 10.6236 68.066 10.7518C68.2279 10.8777 68.4247 10.9407 68.6564 10.9407C68.8903 10.9407 69.0882 10.8766 69.2501 10.7484C69.4121 10.618 69.5346 10.438 69.6179 10.2086C69.7033 9.97698 69.746 9.71046 69.746 9.40909C69.746 9.10997 69.7044 8.84683 69.6212 8.61967C69.538 8.39252 69.4154 8.21484 69.2535 8.08665C69.0916 7.95845 68.8925 7.89435 68.6564 7.89435C68.4225 7.89435 68.2246 7.9562 68.0626 8.0799C67.903 8.2036 67.7804 8.37902 67.6949 8.60618C67.6094 8.83333 67.5667 9.10097 67.5667 9.40909ZM72.1717 12V6.81818H73.5649V7.7223H73.6189C73.7134 7.40069 73.8719 7.15779 74.0946 6.99361C74.3172 6.82718 74.5736 6.74396 74.8638 6.74396C74.9357 6.74396 75.0133 6.74846 75.0965 6.75746C75.1798 6.76645 75.2529 6.77882 75.3158 6.79457V8.06978C75.2484 8.04954 75.155 8.03155 75.0358 8.0158C74.9166 8.00006 74.8075 7.99219 74.7086 7.99219C74.4972 7.99219 74.3083 8.03829 74.1418 8.1305C73.9776 8.22047 73.8472 8.34641 73.7505 8.50835C73.656 8.67028 73.6088 8.85695 73.6088 9.06836V12H72.1717ZM76.0589 12V6.81818H77.496V12H76.0589ZM76.7808 6.15021C76.5671 6.15021 76.3838 6.07937 76.2309 5.93768C76.0802 5.79374 76.0049 5.62169 76.0049 5.42152C76.0049 5.2236 76.0802 5.0538 76.2309 4.91211C76.3838 4.76817 76.5671 4.6962 76.7808 4.6962C76.9945 4.6962 77.1766 4.76817 77.3273 4.91211C77.4803 5.0538 77.5567 5.2236 77.5567 5.42152C77.5567 5.62169 77.4803 5.79374 77.3273 5.93768C77.1766 6.07937 76.9945 6.15021 76.7808 6.15021ZM78.6472 6.81818H80.0844V12.2564C80.0844 12.6567 80.0057 12.9806 79.8482 13.228C79.6908 13.4754 79.4648 13.6564 79.1701 13.7711C78.8778 13.8858 78.528 13.9432 78.121 13.9432C78.0715 13.9432 78.0243 13.9421 77.9793 13.9398C77.932 13.9398 77.8826 13.9387 77.8308 13.9364V12.813C77.8691 12.8153 77.9028 12.8164 77.932 12.8164C77.959 12.8187 77.9883 12.8198 78.0198 12.8198C78.2514 12.8198 78.4133 12.7703 78.5055 12.6713C78.6 12.5746 78.6472 12.4284 78.6472 12.2328V6.81818ZM79.3624 6.15021C79.151 6.15021 78.9689 6.07937 78.8159 5.93768C78.663 5.79374 78.5865 5.62169 78.5865 5.42152C78.5865 5.2236 78.663 5.0538 78.8159 4.91211C78.9689 4.76817 79.151 4.6962 79.3624 4.6962C79.5783 4.6962 79.7616 4.76817 79.9123 4.91211C80.0653 5.0538 80.1417 5.2236 80.1417 5.42152C80.1417 5.62169 80.0653 5.79374 79.9123 5.93768C79.7616 6.07937 79.5783 6.15021 79.3624 6.15021ZM81.2356 12V6.81818H82.6728V12H81.2356ZM81.9576 6.15021C81.7439 6.15021 81.5606 6.07937 81.4077 5.93768C81.257 5.79374 81.1816 5.62169 81.1816 5.42152C81.1816 5.2236 81.257 5.0538 81.4077 4.91211C81.5606 4.76817 81.7439 4.6962 81.9576 4.6962C82.1712 4.6962 82.3534 4.76817 82.5041 4.91211C82.657 5.0538 82.7335 5.2236 82.7335 5.42152C82.7335 5.62169 82.657 5.79374 82.5041 5.93768C82.3534 6.07937 82.1712 6.15021 81.9576 6.15021ZM85.2611 9.00426V12H83.824V6.81818H85.1937V7.73242H85.2544C85.3691 7.43105 85.5614 7.19265 85.8313 7.01722C86.1012 6.83955 86.4284 6.75071 86.813 6.75071C87.1728 6.75071 87.4866 6.82943 87.7542 6.98686C88.0219 7.14429 88.2299 7.3692 88.3783 7.66158C88.5268 7.9517 88.601 8.29806 88.601 8.70064V12H87.1638V8.95703C87.1661 8.63991 87.0851 8.39252 86.9209 8.21484C86.7568 8.03492 86.5307 7.94496 86.2429 7.94496C86.0494 7.94496 85.8785 7.98656 85.7301 8.06978C85.5839 8.15299 85.4692 8.27444 85.386 8.43413C85.305 8.59156 85.2634 8.78161 85.2611 9.00426ZM93.0566 9.79368V6.81818H94.4938V12H93.114V11.0588H93.06C92.9431 11.3624 92.7485 11.6064 92.4764 11.7908C92.2065 11.9753 91.877 12.0675 91.4879 12.0675C91.1416 12.0675 90.8368 11.9888 90.5737 11.8313C90.3105 11.6739 90.1048 11.4501 89.9563 11.16C89.8101 10.8699 89.7359 10.5224 89.7337 10.1175V6.81818H91.1708V9.86115C91.1731 10.167 91.2551 10.4088 91.4171 10.5865C91.579 10.7641 91.796 10.853 92.0682 10.853C92.2414 10.853 92.4033 10.8136 92.554 10.7349C92.7047 10.6539 92.8261 10.5347 92.9183 10.3773C93.0128 10.2199 93.0589 10.0253 93.0566 9.79368ZM97.0805 5.09091V12H95.6433V5.09091H97.0805Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function gf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2004_5260",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2004_5260)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.667 5.2835H53.9775V6.338H48.667V5.2835ZM48.8285 7.478H52.8945V8.504H48.8285V7.478ZM50.7095 3.925H51.84V8.0385H50.7095V3.925ZM50.0635 8.295C50.4118 9.17533 50.9438 9.929 51.6595 10.556C52.3752 11.1767 53.2713 11.6168 54.348 11.8765C54.2657 11.9588 54.177 12.057 54.082 12.171C53.987 12.285 53.8983 12.4022 53.816 12.5225C53.74 12.6492 53.6735 12.7632 53.6165 12.8645C52.4765 12.5288 51.536 12 50.795 11.278C50.0603 10.556 49.4745 9.65983 49.0375 8.5895L50.0635 8.295ZM52.771 7.478H52.9895L53.1795 7.44L53.911 7.7345C53.721 8.4375 53.4613 9.0645 53.132 9.6155C52.809 10.1665 52.4227 10.6478 51.973 11.0595C51.5297 11.4712 51.0325 11.8227 50.4815 12.114C49.9368 12.4053 49.351 12.6428 48.724 12.8265C48.686 12.7315 48.6322 12.6175 48.5625 12.4845C48.4928 12.3578 48.4168 12.2312 48.3345 12.1045C48.2585 11.9842 48.1857 11.8828 48.116 11.8005C48.686 11.6675 49.2212 11.4807 49.7215 11.24C50.2282 10.9993 50.6842 10.7048 51.0895 10.3565C51.4948 10.0082 51.84 9.60917 52.125 9.1595C52.4163 8.7035 52.6317 8.20317 52.771 7.6585V7.478ZM45.2565 8.751C45.5352 8.694 45.8518 8.6275 46.2065 8.5515C46.5612 8.46917 46.9317 8.3805 47.318 8.2855C47.7107 8.18417 48.097 8.086 48.477 7.991L48.6195 9.036C48.1002 9.18167 47.5682 9.32733 47.0235 9.473C46.4852 9.61233 45.9943 9.73583 45.551 9.8435L45.2565 8.751ZM45.38 5.7395H48.5435V6.794H45.38V5.7395ZM46.482 3.925H47.603V11.5915C47.603 11.8638 47.5713 12.076 47.508 12.228C47.451 12.3863 47.3402 12.5098 47.1755 12.5985C47.0172 12.6808 46.8208 12.7347 46.5865 12.76C46.3522 12.7853 46.064 12.798 45.722 12.798C45.703 12.6523 45.6618 12.4782 45.5985 12.2755C45.5352 12.0792 45.4687 11.9082 45.399 11.7625C45.589 11.7688 45.7695 11.772 45.9405 11.772C46.1178 11.772 46.2382 11.772 46.3015 11.772C46.4218 11.772 46.482 11.7087 46.482 11.582V3.925ZM60.1715 7.0125C60.3678 7.36717 60.6022 7.72183 60.8745 8.0765C61.1532 8.43117 61.454 8.77633 61.777 9.112C62.1 9.44767 62.4325 9.76117 62.7745 10.0525C63.1165 10.3438 63.4585 10.594 63.8005 10.803C63.7055 10.879 63.5978 10.9772 63.4775 11.0975C63.3635 11.2178 63.2527 11.3413 63.145 11.468C63.0437 11.5947 62.955 11.7118 62.879 11.8195C62.5433 11.5662 62.2045 11.2748 61.8625 10.9455C61.5268 10.6098 61.2007 10.2488 60.884 9.8625C60.5673 9.46983 60.2665 9.0645 59.9815 8.6465C59.7028 8.2285 59.4527 7.8105 59.231 7.3925L60.1715 7.0125ZM58.509 7.0505L59.5445 7.421C59.3165 7.88333 59.06 8.333 58.775 8.77C58.49 9.207 58.1765 9.61867 57.8345 10.005C57.4988 10.385 57.1378 10.7365 56.7515 11.0595C56.3715 11.3825 55.9788 11.6612 55.5735 11.8955C55.5102 11.7942 55.4247 11.6833 55.317 11.563C55.2157 11.4363 55.1112 11.3128 55.0035 11.1925C54.9022 11.0722 54.804 10.9708 54.709 10.8885C55.1017 10.6985 55.4848 10.4642 55.8585 10.1855C56.2322 9.9005 56.5837 9.59017 56.913 9.2545C57.2487 8.9125 57.5527 8.55467 57.825 8.181C58.0973 7.80733 58.3253 7.4305 58.509 7.0505ZM55.0795 6.262H63.392V7.3925H55.0795V6.262ZM58.6515 3.9345H59.9055V12.855H58.6515V3.9345ZM60.257 4.7135L61.093 4.02C61.2703 4.14667 61.4603 4.29233 61.663 4.457C61.8657 4.61533 62.062 4.77367 62.252 4.932C62.442 5.09033 62.5972 5.23283 62.7175 5.3595L61.8245 6.148C61.7168 6.015 61.5712 5.86617 61.3875 5.7015C61.2102 5.5305 61.0202 5.3595 60.8175 5.1885C60.6148 5.01117 60.428 4.85283 60.257 4.7135ZM67.1255 8.4565C67.6195 9.3875 68.3795 10.1285 69.4055 10.6795C70.4315 11.2305 71.7077 11.5915 73.234 11.7625C73.1517 11.8512 73.063 11.9588 72.968 12.0855C72.8793 12.2185 72.7938 12.3547 72.7115 12.494C72.6292 12.6333 72.5595 12.76 72.5025 12.874C71.4385 12.7157 70.498 12.4655 69.681 12.1235C68.8703 11.7878 68.1673 11.3477 67.572 10.803C66.9767 10.252 66.47 9.59333 66.052 8.827L67.1255 8.4565ZM65.121 7.421H71.2105V8.5325H65.121V7.421ZM64.6555 5.179H72.8065V6.3095H64.6555V5.179ZM68.123 3.925H69.3105V7.9245H68.123V3.925ZM70.8495 7.421H71.087L71.2865 7.3735L72.094 7.8295C71.809 8.60217 71.4258 9.2735 70.9445 9.8435C70.4695 10.4135 69.9185 10.898 69.2915 11.297C68.6645 11.6897 67.9805 12.0127 67.2395 12.266C66.4985 12.5193 65.7163 12.7157 64.893 12.855C64.8613 12.7473 64.8075 12.6238 64.7315 12.4845C64.6618 12.3452 64.5858 12.209 64.5035 12.076C64.4212 11.943 64.342 11.8353 64.266 11.753C65.064 11.6453 65.8145 11.4933 66.5175 11.297C67.2205 11.0943 67.857 10.8315 68.427 10.5085C69.0033 10.1792 69.4973 9.78017 69.909 9.3115C70.3207 8.8365 70.6342 8.27283 70.8495 7.6205V7.421ZM77.3285 5.008H82.297V6.0435H77.3285V5.008ZM77.015 8.6655H82.6485V9.6915H77.015V8.6655ZM76.9295 6.87H82.715V7.9055H76.9295V6.87ZM79.2855 3.9725H80.3685V7.4115H79.2855V3.9725ZM80.511 7.7345H81.594V11.658C81.594 11.9367 81.5623 12.152 81.499 12.304C81.4357 12.4623 81.3122 12.5858 81.1285 12.6745C80.9512 12.7568 80.7327 12.8075 80.473 12.8265C80.2197 12.8455 79.922 12.855 79.58 12.855C79.561 12.6967 79.5198 12.513 79.4565 12.304C79.3932 12.1013 79.3267 11.9272 79.257 11.7815C79.4723 11.7878 79.6877 11.7942 79.903 11.8005C80.1183 11.8005 80.2577 11.7973 80.321 11.791C80.397 11.791 80.4477 11.7815 80.473 11.7625C80.4983 11.7372 80.511 11.6928 80.511 11.6295V7.7345ZM77.528 10.2425L78.4305 9.739C78.5698 9.89733 78.7092 10.0747 78.8485 10.271C78.9878 10.461 79.1145 10.651 79.2285 10.841C79.3425 11.0247 79.4343 11.1957 79.504 11.354L78.5255 11.9145C78.4748 11.7625 78.3957 11.5915 78.288 11.4015C78.1803 11.2052 78.06 11.0057 77.927 10.803C77.8003 10.6003 77.6673 10.4135 77.528 10.2425ZM73.6995 8.751C74.0858 8.66233 74.5482 8.54833 75.0865 8.409C75.6312 8.26967 76.1758 8.124 76.7205 7.972L76.863 8.998C76.3627 9.14367 75.856 9.2925 75.343 9.4445C74.8363 9.59017 74.3708 9.72317 73.9465 9.8435L73.6995 8.751ZM73.8515 5.73H76.787V6.775H73.8515V5.73ZM74.925 3.9345H75.97V11.5915C75.97 11.8512 75.9415 12.057 75.8845 12.209C75.8338 12.3673 75.7357 12.4908 75.59 12.5795C75.4443 12.6618 75.2638 12.7188 75.0485 12.7505C74.8395 12.7822 74.5798 12.7948 74.2695 12.7885C74.2568 12.6492 74.222 12.475 74.165 12.266C74.108 12.0633 74.0447 11.886 73.975 11.734C74.146 11.7403 74.3043 11.7467 74.45 11.753C74.602 11.753 74.7065 11.7498 74.7635 11.7435C74.8205 11.7435 74.8617 11.734 74.887 11.715C74.9123 11.6897 74.925 11.6453 74.925 11.582V3.9345Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function vf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2004_5308",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2004_5308)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM56.3723 12V6.81818H57.8095V12H56.3723ZM57.0943 6.15021C56.8806 6.15021 56.6973 6.07937 56.5444 5.93768C56.3937 5.79374 56.3184 5.62169 56.3184 5.42152C56.3184 5.2236 56.3937 5.0538 56.5444 4.91211C56.6973 4.76817 56.8806 4.6962 57.0943 4.6962C57.3079 4.6962 57.4901 4.76817 57.6408 4.91211C57.7937 5.0538 57.8702 5.2236 57.8702 5.42152C57.8702 5.62169 57.7937 5.79374 57.6408 5.93768C57.4901 6.07937 57.3079 6.15021 57.0943 6.15021ZM63.7917 6.81818L61.9801 12H60.3608L58.5491 6.81818H60.0672L61.1434 10.5257H61.1974L62.2702 6.81818H63.7917ZM68.8386 8.29581L67.5229 8.37678C67.5004 8.26432 67.452 8.16312 67.3778 8.07315C67.3036 7.98094 67.2057 7.90785 67.0843 7.85387C66.9651 7.79764 66.8223 7.76953 66.6559 7.76953C66.4332 7.76953 66.2454 7.81676 66.0925 7.91122C65.9395 8.00343 65.8631 8.12713 65.8631 8.28232C65.8631 8.40601 65.9125 8.51059 66.0115 8.59606C66.1105 8.68152 66.2803 8.75012 66.5209 8.80185L67.4588 8.99077C67.9626 9.09422 68.3381 9.26065 68.5855 9.49006C68.8329 9.71946 68.9566 10.0208 68.9566 10.3942C68.9566 10.7338 68.8565 11.0318 68.6564 11.2882C68.4585 11.5446 68.1863 11.7447 67.84 11.8887C67.4959 12.0304 67.0989 12.1012 66.6491 12.1012C65.9631 12.1012 65.4166 11.9584 65.0095 11.6728C64.6047 11.3849 64.3674 10.9935 64.2977 10.4988L65.7112 10.4245C65.754 10.6337 65.8574 10.7934 66.0216 10.9036C66.1858 11.0115 66.3961 11.0655 66.6525 11.0655C66.9044 11.0655 67.1068 11.0172 67.2597 10.9205C67.4149 10.8215 67.4936 10.6944 67.4959 10.5392C67.4936 10.4088 67.4385 10.302 67.3306 10.2188C67.2226 10.1333 67.0562 10.0681 66.8313 10.0231L65.9339 9.84428C65.4279 9.74308 65.0512 9.56765 64.8038 9.318C64.5586 9.06836 64.436 8.75012 64.436 8.36328C64.436 8.03042 64.526 7.74367 64.7059 7.50302C64.8881 7.26237 65.1434 7.07682 65.4717 6.94638C65.8023 6.81593 66.1892 6.75071 66.6322 6.75071C67.2867 6.75071 67.8017 6.88903 68.1773 7.16566C68.5552 7.44229 68.7756 7.81901 68.8386 8.29581ZM73.538 12.0978C73.2073 12.0978 72.9127 12.0405 72.6541 11.9258C72.3954 11.8088 72.1908 11.6368 72.0401 11.4096C71.8916 11.1802 71.8174 10.8946 71.8174 10.5527C71.8174 10.2649 71.8703 10.0231 71.976 9.82741C72.0817 9.63175 72.2256 9.47431 72.4078 9.35511C72.59 9.23591 72.7969 9.14595 73.0285 9.08523C73.2624 9.0245 73.5076 8.98177 73.764 8.95703C74.0654 8.92554 74.3083 8.89631 74.4927 8.86932C74.6771 8.84008 74.8109 8.79735 74.8941 8.74112C74.9773 8.6849 75.019 8.60168 75.019 8.49148V8.47124C75.019 8.25758 74.9515 8.09227 74.8165 7.97532C74.6838 7.85837 74.4949 7.79989 74.2498 7.79989C73.9911 7.79989 73.7853 7.85724 73.6324 7.97195C73.4795 8.0844 73.3783 8.22609 73.3288 8.39702L71.9996 8.28906C72.0671 7.97419 72.1998 7.70206 72.3977 7.47266C72.5956 7.241 72.8509 7.06333 73.1635 6.93963C73.4784 6.81368 73.8427 6.75071 74.2565 6.75071C74.5444 6.75071 74.8199 6.78445 75.0831 6.85192C75.3484 6.91939 75.5835 7.02397 75.7881 7.16566C75.995 7.30735 76.1581 7.48952 76.2773 7.71218C76.3965 7.93259 76.4561 8.19685 76.4561 8.50497V12H75.0932V11.2814H75.0527C74.9695 11.4434 74.8581 11.5862 74.7187 11.7099C74.5793 11.8313 74.4117 11.9269 74.216 11.9966C74.0204 12.0641 73.7943 12.0978 73.538 12.0978ZM73.9495 11.106C74.1609 11.106 74.3476 11.0644 74.5095 10.9812C74.6715 10.8957 74.7985 10.781 74.8908 10.6371C74.983 10.4931 75.0291 10.3301 75.0291 10.1479V9.59801C74.9841 9.62725 74.9222 9.65424 74.8435 9.67898C74.7671 9.70147 74.6805 9.72283 74.5838 9.74308C74.4871 9.76107 74.3903 9.77794 74.2936 9.79368C74.1969 9.80717 74.1092 9.81954 74.0305 9.83079C73.8618 9.85553 73.7145 9.89489 73.5886 9.94886C73.4626 10.0028 73.3648 10.0759 73.2951 10.1681C73.2253 10.2581 73.1905 10.3706 73.1905 10.5055C73.1905 10.7012 73.2613 10.8507 73.403 10.9542C73.5469 11.0554 73.7291 11.106 73.9495 11.106ZM82.2165 6.81818L80.4049 12H78.7856L76.9739 6.81818H78.4921L79.5682 10.5257H79.6222L80.695 6.81818H82.2165Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function bf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5740",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5740)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 5.09091H47.402L49.3047 9.73295H49.3857L51.2884 5.09091H53.0898V12H51.6729V7.50302H51.6156L49.8276 11.9663H48.8627L47.0748 7.48615H47.0174V12H45.6005V5.09091ZM57.5894 9.79368V6.81818H59.0265V12H57.6467V11.0588H57.5927C57.4758 11.3624 57.2812 11.6064 57.0091 11.7908C56.7392 11.9753 56.4097 12.0675 56.0206 12.0675C55.6743 12.0675 55.3695 11.9888 55.1064 11.8313C54.8433 11.6739 54.6375 11.4501 54.489 11.16C54.3428 10.8699 54.2686 10.5224 54.2664 10.1175V6.81818H55.7035V9.86115C55.7058 10.167 55.7879 10.4088 55.9498 10.5865C56.1117 10.7641 56.3288 10.853 56.6009 10.853C56.7741 10.853 56.936 10.8136 57.0867 10.7349C57.2374 10.6539 57.3588 10.5347 57.451 10.3773C57.5455 10.2199 57.5916 10.0253 57.5894 9.79368ZM61.6132 9.00426V12H60.176V6.81818H61.5457V7.73242H61.6064C61.7211 7.43105 61.9134 7.19265 62.1833 7.01722C62.4532 6.83955 62.7805 6.75071 63.165 6.75071C63.5249 6.75071 63.8386 6.82943 64.1063 6.98686C64.3739 7.14429 64.5819 7.3692 64.7304 7.66158C64.8788 7.9517 64.953 8.29806 64.953 8.70064V12H63.5159V8.95703C63.5181 8.63991 63.4372 8.39252 63.273 8.21484C63.1088 8.03492 62.8828 7.94496 62.5949 7.94496C62.4015 7.94496 62.2306 7.98656 62.0821 8.06978C61.9359 8.15299 61.8212 8.27444 61.738 8.43413C61.657 8.59156 61.6154 8.78161 61.6132 9.00426ZM67.9952 12.0843C67.6016 12.0843 67.2451 11.9831 66.9257 11.7807C66.6086 11.5761 66.3567 11.2758 66.1701 10.88C65.9856 10.4819 65.8934 9.99384 65.8934 9.41584C65.8934 8.82209 65.989 8.32842 66.1802 7.93484C66.3713 7.539 66.6255 7.24325 66.9426 7.04759C67.262 6.84967 67.6117 6.75071 67.9918 6.75071C68.2819 6.75071 68.5237 6.80019 68.7171 6.89915C68.9128 6.99586 69.0702 7.11731 69.1894 7.26349C69.3109 7.40743 69.4031 7.54912 69.466 7.68857H69.5099V5.09091H70.9437V12H69.5268V11.1701H69.466C69.3986 11.314 69.303 11.4569 69.1793 11.5985C69.0578 11.738 68.8993 11.8538 68.7036 11.946C68.5102 12.0382 68.274 12.0843 67.9952 12.0843ZM68.4506 10.9407C68.6822 10.9407 68.8779 10.8777 69.0376 10.7518C69.1995 10.6236 69.3232 10.4448 69.4087 10.2154C69.4964 9.98597 69.5403 9.71721 69.5403 9.40909C69.5403 9.10097 69.4975 8.83333 69.4121 8.60618C69.3266 8.37902 69.2029 8.2036 69.041 8.0799C68.879 7.9562 68.6822 7.89435 68.4506 7.89435C68.2144 7.89435 68.0154 7.95845 67.8535 8.08665C67.6915 8.21484 67.569 8.39252 67.4858 8.61967C67.4025 8.84683 67.3609 9.10997 67.3609 9.40909C67.3609 9.71046 67.4025 9.97698 67.4858 10.2086C67.5712 10.438 67.6938 10.618 67.8535 10.7484C68.0154 10.8766 68.2144 10.9407 68.4506 10.9407ZM74.4868 12.1012C73.9537 12.1012 73.4949 11.9933 73.1104 11.7773C72.728 11.5592 72.4334 11.2511 72.2265 10.853C72.0196 10.4527 71.9161 9.97923 71.9161 9.43271C71.9161 8.89968 72.0196 8.43188 72.2265 8.0293C72.4334 7.62672 72.7246 7.31297 73.1002 7.08807C73.4781 6.86316 73.9211 6.75071 74.4294 6.75071C74.7713 6.75071 75.0895 6.80581 75.3841 6.91602C75.681 7.02397 75.9397 7.18703 76.1601 7.40518C76.3827 7.62334 76.5559 7.89773 76.6796 8.22834C76.8033 8.5567 76.8651 8.94129 76.8651 9.3821V9.77681H72.4896V8.88619H75.5123C75.5123 8.67927 75.4674 8.49598 75.3774 8.33629C75.2874 8.17661 75.1626 8.05179 75.0029 7.96183C74.8455 7.86961 74.6622 7.82351 74.453 7.82351C74.2349 7.82351 74.0415 7.87411 73.8728 7.97532C73.7064 8.07428 73.5759 8.2081 73.4814 8.37678C73.387 8.54321 73.3386 8.72875 73.3364 8.93342V9.78018C73.3364 10.0366 73.3836 10.2581 73.4781 10.4448C73.5748 10.6315 73.7108 10.7754 73.8863 10.8766C74.0617 10.9778 74.2697 11.0284 74.5104 11.0284C74.6701 11.0284 74.8163 11.0059 74.949 10.9609C75.0816 10.916 75.1952 10.8485 75.2897 10.7585C75.3841 10.6686 75.4561 10.5584 75.5056 10.4279L76.8348 10.5156C76.7673 10.835 76.629 11.1139 76.4198 11.3523C76.2129 11.5884 75.9453 11.7728 75.6169 11.9055C75.2908 12.036 74.9141 12.1012 74.4868 12.1012ZM73.3667 6.10973C73.1733 6.10973 73.0069 6.04226 72.8675 5.90732C72.728 5.77012 72.6583 5.60819 72.6583 5.42152C72.6583 5.23035 72.728 5.06842 72.8675 4.93572C73.0069 4.80303 73.1733 4.73668 73.3667 4.73668C73.5624 4.73668 73.7277 4.80303 73.8627 4.93572C73.9999 5.06842 74.0684 5.23035 74.0684 5.42152C74.0684 5.60819 73.9999 5.77012 73.8627 5.90732C73.7277 6.04226 73.5624 6.10973 73.3667 6.10973ZM75.4314 6.10973C75.238 6.10973 75.0715 6.04226 74.9321 5.90732C74.7926 5.77012 74.7229 5.60819 74.7229 5.42152C74.7229 5.23035 74.7926 5.06842 74.9321 4.93572C75.0715 4.80303 75.238 4.73668 75.4314 4.73668C75.627 4.73668 75.7923 4.80303 75.9273 4.93572C76.0645 5.06842 76.1331 5.23035 76.1331 5.42152C76.1331 5.60819 76.0645 5.77012 75.9273 5.90732C75.7923 6.04226 75.627 6.10973 75.4314 6.10973ZM82.1144 8.29581L80.7987 8.37678C80.7762 8.26432 80.7279 8.16312 80.6537 8.07315C80.5795 7.98094 80.4816 7.90785 80.3602 7.85387C80.241 7.79764 80.0982 7.76953 79.9317 7.76953C79.7091 7.76953 79.5213 7.81676 79.3683 7.91122C79.2154 8.00343 79.1389 8.12713 79.1389 8.28232C79.1389 8.40601 79.1884 8.51059 79.2874 8.59606C79.3863 8.68152 79.5561 8.75012 79.7968 8.80185L80.7346 8.99077C81.2384 9.09422 81.614 9.26065 81.8614 9.49006C82.1088 9.71946 82.2325 10.0208 82.2325 10.3942C82.2325 10.7338 82.1324 11.0318 81.9323 11.2882C81.7343 11.5446 81.4622 11.7447 81.1159 11.8887C80.7718 12.0304 80.3748 12.1012 79.925 12.1012C79.239 12.1012 78.6925 11.9584 78.2854 11.6728C77.8806 11.3849 77.6433 10.9935 77.5736 10.4988L78.9871 10.4245C79.0299 10.6337 79.1333 10.7934 79.2975 10.9036C79.4617 11.0115 79.672 11.0655 79.9284 11.0655C80.1802 11.0655 80.3827 11.0172 80.5356 10.9205C80.6908 10.8215 80.7695 10.6944 80.7718 10.5392C80.7695 10.4088 80.7144 10.302 80.6064 10.2188C80.4985 10.1333 80.3321 10.0681 80.1072 10.0231L79.2098 9.84428C78.7037 9.74308 78.327 9.56765 78.0796 9.318C77.8345 9.06836 77.7119 8.75012 77.7119 8.36328C77.7119 8.03042 77.8019 7.74367 77.9818 7.50302C78.164 7.26237 78.4192 7.07682 78.7476 6.94638C79.0782 6.81593 79.4651 6.75071 79.9081 6.75071C80.5626 6.75071 81.0776 6.88903 81.4532 7.16566C81.8311 7.44229 82.0515 7.81901 82.1144 8.29581ZM86.4604 9.79368V6.81818H87.8976V12H86.5178V11.0588H86.4638C86.3469 11.3624 86.1523 11.6064 85.8802 11.7908C85.6103 11.9753 85.2808 12.0675 84.8917 12.0675C84.5454 12.0675 84.2406 11.9888 83.9775 11.8313C83.7144 11.6739 83.5086 11.4501 83.3601 11.16C83.2139 10.8699 83.1397 10.5224 83.1375 10.1175V6.81818H84.5746V9.86115C84.5769 10.167 84.659 10.4088 84.8209 10.5865C84.9828 10.7641 85.1999 10.853 85.472 10.853C85.6452 10.853 85.8071 10.8136 85.9578 10.7349C86.1085 10.6539 86.2299 10.5347 86.3221 10.3773C86.4166 10.2199 86.4627 10.0253 86.4604 9.79368ZM90.5248 12.0978C90.1942 12.0978 89.8995 12.0405 89.6409 11.9258C89.3823 11.8088 89.1776 11.6368 89.0269 11.4096C88.8785 11.1802 88.8042 10.8946 88.8042 10.5527C88.8042 10.2649 88.8571 10.0231 88.9628 9.82741C89.0685 9.63175 89.2124 9.47431 89.3946 9.35511C89.5768 9.23591 89.7837 9.14595 90.0154 9.08523C90.2493 9.0245 90.4944 8.98177 90.7508 8.95703C91.0522 8.92554 91.2951 8.89631 91.4795 8.86932C91.6639 8.84008 91.7977 8.79735 91.8809 8.74112C91.9642 8.6849 92.0058 8.60168 92.0058 8.49148V8.47124C92.0058 8.25758 91.9383 8.09227 91.8034 7.97532C91.6707 7.85837 91.4817 7.79989 91.2366 7.79989C90.978 7.79989 90.7722 7.85724 90.6192 7.97195C90.4663 8.0844 90.3651 8.22609 90.3156 8.39702L88.9864 8.28906C89.0539 7.97419 89.1866 7.70206 89.3845 7.47266C89.5824 7.241 89.8377 7.06333 90.1503 6.93963C90.4652 6.81368 90.8295 6.75071 91.2433 6.75071C91.5312 6.75071 91.8067 6.78445 92.0699 6.85192C92.3353 6.91939 92.5703 7.02397 92.7749 7.16566C92.9819 7.30735 93.1449 7.48952 93.2641 7.71218C93.3833 7.93259 93.4429 8.19685 93.4429 8.50497V12H92.08V11.2814H92.0395C91.9563 11.4434 91.845 11.5862 91.7055 11.7099C91.5661 11.8313 91.3985 11.9269 91.2029 11.9966C91.0072 12.0641 90.7812 12.0978 90.5248 12.0978ZM90.9363 11.106C91.1478 11.106 91.3344 11.0644 91.4964 10.9812C91.6583 10.8957 91.7854 10.781 91.8776 10.6371C91.9698 10.4931 92.0159 10.3301 92.0159 10.1479V9.59801C91.9709 9.62725 91.9091 9.65424 91.8303 9.67898C91.7539 9.70147 91.6673 9.72283 91.5706 9.74308C91.4739 9.76107 91.3772 9.77794 91.2805 9.79368C91.1837 9.80717 91.096 9.81954 91.0173 9.83079C90.8486 9.85553 90.7013 9.89489 90.5754 9.94886C90.4494 10.0028 90.3516 10.0759 90.2819 10.1681C90.2122 10.2581 90.1773 10.3706 90.1773 10.5055C90.1773 10.7012 90.2481 10.8507 90.3898 10.9542C90.5338 11.0554 90.7159 11.106 90.9363 11.106ZM94.5579 12V6.81818H95.9512V7.7223H96.0051C96.0996 7.40069 96.2582 7.15779 96.4808 6.99361C96.7035 6.82718 96.9599 6.74396 97.25 6.74396C97.322 6.74396 97.3996 6.74846 97.4828 6.75746C97.566 6.76645 97.6391 6.77882 97.7021 6.79457V8.06978C97.6346 8.04954 97.5413 8.03155 97.4221 8.0158C97.3029 8.00006 97.1938 7.99219 97.0948 7.99219C96.8834 7.99219 96.6945 8.03829 96.5281 8.1305C96.3639 8.22047 96.2334 8.34641 96.1367 8.50835C96.0423 8.67028 95.995 8.85695 95.995 9.06836V12H94.5579ZM102.081 9.00426V12H100.644V6.81818H102.013V7.73242H102.074C102.189 7.43105 102.381 7.19265 102.651 7.01722C102.921 6.83955 103.248 6.75071 103.633 6.75071C103.993 6.75071 104.306 6.82943 104.574 6.98686C104.842 7.14429 105.05 7.3692 105.198 7.66158C105.347 7.9517 105.421 8.29806 105.421 8.70064V12H103.984V8.95703C103.986 8.63991 103.905 8.39252 103.741 8.21484C103.577 8.03492 103.351 7.94496 103.063 7.94496C102.869 7.94496 102.698 7.98656 102.55 8.06978C102.404 8.15299 102.289 8.27444 102.206 8.43413C102.125 8.59156 102.083 8.78161 102.081 9.00426ZM108.888 14.0511C108.422 14.0511 108.023 13.987 107.69 13.8588C107.36 13.7329 107.097 13.5608 106.901 13.3427C106.705 13.1245 106.578 12.8794 106.52 12.6072L107.849 12.4284C107.889 12.5319 107.954 12.6286 108.041 12.7186C108.129 12.8085 108.245 12.8805 108.389 12.9345C108.535 12.9907 108.713 13.0188 108.922 13.0188C109.234 13.0188 109.492 12.9424 109.694 12.7894C109.899 12.6387 110.001 12.3857 110.001 12.0304V11.0824H109.941C109.878 11.2263 109.783 11.3624 109.657 11.4906C109.531 11.6188 109.369 11.7234 109.171 11.8043C108.973 11.8853 108.737 11.9258 108.463 11.9258C108.074 11.9258 107.72 11.8358 107.4 11.6559C107.083 11.4737 106.83 11.196 106.641 10.8226C106.455 10.447 106.361 9.97248 106.361 9.39897C106.361 8.81197 106.457 8.32167 106.648 7.92809C106.839 7.53451 107.093 7.23988 107.41 7.04421C107.73 6.84854 108.079 6.75071 108.46 6.75071C108.75 6.75071 108.993 6.80019 109.188 6.89915C109.384 6.99586 109.541 7.11731 109.661 7.26349C109.782 7.40743 109.875 7.54912 109.941 7.68857H109.995V6.81818H111.422V12.0506C111.422 12.4914 111.314 12.8603 111.098 13.1571C110.882 13.454 110.583 13.6767 110.2 13.8251C109.82 13.9758 109.383 14.0511 108.888 14.0511ZM108.918 10.8462C109.15 10.8462 109.346 10.7889 109.505 10.6742C109.667 10.5572 109.791 10.3908 109.876 10.1749C109.964 9.95674 110.008 9.69585 110.008 9.39222C110.008 9.0886 109.965 8.82546 109.88 8.60281C109.794 8.3779 109.671 8.2036 109.509 8.0799C109.347 7.9562 109.15 7.89435 108.918 7.89435C108.682 7.89435 108.483 7.95845 108.321 8.08665C108.159 8.21259 108.037 8.38802 107.954 8.61293C107.87 8.83783 107.829 9.0976 107.829 9.39222C107.829 9.69135 107.87 9.94999 107.954 10.1681C108.039 10.3841 108.162 10.5516 108.321 10.6708C108.483 10.7878 108.682 10.8462 108.918 10.8462ZM114.043 12.0978C113.712 12.0978 113.418 12.0405 113.159 11.9258C112.9 11.8088 112.696 11.6368 112.545 11.4096C112.397 11.1802 112.322 10.8946 112.322 10.5527C112.322 10.2649 112.375 10.0231 112.481 9.82741C112.587 9.63175 112.731 9.47431 112.913 9.35511C113.095 9.23591 113.302 9.14595 113.533 9.08523C113.767 9.0245 114.012 8.98177 114.269 8.95703C114.57 8.92554 114.813 8.89631 114.998 8.86932C115.182 8.84008 115.316 8.79735 115.399 8.74112C115.482 8.6849 115.524 8.60168 115.524 8.49148V8.47124C115.524 8.25758 115.456 8.09227 115.321 7.97532C115.189 7.85837 115 7.79989 114.755 7.79989C114.496 7.79989 114.29 7.85724 114.137 7.97195C113.984 8.0844 113.883 8.22609 113.834 8.39702L112.504 8.28906C112.572 7.97419 112.705 7.70206 112.903 7.47266C113.1 7.241 113.356 7.06333 113.668 6.93963C113.983 6.81368 114.348 6.75071 114.761 6.75071C115.049 6.75071 115.325 6.78445 115.588 6.85192C115.853 6.91939 116.088 7.02397 116.293 7.16566C116.5 7.30735 116.663 7.48952 116.782 7.71218C116.901 7.93259 116.961 8.19685 116.961 8.50497V12H115.598V11.2814H115.558C115.474 11.4434 115.363 11.5862 115.224 11.7099C115.084 11.8313 114.917 11.9269 114.721 11.9966C114.525 12.0641 114.299 12.0978 114.043 12.0978ZM114.454 11.106C114.666 11.106 114.852 11.0644 115.014 10.9812C115.176 10.8957 115.303 10.781 115.396 10.6371C115.488 10.4931 115.534 10.3301 115.534 10.1479V9.59801C115.489 9.62725 115.427 9.65424 115.348 9.67898C115.272 9.70147 115.185 9.72283 115.089 9.74308C114.992 9.76107 114.895 9.77794 114.799 9.79368C114.702 9.80717 114.614 9.81954 114.535 9.83079C114.367 9.85553 114.219 9.89489 114.093 9.94886C113.967 10.0028 113.87 10.0759 113.8 10.1681C113.73 10.2581 113.695 10.3706 113.695 10.5055C113.695 10.7012 113.766 10.8507 113.908 10.9542C114.052 11.0554 114.234 11.106 114.454 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function yf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5716",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5716)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H47.0613V7.94158H50.0266V5.09091H51.484V12H50.0266V9.14595H47.0613V12H45.6005ZM54.139 12.0978C53.8084 12.0978 53.5138 12.0405 53.2551 11.9258C52.9965 11.8088 52.7918 11.6368 52.6412 11.4096C52.4927 11.1802 52.4185 10.8946 52.4185 10.5527C52.4185 10.2649 52.4714 10.0231 52.5771 9.82741C52.6828 9.63175 52.8267 9.47431 53.0089 9.35511C53.1911 9.23591 53.398 9.14595 53.6296 9.08523C53.8635 9.0245 54.1087 8.98177 54.3651 8.95703C54.6664 8.92554 54.9093 8.89631 55.0938 8.86932C55.2782 8.84008 55.412 8.79735 55.4952 8.74112C55.5784 8.6849 55.62 8.60168 55.62 8.49148V8.47124C55.62 8.25758 55.5526 8.09227 55.4176 7.97532C55.2849 7.85837 55.096 7.79989 54.8509 7.79989C54.5922 7.79989 54.3864 7.85724 54.2335 7.97195C54.0806 8.0844 53.9793 8.22609 53.9299 8.39702L52.6007 8.28906C52.6681 7.97419 52.8008 7.70206 52.9988 7.47266C53.1967 7.241 53.4519 7.06333 53.7646 6.93963C54.0794 6.81368 54.4438 6.75071 54.8576 6.75071C55.1455 6.75071 55.421 6.78445 55.6841 6.85192C55.9495 6.91939 56.1845 7.02397 56.3892 7.16566C56.5961 7.30735 56.7592 7.48952 56.8784 7.71218C56.9976 7.93259 57.0572 8.19685 57.0572 8.50497V12H55.6942V11.2814H55.6538C55.5705 11.4434 55.4592 11.5862 55.3198 11.7099C55.1803 11.8313 55.0128 11.9269 54.8171 11.9966C54.6214 12.0641 54.3954 12.0978 54.139 12.0978ZM54.5506 11.106C54.762 11.106 54.9487 11.0644 55.1106 10.9812C55.2725 10.8957 55.3996 10.781 55.4918 10.6371C55.584 10.4931 55.6301 10.3301 55.6301 10.1479V9.59801C55.5852 9.62725 55.5233 9.65424 55.4446 9.67898C55.3681 9.70147 55.2815 9.72283 55.1848 9.74308C55.0881 9.76107 54.9914 9.77794 54.8947 9.79368C54.798 9.80717 54.7103 9.81954 54.6316 9.83079C54.4629 9.85553 54.3156 9.89489 54.1896 9.94886C54.0637 10.0028 53.9658 10.0759 53.8961 10.1681C53.8264 10.2581 53.7915 10.3706 53.7915 10.5055C53.7915 10.7012 53.8624 10.8507 54.0041 10.9542C54.148 11.0554 54.3302 11.106 54.5506 11.106ZM62.7121 12.1012C62.1881 12.1012 61.7349 11.9899 61.3526 11.7672C60.9725 11.5423 60.679 11.2297 60.4721 10.8294C60.2652 10.4268 60.1617 9.96011 60.1617 9.42933C60.1617 8.89406 60.2652 8.42625 60.4721 8.02592C60.679 7.62334 60.9725 7.31072 61.3526 7.08807C61.7349 6.86316 62.1881 6.75071 62.7121 6.75071C63.2362 6.75071 63.6882 6.86316 64.0683 7.08807C64.4507 7.31072 64.7453 7.62334 64.9522 8.02592C65.1591 8.42625 65.2626 8.89406 65.2626 9.42933C65.2626 9.96011 65.1591 10.4268 64.9522 10.8294C64.7453 11.2297 64.4507 11.5423 64.0683 11.7672C63.6882 11.9899 63.2362 12.1012 62.7121 12.1012ZM62.7189 10.9879C62.9573 10.9879 63.1563 10.9205 63.316 10.7855C63.4757 10.6483 63.596 10.4616 63.677 10.2255C63.7602 9.98935 63.8018 9.72058 63.8018 9.41921C63.8018 9.11784 63.7602 8.84908 63.677 8.61293C63.596 8.37678 63.4757 8.1901 63.316 8.05291C63.1563 7.91572 62.9573 7.84712 62.7189 7.84712C62.4782 7.84712 62.2758 7.91572 62.1116 8.05291C61.9497 8.1901 61.8271 8.37678 61.7439 8.61293C61.663 8.84908 61.6225 9.11784 61.6225 9.41921C61.6225 9.72058 61.663 9.98935 61.7439 10.2255C61.8271 10.4616 61.9497 10.6483 62.1116 10.7855C62.2758 10.9205 62.4782 10.9879 62.7189 10.9879ZM68.5383 12.1012C68.0075 12.1012 67.551 11.9888 67.1686 11.7638C66.7885 11.5367 66.4962 11.2218 66.2915 10.8192C66.0891 10.4167 65.9879 9.95336 65.9879 9.42933C65.9879 8.89856 66.0902 8.433 66.2949 8.03267C66.5018 7.63009 66.7953 7.31635 67.1754 7.09144C67.5555 6.86429 68.0075 6.75071 68.5316 6.75071C68.9836 6.75071 69.3795 6.8328 69.7191 6.99698C70.0587 7.16116 70.3274 7.39169 70.5253 7.68857C70.7233 7.98544 70.8323 8.33404 70.8526 8.73438H69.4964C69.4582 8.47573 69.357 8.2677 69.1928 8.11026C69.0309 7.95058 68.8183 7.87074 68.5552 7.87074C68.3325 7.87074 68.138 7.93146 67.9715 8.05291C67.8074 8.17211 67.6792 8.34641 67.587 8.57582C67.4947 8.80522 67.4486 9.08298 67.4486 9.40909C67.4486 9.7397 67.4936 10.0208 67.5836 10.2525C67.6758 10.4841 67.8051 10.6607 67.9715 10.7821C68.138 10.9036 68.3325 10.9643 68.5552 10.9643C68.7194 10.9643 68.8667 10.9306 68.9971 10.8631C69.1298 10.7956 69.2389 10.6978 69.3244 10.5696C69.4121 10.4392 69.4694 10.2828 69.4964 10.1007H70.8526C70.8301 10.4965 70.7221 10.8451 70.5287 11.1465C70.3376 11.4456 70.0733 11.6795 69.7359 11.8482C69.3986 12.0169 68.9994 12.1012 68.5383 12.1012ZM75.3791 8.83558V9.96573H72.6735V8.83558H75.3791ZM73.1458 6.81818V12H71.7727V6.81818H73.1458ZM76.2798 6.81818V12H74.9169V6.81818H76.2798ZM79.7361 12.1012C79.212 12.1012 78.7588 11.9899 78.3765 11.7672C77.9964 11.5423 77.7029 11.2297 77.496 10.8294C77.2891 10.4268 77.1856 9.96011 77.1856 9.42933C77.1856 8.89406 77.2891 8.42625 77.496 8.02592C77.7029 7.62334 77.9964 7.31072 78.3765 7.08807C78.7588 6.86316 79.212 6.75071 79.7361 6.75071C80.2601 6.75071 80.7122 6.86316 81.0922 7.08807C81.4746 7.31072 81.7692 7.62334 81.9761 8.02592C82.183 8.42625 82.2865 8.89406 82.2865 9.42933C82.2865 9.96011 82.183 10.4268 81.9761 10.8294C81.7692 11.2297 81.4746 11.5423 81.0922 11.7672C80.7122 11.9899 80.2601 12.1012 79.7361 12.1012ZM79.7428 10.9879C79.9812 10.9879 80.1802 10.9205 80.3399 10.7855C80.4996 10.6483 80.6199 10.4616 80.7009 10.2255C80.7841 9.98935 80.8257 9.72058 80.8257 9.41921C80.8257 9.11784 80.7841 8.84908 80.7009 8.61293C80.6199 8.37678 80.4996 8.1901 80.3399 8.05291C80.1802 7.91572 79.9812 7.84712 79.7428 7.84712C79.5022 7.84712 79.2997 7.91572 79.1356 8.05291C78.9736 8.1901 78.8511 8.37678 78.7678 8.61293C78.6869 8.84908 78.6464 9.11784 78.6464 9.41921C78.6464 9.72058 78.6869 9.98935 78.7678 10.2255C78.8511 10.4616 78.9736 10.6483 79.1356 10.7855C79.2997 10.9205 79.5022 10.9879 79.7428 10.9879ZM83.221 12V6.81818H85.4307C86.0694 6.81818 86.5743 6.93963 86.9454 7.18253C87.3165 7.42543 87.502 7.77066 87.502 8.21822C87.502 8.49935 87.3975 8.73325 87.1883 8.91992C86.9791 9.10659 86.689 9.23254 86.3179 9.29776C86.6283 9.32025 86.8925 9.3911 87.1107 9.5103C87.3311 9.62725 87.4987 9.77906 87.6134 9.96573C87.7303 10.1524 87.7888 10.3593 87.7888 10.5865C87.7888 10.8811 87.7101 11.1341 87.5526 11.3455C87.3975 11.5569 87.1692 11.7189 86.8678 11.8313C86.5687 11.9438 86.2032 12 85.7714 12H83.221ZM84.5603 10.9238H85.7714C85.9716 10.9238 86.1279 10.8766 86.2403 10.7821C86.355 10.6854 86.4124 10.5539 86.4124 10.3874C86.4124 10.203 86.355 10.0579 86.2403 9.95224C86.1279 9.84653 85.9716 9.79368 85.7714 9.79368H84.5603V10.9238ZM84.5603 8.95028H85.461C85.605 8.95028 85.7275 8.93004 85.8287 8.88956C85.9322 8.84683 86.0109 8.7861 86.0649 8.70739C86.1211 8.62867 86.1492 8.53533 86.1492 8.42738C86.1492 8.2677 86.0851 8.14287 85.9569 8.05291C85.8287 7.96295 85.6533 7.91797 85.4307 7.91797H84.5603V8.95028ZM88.6946 12V6.81818H90.1317V12H88.6946ZM89.4165 6.15021C89.2029 6.15021 89.0196 6.07937 88.8667 5.93768C88.716 5.79374 88.6406 5.62169 88.6406 5.42152C88.6406 5.2236 88.716 5.0538 88.8667 4.91211C89.0196 4.76817 89.2029 4.6962 89.4165 4.6962C89.6302 4.6962 89.8124 4.76817 89.9631 4.91211C90.116 5.0538 90.1925 5.2236 90.1925 5.42152C90.1925 5.62169 90.116 5.79374 89.9631 5.93768C89.8124 6.07937 89.6302 6.15021 89.4165 6.15021Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function xf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5692",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5692)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM59.8016 14.0511C59.336 14.0511 58.9368 13.987 58.604 13.8588C58.2733 13.7329 58.0102 13.5608 57.8145 13.3427C57.6189 13.1245 57.4918 12.8794 57.4333 12.6072L58.7625 12.4284C58.803 12.5319 58.8671 12.6286 58.9548 12.7186C59.0425 12.8085 59.1584 12.8805 59.3023 12.9345C59.4485 12.9907 59.6262 13.0188 59.8353 13.0188C60.1479 13.0188 60.4055 12.9424 60.6079 12.7894C60.8125 12.6387 60.9149 12.3857 60.9149 12.0304V11.0824H60.8541C60.7912 11.2263 60.6967 11.3624 60.5708 11.4906C60.4448 11.6188 60.2829 11.7234 60.085 11.8043C59.887 11.8853 59.6509 11.9258 59.3765 11.9258C58.9874 11.9258 58.6332 11.8358 58.3138 11.6559C57.9967 11.4737 57.7437 11.196 57.5548 10.8226C57.3681 10.447 57.2748 9.97248 57.2748 9.39897C57.2748 8.81197 57.3704 8.32167 57.5615 7.92809C57.7527 7.53451 58.0068 7.23988 58.324 7.04421C58.6433 6.84854 58.993 6.75071 59.3731 6.75071C59.6633 6.75071 59.9062 6.80019 60.1018 6.89915C60.2975 6.99586 60.4549 7.11731 60.5741 7.26349C60.6956 7.40743 60.7889 7.54912 60.8541 7.68857H60.9081V6.81818H62.3351V12.0506C62.3351 12.4914 62.2272 12.8603 62.0113 13.1571C61.7954 13.454 61.4962 13.6767 61.1139 13.8251C60.7338 13.9758 60.2964 14.0511 59.8016 14.0511ZM59.8319 10.8462C60.0636 10.8462 60.2593 10.7889 60.4189 10.6742C60.5809 10.5572 60.7046 10.3908 60.79 10.1749C60.8778 9.95674 60.9216 9.69585 60.9216 9.39222C60.9216 9.0886 60.8789 8.82546 60.7934 8.60281C60.7079 8.3779 60.5843 8.2036 60.4223 8.0799C60.2604 7.9562 60.0636 7.89435 59.8319 7.89435C59.5958 7.89435 59.3968 7.95845 59.2348 8.08665C59.0729 8.21259 58.9503 8.38802 58.8671 8.61293C58.7839 8.83783 58.7423 9.0976 58.7423 9.39222C58.7423 9.69135 58.7839 9.94999 58.8671 10.1681C58.9526 10.3841 59.0751 10.5516 59.2348 10.6708C59.3968 10.7878 59.5958 10.8462 59.8319 10.8462ZM64.9564 12.0978C64.6258 12.0978 64.3312 12.0405 64.0725 11.9258C63.8139 11.8088 63.6092 11.6368 63.4585 11.4096C63.3101 11.1802 63.2359 10.8946 63.2359 10.5527C63.2359 10.2649 63.2887 10.0231 63.3944 9.82741C63.5001 9.63175 63.6441 9.47431 63.8263 9.35511C64.0084 9.23591 64.2153 9.14595 64.447 9.08523C64.6809 9.0245 64.926 8.98177 65.1824 8.95703C65.4838 8.92554 65.7267 8.89631 65.9111 8.86932C66.0956 8.84008 66.2294 8.79735 66.3126 8.74112C66.3958 8.6849 66.4374 8.60168 66.4374 8.49148V8.47124C66.4374 8.25758 66.3699 8.09227 66.235 7.97532C66.1023 7.85837 65.9134 7.79989 65.6682 7.79989C65.4096 7.79989 65.2038 7.85724 65.0509 7.97195C64.8979 8.0844 64.7967 8.22609 64.7472 8.39702L63.4181 8.28906C63.4855 7.97419 63.6182 7.70206 63.8161 7.47266C64.0141 7.241 64.2693 7.06333 64.5819 6.93963C64.8968 6.81368 65.2612 6.75071 65.675 6.75071C65.9629 6.75071 66.2384 6.78445 66.5015 6.85192C66.7669 6.91939 67.0019 7.02397 67.2066 7.16566C67.4135 7.30735 67.5766 7.48952 67.6958 7.71218C67.815 7.93259 67.8746 8.19685 67.8746 8.50497V12H66.5116V11.2814H66.4711C66.3879 11.4434 66.2766 11.5862 66.1372 11.7099C65.9977 11.8313 65.8302 11.9269 65.6345 11.9966C65.4388 12.0641 65.2128 12.0978 64.9564 12.0978ZM65.368 11.106C65.5794 11.106 65.7661 11.0644 65.928 10.9812C66.0899 10.8957 66.217 10.781 66.3092 10.6371C66.4014 10.4931 66.4475 10.3301 66.4475 10.1479V9.59801C66.4026 9.62725 66.3407 9.65424 66.262 9.67898C66.1855 9.70147 66.0989 9.72283 66.0022 9.74308C65.9055 9.76107 65.8088 9.77794 65.7121 9.79368C65.6154 9.80717 65.5277 9.81954 65.449 9.83079C65.2803 9.85553 65.133 9.89489 65.007 9.94886C64.8811 10.0028 64.7832 10.0759 64.7135 10.1681C64.6438 10.2581 64.6089 10.3706 64.6089 10.5055C64.6089 10.7012 64.6798 10.8507 64.8215 10.9542C64.9654 11.0554 65.1476 11.106 65.368 11.106ZM70.4267 9.00426V12H68.9895V6.81818H70.3592V7.73242H70.4199C70.5346 7.43105 70.7269 7.19265 70.9968 7.01722C71.2667 6.83955 71.5939 6.75071 71.9785 6.75071C72.3384 6.75071 72.6521 6.82943 72.9197 6.98686C73.1874 7.14429 73.3954 7.3692 73.5439 7.66158C73.6923 7.9517 73.7665 8.29806 73.7665 8.70064V12H72.3294V8.95703C72.3316 8.63991 72.2507 8.39252 72.0865 8.21484C71.9223 8.03492 71.6963 7.94496 71.4084 7.94496C71.215 7.94496 71.044 7.98656 70.8956 8.06978C70.7494 8.15299 70.6347 8.27444 70.5515 8.43413C70.4705 8.59156 70.4289 8.78161 70.4267 9.00426ZM74.8992 6.81818H76.3363V12.2564C76.3363 12.6567 76.2576 12.9806 76.1002 13.228C75.9428 13.4754 75.7167 13.6564 75.4221 13.7711C75.1297 13.8858 74.78 13.9432 74.3729 13.9432C74.3234 13.9432 74.2762 13.9421 74.2312 13.9398C74.184 13.9398 74.1345 13.9387 74.0828 13.9364V12.813C74.121 12.8153 74.1548 12.8164 74.184 12.8164C74.211 12.8187 74.2402 12.8198 74.2717 12.8198C74.5034 12.8198 74.6653 12.7703 74.7575 12.6713C74.852 12.5746 74.8992 12.4284 74.8992 12.2328V6.81818ZM75.6144 6.15021C75.403 6.15021 75.2208 6.07937 75.0679 5.93768C74.9149 5.79374 74.8385 5.62169 74.8385 5.42152C74.8385 5.2236 74.9149 5.0538 75.0679 4.91211C75.2208 4.76817 75.403 4.6962 75.6144 4.6962C75.8303 4.6962 76.0136 4.76817 76.1643 4.91211C76.3172 5.0538 76.3937 5.2236 76.3937 5.42152C76.3937 5.62169 76.3172 5.79374 76.1643 5.93768C76.0136 6.07937 75.8303 6.15021 75.6144 6.15021ZM78.9652 12.0978C78.6346 12.0978 78.34 12.0405 78.0813 11.9258C77.8227 11.8088 77.618 11.6368 77.4673 11.4096C77.3189 11.1802 77.2447 10.8946 77.2447 10.5527C77.2447 10.2649 77.2975 10.0231 77.4032 9.82741C77.5089 9.63175 77.6529 9.47431 77.835 9.35511C78.0172 9.23591 78.2241 9.14595 78.4558 9.08523C78.6897 9.0245 78.9348 8.98177 79.1912 8.95703C79.4926 8.92554 79.7355 8.89631 79.9199 8.86932C80.1043 8.84008 80.2382 8.79735 80.3214 8.74112C80.4046 8.6849 80.4462 8.60168 80.4462 8.49148V8.47124C80.4462 8.25758 80.3787 8.09227 80.2438 7.97532C80.1111 7.85837 79.9222 7.79989 79.677 7.79989C79.4184 7.79989 79.2126 7.85724 79.0597 7.97195C78.9067 8.0844 78.8055 8.22609 78.756 8.39702L77.4268 8.28906C77.4943 7.97419 77.627 7.70206 77.8249 7.47266C78.0228 7.241 78.2781 7.06333 78.5907 6.93963C78.9056 6.81368 79.2699 6.75071 79.6838 6.75071C79.9717 6.75071 80.2472 6.78445 80.5103 6.85192C80.7757 6.91939 81.0107 7.02397 81.2154 7.16566C81.4223 7.30735 81.5853 7.48952 81.7045 7.71218C81.8237 7.93259 81.8833 8.19685 81.8833 8.50497V12H80.5204V11.2814H80.4799C80.3967 11.4434 80.2854 11.5862 80.146 11.7099C80.0065 11.8313 79.839 11.9269 79.6433 11.9966C79.4476 12.0641 79.2216 12.0978 78.9652 12.0978ZM79.3768 11.106C79.5882 11.106 79.7749 11.0644 79.9368 10.9812C80.0987 10.8957 80.2258 10.781 80.318 10.6371C80.4102 10.4931 80.4563 10.3301 80.4563 10.1479V9.59801C80.4113 9.62725 80.3495 9.65424 80.2708 9.67898C80.1943 9.70147 80.1077 9.72283 80.011 9.74308C79.9143 9.76107 79.8176 9.77794 79.7209 9.79368C79.6242 9.80717 79.5365 9.81954 79.4577 9.83079C79.2891 9.85553 79.1417 9.89489 79.0158 9.94886C78.8899 10.0028 78.792 10.0759 78.7223 10.1681C78.6526 10.2581 78.6177 10.3706 78.6177 10.5055C78.6177 10.7012 78.6886 10.8507 78.8303 10.9542C78.9742 11.0554 79.1564 11.106 79.3768 11.106ZM87.5316 14.0511C87.066 14.0511 86.6668 13.987 86.3339 13.8588C86.0033 13.7329 85.7402 13.5608 85.5445 13.3427C85.3489 13.1245 85.2218 12.8794 85.1633 12.6072L86.4925 12.4284C86.533 12.5319 86.5971 12.6286 86.6848 12.7186C86.7725 12.8085 86.8883 12.8805 87.0323 12.9345C87.1785 12.9907 87.3561 13.0188 87.5653 13.0188C87.8779 13.0188 88.1354 12.9424 88.3378 12.7894C88.5425 12.6387 88.6448 12.3857 88.6448 12.0304V11.0824H88.5841C88.5211 11.2263 88.4267 11.3624 88.3007 11.4906C88.1748 11.6188 88.0129 11.7234 87.8149 11.8043C87.617 11.8853 87.3809 11.9258 87.1065 11.9258C86.7174 11.9258 86.3632 11.8358 86.0438 11.6559C85.7267 11.4737 85.4737 11.196 85.2848 10.8226C85.0981 10.447 85.0047 9.97248 85.0047 9.39897C85.0047 8.81197 85.1003 8.32167 85.2915 7.92809C85.4827 7.53451 85.7368 7.23988 86.0539 7.04421C86.3733 6.84854 86.723 6.75071 87.1031 6.75071C87.3932 6.75071 87.6361 6.80019 87.8318 6.89915C88.0275 6.99586 88.1849 7.11731 88.3041 7.26349C88.4256 7.40743 88.5189 7.54912 88.5841 7.68857H88.6381V6.81818H90.0651V12.0506C90.0651 12.4914 89.9572 12.8603 89.7413 13.1571C89.5253 13.454 89.2262 13.6767 88.8439 13.8251C88.4638 13.9758 88.0264 14.0511 87.5316 14.0511ZM87.5619 10.8462C87.7936 10.8462 87.9892 10.7889 88.1489 10.6742C88.3109 10.5572 88.4346 10.3908 88.52 10.1749C88.6077 9.95674 88.6516 9.69585 88.6516 9.39222C88.6516 9.0886 88.6089 8.82546 88.5234 8.60281C88.4379 8.3779 88.3142 8.2036 88.1523 8.0799C87.9904 7.9562 87.7936 7.89435 87.5619 7.89435C87.3258 7.89435 87.1267 7.95845 86.9648 8.08665C86.8029 8.21259 86.6803 8.38802 86.5971 8.61293C86.5139 8.83783 86.4723 9.0976 86.4723 9.39222C86.4723 9.69135 86.5139 9.94999 86.5971 10.1681C86.6825 10.3841 86.8051 10.5516 86.9648 10.6708C87.1267 10.7878 87.3258 10.8462 87.5619 10.8462ZM92.6864 12.0978C92.3558 12.0978 92.0612 12.0405 91.8025 11.9258C91.5439 11.8088 91.3392 11.6368 91.1885 11.4096C91.0401 11.1802 90.9659 10.8946 90.9659 10.5527C90.9659 10.2649 91.0187 10.0231 91.1244 9.82741C91.2301 9.63175 91.3741 9.47431 91.5562 9.35511C91.7384 9.23591 91.9453 9.14595 92.177 9.08523C92.4109 9.0245 92.656 8.98177 92.9124 8.95703C93.2138 8.92554 93.4567 8.89631 93.6411 8.86932C93.8255 8.84008 93.9594 8.79735 94.0426 8.74112C94.1258 8.6849 94.1674 8.60168 94.1674 8.49148V8.47124C94.1674 8.25758 94.0999 8.09227 93.965 7.97532C93.8323 7.85837 93.6434 7.79989 93.3982 7.79989C93.1396 7.79989 92.9338 7.85724 92.7809 7.97195C92.6279 8.0844 92.5267 8.22609 92.4772 8.39702L91.148 8.28906C91.2155 7.97419 91.3482 7.70206 91.5461 7.47266C91.744 7.241 91.9993 7.06333 92.3119 6.93963C92.6268 6.81368 92.9911 6.75071 93.405 6.75071C93.6928 6.75071 93.9684 6.78445 94.2315 6.85192C94.4969 6.91939 94.7319 7.02397 94.9366 7.16566C95.1435 7.30735 95.3065 7.48952 95.4257 7.71218C95.5449 7.93259 95.6045 8.19685 95.6045 8.50497V12H94.2416V11.2814H94.2011C94.1179 11.4434 94.0066 11.5862 93.8671 11.7099C93.7277 11.8313 93.5601 11.9269 93.3645 11.9966C93.1688 12.0641 92.9428 12.0978 92.6864 12.0978ZM93.098 11.106C93.3094 11.106 93.496 11.0644 93.658 10.9812C93.8199 10.8957 93.947 10.781 94.0392 10.6371C94.1314 10.4931 94.1775 10.3301 94.1775 10.1479V9.59801C94.1325 9.62725 94.0707 9.65424 93.992 9.67898C93.9155 9.70147 93.8289 9.72283 93.7322 9.74308C93.6355 9.76107 93.5388 9.77794 93.4421 9.79368C93.3454 9.80717 93.2576 9.81954 93.1789 9.83079C93.0103 9.85553 92.8629 9.89489 92.737 9.94886C92.611 10.0028 92.5132 10.0759 92.4435 10.1681C92.3738 10.2581 92.3389 10.3706 92.3389 10.5055C92.3389 10.7012 92.4098 10.8507 92.5514 10.9542C92.6954 11.0554 92.8776 11.106 93.098 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function wf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5668",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5668)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M47.8025 12.1235C47.0932 12.1235 46.558 11.9652 46.197 11.6485C45.836 11.3318 45.6555 10.8695 45.6555 10.2615V9.8815C45.6555 9.62183 45.6903 9.40967 45.76 9.245C45.8297 9.074 45.9152 8.91883 46.0165 8.7795C46.1178 8.64017 46.2002 8.51667 46.2635 8.409C46.3332 8.295 46.368 8.17783 46.368 8.0575C46.368 7.9435 46.3395 7.86433 46.2825 7.82C46.2318 7.76933 46.1622 7.744 46.0735 7.744C46.0102 7.744 45.9437 7.7535 45.874 7.7725C45.8107 7.7915 45.7378 7.82 45.6555 7.858L45.4275 6.965C45.6048 6.87 45.7948 6.80667 45.9975 6.775C46.2065 6.737 46.3902 6.718 46.5485 6.718C46.8272 6.718 47.0488 6.76233 47.2135 6.851C47.3845 6.93967 47.508 7.06633 47.584 7.231C47.66 7.39567 47.698 7.592 47.698 7.82C47.698 8.01633 47.6695 8.1905 47.6125 8.3425C47.5555 8.48817 47.4827 8.64017 47.394 8.7985C47.3117 8.94417 47.2357 9.08033 47.166 9.207C47.1027 9.33367 47.071 9.51733 47.071 9.758V10.138C47.071 10.3407 47.0995 10.5085 47.1565 10.6415C47.2198 10.7682 47.3053 10.8632 47.413 10.9265C47.527 10.9835 47.66 11.012 47.812 11.012C48.059 11.012 48.2427 10.9423 48.363 10.803C48.4833 10.6573 48.5435 10.4515 48.5435 10.1855V6.794H49.959V10.2235C49.959 10.8505 49.7753 11.3255 49.408 11.6485C49.0407 11.9652 48.5055 12.1235 47.8025 12.1235ZM48.5681 6.072C48.2704 6.072 48.0361 6.02767 47.8651 5.939C47.6941 5.85033 47.5737 5.7395 47.5041 5.6065C47.4281 5.46717 47.3901 5.3215 47.3901 5.1695C47.3901 5.06183 47.4059 4.94783 47.4376 4.8275C47.4692 4.70083 47.5167 4.58367 47.5801 4.476L48.6156 4.609C48.6029 4.65333 48.5934 4.70083 48.5871 4.7515C48.5744 4.79583 48.5681 4.837 48.5681 4.875C48.5681 4.96367 48.5966 5.03333 48.6536 5.084C48.7042 5.12833 48.7929 5.1505 48.9196 5.1505H50.9621V6.072H48.5681ZM53.6336 12.1235C52.8102 12.1235 52.2117 11.9335 51.8381 11.5535C51.4707 11.1672 51.2871 10.6098 51.2871 9.8815V6.794H52.7121V9.9575C52.7121 10.2932 52.7849 10.5497 52.9306 10.727C53.0826 10.898 53.3169 10.9835 53.6336 10.9835C53.9502 10.9835 54.1814 10.898 54.3271 10.727C54.4791 10.5497 54.5551 10.2932 54.5551 9.9575V6.794H55.9801V9.8815C55.9801 10.6098 55.7932 11.1672 55.4196 11.5535C55.0522 11.9335 54.4569 12.1235 53.6336 12.1235ZM58.7711 12.095C58.4861 12.095 58.2454 12.0507 58.0491 11.962C57.8527 11.8733 57.7039 11.7403 57.6026 11.563C57.5012 11.3793 57.4506 11.1513 57.4506 10.879V6.794H58.8756V10.708C58.8756 10.8283 58.9009 10.917 58.9516 10.974C59.0086 11.031 59.0941 11.0595 59.2081 11.0595C59.2587 11.0595 59.3126 11.0532 59.3696 11.0405C59.4266 11.0278 59.4804 11.012 59.5311 10.993L59.6641 11.905C59.5437 11.9683 59.4076 12.0158 59.2556 12.0475C59.1036 12.0792 58.9421 12.095 58.7711 12.095ZM60.4531 12V8.9125C60.4531 8.18417 60.6463 7.63 61.0326 7.25C61.4189 6.86367 62.0301 6.6705 62.8661 6.6705C63.7084 6.6705 64.3164 6.86367 64.6901 7.25C65.0701 7.63 65.2601 8.18417 65.2601 8.9125V12H63.8446V8.8935C63.8446 8.55783 63.7654 8.295 63.6071 8.105C63.4551 7.90867 63.2018 7.8105 62.8471 7.8105C62.4988 7.8105 62.2454 7.90867 62.0871 8.105C61.9351 8.295 61.8591 8.55783 61.8591 8.8935V9.72L61.8876 9.7295C62.0079 9.4825 62.1504 9.321 62.3151 9.245C62.4861 9.16267 62.7173 9.1215 63.0086 9.1215H63.2271V10.1855H63.0086C62.6919 10.1855 62.4513 10.2393 62.2866 10.347C62.1219 10.4547 62.0079 10.5972 61.9446 10.7745C61.8876 10.9455 61.8591 11.1387 61.8591 11.354V12H60.4531ZM69.5587 12V8.618C69.5587 8.314 69.4764 8.0955 69.3117 7.9625C69.147 7.8295 68.8937 7.763 68.5517 7.763C68.2224 7.763 67.8994 7.81367 67.5827 7.915C67.2724 8.01 67.0032 8.124 66.7752 8.257V7.079C66.9589 6.99033 67.2185 6.90167 67.5542 6.813C67.8899 6.718 68.2794 6.6705 68.7227 6.6705C69.0457 6.6705 69.3402 6.70533 69.6062 6.775C69.8785 6.83833 70.116 6.94917 70.3187 7.1075C70.5214 7.2595 70.6765 7.46533 70.7842 7.725C70.8982 7.97833 70.9552 8.295 70.9552 8.675V12H69.5587ZM68.0007 12.095C67.456 12.095 67.0349 11.9652 66.7372 11.7055C66.4459 11.4458 66.3002 11.0817 66.3002 10.613C66.3002 10.1063 66.4807 9.701 66.8417 9.397C67.209 9.093 67.7854 8.90933 68.5707 8.846L69.7867 8.751V9.777L68.7322 9.8815C68.3522 9.9195 68.0862 9.9955 67.9342 10.1095C67.7885 10.2235 67.7157 10.3755 67.7157 10.5655C67.7157 10.7555 67.7759 10.898 67.8962 10.993C68.0229 11.088 68.1844 11.1355 68.3807 11.1355C68.4567 11.1355 68.5327 11.1292 68.6087 11.1165C68.6847 11.0975 68.7544 11.0785 68.8177 11.0595L68.9412 11.9525C68.8209 11.9968 68.6784 12.0317 68.5137 12.057C68.349 12.0823 68.178 12.095 68.0007 12.095ZM66.5247 6.072V5.4735L67.4842 5.0745H70.8757V6.072H66.5247ZM68.5197 5.4925V4.419H69.4222V5.4925H68.5197ZM69.9827 5.4925V4.419H70.8757V5.4925H69.9827ZM69.1768 3.9155V2.1485H70.4118V3.9155H69.1768ZM74.3527 12.1235C73.58 12.1235 73.0069 11.9367 72.6332 11.563C72.2595 11.183 72.0727 10.6225 72.0727 9.8815C72.0727 9.75483 72.0759 9.60283 72.0822 9.4255C72.0949 9.24183 72.1107 9.08033 72.1297 8.941H74.4097V9.8435H73.4692V9.9765C73.4692 10.2298 73.5009 10.4388 73.5642 10.6035C73.6275 10.7618 73.7225 10.879 73.8492 10.955C73.9822 11.031 74.1469 11.069 74.3432 11.069C74.5585 11.069 74.739 11.0215 74.8847 10.9265C75.0367 10.8315 75.1507 10.67 75.2267 10.442C75.309 10.214 75.3502 9.9005 75.3502 9.5015C75.3502 9.12783 75.3059 8.8175 75.2172 8.5705C75.1349 8.31717 74.9924 8.12717 74.7897 8.0005C74.5934 7.87383 74.321 7.8105 73.9727 7.8105C73.7827 7.8105 73.5864 7.83267 73.3837 7.877C73.181 7.915 72.9879 7.96567 72.8042 8.029C72.6269 8.09233 72.4717 8.162 72.3387 8.238V7.0505C72.478 6.9745 72.649 6.908 72.8517 6.851C73.0607 6.794 73.2855 6.74967 73.5262 6.718C73.7669 6.68633 74.0044 6.6705 74.2387 6.6705C74.853 6.6705 75.347 6.7845 75.7207 7.0125C76.1007 7.23417 76.3762 7.55083 76.5472 7.9625C76.7245 8.37417 76.8132 8.86183 76.8132 9.4255C76.8132 10.0018 76.7277 10.4927 76.5567 10.898C76.392 11.297 76.1292 11.601 75.7682 11.81C75.4072 12.019 74.9354 12.1235 74.3527 12.1235ZM79.6895 12.095C79.3032 12.095 78.977 12.0222 78.711 11.8765C78.4514 11.7245 78.2519 11.4997 78.1125 11.202C77.9795 10.9043 77.913 10.5402 77.913 10.1095V6.794H79.338V9.8625C79.338 10.2108 79.4077 10.4642 79.547 10.6225C79.6864 10.7808 79.889 10.86 80.155 10.86C80.4907 10.86 80.7504 10.7333 80.934 10.48C81.1177 10.2203 81.2095 9.82133 81.2095 9.283V6.794H82.6345V12H81.5515L81.3995 11.202H81.314C81.2064 11.4553 81.0195 11.6675 80.7535 11.8385C80.4939 12.0095 80.1392 12.095 79.6895 12.095ZM84.3776 7.744V6.1955C84.3776 5.8155 84.308 5.54317 84.1686 5.3785C84.0293 5.21383 83.8203 5.1315 83.5416 5.1315V4.5615L84.5011 4.1055H86.9236V5.1315H85.3276L85.3181 5.1695C85.4828 5.27083 85.6031 5.4165 85.6791 5.6065C85.7615 5.7965 85.8026 6.04667 85.8026 6.357V7.744H84.3776ZM85.6981 12.095C85.4131 12.095 85.1725 12.0507 84.9761 11.962C84.7798 11.8733 84.631 11.7403 84.5296 11.563C84.4283 11.3793 84.3776 11.1513 84.3776 10.879V6.794H85.8026V10.708C85.8026 10.8283 85.828 10.917 85.8786 10.974C85.9356 11.031 86.0211 11.0595 86.1351 11.0595C86.1858 11.0595 86.2396 11.0532 86.2966 11.0405C86.3536 11.0278 86.4075 11.012 86.4581 10.993L86.5911 11.905C86.4708 11.9683 86.3346 12.0158 86.1826 12.0475C86.0306 12.0792 85.8691 12.095 85.6981 12.095ZM89.1454 12.095C88.6324 12.095 88.2239 11.9842 87.9199 11.7625C87.6159 11.5345 87.3974 11.2242 87.2644 10.8315C87.1314 10.4325 87.0649 9.9765 87.0649 9.4635C87.0649 8.9125 87.1251 8.4565 87.2454 8.0955C87.3721 7.72817 87.5494 7.44317 87.7774 7.2405C88.0054 7.0315 88.2746 6.88583 88.5849 6.8035C88.9016 6.71483 89.2467 6.6705 89.6204 6.6705C90.1904 6.6705 90.6464 6.74967 90.9884 6.908C91.3304 7.06633 91.5774 7.29117 91.7294 7.5825C91.8877 7.87383 91.9669 8.21583 91.9669 8.6085V12H90.5419V8.7225C90.5419 8.42483 90.4691 8.2 90.3234 8.048C90.1841 7.88967 89.9497 7.8105 89.6204 7.8105C89.3987 7.8105 89.2024 7.858 89.0314 7.953C88.8667 8.04167 88.7369 8.20317 88.6419 8.4375C88.5532 8.67183 88.5089 9.0075 88.5089 9.4445C88.5089 9.74217 88.5374 10.005 88.5944 10.233C88.6514 10.461 88.7432 10.6383 88.8699 10.765C89.0029 10.8917 89.1802 10.955 89.4019 10.955C89.4716 10.955 89.5381 10.9518 89.6014 10.9455C89.6711 10.9328 89.7312 10.9202 89.7819 10.9075L89.9149 11.9715C89.8136 12.0158 89.6901 12.0475 89.5444 12.0665C89.4051 12.0855 89.2721 12.095 89.1454 12.095ZM95.4989 12.1235C94.9289 12.1235 94.4729 12.057 94.1309 11.924C93.7889 11.7847 93.5387 11.5915 93.3804 11.3445C93.2284 11.0975 93.1524 10.8125 93.1524 10.4895C93.1524 10.2108 93.1935 9.986 93.2759 9.815C93.3645 9.644 93.4754 9.51417 93.6084 9.4255C93.7477 9.3305 93.887 9.26717 94.0264 9.2355V9.1785C93.8807 9.12783 93.7414 9.05817 93.6084 8.9695C93.4754 8.88083 93.3645 8.7605 93.2759 8.6085C93.1935 8.4565 93.1524 8.2665 93.1524 8.0385C93.1524 7.80417 93.2062 7.58567 93.3139 7.383C93.4279 7.18033 93.6084 7.01883 93.8554 6.8985C94.1024 6.77183 94.4285 6.7085 94.8339 6.7085C95.0302 6.7085 95.2202 6.72433 95.4039 6.756C95.5875 6.78133 95.73 6.81933 95.8314 6.87L95.6129 7.8295C95.5622 7.81683 95.4925 7.80417 95.4039 7.7915C95.3215 7.7725 95.236 7.763 95.1474 7.763C94.951 7.763 94.8054 7.8105 94.7104 7.9055C94.6154 7.99417 94.5679 8.11133 94.5679 8.257C94.5679 8.409 94.609 8.52617 94.6914 8.6085C94.7737 8.69083 94.8782 8.74783 95.0049 8.7795C95.1379 8.81117 95.274 8.827 95.4134 8.827H95.6129V9.7105H95.4134C95.141 9.7105 94.9352 9.758 94.7959 9.853C94.6629 9.948 94.5964 10.1032 94.5964 10.3185C94.5964 10.4325 94.6217 10.5465 94.6724 10.6605C94.7294 10.7682 94.8244 10.86 94.9574 10.936C95.0904 11.0057 95.2804 11.0405 95.5274 11.0405C95.7617 11.0405 95.9454 11.0057 96.0784 10.936C96.2114 10.8663 96.3064 10.7745 96.3634 10.6605C96.4204 10.5402 96.4489 10.4072 96.4489 10.2615V6.794H97.8739V10.214C97.8739 10.8663 97.6807 11.3477 97.2944 11.658C96.9144 11.9683 96.3159 12.1235 95.4989 12.1235Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function _f(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5644",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5644)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM58.4926 12.1012C57.9596 12.1012 57.5008 11.9933 57.1162 11.7773C56.7339 11.5592 56.4392 11.2511 56.2323 10.853C56.0254 10.4527 55.922 9.97923 55.922 9.43271C55.922 8.89968 56.0254 8.43188 56.2323 8.0293C56.4392 7.62672 56.7305 7.31297 57.1061 7.08807C57.4839 6.86316 57.927 6.75071 58.4353 6.75071C58.7771 6.75071 59.0954 6.80581 59.39 6.91602C59.6869 7.02397 59.9455 7.18703 60.1659 7.40518C60.3886 7.62334 60.5618 7.89773 60.6855 8.22834C60.8092 8.5567 60.871 8.94129 60.871 9.3821V9.77681H56.4955V8.88619H59.5182C59.5182 8.67927 59.4732 8.49598 59.3833 8.33629C59.2933 8.17661 59.1685 8.05179 59.0088 7.96183C58.8514 7.86961 58.6681 7.82351 58.4589 7.82351C58.2407 7.82351 58.0473 7.87411 57.8786 7.97532C57.7122 8.07428 57.5818 8.2081 57.4873 8.37678C57.3928 8.54321 57.3445 8.72875 57.3422 8.93342V9.78018C57.3422 10.0366 57.3895 10.2581 57.4839 10.4448C57.5806 10.6315 57.7167 10.7754 57.8921 10.8766C58.0676 10.9778 58.2756 11.0284 58.5162 11.0284C58.6759 11.0284 58.8221 11.0059 58.9548 10.9609C59.0875 10.916 59.2011 10.8485 59.2955 10.7585C59.39 10.6686 59.462 10.5584 59.5115 10.4279L60.8406 10.5156C60.7732 10.835 60.6349 11.1139 60.4257 11.3523C60.2188 11.5884 59.9511 11.7728 59.6228 11.9055C59.2967 12.036 58.92 12.1012 58.4926 12.1012ZM66.5007 6.81818L64.6891 12H63.0697L61.2581 6.81818H62.7762L63.8524 10.5257H63.9064L64.9792 6.81818H66.5007ZM69.4306 12.1012C68.8976 12.1012 68.4388 11.9933 68.0542 11.7773C67.6719 11.5592 67.3772 11.2511 67.1703 10.853C66.9634 10.4527 66.86 9.97923 66.86 9.43271C66.86 8.89968 66.9634 8.43188 67.1703 8.0293C67.3772 7.62672 67.6685 7.31297 68.0441 7.08807C68.4219 6.86316 68.865 6.75071 69.3733 6.75071C69.7151 6.75071 70.0334 6.80581 70.328 6.91602C70.6249 7.02397 70.8835 7.18703 71.1039 7.40518C71.3266 7.62334 71.4997 7.89773 71.6234 8.22834C71.7471 8.5567 71.809 8.94129 71.809 9.3821V9.77681H67.4335V8.88619H70.4562C70.4562 8.67927 70.4112 8.49598 70.3212 8.33629C70.2313 8.17661 70.1065 8.05179 69.9468 7.96183C69.7893 7.86961 69.606 7.82351 69.3969 7.82351C69.1787 7.82351 68.9853 7.87411 68.8166 7.97532C68.6502 8.07428 68.5198 8.2081 68.4253 8.37678C68.3308 8.54321 68.2825 8.72875 68.2802 8.93342V9.78018C68.2802 10.0366 68.3275 10.2581 68.4219 10.4448C68.5186 10.6315 68.6547 10.7754 68.8301 10.8766C69.0055 10.9778 69.2136 11.0284 69.4542 11.0284C69.6139 11.0284 69.7601 11.0059 69.8928 10.9609C70.0255 10.916 70.1391 10.8485 70.2335 10.7585C70.328 10.6686 70.4 10.5584 70.4494 10.4279L71.7786 10.5156C71.7112 10.835 71.5728 11.1139 71.3637 11.3523C71.1568 11.5884 70.8891 11.7728 70.5608 11.9055C70.2347 12.036 69.8579 12.1012 69.4306 12.1012ZM75.5031 6.81818V7.89773H72.3825V6.81818H75.5031ZM73.091 5.5767H74.5281V10.4077C74.5281 10.5404 74.5483 10.6438 74.5888 10.718C74.6293 10.79 74.6855 10.8406 74.7575 10.8699C74.8317 10.8991 74.9172 10.9137 75.0139 10.9137C75.0814 10.9137 75.1488 10.9081 75.2163 10.8968C75.2838 10.8833 75.3355 10.8732 75.3715 10.8665L75.5975 11.9359C75.5256 11.9584 75.4243 11.9843 75.2939 12.0135C75.1635 12.045 75.0049 12.0641 74.8182 12.0708C74.4719 12.0843 74.1682 12.0382 73.9074 11.9325C73.6487 11.8268 73.4474 11.6626 73.3035 11.44C73.1595 11.2173 73.0887 10.9362 73.091 10.5966V5.5767ZM80.1156 12.0978C79.785 12.0978 79.4904 12.0405 79.2317 11.9258C78.9731 11.8088 78.7684 11.6368 78.6177 11.4096C78.4693 11.1802 78.3951 10.8946 78.3951 10.5527C78.3951 10.2649 78.4479 10.0231 78.5536 9.82741C78.6593 9.63175 78.8033 9.47431 78.9854 9.35511C79.1676 9.23591 79.3745 9.14595 79.6062 9.08523C79.8401 9.0245 80.0852 8.98177 80.3416 8.95703C80.643 8.92554 80.8859 8.89631 81.0703 8.86932C81.2547 8.84008 81.3886 8.79735 81.4718 8.74112C81.555 8.6849 81.5966 8.60168 81.5966 8.49148V8.47124C81.5966 8.25758 81.5291 8.09227 81.3942 7.97532C81.2615 7.85837 81.0726 7.79989 80.8274 7.79989C80.5688 7.79989 80.363 7.85724 80.21 7.97195C80.0571 8.0844 79.9559 8.22609 79.9064 8.39702L78.5772 8.28906C78.6447 7.97419 78.7774 7.70206 78.9753 7.47266C79.1732 7.241 79.4285 7.06333 79.7411 6.93963C80.056 6.81368 80.4203 6.75071 80.8342 6.75071C81.122 6.75071 81.3975 6.78445 81.6607 6.85192C81.9261 6.91939 82.1611 7.02397 82.3658 7.16566C82.5727 7.30735 82.7357 7.48952 82.8549 7.71218C82.9741 7.93259 83.0337 8.19685 83.0337 8.50497V12H81.6708V11.2814H81.6303C81.5471 11.4434 81.4358 11.5862 81.2963 11.7099C81.1569 11.8313 80.9893 11.9269 80.7937 11.9966C80.598 12.0641 80.372 12.0978 80.1156 12.0978ZM80.5272 11.106C80.7386 11.106 80.9252 11.0644 81.0872 10.9812C81.2491 10.8957 81.3762 10.781 81.4684 10.6371C81.5606 10.4931 81.6067 10.3301 81.6067 10.1479V9.59801C81.5617 9.62725 81.4999 9.65424 81.4212 9.67898C81.3447 9.70147 81.2581 9.72283 81.1614 9.74308C81.0647 9.76107 80.968 9.77794 80.8713 9.79368C80.7746 9.80717 80.6868 9.81954 80.6081 9.83079C80.4395 9.85553 80.2921 9.89489 80.1662 9.94886C80.0402 10.0028 79.9424 10.0759 79.8727 10.1681C79.803 10.2581 79.7681 10.3706 79.7681 10.5055C79.7681 10.7012 79.839 10.8507 79.9806 10.9542C80.1246 11.0554 80.3068 11.106 80.5272 11.106ZM88.7941 6.81818L86.9825 12H85.3632L83.5516 6.81818H85.0697L86.1459 10.5257H86.1998L87.2726 6.81818H88.7941Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Mf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5764",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5764)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M50.111 7.155V12H48.781V10.404C48.4295 10.5655 48.021 10.6605 47.622 10.6605C46.2825 10.6605 45.627 9.986 45.627 8.675V7.155H45V6.091H50.985V7.155H50.111ZM48.781 7.155H46.9475V8.656C46.9475 9.3305 47.204 9.5965 47.717 9.5965C48.116 9.5965 48.5055 9.378 48.781 9.1215V7.155ZM52.9062 7.155V12H51.5762V7.155H50.8447V6.091H53.7802V7.155H52.9062ZM59.5082 7.155H58.6342V12H57.3137V10.8505C56.9717 11.0405 56.5442 11.1545 56.0407 11.1545C54.7867 11.1545 53.9697 10.537 53.9697 9.416C53.9697 8.3235 54.7487 7.7345 56.0217 7.7345C56.4112 7.7345 56.7437 7.7725 57.0192 7.839L56.9147 8.8745C56.7057 8.827 56.4777 8.7985 56.2117 8.7985C55.6417 8.7985 55.2997 9.036 55.2997 9.454C55.2997 9.8435 55.6037 10.081 56.1167 10.081C56.5917 10.081 57.0477 9.853 57.3137 9.492V7.155H53.6372V6.091H59.5082V7.155ZM62.3821 10.1665C62.0686 10.1665 61.6981 10.2235 61.3751 10.309C60.7196 9.9575 60.2066 9.473 60.2066 8.846C60.2066 8.0955 60.7101 7.706 61.7836 7.706H62.7146V7.155H59.2661V6.091H64.9091V7.155H64.0256V8.6085H62.0021C61.6506 8.6085 61.5081 8.732 61.5081 8.9505C61.5081 9.0835 61.6031 9.2165 61.7266 9.3115C62.0116 9.2545 62.3536 9.1975 62.7526 9.1975C63.9306 9.1975 64.4531 9.739 64.4531 10.556C64.4531 11.392 63.8831 12.0475 62.3441 12.0475C61.2041 12.0475 60.3016 11.6865 59.4561 11.031L60.0356 10.081C60.7481 10.6985 61.4606 11.031 62.2396 11.031C62.8476 11.031 63.1041 10.86 63.1041 10.575C63.1041 10.3185 62.9331 10.1665 62.3821 10.1665ZM62.6228 6.1575C62.2618 5.806 62.0243 5.3595 62.0243 4.856C62.0243 3.944 62.7083 3.488 63.7153 3.488C64.1333 3.488 64.5418 3.564 64.8173 3.697L64.5798 4.5615C64.3708 4.4855 64.1998 4.4475 63.9908 4.4475C63.5443 4.4475 63.2973 4.6945 63.2973 5.103C63.2973 5.4735 63.4968 5.844 63.8483 6.1575H62.6228ZM73.0008 7.155H72.1268V12H70.8063V10.879C70.4263 11.0785 69.9798 11.183 69.4288 11.183C68.1273 11.183 67.3198 10.5085 67.3198 9.4255C67.3198 8.2855 68.1558 7.6965 69.4478 7.6965C69.8563 7.6965 70.1983 7.7345 70.5118 7.8105L70.4073 8.7795C70.1888 8.732 69.9228 8.694 69.6188 8.694C69.5998 8.694 69.5713 8.694 69.5428 8.694L70.4738 9.872C70.5973 9.7865 70.7113 9.6915 70.8063 9.5965V7.155H66.9873V6.091H73.0008V7.155ZM68.5643 9.4635C68.5643 9.9575 68.9253 10.1855 69.4763 10.1855C69.5808 10.1855 69.6853 10.176 69.7803 10.157L68.8018 8.922C68.6498 9.0455 68.5643 9.226 68.5643 9.4635ZM74.9306 7.155V12H73.6006V7.155H72.8691V6.091H75.8046V7.155H74.9306ZM81.8366 6.091V7.155H80.9531V12H79.6326V10.651C79.2811 10.8505 78.8726 10.9645 78.3596 10.9645C76.9821 10.9645 76.1651 10.1665 75.8611 8.5895C76.7636 8.4375 77.1531 8.1905 77.1531 7.763C77.1531 7.5255 77.0581 7.326 76.8871 7.155H75.6616V6.091H81.8366ZM77.3621 9.2165C77.5236 9.6535 77.8371 9.9005 78.3691 9.9005C78.8726 9.9005 79.3001 9.663 79.6326 9.321V7.155H78.2171C78.3881 7.4115 78.4736 7.6775 78.4736 7.9625C78.4736 8.6085 78.0936 8.9695 77.3621 9.2165Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Sf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5572",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5572)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M44.5057 5.18182H46.0227L47.625 9.09091H47.6932L49.2955 5.18182H50.8125V11H49.6193V7.21307H49.571L48.0653 10.9716H47.2528L45.7472 7.19886H45.6989V11H44.5057V5.18182ZM53.3459 8.71307H54.2237V9.17614H53.6044C53.4624 9.17614 53.3288 9.19508 53.2038 9.23295C53.0788 9.26894 52.9775 9.32576 52.8999 9.40341C52.8222 9.47917 52.7824 9.5767 52.7805 9.69602C52.7843 9.8286 52.8563 9.94508 52.9964 10.0455C53.1366 10.1439 53.3374 10.1932 53.5987 10.1932C53.8696 10.1932 54.0713 10.1553 54.2038 10.0795C54.3364 10.0019 54.4131 9.8892 54.4339 9.74148H55.5874C55.5798 9.96117 55.522 10.1544 55.4141 10.321C55.308 10.4877 55.166 10.6278 54.9879 10.7415C54.8099 10.8532 54.6072 10.9375 54.38 10.9943C54.1527 11.0511 53.9131 11.0795 53.6612 11.0795C53.2805 11.0795 52.9358 11.0284 52.6271 10.9261C52.3203 10.822 52.0769 10.6752 51.897 10.4858C51.719 10.2964 51.629 10.072 51.6271 9.8125C51.629 9.6572 51.6631 9.51326 51.7294 9.38068C51.7957 9.24811 51.898 9.13163 52.0362 9.03125C52.1745 8.93087 52.3516 8.85322 52.5675 8.7983C52.7853 8.74148 53.0447 8.71307 53.3459 8.71307ZM54.2237 8.88068H53.3459C53.0656 8.88068 52.8222 8.85227 52.6158 8.79545C52.4093 8.73674 52.2379 8.65814 52.1016 8.55966C51.9671 8.46117 51.8667 8.34943 51.8004 8.22443C51.7341 8.09754 51.701 7.9678 51.701 7.83523C51.701 7.56629 51.7853 7.33902 51.9538 7.15341C52.1224 6.96591 52.3535 6.82386 52.647 6.72727C52.9406 6.62879 53.2768 6.57955 53.6555 6.57955C53.9983 6.57955 54.308 6.63163 54.5845 6.7358C54.8629 6.83807 55.0855 6.98674 55.2521 7.18182C55.4188 7.375 55.5088 7.60795 55.522 7.88068H54.3544C54.3374 7.73864 54.2597 7.63352 54.1214 7.56534C53.9851 7.49527 53.8099 7.46023 53.5959 7.46023C53.3554 7.46023 53.1726 7.50758 53.0476 7.60227C52.9245 7.69697 52.862 7.80682 52.8601 7.93182C52.862 8.0625 52.9283 8.16761 53.0589 8.24716C53.1896 8.32481 53.3714 8.36364 53.6044 8.36364H54.2237V8.88068ZM61.9588 6.63636V7.58239H58.0043V6.63636H61.9588ZM59.3423 6.63636H60.5156V9.67614C60.5156 9.79167 60.5308 9.88163 60.5611 9.94602C60.5933 10.0085 60.6378 10.053 60.6946 10.0795C60.7514 10.1042 60.8177 10.1165 60.8935 10.1165C60.9825 10.1165 61.0545 10.1108 61.1094 10.0994C61.1643 10.0881 61.223 10.0748 61.2855 10.0597L61.4077 10.9545C61.2865 11.0038 61.1681 11.0369 61.0526 11.054C60.9389 11.071 60.8063 11.0795 60.6548 11.0795C60.2401 11.0795 59.9171 10.964 59.6861 10.733C59.4569 10.5 59.3423 10.1458 59.3423 9.67045V6.63636ZM63.9119 8.47727V11H62.7017V6.63636H63.8551V7.40625H63.9062C64.0047 7.15057 64.1676 6.94886 64.3949 6.80114C64.6222 6.65341 64.8968 6.57955 65.2188 6.57955C65.5237 6.57955 65.7888 6.64583 66.0142 6.77841C66.2396 6.91098 66.4138 7.09943 66.5369 7.34375C66.6619 7.58807 66.7244 7.88068 66.7244 8.22159V12.6364H65.5142V8.4375C65.5142 8.17045 65.446 7.96212 65.3097 7.8125C65.1733 7.66098 64.983 7.58523 64.7386 7.58523C64.5777 7.58523 64.4347 7.62027 64.3097 7.69034C64.1847 7.76042 64.0871 7.86269 64.017 7.99716C63.947 8.12973 63.9119 8.28977 63.9119 8.47727ZM69.0334 11L67.3942 6.63636H68.6442L69.7095 9.8125H69.755C69.9273 9.5303 70.0703 9.26515 70.1839 9.01705C70.2976 8.76894 70.3875 8.52273 70.4538 8.27841C70.5201 8.03409 70.5703 7.77936 70.6044 7.5142C70.6385 7.24716 70.6631 6.95455 70.6783 6.63636H71.8544C71.8393 7.4053 71.6896 8.16477 71.4055 8.91477C71.1233 9.66477 70.7171 10.3598 70.1868 11H69.0334ZM74.608 6.63636H75.7841V9.38636C75.7841 9.57576 75.8068 9.72443 75.8523 9.83239C75.8996 9.94034 75.9621 10.017 76.0398 10.0625C76.1193 10.108 76.2045 10.1307 76.2955 10.1307C76.4811 10.1307 76.6402 10.0653 76.7727 9.93466C76.9072 9.80398 77.0104 9.63636 77.0824 9.43182C77.1563 9.22538 77.1932 9.00947 77.1932 8.78409C77.1875 8.55303 77.1657 8.31345 77.1278 8.06534C77.0919 7.81534 77.0436 7.56913 76.983 7.3267C76.9242 7.08239 76.857 6.85227 76.7812 6.63636H77.8949C77.9763 6.79545 78.0511 6.98958 78.1193 7.21875C78.1894 7.44792 78.2453 7.69697 78.2869 7.96591C78.3286 8.23485 78.3494 8.50758 78.3494 8.78409C78.3494 9.10606 78.3106 9.40625 78.233 9.68466C78.1572 9.96307 78.0379 10.2064 77.875 10.4148C77.7121 10.6231 77.5028 10.786 77.2472 10.9034C76.9934 11.0208 76.6884 11.0795 76.3324 11.0795C75.8134 11.0795 75.3958 10.9432 75.0795 10.6705C74.7652 10.3958 74.608 9.96402 74.608 9.375V6.63636ZM84.2081 6.63636V7.52841H79.3445V6.63636H84.2081ZM81.2223 6.63636V11H80.0462V6.63636H81.2223ZM82.3331 6.63636H83.5007V9.63352C83.5026 9.74905 83.5206 9.83902 83.5547 9.90341C83.5888 9.96591 83.6399 10.0095 83.7081 10.0341C83.7763 10.0587 83.8615 10.071 83.9638 10.071C84.0301 10.071 84.0926 10.0682 84.1513 10.0625C84.21 10.0568 84.2611 10.0521 84.3047 10.0483V10.9375C84.2043 10.9697 84.0935 10.9962 83.9723 11.017C83.853 11.0398 83.7223 11.0511 83.5803 11.0511C83.1996 11.0511 82.8965 10.9527 82.6712 10.7557C82.4477 10.5587 82.335 10.233 82.3331 9.77841V6.63636ZM87.2592 11.0852C86.8179 11.0852 86.4363 10.9915 86.1143 10.804C85.7943 10.6146 85.5471 10.3513 85.3729 10.0142C85.1986 9.67519 85.1115 9.2822 85.1115 8.83523C85.1115 8.38447 85.1986 7.99053 85.3729 7.65341C85.5471 7.31439 85.7943 7.05114 86.1143 6.86364C86.4363 6.67424 86.8179 6.57955 87.2592 6.57955C87.7005 6.57955 88.0812 6.67424 88.4013 6.86364C88.7232 7.05114 88.9714 7.31439 89.1456 7.65341C89.3198 7.99053 89.407 8.38447 89.407 8.83523C89.407 9.2822 89.3198 9.67519 89.1456 10.0142C88.9714 10.3513 88.7232 10.6146 88.4013 10.804C88.0812 10.9915 87.7005 11.0852 87.2592 11.0852ZM87.2649 10.1477C87.4657 10.1477 87.6333 10.0909 87.7678 9.97727C87.9022 9.86174 88.0036 9.70455 88.0717 9.50568C88.1418 9.30682 88.1768 9.08049 88.1768 8.8267C88.1768 8.57292 88.1418 8.34659 88.0717 8.14773C88.0036 7.94886 87.9022 7.79167 87.7678 7.67614C87.6333 7.56061 87.4657 7.50284 87.2649 7.50284C87.0623 7.50284 86.8918 7.56061 86.7536 7.67614C86.6172 7.79167 86.514 7.94886 86.4439 8.14773C86.3757 8.34659 86.3416 8.57292 86.3416 8.8267C86.3416 9.08049 86.3757 9.30682 86.4439 9.50568C86.514 9.70455 86.6172 9.86174 86.7536 9.97727C86.8918 10.0909 87.0623 10.1477 87.2649 10.1477ZM90.2109 8.93182V8.84091C90.2128 8.44886 90.2933 8.09659 90.4524 7.78409C90.6115 7.47159 90.8435 7.22538 91.1484 7.04545C91.4534 6.86364 91.8265 6.77273 92.2678 6.77273C92.3303 6.80682 92.389 6.86742 92.4439 6.95455C92.5007 7.03977 92.5746 7.12784 92.6655 7.21875C92.7564 7.30777 92.8833 7.37784 93.0462 7.42898C93.2526 7.49716 93.4486 7.6089 93.6342 7.7642C93.8217 7.91951 93.9742 8.10511 94.0916 8.32102C94.2109 8.53504 94.2696 8.76515 94.2678 9.01136V9.09091C94.2696 9.46402 94.192 9.80114 94.0348 10.1023C93.8795 10.4015 93.6541 10.6392 93.3587 10.8153C93.0632 10.9915 92.7034 11.0795 92.2791 11.0795C91.8378 11.0795 91.4628 10.9858 91.1541 10.7983C90.8473 10.6089 90.6134 10.3523 90.4524 10.0284C90.2933 9.70455 90.2128 9.33902 90.2109 8.93182ZM91.4098 8.84091V8.93182C91.4117 9.15152 91.4392 9.35227 91.4922 9.53409C91.5471 9.71591 91.6371 9.8608 91.7621 9.96875C91.889 10.0748 92.0613 10.1278 92.2791 10.1278C92.4761 10.1278 92.6314 10.0748 92.745 9.96875C92.8606 9.8608 92.9429 9.71591 92.9922 9.53409C93.0433 9.35227 93.0689 9.15152 93.0689 8.93182V8.84091C93.0689 8.64015 93.0433 8.45549 92.9922 8.28693C92.9429 8.11648 92.8596 7.98011 92.7422 7.87784C92.6267 7.77557 92.4685 7.72443 92.2678 7.72443C92.0594 7.72443 91.8928 7.77557 91.7678 7.87784C91.6428 7.98011 91.5518 8.11648 91.495 8.28693C91.4401 8.45549 91.4117 8.64015 91.4098 8.84091ZM94.5774 6.77273V7.72443H92.2678V6.77273H94.5774ZM99.3026 6.63636V7.58239H95.348V6.63636H99.3026ZM96.6861 6.63636H97.8594V9.67614C97.8594 9.79167 97.8745 9.88163 97.9048 9.94602C97.937 10.0085 97.9815 10.053 98.0384 10.0795C98.0952 10.1042 98.1615 10.1165 98.2372 10.1165C98.3262 10.1165 98.3982 10.1108 98.4531 10.0994C98.508 10.0881 98.5668 10.0748 98.6293 10.0597L98.7514 10.9545C98.6302 11.0038 98.5118 11.0369 98.3963 11.054C98.2827 11.071 98.1501 11.0795 97.9986 11.0795C97.5838 11.0795 97.2609 10.964 97.0298 10.733C96.8007 10.5 96.6861 10.1458 96.6861 9.67045V6.63636ZM101.256 8.47727V11H100.045V6.63636H101.199V7.40625H101.25C101.348 7.15057 101.511 6.94886 101.739 6.80114C101.966 6.65341 102.241 6.57955 102.562 6.57955C102.867 6.57955 103.133 6.64583 103.358 6.77841C103.583 6.91098 103.758 7.09943 103.881 7.34375C104.006 7.58807 104.068 7.88068 104.068 8.22159V12.6364H102.858V8.4375C102.858 8.17045 102.79 7.96212 102.653 7.8125C102.517 7.66098 102.327 7.58523 102.082 7.58523C101.921 7.58523 101.778 7.62027 101.653 7.69034C101.528 7.76042 101.431 7.86269 101.361 7.99716C101.291 8.12973 101.256 8.28977 101.256 8.47727ZM101.682 6.06534L101.986 4.71591H103.068L102.395 6.06534H101.682ZM105.011 12.625V8.69318C105.011 8.23674 105.091 7.85133 105.252 7.53693C105.415 7.22254 105.645 6.98485 105.942 6.82386C106.24 6.66098 106.589 6.57955 106.991 6.57955C107.349 6.57955 107.652 6.6392 107.9 6.75852C108.15 6.87784 108.352 7.04261 108.505 7.25284C108.66 7.46307 108.773 7.70644 108.843 7.98295C108.915 8.25758 108.951 8.55114 108.951 8.86364V8.94318C108.951 9.37121 108.882 9.74527 108.744 10.0653C108.607 10.3854 108.41 10.6345 108.153 10.8125C107.895 10.9905 107.586 11.0795 107.227 11.0795C106.886 11.0795 106.611 10.9981 106.403 10.8352C106.194 10.6705 106.031 10.4432 105.914 10.1534C105.799 9.86174 105.707 9.52367 105.638 9.1392L106.178 8.9375C106.178 9.07008 106.19 9.20549 106.212 9.34375C106.235 9.48201 106.275 9.60985 106.332 9.72727C106.388 9.8428 106.469 9.93655 106.573 10.0085C106.677 10.0805 106.811 10.1165 106.974 10.1165C107.182 10.1165 107.344 10.0587 107.46 9.94318C107.577 9.82765 107.658 9.67992 107.704 9.5C107.751 9.32008 107.774 9.13447 107.772 8.94318V8.86364C107.772 8.63258 107.746 8.41951 107.695 8.22443C107.644 8.02936 107.559 7.87311 107.44 7.75568C107.322 7.63826 107.161 7.57955 106.957 7.57955C106.767 7.57955 106.615 7.63542 106.499 7.74716C106.386 7.8589 106.303 8.00758 106.252 8.19318C106.201 8.37879 106.176 8.58239 106.178 8.80398L106.187 12.625H105.011ZM109.836 6.63636H111.012L110.998 9.63352C111 9.80777 111.04 9.92424 111.117 9.98295C111.197 10.0417 111.31 10.071 111.458 10.071C111.534 10.071 111.599 10.0682 111.654 10.0625C111.709 10.0568 111.758 10.0521 111.802 10.0483V10.9375C111.701 10.9716 111.59 10.9991 111.467 11.0199C111.345 11.0407 111.218 11.0511 111.083 11.0511C110.702 11.0511 110.4 10.9527 110.177 10.7557C109.953 10.5587 109.84 10.233 109.836 9.77841V6.63636ZM115.773 5.30966L115.591 6.23011C115.239 6.13163 114.934 6.08239 114.676 6.08239C114.494 6.08239 114.34 6.10322 114.213 6.14489C114.086 6.18655 113.99 6.24811 113.923 6.32955C113.859 6.41098 113.827 6.51136 113.827 6.63068C113.827 6.82576 113.902 6.97159 114.054 7.06818C114.205 7.16288 114.426 7.21023 114.716 7.21023H115.321V7.88636H114.702C114.241 7.88636 113.858 7.83902 113.551 7.74432C113.246 7.64962 113.017 7.50663 112.864 7.31534C112.71 7.12216 112.634 6.88068 112.634 6.59091C112.634 6.28598 112.714 6.02273 112.875 5.80114C113.036 5.57765 113.264 5.4053 113.56 5.28409C113.855 5.16288 114.205 5.10227 114.608 5.10227C114.814 5.10227 115.014 5.11932 115.207 5.15341C115.401 5.1875 115.589 5.23958 115.773 5.30966ZM114.727 7.54545H115.321V8.2017H114.75C114.477 8.2017 114.246 8.23769 114.057 8.30966C113.867 8.37973 113.723 8.48485 113.625 8.625C113.528 8.76326 113.48 8.93561 113.48 9.14205C113.48 9.38447 113.556 9.58049 113.707 9.73011C113.859 9.87973 114.103 9.99242 114.44 10.0682L114.903 10.1705C115.294 10.2576 115.575 10.3826 115.747 10.5455C115.921 10.7064 116.008 10.9015 116.006 11.1307C116.002 11.2898 115.958 11.4545 115.875 11.625C115.794 11.7955 115.682 11.9583 115.54 12.1136C115.4 12.2708 115.24 12.4129 115.06 12.5398L114.449 12.0881C114.578 11.9612 114.671 11.8419 114.73 11.7301C114.789 11.6203 114.818 11.5265 114.818 11.4489C114.818 11.358 114.782 11.2803 114.71 11.2159C114.64 11.1515 114.531 11.0994 114.384 11.0597L113.668 10.8182C113.177 10.6799 112.823 10.4905 112.605 10.25C112.389 10.0095 112.281 9.68371 112.281 9.27273C112.281 8.70076 112.488 8.26989 112.901 7.98011C113.313 7.69034 113.922 7.54545 114.727 7.54545ZM118.131 8.47727V11H116.92V6.63636H118.074V7.40625H118.125C118.223 7.15057 118.386 6.94886 118.614 6.80114C118.841 6.65341 119.116 6.57955 119.438 6.57955C119.742 6.57955 120.008 6.64583 120.233 6.77841C120.458 6.91098 120.633 7.09943 120.756 7.34375C120.881 7.58807 120.943 7.88068 120.943 8.22159V12.6364H119.733V8.4375C119.733 8.17045 119.665 7.96212 119.528 7.8125C119.392 7.66098 119.202 7.58523 118.957 7.58523C118.796 7.58523 118.653 7.62027 118.528 7.69034C118.403 7.76042 118.306 7.86269 118.236 7.99716C118.166 8.12973 118.131 8.28977 118.131 8.47727ZM127.49 6.63636V7.58239H123.536V6.63636H127.49ZM124.874 6.63636H126.047V9.67614C126.047 9.79167 126.062 9.88163 126.092 9.94602C126.125 10.0085 126.169 10.053 126.226 10.0795C126.283 10.1042 126.349 10.1165 126.425 10.1165C126.514 10.1165 126.586 10.1108 126.641 10.0994C126.696 10.0881 126.754 10.0748 126.817 10.0597L126.939 10.9545C126.818 11.0038 126.699 11.0369 126.584 11.054C126.47 11.071 126.338 11.0795 126.186 11.0795C125.771 11.0795 125.448 10.964 125.217 10.733C124.988 10.5 124.874 10.1458 124.874 9.67045V6.63636ZM130.205 11.0852C129.763 11.0852 129.382 10.9915 129.06 10.804C128.74 10.6146 128.492 10.3513 128.318 10.0142C128.144 9.67519 128.057 9.2822 128.057 8.83523C128.057 8.38447 128.144 7.99053 128.318 7.65341C128.492 7.31439 128.74 7.05114 129.06 6.86364C129.382 6.67424 129.763 6.57955 130.205 6.57955C130.646 6.57955 131.027 6.67424 131.347 6.86364C131.669 7.05114 131.917 7.31439 132.091 7.65341C132.265 7.99053 132.352 8.38447 132.352 8.83523C132.352 9.2822 132.265 9.67519 132.091 10.0142C131.917 10.3513 131.669 10.6146 131.347 10.804C131.027 10.9915 130.646 11.0852 130.205 11.0852ZM130.21 10.1477C130.411 10.1477 130.579 10.0909 130.713 9.97727C130.848 9.86174 130.949 9.70455 131.017 9.50568C131.087 9.30682 131.122 9.08049 131.122 8.8267C131.122 8.57292 131.087 8.34659 131.017 8.14773C130.949 7.94886 130.848 7.79167 130.713 7.67614C130.579 7.56061 130.411 7.50284 130.21 7.50284C130.008 7.50284 129.837 7.56061 129.699 7.67614C129.563 7.79167 129.459 7.94886 129.389 8.14773C129.321 8.34659 129.287 8.57292 129.287 8.8267C129.287 9.08049 129.321 9.30682 129.389 9.50568C129.459 9.70455 129.563 9.86174 129.699 9.97727C129.837 10.0909 130.008 10.1477 130.21 10.1477ZM133.139 6.63636H134.315V9.38636C134.315 9.57576 134.338 9.72443 134.384 9.83239C134.431 9.94034 134.493 10.017 134.571 10.0625C134.651 10.108 134.736 10.1307 134.827 10.1307C135.012 10.1307 135.171 10.0653 135.304 9.93466C135.438 9.80398 135.542 9.63636 135.614 9.43182C135.688 9.22538 135.724 9.00947 135.724 8.78409C135.719 8.55303 135.697 8.31345 135.659 8.06534C135.623 7.81534 135.575 7.56913 135.514 7.3267C135.455 7.08239 135.388 6.85227 135.312 6.63636H136.426C136.508 6.79545 136.582 6.98958 136.651 7.21875C136.721 7.44792 136.777 7.69697 136.818 7.96591C136.86 8.23485 136.881 8.50758 136.881 8.78409C136.881 9.10606 136.842 9.40625 136.764 9.68466C136.688 9.96307 136.569 10.2064 136.406 10.4148C136.243 10.6231 136.034 10.786 135.778 10.9034C135.525 11.0208 135.22 11.0795 134.864 11.0795C134.345 11.0795 133.927 10.9432 133.611 10.6705C133.296 10.3958 133.139 9.96402 133.139 9.375V6.63636Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function kf(e) {
  return /* @__PURE__ */ s.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ s.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M129.199 7.29529C129.867 7.29529 130.496 7.41795 131.084 7.66326C131.679 7.9085 132.188 8.24576 132.611 8.67495C133.04 9.09805 133.378 9.61006 133.623 10.211C133.874 10.8058 134 11.4404 134 12.1149C134 13.0163 133.789 13.8349 133.365 14.5707C132.948 15.3066 132.372 15.8829 131.636 16.2999C130.906 16.7107 130.094 16.9161 129.199 16.9161C127.831 16.9161 126.688 16.4593 125.768 15.5456C124.848 14.6321 124.388 13.4884 124.388 12.1149C124.388 10.7414 124.848 9.59477 125.768 8.67495C126.688 7.7552 127.831 7.29529 129.199 7.29529ZM129.199 9.83385C128.567 9.83385 128.04 10.0516 127.617 10.4869C127.2 10.9162 126.991 11.4588 126.991 12.1149C126.991 12.7526 127.2 13.2892 127.617 13.7245C128.04 14.1599 128.567 14.3775 129.199 14.3775C129.818 14.3775 130.339 14.1599 130.762 13.7245C131.185 13.2892 131.397 12.7526 131.397 12.1149C131.397 11.4588 131.185 10.9162 130.762 10.4869C130.345 10.0516 129.824 9.83385 129.199 9.83385Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M120.423 3.47828C120.742 3.15943 121.123 3 121.565 3C122.006 3 122.386 3.15943 122.705 3.47828C123.024 3.79101 123.183 4.16505 123.183 4.60041C123.183 5.04189 123.024 5.42207 122.705 5.74093C122.386 6.05978 122.006 6.2192 121.565 6.2192C121.123 6.2192 120.742 6.05978 120.423 5.74093C120.105 5.42207 119.945 5.04189 119.945 4.60041C119.945 4.16505 120.105 3.79101 120.423 3.47828ZM120.239 7.47925H122.898V16.7322H120.239V7.47925Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M116.607 16.9161C116.129 16.9161 115.721 16.7537 115.383 16.4287C115.052 16.0976 114.887 15.6959 114.887 15.2238C114.887 14.7578 115.052 14.3623 115.383 14.0372C115.721 13.7122 116.129 13.5498 116.607 13.5498C117.091 13.5498 117.499 13.7122 117.83 14.0372C118.167 14.3561 118.336 14.7516 118.336 15.2238C118.336 15.6959 118.167 16.0976 117.83 16.4287C117.499 16.7537 117.091 16.9161 116.607 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M113.571 11.701C113.571 12.0751 113.547 12.4215 113.498 12.7404H106.848C106.97 13.3658 107.238 13.8441 107.648 14.1752C108.059 14.5002 108.583 14.6627 109.221 14.6627C109.638 14.6627 110.036 14.5738 110.417 14.3959C110.803 14.2181 111.076 13.9912 111.235 13.7153L113.305 14.9846C112.968 15.5978 112.434 16.073 111.704 16.4103C110.975 16.7475 110.128 16.9161 109.166 16.9161C107.804 16.9161 106.652 16.4501 105.707 15.5181C104.769 14.5799 104.3 13.4271 104.3 12.0597C104.3 10.7169 104.763 9.58861 105.689 8.67495C106.621 7.7552 107.761 7.29529 109.11 7.29529C110.362 7.29529 111.416 7.72151 112.274 8.57381C113.139 9.42611 113.571 10.4685 113.571 11.701ZM106.885 11.048H110.913C110.858 10.5881 110.643 10.2049 110.27 9.89826C109.895 9.59165 109.463 9.43842 108.973 9.43842C108.421 9.43842 107.967 9.57941 107.611 9.86146C107.256 10.1436 107.014 10.5391 106.885 11.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M99.0479 7.29529C100.164 7.29529 101.071 7.63254 101.771 8.30705C102.476 8.98156 102.828 9.87377 102.828 10.9836V16.7322H100.152V11.609C100.152 11.0633 100.008 10.631 99.7195 10.3122C99.4312 9.99332 99.0479 9.83385 98.5698 9.83385C98.0981 9.83385 97.6989 9.99027 97.3743 10.303C97.0556 10.6096 96.8962 11.0449 96.8962 11.609V16.7322H94.238V11.609C94.238 11.0633 94.0938 10.631 93.8055 10.3122C93.5171 9.99332 93.1281 9.83385 92.6376 9.83385C92.1717 9.83385 91.782 9.98716 91.4697 10.2938C91.1567 10.6004 91.0002 11.0388 91.0002 11.609V16.7322H88.342V7.47924H91.0002V8.59221C91.595 7.7276 92.4753 7.29529 93.6403 7.29529C94.8603 7.29529 95.7341 7.746 96.2615 8.64742C96.5375 8.24271 96.9266 7.9177 97.4294 7.67246C97.9322 7.42099 98.472 7.29529 99.0479 7.29529Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M86.8614 11.701C86.8614 12.0751 86.8368 12.4215 86.7878 12.7404H80.1379C80.2605 13.3658 80.5272 13.8441 80.9381 14.1752C81.3488 14.5002 81.8732 14.6627 82.5109 14.6627C82.9278 14.6627 83.3264 14.5738 83.7066 14.3959C84.0929 14.2181 84.3657 13.9912 84.5251 13.7153L86.5946 14.9846C86.2574 15.5978 85.7239 16.073 84.9942 16.4103C84.2645 16.7475 83.4184 16.9161 82.4557 16.9161C81.0944 16.9161 79.9416 16.4501 78.9974 15.5181C78.0591 14.5799 77.5901 13.4271 77.5901 12.0597C77.5901 10.7169 78.053 9.58861 78.9789 8.67495C79.9109 7.7552 81.0515 7.29529 82.4005 7.29529C83.6514 7.29529 84.706 7.72151 85.5645 8.57381C86.4291 9.42611 86.8614 10.4685 86.8614 11.701ZM80.1747 11.048H84.2032C84.148 10.5881 83.9334 10.2049 83.5594 9.89826C83.1854 9.59165 82.7531 9.43842 82.2625 9.43842C81.7107 9.43842 81.2569 9.57941 80.9013 9.86146C80.5456 10.1436 80.3034 10.5391 80.1747 11.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M76.7807 14.2673L76.9187 16.6219C76.563 16.7936 76.1092 16.8794 75.5574 16.8794C74.4537 16.8794 73.5615 16.5483 72.8809 15.8861C72.2064 15.2177 71.8691 14.2949 71.8691 13.1176V10.0087H70.1492V7.47931H71.8691V5.05115H74.5272V7.47931H76.7991V10.0087H74.5272V12.9795C74.5272 13.4027 74.6652 13.7461 74.9411 14.0097C75.2171 14.2673 75.5544 14.396 75.9529 14.396C76.2595 14.396 76.5355 14.3531 76.7807 14.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M66.0285 16.9161C64.3484 16.9161 62.9657 16.5298 61.8804 15.7572L62.6714 13.9085C63.5421 14.5584 64.5845 14.8835 65.7986 14.8835C66.2094 14.8835 66.5374 14.8129 66.7827 14.6719C67.0341 14.5308 67.1598 14.3499 67.1598 14.1293C67.1598 13.9391 67.0648 13.7828 66.8747 13.6601C66.6907 13.5314 66.4517 13.4302 66.1573 13.3566C65.863 13.283 65.538 13.2094 65.1823 13.1359C64.8267 13.0561 64.471 12.955 64.1154 12.8323C63.7598 12.7036 63.4348 12.5472 63.1404 12.3633C62.8461 12.1732 62.6039 11.9095 62.4138 11.5723C62.2299 11.2289 62.1348 10.8272 62.1287 10.3674C62.1164 9.49667 62.4598 8.76696 63.1588 8.17831C63.8579 7.58965 64.75 7.29529 65.8354 7.29529C67.3009 7.29529 68.4751 7.6479 69.3581 8.35305L68.6039 10.2754C68.2359 9.99947 67.7853 9.76952 67.2519 9.58557C66.7245 9.40162 66.2155 9.30961 65.725 9.30961C65.3877 9.30961 65.1149 9.3801 64.9064 9.52116C64.6979 9.66222 64.5937 9.83697 64.5937 10.0454C64.5937 10.2049 64.6673 10.3459 64.8144 10.4685C64.9616 10.585 65.1517 10.6801 65.3847 10.7537C65.6238 10.8272 65.8936 10.91 66.1941 11.002C66.5007 11.0878 66.8104 11.1737 67.123 11.2595C67.4358 11.3454 67.7423 11.465 68.0428 11.6182C68.3494 11.7715 68.6223 11.9463 68.8614 12.1425C69.1006 12.3326 69.2937 12.584 69.4408 12.8967C69.5942 13.2094 69.6738 13.5651 69.68 13.9636C69.68 14.8221 69.3367 15.5304 68.6498 16.0884C67.9693 16.6402 67.0954 16.9161 66.0285 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M59.112 7.47925H61.9724L56.831 19.8043H53.9888L55.6996 15.978L52.1401 7.47925H55.0098L57.0608 12.8875L59.112 7.47925Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M48.1482 16.9161C46.4681 16.9161 45.0853 16.5298 44 15.7572L44.791 13.9085C45.6617 14.5584 46.7041 14.8835 47.9182 14.8835C48.3291 14.8835 48.6571 14.8129 48.9024 14.6719C49.1538 14.5308 49.2795 14.3499 49.2795 14.1293C49.2795 13.9391 49.1844 13.7828 48.9944 13.6601C48.8104 13.5314 48.5713 13.4302 48.2769 13.3566C47.9826 13.283 47.6576 13.2094 47.302 13.1359C46.9463 13.0561 46.5907 12.955 46.2351 12.8323C45.8794 12.7036 45.5544 12.5472 45.2601 12.3633C44.9658 12.1732 44.7236 11.9095 44.5334 11.5723C44.3495 11.2289 44.2544 10.8272 44.2484 10.3674C44.236 9.49667 44.5795 8.76696 45.2784 8.17831C45.9775 7.58965 46.8697 7.29529 47.955 7.29529C49.4205 7.29529 50.5947 7.6479 51.4777 8.35305L50.7235 10.2754C50.3556 9.99947 49.9049 9.76952 49.3715 9.58557C48.8441 9.40162 48.3352 9.30961 47.8446 9.30961C47.5074 9.30961 47.2345 9.3801 47.0261 9.52116C46.8176 9.66222 46.7133 9.83697 46.7133 10.0454C46.7133 10.2049 46.7869 10.3459 46.9341 10.4685C47.0812 10.585 47.2713 10.6801 47.5043 10.7537C47.7435 10.8272 48.0133 10.91 48.3137 11.002C48.6203 11.0878 48.93 11.1737 49.2427 11.2595C49.5554 11.3454 49.862 11.465 50.1625 11.6182C50.469 11.7715 50.7419 11.9463 50.981 12.1425C51.2202 12.3326 51.4133 12.584 51.5605 12.8967C51.7138 13.2094 51.7936 13.5651 51.7996 13.9636C51.7996 14.8221 51.4563 15.5304 50.7696 16.0884C50.0889 16.6402 49.2151 16.9161 48.1482 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "mask",
          {
            id: "mask0_2008_5572",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ s.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2008_5572)", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7639 20.3424 22.555 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9608 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.85 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M44.1957 22.0909H45.8319L47.4073 25.0664H47.4748L49.0502 22.0909H50.6864L48.1664 26.5575V29H46.7157V26.5575L44.1957 22.0909ZM51.933 29.0978C51.6024 29.0978 51.3077 29.0405 51.0491 28.9258C50.7905 28.8088 50.5858 28.6368 50.4351 28.4096C50.2867 28.1802 50.2124 27.8946 50.2124 27.5527C50.2124 27.2649 50.2653 27.0231 50.371 26.8274C50.4767 26.6317 50.6206 26.4743 50.8028 26.3551C50.985 26.2359 51.1919 26.146 51.4236 26.0852C51.6575 26.0245 51.9026 25.9818 52.159 25.957C52.4604 25.9255 52.7033 25.8963 52.8877 25.8693C53.0721 25.8401 53.2059 25.7973 53.2892 25.7411C53.3724 25.6849 53.414 25.6017 53.414 25.4915V25.4712C53.414 25.2576 53.3465 25.0923 53.2116 24.9753C53.0789 24.8584 52.8899 24.7999 52.6448 24.7999C52.3862 24.7999 52.1804 24.8572 52.0274 24.9719C51.8745 25.0844 51.7733 25.2261 51.7238 25.397L50.3946 25.2891C50.4621 24.9742 50.5948 24.7021 50.7927 24.4727C50.9906 24.241 51.2459 24.0633 51.5585 23.9396C51.8734 23.8137 52.2377 23.7507 52.6515 23.7507C52.9394 23.7507 53.2149 23.7844 53.4781 23.8519C53.7435 23.9194 53.9785 24.024 54.1832 24.1657C54.3901 24.3074 54.5531 24.4895 54.6723 24.7122C54.7915 24.9326 54.8511 25.1969 54.8511 25.505V29H53.4882V28.2814H53.4477C53.3645 28.4434 53.2532 28.5862 53.1137 28.7099C52.9743 28.8313 52.8067 28.9269 52.6111 28.9966C52.4154 29.0641 52.1894 29.0978 51.933 29.0978ZM52.3445 28.106C52.556 28.106 52.7426 28.0644 52.9046 27.9812C53.0665 27.8957 53.1936 27.781 53.2858 27.6371C53.378 27.4931 53.4241 27.3301 53.4241 27.1479V26.598C53.3791 26.6272 53.3173 26.6542 53.2385 26.679C53.1621 26.7015 53.0755 26.7228 52.9788 26.7431C52.8821 26.7611 52.7854 26.7779 52.6887 26.7937C52.5919 26.8072 52.5042 26.8195 52.4255 26.8308C52.2568 26.8555 52.1095 26.8949 51.9836 26.9489C51.8576 27.0028 51.7598 27.0759 51.6901 27.1681C51.6204 27.2581 51.5855 27.3706 51.5855 27.5055C51.5855 27.7012 51.6563 27.8507 51.798 27.9542C51.942 28.0554 52.1241 28.106 52.3445 28.106ZM55.9661 30.9432V23.8182H57.383V24.6886H57.4471C57.5101 24.5491 57.6011 24.4074 57.7203 24.2635C57.8418 24.1173 57.9992 23.9959 58.1926 23.8991C58.3883 23.8002 58.6312 23.7507 58.9213 23.7507C59.2992 23.7507 59.6478 23.8497 59.9672 24.0476C60.2865 24.2433 60.5418 24.539 60.733 24.9348C60.9241 25.3284 61.0197 25.8221 61.0197 26.4158C61.0197 26.9938 60.9264 27.4819 60.7397 27.88C60.5553 28.2758 60.3034 28.5761 59.984 28.7807C59.6669 28.9831 59.3116 29.0843 58.918 29.0843C58.6391 29.0843 58.4018 29.0382 58.2061 28.946C58.0127 28.8538 57.8542 28.738 57.7305 28.5985C57.6068 28.4569 57.5123 28.314 57.4471 28.1701H57.4032V30.9432H55.9661ZM57.3729 26.4091C57.3729 26.7172 57.4156 26.986 57.5011 27.2154C57.5865 27.4448 57.7102 27.6236 57.8722 27.7518C58.0341 27.8777 58.2309 27.9407 58.4625 27.9407C58.6964 27.9407 58.8944 27.8766 59.0563 27.7484C59.2182 27.618 59.3408 27.438 59.424 27.2086C59.5095 26.977 59.5522 26.7105 59.5522 26.4091C59.5522 26.11 59.5106 25.8468 59.4274 25.6197C59.3442 25.3925 59.2216 25.2148 59.0597 25.0866C58.8977 24.9585 58.6987 24.8944 58.4625 24.8944C58.2286 24.8944 58.0307 24.9562 57.8688 25.0799C57.7091 25.2036 57.5865 25.379 57.5011 25.6062C57.4156 25.8333 57.3729 26.101 57.3729 26.4091ZM61.9778 29V23.8182H63.415V29H61.9778ZM64.5662 29V23.8182H65.9359V24.7324H65.9966C66.1045 24.4288 66.2845 24.1893 66.5364 24.0138C66.7882 23.8384 67.0896 23.7507 67.4405 23.7507C67.7958 23.7507 68.0983 23.8395 68.348 24.0172C68.5976 24.1926 68.764 24.431 68.8473 24.7324H68.9012C69.0069 24.4355 69.1981 24.1983 69.4747 24.0206C69.7536 23.8407 70.0831 23.7507 70.4632 23.7507C70.9467 23.7507 71.3392 23.9048 71.6406 24.2129C71.9442 24.5188 72.096 24.9528 72.096 25.5151V29H70.6622V25.7985C70.6622 25.5106 70.5858 25.2947 70.4328 25.1507C70.2799 25.0068 70.0887 24.9348 69.8593 24.9348C69.5984 24.9348 69.3949 25.0181 69.2487 25.1845C69.1025 25.3487 69.0294 25.5657 69.0294 25.8356V29H67.6361V25.7681C67.6361 25.514 67.563 25.3116 67.4169 25.1609C67.2729 25.0102 67.0829 24.9348 66.8467 24.9348C66.687 24.9348 66.5431 24.9753 66.4149 25.0563C66.289 25.135 66.1889 25.2463 66.1147 25.3903C66.0404 25.532 66.0033 25.6984 66.0033 25.8896V29H64.5662ZM73.2312 29V23.8182H74.6684V29H73.2312Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const X5 = ({
  description: e,
  descriptionClassName: t,
  error: r,
  errorClassName: n,
  className: a
}) => {
  const i = r ? /* @__PURE__ */ s.jsx(
    "p",
    {
      className: K("text-danger [&>a]:text-brand-primary text-sm", n),
      ...typeof r == "string" ? {
        dangerouslySetInnerHTML: { __html: r }
      } : {
        children: r
      }
    }
  ) : null;
  return r || e ? /* @__PURE__ */ s.jsxs("div", { className: a, children: [
    e ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: K("[&>a]:text-brand-primary text-sm opacity-70", t),
        children: e
      }
    ) : null,
    i
  ] }) : null;
}, OH = ({
  inputRef: e,
  error: t,
  description: r,
  value: n,
  onChange: a,
  label: i,
  disabled: o,
  isFetching: l,
  labelClassName: c,
  className: u,
  errorClassName: d,
  descriptionClassName: C,
  checkboxIconClassName: p,
  inputClassName: h,
  inputWrapperClassName: f
}) => /* @__PURE__ */ s.jsxs(
  "label",
  {
    className: K(
      "group flex w-fit items-center gap-3",
      o ? "cursor-default" : "cursor-pointer",
      u
    ),
    "aria-checked": n,
    children: [
      /* @__PURE__ */ s.jsxs("div", { className: K("relative flex items-center justify-center", f), children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            ref: e,
            disabled: o,
            checked: n,
            className: K(
              "peer/checkbox main-transition-colors",
              o ? "bg-skeleton-primary/40 border-darkgray/20 checked:bg-text-primary/60 checked:border-text-primary/75 cursor-default" : "border-darkgray bg-background-secondary checked:border-text-primary checked:bg-text-primary",
              l && "animate-pulse",
              "focus-ring h-[20px] w-[20px] cursor-pointer appearance-none rounded-md border",
              h
            ),
            type: "checkbox",
            onChange: (g) => a(g.target.checked)
          }
        ),
        /* @__PURE__ */ s.jsx(
          Dh,
          {
            className: K(
              "absolute",
              o ? n ? "fill-background-secondary/70 opacity-100" : "opacity-0" : "fill-background-secondary opacity-100",
              p
            )
          }
        )
      ] }),
      i && /* @__PURE__ */ s.jsx(
        "span",
        {
          className: K(
            "main-transition-colors",
            n ? "text-text-primary" : "text-text-primary/50",
            "leading-5",
            c,
            "text-left"
          ),
          children: i
        }
      ),
      /* @__PURE__ */ s.jsx(
        X5,
        {
          description: r,
          error: t,
          errorClassName: d,
          descriptionClassName: C
        }
      )
    ]
  }
);
function M6({
  wrapperAs: e = "div",
  wrapperProps: t = { className: "flex justify-between gap-2" },
  label: r,
  required: n,
  labelClassName: a,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return r || n || i ? /* @__PURE__ */ s.jsxs(e, { ...t, children: [
    (r || n) && /* @__PURE__ */ s.jsxs("span", { className: K("flex", a), children: [
      r,
      " ",
      n && /* @__PURE__ */ s.jsx("i", { className: K("text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
function wr() {
  const [e, t] = x.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function r() {
    t({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return x.useEffect(() => (t({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", r), () => {
    window.removeEventListener("resize", r);
  }), []), e;
}
const _r = ({ hoverOpenDelay: e = 100 } = {}) => {
  const [t, r] = e1(!1), n = J(null), a = () => {
    n.current !== null && (clearTimeout(n.current), n.current = null);
  }, i = () => {
    a(), r(!0);
  }, o = () => {
    a(), n.current = setTimeout(() => {
      r(!0);
    }, e);
  }, l = () => {
    a(), r(!1);
  }, c = () => {
    a(), n.current = setTimeout(() => {
      r(!1);
    }, 100);
  };
  return h1(() => () => a(), []), { show: t, open: i, close: l, delayClose: c, delayOpen: o };
}, Mr = (e) => {
  var t;
  return e.hasChildNodes() ? ((t = e.childNodes[0]) == null ? void 0 : t.nodeType) === 3 ? e : Mr(e.childNodes[0]) : e;
}, Lf = (e, t) => {
  const [r, n] = Y.useState(void 0), { width: a } = wr();
  return Y.useLayoutEffect(() => {
    const { current: i } = e;
    i && (() => {
      const l = Mr(i);
      if (!l)
        return;
      const c = l.scrollWidth > i.clientWidth;
      n(c), t && t(c);
    })();
  }, [t, e, a]), r;
}, Sr = n9(function(e, t) {
  return /* @__PURE__ */ s.jsx(
    "button",
    {
      ref: t,
      ...e,
      onClick: (r) => {
        var n;
        r.preventDefault = () => {
        }, (n = e.onClick) == null || n.call(e, r);
      }
    }
  );
}), Hf = n9(function(e, t) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: t,
      ...e,
      onClick: (r) => {
        var n;
        r.preventDefault = () => {
        }, r.stopPropagation = () => {
        }, (n = e.onClick) == null || n.call(e, r);
      }
    }
  );
}), Te = ({
  mode: e = "hover",
  popoverButtonRef: t,
  label: r,
  position: n = "top",
  anchor: a,
  className: i,
  wrapperClassName: o,
  popoverClassName: l,
  labelClassName: c,
  disabled: u,
  stayOnHover: d,
  children: C,
  hoverOpenDelay: p
}) => {
  const h = J(), f = J(null), g = Lf(h), { width: m } = wr(), { show: v, delayOpen: b, delayClose: w } = _r({ hoverOpenDelay: p });
  return /* @__PURE__ */ s.jsx(ye, { className: K("flex items-center", o), children: ({ open: M }) => {
    const y = u ? !1 : e === "click" || m < 1024 ? M : e === "hover" || e === "overflow" && g ? v : !1;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        i3,
        {
          ref: (_) => {
            h && (h.current = _), t && (t.current = _);
          },
          as: e === "click" ? Sr : Hf,
          className: K(
            "relative truncate outline-hidden",
            e === "click" && !u && "cursor-pointer",
            "h-full w-full max-w-fit",
            i
          ),
          disabled: u,
          onMouseEnter: b,
          onMouseLeave: w,
          children: typeof C == "function" ? C(y) : C
        }
      ),
      /* @__PURE__ */ s.jsx(
        U5,
        {
          as: q1,
          show: y,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ s.jsx(
            o3,
            {
              ref: f,
              anchor: a ?? n.replace("-", " "),
              className: K(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                l
              ),
              onMouseEnter: d ? b : void 0,
              onMouseLeave: d ? w : void 0,
              children: /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    c
                  ),
                  children: r
                }
              )
            }
          )
        }
      )
    ] });
  } });
}, BH = (e) => /* @__PURE__ */ s.jsx(Te, { ...e, mode: "click" }), ZH = ({
  selected: e,
  onChange: t,
  label: r,
  labelClassName: n,
  wrapperClassName: a,
  switcherClassName: i,
  disabled: o
}) => /* @__PURE__ */ s.jsxs("div", { className: K("relative flex flex-col gap-2 md:flex-row", a), children: [
  /* @__PURE__ */ s.jsx(
    sr,
    {
      checked: e,
      onChange: t,
      disabled: o,
      className: K(
        "main-transition-colors focus-ring relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
        e && !o ? "bg-brand-primary" : "bg-fill-primary",
        i
      ),
      children: /* @__PURE__ */ s.jsx(
        "span",
        {
          "aria-hidden": "true",
          className: K(
            "bg-background-secondary pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-lg ring-0 transition-transform duration-200 ease-linear",
            e ? "translate-x-5" : "translate-x-0"
          )
        }
      )
    }
  ),
  r && /* @__PURE__ */ s.jsx("div", { className: K(n), children: r })
] });
function e6() {
  return (e6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
function _8(e, t) {
  if (e == null)
    return {};
  var r, n, a = {}, i = Object.keys(e);
  for (n = 0; n < i.length; n++)
    t.indexOf(r = i[n]) >= 0 || (a[r] = e[r]);
  return a;
}
function Y9(e) {
  var t = J(e), r = J(function(n) {
    t.current && t.current(n);
  });
  return t.current = e, r.current;
}
var Y6 = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 1), e > r ? r : e < t ? t : e;
}, A9 = function(e) {
  return "touches" in e;
}, f4 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, q0 = function(e, t, r) {
  var n = e.getBoundingClientRect(), a = A9(t) ? function(i, o) {
    for (var l = 0; l < i.length; l++)
      if (i[l].identifier === o)
        return i[l];
    return i[0];
  }(t.touches, r) : t;
  return { left: Y6((a.pageX - (n.left + f4(e).pageXOffset)) / n.width), top: Y6((a.pageY - (n.top + f4(e).pageYOffset)) / n.height) };
}, Q0 = function(e) {
  !A9(e) && e.preventDefault();
}, je = x.memo(function(e) {
  var t = e.onMove, r = e.onKey, n = _8(e, ["onMove", "onKey"]), a = J(null), i = Y9(t), o = Y9(r), l = J(null), c = J(!1), u = Q(function() {
    var h = function(m) {
      Q0(m), (A9(m) ? m.touches.length > 0 : m.buttons > 0) && a.current ? i(q0(a.current, m, l.current)) : g(!1);
    }, f = function() {
      return g(!1);
    };
    function g(m) {
      var v = c.current, b = f4(a.current), w = m ? b.addEventListener : b.removeEventListener;
      w(v ? "touchmove" : "mousemove", h), w(v ? "touchend" : "mouseup", f);
    }
    return [function(m) {
      var v = m.nativeEvent, b = a.current;
      if (b && (Q0(v), !function(M, y) {
        return y && !A9(M);
      }(v, c.current) && b)) {
        if (A9(v)) {
          c.current = !0;
          var w = v.changedTouches || [];
          w.length && (l.current = w[0].identifier);
        }
        b.focus(), i(q0(b, v, l.current)), g(!0);
      }
    }, function(m) {
      var v = m.which || m.keyCode;
      v < 37 || v > 40 || (m.preventDefault(), o({ left: v === 39 ? 0.05 : v === 37 ? -0.05 : 0, top: v === 40 ? 0.05 : v === 38 ? -0.05 : 0 }));
    }, g];
  }, [o, i]), d = u[0], C = u[1], p = u[2];
  return h1(function() {
    return p;
  }, [p]), x.createElement("div", e6({}, n, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: a, onKeyDown: C, tabIndex: 0, role: "slider" }));
}), M8 = function(e) {
  return e.filter(Boolean).join(" ");
}, Ve = function(e) {
  var t = e.color, r = e.left, n = e.top, a = n === void 0 ? 0.5 : n, i = M8(["react-colorful__pointer", e.className]);
  return x.createElement("div", { className: i, style: { top: 100 * a + "%", left: 100 * r + "%" } }, x.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, p2 = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = Math.pow(10, t)), Math.round(r * e) / r;
}, kr = function(e) {
  return jf(m4(e));
}, m4 = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? p2(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? p2(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, Lr = function(e) {
  return Tf(Pf(e));
}, Hr = function(e) {
  var t = e.s, r = e.v, n = e.a, a = (200 - t) * r / 100;
  return { h: p2(e.h), s: p2(a > 0 && a < 200 ? t * r / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: p2(a / 2), a: p2(n, 2) };
}, g4 = function(e) {
  var t = Hr(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, R3 = function(e) {
  var t = Hr(e);
  return "hsla(" + t.h + ", " + t.s + "%, " + t.l + "%, " + t.a + ")";
}, Pf = function(e) {
  var t = e.h, r = e.s, n = e.v, a = e.a;
  t = t / 360 * 6, r /= 100, n /= 100;
  var i = Math.floor(t), o = n * (1 - r), l = n * (1 - (t - i) * r), c = n * (1 - (1 - t + i) * r), u = i % 6;
  return { r: p2(255 * [n, l, o, o, c, n][u]), g: p2(255 * [c, n, n, l, o, o][u]), b: p2(255 * [o, o, c, n, n, l][u]), a: p2(a, 2) };
}, A8 = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Tf = function(e) {
  var t = e.r, r = e.g, n = e.b, a = e.a, i = a < 1 ? A8(p2(255 * a)) : "";
  return "#" + A8(t) + A8(r) + A8(n) + i;
}, jf = function(e) {
  var t = e.r, r = e.g, n = e.b, a = e.a, i = Math.max(t, r, n), o = i - Math.min(t, r, n), l = o ? i === t ? (r - n) / o : i === r ? 2 + (n - t) / o : 4 + (t - r) / o : 0;
  return { h: p2(60 * (l < 0 ? l + 6 : l)), s: p2(i ? o / i * 100 : 0), v: p2(i / 255 * 100), a };
}, Pr = x.memo(function(e) {
  var t = e.hue, r = e.onChange, n = M8(["react-colorful__hue", e.className]);
  return x.createElement("div", { className: n }, x.createElement(je, { onMove: function(a) {
    r({ h: 360 * a.left });
  }, onKey: function(a) {
    r({ h: Y6(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": p2(t), "aria-valuemax": "360", "aria-valuemin": "0" }, x.createElement(Ve, { className: "react-colorful__hue-pointer", left: t / 360, color: g4({ h: t, s: 100, v: 100, a: 1 }) })));
}), Tr = x.memo(function(e) {
  var t = e.hsva, r = e.onChange, n = { backgroundColor: g4({ h: t.h, s: 100, v: 100, a: 1 }) };
  return x.createElement("div", { className: "react-colorful__saturation", style: n }, x.createElement(je, { onMove: function(a) {
    r({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    r({ s: Y6(t.s + 100 * a.left, 0, 100), v: Y6(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + p2(t.s) + "%, Brightness " + p2(t.v) + "%" }, x.createElement(Ve, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: g4(t) })));
}), jr = function(e, t) {
  if (e === t)
    return !0;
  for (var r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}, Vr = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || jr(m4(e), m4(t));
};
function Ar(e, t, r) {
  var n = Y9(r), a = e1(function() {
    return e.toHsva(t);
  }), i = a[0], o = a[1], l = J({ color: t, hsva: i });
  h1(function() {
    if (!e.equal(t, l.current.color)) {
      var u = e.toHsva(t);
      l.current = { hsva: u, color: t }, o(u);
    }
  }, [t, e]), h1(function() {
    var u;
    jr(i, l.current.hsva) || e.equal(u = e.fromHsva(i), l.current.color) || (l.current = { hsva: i, color: u }, n(u));
  }, [i, e, n]);
  var c = y1(function(u) {
    o(function(d) {
      return Object.assign({}, d, u);
    });
  }, []);
  return [i, c];
}
var Vf = typeof window < "u" ? a8 : h1, Af = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, X0 = /* @__PURE__ */ new Map(), Er = function(e) {
  Vf(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !X0.has(t)) {
      var r = t.createElement("style");
      r.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, X0.set(t, r);
      var n = Af();
      n && r.setAttribute("nonce", n), t.head.appendChild(r);
    }
  }, []);
}, Ef = function(e) {
  var t = e.className, r = e.colorModel, n = e.color, a = n === void 0 ? r.defaultColor : n, i = e.onChange, o = _8(e, ["className", "colorModel", "color", "onChange"]), l = J(null);
  Er(l);
  var c = Ar(r, a, i), u = c[0], d = c[1], C = M8(["react-colorful", t]);
  return x.createElement("div", e6({}, o, { ref: l, className: C }), x.createElement(Tr, { hsva: u, onChange: d }), x.createElement(Pr, { hue: u.h, onChange: d, className: "react-colorful__last-control" }));
}, If = { defaultColor: "000", toHsva: kr, fromHsva: function(e) {
  return Lr({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: Vr }, Df = function(e) {
  return x.createElement(Ef, e6({}, e, { colorModel: If }));
}, Nf = function(e) {
  var t = e.className, r = e.hsva, n = e.onChange, a = { backgroundImage: "linear-gradient(90deg, " + R3(Object.assign({}, r, { a: 0 })) + ", " + R3(Object.assign({}, r, { a: 1 })) + ")" }, i = M8(["react-colorful__alpha", t]), o = p2(100 * r.a);
  return x.createElement("div", { className: i }, x.createElement("div", { className: "react-colorful__alpha-gradient", style: a }), x.createElement(je, { onMove: function(l) {
    n({ a: l.left });
  }, onKey: function(l) {
    n({ a: Y6(r.a + l.left) });
  }, "aria-label": "Alpha", "aria-valuetext": o + "%", "aria-valuenow": o, "aria-valuemin": "0", "aria-valuemax": "100" }, x.createElement(Ve, { className: "react-colorful__alpha-pointer", left: r.a, color: R3(r) })));
}, Rf = function(e) {
  var t = e.className, r = e.colorModel, n = e.color, a = n === void 0 ? r.defaultColor : n, i = e.onChange, o = _8(e, ["className", "colorModel", "color", "onChange"]), l = J(null);
  Er(l);
  var c = Ar(r, a, i), u = c[0], d = c[1], C = M8(["react-colorful", t]);
  return x.createElement("div", e6({}, o, { ref: l, className: C }), x.createElement(Tr, { hsva: u, onChange: d }), x.createElement(Pr, { hue: u.h, onChange: d }), x.createElement(Nf, { hsva: u, onChange: d, className: "react-colorful__last-control" }));
}, Ff = { defaultColor: "0001", toHsva: kr, fromHsva: Lr, equal: Vr }, Of = function(e) {
  return x.createElement(Rf, e6({}, e, { colorModel: Ff }));
}, Bf = /^#?([0-9A-F]{3,8})$/i, Zf = function(e) {
  var t = e.color, r = t === void 0 ? "" : t, n = e.onChange, a = e.onBlur, i = e.escape, o = e.validate, l = e.format, c = e.process, u = _8(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), d = e1(function() {
    return i(r);
  }), C = d[0], p = d[1], h = Y9(n), f = Y9(a), g = y1(function(v) {
    var b = i(v.target.value);
    p(b), o(b) && h(c ? c(b) : b);
  }, [i, c, o, h]), m = y1(function(v) {
    o(v.target.value) || p(i(r)), f(v);
  }, [r, i, o, f]);
  return h1(function() {
    p(i(r));
  }, [r, i]), x.createElement("input", e6({}, u, { value: l ? l(C) : C, spellCheck: "false", onChange: g, onBlur: m }));
}, et = function(e) {
  return "#" + e;
}, Gf = function(e) {
  var t = e.prefixed, r = e.alpha, n = _8(e, ["prefixed", "alpha"]), a = y1(function(o) {
    return o.replace(/([^0-9A-F]+)/gi, "").substring(0, r ? 8 : 6);
  }, [r]), i = y1(function(o) {
    return function(l, c) {
      var u = Bf.exec(l), d = u ? u[1].length : 0;
      return d === 3 || d === 6 || !!c && d === 4 || !!c && d === 8;
    }(o, r);
  }, [r]);
  return x.createElement(Zf, e6({}, n, { escape: a, format: t ? et : void 0, process: et, validate: i }));
};
const GH = ({
  color: e,
  labelClassName: t,
  popoverClassName: r,
  popoverButtonClassName: n,
  popoverButtonChildClassName: a,
  hexColorInput: i,
  wrapperClassName: o,
  children: l,
  additionalPopoverChildren: c,
  focusTrapFeatures: u = L5.None,
  stayWhenUnfocused: d = !1,
  showAlpha: C = !0,
  showOnlyHue: p = !1,
  pickerRef: h,
  error: f,
  description: g,
  anchor: m = "top",
  disabled: v,
  ...b
}) => {
  const [w, M] = e1(!1), y = J(null);
  h1(() => {
    const S = (P) => {
      var A;
      (A = y.current) != null && A.contains(P.target) && M(!0);
    }, j = (P) => {
      y.current && !y.current.contains(P.target) && M(!1);
    }, V = (P) => {
      P.key === "Escape" && M(!1);
    };
    return document.addEventListener("focusin", S), document.addEventListener("touchstart", j, !0), document.addEventListener("mousedown", j, !0), document.addEventListener("keydown", V), () => {
      document.removeEventListener("focusin", S), document.removeEventListener("touchstart", j, !0), document.removeEventListener("mousedown", j, !0), document.removeEventListener("keydown", V);
    };
  }, []), h && (h.current = {
    allowToHideWhenUnfocused: (S) => {
      M(!S);
    }
  });
  const _ = C && !p ? Of : Df;
  return /* @__PURE__ */ s.jsx(ye, { className: "flex items-center", children: ({ open: S, close: j }) => {
    const V = d && w || S;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        i3,
        {
          disabled: v,
          as: Sr,
          className: K(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            f && "border-danger rounded-xl border-2 p-0.5",
            n
          ),
          children: (l == null ? void 0 : l(V)) ?? /* @__PURE__ */ s.jsx(
            "div",
            {
              style: { backgroundColor: e },
              className: K(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                a
              )
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        U5,
        {
          as: q1,
          show: V,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ s.jsx(
            o3,
            {
              ref: y,
              anchor: m,
              className: K(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                p ? "pt-4" : "pt-5",
                r
              ),
              children: /* @__PURE__ */ s.jsx(oe, { features: u, children: /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    t
                  ),
                  children: /* @__PURE__ */ s.jsxs(
                    "div",
                    {
                      className: K(
                        "flex flex-col gap-3",
                        p && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        o
                      ),
                      children: [
                        /* @__PURE__ */ s.jsx(_, { color: e, ...b }),
                        !p && /* @__PURE__ */ s.jsxs("div", { className: "flex", children: [
                          /* @__PURE__ */ s.jsx("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ s.jsx(
                            Gf,
                            {
                              alpha: !0,
                              className: K(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                i
                              ),
                              color: e,
                              onChange: b.onChange
                            }
                          )
                        ] }),
                        c == null ? void 0 : c(j),
                        /* @__PURE__ */ s.jsx(
                          X5,
                          {
                            errorClassName: "text-left",
                            error: f,
                            description: g
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
}, v4 = (e, t) => ({
  ...e ? {
    "data-test-id": `${t}`
  } : {}
});
function R2(e) {
  "@babel/helpers - typeof";
  return R2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, R2(e);
}
const KH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get default() {
    return R2;
  }
}, Symbol.toStringTag, { value: "Module" }));
function Kf(e, t) {
  if (R2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (R2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Ir(e) {
  var t = Kf(e, "string");
  return R2(t) == "symbol" ? t : t + "";
}
function a1(e, t, r) {
  return (t = Ir(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
const zH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a1
}, Symbol.toStringTag, { value: "Module" }));
function A1(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
const UH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A1
}, Symbol.toStringTag, { value: "Module" }));
function tt(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ir(n.key), n);
  }
}
function E1(e, t, r) {
  return t && tt(e.prototype, t), r && tt(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
const YH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E1
}, Symbol.toStringTag, { value: "Module" }));
var zf = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Uf = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Yf = function(t) {
  return Uf[t];
}, Wf = function(t) {
  return t.replace(zf, Yf);
};
function at(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? at(Object(r), !0).forEach(function(n) {
      a1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : at(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var rt = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Wf
};
V1();
function $f() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  rt = nt(nt({}, rt), e);
}
(function() {
  function e() {
    A1(this, e), this.usedNamespaces = {};
  }
  return E1(e, [{
    key: "addUsedNamespaces",
    value: function(r) {
      var n = this;
      r.forEach(function(a) {
        n.usedNamespaces[a] || (n.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var Jf = {
  type: "3rdParty",
  init: function(t) {
    $f(t.options.react);
  }
};
function it(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function qf(e, t) {
  if (e) {
    if (typeof e == "string")
      return it(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? it(e, t) : void 0;
  }
}
const b1 = (e) => typeof e == "string", M9 = () => {
  let e, t;
  const r = new Promise((n, a) => {
    e = n, t = a;
  });
  return r.resolve = e, r.reject = t, r;
}, ot = (e) => e == null ? "" : "" + e, Qf = (e, t, r) => {
  e.forEach((n) => {
    t[n] && (r[n] = t[n]);
  });
}, Xf = /###/g, st = (e) => e && e.indexOf("###") > -1 ? e.replace(Xf, ".") : e, lt = (e) => !e || b1(e), E9 = (e, t, r) => {
  const n = b1(t) ? t.split(".") : t;
  let a = 0;
  for (; a < n.length - 1; ) {
    if (lt(e))
      return {};
    const i = st(n[a]);
    !e[i] && r && (e[i] = new r()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++a;
  }
  return lt(e) ? {} : {
    obj: e,
    k: st(n[a])
  };
}, ct = (e, t, r) => {
  const {
    obj: n,
    k: a
  } = E9(e, t, Object);
  if (n !== void 0 || t.length === 1) {
    n[a] = r;
    return;
  }
  let i = t[t.length - 1], o = t.slice(0, t.length - 1), l = E9(e, o, Object);
  for (; l.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), l = E9(e, o, Object), l && l.obj && typeof l.obj[`${l.k}.${i}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${i}`] = r;
}, em = (e, t, r, n) => {
  const {
    obj: a,
    k: i
  } = E9(e, t, Object);
  a[i] = a[i] || [], a[i].push(r);
}, o7 = (e, t) => {
  const {
    obj: r,
    k: n
  } = E9(e, t);
  if (r)
    return r[n];
}, tm = (e, t, r) => {
  const n = o7(e, r);
  return n !== void 0 ? n : o7(t, r);
}, Dr = (e, t, r) => {
  for (const n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? b1(e[n]) || e[n] instanceof String || b1(t[n]) || t[n] instanceof String ? r && (e[n] = t[n]) : Dr(e[n], t[n], r) : e[n] = t[n]);
  return e;
}, E6 = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var am = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const nm = (e) => b1(e) ? e.replace(/[&<>"'\/]/g, (t) => am[t]) : e;
class rm {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const r = this.regExpMap.get(t);
    if (r !== void 0)
      return r;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}
const im = [" ", ",", "?", "!", ";"], om = new rm(20), sm = (e, t, r) => {
  t = t || "", r = r || "";
  const n = im.filter((o) => t.indexOf(o) < 0 && r.indexOf(o) < 0);
  if (n.length === 0)
    return !0;
  const a = om.getRegExp(`(${n.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !a.test(e);
  if (!i) {
    const o = e.indexOf(r);
    o > 0 && !a.test(e.substring(0, o)) && (i = !0);
  }
  return i;
}, b4 = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const n = t.split(r);
  let a = e;
  for (let i = 0; i < n.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, l = "";
    for (let c = i; c < n.length; ++c)
      if (c !== i && (l += r), l += n[c], o = a[l], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && c < n.length - 1)
          continue;
        i += c - i + 1;
        break;
      }
    a = o;
  }
  return a;
}, s7 = (e) => e && e.replace("_", "-"), lm = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class l7 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, r);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = t || lm, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, r, n, a) {
    return a && !this.debug ? null : (b1(t[0]) && (t[0] = `${n}${this.prefix} ${t[0]}`), this.logger[r](t));
  }
  create(t) {
    return new l7(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new l7(this.logger, t);
  }
}
var u5 = new l7();
class s3 {
  constructor() {
    this.observers = {};
  }
  on(t, r) {
    return t.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const a = this.observers[n].get(r) || 0;
      this.observers[n].set(r, a + 1);
    }), this;
  }
  off(t, r) {
    if (this.observers[t]) {
      if (!r) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(r);
    }
  }
  emit(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((o) => {
      let [l, c] = o;
      for (let u = 0; u < c; u++)
        l(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [l, c] = o;
      for (let u = 0; u < c; u++)
        l.apply(l, [t, ...n]);
    });
  }
}
class ut extends s3 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const r = this.options.ns.indexOf(t);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, r], n && (Array.isArray(n) ? l.push(...n) : b1(n) && i ? l.push(...n.split(i)) : l.push(n)));
    const c = o7(this.data, l);
    return !c && !r && !n && t.indexOf(".") > -1 && (t = l[0], r = l[1], n = l.slice(2).join(".")), c || !o || !b1(n) ? c : b4(this.data && this.data[t] && this.data[t][r], n, i);
  }
  addResource(t, r, n, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let l = [t, r];
    n && (l = l.concat(o ? n.split(o) : n)), t.indexOf(".") > -1 && (l = t.split("."), a = r, r = l[1]), this.addNamespaces(r), ct(this.data, l, a), i.silent || this.emit("added", t, r, n, a);
  }
  addResources(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (b1(n[i]) || Array.isArray(n[i])) && this.addResource(t, r, i, n[i], {
        silent: !0
      });
    a.silent || this.emit("added", t, r, n);
  }
  addResourceBundle(t, r, n, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, l = [t, r];
    t.indexOf(".") > -1 && (l = t.split("."), a = n, n = r, r = l[1]), this.addNamespaces(r);
    let c = o7(this.data, l) || {};
    o.skipCopy || (n = JSON.parse(JSON.stringify(n))), a ? Dr(c, n, i) : c = {
      ...c,
      ...n
    }, ct(this.data, l, c), o.silent || this.emit("added", t, r, n);
  }
  removeResourceBundle(t, r) {
    this.hasResourceBundle(t, r) && delete this.data[t][r], this.removeNamespaces(r), this.emit("removed", t, r);
  }
  hasResourceBundle(t, r) {
    return this.getResource(t, r) !== void 0;
  }
  getResourceBundle(t, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, r)
    } : this.getResource(t, r);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const r = this.getDataByLanguage(t);
    return !!(r && Object.keys(r) || []).find((a) => r[a] && Object.keys(r[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Nr = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, r, n, a) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, r, n, a));
    }), t;
  }
};
const dt = {};
class c7 extends s3 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Qf(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = u5.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const n = this.resolve(t, r);
    return n && n.res !== void 0;
  }
  extractFromKey(t, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const o = n && t.indexOf(n) > -1, l = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !sm(t, n, a);
    if (o && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: b1(i) ? [i] : i
        };
      const u = t.split(n);
      (n !== a || n === a && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), t = u.join(a);
    }
    return {
      key: t,
      namespaces: b1(i) ? [i] : i
    };
  }
  translate(t, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], r), c = l[l.length - 1], u = r.lng || this.language, d = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (d) {
        const M = r.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${c}${M}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: u,
          usedNS: c,
          usedParams: this.getUsedParamsDetails(r)
        } : `${c}${M}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: u,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(r)
      } : o;
    }
    const C = this.resolve(t, r);
    let p = C && C.res;
    const h = C && C.usedKey || o, f = C && C.exactUsedKey || o, g = Object.prototype.toString.apply(p), m = ["[object Number]", "[object Function]", "[object RegExp]"], v = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, b = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !b1(p) && typeof p != "boolean" && typeof p != "number";
    if (b && p && w && m.indexOf(g) < 0 && !(b1(v) && Array.isArray(p))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...r,
          ns: l
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (C.res = M, C.usedParams = this.getUsedParamsDetails(r), C) : M;
      }
      if (i) {
        const M = Array.isArray(p), y = M ? [] : {}, _ = M ? f : h;
        for (const S in p)
          if (Object.prototype.hasOwnProperty.call(p, S)) {
            const j = `${_}${i}${S}`;
            y[S] = this.translate(j, {
              ...r,
              joinArrays: !1,
              ns: l
            }), y[S] === j && (y[S] = p[S]);
          }
        p = y;
      }
    } else if (b && b1(v) && Array.isArray(p))
      p = p.join(v), p && (p = this.extendTranslation(p, t, r, n));
    else {
      let M = !1, y = !1;
      const _ = r.count !== void 0 && !b1(r.count), S = c7.hasDefaultValue(r), j = _ ? this.pluralResolver.getSuffix(u, r.count, r) : "", V = r.ordinal && _ ? this.pluralResolver.getSuffix(u, r.count, {
        ordinal: !1
      }) : "", P = _ && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), A = P && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${j}`] || r[`defaultValue${V}`] || r.defaultValue;
      !this.isValidLookup(p) && S && (M = !0, p = A), this.isValidLookup(p) || (y = !0, p = o);
      const z = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && y ? void 0 : p, N = S && A !== p && this.options.updateMissing;
      if (y || M || N) {
        if (this.logger.log(N ? "updateKey" : "missingKey", u, c, o, N ? A : p), i) {
          const E = this.resolve(o, {
            ...r,
            keySeparator: !1
          });
          E && E.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const U = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && U && U[0])
          for (let E = 0; E < U.length; E++)
            G.push(U[E]);
        else
          this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(r.lng || this.language) : G.push(r.lng || this.language);
        const Z = (E, F, I) => {
          const T = S && I !== p ? I : z;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(E, c, F, T, N, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(E, c, F, T, N, r), this.emit("missingKey", E, c, F, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && _ ? G.forEach((E) => {
          const F = this.pluralResolver.getSuffixes(E, r);
          P && r[`defaultValue${this.options.pluralSeparator}zero`] && F.indexOf(`${this.options.pluralSeparator}zero`) < 0 && F.push(`${this.options.pluralSeparator}zero`), F.forEach((I) => {
            Z([E], o + I, r[`defaultValue${I}`] || A);
          });
        }) : Z(G, o, A));
      }
      p = this.extendTranslation(p, t, r, C, n), y && p === o && this.options.appendNamespaceToMissingKey && (p = `${c}:${o}`), (y || M) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${o}` : o, M ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (C.res = p, C.usedParams = this.getUsedParamsDetails(r), C) : p;
  }
  extendTranslation(t, r, n, a, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = b1(t) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (u) {
        const p = t.match(this.interpolator.nestingRegexp);
        d = p && p.length;
      }
      let C = n.replace && !b1(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (C = {
        ...this.options.interpolation.defaultVariables,
        ...C
      }), t = this.interpolator.interpolate(t, C, n.lng || this.language || a.usedLng, n), u) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        d < h && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (n.lng = this.language || a.usedLng), n.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), f = 0; f < p; f++)
          h[f] = arguments[f];
        return i && i[0] === h[0] && !n.context ? (o.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${r[0]}`), null) : o.translate(...h, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const l = n.postProcess || this.options.postProcess, c = b1(l) ? [l] : l;
    return t != null && c && c.length && n.applyPostProcessor !== !1 && (t = Nr.handle(c, t, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), t;
  }
  resolve(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, a, i, o, l;
    return b1(t) && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(n))
        return;
      const u = this.extractFromKey(c, r), d = u.key;
      a = d;
      let C = u.namespaces;
      this.options.fallbackNS && (C = C.concat(this.options.fallbackNS));
      const p = r.count !== void 0 && !b1(r.count), h = p && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), f = r.context !== void 0 && (b1(r.context) || typeof r.context == "number") && r.context !== "", g = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      C.forEach((m) => {
        this.isValidLookup(n) || (l = m, !dt[`${g[0]}-${m}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(l) && (dt[`${g[0]}-${m}`] = !0, this.logger.warn(`key "${a}" for languages "${g.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), g.forEach((v) => {
          if (this.isValidLookup(n))
            return;
          o = v;
          const b = [d];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(b, d, v, m, r);
          else {
            let M;
            p && (M = this.pluralResolver.getSuffix(v, r.count, r));
            const y = `${this.options.pluralSeparator}zero`, _ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (b.push(d + M), r.ordinal && M.indexOf(_) === 0 && b.push(d + M.replace(_, this.options.pluralSeparator)), h && b.push(d + y)), f) {
              const S = `${d}${this.options.contextSeparator}${r.context}`;
              b.push(S), p && (b.push(S + M), r.ordinal && M.indexOf(_) === 0 && b.push(S + M.replace(_, this.options.pluralSeparator)), h && b.push(S + y));
            }
          }
          let w;
          for (; w = b.pop(); )
            this.isValidLookup(n) || (i = w, n = this.getResource(v, m, w, r));
        }));
      });
    }), {
      res: n,
      usedKey: a,
      exactUsedKey: i,
      usedLng: o,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, r, n, a) : this.resourceStore.getResource(t, r, n, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = t.replace && !b1(t.replace);
    let a = n ? t.replace : t;
    if (n && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !n) {
      a = {
        ...a
      };
      for (const i of r)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const r = "defaultValue";
    for (const n in t)
      if (Object.prototype.hasOwnProperty.call(t, n) && r === n.substring(0, r.length) && t[n] !== void 0)
        return !0;
    return !1;
  }
}
const F3 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class Ct {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = u5.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = s7(t), !t || t.indexOf("-") < 0)
      return null;
    const r = t.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = s7(t), !t || t.indexOf("-") < 0)
      return t;
    const r = t.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(t) {
    if (b1(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = t.split("-");
      return this.options.lowerCaseLng ? n = n.map((a) => a.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = F3(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = F3(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = F3(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let r;
    return t.forEach((n) => {
      if (r)
        return;
      const a = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (r = a);
    }), !r && this.options.supportedLngs && t.forEach((n) => {
      if (r)
        return;
      const a = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(a))
        return r = a;
      r = this.options.supportedLngs.find((i) => {
        if (i === a)
          return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(t, r) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(r)), b1(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!r)
      return t.default || [];
    let n = t[r];
    return n || (n = t[this.getScriptPartFromCode(r)]), n || (n = t[this.formatLanguageCode(r)]), n || (n = t[this.getLanguagePartFromCode(r)]), n || (n = t.default), n || [];
  }
  toResolveHierarchy(t, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], t), a = [], i = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return b1(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : b1(t) && i(this.formatLanguageCode(t)), n.forEach((o) => {
      a.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), a;
  }
}
let cm = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], um = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const dm = ["v1", "v2", "v3"], Cm = ["v4"], pt = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, pm = () => {
  const e = {};
  return cm.forEach((t) => {
    t.lngs.forEach((r) => {
      e[r] = {
        numbers: t.nr,
        plurals: um[t.fc]
      };
    });
  }), e;
};
class hm {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = r, this.logger = u5.create("pluralResolver"), (!this.options.compatibilityJSON || Cm.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = pm(), this.pluralRulesCache = {};
  }
  addRule(t, r) {
    this.rules[t] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n = s7(t === "dev" ? "en" : t), a = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: n,
        type: a
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(n, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const c = this.languageUtils.getLanguagePartFromCode(t);
        o = this.getRule(c, r);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(t, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, n).map((a) => `${r}${a}`);
  }
  getSuffixes(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(t, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((a, i) => pt[a] - pt[i]).map((a) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : n.numbers.map((a) => this.getSuffix(t, a, r)) : [];
  }
  getSuffix(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, n);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(r)}` : this.getSuffixRetroCompatible(a, r) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, r) {
    const n = t.noAbs ? t.plurals(r) : t.plurals(Math.abs(r));
    let a = t.numbers[n];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !dm.includes(this.options.compatibilityJSON);
  }
}
const ht = function(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = tm(e, t, r);
  return !i && a && b1(r) && (i = b4(e, r, n), i === void 0 && (i = b4(t, r, n))), i;
}, O3 = (e) => e.replace(/\$/g, "$$$$");
class fm {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = u5.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((r) => r), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: o,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: u,
      unescapeSuffix: d,
      unescapePrefix: C,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: f,
      nestingSuffixEscaped: g,
      nestingOptionsSeparator: m,
      maxReplaces: v,
      alwaysFormat: b
    } = t.interpolation;
    this.escape = r !== void 0 ? r : nm, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? E6(i) : o || "{{", this.suffix = l ? E6(l) : c || "}}", this.formatSeparator = u || ",", this.unescapePrefix = d ? "" : C || "-", this.unescapeSuffix = this.unescapePrefix ? "" : d || "", this.nestingPrefix = p ? E6(p) : h || E6("$t("), this.nestingSuffix = f ? E6(f) : g || E6(")"), this.nestingOptionsSeparator = m || ",", this.maxReplaces = v || 1e3, this.alwaysFormat = b !== void 0 ? b : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, r, n, a) {
    let i, o, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const v = ht(r, c, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(v, void 0, n, {
          ...a,
          ...r,
          interpolationkey: h
        }) : v;
      }
      const f = h.split(this.formatSeparator), g = f.shift().trim(), m = f.join(this.formatSeparator).trim();
      return this.format(ht(r, c, g, this.options.keySeparator, this.options.ignoreJSONStructure), m, n, {
        ...a,
        ...r,
        interpolationkey: g
      });
    };
    this.resetRegExp();
    const d = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, C = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => O3(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? O3(this.escape(h)) : O3(h)
    }].forEach((h) => {
      for (l = 0; i = h.regex.exec(t); ) {
        const f = i[1].trim();
        if (o = u(f), o === void 0)
          if (typeof d == "function") {
            const m = d(t, i, a);
            o = b1(m) ? m : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, f))
            o = "";
          else if (C) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${t}`), o = "";
        else
          !b1(o) && !this.useRawValueToEscape && (o = ot(o));
        const g = h.safeValue(o);
        if (t = t.replace(i[0], g), C ? (h.regex.lastIndex += o.length, h.regex.lastIndex -= i[0].length) : h.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, o;
    const l = (c, u) => {
      const d = this.nestingOptionsSeparator;
      if (c.indexOf(d) < 0)
        return c;
      const C = c.split(new RegExp(`${d}[ ]*{`));
      let p = `{${C[1]}`;
      c = C[0], p = this.interpolate(p, o);
      const h = p.match(/'/g), f = p.match(/"/g);
      (h && h.length % 2 === 0 && !f || f.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), u && (o = {
          ...u,
          ...o
        });
      } catch (g) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, g), `${c}${d}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, c;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let c = [];
      o = {
        ...n
      }, o = o.replace && !b1(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let u = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const d = a[1].split(this.formatSeparator).map((C) => C.trim());
        a[1] = d.shift(), c = d, u = !0;
      }
      if (i = r(l.call(this, a[1].trim(), o), o), i && a[0] === t && !b1(i))
        return i;
      b1(i) || (i = ot(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), i = ""), u && (i = c.reduce((d, C) => this.format(d, C, n.lng, {
        ...n,
        interpolationkey: a[1].trim()
      }), i.trim())), t = t.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const mm = (e) => {
  let t = e.toLowerCase().trim();
  const r = {};
  if (e.indexOf("(") > -1) {
    const n = e.split("(");
    t = n[0].toLowerCase().trim();
    const a = n[1].substring(0, n[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? r.currency || (r.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? r.range || (r.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [l, ...c] = o.split(":"), u = c.join(":").trim().replace(/^'+|'+$/g, ""), d = l.trim();
        r[d] || (r[d] = u), u === "false" && (r[d] = !1), u === "true" && (r[d] = !0), isNaN(u) || (r[d] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: r
  };
}, I6 = (e) => {
  const t = {};
  return (r, n, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const o = n + JSON.stringify(i);
    let l = t[o];
    return l || (l = e(s7(n), a), t[o] = l), l(r);
  };
};
class gm {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = u5.create("formatter"), this.options = t, this.formats = {
      number: I6((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      }),
      currency: I6((r, n) => {
        const a = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: I6((r, n) => {
        const a = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      }),
      relativetime: I6((r, n) => {
        const a = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (i) => a.format(i, n.range || "day");
      }),
      list: I6((r, n) => {
        const a = new Intl.ListFormat(r, {
          ...n
        });
        return (i) => a.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(t, r) {
    this.formats[t.toLowerCase().trim()] = r;
  }
  addCached(t, r) {
    this.formats[t.toLowerCase().trim()] = I6(r);
  }
  format(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((l) => l.indexOf(")") > -1)) {
      const l = i.findIndex((c) => c.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, l)].join(this.formatSeparator);
    }
    return i.reduce((l, c) => {
      const {
        formatName: u,
        formatOptions: d
      } = mm(c);
      if (this.formats[u]) {
        let C = l;
        try {
          const p = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, h = p.locale || p.lng || a.locale || a.lng || n;
          C = this.formats[u](l, h, {
            ...d,
            ...a,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return C;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return l;
    }, t);
  }
}
const vm = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class bm extends s3 {
  constructor(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = a, this.logger = u5.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, a.backend, a);
  }
  queueLoad(t, r, n, a) {
    const i = {}, o = {}, l = {}, c = {};
    return t.forEach((u) => {
      let d = !0;
      r.forEach((C) => {
        const p = `${u}|${C}`;
        !n.reload && this.store.hasResourceBundle(u, C) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, d = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), c[C] === void 0 && (c[C] = !0)));
      }), d || (l[u] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, r, n) {
    const a = t.split("|"), i = a[0], o = a[1];
    r && this.emit("failedLoading", i, o, r), !r && n && this.store.addResourceBundle(i, o, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = r ? -1 : 2, r && n && (this.state[t] = 0);
    const l = {};
    this.queue.forEach((c) => {
      em(c.loaded, [i], o), vm(c, t), r && c.errors.push(r), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((u) => {
        l[u] || (l[u] = {});
        const d = c.loaded[u];
        d.length && d.forEach((C) => {
          l[u][C] === void 0 && (l[u][C] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, r, n) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: r,
        fcName: n,
        tried: a,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const l = (u, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const C = this.waitingReads.shift();
        this.read(C.lng, C.ns, C.fcName, C.tried, C.wait, C.callback);
      }
      if (u && d && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, r, n, a + 1, i * 2, o);
        }, i);
        return;
      }
      o(u, d);
    }, c = this.backend[n].bind(this.backend);
    if (c.length === 2) {
      try {
        const u = c(t, r);
        u && typeof u.then == "function" ? u.then((d) => l(null, d)).catch(l) : l(null, u);
      } catch (u) {
        l(u);
      }
      return;
    }
    return c(t, r, l);
  }
  prepareLoading(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    b1(t) && (t = this.languageUtils.toResolveHierarchy(t)), b1(r) && (r = [r]);
    const i = this.queueLoad(t, r, n, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, r, n) {
    this.prepareLoading(t, r, {}, n);
  }
  reload(t, r, n) {
    this.prepareLoading(t, r, {
      reload: !0
    }, n);
  }
  loadOne(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = t.split("|"), a = n[0], i = n[1];
    this.read(a, i, "read", void 0, void 0, (o, l) => {
      o && this.logger.warn(`${r}loading namespace ${i} for language ${a} failed`, o), !o && l && this.logger.log(`${r}loaded namespace ${i} for language ${a}`, l), this.loaded(t, o, l);
    });
  }
  saveMissing(t, r, n, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const c = {
          ...o,
          isUpdate: i
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let d;
            u.length === 5 ? d = u(t, r, n, a, c) : d = u(t, r, n, a), d && typeof d.then == "function" ? d.then((C) => l(null, C)).catch(l) : l(null, d);
          } catch (d) {
            l(d);
          }
        else
          u(t, r, n, a, l, c);
      }
      !t || !t[0] || this.store.addResource(t[0], r, n, a);
    }
  }
}
const ft = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), b1(e[1]) && (t.defaultValue = e[1]), b1(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const r = e[3] || e[2];
      Object.keys(r).forEach((n) => {
        t[n] = r[n];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), mt = (e) => (b1(e.ns) && (e.ns = [e.ns]), b1(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), b1(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), E8 = () => {
}, ym = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((r) => {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
};
class W9 extends s3 {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = mt(t), this.services = {}, this.logger = u5, this.modules = {
      external: []
    }, ym(this), r && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, r), this;
      setTimeout(() => {
        this.init(t, r);
      }, 0);
    }
  }
  init() {
    var t = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (b1(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const a = ft();
    this.options = {
      ...a,
      ...this.options,
      ...mt(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (d) => d ? typeof d == "function" ? new d() : d : null;
    if (!this.options.isClone) {
      this.modules.logger ? u5.init(i(this.modules.logger), this.options) : u5.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : typeof Intl < "u" && (d = gm);
      const C = new Ct(this.options);
      this.store = new ut(this.options.resources, this.options);
      const p = this.services;
      p.logger = u5, p.resourceStore = this.store, p.languageUtils = C, p.pluralResolver = new hm(C, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), d && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (p.formatter = i(d), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new fm(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new bm(i(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(h) {
        for (var f = arguments.length, g = new Array(f > 1 ? f - 1 : 0), m = 1; m < f; m++)
          g[m - 1] = arguments[m];
        t.emit(h, ...g);
      }), this.modules.languageDetector && (p.languageDetector = i(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = i(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new c7(this.services, this.options), this.translator.on("*", function(h) {
        for (var f = arguments.length, g = new Array(f > 1 ? f - 1 : 0), m = 1; m < f; m++)
          g[m - 1] = arguments[m];
        t.emit(h, ...g);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = E8), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments), t;
      };
    });
    const c = M9(), u = () => {
      const d = (C, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), c.resolve(p), n(C, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), c;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E8;
    const a = b1(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const i = [], o = (l) => {
        if (!l || l === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((u) => {
          u !== "cimode" && i.indexOf(u) < 0 && i.push(u);
        });
      };
      a ? o(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => o(c)), this.options.preload && this.options.preload.forEach((l) => o(l)), this.services.backendConnector.load(i, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(l);
      });
    } else
      n(null);
  }
  reloadResources(t, r, n) {
    const a = M9();
    return typeof t == "function" && (n = t, t = void 0), typeof r == "function" && (n = r, r = void 0), t || (t = this.languages), r || (r = this.options.ns), n || (n = E8), this.services.backendConnector.reload(t, r, (i) => {
      a.resolve(), n(i);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Nr.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(t, r) {
    var n = this;
    this.isLanguageChangingTo = t;
    const a = M9();
    this.emit("languageChanging", t);
    const i = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, o = (c, u) => {
      u ? (i(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return n.t(...arguments);
      }), r && r(c, function() {
        return n.t(...arguments);
      });
    }, l = (c) => {
      !t && !c && this.services.languageDetector && (c = []);
      const u = b1(c) ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      u && (this.language || i(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (d) => {
        o(d, u);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(t), a;
  }
  getFixedT(t, r, n) {
    var a = this;
    const i = function(o, l) {
      let c;
      if (typeof l != "object") {
        for (var u = arguments.length, d = new Array(u > 2 ? u - 2 : 0), C = 2; C < u; C++)
          d[C - 2] = arguments[C];
        c = a.options.overloadTranslationOptionHandler([o, l].concat(d));
      } else
        c = {
          ...l
        };
      c.lng = c.lng || i.lng, c.lngs = c.lngs || i.lngs, c.ns = c.ns || i.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || n || i.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return c.keyPrefix && Array.isArray(o) ? h = o.map((f) => `${c.keyPrefix}${p}${f}`) : h = c.keyPrefix ? `${c.keyPrefix}${p}${o}` : o, a.t(h, c);
    };
    return b1(t) ? i.lng = t : i.lngs = t, i.ns = r, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const o = (l, c) => {
      const u = this.services.backendConnector.state[`${l}|${c}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (r.precheck) {
      const l = r.precheck(this, o);
      if (l !== void 0)
        return l;
    }
    return !!(this.hasResourceBundle(n, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(n, t) && (!a || o(i, t)));
  }
  loadNamespaces(t, r) {
    const n = M9();
    return this.options.ns ? (b1(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(t, r) {
    const n = M9();
    b1(t) && (t = [t]);
    const a = this.options.preload || [], i = t.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((o) => {
      n.resolve(), r && r(o);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new Ct(ft());
    return r.indexOf(n.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new W9(t, r);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E8;
    const n = t.forkResourceStore;
    n && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new W9(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      i[l] = this[l];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new ut(this.store.data, a), i.services.resourceStore = i.store), i.translator = new c7(i.services, a), i.translator.on("*", function(l) {
      for (var c = arguments.length, u = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
        u[d - 1] = arguments[d];
      i.emit(l, ...u);
    }), i.init(a, r), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const c1 = W9.createInstance();
c1.createInstance = W9.createInstance;
c1.createInstance;
c1.dir;
c1.init;
c1.loadResources;
c1.reloadResources;
c1.use;
c1.changeLanguage;
c1.getFixedT;
c1.t;
c1.exists;
c1.setDefaultNamespace;
c1.hasLoadedNamespace;
c1.loadNamespaces;
c1.loadLanguages;
var j1 = /* @__PURE__ */ ((e) => (e.FRENCH = "fr", e.ENGLISH = "en", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "ja", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "da", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "uk", e.ALBANIA = "sq", e.HINDI = "hi", e))(j1 || {});
const xm = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقة ائتمان أو خصم",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "إزالة",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  },
  product: "منتج",
  quantity: "الكمية",
  order_summary: "ملخص الطلب",
  vat: "ضريبة المبيعات",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  shipping: {
    shipping_method: "طريقة الشحن",
    not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.",
    condition_label: {
      price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}",
      price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر",
      quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر",
      quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر",
      weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام",
      weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر"
    }
  },
  shipping_fee: "رسوم الشحن",
  total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)",
  vat_percent: "ضريبة المبيعات ({{percent}}%)",
  including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})",
  total_amount_with_tax: "المجموع (شامل الضرائب)",
  total_amount_with_shipping: "المجموع (شامل الشحن)"
}, wm = {
  public_pages_purchase: xm
}, _m = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní nebo debetní karta",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "Španělština",
    japanese: "Japonština",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "Čínština",
    swedish: "Švédnština",
    romanian: "Rumunština",
    czech: "Čeština",
    hungarian: "Maďarský",
    slovak: "Slovenština",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "Řečtina",
    serbian: "Srbština",
    hindi: "Hindi",
    norwegian: "Norština",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánština"
  },
  product: "Produkt",
  quantity: "Množství",
  order_summary: "Shrnutí objednávky",
  vat: "Daň z prodeje",
  total: "Celkem",
  subtotal: "Mezisoučet",
  shipping: {
    shipping_method: "Způsob dopravy",
    not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.",
    condition_label: {
      price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}",
      price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více",
      quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami",
      quantity_min: "Pro objednávky obsahující {{min}} nebo více položek",
      weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g",
      weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více"
    }
  },
  shipping_fee: "Poplatek za dopravu",
  total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)",
  vat_percent: "Daň z prodeje ({{percent}}%)",
  including_tax: "Včetně DPH {{percent}} % ({{amount}})",
  total_amount_with_tax: "Celkem (včetně daně)",
  total_amount_with_shipping: "Celkem (včetně dopravy)"
}, Mm = {
  public_pages_purchase: _m
}, Sm = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- eller betalingskort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mængde",
  order_summary: "Ordreoversigt",
  vat: "Salgsskat",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Forsendelsesmetode",
    not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.",
    condition_label: {
      price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For ordrer prissat til {{min}} {{currency}} eller mere",
      quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer",
      quantity_min: "For ordrer indeholdende {{min}} eller flere varer",
      weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g",
      weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere"
    }
  },
  shipping_fee: "Forsendelsesgebyr",
  total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)",
  vat_percent: "Moms ({{percent}} %)",
  including_tax: "Inkluderer {{percent}} % moms ({{amount}})",
  total_amount_with_tax: "Total (inkl. skat)",
  total_amount_with_shipping: "Total (inklusive forsendelse)"
}, km = {
  public_pages_purchase: Sm
}, Lm = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- oder Debitkarte",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  },
  product: "Produkt",
  quantity: "Menge",
  order_summary: "Bestellübersicht",
  vat: "Mehrwertsteuer",
  total: "Gesamt",
  subtotal: "Zwischensumme",
  shipping: {
    shipping_method: "Versandmethode",
    not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.",
    condition_label: {
      price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}",
      price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr",
      quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln",
      quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln",
      weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g",
      weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr"
    }
  },
  shipping_fee: "Versandgebühr",
  total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)",
  vat_percent: "Umsatzsteuer ({{percent}} %)",
  including_tax: "Enthält {{percent}} % MwSt. ({{amount}})",
  total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)",
  total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)"
}, Hm = {
  public_pages_purchase: Lm
}, Pm = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Πλάνο",
    stripe_card: "Πιστωτική ή χρεωστική κάρτα",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Τραπεζικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Τραπεζικές κάρτες (Xendit)",
    paystack_card: "Τραπεζικές κάρτες (Paystack)",
    paypal_connect: "Σύνδεση με PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλογή"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Τηλέφωνο",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Επωνυμία εταιρίας",
    tax_number: "Α.Φ.Μ.",
    state_province: "Νομός",
    street_number: "Αριθμός οδού",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Υποβολή",
    clear: "Επαναφορά",
    time: "Χρόνος",
    all_time: "Συνολικά",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης email",
    last_month: "Προηγούμενος μήνας",
    this_month: "Αυτό το μήνα",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Επιτυχής αντιγραφή",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Το CVC είναι μη έγκυρο",
    empty_cvc: "Εισάγετε το CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/ΕΕ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Τηλέφωνο",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "εγγεγραμμένο πάνω από",
  locale: {
    french: "Γαλλικά",
    german: "Γερμανικά",
    italian: "Ιταλικά",
    dutch: "Ολλανδικά",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσικά",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "Αραβικά",
    turkish: "Τούρκικα",
    chinese: "Κινέζικα",
    swedish: "Σουηδικά",
    romanian: "Ρουμανικά",
    czech: "Τσέχικα",
    hungarian: "Ουγγρικά",
    slovak: "Σλοβάκικα",
    danish: "Δανικά",
    indonesian: "Ινδονησιακά",
    polish: "Πολωνικά",
    greek: "Ελληνικά",
    serbian: "Σερβικά",
    hindi: "Ινδικά",
    norwegian: "Νορβηγικά",
    thai: "Ταϊλανδέζικα",
    slovenian: "Σλοβενικά",
    ukrainian: "Ουκρανικά",
    albania: "Αλβανικά"
  },
  product: "Προϊόν",
  quantity: "Ποσότητα",
  order_summary: "Σύνοψη Παραγγελίας",
  vat: "Φόρος πωλήσεων",
  total: "Σύνολο",
  subtotal: "Μερικό σύνολο",
  shipping: {
    shipping_method: "Τρόπος αποστολής",
    not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη",
    condition_label: {
      price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}",
      price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}",
      quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα",
      quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα",
      weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g",
      weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g"
    }
  },
  shipping_fee: "Χρέωση αποστολής",
  total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)",
  vat_percent: "ΦΠΑ ({{percent}}%)",
  including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})",
  total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)",
  total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)"
}, Tm = {
  public_pages_purchase: Pm
}, jm = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit or debit card",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  },
  product: "Product",
  quantity: "Quantity",
  order_summary: "Order summary",
  vat: "Sales tax",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Shipping method",
    not_available: "Oops! It looks like we don't offer shipping to this location yet",
    condition_label: {
      price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
      price_min: "For orders priced at {{min}} {{currency}} or more",
      quantity: "For orders containing between {{min}} to {{max}} items",
      quantity_min: "For orders containing {{min}} or more items",
      weight: "For orders with a total weight between {{min}}g to {{max}}g",
      weight_min: "For orders with a total weight of {{min}}g or more"
    }
  },
  shipping_fee: "Shipping fee",
  total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
  vat_percent: "Sales tax ({{percent}}%)",
  including_tax: "Includes {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Total (including tax)",
  total_amount_with_shipping: "Total (including Shipping)"
}, Vm = {
  public_pages_purchase: jm
}, Am = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjeta de crédito o débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  },
  product: "Producto",
  quantity: "Cantidad",
  order_summary: "Resumen del pedido",
  vat: "IVA",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envío",
    not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación",
    condition_label: {
      price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}",
      price_min: "Para pedidos que cuesten {{min}} {{currency}} o más",
      quantity: "Para pedidos de entre {{min}} y {{max}} artículos",
      quantity_min: "Para pedidos con {{min}} o más artículos",
      weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g",
      weight_min: "Para pedidos con un peso total de {{min}}g o más"
    }
  },
  shipping_fee: "Tarifa de envío",
  total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)",
  vat_percent: "IVA ({{percent}}%)",
  including_tax: "Incluye el {{percent}}% de IVA ({{amount}})",
  total_amount_with_tax: "Total (impuestos incluidos)",
  total_amount_with_shipping: "Total (incluyendo envío)"
}, Em = {
  public_pages_purchase: Am
}, Im = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carte de crédit ou de débit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  },
  product: "Produit",
  quantity: "Quantité",
  order_summary: "Résumé de la commande",
  vat: "TVA",
  total: "Total",
  subtotal: "Sous-total",
  shipping: {
    shipping_method: "Méthode d'expédition",
    not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit",
    condition_label: {
      price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}",
      price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus",
      quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles",
      quantity_min: "Pour les commandes contenant {{min}} articles ou plus",
      weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g",
      weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus"
    }
  },
  shipping_fee: "Frais d'expédition",
  total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)",
  vat_percent: "TVA ({{percent}}%)",
  including_tax: "Comprend {{percent}} % de TVA ({{amount}})",
  total_amount_with_tax: "Total (TVA incluse)",
  total_amount_with_shipping: "Total (y compris livraison)"
}, Dm = {
  public_pages_purchase: Im
}, Nm = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट या डेबिट कार्ड",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  },
  product: "प्रोडक्ट",
  quantity: "क्वान्टिटी",
  order_summary: "ऑर्डर समरी",
  vat: "सेल्स टैक्स",
  total: "टोटल",
  subtotal: "सब टोटल ",
  shipping: {
    shipping_method: "शिपिंग मेथड",
    not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ",
    condition_label: {
      price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए",
      price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए",
      quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए",
      quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए",
      weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए",
      weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए"
    }
  },
  shipping_fee: "शिपिंग शुल्क",
  total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)",
  vat_percent: "सेल्स टैक्स ({{percent}}%)",
  including_tax: "शामिल है {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "कुल (कर सहित)",
  total_amount_with_shipping: "कुल (शिपिंग सहित)"
}, Rm = {
  public_pages_purchase: Nm
}, Fm = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitel- vagy betéti kártya",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  },
  product: "Termék",
  quantity: "Mennyiség",
  order_summary: "Rendelés összegzése",
  vat: "Áfa",
  total: "Összesen",
  subtotal: "Részösszeg",
  shipping: {
    shipping_method: "Szállítási mód",
    not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.",
    condition_label: {
      price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez",
      price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez",
      quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez",
      quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez",
      weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez",
      weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez"
    }
  },
  shipping_fee: "Szállítási díj",
  total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)",
  vat_percent: "Áruforgalmi adó ({{percent}}%)",
  including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})",
  total_amount_with_tax: "Összesen (beleértve az adót)",
  total_amount_with_shipping: "Összesen (beleértve a szállítást)"
}, Om = {
  public_pages_purchase: Fm
}, Bm = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit atau debit",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  },
  product: "Produk",
  quantity: "Kuantitas",
  order_summary: "Ringkasan Pesanan",
  vat: "Pajak penjualan",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metode Pengiriman",
    not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.",
    condition_label: {
      price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}",
      price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih",
      quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item",
      quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih",
      weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g",
      weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih"
    }
  },
  shipping_fee: "Biaya pengiriman",
  total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)",
  vat_percent: "Pajak penjualan ({{percent}}%)",
  including_tax: "Termasuk PPN {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (termasuk pajak)",
  total_amount_with_shipping: "Total (termasuk pengiriman)"
}, Zm = {
  public_pages_purchase: Bm
}, Gm = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carta di credito o di debito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Partita IVA",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Ora",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  },
  product: "Prodotto",
  quantity: "Quantità",
  order_summary: "Riepilogo dell'ordine",
  vat: "Imposta sulle vendite",
  total: "Totale",
  subtotal: "Totale parziale",
  shipping: {
    shipping_method: "Metodo di spedizione",
    not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.",
    condition_label: {
      price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più",
      quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli",
      quantity_min: "Per ordini contenenti {{min}} articoli o più",
      weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g",
      weight_min: "Per ordini con un peso totale di {{min}}g o più"
    }
  },
  shipping_fee: "Spese di spedizione",
  total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)",
  vat_percent: "Imposta sulle vendite ({{percent}}%)",
  including_tax: "Include {{percent}}% di IVA ({{amount}})",
  total_amount_with_tax: "Totale (IVA inclusa)",
  total_amount_with_shipping: "Totale (spedizione inclusa)"
}, Km = {
  public_pages_purchase: Gm
}, zm = {
  "required-field": "この項目は必須です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカードまたはデビットカード",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "姓",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市区町村",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "法人番号（税番号）",
    state_province: "都道府県",
    street_number: "番地",
    neighborhood: "地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "前回の集計期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  },
  product: "商品",
  quantity: "数量",
  order_summary: "ご注文内容",
  vat: "消費税",
  total: "合計",
  subtotal: "小計",
  shipping: {
    shipping_method: "配送方法",
    not_available: "おっと！この地域への配送にはまだ対応していないようです。",
    condition_label: {
      price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合",
      price_min: "{{min}} {{currency}}以上の注文の場合",
      quantity: "{{min}}から{{max}}個の商品を含む注文の場合",
      quantity_min: "{{min}}個以上の商品を含む注文の場合",
      weight: "合計重量が {{min}}g から {{max}}g までの注文の場合",
      weight_min: "合計重量が {{min}}g 以上の注文の場合"
    }
  },
  shipping_fee: "送料",
  total_amount_with_tax_and_shipping: "合計（消費税・送料込み）",
  vat_percent: "消費税（{{percent}}%）",
  including_tax: "消費税 {{percent}}% を含む（{{amount}}）",
  total_amount_with_tax: "合計（税込）",
  total_amount_with_shipping: "合計（送料込み）"
}, Um = {
  public_pages_purchase: zm
}, Ym = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcard of debetkaart",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  },
  product: "Product",
  quantity: "Aantal",
  order_summary: "Besteloverzicht",
  vat: "Verkoopbelasting",
  total: "Totaal",
  subtotal: "Subtotaal",
  shipping: {
    shipping_method: "Verzendmethode",
    not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden",
    condition_label: {
      price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}",
      price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer",
      quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten",
      quantity_min: "Voor bestellingen met {{min}} of meer artikelen",
      weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g",
      weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer"
    }
  },
  shipping_fee: "Verzendkosten",
  total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)",
  vat_percent: "BTW ({{percent}}%)",
  including_tax: "Inclusief {{percent}}% BTW ({{amount}})",
  total_amount_with_tax: "Totaal (incl. belasting)",
  total_amount_with_shipping: "Totaal (incl. verzending)"
}, Wm = {
  public_pages_purchase: Ym
}, $m = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditt- eller debetkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mengde",
  order_summary: "Ordresammendrag",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsum",
  shipping: {
    shipping_method: "Fraktmetode",
    not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.",
    condition_label: {
      price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For bestillinger priset til {{min}} {{currency}} eller mer",
      quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer",
      quantity_min: "For bestillinger som inneholder {{min}} eller flere varer",
      weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g",
      weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktgebyr",
  total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)",
  vat_percent: "Merverdiavgift ({{percent}}%)",
  including_tax: "Inkludert {{percent}}% MVA ({{amount}})",
  total_amount_with_tax: "Totalbeløp (inkludert skatt)",
  total_amount_with_shipping: "Totalbeløp (inkludert frakt)"
}, Jm = {
  public_pages_purchase: $m
}, qm = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karta kredytowa lub debetowa",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (Paystack)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Osiedle"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Cały czas",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czeski",
    hungarian: "Węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Hinduski",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  },
  product: "Produkt",
  quantity: "Ilość",
  order_summary: "Podsumowanie zamówienia",
  vat: "Podatek od sprzedaży",
  total: "Razem",
  subtotal: "Suma częściowa",
  shipping: {
    shipping_method: "Metoda wysyłki",
    not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.",
    condition_label: {
      price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej",
      quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów",
      quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów",
      weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g",
      weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej"
    }
  },
  shipping_fee: "Opłata za wysyłkę",
  total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)",
  vat_percent: "Podatek od sprzedaży ({{percent}}%)",
  including_tax: "Zawiera {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Razem (z podatkiem)",
  total_amount_with_shipping: "Razem (z wysyłką)"
}, Qm = {
  public_pages_purchase: qm
}, Xm = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito ou débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Até"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado há mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  },
  product: "Produto",
  quantity: "Quantidade",
  order_summary: "Resumo do pedido",
  vat: "Imposto",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envio",
    not_available: "Ops! Parece que ainda não oferecemos envio para este local",
    condition_label: {
      price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais",
      quantity: "Para pedidos contendo entre {{min}} e {{max}} itens",
      quantity_min: "Para pedidos contendo {{min}} ou mais itens",
      weight: "Para pedidos com peso total entre {{min}}g e {{max}}g",
      weight_min: "Para pedidos com peso total de {{min}}g ou mais"
    }
  },
  shipping_fee: "Taxa de envio",
  total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)",
  vat_percent: "Imposto ({{percent}}%)",
  including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})",
  total_amount_with_tax: "Total (incluindo impostos)",
  total_amount_with_shipping: "Total (incluindo envio)"
}, eg = {
  public_pages_purchase: Xm
}, tg = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Card de credit sau debit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  },
  product: "Produs",
  quantity: "Cantitate",
  order_summary: "Rezumatul comenzii",
  vat: "Taxa pe vânzări",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metoda de livrare",
    not_available: "Ups! Se pare că nu oferim livrare în această locație încă.",
    condition_label: {
      price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}",
      price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult",
      quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole",
      quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole",
      weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g",
      weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult"
    }
  },
  shipping_fee: "Taxa de livrare",
  total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)",
  vat_percent: "Taxa pe vânzări ({{percent}}%)",
  including_tax: "Incluzând TVA de {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (inclusiv taxe)",
  total_amount_with_shipping: "Total (inclusiv transport)"
}, ag = {
  public_pages_purchase: tg
}, ng = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитная или дебетовая карта",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "От",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  },
  product: "Продукт",
  quantity: "Количество",
  order_summary: "Итог заказа",
  vat: "Налог с продаж",
  total: "Итого",
  subtotal: "Промежуточный итог",
  shipping: {
    shipping_method: "Способ доставки",
    not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.",
    condition_label: {
      price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для заказов стоимостью {{min}} {{currency}} или более",
      quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров",
      quantity_min: "Для заказов, содержащих {{min}} или более товаров",
      weight: "Для заказов с общим весом от {{min}}g до {{max}}g",
      weight_min: "Для заказов с общим весом {{min}}g или более"
    }
  },
  shipping_fee: "Стоимость доставки",
  total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)",
  vat_percent: "Налог с продаж ({{percent}}%)",
  including_tax: "Включает {{percent}}% НДС ({{amount}})",
  total_amount_with_tax: "Общая сумма (с налогом)",
  total_amount_with_shipping: "Общая сумма (с учетом доставки)"
}, rg = {
  public_pages_purchase: ng
}, ig = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditná alebo debetná karta",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  },
  product: "Produkt",
  quantity: "Množstvo",
  order_summary: "Zhrnutie objednávky",
  vat: "Daň z predaja",
  total: "Celkom",
  subtotal: "Medzisúčet",
  shipping: {
    shipping_method: "Spôsob dopravy",
    not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.",
    condition_label: {
      price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}",
      price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac",
      quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami",
      quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek",
      weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g",
      weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac"
    }
  },
  shipping_fee: "Poplatok za dopravu",
  total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)",
  vat_percent: "Daň z predaja ({{percent}}%)",
  including_tax: "Vrátane DPH {{percent}}% ({{amount}})",
  total_amount_with_tax: "Celkom (vrátane dane)",
  total_amount_with_shipping: "Celkom (vrátane dopravy)"
}, og = {
  public_pages_purchase: ig
}, sg = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditna ali debetna kartica",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  },
  product: "Izdelek",
  quantity: "Količina",
  order_summary: "Povzetek naročila",
  vat: "Davek na prodajo",
  total: "Skupaj",
  subtotal: "Medseštevek",
  shipping: {
    shipping_method: "Način dostave",
    not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.",
    condition_label: {
      price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}",
      price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več",
      quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli",
      quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov",
      weight: "Za naročila s skupno težo med {{min}}g in {{max}}g",
      weight_min: "Za naročila s skupno težo {{min}}g ali več"
    }
  },
  shipping_fee: "Strošek dostave",
  total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)",
  vat_percent: "Davek na prodajo ({{percent}}%)",
  including_tax: "Vključeno {{percent}}% DDV ({{amount}})",
  total_amount_with_tax: "Skupaj (vključno z davkom)",
  total_amount_with_shipping: "Skupaj (vključno s poštnino)"
}, lg = {
  public_pages_purchase: sg
}, cg = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartë krediti ose debiti",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  },
  product: "Produkt",
  quantity: "Sasia",
  order_summary: "Përmbledhja e Porosisë",
  vat: "Tatimi mbi shitjet",
  total: "Totali",
  subtotal: "Nëntotali",
  shipping: {
    shipping_method: "Metoda e Dërgesës",
    not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.",
    condition_label: {
      price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}",
      price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë",
      quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj",
      quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj",
      weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g",
      weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë"
    }
  },
  shipping_fee: "Tarifa e dërgesës",
  total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)",
  vat_percent: "Tatimi mbi shitjet ({{percent}}%)",
  including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})",
  total_amount_with_tax: "Totali (përfshirë taksën)",
  total_amount_with_shipping: "Totali (përfshirë Transportin)"
}, ug = {
  public_pages_purchase: cg
}, dg = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Kreditna ili debitna kartica",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  },
  product: "Proizvod",
  quantity: "Količina",
  order_summary: "Pregled narudžbine",
  vat: "Porez na promet",
  total: "Ukupno",
  subtotal: "Međuzbir",
  shipping: {
    shipping_method: "Metod isporuke",
    not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.",
    condition_label: {
      price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Za narudžbine od {{min}} {{currency}} ili više",
      quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki",
      quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki",
      weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g",
      weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više"
    }
  },
  shipping_fee: "Trošak isporuke",
  total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)",
  vat_percent: "Porez na promet ({{percent}}%)",
  including_tax: "Uključujući {{percent}}% PDV ({{amount}})",
  total_amount_with_tax: "Ukupno (uključujući porez)",
  total_amount_with_shipping: "Ukupno (uključujući dostavu)"
}, Cg = {
  public_pages_purchase: dg
}, pg = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kredit- eller betalkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  },
  product: "Produkt",
  quantity: "Antal",
  order_summary: "Orderöversikt",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsumma",
  shipping: {
    shipping_method: "Fraktmetod",
    not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.",
    condition_label: {
      price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}",
      price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer",
      quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar",
      quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar",
      weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g",
      weight_min: "För beställningar med en totalvikt av {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktavgift",
  total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)",
  vat_percent: "Moms ({{percent}}%)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})",
  total_amount_with_tax: "Totalt (inklusive moms)",
  total_amount_with_shipping: "Totalt (inklusive frakt)"
}, hg = {
  public_pages_purchase: pg
}, fg = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิตหรือเดบิต",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  },
  product: "ผลิตภัณฑ์",
  quantity: "จำนวน",
  order_summary: "สรุปคำสั่งซื้อ",
  vat: "ภาษีขาย",
  total: "รวม",
  subtotal: "ยอดรวมย่อย",
  shipping: {
    shipping_method: "วิธีการจัดส่ง",
    not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้",
    condition_label: {
      price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}",
      price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป",
      quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ",
      quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป",
      weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g",
      weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป"
    }
  },
  shipping_fee: "ค่าจัดส่ง",
  total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)",
  vat_percent: "ภาษีขาย ({{percent}}%)",
  including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})",
  total_amount_with_tax: "รวมทั้งภาษีแล้ว",
  total_amount_with_shipping: "รวมค่าส่งแล้ว"
}, mg = {
  public_pages_purchase: fg
}, gg = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi veya banka kartı",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Tarihinden itibaren",
    to: "Tarihine kadar"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  },
  product: "Ürün",
  quantity: "Miktar",
  order_summary: "Sipariş Özeti",
  vat: "Satış vergisi",
  total: "Toplam",
  subtotal: "Ara Toplam",
  shipping: {
    shipping_method: "Gönderim Yöntemi",
    not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.",
    condition_label: {
      price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için",
      price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için",
      quantity: "{{min}} ile {{max}} ürün içeren siparişler için",
      quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için",
      weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için",
      weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için"
    }
  },
  shipping_fee: "Gönderim ücreti",
  total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)",
  vat_percent: "Satış vergisi ({{percent}}%)",
  including_tax: "KDV dahil {{percent}}% ({{amount}})",
  total_amount_with_tax: "Toplam (vergiler dahil)",
  total_amount_with_shipping: "Toplam (kargo dahil)"
}, vg = {
  public_pages_purchase: gg
}, bg = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитна або дебетова карта",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "Українська",
    albania: "албанець"
  },
  product: "Продукт",
  quantity: "Кількість",
  order_summary: "Підсумок замовлення",
  vat: "Податок на продаж",
  total: "Всього",
  subtotal: "Проміжний підсумок",
  shipping: {
    shipping_method: "Спосіб доставки",
    not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.",
    condition_label: {
      price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше",
      quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів",
      quantity_min: "Для замовлень, що містять {{min}} або більше товарів",
      weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g",
      weight_min: "Для замовлень з загальною вагою {{min}}g або більше"
    }
  },
  shipping_fee: "Вартість доставки",
  total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)",
  vat_percent: "Податок з продажу ({{percent}}%)",
  including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})",
  total_amount_with_tax: "Загалом (з урахуванням податку)",
  total_amount_with_shipping: "Загалом (з урахуванням доставки)"
}, yg = {
  public_pages_purchase: bg
}, xg = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡或借记卡",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  },
  product: "产品",
  quantity: "数量",
  order_summary: "订单摘要",
  vat: "销售税",
  total: "总计",
  subtotal: "小计",
  shipping: {
    shipping_method: "运输方式",
    not_available: "哎呀！看起来我们还不提供该地点的运输服务。",
    condition_label: {
      price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单",
      price_min: "对于价格在 {{min}} {{currency}} 或以上的订单",
      quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单",
      quantity_min: "对于包含 {{min}} 件或更多商品的订单",
      weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单",
      weight_min: "对于总重量在 {{min}}g 或以上的订单"
    }
  },
  shipping_fee: "运费",
  total_amount_with_tax_and_shipping: "总计（包括税费和运费）",
  vat_percent: "销售税 ({{percent}}%)",
  including_tax: "含{{percent}}%增值税（{{amount}}）",
  total_amount_with_tax: "总计（含税）",
  total_amount_with_shipping: "总计（含运费）"
}, wg = {
  public_pages_purchase: xg
}, Rr = ["common"], _g = Rr[0], Mg = Object.values(j1), Sg = {
  ar: { common: wm },
  cs: { common: Mm },
  da: { common: km },
  de: { common: Hm },
  el: { common: Tm },
  en: { common: Vm },
  es: { common: Em },
  fr: { common: Dm },
  hi: { common: Rm },
  hu: { common: Om },
  id: { common: Zm },
  it: { common: Km },
  ja: { common: Um },
  nl: { common: Wm },
  no: { common: Jm },
  pl: { common: Qm },
  pt: { common: eg },
  ro: { common: ag },
  ru: { common: rg },
  sk: { common: og },
  sl: { common: lg },
  sq: { common: ug },
  sr: { common: Cg },
  sv: { common: hg },
  th: { common: mg },
  tr: { common: vg },
  uk: { common: yg },
  zh: { common: wg }
}, kg = {
  supportedLngs: Mg,
  load: "languageOnly",
  debug: !1,
  defaultNS: _g,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: Rr,
  compatibilityJSON: "v3",
  fallbackLng: j1.ENGLISH,
  lng: j1.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Sg
};
c1.use(Jf).init(kg);
const WH = (e) => {
  switch (e) {
    case e2.Stripe:
      return "Stripe";
    case e2.PaypalSoap:
    case e2.PaypalRest:
      return "PayPal";
    case e2.Dlocal:
      return "dLocal";
    case e2.MercadoPagoBR:
    case e2.MercadoPagoCO:
    case e2.MercadoPagoMX:
    case e2.MercadoPagoAR:
    case e2.MercadoPagoCL:
      return "Mercado Pago";
    case e2.Razorpay:
      return "Razorpay";
    case e2.Flutterwave:
      return "Flutterwave";
    case e2.Mollie:
      return "Mollie";
    case e2.Gocardless:
      return "GoCardless";
    case e2.XenditID:
    case e2.XenditPH:
      return "Xendit";
    case e2.PaystackGH:
    case e2.PaystackKE:
    case e2.PaystackNG:
    case e2.PaystackZA:
    case e2.PaystackEG:
    case e2.PaystackCI:
      return "Paystack";
    case e2.CashOnDelivery:
      return c1.t("public_pages_purchase.payment.cash_on_delivery");
    case e2.SecureAndPay:
      return "Secure and Pay";
  }
};
var e2 = /* @__PURE__ */ ((e) => (e.Stripe = "stripe", e.PaypalSoap = "paypal-soap", e.Dlocal = "dlocal", e.MercadoPagoBR = "mercadopago-br", e.MercadoPagoCO = "mercadopago-co", e.MercadoPagoMX = "mercadopago-mx", e.MercadoPagoAR = "mercadopago-ar", e.MercadoPagoCL = "mercadopago-cl", e.Razorpay = "razorpay", e.Flutterwave = "flutterwave", e.Mollie = "mollie", e.Gocardless = "gocardless", e.XenditID = "xendit-id", e.XenditPH = "xendit-ph", e.PaystackGH = "paystack-gh", e.PaystackKE = "paystack-ke", e.PaystackNG = "paystack-ng", e.PaystackZA = "paystack-za", e.PaystackEG = "paystack-eg", e.PaystackCI = "paystack-ci", e.CashOnDelivery = "cash-on-delivery", e.PaypalRest = "paypal-rest", e.SecureAndPay = "secure-and-pay", e))(e2 || {});
const $H = (e) => {
  switch (e) {
    case u1.stripe_card:
      return c1.t("public_pages_purchase.payment.stripe_card");
    case u1.stripe_ideal:
      return c1.t("public_pages_purchase.payment.stripe_ideal");
    case u1.stripe_bancontact:
      return c1.t("public_pages_purchase.payment.stripe_bancotact");
    case u1.stripe_applepay:
      return c1.t("public_pages_purchase.payment.stripe_applepay");
    case u1.dlocal_card:
      return c1.t("public_pages_purchase.payment.dlocal_card");
    case u1.dlocal_boleto:
      return c1.t("public_pages_purchase.payment.dlocal_boleto");
    case u1.dlocal_pix:
      return c1.t("public_pages_purchase.payment.dlocal_pix");
    case u1.paypal_soap:
    case u1.paypal_rest:
      return c1.t("public_pages_purchase.payment.paypal_soap");
    case u1.mercadopago_br_card:
      return c1.t("public_pages_purchase.payment.mercadopago_card");
    case u1.mercadopago_br_pix:
      return c1.t("public_pages_purchase.payment.mercadopago_pix");
    case u1.mercadopago_br_boleto:
      return c1.t("public_pages_purchase.payment.mercadopago_boleto");
    case u1.mercadopago_co_card:
    case u1.mercadopago_ar_card:
    case u1.mercadopago_mx_card:
    case u1.mercadopago_cl_card:
      return c1.t("public_pages_purchase.payment.mercadopago_card");
    case u1.razorpay:
      return c1.t("public_pages_purchase.payment.razorpay");
    case u1.flutterwave:
      return c1.t("public_pages_purchase.payment.flutterwave");
    case u1.mollie:
      return c1.t("public_pages_purchase.payment.mollie");
    case u1.gocardless:
      return c1.t("public_pages_purchase.payment.gocardless");
    case u1.cash_on_delivery:
      return c1.t("public_pages_purchase.payment.cash_on_delivery");
    case u1.xendit_id_card:
    case u1.xendit_ph_card:
      return c1.t("public_pages_purchase.payment.xendit_card");
    case u1.paystack_gh_card:
    case u1.paystack_ke_card:
    case u1.paystack_ng_card:
    case u1.paystack_za_card:
    case u1.paystack_eg_card:
    case u1.paystack_ci_card:
      return c1.t("public_pages_purchase.payment.paystack_card");
    case u1.secure_and_pay:
      return c1.t("public_pages_purchase.payment.secure_and_pay");
  }
}, JH = (e, t) => {
  switch (e) {
    case u1.stripe_card:
    case u1.dlocal_card:
    case u1.mercadopago_br_card:
    case u1.mercadopago_ar_card:
    case u1.mercadopago_co_card:
    case u1.mercadopago_mx_card:
    case u1.mercadopago_cl_card:
    case u1.secure_and_pay:
      return /* @__PURE__ */ s.jsx(Oh, { ...t });
    case u1.stripe_applepay:
      return /* @__PURE__ */ s.jsx(Th, { ...t });
    case u1.stripe_ideal:
      return /* @__PURE__ */ s.jsx(Kh, { ...t });
    case u1.stripe_bancontact:
      return /* @__PURE__ */ s.jsx(Vh, { ...t });
    case u1.dlocal_boleto:
    case u1.mercadopago_br_boleto:
      return /* @__PURE__ */ s.jsx(Ah, { ...t });
    case u1.dlocal_pix:
    case u1.mercadopago_br_pix:
      return /* @__PURE__ */ s.jsx($h, { ...t });
    case u1.paypal_soap:
    case u1.paypal_rest:
      return /* @__PURE__ */ s.jsx(Yh, { ...t });
    case u1.razorpay:
      return /* @__PURE__ */ s.jsx(Jh, { ...t });
    case u1.flutterwave:
      return /* @__PURE__ */ s.jsx(Zh, { ...t });
    case u1.mollie:
      return /* @__PURE__ */ s.jsx(Uh, { ...t });
    case u1.gocardless:
      return /* @__PURE__ */ s.jsx(Gh, { ...t });
    case u1.cash_on_delivery:
      return /* @__PURE__ */ s.jsx(Ih, { ...t });
    case u1.xendit_id_card:
    case u1.xendit_ph_card:
      return /* @__PURE__ */ s.jsx(Qh, { ...t });
    case u1.paystack_gh_card:
    case u1.paystack_ke_card:
    case u1.paystack_ng_card:
    case u1.paystack_za_card:
    case u1.paystack_eg_card:
    case u1.paystack_ci_card:
      return /* @__PURE__ */ s.jsx(Wh, { ...t });
  }
};
var u1 = /* @__PURE__ */ ((e) => (e.stripe_card = "stripe:card", e.stripe_ideal = "stripe:ideal", e.stripe_bancontact = "stripe:bancontact", e.stripe_applepay = "stripe:applepay", e.dlocal_card = "dlocal:card", e.dlocal_boleto = "dlocal:boleto", e.dlocal_pix = "dlocal:pix", e.paypal_soap = "paypal-soap", e.paypal_rest = "paypal-rest", e.mercadopago_br_card = "mercadopago-br:card", e.mercadopago_br_pix = "mercadopago-br:pix", e.mercadopago_br_boleto = "mercadopago-br:boleto", e.mercadopago_co_card = "mercadopago-co:card", e.mercadopago_ar_card = "mercadopago-ar:card", e.mercadopago_mx_card = "mercadopago-mx:card", e.mercadopago_cl_card = "mercadopago-cl:card", e.razorpay = "razorpay", e.flutterwave = "flutterwave", e.mollie = "mollie", e.gocardless = "gocardless", e.cash_on_delivery = "cash-on-delivery", e.xendit_id_card = "xendit-id:card", e.xendit_ph_card = "xendit-ph:card", e.paystack_gh_card = "paystack-gh:card", e.paystack_ke_card = "paystack-ke:card", e.paystack_ng_card = "paystack-ng:card", e.paystack_za_card = "paystack-za:card", e.paystack_eg_card = "paystack-eg:card", e.paystack_ci_card = "paystack-ci:card", e.secure_and_pay = "secure-and-pay", e))(u1 || {}), y4 = /* @__PURE__ */ ((e) => (e.dateFirst = "d/m/Y", e.monthFirst = "m/d/Y", e))(y4 || {}), Lg = /* @__PURE__ */ ((e) => (e.hourMinute = "H:i", e.hourMinuteAmPm = "h:i A", e.hourMinuteSecond = "H:i:s", e.hourMinuteSecondAmPm = "h:i:s A", e))(Lg || {});
function Fr(e) {
  const t = Object.keys(N1).find(
    (r) => N1[r] === e
  );
  return t ? j1[t] : j1.ENGLISH;
}
function qH(e) {
  const t = Object.keys(j1).find(
    (r) => j1[r] === e
  );
  return t ? N1[t] : N1.ENGLISH;
}
function QH(e) {
  return c1.t(Hg[e]);
}
var N1 = /* @__PURE__ */ ((e) => (e.ENGLISH = "en", e.FRENCH = "fr", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "jp", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "dk", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "ua", e.ALBANIA = "sq", e.HINDI = "hi", e))(N1 || {});
const XH = {
  en: "EN",
  fr: "FR",
  es: "ES",
  it: "IT",
  pt: "PT",
  de: "DE",
  nl: "NL",
  ru: "RU",
  jp: "JP",
  ar: "AR",
  tr: "TR",
  zh: "CH",
  sv: "SV",
  ro: "RO",
  cs: "CS",
  hu: "HU",
  sk: "SK",
  dk: "DK",
  id: "ID",
  pl: "PL",
  el: "EL",
  sr: "SR",
  hi: "HI",
  no: "NO",
  th: "TH",
  sl: "SL",
  ua: "UA",
  sq: "SQ"
}, eP = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  de: "Deutsch",
  nl: "Nederlands",
  ru: "Русский",
  jp: "日本語",
  ar: "عربي",
  tr: "Türkçe",
  zh: "中文(简体)",
  sv: "Svenska",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sk: "Slovenský",
  dk: "Dansk",
  id: "Indonesian",
  pl: "Polski",
  el: "Ελληνικά",
  sr: "Srpski",
  hi: "Hindi",
  no: "Norsk",
  th: "ไทย",
  sl: "Slovenski",
  ua: "Український",
  sq: "Shqiptare"
}, Hg = {
  en: "public_pages_purchase.locale.english",
  fr: "public_pages_purchase.locale.french",
  es: "public_pages_purchase.locale.spanish",
  it: "public_pages_purchase.locale.italian",
  pt: "public_pages_purchase.locale.portuguese",
  de: "public_pages_purchase.locale.german",
  nl: "public_pages_purchase.locale.dutch",
  ru: "public_pages_purchase.locale.russian",
  jp: "public_pages_purchase.locale.japanese",
  zh: "public_pages_purchase.locale.chinese",
  tr: "public_pages_purchase.locale.turkish",
  ar: "public_pages_purchase.locale.arabic",
  sv: "public_pages_purchase.locale.swedish",
  ro: "public_pages_purchase.locale.romanian",
  cs: "public_pages_purchase.locale.czech",
  hu: "public_pages_purchase.locale.hungarian",
  sk: "public_pages_purchase.locale.slovak",
  dk: "public_pages_purchase.locale.danish",
  id: "public_pages_purchase.locale.indonesian",
  pl: "public_pages_purchase.locale.polish",
  el: "public_pages_purchase.locale.greek",
  sr: "public_pages_purchase.locale.serbian",
  hi: "public_pages_purchase.locale.hindi",
  no: "public_pages_purchase.locale.norwegian",
  th: "public_pages_purchase.locale.thai",
  sl: "public_pages_purchase.locale.slovenian",
  ua: "public_pages_purchase.locale.ukrainian",
  sq: "public_pages_purchase.locale.albania"
}, Pg = V1(null), tP = ({
  children: e,
  locale: t
}) => (h1(() => {
  if (!c1.isInitialized)
    return;
  const r = Fr(t);
  c1.language !== r && c1.changeLanguage(r);
}, [t]), /* @__PURE__ */ s.jsx(Pg.Provider, { value: { locale: t }, children: e }));
var Ae = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.AlandIslands = "AX", e.Albania = "AL", e.Algeria = "DZ", e.AmericanSamoa = "AS", e.Andorra = "AD", e.Angola = "AO", e.Anguilla = "AI", e.Antarctica = "AQ", e.AntiguaAndBarbuda = "AG", e.Argentina = "AR", e.Armenia = "AM", e.Aruba = "AW", e.Australia = "AU", e.Austria = "AT", e.Azerbaijan = "AZ", e.Bahamas = "BS", e.Bahrain = "BH", e.Bangladesh = "BD", e.Barbados = "BB", e.Belarus = "BY", e.Belgium = "BE", e.Belize = "BZ", e.Benin = "BJ", e.Bermuda = "BM", e.Bhutan = "BT", e.Bolivia = "BO", e.BonaireSintEustatiusSaba = "BQ", e.BosniaAndHerzegovina = "BA", e.Botswana = "BW", e.BouvetIsland = "BV", e.Brazil = "BR", e.BritishIndianOceanTerritory = "IO", e.BruneiDarussalam = "BN", e.Bulgaria = "BG", e.BurkinaFaso = "BF", e.Burundi = "BI", e.Cambodia = "KH", e.Cameroon = "CM", e.Canada = "CA", e.CapeVerde = "CV", e.CaymanIslands = "KY", e.CentralAfricanRepublic = "CF", e.Chad = "TD", e.Chile = "CL", e.China = "CN", e.ChristmasIsland = "CX", e.CocosKeelingIslands = "CC", e.Colombia = "CO", e.Comoros = "KM", e.Congo = "CG", e.CongoDemocraticRepublic = "CD", e.CookIslands = "CK", e.CostaRica = "CR", e.CoteDIvoire = "CI", e.Croatia = "HR", e.Cuba = "CU", e.Curaçao = "CW", e.Cyprus = "CY", e.CzechRepublic = "CZ", e.Denmark = "DK", e.Djibouti = "DJ", e.Dominica = "DM", e.DominicanRepublic = "DO", e.Ecuador = "EC", e.Egypt = "EG", e.ElSalvador = "SV", e.EquatorialGuinea = "GQ", e.Eritrea = "ER", e.Estonia = "EE", e.Ethiopia = "ET", e.FalklandIslands = "FK", e.FaroeIslands = "FO", e.Fiji = "FJ", e.Finland = "FI", e.France = "FR", e.FrenchGuiana = "GF", e.FrenchPolynesia = "PF", e.FrenchSouthernTerritories = "TF", e.Gabon = "GA", e.Gambia = "GM", e.Georgia = "GE", e.Germany = "DE", e.Ghana = "GH", e.Gibraltar = "GI", e.Greece = "GR", e.Greenland = "GL", e.Grenada = "GD", e.Guadeloupe = "GP", e.Guam = "GU", e.Guatemala = "GT", e.Guernsey = "GG", e.Guinea = "GN", e.GuineaBissau = "GW", e.Guyana = "GY", e.Haiti = "HT", e.HeardIslandMcdonaldIslands = "HM", e.HolySeeVaticanCityState = "VA", e.Honduras = "HN", e.HongKong = "HK", e.Hungary = "HU", e.Iceland = "IS", e.India = "IN", e.Indonesia = "ID", e.Iran = "IR", e.Iraq = "IQ", e.Ireland = "IE", e.IsleOfMan = "IM", e.Israel = "IL", e.Italy = "IT", e.Jamaica = "JM", e.Japan = "JP", e.Jersey = "JE", e.Jordan = "JO", e.Kazakhstan = "KZ", e.Kenya = "KE", e.Kiribati = "KI", e.Korea = "KR", e.KoreaDemocraticPeoplesRepublic = "KP", e.Kuwait = "KW", e.Kyrgyzstan = "KG", e.LaoPeoplesDemocraticRepublic = "LA", e.Latvia = "LV", e.Lebanon = "LB", e.Lesotho = "LS", e.Liberia = "LR", e.LibyanArabJamahiriya = "LY", e.Liechtenstein = "LI", e.Lithuania = "LT", e.Luxembourg = "LU", e.Macao = "MO", e.Macedonia = "MK", e.Madagascar = "MG", e.Malawi = "MW", e.Malaysia = "MY", e.Maldives = "MV", e.Mali = "ML", e.Malta = "MT", e.MarshallIslands = "MH", e.Martinique = "MQ", e.Mauritania = "MR", e.Mauritius = "MU", e.Mayotte = "YT", e.Mexico = "MX", e.Micronesia = "FM", e.Moldova = "MD", e.Monaco = "MC", e.Mongolia = "MN", e.Montenegro = "ME", e.Montserrat = "MS", e.Morocco = "MA", e.Mozambique = "MZ", e.Myanmar = "MM", e.Namibia = "NA", e.Nauru = "NR", e.Nepal = "NP", e.Netherlands = "NL", e.NewCaledonia = "NC", e.NewZealand = "NZ", e.Nicaragua = "NI", e.Niger = "NE", e.Nigeria = "NG", e.Niue = "NU", e.NorfolkIsland = "NF", e.NorthernMarianaIslands = "MP", e.Norway = "NO", e.Oman = "OM", e.Pakistan = "PK", e.Palau = "PW", e.PalestinianTerritory = "PS", e.Panama = "PA", e.PapuaNewGuinea = "PG", e.Paraguay = "PY", e.Peru = "PE", e.Philippines = "PH", e.Pitcairn = "PN", e.Poland = "PL", e.Portugal = "PT", e.PuertoRico = "PR", e.Qatar = "QA", e.Reunion = "RE", e.Romania = "RO", e.RussianFederation = "RU", e.Rwanda = "RW", e.SaintBarthelemy = "BL", e.SaintHelena = "SH", e.SaintKittsAndNevis = "KN", e.SaintLucia = "LC", e.SaintMartin = "MF", e.SaintPierreAndMiquelon = "PM", e.SaintVincentAndGrenadines = "VC", e.Samoa = "WS", e.SanMarino = "SM", e.SaoTomeAndPrincipe = "ST", e.SaudiArabia = "SA", e.Senegal = "SN", e.Serbia = "RS", e.Seychelles = "SC", e.SierraLeone = "SL", e.Singapore = "SG", e.SintMaarten = "SX", e.Slovakia = "SK", e.Slovenia = "SI", e.SolomonIslands = "SB", e.Somalia = "SO", e.SouthAfrica = "ZA", e.SouthGeorgiaAndSandwichIsl = "GS", e.SouthSudan = "SS", e.Spain = "ES", e.SriLanka = "LK", e.Sudan = "SD", e.Suriname = "SR", e.SvalbardAndJanMayen = "SJ", e.Swaziland = "SZ", e.Sweden = "SE", e.Switzerland = "CH", e.SyrianArabRepublic = "SY", e.Taiwan = "TW", e.Tajikistan = "TJ", e.Tanzania = "TZ", e.Thailand = "TH", e.TimorLeste = "TL", e.Togo = "TG", e.Tokelau = "TK", e.Tonga = "TO", e.TrinidadAndTobago = "TT", e.Tunisia = "TN", e.Turkey = "TR", e.Turkmenistan = "TM", e.TurksAndCaicosIslands = "TC", e.Tuvalu = "TV", e.Uganda = "UG", e.Ukraine = "UA", e.UnitedArabEmirates = "AE", e.UnitedKingdom = "GB", e.UnitedStates = "US", e.UnitedStatesOutlyingIslands = "UM", e.Uruguay = "UY", e.Uzbekistan = "UZ", e.Vanuatu = "VU", e.Venezuela = "VE", e.Vietnam = "VN", e.VirginIslandsBritish = "VG", e.VirginIslandsUS = "VI", e.WallisAndFutuna = "WF", e.WesternSahara = "EH", e.Yemen = "YE", e.Zambia = "ZM", e.Zimbabwe = "ZW", e))(Ae || {}), Or = {};
const Tg = [
  [
    "AF",
    "AFG",
    "004",
    "ISO 3166-2:AF"
  ],
  [
    "AL",
    "ALB",
    "008",
    "ISO 3166-2:AL"
  ],
  [
    "DZ",
    "DZA",
    "012",
    "ISO 3166-2:DZ"
  ],
  [
    "AS",
    "ASM",
    "016",
    "ISO 3166-2:AS"
  ],
  [
    "AD",
    "AND",
    "020",
    "ISO 3166-2:AD"
  ],
  [
    "AO",
    "AGO",
    "024",
    "ISO 3166-2:AO"
  ],
  [
    "AI",
    "AIA",
    "660",
    "ISO 3166-2:AI"
  ],
  [
    "AQ",
    "ATA",
    "010",
    "ISO 3166-2:AQ"
  ],
  [
    "AG",
    "ATG",
    "028",
    "ISO 3166-2:AG"
  ],
  [
    "AR",
    "ARG",
    "032",
    "ISO 3166-2:AR"
  ],
  [
    "AM",
    "ARM",
    "051",
    "ISO 3166-2:AM"
  ],
  [
    "AW",
    "ABW",
    "533",
    "ISO 3166-2:AW"
  ],
  [
    "AU",
    "AUS",
    "036",
    "ISO 3166-2:AU"
  ],
  [
    "AT",
    "AUT",
    "040",
    "ISO 3166-2:AT"
  ],
  [
    "AZ",
    "AZE",
    "031",
    "ISO 3166-2:AZ"
  ],
  [
    "BS",
    "BHS",
    "044",
    "ISO 3166-2:BS"
  ],
  [
    "BH",
    "BHR",
    "048",
    "ISO 3166-2:BH"
  ],
  [
    "BD",
    "BGD",
    "050",
    "ISO 3166-2:BD"
  ],
  [
    "BB",
    "BRB",
    "052",
    "ISO 3166-2:BB"
  ],
  [
    "BY",
    "BLR",
    "112",
    "ISO 3166-2:BY"
  ],
  [
    "BE",
    "BEL",
    "056",
    "ISO 3166-2:BE"
  ],
  [
    "BZ",
    "BLZ",
    "084",
    "ISO 3166-2:BZ"
  ],
  [
    "BJ",
    "BEN",
    "204",
    "ISO 3166-2:BJ"
  ],
  [
    "BM",
    "BMU",
    "060",
    "ISO 3166-2:BM"
  ],
  [
    "BT",
    "BTN",
    "064",
    "ISO 3166-2:BT"
  ],
  [
    "BO",
    "BOL",
    "068",
    "ISO 3166-2:BO"
  ],
  [
    "BA",
    "BIH",
    "070",
    "ISO 3166-2:BA"
  ],
  [
    "BW",
    "BWA",
    "072",
    "ISO 3166-2:BW"
  ],
  [
    "BV",
    "BVT",
    "074",
    "ISO 3166-2:BV"
  ],
  [
    "BR",
    "BRA",
    "076",
    "ISO 3166-2:BR"
  ],
  [
    "IO",
    "IOT",
    "086",
    "ISO 3166-2:IO"
  ],
  [
    "BN",
    "BRN",
    "096",
    "ISO 3166-2:BN"
  ],
  [
    "BG",
    "BGR",
    "100",
    "ISO 3166-2:BG"
  ],
  [
    "BF",
    "BFA",
    "854",
    "ISO 3166-2:BF"
  ],
  [
    "BI",
    "BDI",
    "108",
    "ISO 3166-2:BI"
  ],
  [
    "KH",
    "KHM",
    "116",
    "ISO 3166-2:KH"
  ],
  [
    "CM",
    "CMR",
    "120",
    "ISO 3166-2:CM"
  ],
  [
    "CA",
    "CAN",
    "124",
    "ISO 3166-2:CA"
  ],
  [
    "CV",
    "CPV",
    "132",
    "ISO 3166-2:CV"
  ],
  [
    "KY",
    "CYM",
    "136",
    "ISO 3166-2:KY"
  ],
  [
    "CF",
    "CAF",
    "140",
    "ISO 3166-2:CF"
  ],
  [
    "TD",
    "TCD",
    "148",
    "ISO 3166-2:TD"
  ],
  [
    "CL",
    "CHL",
    "152",
    "ISO 3166-2:CL"
  ],
  [
    "CN",
    "CHN",
    "156",
    "ISO 3166-2:CN"
  ],
  [
    "CX",
    "CXR",
    "162",
    "ISO 3166-2:CX"
  ],
  [
    "CC",
    "CCK",
    "166",
    "ISO 3166-2:CC"
  ],
  [
    "CO",
    "COL",
    "170",
    "ISO 3166-2:CO"
  ],
  [
    "KM",
    "COM",
    "174",
    "ISO 3166-2:KM"
  ],
  [
    "CG",
    "COG",
    "178",
    "ISO 3166-2:CG"
  ],
  [
    "CD",
    "COD",
    "180",
    "ISO 3166-2:CD"
  ],
  [
    "CK",
    "COK",
    "184",
    "ISO 3166-2:CK"
  ],
  [
    "CR",
    "CRI",
    "188",
    "ISO 3166-2:CR"
  ],
  [
    "CI",
    "CIV",
    "384",
    "ISO 3166-2:CI"
  ],
  [
    "HR",
    "HRV",
    "191",
    "ISO 3166-2:HR"
  ],
  [
    "CU",
    "CUB",
    "192",
    "ISO 3166-2:CU"
  ],
  [
    "CY",
    "CYP",
    "196",
    "ISO 3166-2:CY"
  ],
  [
    "CZ",
    "CZE",
    "203",
    "ISO 3166-2:CZ"
  ],
  [
    "DK",
    "DNK",
    "208",
    "ISO 3166-2:DK"
  ],
  [
    "DJ",
    "DJI",
    "262",
    "ISO 3166-2:DJ"
  ],
  [
    "DM",
    "DMA",
    "212",
    "ISO 3166-2:DM"
  ],
  [
    "DO",
    "DOM",
    "214",
    "ISO 3166-2:DO"
  ],
  [
    "EC",
    "ECU",
    "218",
    "ISO 3166-2:EC"
  ],
  [
    "EG",
    "EGY",
    "818",
    "ISO 3166-2:EG"
  ],
  [
    "SV",
    "SLV",
    "222",
    "ISO 3166-2:SV"
  ],
  [
    "GQ",
    "GNQ",
    "226",
    "ISO 3166-2:GQ"
  ],
  [
    "ER",
    "ERI",
    "232",
    "ISO 3166-2:ER"
  ],
  [
    "EE",
    "EST",
    "233",
    "ISO 3166-2:EE"
  ],
  [
    "ET",
    "ETH",
    "231",
    "ISO 3166-2:ET"
  ],
  [
    "FK",
    "FLK",
    "238",
    "ISO 3166-2:FK"
  ],
  [
    "FO",
    "FRO",
    "234",
    "ISO 3166-2:FO"
  ],
  [
    "FJ",
    "FJI",
    "242",
    "ISO 3166-2:FJ"
  ],
  [
    "FI",
    "FIN",
    "246",
    "ISO 3166-2:FI"
  ],
  [
    "FR",
    "FRA",
    "250",
    "ISO 3166-2:FR"
  ],
  [
    "GF",
    "GUF",
    "254",
    "ISO 3166-2:GF"
  ],
  [
    "PF",
    "PYF",
    "258",
    "ISO 3166-2:PF"
  ],
  [
    "TF",
    "ATF",
    "260",
    "ISO 3166-2:TF"
  ],
  [
    "GA",
    "GAB",
    "266",
    "ISO 3166-2:GA"
  ],
  [
    "GM",
    "GMB",
    "270",
    "ISO 3166-2:GM"
  ],
  [
    "GE",
    "GEO",
    "268",
    "ISO 3166-2:GE"
  ],
  [
    "DE",
    "DEU",
    "276",
    "ISO 3166-2:DE"
  ],
  [
    "GH",
    "GHA",
    "288",
    "ISO 3166-2:GH"
  ],
  [
    "GI",
    "GIB",
    "292",
    "ISO 3166-2:GI"
  ],
  [
    "GR",
    "GRC",
    "300",
    "ISO 3166-2:GR"
  ],
  [
    "GL",
    "GRL",
    "304",
    "ISO 3166-2:GL"
  ],
  [
    "GD",
    "GRD",
    "308",
    "ISO 3166-2:GD"
  ],
  [
    "GP",
    "GLP",
    "312",
    "ISO 3166-2:GP"
  ],
  [
    "GU",
    "GUM",
    "316",
    "ISO 3166-2:GU"
  ],
  [
    "GT",
    "GTM",
    "320",
    "ISO 3166-2:GT"
  ],
  [
    "GN",
    "GIN",
    "324",
    "ISO 3166-2:GN"
  ],
  [
    "GW",
    "GNB",
    "624",
    "ISO 3166-2:GW"
  ],
  [
    "GY",
    "GUY",
    "328",
    "ISO 3166-2:GY"
  ],
  [
    "HT",
    "HTI",
    "332",
    "ISO 3166-2:HT"
  ],
  [
    "HM",
    "HMD",
    "334",
    "ISO 3166-2:HM"
  ],
  [
    "VA",
    "VAT",
    "336",
    "ISO 3166-2:VA"
  ],
  [
    "HN",
    "HND",
    "340",
    "ISO 3166-2:HN"
  ],
  [
    "HK",
    "HKG",
    "344",
    "ISO 3166-2:HK"
  ],
  [
    "HU",
    "HUN",
    "348",
    "ISO 3166-2:HU"
  ],
  [
    "IS",
    "ISL",
    "352",
    "ISO 3166-2:IS"
  ],
  [
    "IN",
    "IND",
    "356",
    "ISO 3166-2:IN"
  ],
  [
    "ID",
    "IDN",
    "360",
    "ISO 3166-2:ID"
  ],
  [
    "IR",
    "IRN",
    "364",
    "ISO 3166-2:IR"
  ],
  [
    "IQ",
    "IRQ",
    "368",
    "ISO 3166-2:IQ"
  ],
  [
    "IE",
    "IRL",
    "372",
    "ISO 3166-2:IE"
  ],
  [
    "IL",
    "ISR",
    "376",
    "ISO 3166-2:IL"
  ],
  [
    "IT",
    "ITA",
    "380",
    "ISO 3166-2:IT"
  ],
  [
    "JM",
    "JAM",
    "388",
    "ISO 3166-2:JM"
  ],
  [
    "JP",
    "JPN",
    "392",
    "ISO 3166-2:JP"
  ],
  [
    "JO",
    "JOR",
    "400",
    "ISO 3166-2:JO"
  ],
  [
    "KZ",
    "KAZ",
    "398",
    "ISO 3166-2:KZ"
  ],
  [
    "KE",
    "KEN",
    "404",
    "ISO 3166-2:KE"
  ],
  [
    "KI",
    "KIR",
    "296",
    "ISO 3166-2:KI"
  ],
  [
    "KP",
    "PRK",
    "408",
    "ISO 3166-2:KP"
  ],
  [
    "KR",
    "KOR",
    "410",
    "ISO 3166-2:KR"
  ],
  [
    "KW",
    "KWT",
    "414",
    "ISO 3166-2:KW"
  ],
  [
    "KG",
    "KGZ",
    "417",
    "ISO 3166-2:KG"
  ],
  [
    "LA",
    "LAO",
    "418",
    "ISO 3166-2:LA"
  ],
  [
    "LV",
    "LVA",
    "428",
    "ISO 3166-2:LV"
  ],
  [
    "LB",
    "LBN",
    "422",
    "ISO 3166-2:LB"
  ],
  [
    "LS",
    "LSO",
    "426",
    "ISO 3166-2:LS"
  ],
  [
    "LR",
    "LBR",
    "430",
    "ISO 3166-2:LR"
  ],
  [
    "LY",
    "LBY",
    "434",
    "ISO 3166-2:LY"
  ],
  [
    "LI",
    "LIE",
    "438",
    "ISO 3166-2:LI"
  ],
  [
    "LT",
    "LTU",
    "440",
    "ISO 3166-2:LT"
  ],
  [
    "LU",
    "LUX",
    "442",
    "ISO 3166-2:LU"
  ],
  [
    "MO",
    "MAC",
    "446",
    "ISO 3166-2:MO"
  ],
  [
    "MG",
    "MDG",
    "450",
    "ISO 3166-2:MG"
  ],
  [
    "MW",
    "MWI",
    "454",
    "ISO 3166-2:MW"
  ],
  [
    "MY",
    "MYS",
    "458",
    "ISO 3166-2:MY"
  ],
  [
    "MV",
    "MDV",
    "462",
    "ISO 3166-2:MV"
  ],
  [
    "ML",
    "MLI",
    "466",
    "ISO 3166-2:ML"
  ],
  [
    "MT",
    "MLT",
    "470",
    "ISO 3166-2:MT"
  ],
  [
    "MH",
    "MHL",
    "584",
    "ISO 3166-2:MH"
  ],
  [
    "MQ",
    "MTQ",
    "474",
    "ISO 3166-2:MQ"
  ],
  [
    "MR",
    "MRT",
    "478",
    "ISO 3166-2:MR"
  ],
  [
    "MU",
    "MUS",
    "480",
    "ISO 3166-2:MU"
  ],
  [
    "YT",
    "MYT",
    "175",
    "ISO 3166-2:YT"
  ],
  [
    "MX",
    "MEX",
    "484",
    "ISO 3166-2:MX"
  ],
  [
    "FM",
    "FSM",
    "583",
    "ISO 3166-2:FM"
  ],
  [
    "MD",
    "MDA",
    "498",
    "ISO 3166-2:MD"
  ],
  [
    "MC",
    "MCO",
    "492",
    "ISO 3166-2:MC"
  ],
  [
    "MN",
    "MNG",
    "496",
    "ISO 3166-2:MN"
  ],
  [
    "MS",
    "MSR",
    "500",
    "ISO 3166-2:MS"
  ],
  [
    "MA",
    "MAR",
    "504",
    "ISO 3166-2:MA"
  ],
  [
    "MZ",
    "MOZ",
    "508",
    "ISO 3166-2:MZ"
  ],
  [
    "MM",
    "MMR",
    "104",
    "ISO 3166-2:MM"
  ],
  [
    "NA",
    "NAM",
    "516",
    "ISO 3166-2:NA"
  ],
  [
    "NR",
    "NRU",
    "520",
    "ISO 3166-2:NR"
  ],
  [
    "NP",
    "NPL",
    "524",
    "ISO 3166-2:NP"
  ],
  [
    "NL",
    "NLD",
    "528",
    "ISO 3166-2:NL"
  ],
  [
    "NC",
    "NCL",
    "540",
    "ISO 3166-2:NC"
  ],
  [
    "NZ",
    "NZL",
    "554",
    "ISO 3166-2:NZ"
  ],
  [
    "NI",
    "NIC",
    "558",
    "ISO 3166-2:NI"
  ],
  [
    "NE",
    "NER",
    "562",
    "ISO 3166-2:NE"
  ],
  [
    "NG",
    "NGA",
    "566",
    "ISO 3166-2:NG"
  ],
  [
    "NU",
    "NIU",
    "570",
    "ISO 3166-2:NU"
  ],
  [
    "NF",
    "NFK",
    "574",
    "ISO 3166-2:NF"
  ],
  [
    "MP",
    "MNP",
    "580",
    "ISO 3166-2:MP"
  ],
  [
    "MK",
    "MKD",
    "807",
    "ISO 3166-2:MK"
  ],
  [
    "NO",
    "NOR",
    "578",
    "ISO 3166-2:NO"
  ],
  [
    "OM",
    "OMN",
    "512",
    "ISO 3166-2:OM"
  ],
  [
    "PK",
    "PAK",
    "586",
    "ISO 3166-2:PK"
  ],
  [
    "PW",
    "PLW",
    "585",
    "ISO 3166-2:PW"
  ],
  [
    "PS",
    "PSE",
    "275",
    "ISO 3166-2:PS"
  ],
  [
    "PA",
    "PAN",
    "591",
    "ISO 3166-2:PA"
  ],
  [
    "PG",
    "PNG",
    "598",
    "ISO 3166-2:PG"
  ],
  [
    "PY",
    "PRY",
    "600",
    "ISO 3166-2:PY"
  ],
  [
    "PE",
    "PER",
    "604",
    "ISO 3166-2:PE"
  ],
  [
    "PH",
    "PHL",
    "608",
    "ISO 3166-2:PH"
  ],
  [
    "PN",
    "PCN",
    "612",
    "ISO 3166-2:PN"
  ],
  [
    "PL",
    "POL",
    "616",
    "ISO 3166-2:PL"
  ],
  [
    "PT",
    "PRT",
    "620",
    "ISO 3166-2:PT"
  ],
  [
    "PR",
    "PRI",
    "630",
    "ISO 3166-2:PR"
  ],
  [
    "QA",
    "QAT",
    "634",
    "ISO 3166-2:QA"
  ],
  [
    "RE",
    "REU",
    "638",
    "ISO 3166-2:RE"
  ],
  [
    "RO",
    "ROU",
    "642",
    "ISO 3166-2:RO"
  ],
  [
    "RU",
    "RUS",
    "643",
    "ISO 3166-2:RU"
  ],
  [
    "RW",
    "RWA",
    "646",
    "ISO 3166-2:RW"
  ],
  [
    "SH",
    "SHN",
    "654",
    "ISO 3166-2:SH"
  ],
  [
    "KN",
    "KNA",
    "659",
    "ISO 3166-2:KN"
  ],
  [
    "LC",
    "LCA",
    "662",
    "ISO 3166-2:LC"
  ],
  [
    "PM",
    "SPM",
    "666",
    "ISO 3166-2:PM"
  ],
  [
    "VC",
    "VCT",
    "670",
    "ISO 3166-2:VC"
  ],
  [
    "WS",
    "WSM",
    "882",
    "ISO 3166-2:WS"
  ],
  [
    "SM",
    "SMR",
    "674",
    "ISO 3166-2:SM"
  ],
  [
    "ST",
    "STP",
    "678",
    "ISO 3166-2:ST"
  ],
  [
    "SA",
    "SAU",
    "682",
    "ISO 3166-2:SA"
  ],
  [
    "SN",
    "SEN",
    "686",
    "ISO 3166-2:SN"
  ],
  [
    "SC",
    "SYC",
    "690",
    "ISO 3166-2:SC"
  ],
  [
    "SL",
    "SLE",
    "694",
    "ISO 3166-2:SL"
  ],
  [
    "SG",
    "SGP",
    "702",
    "ISO 3166-2:SG"
  ],
  [
    "SK",
    "SVK",
    "703",
    "ISO 3166-2:SK"
  ],
  [
    "SI",
    "SVN",
    "705",
    "ISO 3166-2:SI"
  ],
  [
    "SB",
    "SLB",
    "090",
    "ISO 3166-2:SB"
  ],
  [
    "SO",
    "SOM",
    "706",
    "ISO 3166-2:SO"
  ],
  [
    "ZA",
    "ZAF",
    "710",
    "ISO 3166-2:ZA"
  ],
  [
    "GS",
    "SGS",
    "239",
    "ISO 3166-2:GS"
  ],
  [
    "ES",
    "ESP",
    "724",
    "ISO 3166-2:ES"
  ],
  [
    "LK",
    "LKA",
    "144",
    "ISO 3166-2:LK"
  ],
  [
    "SD",
    "SDN",
    "729",
    "ISO 3166-2:SD"
  ],
  [
    "SR",
    "SUR",
    "740",
    "ISO 3166-2:SR"
  ],
  [
    "SJ",
    "SJM",
    "744",
    "ISO 3166-2:SJ"
  ],
  [
    "SZ",
    "SWZ",
    "748",
    "ISO 3166-2:SZ"
  ],
  [
    "SE",
    "SWE",
    "752",
    "ISO 3166-2:SE"
  ],
  [
    "CH",
    "CHE",
    "756",
    "ISO 3166-2:CH"
  ],
  [
    "SY",
    "SYR",
    "760",
    "ISO 3166-2:SY"
  ],
  [
    "TW",
    "TWN",
    "158",
    "ISO 3166-2:TW"
  ],
  [
    "TJ",
    "TJK",
    "762",
    "ISO 3166-2:TJ"
  ],
  [
    "TZ",
    "TZA",
    "834",
    "ISO 3166-2:TZ"
  ],
  [
    "TH",
    "THA",
    "764",
    "ISO 3166-2:TH"
  ],
  [
    "TL",
    "TLS",
    "626",
    "ISO 3166-2:TL"
  ],
  [
    "TG",
    "TGO",
    "768",
    "ISO 3166-2:TG"
  ],
  [
    "TK",
    "TKL",
    "772",
    "ISO 3166-2:TK"
  ],
  [
    "TO",
    "TON",
    "776",
    "ISO 3166-2:TO"
  ],
  [
    "TT",
    "TTO",
    "780",
    "ISO 3166-2:TT"
  ],
  [
    "TN",
    "TUN",
    "788",
    "ISO 3166-2:TN"
  ],
  [
    "TR",
    "TUR",
    "792",
    "ISO 3166-2:TR"
  ],
  [
    "TM",
    "TKM",
    "795",
    "ISO 3166-2:TM"
  ],
  [
    "TC",
    "TCA",
    "796",
    "ISO 3166-2:TC"
  ],
  [
    "TV",
    "TUV",
    "798",
    "ISO 3166-2:TV"
  ],
  [
    "UG",
    "UGA",
    "800",
    "ISO 3166-2:UG"
  ],
  [
    "UA",
    "UKR",
    "804",
    "ISO 3166-2:UA"
  ],
  [
    "AE",
    "ARE",
    "784",
    "ISO 3166-2:AE"
  ],
  [
    "GB",
    "GBR",
    "826",
    "ISO 3166-2:GB"
  ],
  [
    "US",
    "USA",
    "840",
    "ISO 3166-2:US"
  ],
  [
    "UM",
    "UMI",
    "581",
    "ISO 3166-2:UM"
  ],
  [
    "UY",
    "URY",
    "858",
    "ISO 3166-2:UY"
  ],
  [
    "UZ",
    "UZB",
    "860",
    "ISO 3166-2:UZ"
  ],
  [
    "VU",
    "VUT",
    "548",
    "ISO 3166-2:VU"
  ],
  [
    "VE",
    "VEN",
    "862",
    "ISO 3166-2:VE"
  ],
  [
    "VN",
    "VNM",
    "704",
    "ISO 3166-2:VN"
  ],
  [
    "VG",
    "VGB",
    "092",
    "ISO 3166-2:VG"
  ],
  [
    "VI",
    "VIR",
    "850",
    "ISO 3166-2:VI"
  ],
  [
    "WF",
    "WLF",
    "876",
    "ISO 3166-2:WF"
  ],
  [
    "EH",
    "ESH",
    "732",
    "ISO 3166-2:EH"
  ],
  [
    "YE",
    "YEM",
    "887",
    "ISO 3166-2:YE"
  ],
  [
    "ZM",
    "ZMB",
    "894",
    "ISO 3166-2:ZM"
  ],
  [
    "ZW",
    "ZWE",
    "716",
    "ISO 3166-2:ZW"
  ],
  [
    "AX",
    "ALA",
    "248",
    "ISO 3166-2:AX"
  ],
  [
    "BQ",
    "BES",
    "535",
    "ISO 3166-2:BQ"
  ],
  [
    "CW",
    "CUW",
    "531",
    "ISO 3166-2:CW"
  ],
  [
    "GG",
    "GGY",
    "831",
    "ISO 3166-2:GG"
  ],
  [
    "IM",
    "IMN",
    "833",
    "ISO 3166-2:IM"
  ],
  [
    "JE",
    "JEY",
    "832",
    "ISO 3166-2:JE"
  ],
  [
    "ME",
    "MNE",
    "499",
    "ISO 3166-2:ME"
  ],
  [
    "BL",
    "BLM",
    "652",
    "ISO 3166-2:BL"
  ],
  [
    "MF",
    "MAF",
    "663",
    "ISO 3166-2:MF"
  ],
  [
    "RS",
    "SRB",
    "688",
    "ISO 3166-2:RS"
  ],
  [
    "SX",
    "SXM",
    "534",
    "ISO 3166-2:SX"
  ],
  [
    "SS",
    "SSD",
    "728",
    "ISO 3166-2:SS"
  ],
  [
    "XK",
    "XKK",
    "983",
    "ISO 3166-2:XK"
  ]
], jg = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var l3 = {};
l3.remove = Vg;
var B8 = [
  {
    base: " ",
    chars: " "
  },
  {
    base: "0",
    chars: "߀"
  },
  {
    base: "A",
    chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  },
  {
    base: "AA",
    chars: "Ꜳ"
  },
  {
    base: "AE",
    chars: "ÆǼǢ"
  },
  {
    base: "AO",
    chars: "Ꜵ"
  },
  {
    base: "AU",
    chars: "Ꜷ"
  },
  {
    base: "AV",
    chars: "ꜸꜺ"
  },
  {
    base: "AY",
    chars: "Ꜽ"
  },
  {
    base: "B",
    chars: "ⒷＢḂḄḆɃƁ"
  },
  {
    base: "C",
    chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
  },
  {
    base: "D",
    chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
  },
  {
    base: "Dh",
    chars: "Ð"
  },
  {
    base: "DZ",
    chars: "ǱǄ"
  },
  {
    base: "Dz",
    chars: "ǲǅ"
  },
  {
    base: "E",
    chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
  },
  {
    base: "F",
    chars: "ꝼⒻＦḞƑꝻ"
  },
  {
    base: "G",
    chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
  },
  {
    base: "H",
    chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  },
  {
    base: "I",
    chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  },
  {
    base: "J",
    chars: "ⒿＪĴɈȷ"
  },
  {
    base: "K",
    chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  },
  {
    base: "L",
    chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  },
  {
    base: "LJ",
    chars: "Ǉ"
  },
  {
    base: "Lj",
    chars: "ǈ"
  },
  {
    base: "M",
    chars: "ⓂＭḾṀṂⱮƜϻ"
  },
  {
    base: "N",
    chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
  },
  {
    base: "NJ",
    chars: "Ǌ"
  },
  {
    base: "Nj",
    chars: "ǋ"
  },
  {
    base: "O",
    chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  },
  {
    base: "OE",
    chars: "Œ"
  },
  {
    base: "OI",
    chars: "Ƣ"
  },
  {
    base: "OO",
    chars: "Ꝏ"
  },
  {
    base: "OU",
    chars: "Ȣ"
  },
  {
    base: "P",
    chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
  },
  {
    base: "Q",
    chars: "ⓆＱꝖꝘɊ"
  },
  {
    base: "R",
    chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  },
  {
    base: "S",
    chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  },
  {
    base: "T",
    chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  },
  {
    base: "Th",
    chars: "Þ"
  },
  {
    base: "TZ",
    chars: "Ꜩ"
  },
  {
    base: "U",
    chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  },
  {
    base: "V",
    chars: "ⓋＶṼṾƲꝞɅ"
  },
  {
    base: "VY",
    chars: "Ꝡ"
  },
  {
    base: "W",
    chars: "ⓌＷẀẂŴẆẄẈⱲ"
  },
  {
    base: "X",
    chars: "ⓍＸẊẌ"
  },
  {
    base: "Y",
    chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  },
  {
    base: "Z",
    chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  },
  {
    base: "a",
    chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
  },
  {
    base: "aa",
    chars: "ꜳ"
  },
  {
    base: "ae",
    chars: "æǽǣ"
  },
  {
    base: "ao",
    chars: "ꜵ"
  },
  {
    base: "au",
    chars: "ꜷ"
  },
  {
    base: "av",
    chars: "ꜹꜻ"
  },
  {
    base: "ay",
    chars: "ꜽ"
  },
  {
    base: "b",
    chars: "ⓑｂḃḅḇƀƃɓƂ"
  },
  {
    base: "c",
    chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
  },
  {
    base: "d",
    chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
  },
  {
    base: "dh",
    chars: "ð"
  },
  {
    base: "dz",
    chars: "ǳǆ"
  },
  {
    base: "e",
    chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
  },
  {
    base: "f",
    chars: "ⓕｆḟƒ"
  },
  {
    base: "ff",
    chars: "ﬀ"
  },
  {
    base: "fi",
    chars: "ﬁ"
  },
  {
    base: "fl",
    chars: "ﬂ"
  },
  {
    base: "ffi",
    chars: "ﬃ"
  },
  {
    base: "ffl",
    chars: "ﬄ"
  },
  {
    base: "g",
    chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
  },
  {
    base: "h",
    chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  },
  {
    base: "hv",
    chars: "ƕ"
  },
  {
    base: "i",
    chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  },
  {
    base: "j",
    chars: "ⓙｊĵǰɉ"
  },
  {
    base: "k",
    chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  },
  {
    base: "l",
    chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
  },
  {
    base: "lj",
    chars: "ǉ"
  },
  {
    base: "m",
    chars: "ⓜｍḿṁṃɱɯ"
  },
  {
    base: "n",
    chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
  },
  {
    base: "nj",
    chars: "ǌ"
  },
  {
    base: "o",
    chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
  },
  {
    base: "oe",
    chars: "œ"
  },
  {
    base: "oi",
    chars: "ƣ"
  },
  {
    base: "oo",
    chars: "ꝏ"
  },
  {
    base: "ou",
    chars: "ȣ"
  },
  {
    base: "p",
    chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
  },
  {
    base: "q",
    chars: "ⓠｑɋꝗꝙ"
  },
  {
    base: "r",
    chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  },
  {
    base: "s",
    chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
  },
  {
    base: "ss",
    chars: "ß"
  },
  {
    base: "t",
    chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  },
  {
    base: "th",
    chars: "þ"
  },
  {
    base: "tz",
    chars: "ꜩ"
  },
  {
    base: "u",
    chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  },
  {
    base: "v",
    chars: "ⓥｖṽṿʋꝟʌ"
  },
  {
    base: "vy",
    chars: "ꝡ"
  },
  {
    base: "w",
    chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
  },
  {
    base: "x",
    chars: "ⓧｘẋẍ"
  },
  {
    base: "y",
    chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  },
  {
    base: "z",
    chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }
], Ee = {};
for (var I8 = 0; I8 < B8.length; I8 += 1)
  for (var gt = B8[I8].chars, B3 = 0; B3 < gt.length; B3 += 1)
    Ee[gt[B3]] = B8[I8].base;
function Vg(e) {
  return e.replace(/[^\u0000-\u007e]/g, function(t) {
    return Ee[t] || t;
  });
}
l3.replacementList = B8;
l3.diacriticsMap = Ee;
(function(e) {
  const t = Tg, r = jg, n = l3.remove, a = {}, i = {}, o = {}, l = {}, c = {};
  t.forEach(function(y) {
    const _ = y;
    i[_[0]] = _[1], o[_[1]] = _[0], l[_[2]] = _[0], c[_[0]] = _[2];
  });
  function u(y) {
    return ("000" + (y || "")).slice(-3);
  }
  function d(y, _) {
    return Object.prototype.hasOwnProperty.call(y, _);
  }
  function C(y, _) {
    return Object.keys(y).reduce(function(S, j) {
      const V = y[j];
      return S[j] = _(V, j), S;
    }, {});
  }
  function p(y, _) {
    switch (y) {
      case "official":
        return Array.isArray(_) ? _[0] : _;
      case "all":
        return typeof _ == "string" ? [_] : _;
      case "alias":
        return Array.isArray(_) ? _[1] || _[0] : _;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  e.registerLocale = function(y) {
    if (!y.locale)
      throw new TypeError("Missing localeData.locale");
    if (!y.countries)
      throw new TypeError("Missing localeData.countries");
    a[y.locale] = y.countries;
  };
  function h(y) {
    return o[y];
  }
  e.alpha3ToAlpha2 = h;
  function f(y) {
    return i[y];
  }
  e.alpha2ToAlpha3 = f;
  function g(y) {
    return c[h(y)];
  }
  e.alpha3ToNumeric = g;
  function m(y) {
    return c[y];
  }
  e.alpha2ToNumeric = m;
  function v(y) {
    const _ = u(y);
    return f(l[_]);
  }
  e.numericToAlpha3 = v;
  function b(y) {
    const _ = u(y);
    return l[_];
  }
  e.numericToAlpha2 = b;
  function w(y) {
    if (typeof y == "string") {
      if (/^[0-9]*$/.test(y))
        return v(y);
      if (y.length === 2)
        return f(y.toUpperCase());
      if (y.length === 3)
        return y.toUpperCase();
    }
    if (typeof y == "number")
      return v(y);
  }
  e.toAlpha3 = w;
  function M(y) {
    if (typeof y == "string") {
      if (/^[0-9]*$/.test(y))
        return b(y);
      if (y.length === 2)
        return y.toUpperCase();
      if (y.length === 3)
        return h(y.toUpperCase());
    }
    if (typeof y == "number")
      return b(y);
  }
  e.toAlpha2 = M, e.getName = function(y, _, S = {}) {
    "select" in S || (S.select = "official");
    try {
      const V = a[_.toLowerCase()][M(y)];
      return p(S.select, V);
    } catch {
      return;
    }
  }, e.getNames = function(y, _ = {}) {
    "select" in _ || (_.select = "official");
    const S = a[y.toLowerCase()];
    return S === void 0 ? {} : C(S, function(j) {
      return p(_.select, j);
    });
  }, e.getAlpha2Code = function(y, _) {
    const S = (V) => V.toLowerCase(), j = (V, P) => S(V) === S(P);
    try {
      const V = a[_.toLowerCase()];
      for (const P in V)
        if (d(V, P)) {
          if (typeof V[P] == "string" && j(V[P], y))
            return P;
          if (Array.isArray(V[P])) {
            for (const A of V[P])
              if (j(A, y))
                return P;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getSimpleAlpha2Code = function(y, _) {
    const S = (V) => n(V.toLowerCase()), j = (V, P) => S(V) === S(P);
    try {
      const V = a[_.toLowerCase()];
      for (const P in V)
        if (d(V, P)) {
          if (typeof V[P] == "string" && j(V[P], y))
            return P;
          if (Array.isArray(V[P])) {
            for (const A of V[P])
              if (j(A, y))
                return P;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getAlpha2Codes = function() {
    return i;
  }, e.getAlpha3Code = function(y, _) {
    const S = e.getAlpha2Code(y, _);
    if (S)
      return e.toAlpha3(S);
  }, e.getSimpleAlpha3Code = function(y, _) {
    const S = e.getSimpleAlpha2Code(y, _);
    if (S)
      return e.toAlpha3(S);
  }, e.getAlpha3Codes = function() {
    return o;
  }, e.getNumericCodes = function() {
    return l;
  }, e.langs = function() {
    return Object.keys(a);
  }, e.getSupportedLanguages = function() {
    return r;
  }, e.isValid = function(y) {
    if (!y)
      return !1;
    const _ = y.toString().toUpperCase();
    return d(o, _) || d(i, _) || d(l, _);
  };
})(Or);
const x4 = /* @__PURE__ */ M7(Or), Br = "ar", Zr = {
  AF: "أفغانستان",
  AL: "ألبانيا",
  DZ: "الجزائر",
  AS: "ساموا الأمريكية",
  AD: "أندورا",
  AO: "أنغولا",
  AI: "أنغويلا",
  AQ: "القارة القطبية الجنوبية",
  AG: "أنتيغوا وباربودا",
  AR: "الأرجنتين",
  AM: "أرمينيا",
  AW: "أروبا",
  AU: "أستراليا",
  AT: "النمسا",
  AZ: "أذربيجان",
  BS: "باهاماس",
  BH: "البحرين",
  BD: "بنغلاديش",
  BB: "باربادوس",
  BY: "روسيا البيضاء",
  BE: "بلجيكا",
  BZ: "بليز",
  BJ: "بنين",
  BM: "برمودا",
  BT: "بوتان",
  BO: "بوليفيا",
  BA: "البوسنة والهرسك",
  BW: "بوتسوانا",
  BV: "جزيرة بوفيه",
  BR: "البرازيل",
  IO: "إقليم المحيط الهندي البريطاني",
  BN: "بروناي",
  BG: "بلغاريا",
  BF: "بوركينا فاسو",
  BI: "بوروندي",
  KH: "كمبوديا",
  CM: "الكاميرون",
  CA: "كندا",
  CV: "الرأس الأخضر",
  KY: "جزر كايمان",
  CF: "جمهورية أفريقيا الوسطى",
  TD: "تشاد",
  CL: "تشيلي",
  CN: "الصين",
  CX: "جزيرة عيد الميلاد",
  CC: "جزر كوكوس",
  CO: "كولومبيا",
  KM: "جزر القمر",
  CG: "جمهورية الكونغو",
  CD: "جمهورية الكونغو الديمقراطية",
  CK: "جزر كوك",
  CR: "كوستاريكا",
  CI: "ساحل العاج",
  HR: "كرواتيا",
  CU: "كوبا",
  CY: "قبرص",
  CZ: "جمهورية التشيك",
  DK: "الدنمارك",
  DJ: "جيبوتي",
  DM: "دومينيكا",
  DO: "جمهورية الدومينيكان",
  EC: "الإكوادور",
  EG: "مصر",
  SV: "السلفادور",
  GQ: "غينيا الاستوائية",
  ER: "إريتريا",
  EE: "إستونيا",
  ET: "إثيوبيا",
  FK: "جزر فوكلاند",
  FO: "جزر فارو",
  FJ: "فيجي",
  FI: "فنلندا",
  FR: "فرنسا",
  GF: "غويانا الفرنسية",
  PF: "بولينزيا الفرنسية",
  TF: "أراض فرنسية جنوبية وأنتارتيكية",
  GA: "الغابون",
  GM: "غامبيا",
  GE: "جورجيا",
  DE: "ألمانيا",
  GH: "غانا",
  GI: "جبل طارق",
  GR: "اليونان",
  GL: "جرينلاند",
  GD: "غرينادا",
  GP: "غوادلوب",
  GU: "غوام",
  GT: "غواتيمالا",
  GN: "غينيا",
  GW: "غينيا بيساو",
  GY: "غيانا",
  HT: "هايتي",
  HM: "جزيرة هيرد وجزر ماكدونالد",
  VA: "الفاتيكان",
  HN: "هندوراس",
  HK: "هونغ كونغ",
  HU: "المجر",
  IS: "آيسلندا",
  IN: "الهند",
  ID: "إندونيسيا",
  IR: "إيران",
  IQ: "العراق",
  IE: "أيرلندا",
  IL: "إسرائيل",
  IT: "إيطاليا",
  JM: "جامايكا",
  JP: "اليابان",
  JO: "الأردن",
  KZ: "كازاخستان",
  KE: "كينيا",
  KI: "كيريباتي",
  KP: "كوريا الشمالية",
  KR: "كوريا الجنوبية",
  KW: "الكويت",
  KG: "قيرغيزستان",
  LA: "لاوس",
  LV: "لاتفيا",
  LB: "لبنان",
  LS: "ليسوتو",
  LR: "ليبيريا",
  LY: "ليبيا",
  LI: "ليختنشتاين",
  LT: "ليتوانيا",
  LU: "لوكسمبورغ",
  MO: "ماكاو",
  MK: "مقدونيا الشمالية",
  MG: "مدغشقر",
  MW: "مالاوي",
  MY: "ماليزيا",
  MV: "جزر المالديف",
  ML: "مالي",
  MT: "مالطا",
  MH: "جزر مارشال",
  MQ: "مارتينيك",
  MR: "موريتانيا",
  MU: "موريشيوس",
  YT: "مايوت",
  MX: "المكسيك",
  FM: "ولايات ميكرونيسيا المتحدة",
  MD: "مولدوفا",
  MC: "موناكو",
  MN: "منغوليا",
  MS: "مونتسرات",
  MA: "المغرب",
  MZ: "موزمبيق",
  MM: "بورما",
  NA: "ناميبيا",
  NR: "ناورو",
  NP: "نيبال",
  NL: "هولندا",
  NC: "كاليدونيا الجديدة",
  NZ: "نيوزيلندا",
  NI: "نيكاراغوا",
  NE: "النيجر",
  NG: "نيجيريا",
  NU: "نييوي",
  NF: "جزيرة نورفولك",
  MP: "جزر ماريانا الشمالية",
  NO: "النرويج",
  OM: "عمان",
  PK: "باكستان",
  PW: "بالاو",
  PS: "فلسطين",
  PA: "بنما",
  PG: "بابوا غينيا الجديدة",
  PY: "باراغواي",
  PE: "بيرو",
  PH: "الفلبين",
  PN: "جزر بيتكيرن",
  PL: "بولندا",
  PT: "البرتغال",
  PR: "بورتوريكو",
  QA: "قطر",
  RE: "لا ريونيون",
  RO: "رومانيا",
  RU: "روسيا",
  RW: "رواندا",
  SH: "سانت هيلينا وأسينشين وتريستان دا كونا",
  KN: "سانت كيتس ونيفيس",
  LC: "سانت لوسيا",
  PM: "سان بيير وميكلون",
  VC: "سانت فينسنت والغرينادين",
  WS: "ساموا",
  SM: "سان مارينو",
  ST: "ساو تومي وبرينسيب",
  SA: "السعودية",
  SN: "السنغال",
  SC: "سيشل",
  SL: "سيراليون",
  SG: "سنغافورة",
  SK: "سلوفاكيا",
  SI: "سلوفينيا",
  SB: "جزر سليمان",
  SO: "الصومال",
  ZA: "جنوب أفريقيا",
  GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  ES: "إسبانيا",
  LK: "سريلانكا",
  SD: "السودان",
  SR: "سورينام",
  SJ: "سفالبارد ويان ماين",
  SZ: "سوازيلاند",
  SE: "السويد",
  CH: "سويسرا",
  SY: "سوريا",
  TW: "تايوان",
  TJ: "طاجيكستان",
  TZ: "تانزانيا",
  TH: "تايلاند",
  TL: "تيمور الشرقية",
  TG: "توغو",
  TK: "توكيلاو",
  TO: "تونغا",
  TT: "ترينيداد وتوباغو",
  TN: "تونس",
  TR: "تركيا",
  TM: "تركمانستان",
  TC: "جزر توركس وكايكوس",
  TV: "توفالو",
  UG: "أوغندا",
  UA: "أوكرانيا",
  AE: "الإمارات العربية المتحدة",
  GB: "المملكة المتحدة",
  US: "الولايات المتحدة",
  UM: "جزر الولايات المتحدة",
  UY: "الأوروغواي",
  UZ: "أوزبكستان",
  VU: "فانواتو",
  VE: "فنزويلا",
  VN: "فيتنام",
  VG: "جزر العذراء البريطانية",
  VI: "جزر العذراء الأمريكية",
  WF: "والس وفوتونا",
  EH: "الصحراء الغربية",
  YE: "اليمن",
  ZM: "زامبيا",
  ZW: "زيمبابوي",
  AX: "جزر أولاند",
  BQ: "الجزر الكاريبية الهولندية",
  CW: "كوراساو",
  GG: "غيرنزي",
  IM: "جزيرة مان",
  JE: "جيرزي",
  ME: "الجبل الأسود",
  BL: "سان بارتيلمي",
  MF: "سانت مارتن (الجزء الفرنسي)",
  RS: "صربيا",
  SX: "سانت مارتن (الجزء الهولندي)",
  SS: "جنوب السودان",
  XK: "كوسوفو"
}, Ag = {
  locale: Br,
  countries: Zr
}, Eg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Zr,
  default: Ag,
  locale: Br
}, Symbol.toStringTag, { value: "Module" })), Gr = "cs", Kr = {
  AF: "Afghánistán",
  AX: "Ålandy",
  AL: "Albánie",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  VI: "Americké Panenské ostrovy",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktida",
  AG: "Antigua a Barbuda",
  AR: "Argentina",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Austrálie",
  AZ: "Ázerbájdžán",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BE: "Belgie",
  BZ: "Belize",
  BY: "Bělorusko",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhútán",
  BO: "Bolívie",
  BQ: "Bonaire, Svatý Eustach a Saba",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BV: "Bouvetův ostrov",
  BR: "Brazílie",
  IO: "Britské indickooceánské území",
  VG: "Britské Panenské ostrovy",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  CK: "Cookovy ostrovy",
  CW: "Curaçao",
  TD: "Čad",
  ME: "Černá Hora",
  CZ: "Česká republika",
  CN: "Čína",
  DK: "Dánsko",
  CD: "Demokratická republika Kongo",
  DM: "Dominika",
  DO: "Dominikánská republika",
  DJ: "Džibutsko",
  EG: "Egypt",
  EC: "Ekvádor",
  ER: "Eritrea",
  EE: "Estonsko",
  ET: "Etiopie",
  FO: "Faerské ostrovy",
  FK: "Falklandy (Malvíny)",
  FJ: "Fidži",
  PH: "Filipíny",
  FI: "Finsko",
  FR: "Francie",
  GF: "Francouzská Guyana",
  TF: "Francouzská jižní a antarktická území",
  PF: "Francouzská Polynésie",
  GA: "Gabon",
  GM: "Gambie",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GL: "Grónsko",
  GE: "Gruzie",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GG: "Guernsey",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heardův ostrov a McDonaldovy ostrovy",
  HN: "Honduras",
  HK: "Hongkong",
  CL: "Chile",
  HR: "Chorvatsko",
  IN: "Indie",
  ID: "Indonésie",
  IQ: "Irák",
  IR: "Írán",
  IE: "Irsko",
  IS: "Island",
  IT: "Itálie",
  IL: "Izrael",
  JM: "Jamajka",
  JP: "Japonsko",
  YE: "Jemen",
  JE: "Jersey",
  ZA: "Jihoafrická republika",
  GS: "Jižní Georgie a Jižní Sandwichovy ostrovy",
  KR: "Jižní Korea",
  SS: "Jižní Súdán",
  JO: "Jordánsko",
  KY: "Kajmanské ostrovy",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  QA: "Katar",
  KZ: "Kazachstán",
  KE: "Keňa",
  KI: "Kiribati",
  CC: "Kokosové ostrovy",
  CO: "Kolumbie",
  KM: "Komory",
  CG: "Kongo",
  CR: "Kostarika",
  CU: "Kuba",
  KW: "Kuvajt",
  CY: "Kypr",
  KG: "Kyrgyzstán",
  LA: "Laos",
  LS: "Lesotho",
  LB: "Libanon",
  LR: "Libérie",
  LY: "Libye",
  LI: "Lichtenštejnsko",
  LT: "Litva",
  LV: "Lotyšsko",
  LU: "Lucembursko",
  MO: "Macao",
  MG: "Madagaskar",
  HU: "Maďarsko",
  MY: "Malajsie",
  MW: "Malawi",
  MV: "Maledivy",
  ML: "Mali",
  MT: "Malta",
  IM: "Ostrov Man",
  MA: "Maroko",
  MH: "Marshallovy ostrovy",
  MQ: "Martinik",
  MU: "Mauricius",
  MR: "Mauritánie",
  YT: "Mayotte",
  UM: "Menší odlehlé ostrovy USA",
  MX: "Mexiko",
  FM: "Mikronésie",
  MD: "Moldavsko",
  MC: "Monako",
  MN: "Mongolsko",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  DE: "Německo",
  NP: "Nepál",
  NE: "Niger",
  NG: "Nigérie",
  NI: "Nikaragua",
  NU: "Niue",
  NL: "Nizozemsko",
  NF: "Norfolk",
  NO: "Norsko",
  NC: "Nová Kaledonie",
  NZ: "Nový Zéland",
  OM: "Omán",
  PK: "Pákistán",
  PW: "Palau",
  PS: "Palestinská autonomie",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairnovy ostrovy",
  CI: "Pobřeží slonoviny",
  PL: "Polsko",
  PR: "Portoriko",
  PT: "Portugalsko",
  AT: "Rakousko",
  RE: "Réunion",
  GQ: "Rovníková Guinea",
  RO: "Rumunsko",
  RU: "Rusko",
  RW: "Rwanda",
  GR: "Řecko",
  PM: "Saint-Pierre a Miquelon",
  SV: "Salvador",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saúdská Arábie",
  SN: "Senegal",
  KP: "Severní Korea",
  MK: "Severní Makedonie",
  MP: "Severní Mariany",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Slovensko",
  SI: "Slovinsko",
  SO: "Somálsko",
  AE: "Spojené arabské emiráty",
  GB: "Spojené království",
  US: "Spojené státy americké",
  RS: "Srbsko",
  CF: "Středoafrická republika",
  SD: "Súdán",
  SR: "Surinam",
  SH: "Svatá Helena, Ascension a Tristan da Cunha",
  LC: "Svatá Lucie",
  BL: "Svatý Bartoloměj",
  KN: "Svatý Kryštof a Nevis",
  MF: "Svatý Martin (francouzská část)",
  SX: "Svatý Martin (nizozemská část)",
  ST: "Svatý Tomáš a Princův ostrov",
  VC: "Svatý Vincenc a Grenadiny",
  SZ: "Svazijsko",
  SY: "Sýrie",
  SB: "Šalamounovy ostrovy",
  ES: "Španělsko",
  SJ: "Špicberky a Jan Mayen",
  LK: "Šrí Lanka",
  SE: "Švédsko",
  CH: "Švýcarsko",
  TJ: "Tádžikistán",
  TZ: "Tanzanie",
  TH: "Thajsko",
  TW: "Tchaj-wan",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkmenistán",
  TC: "Turks a Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajina",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  CX: "Vánoční ostrov",
  VU: "Vanuatu",
  VA: "Vatikán",
  VE: "Venezuela",
  VN: "Vietnam",
  TL: "Východní Timor",
  WF: "Wallis a Futuna",
  ZM: "Zambie",
  EH: "Západní Sahara",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, Ig = {
  locale: Gr,
  countries: Kr
}, Dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Kr,
  default: Ig,
  locale: Gr
}, Symbol.toStringTag, { value: "Module" })), zr = "da", Ur = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviderusland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brasilien",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Juløen",
  CC: "Cocosøerne",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo",
  CD: "Demokratiske Republik Congo",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CU: "Cuba",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsøerne",
  FO: "Færøerne",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GF: "Fransk Guiana",
  PF: "Fransk Polynesien",
  TF: "Franske Sydterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-øen og McDonald-øerne",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløerne",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesien",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongoliet",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holland",
  NC: "Ny Kaledonien",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Nordmarianerne",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palæstina",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumænien",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sankt Helena",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinerne",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "South Georgia og South Sandwich Islands",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Norge Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  SY: "Syrien",
  TW: "Republikken Kina Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Østtimor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Forenede Arabiske Emirater",
  GB: "Storbritannien",
  US: "USA",
  UM: "USA's ydre småøer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britiske Jomfruøer",
  VI: "Amerikanske Jomfruøer",
  WF: "Wallis og Futuna",
  EH: "Vestsahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Ålandsøerne",
  BQ: "Nederlandske Antiller",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint Martin (fransk side)",
  RS: "Serbien",
  SX: "Saint Martin (hollandsk side)",
  SS: "Sydsudan",
  XK: "Kosovo"
}, Ng = {
  locale: zr,
  countries: Ur
}, Rg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ur,
  default: Ng,
  locale: zr
}, Symbol.toStringTag, { value: "Module" })), Yr = "de", Wr = {
  AF: "Afghanistan",
  EG: "Ägypten",
  AX: "Åland",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  VI: "Amerikanische Jungferninseln",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  GQ: "Äquatorialguinea",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AZ: "Aserbaidschan",
  ET: "Äthiopien",
  AU: "Australien",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien",
  BQ: "Bonaire",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  VG: "Britische Jungferninseln",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  CL: "Chile",
  CN: "China",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Elfenbeinküste",
  CW: "Curaçao",
  DK: "Dänemark",
  DE: "Deutschland",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  DJ: "Dschibuti",
  EC: "Ecuador",
  SV: "El Salvador",
  ER: "Eritrea",
  EE: "Estland",
  FK: "Falklandinseln",
  FO: "Färöer",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Süd- und Antarktisgebiete",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GR: "Griechenland",
  GL: "Grönland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard und McDonaldinseln",
  HN: "Honduras",
  HK: [
    "Hongkong",
    "Hong Kong"
  ],
  IN: "Indien",
  ID: "Indonesien",
  IM: "Insel Man",
  IQ: "Irak",
  IR: "Iran",
  IE: "Irland",
  IS: "Island",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  YE: "Jemen",
  JE: "Jersey",
  JO: "Jordanien",
  KY: "Kaimaninseln",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KZ: "Kasachstan",
  QA: "Katar",
  KE: "Kenia",
  KG: "Kirgisistan",
  KI: "Kiribati",
  CC: "Kokosinseln",
  CO: "Kolumbien",
  KM: "Komoren",
  CD: "Kongo",
  KP: "Nordkorea",
  KR: "Südkorea",
  HR: "Kroatien",
  CU: "Kuba",
  KW: "Kuwait",
  LA: "Laos",
  LS: "Lesotho",
  LV: "Lettland",
  LB: "Libanon",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MA: "Marokko",
  MH: "Marshallinseln",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  FM: "Mikronesien",
  MD: "Moldawien",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NL: "Niederlande",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  MK: "Nordmazedonien",
  MP: "Nördliche Marianen",
  NF: "Norfolkinsel",
  NO: "Norwegen",
  OM: "Oman",
  AT: "Österreich",
  TL: "Osttimor",
  PK: "Pakistan",
  PS: "Staat Palästina",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairninseln",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  TW: "Taiwan",
  CG: "Republik Kongo",
  RE: "Réunion",
  RW: "Ruanda",
  RO: "Rumänien",
  RU: [
    "Russische Föderation",
    "Russland"
  ],
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  SB: "Salomonen",
  ZM: "Sambia",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SE: "Schweden",
  CH: "Schweiz",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  ZW: "Simbabwe",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slowakei",
  SI: "Slowenien",
  SO: "Somalia",
  ES: "Spanien",
  LK: "Sri Lanka",
  SH: "St. Helena",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  ZA: "Südafrika",
  SD: "Sudan",
  GS: "Südgeorgien und die Südlichen Sandwichinseln",
  SS: "Südsudan",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SZ: "Eswatini",
  SY: "Syrien, Arabische Republik",
  TJ: "Tadschikistan",
  TZ: [
    "Tansania, Vereinigte Republik",
    "Tansania"
  ],
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TD: "Tschad",
  CZ: [
    "Tschechische Republik",
    "Tschechien"
  ],
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  HU: "Ungarn",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VA: "Vatikanstadt",
  VE: "Venezuela",
  AE: "Vereinigte Arabische Emirate",
  US: [
    "Vereinigte Staaten von Amerika",
    "Vereinigte Staaten",
    "USA"
  ],
  GB: [
    "Vereinigtes Königreich",
    "Großbritannien"
  ],
  VN: "Vietnam",
  WF: "Wallis und Futuna",
  CX: "Weihnachtsinsel",
  EH: "Westsahara",
  CF: "Zentralafrikanische Republik",
  CY: "Zypern",
  XK: "Kosovo"
}, Fg = {
  locale: Yr,
  countries: Wr
}, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Wr,
  default: Fg,
  locale: Yr
}, Symbol.toStringTag, { value: "Module" })), $r = "el", Jr = {
  AF: "Αφγανιστάν",
  AL: "Αλβανία",
  DZ: "Αλγερία",
  AS: "Αμερικανική Σαμόα",
  AD: "Ανδόρρα",
  AO: "Ανγκόλα",
  AI: "Ανγκουίλα",
  AQ: "Ανταρκτική",
  AG: "Αντίγκουα και Μπαρμπούντα",
  AR: "Αργεντινή",
  AM: "Αρμενία",
  AW: "Αρούμπα",
  AU: "Αυστραλία",
  AT: "Αυστρία",
  AZ: "Αζερμπαϊτζάν",
  BS: "Μπαχάμες",
  BH: "Μπαχρέιν",
  BD: "Μπανγκλαντές",
  BB: "Μπαρμπάντος",
  BY: "Λευκορωσία",
  BE: "Βέλγιο",
  BZ: "Μπελίζ",
  BJ: "Μπενίν",
  BM: "Βερμούδες",
  BT: "Μπουτάν",
  BO: "Βολιβία",
  BA: "Βοσνία και Ερζεγοβίνη",
  BW: "Μποτσουάνα",
  BV: "Μπουβέ",
  BR: "Βραζιλία",
  IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού",
  BN: "Σουλτανάτο του Μπρουνέι",
  BG: "Βουλγαρία",
  BF: "Μπουρκίνα Φάσο",
  BI: "Μπουρουντί",
  KH: "Καμπότζη",
  CM: "Καμερούν",
  CA: "Καναδάς",
  CV: [
    "Δημοκρατία του Πράσινου Ακρωτηρίου",
    "Πράσινο Ακρωτήριο"
  ],
  KY: "Κέιμαν Νήσοι",
  CF: "Κεντροαφρικανική Δημοκρατία",
  TD: "Τσάντ",
  CL: "Χιλή",
  CN: "Κίνα",
  CX: "Νήσος των Χριστουγέννων",
  CC: "Νησιά Κόκος",
  CO: "Κολομβία",
  KM: "Ένωση των Κομορών",
  CG: [
    "Δημοκρατία του Κονγκό",
    "Κονγκό"
  ],
  CD: "Λαϊκή Δημοκρατία του Κονγκό",
  CK: "Νήσοι Κουκ",
  CR: "Κόστα Ρίκα",
  CI: "Ακτή Ελεφαντοστού",
  HR: "Κροατία",
  CU: "Κούβα",
  CY: "Κύπρος",
  CZ: [
    "Τσεχική Δημοκρατία",
    "Τσεχία"
  ],
  DK: "Δανία",
  DJ: "Τζιμπουτί",
  DM: [
    "Κοινοπολιτεία της Δομινίκας",
    "Ντομίνικα"
  ],
  DO: "Δομινικανή Δημοκρατία",
  EC: "Εκουαδόρ",
  EG: "Αίγυπτος",
  SV: "Ελ Σαλβαδόρ",
  GQ: "Ισημερινή-Γουινέα",
  ER: [
    "Κράτος της Ερυθραίας",
    "Ερυθραία"
  ],
  EE: "Εσθονία",
  ET: "Αιθιοπία",
  FK: "Νήσοι Φώκλαντ (Μαλβίνας)",
  FO: "Νήσοι Φερόες",
  FJ: "Δημοκρατία των Φίτζι",
  FI: "Φινλανδία",
  FR: "Γαλλία",
  GF: "Γαλλική Γουιάνα",
  PF: "Γαλλική Πολυνησία",
  TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη",
  GA: "Γκαμπόν",
  GM: "Γκάμπια",
  GE: "Γεωργία",
  DE: "Γερμανία",
  GH: "Γκάνα",
  GI: "Γιβραλτάρ",
  GR: "Ελλάδα",
  GL: "Γροιλανδία",
  GD: "Γρενάδα",
  GP: "Γουαδελούπη",
  GU: "Γκουάμ",
  GT: "Γουατεμάλα",
  GN: "Γουινέα",
  GW: "Γουινέα-Μπισσάου",
  GY: "Γουιάνα",
  HT: "Αϊτη",
  HM: "Νήσοι Χερντ και Μακντόναλντ",
  VA: [
    "Κράτος της Πόλης του Βατικανού",
    "Βατικανό"
  ],
  HN: "Ονδούρα",
  HK: "Χονγκ Κόνγκ",
  HU: "Ουγγαρία",
  IS: "Ισλανδία",
  IN: "Ινδία",
  ID: "Ινδονησία",
  IR: [
    "Ισλαμική Δημοκρατία του Ιράν",
    "Ιράν"
  ],
  IQ: "Ιράκ",
  IE: "Ιρλανδία",
  IL: "Ισραήλ",
  IT: "Ιταλία",
  JM: "Τζαμάικα",
  JP: "Ιαπωνία",
  JO: "Ιορδανία",
  KZ: "Καζακστάν",
  KE: "Κένυα",
  KI: "Κιριμπάτι",
  KP: [
    "Λαοκρατική Δημοκρατία της Κορέας",
    "Βόρεια Κορέα"
  ],
  KR: [
    "Δημοκρατία της Κορέας",
    "Νότια Κορέα"
  ],
  KW: "Κουβέιτ",
  KG: "Κιργιζία",
  LA: [
    "Λαϊκή Δημοκρατία του Λάος",
    "Λάος"
  ],
  LV: "Λετονία",
  LB: "Λίβανο",
  LS: [
    "Βασίλειο του Λεσότο",
    "Λεσότο"
  ],
  LR: "Λιβερία",
  LY: [
    "Κράτος της Λιβύης",
    "Λιβύη"
  ],
  LI: [
    "Πριγκιπάτο του Λίχτενσταϊν",
    "Λίχτενσταϊν"
  ],
  LT: "Λιθουανία",
  LU: "Λουξεμβούργο",
  MO: "Μακάου",
  MK: [
    "Δημοκρατία της Βόρειας Μακεδονίας",
    "Βόρεια Μακεδονία"
  ],
  MG: "Μαδαγασκάρη",
  MW: "Μαλάουι",
  MY: "Μαλαισία",
  MV: "Μαλβίδες",
  ML: "Μαλί",
  MT: "Μάλτα",
  MH: "Νήσοι Μάρσαλ",
  MQ: "Μαρτινίκα",
  MR: "Μαυριτανία",
  MU: "Μαυρίκιος",
  YT: "Μαγιότ",
  MX: "Μεξικό",
  FM: [
    "Ομόσπονδες Πολιτείες της Μικρονησίας",
    "Μικρονησία"
  ],
  MD: [
    "Δημοκρατία της Μολδαβίας",
    "Μολδαβία"
  ],
  MC: [
    "Πριγκιπάτο του Μονακό",
    "Μονακό"
  ],
  MN: "Μογγολία",
  MS: "Μοντσερράτ",
  MA: "Μαρόκο",
  MZ: "Μοζαμβίκη",
  MM: "Μιανμάρ",
  NA: "Ναμίμπια",
  NR: "Ναουρού",
  NP: "Νεπάλ",
  NL: "Ολλανδία",
  NC: "Νέα Καληδονία",
  NZ: "Νέα Ζηλανδία",
  NI: "Νικαράγουα",
  NE: "Νίγηρας",
  NG: "Νιγηρία",
  NU: "Νιούε",
  NF: "Νησί Νόρφολκ",
  MP: "Βόρειες Μαριάνες Νήσοι",
  NO: "Νορβηγία",
  OM: "Ομάν",
  PK: "Πακιστάν",
  PW: "Παλάου",
  PS: [
    "Κράτος της Παλαιστίνης",
    "Παλαιστίνη"
  ],
  PA: "Παναμάς",
  PG: "Παπούα Νέα Γουινέα",
  PY: "Παραγουάη",
  PE: "Περού",
  PH: "Φιλιππίνες",
  PN: "Νήσοι Πίτκαιρν",
  PL: "Πολωνία",
  PT: "Πορτογαλία",
  PR: "Πουέρτο Ρίκο",
  QA: "Κατάρ",
  RE: "Ρεϋνιόν",
  RO: "Ρουμανία",
  RU: [
    "Ρωσική Ομοσπονδία",
    "Ρωσία"
  ],
  RW: "Ρουάντα",
  SH: "Νήσος Αγίας Ελένης",
  KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις",
  LC: "Αγία Λουκία",
  PM: "Σαιν Πιερ και Μικελόν",
  VC: "Άγιος Βικέντιος και Γρεναδίνες",
  WS: "Σαμόα",
  SM: "Άγιος Μαρίνος",
  ST: "Σάο Τομέ και Πρίνσιπε",
  SA: "Σαουδική Αραβία",
  SN: "Σενεγάλη",
  SC: "Σεϋχέλλες",
  SL: "Σιέρα Λεόνε",
  SG: "Σιγκαπούρη",
  SK: "Σλοβακία",
  SI: "Σλοβενία",
  SB: "Νήσοι Σολομώντα",
  SO: "Σομαλία",
  ZA: "Νότια Αφρική",
  GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι",
  ES: "Ισπανία",
  LK: "Σρι Λάνκα",
  SD: "Σουδάν",
  SR: "Σουρινάμ",
  SJ: "Σβάλμπαρντ και Γιαν Μαγιέν",
  SZ: "Σουαζιλάνδη",
  SE: "Σουηδία",
  CH: "Ελβετία",
  SY: [
    "Αραβική Δημοκρατία της Συρίας",
    "Συρία"
  ],
  TW: "Δημοκρατία της Κίνας",
  TJ: "Τατζικιστάν",
  TZ: [
    "Ενωμένη Δημοκρατία της Τανζανίας",
    "Τανζανία"
  ],
  TH: "Ταϊλάνδη",
  TL: "Ανατολικό Τιμόρ",
  TG: "Τογκό",
  TK: "Τοκελάου",
  TO: "Τόνγκα",
  TT: "Τρινιντάντ και Τομπάγκο",
  TN: "Τυνησία",
  TR: "Τουρκία",
  TM: "Τουρκμενιστάν",
  TC: "Τερκς και Κέικος",
  TV: "Τουβαλού",
  UG: "Ουγκάντα",
  UA: "Ουκρανια",
  AE: "Ηνωμένα Αραβικά Εμιράτα",
  GB: "Ηνωμένο Βασίλειο",
  US: [
    "Ηνωμένες Πολιτείες Αμερικής",
    "Αμερική",
    "ΗΠΑ"
  ],
  UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών",
  UY: "Ουρουγουάη",
  UZ: "Ουζμπεκιστάν",
  VU: "Βανουάτου",
  VE: "Βενεζουέλα",
  VN: "Βιετνάμ",
  VG: "Βρετανικές Παρθένοι Νήσοι",
  VI: "Αμερικανικές Παρθένοι Νήσοι",
  WF: "Ουαλίς και Φουτουνά",
  EH: "Δυτική Σαχάρα",
  YE: "Υεμένη",
  ZM: "Ζάμπια",
  ZW: "Ζιμπάμπουε",
  AX: "Νήσοι Ώλαντ",
  BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα",
  CW: "Κουρασάο",
  GG: "Γκουέρνσεϊ",
  IM: "Νήσος του Μαν",
  JE: "Βαϊλάτο του Τζέρσεϊ",
  ME: "Μαυροβούνιο",
  BL: "Άγιος Βαρθολομαίος",
  MF: "Άγιος Μαρτίνος (Γαλλία)",
  RS: "Σερβία",
  SX: "Άγιος Μαρτίνος (Ολλανδία)",
  SS: "Νότιο Σουδάν",
  XK: "Κόσοβο"
}, Bg = {
  locale: $r,
  countries: Jr
}, Zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Jr,
  default: Bg,
  locale: $r
}, Symbol.toStringTag, { value: "Module" })), qr = "en", Qr = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: [
    "People's Republic of China",
    "China"
  ],
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: [
    "Republic of the Congo",
    "Congo"
  ],
  CD: [
    "Democratic Republic of the Congo",
    "Congo"
  ],
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: [
    "Cote d'Ivoire",
    "Côte d'Ivoire",
    "Ivory Coast"
  ],
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: [
    "Czech Republic",
    "Czechia"
  ],
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: [
    "Republic of The Gambia",
    "The Gambia",
    "Gambia"
  ],
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Islamic Republic of Iran",
    "Iran"
  ],
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: [
    "South Korea",
    "Korea, Republic of",
    "Republic of Korea"
  ],
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Netherlands",
    "The Netherlands",
    "Netherlands (Kingdom of the)"
  ],
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: [
    "The Republic of North Macedonia",
    "North Macedonia"
  ],
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: [
    "State of Palestine",
    "Palestine"
  ],
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: [
    "Pitcairn",
    "Pitcairn Islands"
  ],
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: [
    "Russian Federation",
    "Russia"
  ],
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: [
    "Taiwan, Province of China",
    "Taiwan"
  ],
  TJ: "Tajikistan",
  TZ: [
    "United Republic of Tanzania",
    "Tanzania"
  ],
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: [
    "Türkiye",
    "Turkey"
  ],
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: [
    "United Arab Emirates",
    "UAE"
  ],
  GB: [
    "United Kingdom",
    "UK",
    "Great Britain"
  ],
  US: [
    "United States of America",
    "United States",
    "USA",
    "U.S.A.",
    "US",
    "U.S."
  ],
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: [
    "Åland Islands",
    "Aland Islands"
  ],
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "South Sudan",
  XK: "Kosovo"
}, Gg = {
  locale: qr,
  countries: Qr
}, Kg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Qr,
  default: Gg,
  locale: qr
}, Symbol.toStringTag, { value: "Module" })), Xr = "es", ei = {
  AF: "Afganistán",
  AL: "Albania",
  DZ: "Argelia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benin",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BA: "Bosnia y Herzegovina",
  BW: "Botswana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Isla de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "Congo (República Democrática del)",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil",
  HR: "Croacia",
  CU: "Cuba",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Malvinas",
  FO: "Islas Feroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guayana Francesa",
  PF: "Polinesia Francesa",
  TF: "Tierras Australes Francesas",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haití",
  HM: "Heard e Islas McDonald",
  VA: "Santa Sede",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Irán",
    "República Islámica de Irán"
  ],
  IQ: "Iraq",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "República Popular Democrática de Corea",
  KR: "República de Corea",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular de Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Macedonia del Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Malí",
  MT: "Malta",
  MH: "Islas Marshall",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  FM: "Micronesia",
  MD: "Moldavia",
  MC: "Mónaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  MP: "Islas Marianas del Norte",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papua Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Catar",
  RE: "Reunión",
  RO: "Rumanía",
  RU: "Rusia",
  RW: "Ruanda",
  SH: "Santa Helena, Ascensión y Tristán de Acuña",
  KN: "Saint Kitts y Nevis",
  LC: "Santa Lucía",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Georgia del Sur y las Islas Sandwich del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SD: "Sudán",
  SR: "Suriname",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  SY: "República Árabe Siria",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania",
  TH: "Tailandia",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UM: "Islas Ultramarinas Menores de los Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Islas Vírgenes británicas",
  VI: "Islas Vírgenes de los Estados Unidos",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
  AX: "Islas Åland",
  BQ: "Bonaire, San Eustaquio y Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isla de Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (francesa)",
  RS: "Serbia",
  SX: "Sint Maarten (neerlandesa)",
  SS: "Sudán del Sur",
  XK: "Kosovo"
}, zg = {
  locale: Xr,
  countries: ei
}, Ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ei,
  default: zg,
  locale: Xr
}, Symbol.toStringTag, { value: "Module" })), ti = "fr", ai = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Océan Indien Britannique",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République Centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos",
  CO: "Colombie",
  KM: "Comores",
  CG: "République du Congo",
  CD: "République démocratique du Congo",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte-d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CY: "Chypre",
  CZ: "République Tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (Vatican)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée du Nord",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie",
  MD: "Moldavie",
  MC: "Monaco",
  MN: "Mongolie",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niué",
  NF: "Île Norfolk",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Îles Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Russie",
  RW: "Rwanda",
  SH: "Sainte-Hélène",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "São Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Île Jan Mayen",
  SZ: "Royaume d'Eswatini",
  SE: "Suède",
  CH: "Suisse",
  SY: "Syrie",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "République unie de Tanzanie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Îles vierges britanniques",
  VI: "Îles vierges américaines",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Saint-Eustache et Saba",
  CW: "Curaçao",
  GG: "Guernesey",
  IM: "Île de Man",
  JE: "Jersey",
  ME: "Monténégro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin (partie française)",
  RS: "Serbie",
  SX: "Saint-Martin (partie néerlandaise)",
  SS: "Soudan du Sud",
  XK: "Kosovo"
}, Yg = {
  locale: ti,
  countries: ai
}, Wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ai,
  default: Yg,
  locale: ti
}, Symbol.toStringTag, { value: "Module" })), ni = "hi", ri = {
  AD: "अंडोरा",
  AE: "संयुक्त अरब अमीरात",
  AF: "अफगानिस्तान",
  AG: "एंटीगुआ और बारबूडा",
  AI: "अंग्विला",
  AL: "अल्बानिया",
  AM: "अर्मेनिया",
  AO: "अंगोला",
  AQ: "अंटार्टिका",
  AR: "अर्जेंटिना",
  AS: "अमेरिकान सामोआ",
  AT: "आस्ट्रिया",
  AU: "आस्ट्रेलिया",
  AW: "अरुबा",
  AX: "ऑलैण्ड द्वीपसमूह",
  AZ: "अजरबेजान",
  BA: "बोस्निया हर्जेगोविना",
  BB: "बार्बाडोस",
  BD: "बांग्लादेश",
  BE: "बेल्जियम",
  BF: "बुर्किना फासो",
  BG: "बल्गारिया",
  BH: "बहरीन",
  BI: "बुरुंडी",
  BJ: "बानिन",
  BL: "सेंट_बार्थेलेमी",
  BM: "बर्मूडा",
  BN: "ब्रुनेई",
  BO: "बोलिविया",
  BQ: "कैरिबियन नीदरलैंड",
  BR: "ब्राजील",
  BS: "बहामास",
  BT: "भूटान",
  BV: "बाउवेट",
  BW: "बोत्सवाना",
  BY: "बेलारुस",
  BZ: "बेलिजे",
  CA: "कनाडा",
  CC: "कोकोस (कीलिंग) द्वीप",
  CD: "कांगो लोकतान्त्रिक गणराज्य",
  CF: "सेंट्रल अफ्रीका गणतंत्र",
  CG: "कांगो",
  CH: "स्विट्जरलैंड",
  CI: "आइवरी कोस्ट",
  CK: "कुक द्वीप",
  CL: "चिली",
  CM: "कैमरून",
  CN: "चीन",
  CO: "कोलंबिया",
  CR: "कोस्टा रिका",
  CU: "क्यूबा",
  CV: "केप वर्दे",
  CW: "कुराकाओ",
  CX: "क्रिसमस द्वीप",
  CY: "साइप्रस",
  CZ: "चेक",
  DE: "जर्मनी",
  DJ: "जिबॉती",
  DK: "डैनमार्क",
  DM: "डोमिनिक",
  DO: "डोमिनिक गणतंत्र",
  DZ: "अल्जीरिया",
  EC: "इक्वाडोर",
  EE: "एस्तोनिया",
  EG: "मिस्र",
  EH: "पश्चिमी सहारा",
  ER: "एरिट्रेया",
  ES: "स्पेन",
  ET: "इथियोपिया",
  FI: "फिनलैंड",
  FJ: "फिजी",
  FK: "फाकलैंड द्वीप समूह (मालविनास)",
  FM: "माइक्रोनेशिया",
  FO: "फराओ द्वीप समूह",
  FR: "फ्रांस",
  GA: "गैबोन",
  GB: "ग्रेट ब्रिटेन",
  GD: "ग्रेनेडा",
  GE: "जॉर्जिया",
  GF: "फ्रेंच गुआना",
  GG: "ग्वेर्नसे",
  GH: "घाना",
  GI: "जिब्राल्टर",
  GL: "ग्रीनलैंड",
  GM: "गाम्बिया",
  GN: "गिनी",
  GP: "ग्वाडेलोप",
  GQ: "एक्वेटोरियल गिनी",
  GR: "यूनान",
  GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह",
  GT: "ग्वाटेमाला",
  GU: "ग्वाम",
  GW: "गिनी-बिसाउ",
  GY: "गुआना",
  HK: "हांग कांग",
  HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह",
  HN: "होंडुरास",
  HR: "क्रोएशिया",
  HT: "हैती",
  HU: "हंगरी",
  ID: "इंडोनेशिया",
  IE: "आयरलैंड",
  IL: "इजराइल",
  IM: "आइसल ऑफ मैन",
  IN: "भारत",
  IO: "ब्रितानी हिंद महासागरीय क्षेत्र",
  IQ: "इराक",
  IR: "ईरान",
  IS: "आइसलैंड",
  IT: "इटली",
  JE: "जर्सी",
  JM: "जमैका",
  JO: "जॉर्डन",
  JP: "जापान",
  KE: "केन्या",
  KG: "किर्जिस्तान",
  KH: "कंबोडिया",
  KI: "किरिबिती",
  KM: "कोमोरोस",
  KN: "सेंट किट्स एंड नेविस",
  KP: "उत्तर कोरिया",
  KR: "दक्षिण कोरिया",
  KW: "कुवैत",
  KY: "केमैन आइसलैंड्स",
  KZ: "कज़ाखिस्तान",
  LA: "लाओस",
  LB: "लेबनान",
  LC: "सेंट लुसिया",
  LI: "लिक्टेनिस्टीन",
  LK: "श्री लंका",
  LR: "लाइबेरिया",
  LS: "लेसोथो",
  LT: "लिथुआनिया",
  LU: "लक्जमबर्ग",
  LV: "लात्विया",
  LY: "लीबिया",
  MA: "मोरक्को",
  MC: "मोनाको",
  MD: "मोलदोवा",
  ME: "मोंटेनेग्रो",
  MF: "सेंट मार्टिन की सामूहिकता",
  MG: "मैडागास्कर",
  MH: "मार्शल द्वीपसमूह",
  MK: "मकदूनिया",
  ML: "माली",
  MM: "म्यामांर (बर्मा)",
  MN: "मंगोलिया",
  MO: "मकाओ",
  MP: "उत्तर मैरिना द्वीपसमूह",
  MQ: "मार्टिनिक",
  MR: "मॉरितानिया",
  MS: "मोंटसेराट",
  MT: "माल्टा",
  MU: "मारीशस",
  MV: "मालदीव",
  MW: "मालावी",
  MX: "मेक्सिको",
  MY: "मलयेशिया",
  MZ: "मोजांबिक",
  NA: "नामीबिया",
  NC: "न्यू कैलेडोनिया",
  NE: "नाइजर",
  NF: "नोरफॉक द्वीप",
  NG: "नाइजीरिया",
  NI: "निकारागुआ",
  NL: "नीदरलैंड्स",
  NO: "नॉर्वे",
  NP: "नेपाल",
  NR: "नाउरू",
  NU: "नियू",
  NZ: "न्यूजीलैंड",
  OM: "ओमान",
  PA: "पनामा",
  PE: "पेरू",
  PF: "फ्रैंच गुआना",
  PG: "पापुआ न्यू गिनी",
  PH: "फिलीपींस",
  PK: "पाकिस्तान",
  PL: "पोलैंड",
  PM: "सेंट पिएरे एंड मिक्वेलॉन",
  PN: "पिटकैर्न द्वीपसमूह",
  PR: "पुएर्तो रिको",
  PS: "फिलिस्तीन राज्य",
  PT: "पुर्तगाल",
  PW: "पलाउ",
  PY: "पराग्वे",
  QA: "क़तार",
  RE: "रीयूनियन",
  RO: "रोमानिया",
  RS: "सर्बिया",
  RU: "रूस",
  RW: "रवांडा",
  SA: "सऊदी अरब",
  SB: "सोलोमन द्वीपसमूह",
  SC: "सेशेल्स",
  SD: "सूडान",
  SE: "स्वीडन",
  SG: "सिंगापुर",
  SH: "सेंट हेलेना",
  SI: "स्लोवानिया",
  SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)",
  SK: "स्लोवाकिया",
  SL: "सियारा लिओन",
  SM: "सैन मारिनो",
  SN: "सेनेगल",
  SO: "सोमालिया",
  SR: "सूरीनाम",
  SS: "दक्षिण सूडान",
  ST: "साओ टॉम एंड प्रिंसिपी",
  SV: "सल्वाडोर",
  SX: "सिण्ट मार्टेन",
  SY: "सीरिया",
  SZ: "स्वाजीलैंड",
  TC: "तुर्क एंड कैकोस द्वीपसमूह",
  TD: "चाड",
  TF: "फ्रांसीसी दक्षिणी क्षेत्र",
  TG: "टोगो",
  TH: "थाईलैंड",
  TJ: "तज़ाकिस्तान",
  TK: "टोकेलू",
  TL: "पूर्वी तिमोर",
  TM: "तुर्कमेनिस्तान",
  TN: "ट्यूनीशिया",
  TO: "टोंगा",
  TR: "तुर्की",
  TT: "ट्रिनिडाड एंड टोबैगो",
  TV: "तुवालू",
  TW: "ताइवान",
  TZ: "तंजानिया",
  UA: "उक्रेन",
  UG: "उगांडा",
  UM: "यूएस माइनर आउटलाइंग द्वीपसमूह",
  US: "यूएसए (संयुक्त राज्य अमेरिका)",
  UY: "उरुग्वे",
  UZ: "उजबेकिस्तान",
  VA: "वेटिकन",
  VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स",
  VE: "वेनेजुएला",
  VG: "ब्रितानी वर्जिन द्वीपसमूह",
  VI: "अमेरिकी वर्जिन द्वीपसमूह",
  VN: "विएतनाम",
  VU: "वनातू",
  WF: "वालीज एंड फुटुना",
  WS: "पश्चिमी सामोआ",
  XK: "कोसोवो",
  YE: "यमन",
  YT: "मायोते",
  ZA: "दक्षिण अफ्रीका",
  ZM: "जाम्बिया",
  ZW: "जिंबावे"
}, $g = {
  locale: ni,
  countries: ri
}, Jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ri,
  default: $g,
  locale: ni
}, Symbol.toStringTag, { value: "Module" })), ii = "hu", oi = {
  AF: "Afganisztán",
  AL: "Albánia",
  DZ: "Algéria",
  AS: "Amerikai Szamoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktisz",
  AG: "Antigua és Barbuda",
  AR: "Argentína",
  AM: "Örményország",
  AW: "Aruba",
  AU: "Ausztrália",
  AT: "Ausztria",
  AZ: "Azerbajdzsán",
  BS: "Bahama-szigetek",
  BH: "Bahrein",
  BD: "Banglades",
  BB: "Barbados",
  BY: "Fehéroroszország",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhután",
  BO: "Bolívia",
  BA: "Bosznia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet-sziget",
  BR: "Brazília",
  IO: "Brit Indiai-óceáni Terület",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodzsa",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zöld-foki Köztársaság",
  KY: "Kajmán-szigetek",
  CF: "Közép-afrikai Köztársaság",
  TD: "Csád",
  CL: "Chile",
  CN: "Kína",
  CX: "Karácsony-sziget",
  CC: "Kókusz (Keeling)-szigetek",
  CO: "Kolumbia",
  KM: "Comore-szigetek",
  CG: "Kongói Köztársaság",
  CD: "Kongói Demokratikus Köztársaság",
  CK: "Cook-szigetek",
  CR: "Costa Rica",
  CI: "Elefántcsontpart",
  HR: "Horvátország",
  CU: "Kuba",
  CY: "Ciprus",
  CZ: "Csehország",
  DK: "Dánia",
  DJ: "Dzsibuti",
  DM: "Dominikai Közösség",
  DO: "Dominikai Köztársaság",
  EC: "Ecuador",
  EG: "Egyiptom",
  SV: "Salvador",
  GQ: "Egyenlítői-Guinea",
  ER: "Eritrea",
  EE: "Észtország",
  ET: "Etiópia",
  FK: "Falkland-szigetek",
  FO: "Feröer",
  FJ: "Fidzsi-szigetek",
  FI: "Finnország",
  FR: "Franciaország",
  GF: "Francia Guyana",
  PF: "Francia Polinézia",
  TF: "Francia déli területek",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Grúzia",
  DE: "Németország",
  GH: "Ghána",
  GI: "Gibraltár",
  GR: "Görögország",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Bissau-Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-sziget és McDonald-szigetek",
  VA: "Vatikán",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Magyarország",
  IS: "Izland",
  IN: "India",
  ID: "Indonézia",
  IR: "Irán",
  IQ: "Irak",
  IE: "Írország",
  IL: "Izrael",
  IT: "Olaszország",
  JM: "Jamaica",
  JP: "Japán",
  JO: "Jordánia",
  KZ: "Kazahsztán",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Észak-Korea",
  KR: "Dél-Korea",
  KW: "Kuvait",
  KG: "Kirgizisztán",
  LA: "Laosz",
  LV: "Lettország",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Litvánia",
  LU: "Luxemburg",
  MO: "Makao",
  MK: "Észak-Macedónia",
  MG: "Madagaszkár",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldív-szigetek",
  ML: "Mali",
  MT: "Málta",
  MH: "Marshall-szigetek",
  MQ: "Martinique",
  MR: "Mauritánia",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexikó",
  FM: "Mikronéziai Szövetségi Államok",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongólia",
  MS: "Montserrat",
  MA: "Marokkó",
  MZ: "Mozambik",
  MM: "Mianmar",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepál",
  NL: "Hollandia",
  NC: "Új-Kaledónia",
  NZ: "Új-Zéland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niue",
  NF: "Norfolk-sziget",
  MP: "Északi-Mariana-szigetek",
  NO: "Norvégia",
  OM: "Omán",
  PK: "Pakisztán",
  PW: "Palau",
  PS: "Palesztina",
  PA: "Panama",
  PG: "Pápua Új-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Fülöp-szigetek",
  PN: "Pitcairn-szigetek",
  PL: "Lengyelország",
  PT: "Portugália",
  PR: "Puerto Rico",
  QA: "Katar",
  RE: "Réunion",
  RO: "Románia",
  RU: "Oroszország",
  RW: "Ruanda",
  SH: "Saint Helena",
  KN: "Saint Kitts és Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent és a Grenadine-szigetek",
  WS: "Szamoa",
  SM: "San Marino",
  ST: "São Tomé és Príncipe",
  SA: "Szaudi-Arábia",
  SN: "Szenegál",
  SC: "Seychelle-szigetek",
  SL: "Sierra Leone",
  SG: "Szingapúr",
  SK: "Szlovákia",
  SI: "Szlovénia",
  SB: "Salamon-szigetek",
  SO: "Szomália",
  ZA: "Dél-Afrika",
  GS: "Déli-Georgia és Déli-Sandwich-szigetek",
  ES: "Spanyolország",
  LK: "Sri Lanka",
  SD: "Szudán",
  SR: "Suriname",
  SJ: "Spitzbergák és Jan Mayen",
  SZ: "Szváziföld",
  SE: "Svédország",
  CH: "Svájc",
  SY: "Szíria",
  TW: "Tajvan",
  TJ: "Tádzsikisztán",
  TZ: "Tanzánia",
  TH: "Thaiföld",
  TL: "Kelet-Timor",
  TG: "Togo",
  TK: "Tokelau-szigetek",
  TO: "Tonga",
  TT: "Trinidad és Tobago",
  TN: "Tunézia",
  TR: "Törökország",
  TM: "Türkmenisztán",
  TC: "Turks- és Caicos-szigetek",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajna",
  AE: "Egyesült Arab Emírségek",
  GB: "Egyesült Királyság",
  US: "Amerikai Egyesült Államok",
  UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai",
  UY: "Uruguay",
  UZ: "Üzbegisztán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Brit Virgin-szigetek",
  VI: "Amerikai Virgin-szigetek",
  WF: "Wallis és Futuna",
  EH: "Nyugat-Szahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibi Hollandia",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man-sziget",
  JE: "Jersey",
  ME: "Montenegró",
  BL: "Saint Barthélemy",
  MF: "Szent Márton-sziget (francia rész)",
  RS: "Szerbia",
  SX: "Szent Márton-sziget (holland rész)",
  SS: "Dél-Szudán",
  XK: "Koszovó"
}, qg = {
  locale: ii,
  countries: oi
}, Qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: oi,
  default: qg,
  locale: ii
}, Symbol.toStringTag, { value: "Module" })), si = "id", li = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarusia",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BV: "Kepulauan Bouvet",
  BR: "Brasil",
  IO: "Teritori Samudra Hindia Britania",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Tanjung Verde",
  KY: "Kepulauan Cayman",
  CF: "Afrika Tengah",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Pulau Natal",
  CC: "Kepulauan Cocos (Keeling)",
  CO: "Kolombia",
  KM: "Komoro",
  CG: "Kongo",
  CD: "Republik Demokratik Kongo",
  CK: "Kepulauan Cook",
  CR: "Kosta Rika",
  CI: "Pantai Gading",
  HR: "Kroasia",
  CU: "Kuba",
  CY: "Siprus",
  CZ: "Republik Ceko",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominika",
  DO: "Republik Dominika",
  EC: "Ekuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Khatulistiwa",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Kepulauan Falkland(Malvinas)",
  FO: "Kepulauan Faroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Perancis",
  GF: "Guyana Perancis",
  PF: "Polinesia Perancis",
  TF: "Antartika Perancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Yunani",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatamala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Pulau Heard dan Kepulauan McDonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungaria",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Jepang",
  JO: "Yordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea Utara",
  KR: "Korea Selatan",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxemburg",
  MO: "Makau",
  MK: "Makedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MQ: "Martinik",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  FM: "Federasi Mikronesia",
  MD: "Moldova",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Moroko",
  MZ: "Mozambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Belanda",
  NC: "Kaledonia Baru",
  NZ: "Selandia Baru",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Kepulauan Norfolk",
  MP: "Kepulauan Mariana Utara",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nugini",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PN: "Pitcairn",
  PL: "Polandia",
  PT: "Portugal",
  PR: "Puerto Riko",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Rumania",
  RU: "Rusia",
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre dan Miquelon",
  VC: "Saint Vincent dan the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome dan Principe",
  SA: "Arab Saudi",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  GS: "Georgia Selatan dan Kepulauan Sandwich Selatan",
  ES: "Spanyol",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard dan Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Swiss",
  SY: "Suriah",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Turks dan Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Uni Emirat Arab",
  GB: "Britania Raya",
  US: "Amerika Serikat",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Sahara Barat",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland Islands",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "Sudan Selatan",
  XK: "Kosovo"
}, Xg = {
  locale: si,
  countries: li
}, ev = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: li,
  default: Xg,
  locale: si
}, Symbol.toStringTag, { value: "Module" })), ci = "it", ui = {
  AD: "Andorra",
  AE: "Emirati Arabi Uniti",
  AF: "Afghanistan",
  AG: "Antigua e Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antartide",
  AR: "Argentina",
  AS: "Samoa Americane",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Isole Åland",
  AZ: "Azerbaigian",
  BA: "Bosnia ed Erzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgio",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Isole BES",
  BR: "Brasile",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Isola Bouvet",
  BW: "Botswana",
  BY: "Bielorussia",
  BZ: "Belize",
  CA: "Canada",
  CC: "Isole Cocos e Keeling",
  CD: "Repubblica Democratica del Congo",
  CF: "Repubblica Centrafricana",
  CG: "Repubblica del Congo",
  CH: "Svizzera",
  CI: "Costa d'Avorio",
  CK: "Isole Cook",
  CL: "Cile",
  CM: "Camerun",
  CN: "Cina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capo Verde",
  CW: "Curaçao",
  CX: "Isola del Natale",
  CY: "Cipro",
  CZ: "Repubblica Ceca",
  DE: "Germania",
  DJ: "Gibuti",
  DK: "Danimarca",
  DM: "Dominica",
  DO: "Repubblica Dominicana",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egitto",
  EH: "Sahara Occidentale",
  ER: "Eritrea",
  ES: "Spagna",
  ET: "Etiopia",
  FI: "Finlandia",
  FJ: "Figi",
  FK: "Isole Falkland",
  FM: "Stati Federati di Micronesia",
  FO: "Isole Fær Øer",
  FR: "Francia",
  GA: "Gabon",
  GB: "Regno Unito",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Francese",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibilterra",
  GL: "Groenlandia",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadalupa",
  GQ: "Guinea Equatoriale",
  GR: "Grecia",
  GS: "Georgia del Sud e isole Sandwich meridionali",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Isole Heard e McDonald",
  HN: "Honduras",
  HR: "Croazia",
  HT: "Haiti",
  HU: "Ungheria",
  ID: "Indonesia",
  IE: "Irlanda",
  IL: "Israele",
  IM: "Isola di Man",
  IN: "India",
  IO: "Territori Britannici dell'Oceano Indiano",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Giamaica",
  JO: "Giordania",
  JP: "Giappone",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambogia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts e Nevis",
  KP: "Corea del Nord",
  KR: "Corea del Sud",
  KW: "Kuwait",
  KY: "Isole Cayman",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Libano",
  LC: "Santa Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Lussemburgo",
  LV: "Lettonia",
  LY: "Libia",
  MA: "Marocco",
  MC: "Monaco",
  MD: "Moldavia",
  ME: "Montenegro",
  MF: "Saint-Martin",
  MG: "Madagascar",
  MH: "Isole Marshall",
  MK: "Macedonia del Nord",
  ML: "Mali",
  MM: "Birmania  Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Isole Marianne Settentrionali",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Messico",
  MY: "Malesia",
  MZ: "Mozambico",
  NA: "Namibia",
  NC: "Nuova Caledonia",
  NE: "Niger",
  NF: "Isola Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Paesi Bassi",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nuova Zelanda",
  OM: "Oman",
  PA: "Panamá",
  PE: "Perù",
  PF: "Polinesia Francese",
  PG: "Papua Nuova Guinea",
  PH: "Filippine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint Pierre e Miquelon",
  PN: "Isole Pitcairn",
  PR: "Porto Rico",
  PS: "Stato di Palestina",
  PT: "Portogallo",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Ruanda",
  SA: "Arabia Saudita",
  SB: "Isole Salomone",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Svezia",
  SG: "Singapore",
  SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
  SI: "Slovenia",
  SJ: "Svalbard e Jan Mayen",
  SK: "Slovacchia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudan del Sud",
  ST: "São Tomé e Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Isole Turks e Caicos",
  TD: "Ciad",
  TF: "Territori Francesi del Sud",
  TG: "Togo",
  TH: "Thailandia",
  TJ: "Tagikistan",
  TK: "Tokelau",
  TL: "Timor Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turchia",
  TT: "Trinidad e Tobago",
  TV: "Tuvalu",
  TW: [
    "Repubblica di Cina",
    "Taiwan"
  ],
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Isole minori esterne degli Stati Uniti",
  US: "Stati Uniti d'America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Città del Vaticano",
  VC: "Saint Vincent e Grenadine",
  VE: "Venezuela",
  VG: "Isole Vergini Britanniche",
  VI: "Isole Vergini Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis e Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Sudafrica",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, tv = {
  locale: ci,
  countries: ui
}, av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ui,
  default: tv,
  locale: ci
}, Symbol.toStringTag, { value: "Module" })), di = "ja", Ci = {
  AF: "アフガニスタン",
  AL: "アルバニア",
  DZ: "アルジェリア",
  AS: "アメリカ領サモア",
  AD: "アンドラ",
  AO: "アンゴラ",
  AI: "アンギラ",
  AQ: "南極",
  AG: "アンティグア・バーブーダ",
  AR: "アルゼンチン",
  AM: "アルメニア",
  AW: "アルバ",
  AU: "オーストラリア",
  AT: "オーストリア",
  AZ: "アゼルバイジャン",
  BS: "バハマ",
  BH: "バーレーン",
  BD: "バングラデシュ",
  BB: "バルバドス",
  BY: "ベラルーシ",
  BE: "ベルギー",
  BZ: "ベリーズ",
  BJ: "ベナン",
  BM: "バミューダ",
  BT: "ブータン",
  BO: "ボリビア多民族国",
  BA: "ボスニア・ヘルツェゴビナ",
  BW: "ボツワナ",
  BV: "ブーベ島",
  BR: "ブラジル",
  IO: "イギリス領インド洋地域",
  BN: "ブルネイ・ダルサラーム",
  BG: "ブルガリア",
  BF: "ブルキナファソ",
  BI: "ブルンジ",
  KH: "カンボジア",
  CM: "カメルーン",
  CA: "カナダ",
  CV: "カーボベルデ",
  KY: "ケイマン諸島",
  CF: "中央アフリカ共和国",
  TD: "チャド",
  CL: "チリ",
  CN: "中華人民共和国",
  CX: "クリスマス島",
  CC: "ココス（キーリング）諸島",
  CO: "コロンビア",
  KM: "コモロ",
  CG: "コンゴ共和国",
  CD: "コンゴ民主共和国",
  CK: "クック諸島",
  CR: "コスタリカ",
  CI: "コートジボワール",
  HR: "クロアチア",
  CU: "キューバ",
  CY: "キプロス",
  CZ: "チェコ",
  DK: "デンマーク",
  DJ: "ジブチ",
  DM: "ドミニカ国",
  DO: "ドミニカ共和国",
  EC: "エクアドル",
  EG: "エジプト",
  SV: "エルサルバドル",
  GQ: "赤道ギニア",
  ER: "エリトリア",
  EE: "エストニア",
  ET: "エチオピア",
  FK: "フォークランド（マルビナス）諸島",
  FO: "フェロー諸島",
  FJ: "フィジー",
  FI: "フィンランド",
  FR: "フランス",
  GF: "フランス領ギアナ",
  PF: "フランス領ポリネシア",
  TF: "フランス領南方・南極地域",
  GA: "ガボン",
  GM: "ガンビア",
  GE: "ジョージア",
  DE: "ドイツ",
  GH: "ガーナ",
  GI: "ジブラルタル",
  GR: "ギリシャ",
  GL: "グリーンランド",
  GD: "グレナダ",
  GP: "グアドループ",
  GU: "グアム",
  GT: "グアテマラ",
  GN: "ギニア",
  GW: "ギニアビサウ",
  GY: "ガイアナ",
  HT: "ハイチ",
  HM: "ハード島とマクドナルド諸島",
  VA: "バチカン市国",
  HN: "ホンジュラス",
  HK: "香港",
  HU: "ハンガリー",
  IS: "アイスランド",
  IN: "インド",
  ID: "インドネシア",
  IR: "イラン・イスラム共和国",
  IQ: "イラク",
  IE: "アイルランド",
  IL: "イスラエル",
  IT: "イタリア",
  JM: "ジャマイカ",
  JP: "日本",
  JO: "ヨルダン",
  KZ: "カザフスタン",
  KE: "ケニア",
  KI: "キリバス",
  KP: "朝鮮民主主義人民共和国",
  KR: "大韓民国",
  KW: "クウェート",
  KG: "キルギス",
  LA: "ラオス人民民主共和国",
  LV: "ラトビア",
  LB: "レバノン",
  LS: "レソト",
  LR: "リベリア",
  LY: "リビア",
  LI: "リヒテンシュタイン",
  LT: "リトアニア",
  LU: "ルクセンブルク",
  MO: "マカオ",
  MG: "マダガスカル",
  MW: "マラウイ",
  MY: "マレーシア",
  MV: "モルディブ",
  ML: "マリ",
  MT: "マルタ",
  MH: "マーシャル諸島",
  MQ: "マルティニーク",
  MR: "モーリタニア",
  MU: "モーリシャス",
  YT: "マヨット",
  MX: "メキシコ",
  FM: "ミクロネシア連邦",
  MD: "モルドバ共和国",
  MC: "モナコ",
  MN: "モンゴル",
  MS: "モントセラト",
  MA: "モロッコ",
  MZ: "モザンビーク",
  MM: "ミャンマー",
  NA: "ナミビア",
  NR: "ナウル",
  NP: "ネパール",
  NL: "オランダ",
  NC: "ニューカレドニア",
  NZ: "ニュージーランド",
  NI: "ニカラグア",
  NE: "ニジェール",
  NG: "ナイジェリア",
  NU: "ニウエ",
  NF: "ノーフォーク島",
  MK: "北マケドニア",
  MP: "北マリアナ諸島",
  NO: "ノルウェー",
  OM: "オマーン",
  PK: "パキスタン",
  PW: "パラオ",
  PS: "パレスチナ",
  PA: "パナマ",
  PG: "パプアニューギニア",
  PY: "パラグアイ",
  PE: "ペルー",
  PH: "フィリピン",
  PN: "ピトケアン",
  PL: "ポーランド",
  PT: "ポルトガル",
  PR: "プエルトリコ",
  QA: "カタール",
  RE: "レユニオン",
  RO: "ルーマニア",
  RU: "ロシア連邦",
  RW: "ルワンダ",
  SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
  KN: "セントクリストファー・ネイビス",
  LC: "セントルシア",
  PM: "サンピエール島・ミクロン島",
  VC: "セントビンセントおよびグレナディーン諸島",
  WS: "サモア",
  SM: "サンマリノ",
  ST: "サントメ・プリンシペ",
  SA: "サウジアラビア",
  SN: "セネガル",
  SC: "セーシェル",
  SL: "シエラレオネ",
  SG: "シンガポール",
  SK: "スロバキア",
  SI: "スロベニア",
  SB: "ソロモン諸島",
  SO: "ソマリア",
  ZA: "南アフリカ",
  GS: "サウスジョージア・サウスサンドウィッチ諸島",
  ES: "スペイン",
  LK: "スリランカ",
  SD: "スーダン",
  SR: "スリナム",
  SJ: "スヴァールバル諸島およびヤンマイエン島",
  SZ: "スワジランド",
  SE: "スウェーデン",
  CH: "スイス",
  SY: "シリア・アラブ共和国",
  TW: "台湾",
  TJ: "タジキスタン",
  TZ: "タンザニア",
  TH: "タイ",
  TL: "東ティモール",
  TG: "トーゴ",
  TK: "トケラウ",
  TO: "トンガ",
  TT: "トリニダード・トバゴ",
  TN: "チュニジア",
  TR: "トルコ",
  TM: "トルクメニスタン",
  TC: "タークス・カイコス諸島",
  TV: "ツバル",
  UG: "ウガンダ",
  UA: "ウクライナ",
  AE: "アラブ首長国連邦",
  GB: "イギリス",
  US: "アメリカ合衆国",
  UM: "合衆国領有小離島",
  UY: "ウルグアイ",
  UZ: "ウズベキスタン",
  VU: "バヌアツ",
  VE: "ベネズエラ・ボリバル共和国",
  VN: "ベトナム",
  VG: "イギリス領ヴァージン諸島",
  VI: "アメリカ領ヴァージン諸島",
  WF: "ウォリス・フツナ",
  EH: "西サハラ",
  YE: "イエメン",
  ZM: "ザンビア",
  ZW: "ジンバブエ",
  AX: "オーランド諸島",
  BQ: "ボネール、シント・ユースタティウスおよびサバ",
  CW: "キュラソー",
  GG: "ガーンジー",
  IM: "マン島",
  JE: "ジャージー",
  ME: "モンテネグロ",
  BL: "サン・バルテルミー",
  MF: "サン・マルタン（フランス領）",
  RS: "セルビア",
  SX: "シント・マールテン（オランダ領）",
  SS: "南スーダン",
  XK: "コソボ"
}, nv = {
  locale: di,
  countries: Ci
}, rv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ci,
  default: nv,
  locale: di
}, Symbol.toStringTag, { value: "Module" })), pi = "nl", hi = {
  AF: "Afghanistan",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: [
    "België",
    "Koninkrijk België"
  ],
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivië",
  BA: "Bosnië-Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Eiland",
  BR: "Brazilië",
  IO: "Brits Indische oceaan",
  BN: "Brunei Darussalam",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo, Volksrepubliek",
  CD: "Congo, Democratische Republiek",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Ethiopië",
  FK: "Falklandeilanden",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Heilige Stoel",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran",
  IQ: "Irak",
  IE: "Ierland",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Noord-Korea",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: [
    "Maldiven",
    "Malediven"
  ],
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië, Federale Staten",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Nederland",
    "Koninkrijk der Nederlanden"
  ],
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Noordelijke Marianen",
  MK: "Noord-Macedonië",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sint-Helena",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé en Principe",
  SA: "Saudi-Arabië",
  SN: "Senegal",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SZ: "Ngwane, Koninkrijk Eswatini",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrië",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: [
    "Tanzania",
    "Tanzania, Verenigde Republiek"
  ],
  TH: "Thailand",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: [
    "Groot-Brittannië",
    "Verenigd Koninkrijk"
  ],
  US: [
    "Verenigde Staten van Amerika",
    "Verenigde Staten"
  ],
  UM: "Ver afgelegen eilandjes van de Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Maagdeneilanden, Britse",
  VI: "Maagdeneilanden, Amerikaanse",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Sint Eustatius en Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man Eiland",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: [
    "Sint-Maarten (Frans deel)",
    "Sint-Maarten (Franse Antillen)",
    "Collectiviteit van Sint-Maarten"
  ],
  RS: "Servië",
  SX: [
    "Sint Maarten",
    "Sint-Maarten",
    "Sint Maarten (Nederlands deel)",
    "Land Sint Maarten"
  ],
  SS: "Zuid-Soedan",
  XK: "Kosovo"
}, iv = {
  locale: pi,
  countries: hi
}, ov = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: hi,
  default: iv,
  locale: pi
}, Symbol.toStringTag, { value: "Module" })), fi = "no", mi = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviterussland",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvetøya",
  BR: "Brasil",
  IO: "Det britiske territoriet i Indiahavet",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Caymanøyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Tsjad",
  CL: "Chile",
  CN: "Kina",
  CX: "Christmasøya",
  CC: "Kokosøyene",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo-Brazzaville",
  CD: "Kongo",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CU: "Cuba",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopia",
  FK: "Falklandsøyene",
  FO: "Færøyene",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesia",
  TF: "De franske sørterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- og McDonaldøyene",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hongkong SAR Kina",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nord-Korea",
  KR: "Sør-Korea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR Kina",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløyene",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesiaføderasjonen",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Ny-Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkøya",
  MK: "Nord-Makedonia",
  MP: "Nord-Marianene",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Det palestinske området",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PN: "Pitcairnøyene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  SH: "St. Helena",
  KN: "Saint Kitts og Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "St. Vincent og Grenadinene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonøyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  ES: "Spania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Sveits",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Øst-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "De forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UM: "USAs ytre øyer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "De britiske jomfruøyene",
  VI: "De amerikanske jomfruøyene",
  WF: "Wallis og Futuna",
  EH: "Vest-Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibisk Nederland",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sør-Sudan",
  XK: "Kosovo"
}, sv = {
  locale: fi,
  countries: mi
}, lv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: mi,
  default: sv,
  locale: fi
}, Symbol.toStringTag, { value: "Module" })), gi = "pl", vi = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algieria",
  AS: "Samoa Amerykańskie",
  AD: "Andora",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktyka",
  AG: "Antigua i Barbuda",
  AR: "Argentyna",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbejdżan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladesz",
  BB: "Barbados",
  BY: "Białoruś",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhutan",
  BO: "Boliwia",
  BA: "Bośnia i Hercegowina",
  BW: "Botswana",
  BV: "Wyspa Bouveta",
  BR: "Brazylia",
  IO: "Brytyjskie Terytorium Oceanu Indyjskiego",
  BN: "Brunei",
  BG: "Bułgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodża",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Republika Zielonego Przylądka",
  KY: "Kajmany",
  CF: "Republika Środkowoafrykańska",
  TD: "Czad",
  CL: "Chile",
  CN: "Chiny",
  CX: "Wyspa Bożego Narodzenia",
  CC: "Wyspy Kokosowe",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Kongo",
  CD: "Demokratyczna Republika Konga",
  CK: "Wyspy Cooka",
  CR: "Kostaryka",
  CI: "Wybrzeże Kości Słoniowej",
  HR: "Chorwacja",
  CU: "Kuba",
  CY: "Cypr",
  CZ: "Czechy",
  DK: "Dania",
  DJ: "Dżibuti",
  DM: "Dominika",
  DO: "Dominikana",
  EC: "Ekwador",
  EG: "Egipt",
  SV: "Salwador",
  GQ: "Gwinea Równikowa",
  ER: "Erytrea",
  EE: "Estonia",
  ET: "Etiopia",
  FK: "Falklandy",
  FO: "Wyspy Owcze",
  FJ: "Fidżi",
  FI: "Finlandia",
  FR: "Francja",
  GF: "Gujana Francuska",
  PF: "Polinezja Francuska",
  TF: "Francuskie Terytoria Południowe i Antarktyczne",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzja",
  DE: "Niemcy",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecja",
  GL: "Grenlandia",
  GD: "Grenada",
  GP: "Gwadelupa",
  GU: "Guam",
  GT: "Gwatemala",
  GN: "Gwinea",
  GW: "Gwinea Bissau",
  GY: "Gujana",
  HT: "Haiti",
  HM: "Wyspy Heard i McDonalda",
  VA: "Watykan",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Węgry",
  IS: "Islandia",
  IN: "Indie",
  ID: "Indonezja",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Izrael",
  IT: "Włochy",
  JM: "Jamajka",
  JP: "Japonia",
  JO: "Jordania",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea Północna",
  KR: "Korea Południowa",
  KW: "Kuwejt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Łotwa",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Litwa",
  LU: "Luksemburg",
  MO: "Makau",
  MK: "Macedonia Północna",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malezja",
  MV: "Malediwy",
  ML: "Mali",
  MT: "Malta",
  MH: "Wyspy Marshalla",
  MQ: "Martynika",
  MR: "Mauretania",
  MU: "Mauritius",
  YT: "Majotta",
  MX: "Meksyk",
  FM: "Mikronezja",
  MD: "Mołdawia",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanma",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandia",
  NC: "Nowa Kaledonia",
  NZ: "Nowa Zelandia",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Mariany Północne",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestyna",
  PA: "Panama",
  PG: "Papua-Nowa Gwinea",
  PY: "Paragwaj",
  PE: "Peru",
  PH: "Filipiny",
  PN: "Pitcairn",
  PL: "Polska",
  PT: "Portugalia",
  PR: "Portoryko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumunia",
  RU: "Rosja",
  RW: "Rwanda",
  SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
  KN: "Saint Kitts i Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre i Miquelon",
  VC: "Saint Vincent i Grenadyny",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Wyspy Świętego Tomasza i Książęca",
  SA: "Arabia Saudyjska",
  SN: "Senegal",
  SC: "Seszele",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Słowacja",
  SI: "Słowenia",
  SB: "Wyspy Salomona",
  SO: "Somalia",
  ZA: "Południowa Afryka",
  GS: "Georgia Południowa i Sandwich Południowy",
  ES: "Hiszpania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard i Jan Mayen",
  SZ: "Eswatini",
  SE: "Szwecja",
  CH: "Szwajcaria",
  SY: "Syria",
  TW: "Tajwan",
  TJ: "Tadżykistan",
  TZ: "Tanzania",
  TH: "Tajlandia",
  TL: "Timor Wschodni",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trynidad i Tobago",
  TN: "Tunezja",
  TR: "Turcja",
  TM: "Turkmenistan",
  TC: "Turks i Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Zjednoczone Emiraty Arabskie",
  GB: "Wielka Brytania",
  US: "Stany Zjednoczone",
  UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  UY: "Urugwaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Wenezuela",
  VN: "Wietnam",
  VG: "Brytyjskie Wyspy Dziewicze",
  VI: "Wyspy Dziewicze Stanów Zjednoczonych",
  WF: "Wallis i Futuna",
  EH: "Sahara Zachodnia",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Wyspy Alandzkie",
  BQ: "Bonaire, Sint Eustatius i Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Wyspa Man",
  JE: "Jersey",
  ME: "Czarnogóra",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sudan Południowy",
  XK: "Kosowo"
}, cv = {
  locale: gi,
  countries: vi
}, uv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: vi,
  default: cv,
  locale: gi
}, Symbol.toStringTag, { value: "Module" })), bi = "pt", yi = {
  AF: "Afeganistão",
  ZA: "África do Sul",
  AL: "Albânia",
  DE: "Alemanha",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antígua e Barbuda",
  SA: "Arábia Saudita",
  DZ: "Argélia",
  AR: "Argentina",
  AM: "Arménia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benim",
  BM: "Bermudas",
  BY: "Bielorrússia",
  BO: "Bolívia",
  BA: "Bósnia-Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  BT: "Butão",
  CV: "Cabo Verde",
  KH: "Camboja",
  CA: "Canadá",
  QA: "Qatar",
  KZ: "Cazaquistão",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CY: "Chipre",
  VA: "Santa Sé",
  SG: "Singapura",
  CO: "Colômbia",
  KM: "Comores",
  CG: "República Democrática do Congo",
  CD: "República Popular do Congo",
  KP: "Coreia do Norte",
  KR: "Coreia do Sul",
  CI: "Costa do Marfim",
  CR: "Costa Rica",
  HR: "Croácia",
  CU: "Cuba",
  CW: "Curaçao",
  DK: "Dinamarca",
  DJ: "Djibouti",
  DM: "Dominica",
  EG: "Egito",
  SV: "El Salvador",
  AE: "Emirados Árabes Unidos",
  EC: "Equador",
  ER: "Eritreia",
  SK: "Eslováquia",
  SI: "Eslovénia",
  ES: "Espanha",
  US: [
    "Estados Unidos",
    "Estados Unidos da América"
  ],
  EE: "Estónia",
  ET: "Etiópia",
  FJ: "Fiji",
  PH: "Filipinas",
  FI: "Finlândia",
  FR: "França",
  GA: "Gabão",
  GM: "Gâmbia",
  GH: "Gana",
  GE: "Geórgia",
  GS: "Geórgia do Sul e Ilhas Sandwich do Sul",
  GI: "Gibraltar",
  GD: "Granada",
  GR: "Grécia",
  GL: "Gronelândia",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GY: "Guiana",
  GF: "Guiana Francesa",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GQ: "Guiné Equatorial",
  HT: "Haiti",
  NL: "Países Baixos",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungria",
  YE: "Iémen",
  BV: "Ilha Bouvet",
  CX: "Ilha de Natal",
  IM: "Ilha de Man",
  NF: "Ilha Norfolk",
  AX: "Ilhas Åland",
  KY: "Ilhas Caimão",
  CC: "Ilhas Cocos (Keeling)",
  CK: "Ilhas Cook",
  UM: "Ilhas Distantes dos EUA",
  HM: "Ilha Heard e Ilhas McDonald",
  FO: "Ilhas Faroé",
  FK: "Ilhas Malvinas",
  MP: "Ilhas Marianas do Norte",
  MH: "Ilhas Marshall",
  PN: "Ilhas Pitcairn",
  SB: "Ilhas Salomão",
  TC: "Ilhas Turcas e Caicos",
  VG: "Ilhas Virgens Britânicas",
  VI: "Ilhas Virgens Americanas",
  IN: "Índia",
  ID: "Indonésia",
  IR: "Irão",
  IQ: "Iraque",
  IE: "Irlanda",
  IS: "Islândia",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KW: "Koweit",
  LA: "Laos",
  LS: "Lesoto",
  LV: "Letónia",
  LB: "Líbano",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau",
  MK: "Macedónia do Norte",
  MG: "Madagáscar",
  MY: "Malásia",
  MW: "Maláui",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MA: "Marrocos",
  MQ: "Martinica",
  MU: "Maurícia",
  MR: "Mauritânia",
  YT: "Mayotte",
  MX: "México",
  MM: "Mianmar (Birmânia)",
  FM: "Micronésia",
  MZ: "Moçambique",
  MD: "Moldávia",
  MC: "Mónaco",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Monserrate",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepal",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NU: "Niue",
  NO: "Noruega",
  NC: "Nova Caledónia",
  NZ: "Nova Zelândia",
  OM: "Omã",
  BQ: "Países Baixos Caribenhos",
  PW: "Palau",
  PA: "Panamá",
  PG: "Papua-Nova Guiné",
  PK: "Paquistão",
  PY: "Paraguai",
  PE: "Peru",
  PF: "Polinésia Francesa",
  PL: "Polónia",
  PR: "Porto Rico",
  PT: "Portugal",
  KE: "Quénia",
  KG: "Quirguistão",
  KI: "Quiribati",
  GB: "Reino Unido",
  CF: "República Centro-Africana",
  DO: "República Dominicana",
  CM: "Camarões",
  CZ: "Chéquia",
  RE: "Reunião",
  RO: "Roménia",
  RW: "Ruanda",
  RU: "Rússia",
  EH: "Saara Ocidental",
  PM: "Saint Pierre e Miquelon",
  WS: "Samoa",
  AS: "Samoa Americana",
  SM: "San Marino",
  SH: "Santa Helena",
  LC: "Santa Lúcia",
  BL: "São Bartolomeu",
  KN: "São Cristóvão e Neves",
  MF: "São Martinho",
  ST: "São Tomé e Príncipe",
  VC: "São Vicente e Granadinas",
  SN: "Senegal",
  SL: "Serra Leoa",
  RS: "Sérvia",
  SC: "Seychelles",
  SX: "São Martinho",
  SY: "Síria",
  SO: "Somália",
  LK: "Sri Lanka",
  SZ: "Essuatíni",
  SD: "Sudão",
  SS: "Sudão do Sul",
  SE: "Suécia",
  CH: "Suíça",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  TH: "Tailândia",
  TW: "Taiwan",
  TJ: "Tajiquistão",
  TZ: "Tanzânia",
  IO: "Território Britânico do Oceano Índico",
  TF: "Terras Austrais e Antárticas Francesas",
  PS: "Territórios palestinos",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trindade e Tobago",
  TN: "Tunísia",
  TM: "Turquemenistão",
  TR: "Turquia",
  TV: "Tuvalu",
  UA: "Ucrânia",
  UG: "Uganda",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietname",
  WF: "Wallis e Futuna",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
  XK: "Kosovo"
}, dv = {
  locale: bi,
  countries: yi
}, Cv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: yi,
  default: dv,
  locale: bi
}, Symbol.toStringTag, { value: "Module" })), xi = "ro", wi = {
  AD: "Andorra",
  AE: "Emiratele Arabe Unite",
  AF: "Afganistan",
  AG: "Antigua și Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "Samoa Americană",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Insulele Åland",
  AZ: "Azerbaidjan",
  BA: "Bosnia și Herțegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgia",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Sfântul Bartolomeu",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Insulele Caraibe Olandeze",
  BR: "Brazilia",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Insula Bouvet",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Insulele Cocos (Keeling)",
  CD: "Congo - Kinshasa",
  CF: "Republica Centrafricană",
  CG: "Congo - Brazzaville",
  CH: "Elveția",
  CI: "Côte d’Ivoire",
  CK: "Insulele Cook",
  CL: "Chile",
  CM: "Camerun",
  CN: "China",
  CO: "Columbia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capul Verde",
  CW: "Curaçao",
  CX: "Insula Christmas",
  CY: "Cipru",
  CZ: "Cehia",
  DE: "Germania",
  DJ: "Djibouti",
  DK: "Danemarca",
  DM: "Dominica",
  DO: "Republica Dominicană",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egipt",
  EH: "Sahara Occidentală",
  ER: "Eritreea",
  ES: "Spania",
  ET: "Etiopia",
  FI: "Finlanda",
  FJ: "Fiji",
  FK: "Insulele Falkland",
  FM: "Micronezia",
  FO: "Insulele Feroe",
  FR: "Franța",
  GA: "Gabon",
  GB: "Regatul Unit",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Franceză",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenlanda",
  GM: "Gambia",
  GN: "Guineea",
  GP: "Guadelupa",
  GQ: "Guineea Ecuatorială",
  GR: "Grecia",
  GS: "Georgia de Sud și Insulele Sandwich de Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guineea-Bissau",
  GY: "Guyana",
  HK: "R.A.S. Hong Kong a Chinei",
  HM: "Insula Heard și Insulele McDonald",
  HN: "Honduras",
  HR: "Croația",
  HT: "Haiti",
  HU: "Ungaria",
  ID: "Indonezia",
  IE: "Irlanda",
  IL: "Israel",
  IM: "Insula Man",
  IN: "India",
  IO: "Teritoriul Britanic din Oceanul Indian",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Iordania",
  JP: "Japonia",
  KE: "Kenya",
  KG: "Kârgâzstan",
  KH: "Cambodgia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts și Nevis",
  KP: "Coreea de Nord",
  KR: "Coreea de Sud",
  KW: "Kuweit",
  KY: "Insulele Cayman",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Liban",
  LC: "Sfânta Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Luxemburg",
  LV: "Letonia",
  LY: "Libia",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Republica Moldova",
  ME: "Muntenegru",
  MF: "Sfântul Martin",
  MG: "Madagascar",
  MH: "Insulele Marshall",
  MK: "Macedonia de Nord",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "R.A.S. Macao a Chinei",
  MP: "Insulele Mariane de Nord",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Mexic",
  MY: "Malaysia",
  MZ: "Mozambic",
  NA: "Namibia",
  NC: "Noua Caledonie",
  NE: "Niger",
  NF: "Insula Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Țările de Jos",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Noua Zeelandă",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Polinezia Franceză",
  PG: "Papua-Noua Guinee",
  PH: "Filipine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint-Pierre și Miquelon",
  PN: "Insulele Pitcairn",
  PR: "Puerto Rico",
  PS: "Teritoriile Palestiniene",
  PT: "Portugalia",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "România",
  RS: "Serbia",
  RU: "Rusia",
  RW: "Rwanda",
  SA: "Arabia Saudită",
  SB: "Insulele Solomon",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Suedia",
  SG: "Singapore",
  SH: "Sfânta Elena",
  SI: "Slovenia",
  SJ: "Svalbard și Jan Mayen",
  SK: "Slovacia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudanul de Sud",
  ST: "Sao Tomé și Príncipe",
  SV: "El Salvador",
  SX: "Sint-Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Insulele Turks și Caicos",
  TD: "Ciad",
  TF: "Teritoriile Australe și Antarctice Franceze",
  TG: "Togo",
  TH: "Thailanda",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timorul de Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turcia",
  TT: "Trinidad și Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Insulele Îndepărtate ale S.U.A.",
  US: "Statele Unite ale Americii",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Statul Cetății Vaticanului",
  VC: "Saint Vincent și Grenadinele",
  VE: "Venezuela",
  VG: "Insulele Virgine Britanice",
  VI: "Insulele Virgine Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis și Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Africa de Sud",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, pv = {
  locale: xi,
  countries: wi
}, hv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: wi,
  default: pv,
  locale: xi
}, Symbol.toStringTag, { value: "Module" })), _i = "ru", Mi = {
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  AX: "Аландские острова",
  AL: "Албания",
  DZ: "Алжир",
  VI: "Виргинские Острова (США)",
  AS: "Американское Самоа",
  AI: "Ангилья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктида",
  AG: "Антигуа и Барбуда",
  AR: "Аргентина",
  AM: "Армения",
  AW: "Аруба",
  AF: "Афганистан",
  BS: "Багамы",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Белиз",
  BY: "Беларусь",
  BE: "Бельгия",
  BJ: "Бенин",
  BM: "Бермуды",
  BG: "Болгария",
  BO: "Боливия",
  BQ: "Бонэйр, Синт-Эстатиус и Саба",
  BA: "Босния и Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  IO: "Британская территория в Индийском океане",
  VG: "Виргинские Острова (Великобритания)",
  BN: "Бруней",
  BF: "Буркина-Фасо",
  BI: "Бурунди",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобритания",
  HU: "Венгрия",
  VE: "Венесуэла",
  UM: "Внешние малые острова (США)",
  TL: "Восточный Тимор",
  VN: "Вьетнам",
  GA: "Габон",
  HT: "Гаити",
  GY: "Гайана",
  GM: "Гамбия",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвиана",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  DE: "Германия",
  GG: "Гернси",
  GI: "Гибралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GL: "Гренландия",
  GR: "Греция",
  GE: "Грузия",
  GU: "Гуам",
  DK: "Дания",
  JE: "Джерси",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканская Республика",
  CD: "Демократическая Республика Конго",
  EG: "Египет",
  ZM: "Замбия",
  EH: "САДР",
  ZW: "Зимбабве",
  IL: "Израиль",
  IN: "Индия",
  ID: "Индонезия",
  JO: "Иордания",
  IQ: "Ирак",
  IR: "Иран",
  IE: "Ирландия",
  IS: "Исландия",
  ES: "Испания",
  IT: "Италия",
  YE: "Йемен",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Острова Кайман",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  QA: "Катар",
  KE: "Кения",
  CY: "Кипр",
  KG: "Киргизия",
  KI: "Кирибати",
  TW: [
    "Тайвань",
    "Китайская Республика"
  ],
  KP: "КНДР (Корейская Народно-Демократическая Республика)",
  CN: "КНР (Китайская Народная Республика)",
  CC: "Кокосовые острова",
  CO: "Колумбия",
  KM: "Коморы",
  CR: "Коста-Рика",
  CI: "Кот-д’Ивуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвия",
  LS: "Лесото",
  LR: "Либерия",
  LB: "Ливан",
  LY: "Ливия",
  LT: "Литва",
  LI: "Лихтенштейн",
  LU: "Люксембург",
  MU: "Маврикий",
  MR: "Мавритания",
  MG: "Мадагаскар",
  YT: "Майотта",
  MO: "Макао",
  MW: "Малави",
  MY: "Малайзия",
  ML: "Мали",
  MV: "Мальдивы",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиника",
  MH: "Маршалловы Острова",
  MX: "Мексика",
  FM: "Микронезия",
  MZ: "Мозамбик",
  MD: "Молдавия",
  MC: "Монако",
  MN: "Монголия",
  MS: "Монтсеррат",
  MM: "Мьянма",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NE: "Нигер",
  NG: "Нигерия",
  NL: "Нидерланды",
  NI: "Никарагуа",
  NU: "Ниуэ",
  NZ: "Новая Зеландия",
  NC: "Новая Каледония",
  NO: "Норвегия",
  AE: "ОАЭ",
  OM: "Оман",
  BV: "Остров Буве",
  IM: "Остров Мэн",
  CK: "Острова Кука",
  NF: "Остров Норфолк",
  CX: "Остров Рождества",
  PN: "Острова Питкэрн",
  SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Государство Палестина",
  PA: "Панама",
  PG: "Папуа — Новая Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PL: "Польша",
  PT: "Португалия",
  PR: "Пуэрто-Рико",
  CG: "Республика Конго",
  KR: "Республика Корея",
  RE: "Реюньон",
  RU: [
    "Российская Федерация",
    "Россия"
  ],
  RW: "Руанда",
  RO: "Румыния",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе и Принсипи",
  SA: "Саудовская Аравия",
  SZ: "Эсватини",
  MK: "Северная Македония",
  MP: "Северные Марианские Острова",
  SC: "Сейшельские Острова",
  BL: "Сен-Бартелеми",
  MF: "Сен-Мартен",
  PM: "Сен-Пьер и Микелон",
  SN: "Сенегал",
  VC: "Сент-Винсент и Гренадины",
  KN: "Сент-Китс и Невис",
  LC: "Сент-Люсия",
  RS: "Сербия",
  SG: "Сингапур",
  SX: "Синт-Мартен",
  SY: "Сирия",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломоновы Острова",
  SO: "Сомали",
  SD: "Судан",
  SR: "Суринам",
  US: "США",
  SL: "Сьерра-Леоне",
  TJ: "Таджикистан",
  TH: "Таиланд",
  TZ: "Танзания",
  TC: "Теркс и Кайкос",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TN: "Тунис",
  TM: "Туркмения",
  TR: "Турция",
  UG: "Уганда",
  UZ: "Узбекистан",
  UA: "Украина",
  WF: "Уоллис и Футуна",
  UY: "Уругвай",
  FO: "Фареры",
  FJ: "Фиджи",
  PH: "Филиппины",
  FI: "Финляндия",
  FK: "Фолклендские острова",
  FR: "Франция",
  PF: "Французская Полинезия",
  TF: "Французские Южные и Антарктические Территории",
  HM: "Херд и Макдональд",
  HR: "Хорватия",
  CF: "ЦАР",
  TD: "Чад",
  ME: "Черногория",
  CZ: "Чехия",
  CL: "Чили",
  CH: "Швейцария",
  SE: "Швеция",
  SJ: "Шпицберген и Ян-Майен",
  LK: "Шри-Ланка",
  EC: "Эквадор",
  GQ: "Экваториальная Гвинея",
  ER: "Эритрея",
  EE: "Эстония",
  ET: "Эфиопия",
  ZA: "ЮАР",
  GS: "Южная Георгия и Южные Сандвичевы Острова",
  SS: "Южный Судан",
  JM: "Ямайка",
  JP: "Япония",
  XK: "Косово"
}, fv = {
  locale: _i,
  countries: Mi
}, mv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Mi,
  default: fv,
  locale: _i
}, Symbol.toStringTag, { value: "Module" })), Si = "sk", ki = {
  AD: "Andorra",
  AE: "Spojené arabské emiráty",
  AF: "Afganistan",
  AG: "Antigua a Barbuda",
  AI: "Anguilla",
  AL: "Albánsko",
  AM: "Arménsko",
  AO: "Angola",
  AQ: "Antarktída",
  AR: "Argentína",
  AS: "Americká Samoa",
  AT: "Rakúsko",
  AU: "Austrália",
  AW: "Aruba",
  AX: "Alandy",
  AZ: "Azerbajdžan",
  BA: "Bosna a Hercegovina",
  BB: "Barbados",
  BD: "Bangladéš",
  BE: "Belgicko",
  BF: "Burkina Faso",
  BG: "Bulharsko",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Svätý Bartolomej",
  BM: "Bermudy",
  BN: "Brunej",
  BO: "Bolívia",
  BQ: "Karibské Holandsko",
  BR: "Brazília",
  BS: "Bahamy",
  BT: "Bhután",
  BV: "Bouvetov ostrov",
  BW: "Botswana",
  BY: "Bielorusko",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosové ostrovy",
  CD: "Konžská demokratická republika",
  CF: "Stredoafrická republika",
  CG: "Konžská republika",
  CH: "Švajčiarsko",
  CI: "Pobrežie Slonoviny",
  CK: "Cookove ostrovy",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Čína",
  CO: "Kolumbia",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Kapverdy",
  CW: "Curaçao",
  CX: "Vianočný ostrov",
  CY: "Cyprus",
  CZ: "Česko",
  DE: "Nemecko",
  DJ: "Džibutsko",
  DK: "Dánsko",
  DM: "Dominika",
  DO: "Dominikánska republika",
  DZ: "Alžírsko",
  EC: "Ekvádor",
  EE: "Estónsko",
  EG: "Egypt",
  EH: "Západná Sahara",
  ER: "Eritrea",
  ES: "Španielsko",
  ET: "Etiópia",
  FI: "Fínsko",
  FJ: "Fidži",
  FK: "Falklandy",
  FM: "Mikronézia",
  FO: "Faerské ostrovy",
  FR: "Francúzsko",
  GA: "Gabon",
  GB: "Spojené kráľovstvo",
  GD: "Grenada",
  GE: "Gruzínsko",
  GF: "Francúzska Guayana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltár",
  GL: "Grónsko",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Rovníková Guinea",
  GR: "Grécko",
  GS: "Južná Georgia a Južné Sandwichove ostrovy",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guayana",
  HK: "Hongkong – OAO Číny",
  HM: "Heardov ostrov a Macdonaldove ostrovy",
  HN: "Honduras",
  HR: "Chorvátsko",
  HT: "Haiti",
  HU: "Maďarsko",
  ID: "Indonézia",
  IE: "Írsko",
  IL: "Izrael",
  IM: "Ostrov Man",
  IN: "India",
  IO: "Britské indickooceánske územie",
  IQ: "Irak",
  IR: "Irán",
  IS: "Island",
  IT: "Taliansko",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordánsko",
  JP: "Japonsko",
  KE: "Keňa",
  KG: "Kirgizsko",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komory",
  KN: "Svätý Krištof a Nevis",
  KP: "Severná Kórea",
  KR: "Južná Kórea",
  KW: "Kuvajt",
  KY: "Kajmanie ostrovy",
  KZ: "Kazachstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Svätá Lucia",
  LI: "Lichtenštajnsko",
  LK: "Srí Lanka",
  LR: "Libéria",
  LS: "Lesotho",
  LT: "Litva",
  LU: "Luxembursko",
  LV: "Lotyšsko",
  LY: "Líbya",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavsko",
  ME: "Čierna Hora",
  MF: "Svätý Martin (fr.)",
  MG: "Madagaskar",
  MH: "Marshallove ostrovy",
  MK: "Severné Macedónsko",
  ML: "Mali",
  MM: "Mjanmarsko",
  MN: "Mongolsko",
  MO: "Macao – OAO Číny",
  MP: "Severné Mariány",
  MQ: "Martinik",
  MR: "Mauritánia",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Maurícius",
  MV: "Maldivy",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malajzia",
  MZ: "Mozambik",
  NA: "Namíbia",
  NC: "Nová Kaledónia",
  NE: "Niger",
  NF: "Norfolk",
  NG: "Nigéria",
  NI: "Nikaragua",
  NL: "Holandsko",
  NO: "Nórsko",
  NP: "Nepál",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nový Zéland",
  OM: "Omán",
  PA: "Panama",
  PE: "Peru",
  PF: "Francúzska Polynézia",
  PG: "Papua Nová Guinea",
  PH: "Filipíny",
  PK: "Pakistan",
  PL: "Poľsko",
  PM: "Saint Pierre a Miquelon",
  PN: "Pitcairnove ostrovy",
  PR: "Portoriko",
  PS: "Palestínske územia",
  PT: "Portugalsko",
  PW: "Palau",
  PY: "Paraguaj",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumunsko",
  RS: "Srbsko",
  RU: "Rusko",
  RW: "Rwanda",
  SA: "Saudská Arábia",
  SB: "Šalamúnove ostrovy",
  SC: "Seychely",
  SD: "Sudán",
  SE: "Švédsko",
  SG: "Singapur",
  SH: "Svätá Helena",
  SI: "Slovinsko",
  SJ: "Svalbard a Jan Mayen",
  SK: "Slovensko",
  SL: "Sierra Leone",
  SM: "San Maríno",
  SN: "Senegal",
  SO: "Somálsko",
  SR: "Surinam",
  SS: "Južný Sudán",
  ST: "Svätý Tomáš a Princov ostrov",
  SV: "Salvádor",
  SX: "Svätý Martin (hol.)",
  SY: "Sýria",
  SZ: "Svazijsko",
  TC: "Turks a Caicos",
  TD: "Čad",
  TF: "Francúzske južné a antarktické územia",
  TG: "Togo",
  TH: "Thajsko",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Východný Timor",
  TM: "Turkménsko",
  TN: "Tunisko",
  TO: "Tonga",
  TR: "Turecko",
  TT: "Trinidad a Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzánia",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Menšie odľahlé ostrovy USA",
  US: "Spojené štáty",
  UY: "Uruguaj",
  UZ: "Uzbekistan",
  VA: "Vatikán",
  VC: "Svätý Vincent a Grenadíny",
  VE: "Venezuela",
  VG: "Britské Panenské ostrovy",
  VI: "Americké Panenské ostrovy",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis a Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južná Afrika",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, gv = {
  locale: Si,
  countries: ki
}, vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ki,
  default: gv,
  locale: Si
}, Symbol.toStringTag, { value: "Module" })), Li = "sl", Hi = {
  AD: "Andora",
  AE: "Združeni arabski emirati",
  AF: "Afganistan",
  AG: "Antigva in Barbuda",
  AI: "Angvila",
  AL: "Albanija",
  AM: "Armenija",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Argentina",
  AS: "Ameriška Samoa",
  AT: "Avstrija",
  AU: "Avstralija",
  AW: "Aruba",
  AX: "Ålandski otoki",
  AZ: "Azerbajdžan",
  BA: "Bosna in Hercegovina",
  BB: "Barbados",
  BD: "Bangladeš",
  BE: "Belgija",
  BF: "Burkina Faso",
  BG: "Bolgarija",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermudi",
  BN: "Brunej",
  BO: "Bolivija",
  BQ: "Nizozemski Karibi",
  BR: "Brazilija",
  BS: "Bahami",
  BT: "Butan",
  BV: "Bouvetov otok",
  BW: "Bocvana",
  BY: "Belorusija",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosovi otoki",
  CD: "Demokratična republika Kongo",
  CF: "Centralnoafriška republika",
  CG: "Kongo - Brazzaville",
  CH: "Švica",
  CI: "Slonokoščena obala",
  CK: "Cookovi otoki",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Kitajska",
  CO: "Kolumbija",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Zelenortski otoki",
  CW: "Curaçao",
  CX: "Božični otok",
  CY: "Ciper",
  CZ: "Češka",
  DE: "Nemčija",
  DJ: "Džibuti",
  DK: "Danska",
  DM: "Dominika",
  DO: "Dominikanska republika",
  DZ: "Alžirija",
  EC: "Ekvador",
  EE: "Estonija",
  EG: "Egipt",
  EH: "Zahodna Sahara",
  ER: "Eritreja",
  ES: "Španija",
  ET: "Etiopija",
  FI: "Finska",
  FJ: "Fidži",
  FK: "Falklandski otoki",
  FM: "Mikronezija",
  FO: "Ferski otoki",
  FR: "Francija",
  GA: "Gabon",
  GB: "Združeno kraljestvo",
  GD: "Grenada",
  GE: "Gruzija",
  GF: "Francoska Gvajana",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Gibraltar",
  GL: "Grenlandija",
  GM: "Gambija",
  GN: "Gvineja",
  GP: "Gvadalupe",
  GQ: "Ekvatorialna Gvineja",
  GR: "Grčija",
  GS: "Južna Georgia in Južni Sandwichevi otoki",
  GT: "Gvatemala",
  GU: "Guam",
  GW: "Gvineja Bissau",
  GY: "Gvajana",
  HK: "Hongkong",
  HM: "Heardov otok in McDonaldovi otoki",
  HN: "Honduras",
  HR: "Hrvaška",
  HT: "Haiti",
  HU: "Madžarska",
  ID: "Indonezija",
  IE: "Irska",
  IL: "Izrael",
  IM: "Otok Man",
  IN: "Indija",
  IO: "Britansko ozemlje v Indijskem oceanu",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islandija",
  IT: "Italija",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordanija",
  JP: "Japonska",
  KE: "Kenija",
  KG: "Kirgizistan",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komori",
  KN: "Saint Kitts in Nevis",
  KP: "Severna Koreja",
  KR: "Južna Koreja",
  KW: "Kuvajt",
  KY: "Kajmanski otoki",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Lihtenštajn",
  LK: "Šrilanka",
  LR: "Liberija",
  LS: "Lesoto",
  LT: "Litva",
  LU: "Luksemburg",
  LV: "Latvija",
  LY: "Libija",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavija",
  ME: "Črna gora",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshallovi otoki",
  MK: "Severna Makedonija",
  ML: "Mali",
  MM: "Mjanmar (Burma)",
  MN: "Mongolija",
  MO: "Macao",
  MP: "Severni Marianski otoki",
  MQ: "Martinik",
  MR: "Mavretanija",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivi",
  MW: "Malavi",
  MX: "Mehika",
  MY: "Malezija",
  MZ: "Mozambik",
  NA: "Namibija",
  NC: "Nova Kaledonija",
  NE: "Niger",
  NF: "Norfolški otok",
  NG: "Nigerija",
  NI: "Nikaragva",
  NL: "Nizozemska",
  NO: "Norveška",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nova Zelandija",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Francoska Polinezija",
  PG: "Papua Nova Gvineja",
  PH: "Filipini",
  PK: "Pakistan",
  PL: "Poljska",
  PM: "Saint Pierre in Miquelon",
  PN: "Pitcairn",
  PR: "Portoriko",
  PS: "Palestinsko ozemlje",
  PT: "Portugalska",
  PW: "Palau",
  PY: "Paragvaj",
  QA: "Katar",
  RE: "Reunion",
  RO: "Romunija",
  RS: "Srbija",
  RU: "Rusija",
  RW: "Ruanda",
  SA: "Saudova Arabija",
  SB: "Salomonovi otoki",
  SC: "Sejšeli",
  SD: "Sudan",
  SE: "Švedska",
  SG: "Singapur",
  SH: "Sveta Helena",
  SI: "Slovenija",
  SJ: "Svalbard in Jan Mayen",
  SK: "Slovaška",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalija",
  SR: "Surinam",
  SS: "Južni Sudan",
  ST: "Sao Tome in Principe",
  SV: "Salvador",
  SX: "Sint Maarten",
  SY: "Sirija",
  SZ: "Svazi",
  TC: "Otoki Turks in Caicos",
  TD: "Čad",
  TF: "Francosko južno ozemlje",
  TG: "Togo",
  TH: "Tajska",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunizija",
  TO: "Tonga",
  TR: "Turčija",
  TT: "Trinidad in Tobago",
  TV: "Tuvalu",
  TW: "Tajvan",
  TZ: "Tanzanija",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Stranski zunanji otoki Združenih držav",
  US: "Združene države Amerike",
  UY: "Urugvaj",
  UZ: "Uzbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent in Grenadine",
  VE: "Venezuela",
  VG: "Britanski Deviški otoki",
  VI: "Ameriški Deviški otoki",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis in Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južnoafriška republika",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, bv = {
  locale: Li,
  countries: Hi
}, yv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Hi,
  default: bv,
  locale: Li
}, Symbol.toStringTag, { value: "Module" })), Pi = "sq", Ti = {
  AF: "Afganistan",
  AL: "Shqipëri",
  DZ: "Algjeri",
  AS: "Samoa Amerikane",
  AD: "Andorrë",
  AO: "Angolë",
  AI: "Anguilë",
  AQ: "Antarktidë",
  AG: "Antigua & Barbuda",
  AR: "Argjentinë",
  AM: "Armeni",
  AW: "Arubë",
  AU: "Australi",
  AT: "Austri",
  AZ: "Azerbajxhan",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bjellorusi",
  BE: "Belgjikë",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Butan",
  BO: "Bolivi",
  BA: "Bosnjë & Hercegovinë",
  BW: "Botsvanë",
  BV: "Ishulli Buve",
  BR: "Brazil",
  IO: "Territori Britanik i Oqeanit Indian",
  BN: "Brunej",
  BG: "Bullgari",
  BF: "Burkina Faso",
  BI: "Burund",
  KH: "Kamboxhia",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kepi i Gjelbër",
  KY: "Ishujt Kajman",
  CF: "Republika Afrikano-Qendrore",
  TD: "Çad",
  CL: "Kili",
  CN: "Kinë",
  CX: "Ishulli i Krishtlindjes",
  CC: "Ishujt Kokos (Kiling)",
  CO: "Kolumbi",
  KM: "Komore",
  CG: "Kongo-Brazavil",
  CD: "Kongo-Kinshasa",
  CK: "Ishulli Kuk",
  CR: "Kosta Rikë",
  CI: "Bregu i Fildishtë",
  HR: "Kroaci",
  CU: "Kubë",
  CY: "Qipro",
  CZ: "Republika Çeke",
  DK: "Danimarkë",
  DJ: "Xhibut",
  DM: "Dominikë",
  DO: "Republika Dominikane",
  EC: "Ekuador",
  EG: "Egjipt",
  SV: "El Salvador",
  GQ: "Guineja Ekuatoriale",
  ER: "Eritre",
  EE: "Estoni",
  ET: "Etiopi",
  FK: "Ishujt Folkland",
  FO: "Ishujt Faroe",
  FJ: "Fixhi",
  FI: "Finlandë",
  FR: "Francë",
  GF: "Guajana Frënge",
  PF: "Polinezia Frënge",
  TF: "Territoret Frënge Jugore",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gjeorgji",
  DE: "Gjermani",
  GH: "Gana",
  GI: "Gjibraltar",
  GR: "Greqi",
  GL: "Groenlandë",
  GD: "Grenadë",
  GP: "Guadalup",
  GU: "Guam",
  GT: "Guatemalë",
  GN: "Guine",
  GW: "Guinea-Bisau",
  GY: "Guajanë",
  HT: "Haiti",
  HM: "Ishujt Hërd & Mekdonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "RVA i Hong Kongut Kinë",
  HU: "Hungari",
  IS: "Islandë",
  IN: "Indi",
  ID: "Indonezi",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandë",
  IL: "Izrael",
  IT: "Itali",
  JM: "Xhamajkë",
  JP: "Japoni",
  JO: "Jordani",
  KZ: "Kazakistan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Koreja e Veriut",
  KR: "Koreja e Jugut",
  KW: "Kuvajt",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letoni",
  LB: "Liban",
  LS: "Lesoto",
  LR: "Liberi",
  LY: "Libi",
  LI: "Lihtenshtein",
  LT: "Lituani",
  LU: "Luksemburg",
  MO: "RVA i Makaos Kinë",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malajzi",
  MV: "Maldive",
  ML: "Mali",
  MT: "Maltë",
  MH: "Ishujt Marshall",
  MQ: "Martinikë",
  MR: "Mauritani",
  MU: "Mauritius",
  YT: "Majote",
  MX: "Meksikë",
  FM: "Mikronezi",
  MD: "Moldavi",
  MC: "Monako",
  MN: "Mongoli",
  MS: "Montserat",
  MA: "Marok",
  MZ: "Mozambik",
  MM: "Mianmar (Burma)",
  NA: "Namibi",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandë",
  NC: "Kaledonia e Re",
  NZ: "Zelandë e Re",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeri",
  NU: "Niue",
  NF: "Ishujt Norfolk",
  MK: "Maqedoni",
  MP: "Ishujt Veriorë Mariana",
  NO: "Norvegji",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Territoret Palestineze",
  PA: "Panama",
  PG: "Papua Guineja e Re",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipine",
  PN: "Ishujt Pitkern",
  PL: "Poloni",
  PT: "Portugali",
  PR: "Porto Riko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumani",
  RU: "Rusi",
  RW: "Ruandë",
  SH: "Shën Helena",
  KN: "Shën Kits e Nevis",
  LC: "Shën Luçia",
  PM: "Shën Pier dhe Mikëlon",
  VC: "Shën Vinsent & Grenadinet",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome & Prinsipe",
  SA: "Arabi Saudite",
  SN: "Senegal",
  SC: "Sejshelle",
  SL: "Sierra Leone",
  SG: "Singapor",
  SK: "Sllovaki",
  SI: "Slloveni",
  SB: "Ishujt Solomon",
  SO: "Somali",
  ZA: "Afrikë e Jugut",
  GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut",
  ES: "Spanjë",
  LK: "Sri Lankë",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard & Zhan Majen",
  SZ: "Svaziland",
  SE: "Suedi",
  CH: "Zvicër",
  SY: "Siri",
  TW: "Tajvan",
  TJ: "Taxhikistan",
  TZ: "Tanzani",
  TH: "Tajlandë",
  TL: "Timori Lindor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad & Tobago",
  TN: "Tunizi",
  TR: "Turqi",
  TM: "Turkmenistan",
  TC: "Ishujt Turk & Kaikos",
  TV: "Tuvalu",
  UG: "Ugandë",
  UA: "Ukrainë",
  AE: "Emiratet e Bashkuara Arabe",
  GB: "Mbretëria e Bashkuar",
  US: "Shtetet e Bashkuara të Amerikës",
  UM: "Ishujt e Përtejmë SHBA-së",
  UY: "Uruguai",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuelë",
  VN: "Vietnam",
  VG: "Ishujt e Virgjër Britanikë",
  VI: "Ishujt e Virgjër Amerikanë",
  WF: "Uollis e Futuna",
  EH: "Sahara Perëndimore",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabve",
  AX: "Ishujt Aland",
  BQ: "Karaibet Holandeze",
  CW: "Kurasao",
  GG: "Gërnsi",
  IM: "Ishulli i Robit",
  JE: "Xhërsi",
  ME: "Mali i Zi",
  BL: "Shën Bartolomeo",
  MF: "Shën Martin",
  RS: "Serbi",
  SX: "Shën Martin",
  SS: "Sudan i Jugut",
  XK: "Kosovë"
}, xv = {
  locale: Pi,
  countries: Ti
}, wv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ti,
  default: xv,
  locale: Pi
}, Symbol.toStringTag, { value: "Module" })), ji = "sr", Vi = {
  AD: "Андора",
  AE: "Уједињени Арапски Емирати",
  AF: "Авганистан",
  AG: "Антигва и Барбуда",
  AI: "Ангвила",
  AL: "Албанија",
  AM: "Јерменија",
  AO: "Ангола",
  AQ: "Антарктик",
  AR: "Аргентина",
  AS: "Америчка Самоа",
  AT: "Аустрија",
  AU: "Аустралија",
  AW: "Аруба",
  AX: "Оландска Острва",
  AZ: "Азербејџан",
  BA: "Босна и Херцеговина",
  BB: "Барбадос",
  BD: "Бангладеш",
  BE: "Белгија",
  BF: "Буркина Фасо",
  BG: "Бугарска",
  BH: "Бахреин",
  BI: "Бурунди",
  BJ: "Бенин",
  BL: "Сен Бартелеми",
  BM: "Бермуда",
  BN: "Брунеј",
  BO: "Боливија",
  BQ: "Карипска Холандија",
  BR: "Бразил",
  BS: "Бахами",
  BT: "Бутан",
  BV: "Острво Буве",
  BW: "Боцвана",
  BY: "Белорусија",
  BZ: "Белизе",
  CA: "Канада",
  CC: "Кокосова (Килингова) Острва",
  CD: "Конго - Киншаса",
  CF: "Централноафричка Република",
  CG: "Конго - Бразавил",
  CH: "Швајцарска",
  CI: "Обала Слоноваче",
  CK: "Кукова Острва",
  CL: "Чиле",
  CM: "Камерун",
  CN: "Кина",
  CO: "Колумбија",
  CR: "Костарика",
  CU: "Куба",
  CV: "Зеленортска Острва",
  CW: "Курасао",
  CX: "Божићно Острво",
  CY: "Кипар",
  CZ: "Чешка",
  DE: "Немачка",
  DJ: "Џибути",
  DK: "Данска",
  DM: "Доминика",
  DO: "Доминиканска Република",
  DZ: "Алжир",
  EC: "Еквадор",
  EE: "Естонија",
  EG: "Египат",
  EH: "Западна Сахара",
  ER: "Еритреја",
  ES: "Шпанија",
  ET: "Етиопија",
  FI: "Финска",
  FJ: "Фиџи",
  FK: "Фокландска Острва",
  FM: "Микронезија",
  FO: "Фарска Острва",
  FR: "Француска",
  GA: "Габон",
  GB: "Уједињено Краљевство",
  GD: "Гренада",
  GE: "Грузија",
  GF: "Француска Гвајана",
  GG: "Гернзи",
  GH: "Гана",
  GI: "Гибралтар",
  GL: "Гренланд",
  GM: "Гамбија",
  GN: "Гвинеја",
  GP: "Гваделуп",
  GQ: "Екваторијална Гвинеја",
  GR: "Грчка",
  GS: "Јужна Џорџија и Јужна Сендвичка Острва",
  GT: "Гватемала",
  GU: "Гуам",
  GW: "Гвинеја-Бисао",
  GY: "Гвајана",
  HK: "САР Хонгконг (Кина)",
  HM: "Острво Херд и Мекдоналдова острва",
  HN: "Хондурас",
  HR: "Хрватска",
  HT: "Хаити",
  HU: "Мађарска",
  ID: "Индонезија",
  IE: "Ирска",
  IL: "Израел",
  IM: "Острво Ман",
  IN: "Индија",
  IO: "Британска територија Индијског океана",
  IQ: "Ирак",
  IR: "Иран",
  IS: "Исланд",
  IT: "Италија",
  JE: "Џерзи",
  JM: "Јамајка",
  JO: "Јордан",
  JP: "Јапан",
  KE: "Кенија",
  KG: "Киргистан",
  KH: "Камбоџа",
  KI: "Кирибати",
  KM: "Коморска Острва",
  KN: "Сент Китс и Невис",
  KP: "Северна Кореја",
  KR: "Јужна Кореја",
  KW: "Кувајт",
  KY: "Кајманска Острва",
  KZ: "Казахстан",
  LA: "Лаос",
  LB: "Либан",
  LC: "Света Луција",
  LI: "Лихтенштајн",
  LK: "Шри Ланка",
  LR: "Либерија",
  LS: "Лесото",
  LT: "Литванија",
  LU: "Луксембург",
  LV: "Летонија",
  LY: "Либија",
  MA: "Мароко",
  MC: "Монако",
  MD: "Молдавија",
  ME: "Црна Гора",
  MF: "Свети Мартин (Француска)",
  MG: "Мадагаскар",
  MH: "Маршалска Острва",
  MK: "Северна Македонија",
  ML: "Мали",
  MM: "Мијанмар (Бурма)",
  MN: "Монголија",
  MO: "САР Макао (Кина)",
  MP: "Северна Маријанска Острва",
  MQ: "Мартиник",
  MR: "Мауританија",
  MS: "Монсерат",
  MT: "Малта",
  MU: "Маурицијус",
  MV: "Малдиви",
  MW: "Малави",
  MX: "Мексико",
  MY: "Малезија",
  MZ: "Мозамбик",
  NA: "Намибија",
  NC: "Нова Каледонија",
  NE: "Нигер",
  NF: "Острво Норфок",
  NG: "Нигерија",
  NI: "Никарагва",
  NL: "Холандија",
  NO: "Норвешка",
  NP: "Непал",
  NR: "Науру",
  NU: "Ниуе",
  NZ: "Нови Зеланд",
  OM: "Оман",
  PA: "Панама",
  PE: "Перу",
  PF: "Француска Полинезија",
  PG: "Папуа Нова Гвинеја",
  PH: "Филипини",
  PK: "Пакистан",
  PL: "Пољска",
  PM: "Сен Пјер и Микелон",
  PN: "Питкерн",
  PR: "Порторико",
  PS: "Палестинске територије",
  PT: "Португалија",
  PW: "Палау",
  PY: "Парагвај",
  QA: "Катар",
  RE: "Реинион",
  RO: "Румунија",
  RS: "Србија",
  RU: "Русија",
  RW: "Руанда",
  SA: "Саудијска Арабија",
  SB: "Соломонска Острва",
  SC: "Сејшели",
  SD: "Судан",
  SE: "Шведска",
  SG: "Сингапур",
  SH: "Света Јелена",
  SI: "Словенија",
  SJ: "Свалбард и Јан Мајен",
  SK: "Словачка",
  SL: "Сијера Леоне",
  SM: "Сан Марино",
  SN: "Сенегал",
  SO: "Сомалија",
  SR: "Суринам",
  SS: "Јужни Судан",
  ST: "Сао Томе и Принципе",
  SV: "Салвадор",
  SX: "Свети Мартин (Холандија)",
  SY: "Сирија",
  SZ: "Свазиленд",
  TC: "Острва Туркс и Каикос",
  TD: "Чад",
  TF: "Француске Јужне Територије",
  TG: "Того",
  TH: "Тајланд",
  TJ: "Таџикистан",
  TK: "Токелау",
  TL: "Источни Тимор",
  TM: "Туркменистан",
  TN: "Тунис",
  TO: "Тонга",
  TR: "Турска",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TW: "Тајван",
  TZ: "Танзанија",
  UA: "Украјина",
  UG: "Уганда",
  UM: "Удаљена острва САД",
  US: "Сједињене Државе",
  UY: "Уругвај",
  UZ: "Узбекистан",
  VA: "Ватикан",
  VC: "Сент Винсент и Гренадини",
  VE: "Венецуела",
  VG: "Британска Девичанска Острва",
  VI: "Америчка Девичанска Острва",
  VN: "Вијетнам",
  VU: "Вануату",
  WF: "Валис и Футуна",
  WS: "Самоа",
  XK: "Косово",
  YE: "Јемен",
  YT: "Мајот",
  ZA: "Јужноафричка Република",
  ZM: "Замбија",
  ZW: "Зимбабве"
}, _v = {
  locale: ji,
  countries: Vi
}, Mv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Vi,
  default: _v,
  locale: ji
}, Symbol.toStringTag, { value: "Module" })), Ai = "sv", Ei = {
  AD: "Andorra",
  AE: "Förenade Arabemiraten",
  AF: "Afghanistan",
  AG: "Antigua och Barbuda",
  AI: "Anguilla",
  AL: "Albanien",
  AM: "Armenien",
  AO: "Angola",
  AQ: "Antarktis",
  AR: "Argentina",
  AS: "Amerikanska Samoa",
  AT: "Österrike",
  AU: "Australien",
  AW: "Aruba",
  AX: "Åland",
  AZ: "Azerbajdzjan",
  BA: "Bosnien och Hercegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgien",
  BF: "Burkina Faso",
  BG: "Bulgarien",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Bonaire, Saint Eustatius och Saba",
  BR: "Brasilien",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvetön",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosöarna",
  CD: "Demokratiska republiken Kongo",
  CF: "Centralafrikanska republiken",
  CG: "Kongo-Brazzaville",
  CH: "Schweiz",
  CI: "Elfenbenskusten",
  CK: "Cooköarna",
  CL: "Chile",
  CM: "Kamerun",
  CN: "Kina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Kuba",
  CV: "Kap Verde",
  CW: "Curacao",
  CX: "Julön",
  CY: "Cypern",
  CZ: "Tjeckien",
  DE: "Tyskland",
  DJ: "Djibouti",
  DK: "Danmark",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  DZ: "Algeriet",
  EC: "Ecuador",
  EE: "Estland",
  EG: "Egypten",
  EH: "Västsahara",
  ER: "Eritrea",
  ES: "Spanien",
  ET: "Etiopien",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falklandsöarna",
  FM: "Mikronesiska federationen",
  FO: "Färöarna",
  FR: "Frankrike",
  GA: "Gabon",
  GB: "Storbritannien",
  GD: "Grenada",
  GE: "Georgien",
  GF: "Franska Guyana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Grönland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Ekvatorialguinea",
  GR: "Grekland",
  GS: "Sydgeorgien och Sydsandwichöarna",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HK: "Hongkong",
  HM: "Heard- och McDonaldsöarna",
  HN: "Honduras",
  HR: "Kroatien",
  HT: "Haiti",
  HU: "Ungern",
  ID: "Indonesien",
  IE: "Irland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "Indien",
  IO: "Brittiska territoriet i Indiska Oceanen",
  IQ: "Irak",
  IR: "Iran",
  IS: "Island",
  IT: "Italien",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordanien",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kirgizistan",
  KH: "Kambodja",
  KI: "Kiribati",
  KM: "Komorerna",
  KN: "Saint Kitts och Nevis",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KY: "Caymanöarna",
  KZ: "Kazakstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Litauen",
  LU: "Luxemburg",
  LV: "Lettland",
  LY: "Libyen",
  MA: "Marocko",
  MC: "Monaco",
  MD: "Moldavien",
  ME: "Montenegro",
  MF: "Saint Martin (franska delen)",
  MG: "Madagaskar",
  MH: "Marshallöarna",
  MK: "Nordmakedonien",
  ML: "Mali",
  MM: "Burma",
  MN: "Mongoliet",
  MO: "Macau",
  MP: "Nordmarianerna",
  MQ: "Martinique",
  MR: "Mauretanien",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldiverna",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malaysia",
  MZ: "Moçambique",
  NA: "Namibia",
  NC: "Nya Kaledonien",
  NE: "Niger",
  NF: "Norfolkön",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Nederländerna",
  NO: "Norge",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nya Zeeland",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Franska Polynesien",
  PG: "Papua Nya Guinea",
  PH: "Filippinerna",
  PK: "Pakistan",
  PL: "Polen",
  PM: "Saint-Pierre och Miquelon",
  PN: "Pitcairnöarna",
  PR: "Puerto Rico",
  PS: "Palestinska territoriet, ockuperade",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumänien",
  RS: "Serbien",
  RU: "Ryssland",
  RW: "Rwanda",
  SA: "Saudiarabien",
  SB: "Salomonöarna",
  SC: "Seychellerna",
  SD: "Sudan",
  SE: "Sverige",
  SG: "Singapore",
  SH: "Sankta Helena",
  SI: "Slovenien",
  SJ: "Svalbard och Jan Mayen",
  SK: "Slovakien",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Surinam",
  SS: "Sydsudan",
  ST: "São Tomé och Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (nederländska delen)",
  SY: "Syrien",
  SZ: "Eswatini",
  TC: "Turks- och Caicosöarna",
  TD: "Tchad",
  TF: "Franska södra territorierna",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tadzjikistan",
  TK: "Tokelauöarna",
  TL: "Östtimor",
  TM: "Turkmenistan",
  TN: "Tunisien",
  TO: "Tonga",
  TR: "Turkiet",
  TT: "Trinidad och Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraina",
  UG: "Uganda",
  UM: "USA:s yttre öar",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatikanstaten",
  VC: "Saint Vincent och Grenadinerna",
  VE: "Venezuela",
  VG: "Brittiska Jungfruöarna",
  VI: "Amerikanska Jungfruöarna",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis- och Futunaöarna",
  WS: "Samoa",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Sydafrika",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, Sv = {
  locale: Ai,
  countries: Ei
}, kv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ei,
  default: Sv,
  locale: Ai
}, Symbol.toStringTag, { value: "Module" })), Ii = "th", Di = {
  BD: "บังกลาเทศ",
  BE: "เบลเยียม",
  BF: "บูร์กินาฟาโซ",
  BG: "บัลแกเรีย",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BB: "บาร์เบโดส",
  WF: "วาลลิสและฟุตูนา",
  BL: "เซนต์บาร์เธเลมี",
  BM: "เบอร์มิวดา",
  BN: "บรูไน",
  BO: "โบลิเวีย",
  BH: "บาห์เรน",
  BI: "บุรุนดี",
  BJ: "เบนิน",
  BT: "ภูฏาน",
  JM: "จาเมกา",
  BV: "เกาะบูเวต",
  BW: "บอตสวานา",
  WS: "ซามัว",
  BR: "บราซิล",
  BS: "บาฮามาส",
  JE: "เจอร์ซีย์",
  BY: "เบลารุส",
  BZ: "เบลีซ",
  RU: "รัสเซีย",
  RW: "รวันดา",
  RS: "เซอร์เบีย",
  TL: "ติมอร์ตะวันออก",
  RE: "เรอูนียง",
  TM: "เติร์กเมนิสถาน",
  TJ: "ทาจิกิสถาน",
  RO: "โรมาเนีย",
  TK: "โตเกเลา",
  GW: "กินี-บิสเซา",
  GU: "กวม",
  GT: "กัวเตมาลา",
  GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  GR: "กรีซ",
  GQ: "อิเควทอเรียลกินี",
  GP: "กวาเดอลูป",
  JP: "ญี่ปุ่น",
  GY: "กายอานา",
  GG: "เกิร์นซีย์",
  GF: "เฟรนช์เกียนา",
  GE: "จอร์เจีย",
  GD: "เกรเนดา",
  GB: "สหราชอาณาจักร",
  GA: "กาบอง",
  SV: "เอลซัลวาดอร์",
  GN: "กินี",
  GM: "แกมเบีย",
  GL: "กรีนแลนด์",
  GI: "ยิบรอลตาร์",
  GH: "กานา",
  OM: "โอมาน",
  TN: "ตูนิเซีย",
  JO: "จอร์แดน",
  HR: "โครเอเชีย",
  HT: "เฮติ",
  HU: "ฮังการี",
  HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน",
  HN: "ฮอนดูรัส",
  HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
  VE: "เวเนซุเอลา",
  PR: "เปอร์โตริโก",
  PS: "ปาเลสไตน์",
  PW: "ปาเลา",
  PT: "โปรตุเกส",
  SJ: "สฟาลบาร์และยานไมเอน",
  PY: "ปารากวัย",
  IQ: "อิรัก",
  PA: "ปานามา",
  PF: "เฟรนช์โปลินีเซีย",
  PG: "ปาปัวนิวกินี",
  PE: "เปรู",
  PK: "ปากีสถาน",
  PH: "ฟิลิปปินส์",
  PN: "พิตแคร์น",
  PL: "โปแลนด์",
  PM: "แซงปีแยร์และมีเกอลง",
  ZM: "แซมเบีย",
  EH: "ซาฮาราตะวันตก",
  EE: "เอสโตเนีย",
  EG: "อียิปต์",
  ZA: "แอฟริกาใต้",
  EC: "เอกวาดอร์",
  IT: "อิตาลี",
  VN: "เวียดนาม",
  SB: "หมู่เกาะโซโลมอน",
  ET: "เอธิโอเปีย",
  SO: "โซมาเลีย",
  ZW: "ซิมบับเว",
  SA: "ซาอุดีอาระเบีย",
  ES: "สเปน",
  ER: "เอริเทรีย",
  ME: "มอนเตเนโกร",
  MD: "มอลโดวา",
  MG: "มาดากัสการ์",
  MF: "เซนต์มาติน",
  MA: "โมร็อกโก",
  MC: "โมนาโก",
  UZ: "อุซเบกิสถาน",
  MM: "เมียนม่าร์ [พม่า]",
  ML: "มาลี",
  MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน",
  MN: "มองโกเลีย",
  MH: "หมู่เกาะมาร์แชลล์",
  MK: "มาซิโดเนีย",
  MU: "มอริเชียส",
  MT: "มอลตา",
  MW: "มาลาวี",
  MV: "มัลดีฟส์",
  MQ: "มาร์ตินีก",
  MP: "หมู่เกาะนอร์เทิร์นมาเรียนา",
  MS: "มอนต์เซอร์รัต",
  MR: "มอริเตเนีย",
  IM: "เกาะแมน",
  UG: "ยูกันดา",
  TZ: "แทนซาเนีย",
  MY: "มาเลเซีย",
  MX: "เม็กซิโก",
  IL: "อิสราเอล",
  FR: "ฝรั่งเศส",
  IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  SH: "เซนต์เฮเลนา",
  FI: "ฟินแลนด์",
  FJ: "ฟิจิ",
  FK: "หมู่เกาะฟอล์กแลนด์",
  FM: "ไมโครนีเซีย",
  FO: "หมู่เกาะแฟโร",
  NI: "นิการากัว",
  NL: "เนเธอร์แลนด์",
  NO: "นอร์เวย์",
  NA: "นามิเบีย",
  VU: "วานูอาตู",
  NC: "นิวแคลิโดเนีย",
  NE: "ไนเจอร์",
  NF: "เกาะนอร์ฟอล์ก",
  NG: "ไนจีเรีย",
  NZ: "นิวซีแลนด์",
  NP: "เนปาล",
  NR: "นาอูรู",
  NU: "นีอูเอ",
  CK: "หมู่เกาะคุก",
  CI: "ไอวอรี่โคสต์",
  CH: "สวิตเซอร์แลนด์",
  CO: "โคลอมเบีย",
  CN: "จีน",
  CM: "แคเมอรูน",
  CL: "ชิลี",
  CC: "หมู่เกาะโคโคส",
  CA: "แคนาดา",
  CG: "คองโก-บราซซาวิล",
  CF: "สาธารณรัฐแอฟริกากลาง",
  CD: "คองโก-กินชาซา",
  CZ: "สาธารณรัฐเช็ก",
  CY: "ไซปรัส",
  CX: "เกาะคริสต์มาส",
  CR: "คอสตาริกา",
  CV: "เคปเวิร์ด",
  CU: "คิวบา",
  SZ: "สวาซิแลนด์",
  SY: "ซีเรีย",
  KG: "คีร์กีซสถาน",
  KE: "เคนยา",
  SR: "ซูรินาเม",
  KI: "คิริบาส",
  KH: "กัมพูชา",
  KN: "เซนต์คิตส์และเนวิส",
  KM: "คอโมโรส",
  ST: "เซาตูเมและปรินซิปี",
  SK: "สโลวะเกีย",
  KR: "เกาหลีใต้",
  SI: "สโลวีเนีย",
  KP: "เกาหลีเหนือ",
  KW: "คูเวต",
  SN: "เซเนกัล",
  SM: "ซานมารีโน",
  SL: "เซียร์ราลีโอน",
  SC: "เซเชลส์",
  KZ: "คาซัคสถาน",
  KY: "หมู่เกาะเคย์แมน",
  SG: "สิงคโปร์",
  SE: "สวีเดน",
  SD: "ซูดาน",
  DO: "สาธารณรัฐโดมินิกัน",
  DM: "โดมินิกา",
  DJ: "จิบูตี",
  DK: "เดนมาร์ก",
  VG: "หมู่เกาะบริติชเวอร์จิน",
  DE: "เยอรมนี",
  YE: "เยเมน",
  DZ: "แอลจีเรีย",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  YT: "มายอต",
  UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง",
  LB: "เลบานอน",
  LC: "เซนต์ลูเซีย",
  LA: "ลาว",
  TV: "ตูวาลู",
  TW: "ไต้หวัน",
  TT: "ตรินิแดดและโตเบโก",
  TR: "ตุรกี",
  LK: "ศรีลังกา",
  LI: "ลิกเตนสไตน์",
  LV: "ลัตเวีย",
  TO: "ตองกา",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  LR: "ไลบีเรีย",
  LS: "เลโซโท",
  TH: "ไทย",
  TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  TG: "โตโก",
  TD: "ชาด",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  LY: "ลิเบีย",
  VA: "วาติกัน",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  AD: "อันดอร์รา",
  AG: "แอนติกาและบาร์บูดา",
  AF: "อัฟกานิสถาน",
  AI: "แองกวิลลา",
  VI: "หมู่เกาะยูเอสเวอร์จิน",
  IS: "ไอซ์แลนด์",
  IR: "อิหร่าน",
  AM: "อาร์เมเนีย",
  AL: "แอลเบเนีย",
  AO: "แองโกลา",
  AQ: "แอนตาร์กติกา",
  AS: "อเมริกันซามัว",
  AR: "อาร์เจนตินา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AW: "อารูบา",
  IN: "อินเดีย",
  AX: "หมู่เกาะโอลันด์",
  AZ: "อาเซอร์ไบจาน",
  IE: "ไอร์แลนด์",
  ID: "อินโดนีเซีย",
  UA: "ยูเครน",
  QA: "กาตาร์",
  MZ: "โมซัมบิก",
  BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา",
  CW: "คูราเซา",
  SX: "Sint Maarten (ส่วนดัตช์)",
  SS: "ซูดานใต้",
  XK: "โคโซโว"
}, Lv = {
  locale: Ii,
  countries: Di
}, Hv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Di,
  default: Lv,
  locale: Ii
}, Symbol.toStringTag, { value: "Module" })), Ni = "tr", Ri = {
  AD: "Andorra",
  AE: "Birleşik Arap Emirlikleri",
  AF: "Afganistan",
  AG: "Antigua ve Barbuda",
  AI: "Anguilla",
  AL: "Arnavutluk",
  AM: "Ermenistan",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Arjantin",
  AS: "Amerikan Samoası",
  AT: "Avusturya",
  AU: "Avustralya",
  AW: "Aruba",
  AX: "Åland Adaları",
  AZ: "Azerbaycan",
  BA: "Bosna Hersek",
  BB: "Barbados",
  BD: "Bangladeş",
  BE: "Belçika",
  BF: "Burkina Faso",
  BG: "Bulgaristan",
  BH: "Bahreyn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivya",
  BQ: "Karayip Hollanda",
  BR: "Brezilya",
  BS: "Bahamalar",
  BT: "Butan",
  BV: "Bouvet Adası",
  BW: "Botsvana",
  BY: "Beyaz Rusya",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Cocos (Keeling) Adaları",
  CD: "Kongo - Kinşasa",
  CF: "Orta Afrika Cumhuriyeti",
  CG: "Kongo - Brazavil",
  CH: "İsviçre",
  CI: "Fildişi Sahili",
  CK: "Cook Adaları",
  CL: "Şili",
  CM: "Kamerun",
  CN: "Çin",
  CO: "Kolombiya",
  CR: "Kosta Rika",
  CU: "Küba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Adası",
  CY: "Güney Kıbrıs Rum Kesimi",
  CZ: "Çek Cumhuriyeti",
  DE: "Almanya",
  DJ: "Cibuti",
  DK: "Danimarka",
  DM: "Dominika",
  DO: "Dominik Cumhuriyeti",
  DZ: "Cezayir",
  EC: "Ekvador",
  EE: "Estonya",
  EG: "Mısır",
  EH: "Batı Sahara",
  ER: "Eritre",
  ES: "İspanya",
  ET: "Etiyopya",
  FI: "Finlandiya",
  FJ: "Fiji",
  FK: "Falkland Adaları",
  FM: "Mikronezya",
  FO: "Faroe Adaları",
  FR: "Fransa",
  GA: "Gabon",
  GB: "Birleşik Krallık",
  GD: "Grenada",
  GE: "Gürcistan",
  GF: "Fransız Guyanası",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Cebelitarık",
  GL: "Grönland",
  GM: "Gambiya",
  GN: "Gine",
  GP: "Guadalupe",
  GQ: "Ekvator Ginesi",
  GR: "Yunanistan",
  GS: "Güney Georgia ve Güney Sandwich Adaları",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Gine-Bissau",
  GY: "Guyana",
  HK: "Çin Hong Kong ÖYB",
  HM: "Heard Adası ve McDonald Adaları",
  HN: "Honduras",
  HR: "Hırvatistan",
  HT: "Haiti",
  HU: "Macaristan",
  ID: "Endonezya",
  IE: "İrlanda",
  IL: "İsrail",
  IM: "Man Adası",
  IN: "Hindistan",
  IO: "Britanya Hint Okyanusu Toprakları",
  IQ: "Irak",
  IR: "İran",
  IS: "İzlanda",
  IT: "İtalya",
  JE: "Jersey",
  JM: "Jamaika",
  JO: "Ürdün",
  JP: "Japonya",
  KE: "Kenya",
  KG: "Kırgızistan",
  KH: "Kamboçya",
  KI: "Kiribati",
  KM: "Komorlar",
  KN: "Saint Kitts ve Nevis",
  KP: "Kuzey Kore",
  KR: "Güney Kore",
  KW: "Kuveyt",
  KY: "Cayman Adaları",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Lübnan",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberya",
  LS: "Lesoto",
  LT: "Litvanya",
  LU: "Lüksemburg",
  LV: "Letonya",
  LY: "Libya",
  MA: "Fas",
  MC: "Monako",
  MD: "Moldova",
  ME: "Karadağ",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshall Adaları",
  MK: "Kuzey Makedonya",
  ML: "Mali",
  MM: "Myanmar (Burma)",
  MN: "Moğolistan",
  MO: "Çin Makao ÖYB",
  MP: "Kuzey Mariana Adaları",
  MQ: "Martinik",
  MR: "Moritanya",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivler",
  MW: "Malavi",
  MX: "Meksika",
  MY: "Malezya",
  MZ: "Mozambik",
  NA: "Namibya",
  NC: "Yeni Kaledonya",
  NE: "Nijer",
  NF: "Norfolk Adası",
  NG: "Nijerya",
  NI: "Nikaragua",
  NL: "Hollanda",
  NO: "Norveç",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Yeni Zelanda",
  OM: "Umman",
  PA: "Panama",
  PE: "Peru",
  PF: "Fransız Polinezyası",
  PG: "Papua Yeni Gine",
  PH: "Filipinler",
  PK: "Pakistan",
  PL: "Polonya",
  PM: "Saint Pierre ve Miquelon",
  PN: "Pitcairn Adaları",
  PR: "Porto Riko",
  PS: "Filistin Bölgeleri",
  PT: "Portekiz",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Katar",
  RE: "Réunion",
  RO: "Romanya",
  RS: "Sırbistan",
  RU: "Rusya",
  RW: "Ruanda",
  SA: "Suudi Arabistan",
  SB: "Solomon Adaları",
  SC: "Seyşeller",
  SD: "Sudan",
  SE: "İsveç",
  SG: "Singapur",
  SH: "Saint Helena",
  SI: "Slovenya",
  SJ: "Svalbard ve Jan Mayen Adaları",
  SK: "Slovakya",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somali",
  SR: "Surinam",
  SS: "Güney Sudan",
  ST: "São Tomé ve Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Suriye",
  SZ: "Svaziland",
  TC: "Turks ve Caicos Adaları",
  TD: "Çad",
  TF: "Fransız Güney Toprakları",
  TG: "Togo",
  TH: "Tayland",
  TJ: "Tacikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Türkmenistan",
  TN: "Tunus",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinidad ve Tobago",
  TV: "Tuvalu",
  TW: "Tayvan",
  TZ: "Tanzanya",
  UA: "Ukrayna",
  UG: "Uganda",
  UM: "ABD Uzak Adaları",
  US: [
    "ABD",
    "A.B.D.",
    "Amerika Birleşik Devletleri",
    "Birleşik Devletler",
    "Amerika"
  ],
  UY: "Uruguay",
  UZ: "Özbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent ve Grenadinler",
  VE: "Venezuela",
  VG: "Britanya Virjin Adaları",
  VI: "ABD Virjin Adaları",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis ve Futuna Adaları",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Güney Afrika",
  ZM: "Zambiya",
  ZW: "Zimbabve",
  XK: "Kosova"
}, Pv = {
  locale: Ni,
  countries: Ri
}, Tv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ri,
  default: Pv,
  locale: Ni
}, Symbol.toStringTag, { value: "Module" })), Fi = "uk", Oi = {
  AU: "Австралія",
  AT: "Австрія",
  AZ: "Азербайджан",
  AX: "Аландські Острови",
  AL: "Албанія",
  DZ: "Алжир",
  AS: "Американське Самоа",
  AI: "Ангілья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктика",
  AG: "Антигуа і Барбуда",
  MO: "Макао",
  AR: "Аргентина",
  AM: "Вірменія",
  AW: "Аруба",
  AF: "Афганістан",
  BS: "Багамські Острови",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Беліз",
  BE: "Бельгія",
  BJ: "Бенін",
  BM: "Бермудські Острови",
  BY: "Білорусь",
  BG: "Болгарія",
  BO: "Болівія",
  BA: "Боснія і Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилія",
  IO: "Британська Територія в Індійському Океані",
  VG: "Британські Віргінські Острови",
  BN: "Бруней-Даруссалам",
  BF: "Буркіна-Фасо",
  BI: "Бурунді",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобританія",
  VE: "Венесуела",
  VI: "Віргінські Острови (США)",
  WF: "Волліс і Футуна",
  VN: "В'єтнам",
  UM: "Зовнішні Віддалені Острови (США)",
  GA: "Габон",
  HT: "Гаїті",
  GY: "Гаяна",
  GM: "Гамбія",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвіана",
  GN: "Гвінея",
  GW: "Гвінея-Бісау",
  GG: "Гернсі",
  GI: "Гібралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GR: "Греція",
  GE: "Грузія",
  GU: "Гуам",
  GL: "Гренландія",
  DK: "Данія",
  JE: "Джерсі",
  DJ: "Джибуті",
  DM: "Домініка",
  DO: "Домініканська Республіка",
  CD: "Демократична Республіка Конго",
  EC: "Еквадор",
  GQ: "Екваторіальна Гвінея",
  ER: "Еритрея",
  EE: "Естонія",
  ET: "Ефіопія",
  EG: "Єгипет",
  YE: "Ємен",
  ZM: "Замбія",
  ZW: "Зімбабве",
  IL: "Ізраїль",
  IN: "Індія",
  ID: "Індонезія",
  IQ: "Ірак",
  IR: "Іран",
  IE: "Ірландія",
  IS: "Ісландія",
  ES: "Іспанія",
  IT: "Італія",
  JO: "Йорданія",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Кайманові Острови",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  BQ: "Карибські Нідерланди",
  QA: "Катар",
  KE: "Кенія",
  CY: "Кіпр",
  KI: "Кірибаті",
  KG: "Киргизстан",
  TW: "Тайвань, Провінція Китаю",
  KP: "Корейська Народно-Демократична Республіка",
  CN: "Китай",
  CC: "Кокосові Острови",
  CO: "Колумбія",
  KM: "Комори",
  XK: "Косово",
  CR: "Коста-Рика",
  CI: "Кот-Д'Івуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвія",
  LS: "Лесото",
  LR: "Ліберія",
  LB: "Ліван",
  LY: "Лівія",
  LT: "Литва",
  LI: "Ліхтенштейн",
  LU: "Люксембург",
  MU: "Маврикій",
  MR: "Мавританія",
  MG: "Мадагаскар",
  YT: "Майотта",
  MW: "Малаві",
  MY: "Малайзія",
  ML: "Малі",
  MV: "Мальдіви",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиніка",
  MH: "Маршаллові Острови",
  MX: "Мексика",
  FM: "Мікронезія",
  MZ: "Мозамбік",
  MD: "Молдова",
  MC: "Монако",
  MN: "Монголія",
  MS: "Монтсеррат",
  MM: "М'янма",
  NA: "Намібія",
  NR: "Науру",
  NP: "Непал",
  NE: "Нігер",
  NG: "Нігерія",
  NL: "Нідерланди",
  NI: "Нікарагуа",
  DE: "Німеччина",
  NU: "Ніуе",
  NZ: "Нова Зеландія",
  NC: "Нова Каледонія",
  NO: "Норвегія",
  AE: "Об'єднані Арабські Емірати",
  OM: "Оман",
  BV: "Острів Буве",
  HM: "Острів Герд і Острови Макдоналд",
  IM: "Острів Мен",
  NF: "Острів Норфолк",
  CX: "Острів Різдва",
  CK: "Острови Кука",
  SH: "Острів Святої Єлени",
  TC: "Острови Теркс і Кайкос",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Палестина",
  PA: "Панама",
  PG: "Папуа-Нова Гвінея",
  ZA: "Південна Африка",
  PY: "Парагвай",
  PE: "Перу",
  GS: "Південна Джорджія та Південні Сандвічеві Острови",
  KR: "Республіка Корея",
  SS: "Південний Судан",
  MK: "Північна Македонія",
  MP: "Північні Маріанські Острови",
  PN: "Піткерн",
  PL: "Польща",
  PT: "Португалія",
  PR: "Пуерто-Рико",
  CG: "Конго",
  RE: "Реюньйон",
  RU: "Росія",
  RW: "Руанда",
  RO: "Румунія",
  EH: "Західна Сахара",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе і Принсіпі",
  SA: "Саудівська Аравія",
  SZ: "Есватіні",
  SJ: "Острови Шпіцберген та Ян-Маєн",
  SC: "Сейшельські Острови",
  BL: "Сен-Бартелемі",
  MF: "Сен-Мартен",
  PM: "Сен-П'єр і Мікелон",
  SN: "Сенегал",
  VC: "Сент-Вінсент і Гренадіни",
  KN: "Сент-Кітс і Невіс",
  LC: "Сент-Люсія",
  RS: "Сербія",
  SG: "Сингапур",
  SX: "Сінт-Мартен",
  SY: "Сирія",
  SK: "Словаччина",
  SI: "Словенія",
  SB: "Соломонові Острови",
  SO: "Сомалі",
  SD: "Судан",
  SR: "Суринам",
  TL: "Тимор-Лешті",
  US: "США",
  SL: "Сьєрра-Леоне",
  TJ: "Таджикистан",
  TH: "Таїланд",
  TZ: "Танзанія",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринідад і Тобаго",
  TV: "Тувалу",
  TN: "Туніс",
  TM: "Туркменистан",
  TR: "Туреччина",
  UG: "Уганда",
  HU: "Угорщина",
  UZ: "Узбекистан",
  UA: "Україна",
  UY: "Уругвай",
  FO: "Фарерські Острови",
  FJ: "Фіджі",
  PH: "Філіппіни",
  FI: "Фінляндія",
  FK: "Фолклендські Острови",
  FR: "Франція",
  PF: "Французька Полінезія",
  TF: "Французькі Південні і Антарктичні Території",
  HR: "Хорватія",
  CF: "Центральноафриканська Республіка",
  TD: "Чад",
  ME: "Чорногорія",
  CZ: "Чехія",
  CL: "Чилі",
  CH: "Швейцарія",
  SE: "Швеція",
  LK: "Шри-Ланка",
  JM: "Ямайка",
  JP: "Японія"
}, jv = {
  locale: Fi,
  countries: Oi
}, Vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Oi,
  default: jv,
  locale: Fi
}, Symbol.toStringTag, { value: "Module" })), Bi = "zh", Zi = {
  AD: "安道尔",
  AE: "阿联酋",
  AF: "阿富汗",
  AG: "安提瓜和巴布达",
  AI: "安圭拉",
  AL: "阿尔巴尼亚",
  AM: "亚美尼亚",
  AO: "安哥拉",
  AQ: "南极洲",
  AR: "阿根廷",
  AS: "美属萨摩亚",
  AT: "奥地利",
  AU: "澳大利亚",
  AW: "阿鲁巴",
  AX: "奥兰",
  AZ: "阿塞拜疆",
  BA: "波黑",
  BB: "巴巴多斯",
  BD: "孟加拉国",
  BE: "比利时",
  BF: "布基纳法索",
  BG: "保加利亚",
  BH: "巴林",
  BI: "布隆迪",
  BJ: "贝宁",
  BL: "圣巴泰勒米",
  BM: "百慕大",
  BN: "文莱",
  BO: "玻利维亚",
  BQ: "荷兰加勒比区",
  BR: "巴西",
  BS: "巴哈马",
  BT: "不丹",
  BV: "布韦岛",
  BW: "博茨瓦纳",
  BY: "白俄罗斯",
  BZ: "伯利兹",
  CA: "加拿大",
  CC: "科科斯（基林）群岛",
  CD: "刚果（金）",
  CF: "中非",
  CG: "刚果（布）",
  CH: "瑞士",
  CI: "科特迪瓦",
  CK: "库克群岛",
  CL: "智利",
  CM: "喀麦隆",
  CN: "中国",
  CO: "哥伦比亚",
  CR: "哥斯达黎加",
  CU: "古巴",
  CV: "佛得角",
  CW: "库拉索",
  CX: "圣诞岛",
  CY: "塞浦路斯",
  CZ: "捷克",
  DE: "德国",
  DJ: "吉布提",
  DK: "丹麦",
  DM: "多米尼克",
  DO: "多米尼加",
  DZ: "阿尔及利亚",
  EC: "厄瓜多尔",
  EE: "爱沙尼亚",
  EG: "埃及",
  EH: "阿拉伯撒哈拉民主共和国",
  ER: "厄立特里亚",
  ES: "西班牙",
  ET: "埃塞俄比亚",
  FI: "芬兰",
  FJ: "斐济",
  FK: "福克兰群岛",
  FM: "密克罗尼西亚联邦",
  FO: "法罗群岛",
  FR: "法国",
  GA: "加蓬",
  GB: "英国",
  GD: "格林纳达",
  GE: "格鲁吉亚",
  GF: "法属圭亚那",
  GG: "根西",
  GH: "加纳",
  GI: "直布罗陀",
  GL: "格陵兰",
  GM: "冈比亚",
  GN: "几内亚",
  GP: "瓜德罗普",
  GQ: "赤道几内亚",
  GR: "希腊",
  GS: "南乔治亚和南桑威奇群岛",
  GT: "危地马拉",
  GU: "关岛",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HK: "香港",
  HM: "赫德岛和麦克唐纳群岛",
  HN: "洪都拉斯",
  HR: "克罗地亚",
  HT: "海地",
  HU: "匈牙利",
  ID: "印尼",
  IE: "爱尔兰",
  IL: "以色列",
  IM: "马恩岛",
  IN: "印度",
  IO: "英属印度洋领地",
  IQ: "伊拉克",
  IR: "伊朗",
  IS: "冰岛",
  IT: "意大利",
  JE: "泽西",
  JM: "牙买加",
  JO: "约旦",
  JP: "日本",
  KE: "肯尼亚",
  KG: "吉尔吉斯斯坦",
  KH: "柬埔寨",
  KI: "基里巴斯",
  KM: "科摩罗",
  KN: "圣基茨和尼维斯",
  KP: "朝鲜",
  KR: "韩国",
  KW: "科威特",
  KY: "开曼群岛",
  KZ: "哈萨克斯坦",
  LA: "老挝",
  LB: "黎巴嫩",
  LC: "圣卢西亚",
  LI: "列支敦士登",
  LK: "斯里兰卡",
  LR: "利比里亚",
  LS: "莱索托",
  LT: "立陶宛",
  LU: "卢森堡",
  LV: "拉脱维亚",
  LY: "利比亚",
  MA: "摩洛哥",
  MC: "摩纳哥",
  MD: "摩尔多瓦",
  ME: "黑山",
  MF: "法属圣马丁",
  MG: "马达加斯加",
  MH: "马绍尔群岛",
  MK: "北马其顿",
  ML: "马里",
  MM: "缅甸",
  MN: "蒙古",
  MO: "澳门",
  MP: "北马里亚纳群岛",
  MQ: "马提尼克",
  MR: "毛里塔尼亚",
  MS: "蒙特塞拉特",
  MT: "马耳他",
  MU: "毛里求斯",
  MV: "马尔代夫",
  MW: "马拉维",
  MX: "墨西哥",
  MY: "马来西亚",
  MZ: "莫桑比克",
  NA: "纳米比亚",
  NC: "新喀里多尼亚",
  NE: "尼日尔",
  NF: "诺福克岛",
  NG: "尼日利亚",
  NI: "尼加拉瓜",
  NL: "荷兰",
  NO: "挪威",
  NP: "尼泊尔",
  NR: "瑙鲁",
  NU: "纽埃",
  NZ: "新西兰",
  OM: "阿曼",
  PA: "巴拿马",
  PE: "秘鲁",
  PF: "法属波利尼西亚",
  PG: "巴布亚新几内亚",
  PH: "菲律宾",
  PK: "巴基斯坦",
  PL: "波兰",
  PM: "圣皮埃尔和密克隆",
  PN: "皮特凯恩群岛",
  PR: "波多黎各",
  PS: "巴勒斯坦",
  PT: "葡萄牙",
  PW: "帕劳",
  PY: "巴拉圭",
  QA: "卡塔尔",
  RE: "留尼汪",
  RO: "罗马尼亚",
  RS: "塞尔维亚",
  RU: "俄罗斯",
  RW: "卢旺达",
  SA: "沙特阿拉伯",
  SB: "所罗门群岛",
  SC: "塞舌尔",
  SD: "苏丹",
  SE: "瑞典",
  SG: "新加坡",
  SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
  SI: "斯洛文尼亚",
  SJ: "斯瓦尔巴和扬马延",
  SK: "斯洛伐克",
  SL: "塞拉利昂",
  SM: "圣马力诺",
  SN: "塞内加尔",
  SO: "索马里",
  SR: "苏里南",
  SS: "南苏丹",
  ST: "圣多美和普林西比",
  SV: "萨尔瓦多",
  SX: "荷属圣马丁",
  SY: "叙利亚",
  SZ: "斯威士兰",
  TC: "特克斯和凯科斯群岛",
  TD: "乍得",
  TF: "法属南部领地",
  TG: "多哥",
  TH: "泰国",
  TJ: "塔吉克斯坦",
  TK: "托克劳",
  TL: "东帝汶",
  TM: "土库曼斯坦",
  TN: "突尼斯",
  TO: "汤加",
  TR: "土耳其",
  TT: "特立尼达和多巴哥",
  TV: "图瓦卢",
  TW: "中国台湾省",
  TZ: "坦桑尼亚",
  UA: "乌克兰",
  UG: "乌干达",
  UM: "美国本土外小岛屿",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VA: "梵蒂冈",
  VC: "圣文森特和格林纳丁斯",
  VE: "委内瑞拉",
  VG: "英属维尔京群岛",
  VI: "美属维尔京群岛",
  VN: "越南",
  VU: "瓦努阿图",
  WF: "瓦利斯和富图纳",
  WS: "萨摩亚",
  XK: "科索沃",
  YE: "也门",
  YT: "马约特",
  ZA: "南非",
  ZM: "赞比亚",
  ZW: "津巴布韦"
}, Av = {
  locale: Bi,
  countries: Zi
}, Ev = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Zi,
  default: Av,
  locale: Bi
}, Symbol.toStringTag, { value: "Module" })), Iv = {
  ar: Eg,
  cs: Dg,
  da: Rg,
  de: Og,
  el: Zg,
  en: Kg,
  es: Ug,
  fr: Wg,
  hi: Jg,
  hu: Qg,
  id: ev,
  it: av,
  ja: rv,
  nl: ov,
  no: lv,
  pl: uv,
  pt: Cv,
  ro: hv,
  ru: mv,
  sk: vv,
  sl: yv,
  sq: wv,
  sr: Mv,
  sv: kv,
  th: Hv,
  tr: Tv,
  uk: Vv,
  zh: Ev
};
Object.values(Iv).forEach((e) => {
  x4.registerLocale(e.default);
});
const Gi = (e, t) => {
  const r = Fr(t);
  switch (e) {
    case Ae.Taiwan:
      return x4.getName(e, r, { select: "alias" });
    default:
      return x4.getName(e, r, { select: "official" });
  }
}, aP = (e = N1.ENGLISH) => Object.values(Ae).map((t) => ({
  id: t,
  caption: Gi(t, e) ?? ""
})), nP = (e, t = N1.ENGLISH) => Gi(e, t) ?? "";
var L2 = /* @__PURE__ */ ((e) => (e.Email = "email", e.FirstName = "first_name", e.Surname = "surname", e.Country = "country", e.City = "city", e.Neighborhood = "neighborhood", e.StreetAddress = "street_address", e.StreetNumber = "street_number", e.Postcode = "postcode", e.PhoneNumber = "phone_number", e.CompanyName = "company_name", e.TaxNumber = "tax_number", e.State = "state", e))(L2 || {});
const Dv = {
  [L2.Email]: "public_pages_purchase.contact_slug.email",
  [L2.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [L2.Surname]: "public_pages_purchase.contact_slug.last_name",
  [L2.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [L2.Country]: "public_pages_purchase.contact_slug.country",
  [L2.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [L2.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [L2.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [L2.City]: "public_pages_purchase.contact_slug.city",
  [L2.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [L2.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [L2.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [L2.State]: "public_pages_purchase.contact_slug.state_province"
}, Nv = (e) => c1.t(Dv[e]), rP = (e) => {
  const { slug: t, fieldName: r } = e;
  return Object.values(L2).includes(t) ? Nv(t) : r;
};
var Rv = /* @__PURE__ */ ((e) => (e.ARGENTINE_PESO = "ars", e.AUSTRALIAN_DOLLAR = "aud", e.BULGARIAN_LEV = "bgn", e.BRAZILIAN_REAL = "brl", e.CANADIAN_DOLLAR = "cad", e.CENTRAL_AFRICAN_FRANC = "xaf", e.CHILEAN_PESO = "clp", e.CHINESE_YUAN = "cny", e.COLOMBIAN_PESO = "cop", e.CZECH_CROWN = "czk", e.DANISH_KRONE = "dkk", e.EGYPTIAN_POUND = "egp", e.EURO = "eur", e.GHANAIAN_CEDI = "ghs", e.GUINEAN_FRANC = "gnf", e.HONG_KONG_DOLLAR = "hkd", e.HUNGARIAN_FORINT = "huf", e.ICELANDIC_KRONA = "isk", e.INDIAN_RUPEE = "inr", e.INDONESIAN_RUPIAH = "idr", e.ISRAELI_NEW_SHEKEL = "ils", e.JAPANESE_YEN = "jpy", e.KENYAN_SHILLING = "kes", e.MALAWIAN_KWACHA = "mwk", e.MALAYSIAN_RINGGIT = "myr", e.MEXICAN_PESO = "mxn", e.MOROCCAN_DIRHAM = "mad", e.NEW_ZEALAND_DOLLAR = "nzd", e.NIGERIAN_NAIRA = "ngn", e.NORWEGIAN_KRONE = "nok", e.PHILIPPINE_PESO = "php", e.POLISH_ZLOTY = "pln", e.POUND_STERLING = "gbp", e.ROMANIA_LEI = "ron", e.RUSSIAN_RUBLE = "rub", e.RWANDAN_FRANC = "rwf", e.SAO_TOME_AND_PRINCIPE_DOBRA = "std", e.SAUDI_RIYAL = "sar", e.SIERRA_LEONEAN_LEONE = "sll", e.SINGAPORE_DOLLAR = "sgd", e.SOUTH_AFRICAN_RAND = "zar", e.SRI_LANKAN_RUPEE = "lkr", e.SWEDISH_KRONA = "sek", e.SWISS_FRANC = "chf", e.TANZANIAN_SHILLING = "tzs", e.THAI_BAHT = "thb", e.TURKISH_LIRA = "try", e.UGANDAN_SHILLING = "ugx", e.US_DOLLAR = "usd", e.UNITED_ARAB_EMIRATES_DIRHAM = "aed", e.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", e.ZAMBIAN_KWACHA = "zmw", e.SERBIAN_DINAR = "rsd", e.UKRAINIAN_HRYVNIA = "uah", e.ALBANIAN_LEK = "all", e.VIETNAM_DONG = "vnd", e.PERUVIAN_SOL = "pen", e))(Rv || {});
const Z3 = (e, t) => new Date(
  new Intl.DateTimeFormat(j1.ENGLISH, {
    timeZone: t,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(e)
), i2 = (e, t) => e ? e instanceof Date ? Z3(e, t) : e.match(/([-+]\d+:?\d+)$/) ? Z3(new Date(e), t) : new Date(e) : Z3(/* @__PURE__ */ new Date(), t), o6 = (e) => {
  const t = function(r) {
    return (r < 10 ? "0" : "") + r;
  };
  return e.getFullYear() + "-" + t(e.getMonth() + 1) + "-" + t(e.getDate()) + "T" + t(e.getHours()) + ":" + t(e.getMinutes()) + ":" + t(e.getSeconds());
}, Fv = (e) => {
  switch (e) {
    case y4.dateFirst:
      return "en-GB";
    case y4.monthFirst:
      return "en-US";
    default:
      return;
  }
}, vt = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(Fv(t == null ? void 0 : t.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: t == null ? void 0 : t.timeZone
}), Z8 = (e, t) => i2(e, t);
let Ov = { data: "" }, Bv = (e) => {
  if (typeof window == "object") {
    let t = (e ? e.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), { innerHTML: " ", id: "_goober" });
    return t.nonce = window.__nonce__, t.parentNode || (e || document.head).appendChild(t), t.firstChild;
  }
  return e || Ov;
}, Zv = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Gv = /\/\*[^]*?\*\/|  +/g, bt = /\n+/g, B5 = (e, t) => {
  let r = "", n = "", a = "";
  for (let i in e) {
    let o = e[i];
    i[0] == "@" ? i[1] == "i" ? r = i + " " + o + ";" : n += i[1] == "f" ? B5(o, i) : i + "{" + B5(o, i[1] == "k" ? "" : t) + "}" : typeof o == "object" ? n += B5(o, t ? t.replace(/([^,])+/g, (l) => i.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (c) => /&/.test(c) ? c.replace(/&/g, l) : l ? l + " " + c : c)) : i) : o != null && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), a += B5.p ? B5.p(i, o) : i + ":" + o + ";");
  }
  return r + (t && a ? t + "{" + a + "}" : a) + n;
}, S5 = {}, Ki = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let r in e)
      t += r + Ki(e[r]);
    return t;
  }
  return e;
}, Kv = (e, t, r, n, a) => {
  let i = Ki(e), o = S5[i] || (S5[i] = ((c) => {
    let u = 0, d = 11;
    for (; u < c.length; )
      d = 101 * d + c.charCodeAt(u++) >>> 0;
    return "go" + d;
  })(i));
  if (!S5[o]) {
    let c = i !== e ? e : ((u) => {
      let d, C, p = [{}];
      for (; d = Zv.exec(u.replace(Gv, "")); )
        d[4] ? p.shift() : d[3] ? (C = d[3].replace(bt, " ").trim(), p.unshift(p[0][C] = p[0][C] || {})) : p[0][d[1]] = d[2].replace(bt, " ").trim();
      return p[0];
    })(e);
    S5[o] = B5(a ? { ["@keyframes " + o]: c } : c, r ? "" : "." + o);
  }
  let l = r && S5.g ? S5.g : null;
  return r && (S5.g = S5[o]), ((c, u, d, C) => {
    C ? u.data = u.data.replace(C, c) : u.data.indexOf(c) === -1 && (u.data = d ? c + u.data : u.data + c);
  })(S5[o], t, n, l), o;
}, zv = (e, t, r) => e.reduce((n, a, i) => {
  let o = t[i];
  if (o && o.call) {
    let l = o(r), c = l && l.props && l.props.className || /^go/.test(l) && l;
    o = c ? "." + c : l && typeof l == "object" ? l.props ? "" : B5(l, "") : l === !1 ? "" : l;
  }
  return n + a + (o ?? "");
}, "");
function c3(e) {
  let t = this || {}, r = e.call ? e(t.p) : e;
  return Kv(r.unshift ? r.raw ? zv(r, [].slice.call(arguments, 1), t.p) : r.reduce((n, a) => Object.assign(n, a && a.call ? a(t.p) : a), {}) : r, Bv(t.target), t.g, t.o, t.k);
}
let zi, w4, _4;
c3.bind({ g: 1 });
let P5 = c3.bind({ k: 1 });
function Uv(e, t, r, n) {
  B5.p = t, zi = e, w4 = r, _4 = n;
}
function t6(e, t) {
  let r = this || {};
  return function() {
    let n = arguments;
    function a(i, o) {
      let l = Object.assign({}, i), c = l.className || a.className;
      r.p = Object.assign({ theme: w4 && w4() }, l), r.o = / *go\d+/.test(c), l.className = c3.apply(r, n) + (c ? " " + c : "");
      let u = e;
      return e[0] && (u = l.as || e, delete l.as), _4 && u[0] && _4(l), zi(u, l);
    }
    return a;
  };
}
var Yv = (e) => typeof e == "function", u7 = (e, t) => Yv(e) ? e(t) : e, Wv = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), Ui = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), $v = 20, Yi = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, $v) };
    case 1:
      return { ...e, toasts: e.toasts.map((i) => i.id === t.toast.id ? { ...i, ...t.toast } : i) };
    case 2:
      let { toast: r } = t;
      return Yi(e, { type: e.toasts.find((i) => i.id === r.id) ? 1 : 0, toast: r });
    case 3:
      let { toastId: n } = t;
      return { ...e, toasts: e.toasts.map((i) => i.id === n || n === void 0 ? { ...i, dismissed: !0, visible: !1 } : i) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((i) => i.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let a = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((i) => ({ ...i, pauseDuration: i.pauseDuration + a })) };
  }
}, G8 = [], K8 = { toasts: [], pausedAt: void 0 }, S6 = (e) => {
  K8 = Yi(K8, e), G8.forEach((t) => {
    t(K8);
  });
}, Jv = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, qv = (e = {}) => {
  let [t, r] = e1(K8);
  h1(() => (G8.push(r), () => {
    let a = G8.indexOf(r);
    a > -1 && G8.splice(a, 1);
  }), [t]);
  let n = t.toasts.map((a) => {
    var i, o, l;
    return { ...e, ...e[a.type], ...a, removeDelay: a.removeDelay || ((i = e[a.type]) == null ? void 0 : i.removeDelay) || (e == null ? void 0 : e.removeDelay), duration: a.duration || ((o = e[a.type]) == null ? void 0 : o.duration) || (e == null ? void 0 : e.duration) || Jv[a.type], style: { ...e.style, ...(l = e[a.type]) == null ? void 0 : l.style, ...a.style } };
  });
  return { ...t, toasts: n };
}, Qv = (e, t = "blank", r) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...r, id: (r == null ? void 0 : r.id) || Wv() }), S8 = (e) => (t, r) => {
  let n = Qv(t, e, r);
  return S6({ type: 2, toast: n }), n.id;
}, J1 = (e, t) => S8("blank")(e, t);
J1.error = S8("error");
J1.success = S8("success");
J1.loading = S8("loading");
J1.custom = S8("custom");
J1.dismiss = (e) => {
  S6({ type: 3, toastId: e });
};
J1.remove = (e) => S6({ type: 4, toastId: e });
J1.promise = (e, t, r) => {
  let n = J1.loading(t.loading, { ...r, ...r == null ? void 0 : r.loading });
  return typeof e == "function" && (e = e()), e.then((a) => {
    let i = t.success ? u7(t.success, a) : void 0;
    return i ? J1.success(i, { id: n, ...r, ...r == null ? void 0 : r.success }) : J1.dismiss(n), a;
  }).catch((a) => {
    let i = t.error ? u7(t.error, a) : void 0;
    i ? J1.error(i, { id: n, ...r, ...r == null ? void 0 : r.error }) : J1.dismiss(n);
  }), e;
};
var Xv = (e, t) => {
  S6({ type: 1, toast: { id: e, height: t } });
}, eb = () => {
  S6({ type: 5, time: Date.now() });
}, I9 = /* @__PURE__ */ new Map(), tb = 1e3, ab = (e, t = tb) => {
  if (I9.has(e))
    return;
  let r = setTimeout(() => {
    I9.delete(e), S6({ type: 4, toastId: e });
  }, t);
  I9.set(e, r);
}, nb = (e) => {
  let { toasts: t, pausedAt: r } = qv(e);
  h1(() => {
    if (r)
      return;
    let i = Date.now(), o = t.map((l) => {
      if (l.duration === 1 / 0)
        return;
      let c = (l.duration || 0) + l.pauseDuration - (i - l.createdAt);
      if (c < 0) {
        l.visible && J1.dismiss(l.id);
        return;
      }
      return setTimeout(() => J1.dismiss(l.id), c);
    });
    return () => {
      o.forEach((l) => l && clearTimeout(l));
    };
  }, [t, r]);
  let n = y1(() => {
    r && S6({ type: 6, time: Date.now() });
  }, [r]), a = y1((i, o) => {
    let { reverseOrder: l = !1, gutter: c = 8, defaultPosition: u } = o || {}, d = t.filter((h) => (h.position || u) === (i.position || u) && h.height), C = d.findIndex((h) => h.id === i.id), p = d.filter((h, f) => f < C && h.visible).length;
    return d.filter((h) => h.visible).slice(...l ? [p + 1] : [0, p]).reduce((h, f) => h + (f.height || 0) + c, 0);
  }, [t]);
  return h1(() => {
    t.forEach((i) => {
      if (i.dismissed)
        ab(i.id, i.removeDelay);
      else {
        let o = I9.get(i.id);
        o && (clearTimeout(o), I9.delete(i.id));
      }
    });
  }, [t]), { toasts: t, handlers: { updateHeight: Xv, startPause: eb, endPause: n, calculateOffset: a } };
}, rb = P5`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, ib = P5`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ob = P5`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, sb = t6("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${rb} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${ib} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${ob} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, lb = P5`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, cb = t6("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${lb} 1s linear infinite;
`, ub = P5`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, db = P5`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, Cb = t6("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ub} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${db} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, pb = t6("div")`
  position: absolute;
`, hb = t6("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, fb = P5`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, mb = t6("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${fb} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, gb = ({ toast: e }) => {
  let { icon: t, type: r, iconTheme: n } = e;
  return t !== void 0 ? typeof t == "string" ? Y.createElement(mb, null, t) : t : r === "blank" ? null : Y.createElement(hb, null, Y.createElement(cb, { ...n }), r !== "loading" && Y.createElement(pb, null, r === "error" ? Y.createElement(sb, { ...n }) : Y.createElement(Cb, { ...n })));
}, vb = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, bb = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, yb = "0%{opacity:0;} 100%{opacity:1;}", xb = "0%{opacity:1;} 100%{opacity:0;}", wb = t6("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, _b = t6("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Mb = (e, t) => {
  let r = e.includes("top") ? 1 : -1, [n, a] = Ui() ? [yb, xb] : [vb(r), bb(r)];
  return { animation: t ? `${P5(n)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${P5(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, Sb = Y.memo(({ toast: e, position: t, style: r, children: n }) => {
  let a = e.height ? Mb(e.position || t || "top-center", e.visible) : { opacity: 0 }, i = Y.createElement(gb, { toast: e }), o = Y.createElement(_b, { ...e.ariaProps }, u7(e.message, e));
  return Y.createElement(wb, { className: e.className, style: { ...a, ...r, ...e.style } }, typeof n == "function" ? n({ icon: i, message: o }) : Y.createElement(Y.Fragment, null, i, o));
});
Uv(Y.createElement);
var kb = ({ id: e, className: t, style: r, onHeightUpdate: n, children: a }) => {
  let i = Y.useCallback((o) => {
    if (o) {
      let l = () => {
        let c = o.getBoundingClientRect().height;
        n(e, c);
      };
      l(), new MutationObserver(l).observe(o, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [e, n]);
  return Y.createElement("div", { ref: i, className: t, style: r }, a);
}, Lb = (e, t) => {
  let r = e.includes("top"), n = r ? { top: 0 } : { bottom: 0 }, a = e.includes("center") ? { justifyContent: "center" } : e.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: Ui() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t * (r ? 1 : -1)}px)`, ...n, ...a };
}, Hb = c3`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, D8 = 16, Pb = ({ reverseOrder: e, position: t = "top-center", toastOptions: r, gutter: n, children: a, containerStyle: i, containerClassName: o }) => {
  let { toasts: l, handlers: c } = nb(r);
  return Y.createElement("div", { id: "_rht_toaster", style: { position: "fixed", zIndex: 9999, top: D8, left: D8, right: D8, bottom: D8, pointerEvents: "none", ...i }, className: o, onMouseEnter: c.startPause, onMouseLeave: c.endPause }, l.map((u) => {
    let d = u.position || t, C = c.calculateOffset(u, { reverseOrder: e, gutter: n, defaultPosition: t }), p = Lb(d, C);
    return Y.createElement(kb, { id: u.id, key: u.id, onHeightUpdate: c.updateHeight, className: u.visible ? Hb : "", style: p }, u.type === "custom" ? u7(u.message, u) : a ? a(u) : Y.createElement(Sb, { toast: u, position: d }));
  }));
}, Tb = J1, Ie = {}, Wi = {}, De = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.instanceOfHashable = e.guessType = e.guessObjectType = e.TYPE_MAP = void 0, e.TYPE_MAP = {
    Array: "array",
    Int8Array: "typedarray",
    Uint8Array: "typedarray",
    Uint8ClampedArray: "typedarray",
    Int16Array: "typedarray",
    Uint16Array: "typedarray",
    Int32Array: "typedarray",
    Uint32Array: "typedarray",
    Float32Array: "typedarray",
    Float64Array: "typedarray",
    BigUint64Array: "typedarray",
    BigInt64Array: "typedarray",
    Buffer: "typedarray",
    Map: "map",
    Set: "set",
    Date: "date",
    String: "string",
    Number: "number",
    BigInt: "bigint",
    Boolean: "boolean",
    Object: "object"
  };
  const t = (a) => {
    var o;
    if (a === null)
      return "null";
    if ((0, e.instanceOfHashable)(a))
      return "hashable";
    const i = ((o = a == null ? void 0 : a.constructor) == null ? void 0 : o.name) ?? "unknown";
    return e.TYPE_MAP[i] || "unknown";
  };
  e.guessObjectType = t;
  const r = (a) => {
    const i = typeof a;
    return i !== "object" ? i : (0, e.guessObjectType)(a);
  };
  e.guessType = r;
  const n = (a) => typeof a.toHashableString == "function";
  e.instanceOfHashable = n;
})(De);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e._mapSort = e._map = e._objectSort = e._object = e._setCoerce = e._set = e._setSort = e._setSortCoerce = e._typedArray = e._typedArraySort = e._array = e._arraySort = e._date = e._dateCoerce = e._functionTrim = e._functionTrimCoerce = e._function = e._functionCoerce = e._null = e._nullCoerce = e._undefined = e._undefinedCoerce = e._symbol = e._symbolCoerce = e._boolean = e._booleanCoerce = e._bigInt = e._bigIntCoerce = e._number = e._numberCoerce = e._stringTrim = e._stringTrimCoerce = e._string = e._stringCoerce = e._hashable = e.PREFIX = void 0;
  const t = De;
  e.PREFIX = {
    string: "<:s>",
    number: "<:n>",
    bigint: "<:bi>",
    boolean: "<:b>",
    symbol: "<:smbl>",
    undefined: "<:undf>",
    null: "<:null>",
    function: "<:func>",
    array: "",
    date: "<:date>",
    set: "<:set>",
    map: "<:map>"
  };
  function r(T) {
    return T.toHashableString();
  }
  e._hashable = r;
  function n(T) {
    return T;
  }
  e._stringCoerce = n;
  function a(T) {
    return e.PREFIX.string + ":" + T;
  }
  e._string = a;
  function i(T) {
    return T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrimCoerce = i;
  function o(T) {
    return e.PREFIX.string + ":" + T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrim = o;
  function l(T) {
    return T.toString();
  }
  e._numberCoerce = l;
  function c(T) {
    return `${e.PREFIX.number}:${T}`;
  }
  e._number = c;
  function u(T) {
    return T.toString();
  }
  e._bigIntCoerce = u;
  function d(T) {
    return `${e.PREFIX.bigint}:${T.toString()}`;
  }
  e._bigInt = d;
  function C(T) {
    return T ? "1" : "0";
  }
  e._booleanCoerce = C;
  function p(T) {
    return e.PREFIX.boolean + ":" + T.toString();
  }
  e._boolean = p;
  function h() {
    return e.PREFIX.symbol;
  }
  e._symbolCoerce = h;
  function f(T) {
    return e.PREFIX.symbol + ":" + T.toString();
  }
  e._symbol = f;
  function g() {
    return "";
  }
  e._undefinedCoerce = g;
  function m() {
    return e.PREFIX.undefined;
  }
  e._undefined = m;
  function v() {
    return "";
  }
  e._nullCoerce = v;
  function b() {
    return e.PREFIX.null;
  }
  e._null = b;
  function w(T) {
    return T.name + "=>" + T.toString();
  }
  e._functionCoerce = w;
  function M(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString();
  }
  e._function = M;
  function y(T) {
    return T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrimCoerce = y;
  function _(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrim = _;
  function S(T) {
    return T.toISOString();
  }
  e._dateCoerce = S;
  function j(T) {
    return e.PREFIX.date + ":" + T.toISOString();
  }
  e._date = j;
  function V(T) {
    const B = this;
    return "[" + T.map((D) => B[(0, t.guessType)(D)](D)).sort().toString() + "]";
  }
  e._arraySort = V;
  function P(T) {
    const B = this;
    return "[" + T.map((D) => B[(0, t.guessType)(D)](D)).toString() + "]";
  }
  e._array = P;
  function A(T) {
    const B = this;
    return "[" + Array.prototype.slice.call(T).map(($) => B[(0, t.guessType)($)]($)).sort().toString() + "]";
  }
  e._typedArraySort = A;
  function R(T) {
    const B = this;
    return "[" + Array.prototype.slice.call(T).map(($) => B[(0, t.guessType)($)]($)).toString() + "]";
  }
  e._typedArray = R;
  function z(T) {
    return V.call(this, Array.from(T));
  }
  e._setSortCoerce = z;
  function N(T) {
    return `${e.PREFIX.set}:${V.call(this, Array.from(T))}`;
  }
  e._setSort = N;
  function G(T) {
    return `${e.PREFIX.set}:${P.call(this, Array.from(T))}`;
  }
  e._set = G;
  function U(T) {
    return P.call(this, Array.from(T));
  }
  e._setCoerce = U;
  function Z(T) {
    const B = this, D = Object.keys(T), $ = [];
    for (const W of D) {
      const i1 = T[W], r1 = (0, t.guessType)(i1);
      $.push(W + ":" + B[r1](i1));
    }
    return "{" + $.toString() + "}";
  }
  e._object = Z;
  function E(T) {
    const B = this, D = Object.keys(T).sort(), $ = [];
    for (const W of D) {
      const i1 = T[W], r1 = (0, t.guessType)(i1);
      $.push(W + ":" + B[r1](i1));
    }
    return "{" + $.toString() + "}";
  }
  e._objectSort = E;
  function F(T) {
    const B = this, D = Array.from(T), $ = [];
    for (const W of D) {
      const [i1, r1] = W;
      $.push([B[(0, t.guessType)(i1)](i1), B[(0, t.guessType)(r1)](r1)]);
    }
    return "[" + $.join(";") + "]";
  }
  e._map = F;
  function I(T) {
    const B = this, D = Array.from(T), $ = [];
    for (const W of D) {
      const [i1, r1] = W;
      $.push([B[(0, t.guessType)(i1)](i1), B[(0, t.guessType)(r1)](r1)]);
    }
    return "[" + $.sort().join(";") + "]";
  }
  e._mapSort = I;
})(Wi);
var jb = G6 && G6.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var a = Object.getOwnPropertyDescriptor(t, r);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, a);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Vb = G6 && G6.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Ab = G6 && G6.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && jb(t, e, r);
  return Vb(t, e), t;
};
Object.defineProperty(Ie, "__esModule", { value: !0 });
var M4 = Ie.objectSorter = void 0;
const D1 = Ab(Wi), Eb = De, Ib = (e) => {
  const { sort: t, coerce: r, trim: n } = {
    sort: !0,
    coerce: !0,
    trim: !1,
    ...e
  }, a = {
    array: typeof t == "boolean" ? t : (t == null ? void 0 : t.array) ?? !1,
    typedArray: typeof t == "boolean" ? !1 : (t == null ? void 0 : t.typedArray) ?? !1,
    object: typeof t == "boolean" ? t : (t == null ? void 0 : t.object) ?? !1,
    set: typeof t == "boolean" ? t : (t == null ? void 0 : t.set) ?? !1,
    map: typeof t == "boolean" ? t : (t == null ? void 0 : t.map) ?? !1
  }, i = {
    boolean: typeof r == "boolean" ? r : (r == null ? void 0 : r.boolean) ?? !1,
    number: typeof r == "boolean" ? r : (r == null ? void 0 : r.number) ?? !1,
    bigint: typeof r == "boolean" ? r : (r == null ? void 0 : r.bigint) ?? !1,
    string: typeof r == "boolean" ? r : (r == null ? void 0 : r.string) ?? !1,
    undefined: typeof r == "boolean" ? r : (r == null ? void 0 : r.undefined) ?? !1,
    null: typeof r == "boolean" ? r : (r == null ? void 0 : r.null) ?? !1,
    symbol: typeof r == "boolean" ? r : (r == null ? void 0 : r.symbol) ?? !1,
    function: typeof r == "boolean" ? r : (r == null ? void 0 : r.function) ?? !1,
    date: typeof r == "boolean" ? r : (r == null ? void 0 : r.date) ?? !1,
    set: typeof r == "boolean" ? r : (r == null ? void 0 : r.set) ?? !1
  }, o = {
    string: typeof n == "boolean" ? n : (n == null ? void 0 : n.string) ?? !1,
    function: typeof n == "boolean" ? n : (n == null ? void 0 : n.function) ?? !1
  }, l = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    unknown: function(d) {
      var h;
      const C = ((h = d.constructor) == null ? void 0 : h.name) ?? "unknonw";
      let p = "unknown";
      return typeof d.toString == "function" ? p = d.toString() : Object.keys(d).length > 0 && (p = JSON.stringify(d)), `<:${C}>:${p}`;
    }
  };
  l.hashable = D1._hashable.bind(l), o.string ? l.string = i.string ? D1._stringTrimCoerce.bind(l) : D1._stringTrim.bind(l) : l.string = i.string ? D1._stringCoerce.bind(l) : D1._string.bind(l), l.number = i.number ? D1._numberCoerce.bind(l) : D1._number.bind(l), l.bigint = i.bigint ? D1._bigIntCoerce.bind(l) : D1._bigInt.bind(l), l.boolean = i.boolean ? D1._booleanCoerce.bind(l) : D1._boolean.bind(l), l.symbol = i.symbol ? D1._symbolCoerce.bind(l) : D1._symbol.bind(l), l.undefined = i.undefined ? D1._undefinedCoerce.bind(l) : D1._undefined.bind(l), l.null = i.null ? D1._nullCoerce.bind(l) : D1._null.bind(l), o.function ? l.function = i.function ? D1._functionTrimCoerce.bind(l) : D1._functionTrim.bind(l) : l.function = i.function ? D1._functionCoerce.bind(l) : D1._function.bind(l), l.date = i.date ? D1._dateCoerce.bind(l) : D1._date.bind(l), l.array = a.array ? D1._arraySort.bind(l) : D1._array.bind(l), l.typedarray = a.typedArray ? D1._typedArraySort.bind(l) : D1._typedArray.bind(l), a.set ? l.set = i.set ? D1._setSortCoerce.bind(l) : D1._setSort.bind(l) : l.set = i.set ? D1._setCoerce.bind(l) : D1._set.bind(l), l.object = a.object ? D1._objectSort.bind(l) : D1._object.bind(l), l.map = a.map ? D1._mapSort.bind(l) : D1._map.bind(l);
  function c(u) {
    return l[(0, Eb.guessType)(u)](u);
  }
  return c;
};
M4 = Ie.objectSorter = Ib;
const Db = J1.error, Nb = J1.success, Rb = J1.loading, Fb = J1.custom, u3 = (e) => {
  const t = {
    id: "mock-id",
    type: "blank",
    message: e,
    visible: !0,
    ariaProps: { role: "status", "aria-live": "polite" },
    pauseDuration: 0,
    createdAt: 0,
    dismissed: !1
  };
  let r;
  return typeof e == "string" ? r = e : typeof e == "function" ? r = JSON.stringify(M4()(e(t))) : typeof e == "object" && (r = JSON.stringify(M4()(e))), r;
};
J1.error = (e, t) => Db(e, {
  id: u3(e),
  ...t
});
J1.success = (e, t) => Nb(e, {
  id: u3(e),
  ...t
});
J1.loading = (e, t) => Rb(e, {
  id: u3(e),
  ...t
});
J1.custom = (e, t) => Fb(e, {
  id: u3(e),
  ...t
});
async function Ob(e, t) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(e), t && J1.success(t);
  } catch {
    J1.error(c1.t("public_pages_purchase.copy_clipboard_error"));
  }
}
const iP = (e) => Number(e), oP = (e) => Number(e), sP = (e) => e / 100, lP = (e) => Number(e) * 100, cP = (e) => {
  switch (e) {
    case N1.ARABIC:
      return /* @__PURE__ */ s.jsx(Xh, {});
    case N1.ENGLISH:
      return /* @__PURE__ */ s.jsx(J0, {});
    case N1.FRENCH:
      return /* @__PURE__ */ s.jsx(sf, {});
    case N1.RUSSIAN:
      return /* @__PURE__ */ s.jsx(ef, {});
    case N1.CHINESE:
      return /* @__PURE__ */ s.jsx(gf, {});
    case N1.DEUTSCH:
      return /* @__PURE__ */ s.jsx(af, {});
    case N1.SPANISH:
      return /* @__PURE__ */ s.jsx(of, {});
    case N1.ITALIAN:
      return /* @__PURE__ */ s.jsx(rf, {});
    case N1.POLISH:
      return /* @__PURE__ */ s.jsx(uf, {});
    case N1.PORTUGUESE:
      return /* @__PURE__ */ s.jsx(nf, {});
    case N1.SWEDISH:
      return /* @__PURE__ */ s.jsx(vf, {});
    case N1.CZECH:
      return /* @__PURE__ */ s.jsx(ff, {});
    case N1.UKRAINIAN:
      return /* @__PURE__ */ s.jsx(yf, {});
    case N1.JAPANESE:
      return /* @__PURE__ */ s.jsx(lf, {});
    case N1.DANISH:
      return /* @__PURE__ */ s.jsx(Cf, {});
    case N1.DUTCH:
      return /* @__PURE__ */ s.jsx(tf, {});
    case N1.HINDI:
      return /* @__PURE__ */ s.jsx(Mf, {});
    case N1.INDONESIAN:
      return /* @__PURE__ */ s.jsx(df, {});
    case N1.NORWEGIAN:
      return /* @__PURE__ */ s.jsx(_f, {});
    case N1.THAI:
      return /* @__PURE__ */ s.jsx(wf, {});
    case N1.SERBIAN:
      return /* @__PURE__ */ s.jsx(cf, {});
    case N1.SLOVAK:
      return /* @__PURE__ */ s.jsx(pf, {});
    case N1.HUNGARIAN:
      return /* @__PURE__ */ s.jsx(hf, {});
    case N1.ROMANIAN:
      return /* @__PURE__ */ s.jsx(mf, {});
    case N1.ALBANIA:
      return /* @__PURE__ */ s.jsx(bf, {});
    case N1.SLOVENIAN:
      return /* @__PURE__ */ s.jsx(xf, {});
    case N1.GREEK:
      return /* @__PURE__ */ s.jsx(Sf, {});
    case N1.TURKISH:
      return /* @__PURE__ */ s.jsx(kf, {});
    default:
      return /* @__PURE__ */ s.jsx(J0, {});
  }
}, Bb = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", Zb = "flex items-center justify-center gap-2", Gb = (e) => "href" in e, Kb = ({
  as: e = "a",
  href: t,
  isFetching: r,
  className: n,
  children: a,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || r ? /* @__PURE__ */ s.jsx("button", { className: n, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ s.jsx(S4, { buttonTextClassName: i, isFetching: r, children: a }) }) : /* @__PURE__ */ s.jsx(e, { className: n, href: t, ...o, children: /* @__PURE__ */ s.jsx(S4, { buttonTextClassName: i, isFetching: r, children: a }) }), S4 = ({
  children: e,
  isFetching: t,
  buttonTextClassName: r
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: K(
      "flex items-center justify-center gap-2 truncate",
      t && "opacity-0",
      r
    ),
    children: e
  }
), k6 = ({
  width: e = "small",
  isFetching: t,
  backgroundColor: r,
  color: n,
  hoverColor: a,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: l,
  loaderType: c,
  testAttributePostfix: u,
  className: d,
  buttonTextClassName: C,
  loaderClassName: p,
  as: h,
  ...f
}) => {
  const g = f, m = K(
    r7(
      Bb,
      Zb,
      r,
      n,
      a,
      i,
      e === "small" ? "px-4" : "px-10",
      o && `border ${o}`,
      l,
      t && "pointer-events-none select-none"
    ),
    d
  ), v = K(
    r7("absolute", t ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    p
  );
  if (Gb(g)) {
    const { "aria-disabled": b, ...w } = g;
    return /* @__PURE__ */ s.jsx(
      Kb,
      {
        as: h,
        isFetching: t,
        "aria-disabled": b || t,
        className: K(m, b && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...v4(!!u, `${u}`),
        children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(i7, { small: !0, type: c, className: v }),
          g.children
        ] })
      }
    );
  } else {
    const { disabled: b, ...w } = g;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        disabled: t || b,
        className: K(m, b && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...v4(!!u, `${u}`),
        children: [
          /* @__PURE__ */ s.jsx(i7, { small: !0, type: c, className: v }),
          /* @__PURE__ */ s.jsx(S4, { buttonTextClassName: C, isFetching: t, children: g.children })
        ]
      }
    );
  }
}, uP = (e) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-text-primary/50",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary",
    ...e
  }
);
var W6 = /* @__PURE__ */ ((e) => (e.danger = "danger", e.blue = "blue", e))(W6 || {});
const zb = (e) => {
  switch (e) {
    case W6.danger:
      return "hover:text-danger";
    case W6.blue:
      return "hover:text-brand-primary";
    default:
      return "text-brand-primary";
  }
}, Ub = (e) => {
  switch (e) {
    case W6.danger:
      return "hover:border-danger";
    case W6.blue:
      return "hover:border-brand-primary";
    default:
      return "border-brand-primary";
  }
}, dP = ({
  neutralType: e = W6.blue,
  ...t
}) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-text-primary",
    hoverColor: zb(e),
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-background-secondary",
    borderColor: "border-text-secondary/30",
    hoverBorderColor: Ub(e),
    ...t
  }
), CP = (e) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-text-primary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-transparent",
    hoverBackgroundColor: "hover:bg-text-primary",
    borderColor: "border-text-primary",
    loaderType: "dark",
    ...e
  }
), pP = (e) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-green",
    hoverBackgroundColor: "hover:bg-green",
    ...e
  }
), yt = ({ selected: e, ...t }) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: e ? "text-brand-primary" : "text-text-primary",
    hoverColor: e ? "hover:text-brand-primary" : "hover:text-text-primary",
    backgroundColor: e ? "bg-brand-primary/10" : "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary/10",
    borderColor: e ? "border-brand-primary" : "border-text-secondary/30",
    hoverBorderColor: "border-brand-primary",
    type: "button",
    ...t
  }
), $i = (e) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-brand-primary",
    hoverBackgroundColor: "hover:bg-brand-primary-hover",
    ...e
  }
), Ji = (e) => /* @__PURE__ */ s.jsx(
  k6,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-danger",
    hoverBackgroundColor: "hover:bg-danger",
    ...e
  }
);
function Yb({
  active: e,
  isFetching: t,
  iconClassName: r,
  menuButtonClassName: n,
  dataTestAttributes: a,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(
    he,
    {
      disabled: t,
      className: K(
        !i && "hover:bg-brand-primary focus-ring group h-[30px] rounded-lg px-3 py-1 transition-colors lg:h-[20px]",
        !i && (e ? "bg-brand-primary" : "bg-background-primary"),
        t && "pointer-events-none animate-pulse",
        n
      ),
      ...a,
      ...o,
      children: typeof i == "function" ? (l) => i({ ...l, active: e }) : i ?? /* @__PURE__ */ s.jsx(
        Bh,
        {
          className: K(
            "group-hover:fill-background-secondary",
            e && "fill-background-secondary",
            r
          )
        }
      )
    }
  );
}
const hP = ({
  menuItems: e,
  anchor: t = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: r,
  toggleOnHover: n = !0,
  ...a
}) => {
  const { show: i, close: o, delayOpen: l, delayClose: c } = _r();
  return /* @__PURE__ */ s.jsx(Wn, { children: ({ open: u, close: d }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Yb,
      {
        ...a,
        active: n && i || u,
        onMouseEnter: l,
        onMouseLeave: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      U5,
      {
        show: n && i || u,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ s.jsx(
          fe,
          {
            onClick: () => {
              d(), o();
            },
            static: !0,
            anchor: t,
            className: K(
              "bg-background-secondary border-background-tertiary overflow-hidden rounded-lg border shadow-lg focus:outline-hidden",
              r
            ),
            portal: !0,
            onMouseEnter: l,
            onMouseLeave: c,
            children: e
          }
        )
      }
    )
  ] }) });
}, Wb = "group aria-pressed:text-brand-primary hover:text-brand-primary flex items-center gap-2 w-full px-4 py-3 lg:py-2 text-left text-sm transition-colors border-b border-background-tertiary last:border-0", fP = ({
  dataTestAttributes: e,
  onClick: t,
  label: r,
  buttonClassName: n,
  labelClassName: a,
  children: i,
  ...o
}) => /* @__PURE__ */ s.jsx(me, { ...o, children: i || (({ focus: l }) => /* @__PURE__ */ s.jsx(
  "button",
  {
    onClick: t,
    "aria-pressed": l,
    type: "button",
    className: K(
      Wb,
      o.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed",
      n
    ),
    ...e,
    children: /* @__PURE__ */ s.jsx("span", { className: a, children: r })
  }
)) }, "action-settings"), $b = (e) => {
  switch (e) {
    case "success":
      return "border-green";
    case "error":
      return "border-danger";
    default:
      return "border-brand-primary";
  }
}, Jb = (e) => {
  switch (e) {
    case "success":
      return "hover:fill-green group-focus-visible:fill-green";
    case "error":
      return "hover:fill-danger group-focus-visible:fill-danger";
    default:
      return "hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  }
}, qi = ({
  t: e,
  afterClose: t,
  className: r,
  titleClassName: n,
  buttonClassName: a,
  hideCloseButton: i
}) => {
  const o = J(null), l = $b(e.type), c = Jb(e.type);
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: K(
        "bg-background-secondary text-text-tertiary flex max-w-[350px] items-center gap-2.5 rounded-lg border px-2.5 py-2 shadow-lg",
        e.visible ? "animate-toast-enter" : "animate-toast-leave",
        l,
        r
      ),
      "data-test-id": `toast-${e.type}`,
      children: [
        e.icon,
        /* @__PURE__ */ s.jsx("div", { className: K("break-words", n), children: e.message }),
        !i && /* @__PURE__ */ s.jsx(
          "button",
          {
            ref: o,
            className: K("group h-fit outline-hidden", a),
            onClick: () => {
              Tb.dismiss(e.id), t && t();
            },
            children: /* @__PURE__ */ s.jsx(
              w8,
              {
                className: K("fill-fill-primary main-transition-colors", c)
              }
            )
          }
        )
      ]
    }
  );
}, mP = ({
  className: e,
  titleClassName: t,
  buttonClassName: r,
  afterClose: n
}) => /* @__PURE__ */ s.jsx(
  Pb,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ s.jsx(Nh, { className: "fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ s.jsx(Fh, { className: "fill-danger h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      }
    },
    children: (a) => /* @__PURE__ */ s.jsx(
      qi,
      {
        t: a,
        className: e,
        titleClassName: t,
        buttonClassName: r,
        afterClose: n
      }
    )
  }
), gP = ({
  className: e,
  titleClassName: t,
  buttonClassName: r
} = {}) => ({ infoToast: y1(
  (a, i, o, l) => J1.custom(
    (c) => /* @__PURE__ */ s.jsx(
      qi,
      {
        t: { ...c, message: a },
        className: e,
        titleClassName: t,
        buttonClassName: r,
        afterClose: o,
        hideCloseButton: l
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ s.jsx(xr, { className: "fill-brand-primary h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
      ...i
    }
  ),
  []
) }), vP = ({
  options: e,
  selected: t,
  onChange: r,
  disabled: n,
  error: a,
  label: i,
  required: o,
  className: l,
  labelClassName: c,
  optionsWrapperClassName: u,
  optionWrapperClassName: d,
  selectedOptionWrapperClassName: C,
  optionClassName: p,
  inputClassName: h
}) => /* @__PURE__ */ s.jsxs("div", { className: K("flex flex-col gap-1", l), children: [
  /* @__PURE__ */ s.jsx(M6, { label: i, labelClassName: c, required: o }),
  /* @__PURE__ */ s.jsx("ul", { className: K("flex items-center gap-5", u), children: e ? e.map((f) => /* @__PURE__ */ s.jsx(
    Te,
    {
      label: f.tooltipLabel ?? "",
      disabled: !f.showTooltip,
      children: /* @__PURE__ */ s.jsx(
        "li",
        {
          className: K(
            d,
            f.id === t && C
          ),
          children: /* @__PURE__ */ s.jsxs(
            "label",
            {
              className: K(
                "r relative flex w-fit items-center gap-2",
                !n && "cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    className: K(
                      "border-2 outline-hidden",
                      n ? "border-fill-primary/70" : "border-fill-primary",
                      "h-[20px] w-[20px] rounded-full",
                      f.id === t ? "bg-background-secondary" : "bg-transparent",
                      "main-transition-colors focus-ring shrink-0 appearance-none",
                      h
                    ),
                    disabled: n || f.disabled,
                    checked: f.id === t,
                    value: f.caption,
                    onChange: () => r(f.id),
                    type: "radio"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "svg",
                  {
                    width: 20,
                    height: 20,
                    className: K(
                      "main-transition-colors absolute",
                      f.id === t ? "fill-green" : "fill-transparent",
                      n && "opacity-70"
                    ),
                    children: /* @__PURE__ */ s.jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                  f.caption && /* @__PURE__ */ s.jsx(
                    "span",
                    {
                      className: K(
                        "main-transition-colors",
                        f.id === t ? "text-text-primary" : "text-text-primary/50",
                        n && "opacity-70",
                        p,
                        "text-left"
                      ),
                      children: f.caption
                    }
                  ),
                  f.additionalInfo
                ] })
              ]
            }
          )
        }
      )
    },
    f.id
  )) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ s.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ s.jsx(X5, { error: a })
] });
function Ne({
  arrowButtonClassName: e,
  open: t,
  isDisabled: r,
  As: n = b8
}) {
  return /* @__PURE__ */ s.jsx(
    n,
    {
      as: "div",
      className: K(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        r && "cursor-not-allowed",
        e
      ),
      disabled: r,
      children: /* @__PURE__ */ s.jsx(
        br,
        {
          className: K("stroke-text-primary main-transition", t && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function Re({ onClick: e, closeButtonClassName: t, isDisabled: r }) {
  return /* @__PURE__ */ s.jsx(
    "button",
    {
      type: "button",
      className: K(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        r && "cursor-not-allowed",
        t
      ),
      onClick: e,
      disabled: r,
      children: /* @__PURE__ */ s.jsx(w8, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function qb({
  children: e,
  selectedData: t,
  virtual: r,
  disabled: n,
  onClose: a,
  onChange: i
}) {
  return /* @__PURE__ */ s.jsx(
    ne,
    {
      immediate: !0,
      multiple: !0,
      value: t,
      virtual: r,
      onChange: (o) => i((o == null ? void 0 : o.filter((l) => l.id !== void 0).map((l) => l.id)) ?? []),
      disabled: n,
      onClose: a,
      children: ({ open: o }) => e(o)
    }
  );
}
function Qb({
  children: e,
  selectedData: t,
  virtual: r,
  disabled: n,
  onClose: a,
  onChange: i
}) {
  return /* @__PURE__ */ s.jsx(
    ne,
    {
      immediate: !0,
      value: t,
      virtual: r,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: n,
      onClose: a,
      children: ({ open: o }) => e(o)
    }
  );
}
const Qi = "text-[16px] sm:text-sm", Fe = "px-4 py-2.5";
function Xi({
  isDisabled: e,
  open: t,
  hasError: r,
  className: n,
  placeholder: a,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: l,
  onChange: c,
  inputRef: u,
  dataTest: d
}) {
  return /* @__PURE__ */ s.jsx(
    ae,
    {
      ref: u,
      className: K(
        "w-full truncate",
        Qi,
        "flex items-center justify-between",
        Fe,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        e ? "bg-skeleton-primary/20" : "bg-background-secondary",
        t ? "border-brand-primary" : r ? "border-danger" : "border-text-secondary/30",
        o && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        n
      ),
      onChange: (C) => c == null ? void 0 : c(C.target.value),
      onKeyDown: (C) => C.stopPropagation(),
      onFocus: l,
      displayValue: i ? () => i : void 0,
      placeholder: a ?? c1.t("public_pages_purchase.form_select.select"),
      ...d
    }
  );
}
function Oe({ loaderWrapperClassName: e, loaderClassName: t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: K(
        "flex h-full items-center justify-center",
        "scale-75",
        e
      ),
      children: /* @__PURE__ */ s.jsx(i7, { className: K(t) })
    }
  );
}
const Be = ({
  item: e,
  optionClassName: t,
  optionIconWrapperClassName: r,
  optionRef: n,
  as: a
}) => {
  const i = (e == null ? void 0 : e.customCaption) ?? (e == null ? void 0 : e.caption), o = ({ disabled: c, selected: u }) => K(
    "bg-background-secondary text-text-primary",
    Fe,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    u && "bg-brand-primary text-background-secondary",
    c && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    t,
    e == null ? void 0 : e.className
  ), l = ({ selected: c }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    i,
    /* @__PURE__ */ s.jsxs("div", { className: K("flex items-center gap-3", r), children: [
      c && /* @__PURE__ */ s.jsx(
        Rh,
        {
          className: r7(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      e == null ? void 0 : e.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ s.jsx(
    a,
    {
      disabled: e == null ? void 0 : e.disabled,
      ref: n,
      value: e,
      className: o,
      "data-test-id": e == null ? void 0 : e.dataTestAttribute,
      children: l
    },
    e == null ? void 0 : e.id
  );
}, d3 = n9(
  ({ children: e, style: t, optionsClassName: r, as: n, optionsProps: a }, i) => /* @__PURE__ */ s.jsx(
    n,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: i,
      style: t,
      className: K(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        Qi,
        r
      ),
      ...a,
      children: e
    }
  )
);
d3.displayName = "ListOptionsWrapper";
const xt = 240, eo = () => ({
  id: void 0,
  caption: c1.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), Ze = (e, t) => {
  let r = 0;
  return e && (e.querySelectorAll('[role="option"]').forEach((a) => {
    r += a.getBoundingClientRect().height;
  }), r = t ? Math.min(r, xt) || xt : 42), r;
};
function to({
  optionsClassName: e,
  data: t,
  loaderWrapperClassName: r,
  loaderClassName: n,
  asOptions: a,
  asOption: i,
  ...o
}) {
  const [l, c] = e1(null), u = Ze(l, t);
  return /* @__PURE__ */ s.jsx(
    d3,
    {
      as: a,
      ref: c,
      optionsClassName: e,
      style: { height: u },
      children: ({ option: d }) => t ? Be({ ...o, as: i, item: d }) : /* @__PURE__ */ s.jsx(
        Oe,
        {
          loaderWrapperClassName: r,
          loaderClassName: n
        }
      )
    }
  );
}
const ao = (e, t) => (t == null ? void 0 : t.find((r) => r.id === e)) ?? null, no = (e) => {
  const [t, r] = e1(""), [n, a] = e1(e);
  return h1(() => {
    const i = t === "" ? e : (e == null ? void 0 : e.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(t.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    a(() => i);
  }, [e, t]), { filteredData: n, setFilteredData: a, query: t, setQuery: r };
}, ro = (e = []) => ({
  options: e.length > 0 ? e : [eo()],
  disabled: (t) => (t == null ? void 0 : t.disabled) ?? !1
});
function bP({
  label: e,
  data: t,
  staticData: r,
  onChange: n,
  labelClassName: a,
  value: i,
  isPreFetching: o,
  placeholder: l,
  error: c,
  required: u,
  description: d,
  className: C,
  containerClassName: p,
  closeButtonClassName: h,
  arrowButtonClassName: f,
  fieldClassName: g,
  disabled: m,
  withoutCloseIcon: v,
  onOpen: b,
  onClose: w,
  dataTest: M,
  wrapperProps: y,
  loaderClassName: _,
  loaderWrapperClassName: S,
  inputWrapperClassName: j,
  inputRef: V,
  statusIcon: P,
  statusIconClassName: A,
  ...R
}) {
  const [z, N] = e1(!1);
  h1(() => {
    z && b && (b(), N(!1));
  }, [z]);
  const G = ao(i, t ?? r) ?? null, { filteredData: U, setQuery: Z } = no(t), E = i !== void 0, T = m || o || E && (!t && !r), B = E && !v && !T;
  return /* @__PURE__ */ s.jsxs("div", { className: K("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ s.jsx(
      Qb,
      {
        selectedData: G,
        virtual: ro(U),
        onChange: n,
        disabled: T,
        onClose: () => {
          Z(""), w == null || w();
        },
        children: (D) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsxs(J7, { className: K("relative flex flex-col gap-1", g), children: [
            /* @__PURE__ */ s.jsx(
              M6,
              {
                wrapperAs: "label",
                wrapperProps: y,
                label: e,
                required: u,
                labelClassName: K("text-sm font-medium", a)
              }
            ),
            /* @__PURE__ */ s.jsxs(b8, { as: "button", className: K("relative", j), children: [
              /* @__PURE__ */ s.jsx(
                Xi,
                {
                  dataTest: M,
                  inputRef: V,
                  isDisabled: T,
                  hasError: !!c,
                  open: D,
                  className: C,
                  placeholder: l,
                  selectedCaption: (G == null ? void 0 : G.caption) ?? "",
                  isPreFetching: o,
                  onFocus: () => N(!0),
                  onChange: ($) => {
                    N(!0), Z($);
                  }
                }
              ),
              P ? /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    A
                  ),
                  children: P
                }
              ) : /* @__PURE__ */ s.jsx(
                Ne,
                {
                  isDisabled: T,
                  arrowButtonClassName: K(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    f
                  ),
                  open: D
                }
              )
            ] }),
            B && /* @__PURE__ */ s.jsx(
              Re,
              {
                isDisabled: T,
                closeButtonClassName: K(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  h
                ),
                onClick: () => n(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx(
            to,
            {
              asOptions: Z7,
              asOption: G7,
              data: U,
              ...R
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ s.jsx(X5, { error: c, description: d })
  ] });
}
function yP({
  data: e,
  staticData: t,
  onChange: r,
  value: n,
  isPreFetching: a,
  placeholder: i,
  required: o,
  description: l,
  className: c,
  closeButtonClassName: u,
  arrowButtonClassName: d,
  fieldClassName: C,
  disabled: p,
  withoutCloseIcon: h,
  onOpen: f,
  onClose: g,
  dataTest: m,
  wrapperProps: v,
  loaderClassName: b,
  loaderWrapperClassName: w,
  captionClassName: M,
  inputRef: y,
  optionsClassName: _,
  ...S
}) {
  const [j, V] = e1(!1);
  h1(() => {
    j && f && (f(), V(!1));
  }, [j]);
  const P = ao(n, e ?? t) ?? null, A = n !== void 0, N = p || a || A && (!e && !t), G = A && !h && !N, U = Q(() => {
    if (e)
      return e.length > 0 ? e : [eo()];
  }, [e]), [Z, E] = e1(null), F = Ze(Z, e);
  return /* @__PURE__ */ s.jsx(
    e3,
    {
      value: P,
      onChange: (I) => {
        I !== null && r(I == null ? void 0 : I.id);
      },
      disabled: N,
      children: ({ open: I }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsxs(J7, { className: K("relative flex w-fit flex-col gap-1", C), children: [
          /* @__PURE__ */ s.jsxs(
            z6,
            {
              className: K(
                "inline-grid w-fit",
                "pr-6",
                G && "pr-10",
                "focus-ring rounded-md outline-hidden",
                c
              ),
              children: [
                /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: K(
                      "text-start truncate underline decoration-dashed",
                      M
                    ),
                    children: (P == null ? void 0 : P.caption) ?? i ?? c1.t("public_pages_purchase.form_select.select")
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  Ne,
                  {
                    As: z6,
                    isDisabled: N,
                    arrowButtonClassName: K(
                      "absolute bottom-0 right-0",
                      "h-6 w-4",
                      d
                    ),
                    open: I
                  }
                )
              ]
            }
          ),
          G && /* @__PURE__ */ s.jsx(
            Re,
            {
              isDisabled: N,
              closeButtonClassName: K(
                "absolute bottom-0 right-5 ",
                "h-6 w-4",
                u
              ),
              onClick: () => r(void 0)
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          d3,
          {
            ref: E,
            style: { height: F },
            as: x8,
            optionsClassName: K("h-fit w-fit outline-hidden", _),
            children: U ? U.map(
              (T) => Be({
                item: T,
                as: X7,
                optionClassName: S == null ? void 0 : S.optionClassName,
                optionIconWrapperClassName: S == null ? void 0 : S.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ s.jsx(
              Oe,
              {
                loaderWrapperClassName: K("p-2", w),
                loaderClassName: b
              }
            )
          }
        )
      ] })
    }
  );
}
function xP({
  label: e,
  data: t,
  staticData: r,
  onChange: n,
  labelClassName: a,
  value: i,
  isPreFetching: o,
  placeholder: l,
  error: c,
  required: u,
  description: d,
  className: C,
  containerClassName: p,
  closeButtonClassName: h,
  arrowButtonClassName: f,
  fieldClassName: g,
  disabled: m,
  withoutCloseIcon: v,
  onOpen: b,
  onClose: w,
  dataTest: M,
  wrapperProps: y,
  loaderClassName: _,
  loaderWrapperClassName: S,
  hideSelectedValues: j,
  inputWrapperClassName: V,
  inputRef: P,
  ...A
}) {
  const [R, z] = e1(!1);
  h1(() => {
    R && b && (b(), z(!1));
  }, [R]);
  const N = Q(
    () => {
      var B;
      return ((B = t ?? r) == null ? void 0 : B.filter((D) => i == null ? void 0 : i.includes(D.id))) ?? [];
    },
    [t, r, i]
  ), { filteredData: G, setQuery: U } = no(t), Z = i.length > 0, I = m || o || Z && (!t && !r), T = Z && !v && !I;
  return /* @__PURE__ */ s.jsxs("div", { className: K("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ s.jsx(
      qb,
      {
        selectedData: N,
        virtual: ro(G),
        onChange: n,
        disabled: I,
        onClose: () => {
          U(""), w == null || w();
        },
        children: (B) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsxs(J7, { className: K("flex flex-col gap-1", g), children: [
            /* @__PURE__ */ s.jsx(
              M6,
              {
                wrapperAs: "label",
                wrapperProps: y,
                label: e,
                required: u,
                labelClassName: K("text-sm font-medium", a)
              }
            ),
            /* @__PURE__ */ s.jsxs(b8, { as: "div", className: K("relative", V), children: [
              /* @__PURE__ */ s.jsx(
                Xi,
                {
                  dataTest: M,
                  inputRef: P,
                  isDisabled: I,
                  hasError: !!c,
                  open: B,
                  className: C,
                  placeholder: l,
                  isPreFetching: o,
                  selectedCaption: j ? "" : N.map((D) => D.caption).join(", "),
                  onFocus: () => z(!0),
                  onChange: (D) => {
                    z(!0), U(D);
                  }
                }
              ),
              /* @__PURE__ */ s.jsx(
                Ne,
                {
                  isDisabled: I,
                  arrowButtonClassName: K(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    f
                  ),
                  open: B
                }
              )
            ] }),
            T && /* @__PURE__ */ s.jsx(
              Re,
              {
                isDisabled: I,
                closeButtonClassName: K(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  h
                ),
                onClick: () => n([])
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx(
            to,
            {
              asOptions: Z7,
              asOption: G7,
              data: G,
              ...A
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ s.jsx(X5, { error: c, description: d })
  ] });
}
function wP({
  value: e,
  onChange: t,
  children: r,
  optionsClassName: n,
  data: a,
  loaderClassName: i,
  loaderWrapperClassName: o,
  optionClassName: l,
  optionIconWrapperClassName: c,
  disabled: u,
  buttonClassName: d,
  optionsProps: C
}) {
  const p = a == null ? void 0 : a.find((m) => m.id === e), [h, f] = e1(null), g = Ze(h, a);
  return /* @__PURE__ */ s.jsx(e3, { disabled: u, value: p, onChange: (m) => t(m == null ? void 0 : m.id), children: ({ open: m }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      z6,
      {
        className: K(
          "ring-brand-primary outline-hidden focus-visible:ring-2",
          d
        ),
        children: r(m)
      }
    ),
    /* @__PURE__ */ s.jsx(
      d3,
      {
        ref: f,
        style: { height: g },
        as: x8,
        optionsClassName: K("h-fit outline-hidden", n),
        optionsProps: C,
        children: a ? a.map(
          (v) => Be({
            item: v,
            as: X7,
            optionClassName: l,
            optionIconWrapperClassName: c
          })
        ) : /* @__PURE__ */ s.jsx(
          Oe,
          {
            loaderWrapperClassName: o,
            loaderClassName: i
          }
        )
      }
    )
  ] }) });
}
function _P({ amount: e, className: t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: K(
        "text-background-secondary bg-green flex min-h-6 min-w-6 items-center justify-center rounded-full p-1 text-xs",
        t
      ),
      children: e
    }
  );
}
const MP = ({
  children: e,
  className: t,
  color: r = "blue",
  showHint: n = !0,
  ...a
}) => /* @__PURE__ */ s.jsxs("div", { className: K("flex items-center gap-0.5", t), children: [
  e,
  n && /* @__PURE__ */ s.jsx(
    Te,
    {
      mode: "click",
      ...a,
      className: K("focus-ring rounded-full"),
      popoverClassName: K("!max-w-[200px] sm:!max-w-[350px]", a.popoverClassName),
      wrapperClassName: "m-1",
      children: (i) => /* @__PURE__ */ s.jsx(
        xr,
        {
          className: K(
            `group-focus-visible:fill-${r} h-[16px] w-[16px]`,
            i ? `fill-${r}` : "fill-fill-primary"
          )
        }
      )
    }
  )
] });
var io = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var l = arguments[o];
        l && (i = a(i, n(l)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var l in i)
        t.call(i, l) && i[l] && (o = a(o, l));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(io);
var Xb = io.exports;
const y2 = /* @__PURE__ */ M7(Xb);
function t1(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function C3(e) {
  return t1(1, arguments), e instanceof Date || R2(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function o1(e) {
  t1(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || R2(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $9(e) {
  if (t1(1, arguments), !C3(e) && typeof e != "number")
    return !1;
  var t = o1(e);
  return !isNaN(Number(t));
}
function L1(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ge(e, t) {
  t1(2, arguments);
  var r = o1(e).getTime(), n = L1(t);
  return new Date(r + n);
}
function oo(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return Ge(e, -r);
}
var ey = 864e5;
function ty(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / ey) + 1;
}
function $6(e) {
  t1(1, arguments);
  var t = 1, r = o1(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function so(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = $6(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = $6(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function ay(e) {
  t1(1, arguments);
  var t = so(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = $6(r);
  return n;
}
var ny = 6048e5;
function lo(e) {
  t1(1, arguments);
  var t = o1(e), r = $6(t).getTime() - ay(t).getTime();
  return Math.round(r / ny) + 1;
}
var ry = {};
function L6() {
  return ry;
}
function b6(e, t) {
  var r, n, a, i, o, l, c, u;
  t1(1, arguments);
  var d = L6(), C = L1((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : d.weekStartsOn) !== null && n !== void 0 ? n : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(C >= 0 && C <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = o1(e), h = p.getUTCDay(), f = (h < C ? 7 : 0) + h - C;
  return p.setUTCDate(p.getUTCDate() - f), p.setUTCHours(0, 0, 0, 0), p;
}
function Ke(e, t) {
  var r, n, a, i, o, l, c, u;
  t1(1, arguments);
  var d = o1(e), C = d.getUTCFullYear(), p = L6(), h = L1((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && n !== void 0 ? n : (c = p.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(C + 1, 0, h), f.setUTCHours(0, 0, 0, 0);
  var g = b6(f, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(C, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = b6(m, t);
  return d.getTime() >= g.getTime() ? C + 1 : d.getTime() >= v.getTime() ? C : C - 1;
}
function iy(e, t) {
  var r, n, a, i, o, l, c, u;
  t1(1, arguments);
  var d = L6(), C = L1((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = Ke(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, C), h.setUTCHours(0, 0, 0, 0);
  var f = b6(h, t);
  return f;
}
var oy = 6048e5;
function co(e, t) {
  t1(1, arguments);
  var r = o1(e), n = b6(r, t).getTime() - iy(r, t).getTime();
  return Math.round(n / oy) + 1;
}
function U1(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var R5 = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return U1(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : U1(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return U1(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return U1(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return U1(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return U1(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return U1(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return U1(i, r.length);
  }
}, D6 = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, sy = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return R5.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = Ke(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var l = o % 100;
      return U1(l, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : U1(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = so(t);
    return U1(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return U1(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return U1(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return U1(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return R5.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return U1(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = co(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : U1(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = lo(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : U1(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : R5.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = ty(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : U1(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return U1(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return U1(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return U1(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = D6.noon : a === 0 ? i = D6.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = D6.evening : a >= 12 ? i = D6.afternoon : a >= 4 ? i = D6.morning : i = D6.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return R5.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : R5.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : U1(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : U1(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : R5.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : R5.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return R5.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return _t(o);
      case "XXXX":
      case "XX":
        return i6(o);
      case "XXXXX":
      case "XXX":
      default:
        return i6(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return _t(o);
      case "xxxx":
      case "xx":
        return i6(o);
      case "xxxxx":
      case "xxx":
      default:
        return i6(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + wt(o, ":");
      case "OOOO":
      default:
        return "GMT" + i6(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + wt(o, ":");
      case "zzzz":
      default:
        return "GMT" + i6(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return U1(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return U1(o, r.length);
  }
};
function wt(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t;
  return r + String(a) + o + U1(i, 2);
}
function _t(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + U1(Math.abs(e) / 60, 2);
  }
  return i6(e, t);
}
function i6(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = U1(Math.floor(a / 60), 2), o = U1(a % 60, 2);
  return n + i + r + o;
}
var Mt = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, uo = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, ly = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return Mt(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Mt(a, r)).replace("{{time}}", uo(i, r));
}, k4 = {
  p: uo,
  P: ly
};
function d7(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var cy = ["D", "DD"], uy = ["YY", "YYYY"];
function Co(e) {
  return cy.indexOf(e) !== -1;
}
function po(e) {
  return uy.indexOf(e) !== -1;
}
function C7(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var dy = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Cy = function(t, r, n) {
  var a, i = dy[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function G3(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var py = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, hy = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fy = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, my = {
  date: G3({
    formats: py,
    defaultWidth: "full"
  }),
  time: G3({
    formats: hy,
    defaultWidth: "full"
  }),
  dateTime: G3({
    formats: fy,
    defaultWidth: "full"
  })
}, gy = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vy = function(t, r, n, a) {
  return gy[t];
};
function S9(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var l = e.defaultWidth, c = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[c] || e.values[l];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[u];
  };
}
var by = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, wy = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, _y = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, My = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Sy = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ky = {
  ordinalNumber: Sy,
  era: S9({
    values: by,
    defaultWidth: "wide"
  }),
  quarter: S9({
    values: yy,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: S9({
    values: xy,
    defaultWidth: "wide"
  }),
  day: S9({
    values: wy,
    defaultWidth: "wide"
  }),
  dayPeriod: S9({
    values: _y,
    defaultWidth: "wide",
    formattingValues: My,
    defaultFormattingWidth: "wide"
  })
};
function k9(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], l = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(l) ? Hy(l, function(C) {
      return C.test(o);
    }) : Ly(l, function(C) {
      return C.test(o);
    }), u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? r.valueCallback(u) : u;
    var d = t.slice(o.length);
    return {
      value: u,
      rest: d
    };
  };
}
function Ly(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function Hy(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Py(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var l = t.slice(a.length);
    return {
      value: o,
      rest: l
    };
  };
}
var Ty = /^(\d+)(th|st|nd|rd)?/i, jy = /\d+/i, Vy = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ay = {
  any: [/^b/i, /^(a|c)/i]
}, Ey = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Iy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dy = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ny = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Ry = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Fy = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Oy = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, By = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Zy = {
  ordinalNumber: Py({
    matchPattern: Ty,
    parsePattern: jy,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: k9({
    matchPatterns: Vy,
    defaultMatchWidth: "wide",
    parsePatterns: Ay,
    defaultParseWidth: "any"
  }),
  quarter: k9({
    matchPatterns: Ey,
    defaultMatchWidth: "wide",
    parsePatterns: Iy,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: k9({
    matchPatterns: Dy,
    defaultMatchWidth: "wide",
    parsePatterns: Ny,
    defaultParseWidth: "any"
  }),
  day: k9({
    matchPatterns: Ry,
    defaultMatchWidth: "wide",
    parsePatterns: Fy,
    defaultParseWidth: "any"
  }),
  dayPeriod: k9({
    matchPatterns: Oy,
    defaultMatchWidth: "any",
    parsePatterns: By,
    defaultParseWidth: "any"
  })
}, h9 = {
  code: "en-US",
  formatDistance: Cy,
  formatLong: my,
  formatRelative: vy,
  localize: ky,
  match: Zy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Gy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ky = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, zy = /^'([^]*?)'?$/, Uy = /''/g, Yy = /[a-zA-Z]/;
function St(e, t, r) {
  var n, a, i, o, l, c, u, d, C, p, h, f, g, m, v, b, w, M;
  t1(2, arguments);
  var y = String(t), _ = L6(), S = (n = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : _.locale) !== null && n !== void 0 ? n : h9, j = L1((i = (o = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : _.firstWeekContainsDate) !== null && o !== void 0 ? o : (C = _.locale) === null || C === void 0 || (p = C.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var V = L1((h = (f = (g = (m = r == null ? void 0 : r.weekStartsOn) !== null && m !== void 0 ? m : r == null || (v = r.locale) === null || v === void 0 || (b = v.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && g !== void 0 ? g : _.weekStartsOn) !== null && f !== void 0 ? f : (w = _.locale) === null || w === void 0 || (M = w.options) === null || M === void 0 ? void 0 : M.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(V >= 0 && V <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!S.localize)
    throw new RangeError("locale must contain localize property");
  if (!S.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var P = o1(e);
  if (!$9(P))
    throw new RangeError("Invalid time value");
  var A = d7(P), R = oo(P, A), z = {
    firstWeekContainsDate: j,
    weekStartsOn: V,
    locale: S,
    _originalDate: P
  }, N = y.match(Ky).map(function(G) {
    var U = G[0];
    if (U === "p" || U === "P") {
      var Z = k4[U];
      return Z(G, S.formatLong);
    }
    return G;
  }).join("").match(Gy).map(function(G) {
    if (G === "''")
      return "'";
    var U = G[0];
    if (U === "'")
      return Wy(G);
    var Z = sy[U];
    if (Z)
      return !(r != null && r.useAdditionalWeekYearTokens) && po(G) && C7(G, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && Co(G) && C7(G, t, String(e)), Z(R, G, S.localize, z);
    if (U.match(Yy))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + U + "`");
    return G;
  }).join("");
  return N;
}
function Wy(e) {
  var t = e.match(zy);
  return t ? t[1].replace(Uy, "'") : e;
}
var $y = 6e4;
function L4(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return Ge(e, r * $y);
}
var Jy = 36e5;
function qy(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return Ge(e, r * Jy);
}
function f9(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function p7(e, t) {
  t1(2, arguments);
  var r = L1(t), n = r * 7;
  return f9(e, n);
}
function e5(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), a), r);
}
function ho(e, t) {
  t1(2, arguments);
  var r = L1(t), n = r * 3;
  return e5(e, n);
}
function J6(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return e5(e, r * 12);
}
function Qy(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return f9(e, -r);
}
function kt(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return p7(e, -r);
}
function q6(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return e5(e, -r);
}
function Xy(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return ho(e, -r);
}
function J9(e, t) {
  t1(2, arguments);
  var r = L1(t);
  return J6(e, -r);
}
function Lt(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getSeconds();
  return r;
}
function p5(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getMinutes();
  return r;
}
function h5(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getHours();
  return r;
}
function ex(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getDay();
  return r;
}
function Ht(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getDate();
  return r;
}
function fo(e, t) {
  var r, n, a, i, o, l, c, u;
  t1(1, arguments);
  var d = L6(), C = L1((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : d.weekStartsOn) !== null && n !== void 0 ? n : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(C >= 0 && C <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = o1(e), h = p.getDay(), f = (h < C ? 7 : 0) + h - C;
  return p.setDate(p.getDate() - f), p.setHours(0, 0, 0, 0), p;
}
function h7(e) {
  return t1(1, arguments), fo(e, {
    weekStartsOn: 1
  });
}
function tx(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var a = h7(n), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  var o = h7(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function ax(e) {
  t1(1, arguments);
  var t = tx(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var n = h7(r);
  return n;
}
var nx = 6048e5;
function rx(e) {
  t1(1, arguments);
  var t = o1(e), r = h7(t).getTime() - ax(t).getTime();
  return Math.round(r / nx) + 1;
}
function _2(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getMonth();
  return r;
}
function R6(e) {
  t1(1, arguments);
  var t = o1(e), r = Math.floor(t.getMonth() / 3) + 1;
  return r;
}
function H1(e) {
  return t1(1, arguments), o1(e).getFullYear();
}
function H4(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getTime();
  return r;
}
function ix(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  return r.setSeconds(n), r;
}
function z8(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  return r.setMinutes(n), r;
}
function U8(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  return r.setHours(n), r;
}
function ox(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getFullYear(), n = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(r, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function H2(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t), a = r.getFullYear(), i = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a, n, 15), o.setHours(0, 0, 0, 0);
  var l = ox(o);
  return r.setMonth(n, Math.min(i, l)), r;
}
function N6(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t), a = Math.floor(r.getMonth() / 3) + 1, i = n - a;
  return H2(r, r.getMonth() + i * 3);
}
function k5(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(n), r);
}
function Pt(e) {
  t1(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (R2(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = o1(n);
    (r === void 0 || r > a || isNaN(a.getDate())) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Tt(e) {
  t1(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (R2(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(n) {
    var a = o1(n);
    (r === void 0 || r < a || isNaN(Number(a))) && (r = a);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function f5(e) {
  t1(1, arguments);
  var t = o1(e);
  return t.setHours(0, 0, 0, 0), t;
}
var sx = 864e5;
function q9(e, t) {
  t1(2, arguments);
  var r = f5(e), n = f5(t), a = r.getTime() - d7(r), i = n.getTime() - d7(n);
  return Math.round((a - i) / sx);
}
function f7(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
function m7(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getFullYear() - n.getFullYear();
}
function mo(e) {
  t1(1, arguments);
  var t = o1(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function P4(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getMonth(), n = r - r % 3;
  return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
}
function go(e) {
  t1(1, arguments);
  var t = o1(e), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function T4(e) {
  t1(1, arguments);
  var t = o1(e);
  return t.setHours(23, 59, 59, 999), t;
}
function lx(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function cx(e) {
  t1(1, arguments);
  var t = o1(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function ux(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getTime() === n.getTime();
}
function dx(e, t) {
  t1(2, arguments);
  var r = f5(e), n = f5(t);
  return r.getTime() === n.getTime();
}
function Cx(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function px(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getFullYear() === n.getFullYear();
}
function hx(e, t) {
  t1(2, arguments);
  var r = P4(e), n = P4(t);
  return r.getTime() === n.getTime();
}
function J5(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getTime() > n.getTime();
}
function G5(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t);
  return r.getTime() < n.getTime();
}
function Q9(e, t) {
  t1(2, arguments);
  var r = o1(e).getTime(), n = o1(t.start).getTime(), a = o1(t.end).getTime();
  if (!(n <= a))
    throw new RangeError("Invalid interval");
  return r >= n && r <= a;
}
function jt(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = qf(e)) || t) {
      r && (e = r);
      var n = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, l = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var u = r.next();
      return o = u.done, u;
    },
    e: function(u) {
      l = !0, i = u;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (l)
          throw i;
      }
    }
  };
}
function fx(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function s1(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function j4(e, t) {
  return j4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, j4(e, t);
}
function Z1(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && j4(e, t);
}
function g7(e) {
  return g7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, g7(e);
}
function vo() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vo = function() {
    return !!e;
  })();
}
function mx(e, t) {
  if (t && (R2(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return s1(e);
}
function G1(e) {
  var t = vo();
  return function() {
    var r, n = g7(e);
    if (t) {
      var a = g7(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else
      r = n.apply(this, arguments);
    return mx(this, r);
  };
}
var gx = 10, bo = /* @__PURE__ */ function() {
  function e() {
    A1(this, e), a1(this, "priority", void 0), a1(this, "subPriority", 0);
  }
  return E1(e, [{
    key: "validate",
    value: function(r, n) {
      return !0;
    }
  }]), e;
}(), vx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r(n, a, i, o, l) {
    var c;
    return A1(this, r), c = t.call(this), c.value = n, c.validateValue = a, c.setValue = i, c.priority = o, l && (c.subPriority = l), c;
  }
  return E1(r, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return this.setValue(a, i, this.value, o);
    }
  }]), r;
}(bo), bx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", gx), a1(s1(n), "subPriority", -1), n;
  }
  return E1(r, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
    }
  }]), r;
}(bo), K1 = /* @__PURE__ */ function() {
  function e() {
    A1(this, e), a1(this, "incompatibleTokens", void 0), a1(this, "priority", void 0), a1(this, "subPriority", void 0);
  }
  return E1(e, [{
    key: "run",
    value: function(r, n, a, i) {
      var o = this.parse(r, n, a, i);
      return o ? {
        setter: new vx(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, n, a) {
      return !0;
    }
  }]), e;
}(), yx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 140), a1(s1(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(a, {
            width: "wide"
          }) || o.era(a, {
            width: "abbreviated"
          }) || o.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), ze = 6e4, Ue = 36e5, xx = 1e3, c2 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, s5 = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function u2(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function n2(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function l5(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * Ue + i * ze + o * xx),
    rest: t.slice(r[0].length)
  };
}
function yo(e) {
  return n2(c2.anyDigitsSigned, e);
}
function o2(e, t) {
  switch (e) {
    case 1:
      return n2(c2.singleDigit, t);
    case 2:
      return n2(c2.twoDigits, t);
    case 3:
      return n2(c2.threeDigits, t);
    case 4:
      return n2(c2.fourDigits, t);
    default:
      return n2(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function v7(e, t) {
  switch (e) {
    case 1:
      return n2(c2.singleDigitSigned, t);
    case 2:
      return n2(c2.twoDigitsSigned, t);
    case 3:
      return n2(c2.threeDigitsSigned, t);
    case 4:
      return n2(c2.fourDigitsSigned, t);
    default:
      return n2(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Ye(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function xo(e, t) {
  var r = t > 0, n = r ? t : 1 - t, a;
  if (n <= 50)
    a = e || 100;
  else {
    var i = n + 50, o = Math.floor(i / 100) * 100, l = e >= i % 100;
    a = e + o - (l ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function wo(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var wx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 130), a1(s1(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return u2(o2(4, a), l);
        case "yo":
          return u2(o.ordinalNumber(a, {
            unit: "year"
          }), l);
        default:
          return u2(o2(i.length, a), l);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var l = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var c = xo(o.year, l);
        return a.setUTCFullYear(c, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var u = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), _x = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 130), a1(s1(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return u2(o2(4, a), l);
        case "Yo":
          return u2(o.ordinalNumber(a, {
            unit: "year"
          }), l);
        default:
          return u2(o2(i.length, a), l);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, o, l) {
      var c = Ke(a, l);
      if (o.isTwoDigitYear) {
        var u = xo(o.year, c);
        return a.setUTCFullYear(u, 0, l.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), b6(a, l);
      }
      var d = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(d, 0, l.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), b6(a, l);
    }
  }]), r;
}(K1), Mx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 130), a1(s1(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i) {
      return v7(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var l = /* @__PURE__ */ new Date(0);
      return l.setUTCFullYear(o, 0, 4), l.setUTCHours(0, 0, 0, 0), $6(l);
    }
  }]), r;
}(K1), Sx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 130), a1(s1(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i) {
      return v7(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), kx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 120), a1(s1(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return o2(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Lx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 120), a1(s1(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return o2(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Hx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), a1(s1(n), "priority", 110), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      var l = function(u) {
        return u - 1;
      };
      switch (i) {
        case "M":
          return u2(n2(c2.month, a), l);
        case "MM":
          return u2(o2(2, a), l);
        case "Mo":
          return u2(o.ordinalNumber(a, {
            unit: "month"
          }), l);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Px = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 110), a1(s1(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      var l = function(u) {
        return u - 1;
      };
      switch (i) {
        case "L":
          return u2(n2(c2.month, a), l);
        case "LL":
          return u2(o2(2, a), l);
        case "Lo":
          return u2(o.ordinalNumber(a, {
            unit: "month"
          }), l);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1);
function Tx(e, t, r) {
  t1(2, arguments);
  var n = o1(e), a = L1(t), i = co(n, r) - a;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var jx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 100), a1(s1(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "w":
          return n2(c2.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o, l) {
      return b6(Tx(a, o, l), l);
    }
  }]), r;
}(K1);
function Vx(e, t) {
  t1(2, arguments);
  var r = o1(e), n = L1(t), a = lo(r) - n;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var Ax = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 100), a1(s1(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "I":
          return n2(c2.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return $6(Vx(a, o));
    }
  }]), r;
}(K1), Ex = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ix = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Dx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "subPriority", 1), a1(s1(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "d":
          return n2(c2.date, a);
        case "do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), l = wo(o), c = a.getUTCMonth();
      return l ? i >= 1 && i <= Ix[c] : i >= 1 && i <= Ex[c];
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Nx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "subpriority", 1), a1(s1(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return n2(c2.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var o = a.getUTCFullYear(), l = wo(o);
      return l ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1);
function We(e, t, r) {
  var n, a, i, o, l, c, u, d;
  t1(2, arguments);
  var C = L6(), p = L1((n = (a = (i = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (l = r.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && i !== void 0 ? i : C.weekStartsOn) !== null && a !== void 0 ? a : (u = C.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = o1(e), f = L1(t), g = h.getUTCDay(), m = f % 7, v = (m + 7) % 7, b = (v < p ? 7 : 0) + f - g;
  return h.setUTCDate(h.getUTCDate() + b), h;
}
var Rx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, l) {
      return a = We(a, o, l), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Fx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o, l) {
      var c = function(d) {
        var C = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + C;
      };
      switch (i) {
        case "e":
        case "ee":
          return u2(o2(i.length, a), c);
        case "eo":
          return u2(o.ordinalNumber(a, {
            unit: "day"
          }), c);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, l) {
      return a = We(a, o, l), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Ox = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o, l) {
      var c = function(d) {
        var C = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + C;
      };
      switch (i) {
        case "c":
        case "cc":
          return u2(o2(i.length, a), c);
        case "co":
          return u2(o.ordinalNumber(a, {
            unit: "day"
          }), c);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, o, l) {
      return a = We(a, o, l), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1);
function Bx(e, t) {
  t1(2, arguments);
  var r = L1(t);
  r % 7 === 0 && (r = r - 7);
  var n = 1, a = o1(e), i = a.getUTCDay(), o = r % 7, l = (o + 7) % 7, c = (l < n ? 7 : 0) + r - i;
  return a.setUTCDate(a.getUTCDate() + c), a;
}
var Zx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 90), a1(s1(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      var l = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (i) {
        case "i":
        case "ii":
          return o2(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return u2(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiii":
          return u2(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiiii":
          return u2(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiii":
        default:
          return u2(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), l);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a = Bx(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(K1), Gx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 80), a1(s1(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ye(o), 0, 0, 0), a;
    }
  }]), r;
}(K1), Kx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 80), a1(s1(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ye(o), 0, 0, 0), a;
    }
  }]), r;
}(K1), zx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 80), a1(s1(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(Ye(o), 0, 0, 0), a;
    }
  }]), r;
}(K1), Ux = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 70), a1(s1(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "h":
          return n2(c2.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var l = a.getUTCHours() >= 12;
      return l && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !l && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(K1), Yx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 70), a1(s1(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "H":
          return n2(c2.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(K1), Wx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 70), a1(s1(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "K":
          return n2(c2.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var l = a.getUTCHours() >= 12;
      return l && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), r;
}(K1), $x = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 70), a1(s1(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "k":
          return n2(c2.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      var l = o <= 24 ? o % 24 : o;
      return a.setUTCHours(l, 0, 0, 0), a;
    }
  }]), r;
}(K1), Jx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 60), a1(s1(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "m":
          return n2(c2.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), r;
}(K1), qx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 50), a1(s1(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i, o) {
      switch (i) {
        case "s":
          return n2(c2.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return o2(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), r;
}(K1), Qx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 30), a1(s1(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i) {
      var o = function(c) {
        return Math.floor(c * Math.pow(10, -i.length + 3));
      };
      return u2(o2(i.length, a), o);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), r;
}(K1), Xx = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 10), a1(s1(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return l5(s5.basicOptionalMinutes, a);
        case "XX":
          return l5(s5.basic, a);
        case "XXXX":
          return l5(s5.basicOptionalSeconds, a);
        case "XXXXX":
          return l5(s5.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return l5(s5.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(K1), ew = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 10), a1(s1(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return l5(s5.basicOptionalMinutes, a);
        case "xx":
          return l5(s5.basic, a);
        case "xxxx":
          return l5(s5.basicOptionalSeconds, a);
        case "xxxxx":
          return l5(s5.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return l5(s5.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), r;
}(K1), tw = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 40), a1(s1(n), "incompatibleTokens", "*"), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a) {
      return yo(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(K1), aw = /* @__PURE__ */ function(e) {
  Z1(r, e);
  var t = G1(r);
  function r() {
    var n;
    A1(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), a1(s1(n), "priority", 20), a1(s1(n), "incompatibleTokens", "*"), n;
  }
  return E1(r, [{
    key: "parse",
    value: function(a) {
      return yo(a);
    }
  }, {
    key: "set",
    value: function(a, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(K1), nw = {
  G: new yx(),
  y: new wx(),
  Y: new _x(),
  R: new Mx(),
  u: new Sx(),
  Q: new kx(),
  q: new Lx(),
  M: new Hx(),
  L: new Px(),
  w: new jx(),
  I: new Ax(),
  d: new Dx(),
  D: new Nx(),
  E: new Rx(),
  e: new Fx(),
  c: new Ox(),
  i: new Zx(),
  a: new Gx(),
  b: new Kx(),
  B: new zx(),
  h: new Ux(),
  H: new Yx(),
  K: new Wx(),
  k: new $x(),
  m: new Jx(),
  s: new qx(),
  S: new Qx(),
  X: new Xx(),
  x: new ew(),
  t: new tw(),
  T: new aw()
}, rw = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, iw = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ow = /^'([^]*?)'?$/, sw = /''/g, lw = /\S/, cw = /[a-zA-Z]/;
function K3(e, t, r, n) {
  var a, i, o, l, c, u, d, C, p, h, f, g, m, v, b, w, M, y;
  t1(3, arguments);
  var _ = String(e), S = String(t), j = L6(), V = (a = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : j.locale) !== null && a !== void 0 ? a : h9;
  if (!V.match)
    throw new RangeError("locale must contain match property");
  var P = L1((o = (l = (c = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (d = n.locale) === null || d === void 0 || (C = d.options) === null || C === void 0 ? void 0 : C.firstWeekContainsDate) !== null && c !== void 0 ? c : j.firstWeekContainsDate) !== null && l !== void 0 ? l : (p = j.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = L1((f = (g = (m = (v = n == null ? void 0 : n.weekStartsOn) !== null && v !== void 0 ? v : n == null || (b = n.locale) === null || b === void 0 || (w = b.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && m !== void 0 ? m : j.weekStartsOn) !== null && g !== void 0 ? g : (M = j.locale) === null || M === void 0 || (y = M.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(A >= 0 && A <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (S === "")
    return _ === "" ? o1(r) : /* @__PURE__ */ new Date(NaN);
  var R = {
    firstWeekContainsDate: P,
    weekStartsOn: A,
    locale: V
  }, z = [new bx()], N = S.match(iw).map(function(d1) {
    var m1 = d1[0];
    if (m1 in k4) {
      var Q1 = k4[m1];
      return Q1(d1, V.formatLong);
    }
    return d1;
  }).join("").match(rw), G = [], U = jt(N), Z;
  try {
    var E = function() {
      var m1 = Z.value;
      !(n != null && n.useAdditionalWeekYearTokens) && po(m1) && C7(m1, S, e), !(n != null && n.useAdditionalDayOfYearTokens) && Co(m1) && C7(m1, S, e);
      var Q1 = m1[0], _1 = nw[Q1];
      if (_1) {
        var p1 = _1.incompatibleTokens;
        if (Array.isArray(p1)) {
          var T1 = G.find(function(k1) {
            return p1.includes(k1.token) || k1.token === Q1;
          });
          if (T1)
            throw new RangeError("The format string mustn't contain `".concat(T1.fullToken, "` and `").concat(m1, "` at the same time"));
        } else if (_1.incompatibleTokens === "*" && G.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(m1, "` and any other token at the same time"));
        G.push({
          token: Q1,
          fullToken: m1
        });
        var l1 = _1.run(_, m1, V.match, R);
        if (!l1)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        z.push(l1.setter), _ = l1.rest;
      } else {
        if (Q1.match(cw))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Q1 + "`");
        if (m1 === "''" ? m1 = "'" : Q1 === "'" && (m1 = uw(m1)), _.indexOf(m1) === 0)
          _ = _.slice(m1.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (U.s(); !(Z = U.n()).done; ) {
      var F = E();
      if (R2(F) === "object")
        return F.v;
    }
  } catch (d1) {
    U.e(d1);
  } finally {
    U.f();
  }
  if (_.length > 0 && lw.test(_))
    return /* @__PURE__ */ new Date(NaN);
  var I = z.map(function(d1) {
    return d1.priority;
  }).sort(function(d1, m1) {
    return m1 - d1;
  }).filter(function(d1, m1, Q1) {
    return Q1.indexOf(d1) === m1;
  }).map(function(d1) {
    return z.filter(function(m1) {
      return m1.priority === d1;
    }).sort(function(m1, Q1) {
      return Q1.subPriority - m1.subPriority;
    });
  }).map(function(d1) {
    return d1[0];
  }), T = o1(r);
  if (isNaN(T.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var B = oo(T, d7(T)), D = {}, $ = jt(I), W;
  try {
    for ($.s(); !(W = $.n()).done; ) {
      var i1 = W.value;
      if (!i1.validate(B, R))
        return /* @__PURE__ */ new Date(NaN);
      var r1 = i1.set(B, D, R);
      Array.isArray(r1) ? (B = r1[0], fx(D, r1[1])) : B = r1;
    }
  } catch (d1) {
    $.e(d1);
  } finally {
    $.f();
  }
  return B;
}
function uw(e) {
  return e.match(ow)[1].replace(sw, "'");
}
function dw(e, t) {
  var r;
  t1(1, arguments);
  var n = L1((r = void 0) !== null && r !== void 0 ? r : 2);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = fw(e), i;
  if (a.date) {
    var o = mw(a.date, n);
    i = gw(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l = i.getTime(), c = 0, u;
  if (a.time && (c = vw(a.time), isNaN(c)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (u = bw(a.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var d = new Date(l + c), C = /* @__PURE__ */ new Date(0);
    return C.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), C.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), C;
  }
  return new Date(l + c + u);
}
var N8 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Cw = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, pw = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, hw = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function fw(e) {
  var t = {}, r = e.split(N8.dateTimeDelimiter), n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], N8.timeZoneDelimiter.test(t.date) && (t.date = e.split(N8.timeZoneDelimiter)[0], n = e.substr(t.date.length, e.length))), n) {
    var a = N8.timezone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timezone = a[1]) : t.time = n;
  }
  return t;
}
function mw(e, t) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), n = e.match(r);
  if (!n)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = n[1] ? parseInt(n[1]) : null, i = n[2] ? parseInt(n[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function gw(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = e.match(Cw);
  if (!r)
    return /* @__PURE__ */ new Date(NaN);
  var n = !!r[4], a = L9(r[1]), i = L9(r[2]) - 1, o = L9(r[3]), l = L9(r[4]), c = L9(r[5]) - 1;
  if (n)
    return Mw(t, l, c) ? yw(t, l, c) : /* @__PURE__ */ new Date(NaN);
  var u = /* @__PURE__ */ new Date(0);
  return !ww(t, i, o) || !_w(t, a) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(a, o)), u);
}
function L9(e) {
  return e ? parseInt(e) : 1;
}
function vw(e) {
  var t = e.match(pw);
  if (!t)
    return NaN;
  var r = z3(t[1]), n = z3(t[2]), a = z3(t[3]);
  return Sw(r, n, a) ? r * Ue + n * ze + a * 1e3 : NaN;
}
function z3(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function bw(e) {
  if (e === "Z")
    return 0;
  var t = e.match(hw);
  if (!t)
    return 0;
  var r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return kw(n, a) ? r * (n * Ue + a * ze) : NaN;
}
function yw(e, t, r) {
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var a = n.getUTCDay() || 7, i = (t - 1) * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var xw = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function _o(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ww(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (xw[t] || (_o(e) ? 29 : 28));
}
function _w(e, t) {
  return t >= 1 && t <= (_o(e) ? 366 : 365);
}
function Mw(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function Sw(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function kw(e, t) {
  return t >= 0 && t <= 59;
}
function Lw(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, V4(e, t);
}
function V4(e, t) {
  return V4 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, V4(e, t);
}
function Hw(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Vt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pw(e, t, r) {
  return e === t ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(r) : e.classList.contains(r);
}
function Tw(e, t, r) {
  if (e === t)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && Pw(e, t, r))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function jw(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var Vw = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var t = !1, r = Object.defineProperty({}, "passive", {
      get: function() {
        t = !0;
      }
    }), n = function() {
    };
    return window.addEventListener("testPassiveEventSupport", n, r), window.removeEventListener("testPassiveEventSupport", n, r), t;
  }
};
function Aw(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var Ew = Aw(), A4, R8 = {}, U3 = {}, Iw = ["touchstart", "touchmove"], Dw = "ignore-react-onclickoutside";
function At(e, t) {
  var r = {}, n = Iw.indexOf(t) !== -1;
  return n && A4 && (r.passive = !e.props.preventDefault), r;
}
function p3(e, t) {
  var r, n, a = e.displayName || e.name || "Component";
  return n = r = /* @__PURE__ */ function(i) {
    Lw(o, i);
    function o(c) {
      var u;
      return u = i.call(this, c) || this, u.__outsideClickHandler = function(d) {
        if (typeof u.__clickOutsideHandlerProp == "function") {
          u.__clickOutsideHandlerProp(d);
          return;
        }
        var C = u.getInstance();
        if (typeof C.props.handleClickOutside == "function") {
          C.props.handleClickOutside(d);
          return;
        }
        if (typeof C.handleClickOutside == "function") {
          C.handleClickOutside(d);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, u.__getComponentNode = function() {
        var d = u.getInstance();
        return typeof d.setClickOutsideRef == "function" ? d.setClickOutsideRef() : ws(d);
      }, u.enableOnClickOutside = function() {
        if (!(typeof document > "u" || U3[u._uid])) {
          typeof A4 > "u" && (A4 = Vw()), U3[u._uid] = !0;
          var d = u.props.eventTypes;
          d.forEach || (d = [d]), R8[u._uid] = function(C) {
            if (u.componentNode !== null && !(u.initTimeStamp > C.timeStamp) && (u.props.preventDefault && C.preventDefault(), u.props.stopPropagation && C.stopPropagation(), !(u.props.excludeScrollbar && jw(C)))) {
              var p = C.composed && C.composedPath && C.composedPath().shift() || C.target;
              Tw(p, u.componentNode, u.props.outsideClickIgnoreClass) === document && u.__outsideClickHandler(C);
            }
          }, d.forEach(function(C) {
            document.addEventListener(C, R8[u._uid], At(Vt(u), C));
          });
        }
      }, u.disableOnClickOutside = function() {
        delete U3[u._uid];
        var d = R8[u._uid];
        if (d && typeof document < "u") {
          var C = u.props.eventTypes;
          C.forEach || (C = [C]), C.forEach(function(p) {
            return document.removeEventListener(p, d, At(Vt(u), p));
          }), delete R8[u._uid];
        }
      }, u.getRef = function(d) {
        return u.instanceRef = d;
      }, u._uid = Ew(), u.initTimeStamp = performance.now(), u;
    }
    var l = o.prototype;
    return l.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var u = this.instanceRef;
      return u.getInstance ? u.getInstance() : u;
    }, l.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, l.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, l.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, l.render = function() {
      var u = this.props;
      u.excludeScrollbar;
      var d = Hw(u, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? d.ref = this.getRef : d.wrappedRef = this.getRef, d.disableOnClickOutside = this.disableOnClickOutside, d.enableOnClickOutside = this.enableOnClickOutside, va(e, d);
    }, o;
  }(ys), r.displayName = "OnClickOutside(" + a + ")", r.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: Dw,
    preventDefault: !1,
    stopPropagation: !1
  }, r.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, n;
}
var Mo = Y.createContext(), So = Y.createContext();
function Nw(e) {
  var t = e.children, r = Y.useState(null), n = r[0], a = r[1], i = Y.useRef(!1);
  Y.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = Y.useCallback(function(l) {
    i.current || a(l);
  }, []);
  return /* @__PURE__ */ Y.createElement(Mo.Provider, {
    value: n
  }, /* @__PURE__ */ Y.createElement(So.Provider, {
    value: o
  }, t));
}
var ko = function(t) {
  return Array.isArray(t) ? t[0] : t;
}, Lo = function(t) {
  if (typeof t == "function") {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    return t.apply(void 0, n);
  }
}, E4 = function(t, r) {
  if (typeof t == "function")
    return Lo(t, r);
  t != null && (t.current = r);
}, Et = function(t) {
  return t.reduce(function(r, n) {
    var a = n[0], i = n[1];
    return r[a] = i, r;
  }, {});
}, It = typeof window < "u" && window.document && window.document.createElement ? Y.useLayoutEffect : Y.useEffect, V2 = "top", K2 = "bottom", z2 = "right", A2 = "left", $e = "auto", k8 = [V2, K2, z2, A2], Q6 = "start", X9 = "end", Rw = "clippingParents", Ho = "viewport", H9 = "popper", Fw = "reference", Dt = /* @__PURE__ */ k8.reduce(function(e, t) {
  return e.concat([t + "-" + Q6, t + "-" + X9]);
}, []), Po = /* @__PURE__ */ [].concat(k8, [$e]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Q6, t + "-" + X9]);
}, []), Ow = "beforeRead", Bw = "read", Zw = "afterRead", Gw = "beforeMain", Kw = "main", zw = "afterMain", Uw = "beforeWrite", Yw = "write", Ww = "afterWrite", $w = [Ow, Bw, Zw, Gw, Kw, zw, Uw, Yw, Ww];
function b5(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function F2(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function y6(e) {
  var t = F2(e).Element;
  return e instanceof t || e instanceof Element;
}
function G2(e) {
  var t = F2(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Je(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = F2(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Jw(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !G2(i) || !b5(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var l = a[o];
      l === !1 ? i.removeAttribute(o) : i.setAttribute(o, l === !0 ? "" : l);
    }));
  });
}
function qw(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = o.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !G2(a) || !b5(a) || (Object.assign(a.style, l), Object.keys(i).forEach(function(c) {
        a.removeAttribute(c);
      }));
    });
  };
}
const Qw = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Jw,
  effect: qw,
  requires: ["computeStyles"]
};
function m5(e) {
  return e.split("-")[0];
}
var C6 = Math.max, b7 = Math.min, X6 = Math.round;
function I4() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function To() {
  return !/^((?!chrome|android).)*safari/i.test(I4());
}
function e9(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && G2(e) && (a = e.offsetWidth > 0 && X6(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && X6(n.height) / e.offsetHeight || 1);
  var o = y6(e) ? F2(e) : window, l = o.visualViewport, c = !To() && r, u = (n.left + (c && l ? l.offsetLeft : 0)) / a, d = (n.top + (c && l ? l.offsetTop : 0)) / i, C = n.width / a, p = n.height / i;
  return {
    width: C,
    height: p,
    top: d,
    right: u + C,
    bottom: d + p,
    left: u,
    x: u,
    y: d
  };
}
function qe(e) {
  var t = e9(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function jo(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Je(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function T5(e) {
  return F2(e).getComputedStyle(e);
}
function Xw(e) {
  return ["table", "td", "th"].indexOf(b5(e)) >= 0;
}
function a6(e) {
  return ((y6(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function h3(e) {
  return b5(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Je(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    a6(e)
  );
}
function Nt(e) {
  return !G2(e) || // https://github.com/popperjs/popper-core/issues/837
  T5(e).position === "fixed" ? null : e.offsetParent;
}
function e_(e) {
  var t = /firefox/i.test(I4()), r = /Trident/i.test(I4());
  if (r && G2(e)) {
    var n = T5(e);
    if (n.position === "fixed")
      return null;
  }
  var a = h3(e);
  for (Je(a) && (a = a.host); G2(a) && ["html", "body"].indexOf(b5(a)) < 0; ) {
    var i = T5(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function L8(e) {
  for (var t = F2(e), r = Nt(e); r && Xw(r) && T5(r).position === "static"; )
    r = Nt(r);
  return r && (b5(r) === "html" || b5(r) === "body" && T5(r).position === "static") ? t : r || e_(e) || t;
}
function Qe(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function D9(e, t, r) {
  return C6(e, b7(t, r));
}
function t_(e, t, r) {
  var n = D9(e, t, r);
  return n > r ? r : n;
}
function Vo() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ao(e) {
  return Object.assign({}, Vo(), e);
}
function Eo(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var a_ = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Ao(typeof t != "number" ? t : Eo(t, k8));
};
function n_(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, l = m5(r.placement), c = Qe(l), u = [A2, z2].indexOf(l) >= 0, d = u ? "height" : "width";
  if (!(!i || !o)) {
    var C = a_(a.padding, r), p = qe(i), h = c === "y" ? V2 : A2, f = c === "y" ? K2 : z2, g = r.rects.reference[d] + r.rects.reference[c] - o[c] - r.rects.popper[d], m = o[c] - r.rects.reference[c], v = L8(i), b = v ? c === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, w = g / 2 - m / 2, M = C[h], y = b - p[d] - C[f], _ = b / 2 - p[d] / 2 + w, S = D9(M, _, y), j = c;
    r.modifiersData[n] = (t = {}, t[j] = S, t.centerOffset = S - _, t);
  }
}
function r_(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || jo(t.elements.popper, a) && (t.elements.arrow = a));
}
const i_ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: n_,
  effect: r_,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function t9(e) {
  return e.split("-")[1];
}
var o_ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function s_(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: X6(r * a) / a || 0,
    y: X6(n * a) / a || 0
  };
}
function Rt(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, C = e.isFixed, p = o.x, h = p === void 0 ? 0 : p, f = o.y, g = f === void 0 ? 0 : f, m = typeof d == "function" ? d({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = m.x, g = m.y;
  var v = o.hasOwnProperty("x"), b = o.hasOwnProperty("y"), w = A2, M = V2, y = window;
  if (u) {
    var _ = L8(r), S = "clientHeight", j = "clientWidth";
    if (_ === F2(r) && (_ = a6(r), T5(_).position !== "static" && l === "absolute" && (S = "scrollHeight", j = "scrollWidth")), _ = _, a === V2 || (a === A2 || a === z2) && i === X9) {
      M = K2;
      var V = C && _ === y && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[S]
      );
      g -= V - n.height, g *= c ? 1 : -1;
    }
    if (a === A2 || (a === V2 || a === K2) && i === X9) {
      w = z2;
      var P = C && _ === y && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[j]
      );
      h -= P - n.width, h *= c ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: l
  }, u && o_), R = d === !0 ? s_({
    x: h,
    y: g
  }, F2(r)) : {
    x: h,
    y: g
  };
  if (h = R.x, g = R.y, c) {
    var z;
    return Object.assign({}, A, (z = {}, z[M] = b ? "0" : "", z[w] = v ? "0" : "", z.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", z));
  }
  return Object.assign({}, A, (t = {}, t[M] = b ? g + "px" : "", t[w] = v ? h + "px" : "", t.transform = "", t));
}
function l_(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, l = r.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: m5(t.placement),
    variation: t9(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Rt(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Rt(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const c_ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: l_,
  data: {}
};
var F8 = {
  passive: !0
};
function u_(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, l = o === void 0 ? !0 : o, c = F2(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(d) {
    d.addEventListener("scroll", r.update, F8);
  }), l && c.addEventListener("resize", r.update, F8), function() {
    i && u.forEach(function(d) {
      d.removeEventListener("scroll", r.update, F8);
    }), l && c.removeEventListener("resize", r.update, F8);
  };
}
const d_ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: u_,
  data: {}
};
var C_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Y8(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return C_[t];
  });
}
var p_ = {
  start: "end",
  end: "start"
};
function Ft(e) {
  return e.replace(/start|end/g, function(t) {
    return p_[t];
  });
}
function Xe(e) {
  var t = F2(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function e0(e) {
  return e9(a6(e)).left + Xe(e).scrollLeft;
}
function h_(e, t) {
  var r = F2(e), n = a6(e), a = r.visualViewport, i = n.clientWidth, o = n.clientHeight, l = 0, c = 0;
  if (a) {
    i = a.width, o = a.height;
    var u = To();
    (u || !u && t === "fixed") && (l = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: l + e0(e),
    y: c
  };
}
function f_(e) {
  var t, r = a6(e), n = Xe(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = C6(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = C6(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), l = -n.scrollLeft + e0(e), c = -n.scrollTop;
  return T5(a || r).direction === "rtl" && (l += C6(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: l,
    y: c
  };
}
function t0(e) {
  var t = T5(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function Io(e) {
  return ["html", "body", "#document"].indexOf(b5(e)) >= 0 ? e.ownerDocument.body : G2(e) && t0(e) ? e : Io(h3(e));
}
function N9(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Io(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = F2(n), o = a ? [i].concat(i.visualViewport || [], t0(n) ? n : []) : n, l = t.concat(o);
  return a ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(N9(h3(o)))
  );
}
function D4(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function m_(e, t) {
  var r = e9(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ot(e, t, r) {
  return t === Ho ? D4(h_(e, r)) : y6(t) ? m_(t, r) : D4(f_(a6(e)));
}
function g_(e) {
  var t = N9(h3(e)), r = ["absolute", "fixed"].indexOf(T5(e).position) >= 0, n = r && G2(e) ? L8(e) : e;
  return y6(n) ? t.filter(function(a) {
    return y6(a) && jo(a, n) && b5(a) !== "body";
  }) : [];
}
function v_(e, t, r, n) {
  var a = t === "clippingParents" ? g_(e) : [].concat(t), i = [].concat(a, [r]), o = i[0], l = i.reduce(function(c, u) {
    var d = Ot(e, u, n);
    return c.top = C6(d.top, c.top), c.right = b7(d.right, c.right), c.bottom = b7(d.bottom, c.bottom), c.left = C6(d.left, c.left), c;
  }, Ot(e, o, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Do(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? m5(n) : null, i = n ? t9(n) : null, o = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, c;
  switch (a) {
    case V2:
      c = {
        x: o,
        y: t.y - r.height
      };
      break;
    case K2:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case z2:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case A2:
      c = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = a ? Qe(a) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (i) {
      case Q6:
        c[u] = c[u] - (t[d] / 2 - r[d] / 2);
        break;
      case X9:
        c[u] = c[u] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return c;
}
function e8(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, l = r.boundary, c = l === void 0 ? Rw : l, u = r.rootBoundary, d = u === void 0 ? Ho : u, C = r.elementContext, p = C === void 0 ? H9 : C, h = r.altBoundary, f = h === void 0 ? !1 : h, g = r.padding, m = g === void 0 ? 0 : g, v = Ao(typeof m != "number" ? m : Eo(m, k8)), b = p === H9 ? Fw : H9, w = e.rects.popper, M = e.elements[f ? b : p], y = v_(y6(M) ? M : M.contextElement || a6(e.elements.popper), c, d, o), _ = e9(e.elements.reference), S = Do({
    reference: _,
    element: w,
    strategy: "absolute",
    placement: a
  }), j = D4(Object.assign({}, w, S)), V = p === H9 ? j : _, P = {
    top: y.top - V.top + v.top,
    bottom: V.bottom - y.bottom + v.bottom,
    left: y.left - V.left + v.left,
    right: V.right - y.right + v.right
  }, A = e.modifiersData.offset;
  if (p === H9 && A) {
    var R = A[a];
    Object.keys(P).forEach(function(z) {
      var N = [z2, K2].indexOf(z) >= 0 ? 1 : -1, G = [V2, K2].indexOf(z) >= 0 ? "y" : "x";
      P[z] += R[G] * N;
    });
  }
  return P;
}
function b_(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, l = r.flipVariations, c = r.allowedAutoPlacements, u = c === void 0 ? Po : c, d = t9(n), C = d ? l ? Dt : Dt.filter(function(f) {
    return t9(f) === d;
  }) : k8, p = C.filter(function(f) {
    return u.indexOf(f) >= 0;
  });
  p.length === 0 && (p = C);
  var h = p.reduce(function(f, g) {
    return f[g] = e8(e, {
      placement: g,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[m5(g)], f;
  }, {});
  return Object.keys(h).sort(function(f, g) {
    return h[f] - h[g];
  });
}
function y_(e) {
  if (m5(e) === $e)
    return [];
  var t = Y8(e);
  return [Ft(e), t, Ft(t)];
}
function x_(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, l = o === void 0 ? !0 : o, c = r.fallbackPlacements, u = r.padding, d = r.boundary, C = r.rootBoundary, p = r.altBoundary, h = r.flipVariations, f = h === void 0 ? !0 : h, g = r.allowedAutoPlacements, m = t.options.placement, v = m5(m), b = v === m, w = c || (b || !f ? [Y8(m)] : y_(m)), M = [m].concat(w).reduce(function($, W) {
      return $.concat(m5(W) === $e ? b_(t, {
        placement: W,
        boundary: d,
        rootBoundary: C,
        padding: u,
        flipVariations: f,
        allowedAutoPlacements: g
      }) : W);
    }, []), y = t.rects.reference, _ = t.rects.popper, S = /* @__PURE__ */ new Map(), j = !0, V = M[0], P = 0; P < M.length; P++) {
      var A = M[P], R = m5(A), z = t9(A) === Q6, N = [V2, K2].indexOf(R) >= 0, G = N ? "width" : "height", U = e8(t, {
        placement: A,
        boundary: d,
        rootBoundary: C,
        altBoundary: p,
        padding: u
      }), Z = N ? z ? z2 : A2 : z ? K2 : V2;
      y[G] > _[G] && (Z = Y8(Z));
      var E = Y8(Z), F = [];
      if (i && F.push(U[R] <= 0), l && F.push(U[Z] <= 0, U[E] <= 0), F.every(function($) {
        return $;
      })) {
        V = A, j = !1;
        break;
      }
      S.set(A, F);
    }
    if (j)
      for (var I = f ? 3 : 1, T = function(W) {
        var i1 = M.find(function(r1) {
          var d1 = S.get(r1);
          if (d1)
            return d1.slice(0, W).every(function(m1) {
              return m1;
            });
        });
        if (i1)
          return V = i1, "break";
      }, B = I; B > 0; B--) {
        var D = T(B);
        if (D === "break")
          break;
      }
    t.placement !== V && (t.modifiersData[n]._skip = !0, t.placement = V, t.reset = !0);
  }
}
const w_ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: x_,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Bt(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Zt(e) {
  return [V2, z2, K2, A2].some(function(t) {
    return e[t] >= 0;
  });
}
function __(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = e8(t, {
    elementContext: "reference"
  }), l = e8(t, {
    altBoundary: !0
  }), c = Bt(o, n), u = Bt(l, a, i), d = Zt(c), C = Zt(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: C
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": C
  });
}
const M_ = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: __
};
function S_(e, t, r) {
  var n = m5(e), a = [A2, V2].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], l = i[1];
  return o = o || 0, l = (l || 0) * a, [A2, z2].indexOf(n) >= 0 ? {
    x: l,
    y: o
  } : {
    x: o,
    y: l
  };
}
function k_(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = Po.reduce(function(d, C) {
    return d[C] = S_(C, t.rects, i), d;
  }, {}), l = o[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
const L_ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: k_
};
function H_(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Do({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const P_ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: H_,
  data: {}
};
function T_(e) {
  return e === "x" ? "y" : "x";
}
function j_(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, l = o === void 0 ? !1 : o, c = r.boundary, u = r.rootBoundary, d = r.altBoundary, C = r.padding, p = r.tether, h = p === void 0 ? !0 : p, f = r.tetherOffset, g = f === void 0 ? 0 : f, m = e8(t, {
    boundary: c,
    rootBoundary: u,
    padding: C,
    altBoundary: d
  }), v = m5(t.placement), b = t9(t.placement), w = !b, M = Qe(v), y = T_(M), _ = t.modifiersData.popperOffsets, S = t.rects.reference, j = t.rects.popper, V = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, P = typeof V == "number" ? {
    mainAxis: V,
    altAxis: V
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, V), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var z, N = M === "y" ? V2 : A2, G = M === "y" ? K2 : z2, U = M === "y" ? "height" : "width", Z = _[M], E = Z + m[N], F = Z - m[G], I = h ? -j[U] / 2 : 0, T = b === Q6 ? S[U] : j[U], B = b === Q6 ? -j[U] : -S[U], D = t.elements.arrow, $ = h && D ? qe(D) : {
        width: 0,
        height: 0
      }, W = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Vo(), i1 = W[N], r1 = W[G], d1 = D9(0, S[U], $[U]), m1 = w ? S[U] / 2 - I - d1 - i1 - P.mainAxis : T - d1 - i1 - P.mainAxis, Q1 = w ? -S[U] / 2 + I + d1 + r1 + P.mainAxis : B + d1 + r1 + P.mainAxis, _1 = t.elements.arrow && L8(t.elements.arrow), p1 = _1 ? M === "y" ? _1.clientTop || 0 : _1.clientLeft || 0 : 0, T1 = (z = A == null ? void 0 : A[M]) != null ? z : 0, l1 = Z + m1 - T1 - p1, k1 = Z + Q1 - T1, r2 = D9(h ? b7(E, l1) : E, Z, h ? C6(F, k1) : F);
      _[M] = r2, R[M] = r2 - Z;
    }
    if (l) {
      var n5, n6 = M === "x" ? V2 : A2, H6 = M === "x" ? K2 : z2, _5 = _[y], P6 = y === "y" ? "height" : "width", T6 = _5 + m[n6], H8 = _5 - m[H6], m9 = [V2, A2].indexOf(v) !== -1, g9 = (n5 = A == null ? void 0 : A[y]) != null ? n5 : 0, v9 = m9 ? T6 : _5 - S[P6] - j[P6] - g9 + P.altAxis, I5 = m9 ? _5 + S[P6] + j[P6] - g9 - P.altAxis : H8, P8 = h && m9 ? t_(v9, _5, I5) : D9(h ? v9 : T6, _5, h ? I5 : H8);
      _[y] = P8, R[y] = P8 - _5;
    }
    t.modifiersData[n] = R;
  }
}
const V_ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: j_,
  requiresIfExists: ["offset"]
};
function A_(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function E_(e) {
  return e === F2(e) || !G2(e) ? Xe(e) : A_(e);
}
function I_(e) {
  var t = e.getBoundingClientRect(), r = X6(t.width) / e.offsetWidth || 1, n = X6(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function D_(e, t, r) {
  r === void 0 && (r = !1);
  var n = G2(t), a = G2(t) && I_(t), i = a6(t), o = e9(e, a, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((b5(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  t0(i)) && (l = E_(t)), G2(t) ? (c = e9(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = e0(i))), {
    x: o.left + l.scrollLeft - c.x,
    y: o.top + l.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function N_(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(l) {
      if (!r.has(l)) {
        var c = t.get(l);
        c && a(c);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function R_(e) {
  var t = N_(e);
  return $w.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function F_(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function O_(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Gt = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Kt() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function B_(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? Gt : a;
  return function(l, c, u) {
    u === void 0 && (u = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Gt, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, C = [], p = !1, h = {
      state: d,
      setOptions: function(v) {
        var b = typeof v == "function" ? v(d.options) : v;
        g(), d.options = Object.assign({}, i, d.options, b), d.scrollParents = {
          reference: y6(l) ? N9(l) : l.contextElement ? N9(l.contextElement) : [],
          popper: N9(c)
        };
        var w = R_(O_([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function(M) {
          return M.enabled;
        }), f(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var v = d.elements, b = v.reference, w = v.popper;
          if (Kt(b, w)) {
            d.rects = {
              reference: D_(b, L8(w), d.options.strategy === "fixed"),
              popper: qe(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(P) {
              return d.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var M = 0; M < d.orderedModifiers.length; M++) {
              if (d.reset === !0) {
                d.reset = !1, M = -1;
                continue;
              }
              var y = d.orderedModifiers[M], _ = y.fn, S = y.options, j = S === void 0 ? {} : S, V = y.name;
              typeof _ == "function" && (d = _({
                state: d,
                options: j,
                name: V,
                instance: h
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: F_(function() {
        return new Promise(function(m) {
          h.forceUpdate(), m(d);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!Kt(l, c))
      return h;
    h.setOptions(u).then(function(m) {
      !p && u.onFirstUpdate && u.onFirstUpdate(m);
    });
    function f() {
      d.orderedModifiers.forEach(function(m) {
        var v = m.name, b = m.options, w = b === void 0 ? {} : b, M = m.effect;
        if (typeof M == "function") {
          var y = M({
            state: d,
            name: v,
            instance: h,
            options: w
          }), _ = function() {
          };
          C.push(y || _);
        }
      });
    }
    function g() {
      C.forEach(function(m) {
        return m();
      }), C = [];
    }
    return h;
  };
}
var Z_ = [d_, P_, c_, Qw, L_, w_, V_, i_, M_], G_ = /* @__PURE__ */ B_({
  defaultModifiers: Z_
}), K_ = typeof Element < "u", z_ = typeof Map == "function", U_ = typeof Set == "function", Y_ = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function W8(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var r, n, a;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!W8(e[n], t[n]))
          return !1;
      return !0;
    }
    var i;
    if (z_ && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!t.has(n.value[0]))
          return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!W8(n.value[1], t.get(n.value[0])))
          return !1;
      return !0;
    }
    if (U_ && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!t.has(n.value[0]))
          return !1;
      return !0;
    }
    if (Y_ && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (e[n] !== t[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[n]))
        return !1;
    if (K_ && e instanceof Element)
      return !1;
    for (n = r; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !W8(e[a[n]], t[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var W_ = function(t, r) {
  try {
    return W8(t, r);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const $_ = /* @__PURE__ */ M7(W_);
var J_ = [], q_ = function(t, r, n) {
  n === void 0 && (n = {});
  var a = Y.useRef(null), i = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || J_
  }, o = Y.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), l = o[0], c = o[1], u = Y.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(h) {
        var f = h.state, g = Object.keys(f.elements);
        O9.flushSync(function() {
          c({
            styles: Et(g.map(function(m) {
              return [m, f.styles[m] || {}];
            })),
            attributes: Et(g.map(function(m) {
              return [m, f.attributes[m]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = Y.useMemo(function() {
    var p = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return $_(a.current, p) ? a.current || p : (a.current = p, p);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, u]), C = Y.useRef();
  return It(function() {
    C.current && C.current.setOptions(d);
  }, [d]), It(function() {
    if (!(t == null || r == null)) {
      var p = n.createPopper || G_, h = p(t, r, d);
      return C.current = h, function() {
        h.destroy(), C.current = null;
      };
    }
  }, [t, r, n.createPopper]), {
    state: C.current ? C.current.state : null,
    styles: l.styles,
    attributes: l.attributes,
    update: C.current ? C.current.update : null,
    forceUpdate: C.current ? C.current.forceUpdate : null
  };
}, Q_ = function() {
}, X_ = function() {
  return Promise.resolve(null);
}, eM = [];
function tM(e) {
  var t = e.placement, r = t === void 0 ? "bottom" : t, n = e.strategy, a = n === void 0 ? "absolute" : n, i = e.modifiers, o = i === void 0 ? eM : i, l = e.referenceElement, c = e.onFirstUpdate, u = e.innerRef, d = e.children, C = Y.useContext(Mo), p = Y.useState(null), h = p[0], f = p[1], g = Y.useState(null), m = g[0], v = g[1];
  Y.useEffect(function() {
    E4(u, h);
  }, [u, h]);
  var b = Y.useMemo(function() {
    return {
      placement: r,
      strategy: a,
      onFirstUpdate: c,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: m != null,
        options: {
          element: m
        }
      }])
    };
  }, [r, a, c, o, m]), w = q_(l || C, h, b), M = w.state, y = w.styles, _ = w.forceUpdate, S = w.update, j = Y.useMemo(function() {
    return {
      ref: f,
      style: y.popper,
      placement: M ? M.placement : r,
      hasPopperEscaped: M && M.modifiersData.hide ? M.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: M && M.modifiersData.hide ? M.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: y.arrow,
        ref: v
      },
      forceUpdate: _ || Q_,
      update: S || X_
    };
  }, [f, v, r, M, y, S, _]);
  return ko(d)(j);
}
var aM = process.env.NODE_ENV !== "production", No = function() {
};
if (aM) {
  var nM = function(t, r) {
    var n = arguments.length;
    r = new Array(n > 1 ? n - 1 : 0);
    for (var a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    var i = 0, o = "Warning: " + t.replace(/%s/g, function() {
      return r[i++];
    });
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  };
  No = function(e, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var a = 2; a < n; a++)
      r[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || nM.apply(null, [t].concat(r));
  };
}
var rM = No;
const iM = /* @__PURE__ */ M7(rM);
function oM(e) {
  var t = e.children, r = e.innerRef, n = Y.useContext(So), a = Y.useCallback(function(i) {
    E4(r, i), Lo(n, i);
  }, [r, n]);
  return Y.useEffect(function() {
    return function() {
      return E4(r, null);
    };
  }, []), Y.useEffect(function() {
    iM(!!n, "`Reference` should not be used outside of a `Manager` component.");
  }, [n]), ko(t)({
    ref: a
  });
}
function sM(e, t) {
  if (t1(2, arguments), R2(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var r = o1(e);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = H2(r, t.month)), t.date != null && r.setDate(L1(t.date)), t.hours != null && r.setHours(L1(t.hours)), t.minutes != null && r.setMinutes(L1(t.minutes)), t.seconds != null && r.setSeconds(L1(t.seconds)), t.milliseconds != null && r.setMilliseconds(L1(t.milliseconds)), r);
}
function zt(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function y7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zt(Object(r), !0).forEach(function(n) {
      k(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zt(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N4(e) {
  return N4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, N4(e);
}
function f2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ut(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ro(n.key), n);
  }
}
function m2(e, t, r) {
  return t && Ut(e.prototype, t), r && Ut(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function k(e, t, r) {
  return (t = Ro(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function a9() {
  return a9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a9.apply(this, arguments);
}
function g2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && R4(e, t);
}
function x7(e) {
  return x7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, x7(e);
}
function R4(e, t) {
  return R4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, R4(e, t);
}
function L(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function v2(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var r, n = x7(e);
    if (t) {
      var a = x7(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else
      r = n.apply(this, arguments);
    return function(i, o) {
      if (o && (typeof o == "object" || typeof o == "function"))
        return o;
      if (o !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return L(i);
    }(this, r);
  };
}
function t8(e) {
  return function(t) {
    if (Array.isArray(t))
      return Y3(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, r) {
    if (t) {
      if (typeof t == "string")
        return Y3(t, r);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
        return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return Y3(t, r);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Y3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Ro(e) {
  var t = function(r, n) {
    if (typeof r != "object" || r === null)
      return r;
    var a = r[Symbol.toPrimitive];
    if (a !== void 0) {
      var i = a.call(r, n || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(r);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Yt = function(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, Wt = function(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, lM = { p: Wt, P: function(e, t) {
  var r, n = e.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return Yt(e, t);
  switch (a) {
    case "P":
      r = t.dateTime({ width: "short" });
      break;
    case "PP":
      r = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = t.dateTime({ width: "long" });
      break;
    default:
      r = t.dateTime({ width: "full" });
  }
  return r.replace("{{date}}", Yt(a, t)).replace("{{time}}", Wt(i, t));
} }, R9 = 12, cM = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function W1(e) {
  var t = e ? typeof e == "string" || e instanceof String ? dw(e) : o1(e) : /* @__PURE__ */ new Date();
  return O5(t) ? t : null;
}
function O5(e, t) {
  return t = t || /* @__PURE__ */ new Date("1/1/1000"), $9(e) && !G5(e, t);
}
function t2(e, t, r) {
  if (r === "en")
    return St(e, t, { awareOfUnicodeTokens: !0 });
  var n = h6(r);
  return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && p6() && h6(p6()) && (n = h6(p6())), St(e, t, { locale: n || null, awareOfUnicodeTokens: !0 });
}
function r5(e, t) {
  var r = t.dateFormat, n = t.locale;
  return e && t2(e, Array.isArray(r) ? r[0] : r, n) || "";
}
function $t(e, t) {
  var r = t.hour, n = r === void 0 ? 0 : r, a = t.minute, i = a === void 0 ? 0 : a, o = t.second;
  return U8(z8(ix(e, o === void 0 ? 0 : o), i), n);
}
function g5(e, t, r) {
  var n = h6(t || p6());
  return fo(e, { locale: n, weekStartsOn: r });
}
function Y5(e) {
  return mo(e);
}
function T9(e) {
  return go(e);
}
function Jt(e) {
  return P4(e);
}
function qt() {
  return f5(W1());
}
function K5(e, t) {
  return e && t ? px(e, t) : !e && !t;
}
function $2(e, t) {
  return e && t ? Cx(e, t) : !e && !t;
}
function w7(e, t) {
  return e && t ? hx(e, t) : !e && !t;
}
function $1(e, t) {
  return e && t ? dx(e, t) : !e && !t;
}
function c6(e, t) {
  return e && t ? ux(e, t) : !e && !t;
}
function $8(e, t, r) {
  var n, a = f5(t), i = T4(r);
  try {
    n = Q9(e, { start: a, end: i });
  } catch {
    n = !1;
  }
  return n;
}
function p6() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function h6(e) {
  if (typeof e == "string") {
    var t = typeof window < "u" ? window : globalThis;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function a0(e, t) {
  return t2(H2(W1(), e), "LLLL", t);
}
function Fo(e, t) {
  return t2(H2(W1(), e), "LLL", t);
}
function f3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, i = t.excludeDateIntervals, o = t.includeDates, l = t.includeDateIntervals, c = t.filterDate;
  return m3(e, { minDate: r, maxDate: n }) || a && a.some(function(u) {
    return $1(e, u);
  }) || i && i.some(function(u) {
    var d = u.start, C = u.end;
    return Q9(e, { start: d, end: C });
  }) || o && !o.some(function(u) {
    return $1(e, u);
  }) || l && !l.some(function(u) {
    var d = u.start, C = u.end;
    return Q9(e, { start: d, end: C });
  }) || c && !c(W1(e)) || !1;
}
function n0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.excludeDates, n = t.excludeDateIntervals;
  return n && n.length > 0 ? n.some(function(a) {
    var i = a.start, o = a.end;
    return Q9(e, { start: i, end: o });
  }) : r && r.some(function(a) {
    return $1(e, a);
  }) || !1;
}
function Oo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return m3(e, { minDate: mo(r), maxDate: lx(n) }) || a && a.some(function(l) {
    return $2(e, l);
  }) || i && !i.some(function(l) {
    return $2(e, l);
  }) || o && !o(W1(e)) || !1;
}
function W3(e, t, r, n) {
  var a = H1(e), i = _2(e), o = H1(t), l = _2(t), c = H1(n);
  return a === o && a === c ? i <= r && r <= l : a < o ? c === a && i <= r || c === o && l >= r || c < o && c > a : void 0;
}
function uM(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return m3(e, { minDate: r, maxDate: n }) || a && a.some(function(l) {
    return w7(e, l);
  }) || i && !i.some(function(l) {
    return w7(e, l);
  }) || o && !o(W1(e)) || !1;
}
function $3(e, t, r) {
  if (!$9(t) || !$9(r))
    return !1;
  var n = H1(t), a = H1(r);
  return n <= e && a >= e;
}
function Bo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate, l = new Date(e, 0, 1);
  return m3(l, { minDate: go(r), maxDate: cx(n) }) || a && a.some(function(c) {
    return K5(l, c);
  }) || i && !i.some(function(c) {
    return K5(l, c);
  }) || o && !o(W1(l)) || !1;
}
function J3(e, t, r, n) {
  var a = H1(e), i = R6(e), o = H1(t), l = R6(t), c = H1(n);
  return a === o && a === c ? i <= r && r <= l : a < o ? c === a && i <= r || c === o && l >= r || c < o && c > a : void 0;
}
function m3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.maxDate;
  return r && q9(e, r) < 0 || n && q9(e, n) > 0;
}
function Qt(e, t) {
  return t.some(function(r) {
    return h5(r) === h5(e) && p5(r) === p5(e);
  });
}
function Xt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.excludeTimes, n = t.includeTimes, a = t.filterTime;
  return r && Qt(e, r) || n && !Qt(e, n) || a && !a(e) || !1;
}
function ea(e, t) {
  var r = t.minTime, n = t.maxTime;
  if (!r || !n)
    throw new Error("Both minTime and maxTime props required");
  var a, i = W1(), o = U8(z8(i, p5(e)), h5(e)), l = U8(z8(i, p5(r)), h5(r)), c = U8(z8(i, p5(n)), h5(n));
  try {
    a = !Q9(o, { start: l, end: c });
  } catch {
    a = !1;
  }
  return a;
}
function ta(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = q6(e, 1);
  return r && f7(r, a) > 0 || n && n.every(function(i) {
    return f7(i, a) > 0;
  }) || !1;
}
function aa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = e5(e, 1);
  return r && f7(a, r) > 0 || n && n.every(function(i) {
    return f7(a, i) > 0;
  }) || !1;
}
function na(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = J9(e, 1);
  return r && m7(r, a) > 0 || n && n.every(function(i) {
    return m7(i, a) > 0;
  }) || !1;
}
function ra(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = J6(e, 1);
  return r && m7(a, r) > 0 || n && n.every(function(i) {
    return m7(a, i) > 0;
  }) || !1;
}
function Zo(e) {
  var t = e.minDate, r = e.includeDates;
  if (r && t) {
    var n = r.filter(function(a) {
      return q9(a, t) >= 0;
    });
    return Pt(n);
  }
  return r ? Pt(r) : t;
}
function Go(e) {
  var t = e.maxDate, r = e.includeDates;
  if (r && t) {
    var n = r.filter(function(a) {
      return q9(a, t) <= 0;
    });
    return Tt(n);
  }
  return r ? Tt(r) : t;
}
function ia() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", r = /* @__PURE__ */ new Map(), n = 0, a = e.length; n < a; n++) {
    var i = e[n];
    if (C3(i)) {
      var o = t2(i, "MM.dd.yyyy"), l = r.get(o) || [];
      l.includes(t) || (l.push(t), r.set(o, l));
    } else if (N4(i) === "object") {
      var c = Object.keys(i), u = c[0], d = i[c[0]];
      if (typeof u == "string" && d.constructor === Array)
        for (var C = 0, p = d.length; C < p; C++) {
          var h = t2(d[C], "MM.dd.yyyy"), f = r.get(h) || [];
          f.includes(u) || (f.push(u), r.set(h, f));
        }
    }
  }
  return r;
}
function dM() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    var a = n.date, i = n.holidayName;
    if (C3(a)) {
      var o = t2(a, "MM.dd.yyyy"), l = r.get(o) || {};
      if (!("className" in l) || l.className !== t || (c = l.holidayNames, u = [i], c.length !== u.length || !c.every(function(C, p) {
        return C === u[p];
      }))) {
        var c, u;
        l.className = t;
        var d = l.holidayNames;
        l.holidayNames = d ? [].concat(t8(d), [i]) : [i], r.set(o, l);
      }
    }
  }), r;
}
function CM(e, t, r, n, a) {
  for (var i = a.length, o = [], l = 0; l < i; l++) {
    var c = L4(qy(e, h5(a[l])), p5(a[l])), u = L4(e, (r + 1) * n);
    J5(c, t) && G5(c, u) && o.push(a[l]);
  }
  return o;
}
function oa(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function F6(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : R9, r = Math.ceil(H1(e) / t) * t;
  return { startPeriod: r - (t - 1), endPeriod: r };
}
function sa(e) {
  var t = e.getSeconds(), r = e.getMilliseconds();
  return o1(e.getTime() - 1e3 * t - r);
}
function pM(e, t, r, n) {
  for (var a = [], i = 0; i < 2 * t + 1; i++) {
    var o = e + t - i, l = !0;
    r && (l = H1(r) <= o), n && l && (l = H1(n) >= o), l && a.push(o);
  }
  return a;
}
var hM = p3(function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    f2(this, r), k(L(a = t.call(this, n)), "renderOptions", function() {
      var c = a.props.year, u = a.state.yearsList.map(function(p) {
        return x.createElement("div", { className: c === p ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: p, onClick: a.onChange.bind(L(a), p), "aria-selected": c === p ? "true" : void 0 }, c === p ? x.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", p);
      }), d = a.props.minDate ? H1(a.props.minDate) : null, C = a.props.maxDate ? H1(a.props.maxDate) : null;
      return C && a.state.yearsList.find(function(p) {
        return p === C;
      }) || u.unshift(x.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: a.incrementYears }, x.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), d && a.state.yearsList.find(function(p) {
        return p === d;
      }) || u.push(x.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: a.decrementYears }, x.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), u;
    }), k(L(a), "onChange", function(c) {
      a.props.onChange(c);
    }), k(L(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), k(L(a), "shiftYears", function(c) {
      var u = a.state.yearsList.map(function(d) {
        return d + c;
      });
      a.setState({ yearsList: u });
    }), k(L(a), "incrementYears", function() {
      return a.shiftYears(1);
    }), k(L(a), "decrementYears", function() {
      return a.shiftYears(-1);
    });
    var i = n.yearDropdownItemNumber, o = n.scrollableYearDropdown, l = i || (o ? 10 : 5);
    return a.state = { yearsList: pM(a.props.year, l, a.props.minDate, a.props.maxDate) }, a.dropdownRef = u6(), a;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    var n = this.dropdownRef.current;
    if (n) {
      var a = n.children ? Array.from(n.children) : null, i = a ? a.find(function(o) {
        return o.ariaSelected;
      }) : null;
      n.scrollTop = i ? i.offsetTop + (i.clientHeight - n.clientHeight) / 2 : (n.scrollHeight - n.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var n = y2({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return x.createElement("div", { className: n, ref: this.dropdownRef }, this.renderOptions());
  } }]), r;
}()), fM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(L(n), "renderSelectOptions", function() {
      for (var l = n.props.minDate ? H1(n.props.minDate) : 1900, c = n.props.maxDate ? H1(n.props.maxDate) : 2100, u = [], d = l; d <= c; d++)
        u.push(x.createElement("option", { key: d, value: d }, d));
      return u;
    }), k(L(n), "onSelectChange", function(l) {
      n.onChange(l.target.value);
    }), k(L(n), "renderSelectMode", function() {
      return x.createElement("select", { value: n.props.year, className: "react-datepicker__year-select", onChange: n.onSelectChange }, n.renderSelectOptions());
    }), k(L(n), "renderReadView", function(l) {
      return x.createElement("div", { key: "read", style: { visibility: l ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(c) {
        return n.toggleDropdown(c);
      } }, x.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), x.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, n.props.year));
    }), k(L(n), "renderDropdown", function() {
      return x.createElement(hM, { key: "dropdown", year: n.props.year, onChange: n.onChange, onCancel: n.toggleDropdown, minDate: n.props.minDate, maxDate: n.props.maxDate, scrollableYearDropdown: n.props.scrollableYearDropdown, yearDropdownItemNumber: n.props.yearDropdownItemNumber });
    }), k(L(n), "renderScrollMode", function() {
      var l = n.state.dropdownVisible, c = [n.renderReadView(!l)];
      return l && c.unshift(n.renderDropdown()), c;
    }), k(L(n), "onChange", function(l) {
      n.toggleDropdown(), l !== n.props.year && n.props.onChange(l);
    }), k(L(n), "toggleDropdown", function(l) {
      n.setState({ dropdownVisible: !n.state.dropdownVisible }, function() {
        n.props.adjustDateOnChange && n.handleYearChange(n.props.date, l);
      });
    }), k(L(n), "handleYearChange", function(l, c) {
      n.onSelect(l, c), n.setOpen();
    }), k(L(n), "onSelect", function(l, c) {
      n.props.onSelect && n.props.onSelect(l, c);
    }), k(L(n), "setOpen", function() {
      n.props.setOpen && n.props.setOpen(!0);
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    var n;
    switch (this.props.dropdownMode) {
      case "scroll":
        n = this.renderScrollMode();
        break;
      case "select":
        n = this.renderSelectMode();
    }
    return x.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, n);
  } }]), r;
}(), mM = p3(function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "isSelectedMonth", function(l) {
      return n.props.month === l;
    }), k(L(n), "renderOptions", function() {
      return n.props.monthNames.map(function(l, c) {
        return x.createElement("div", { className: n.isSelectedMonth(c) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: l, onClick: n.onChange.bind(L(n), c), "aria-selected": n.isSelectedMonth(c) ? "true" : void 0 }, n.isSelectedMonth(c) ? x.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", l);
      });
    }), k(L(n), "onChange", function(l) {
      return n.props.onChange(l);
    }), k(L(n), "handleClickOutside", function() {
      return n.props.onCancel();
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    return x.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), r;
}()), gM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(L(n), "renderSelectOptions", function(l) {
      return l.map(function(c, u) {
        return x.createElement("option", { key: u, value: u }, c);
      });
    }), k(L(n), "renderSelectMode", function(l) {
      return x.createElement("select", { value: n.props.month, className: "react-datepicker__month-select", onChange: function(c) {
        return n.onChange(c.target.value);
      } }, n.renderSelectOptions(l));
    }), k(L(n), "renderReadView", function(l, c) {
      return x.createElement("div", { key: "read", style: { visibility: l ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: n.toggleDropdown }, x.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), x.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, c[n.props.month]));
    }), k(L(n), "renderDropdown", function(l) {
      return x.createElement(mM, { key: "dropdown", month: n.props.month, monthNames: l, onChange: n.onChange, onCancel: n.toggleDropdown });
    }), k(L(n), "renderScrollMode", function(l) {
      var c = n.state.dropdownVisible, u = [n.renderReadView(!c, l)];
      return c && u.unshift(n.renderDropdown(l)), u;
    }), k(L(n), "onChange", function(l) {
      n.toggleDropdown(), l !== n.props.month && n.props.onChange(l);
    }), k(L(n), "toggleDropdown", function() {
      return n.setState({ dropdownVisible: !n.state.dropdownVisible });
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    var n, a = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return Fo(o, a.props.locale);
    } : function(o) {
      return a0(o, a.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        n = this.renderScrollMode(i);
        break;
      case "select":
        n = this.renderSelectMode(i);
    }
    return x.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, n);
  } }]), r;
}();
function vM(e, t) {
  for (var r = [], n = Y5(e), a = Y5(t); !J5(n, a); )
    r.push(W1(n)), n = e5(n, 1);
  return r;
}
var bM = p3(function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "renderOptions", function() {
      return a.state.monthYearsList.map(function(i) {
        var o = H4(i), l = K5(a.props.date, i) && $2(a.props.date, i);
        return x.createElement("div", { className: l ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: a.onChange.bind(L(a), o), "aria-selected": l ? "true" : void 0 }, l ? x.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", t2(i, a.props.dateFormat, a.props.locale));
      });
    }), k(L(a), "onChange", function(i) {
      return a.props.onChange(i);
    }), k(L(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), a.state = { monthYearsList: vM(a.props.minDate, a.props.maxDate) }, a;
  }
  return m2(r, [{ key: "render", value: function() {
    var n = y2({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return x.createElement("div", { className: n }, this.renderOptions());
  } }]), r;
}()), yM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(L(n), "renderSelectOptions", function() {
      for (var l = Y5(n.props.minDate), c = Y5(n.props.maxDate), u = []; !J5(l, c); ) {
        var d = H4(l);
        u.push(x.createElement("option", { key: d, value: d }, t2(l, n.props.dateFormat, n.props.locale))), l = e5(l, 1);
      }
      return u;
    }), k(L(n), "onSelectChange", function(l) {
      n.onChange(l.target.value);
    }), k(L(n), "renderSelectMode", function() {
      return x.createElement("select", { value: H4(Y5(n.props.date)), className: "react-datepicker__month-year-select", onChange: n.onSelectChange }, n.renderSelectOptions());
    }), k(L(n), "renderReadView", function(l) {
      var c = t2(n.props.date, n.props.dateFormat, n.props.locale);
      return x.createElement("div", { key: "read", style: { visibility: l ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(u) {
        return n.toggleDropdown(u);
      } }, x.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), x.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, c));
    }), k(L(n), "renderDropdown", function() {
      return x.createElement(bM, { key: "dropdown", date: n.props.date, dateFormat: n.props.dateFormat, onChange: n.onChange, onCancel: n.toggleDropdown, minDate: n.props.minDate, maxDate: n.props.maxDate, scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown, locale: n.props.locale });
    }), k(L(n), "renderScrollMode", function() {
      var l = n.state.dropdownVisible, c = [n.renderReadView(!l)];
      return l && c.unshift(n.renderDropdown()), c;
    }), k(L(n), "onChange", function(l) {
      n.toggleDropdown();
      var c = W1(parseInt(l));
      K5(n.props.date, c) && $2(n.props.date, c) || n.props.onChange(c);
    }), k(L(n), "toggleDropdown", function() {
      return n.setState({ dropdownVisible: !n.state.dropdownVisible });
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    var n;
    switch (this.props.dropdownMode) {
      case "scroll":
        n = this.renderScrollMode();
        break;
      case "select":
        n = this.renderSelectMode();
    }
    return x.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, n);
  } }]), r;
}(), xM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "dayEl", x.createRef()), k(L(n), "handleClick", function(l) {
      !n.isDisabled() && n.props.onClick && n.props.onClick(l);
    }), k(L(n), "handleMouseEnter", function(l) {
      !n.isDisabled() && n.props.onMouseEnter && n.props.onMouseEnter(l);
    }), k(L(n), "handleOnKeyDown", function(l) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), n.props.handleOnKeyDown(l);
    }), k(L(n), "isSameDay", function(l) {
      return $1(n.props.day, l);
    }), k(L(n), "isKeyboardSelected", function() {
      return !n.props.disabledKeyboardNavigation && !(n.isSameDay(n.props.selected) || n.isSameWeek(n.props.selected)) && (n.isSameDay(n.props.preSelection) || n.isSameWeek(n.props.preSelection));
    }), k(L(n), "isDisabled", function() {
      return f3(n.props.day, n.props);
    }), k(L(n), "isExcluded", function() {
      return n0(n.props.day, n.props);
    }), k(L(n), "isStartOfWeek", function() {
      return $1(n.props.day, g5(n.props.day, n.props.locale, n.props.calendarStartDay));
    }), k(L(n), "isSameWeek", function(l) {
      return n.props.showWeekPicker && $1(l, g5(n.props.day, n.props.locale, n.props.calendarStartDay));
    }), k(L(n), "getHighLightedClass", function() {
      var l = n.props, c = l.day, u = l.highlightDates;
      if (!u)
        return !1;
      var d = t2(c, "MM.dd.yyyy");
      return u.get(d);
    }), k(L(n), "getHolidaysClass", function() {
      var l = n.props, c = l.day, u = l.holidays;
      if (!u)
        return !1;
      var d = t2(c, "MM.dd.yyyy");
      return u.has(d) ? [u.get(d).className] : void 0;
    }), k(L(n), "isInRange", function() {
      var l = n.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && $8(c, u, d);
    }), k(L(n), "isInSelectingRange", function() {
      var l, c = n.props, u = c.day, d = c.selectsStart, C = c.selectsEnd, p = c.selectsRange, h = c.selectsDisabledDaysInRange, f = c.startDate, g = c.endDate, m = (l = n.props.selectingDate) !== null && l !== void 0 ? l : n.props.preSelection;
      return !(!(d || C || p) || !m || !h && n.isDisabled()) && (d && g && (G5(m, g) || c6(m, g)) ? $8(u, m, g) : (C && f && (J5(m, f) || c6(m, f)) || !(!p || !f || g || !J5(m, f) && !c6(m, f))) && $8(u, f, m));
    }), k(L(n), "isSelectingRangeStart", function() {
      var l;
      if (!n.isInSelectingRange())
        return !1;
      var c = n.props, u = c.day, d = c.startDate, C = c.selectsStart, p = (l = n.props.selectingDate) !== null && l !== void 0 ? l : n.props.preSelection;
      return $1(u, C ? p : d);
    }), k(L(n), "isSelectingRangeEnd", function() {
      var l;
      if (!n.isInSelectingRange())
        return !1;
      var c = n.props, u = c.day, d = c.endDate, C = c.selectsEnd, p = c.selectsRange, h = (l = n.props.selectingDate) !== null && l !== void 0 ? l : n.props.preSelection;
      return $1(u, C || p ? h : d);
    }), k(L(n), "isRangeStart", function() {
      var l = n.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && $1(u, c);
    }), k(L(n), "isRangeEnd", function() {
      var l = n.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && $1(d, c);
    }), k(L(n), "isWeekend", function() {
      var l = ex(n.props.day);
      return l === 0 || l === 6;
    }), k(L(n), "isAfterMonth", function() {
      return n.props.month !== void 0 && (n.props.month + 1) % 12 === _2(n.props.day);
    }), k(L(n), "isBeforeMonth", function() {
      return n.props.month !== void 0 && (_2(n.props.day) + 1) % 12 === n.props.month;
    }), k(L(n), "isCurrentDay", function() {
      return n.isSameDay(W1());
    }), k(L(n), "isSelected", function() {
      return n.isSameDay(n.props.selected) || n.isSameWeek(n.props.selected);
    }), k(L(n), "getClassNames", function(l) {
      var c, u = n.props.dayClassName ? n.props.dayClassName(l) : void 0;
      return y2("react-datepicker__day", u, "react-datepicker__day--" + t2(n.props.day, "ddd", c), { "react-datepicker__day--disabled": n.isDisabled(), "react-datepicker__day--excluded": n.isExcluded(), "react-datepicker__day--selected": n.isSelected(), "react-datepicker__day--keyboard-selected": n.isKeyboardSelected(), "react-datepicker__day--range-start": n.isRangeStart(), "react-datepicker__day--range-end": n.isRangeEnd(), "react-datepicker__day--in-range": n.isInRange(), "react-datepicker__day--in-selecting-range": n.isInSelectingRange(), "react-datepicker__day--selecting-range-start": n.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": n.isSelectingRangeEnd(), "react-datepicker__day--today": n.isCurrentDay(), "react-datepicker__day--weekend": n.isWeekend(), "react-datepicker__day--outside-month": n.isAfterMonth() || n.isBeforeMonth() }, n.getHighLightedClass("react-datepicker__day--highlighted"), n.getHolidaysClass());
    }), k(L(n), "getAriaLabel", function() {
      var l = n.props, c = l.day, u = l.ariaLabelPrefixWhenEnabled, d = u === void 0 ? "Choose" : u, C = l.ariaLabelPrefixWhenDisabled, p = C === void 0 ? "Not available" : C, h = n.isDisabled() || n.isExcluded() ? p : d;
      return "".concat(h, " ").concat(t2(c, "PPPP", n.props.locale));
    }), k(L(n), "getTitle", function() {
      var l = n.props, c = l.day, u = l.holidays, d = u === void 0 ? /* @__PURE__ */ new Map() : u, C = t2(c, "MM.dd.yyyy");
      return d.has(C) && d.get(C).holidayNames.length > 0 ? d.get(C).holidayNames.join(", ") : "";
    }), k(L(n), "getTabIndex", function(l, c) {
      var u = l || n.props.selected, d = c || n.props.preSelection;
      return (!n.props.showWeekPicker || !n.props.showWeekNumber && n.isStartOfWeek()) && (n.isKeyboardSelected() || n.isSameDay(u) && $1(d, u)) ? 0 : -1;
    }), k(L(n), "handleFocusDay", function() {
      var l, c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = !1;
      n.getTabIndex() === 0 && !c.isInputFocused && n.isSameDay(n.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (u = !0), n.props.inline && !n.props.shouldFocusDayInline && (u = !1), n.props.containerRef && n.props.containerRef.current && n.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (u = !0), n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() && (u = !1), n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() && (u = !1)), u && ((l = n.dayEl.current) === null || l === void 0 || l.focus({ preventScroll: !0 }));
    }), k(L(n), "renderDayContents", function() {
      return n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() || n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() ? null : n.props.renderDayContents ? n.props.renderDayContents(Ht(n.props.day), n.props.day) : Ht(n.props.day);
    }), k(L(n), "render", function() {
      return x.createElement("div", { ref: n.dayEl, className: n.getClassNames(n.props.day), onKeyDown: n.handleOnKeyDown, onClick: n.handleClick, onMouseEnter: n.handleMouseEnter, tabIndex: n.getTabIndex(), "aria-label": n.getAriaLabel(), role: "option", title: n.getTitle(), "aria-disabled": n.isDisabled(), "aria-current": n.isCurrentDay() ? "date" : void 0, "aria-selected": n.isSelected() || n.isInRange() }, n.renderDayContents(), n.getTitle() !== "" && x.createElement("span", { className: "holiday-overlay" }, n.getTitle()));
    }), n;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(n) {
    this.handleFocusDay(n);
  } }]), r;
}(), wM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "weekNumberEl", x.createRef()), k(L(n), "handleClick", function(l) {
      n.props.onClick && n.props.onClick(l);
    }), k(L(n), "handleOnKeyDown", function(l) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), n.props.handleOnKeyDown(l);
    }), k(L(n), "isKeyboardSelected", function() {
      return !n.props.disabledKeyboardNavigation && !$1(n.props.date, n.props.selected) && $1(n.props.date, n.props.preSelection);
    }), k(L(n), "getTabIndex", function() {
      return n.props.showWeekPicker && n.props.showWeekNumber && (n.isKeyboardSelected() || $1(n.props.date, n.props.selected) && $1(n.props.preSelection, n.props.selected)) ? 0 : -1;
    }), k(L(n), "handleFocusWeekNumber", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      n.getTabIndex() === 0 && !l.isInputFocused && $1(n.props.date, n.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (c = !0), n.props.inline && !n.props.shouldFocusDayInline && (c = !1), n.props.containerRef && n.props.containerRef.current && n.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (c = !0)), c && n.weekNumberEl.current && n.weekNumberEl.current.focus({ preventScroll: !0 });
    }), n;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(n) {
    this.handleFocusWeekNumber(n);
  } }, { key: "render", value: function() {
    var n = this.props, a = n.weekNumber, i = n.ariaLabelPrefix, o = i === void 0 ? "week " : i, l = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!n.onClick, "react-datepicker__week-number--selected": $1(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return x.createElement("div", { ref: this.weekNumberEl, className: y2(l), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, a);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), r;
}(), _M = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "handleDayClick", function(l, c) {
      n.props.onDayClick && n.props.onDayClick(l, c);
    }), k(L(n), "handleDayMouseEnter", function(l) {
      n.props.onDayMouseEnter && n.props.onDayMouseEnter(l);
    }), k(L(n), "handleWeekClick", function(l, c, u) {
      if (typeof n.props.onWeekSelect == "function" && n.props.onWeekSelect(l, c, u), n.props.showWeekPicker) {
        var d = g5(l, n.props.locale, n.props.calendarStartDay);
        n.handleDayClick(d, u);
      }
      n.props.shouldCloseOnSelect && n.props.setOpen(!1);
    }), k(L(n), "formatWeekNumber", function(l) {
      return n.props.formatWeekNumber ? n.props.formatWeekNumber(l) : function(c, u) {
        var d = p6() && h6(p6());
        return rx(c, d ? { locale: d } : null);
      }(l);
    }), k(L(n), "renderDays", function() {
      var l = g5(n.props.day, n.props.locale, n.props.calendarStartDay), c = [], u = n.formatWeekNumber(l);
      if (n.props.showWeekNumber) {
        var d = n.props.onWeekSelect || n.props.showWeekPicker ? n.handleWeekClick.bind(L(n), l, u) : void 0;
        c.push(x.createElement(wM, { key: "W", weekNumber: u, date: l, onClick: d, selected: n.props.selected, preSelection: n.props.preSelection, ariaLabelPrefix: n.props.ariaLabelPrefix, showWeekPicker: n.props.showWeekPicker, showWeekNumber: n.props.showWeekNumber, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, handleOnKeyDown: n.props.handleOnKeyDown, isInputFocused: n.props.isInputFocused, containerRef: n.props.containerRef }));
      }
      return c.concat([0, 1, 2, 3, 4, 5, 6].map(function(C) {
        var p = f9(l, C);
        return x.createElement(xM, { ariaLabelPrefixWhenEnabled: n.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: n.props.disabledDayAriaLabelPrefix, key: p.valueOf(), day: p, month: n.props.month, onClick: n.handleDayClick.bind(L(n), p), onMouseEnter: n.handleDayMouseEnter.bind(L(n), p), minDate: n.props.minDate, maxDate: n.props.maxDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, highlightDates: n.props.highlightDates, holidays: n.props.holidays, selectingDate: n.props.selectingDate, filterDate: n.props.filterDate, preSelection: n.props.preSelection, selected: n.props.selected, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, showWeekPicker: n.props.showWeekPicker, showWeekNumber: n.props.showWeekNumber, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, startDate: n.props.startDate, endDate: n.props.endDate, dayClassName: n.props.dayClassName, renderDayContents: n.props.renderDayContents, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, handleOnKeyDown: n.props.handleOnKeyDown, isInputFocused: n.props.isInputFocused, containerRef: n.props.containerRef, inline: n.props.inline, shouldFocusDayInline: n.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: n.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: n.props.monthShowsDuplicateDaysStart, locale: n.props.locale });
      }));
    }), k(L(n), "startOfWeek", function() {
      return g5(n.props.day, n.props.locale, n.props.calendarStartDay);
    }), k(L(n), "isKeyboardSelected", function() {
      return !n.props.disabledKeyboardNavigation && !$1(n.startOfWeek(), n.props.selected) && $1(n.startOfWeek(), n.props.preSelection);
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    var n = { "react-datepicker__week": !0, "react-datepicker__week--selected": $1(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return x.createElement("div", { className: y2(n) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), r;
}(), Ko = "two_columns", zo = "three_columns", Uo = "four_columns", q3 = k(k(k({}, Ko, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), zo, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), Uo, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function la(e, t) {
  return e ? Uo : t ? Ko : zo;
}
var MM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "MONTH_REFS", t8(Array(12)).map(function() {
      return x.createRef();
    })), k(L(n), "QUARTER_REFS", t8(Array(4)).map(function() {
      return x.createRef();
    })), k(L(n), "isDisabled", function(l) {
      return f3(l, n.props);
    }), k(L(n), "isExcluded", function(l) {
      return n0(l, n.props);
    }), k(L(n), "handleDayClick", function(l, c) {
      n.props.onDayClick && n.props.onDayClick(l, c, n.props.orderInDisplay);
    }), k(L(n), "handleDayMouseEnter", function(l) {
      n.props.onDayMouseEnter && n.props.onDayMouseEnter(l);
    }), k(L(n), "handleMouseLeave", function() {
      n.props.onMouseLeave && n.props.onMouseLeave();
    }), k(L(n), "isRangeStartMonth", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate;
      return !(!d || !C) && $2(H2(u, l), d);
    }), k(L(n), "isRangeStartQuarter", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate;
      return !(!d || !C) && w7(N6(u, l), d);
    }), k(L(n), "isRangeEndMonth", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate;
      return !(!d || !C) && $2(H2(u, l), C);
    }), k(L(n), "isRangeEndQuarter", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate;
      return !(!d || !C) && w7(N6(u, l), C);
    }), k(L(n), "isInSelectingRangeMonth", function(l) {
      var c, u = n.props, d = u.day, C = u.selectsStart, p = u.selectsEnd, h = u.selectsRange, f = u.startDate, g = u.endDate, m = (c = n.props.selectingDate) !== null && c !== void 0 ? c : n.props.preSelection;
      return !(!(C || p || h) || !m) && (C && g ? W3(m, g, l, d) : (p && f || !(!h || !f || g)) && W3(f, m, l, d));
    }), k(L(n), "isSelectingMonthRangeStart", function(l) {
      var c;
      if (!n.isInSelectingRangeMonth(l))
        return !1;
      var u = n.props, d = u.day, C = u.startDate, p = u.selectsStart, h = H2(d, l), f = (c = n.props.selectingDate) !== null && c !== void 0 ? c : n.props.preSelection;
      return $2(h, p ? f : C);
    }), k(L(n), "isSelectingMonthRangeEnd", function(l) {
      var c;
      if (!n.isInSelectingRangeMonth(l))
        return !1;
      var u = n.props, d = u.day, C = u.endDate, p = u.selectsEnd, h = u.selectsRange, f = H2(d, l), g = (c = n.props.selectingDate) !== null && c !== void 0 ? c : n.props.preSelection;
      return $2(f, p || h ? g : C);
    }), k(L(n), "isInSelectingRangeQuarter", function(l) {
      var c, u = n.props, d = u.day, C = u.selectsStart, p = u.selectsEnd, h = u.selectsRange, f = u.startDate, g = u.endDate, m = (c = n.props.selectingDate) !== null && c !== void 0 ? c : n.props.preSelection;
      return !(!(C || p || h) || !m) && (C && g ? J3(m, g, l, d) : (p && f || !(!h || !f || g)) && J3(f, m, l, d));
    }), k(L(n), "isWeekInMonth", function(l) {
      var c = n.props.day, u = f9(l, 6);
      return $2(l, c) || $2(u, c);
    }), k(L(n), "isCurrentMonth", function(l, c) {
      return H1(l) === H1(W1()) && c === _2(W1());
    }), k(L(n), "isCurrentQuarter", function(l, c) {
      return H1(l) === H1(W1()) && c === R6(W1());
    }), k(L(n), "isSelectedMonth", function(l, c, u) {
      return _2(u) === c && H1(l) === H1(u);
    }), k(L(n), "isSelectedQuarter", function(l, c, u) {
      return R6(l) === c && H1(l) === H1(u);
    }), k(L(n), "renderWeeks", function() {
      for (var l = [], c = n.props.fixedHeight, u = 0, d = !1, C = g5(Y5(n.props.day), n.props.locale, n.props.calendarStartDay); l.push(x.createElement(_M, { ariaLabelPrefix: n.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: n.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: n.props.disabledDayAriaLabelPrefix, key: u, day: C, month: _2(n.props.day), onDayClick: n.handleDayClick, onDayMouseEnter: n.handleDayMouseEnter, onWeekSelect: n.props.onWeekSelect, formatWeekNumber: n.props.formatWeekNumber, locale: n.props.locale, minDate: n.props.minDate, maxDate: n.props.maxDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, inline: n.props.inline, shouldFocusDayInline: n.props.shouldFocusDayInline, highlightDates: n.props.highlightDates, holidays: n.props.holidays, selectingDate: n.props.selectingDate, filterDate: n.props.filterDate, preSelection: n.props.preSelection, selected: n.props.selected, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, showWeekNumber: n.props.showWeekNumbers, showWeekPicker: n.props.showWeekPicker, startDate: n.props.startDate, endDate: n.props.endDate, dayClassName: n.props.dayClassName, setOpen: n.props.setOpen, shouldCloseOnSelect: n.props.shouldCloseOnSelect, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, renderDayContents: n.props.renderDayContents, handleOnKeyDown: n.props.handleOnKeyDown, isInputFocused: n.props.isInputFocused, containerRef: n.props.containerRef, calendarStartDay: n.props.calendarStartDay, monthShowsDuplicateDaysEnd: n.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: n.props.monthShowsDuplicateDaysStart })), !d; ) {
        u++, C = p7(C, 1);
        var p = c && u >= 6, h = !c && !n.isWeekInMonth(C);
        if (p || h) {
          if (!n.props.peekNextMonth)
            break;
          d = !0;
        }
      }
      return l;
    }), k(L(n), "onMonthClick", function(l, c) {
      n.handleDayClick(Y5(H2(n.props.day, c)), l);
    }), k(L(n), "onMonthMouseEnter", function(l) {
      n.handleDayMouseEnter(Y5(H2(n.props.day, l)));
    }), k(L(n), "handleMonthNavigation", function(l, c) {
      n.isDisabled(c) || n.isExcluded(c) || (n.props.setPreSelection(c), n.MONTH_REFS[l].current && n.MONTH_REFS[l].current.focus());
    }), k(L(n), "onMonthKeyDown", function(l, c) {
      var u = n.props, d = u.selected, C = u.preSelection, p = u.disabledKeyboardNavigation, h = u.showTwoColumnMonthYearPicker, f = u.showFourColumnMonthYearPicker, g = u.setPreSelection, m = l.key;
      if (m !== "Tab" && l.preventDefault(), !p) {
        var v = la(f, h), b = q3[v].verticalNavigationOffset, w = q3[v].grid;
        switch (m) {
          case "Enter":
            n.onMonthClick(l, c), g(d);
            break;
          case "ArrowRight":
            n.handleMonthNavigation(c === 11 ? 0 : c + 1, e5(C, 1));
            break;
          case "ArrowLeft":
            n.handleMonthNavigation(c === 0 ? 11 : c - 1, q6(C, 1));
            break;
          case "ArrowUp":
            n.handleMonthNavigation(w[0].includes(c) ? c + 12 - b : c - b, q6(C, b));
            break;
          case "ArrowDown":
            n.handleMonthNavigation(w[w.length - 1].includes(c) ? c - 12 + b : c + b, e5(C, b));
        }
      }
    }), k(L(n), "onQuarterClick", function(l, c) {
      n.handleDayClick(Jt(N6(n.props.day, c)), l);
    }), k(L(n), "onQuarterMouseEnter", function(l) {
      n.handleDayMouseEnter(Jt(N6(n.props.day, l)));
    }), k(L(n), "handleQuarterNavigation", function(l, c) {
      n.isDisabled(c) || n.isExcluded(c) || (n.props.setPreSelection(c), n.QUARTER_REFS[l - 1].current && n.QUARTER_REFS[l - 1].current.focus());
    }), k(L(n), "onQuarterKeyDown", function(l, c) {
      var u = l.key;
      if (!n.props.disabledKeyboardNavigation)
        switch (u) {
          case "Enter":
            n.onQuarterClick(l, c), n.props.setPreSelection(n.props.selected);
            break;
          case "ArrowRight":
            n.handleQuarterNavigation(c === 4 ? 1 : c + 1, ho(n.props.preSelection, 1));
            break;
          case "ArrowLeft":
            n.handleQuarterNavigation(c === 1 ? 4 : c - 1, Xy(n.props.preSelection, 1));
        }
    }), k(L(n), "getMonthClassNames", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate, p = c.selected, h = c.minDate, f = c.maxDate, g = c.preSelection, m = c.monthClassName, v = c.excludeDates, b = c.includeDates, w = m ? m(H2(u, l)) : void 0, M = H2(u, l);
      return y2("react-datepicker__month-text", "react-datepicker__month-".concat(l), w, { "react-datepicker__month-text--disabled": (h || f || v || b) && Oo(M, n.props), "react-datepicker__month-text--selected": n.isSelectedMonth(u, l, p), "react-datepicker__month-text--keyboard-selected": !n.props.disabledKeyboardNavigation && _2(g) === l, "react-datepicker__month-text--in-selecting-range": n.isInSelectingRangeMonth(l), "react-datepicker__month-text--in-range": W3(d, C, l, u), "react-datepicker__month-text--range-start": n.isRangeStartMonth(l), "react-datepicker__month-text--range-end": n.isRangeEndMonth(l), "react-datepicker__month-text--selecting-range-start": n.isSelectingMonthRangeStart(l), "react-datepicker__month-text--selecting-range-end": n.isSelectingMonthRangeEnd(l), "react-datepicker__month-text--today": n.isCurrentMonth(u, l) });
    }), k(L(n), "getTabIndex", function(l) {
      var c = _2(n.props.preSelection);
      return n.props.disabledKeyboardNavigation || l !== c ? "-1" : "0";
    }), k(L(n), "getQuarterTabIndex", function(l) {
      var c = R6(n.props.preSelection);
      return n.props.disabledKeyboardNavigation || l !== c ? "-1" : "0";
    }), k(L(n), "getAriaLabel", function(l) {
      var c = n.props, u = c.chooseDayAriaLabelPrefix, d = u === void 0 ? "Choose" : u, C = c.disabledDayAriaLabelPrefix, p = C === void 0 ? "Not available" : C, h = c.day, f = H2(h, l), g = n.isDisabled(f) || n.isExcluded(f) ? p : d;
      return "".concat(g, " ").concat(t2(f, "MMMM yyyy"));
    }), k(L(n), "getQuarterClassNames", function(l) {
      var c = n.props, u = c.day, d = c.startDate, C = c.endDate, p = c.selected, h = c.minDate, f = c.maxDate, g = c.preSelection, m = c.disabledKeyboardNavigation;
      return y2("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(l), { "react-datepicker__quarter-text--disabled": (h || f) && uM(N6(u, l), n.props), "react-datepicker__quarter-text--selected": n.isSelectedQuarter(u, l, p), "react-datepicker__quarter-text--keyboard-selected": !m && R6(g) === l, "react-datepicker__quarter-text--in-selecting-range": n.isInSelectingRangeQuarter(l), "react-datepicker__quarter-text--in-range": J3(d, C, l, u), "react-datepicker__quarter-text--range-start": n.isRangeStartQuarter(l), "react-datepicker__quarter-text--range-end": n.isRangeEndQuarter(l) });
    }), k(L(n), "getMonthContent", function(l) {
      var c = n.props, u = c.showFullMonthYearPicker, d = c.renderMonthContent, C = c.locale, p = c.day, h = Fo(l, C), f = a0(l, C);
      return d ? d(l, h, f, p) : u ? f : h;
    }), k(L(n), "getQuarterContent", function(l) {
      var c = n.props, u = c.renderQuarterContent, d = function(C, p) {
        return t2(N6(W1(), C), "QQQ", p);
      }(l, c.locale);
      return u ? u(l, d) : d;
    }), k(L(n), "renderMonths", function() {
      var l = n.props, c = l.showTwoColumnMonthYearPicker, u = l.showFourColumnMonthYearPicker, d = l.day, C = l.selected;
      return q3[la(u, c)].grid.map(function(p, h) {
        return x.createElement("div", { className: "react-datepicker__month-wrapper", key: h }, p.map(function(f, g) {
          return x.createElement("div", { ref: n.MONTH_REFS[f], key: g, onClick: function(m) {
            n.onMonthClick(m, f);
          }, onKeyDown: function(m) {
            n.onMonthKeyDown(m, f);
          }, onMouseEnter: function() {
            return n.onMonthMouseEnter(f);
          }, tabIndex: n.getTabIndex(f), className: n.getMonthClassNames(f), role: "option", "aria-label": n.getAriaLabel(f), "aria-current": n.isCurrentMonth(d, f) ? "date" : void 0, "aria-selected": n.isSelectedMonth(d, f, C) }, n.getMonthContent(f));
        }));
      });
    }), k(L(n), "renderQuarters", function() {
      var l = n.props, c = l.day, u = l.selected;
      return x.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(d, C) {
        return x.createElement("div", { key: C, ref: n.QUARTER_REFS[C], role: "option", onClick: function(p) {
          n.onQuarterClick(p, d);
        }, onKeyDown: function(p) {
          n.onQuarterKeyDown(p, d);
        }, onMouseEnter: function() {
          return n.onQuarterMouseEnter(d);
        }, className: n.getQuarterClassNames(d), "aria-selected": n.isSelectedQuarter(c, d, u), tabIndex: n.getQuarterTabIndex(d), "aria-current": n.isCurrentQuarter(c, d) ? "date" : void 0 }, n.getQuarterContent(d));
      }));
    }), k(L(n), "getClassNames", function() {
      var l = n.props, c = l.selectingDate, u = l.selectsStart, d = l.selectsEnd, C = l.showMonthYearPicker, p = l.showQuarterYearPicker, h = l.showWeekPicker;
      return y2("react-datepicker__month", { "react-datepicker__month--selecting-range": c && (u || d) }, { "react-datepicker__monthPicker": C }, { "react-datepicker__quarterPicker": p }, { "react-datepicker__weekPicker": h });
    }), n;
  }
  return m2(r, [{ key: "render", value: function() {
    var n = this.props, a = n.showMonthYearPicker, i = n.showQuarterYearPicker, o = n.day, l = n.ariaLabelPrefix, c = l === void 0 ? "month " : l;
    return x.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(c, " ").concat(t2(o, "yyyy-MM")), role: "listbox" }, a ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), r;
}(), Yo = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    var n;
    f2(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return k(L(n = t.call.apply(t, [this].concat(i))), "state", { height: null }), k(L(n), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        n.list && (n.list.scrollTop = n.centerLi && r.calcCenterPosition(n.props.monthRef ? n.props.monthRef.clientHeight - n.header.clientHeight : n.list.clientHeight, n.centerLi));
      });
    }), k(L(n), "handleClick", function(l) {
      (n.props.minTime || n.props.maxTime) && ea(l, n.props) || (n.props.excludeTimes || n.props.includeTimes || n.props.filterTime) && Xt(l, n.props) || n.props.onChange(l);
    }), k(L(n), "isSelectedTime", function(l) {
      return n.props.selected && (c = n.props.selected, u = l, sa(c).getTime() === sa(u).getTime());
      var c, u;
    }), k(L(n), "isDisabledTime", function(l) {
      return (n.props.minTime || n.props.maxTime) && ea(l, n.props) || (n.props.excludeTimes || n.props.includeTimes || n.props.filterTime) && Xt(l, n.props);
    }), k(L(n), "liClasses", function(l) {
      var c = ["react-datepicker__time-list-item", n.props.timeClassName ? n.props.timeClassName(l) : void 0];
      return n.isSelectedTime(l) && c.push("react-datepicker__time-list-item--selected"), n.isDisabledTime(l) && c.push("react-datepicker__time-list-item--disabled"), n.props.injectTimes && (60 * h5(l) + p5(l)) % n.props.intervals != 0 && c.push("react-datepicker__time-list-item--injected"), c.join(" ");
    }), k(L(n), "handleOnKeyDown", function(l, c) {
      l.key === " " && (l.preventDefault(), l.key = "Enter"), l.key !== "ArrowUp" && l.key !== "ArrowLeft" || !l.target.previousSibling || (l.preventDefault(), l.target.previousSibling.focus()), l.key !== "ArrowDown" && l.key !== "ArrowRight" || !l.target.nextSibling || (l.preventDefault(), l.target.nextSibling.focus()), l.key === "Enter" && n.handleClick(c), n.props.handleOnKeyDown(l);
    }), k(L(n), "renderTimes", function() {
      for (var l = [], c = n.props.format ? n.props.format : "p", u = n.props.intervals, d = n.props.selected || n.props.openToDate || W1(), C = f5(d), p = n.props.injectTimes && n.props.injectTimes.sort(function(w, M) {
        return w - M;
      }), h = 60 * function(w) {
        var M = new Date(w.getFullYear(), w.getMonth(), w.getDate()), y = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 24);
        return Math.round((+y - +M) / 36e5);
      }(d), f = h / u, g = 0; g < f; g++) {
        var m = L4(C, g * u);
        if (l.push(m), p) {
          var v = CM(C, m, g, u, p);
          l = l.concat(v);
        }
      }
      var b = l.reduce(function(w, M) {
        return M.getTime() <= d.getTime() ? M : w;
      }, l[0]);
      return l.map(function(w, M) {
        return x.createElement("li", { key: M, onClick: n.handleClick.bind(L(n), w), className: n.liClasses(w), ref: function(y) {
          w === b && (n.centerLi = y);
        }, onKeyDown: function(y) {
          n.handleOnKeyDown(y, w);
        }, tabIndex: w === b ? 0 : -1, role: "option", "aria-selected": n.isSelectedTime(w) ? "true" : void 0, "aria-disabled": n.isDisabledTime(w) ? "true" : void 0 }, t2(w, c, n.props.locale));
      });
    }), n;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var n = this, a = this.state.height;
    return x.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, x.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      n.header = i;
    } }, x.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), x.createElement("div", { className: "react-datepicker__time" }, x.createElement("div", { className: "react-datepicker__time-box" }, x.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      n.list = i;
    }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), r;
}();
k(Yo, "calcCenterPosition", function(e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var SM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "YEAR_REFS", t8(Array(a.props.yearItemNumber)).map(function() {
      return x.createRef();
    })), k(L(a), "isDisabled", function(i) {
      return f3(i, a.props);
    }), k(L(a), "isExcluded", function(i) {
      return n0(i, a.props);
    }), k(L(a), "selectingDate", function() {
      var i;
      return (i = a.props.selectingDate) !== null && i !== void 0 ? i : a.props.preSelection;
    }), k(L(a), "updateFocusOnPaginate", function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(L(a));
      window.requestAnimationFrame(o);
    }), k(L(a), "handleYearClick", function(i, o) {
      a.props.onDayClick && a.props.onDayClick(i, o);
    }), k(L(a), "handleYearNavigation", function(i, o) {
      var l = a.props, c = l.date, u = l.yearItemNumber, d = F6(c, u).startPeriod;
      a.isDisabled(o) || a.isExcluded(o) || (a.props.setPreSelection(o), i - d == -1 ? a.updateFocusOnPaginate(u - 1) : i - d === u ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[i - d].current.focus());
    }), k(L(a), "isSameDay", function(i, o) {
      return $1(i, o);
    }), k(L(a), "isCurrentYear", function(i) {
      return i === H1(W1());
    }), k(L(a), "isRangeStart", function(i) {
      return a.props.startDate && a.props.endDate && K5(k5(W1(), i), a.props.startDate);
    }), k(L(a), "isRangeEnd", function(i) {
      return a.props.startDate && a.props.endDate && K5(k5(W1(), i), a.props.endDate);
    }), k(L(a), "isInRange", function(i) {
      return $3(i, a.props.startDate, a.props.endDate);
    }), k(L(a), "isInSelectingRange", function(i) {
      var o = a.props, l = o.selectsStart, c = o.selectsEnd, u = o.selectsRange, d = o.startDate, C = o.endDate;
      return !(!(l || c || u) || !a.selectingDate()) && (l && C ? $3(i, a.selectingDate(), C) : (c && d || !(!u || !d || C)) && $3(i, d, a.selectingDate()));
    }), k(L(a), "isSelectingRangeStart", function(i) {
      if (!a.isInSelectingRange(i))
        return !1;
      var o = a.props, l = o.startDate, c = o.selectsStart, u = k5(W1(), i);
      return K5(u, c ? a.selectingDate() : l);
    }), k(L(a), "isSelectingRangeEnd", function(i) {
      if (!a.isInSelectingRange(i))
        return !1;
      var o = a.props, l = o.endDate, c = o.selectsEnd, u = o.selectsRange, d = k5(W1(), i);
      return K5(d, c || u ? a.selectingDate() : l);
    }), k(L(a), "isKeyboardSelected", function(i) {
      var o = T9(k5(a.props.date, i));
      return !a.props.disabledKeyboardNavigation && !a.props.inline && !$1(o, T9(a.props.selected)) && $1(o, T9(a.props.preSelection));
    }), k(L(a), "onYearClick", function(i, o) {
      var l = a.props.date;
      a.handleYearClick(T9(k5(l, o)), i);
    }), k(L(a), "onYearKeyDown", function(i, o) {
      var l = i.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (l) {
          case "Enter":
            a.onYearClick(i, o), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleYearNavigation(o + 1, J6(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleYearNavigation(o - 1, J9(a.props.preSelection, 1));
        }
    }), k(L(a), "getYearClassNames", function(i) {
      var o = a.props, l = o.minDate, c = o.maxDate, u = o.selected, d = o.excludeDates, C = o.includeDates, p = o.filterDate;
      return y2("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === H1(u), "react-datepicker__year-text--disabled": (l || c || d || C || p) && Bo(i, a.props), "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(i), "react-datepicker__year-text--range-start": a.isRangeStart(i), "react-datepicker__year-text--range-end": a.isRangeEnd(i), "react-datepicker__year-text--in-range": a.isInRange(i), "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(i), "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(i), "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(i), "react-datepicker__year-text--today": a.isCurrentYear(i) });
    }), k(L(a), "getYearTabIndex", function(i) {
      return a.props.disabledKeyboardNavigation ? "-1" : i === H1(a.props.preSelection) ? "0" : "-1";
    }), k(L(a), "getYearContainerClassNames", function() {
      var i = a.props, o = i.selectingDate, l = i.selectsStart, c = i.selectsEnd, u = i.selectsRange;
      return y2("react-datepicker__year", { "react-datepicker__year--selecting-range": o && (l || c || u) });
    }), k(L(a), "getYearContent", function(i) {
      return a.props.renderYearContent ? a.props.renderYearContent(i) : i;
    }), a;
  }
  return m2(r, [{ key: "render", value: function() {
    for (var n = this, a = [], i = this.props, o = i.date, l = i.yearItemNumber, c = i.onYearMouseEnter, u = i.onYearMouseLeave, d = F6(o, l), C = d.startPeriod, p = d.endPeriod, h = function(g) {
      a.push(x.createElement("div", { ref: n.YEAR_REFS[g - C], onClick: function(m) {
        n.onYearClick(m, g);
      }, onKeyDown: function(m) {
        n.onYearKeyDown(m, g);
      }, tabIndex: n.getYearTabIndex(g), className: n.getYearClassNames(g), onMouseEnter: function(m) {
        return c(m, g);
      }, onMouseLeave: function(m) {
        return u(m, g);
      }, key: g, "aria-current": n.isCurrentYear(g) ? "date" : void 0 }, n.getYearContent(g)));
    }, f = C; f <= p; f++)
      h(f);
    return x.createElement("div", { className: this.getYearContainerClassNames() }, x.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, a));
  } }]), r;
}(), kM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "onTimeChange", function(i) {
      a.setState({ time: i });
      var o = a.props.date, l = o instanceof Date && !isNaN(o) ? o : /* @__PURE__ */ new Date();
      l.setHours(i.split(":")[0]), l.setMinutes(i.split(":")[1]), a.props.onChange(l);
    }), k(L(a), "renderTimeInput", function() {
      var i = a.state.time, o = a.props, l = o.date, c = o.timeString, u = o.customTimeInput;
      return u ? x.cloneElement(u, { date: l, value: i, onChange: a.onTimeChange }) : x.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(d) {
        a.onTimeChange(d.target.value || c);
      } });
    }), a.state = { time: a.props.timeString }, a;
  }
  return m2(r, [{ key: "render", value: function() {
    return x.createElement("div", { className: "react-datepicker__input-time-container" }, x.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), x.createElement("div", { className: "react-datepicker-time__input-container" }, x.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(n, a) {
    return n.timeString !== a.time ? { time: n.timeString } : null;
  } }]), r;
}();
function LM(e) {
  var t = e.className, r = e.children, n = e.showPopperArrow, a = e.arrowProps, i = a === void 0 ? {} : a;
  return x.createElement("div", { className: t }, n && x.createElement("div", a9({ className: "react-datepicker__triangle" }, i)), r);
}
var HM = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], PM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "handleClickOutside", function(i) {
      a.props.onClickOutside(i);
    }), k(L(a), "setClickOutsideRef", function() {
      return a.containerRef.current;
    }), k(L(a), "handleDropdownFocus", function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return HM.some(function(l) {
          return o.indexOf(l) >= 0;
        });
      })(i.target) && a.props.onDropdownFocus();
    }), k(L(a), "getDateInView", function() {
      var i = a.props, o = i.preSelection, l = i.selected, c = i.openToDate, u = Zo(a.props), d = Go(a.props), C = W1(), p = c || l || o;
      return p || (u && G5(C, u) ? u : d && J5(C, d) ? d : C);
    }), k(L(a), "increaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: e5(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), k(L(a), "decreaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: q6(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), k(L(a), "handleDayClick", function(i, o, l) {
      a.props.onSelect(i, o, l), a.props.setPreSelection && a.props.setPreSelection(i);
    }), k(L(a), "handleDayMouseEnter", function(i) {
      a.setState({ selectingDate: i }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(i);
    }), k(L(a), "handleMonthMouseLeave", function() {
      a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
    }), k(L(a), "handleYearMouseEnter", function(i, o) {
      a.setState({ selectingDate: k5(W1(), o) }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(i, o);
    }), k(L(a), "handleYearMouseLeave", function(i, o) {
      a.props.onYearMouseLeave && a.props.onYearMouseLeave(i, o);
    }), k(L(a), "handleYearChange", function(i) {
      a.props.onYearChange && (a.props.onYearChange(i), a.setState({ isRenderAriaLiveMessage: !0 })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), k(L(a), "handleMonthChange", function(i) {
      a.handleCustomMonthChange(i), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), k(L(a), "handleCustomMonthChange", function(i) {
      a.props.onMonthChange && (a.props.onMonthChange(i), a.setState({ isRenderAriaLiveMessage: !0 }));
    }), k(L(a), "handleMonthYearChange", function(i) {
      a.handleYearChange(i), a.handleMonthChange(i);
    }), k(L(a), "changeYear", function(i) {
      a.setState(function(o) {
        var l = o.date;
        return { date: k5(l, i) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), k(L(a), "changeMonth", function(i) {
      a.setState(function(o) {
        var l = o.date;
        return { date: H2(l, i) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), k(L(a), "changeMonthYear", function(i) {
      a.setState(function(o) {
        var l = o.date;
        return { date: k5(H2(l, _2(i)), H1(i)) };
      }, function() {
        return a.handleMonthYearChange(a.state.date);
      });
    }), k(L(a), "header", function() {
      var i = g5(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), o = [];
      return a.props.showWeekNumbers && o.push(x.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map(function(l) {
        var c = f9(i, l), u = a.formatWeekday(c, a.props.locale), d = a.props.weekDayClassName ? a.props.weekDayClassName(c) : void 0;
        return x.createElement("div", { key: l, className: y2("react-datepicker__day-name", d) }, u);
      }));
    }), k(L(a), "formatWeekday", function(i, o) {
      return a.props.formatWeekDay ? function(l, c, u) {
        return c(t2(l, "EEEE", u));
      }(i, a.props.formatWeekDay, o) : a.props.useWeekdaysShort ? function(l, c) {
        return t2(l, "EEE", c);
      }(i, o) : function(l, c) {
        return t2(l, "EEEEEE", c);
      }(i, o);
    }), k(L(a), "decreaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: J9(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), k(L(a), "clearSelectingDate", function() {
      a.setState({ selectingDate: null });
    }), k(L(a), "renderPreviousButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = na(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(v) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = b.minDate, M = b.yearItemNumber, y = M === void 0 ? R9 : M, _ = F6(T9(J9(v, y)), y).endPeriod, S = w && H1(w);
              return S && S > _ || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = ta(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], l = a.decreaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (l = a.decreaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), l = null);
          var c = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, u = a.props, d = u.previousMonthButtonLabel, C = u.previousYearButtonLabel, p = a.props, h = p.previousMonthAriaLabel, f = h === void 0 ? typeof d == "string" ? d : "Previous Month" : h, g = p.previousYearAriaLabel, m = g === void 0 ? typeof C == "string" ? C : "Previous Year" : g;
          return x.createElement("button", { type: "button", className: o.join(" "), onClick: l, onKeyDown: a.props.handleOnKeyDown, "aria-label": c ? m : f }, x.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, c ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
        }
      }
    }), k(L(a), "increaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: J6(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), k(L(a), "renderNextButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = ra(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(v) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = b.maxDate, M = b.yearItemNumber, y = M === void 0 ? R9 : M, _ = F6(J6(v, y), y).startPeriod, S = w && H1(w);
              return S && S < _ || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = aa(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var l = a.increaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (l = a.increaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), l = null);
          var c = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, u = a.props, d = u.nextMonthButtonLabel, C = u.nextYearButtonLabel, p = a.props, h = p.nextMonthAriaLabel, f = h === void 0 ? typeof d == "string" ? d : "Next Month" : h, g = p.nextYearAriaLabel, m = g === void 0 ? typeof C == "string" ? C : "Next Year" : g;
          return x.createElement("button", { type: "button", className: o.join(" "), onClick: l, onKeyDown: a.props.handleOnKeyDown, "aria-label": c ? m : f }, x.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, c ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
        }
      }
    }), k(L(a), "renderCurrentMonth", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, o = ["react-datepicker__current-month"];
      return a.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), x.createElement("div", { className: o.join(" ") }, t2(i, a.props.dateFormat, a.props.locale));
    }), k(L(a), "renderYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showYearDropdown && !i)
        return x.createElement(fM, { adjustDateOnChange: a.props.adjustDateOnChange, date: a.state.date, onSelect: a.props.onSelect, setOpen: a.props.setOpen, dropdownMode: a.props.dropdownMode, onChange: a.changeYear, minDate: a.props.minDate, maxDate: a.props.maxDate, year: H1(a.state.date), scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), k(L(a), "renderMonthDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthDropdown && !i)
        return x.createElement(gM, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, onChange: a.changeMonth, month: _2(a.state.date), useShortMonthInDropdown: a.props.useShortMonthInDropdown });
    }), k(L(a), "renderMonthYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthYearDropdown && !i)
        return x.createElement(yM, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, dateFormat: a.props.dateFormat, onChange: a.changeMonthYear, minDate: a.props.minDate, maxDate: a.props.maxDate, date: a.state.date, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown });
    }), k(L(a), "handleTodayButtonClick", function(i) {
      a.props.onSelect(qt(), i), a.props.setPreSelection && a.props.setPreSelection(qt());
    }), k(L(a), "renderTodayButton", function() {
      if (a.props.todayButton && !a.props.showTimeSelectOnly)
        return x.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
          return a.handleTodayButtonClick(i);
        } }, a.props.todayButton);
    }), k(L(a), "renderDefaultHeader", function(i) {
      var o = i.monthDate, l = i.i;
      return x.createElement("div", { className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a.renderCurrentMonth(o), x.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode), onFocus: a.handleDropdownFocus }, a.renderMonthDropdown(l !== 0), a.renderMonthYearDropdown(l !== 0), a.renderYearDropdown(l !== 0)), x.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), k(L(a), "renderCustomHeader", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, l = i.i;
      if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly)
        return null;
      var c = ta(a.state.date, a.props), u = aa(a.state.date, a.props), d = na(a.state.date, a.props), C = ra(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
      return x.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a.props.onDropdownFocus }, a.props.renderCustomHeader(y7(y7({}, a.state), {}, { customHeaderCount: l, monthDate: o, changeMonth: a.changeMonth, changeYear: a.changeYear, decreaseMonth: a.decreaseMonth, increaseMonth: a.increaseMonth, decreaseYear: a.decreaseYear, increaseYear: a.increaseYear, prevMonthButtonDisabled: c, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: C })), p && x.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), k(L(a), "renderYearHeader", function() {
      var i = a.state.date, o = a.props, l = o.showYearPicker, c = F6(i, o.yearItemNumber), u = c.startPeriod, d = c.endPeriod;
      return x.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, l ? "".concat(u, " - ").concat(d) : H1(i));
    }), k(L(a), "renderHeader", function(i) {
      switch (!0) {
        case a.props.renderCustomHeader !== void 0:
          return a.renderCustomHeader(i);
        case (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker):
          return a.renderYearHeader(i);
        default:
          return a.renderDefaultHeader(i);
      }
    }), k(L(a), "renderMonths", function() {
      var i;
      if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
        for (var o = [], l = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, c = q6(a.state.date, l), u = (i = a.props.monthSelectedIn) !== null && i !== void 0 ? i : l, d = 0; d < a.props.monthsShown; ++d) {
          var C = e5(c, d - u + l), p = "month-".concat(d), h = d < a.props.monthsShown - 1, f = d > 0;
          o.push(x.createElement("div", { key: p, ref: function(g) {
            a.monthContainer = g;
          }, className: "react-datepicker__month-container" }, a.renderHeader({ monthDate: C, i: d }), x.createElement(MM, { chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, ariaLabelPrefix: a.props.monthAriaLabelPrefix, onChange: a.changeMonthYear, day: C, dayClassName: a.props.dayClassName, calendarStartDay: a.props.calendarStartDay, monthClassName: a.props.monthClassName, onDayClick: a.handleDayClick, handleOnKeyDown: a.props.handleOnDayKeyDown, onDayMouseEnter: a.handleDayMouseEnter, onMouseLeave: a.handleMonthMouseLeave, onWeekSelect: a.props.onWeekSelect, orderInDisplay: d, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.state.selectingDate, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, fixedHeight: a.props.fixedHeight, filterDate: a.props.filterDate, preSelection: a.props.preSelection, setPreSelection: a.props.setPreSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumbers: a.props.showWeekNumbers, startDate: a.props.startDate, endDate: a.props.endDate, peekNextMonth: a.props.peekNextMonth, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, isInputFocused: a.props.isInputFocused, containerRef: a.containerRef, monthShowsDuplicateDaysEnd: h, monthShowsDuplicateDaysStart: f })));
        }
        return o;
      }
    }), k(L(a), "renderYears", function() {
      if (!a.props.showTimeSelectOnly)
        return a.props.showYearPicker ? x.createElement("div", { className: "react-datepicker__year--container" }, a.renderHeader(), x.createElement(SM, a9({ onDayClick: a.handleDayClick, selectingDate: a.state.selectingDate, clearSelectingDate: a.clearSelectingDate, date: a.state.date }, a.props, { onYearMouseEnter: a.handleYearMouseEnter, onYearMouseLeave: a.handleYearMouseLeave }))) : void 0;
    }), k(L(a), "renderTimeSection", function() {
      if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
        return x.createElement(Yo, { selected: a.props.selected, openToDate: a.props.openToDate, onChange: a.props.onTimeChange, timeClassName: a.props.timeClassName, format: a.props.timeFormat, includeTimes: a.props.includeTimes, intervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, todayButton: a.props.todayButton, showMonthDropdown: a.props.showMonthDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, monthRef: a.state.monthContainer, injectTimes: a.props.injectTimes, locale: a.props.locale, handleOnKeyDown: a.props.handleOnKeyDown, showTimeSelectOnly: a.props.showTimeSelectOnly });
    }), k(L(a), "renderInputTimeSection", function() {
      var i = new Date(a.props.selected), o = O5(i) && a.props.selected ? "".concat(oa(i.getHours()), ":").concat(oa(i.getMinutes())) : "";
      if (a.props.showTimeInput)
        return x.createElement(kM, { date: i, timeString: o, timeInputLabel: a.props.timeInputLabel, onChange: a.props.onTimeChange, customTimeInput: a.props.customTimeInput });
    }), k(L(a), "renderAriaLiveRegion", function() {
      var i, o = F6(a.state.date, a.props.yearItemNumber), l = o.startPeriod, c = o.endPeriod;
      return i = a.props.showYearPicker ? "".concat(l, " - ").concat(c) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? H1(a.state.date) : "".concat(a0(_2(a.state.date), a.props.locale), " ").concat(H1(a.state.date)), x.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, a.state.isRenderAriaLiveMessage && i);
    }), k(L(a), "renderChildren", function() {
      if (a.props.children)
        return x.createElement("div", { className: "react-datepicker__children-container" }, a.props.children);
    }), a.containerRef = x.createRef(), a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, a;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    var n = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void n.setState({ monthContainer: n.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(n) {
    var a = this;
    if (!this.props.preSelection || $1(this.props.preSelection, n.preSelection) && this.props.monthSelectedIn === n.monthSelectedIn)
      this.props.openToDate && !$1(this.props.openToDate, n.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var i = !$2(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return i && a.handleCustomMonthChange(a.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var n = this.props.container || LM;
    return x.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, x.createElement(n, { className: y2("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: R9 };
  } }]), r;
}(), TM = function(e) {
  var t = e.icon, r = e.className, n = r === void 0 ? "" : r, a = e.onClick, i = "react-datepicker__calendar-icon";
  return x.isValidElement(t) ? x.cloneElement(t, { className: "".concat(t.props.className || "", " ").concat(i, " ").concat(n), onClick: function(o) {
    typeof t.props.onClick == "function" && t.props.onClick(o), typeof a == "function" && a(o);
  } }) : typeof t == "string" ? x.createElement("i", { className: "".concat(i, " ").concat(t, " ").concat(n), "aria-hidden": "true", onClick: a }) : x.createElement("svg", { className: "".concat(i, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a }, x.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, Wo = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), (a = t.call(this, n)).el = document.createElement("div"), a;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return xs.createPortal(this.props.children, this.el);
  } }]), r;
}(), jM = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, $o = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "getTabChildren", function() {
      return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(jM);
    }), k(L(a), "handleFocusStart", function() {
      var i = a.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    }), k(L(a), "handleFocusEnd", function() {
      var i = a.getTabChildren();
      i && i.length > 1 && i[0].focus();
    }), a.tabLoopRef = x.createRef(), a;
  }
  return m2(r, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? x.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, x.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, x.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), r;
}(), VM = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r() {
    return f2(this, r), t.apply(this, arguments);
  }
  return m2(r, [{ key: "render", value: function() {
    var n, a = this.props, i = a.className, o = a.wrapperClassName, l = a.hidePopper, c = a.popperComponent, u = a.popperModifiers, d = a.popperPlacement, C = a.popperProps, p = a.targetComponent, h = a.enableTabLoop, f = a.popperOnKeyDown, g = a.portalId, m = a.portalHost;
    if (!l) {
      var v = y2("react-datepicker-popper", i);
      n = x.createElement(tM, a9({ modifiers: u, placement: d }, C), function(w) {
        var M = w.ref, y = w.style, _ = w.placement, S = w.arrowProps;
        return x.createElement($o, { enableTabLoop: h }, x.createElement("div", { ref: M, style: y, className: v, "data-placement": _, onKeyDown: f }, x.cloneElement(c, { arrowProps: S })));
      });
    }
    this.props.popperContainer && (n = x.createElement(this.props.popperContainer, {}, n)), g && !l && (n = x.createElement(Wo, { portalId: g, portalHost: m }, n));
    var b = y2("react-datepicker-wrapper", o);
    return x.createElement(Nw, { className: "react-datepicker-manager" }, x.createElement(oM, null, function(w) {
      var M = w.ref;
      return x.createElement("div", { ref: M, className: b }, p);
    }), n);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), r;
}(), ca = "react-datepicker-ignore-onclickoutside", AM = p3(PM), Q3 = "Date input not valid.", g3 = function(e) {
  g2(r, x.Component);
  var t = v2(r);
  function r(n) {
    var a;
    return f2(this, r), k(L(a = t.call(this, n)), "getPreSelection", function() {
      return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : W1();
    }), k(L(a), "modifyHolidays", function() {
      var i;
      return (i = a.props.holidays) === null || i === void 0 ? void 0 : i.reduce(function(o, l) {
        var c = new Date(l.date);
        return $9(c) ? [].concat(t8(o), [y7(y7({}, l), {}, { date: c })]) : o;
      }, []);
    }), k(L(a), "calcInitialState", function() {
      var i, o = a.getPreSelection(), l = Zo(a.props), c = Go(a.props), u = l && G5(o, f5(l)) ? l : c && J5(o, T4(c)) ? c : o;
      return { open: a.props.startOpen || !1, preventFocus: !1, preSelection: (i = a.props.selectsRange ? a.props.startDate : a.props.selected) !== null && i !== void 0 ? i : u, highlightDates: ia(a.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), k(L(a), "clearPreventFocusTimeout", function() {
      a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
    }), k(L(a), "setFocus", function() {
      a.input && a.input.focus && a.input.focus({ preventScroll: !0 });
    }), k(L(a), "setBlur", function() {
      a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
    }), k(L(a), "setOpen", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      a.setState({ open: i, preSelection: i && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection, lastPreSelectChange: X3 }, function() {
        i || a.setState(function(l) {
          return { focused: !!o && l.focused };
        }, function() {
          !o && a.setBlur(), a.setState({ inputValue: null });
        });
      });
    }), k(L(a), "inputOk", function() {
      return C3(a.state.preSelection);
    }), k(L(a), "isCalendarOpen", function() {
      return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
    }), k(L(a), "handleFocus", function(i) {
      a.state.preventFocus || (a.props.onFocus(i), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({ focused: !0 });
    }), k(L(a), "sendFocusBackToInput", function() {
      a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({ preventFocus: !0 }, function() {
        a.preventFocusTimeout = setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      });
    }), k(L(a), "cancelFocusInput", function() {
      clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
    }), k(L(a), "deferFocusInput", function() {
      a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
        return a.setFocus();
      }, 1);
    }), k(L(a), "handleDropdownFocus", function() {
      a.cancelFocusInput();
    }), k(L(a), "handleBlur", function(i) {
      (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(i), a.setState({ focused: !1 });
    }), k(L(a), "handleCalendarClickOutside", function(i) {
      a.props.inline || a.setOpen(!1), a.props.onClickOutside(i), a.props.withPortal && i.preventDefault();
    }), k(L(a), "handleChange", function() {
      for (var i = arguments.length, o = new Array(i), l = 0; l < i; l++)
        o[l] = arguments[l];
      var c = o[0];
      if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(L(a), o), typeof c.isDefaultPrevented == "function" && !c.isDefaultPrevented())) {
        a.setState({ inputValue: c.target.value, lastPreSelectChange: EM });
        var u, d, C, p, h, f, g, m, v = (u = c.target.value, d = a.props.dateFormat, C = a.props.locale, p = a.props.strictParsing, h = a.props.minDate, f = null, g = h6(C) || h6(p6()), m = !0, Array.isArray(d) ? (d.forEach(function(b) {
          var w = K3(u, b, /* @__PURE__ */ new Date(), { locale: g });
          p && (m = O5(w, h) && u === t2(w, b, C)), O5(w, h) && m && (f = w);
        }), f) : (f = K3(u, d, /* @__PURE__ */ new Date(), { locale: g }), p ? m = O5(f) && u === t2(f, d, C) : O5(f) || (d = d.match(cM).map(function(b) {
          var w = b[0];
          return w === "p" || w === "P" ? g ? (0, lM[w])(b, g.formatLong) : w : b;
        }).join(""), u.length > 0 && (f = K3(u, d.slice(0, u.length), /* @__PURE__ */ new Date())), O5(f) || (f = new Date(u))), O5(f) && m ? f : null));
        a.props.showTimeSelectOnly && a.props.selected && v && !$1(v, a.props.selected) && (v = sM(a.props.selected, { hours: h5(v), minutes: p5(v), seconds: Lt(v) })), !v && c.target.value || (a.props.showWeekPicker && (v = g5(v, a.props.locale, a.props.calendarStartDay)), a.setSelected(v, c, !0));
      }
    }), k(L(a), "handleSelect", function(i, o, l) {
      if (a.props.shouldCloseOnSelect && !a.props.showTimeSelect && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(o), a.props.showWeekPicker && (i = g5(i, a.props.locale, a.props.calendarStartDay)), a.setSelected(i, o, !1, l), a.props.showDateSelect && a.setState({ isRenderAriaLiveMessage: !0 }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect)
        a.setPreSelection(i);
      else if (!a.props.inline) {
        a.props.selectsRange || a.setOpen(!1);
        var c = a.props, u = c.startDate, d = c.endDate;
        !u || d || G5(i, u) || a.setOpen(!1);
      }
    }), k(L(a), "setSelected", function(i, o, l, c) {
      var u = i;
      if (a.props.showYearPicker) {
        if (u !== null && Bo(H1(u), a.props))
          return;
      } else if (a.props.showMonthYearPicker) {
        if (u !== null && Oo(u, a.props))
          return;
      } else if (u !== null && f3(u, a.props))
        return;
      var d = a.props, C = d.onChange, p = d.selectsRange, h = d.startDate, f = d.endDate;
      if (!c6(a.props.selected, u) || a.props.allowSameDay || p)
        if (u !== null && (!a.props.selected || l && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (u = $t(u, { hour: h5(a.props.selected), minute: p5(a.props.selected), second: Lt(a.props.selected) })), a.props.inline || a.setState({ preSelection: u }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: c })), p) {
          var g = h && !f, m = h && f;
          !h && !f ? C([u, null], o) : g && (G5(u, h) ? C([u, null], o) : C([h, u], o)), m && C([u, null], o);
        } else
          C(u, o);
      l || (a.props.onSelect(u, o), a.setState({ inputValue: null }));
    }), k(L(a), "setPreSelection", function(i) {
      var o = a.props.minDate !== void 0, l = a.props.maxDate !== void 0, c = !0;
      if (i) {
        a.props.showWeekPicker && (i = g5(i, a.props.locale, a.props.calendarStartDay));
        var u = f5(i);
        if (o && l)
          c = $8(i, a.props.minDate, a.props.maxDate);
        else if (o) {
          var d = f5(a.props.minDate);
          c = J5(i, d) || c6(u, d);
        } else if (l) {
          var C = T4(a.props.maxDate);
          c = G5(i, C) || c6(u, C);
        }
      }
      c && a.setState({ preSelection: i });
    }), k(L(a), "toggleCalendar", function() {
      a.setOpen(!a.state.open);
    }), k(L(a), "handleTimeChange", function(i) {
      var o = a.props.selected ? a.props.selected : a.getPreSelection(), l = a.props.selected ? i : $t(o, { hour: h5(i), minute: p5(i) });
      a.setState({ preSelection: l }), a.props.onChange(l), a.props.shouldCloseOnSelect && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({ isRenderAriaLiveMessage: !0 }), a.setState({ inputValue: null });
    }), k(L(a), "onInputClick", function() {
      a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
    }), k(L(a), "onInputKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key;
      if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
        if (a.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var l = a.props.showWeekPicker && a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', c = a.calendar.componentNode && a.calendar.componentNode.querySelector(l);
            return void (c && c.focus({ preventScroll: !0 }));
          }
          var u = W1(a.state.preSelection);
          o === "Enter" ? (i.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === X3 ? (a.handleSelect(u, i), !a.props.shouldCloseOnSelect && a.setPreSelection(u)) : a.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1)) : o === "Tab" && a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: Q3 });
        }
      } else
        o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || a.onInputClick();
    }), k(L(a), "onPortalKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), k(L(a), "onDayKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key, l = W1(a.state.preSelection);
      if (o === "Enter")
        i.preventDefault(), a.handleSelect(l, i), !a.props.shouldCloseOnSelect && a.setPreSelection(l);
      else if (o === "Escape")
        i.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: Q3 });
      else if (!a.props.disabledKeyboardNavigation) {
        var c;
        switch (o) {
          case "ArrowLeft":
            c = a.props.showWeekPicker ? kt(l, 1) : Qy(l, 1);
            break;
          case "ArrowRight":
            c = a.props.showWeekPicker ? p7(l, 1) : f9(l, 1);
            break;
          case "ArrowUp":
            c = kt(l, 1);
            break;
          case "ArrowDown":
            c = p7(l, 1);
            break;
          case "PageUp":
            c = q6(l, 1);
            break;
          case "PageDown":
            c = e5(l, 1);
            break;
          case "Home":
            c = J9(l, 1);
            break;
          case "End":
            c = J6(l, 1);
            break;
          default:
            c = null;
        }
        if (!c)
          return void (a.props.onInputError && a.props.onInputError({ code: 1, msg: Q3 }));
        if (i.preventDefault(), a.setState({ lastPreSelectChange: X3 }), a.props.adjustDateOnChange && a.setSelected(c), a.setPreSelection(c), a.props.inline) {
          var u = _2(l), d = _2(c), C = H1(l), p = H1(c);
          u !== d || C !== p ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), k(L(a), "onPopperKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.sendFocusBackToInput());
    }), k(L(a), "onClearClick", function(i) {
      i && i.preventDefault && i.preventDefault(), a.sendFocusBackToInput(), a.props.selectsRange ? a.props.onChange([null, null], i) : a.props.onChange(null, i), a.setState({ inputValue: null });
    }), k(L(a), "clear", function() {
      a.onClearClick();
    }), k(L(a), "onScroll", function(i) {
      typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(i) && a.setOpen(!1);
    }), k(L(a), "renderCalendar", function() {
      return a.props.inline || a.isCalendarOpen() ? x.createElement(AM, { ref: function(i) {
        a.calendar = i;
      }, locale: a.props.locale, calendarStartDay: a.props.calendarStartDay, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, monthAriaLabelPrefix: a.props.monthAriaLabelPrefix, adjustDateOnChange: a.props.adjustDateOnChange, setOpen: a.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, dateFormat: a.props.dateFormatCalendar, useWeekdaysShort: a.props.useWeekdaysShort, formatWeekDay: a.props.formatWeekDay, dropdownMode: a.props.dropdownMode, selected: a.props.selected, preSelection: a.state.preSelection, onSelect: a.handleSelect, onWeekSelect: a.props.onWeekSelect, openToDate: a.props.openToDate, minDate: a.props.minDate, maxDate: a.props.maxDate, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, startDate: a.props.startDate, endDate: a.props.endDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, filterDate: a.props.filterDate, onClickOutside: a.handleCalendarClickOutside, formatWeekNumber: a.props.formatWeekNumber, highlightDates: a.state.highlightDates, holidays: dM(a.modifyHolidays()), includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, includeTimes: a.props.includeTimes, injectTimes: a.props.injectTimes, inline: a.props.inline, shouldFocusDayInline: a.state.shouldFocusDayInline, peekNextMonth: a.props.peekNextMonth, showMonthDropdown: a.props.showMonthDropdown, showPreviousMonths: a.props.showPreviousMonths, useShortMonthInDropdown: a.props.useShortMonthInDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showWeekNumbers: a.props.showWeekNumbers, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, forceShowMonthNavigation: a.props.forceShowMonthNavigation, showDisabledMonthNavigation: a.props.showDisabledMonthNavigation, scrollableYearDropdown: a.props.scrollableYearDropdown, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, todayButton: a.props.todayButton, weekLabel: a.props.weekLabel, outsideClickIgnoreClass: ca, fixedHeight: a.props.fixedHeight, monthsShown: a.props.monthsShown, monthSelectedIn: a.state.monthSelectedIn, onDropdownFocus: a.handleDropdownFocus, onMonthChange: a.props.onMonthChange, onYearChange: a.props.onYearChange, dayClassName: a.props.dayClassName, weekDayClassName: a.props.weekDayClassName, monthClassName: a.props.monthClassName, timeClassName: a.props.timeClassName, showDateSelect: a.props.showDateSelect, showTimeSelect: a.props.showTimeSelect, showTimeSelectOnly: a.props.showTimeSelectOnly, onTimeChange: a.handleTimeChange, timeFormat: a.props.timeFormat, timeIntervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, className: a.props.calendarClassName, container: a.props.calendarContainer, yearItemNumber: a.props.yearItemNumber, yearDropdownItemNumber: a.props.yearDropdownItemNumber, previousMonthAriaLabel: a.props.previousMonthAriaLabel, previousMonthButtonLabel: a.props.previousMonthButtonLabel, nextMonthAriaLabel: a.props.nextMonthAriaLabel, nextMonthButtonLabel: a.props.nextMonthButtonLabel, previousYearAriaLabel: a.props.previousYearAriaLabel, previousYearButtonLabel: a.props.previousYearButtonLabel, nextYearAriaLabel: a.props.nextYearAriaLabel, nextYearButtonLabel: a.props.nextYearButtonLabel, timeInputLabel: a.props.timeInputLabel, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderCustomHeader: a.props.renderCustomHeader, popperProps: a.props.popperProps, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, onDayMouseEnter: a.props.onDayMouseEnter, onMonthMouseLeave: a.props.onMonthMouseLeave, onYearMouseEnter: a.props.onYearMouseEnter, onYearMouseLeave: a.props.onYearMouseLeave, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showTimeInput: a.props.showTimeInput, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, showPopperArrow: a.props.showPopperArrow, excludeScrollbar: a.props.excludeScrollbar, handleOnKeyDown: a.props.onKeyDown, handleOnDayKeyDown: a.onDayKeyDown, isInputFocused: a.state.focused, customTimeInput: a.props.customTimeInput, setPreSelection: a.setPreSelection }, a.props.children) : null;
    }), k(L(a), "renderAriaLiveRegion", function() {
      var i, o = a.props, l = o.dateFormat, c = o.locale, u = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
      return i = a.props.selectsRange ? "Selected start date: ".concat(r5(a.props.startDate, { dateFormat: u, locale: c }), ". ").concat(a.props.endDate ? "End date: " + r5(a.props.endDate, { dateFormat: u, locale: c }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(r5(a.props.selected, { dateFormat: l, locale: c })) : a.props.showYearPicker ? "Selected year: ".concat(r5(a.props.selected, { dateFormat: "yyyy", locale: c })) : a.props.showMonthYearPicker ? "Selected month: ".concat(r5(a.props.selected, { dateFormat: "MMMM yyyy", locale: c })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(r5(a.props.selected, { dateFormat: "yyyy, QQQ", locale: c })) : "Selected date: ".concat(r5(a.props.selected, { dateFormat: u, locale: c })), x.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, i);
    }), k(L(a), "renderDateInput", function() {
      var i, o = y2(a.props.className, k({}, ca, a.state.open)), l = a.props.customInput || x.createElement("input", { type: "text" }), c = a.props.customInputRef || "ref", u = typeof a.props.value == "string" ? a.props.value : typeof a.state.inputValue == "string" ? a.state.inputValue : a.props.selectsRange ? function(d, C, p) {
        if (!d)
          return "";
        var h = r5(d, p), f = C ? r5(C, p) : "";
        return "".concat(h, " - ").concat(f);
      }(a.props.startDate, a.props.endDate, a.props) : r5(a.props.selected, a.props);
      return x.cloneElement(l, (k(k(k(k(k(k(k(k(k(k(i = {}, c, function(d) {
        a.input = d;
      }), "value", u), "onBlur", a.handleBlur), "onChange", a.handleChange), "onClick", a.onInputClick), "onFocus", a.handleFocus), "onKeyDown", a.onInputKeyDown), "id", a.props.id), "name", a.props.name), "form", a.props.form), k(k(k(k(k(k(k(k(k(k(i, "autoFocus", a.props.autoFocus), "placeholder", a.props.placeholderText), "disabled", a.props.disabled), "autoComplete", a.props.autoComplete), "className", y2(l.props.className, o)), "title", a.props.title), "readOnly", a.props.readOnly), "required", a.props.required), "tabIndex", a.props.tabIndex), "aria-describedby", a.props.ariaDescribedBy), k(k(k(i, "aria-invalid", a.props.ariaInvalid), "aria-labelledby", a.props.ariaLabelledBy), "aria-required", a.props.ariaRequired)));
    }), k(L(a), "renderClearButton", function() {
      var i = a.props, o = i.isClearable, l = i.disabled, c = i.selected, u = i.startDate, d = i.endDate, C = i.clearButtonTitle, p = i.clearButtonClassName, h = p === void 0 ? "" : p, f = i.ariaLabelClose, g = f === void 0 ? "Close" : f;
      return !o || c == null && u == null && d == null ? null : x.createElement("button", { type: "button", className: y2("react-datepicker__close-icon", h, { "react-datepicker__close-icon--disabled": l }), disabled: l, "aria-label": g, onClick: a.onClearClick, title: C, tabIndex: -1 });
    }), a.state = a.calcInitialState(), a.preventFocusTimeout = null, a;
  }
  return m2(r, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(n, a) {
    var i, o;
    n.inline && (i = n.selected, o = this.props.selected, i && o ? _2(i) !== _2(o) || H1(i) !== H1(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && n.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), n.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: ia(this.props.highlightDates) }), a.focused || c6(n.selected, this.props.selected) || this.setState({ inputValue: null }), a.open !== this.state.open && (a.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), a.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var n = this.props, a = n.showIcon, i = n.icon, o = n.calendarIconClassname, l = n.toggleCalendarOnIconClick, c = this.state.open;
    return x.createElement("div", { className: "react-datepicker__input-container".concat(a ? " react-datepicker__view-calendar-icon" : "") }, a && x.createElement(TM, a9({ icon: i, className: "".concat(o, " ").concat(c && "react-datepicker-ignore-onclickoutside") }, l ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var n = this.renderCalendar();
    if (this.props.inline)
      return n;
    if (this.props.withPortal) {
      var a = this.state.open ? x.createElement($o, { enableTabLoop: this.props.enableTabLoop }, x.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, n)) : null;
      return this.state.open && this.props.portalId && (a = x.createElement(Wo, { portalId: this.props.portalId, portalHost: this.props.portalHost }, a)), x.createElement("div", null, this.renderInputContainer(), a);
    }
    return x.createElement(VM, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: n, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: R9, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), r;
}(), EM = "input", X3 = "navigate";
const IM = (e) => {
  const t = new Date(0, 0, 0, 0, 0), { hours: r, minutes: n, seconds: a } = NM(e);
  return t.setHours(Number(r)), t.setMinutes(Number(n)), t.setSeconds(Number(a)), t;
}, ua = (e) => {
  const t = e.getHours(), r = e.getMinutes(), n = e.getSeconds();
  return t * 3600 + r * 60 + n;
}, DM = (e) => {
  const t = Math.floor(e / 3600), r = Math.floor(e % (60 * 60) / 60);
  return {
    hours: t < 10 ? `0${t}` : String(t),
    minutes: r < 10 ? `0${r}` : String(r)
  };
}, NM = (e) => {
  const { hours: t, minutes: r } = DM(e), n = e % 60;
  return {
    hours: t,
    minutes: r,
    seconds: n < 10 ? `0${n}` : String(n)
  };
}, v3 = n9(function({
  error: t,
  label: r,
  labelClassName: n,
  labelRightElement: a,
  htmlFor: i,
  nativeLabelProps: o,
  value: l,
  onChange: c,
  onFocus: u,
  maxLength: d,
  placeholder: C,
  isPreFetching: p,
  required: h,
  description: f,
  className: g,
  addonBefore: m,
  addonAfter: v,
  inputClassName: b,
  success: w,
  addonAfterClassName: M,
  addonBeforeClassName: y,
  statusIcon: _,
  statusIconClassName: S,
  labelContentWrapperClassName: j,
  errorAndDescriptionClassName: V,
  descriptionClassName: P,
  errorClassName: A,
  ...R
}, z) {
  const N = K(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    p ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), G = K(Fe, _ && "pr-9");
  return /* @__PURE__ */ s.jsxs(
    "label",
    {
      className: K("flex flex-col gap-1 text-sm font-medium", g),
      ...o,
      children: [
        /* @__PURE__ */ s.jsx(
          M6,
          {
            label: r,
            labelClassName: n,
            labelRightElement: a,
            required: h
          }
        ),
        /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: K(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              p && "animate-pulse",
              j
            ),
            children: [
              m && /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    N,
                    y
                  ),
                  children: m
                }
              ),
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ref: z,
                  className: K(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    G,
                    t ? "border-danger" : w ? "border-green" : "border-text-secondary/30",
                    p ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    m && "rounded-l-none",
                    v && "rounded-r-none",
                    b
                  ),
                  type: R.type || "text",
                  value: l,
                  onChange: c,
                  onFocus: u,
                  maxLength: d,
                  placeholder: C,
                  spellCheck: !1,
                  disabled: R.disabled || p,
                  ...R
                }
              ),
              v && /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    N,
                    M
                  ),
                  children: v
                }
              ),
              _ && /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: K(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    S
                  ),
                  children: _
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          X5,
          {
            description: f,
            error: t,
            className: V,
            descriptionClassName: P,
            errorClassName: A
          }
        )
      ]
    }
  );
});
function SP({
  inputRef: e,
  label: t,
  labelClassName: r,
  required: n,
  value: a,
  onChange: i,
  onFocus: o,
  maxLength: l,
  error: c,
  placeholder: u,
  onClear: d,
  description: C,
  testAttributePostfix: p,
  isPreFetching: h,
  searchIconClassName: f,
  closeIconClassName: g,
  errorAndDescriptionClassName: m,
  descriptionClassName: v,
  errorClassName: b,
  showSearchIcon: w,
  ...M
}) {
  return /* @__PURE__ */ s.jsxs("label", { className: `${M.className} relative flex flex-col gap-1 text-sm font-medium`, children: [
    /* @__PURE__ */ s.jsx(M6, { label: t, labelClassName: r, required: n }),
    (a === "" || w) && /* @__PURE__ */ s.jsx(
      qh,
      {
        className: K(
          "z-1 absolute right-4 h-[21px] w-[21px] translate-y-1/2 scale-75",
          t && "top-[24px]",
          f
        )
      }
    ),
    a !== "" && /* @__PURE__ */ s.jsx(
      w8,
      {
        onClick: d,
        className: K(
          "z-1 fill-text-primary absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer",
          t && "top-[24px]",
          g
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      "input",
      {
        ref: e,
        className: `text-text-primary main-transition-colors bg-background-secondary relative w-full rounded-lg border ${c ? "border-danger" : "border-text-secondary/30"} focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden ${h ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent" : "disabled:bg-background-tertiary/40"} ${M.inputClassName || ""}`,
        onKeyDown: (y) => M.type === "number" && ["e", "E", "+", "-"].includes(y.key) && y.preventDefault(),
        type: M.type || "text",
        disabled: M.disabled || h,
        value: a,
        onChange: i,
        onFocus: o,
        maxLength: l,
        placeholder: u || c1.t("public_pages_purchase.input.search"),
        spellCheck: !1,
        ...v4(!!p, `${p}`)
      }
    ),
    /* @__PURE__ */ s.jsx(
      X5,
      {
        description: C,
        error: c,
        className: m,
        descriptionClassName: v,
        errorClassName: b
      }
    )
  ] });
}
const kP = ({
  onChange: e,
  value: t = "",
  addonBefore: r,
  withCopyButton: n,
  buttonClassName: a,
  linkIconClassName: i,
  scheme: o = "https://",
  ...l
}) => {
  const c = t.replace(o, ""), u = ({ target: { value: d } }) => {
    if (!d || d === o)
      return e("");
    e(o + d.replace(o, ""));
  };
  return /* @__PURE__ */ s.jsx(
    v3,
    {
      type: "url",
      addonBefore: r || o,
      value: c,
      onChange: u,
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: n && /* @__PURE__ */ s.jsx(
        "button",
        {
          type: "button",
          onClick: async (d) => {
            d.preventDefault(), await Ob(t, c1.t("public_pages_purchase.copy_clipboard"));
          },
          className: K(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            a
          ),
          children: /* @__PURE__ */ s.jsx(
            zh,
            {
              className: K(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                i
              )
            }
          )
        }
      ),
      ...l
    }
  );
}, LP = ({
  value: e,
  onChange: t,
  type: r = "float",
  toFixed: n = 2,
  max: a,
  min: i,
  onBlur: o,
  ...l
}) => {
  const [c, u] = e1(e.toString());
  h1(() => {
    u(e.toString());
  }, [e]);
  const d = (p) => {
    const h = p.target.value;
    if (r === "integer")
      /^[0-9]*$/.test(h) && u(h);
    else {
      const f = h.replace(",", "."), g = new RegExp(`^-?\\d*(\\.\\d{0,${n}})?$`);
      f.match(g) !== null && u(f);
    }
  }, C = (p) => {
    let h;
    r === "integer" ? h = parseInt(c, 10) || 0 : h = parseFloat(c) || 0, a !== void 0 && (h = Math.min(h, a)), i !== void 0 && (h = Math.max(h, i)), r === "integer" && (h = Math.max(0, h)), t(h), u(r === "integer" ? h.toString() : h.toFixed(n)), o == null || o(p, h);
  };
  return /* @__PURE__ */ s.jsx(
    v3,
    {
      value: c,
      onChange: d,
      onBlur: C,
      min: r === "integer" ? "0" : void 0,
      type: "text",
      ...l
    }
  );
}, RM = "react-international-phone-", Jo = (...e) => e.filter((t) => !!t).join(" ").trim(), FM = (...e) => Jo(...e).split(" ").map((t) => `${RM}${t}`).join(" "), j2 = ({ addPrefix: e, rawClassNames: t }) => Jo(FM(...e), ...t), i5 = (e) => e.replace(/\D/g, ""), da = 35, OM = ({
  value: e,
  mask: t,
  maskSymbol: r,
  allowMoreDigitsThanMaskAllows: n,
  offset: a = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (e.length < a)
    return e;
  const o = e.slice(0, a), l = e.slice(a);
  let c = o, u = 0;
  for (const C of t.split("")) {
    if (u >= l.length) {
      if (!i && C !== r) {
        c += C;
        continue;
      }
      break;
    }
    C === r ? (c += l[u], u += 1) : c += C;
  }
  let d = i5(c);
  return n && d.length < e.length && (c += e.slice(d.length), d = i5(c)), d.length >= da && (c = c.slice(0, -(d.length - da) || void 0)), c;
}, BM = (e, t) => {
  const r = e.style.display;
  r !== "block" && (e.style.display = "block");
  const n = e.getBoundingClientRect(), a = t.getBoundingClientRect(), i = a.top - n.top, o = n.bottom - a.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? e.scrollTop += i : e.scrollTop -= o), e.style.display = r;
}, J2 = (e) => {
  const [t, r, n, a, i, o, l] = e;
  return {
    name: t,
    regions: r,
    iso2: n,
    dialCode: a,
    format: i,
    priority: o,
    areaCodes: l
  };
}, ZM = (e) => `Field "${e}" is not supported`, O6 = ({
  value: e,
  field: t,
  countries: r,
  defaultCountry: n
}) => {
  if (["regions", "priority"].includes(t))
    throw new Error(ZM(t));
  const a = r.find((i) => {
    const o = J2(i);
    return e === o[t];
  }) || r.find((i) => {
    const o = J2(i);
    return n.toLocaleLowerCase() === o[t];
  });
  if (a)
    return J2(a);
}, Ca = ({
  phone: e,
  countries: t,
  currentCountryIso2: r,
  defaultCountry: n
}) => {
  var c;
  const a = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!e)
    return a;
  const i = i5(e);
  if (!i)
    return a;
  let o = a;
  const l = ({
    country: u,
    fullDialCodeMatch: d,
    areaCodeMatch: C
  }) => {
    var f, g;
    const p = u.dialCode === ((f = o.country) == null ? void 0 : f.dialCode), h = (u.priority ?? 0) < (((g = o.country) == null ? void 0 : g.priority) ?? 0);
    (!p || h) && (o = { country: u, fullDialCodeMatch: d, areaCodeMatch: C });
  };
  for (const u of t) {
    const d = J2(u), { dialCode: C, areaCodes: p } = d;
    if (i.startsWith(C)) {
      const h = o.country ? Number(C) >= Number(o.country.dialCode) : !0;
      if (p) {
        const f = i.substring(C.length);
        for (const g of p)
          if (f.startsWith(g))
            return {
              country: d,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (h || C === i || !o.fullDialCodeMatch) && l({
        country: d,
        fullDialCodeMatch: !0,
        areaCodeMatch: p ? !p : void 0
      });
    }
    o.fullDialCodeMatch || i.length < C.length && C.startsWith(i) && (!o.country || Number(C) <= Number(o.country.dialCode)) && l({ country: d, fullDialCodeMatch: !1 });
  }
  if (r) {
    const u = O6({
      value: r,
      field: "iso2",
      countries: t,
      defaultCountry: n
    });
    !!o && !!u && // different countries with same dial code
    ((c = o.country) == null ? void 0 : c.dialCode) === u.dialCode && o.country !== u && // full dial code match (without area code)
    o.fullDialCodeMatch && !o.areaCodeMatch && (o = {
      country: u,
      areaCodeMatch: u != null && u.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return o;
}, GM = ({
  phone: e,
  dialCode: t,
  prefix: r = "+",
  charAfterDialCode: n = " "
}) => {
  if (!e || !t)
    return e;
  let a = e;
  return a.startsWith(r) && (a = a.replace(r, "")), a.startsWith(t) ? (a = a.replace(t, ""), a.startsWith(n) && (a = a.replace(n, "")), a) : e;
}, pa = ({
  phone: e,
  dialCode: t,
  prefix: r = "+",
  charAfterDialCode: n = " "
}) => `${r}${t}${n}${GM({
  phone: e,
  dialCode: t,
  charAfterDialCode: n,
  prefix: r
})}`, KM = (e, t) => {
  const r = t.disableDialCodeAndPrefix ? !1 : t.forceDialCode, n = t.disableDialCodeAndPrefix ? !1 : t.insertDialCodeOnEmpty;
  let a = e;
  const i = (u) => t.trimNonDigitsEnd ? u.trim() : u;
  if (!a)
    return n && !a.length || r ? i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`) : i(a);
  if (a = i5(a), a === t.dialCode && !t.disableDialCodeAndPrefix)
    return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
  if (t.dialCode.startsWith(a) && !t.disableDialCodeAndPrefix)
    return i(r ? `${t.prefix}${t.dialCode}${t.charAfterDialCode}` : `${t.prefix}${a}`);
  if (!a.startsWith(t.dialCode) && !t.disableDialCodeAndPrefix) {
    if (r)
      return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
    if (a.length < t.dialCode.length)
      return i(`${t.prefix}${a}`);
  }
  const o = () => {
    let u = t.dialCode.length;
    t.disableDialCodeAndPrefix && (u = 0);
    const d = a.slice(0, u), C = a.slice(u);
    return {
      phoneLeftSide: d,
      phoneRightSide: C
    };
  };
  let { phoneLeftSide: l, phoneRightSide: c } = o();
  return l = `${t.prefix}${l}${t.charAfterDialCode}`, c = OM({
    value: c,
    mask: t.mask,
    maskSymbol: t.maskChar,
    allowMoreDigitsThanMaskAllows: t.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: t.trimNonDigitsEnd
  }), t.disableDialCodeAndPrefix && (l = ""), i(`${l}${c}`);
}, P9 = (e) => /\d/.test(e), zM = ({
  phoneBeforeInput: e,
  phoneAfterInput: t,
  phoneAfterFormatted: r,
  cursorPositionAfterInput: n,
  leftOffset: a = 0,
  deletion: i
}) => {
  if (n < a)
    return a;
  if (!e)
    return r.length;
  const o = i === "backward";
  if (n === 0 && t.length > 0 && r.length > 0) {
    if (o)
      return 0;
    for (let C = 0; C < r.length; C += 1)
      if (P9(r[C]))
        return C;
    return r.length;
  }
  if (t.length < e.length && t.length === 1)
    return r.length;
  let l = null;
  for (let C = n - 1; C >= 0; C -= 1)
    if (P9(t[C])) {
      l = C;
      break;
    }
  if (l === null)
    return n !== 0 ? n : r.length;
  let c = 0;
  for (let C = 0; C < l; C += 1)
    P9(t[C]) && (c += 1);
  o && (c -= 1);
  let u = 0, d = 0;
  for (let C = 0; C < r.length && (u += 1, P9(r[C]) && (d += 1), d !== c + 1); C += 1)
    ;
  for (; !P9(r[u]) && u < r.length; )
    u += 1;
  return o && (u += 1), u;
}, r0 = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], _7 = "fr", UM = () => {
  const e = J(), t = J(Date.now());
  return {
    check: () => {
      const n = Date.now(), a = e.current ? n - t.current : void 0;
      return e.current = t.current, t.current = n, a;
    }
  };
}, YM = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function WM(e, t) {
  const { size: r, overrideLastItemDebounceMS: n, onChange: a } = {
    ...YM,
    ...t
  }, [i, o] = e1(e), [l, c] = e1([i]), [u, d] = e1(0), C = UM();
  return [i, (g, m) => {
    if (
      // compare entries if passed value is object
      typeof g == "object" && Object.entries(g).toString() === Object.entries(i).toString() || g === i
    )
      return;
    const v = n > 0, b = C.check(), w = v && b !== void 0 ? b > n : !0;
    if (
      // use value of config.overrideLastItem if passed
      (m == null ? void 0 : m.overrideLastItem) !== void 0 ? m.overrideLastItem : !w
    )
      c((y) => [...y.slice(0, u), g]);
    else {
      const y = l.length >= r;
      c((_) => [..._.slice(y ? 1 : 0, u + 1), g]), y || d((_) => _ + 1);
    }
    o(g), a == null || a(g);
  }, () => {
    if (u <= 0)
      return { success: !1 };
    const g = l[u - 1];
    return o(g), d((m) => m - 1), a == null || a(g), { success: !0, value: g };
  }, () => {
    if (u + 1 >= l.length)
      return { success: !1 };
    const g = l[u + 1];
    return o(g), d((m) => m + 1), a == null || a(g), { success: !0, value: g };
  }];
}
const $M = ".", T2 = {
  defaultCountry: _7,
  initialCountry: _7,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: r0,
  dontShowDialCodePrefillOnFocus: !1
}, JM = ({
  defaultCountry: e = T2.defaultCountry,
  initialCountry: t = T2.initialCountry,
  value: r = T2.value,
  countries: n = T2.countries,
  prefix: a = T2.prefix,
  defaultMask: i = T2.defaultMask,
  allowMoreDigitsThanMaskAllows: o = T2.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: l = T2.charAfterDialCode,
  historySaveDebounceMS: c = T2.historySaveDebounceMS,
  disableCountryGuess: u = T2.disableCountryGuess,
  disableDialCodePrefill: d = T2.disableDialCodePrefill,
  forceDialCode: C = T2.forceDialCode,
  disableDialCodeAndPrefix: p = T2.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: h = T2.dontShowDialCodePrefillOnFocus,
  onChange: f
}) => {
  const g = r || "", m = p ? !1 : !u, v = J(null), b = ({
    value: Z,
    country: E,
    trimNonDigitsEnd: F,
    insertDialCodeOnEmpty: I,
    forceDisableCountryGuess: T
  }) => {
    const D = !T && m ? Ca({
      phone: Z,
      countries: n,
      currentCountryIso2: E.iso2,
      defaultCountry: e
    }) : void 0, $ = (D == null ? void 0 : D.country) ?? E;
    return { phone: $ ? KM(Z, {
      prefix: a,
      mask: $.format || i,
      maskChar: $M,
      dialCode: $.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: F,
      charAfterDialCode: l,
      forceDialCode: C,
      insertDialCodeOnEmpty: I,
      disableDialCodeAndPrefix: p
    }) : Z, countryGuessResult: D, formatCountry: $ };
  }, w = (Z) => {
    typeof document < "u" && document.activeElement === v.current && Promise.resolve().then(() => {
      var E;
      (E = v.current) == null || E.setSelectionRange(Z, Z);
    });
  }, M = y1(
    ({ phone: Z, country: E }) => f == null ? void 0 : f({
      phone: Z,
      unformatedPhone: i5(Z),
      country: E,
      prefix: a
    }),
    [f, a]
  ), [{ phone: y, country: _ }, S, j, V] = WM(
    () => {
      const E = Ca({
        phone: g,
        countries: n,
        currentCountryIso2: t,
        defaultCountry: e
      }).country || O6({
        value: t,
        field: "iso2",
        countries: n,
        defaultCountry: e
      });
      E || console.error(
        `[react-international-phone]: can not find a country with "${e}" iso2 code`
      );
      const F = E || // set "us" if user provided not valid country
      J2(n.find((T) => J2(T).iso2 === _7)), I = b({
        value: g,
        country: F,
        insertDialCodeOnEmpty: h ? !d : !1
      }).phone;
      return w(I.length), {
        phone: I,
        country: F.iso2
      };
    },
    {
      overrideLastItemDebounceMS: c,
      onChange: M
    }
  ), P = Q(() => O6({
    value: _,
    field: "iso2",
    countries: n,
    defaultCountry: e
  }), [n, _, e]), A = y1(() => {
    var Z;
    h || (Z = v == null ? void 0 : v.current) != null && Z.value || M == null || M({
      phone: pa({
        phone: y,
        dialCode: P.dialCode,
        charAfterDialCode: l,
        prefix: a
      }),
      country: _
    });
  }, [
    l,
    _,
    P,
    M,
    y,
    a,
    h
  ]), R = (Z, {
    deletion: E,
    cursorPosition: F,
    insertDialCodeOnEmpty: I,
    inserted: T
  } = {}) => {
    var d1;
    let B = Z, D = F;
    C && !p && P && // dial code has been changed
    !i5(Z).startsWith(P.dialCode) && Z && (T && Z.startsWith(a) && // cursor position was set to 0 before the input
    Z.length - (F ?? 0) === 0 ? B = Z : (B = y, D = 0));
    const { phone: $, countryGuessResult: W } = b({
      value: B,
      country: P,
      trimNonDigitsEnd: E === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: I,
      forceDisableCountryGuess: C && !!E && i5(B).length < P.dialCode.length
    });
    let i1 = P;
    m && (W != null && W.country) && W.country.name !== _ && W.fullDialCodeMatch && (i1 = W.country);
    const r1 = zM({
      cursorPositionAfterInput: D ?? 0,
      phoneBeforeInput: y,
      phoneAfterInput: Z,
      phoneAfterFormatted: $,
      leftOffset: C ? a.length + (((d1 = P == null ? void 0 : P.dialCode) == null ? void 0 : d1.length) ?? 0) + l.length : 0,
      deletion: E
    });
    return S({
      phone: $,
      country: i1.iso2
    }), w(r1), $;
  };
  h1(() => {
    const Z = v.current;
    if (!Z)
      return;
    const E = (F) => {
      if (!F.key)
        return;
      const I = F.ctrlKey, T = F.shiftKey, B = F.key.toLowerCase() === "z";
      !I || !B || (T ? V() : j());
    };
    return Z.addEventListener("keydown", E), () => {
      Z.removeEventListener("keydown", E);
    };
  }, [v, j, V]);
  const z = (Z) => {
    Z.preventDefault();
    const E = Z.nativeEvent.inputType, F = () => {
      if ((E == null ? void 0 : E.toLocaleLowerCase().includes("delete")) ?? !1)
        return E != null && E.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, I = E == null ? void 0 : E.startsWith("insertFrom"), T = R(Z.target.value, {
      deletion: F(),
      inserted: I,
      cursorPosition: Z.target.selectionStart ?? 0
    });
    return p && P ? pa({
      phone: T,
      dialCode: P.dialCode,
      charAfterDialCode: l,
      prefix: a
    }) : T;
  }, N = (Z) => {
    const E = O6({
      value: Z,
      field: "iso2",
      countries: n,
      defaultCountry: e
    });
    if (!E)
      return;
    const F = p ? "" : `${a}${E.dialCode}${l}`;
    S({
      phone: F,
      country: E.iso2
    }), Promise.resolve().then(() => {
      var I;
      (I = v.current) == null || I.focus();
    });
  }, [G, U] = e1(!1);
  return h1(() => {
    if (!G) {
      U(!0), g !== y && (M == null || M({ phone: y, country: _ }));
      return;
    }
    i5(g) !== i5(y) && R(i5(g));
  }, [g]), h1(() => {
    if (!y && t) {
      const Z = O6({
        value: t,
        field: "iso2",
        countries: n,
        defaultCountry: e
      });
      S({
        phone: y,
        country: (Z == null ? void 0 : Z.iso2) || e
      });
    }
  }, [t]), {
    phone: y,
    // Formatted phone string.
    country: _,
    // Current country iso code.
    setCountry: N,
    // Country setter.
    handlePhoneValueChange: z,
    // Change handler for input component
    onFocus: A,
    inputRef: v
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
};
const qM = (e, t) => {
  const r = parseInt(e, 16);
  return Number(r + t).toString(16);
}, QM = "abcdefghijklmnopqrstuvwxyz", XM = "1f1e6", ha = QM.split("").reduce((e, t, r) => ({
  ...e,
  // construct alphabet by incrementing A letter codepoint value
  [t]: qM(XM, r)
}), {}), eS = (e) => [ha[e[0]], ha[e[1]]].join("-"), qo = ({
  iso2: e,
  size: t = "24px",
  protocol: r = "https",
  disableLazyLoading: n,
  className: a,
  ...i
}) => {
  if (!e)
    return /* @__PURE__ */ s.jsx("img", { width: t, height: t, ...i });
  const o = eS(e), l = `${r}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ s.jsx(
    "img",
    {
      className: j2({
        addPrefix: ["flag-emoji"],
        rawClassNames: [a]
      }),
      src: l,
      width: t,
      height: t,
      draggable: !1,
      "data-country": e,
      loading: n ? void 0 : "lazy",
      ...i
    }
  );
};
const Qo = ({
  show: e,
  dialCodePrefix: t = "+",
  selectedCountry: r,
  countries: n = r0,
  onSelect: a,
  onClose: i,
  searchInputPlaceholder: o,
  ...l
}) => {
  const c = J(null), u = J(null), d = J(), [C, p] = e1(""), h = Q(() => {
    if (C) {
      const _ = C.toLowerCase();
      return n.filter(([S]) => S.toLowerCase().includes(_));
    } else
      return n;
  }, [n, C]), f = y1(
    (_) => h.findIndex((S) => J2(S).iso2 === _),
    [h]
  ), [g, m] = e1(f(r)), v = () => {
    d.current !== r && m(f(r));
  }, b = y1(
    (_) => {
      m(f(_.iso2)), a == null || a(_);
    },
    [a, f]
  ), w = (_) => {
    const S = h.length - 1, j = (V) => _ === "prev" ? V - 1 : _ === "next" ? V + 1 : _ === "last" ? S : 0;
    m((V) => {
      const P = j(V);
      return P < 0 ? 0 : P > S ? S : P;
    });
  }, M = (_) => {
    if (_.stopPropagation(), _.key === "Enter") {
      const S = J2(h[g]);
      b(S);
      return;
    }
    if (_.key === "Escape") {
      i == null || i();
      return;
    }
    if (_.key === "ArrowUp") {
      _.preventDefault(), w("prev");
      return;
    }
    if (_.key === "ArrowDown") {
      _.preventDefault(), w("next");
      return;
    }
    if (_.key === "PageUp") {
      _.preventDefault(), w("first");
      return;
    }
    if (_.key === "PageDown") {
      _.preventDefault(), w("last");
      return;
    }
    _.key === " " && _.preventDefault();
  }, y = y1(() => {
    if (!u.current || g === void 0 || !h[g])
      return;
    const _ = J2(h[g]).iso2;
    if (_ === d.current)
      return;
    const S = u.current.querySelector(`[data-country="${_}"]`);
    S && (BM(u.current, S), d.current = _);
  }, [g, h]);
  return h1(() => {
    y();
  }, [g, y]), h1(() => {
    c.current && (e ? Promise.resolve().then(() => {
      var _;
      return (_ = c.current) == null ? void 0 : _.focus();
    }) : v());
  }, [e]), h1(() => {
    v();
  }, [r]), /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: j2({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [l.className]
      }),
      style: { display: e ? "block" : "none", ...l.style },
      tabIndex: -1,
      "aria-activedescendant": `${h[g] && J2(h[g]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            ref: c,
            className: j2({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [l.searchInputClassName]
            }),
            placeholder: o || "",
            style: l.searchInputStyle,
            type: "text",
            value: C,
            onChange: (_) => p(_.target.value),
            onKeyDown: M
          }
        ),
        C && /* @__PURE__ */ s.jsx(
          w8,
          {
            onClick: () => p(""),
            className: j2({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [l.clearSearchInputClassName]
            }),
            style: l.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ s.jsx(
          "ul",
          {
            ref: u,
            role: "listbox",
            className: j2({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [l.listClassName]
            }),
            style: l.listStyle,
            children: h.map((_, S) => {
              const j = J2(_), V = j.iso2 === r, P = S === g;
              return /* @__PURE__ */ s.jsxs(
                "li",
                {
                  "data-country": j.iso2,
                  "data-focused": P,
                  role: "option",
                  "aria-selected": V,
                  "aria-label": `${j.name} ${t}${j.dialCode}`,
                  id: `${j.iso2}-option`,
                  className: j2({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      V && "country-selector-dropdown__list-item--selected",
                      P && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [l.listItemClassName]
                  }),
                  onClick: () => b(j),
                  style: l.listItemStyle,
                  children: [
                    /* @__PURE__ */ s.jsx(
                      qo,
                      {
                        iso2: j.iso2,
                        className: j2({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [l.listItemFlagClassName]
                        }),
                        style: l.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      "span",
                      {
                        className: j2({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [l.listItemCountryNameClassName]
                        }),
                        style: l.listItemCountryNameStyle,
                        children: j.name
                      }
                    ),
                    /* @__PURE__ */ s.jsxs(
                      "span",
                      {
                        className: j2({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [l.listItemDialCodeClassName]
                        }),
                        style: l.listItemDialCodeStyle,
                        children: [
                          t,
                          j.dialCode
                        ]
                      }
                    )
                  ]
                },
                j.iso2
              );
            })
          }
        )
      ]
    }
  );
};
const tS = ({
  selectedCountry: e,
  onSelect: t,
  disabled: r,
  hideDropdown: n,
  defaultCountry: a = _7,
  countries: i = r0,
  renderButtonWrapper: o,
  ...l
}) => {
  const [c, u] = e1(!1), d = Q(() => {
    if (e)
      return O6({
        value: e,
        field: "iso2",
        countries: i,
        defaultCountry: a
      });
  }, [i, a, e]), C = J(null), p = (f) => {
    f.key && ["ArrowUp", "ArrowDown"].includes(f.key) && (f.preventDefault(), u(!0));
  }, h = () => {
    const f = {
      title: d == null ? void 0 : d.name,
      onClick: () => u((m) => !m),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (m) => m.preventDefault(),
      onKeyDown: p,
      disabled: n || r,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": c
    }, g = /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: j2({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [l.buttonContentWrapperClassName]
        }),
        style: l.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ s.jsx(
            qo,
            {
              iso2: e,
              className: j2({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  r && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [l.flagClassName]
              }),
              style: {
                visibility: e ? "visible" : "hidden",
                ...l.flagStyle
              }
            }
          ),
          !n && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: j2({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  r && "country-selector-button__dropdown-arrow--disabled",
                  c && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [l.dropdownArrowClassName]
              }),
              style: l.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: g,
      rootProps: f
    }) : /* @__PURE__ */ s.jsx(
      "button",
      {
        ...f,
        type: "button",
        className: j2({
          addPrefix: [
            "country-selector-button",
            c && "country-selector-button--active",
            r && "country-selector-button--disabled",
            n && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [l.buttonClassName]
        }),
        "data-country": e,
        style: l.buttonStyle,
        children: g
      }
    );
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: j2({
        addPrefix: ["country-selector"],
        rawClassNames: [l.className]
      }),
      style: l.style,
      ref: C,
      children: [
        h(),
        /* @__PURE__ */ s.jsx(
          Qo,
          {
            show: c,
            countries: i,
            onSelect: (f) => {
              u(!1), t == null || t(f);
            },
            selectedCountry: e,
            onClose: () => {
              u(!1);
            },
            ...l.dropdownStyleProps
          }
        )
      ]
    }
  );
};
const HP = ({
  label: e,
  labelClassName: t,
  required: r,
  value: n,
  onChange: a,
  error: i,
  wrapperClassName: o,
  inputClassName: l,
  listClassName: c,
  searchInputClassName: u,
  clearSearchInputClassName: d,
  listItemClassName: C,
  listItemCountryNameClassName: p,
  countrySelectorDropdownClassName: h,
  countrySelectorClassName: f,
  buttonClassName: g,
  listboxButtonClassName: m,
  listboxOptionsClassName: v,
  initialCountry: b,
  ...w
}) => {
  const M = J(null), y = J(null), _ = J(null), { country: S, setCountry: j, phone: V, handlePhoneValueChange: P, onFocus: A, inputRef: R } = JM({
    value: n,
    onChange: ({ unformatedPhone: z }) => a(z),
    initialCountry: b == null ? void 0 : b.toLowerCase()
  });
  return /* @__PURE__ */ s.jsx("div", { className: o, children: /* @__PURE__ */ s.jsx(e3, { children: ({ open: z }) => {
    var N;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ s.jsx(
          M6,
          {
            label: e,
            required: r,
            labelClassName: K("text-sm font-medium", t)
          }
        ),
        /* @__PURE__ */ s.jsxs(
          "div",
          {
            ref: y,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ s.jsxs(
                z6,
                {
                  ref: _,
                  as: "div",
                  disabled: w.disabled,
                  className: K(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    m,
                    w.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ s.jsx(
                      tS,
                      {
                        className: K("flex", f),
                        buttonStyle: { border: "none" },
                        buttonClassName: K(
                          w.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          g
                        ),
                        hideDropdown: !0,
                        disabled: w.disabled,
                        selectedCountry: S,
                        defaultCountry: b == null ? void 0 : b.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      br,
                      {
                        className: `transition-transform duration-300 ${z && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ s.jsx(
                v3,
                {
                  ref: R,
                  type: "tel",
                  placeholder: c1.t("public_pages_purchase.input.phone_number"),
                  inputClassName: K(
                    "pl-16",
                    z && "border-brand-primary",
                    l
                  ),
                  value: V,
                  onChange: P,
                  onFocus: A,
                  error: i,
                  ...w
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(
        x8,
        {
          className: K("focus-visible:outline-hidden", v),
          children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: M,
              style: {
                width: `${(N = R.current) == null ? void 0 : N.clientWidth}px`
              },
              children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
                Qo,
                {
                  className: K(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    h
                  ),
                  listClassName: K(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    c
                  ),
                  searchInputClassName: K(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    u
                  ),
                  clearSearchInputClassName: K(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    d
                  ),
                  listItemClassName: K(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    C
                  ),
                  listItemCountryNameClassName: K(
                    "truncate",
                    p
                  ),
                  searchInputPlaceholder: c1.t("public_pages_purchase.input.phone_search"),
                  show: z,
                  selectedCountry: S,
                  onSelect: (G) => {
                    var U;
                    j(G.iso2), (U = _.current) == null || U.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
}, aS = (e) => {
  const t = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return e.split(/([^\w])/g).map((r) => t[r] || r).join("");
}, nS = (e, t) => {
  const r = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, n = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, a = (l, c) => l.split(/([ :/])/).map(
    (u) => u.split("").map((d) => c[d] || d).join("")
  ).join(""), i = a(e, n), o = a(t, r);
  return {
    timeFormat: i,
    dateFormat: o
  };
}, PP = ({
  seconds: e,
  onChangeSeconds: t,
  containerClassName: r,
  userDateFormat: n,
  userTimeFormat: a,
  classNameCustomInput: i,
  wrapperClassName: o,
  showTimeSelect: l = !0,
  showTimeSelectOnly: c = !0,
  timeIntervals: u = 15,
  ...d
}) => {
  const { timeFormat: C } = n && a ? nS(a, n) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ s.jsx("div", { className: K("w-min", r), children: /* @__PURE__ */ s.jsx(
      g3,
      {
        disabled: d.disabled || d.isPreFetching,
        selected: typeof e == "number" ? IM(e) : null,
        onChange: (p) => {
          p && t(ua(p));
        },
        showTimeSelect: l,
        showTimeSelectOnly: c,
        timeIntervals: u,
        timeCaption: c1.t("public_pages_purchase.date_picker.time"),
        timeFormat: C,
        dateFormat: C,
        placeholderText: aS(C),
        customInput: /* @__PURE__ */ s.jsx(v3, { className: K("w-32", i), ...d }),
        timeClassName: (p) => e === ua(p) ? "text-brand-primary" : "text-text-primary",
        wrapperClassName: K("time-only", o)
      }
    ) })
  );
};
var F4 = /* @__PURE__ */ ((e) => (e.DateSince = "dateSince", e.DateTill = "dateTill", e))(F4 || {}), F9 = /* @__PURE__ */ ((e) => (e.Last30Days = "last_30_days", e.ThisMonth = "this_month", e.LastMonth = "last_month", e))(F9 || {}), f6 = /* @__PURE__ */ ((e) => (e.AllTime = "all_time", e.Last3Months = "last_3_months", e.EvaluationPeriod = "evaluation_period", e))(f6 || {});
const b3 = n9(
  ({
    onClick: e,
    error: t,
    label: r,
    labelClassName: n,
    required: a,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: l,
    children: c,
    value: u
  }, d) => /* @__PURE__ */ s.jsxs("div", { className: K("flex flex-col gap-1", i), children: [
    /* @__PURE__ */ s.jsx(M6, { label: r, labelClassName: n, required: a }),
    /* @__PURE__ */ s.jsxs("button", { onClick: e, ref: d, type: "button", className: o, children: [
      c(u),
      /* @__PURE__ */ s.jsx(
        Eh,
        {
          className: K(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            u ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(X5, { error: t, description: l })
  ] })
);
b3.displayName = "ButtonInput";
const i0 = ({
  date: e,
  prevMonthButtonDisabled: t,
  nextMonthButtonDisabled: r,
  increaseMonth: n,
  decreaseMonth: a,
  intlLocale: i
}) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between px-2 py-2", children: [
  /* @__PURE__ */ s.jsx(
    "button",
    {
      onClick: a,
      disabled: t,
      type: "button",
      className: K(
        "group rounded-full outline-hidden  ",
        t && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ s.jsx(jh, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  ),
  /* @__PURE__ */ s.jsx("span", { className: "text-text-primary text-base", children: new Intl.DateTimeFormat(i, {
    month: "long",
    year: "numeric"
  }).format(e) }),
  /* @__PURE__ */ s.jsx(
    "button",
    {
      onClick: n,
      disabled: r,
      type: "button",
      className: K(
        "group rounded-full outline-hidden ",
        r && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ s.jsx(yr, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  )
] }), o0 = (e, t) => {
  h1(() => {
    (async () => {
      try {
        if (e) {
          let n;
          switch (e) {
            case j1.ENGLISH:
            case "en":
              n = await import("./index-DrlaV7UC.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.FRENCH:
            case "fr":
              n = await import("./index-DLqwu96s.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.SPANISH:
            case "es":
              n = await import("./index-9InrCJEw.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.ITALIAN:
            case "it":
              n = await import("./index-BKVEvGIg.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.PORTUGUESE:
            case "pt":
              n = await import("./index-DLZy-nFl.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.DEUTSCH:
            case "de":
              n = await import("./index-obhAk3mP.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.DUTCH:
            case "nl":
              n = await import("./index-dKIIb7If.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.RUSSIAN:
            case "ru":
              n = await import("./index-Cgfd5RsD.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.JAPANESE:
            case "ja":
              n = await import("./index-CzkEWaVc.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.ARABIC:
            case "ar":
              n = await import("./index-BRPuSeNm.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.TURKISH:
            case "tr":
              n = await import("./index-3a51ZrHP.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.CHINESE:
            case "zh":
              n = await import("./index-iIdoHN2f.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.SWEDISH:
            case "sv":
              n = await import("./index-VETBXfiw.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.ROMANIAN:
            case "ro":
              n = await import("./index-B4ttz2W4.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.CZECH:
            case "cs":
              n = await import("./index-DGnYhvIl.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.HUNGARIAN:
            case "hu":
              n = await import("./index-dNedhFi7.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.SLOVAK:
            case "sk":
              n = await import("./index-D1qbcCoD.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.DANISH:
            case "da":
              n = await import("./index-B-S5M0Yr.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.INDONESIAN:
            case "id":
              n = await import("./index-TGPjk2u5.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.POLISH:
            case "pl":
              n = await import("./index-CLyD7xfg.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.GREEK:
            case "el":
              n = await import("./index-8bsrdm6e.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.SERBIAN:
            case "sr":
              n = await import("./index-Cg4Ymraq.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.NORWEGIAN:
            case "no":
              n = await import("./index-DK4wdavt.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.THAI:
            case "th":
              n = await import("./index-CoRgkZwL.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.SLOVENIAN:
            case "sl":
              n = await import("./index-DUuEL67y.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.UKRAINIAN:
            case "uk":
              n = await import("./index-BaTj4SXI.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.ALBANIA:
            case "sq":
              n = await import("./index-DJvTXgKt.mjs").then((a) => a.i).then((a) => a.default);
              break;
            case j1.HINDI:
            case "hi":
              n = await import("./index-DpV4LBH9.mjs").then((a) => a.i).then((a) => a.default);
              break;
            default:
              n = await import("./index-DrlaV7UC.mjs").then((a) => a.i).then((a) => a.default);
              break;
          }
          n && t(n);
        } else {
          const n = await import("./index-DrlaV7UC.mjs").then((a) => a.i).then((a) => a.default);
          t(n);
        }
      } catch (n) {
        console.error("Error loading locale:", n), t(h9);
      }
    })();
  }, [e, t]);
}, TP = ({
  value: e,
  onChange: t,
  error: r,
  label: n,
  required: a,
  placeholder: i,
  description: o,
  customProps: l,
  wrapperButtonInputClassName: c,
  labelClassName: u,
  timezone: d,
  intlLocale: C,
  disableApplyButton: p,
  ...h
}) => {
  const [f, g] = e1(
    e && i2(e, d) || null
  ), [m, v] = e1(
    e && i2(e, d) || null
  ), [b, w] = e1(h9), M = J(null);
  return h1(() => {
    e && !f && !m && d && (g(i2(e, d)), v(i2(e, d)));
  }, [e, d, f, m]), o0(C, w), /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
    g3,
    {
      ref: M,
      selected: f,
      showTimeSelect: !0,
      dayClassName: (y) => f && m && y.toDateString() === m.toDateString() && f.toDateString() !== m.toDateString() ? "text-brand-primary/50" : "",
      timeClassName: (y) => f && m && y.getTime() === m.getTime() && f.getTime() !== m.getTime() ? "text-brand-primary/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        g(m);
      },
      timeFormat: "HH:mm",
      timeIntervals: 15,
      timeCaption: c1.t("public_pages_purchase.date_picker.time"),
      timeInputLabel: c1.t("public_pages_purchase.date_picker.time"),
      onChange: (y) => {
        y && g(y);
      },
      locale: b,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ s.jsx(
        b3,
        {
          error: r,
          label: n,
          required: a,
          wrapperButtonInputClassName: c,
          buttonInputClassName: `flex group justify-between min-w-[250px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${r ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          description: o,
          labelClassName: u,
          children: () => /* @__PURE__ */ s.jsx("span", { children: m ? new Intl.DateTimeFormat(C, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hourCycle: "h23",
            minute: "2-digit"
          }).format(m) : /* @__PURE__ */ s.jsx("span", { className: "text-text-tertiary/70", children: i }) })
        }
      ),
      renderCustomHeader: ({
        date: y,
        decreaseMonth: _,
        increaseMonth: S,
        prevMonthButtonDisabled: j,
        nextMonthButtonDisabled: V
      }) => /* @__PURE__ */ s.jsx(
        i0,
        {
          date: y,
          decreaseMonth: _,
          increaseMonth: S,
          prevMonthButtonDisabled: j,
          nextMonthButtonDisabled: V,
          intlLocale: C
        }
      ),
      ...h,
      ...l,
      children: /* @__PURE__ */ s.jsxs("div", { className: "flex w-full justify-center gap-5 sm:col-span-2", children: [
        /* @__PURE__ */ s.jsx(
          $i,
          {
            disabled: !f || (p == null ? void 0 : p(f)),
            onClick: () => {
              var y;
              f && ((y = M.current) == null || y.setOpen(!1), v(f), t(o6(f)));
            },
            width: "large",
            children: c1.t("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ji,
          {
            onClick: () => {
              var y;
              (y = M.current) == null || y.setOpen(!1), v(null), t(null);
            },
            width: "large",
            children: c1.t("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
}, rS = {
  [F9.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [F9.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [F9.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, iS = {
  [f6.AllTime]: "public_pages_purchase.date_picker.all_time",
  [f6.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [f6.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, oS = (e) => c1.t(rS[e]), sS = (e) => c1.t(iS[e]);
function fa(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function lS(e, t) {
  t1(2, arguments);
  var r = o1(e), n = o1(t), a = fa(r, n), i = Math.abs(q9(r, n));
  r.setDate(r.getDate() - a * i);
  var o = +(fa(r, n) === -a), l = a * (i - o);
  return l === 0 ? 0 : l;
}
const cS = (e, t, r) => (e && t && lS(t, e) > r && (e = new Date(t.getTime() - r * 24 * 60 * 60 * 1e3)), [e, t]), uS = (e) => Object.values(f6).includes(
  e
), dS = ({
  activeFilter: e,
  setDateRange: t,
  timezone: r,
  customFilters: n
}) => {
  var i;
  if (uS(e)) {
    const o = (i = n.find((l) => l.slug === e)) == null ? void 0 : i.handler;
    o && t(o());
  } else
    switch (e) {
      case "last_30_days": {
        const o = i2("", r);
        o.setHours(23, 59, 59, 999);
        const l = new Date(o);
        l.setDate(l.getDate() - 30), l.setHours(0, 0, 0, 0), t([l, o]);
        break;
      }
      case "this_month": {
        const o = i2("", r), l = o.getFullYear(), c = o.getMonth(), u = new Date(l, c, 1), d = new Date(l, c + 1, 0);
        t([u, d]);
        break;
      }
      case "last_month": {
        const o = i2("", r), l = o.getFullYear(), c = o.getMonth(), u = new Date(l, c - 1, 1), d = new Date(l, c, 0);
        t([u, d]);
        break;
      }
    }
}, CS = (e, t) => {
  const r = i2("", t);
  return r.setHours(23, 59, 59, 999), [i2(e, t), r];
}, pS = (e) => {
  const t = i2("", e);
  t.setHours(23, 59, 59, 999);
  const r = i2("", e);
  return r.setMonth(r.getMonth() - 3), r.setHours(0, 0, 0, 0), [r, t];
}, ma = (e, t) => ({
  slug: f6.AllTime,
  handler: () => CS(e, t)
}), jP = (e) => ({
  slug: f6.Last3Months,
  handler: () => pS(e)
}), hS = (e) => (e.setHours(0, 0, 0, 0), e), Xo = (e) => (e.setHours(23, 59, 59, 999), e), VP = ({
  date: e,
  light: t,
  getDefaultDate: r,
  small: n,
  customFilters: a,
  filtersDisabled: i,
  onChange: o,
  placeholder: l,
  error: c,
  description: u,
  disabled: d,
  label: C,
  required: p,
  maxDate: h,
  minDate: f,
  wrapperButtonInputClassName: g,
  intlLocale: m,
  createdAt: v,
  timezone: b,
  dateFormat: w,
  customProps: M,
  labelClassName: y,
  maxInterval: _,
  showActionsSideBar: S = !0
}) => {
  const j = J(null), [V, P] = e1(h9), A = Q(
    () => (f && o6(f)) ?? v,
    [f, v]
  ), R = (_1) => !m || !A || !_1 ? _1 : Z8(A) > Z8(_1) ? A : _1, [z, N] = e, G = R(e[0]), [U, Z] = e1(), [E, F] = e1(), [I, T] = e1([
    G && i2(G, b) || null,
    N && i2(N, b) || null
  ]), [B, D] = I, [$, W] = e1(
    G && i2(G, b) || null
  ), [i1, r1] = e1(
    N && i2(N, b) || null
  );
  h1(() => {
    !b || !A || dS({
      activeFilter: E,
      timezone: b,
      setDateRange: T,
      customFilters: a || [ma(A, b)]
    });
  }, [U, E, a, A]), o0(m, P), h1(() => {
    if (G && N && b) {
      const _1 = i2(G, b), p1 = i2(N, b);
      T([_1, p1]), W(_1), r1(p1);
    }
  }, [e, G, N, b]);
  const d1 = /* @__PURE__ */ s.jsxs("div", { className: "flex w-full flex-col gap-3 px-2 sm:flex-row sm:gap-5", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex w-fit sm:w-full", children: [
      /* @__PURE__ */ s.jsxs("span", { className: "text-text-secondary pr-1", children: [
        c1.t("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ s.jsx("span", { className: "text-text-primary", children: B ? vt(B, { dateFormat: w }) : "-" })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex w-fit sm:w-full sm:pl-2", children: [
      /* @__PURE__ */ s.jsxs("span", { className: "text-text-secondary pr-1", children: [
        c1.t("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ s.jsx("span", { className: "text-text-primary", children: D ? vt(D, { dateFormat: w }) : "-" })
    ] })
  ] }), m1 = /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Ji,
      {
        disabled: d,
        onClick: () => {
          var _1;
          if ((_1 = j.current) == null || _1.setOpen(!1), r) {
            const [p1, T1] = r(), l1 = R(p1) ?? void 0, k1 = i2(l1, b), r2 = i2(T1, b);
            r1(r2), W(k1), o([
              o6(k1),
              o6(r2)
            ]);
          } else
            r1(null), W(null), o([null, null]);
          Z(void 0);
        },
        className: "w-full",
        children: c1.t("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ s.jsx(
      $i,
      {
        disabled: !I[0] || !I[1] || d,
        className: "w-full",
        onClick: () => {
          var T1;
          const [_1, p1] = I;
          _1 && p1 ? (W(_1), r1(p1), Z(E), hS(_1), Xo(p1), o([o6(_1), o6(p1)])) : o([null, null]), (T1 = j.current) == null || T1.setOpen(!1);
        },
        children: c1.t("public_pages_purchase.date_picker.apply")
      }
    )
  ] }), Q1 = S ? (_1) => /* @__PURE__ */ s.jsxs(
    "div",
    {
      ..._1,
      className: K(
        "flex flex-col justify-center gap-4 sm:flex-row sm:gap-5",
        _1.className
      ),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-4 md:mb-4", children: [
          /* @__PURE__ */ s.jsx("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: _1.children }),
          d1
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "sm:border-text-secondary/30 flex w-full flex-col items-center justify-center gap-5 border-transparent sm:m-auto sm:border-t sm:p-2 md:w-fit md:border-l md:border-t-0 md:pl-5", children: [
          /* @__PURE__ */ s.jsxs("ul", { className: "hidden w-1/2 gap-5 sm:flex sm:flex-col md:w-full", children: [
            Object.values(F9).map((p1) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
              yt,
              {
                className: "w-full",
                disabled: !b || i || d,
                onClick: () => {
                  F(p1);
                },
                selected: p1 === E,
                children: oS(p1)
              }
            ) }, p1)),
            (a || [ma(A, b)]).map(
              (p1) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
                yt,
                {
                  className: "w-full",
                  disabled: i || d,
                  onClick: () => {
                    F(p1.slug);
                  },
                  selected: p1.slug === E,
                  children: sS(p1.slug)
                }
              ) }, p1.slug)
            )
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "flex w-full justify-between gap-3 sm:w-1/2 md:w-full", children: m1 })
        ] })
      ]
    }
  ) : (_1) => /* @__PURE__ */ s.jsxs("div", { ..._1, children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: _1.children }),
    d1,
    /* @__PURE__ */ s.jsx("div", { className: "flex w-full justify-center gap-3", children: m1 })
  ] });
  return /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
    g3,
    {
      ref: j,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: B,
      startDate: B,
      className: "w-full",
      calendarClassName: "date-range-picker",
      popperClassName: "react-datepicker-bottom",
      onCalendarClose: () => {
        T([$, i1]), F(U);
      },
      calendarContainer: Q1,
      endDate: D,
      minDate: Z8(A, b),
      maxDate: h,
      dateFormat: "MMMM d, yyyy",
      onChange: (_1) => {
        if (_1) {
          F(void 0);
          const [p1, T1] = _1;
          T(_ ? cS(p1, T1, _) : [p1, T1]);
        }
      },
      locale: V,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ s.jsx(
        b3,
        {
          buttonInputClassName: `flex group justify-between ${n ? "" : "min-w-[150px] lg:min-w-[200px]"} w-full py-2.5 px-4 text-sm font-medium ${t ? "text-[rgb(var(--text-tertiary))]" : "text-text-primary"} border ${c ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          wrapperButtonInputClassName: g,
          labelClassName: y,
          error: c,
          label: C,
          required: p,
          description: u,
          children: () => /* @__PURE__ */ s.jsx("span", { className: "text-start whitespace-nowrap", children: $ && i1 ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx("span", { className: "hidden lg:inline", children: `${new Intl.DateTimeFormat(m, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format($)} - ${new Intl.DateTimeFormat(m, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(i1)}
              ` }),
            /* @__PURE__ */ s.jsx("span", { className: "inline lg:hidden", children: `${new Intl.DateTimeFormat(m, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format($)} - ${new Intl.DateTimeFormat(m, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(i1)}
              ` })
          ] }) : /* @__PURE__ */ s.jsx("span", { className: "text-text-tertiary/70", children: l || c1.t("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: _1,
        decreaseMonth: p1,
        increaseMonth: T1,
        prevMonthButtonDisabled: l1,
        nextMonthButtonDisabled: k1
      }) => /* @__PURE__ */ s.jsx(
        i0,
        {
          date: _1,
          decreaseMonth: p1,
          increaseMonth: T1,
          prevMonthButtonDisabled: l1,
          nextMonthButtonDisabled: k1,
          intlLocale: m
        }
      ),
      ...M
    }
  ) });
}, AP = ({
  mode: e = F4.DateSince,
  value: t,
  onChange: r,
  description: n,
  error: a,
  label: i,
  required: o,
  placeholder: l,
  maxDate: c,
  minDate: u,
  wrapperButtonInputClassName: d,
  disabled: C,
  timezone: p,
  intlLocale: h,
  createdAt: f,
  labelClassName: g,
  customProps: m
}) => {
  const [v, b] = e1(
    t && i2(t, p) || null
  ), [w, M] = e1(), [y, _] = e1(h9), S = f && p ? Z8(f, p) : null;
  return o0(h, _), h1(() => {
    if (!p)
      return;
    const j = t ? i2(t, p) : null;
    (!v || (j == null ? void 0 : j.toISOString()) !== v.toISOString()) && b(j);
  }, [t, p, v]), /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
    g3,
    {
      selected: v,
      dateFormat: "MMMM d, yyyy",
      onChange: (j) => {
        j && ((v ? j.toDateString() === v.toDateString() : !1) ? (b(null), r(null)) : (b(j), e === F4.DateTill && Xo(j), r(o6(j))));
      },
      onChangeRaw: (j) => {
        w === j.target.ariaLabel ? (b(null), r(null)) : M(j.target.ariaLabel);
      },
      locale: y,
      minDate: u || S,
      maxDate: c,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ s.jsx(
        b3,
        {
          description: n,
          buttonInputClassName: `flex group justify-between min-w-[200px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${C ? "bg-background-tertiary/40" : "bg-background-secondary focus:border-brand-primary"} ${a ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          error: a,
          label: i,
          required: o,
          wrapperButtonInputClassName: d,
          labelClassName: g,
          children: (j) => /* @__PURE__ */ s.jsx("span", { className: "text-start", children: j || /* @__PURE__ */ s.jsx("span", { className: "text-text-tertiary/70", children: l }) })
        }
      ),
      renderCustomHeader: ({
        date: j,
        decreaseMonth: V,
        increaseMonth: P,
        prevMonthButtonDisabled: A,
        nextMonthButtonDisabled: R
      }) => /* @__PURE__ */ s.jsx(
        i0,
        {
          date: j,
          decreaseMonth: V,
          increaseMonth: P,
          prevMonthButtonDisabled: A,
          nextMonthButtonDisabled: R,
          intlLocale: h
        }
      ),
      disabled: C,
      ...m
    }
  ) });
}, ga = ({
  children: e,
  isLast: t,
  className: r,
  isLink: n,
  onClick: a
}) => {
  const i = (o) => {
    a && (o.preventDefault(), a());
  };
  return /* @__PURE__ */ s.jsx(
    "h2",
    {
      className: K(
        "text-text-tertiary text-[18px] font-semibold leading-8 transition-colors md:truncate md:text-[20px]  lg:text-[22px]",
        r,
        (n || a) && "hover:text-text-primary cursor-pointer",
        t && "text-text-primary"
      ),
      onClick: i,
      children: e
    }
  );
}, EP = ({
  data: e,
  isFetching: t,
  classnameBreadcrumbsItem: r,
  CustomBreadcrumbLinkItem: n
}) => {
  const a = J(null), i = J(null);
  return a8(() => {
    a.current && i.current && a.current.scrollTo(i.current.offsetLeft, 0);
  }, [t]), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: a,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: e.map((o, l) => {
        const c = l === e.length - 1;
        return /* @__PURE__ */ s.jsxs(
          "li",
          {
            className: "flex flex-nowrap items-center gap-3 md:truncate",
            ref: c ? i : void 0,
            children: [
              l !== 0 && /* @__PURE__ */ s.jsx(yr, { height: "14", width: "10", fill: "rgb(var(--text-tertiary))" }),
              !o.isStatic && t ? /* @__PURE__ */ s.jsx(i7, { small: !0, type: "dark" }) : o.href ? /* @__PURE__ */ s.jsx(
                ga,
                {
                  isLast: c,
                  className: K(r),
                  isLink: !0,
                  onClick: o.onClick,
                  children: n ? /* @__PURE__ */ s.jsx(n, { href: o.href, children: o.caption }) : /* @__PURE__ */ s.jsx("a", { href: o.href, rel: "noreferrer", className: "outline-hidden", children: o.caption })
                }
              ) : /* @__PURE__ */ s.jsx(
                ga,
                {
                  onClick: o.onClick,
                  className: K(r),
                  isLast: c,
                  children: o.caption
                }
              )
            ]
          },
          l
        );
      })
    }
  );
};
export {
  Qb as $,
  hP as A,
  k6 as B,
  OH as C,
  Ji as D,
  xP as E,
  M6 as F,
  ao as G,
  ro as H,
  Ze as I,
  Be as J,
  no as K,
  i7 as L,
  xS as M,
  dP as N,
  xt as O,
  BH as P,
  eo as Q,
  vP as R,
  CP as S,
  mP as T,
  Ne as U,
  Re as V,
  Xi as W,
  Oe as X,
  d3 as Y,
  to as Z,
  KH as _,
  gS as a,
  PS as a$,
  qb as a0,
  wP as a1,
  _P as a2,
  Te as a3,
  MP as a4,
  NM as a5,
  IM as a6,
  ua as a7,
  DM as a8,
  PP as a9,
  j1 as aA,
  qH as aB,
  Fr as aC,
  QH as aD,
  N1 as aE,
  XH as aF,
  Hg as aG,
  eP as aH,
  tP as aI,
  Ae as aJ,
  aP as aK,
  nP as aL,
  L2 as aM,
  Nv as aN,
  rP as aO,
  Rv as aP,
  wS as aQ,
  _S as aR,
  MS as aS,
  SS as aT,
  Th as aU,
  br as aV,
  kS as aW,
  jh as aX,
  yr as aY,
  LS as aZ,
  HS as a_,
  F4 as aa,
  F9 as ab,
  f6 as ac,
  TP as ad,
  VP as ae,
  AP as af,
  jP as ag,
  hS as ah,
  Xo as ai,
  ga as aj,
  EP as ak,
  v3 as al,
  SP as am,
  kP as an,
  LP as ao,
  HP as ap,
  wr as aq,
  _r as ar,
  Lf as as,
  e2 as at,
  WH as au,
  $H as av,
  u1 as aw,
  JH as ax,
  y4 as ay,
  Lg as az,
  YH as b,
  Hk as b$,
  TS as b0,
  jS as b1,
  VS as b2,
  AS as b3,
  Vh as b4,
  ES as b5,
  IS as b6,
  DS as b7,
  NS as b8,
  RS as b9,
  nk as bA,
  rk as bB,
  ik as bC,
  ok as bD,
  sk as bE,
  lk as bF,
  ck as bG,
  uk as bH,
  dk as bI,
  Ck as bJ,
  pk as bK,
  Oh as bL,
  hk as bM,
  fk as bN,
  mk as bO,
  gk as bP,
  Bh as bQ,
  vk as bR,
  bk as bS,
  yk as bT,
  xk as bU,
  wk as bV,
  _k as bW,
  Mk as bX,
  Sk as bY,
  kk as bZ,
  Lk as b_,
  FS as ba,
  OS as bb,
  Ah as bc,
  BS as bd,
  ZS as be,
  GS as bf,
  Eh as bg,
  KS as bh,
  zS as bi,
  US as bj,
  YS as bk,
  WS as bl,
  Ih as bm,
  $S as bn,
  Dh as bo,
  Nh as bp,
  JS as bq,
  Rh as br,
  qS as bs,
  QS as bt,
  XS as bu,
  Fh as bv,
  w8 as bw,
  ek as bx,
  tk as by,
  ak as bz,
  UH as c,
  $h as c$,
  Pk as c0,
  Tk as c1,
  jk as c2,
  Vk as c3,
  Zh as c4,
  Ak as c5,
  Ek as c6,
  Ik as c7,
  Dk as c8,
  Gh as c9,
  Uh as cA,
  sL as cB,
  lL as cC,
  cL as cD,
  uL as cE,
  dL as cF,
  CL as cG,
  pL as cH,
  hL as cI,
  fL as cJ,
  mL as cK,
  gL as cL,
  vL as cM,
  bL as cN,
  yL as cO,
  Yh as cP,
  xL as cQ,
  Wh as cR,
  wL as cS,
  _L as cT,
  ML as cU,
  SL as cV,
  kL as cW,
  LL as cX,
  HL as cY,
  PL as cZ,
  TL as c_,
  Nk as ca,
  Rk as cb,
  Fk as cc,
  Ok as cd,
  Bk as ce,
  Zk as cf,
  Kh as cg,
  Gk as ch,
  Kk as ci,
  zk as cj,
  Uk as ck,
  Yk as cl,
  Wk as cm,
  $k as cn,
  zh as co,
  Jk as cp,
  qk as cq,
  Qk as cr,
  Xk as cs,
  eL as ct,
  tL as cu,
  aL as cv,
  nL as cw,
  rL as cx,
  iL as cy,
  oL as cz,
  zH as d,
  IH as d$,
  jL as d0,
  VL as d1,
  AL as d2,
  xr as d3,
  EL as d4,
  IL as d5,
  Jh as d6,
  DL as d7,
  NL as d8,
  RL as d9,
  cH as dA,
  uH as dB,
  dH as dC,
  CH as dD,
  pH as dE,
  hH as dF,
  fH as dG,
  mH as dH,
  gH as dI,
  vH as dJ,
  bH as dK,
  yH as dL,
  xH as dM,
  wH as dN,
  _H as dO,
  MH as dP,
  SH as dQ,
  kH as dR,
  LH as dS,
  HH as dT,
  PH as dU,
  Qh as dV,
  TH as dW,
  jH as dX,
  VH as dY,
  AH as dZ,
  EH as d_,
  FL as da,
  OL as db,
  BL as dc,
  ZL as dd,
  GL as de,
  KL as df,
  zL as dg,
  UL as dh,
  qh as di,
  YL as dj,
  WL as dk,
  $L as dl,
  JL as dm,
  qL as dn,
  QL as dp,
  XL as dq,
  eH as dr,
  tH as ds,
  aH as dt,
  nH as du,
  rH as dv,
  iH as dw,
  oH as dx,
  sH as dy,
  lH as dz,
  Ph as e,
  DH as e0,
  NH as e1,
  RH as e2,
  FH as e3,
  Xh as e4,
  ef as e5,
  tf as e6,
  af as e7,
  nf as e8,
  rf as e9,
  o6 as eA,
  vt as eB,
  Ob as eC,
  iP as eD,
  oP as eE,
  sP as eF,
  lP as eG,
  cP as eH,
  Qi as eI,
  of as ea,
  sf as eb,
  J0 as ec,
  lf as ed,
  cf as ee,
  uf as ef,
  df as eg,
  Cf as eh,
  pf as ei,
  hf as ej,
  ff as ek,
  mf as el,
  gf as em,
  vf as en,
  bf as eo,
  yf as ep,
  xf as eq,
  wf as er,
  _f as es,
  Mf as et,
  Sf as eu,
  kf as ev,
  v4 as ew,
  Z8 as ex,
  Z3 as ey,
  i2 as ez,
  X5 as f,
  M7 as g,
  yS as h,
  ZH as i,
  GH as j,
  uP as k,
  W6 as l,
  pP as m,
  yt as n,
  $i as o,
  Gb as p,
  Ub as q,
  zb as r,
  Bb as s,
  Zb as t,
  fP as u,
  Wb as v,
  gP as w,
  J1 as x,
  bP as y,
  yP as z
};
